import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: string; output: string; }
  ContactEmailScalar: { input: any; output: any; }
  CustomValueStringScalar: { input: any; output: any; }
  GridStringArrayScalar: { input: any; output: any; }
  ISO8601Date: { input: string; output: string; }
  ISO8601DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  NormalizedUrl: { input: any; output: any; }
  Url: { input: string; output: string; }
};

export type AccessConfig = {
  __typename?: 'AccessConfig';
  id: Scalars['ID']['output'];
  showRoleAdmin: Scalars['Boolean']['output'];
};

export type AccessRole = {
  __typename?: 'AccessRole';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPersisted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AccessRoleEntries = {
  __typename?: 'AccessRoleEntries';
  entries: Array<AccessRole>;
};

export enum AccountColour {
  Col1 = 'COL1',
  Col2 = 'COL2',
  Col3 = 'COL3',
  Col4 = 'COL4',
  Col5 = 'COL5',
  Col6 = 'COL6',
  Col7 = 'COL7',
  Col8 = 'COL8',
  Col9 = 'COL9',
  Col10 = 'COL10',
  ColDefault = 'COL_DEFAULT'
}

export type ActivityTotals = {
  __typename?: 'ActivityTotals';
  existingContacts: Scalars['Int']['output'];
  meetings: Scalars['Int']['output'];
  newContacts: Scalars['Int']['output'];
  newOpportunities: Scalars['Int']['output'];
};

/** Autogenerated return type of AddBlockPageToBlockPageListMutation. */
export type AddBlockPageToBlockPageListMutationPayload = {
  __typename?: 'AddBlockPageToBlockPageListMutationPayload';
  blockPage: Maybe<BlockPage>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddClientCompanyForSyncMutation. */
export type AddClientCompanyForSyncMutationPayload = {
  __typename?: 'AddClientCompanyForSyncMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddCommentToCommentThreadMutation. */
export type AddCommentToCommentThreadMutationPayload = {
  __typename?: 'AddCommentToCommentThreadMutationPayload';
  comment: Maybe<Comment>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddCompanyContactToPersonMutation. */
export type AddCompanyContactToPersonMutationPayload = {
  __typename?: 'AddCompanyContactToPersonMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddCompanyDocumentMutation. */
export type AddCompanyDocumentMutationPayload = {
  __typename?: 'AddCompanyDocumentMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddCompanyListMemberMutation. */
export type AddCompanyListMemberMutationPayload = {
  __typename?: 'AddCompanyListMemberMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CompanyListMember>;
};

/** Autogenerated return type of AddCompanyTagsMutation. */
export type AddCompanyTagsMutationPayload = {
  __typename?: 'AddCompanyTagsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddCompanyToAssociationMutation. */
export type AddCompanyToAssociationMutationPayload = {
  __typename?: 'AddCompanyToAssociationMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddCompanyToExclusionListMutation. */
export type AddCompanyToExclusionListMutationPayload = {
  __typename?: 'AddCompanyToExclusionListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CompanyExclusion>;
};

/** Autogenerated return type of AddCompanyToHierarchyMutation. */
export type AddCompanyToHierarchyMutationPayload = {
  __typename?: 'AddCompanyToHierarchyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddContactMutation. */
export type AddContactMutationPayload = {
  __typename?: 'AddContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  uid: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of AddContactNewCompanySwitchMutation. */
export type AddContactNewCompanySwitchMutationPayload = {
  __typename?: 'AddContactNewCompanySwitchMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Contact>;
};

/** Autogenerated return type of AddContactPersonalEmailCompanySwitchMutation. */
export type AddContactPersonalEmailCompanySwitchMutationPayload = {
  __typename?: 'AddContactPersonalEmailCompanySwitchMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Contact>;
};

/** Autogenerated return type of AddContactToListMutation. */
export type AddContactToListMutationPayload = {
  __typename?: 'AddContactToListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  gridMemberRecord: Maybe<ContactListGridMember>;
  record: Maybe<ListMember>;
};

/** Autogenerated return type of AddContactUnknownCompanySwitchMutation. */
export type AddContactUnknownCompanySwitchMutationPayload = {
  __typename?: 'AddContactUnknownCompanySwitchMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddContactWorkEmailCompanySwitchMutation. */
export type AddContactWorkEmailCompanySwitchMutationPayload = {
  __typename?: 'AddContactWorkEmailCompanySwitchMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Contact>;
};

/** Autogenerated return type of AddContactsToHierarchyMutation. */
export type AddContactsToHierarchyMutationPayload = {
  __typename?: 'AddContactsToHierarchyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddContactsToListMutation. */
export type AddContactsToListMutationPayload = {
  __typename?: 'AddContactsToListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddContactsToListWithTrackerMutation. */
export type AddContactsToListWithTrackerMutationPayload = {
  __typename?: 'AddContactsToListWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddContactsWithCompanyToHierarchyMutation. */
export type AddContactsWithCompanyToHierarchyMutationPayload = {
  __typename?: 'AddContactsWithCompanyToHierarchyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddDataTemplatesTemplateFieldsMutation. */
export type AddDataTemplatesTemplateFieldsMutationPayload = {
  __typename?: 'AddDataTemplatesTemplateFieldsMutationPayload';
  createdFields: Array<DataTemplateField>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddDuplicateCompaniesToHierarchyMutation. */
export type AddDuplicateCompaniesToHierarchyMutationPayload = {
  __typename?: 'AddDuplicateCompaniesToHierarchyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddEmailAliasMutation. */
export type AddEmailAliasMutationPayload = {
  __typename?: 'AddEmailAliasMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddFromTableLikeToAnotherMutation. */
export type AddFromTableLikeToAnotherMutationPayload = {
  __typename?: 'AddFromTableLikeToAnotherMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  progressTracker: Maybe<ProgressTracker>;
};

/** Autogenerated return type of AddInteractionKeyActivityMutation. */
export type AddInteractionKeyActivityMutationPayload = {
  __typename?: 'AddInteractionKeyActivityMutationPayload';
  detail: Maybe<KeyActivity>;
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of AddKeyActivityFromOutlookMutation. */
export type AddKeyActivityFromOutlookMutationPayload = {
  __typename?: 'AddKeyActivityFromOutlookMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  keyActivity: Maybe<KeyActivity>;
};

/** Autogenerated return type of AddKeyActivityToListMutation. */
export type AddKeyActivityToListMutationPayload = {
  __typename?: 'AddKeyActivityToListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<KeyActivityListMember>;
};

/** Autogenerated return type of AddListContactsToListMutation. */
export type AddListContactsToListMutationPayload = {
  __typename?: 'AddListContactsToListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddListContactsToListWithTrackerMutation. */
export type AddListContactsToListWithTrackerMutationPayload = {
  __typename?: 'AddListContactsToListWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddMyContactsToListMutation. */
export type AddMyContactsToListMutationPayload = {
  __typename?: 'AddMyContactsToListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddMyContactsToListWithTrackerMutation. */
export type AddMyContactsToListWithTrackerMutationPayload = {
  __typename?: 'AddMyContactsToListWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddOptionMutation. */
export type AddOptionMutationPayload = {
  __typename?: 'AddOptionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddProjectDocumentMutation. */
export type AddProjectDocumentMutationPayload = {
  __typename?: 'AddProjectDocumentMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddProjectMembersMutation. */
export type AddProjectMembersMutationPayload = {
  __typename?: 'AddProjectMembersMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddProjectNoteMutation. */
export type AddProjectNoteMutationPayload = {
  __typename?: 'AddProjectNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddProjectTaskMutation. */
export type AddProjectTaskMutationPayload = {
  __typename?: 'AddProjectTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<ProjectTask>;
};

/** Autogenerated return type of AddProjectTaskSectionMutation. */
export type AddProjectTaskSectionMutationPayload = {
  __typename?: 'AddProjectTaskSectionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<ProjectTaskSection>;
};

/** Autogenerated return type of AddRecipientMutation. */
export type AddRecipientMutationPayload = {
  __typename?: 'AddRecipientMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddTagsToAllContactsWithTrackerMutation. */
export type AddTagsToAllContactsWithTrackerMutationPayload = {
  __typename?: 'AddTagsToAllContactsWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddTagsToContactsMutation. */
export type AddTagsToContactsMutationPayload = {
  __typename?: 'AddTagsToContactsMutationPayload';
  contactCards: Maybe<Array<ContactCard>>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of AddUserMutation. */
export type AddUserMutationPayload = {
  __typename?: 'AddUserMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type ApiDefinition = {
  __typename?: 'ApiDefinition';
  apiUrl: Maybe<Scalars['String']['output']>;
  httpMethod: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Input fields for creating an API definition */
export type ApiDefinitionInput = {
  /** Headers for the API */
  apiHeaders?: InputMaybe<Array<ApiHeaderInput>>;
  /** Secrets for the API */
  apiSecrets?: InputMaybe<Array<ApiSecretInput>>;
  /** URL of the API */
  apiUrl: Scalars['String']['input'];
  /** HTTP body of the API */
  httpBody?: InputMaybe<Scalars['String']['input']>;
  /** HTTP method of the API */
  httpMethod: HttpMethodEnum;
};

/** Input fields for creating an API header */
export type ApiHeaderInput = {
  /** Key of the header */
  key: Scalars['String']['input'];
  /** Value of the header */
  value: Scalars['String']['input'];
};

/** Input fields for creating an API secret */
export type ApiSecretInput = {
  /** Name of the secret */
  name: Scalars['String']['input'];
  /** Value of the secret */
  value: Scalars['String']['input'];
};

export type ApiSourceTable = {
  __typename?: 'ApiSourceTable';
  apiDefinition: ApiDefinition;
  apiDefinitionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  jsonPathColumnMappings: Array<JsonPathColumnMapping>;
  name: Maybe<Scalars['String']['output']>;
  sourceUid: Scalars['String']['output'];
  tableKey: Scalars['String']['output'];
};

/** Input fields for creating an API source table */
export type ApiSourceTableInput = {
  /** Headers for the API */
  apiHeaders?: InputMaybe<Array<ApiHeaderInput>>;
  /** Secrets for the API */
  apiSecrets?: InputMaybe<Array<ApiSecretInput>>;
  /** JSON mappings for the table */
  jsonMappings?: InputMaybe<Array<JsonMappingInput>>;
  /** Name of the API source */
  name?: InputMaybe<Scalars['String']['input']>;
  /** UID of the source */
  sourceUid: Scalars['ID']['input'];
  /** Key of the table */
  tableKey: RowTypeEnum;
};

/** Autogenerated return type of ArchiveCampaignMutation. */
export type ArchiveCampaignMutationPayload = {
  __typename?: 'ArchiveCampaignMutationPayload';
  archivedCampaign: Maybe<Campaign>;
  failReasons: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of ArchiveCompanyListMutation. */
export type ArchiveCompanyListMutationPayload = {
  __typename?: 'ArchiveCompanyListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ArchiveCompanyMutation. */
export type ArchiveCompanyMutationPayload = {
  __typename?: 'ArchiveCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ArchiveCompanyNoteMutation. */
export type ArchiveCompanyNoteMutationPayload = {
  __typename?: 'ArchiveCompanyNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ArchiveContactListMutation. */
export type ArchiveContactListMutationPayload = {
  __typename?: 'ArchiveContactListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ArchiveContactMutation. */
export type ArchiveContactMutationPayload = {
  __typename?: 'ArchiveContactMutationPayload';
  contact: Maybe<Contact>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ArchiveGenericListMutation. */
export type ArchiveGenericListMutationPayload = {
  __typename?: 'ArchiveGenericListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ArchivePersonMutation. */
export type ArchivePersonMutationPayload = {
  __typename?: 'ArchivePersonMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ArchiveTemplateMutation. */
export type ArchiveTemplateMutationPayload = {
  __typename?: 'ArchiveTemplateMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  template: Maybe<Template>;
};

/** Autogenerated return type of ArchiveUserMutation. */
export type ArchiveUserMutationPayload = {
  __typename?: 'ArchiveUserMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  user: Maybe<User>;
};

export enum ArchivedCompaniesOrderBy {
  ArchivedAtAsc = 'ARCHIVED_AT_ASC',
  ArchivedAtDesc = 'ARCHIVED_AT_DESC'
}

/** Filtering Options for archived contacts */
export type ArchivedContactsFiltering = {
  term?: InputMaybe<Scalars['String']['input']>;
};

export enum ArchivedContactsOrderBy {
  ArchivedAtAsc = 'ARCHIVED_AT_ASC',
  ArchivedAtDesc = 'ARCHIVED_AT_DESC'
}

export type Audience = {
  __typename?: 'Audience';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AudienceList = {
  __typename?: 'AudienceList';
  entries: Array<Audience>;
};

export type Audit = {
  __typename?: 'Audit';
  action: AuditAction;
  auditedEntity: AuditEntity;
  changes: Array<AuditChange>;
  performedAt: Scalars['ISO8601DateTime']['output'];
  performedBy: Maybe<Scalars['String']['output']>;
  performer: Maybe<User>;
};

export enum AuditAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type AuditChange = {
  __typename?: 'AuditChange';
  name: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
};

export enum AuditEntity {
  CompanyDocumentFile = 'COMPANY_DOCUMENT_FILE',
  CompanyInfo = 'COMPANY_INFO',
  CompanyKeyContact = 'COMPANY_KEY_CONTACT',
  CompanyOfficeLocation = 'COMPANY_OFFICE_LOCATION',
  Contact = 'CONTACT',
  ContactConsent = 'CONTACT_CONSENT',
  ContactInfo = 'CONTACT_INFO',
  ContactLocation = 'CONTACT_LOCATION',
  Note = 'NOTE',
  Opportunity = 'OPPORTUNITY',
  RelationshipPartner = 'RELATIONSHIP_PARTNER'
}

export type AuditTrail = {
  __typename?: 'AuditTrail';
  entries: Array<Audit>;
};

export enum BaseLegacyRole {
  Admin = 'ADMIN',
  IndividualLawyer = 'INDIVIDUAL_LAWYER',
  Manager = 'MANAGER',
  RestrictedLawyer = 'RESTRICTED_LAWYER',
  Support = 'SUPPORT'
}

export type BeeAuth = {
  __typename?: 'BeeAuth';
  accessToken: Scalars['String']['output'];
  v2: Scalars['Boolean']['output'];
};

export type BeePlugin = {
  __typename?: 'BeePlugin';
  beeUserUid: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Autogenerated return type of BlockCompanyMutation. */
export type BlockCompanyMutationPayload = {
  __typename?: 'BlockCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BlockDomainMutation. */
export type BlockDomainMutationPayload = {
  __typename?: 'BlockDomainMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type BlockPage = {
  __typename?: 'BlockPage';
  /** @deprecated No longer used */
  content: Maybe<Scalars['String']['output']>;
  contentInBinary: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  iconCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  position: Maybe<Scalars['Int']['output']>;
};

/** Block Pages attribute */
export type BlockPageAttributes = {
  iconCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockPageList = {
  __typename?: 'BlockPageList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pages: Array<BlockPage>;
};

/** Block Pages Position update attributes */
export type BlockPagePositionAttributes = {
  id: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type BlockPageProvider = {
  __typename?: 'BlockPageProvider';
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BlockedContact = {
  __typename?: 'BlockedContact';
  contact: Contact;
  errors: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type BlockedDomainEntries = {
  __typename?: 'BlockedDomainEntries';
  entries: Array<BlockedValue>;
  pageInfo: PagingInfo;
};

export type BlockedEmailEntries = {
  __typename?: 'BlockedEmailEntries';
  entries: Array<BlockedValue>;
  pageInfo: PagingInfo;
};

export type BlockedValue = {
  __typename?: 'BlockedValue';
  createdAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

/** Options for filtering board */
export type BoardFiltering = {
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type BooleanContactSearchFilter = {
  operator: BooleanSearchOperator;
  property: BooleanContactSearchableProperty;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum BooleanContactSearchableProperty {
  KeyContact = 'KEY_CONTACT',
  OpenOpportunity = 'OPEN_OPPORTUNITY'
}

export type BooleanListMemberSearchFilter = {
  operator: BooleanSearchOperator;
  property: BooleanListMemberSearchableProperty;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum BooleanListMemberSearchableProperty {
  MarketingExcluded = 'MARKETING_EXCLUDED',
  OpenTask = 'OPEN_TASK'
}

export enum BooleanSearchOperator {
  No = 'NO',
  Yes = 'YES'
}

export type BounceCount = {
  __typename?: 'BounceCount';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isLimitReached: Scalars['Boolean']['output'];
  state: BounceStateEnum;
};

export enum BounceStateEnum {
  No = 'NO',
  Some = 'SOME',
  Yes = 'YES'
}

export type BouncedEmail = {
  __typename?: 'BouncedEmail';
  count: Scalars['Int']['output'];
  email: Scalars['String']['output'];
};

export type BouncedEmailEntries = {
  __typename?: 'BouncedEmailEntries';
  entries: Array<BouncedEmail>;
};

/** Autogenerated return type of BulkAddCompanyListMemberMutation. */
export type BulkAddCompanyListMemberMutationPayload = {
  __typename?: 'BulkAddCompanyListMemberMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  records: Array<CompanyListMember>;
};

/** Autogenerated return type of BulkAddListMemberMutation. */
export type BulkAddListMemberMutationPayload = {
  __typename?: 'BulkAddListMemberMutationPayload';
  blockedContacts: Array<BlockedContact>;
  failReasons: Array<Scalars['String']['output']>;
  gridMemberRecords: Array<ContactListGridMember>;
  members: Array<ListMember>;
};

/** Autogenerated return type of BulkAddListMemberWithTrackerMutation. */
export type BulkAddListMemberWithTrackerMutationPayload = {
  __typename?: 'BulkAddListMemberWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkAddTagsToContactsWithTrackerMutation. */
export type BulkAddTagsToContactsWithTrackerMutationPayload = {
  __typename?: 'BulkAddTagsToContactsWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkArchiveCompaniesMutation. */
export type BulkArchiveCompaniesMutationPayload = {
  __typename?: 'BulkArchiveCompaniesMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkArchiveContactMutation. */
export type BulkArchiveContactMutationPayload = {
  __typename?: 'BulkArchiveContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkArchiveContactWithTrackerMutation. */
export type BulkArchiveContactWithTrackerMutationPayload = {
  __typename?: 'BulkArchiveContactWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkAssociateCompaniesMutation. */
export type BulkAssociateCompaniesMutationPayload = {
  __typename?: 'BulkAssociateCompaniesMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkEditListMemberWithTrackerMutation. */
export type BulkEditListMemberWithTrackerMutationPayload = {
  __typename?: 'BulkEditListMemberWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkIgnoreIncompleteCompaniesMutation. */
export type BulkIgnoreIncompleteCompaniesMutationPayload = {
  __typename?: 'BulkIgnoreIncompleteCompaniesMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkIgnoreIncompleteContactsMutation. */
export type BulkIgnoreIncompleteContactsMutationPayload = {
  __typename?: 'BulkIgnoreIncompleteContactsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkMarkAllKeyActivityContactsMutation. */
export type BulkMarkAllKeyActivityContactsMutationPayload = {
  __typename?: 'BulkMarkAllKeyActivityContactsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkMarkKeyActivityMutation. */
export type BulkMarkKeyActivityMutationPayload = {
  __typename?: 'BulkMarkKeyActivityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkMarkKeyActivityWithTrackerMutation. */
export type BulkMarkKeyActivityWithTrackerMutationPayload = {
  __typename?: 'BulkMarkKeyActivityWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkRemoveCompanyListMemberMutation. */
export type BulkRemoveCompanyListMemberMutationPayload = {
  __typename?: 'BulkRemoveCompanyListMemberMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkRemoveContactListMembersMutation. */
export type BulkRemoveContactListMembersMutationPayload = {
  __typename?: 'BulkRemoveContactListMembersMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkRemoveContactsFromListWithTrackerMutation. */
export type BulkRemoveContactsFromListWithTrackerMutationPayload = {
  __typename?: 'BulkRemoveContactsFromListWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkRemoveListMemberMutation. */
export type BulkRemoveListMemberMutationPayload = {
  __typename?: 'BulkRemoveListMemberMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkRemoveTagMutation. */
export type BulkRemoveTagMutationPayload = {
  __typename?: 'BulkRemoveTagMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkRemoveTagsFromContactsWithTrackerMutation. */
export type BulkRemoveTagsFromContactsWithTrackerMutationPayload = {
  __typename?: 'BulkRemoveTagsFromContactsWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkRestoreArchivedCompaniesMutation. */
export type BulkRestoreArchivedCompaniesMutationPayload = {
  __typename?: 'BulkRestoreArchivedCompaniesMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkRestoreArchivedContactsMutation. */
export type BulkRestoreArchivedContactsMutationPayload = {
  __typename?: 'BulkRestoreArchivedContactsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkSetContactConsentWithTrackerMutation. */
export type BulkSetContactConsentWithTrackerMutationPayload = {
  __typename?: 'BulkSetContactConsentWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<ContactConsent>;
};

/** Autogenerated return type of BulkUpdateCompanyListMemberMutation. */
export type BulkUpdateCompanyListMemberMutationPayload = {
  __typename?: 'BulkUpdateCompanyListMemberMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  records: Array<CompanyListMember>;
};

/** Autogenerated return type of BulkUpdateCompanyTypeMutation. */
export type BulkUpdateCompanyTypeMutationPayload = {
  __typename?: 'BulkUpdateCompanyTypeMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type BulkUpdateContactAttributes = {
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  locationAttributes?: InputMaybe<LocationAttributes>;
  officeLocationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkUpdateContactMutation. */
export type BulkUpdateContactMutationPayload = {
  __typename?: 'BulkUpdateContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkUpdateContactsReviewRuleValueForContactsMutation. */
export type BulkUpdateContactsReviewRuleValueForContactsMutationPayload = {
  __typename?: 'BulkUpdateContactsReviewRuleValueForContactsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkUpdateListMemberMutation. */
export type BulkUpdateListMemberMutationPayload = {
  __typename?: 'BulkUpdateListMemberMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  gridMemberRecords: Array<ContactListGridMember>;
  records: Array<ListMember>;
};

export type Calendar = {
  __typename?: 'Calendar';
  entries: Array<CalendarEntry>;
  /** @deprecated Pagination is no longer supported */
  pageInfo: PagingInfo;
};

/** Calendar attached objects */
export type CalendarAttachable = EmployeeMeeting | KeyActivity | Task;

export enum CalendarAttachableEnum {
  EmployeeMeeting = 'EmployeeMeeting',
  KeyActivity = 'KeyActivity',
  Task = 'Task'
}

export type CalendarEntry = {
  __typename?: 'CalendarEntry';
  calendarAttachable: CalendarAttachable;
  endTime: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isAllDay: Scalars['Boolean']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
  title: Scalars['String']['output'];
};

/** Filter options for my calendar */
export type CalendarFieldFilter = {
  attachableTypes?: InputMaybe<Array<CalendarAttachableEnum>>;
  rangeEndAt: Scalars['ISO8601DateTime']['input'];
  rangeStartAt: Scalars['ISO8601DateTime']['input'];
};

export enum CalendarFieldOrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Campaign = {
  __typename?: 'Campaign';
  allowContinuousResend: Scalars['Boolean']['output'];
  analytics: Maybe<CampaignAnalytics>;
  attachment: Maybe<File>;
  clickTracking: Scalars['Boolean']['output'];
  continuous: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  /** @deprecated Use sender { email } instead */
  fromEmail: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  openTracking: Scalars['Boolean']['output'];
  project: Maybe<Project>;
  projectUrl: Scalars['String']['output'];
  recipientList: Maybe<List>;
  recipientListFilter: Maybe<CampaignRecipientListFilter>;
  scheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  sender: Maybe<Sender>;
  sentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: CampaignStatus;
  subject: Maybe<Scalars['String']['output']>;
  templateHtml: Maybe<Scalars['String']['output']>;
  templateJson: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usageMode: Maybe<CampaignUsage>;
};

export type CampaignAnalytics = {
  __typename?: 'CampaignAnalytics';
  clickThroughRate: Scalars['Int']['output'];
  /** @deprecated Use percent_failed instead */
  percentBounced: Scalars['Int']['output'];
  percentClicked: Scalars['Int']['output'];
  percentComplained: Scalars['Int']['output'];
  percentDelivered: Scalars['Int']['output'];
  percentFailed: Scalars['Int']['output'];
  percentOpened: Scalars['Int']['output'];
  percentSkipped: Scalars['Int']['output'];
  percentUnsubscribed: Scalars['Int']['output'];
  totalAccepted: Scalars['Int']['output'];
  /** @deprecated Use total_failed instead */
  totalBounced: Scalars['Int']['output'];
  totalClicked: Scalars['Int']['output'];
  totalComplained: Scalars['Int']['output'];
  totalDelivered: Scalars['Int']['output'];
  totalFailed: Scalars['Int']['output'];
  totalOpened: Scalars['Int']['output'];
  totalRecipients: Scalars['Int']['output'];
  totalSkipped: Scalars['Int']['output'];
  totalUnsubscribed: Scalars['Int']['output'];
};

export type CampaignManager = {
  __typename?: 'CampaignManager';
  apiType: Scalars['String']['output'];
  connectorType: Maybe<ConnectorType>;
  id: Scalars['ID']['output'];
  /** Whether the connector has field to field mapping */
  mappingEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CampaignManagerDetail = {
  __typename?: 'CampaignManagerDetail';
  connectedListId: Scalars['String']['output'];
  lastSyncAt: Maybe<Scalars['ISO8601Date']['output']>;
  segmentName: Maybe<Scalars['String']['output']>;
};

export type CampaignRecipient = {
  __typename?: 'CampaignRecipient';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  changedJob: Scalars['Boolean']['output'];
  company: Company;
  contactCompanySwitch: Maybe<ContactCompanySwitch>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  emailAddresses: Array<Scalars['ContactEmailScalar']['output']>;
  id: Scalars['ID']['output'];
  inMyContacts: Maybe<Scalars['Boolean']['output']>;
  info: ContactInfo;
  interactionsBounce: Maybe<BounceCount>;
  interactionsIsEngaged: Scalars['Boolean']['output'];
  interactionsLast: LastAts;
  interactionsTotal: Totals;
  /** @deprecated Use interactionsIsEngaged instead */
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isEmployee: Scalars['Boolean']['output'];
  isKeyContact: Scalars['Boolean']['output'];
  isPersonal: Scalars['Boolean']['output'];
  marketingListConsent: ContactConsent;
  nextCompanyContact: Maybe<PersonCompanyContact>;
  officeLocation: Maybe<CompanyOfficeLocation>;
  primaryEmail: Maybe<Scalars['ContactEmailScalar']['output']>;
  /** Most recent state of the recipient */
  status: CampaignRecipientStatus;
  unarchiveOnNextInteraction: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  whoKnows: Array<WhoKnows>;
};


export type CampaignRecipientWhoKnowsArgs = {
  connectionCategory: WhoKnowsCategory;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignRecipientEntries = {
  __typename?: 'CampaignRecipientEntries';
  entries: Array<CampaignRecipient>;
  pageInfo: PagingInfo;
};

export type CampaignRecipientListFilter = {
  __typename?: 'CampaignRecipientListFilter';
  campaign: Campaign;
  conditions: Scalars['JSON']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  recipientList: List;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input fields for creating/updating a campaign recipient list filter */
export type CampaignRecipientListFilterInput = {
  /** ID of the campaign */
  campaignId: Scalars['ID']['input'];
  /** Filtering conditions */
  conditions?: InputMaybe<ColumnsFilteringInput>;
  /** ID of the recipient list */
  recipientListId: Scalars['ID']['input'];
};

export enum CampaignRecipientStatus {
  /** Recipient has clicked on a link in the campaign */
  Clicked = 'CLICKED',
  /** Recipient has complained about the campaign */
  Complained = 'COMPLAINED',
  /** Campaign delivered to recipient */
  Delivered = 'DELIVERED',
  /** Campaign failed to be delivered to recipient */
  Failed = 'FAILED',
  /** Campaign opened by recipient */
  Opened = 'OPENED',
  /** Campaign opened by recipient with no other interactions */
  OpenedUnique = 'OPENED_UNIQUE',
  /** Recipient queued for delivery */
  Queued = 'QUEUED',
  /** Campaign scheduled for recipient */
  Scheduled = 'SCHEDULED',
  /** Campaign sent to recipient */
  Sent = 'SENT',
  /** Recipient skipped from delivery */
  Skipped = 'SKIPPED',
  /** Campaign yet to be scheduled for recipient */
  Unscheduled = 'UNSCHEDULED',
  /** Recipient has unsubscribed from campaign */
  Unsubscribed = 'UNSUBSCRIBED'
}

export type CampaignRecipientsFilterInput = {
  clickedLink?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated, use eventTypes instead */
  eventType?: InputMaybe<CampaignRecipientStatus>;
  eventTypes?: InputMaybe<Array<CampaignRecipientStatus>>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export enum CampaignStatus {
  /** All active campaigns */
  Active = 'ACTIVE',
  /** Campaign has been archived */
  Archived = 'ARCHIVED',
  /** Campaign is in draft mode */
  Draft = 'DRAFT',
  /** Campaign has been schedule to be sent */
  Scheduled = 'SCHEDULED',
  /** Campaign is currently sending */
  Sending = 'SENDING',
  /** Campaign has been sent */
  Sent = 'SENT'
}

export enum CampaignUsage {
  /** Campaign is not in use anywhere */
  None = 'NONE',
  /** Campaign belongs to a project */
  Project = 'PROJECT'
}

export type Campaigns = {
  __typename?: 'Campaigns';
  entries: Array<Campaign>;
  pageInfo: PagingInfo;
};

export type CampaignsFilterInput = {
  createdAt?: InputMaybe<DateRangeInput>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  scheduledAt?: InputMaybe<DateRangeInput>;
  sentAt?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<CampaignStatus>;
  term?: InputMaybe<Scalars['String']['input']>;
  workspaces?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CareerCompany = {
  __typename?: 'CareerCompany';
  company: Maybe<Company>;
  companyDisplayName: Scalars['String']['output'];
  companyId: Maybe<Scalars['ID']['output']>;
  companyLinkedinUrl: Maybe<Scalars['Url']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  currentStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  jobTitles: Array<ContactJobTitle>;
};

/** Autogenerated return type of ChangeContactCompanyMutation. */
export type ChangeContactCompanyMutationPayload = {
  __typename?: 'ChangeContactCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ClassifyDomainMutation. */
export type ClassifyDomainMutationPayload = {
  __typename?: 'ClassifyDomainMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ClassifyDomainsMutation. */
export type ClassifyDomainsMutationPayload = {
  __typename?: 'ClassifyDomainsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ClassifyEmailMutation. */
export type ClassifyEmailMutationPayload = {
  __typename?: 'ClassifyEmailMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type Clean = {
  __typename?: 'Clean';
  /** Whether this list has been completely cleaned at some point in the past */
  beenCleaned: Scalars['Boolean']['output'];
  cleanEnd: Maybe<Scalars['ISO8601DateTime']['output']>;
  cleanStart: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  percentComplete: Scalars['Int']['output'];
  /** Overall status of the cleaning process */
  status: Maybe<ExecutionStatus>;
  totalBounced: Scalars['Int']['output'];
  totalConsentNotGiven: Scalars['Int']['output'];
  totalHighRisk: Scalars['Int']['output'];
  totalLowRisk: Scalars['Int']['output'];
  totalMediumRisk: Scalars['Int']['output'];
  totalMembers: Scalars['Int']['output'];
  totalUnengaged: Scalars['Int']['output'];
  totalUnsubscribed: Scalars['Int']['output'];
};

/** Autogenerated return type of CloneCampaignMutation. */
export type CloneCampaignMutationPayload = {
  __typename?: 'CloneCampaignMutationPayload';
  clonedCampaign: Maybe<Campaign>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CloneTemplateMutation. */
export type CloneTemplateMutationPayload = {
  __typename?: 'CloneTemplateMutationPayload';
  clonedTemplate: Maybe<Template>;
  failReasons: Array<Scalars['String']['output']>;
};

export type Column = {
  __typename?: 'Column';
  columnValueSuggestions: Scalars['Boolean']['output'];
  emsAccessible: Scalars['Boolean']['output'];
  filterOnly: Scalars['Boolean']['output'];
  filterOperations: Array<ColumnFilterOperationEnum>;
  /** @deprecated Use `column_value_suggestions` instead */
  filterSuggestions: Scalars['Boolean']['output'];
  groupName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  multiple: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  optionChoices: Array<SchemaOptionChoice>;
  orderable: Scalars['Boolean']['output'];
  /** @deprecated No longer used, as searchable is determined on the Table level */
  searchable: Scalars['Boolean']['output'];
  updateable: Scalars['Boolean']['output'];
  useSnakeCase: Scalars['Boolean']['output'];
  valueType: ValueTypeEnum;
};

export type ColumnConditionInput = {
  operation: ColumnFilterOperationEnum;
  value?: InputMaybe<Scalars['String']['input']>;
  valueTo?: InputMaybe<Scalars['String']['input']>;
};

export type ColumnConditionOutput = {
  __typename?: 'ColumnConditionOutput';
  operation: ColumnFilterOperationEnum;
  value: Maybe<Scalars['String']['output']>;
  valueTo: Maybe<Scalars['String']['output']>;
};

export type ColumnFilterInput = {
  columnUid: Scalars['ID']['input'];
  conditions: Array<ColumnConditionInput>;
  joinOperator: ColumnJoinOperatorEnum;
};

export enum ColumnFilterOperationEnum {
  Blank = 'BLANK',
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  False = 'FALSE',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  InRange = 'IN_RANGE',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotBlank = 'NOT_BLANK',
  NotContains = 'NOT_CONTAINS',
  NotEqual = 'NOT_EQUAL',
  NotInRange = 'NOT_IN_RANGE',
  StartsWith = 'STARTS_WITH',
  True = 'TRUE'
}

export type ColumnFilterOutput = {
  __typename?: 'ColumnFilterOutput';
  columnName: Scalars['String']['output'];
  columnUid: Scalars['ID']['output'];
  conditions: Array<ColumnConditionOutput>;
  joinOperator: ColumnJoinOperatorEnum;
};

export enum ColumnJoinOperatorEnum {
  And = 'AND',
  Or = 'OR'
}

export type ColumnValueInput = {
  columnUid: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']>;
};

export enum ColumnValueSuggestionCategory {
  Creating = 'creating',
  Filtering = 'filtering',
  Updating = 'updating'
}

export type ColumnsFilteringInput = {
  filters: Array<ColumnFilterInput>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  joinOperator: ColumnJoinOperatorEnum;
};

export type ColumnsFilteringOutput = {
  __typename?: 'ColumnsFilteringOutput';
  filters: Array<ColumnFilterOutput>;
  joinOperator: ColumnJoinOperatorEnum;
};

export type Comment = {
  __typename?: 'Comment';
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  edited: Scalars['Boolean']['output'];
  /** Deprecated: Use either htmlForEditor or renderSafeHtml */
  htmlContent: Scalars['String']['output'];
  /** Raw unsafe HTML content  */
  htmlForEditor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** render safe HTML content */
  renderSafeHtml: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CommentThread = {
  __typename?: 'CommentThread';
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CommentThreadAttachable {
  BlockPage = 'BlockPage',
  KeyActivity = 'KeyActivity',
  List = 'List',
  Tab = 'Tab',
  Task = 'Task'
}

export type CommentThreadComments = {
  __typename?: 'CommentThreadComments';
  entries: Array<Comment>;
  pageInfo: PagingInfo;
};

export type CommentThreadInfo = {
  __typename?: 'CommentThreadInfo';
  commentsCount: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use mentionables field instead */
  mentionableUsers: Maybe<Array<User>>;
  mentionables: Array<UserInfo>;
};

export type CommsOrCategoryFilterInput = {
  activityCategories?: InputMaybe<Array<KeyActivityCategory>>;
  commsTypes?: InputMaybe<Array<InteractionEnum>>;
};

export enum CompaniesOrderBy {
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  InsightStatsTotalInteractionsAsc = 'INSIGHT_STATS_TOTAL_INTERACTIONS_ASC',
  InsightStatsTotalInteractionsDesc = 'INSIGHT_STATS_TOTAL_INTERACTIONS_DESC',
  LastInteractionAsc = 'LAST_INTERACTION_ASC',
  LastInteractionDesc = 'LAST_INTERACTION_DESC',
  NumberOfInteractionAsc = 'NUMBER_OF_INTERACTION_ASC',
  NumberOfInteractionDesc = 'NUMBER_OF_INTERACTION_DESC'
}

export type Company = {
  __typename?: 'Company';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canManageRelationshipPartners: Scalars['Boolean']['output'];
  companyHierarchy: CompanyHierarchy;
  companyType: CompanyCustomType;
  companyTypes: Array<CompanyCustomType>;
  contacts: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  documents: Array<CompanyDocument>;
  domain: Maybe<Scalars['String']['output']>;
  domains: Array<Scalars['String']['output']>;
  externalIdentifier: Maybe<ExternalIdentifier>;
  hasCustomLogo: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  info: CompanyInfo;
  insightStat: InsightStat;
  interactionsLast: LastAts;
  interactionsTotal: Totals;
  isBlocked: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  isSubDomainCompany: Scalars['Boolean']['output'];
  lastReferralSource: Maybe<Contact>;
  lastYearDepartmentsStats: Array<LastYearCompanyDepartmentStat>;
  logoUrl: Maybe<Scalars['String']['output']>;
  monthlyEngagement: Array<CompanyMonthlyInteractionDist>;
  openOpportunityCount: Scalars['Int']['output'];
  opportunityStats: OpportunityStat;
  pendingTaskCount: Scalars['Int']['output'];
  referredOpportunityStats: OpportunityStat;
  /** @deprecated use relationshipPartners */
  relationshipPartner: Maybe<Employee>;
  relationshipPartners: Maybe<Array<Employee>>;
  reporting: CompanyReporting;
  /** @deprecated Use company_types */
  secondaryTypes: Array<CompanyCustomType>;
  upcomingMeetingCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type CompanyLogoUrlArgs = {
  preferIdenticonFallback?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
};

export type CompanyAiNewsResult = {
  __typename?: 'CompanyAiNewsResult';
  citations: Array<Scalars['String']['output']>;
  failReasons: Maybe<Array<Scalars['String']['output']>>;
  summary: Scalars['String']['output'];
};

/** Attributes for company */
export type CompanyAttributes = {
  correspondenceEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  correspondenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  homepage?: InputMaybe<Scalars['String']['input']>;
  industryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Internal industry ids or internal industry names */
  internalIndustryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCard = {
  __typename?: 'CompanyCard';
  domain: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CompanyCell = {
  __typename?: 'CompanyCell';
  companyCard: Maybe<CompanyCard>;
};

export type CompanyCustomType = {
  __typename?: 'CompanyCustomType';
  defaultType: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  typeName: Scalars['String']['output'];
};

export type CompanyDetail = {
  __typename?: 'CompanyDetail';
  companyTypes: Maybe<Scalars['GridStringArrayScalar']['output']>;
  correspondenceEmails: Maybe<Scalars['GridStringArrayScalar']['output']>;
  correspondenceNumbers: Maybe<Scalars['GridStringArrayScalar']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryNames: Maybe<Scalars['GridStringArrayScalar']['output']>;
  internalIndustryNames: Maybe<Scalars['GridStringArrayScalar']['output']>;
  linkedinUrl: Maybe<Scalars['String']['output']>;
  numberOfEmployees: Maybe<Scalars['Int']['output']>;
  primaryLocation: Maybe<CompanyOfficeLocationGrid>;
  tags: Scalars['GridStringArrayScalar']['output'];
  twitterUrl: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

export type CompanyDocument = {
  __typename?: 'CompanyDocument';
  file: Maybe<File>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['Url']['output']>;
};

/** company document attributes */
export type CompanyDocumentAttributes = {
  file?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyEntries = {
  __typename?: 'CompanyEntries';
  entries: Array<Company>;
  pageInfo: PagingInfo;
};

export type CompanyExclusion = MatchingExclusion & {
  __typename?: 'CompanyExclusion';
  company: Company;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  excludeFromEveryListCategory: Scalars['Boolean']['output'];
  exclusionListCategories: Array<ListCategory>;
  exclusionType: ExclusionType;
  id: Scalars['ID']['output'];
  matchedContact: Contact;
  reason: Scalars['String']['output'];
};

export type CompanyExclusionList = {
  __typename?: 'CompanyExclusionList';
  entries: Array<CompanyExclusion>;
  pageInfo: PagingInfo;
};

/** Options for filtering contacts */
export type CompanyFilter = {
  operator: FilterOperator;
  property: CompanyFilterProperty;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanyFilterProperty {
  HeadquarterCity = 'HEADQUARTER_CITY',
  HeadquarterCountry = 'HEADQUARTER_COUNTRY',
  HeadquarterState = 'HEADQUARTER_STATE',
  IndustryNames = 'INDUSTRY_NAMES',
  InternalIndustryNames = 'INTERNAL_INDUSTRY_NAMES',
  Name = 'NAME',
  OfficeLocationCity = 'OFFICE_LOCATION_CITY',
  OfficeLocationCountry = 'OFFICE_LOCATION_COUNTRY',
  OfficeLocationState = 'OFFICE_LOCATION_STATE',
  Tags = 'TAGS'
}

/** Filtering Options for companies */
export type CompanyFiltering = {
  companyDefaultType?: InputMaybe<CompanyTypeDefault>;
  /** Filters by company type uid */
  companyTypeUid?: InputMaybe<Scalars['ID']['input']>;
  /** Filters by company uids */
  companyUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** exclude companies that have been created from work history */
  excludeWorkHistoryCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include archived companies */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeIndividuals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by Employee uid or Employee email who knows contacts */
  knowByUid?: InputMaybe<Scalars['String']['input']>;
  /** Filters by owner Employee uid or Employee email */
  ownerUid?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<CompanyFilter>>;
  term?: InputMaybe<Scalars['String']['input']>;
  timeFilters?: InputMaybe<Array<CompanyTimeFilter>>;
};

export type CompanyForCustomField = {
  __typename?: 'CompanyForCustomField';
  domain: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info: CompanyInfoForCustomField;
  logoUrl: Maybe<Scalars['String']['output']>;
};

/** Opportunity information */
export type CompanyGoal = {
  __typename?: 'CompanyGoal';
  archived: Scalars['Boolean']['output'];
  assignedTo: Maybe<Employee>;
  company: Company;
  contactLast: Maybe<LastAts>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Maybe<User>;
  customFields: Array<CustomField>;
  customStatus: Maybe<OpportunityTrackingCustomStatus>;
  date: Maybe<Scalars['ISO8601Date']['output']>;
  description: Maybe<RichContent>;
  documents: Array<GoalDocument>;
  emailBody: Maybe<RichContent>;
  id: Scalars['ID']['output'];
  includedLawyers: Array<Employee>;
  keyContacts: Maybe<Array<Contact>>;
  outcome: GoalOutcome;
  project: Maybe<Project>;
  proposedFee: Maybe<Scalars['Float']['output']>;
  proposedFeeAmount: Maybe<Money>;
  receivedReferral: Scalars['Boolean']['output'];
  referralSource: Maybe<Contact>;
  tags: Array<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Attributes for company goal */
export type CompanyGoalAttributes = {
  assignedToEmail?: InputMaybe<Scalars['String']['input']>;
  assignedToId?: InputMaybe<Scalars['ID']['input']>;
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  customStatusId?: InputMaybe<Scalars['ID']['input']>;
  /** Status Name or Status id */
  customStatusUid?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  /** Internal id or email */
  internalContactUid?: InputMaybe<Scalars['ID']['input']>;
  /** Array of key contact ids or emails */
  keyContactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Array of lawyer ids or emails */
  lawyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  messageReference?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<GoalOutcome>;
  proposedFee?: InputMaybe<Scalars['Float']['input']>;
  receivedReferral?: InputMaybe<Scalars['Boolean']['input']>;
  referralSourceEmail?: InputMaybe<Scalars['String']['input']>;
  referralSourceId?: InputMaybe<Scalars['ID']['input']>;
  /** Referral source id or email */
  referralSourceUid?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Options for filtering goals */
export type CompanyGoalFiltering = {
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  customStatusId?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** with Employee by id */
  involvedEmployeeUid?: InputMaybe<Scalars['ID']['input']>;
  messageReference?: InputMaybe<Scalars['String']['input']>;
  /** with owner id or email */
  ownerUid?: InputMaybe<Scalars['String']['input']>;
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  receivedReferral?: InputMaybe<Scalars['Boolean']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  timeFilters?: InputMaybe<Array<OpportunityTimeFilter>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** with Employee by id or email */
  withEmployeeUid?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyGoalList = {
  __typename?: 'CompanyGoalList';
  customStatusDistribution: Array<CustomStatusDistribution>;
  entries: Array<CompanyGoal>;
  pageInfo: PagingInfo;
  totalProposedFeeAmount: Money;
};

export type CompanyGrid = {
  __typename?: 'CompanyGrid';
  domain: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryNames: Array<Scalars['String']['output']>;
  internalIndustryNames: Array<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  monthlyEngagement: Array<CompanyMonthlyInteractionDist>;
  name: Scalars['String']['output'];
  typeName: Scalars['String']['output'];
  typeNames: Array<Scalars['String']['output']>;
};

export type CompanyHierarchy = {
  __typename?: 'CompanyHierarchy';
  company: Company;
  customFields: Array<CustomField>;
  hierarchy: Maybe<Hierarchy>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  parent: Maybe<Company>;
  position: Scalars['Int']['output'];
};

export type CompanyHierarchyEntries = {
  __typename?: 'CompanyHierarchyEntries';
  count: Scalars['Int']['output'];
  entries: Array<CompanyHierarchy>;
};

export type CompanyHierarchyNodeFiltering = {
  /** Filter by hierarchy id or hierarchy name */
  hierarchyUid?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyIndustryName = {
  __typename?: 'CompanyIndustryName';
  createdAt: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  internalIndustries: Array<InternalIndustry>;
  value: Scalars['String']['output'];
};

/** Options for filtering company industry names */
export type CompanyIndustryNameFiltering = {
  term?: InputMaybe<Scalars['String']['input']>;
  unmapped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyIndustryNameList = {
  __typename?: 'CompanyIndustryNameList';
  entries: Array<CompanyIndustryName>;
  pageInfo: PagingInfo;
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  correspondenceEmails: Maybe<Array<Scalars['String']['output']>>;
  correspondenceNumbers: Maybe<Array<Scalars['String']['output']>>;
  description: Maybe<Scalars['String']['output']>;
  headquarterLocation: Maybe<CompanyOfficeLocation>;
  id: Maybe<Scalars['ID']['output']>;
  industryNames: Maybe<Array<Scalars['String']['output']>>;
  internalIndustries: Maybe<Array<InternalIndustry>>;
  internalIndustryNames: Maybe<Array<Scalars['String']['output']>>;
  linkedinUrl: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
  name: Scalars['String']['output'];
  numberOfEmployees: Maybe<Scalars['Int']['output']>;
  primaryLocation: Maybe<CompanyOfficeLocation>;
  tags: Array<Scalars['String']['output']>;
  twitterUrl: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

export type CompanyInfoForCustomField = {
  __typename?: 'CompanyInfoForCustomField';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanyInteractionDist = {
  __typename?: 'CompanyInteractionDist';
  day: Scalars['ISO8601Date']['output'];
  interactionCount: Scalars['Int']['output'];
};

export type CompanyListAttributes = {
  renderMode?: InputMaybe<RenderMode>;
};

export type CompanyListEntries = {
  __typename?: 'CompanyListEntries';
  entries: Array<CompanyListItem>;
  pageInfo: PagingInfo;
};

export type CompanyListItem = {
  __typename?: 'CompanyListItem';
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  memberCustomFields: Maybe<Array<CustomFieldSchema>>;
  name: Scalars['String']['output'];
  project: Maybe<Project>;
  reminderSettings: Array<ReminderSetting>;
  tabUid: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usageMode: CompanyUsageModeInput;
};

export type CompanyListMember = {
  __typename?: 'CompanyListMember';
  company: Company;
  companyList: CompanyListItem;
  companyListId: Scalars['ID']['output'];
  completedTasksCount: Scalars['Int']['output'];
  /** @deprecated Use gridCustomFields instead */
  customFields: Array<CustomField>;
  gridCustomFields: Array<CustomFieldGrid>;
  id: Scalars['ID']['output'];
  listReminders: Array<Reminder>;
  tasksCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CompanyListMembers = {
  __typename?: 'CompanyListMembers';
  entries: Array<CompanyListMember>;
  pageInfo: PagingInfo;
};

export type CompanyMonthlyInteractionDist = {
  __typename?: 'CompanyMonthlyInteractionDist';
  interactionCount: Scalars['Int']['output'];
  month: Scalars['String']['output'];
};

export type CompanyNodeEntries = {
  __typename?: 'CompanyNodeEntries';
  entries: Array<CompanyHierarchy>;
  pageInfo: PagingInfo;
};

export type CompanyNote = {
  __typename?: 'CompanyNote';
  access: CompanyNoteAccess;
  company: Company;
  contact: Maybe<Contact>;
  content: RichContent;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: Maybe<User>;
  creatorName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updater: Maybe<User>;
};

/** Manages access and visibilty */
export enum CompanyNoteAccess {
  Custom = 'CUSTOM',
  Firmwide = 'FIRMWIDE',
  Personal = 'PERSONAL'
}

export type CompanyNoteList = {
  __typename?: 'CompanyNoteList';
  entries: Array<CompanyNote>;
  pageInfo: PagingInfo;
};

export type CompanyOfficeLocation = {
  __typename?: 'CompanyOfficeLocation';
  companyOfficeLocationId: Scalars['ID']['output'];
  headquarter: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  labels: Array<Scalars['String']['output']>;
  location: Location;
  primary: Scalars['Boolean']['output'];
};

export type CompanyOfficeLocationCard = {
  __typename?: 'CompanyOfficeLocationCard';
  brief: Scalars['String']['output'];
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  id: Scalars['ID']['output'];
  postCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  streetAddress: Maybe<Scalars['String']['output']>;
};

export type CompanyOfficeLocationCell = {
  __typename?: 'CompanyOfficeLocationCell';
  locationCard: Maybe<CompanyOfficeLocationCard>;
};

export type CompanyOfficeLocationGrid = {
  __typename?: 'CompanyOfficeLocationGrid';
  brief: Scalars['String']['output'];
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  isHeadquarter: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Maybe<Scalars['Boolean']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  streetAddress: Maybe<Scalars['String']['output']>;
};

export type CompanyOfficeLocationList = {
  __typename?: 'CompanyOfficeLocationList';
  entries: Array<CompanyOfficeLocation>;
  pageInfo: PagingInfo;
};

export type CompanyOpportunity = {
  __typename?: 'CompanyOpportunity';
  customStatus: Maybe<OpportunityTrackingCustomStatus>;
  id: Scalars['ID']['output'];
  opportunity: Maybe<Opportunity>;
  trackingNumber: Scalars['String']['output'];
};

/** Options for filtering company opportunities */
export type CompanyOpportunityFiltering = {
  /** use to filter by outcome for custom status */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  customStatusId?: InputMaybe<Scalars['String']['input']>;
  /** use to filter by employee */
  employeeUid?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** use to filter by involved employee */
  involvedEmployeeUid?: InputMaybe<Scalars['String']['input']>;
  /** use to filter by key contact */
  keyContactUid?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type CompanyOpportunityList = {
  __typename?: 'CompanyOpportunityList';
  entries: Array<CompanyOpportunity>;
};

export type CompanyProfile = {
  __typename?: 'CompanyProfile';
  emailPreview: Array<Scalars['String']['output']>;
  guessedProfileEmail: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  linkedinUrl: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  profileEmail: Maybe<Scalars['String']['output']>;
  profileImgUrl: Maybe<Scalars['String']['output']>;
  prospectEmailRequest: Maybe<ProspectEmailRequest>;
  status: Maybe<ProspectEmailRequestStatus>;
};

/** Filtering Options for company profiles */
export type CompanyProfileFiltering = {
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProfileList = {
  __typename?: 'CompanyProfileList';
  entries: Array<CompanyProfile>;
  pageInfo: PagingInfo;
};

export type CompanyProspect = {
  __typename?: 'CompanyProspect';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  position: Scalars['String']['output'];
  sourcePage: Maybe<Scalars['String']['output']>;
};

/** Filtering Options for company prospects */
export type CompanyProspectFiltering = {
  term?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyProspectList = {
  __typename?: 'CompanyProspectList';
  entries: Array<CompanyProspect>;
  pageInfo: PagingInfo;
};

export type CompanyReengagement = {
  __typename?: 'CompanyReengagement';
  company: Company;
  interactionPenalty: Scalars['Int']['output'];
};

export type CompanyReengagementList = {
  __typename?: 'CompanyReengagementList';
  entries: Array<CompanyReengagement>;
  pageInfo: PagingInfo;
};

export type CompanyReporting = {
  __typename?: 'CompanyReporting';
  url: Maybe<Scalars['Url']['output']>;
};

export type CompanySearchEntries = {
  __typename?: 'CompanySearchEntries';
  entries: Array<Prospect>;
  pageInfo: PagingInfo;
};

export enum CompanySwitchKnownDetail {
  NextCompanyKnown = 'NEXT_COMPANY_KNOWN',
  NothingKnown = 'NOTHING_KNOWN',
  OnlyPersonalKnown = 'ONLY_PERSONAL_KNOWN',
  WorkEmailKnown = 'WORK_EMAIL_KNOWN'
}

/** Options for filtering by time */
export type CompanyTimeFilter = {
  position: TimeFilterPosition;
  property: CompanyTimeFilterProperty;
  value: Scalars['ISO8601DateTime']['input'];
};

export enum CompanyTimeFilterProperty {
  Created = 'CREATED',
  Updated = 'UPDATED'
}

export enum CompanyTypeDefault {
  Client = 'CLIENT',
  Prospect = 'PROSPECT',
  Unclassified = 'UNCLASSIFIED'
}

export enum CompanyUsageModeInput {
  Personal = 'PERSONAL',
  Project = 'PROJECT',
  Shared = 'SHARED'
}

/** Autogenerated return type of CompleteClientCompaniesSyncMutation. */
export type CompleteClientCompaniesSyncMutationPayload = {
  __typename?: 'CompleteClientCompaniesSyncMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CompleteMyTaskMutation. */
export type CompleteMyTaskMutationPayload = {
  __typename?: 'CompleteMyTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CompleteTaskMutation. */
export type CompleteTaskMutationPayload = {
  __typename?: 'CompleteTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Task>;
};

export type ConfirmationPageSettings = {
  __typename?: 'ConfirmationPageSettings';
  /** The url to redirect to once form submission has succeede */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** The header text to display on the thank you page */
  thankYouHeader: Maybe<Scalars['String']['output']>;
  /** The message text to display on the thank you page */
  thankYouMessage: Maybe<Scalars['String']['output']>;
};

/** Confirmation Page Settings Input Element Type. */
export type ConfirmationPageSettingsInput = {
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  thankYouHeader?: InputMaybe<Scalars['String']['input']>;
  thankYouMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ConnectListMutation. */
export type ConnectListMutationPayload = {
  __typename?: 'ConnectListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type ConnectedList = {
  __typename?: 'ConnectedList';
  campaignManager: Maybe<CampaignManager>;
  connected: Maybe<Scalars['Boolean']['output']>;
  externalUrl: Maybe<Scalars['Url']['output']>;
  id: Scalars['String']['output'];
  lastSyncAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastSyncError: Maybe<Scalars['String']['output']>;
  list: Maybe<List>;
  mappings: Array<ConnectedListMapping>;
  nameOnEms: Maybe<Scalars['String']['output']>;
  outOfSync: Maybe<Scalars['Boolean']['output']>;
  syncing: Scalars['Boolean']['output'];
};

export type ConnectedListMapping = {
  __typename?: 'ConnectedListMapping';
  /** The form field to which the condition is applied */
  customFieldSchema: Maybe<CustomFieldSchema>;
  /** ID of the mapping */
  id: Scalars['ID']['output'];
  /** The contact detail field name */
  nexlFieldName: Maybe<ContactFieldsForSync>;
  /** The remote custom field schema ID */
  remoteCustomFieldSchemaUid: Maybe<Scalars['String']['output']>;
};

export type ConnectedListMappingInput = {
  customFieldSchemaId?: InputMaybe<Scalars['ID']['input']>;
  nexlFieldName?: InputMaybe<ContactFieldsForSync>;
  remoteCustomFieldSchemaUid?: InputMaybe<Scalars['String']['input']>;
};

export enum ConnectedListMappingSource {
  BasicField = 'BASIC_FIELD',
  GlobalField = 'GLOBAL_FIELD',
  ListCustomField = 'LIST_CUSTOM_FIELD'
}

export type ConnectedListMappings = {
  __typename?: 'ConnectedListMappings';
  entries: Array<ConnectedListMembers>;
  pageInfo: PagingInfo;
};

export type ConnectedListMembers = {
  __typename?: 'ConnectedListMembers';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mappedValues: Array<ConnectedListMembersMapped>;
};

export type ConnectedListMembersMapped = {
  __typename?: 'ConnectedListMembersMapped';
  nexlValue: Scalars['String']['output'];
  remoteCustomFieldSchemaUid: Scalars['String']['output'];
};

export enum ConnectorType {
  Brevo = 'BREVO',
  Concep = 'CONCEP',
  Tester = 'TESTER'
}

export type Contact = {
  __typename?: 'Contact';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  changedJob: Scalars['Boolean']['output'];
  company: Company;
  contactCompanySwitch: Maybe<ContactCompanySwitch>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  emailAddresses: Array<Scalars['ContactEmailScalar']['output']>;
  id: Scalars['ID']['output'];
  inMyContacts: Maybe<Scalars['Boolean']['output']>;
  info: ContactInfo;
  interactionsBounce: Maybe<BounceCount>;
  interactionsIsEngaged: Scalars['Boolean']['output'];
  interactionsLast: LastAts;
  interactionsTotal: Totals;
  /** @deprecated Use interactionsIsEngaged instead */
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isEmployee: Scalars['Boolean']['output'];
  isKeyContact: Scalars['Boolean']['output'];
  isPersonal: Scalars['Boolean']['output'];
  marketingListConsent: ContactConsent;
  nextCompanyContact: Maybe<PersonCompanyContact>;
  officeLocation: Maybe<CompanyOfficeLocation>;
  primaryEmail: Maybe<Scalars['ContactEmailScalar']['output']>;
  unarchiveOnNextInteraction: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  whoKnows: Array<WhoKnows>;
};


export type ContactWhoKnowsArgs = {
  connectionCategory: WhoKnowsCategory;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes for contact */
export type ContactAttributes = {
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  department?: InputMaybe<Scalars['String']['input']>;
  educations?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  locationAttributes?: InputMaybe<LocationAttributes>;
  /** DEPRECATED: Use location_attributes instead */
  locationsAttributes?: InputMaybe<Array<LocationAttributes>>;
  office?: InputMaybe<Scalars['String']['input']>;
  officeLocationId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCard = {
  __typename?: 'ContactCard';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Deprecated: Use company_card instead. */
  company: CompanyGrid;
  companyCard: CompanyCard;
  companyDetail: CompanyDetail;
  companyExternalIdentifier: Maybe<ExternalIdentifier>;
  companyKeyContactSince: Maybe<Scalars['ISO8601DateTime']['output']>;
  companySwitchKnownDetail: Maybe<CompanySwitchKnownDetail>;
  contactId: Scalars['ID']['output'];
  contactLocation: Maybe<Location>;
  displayName: Scalars['String']['output'];
  educations: Maybe<Scalars['GridStringArrayScalar']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isBounced: Maybe<Scalars['Boolean']['output']>;
  isInteractionsEngaged: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  linkedinUrl: Maybe<Scalars['Url']['output']>;
  phoneNumbers: Maybe<Scalars['GridStringArrayScalar']['output']>;
  primaryEmail: Maybe<Scalars['ContactEmailScalar']['output']>;
  tags: Maybe<Scalars['GridStringArrayScalar']['output']>;
  twitterUrl: Maybe<Scalars['String']['output']>;
};

export type ContactCell = {
  __typename?: 'ContactCell';
  contactCard: Maybe<ContactCard>;
};

export enum ContactCommunicationCondition {
  Any = 'ANY',
  Bounced = 'BOUNCED',
  ExclusionList = 'EXCLUSION_LIST',
  Unengaged = 'UNENGAGED'
}

export type ContactCompanySwitch = {
  __typename?: 'ContactCompanySwitch';
  /** @deprecated Never implemented */
  company: Maybe<Company>;
  creator: User;
  id: Scalars['ID']['output'];
  knownDetail: Maybe<CompanySwitchKnownDetail>;
};

export type ContactConsent = {
  __typename?: 'ContactConsent';
  autoChangedReason: Maybe<Scalars['String']['output']>;
  howWasConsentGiven: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  status: ContactConsentStatus;
  whenWasConsentGiven: Maybe<Scalars['ISO8601Date']['output']>;
};

export type ContactConsentAttribute = {
  howWasConsentGiven?: InputMaybe<Scalars['String']['input']>;
  status: ContactConsentStatus;
  whenWasConsentGiven?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export enum ContactConsentStatus {
  ConsentGiven = 'CONSENT_GIVEN',
  ConsentNotGiven = 'CONSENT_NOT_GIVEN',
  LegitimateInterest = 'LEGITIMATE_INTEREST',
  UserUnsubscribed = 'USER_UNSUBSCRIBED'
}

export type ContactEntries = {
  __typename?: 'ContactEntries';
  entries: Array<Contact>;
};

export type ContactExclusion = MatchingExclusion & {
  __typename?: 'ContactExclusion';
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  excludeFromEveryListCategory: Scalars['Boolean']['output'];
  exclusionListCategories: Array<ListCategory>;
  exclusionType: ExclusionType;
  id: Scalars['ID']['output'];
  matchedContact: Contact;
  /** Deprecated, use option_choices instead */
  optionChoiceValues: Maybe<Array<Scalars['String']['output']>>;
  optionChoices: Array<OptionChoice>;
  reason: Scalars['String']['output'];
  schema: CustomFieldSchema;
  /** Deprecated, use schema instead */
  schemaName: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating/updating a contact exclusion rule */
export type ContactExclusionAttributes = {
  /** Whether to exclude from all categories. */
  excludeFromEveryListCategory: Scalars['Boolean']['input'];
  /** The categories of lists to exclude contacts from. */
  exclusionListCategories: Array<ListCategory>;
  /** The select field values to exclude. */
  optionChoiceUids: Array<Scalars['ID']['input']>;
  /** The reason for excluding the contacts. */
  reason: Scalars['String']['input'];
  /** The select field to exclude contacts from. */
  schemaUid: Scalars['ID']['input'];
};

export type ContactExclusions = {
  __typename?: 'ContactExclusions';
  entries: Array<ContactExclusion>;
  pageInfo: PagingInfo;
};

export enum ContactFieldsForSync {
  City = 'CITY',
  CompanyName = 'COMPANY_NAME',
  Country = 'COUNTRY',
  EmailAddress = 'EMAIL_ADDRESS',
  FirstName = 'FIRST_NAME',
  JobTitle = 'JOB_TITLE',
  LastName = 'LAST_NAME',
  State = 'STATE'
}

/** Options for filtering contacts */
export type ContactFilter = {
  operator: FilterOperator;
  property: ContactFilterProperty;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ContactFilterProperty {
  City = 'CITY',
  CompanyHeadquarterCity = 'COMPANY_HEADQUARTER_CITY',
  CompanyHeadquarterCountry = 'COMPANY_HEADQUARTER_COUNTRY',
  CompanyHeadquarterState = 'COMPANY_HEADQUARTER_STATE',
  CompanyIndustryNames = 'COMPANY_INDUSTRY_NAMES',
  CompanyInternalIndustryNames = 'COMPANY_INTERNAL_INDUSTRY_NAMES',
  CompanyName = 'COMPANY_NAME',
  CompanyTags = 'COMPANY_TAGS',
  Country = 'COUNTRY',
  JobTitle = 'JOB_TITLE',
  State = 'STATE',
  Tags = 'TAGS'
}

export type ContactForCustomField = {
  __typename?: 'ContactForCustomField';
  company: Company;
  id: Scalars['ID']['output'];
  info: ContactInfoForCustomField;
  interactionsBounce: Maybe<BounceCount>;
  interactionsIsEngaged: Scalars['Boolean']['output'];
  /** @deprecated Use interactionsIsEngaged instead */
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isKeyContact: Scalars['Boolean']['output'];
  primaryEmail: Maybe<Scalars['ContactEmailScalar']['output']>;
};

export type ContactGrid = {
  __typename?: 'ContactGrid';
  city: Maybe<Scalars['String']['output']>;
  company: CompanyGrid;
  country: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isKeyContact: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  primaryEmail: Scalars['ContactEmailScalar']['output'];
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  customFields: Maybe<Array<CustomField>>;
  department: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  educations: Array<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  linkedinUrl: Maybe<Scalars['Url']['output']>;
  location: Maybe<Location>;
  office: Maybe<Scalars['String']['output']>;
  phoneNumbers: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  twitterUrl: Maybe<Scalars['String']['output']>;
};


export type ContactInfoImageUrlArgs = {
  preferIdenticonFallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactInfoForCustomField = {
  __typename?: 'ContactInfoForCustomField';
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export type ContactJobTitle = {
  __typename?: 'ContactJobTitle';
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
};

export type ContactKeyActivityList = {
  __typename?: 'ContactKeyActivityList';
  entries: Array<KeyActivity>;
};

export type ContactList = {
  __typename?: 'ContactList';
  entries: Array<Contact>;
  pageInfo: PagingInfo;
};

export type ContactListAttributes = {
  category?: InputMaybe<ListCategory>;
  renderMode?: InputMaybe<RenderMode>;
};

export type ContactListDelta = {
  __typename?: 'ContactListDelta';
  added: Array<ContactListGridMember>;
  /** Whether the delta exceeds the limit */
  exceeded: Scalars['Boolean']['output'];
  removed: Array<ContactListGridMember>;
  updated: Array<ContactListGridMember>;
};

export type ContactListForms = {
  __typename?: 'ContactListForms';
  entries: Array<Form>;
  pageInfo: PagingInfo;
};

export type ContactListGridMember = {
  __typename?: 'ContactListGridMember';
  addedBy: Maybe<UserCard>;
  completedTasksCount: Scalars['Int']['output'];
  contactCard: ContactCard;
  contactCustomFields: Array<CustomFieldGrid>;
  contactId: Scalars['ID']['output'];
  contactInteractionsLast: Maybe<LastAts>;
  contactInteractionsTotal: Maybe<Totals>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customFields: Array<CustomFieldGrid>;
  id: Scalars['ID']['output'];
  inMyContacts: Maybe<Scalars['Boolean']['output']>;
  listId: Scalars['ID']['output'];
  listReminders: Array<Reminder>;
  marketingListContactConsent: ContactConsent;
  officeLocation: Maybe<Location>;
  tasksCount: Scalars['Int']['output'];
  topKnowBy: Array<WhoKnows>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ContactListGridMemberEntries = {
  __typename?: 'ContactListGridMemberEntries';
  deltaAfter: Scalars['ISO8601DateTime']['output'];
  entries: Array<ContactListGridMember>;
  id: Scalars['ID']['output'];
  pageInfo: PagingInfo;
};


export type ContactListGridMemberEntriesDeltaAfterArgs = {
  deltaSize: Scalars['Int']['input'];
};

/** Filtering Options for contact list grid members */
export type ContactListGridMembersFiltering = {
  groups?: InputMaybe<Array<GroupFilter>>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPreference = {
  __typename?: 'ContactPreference';
  customFieldSchema: CustomFieldSchema;
  customFieldValue: Maybe<CustomField>;
};

export type ContactPreferences = {
  __typename?: 'ContactPreferences';
  entries: Array<ContactPreference>;
  schemaCount: Scalars['Int']['output'];
};

export enum ContactPrivacy {
  PrivateEntireHistory = 'PRIVATE_ENTIRE_HISTORY',
  PrivateFutureHistory = 'PRIVATE_FUTURE_HISTORY',
  Public = 'PUBLIC'
}

export type ContactRequireHierarchyPlacement = {
  __typename?: 'ContactRequireHierarchyPlacement';
  contact: Contact;
  hierarchy: Hierarchy;
  id: Scalars['ID']['output'];
};

export type ContactRequireHierarchyPlacementList = {
  __typename?: 'ContactRequireHierarchyPlacementList';
  entries: Maybe<Array<ContactRequireHierarchyPlacement>>;
  pageInfo: Maybe<PagingInfo>;
};

/** Options for filtering by time */
export type ContactTimeFilter = {
  position: TimeFilterPosition;
  property: ContactTimeFilterProperty;
  value: Scalars['ISO8601DateTime']['input'];
};

export enum ContactTimeFilterProperty {
  Created = 'CREATED',
  Updated = 'UPDATED'
}

export type ContactUpdateEvent = {
  __typename?: 'ContactUpdateEvent';
  change: Maybe<UpdateEventChange>;
  contact: Contact;
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventDate: Scalars['ISO8601Date']['output'];
  eventType: UpdateEvent;
  id: Scalars['ID']['output'];
  nextValue: Scalars['String']['output'];
};

export type ContactUpdateEventFilter = {
  companyTypeUids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of ContactsBulkMarkKeyActivityWithTrackerMutation. */
export type ContactsBulkMarkKeyActivityWithTrackerMutationPayload = {
  __typename?: 'ContactsBulkMarkKeyActivityWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type ContactsExistInList = {
  __typename?: 'ContactsExistInList';
  entries: Array<Scalars['String']['output']>;
};

/** Filtering Options for contacts */
export type ContactsFiltering = {
  /** Company uid */
  belongToCompanyHierarchy?: InputMaybe<Scalars['ID']['input']>;
  companyRelationshipPartnerUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyTypeUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  consentStatuses?: InputMaybe<Array<ContactConsentStatus>>;
  contactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Use in conjunction with include_internal_contact=true to get all employees */
  excludeExternal?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<GroupFilter>>;
  /** Include archived contacts */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeInternalContact?: InputMaybe<Scalars['Boolean']['input']>;
  keyActivityDescription?: InputMaybe<Scalars['String']['input']>;
  keyActivityTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  knowByUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  missingKeyData?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  timeFilters?: InputMaybe<Array<ContactTimeFilter>>;
  withBouncedEmails?: InputMaybe<Scalars['Boolean']['input']>;
  withCustomField?: InputMaybe<Array<CustomFieldTerm>>;
  /** When set to true, only returns contacts who have changed jobs */
  withJobChanges?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContactsOrderBy {
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  LastInteractionAsc = 'LAST_INTERACTION_ASC',
  LastInteractionDesc = 'LAST_INTERACTION_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  NumberOfInteractionAsc = 'NUMBER_OF_INTERACTION_ASC',
  NumberOfInteractionDesc = 'NUMBER_OF_INTERACTION_DESC'
}

export type ContactsReviewConfiguration = {
  __typename?: 'ContactsReviewConfiguration';
  allowContactsReview: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type ContactsReviewRule = {
  __typename?: 'ContactsReviewRule';
  id: Scalars['ID']['output'];
  optionChoice: OptionChoice;
  schema: CustomFieldSchema;
  subTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Content type for notes */
export enum ContentTypeEnum {
  Html = 'HTML',
  Markdown = 'MARKDOWN'
}

/** Core permissions */
export type CorePermission = {
  __typename?: 'CorePermission';
  allCompanies: Scalars['Boolean']['output'];
  allContacts: Scalars['Boolean']['output'];
  exportAllCompanies: Scalars['Boolean']['output'];
  exportAllContacts: Scalars['Boolean']['output'];
  exportMyCompanies: Scalars['Boolean']['output'];
  exportMyContacts: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  showMyCompanies: Scalars['Boolean']['output'];
  showMyContacts: Scalars['Boolean']['output'];
  viewCompanyRecords: Scalars['Boolean']['output'];
  viewCompanyWhoKnows: Scalars['Boolean']['output'];
  viewContactActivities: Scalars['Boolean']['output'];
  viewContactEmailAddresses: Scalars['Boolean']['output'];
  viewContactRecords: Scalars['Boolean']['output'];
  viewContactWhoKnows: Scalars['Boolean']['output'];
  viewEmployeeEngagementTab: Scalars['Boolean']['output'];
  viewLastInteractionDateFirm: Scalars['Boolean']['output'];
  viewLastInteractionDateUser: Scalars['Boolean']['output'];
};

/** Country information */
export type Country = {
  __typename?: 'Country';
  code: CountryCode;
  emojiFlag: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryCell = {
  __typename?: 'CountryCell';
  country: Maybe<Country>;
};

/** Alpha 2 code representing a country */
export enum CountryCode {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo, The Democratic Republic of the */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cabo Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czechia */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands (Malvinas) */
  Fk = 'FK',
  /** Micronesia, Federated States of */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Lao People's Democratic Republic */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** North Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine, State of */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russian Federation */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syrian Arab Republic */
  Sy = 'SY',
  /** Eswatini */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Türkiye */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Holy See (Vatican City State) */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** Virgin Islands, British */
  Vg = 'VG',
  /** Virgin Islands, U.S. */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

/** Autogenerated return type of CreateApiDefinitionMutation. */
export type CreateApiDefinitionMutationPayload = {
  __typename?: 'CreateApiDefinitionMutationPayload';
  apiConnection: Maybe<ApiSourceTable>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateBlockPageListTabMutation. */
export type CreateBlockPageListTabMutationPayload = {
  __typename?: 'CreateBlockPageListTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateCampaignMutation. */
export type CreateCampaignMutationPayload = {
  __typename?: 'CreateCampaignMutationPayload';
  campaign: Maybe<Campaign>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateCampaignTabMutation. */
export type CreateCampaignTabMutationPayload = {
  __typename?: 'CreateCampaignTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateCareerCompanyMutation. */
export type CreateCareerCompanyMutationPayload = {
  __typename?: 'CreateCareerCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<PersonCompanyContact>;
};

/** Autogenerated return type of CreateCommentThreadMutation. */
export type CreateCommentThreadMutationPayload = {
  __typename?: 'CreateCommentThreadMutationPayload';
  commentThread: Maybe<CommentThread>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateCompanyContactMutation. */
export type CreateCompanyContactMutationPayload = {
  __typename?: 'CreateCompanyContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  uid: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateCompanyKeyContactMutation. */
export type CreateCompanyKeyContactMutationPayload = {
  __typename?: 'CreateCompanyKeyContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateCompanyListCustomFieldSchemaMutation. */
export type CreateCompanyListCustomFieldSchemaMutationPayload = {
  __typename?: 'CreateCompanyListCustomFieldSchemaMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CustomFieldSchema>;
};

/** Autogenerated return type of CreateCompanyListMutation. */
export type CreateCompanyListMutationPayload = {
  __typename?: 'CreateCompanyListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateCompanyListReminderSettingMutation. */
export type CreateCompanyListReminderSettingMutationPayload = {
  __typename?: 'CreateCompanyListReminderSettingMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateCompanyMutation. */
export type CreateCompanyMutationPayload = {
  __typename?: 'CreateCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  uid: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateCompanyNoteMutation. */
export type CreateCompanyNoteMutationPayload = {
  __typename?: 'CreateCompanyNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateCompanyRelationshipPartnerMutation. */
export type CreateCompanyRelationshipPartnerMutationPayload = {
  __typename?: 'CreateCompanyRelationshipPartnerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  relationshipPartnerCreated: Maybe<RelationshipPartner>;
};

/** Autogenerated return type of CreateContactExclusionRuleMutation. */
export type CreateContactExclusionRuleMutationPayload = {
  __typename?: 'CreateContactExclusionRuleMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<ContactExclusion>;
};

/** Autogenerated return type of CreateContactListMutation. */
export type CreateContactListMutationPayload = {
  __typename?: 'CreateContactListMutationPayload';
  contactList: Maybe<List>;
  failReasons: Array<Scalars['String']['output']>;
  /** @deprecated Use contactList { id } instead */
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateContactListReminderSettingMutation. */
export type CreateContactListReminderSettingMutationPayload = {
  __typename?: 'CreateContactListReminderSettingMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateContactListWebhookMutation. */
export type CreateContactListWebhookMutationPayload = {
  __typename?: 'CreateContactListWebhookMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<WebhookTrigger>;
};

/** Autogenerated return type of CreateContactMutation. */
export type CreateContactMutationPayload = {
  __typename?: 'CreateContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Contact>;
  /** @deprecated Use `record { id }` instead */
  uid: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateContactsMutation. */
export type CreateContactsMutationPayload = {
  __typename?: 'CreateContactsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateCustomObjectRecordsMutation. */
export type CreateCustomObjectRecordsMutationPayload = {
  __typename?: 'CreateCustomObjectRecordsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateCustomUserRoleMutation. */
export type CreateCustomUserRoleMutationPayload = {
  __typename?: 'CreateCustomUserRoleMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  role: Maybe<AccessRole>;
};

/** Autogenerated return type of CreateDataTemplatesRecordMutation. */
export type CreateDataTemplatesRecordMutationPayload = {
  __typename?: 'CreateDataTemplatesRecordMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateDataTemplatesTemplateMutation. */
export type CreateDataTemplatesTemplateMutationPayload = {
  __typename?: 'CreateDataTemplatesTemplateMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  template: Maybe<DataTemplate>;
};

/** Autogenerated return type of CreateEmbedUrlTabMutation. */
export type CreateEmbedUrlTabMutationPayload = {
  __typename?: 'CreateEmbedUrlTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateEventPackRequestMutation. */
export type CreateEventPackRequestMutationPayload = {
  __typename?: 'CreateEventPackRequestMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<EventPackRequest>;
};

/** Autogenerated return type of CreateExportAuditMutation. */
export type CreateExportAuditMutationPayload = {
  __typename?: 'CreateExportAuditMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateFlatfileWorkbookForAdminImportMutation. */
export type CreateFlatfileWorkbookForAdminImportMutationPayload = {
  __typename?: 'CreateFlatfileWorkbookForAdminImportMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  workbook: Maybe<FlatFileWorkbook>;
};

/** Autogenerated return type of CreateFlatfileWorkbookForCustomObjectsAdminImportMutation. */
export type CreateFlatfileWorkbookForCustomObjectsAdminImportMutationPayload = {
  __typename?: 'CreateFlatfileWorkbookForCustomObjectsAdminImportMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  workbook: Maybe<FlatFileWorkbook>;
};

/** Autogenerated return type of CreateFlatfileWorkbookForListImportMutation. */
export type CreateFlatfileWorkbookForListImportMutationPayload = {
  __typename?: 'CreateFlatfileWorkbookForListImportMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  workbook: Maybe<FlatFileWorkbook>;
};

/** Autogenerated return type of CreateFormMutation. */
export type CreateFormMutationPayload = {
  __typename?: 'CreateFormMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Form>;
};

/** Autogenerated return type of CreateFormWorkflowMutation. */
export type CreateFormWorkflowMutationPayload = {
  __typename?: 'CreateFormWorkflowMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  workflow: Maybe<Workflow>;
};

/** Autogenerated return type of CreateGenericListCustomFieldSchemaMutation. */
export type CreateGenericListCustomFieldSchemaMutationPayload = {
  __typename?: 'CreateGenericListCustomFieldSchemaMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateGenericListItemMutation. */
export type CreateGenericListItemMutationPayload = {
  __typename?: 'CreateGenericListItemMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<GenericListItem>;
};

/** Autogenerated return type of CreateGenericListMutation. */
export type CreateGenericListMutationPayload = {
  __typename?: 'CreateGenericListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<GenericList>;
};

/** Autogenerated return type of CreateGenericListReminderSettingMutation. */
export type CreateGenericListReminderSettingMutationPayload = {
  __typename?: 'CreateGenericListReminderSettingMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateGenericListWebhookMutation. */
export type CreateGenericListWebhookMutationPayload = {
  __typename?: 'CreateGenericListWebhookMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<WebhookTrigger>;
};

/** Autogenerated return type of CreateInternalIndustryMutation. */
export type CreateInternalIndustryMutationPayload = {
  __typename?: 'CreateInternalIndustryMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateKeyActivitiesMutation. */
export type CreateKeyActivitiesMutationPayload = {
  __typename?: 'CreateKeyActivitiesMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateKeyActivityListCustomFieldSchemaMutation. */
export type CreateKeyActivityListCustomFieldSchemaMutationPayload = {
  __typename?: 'CreateKeyActivityListCustomFieldSchemaMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateKeyActivityListTabMutation. */
export type CreateKeyActivityListTabMutationPayload = {
  __typename?: 'CreateKeyActivityListTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<TabResult>;
};

/** Autogenerated return type of CreateLinkedinPostRequestMutation. */
export type CreateLinkedinPostRequestMutationPayload = {
  __typename?: 'CreateLinkedinPostRequestMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<LinkedinPostRequest>;
};

/** Autogenerated return type of CreateListCustomFieldSchemaMutation. */
export type CreateListCustomFieldSchemaMutationPayload = {
  __typename?: 'CreateListCustomFieldSchemaMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateListViewMutation. */
export type CreateListViewMutationPayload = {
  __typename?: 'CreateListViewMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  listView: Maybe<ListView>;
};

/** Autogenerated return type of CreateMarketingContactListMutation. */
export type CreateMarketingContactListMutationPayload = {
  __typename?: 'CreateMarketingContactListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<List>;
};

/** Autogenerated return type of CreateMarketingEmailRequestMutation. */
export type CreateMarketingEmailRequestMutationPayload = {
  __typename?: 'CreateMarketingEmailRequestMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<MarketingEmailRequest>;
};

/** Autogenerated return type of CreateNoteMutation. */
export type CreateNoteMutationPayload = {
  __typename?: 'CreateNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  note: Maybe<Note>;
};

/** Autogenerated return type of CreateObjectiveMutation. */
export type CreateObjectiveMutationPayload = {
  __typename?: 'CreateObjectiveMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  objectiveUuid: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreateOfficeLocationMutation. */
export type CreateOfficeLocationMutationPayload = {
  __typename?: 'CreateOfficeLocationMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreatePageViewTabMutation. */
export type CreatePageViewTabMutationPayload = {
  __typename?: 'CreatePageViewTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of CreatePersonMutation. */
export type CreatePersonMutationPayload = {
  __typename?: 'CreatePersonMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateProgressMutation. */
export type CreateProgressMutationPayload = {
  __typename?: 'CreateProgressMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateProjectFolderMutation. */
export type CreateProjectFolderMutationPayload = {
  __typename?: 'CreateProjectFolderMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateProjectFromTemplateMutation. */
export type CreateProjectFromTemplateMutationPayload = {
  __typename?: 'CreateProjectFromTemplateMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Project>;
};

/** Autogenerated return type of CreateProjectMutation. */
export type CreateProjectMutationPayload = {
  __typename?: 'CreateProjectMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Project>;
};

/** Autogenerated return type of CreateProjectOpportunityCustomFieldSchemaMutation. */
export type CreateProjectOpportunityCustomFieldSchemaMutationPayload = {
  __typename?: 'CreateProjectOpportunityCustomFieldSchemaMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CustomFieldSchema>;
};

/** Autogenerated return type of CreateProjectOpportunityMutation. */
export type CreateProjectOpportunityMutationPayload = {
  __typename?: 'CreateProjectOpportunityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<ProjectOpportunityGrid>;
};

/** Autogenerated return type of CreateReportMutation. */
export type CreateReportMutationPayload = {
  __typename?: 'CreateReportMutationPayload';
  /** Errors encountered during creation. */
  failReasons: Array<Scalars['String']['output']>;
  /** The created report. */
  report: Maybe<ResearchReport>;
};

/** Autogenerated return type of CreateReportSectionMutation. */
export type CreateReportSectionMutationPayload = {
  __typename?: 'CreateReportSectionMutationPayload';
  /** Errors encountered during creation. */
  failReasons: Array<Scalars['String']['output']>;
  /** The created report section. */
  reportSection: Maybe<ResearchReportSection>;
};

/** Autogenerated return type of CreateSentReferralMutation. */
export type CreateSentReferralMutationPayload = {
  __typename?: 'CreateSentReferralMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<SentReferral>;
};

/** Autogenerated return type of CreateStaticCompanyListTabMutation. */
export type CreateStaticCompanyListTabMutationPayload = {
  __typename?: 'CreateStaticCompanyListTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  record: Maybe<TabResult>;
};

/** Autogenerated return type of CreateStaticContactListTabMutation. */
export type CreateStaticContactListTabMutationPayload = {
  __typename?: 'CreateStaticContactListTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  record: Maybe<TabResult>;
};

/** Autogenerated return type of CreateStaticGenericListTabMutation. */
export type CreateStaticGenericListTabMutationPayload = {
  __typename?: 'CreateStaticGenericListTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  /** Depreciated, use record.id instead. */
  id: Maybe<Scalars['ID']['output']>;
  record: Maybe<TabResult>;
};

/** Autogenerated return type of CreateStaticMarketingListTabMutation. */
export type CreateStaticMarketingListTabMutationPayload = {
  __typename?: 'CreateStaticMarketingListTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  record: Maybe<TabResult>;
};

/** Input fields for creating a rollup field */
export type CreateTableLikeRollupFieldInput = {
  /** Optional filtering conditions */
  conditions?: InputMaybe<ColumnsFilteringInput>;
  /** Name of the rollup field */
  name: Scalars['String']['input'];
  /** Type of aggregation operation */
  operationType: OperationTypeEnum;
  /** ID of the owner */
  ownedById: Scalars['ID']['input'];
  /** Type of the owner */
  ownedByType: TableLikeRollupOwnedByTypeEnum;
  /** ID of the source list */
  sourceListId?: InputMaybe<Scalars['ID']['input']>;
  /** Type of the source list */
  sourceListType?: InputMaybe<TableLikeRollupSourceListTypeEnum>;
  /** Type of the source for the rollup field */
  sourceType: SourceTypeEnum;
  /** ID of the target column for aggregation (required for non-COUNT operations) */
  targetColumnId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateTableLikeRollupFieldMutation. */
export type CreateTableLikeRollupFieldMutationPayload = {
  __typename?: 'CreateTableLikeRollupFieldMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  rollupField: Maybe<TableLikeRollupFieldType>;
};

/** Autogenerated return type of CreateTagMutation. */
export type CreateTagMutationPayload = {
  __typename?: 'CreateTagMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type CreateTaskAttributes = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueOn?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<PriorityEnum>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTaskMutation. */
export type CreateTaskMutationPayload = {
  __typename?: 'CreateTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Task>;
};

/** Autogenerated return type of CreateTemplateMutation. */
export type CreateTemplateMutationPayload = {
  __typename?: 'CreateTemplateMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  template: Maybe<Template>;
};

/** Autogenerated return type of CreateTemplateSavedRowMutation. */
export type CreateTemplateSavedRowMutationPayload = {
  __typename?: 'CreateTemplateSavedRowMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  savedRow: Maybe<TemplateSavedRow>;
};

/** Autogenerated return type of CreateTrackEventMutation. */
export type CreateTrackEventMutationPayload = {
  __typename?: 'CreateTrackEventMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateUserDelegateAccessMutation. */
export type CreateUserDelegateAccessMutationPayload = {
  __typename?: 'CreateUserDelegateAccessMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateWebhookMutation. */
export type CreateWebhookMutationPayload = {
  __typename?: 'CreateWebhookMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: WebhookTrigger;
};

/** Currency information */
export type Currency = {
  __typename?: 'Currency';
  decimalMark: Scalars['String']['output'];
  exponent: Scalars['Int']['output'];
  isoCode: CurrencyCode;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  symbolFirst: Scalars['Boolean']['output'];
  thousandsSeparator: Scalars['String']['output'];
};

export type CurrencyCell = {
  __typename?: 'CurrencyCell';
  money: Maybe<Money>;
};

/** Currency iso code */
export enum CurrencyCode {
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Gulden */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bitcoin Cash */
  Bch = 'BCH',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudian Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bitcoin */
  Btc = 'BTC',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Botswana Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belarusian Ruble */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** Swiss Franc */
  Chf = 'CHF',
  /** Unidad de Fomento */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Renminbi Yuan Offshore */
  Cnh = 'CNH',
  /** Chinese Renminbi Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Czech Koruna */
  Czk = 'CZK',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Pound */
  Fkp = 'FKP',
  /** British Pound */
  Gbp = 'GBP',
  /** British Penny */
  Gbx = 'GBX',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Guernsey Pound */
  Ggp = 'GGP',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Guyanese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Israeli New Sheqel */
  Ils = 'ILS',
  /** Isle of Man Pound */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Jersey Pound */
  Jep = 'JEP',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgyzstani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Lao Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tögrög */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya */
  Mro = 'MRO',
  /** Mauritanian Ouguiya */
  Mru = 'MRU',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Złoty */
  Pln = 'PLN',
  /** Paraguayan Guaraní */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Saint Helenian Pound */
  Shp = 'SHP',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** New Leone */
  Sle = 'SLE',
  /** Sierra Leonean Leone */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé and Príncipe Dobra */
  Std = 'STD',
  /** São Tomé and Príncipe Second Dobra */
  Stn = 'STN',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat */
  Tmm = 'TMM',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd = 'TTD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** United States Dollar */
  Usd = 'USD',
  /** USD Coin */
  Usdc = 'USDC',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uzbekistan Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar */
  Vef = 'VEF',
  /** Venezuelan Bolívar Soberano */
  Ves = 'VES',
  /** Vietnamese Đồng */
  Vnd = 'VND',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African Cfa Franc */
  Xaf = 'XAF',
  /** Silver (Troy Ounce) */
  Xag = 'XAG',
  /** Gold (Troy Ounce) */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account 9 */
  Xbc = 'XBC',
  /** European Unit of Account 17 */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** UIC Franc */
  Xfu = 'XFU',
  /** West African Cfa Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** Cfp Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** Codes specifically reserved for testing purposes */
  Xts = 'XTS',
  /** Yemeni Rial */
  Yer = 'YER',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha */
  Zmk = 'ZMK',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zimbabwean Dollar */
  Zwd = 'ZWD',
  /** Zimbabwean Dollar */
  Zwl = 'ZWL',
  /** Zimbabwean Dollar */
  Zwn = 'ZWN',
  /** Zimbabwean Dollar */
  Zwr = 'ZWR'
}

export type CustomBoardColumn = {
  __typename?: 'CustomBoardColumn';
  count: Scalars['Int']['output'];
  customStatus: OpportunityTrackingCustomStatus;
  displayLimitExceeded: Maybe<Scalars['Boolean']['output']>;
  items: Array<CustomBoardItem>;
  totalProposedFees: Money;
};

export type CustomBoardItem = {
  __typename?: 'CustomBoardItem';
  index: Maybe<Scalars['Int']['output']>;
  opportunity: CompanyGoal;
};

export type CustomCurrencyFieldGrid = {
  __typename?: 'CustomCurrencyFieldGrid';
  amount: Maybe<Money>;
};

export type CustomDatetimeFieldGrid = {
  __typename?: 'CustomDatetimeFieldGrid';
  date: Maybe<Scalars['ISO8601Date']['output']>;
};

export type CustomEmployeeFieldGrid = {
  __typename?: 'CustomEmployeeFieldGrid';
  employee: Maybe<EmployeeGrid>;
};

/** Company goal custom fields */
export type CustomField = {
  __typename?: 'CustomField';
  currency: Maybe<Currency>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  schemaId: Scalars['ID']['output'];
  stringValue: Scalars['String']['output'];
  value: Maybe<CustomFieldValue>;
  valueTypeEnum: Maybe<CustomFieldSchemaValue>;
};

export type CustomFieldAttribute = {
  jsonValue?: InputMaybe<Scalars['CustomValueStringScalar']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schemaId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type CustomFieldCompany = {
  __typename?: 'CustomFieldCompany';
  companies: Maybe<Array<CompanyForCustomField>>;
};

export type CustomFieldContact = {
  __typename?: 'CustomFieldContact';
  contacts: Maybe<Array<ContactForCustomField>>;
};

export type CustomFieldDate = {
  __typename?: 'CustomFieldDate';
  dateValue: Maybe<Scalars['ISO8601Date']['output']>;
};

export type CustomFieldEmployee = {
  __typename?: 'CustomFieldEmployee';
  employee: Maybe<EmployeeForCustomField>;
};

export type CustomFieldFullDateTime = {
  __typename?: 'CustomFieldFullDateTime';
  dateTime: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Opportunity custom fields */
export type CustomFieldGrid = {
  __typename?: 'CustomFieldGrid';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  schemaId: Scalars['ID']['output'];
  schemaValueType: CustomFieldSchemaValue;
  stringValue: Maybe<Scalars['String']['output']>;
  value: Maybe<CustomFieldGridValueUnion>;
};

export type CustomFieldGridTypeEntries = {
  __typename?: 'CustomFieldGridTypeEntries';
  entries: Array<CustomFieldGrid>;
};

export type CustomFieldGridValueUnion = CustomCurrencyFieldGrid | CustomDatetimeFieldGrid | CustomEmployeeFieldGrid | CustomFullDateTimeFieldGrid | CustomMultiCompanyFieldGrid | CustomMultiContactFieldGrid | CustomMultiCountryFieldGrid | CustomMultiEmployeeFieldGrid | CustomMultiOptionalValueFieldGrid | CustomNewlyDefinedFieldGrid | CustomNumberFieldGrid | CustomOptionalValueFieldGrid | CustomRichTextFieldGrid | CustomTextFieldGrid;

export type CustomFieldMoney = {
  __typename?: 'CustomFieldMoney';
  moneyValue: Maybe<Money>;
};

export type CustomFieldMulti = {
  __typename?: 'CustomFieldMulti';
  multiOption: Maybe<Array<Option>>;
};

export type CustomFieldMultiCountry = {
  __typename?: 'CustomFieldMultiCountry';
  countries: Maybe<Array<Country>>;
};

export type CustomFieldMultiEmployee = {
  __typename?: 'CustomFieldMultiEmployee';
  employees: Maybe<Array<EmployeeForCustomField>>;
};

export type CustomFieldNumber = {
  __typename?: 'CustomFieldNumber';
  numberValue: Maybe<Scalars['BigInt']['output']>;
};

export type CustomFieldOptional = {
  __typename?: 'CustomFieldOptional';
  option: Maybe<Option>;
};

export type CustomFieldRichText = {
  __typename?: 'CustomFieldRichText';
  richContent: RichContent;
};

export type CustomFieldSchema = {
  __typename?: 'CustomFieldSchema';
  campaigns: Maybe<Array<Campaign>>;
  currency: Maybe<Currency>;
  hideFromForm: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optionChoices: Maybe<Array<OptionChoice>>;
  position: Scalars['Int']['output'];
  schemaId: Scalars['String']['output'];
  searchable: Maybe<Scalars['Boolean']['output']>;
  usage: CustomFieldSchemaUsage;
  valueTypeEnum: CustomFieldSchemaValue;
};

export type CustomFieldSchemaAttributes = {
  currencyCode?: InputMaybe<CurrencyCode>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<OptionsAttributes>>;
  valueType?: InputMaybe<CustomFieldSchemaValue>;
};

export type CustomFieldSchemaInputAttributes = {
  name?: InputMaybe<Scalars['String']['input']>;
  options: Array<OptionChoiceAttributes>;
  schemaUid: Scalars['ID']['input'];
};

/** What type of object the custom field is associated with */
export enum CustomFieldSchemaOwner {
  Contact = 'CONTACT',
  HierarchyNode = 'HIERARCHY_NODE',
  Opportunity = 'OPPORTUNITY',
  SentReferral = 'SENT_REFERRAL'
}

export type CustomFieldSchemaPosition = {
  position: Scalars['Int']['input'];
  schemaId: Scalars['ID']['input'];
};

export enum CustomFieldSchemaUsage {
  Default = 'DEFAULT',
  Preference = 'PREFERENCE'
}

export enum CustomFieldSchemaValue {
  Currency = 'CURRENCY',
  Datetime = 'DATETIME',
  Employee = 'EMPLOYEE',
  FullDateTime = 'FULL_DATE_TIME',
  MultiCompany = 'MULTI_COMPANY',
  MultiContact = 'MULTI_CONTACT',
  MultiCountry = 'MULTI_COUNTRY',
  MultiEmployee = 'MULTI_EMPLOYEE',
  MultiOptionalValue = 'MULTI_OPTIONAL_VALUE',
  Number = 'NUMBER',
  OptionalValue = 'OPTIONAL_VALUE',
  RichText = 'RICH_TEXT',
  Text = 'TEXT'
}

export type CustomFieldSchemasList = {
  __typename?: 'CustomFieldSchemasList';
  entries: Array<CustomFieldSchema>;
};

export type CustomFieldSelectSearchFilter = {
  operator: SelectSearchOperator;
  property: Scalars['String']['input'];
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomFieldString = {
  __typename?: 'CustomFieldString';
  stringValue: Maybe<Scalars['String']['output']>;
};

export type CustomFieldTerm = {
  name?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomFieldTextSearchFilter = {
  operator: TextSearchOperator;
  property: Scalars['String']['input'];
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomFieldTimeRange = {
  __typename?: 'CustomFieldTimeRange';
  timeRange: Maybe<TimeRange>;
};

export type CustomFieldTypeEntries = {
  __typename?: 'CustomFieldTypeEntries';
  entries: Array<CustomField>;
};

/** Custom Field Value */
export type CustomFieldValue = CustomFieldCompany | CustomFieldContact | CustomFieldDate | CustomFieldEmployee | CustomFieldFullDateTime | CustomFieldMoney | CustomFieldMulti | CustomFieldMultiCountry | CustomFieldMultiEmployee | CustomFieldNumber | CustomFieldOptional | CustomFieldRichText | CustomFieldString | CustomFieldTimeRange;

export type CustomFullDateTimeFieldGrid = {
  __typename?: 'CustomFullDateTimeFieldGrid';
  dateTime: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type CustomMultiCompanyFieldGrid = {
  __typename?: 'CustomMultiCompanyFieldGrid';
  companies: Array<CompanyGrid>;
  companyCards: Array<CompanyCard>;
  companyDetails: Array<CompanyDetail>;
};

export type CustomMultiContactFieldGrid = {
  __typename?: 'CustomMultiContactFieldGrid';
  contactCards: Array<ContactCard>;
  contacts: Array<ContactGrid>;
};

export type CustomMultiCountryFieldGrid = {
  __typename?: 'CustomMultiCountryFieldGrid';
  countries: Array<Country>;
};

export type CustomMultiEmployeeFieldGrid = {
  __typename?: 'CustomMultiEmployeeFieldGrid';
  employees: Array<EmployeeGrid>;
};

export type CustomMultiOptionalValueFieldGrid = {
  __typename?: 'CustomMultiOptionalValueFieldGrid';
  selected: Array<Option>;
};

export type CustomNewlyDefinedFieldGrid = {
  __typename?: 'CustomNewlyDefinedFieldGrid';
  customableId: Maybe<Scalars['String']['output']>;
};

export type CustomNumberFieldGrid = {
  __typename?: 'CustomNumberFieldGrid';
  /** @deprecated Use `numberValue` instead */
  number: Maybe<Scalars['Int']['output']>;
  numberValue: Maybe<Scalars['BigInt']['output']>;
};

export type CustomObjectsFieldValueInput = {
  fieldUid: Scalars['ID']['input'];
  fieldValue: Array<Scalars['String']['input']>;
};

export type CustomObjectsRecordValueInput = {
  fieldValues: Array<CustomObjectsFieldValueInput>;
  templateUid: Scalars['ID']['input'];
};

export type CustomOptionalValueFieldGrid = {
  __typename?: 'CustomOptionalValueFieldGrid';
  selected: Maybe<Option>;
};

export type CustomRichTextFieldGrid = {
  __typename?: 'CustomRichTextFieldGrid';
  html: Scalars['String']['output'];
  plainText: Scalars['String']['output'];
  trixHtml: Scalars['String']['output'];
};

export type CustomStatusDistribution = {
  __typename?: 'CustomStatusDistribution';
  count: Scalars['Int']['output'];
  customStatus: OpportunityTrackingCustomStatus;
  totalProposedFeeAmount: Money;
};

export type CustomTextFieldGrid = {
  __typename?: 'CustomTextFieldGrid';
  text: Maybe<Scalars['String']['output']>;
};

export type DataCleanerConfiguration = {
  __typename?: 'DataCleanerConfiguration';
  id: Maybe<Scalars['ID']['output']>;
  showContactsRequiringPlacement: Scalars['Boolean']['output'];
};

export type DataTemplate = {
  __typename?: 'DataTemplate';
  columns: Array<DataTemplateColumn>;
  fields: Array<DataTemplateField>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DataTemplateColumn = {
  __typename?: 'DataTemplateColumn';
  filterOperations: Array<ColumnFilterOperationEnum>;
  headerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initialHide: Scalars['Boolean']['output'];
  sortable: Scalars['Boolean']['output'];
  templateFieldType: TemplateFieldType;
};

export type DataTemplateEntries = {
  __typename?: 'DataTemplateEntries';
  entries: Array<DataTemplate>;
  pageInfo: PagingInfo;
};

export type DataTemplateEntriesFilter = {
  /** Template Ids or Names to filter by */
  templateUid?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DataTemplateField = {
  __typename?: 'DataTemplateField';
  fieldType: TemplateFieldType;
  id: Scalars['ID']['output'];
  multiple: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum DataTemplatePermissionAccessEnum {
  Read = 'READ',
  Write = 'WRITE'
}

export enum DataTemplatePermissionVisibilityEnum {
  All = 'ALL',
  My = 'MY',
  None = 'NONE'
}

export type DataTemplatePermissionsEntries = {
  __typename?: 'DataTemplatePermissionsEntries';
  entries: Array<TemplateRolePermission>;
  pageInfo: PagingInfo;
};

export type DateContactSearchFilter = {
  operator: DateSearchOperator;
  property: DateContactSearchableProperty;
  values: Array<Scalars['String']['input']>;
};

export enum DateContactSearchableProperty {
  CreatedDate = 'CREATED_DATE',
  KeyActivityOn = 'KEY_ACTIVITY_ON',
  LastMeetingOn = 'LAST_MEETING_ON'
}

export type DateListMemberSearchFilter = {
  operator: DateSearchOperator;
  property: DateListMemberSearchableProperty;
  values: Array<Scalars['String']['input']>;
};

export enum DateListMemberSearchableProperty {
  AddedDatetime = 'ADDED_DATETIME',
  LastUpdated = 'LAST_UPDATED'
}

export type DateOnlyCell = {
  __typename?: 'DateOnlyCell';
  date: Maybe<Scalars['ISO8601Date']['output']>;
};

export type DateRangeInput = {
  finish: Scalars['ISO8601DateTime']['input'];
  start: Scalars['ISO8601DateTime']['input'];
};

export enum DateSearchOperator {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotBetween = 'NOT_BETWEEN'
}

export type DateTimeCell = {
  __typename?: 'DateTimeCell';
  dateTime: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of DeleteApiSourceMutation. */
export type DeleteApiSourceMutationPayload = {
  __typename?: 'DeleteApiSourceMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DeleteCareerCompanyMutation. */
export type DeleteCareerCompanyMutationPayload = {
  __typename?: 'DeleteCareerCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DeleteFormMutation. */
export type DeleteFormMutationPayload = {
  __typename?: 'DeleteFormMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DeleteFormWorkflowMutation. */
export type DeleteFormWorkflowMutationPayload = {
  __typename?: 'DeleteFormWorkflowMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DeleteListViewMutation. */
export type DeleteListViewMutationPayload = {
  __typename?: 'DeleteListViewMutationPayload';
  failReasons: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of DeleteMyTaskMutation. */
export type DeleteMyTaskMutationPayload = {
  __typename?: 'DeleteMyTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  task: Maybe<MyTask>;
};

/** Autogenerated return type of DeleteReportMutation. */
export type DeleteReportMutationPayload = {
  __typename?: 'DeleteReportMutationPayload';
  /** Reasons why the delete might have failed. */
  failReasons: Array<Scalars['String']['output']>;
  /** The deleted report. */
  report: Maybe<ResearchReport>;
};

/** Autogenerated return type of DeleteReportSectionMutation. */
export type DeleteReportSectionMutationPayload = {
  __typename?: 'DeleteReportSectionMutationPayload';
  /** Reasons why the delete might have failed. */
  failReasons: Array<Scalars['String']['output']>;
  /** The deleted report section. */
  reportSection: Maybe<ResearchReportSection>;
};

/** Autogenerated return type of DeleteRoleMutation. */
export type DeleteRoleMutationPayload = {
  __typename?: 'DeleteRoleMutationPayload';
  accessRole: Maybe<AccessRole>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DeleteSentReferralMutation. */
export type DeleteSentReferralMutationPayload = {
  __typename?: 'DeleteSentReferralMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DeleteTableLikeRollupFieldMutation. */
export type DeleteTableLikeRollupFieldMutationPayload = {
  __typename?: 'DeleteTableLikeRollupFieldMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  rollupField: Maybe<TableLikeRollupFieldType>;
};

/** Autogenerated return type of DeleteTableLikeRowsMutation. */
export type DeleteTableLikeRowsMutationPayload = {
  __typename?: 'DeleteTableLikeRowsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  progressTracker: Maybe<ProgressTracker>;
  rowIdsDeleted: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of DeleteTaskMutation. */
export type DeleteTaskMutationPayload = {
  __typename?: 'DeleteTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  task: Maybe<Task>;
};

/** Autogenerated return type of DeleteThemeCoverImageForFormMutation. */
export type DeleteThemeCoverImageForFormMutationPayload = {
  __typename?: 'DeleteThemeCoverImageForFormMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  form: Maybe<Form>;
};

/** Autogenerated return type of DeleteUserDelegateAccessMutation. */
export type DeleteUserDelegateAccessMutationPayload = {
  __typename?: 'DeleteUserDelegateAccessMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type Department = {
  __typename?: 'Department';
  employees: Array<Employee>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type DepartmentEmployeesArgs = {
  limit: Scalars['Int']['input'];
};

export type DepartmentList = {
  __typename?: 'DepartmentList';
  entries: Array<Department>;
  pageInfo: PagingInfo;
};

export type DeploymentInfo = {
  __typename?: 'DeploymentInfo';
  commit: Maybe<Scalars['String']['output']>;
  releaseCreatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  releaseVersion: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of DescheduleCampaignMutation. */
export type DescheduleCampaignMutationPayload = {
  __typename?: 'DescheduleCampaignMutationPayload';
  campaign: Maybe<Campaign>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DiscardNoteMutation. */
export type DiscardNoteMutationPayload = {
  __typename?: 'DiscardNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  note: Maybe<Note>;
};

/** Autogenerated return type of DisconnectConnectedListMutation. */
export type DisconnectConnectedListMutationPayload = {
  __typename?: 'DisconnectConnectedListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DisconnectListMutation. */
export type DisconnectListMutationPayload = {
  __typename?: 'DisconnectListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DismissReminderMutation. */
export type DismissReminderMutationPayload = {
  __typename?: 'DismissReminderMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export enum DisplayAs {
  Checkbox = 'CHECKBOX',
  ConsentStatus = 'CONSENT_STATUS',
  Country = 'COUNTRY',
  Currency = 'CURRENCY',
  Datetime = 'DATETIME',
  Employee = 'EMPLOYEE',
  FullDateTime = 'FULL_DATE_TIME',
  MultiCompany = 'MULTI_COMPANY',
  MultiContact = 'MULTI_CONTACT',
  MultiCountry = 'MULTI_COUNTRY',
  MultiEmployee = 'MULTI_EMPLOYEE',
  MultiOptionalValue = 'MULTI_OPTIONAL_VALUE',
  Number = 'NUMBER',
  OptionalValue = 'OPTIONAL_VALUE',
  RadioButton = 'RADIO_BUTTON',
  RichText = 'RICH_TEXT',
  Tags = 'TAGS',
  Text = 'TEXT'
}

export type DocumentFile = {
  __typename?: 'DocumentFile';
  contentType: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  filename: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type DocumentUrl = {
  __typename?: 'DocumentUrl';
  link: Scalars['String']['output'];
};

/** Autogenerated return type of DownloadCampaignTemplateMutation. */
export type DownloadCampaignTemplateMutationPayload = {
  __typename?: 'DownloadCampaignTemplateMutationPayload';
  failReasons: Maybe<Array<Scalars['String']['output']>>;
  templateHtml: Maybe<Scalars['String']['output']>;
};

export enum DupilcateCompaniesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC'
}

export enum DupilcateContactsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC'
}

/** Filtering Options for duplicate companies */
export type DuplicateCompaniesFiltering = {
  term?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateCompaniesList = {
  __typename?: 'DuplicateCompaniesList';
  entries: Array<DuplicateCompany>;
  pageInfo: PagingInfo;
};

export type DuplicateCompany = {
  __typename?: 'DuplicateCompany';
  duplicate: Company;
  id: Scalars['ID']['output'];
  original: Company;
};

export type DuplicateContact = {
  __typename?: 'DuplicateContact';
  confirmedDuplicate: Scalars['Boolean']['output'];
  duplicate: Contact;
  id: Scalars['ID']['output'];
  original: Contact;
};

/** Filtering Options for duplicate contacts */
export type DuplicateContactFiltering = {
  confirmedDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateContactsList = {
  __typename?: 'DuplicateContactsList';
  entries: Array<DuplicateContact>;
  pageInfo: PagingInfo;
};

export type EMarketingConnectors = {
  __typename?: 'EMarketingConnectors';
  entries: Array<CampaignManager>;
  totalCount: Scalars['Int']['output'];
};

/** An educational institution attended by a person */
export type Education = {
  __typename?: 'Education';
  /** End date of the education */
  endDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the education record */
  id: Scalars['ID']['output'];
  /** Name of the educational institution */
  institution: Maybe<Scalars['String']['output']>;
  /** The person associated with this education record */
  person: Person;
  /** Start date of the education */
  startDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Degree or qualification obtained */
  value: Maybe<Scalars['String']['output']>;
};

export type EducationAttributes = {
  /** End date of the education */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  institute: Scalars['String']['input'];
  /** Start date of the education */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type EmailCell = {
  __typename?: 'EmailCell';
  email: Maybe<Scalars['ContactEmailScalar']['output']>;
};

export type EmailContent = {
  __typename?: 'EmailContent';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
};

/** Email addresses with preferred status */
export type EmailEntryInput = {
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type EmailHeaderInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the result of a email lookup */
export type EmailLookup = {
  __typename?: 'EmailLookup';
  /** True if the email domain is invalid or could not be processed. */
  isExceptional: Maybe<Scalars['Boolean']['output']>;
  /** True if the email belongs to a known free domain provider. */
  isPersonal: Maybe<Scalars['Boolean']['output']>;
};

export type EmailMarketingConfiguration = {
  __typename?: 'EmailMarketingConfiguration';
  continuousSendingDefault: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  fonts: Array<Font>;
  id: Scalars['ID']['output'];
  senders: Array<Sender>;
};

/** Options for filtering email marketing lists */
export type EmailMarketingListFiltering = {
  term?: InputMaybe<Scalars['String']['input']>;
};

export type EmbedUrl = {
  __typename?: 'EmbedUrl';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
};

export type EmbeddedReportingDashboard = {
  __typename?: 'EmbeddedReportingDashboard';
  description: Maybe<RichContent>;
  embeddedPath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  previewUrl: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type EmbeddedReportingDashboardList = {
  __typename?: 'EmbeddedReportingDashboardList';
  entries: Array<EmbeddedReportingDashboard>;
};

export type Employee = {
  __typename?: 'Employee';
  contact: Contact;
  department: Maybe<Department>;
  email: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  info: ContactInfo;
  office: Maybe<Office>;
};

export type EmployeeCell = {
  __typename?: 'EmployeeCell';
  employeeCard: Maybe<EmployeeGrid>;
};

export type EmployeeCompanyStats = {
  __typename?: 'EmployeeCompanyStats';
  company: Company;
  employee: Employee;
  id: Scalars['ID']['output'];
  knows: Array<WhoKnows>;
  last: Maybe<LastAts>;
  total: Totals;
};

/** Filtering Options for employee company stats */
export type EmployeeCompanyStatsFilteringInput = {
  /** company domain or id */
  companyUid?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeCompanyStatsList = {
  __typename?: 'EmployeeCompanyStatsList';
  entries: Array<EmployeeCompanyStats>;
  pageInfo: PagingInfo;
};

export type EmployeeForCustomField = {
  __typename?: 'EmployeeForCustomField';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  info: ContactInfoForCustomField;
};

export type EmployeeGrid = {
  __typename?: 'EmployeeGrid';
  departmentName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  officeName: Maybe<Scalars['String']['output']>;
};

export type EmployeeList = {
  __typename?: 'EmployeeList';
  entries: Array<Employee>;
  pageInfo: PagingInfo;
};

export type EmployeeMeeting = {
  __typename?: 'EmployeeMeeting';
  companies: Array<Company>;
  contacts: Array<Contact>;
  endTime: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isCancelled: Scalars['Boolean']['output'];
  keyActivity: Maybe<KeyActivity>;
  sourceEventReference: Scalars['String']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
};

export type EmployeeMeetingList = {
  __typename?: 'EmployeeMeetingList';
  entries: Array<EmployeeMeeting>;
};

export enum EmployeeMeetingsOrderBy {
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC'
}

export type EnabledModules = {
  __typename?: 'EnabledModules';
  apps: Scalars['Boolean']['output'];
  marketingLists: Scalars['Boolean']['output'];
  objectives: Scalars['Boolean']['output'];
  opportunities: Scalars['Boolean']['output'];
  projects: Scalars['Boolean']['output'];
  prospecting: Scalars['Boolean']['output'];
  referrals: Scalars['Boolean']['output'];
};

export type EngagementReport = {
  __typename?: 'EngagementReport';
  activityTotals: Maybe<ActivityTotals>;
  beginOn: Maybe<Scalars['String']['output']>;
  endOn: Maybe<Scalars['String']['output']>;
  errorsFullMessages: Maybe<Array<Scalars['String']['output']>>;
  futureMeetings: Maybe<FutureMeetings>;
  newContacts: Maybe<NewContacts>;
  openOpportunities: Maybe<OpenOpportunities>;
  pastMeetings: Maybe<PastMeetings>;
  pendingTasks: Maybe<PendingTasks>;
  stayInTouchReminders: Maybe<StayInTouchReminders>;
  totalWonOpportunities: TotalWonOpportunities;
};


export type EngagementReportBeginOnArgs = {
  format: Scalars['String']['input'];
};


export type EngagementReportEndOnArgs = {
  format: Scalars['String']['input'];
};

/** Enrichment Permissions */
export type EnrichmentPermission = {
  __typename?: 'EnrichmentPermission';
  allProspects: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  viewMyProspects: Scalars['Boolean']['output'];
};

/** Event item */
export type EventItem = Interaction | KeyActivity;

export type EventPackRequest = {
  __typename?: 'EventPackRequest';
  eventDescription: Scalars['String']['output'];
  eventPackResponse: Maybe<EventPackResponse>;
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  requestStatus: RequestStatus;
  startTime: Scalars['String']['output'];
};

/** Attributes for event pack request */
export type EventPackRequestAttribute = {
  eventDescription: Scalars['String']['input'];
  location: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type EventPackResponse = {
  __typename?: 'EventPackResponse';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  linkedinPost: Scalars['String']['output'];
  website: Scalars['String']['output'];
};

export enum ExclusionType {
  Block = 'BLOCK',
  Warn = 'WARN'
}

/** Autogenerated return type of ExecuteListCleanMutation. */
export type ExecuteListCleanMutationPayload = {
  __typename?: 'ExecuteListCleanMutationPayload';
  clean: Clean;
  failReasons: Array<Scalars['String']['output']>;
};

export enum ExecutionStatus {
  AwaitingStart = 'AWAITING_START',
  Complete = 'COMPLETE',
  CopyingContacts = 'COPYING_CONTACTS',
  CopyingContactsComplete = 'COPYING_CONTACTS_COMPLETE',
  ValidationInProgress = 'VALIDATION_IN_PROGRESS'
}

export type Export = {
  __typename?: 'Export';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  expectedCount: Scalars['Int']['output'];
  file: Maybe<File>;
  id: Scalars['ID']['output'];
  percentageComplete: Maybe<Scalars['Int']['output']>;
  status: ExportStatus;
};

export type ExportAudit = {
  __typename?: 'ExportAudit';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Can be one of contact, company, key_activity, generic, opportunities, sent_referrals */
  dataType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The user who performed the export */
  performer: Maybe<User>;
  /** The primary location eg: 'Project name ' or 'Company name' */
  primaryName: Scalars['String']['output'];
  /** Number of rows exported */
  rowCount: Scalars['Int']['output'];
  /** The name of the tab or list */
  secondaryName: Scalars['String']['output'];
  /** The user whose data is being exported */
  user: User;
};

export type ExportAuditEntries = {
  __typename?: 'ExportAuditEntries';
  entries: Array<ExportAudit>;
  pageInfo: PagingInfo;
};

/** Autogenerated return type of ExportCampaignRecipientsMutation. */
export type ExportCampaignRecipientsMutationPayload = {
  __typename?: 'ExportCampaignRecipientsMutationPayload';
  export: Maybe<Export>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ExportCompaniesMutation. */
export type ExportCompaniesMutationPayload = {
  __typename?: 'ExportCompaniesMutationPayload';
  export: Maybe<Export>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ExportContactsMutation. */
export type ExportContactsMutationPayload = {
  __typename?: 'ExportContactsMutationPayload';
  export: Maybe<Export>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Types of export audit data */
export enum ExportDataEnum {
  Company = 'COMPANY',
  Contact = 'CONTACT',
  Generic = 'GENERIC',
  KeyActivity = 'KEY_ACTIVITY',
  Opportunities = 'OPPORTUNITIES',
  SentReferrals = 'SENT_REFERRALS'
}

export type ExportEntries = {
  __typename?: 'ExportEntries';
  entries: Array<Export>;
  pageInfo: PagingInfo;
};

/** Autogenerated return type of ExportIncompleteCompaniesMutation. */
export type ExportIncompleteCompaniesMutationPayload = {
  __typename?: 'ExportIncompleteCompaniesMutationPayload';
  export: Maybe<Export>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ExportIncompleteContactsMutation. */
export type ExportIncompleteContactsMutationPayload = {
  __typename?: 'ExportIncompleteContactsMutationPayload';
  export: Maybe<Export>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Filtering Options for filtering list members */
export type ExportListFilter = {
  /** filter members by contact id or email */
  contactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of ExportListMutation. */
export type ExportListMutationPayload = {
  __typename?: 'ExportListMutationPayload';
  export: Maybe<Export>;
  failReasons: Array<Scalars['String']['output']>;
};

export enum ExportStatus {
  Complete = 'COMPLETE',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

/** Autogenerated return type of ExportTableLikeRowsMutation. */
export type ExportTableLikeRowsMutationPayload = {
  __typename?: 'ExportTableLikeRowsMutationPayload';
  export: Maybe<Export>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ExportUnengagedContactsMutation. */
export type ExportUnengagedContactsMutationPayload = {
  __typename?: 'ExportUnengagedContactsMutationPayload';
  export: Maybe<Export>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ExportsUpdated. */
export type ExportsUpdatedPayload = {
  __typename?: 'ExportsUpdatedPayload';
  entries: Array<Export>;
};

export type ExternalIdentifier = {
  __typename?: 'ExternalIdentifier';
  client: Scalars['String']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Company external identifier input */
export type ExternalIdentifierInput = {
  client: Scalars['String']['input'];
  group: Scalars['String']['input'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
};

export type File = {
  __typename?: 'File';
  /** @deprecated use url instead */
  content: Maybe<Scalars['String']['output']>;
  contentType: Maybe<Scalars['String']['output']>;
  fileUuid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url: Scalars['Url']['output'];
};

export enum FilterOperator {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  EndsWith = 'ENDS_WITH',
  HasAnyValue = 'HAS_ANY_VALUE',
  HasNoValue = 'HAS_NO_VALUE',
  Is = 'IS',
  IsNot = 'IS_NOT',
  IsOneOf = 'IS_ONE_OF',
  StartsWith = 'STARTS_WITH'
}

/** Autogenerated return type of FindProspectEmailMutation. */
export type FindProspectEmailMutationPayload = {
  __typename?: 'FindProspectEmailMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  /** Contact email request */
  request: ProspectEmailRequest;
};

/** Autogenerated return type of FindProspectsMutation. */
export type FindProspectsMutationPayload = {
  __typename?: 'FindProspectsMutationPayload';
  /** Amount of new prospects found */
  amount: Scalars['Int']['output'];
  failReasons: Array<Scalars['String']['output']>;
};

/** Result of fixing an Active Storage URL with invalid signature */
export type FixActiveStorageUrlResult = {
  __typename?: 'FixActiveStorageUrlResult';
  /** Reasons why the URL fixing failed, if any */
  failReasons: Array<Scalars['String']['output']>;
  /** The URL with a valid signature, or null if fixing failed */
  fixedUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of FlagDuplicateContactsMutation. */
export type FlagDuplicateContactsMutationPayload = {
  __typename?: 'FlagDuplicateContactsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of FlagDuplicatePeopleMutation. */
export type FlagDuplicatePeopleMutationPayload = {
  __typename?: 'FlagDuplicatePeopleMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type FlatFileConfig = {
  __typename?: 'FlatFileConfig';
  apiUrl: Scalars['Url']['output'];
  id: Scalars['ID']['output'];
  mountUrl: Scalars['Url']['output'];
};

export enum FlatFileImportType {
  Company = 'COMPANY',
  Contact = 'CONTACT',
  Generic = 'GENERIC',
  KeyActivity = 'KEY_ACTIVITY'
}

export type FlatFileWorkbook = {
  __typename?: 'FlatFileWorkbook';
  accessToken: Scalars['String']['output'];
  apiUrl: Scalars['Url']['output'];
  id: Scalars['ID']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  sheetIdentifier: Scalars['ID']['output'];
  spaceIdentifier: Scalars['ID']['output'];
  spaceUrl: Scalars['Url']['output'];
};

export type Folder = {
  __typename?: 'Folder';
  id: Scalars['ID']['output'];
  isRoot: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Folder>;
  projectsCount: Scalars['Int']['output'];
  subFoldersCount: Scalars['Int']['output'];
};

export type Font = {
  __typename?: 'Font';
  family: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated return type of ForceEnrichMutation. */
export type ForceEnrichMutationPayload = {
  __typename?: 'ForceEnrichMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type Form = {
  __typename?: 'Form';
  confirmationPageSettings: Maybe<ConfirmationPageSettings>;
  contactList: Maybe<List>;
  /** The id of the contact list associated with this form */
  contactListId: Maybe<Scalars['ID']['output']>;
  /** The default footer in HTML, to be displayed below the form. */
  defaultFooter: Maybe<Scalars['String']['output']>;
  /** Description of the form */
  description: Maybe<Scalars['String']['output']>;
  /** Indicate if recaptcha should be disabled */
  disableRecaptcha: Scalars['Boolean']['output'];
  /** The elements belonging to the form */
  elements: Array<FormElement>;
  /** Whether the form is expired */
  expired: Scalars['Boolean']['output'];
  expirySettings: Maybe<FormExpirySettings>;
  /** ID of the form */
  id: Scalars['ID']['output'];
  /** Indicate if the default footer should be included on the form */
  includeDefaultFooter: Scalars['Boolean']['output'];
  keyActivitySettings: Maybe<KeyActivitySettings>;
  publishedUrl: Maybe<Scalars['String']['output']>;
  /** Indicate if consent status should be defaulted on form submission */
  setConsentToGiven: Scalars['Boolean']['output'];
  /** The current status of the form */
  status: Maybe<FormStatusEnum>;
  theme: FormTheme;
  /** Title of the form */
  title: Scalars['String']['output'];
  waitlistSettings: Maybe<FormWaitlistSettings>;
  /** The workflows belonging to the form */
  workflows: Maybe<Array<Workflow>>;
};

/** Objects which may be a Form Element */
export type FormElement = InputElement | TextElement;

/** Form Builder Input Element Type. One of input or text HAS to be provided. */
export type FormElementInput = {
  /** A HTML input element */
  input?: InputMaybe<InputElementInput>;
  /** A text element */
  text?: InputMaybe<TextElementInput>;
};

export type FormExpirySettings = {
  __typename?: 'FormExpirySettings';
  date: Maybe<Scalars['ISO8601DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  formId: Scalars['ID']['output'];
  /** Page description with HTML content */
  pageDescription: Maybe<PageDescription>;
  pageHeader: Maybe<Scalars['String']['output']>;
};

export type FormSettings = {
  prefillFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FormStatusEnum {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  UnpublishedChanges = 'UNPUBLISHED_CHANGES'
}

export type FormTheme = {
  __typename?: 'FormTheme';
  coverImage: Maybe<File>;
  id: Scalars['ID']['output'];
};

/** Settings for form theme */
export type FormThemeSettingsInput = {
  coverImage?: InputMaybe<Scalars['String']['input']>;
};

/** Waitlist settings for a form */
export type FormWaitlistSettings = {
  __typename?: 'FormWaitlistSettings';
  /** The condition for triggering the waitlist */
  condition: Maybe<WaitlistCondition>;
  /** Indicates if the waitlist is enabled */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the form this waitlist settings belong to */
  formId: Scalars['ID']['output'];
  /** Indicates if the waitlist is redirect required */
  redirectRequired: Scalars['Boolean']['output'];
  /** The URL to redirect to when the waitlist is triggered */
  redirectUrl: Maybe<Scalars['String']['output']>;
};

export type FutureMeeting = {
  __typename?: 'FutureMeeting';
  company: Company;
  companyUrl: Scalars['Url']['output'];
  withContacts: Array<Contact>;
  withNames: Scalars['String']['output'];
};

export type FutureMeetings = {
  __typename?: 'FutureMeetings';
  amount: Scalars['Int']['output'];
  entries: Array<FutureMeeting>;
  viewAllUrl: Maybe<Scalars['Url']['output']>;
};

/** Autogenerated return type of GenerateEmailMutation. */
export type GenerateEmailMutationPayload = {
  __typename?: 'GenerateEmailMutationPayload';
  email: Maybe<EmailContent>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of GenerateJwtMutation. */
export type GenerateJwtMutationPayload = {
  __typename?: 'GenerateJwtMutationPayload';
  /** The expiration timestamp of the token. */
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Errors encountered during JWT generation. */
  failReasons: Maybe<Array<Scalars['String']['output']>>;
  /** The generated JWT. */
  token: Maybe<Scalars['String']['output']>;
};

/** Filtering Options for contacts */
export type GenericContactsFiltering = {
  keyActivityDescription?: InputMaybe<Scalars['String']['input']>;
  missingKeyData?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  timeFilters?: InputMaybe<Array<ContactTimeFilter>>;
  withBouncedEmails?: InputMaybe<Scalars['Boolean']['input']>;
  withCustomField?: InputMaybe<Array<CustomFieldTerm>>;
  /** When set to true, only returns contacts who have changed jobs */
  withJobChanges?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenericList = {
  __typename?: 'GenericList';
  createdAt: Scalars['ISO8601DateTime']['output'];
  customFieldSchemas: Array<CustomFieldSchema>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  items: Array<GenericListItem>;
  reminderSettings: Array<ReminderSetting>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GenericListAttributes = {
  renderMode?: InputMaybe<RenderMode>;
};

export type GenericListItem = {
  __typename?: 'GenericListItem';
  completedTasksCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use gridCustomFields instead */
  customFields: Array<CustomField>;
  genericList: GenericList;
  gridCustomFields: Array<CustomFieldGrid>;
  id: Scalars['ID']['output'];
  listReminders: Array<Reminder>;
  tasksCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GenericListItemEntries = {
  __typename?: 'GenericListItemEntries';
  entries: Array<GenericListItem>;
  pageInfo: PagingInfo;
};

/** Document objects on goal */
export type GoalDocument = DocumentFile | DocumentUrl;

export enum GoalOutcome {
  Lost = 'LOST',
  Pending = 'PENDING',
  Won = 'WON'
}

export type GroupFilter = {
  booleanFilters?: InputMaybe<Array<BooleanContactSearchFilter>>;
  customFieldSelectFilters?: InputMaybe<Array<CustomFieldSelectSearchFilter>>;
  customFieldTextFilters?: InputMaybe<Array<CustomFieldTextSearchFilter>>;
  dateFilters?: InputMaybe<Array<DateContactSearchFilter>>;
  operator: GroupFilterOperator;
  selectFilters?: InputMaybe<Array<SelectContactSearchFilter>>;
  textFilters?: InputMaybe<Array<TextContactSearchFilter>>;
};

export enum GroupFilterOperator {
  And = 'AND',
  Or = 'OR'
}

/** Grouped objectives */
export type GroupedObjective = {
  __typename?: 'GroupedObjective';
  group: Scalars['String']['output'];
  objectives: Array<Objective>;
};

export type HeadCountRange = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

/** Autogenerated return type of HideContactFromWhoKnowsMutation. */
export type HideContactFromWhoKnowsMutationPayload = {
  __typename?: 'HideContactFromWhoKnowsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of HideEmployeeMutation. */
export type HideEmployeeMutationPayload = {
  __typename?: 'HideEmployeeMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type Hierarchy = {
  __typename?: 'Hierarchy';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  partOfHierarchy: Scalars['Boolean']['output'];
};

export type HierarchyInput = {
  companyDomain: Scalars['String']['input'];
  parentDomain?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export enum HttpMethodEnum {
  Get = 'GET',
  Post = 'POST'
}

/** Autogenerated return type of IgnoreContactRequiringPlacementMutation. */
export type IgnoreContactRequiringPlacementMutationPayload = {
  __typename?: 'IgnoreContactRequiringPlacementMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of IgnoreIncompleteCompanyMutation. */
export type IgnoreIncompleteCompanyMutationPayload = {
  __typename?: 'IgnoreIncompleteCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of IgnoreIncompleteContactMutation. */
export type IgnoreIncompleteContactMutationPayload = {
  __typename?: 'IgnoreIncompleteContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type Import = {
  __typename?: 'Import';
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  originalFileName: Maybe<Scalars['String']['output']>;
  processedCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated return type of ImportBusinessCardsMutation. */
export type ImportBusinessCardsMutationPayload = {
  __typename?: 'ImportBusinessCardsMutationPayload';
  contacts: Maybe<Array<Contact>>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ImportFlatfileWorkbookMutation. */
export type ImportFlatfileWorkbookMutationPayload = {
  __typename?: 'ImportFlatfileWorkbookMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type ImportListEntries = {
  __typename?: 'ImportListEntries';
  entries: Array<Import>;
  pageInfo: PagingInfo;
};

export type IncompleteCompaniesList = {
  __typename?: 'IncompleteCompaniesList';
  entries: Array<IncompleteCompany>;
  pageInfo: PagingInfo;
};

export type IncompleteCompany = {
  __typename?: 'IncompleteCompany';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canManageRelationshipPartners: Scalars['Boolean']['output'];
  companyHierarchy: CompanyHierarchy;
  companyType: CompanyCustomType;
  companyTypes: Array<CompanyCustomType>;
  contacts: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  documents: Array<CompanyDocument>;
  domain: Maybe<Scalars['String']['output']>;
  domains: Array<Scalars['String']['output']>;
  externalIdentifier: Maybe<ExternalIdentifier>;
  hasCustomLogo: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  info: CompanyInfo;
  insightStat: InsightStat;
  interactionsLast: LastAts;
  interactionsTotal: Totals;
  isBlocked: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  isSubDomainCompany: Scalars['Boolean']['output'];
  lastReferralSource: Maybe<Contact>;
  lastYearDepartmentsStats: Array<LastYearCompanyDepartmentStat>;
  logoUrl: Maybe<Scalars['String']['output']>;
  missing: Array<MissingCompanyKind>;
  monthlyEngagement: Array<CompanyMonthlyInteractionDist>;
  openOpportunityCount: Scalars['Int']['output'];
  opportunityStats: OpportunityStat;
  pendingTaskCount: Scalars['Int']['output'];
  referredOpportunityStats: OpportunityStat;
  /** @deprecated use relationshipPartners */
  relationshipPartner: Maybe<Employee>;
  relationshipPartners: Maybe<Array<Employee>>;
  reporting: CompanyReporting;
  /** @deprecated Use company_types */
  secondaryTypes: Array<CompanyCustomType>;
  upcomingMeetingCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type IncompleteCompanyLogoUrlArgs = {
  preferIdenticonFallback?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
};

/** Filtering Options for incomplete companies */
export type IncompleteCompanyFiltering = {
  missing?: InputMaybe<Array<MissingCompanyKind>>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type IncompleteContact = {
  __typename?: 'IncompleteContact';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  changedJob: Scalars['Boolean']['output'];
  company: Company;
  contactCompanySwitch: Maybe<ContactCompanySwitch>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  emailAddresses: Array<Scalars['ContactEmailScalar']['output']>;
  id: Scalars['ID']['output'];
  inMyContacts: Maybe<Scalars['Boolean']['output']>;
  info: ContactInfo;
  interactionsBounce: Maybe<BounceCount>;
  interactionsIsEngaged: Scalars['Boolean']['output'];
  interactionsLast: LastAts;
  interactionsTotal: Totals;
  /** @deprecated Use interactionsIsEngaged instead */
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isEmployee: Scalars['Boolean']['output'];
  isKeyContact: Scalars['Boolean']['output'];
  isPersonal: Scalars['Boolean']['output'];
  marketingListConsent: ContactConsent;
  missing: Array<MissingContactInfo>;
  nextCompanyContact: Maybe<PersonCompanyContact>;
  officeLocation: Maybe<CompanyOfficeLocation>;
  primaryEmail: Maybe<Scalars['ContactEmailScalar']['output']>;
  unarchiveOnNextInteraction: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  whoKnows: Array<WhoKnows>;
};


export type IncompleteContactWhoKnowsArgs = {
  connectionCategory: WhoKnowsCategory;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Filtering Options for incomplete contacts */
export type IncompleteContactFiltering = {
  groups?: InputMaybe<Array<GroupFilter>>;
  missing?: InputMaybe<Array<MissingContactInfo>>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type IncompleteContactsList = {
  __typename?: 'IncompleteContactsList';
  entries: Array<IncompleteContact>;
  pageInfo: PagingInfo;
};

export type IndividualConsented = {
  __typename?: 'IndividualConsented';
  isRequired: Scalars['Boolean']['output'];
  url: Maybe<Scalars['Url']['output']>;
};

export type IndustryMapping = {
  __typename?: 'IndustryMapping';
  companyIndustryName: CompanyIndustryName;
  createdAt: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['String']['output'];
  internalIndustry: InternalIndustry;
};

export type IndustryMappingList = {
  __typename?: 'IndustryMappingList';
  entries: Array<IndustryMapping>;
};

export type InputElement = {
  __typename?: 'InputElement';
  customField: Maybe<CustomFieldSchema>;
  customFieldSchemaId: Maybe<Scalars['ID']['output']>;
  defaultValue: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayAs: Maybe<DisplayAs>;
  field: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  /** ID of the element (can be null when invalid) */
  id: Maybe<Scalars['ID']['output']>;
  label: Maybe<Scalars['String']['output']>;
  placeholder: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

/** HTML Input Form Element Type */
export type InputElementInput = {
  customFieldSchemaId?: InputMaybe<Scalars['ID']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayAs?: InputMaybe<DisplayAs>;
  field: Scalars['String']['input'];
  hidden: Scalars['Boolean']['input'];
  /** The id of the form element */
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type InsightStat = {
  __typename?: 'InsightStat';
  id: Scalars['ID']['output'];
  lastBdInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastLeadInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastMarketingInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  previousTotalEmails: Scalars['Int']['output'];
  previousTotalInteractions: Scalars['Int']['output'];
  previousTotalMeetings: Scalars['Int']['output'];
  totalEmails: Scalars['Int']['output'];
  totalEmailsIncrease: Scalars['Int']['output'];
  totalInteractionIncrease: Scalars['Int']['output'];
  totalInteractions: Scalars['Int']['output'];
  totalMeetings: Scalars['Int']['output'];
  totalMeetingsIncrease: Scalars['Int']['output'];
};

/** Autogenerated return type of InstallEmsConnectorMutation. */
export type InstallEmsConnectorMutationPayload = {
  __typename?: 'InstallEmsConnectorMutationPayload';
  emsManager: Maybe<CampaignManager>;
  failReasons: Array<Scalars['String']['output']>;
};

export type IntegerCell = {
  __typename?: 'IntegerCell';
  integer: Maybe<Scalars['Int']['output']>;
};

export type Interaction = {
  __typename?: 'Interaction';
  direction: InteractionDirection;
  id: Scalars['ID']['output'];
  interactionType: Scalars['String']['output'];
  keyActivity: Maybe<KeyActivity>;
  occuredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  occuredEndAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  occuredEndOn: Maybe<Scalars['ISO8601Date']['output']>;
  occuredOn: Maybe<Scalars['ISO8601Date']['output']>;
  participants: Array<InteractionParticipant>;
  webLink: Maybe<Scalars['String']['output']>;
};

export type InteractionDetailList = {
  __typename?: 'InteractionDetailList';
  entries: Array<KeyActivity>;
  pageInfo: PagingInfo;
};

export type InteractionDetailsFilter = {
  categories?: InputMaybe<Array<KeyActivityCategory>>;
  category?: InputMaybe<KeyActivityCategory>;
  /** company id or company domain */
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  /** contact id or contact email */
  contactUid?: InputMaybe<Scalars['ID']['input']>;
  occurredAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  occurredBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type InteractionDetailsOrderBy = {
  direction?: InputMaybe<InteractionDetailsOrderByDirection>;
  field: InteractionDetailsOrderByField;
};

export enum InteractionDetailsOrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum InteractionDetailsOrderByField {
  CreatedAt = 'CREATED_AT',
  InteractionOn = 'INTERACTION_ON',
  UpdatedAt = 'UPDATED_AT'
}

export enum InteractionDirection {
  Mutual = 'MUTUAL',
  TenantReceived = 'TENANT_RECEIVED',
  TenantSent = 'TENANT_SENT'
}

export enum InteractionEnum {
  Custom = 'CUSTOM',
  Email = 'EMAIL',
  Meeting = 'MEETING'
}

export type InteractionMaximum = {
  __typename?: 'InteractionMaximum';
  id: Scalars['ID']['output'];
  lastAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  total: Maybe<Scalars['Int']['output']>;
};

export type InteractionMonthlyStat = {
  __typename?: 'InteractionMonthlyStat';
  id: Maybe<Scalars['ID']['output']>;
  interactionCount: Maybe<Scalars['Int']['output']>;
  meetingCount: Maybe<Scalars['Int']['output']>;
  monthAsDate: Scalars['ISO8601Date']['output'];
  receivedEmailCount: Maybe<Scalars['Int']['output']>;
  sentEmailCount: Maybe<Scalars['Int']['output']>;
};

export type InteractionParticipant = {
  __typename?: 'InteractionParticipant';
  contact: Maybe<Contact>;
  email: Scalars['ContactEmailScalar']['output'];
  id: Scalars['String']['output'];
  role: ParticipantRole;
};

export type InteractionsConfiguration = {
  __typename?: 'InteractionsConfiguration';
  id: Scalars['ID']['output'];
  keyActivityTitlesOnlyUseRecommended: Scalars['Boolean']['output'];
  keyActivityTitlesRecommendedGroup: TitlesRecommendedGroupEnum;
};

export type InteractionsFilter = {
  commsTypesOrActivityCategories?: InputMaybe<CommsOrCategoryFilterInput>;
  occurredAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  occurredBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

/** interactions permissions */
export type InteractionsPermission = {
  __typename?: 'InteractionsPermission';
  exportAllActivities: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type InternalIndustry = {
  __typename?: 'InternalIndustry';
  companyInfoInternalIndustryCount: Scalars['Int']['output'];
  id: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export type InternalIndustryList = {
  __typename?: 'InternalIndustryList';
  entries: Array<InternalIndustry>;
};

export type JobChangeUpdate = {
  __typename?: 'JobChangeUpdate';
  nextContacts: Array<Contact>;
  previousContact: Contact;
};

export type JobTitleUpdate = {
  __typename?: 'JobTitleUpdate';
  nextJobTitle: Scalars['String']['output'];
  previousJobTitle: Scalars['String']['output'];
};

/** Input fields for json mappings on an api column */
export type JsonMappingInput = {
  /** UID of the column */
  columnUid: Scalars['ID']['input'];
  /** JSON path to the column */
  jsonPath: Scalars['String']['input'];
};

export type JsonPathColumnMapping = {
  __typename?: 'JsonPathColumnMapping';
  columnId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jsonPath: Scalars['String']['output'];
};

/** JWT audience URLs for different NEXL applications. */
export type JwtAudience = {
  __typename?: 'JwtAudience';
  /** The audience URL for NEXL360. */
  nexl360: Scalars['String']['output'];
  /** The audience URL for NEXL AI. */
  nexlAi: Scalars['String']['output'];
};

export type KeyActivity = {
  __typename?: 'KeyActivity';
  activityTitle: Scalars['String']['output'];
  calendarMeeting: Maybe<EmployeeMeeting>;
  category: KeyActivityCategory;
  contactsInvolved: Array<Contact>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interaction: Maybe<PartitionedInteraction>;
  interactionEndAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  interactionOn: Scalars['ISO8601DateTime']['output'];
  involvedCompanies: Array<Company>;
  involvedContacts: Array<Contact>;
  keyActivityListMember: Maybe<KeyActivityListMember>;
  notes: Maybe<RichContent>;
  sourceReferenceId: Scalars['String']['output'];
  staffInvolved: Array<Employee>;
};

/** Attributes for creating a key activity */
export type KeyActivityAttributes = {
  activityTitle: Scalars['String']['input'];
  category: KeyActivityCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionOn: Scalars['ISO8601DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for creating a key activity in batches */
export type KeyActivityBatchItemInput = {
  activityTitle: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalContacts: Array<Scalars['String']['input']>;
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionOn: Scalars['ISO8601DateTime']['input'];
  internalContacts?: InputMaybe<Array<Scalars['String']['input']>>;
  keyActivityCategory: KeyActivityCategory;
  keyActivityListUid?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sourceReferenceId?: InputMaybe<Scalars['String']['input']>;
};

export enum KeyActivityCategory {
  BusinessDevelopment = 'BUSINESS_DEVELOPMENT',
  Lead = 'LEAD',
  Marketing = 'MARKETING'
}

export type KeyActivityCategoryTotal = {
  __typename?: 'KeyActivityCategoryTotal';
  category: KeyActivityCategory;
  id: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export type KeyActivityDescriptionList = {
  __typename?: 'KeyActivityDescriptionList';
  entries: Array<Scalars['String']['output']>;
};

export type KeyActivityList = {
  __typename?: 'KeyActivityList';
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  includesKeyActivity: Scalars['Boolean']['output'];
  memberCustomFields: Maybe<Array<CustomFieldSchema>>;
  name: Scalars['String']['output'];
  project: Maybe<Project>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type KeyActivityListIncludesKeyActivityArgs = {
  keyActivityUid?: InputMaybe<Scalars['ID']['input']>;
};

export type KeyActivityListAttributes = {
  renderMode?: InputMaybe<RenderMode>;
};

/** Options for filtering key activity lists */
export type KeyActivityListFiltering = {
  term?: InputMaybe<Scalars['String']['input']>;
};

export type KeyActivityListMember = {
  __typename?: 'KeyActivityListMember';
  customFields: Array<CustomField>;
  id: Scalars['ID']['output'];
  isPersisted: Scalars['Boolean']['output'];
  keyActivity: KeyActivity;
  list: KeyActivityList;
};

export type KeyActivityListMembers = {
  __typename?: 'KeyActivityListMembers';
  entries: Array<KeyActivityListMember>;
  pageInfo: PagingInfo;
};

export type KeyActivityLists = {
  __typename?: 'KeyActivityLists';
  entries: Maybe<Array<KeyActivityList>>;
  pageInfo: Maybe<PagingInfo>;
};

export type KeyActivityMonthStatsEntry = {
  __typename?: 'KeyActivityMonthStatsEntry';
  id: Scalars['ID']['output'];
  month: Scalars['ISO8601Date']['output'];
  totals: Maybe<Array<KeyActivityCategoryTotal>>;
};

export type KeyActivitySettings = {
  __typename?: 'KeyActivitySettings';
  /** The category of the key activity */
  category: Maybe<KeyActivityCategory>;
  /** The description of the activity */
  description: Maybe<Scalars['String']['output']>;
  /** Indicates if a key activity should be created upon form submission */
  enabled: Maybe<Scalars['Boolean']['output']>;
  /** The name of the activity */
  title: Maybe<Scalars['String']['output']>;
};

/** Key Activity Settings Input Element Type. */
export type KeyActivitySettingsInput = {
  category: KeyActivityCategory;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type KeyActivityTitleList = {
  __typename?: 'KeyActivityTitleList';
  entries: Array<Scalars['String']['output']>;
};

export type LastAts = {
  __typename?: 'LastAts';
  emailAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interactionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  meetingAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  receivedEmailAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  sentEmailAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type LastYearCompanyDepartmentStat = {
  __typename?: 'LastYearCompanyDepartmentStat';
  company: Company;
  department: Department;
  id: Maybe<Scalars['ID']['output']>;
  interactionCount: Maybe<Scalars['Int']['output']>;
  meetingCount: Maybe<Scalars['Int']['output']>;
  monthlyStats: Array<InteractionMonthlyStat>;
  receivedEmailCount: Maybe<Scalars['Int']['output']>;
  sentEmailCount: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of LinkProjectsToOpportunityMutation. */
export type LinkProjectsToOpportunityMutationPayload = {
  __typename?: 'LinkProjectsToOpportunityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type LinkedinPostRequest = {
  __typename?: 'LinkedinPostRequest';
  id: Scalars['ID']['output'];
  linkedinPostResponse: Maybe<LinkedinPostResponse>;
  postDescription: Scalars['String']['output'];
  requestStatus: RequestStatus;
};

/** Attributes for linkedin post request */
export type LinkedinPostRequestAttribute = {
  postDescription: Scalars['String']['input'];
};

export type LinkedinPostResponse = {
  __typename?: 'LinkedinPostResponse';
  id: Scalars['ID']['output'];
  postResponse: Scalars['String']['output'];
};

export type List = {
  __typename?: 'List';
  allowDuplicates: Scalars['Boolean']['output'];
  category: Maybe<ListCategory>;
  clean: Maybe<Clean>;
  contactsCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: Maybe<User>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  memberCustomFields: Maybe<Array<CustomFieldSchema>>;
  name: Scalars['String']['output'];
  project: Maybe<Project>;
  reminderSettings: Array<ReminderSetting>;
  renderMode: RenderMode;
  tabUid: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usageMode: UsageMode;
};

export enum ListAuditAction {
  AddedContact = 'ADDED_CONTACT',
  RemovedContact = 'REMOVED_CONTACT'
}

export type ListAuditHistory = {
  __typename?: 'ListAuditHistory';
  entries: Array<ListAuditHistoryEntry>;
  pageInfo: PagingInfo;
};

/** Audit history entry for lists */
export type ListAuditHistoryEntry = {
  __typename?: 'ListAuditHistoryEntry';
  auditAction: ListAuditAction;
  auditable: Maybe<ListAuditable>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  user: Maybe<User>;
};

/** List auditable types */
export type ListAuditable = List | ListMember;

export enum ListCategory {
  ClientAlert = 'CLIENT_ALERT',
  CountryGroup = 'COUNTRY_GROUP',
  EventInvite = 'EVENT_INVITE',
  GeneralMarketing = 'GENERAL_MARKETING',
  Newsletter = 'NEWSLETTER',
  OfficeLists = 'OFFICE_LISTS',
  Other = 'OTHER',
  PracticeArea = 'PRACTICE_AREA',
  SectorOrIndustry = 'SECTOR_OR_INDUSTRY',
  Subscribers = 'SUBSCRIBERS',
  WebinarInvite = 'WEBINAR_INVITE'
}

export type ListCell = {
  __typename?: 'ListCell';
  listCard: Maybe<MyList>;
};

/** Autogenerated return type of ListContactsBulkMarkKeyActivityWithTrackerMutation. */
export type ListContactsBulkMarkKeyActivityWithTrackerMutationPayload = {
  __typename?: 'ListContactsBulkMarkKeyActivityWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type ListEntries = {
  __typename?: 'ListEntries';
  entries: Array<List>;
  pageInfo: PagingInfo;
};

/** Options for filtering lists */
export type ListFiltering = {
  category?: InputMaybe<ListCategory>;
  listStatus?: InputMaybe<ListStatus>;
  projectUuid?: InputMaybe<Scalars['ID']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  usageModes?: InputMaybe<Array<UsageModeFilter>>;
};

export type ListMember = {
  __typename?: 'ListMember';
  completedTasksCount: Scalars['Int']['output'];
  contact: Contact;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: Maybe<User>;
  customFields: Array<CustomField>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  list: List;
  listId: Scalars['ID']['output'];
  listReminders: Array<Reminder>;
  missingRequiredFields: Array<Scalars['String']['output']>;
  myContact: Maybe<MyContact>;
  remover: Maybe<User>;
  subscriptionErrorMessage: Maybe<Scalars['String']['output']>;
  tasksCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ListMemberFilter = {
  groups?: InputMaybe<Array<ListMemberGroupFilter>>;
};

export type ListMemberGroupFilter = {
  booleanFilters?: InputMaybe<Array<BooleanListMemberSearchFilter>>;
  customFieldSelectFilters?: InputMaybe<Array<CustomFieldSelectSearchFilter>>;
  customFieldTextFilters?: InputMaybe<Array<CustomFieldTextSearchFilter>>;
  dateFilters?: InputMaybe<Array<DateListMemberSearchFilter>>;
  operator: GroupFilterOperator;
  selectFilters?: InputMaybe<Array<SelectListMemberSearchFilter>>;
};

export type ListMembers = {
  __typename?: 'ListMembers';
  entries: Array<ListMember>;
  pageInfo: PagingInfo;
};

/** Filtering Options for filtering list members */
export type ListMembersFilter = {
  /** Employee ID */
  addedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  communicationCondition?: InputMaybe<ContactCommunicationCondition>;
  consentStatus?: InputMaybe<Array<ContactConsentStatus>>;
  /** filter members by contact id or email */
  contactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter members by contact uids ignoring duplicate lists */
  contactUidsNoDuplicates?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeClassified?: InputMaybe<Scalars['Boolean']['input']>;
  excludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** List Member ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  marketingListOnly?: InputMaybe<Scalars['Boolean']['input']>;
  myContacts?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<ListMembersScope>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ListMembersOrderBy {
  AddedByAsc = 'ADDED_BY_ASC',
  AddedByDesc = 'ADDED_BY_DESC',
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  ContactNameAsc = 'CONTACT_NAME_ASC',
  ContactNameDesc = 'CONTACT_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DiscardedAtAsc = 'DISCARDED_AT_ASC',
  DiscardedAtDesc = 'DISCARDED_AT_DESC',
  LastInteractionAsc = 'LAST_INTERACTION_ASC',
  LastInteractionDesc = 'LAST_INTERACTION_DESC',
  LocationAsc = 'LOCATION_ASC',
  LocationDesc = 'LOCATION_DESC'
}

export enum ListMembersScope {
  Kept = 'KEPT',
  KeptAndRemoved = 'KEPT_AND_REMOVED',
  Removed = 'REMOVED'
}

export type ListReminderSettingDateOption = {
  __typename?: 'ListReminderSettingDateOption';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum ListStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type ListView = {
  __typename?: 'ListView';
  /** AGgrid Column state configuration */
  columnStateConfiguration: Maybe<UiConfiguration>;
  /** Aggrid Filter model configuration */
  filterModelConfiguration: Maybe<UiConfiguration>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  renderMode: ListViewRenderMode;
  /** Schema uid of either single select, employee or datetime custom field */
  schemaUid: Maybe<Scalars['ID']['output']>;
  /** Search state configuration */
  searchStateConfiguration: Maybe<UiConfiguration>;
  viewType: ListViewType;
};

/** Attributes for creating or updating a list view */
export type ListViewAttributes = {
  /** AGGrid column state configuration */
  columnStateConfiguration?: InputMaybe<UiConfigurationAttributes>;
  /** AGGrid filter model configuration */
  filterModelConfiguration?: InputMaybe<UiConfigurationAttributes>;
  /** List uid of contact list, company list or generic list */
  listUid?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  renderMode?: InputMaybe<ListViewRenderMode>;
  /** Schema uid of either single select, employee or datetime custom field */
  schemaUid?: InputMaybe<Scalars['ID']['input']>;
  /** Search state configuration */
  searchStateConfiguration?: InputMaybe<UiConfigurationAttributes>;
  viewType?: InputMaybe<ListViewType>;
};

export enum ListViewRenderMode {
  Default = 'DEFAULT',
  Large = 'LARGE'
}

export enum ListViewType {
  Board = 'BOARD',
  Calendar = 'CALENDAR',
  List = 'LIST',
  Timeline = 'TIMELINE'
}

export enum ListsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Location = {
  __typename?: 'Location';
  brief: Scalars['String']['output'];
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  id: Scalars['ID']['output'];
  postCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  streetAddress: Maybe<Scalars['String']['output']>;
};

export type LocationAttributes = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

export type LocationOption = {
  __typename?: 'LocationOption';
  city: Maybe<Scalars['String']['output']>;
  country: Country;
};

export type LocationOptionList = {
  __typename?: 'LocationOptionList';
  entries: Array<LocationOption>;
  pageInfo: PagingInfo;
};

export type Magicbell = {
  __typename?: 'Magicbell';
  apiKey: Maybe<Scalars['String']['output']>;
  userExternalId: Scalars['String']['output'];
  userKey: Scalars['String']['output'];
};

/** Autogenerated return type of MarkContactAsJobNotChangedMutation. */
export type MarkContactAsJobNotChangedMutationPayload = {
  __typename?: 'MarkContactAsJobNotChangedMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MarkKeyActivityMutation. */
export type MarkKeyActivityMutationPayload = {
  __typename?: 'MarkKeyActivityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  keyActitivityListMember: Maybe<KeyActivityListMember>;
  keyActivity: Maybe<KeyActivity>;
};

/** Autogenerated return type of MarkUpcomingMeetingAsKeyActivityMutation. */
export type MarkUpcomingMeetingAsKeyActivityMutationPayload = {
  __typename?: 'MarkUpcomingMeetingAsKeyActivityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  keyActivity: Maybe<KeyActivity>;
};

export type MarketingContactAllowance = {
  __typename?: 'MarketingContactAllowance';
  activeFrom: Scalars['ISO8601Date']['output'];
  allowance: Scalars['Int']['output'];
  usage: Scalars['Int']['output'];
  utilisation: Scalars['Int']['output'];
};

export type MarketingContactAllowanceEntries = {
  __typename?: 'MarketingContactAllowanceEntries';
  entries: Array<MarketingContactAllowance>;
  pageInfo: PagingInfo;
};

export type MarketingEmailRequest = {
  __typename?: 'MarketingEmailRequest';
  emailDescription: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  marketingEmailResponse: Maybe<MarketingEmailResponse>;
  requestStatus: RequestStatus;
};

/** Attributes for marketing email request */
export type MarketingEmailRequestAttribute = {
  emailDescription: Scalars['String']['input'];
};

export type MarketingEmailResponse = {
  __typename?: 'MarketingEmailResponse';
  emailResponse: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type MarketingListAttributes = {
  category?: InputMaybe<ListCategory>;
  renderMode?: InputMaybe<RenderMode>;
};

export type MarketingListConfiguration = {
  __typename?: 'MarketingListConfiguration';
  allowUnsubscribed: Scalars['Boolean']['output'];
  consentConsentGivenText: Scalars['String']['output'];
  consentLegitimateInterestText: Scalars['String']['output'];
  consentUserUnsubscribedText: Scalars['String']['output'];
  enableEms: Scalars['Boolean']['output'];
  enableMarketingExclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type MarketingListCounts = {
  __typename?: 'MarketingListCounts';
  /** Count of excluded companies */
  excludedCompaniesCount: Scalars['Int']['output'];
  /** Count of excluded contact */
  excludedContactsCount: Scalars['Int']['output'];
  /** Count of contacts excluded by company exclusion and contact exclusion */
  totalExcludedContactsCount: Scalars['Int']['output'];
};

/** Options for filtering lists */
export type MarketingListFiltering = {
  category?: InputMaybe<ListCategory>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type MarketingListSyncRequest = {
  __typename?: 'MarketingListSyncRequest';
  connectedList: Maybe<ConnectedList>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
};

/** marketing lists permissions */
export type MarketingListsPermission = {
  __typename?: 'MarketingListsPermission';
  exportMarketingLists: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type MatchingExclusion = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  excludeFromEveryListCategory: Scalars['Boolean']['output'];
  exclusionListCategories: Array<ListCategory>;
  exclusionType: ExclusionType;
  id: Scalars['ID']['output'];
  matchedContact: Contact;
  reason: Scalars['String']['output'];
};

export type MeetingList = {
  __typename?: 'MeetingList';
  entries: Array<EmployeeMeeting>;
  pageInfo: PagingInfo;
};

/** Filtering Options for meetings */
export type MeetingsFiltering = {
  /** Company ID or Company Domain */
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  /** Contact ID or Contact Email */
  contactUid?: InputMaybe<Scalars['ID']['input']>;
  keyActivityCategories?: InputMaybe<Array<KeyActivityCategory>>;
  startTimeAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export enum MeetingsOwnership {
  All = 'ALL',
  User = 'USER'
}

export enum MeetingsTimeScope {
  All = 'ALL',
  Future = 'FUTURE',
  Past = 'PAST'
}

/** Autogenerated return type of MergeCompanyMutation. */
export type MergeCompanyMutationPayload = {
  __typename?: 'MergeCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MergeContactMutation. */
export type MergeContactMutationPayload = {
  __typename?: 'MergeContactMutationPayload';
  currentRecord: Maybe<Contact>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MergePeopleMutation. */
export type MergePeopleMutationPayload = {
  __typename?: 'MergePeopleMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type MergeTag = {
  __typename?: 'MergeTag';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MicrosoftAdminConsent = {
  __typename?: 'MicrosoftAdminConsent';
  consentUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MicrosoftAdminConsentDetail = {
  __typename?: 'MicrosoftAdminConsentDetail';
  consents: Array<MicrosoftAdminConsent>;
};

export enum MissingCompanyKind {
  Country = 'COUNTRY',
  Industry = 'INDUSTRY',
  Name = 'NAME'
}

export enum MissingContactInfo {
  Country = 'COUNTRY',
  FirstName = 'FIRST_NAME',
  JobTitle = 'JOB_TITLE',
  LastName = 'LAST_NAME'
}

export type MobileConfig = {
  __typename?: 'MobileConfig';
  name: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type MobileConfigs = {
  __typename?: 'MobileConfigs';
  entries: Array<MobileConfig>;
  json: Scalars['JSON']['output'];
};

export type Money = {
  __typename?: 'Money';
  cents: Scalars['BigInt']['output'];
  currency: Currency;
  format: Scalars['String']['output'];
};

export type MoneyRank = {
  __typename?: 'MoneyRank';
  amount: Money;
  rank: Scalars['String']['output'];
};

/** Autogenerated return type of MoveCompaniesToHierarchyMutation. */
export type MoveCompaniesToHierarchyMutationPayload = {
  __typename?: 'MoveCompaniesToHierarchyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MoveCompanyToHierarchyMutation. */
export type MoveCompanyToHierarchyMutationPayload = {
  __typename?: 'MoveCompanyToHierarchyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MoveContactToPersonMutation. */
export type MoveContactToPersonMutationPayload = {
  __typename?: 'MoveContactToPersonMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type MoveOpportunityInputCustom = {
  customStatusId: Scalars['ID']['input'];
  index: Scalars['Int']['input'];
  uid: Scalars['String']['input'];
};

export type MsEventSourceReference = {
  __typename?: 'MsEventSourceReference';
  error: Maybe<Scalars['String']['output']>;
  keyActivity: Maybe<KeyActivity>;
};

export type MultiMyContactList = {
  __typename?: 'MultiMyContactList';
  entries: Maybe<Array<MyList>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add a block page to a block page list */
  addBlockPageToBlockPageList: Maybe<AddBlockPageToBlockPageListMutationPayload>;
  /** Add a client company that will be synced to companies when sync completed */
  addClientCompanyForSync: Maybe<AddClientCompanyForSyncMutationPayload>;
  /** Add a new comment to a comment thread */
  addCommentToCommentThread: Maybe<AddCommentToCommentThreadMutationPayload>;
  /** Adds a company contact to a person. */
  addCompanyContactToPerson: Maybe<AddCompanyContactToPersonMutationPayload>;
  /** Add a company document */
  addCompanyDocument: Maybe<AddCompanyDocumentMutationPayload>;
  /** Add company to list */
  addCompanyListMember: Maybe<AddCompanyListMemberMutationPayload>;
  /** Adds a tag to company */
  addCompanyTags: Maybe<AddCompanyTagsMutationPayload>;
  /** Add new company to company hierarchy */
  addCompanyToAssociation: Maybe<AddCompanyToAssociationMutationPayload>;
  /** Add a company to the exclusion list. */
  addCompanyToExclusionList: Maybe<AddCompanyToExclusionListMutationPayload>;
  /** Add new company to company hierarchy */
  addCompanyToHierarchy: Maybe<AddCompanyToHierarchyMutationPayload>;
  /** Add a contact */
  addContact: Maybe<AddContactMutationPayload>;
  /** Add new company for contact with linkedin url */
  addContactNewCompanySwitch: Maybe<AddContactNewCompanySwitchMutationPayload>;
  /** Adds a personal email to a contact as part of a company switch */
  addContactPersonalEmailCompanySwitch: Maybe<AddContactPersonalEmailCompanySwitchMutationPayload>;
  /** Adds a contact to a list */
  addContactToList: Maybe<AddContactToListMutationPayload>;
  /** Adds a company switch to a contact */
  addContactUnknownCompanySwitch: Maybe<AddContactUnknownCompanySwitchMutationPayload>;
  /** Adds a new work email to a contact for company switch */
  addContactWorkEmailCompanySwitch: Maybe<AddContactWorkEmailCompanySwitchMutationPayload>;
  /** Move contact in company hierarchy */
  addContactsToHierarchy: Maybe<AddContactsToHierarchyMutationPayload>;
  /** Add contacts to a list with filter */
  addContactsToList: Maybe<AddContactsToListMutationPayload>;
  /** Add contacts to a list with filter and track progress */
  addContactsToListWithTracker: Maybe<AddContactsToListWithTrackerMutationPayload>;
  /** Move contact with company company hierarchy */
  addContactsWithCompanyToHierarchy: Maybe<AddContactsWithCompanyToHierarchyMutationPayload>;
  addCustomOption: Maybe<AddOptionMutationPayload>;
  /** Add Data Templates Template Fields */
  addDataTemplatesTemplateFields: Maybe<AddDataTemplatesTemplateFieldsMutationPayload>;
  /** Join duplicate companies together via a hierarchy */
  addDuplicateCompaniesToHierarchy: Maybe<AddDuplicateCompaniesToHierarchyMutationPayload>;
  addEmailAlias: Maybe<AddEmailAliasMutationPayload>;
  addEmailMarketingCampaignAttachment: Maybe<MyAddCampaignAttachmentMutationPayload>;
  /** Adds a recipient to a continuous email marketing campaign */
  addEmailMarketingCampaignRecipient: Maybe<AddRecipientMutationPayload>;
  /** Add from one table-like source to another */
  addFromTableLikeToAnother: Maybe<AddFromTableLikeToAnotherMutationPayload>;
  /** Assign lawyer to oppotunity tracking */
  addIncludedLawyer: Maybe<OpportunityTrackingAddIncludedLawyerMutationPayload>;
  /** Add interaction key activity for a interaction */
  addInteractionKeyActivity: Maybe<AddInteractionKeyActivityMutationPayload>;
  /** Create a key key activity from outlook */
  addKeyActivityFromOutlook: Maybe<AddKeyActivityFromOutlookMutationPayload>;
  /** Add a key activity to a key activity list. */
  addKeyActivityToList: Maybe<AddKeyActivityToListMutationPayload>;
  addListContactsToList: Maybe<AddListContactsToListMutationPayload>;
  /** Add list contacts to list and track progress */
  addListContactsToListWithTracker: Maybe<AddListContactsToListWithTrackerMutationPayload>;
  /** Adds a contact to my contacts */
  addMyContact: Maybe<MyAddContactMutationPayload>;
  /** Add my contacts to list */
  addMyContactsToList: Maybe<AddMyContactsToListMutationPayload>;
  /** Add my contacts to list and track the progress */
  addMyContactsToListWithTracker: Maybe<AddMyContactsToListWithTrackerMutationPayload>;
  /** Add files to opportunity */
  addOpportunityFile: Maybe<OpportunityTrackingAddGoalFileMutationPayload>;
  /** Add note to opportunity */
  addOpportunityNote: Maybe<OpportunityTrackingAddOpportunityNoteMutationPayload>;
  /** Add a project document */
  addProjectDocument: Maybe<AddProjectDocumentMutationPayload>;
  addProjectMembers: Maybe<AddProjectMembersMutationPayload>;
  addProjectNote: Maybe<AddProjectNoteMutationPayload>;
  addProjectTask: Maybe<AddProjectTaskMutationPayload>;
  addProjectTaskSection: Maybe<AddProjectTaskSectionMutationPayload>;
  /** Bulk add tags to all contacts and track progress */
  addTagsToAllContactsWithTracker: Maybe<AddTagsToAllContactsWithTrackerMutationPayload>;
  /** Bulk add tags to contacts in list */
  addTagsToContacts: Maybe<AddTagsToContactsMutationPayload>;
  /** Allow to add a User */
  addUser: Maybe<AddUserMutationPayload>;
  /** Archive company */
  archiveCompany: Maybe<ArchiveCompanyMutationPayload>;
  /** Archive a company list. */
  archiveCompanyList: Maybe<ArchiveCompanyListMutationPayload>;
  /** Archive company note */
  archiveCompanyNote: Maybe<ArchiveCompanyNoteMutationPayload>;
  /** Archive contact */
  archiveContact: Maybe<ArchiveContactMutationPayload>;
  /** Archive a contact list. */
  archiveContactList: Maybe<ArchiveContactListMutationPayload>;
  archiveEmailMarketingCampaign: Maybe<ArchiveCampaignMutationPayload>;
  archiveEmailMarketingTemplate: Maybe<ArchiveTemplateMutationPayload>;
  /** Archive a generic list. */
  archiveGenericList: Maybe<ArchiveGenericListMutationPayload>;
  /** Removes a goal */
  archiveOpportunity: Maybe<OpportunityTrackingArchiveGoalMutationPayload>;
  /** Archive opportunity note */
  archiveOpportunityNote: Maybe<OpportunityTrackingArchiveOpportunityNoteMutationPayload>;
  /** Archive a person and all associated same_contacts */
  archivePerson: Maybe<ArchivePersonMutationPayload>;
  /** Archive's the user and prevents future logins */
  archiveUser: Maybe<ArchiveUserMutationPayload>;
  blockCompany: Maybe<BlockCompanyMutationPayload>;
  /** Block domain and any subdomains from recording interactions */
  blockDomain: Maybe<BlockDomainMutationPayload>;
  /** Bulk add companies to list */
  bulkAddCompanyListMember: Maybe<BulkAddCompanyListMemberMutationPayload>;
  /** Bulk add contacts to list */
  bulkAddListMember: Maybe<BulkAddListMemberMutationPayload>;
  /** Bulk add contacts to list and track progress */
  bulkAddListMemberWithTracker: Maybe<BulkAddListMemberWithTrackerMutationPayload>;
  /** Bulk add tags to contacts and track progress */
  bulkAddTagsToContactsWithTracker: Maybe<BulkAddTagsToContactsWithTrackerMutationPayload>;
  /** Bulk Archive many companies */
  bulkArchiveCompanies: Maybe<BulkArchiveCompaniesMutationPayload>;
  /** Bulk archive contact */
  bulkArchiveContact: Maybe<BulkArchiveContactMutationPayload>;
  /** Bulk archive contact and track progress */
  bulkArchiveContactWithTracker: Maybe<BulkArchiveContactWithTrackerMutationPayload>;
  /** Bulk Associate companies */
  bulkAssociateCompanies: Maybe<BulkAssociateCompaniesMutationPayload>;
  /** Bulk updates member's custom fields and tracker process */
  bulkEditListMemberWithTracker: Maybe<BulkEditListMemberWithTrackerMutationPayload>;
  /** Bulk ignore companies from the incomplete company list */
  bulkIgnoreIncompleteCompanies: Maybe<BulkIgnoreIncompleteCompaniesMutationPayload>;
  /** Bulk ignore contacts from the incomplete company list */
  bulkIgnoreIncompleteContacts: Maybe<BulkIgnoreIncompleteContactsMutationPayload>;
  bulkMarkAllKeyActivityContacts: Maybe<BulkMarkAllKeyActivityContactsMutationPayload>;
  /** Bulk mark key activities */
  bulkMarkKeyActivity: Maybe<BulkMarkKeyActivityMutationPayload>;
  /** Bulk mark key activities in the background */
  bulkMarkKeyActivityWithTracker: Maybe<BulkMarkKeyActivityWithTrackerMutationPayload>;
  /** Bulk remove companies to list */
  bulkRemoveCompanyListMember: Maybe<BulkRemoveCompanyListMemberMutationPayload>;
  bulkRemoveContactListCleanedMembers: Maybe<BulkRemoveContactListMembersMutationPayload>;
  /** Bulk remove contacts from list and track progress */
  bulkRemoveContactsFromListWithTracker: Maybe<BulkRemoveContactsFromListWithTrackerMutationPayload>;
  /** Bulk remove contacts from list */
  bulkRemoveListMember: Maybe<BulkRemoveListMemberMutationPayload>;
  /** Bulk remove contacts from my contacts */
  bulkRemoveMyContact: Maybe<MyBulkRemoveContactMutationPayload>;
  /** Bulk Remove Tag */
  bulkRemoveTag: Maybe<BulkRemoveTagMutationPayload>;
  /** Bulk remove tags from contacts and track progress */
  bulkRemoveTagsFromContactsWithTracker: Maybe<BulkRemoveTagsFromContactsWithTrackerMutationPayload>;
  /** Bulk restore archive contact */
  bulkRestoreArchiveContacts: Maybe<BulkRestoreArchivedContactsMutationPayload>;
  /** Restore Archived many companies */
  bulkRestoreArchivedCompanies: Maybe<BulkRestoreArchivedCompaniesMutationPayload>;
  /** Bulk Update or set contacts consent and track progress */
  bulkSetContactConsentWithTracker: Maybe<BulkSetContactConsentWithTrackerMutationPayload>;
  /** Sets a stay in touch frequency to my contacts */
  bulkStayInTouch: Maybe<MyBulkStayInTouchMutationPayload>;
  /** Bulk updates companies custom fields */
  bulkUpdateCompanyListMember: Maybe<BulkUpdateCompanyListMemberMutationPayload>;
  /** Update type of many companies */
  bulkUpdateCompanyType: Maybe<BulkUpdateCompanyTypeMutationPayload>;
  /** Bulk update contacts and track progress */
  bulkUpdateContact: Maybe<BulkUpdateContactMutationPayload>;
  /** Bulk update privacy of contacts */
  bulkUpdateContactsPrivacy: Maybe<MyBulkUpdateContactsPrivacyMutationPayload>;
  /** Bulk update contacts review rule value for contacts. */
  bulkUpdateContactsReviewRuleValueForContacts: Maybe<BulkUpdateContactsReviewRuleValueForContactsMutationPayload>;
  /** Bulk updates member's custom fields */
  bulkUpdateListMember: Maybe<BulkUpdateListMemberMutationPayload>;
  cancelScheduledEmailMarketingCampaign: Maybe<DescheduleCampaignMutationPayload>;
  /** Update a company */
  changeContactCompany: Maybe<ChangeContactCompanyMutationPayload>;
  /** Removes interactions with domain and blocks future interactions with this domain */
  classifyDomain: Maybe<ClassifyDomainMutationPayload>;
  /** Block companies domains from recording interactions */
  classifyDomains: Maybe<ClassifyDomainsMutationPayload>;
  /** Removes interactions with email and blocks future interactions with this email */
  classifyEmail: Maybe<ClassifyEmailMutationPayload>;
  /** Clones an existing email marketing campaign */
  cloneEmailMarketingCampaign: Maybe<CloneCampaignMutationPayload>;
  cloneEmailMarketingTemplate: Maybe<CloneTemplateMutationPayload>;
  /** Completes the sync of client companies to companies */
  completeClientCompaniesSync: Maybe<CompleteClientCompaniesSyncMutationPayload>;
  /** Complete my task */
  completeMyTask: Maybe<CompleteMyTaskMutationPayload>;
  /** Complete task */
  completeTask: Maybe<CompleteTaskMutationPayload>;
  connectList: Maybe<ConnectListMutationPayload>;
  /** Bulk mark key activity for all contacts with tracker */
  contactsBulkMarkKeyActivityWithTracker: Maybe<ContactsBulkMarkKeyActivityWithTrackerMutationPayload>;
  createApiDefinition: Maybe<CreateApiDefinitionMutationPayload>;
  /** Create a block page list tab */
  createBlockPageListTab: Maybe<CreateBlockPageListTabMutationPayload>;
  /** Create a email marketing campaign tab */
  createCampaignTab: Maybe<CreateCampaignTabMutationPayload>;
  /** Creates a career company record for a Tenant Contact */
  createCareerCompany: Maybe<CreateCareerCompanyMutationPayload>;
  /** Create a new comment thread and add the first comment to it */
  createCommentThread: Maybe<CreateCommentThreadMutationPayload>;
  /** Create company */
  createCompany: Maybe<CreateCompanyMutationPayload>;
  /** Add contact to a company */
  createCompanyContact: Maybe<CreateCompanyContactMutationPayload>;
  createCompanyKeyContact: Maybe<CreateCompanyKeyContactMutationPayload>;
  /** Create a company list */
  createCompanyList: Maybe<CreateCompanyListMutationPayload>;
  createCompanyListCustomFieldSchema: Maybe<CreateCompanyListCustomFieldSchemaMutationPayload>;
  createCompanyListReminderSetting: Maybe<CreateCompanyListReminderSettingMutationPayload>;
  /** Create a company note */
  createCompanyNote: Maybe<CreateCompanyNoteMutationPayload>;
  /** Create company location */
  createCompanyOfficeLocation: Maybe<CreateOfficeLocationMutationPayload>;
  /** Create company opportunity */
  createCompanyOpportunity: Maybe<OpportunityTrackingCreateOpportunityMutationPayload>;
  /** Create company relationship partner */
  createCompanyRelationshipPartner: Maybe<CreateCompanyRelationshipPartnerMutationPayload>;
  /** Create a contact or activate an archived contact */
  createContact: Maybe<CreateContactMutationPayload>;
  /** Create a contact exclusion rule */
  createContactExclusionRule: Maybe<CreateContactExclusionRuleMutationPayload>;
  createContactListReminderSetting: Maybe<CreateContactListReminderSettingMutationPayload>;
  /** Add a contact list webhook */
  createContactListWebhook: Maybe<CreateContactListWebhookMutationPayload>;
  /** Create multiple contacts by email */
  createContacts: Maybe<CreateContactsMutationPayload>;
  /** Create Multiple Custom Object Records */
  createCustomObjectRecords: Maybe<CreateCustomObjectRecordsMutationPayload>;
  /** Create a custom user role. */
  createCustomUserRole: Maybe<CreateCustomUserRoleMutationPayload>;
  /** Create Data Templates Record */
  createDataTemplatesRecord: Maybe<CreateDataTemplatesRecordMutationPayload>;
  /** Create a new data template */
  createDataTemplatesTemplate: Maybe<CreateDataTemplatesTemplateMutationPayload>;
  createEmailMarketingCampaign: Maybe<CreateCampaignMutationPayload>;
  createEmailMarketingTemplate: Maybe<CreateTemplateMutationPayload>;
  createEmailMarketingTemplateSavedRow: Maybe<CreateTemplateSavedRowMutationPayload>;
  /** Create embed url tab */
  createEmbedUrlTab: Maybe<CreateEmbedUrlTabMutationPayload>;
  /** Create an event pack request */
  createEventPackRequest: Maybe<CreateEventPackRequestMutationPayload>;
  /** Create an audit record for an export */
  createExportAudit: Maybe<CreateExportAuditMutationPayload>;
  /** Prepare for a flat file admin for import. */
  createFlatfileWorkbookForAdminImport: Maybe<CreateFlatfileWorkbookForAdminImportMutationPayload>;
  /** Import Records for a certain type of custom object */
  createFlatfileWorkbookForCustomObjectsAdminImport: Maybe<CreateFlatfileWorkbookForCustomObjectsAdminImportMutationPayload>;
  /** Prepare for a flat file import for a list. */
  createFlatfileWorkbookForListImport: Maybe<CreateFlatfileWorkbookForListImportMutationPayload>;
  /** Create a form */
  createForm: Maybe<CreateFormMutationPayload>;
  /** Create a workflow for a form */
  createFormWorkflow: Maybe<CreateFormWorkflowMutationPayload>;
  /** Create a generic list */
  createGenericList: Maybe<CreateGenericListMutationPayload>;
  createGenericListCustomFieldSchema: Maybe<CreateGenericListCustomFieldSchemaMutationPayload>;
  createGenericListItem: Maybe<CreateGenericListItemMutationPayload>;
  createGenericListReminderSetting: Maybe<CreateGenericListReminderSettingMutationPayload>;
  /** Add a generic list webhook */
  createGenericListWebhook: Maybe<CreateGenericListWebhookMutationPayload>;
  /** create internal industry */
  createInternalIndustry: Maybe<CreateInternalIndustryMutationPayload>;
  /** Create key activities in bulk */
  createKeyActivities: Maybe<CreateKeyActivitiesMutationPayload>;
  createKeyActivityListCustomFieldSchema: Maybe<CreateKeyActivityListCustomFieldSchemaMutationPayload>;
  /** Create a key activity list tab */
  createKeyActivityListTab: Maybe<CreateKeyActivityListTabMutationPayload>;
  /** Create a linkedin post request */
  createLinkedinPostRequest: Maybe<CreateLinkedinPostRequestMutationPayload>;
  /** Create a contact list */
  createList: Maybe<CreateContactListMutationPayload>;
  createListCustomFieldSchema: Maybe<CreateListCustomFieldSchemaMutationPayload>;
  /** Creates a list view */
  createListView: Maybe<CreateListViewMutationPayload>;
  /** Create a marketing contact list */
  createMarketingContactList: Maybe<CreateMarketingContactListMutationPayload>;
  /** Create an marketing email request */
  createMarketingEmailRequest: Maybe<CreateMarketingEmailRequestMutationPayload>;
  /** Create a note */
  createNote: Maybe<CreateNoteMutationPayload>;
  createObjective: Maybe<CreateObjectiveMutationPayload>;
  createObjectiveProgress: Maybe<CreateProgressMutationPayload>;
  createOpportunityCustomFieldSchema: Maybe<OpportunityTrackingCreateOpportunityCustomFieldSchemaMutationPayload>;
  /** Create a page saved view tab */
  createPageViewTab: Maybe<CreatePageViewTabMutationPayload>;
  /** Create a Person with multiple contacts */
  createPerson: Maybe<CreatePersonMutationPayload>;
  createProject: Maybe<CreateProjectMutationPayload>;
  createProjectFolder: Maybe<CreateProjectFolderMutationPayload>;
  createProjectFromTemplate: Maybe<CreateProjectFromTemplateMutationPayload>;
  /** Creates an Opportunity for a Project */
  createProjectOpportunity: Maybe<CreateProjectOpportunityMutationPayload>;
  /** Create custom field schema for workspace opportunities */
  createProjectOpportunityCustomFieldSchema: Maybe<CreateProjectOpportunityCustomFieldSchemaMutationPayload>;
  /** Creates a new research report. */
  createResearchReport: Maybe<CreateReportMutationPayload>;
  /** Creates a new section within a research report. */
  createResearchReportSection: Maybe<CreateReportSectionMutationPayload>;
  createSentReferral: Maybe<CreateSentReferralMutationPayload>;
  /** Create a static company list tab */
  createStaticCompanyListTab: Maybe<CreateStaticCompanyListTabMutationPayload>;
  /** Create a static contact list tab */
  createStaticContactListTab: Maybe<CreateStaticContactListTabMutationPayload>;
  /** Create a static generic list tab */
  createStaticGenericListTab: Maybe<CreateStaticGenericListTabMutationPayload>;
  /** Create a static contact list tab */
  createStaticMarketingListTab: Maybe<CreateStaticMarketingListTabMutationPayload>;
  createTableLikeRollupField: Maybe<CreateTableLikeRollupFieldMutationPayload>;
  /** Create Tag */
  createTag: Maybe<CreateTagMutationPayload>;
  /** Create a task */
  createTask: Maybe<CreateTaskMutationPayload>;
  /** Create track event */
  createTrackEvent: Maybe<CreateTrackEventMutationPayload>;
  /** Create user delegate access for two user uids */
  createUserDelegateAccess: Maybe<CreateUserDelegateAccessMutationPayload>;
  /** Add a webhook */
  createWebhook: Maybe<CreateWebhookMutationPayload>;
  deleteApiSource: Maybe<DeleteApiSourceMutationPayload>;
  /** Deletes a career company record for a Tenant Contact */
  deleteCareerCompany: Maybe<DeleteCareerCompanyMutationPayload>;
  deleteEmailMarketingCampaignAttachment: Maybe<MyDeleteCampaignAttachmentMutationPayload>;
  /** Publishes a form */
  deleteForm: Maybe<DeleteFormMutationPayload>;
  /** Delete a workflow for a form */
  deleteFormWorkflow: Maybe<DeleteFormWorkflowMutationPayload>;
  /** Delete a list view */
  deleteListView: Maybe<DeleteListViewMutationPayload>;
  /** Delete my task */
  deleteMyTask: Maybe<DeleteMyTaskMutationPayload>;
  /** Deletes a research report. */
  deleteResearchReport: Maybe<DeleteReportMutationPayload>;
  /** Deletes a research report section. */
  deleteResearchReportSection: Maybe<DeleteReportSectionMutationPayload>;
  /** Deletes a Role */
  deleteRole: Maybe<DeleteRoleMutationPayload>;
  deleteSentReferral: Maybe<DeleteSentReferralMutationPayload>;
  deleteTableLikeRollupField: Maybe<DeleteTableLikeRollupFieldMutationPayload>;
  deleteTableLikeRows: Maybe<DeleteTableLikeRowsMutationPayload>;
  /** Delete my task */
  deleteTask: Maybe<DeleteTaskMutationPayload>;
  /** Delete the cover image for the theme of a form */
  deleteThemeCoverImageForForm: Maybe<DeleteThemeCoverImageForFormMutationPayload>;
  /** Deletes user delegate access */
  deleteUserDelegateAccess: Maybe<DeleteUserDelegateAccessMutationPayload>;
  /** Discard a note (soft delete) */
  discardNote: Maybe<DiscardNoteMutationPayload>;
  disconnectConnectedList: Maybe<DisconnectConnectedListMutationPayload>;
  disconnectList: Maybe<DisconnectListMutationPayload>;
  dismissReminder: Maybe<DismissReminderMutationPayload>;
  /** Download the HTML template of a campaign. */
  downloadEmailMarketingCampaignTemplate: Maybe<DownloadCampaignTemplateMutationPayload>;
  /** export companies */
  exportCompanies: Maybe<ExportCompaniesMutationPayload>;
  /** export contacts in the background */
  exportContacts: Maybe<ExportContactsMutationPayload>;
  exportEmailMarketingCampaignRecipients: Maybe<ExportCampaignRecipientsMutationPayload>;
  /** export incomplete companies in the background */
  exportIncompleteCompanies: Maybe<ExportIncompleteCompaniesMutationPayload>;
  /** Export incomplete contacts in the background */
  exportIncompleteContacts: Maybe<ExportIncompleteContactsMutationPayload>;
  /** export list in the background */
  exportList: Maybe<ExportListMutationPayload>;
  /** export my contacts in the background */
  exportMyContacts: Maybe<MyExportContactsMutationPayload>;
  exportTableLikeRows: Maybe<ExportTableLikeRowsMutationPayload>;
  /** export unengaged contacts in the background */
  exportUnengagedContacts: Maybe<ExportUnengagedContactsMutationPayload>;
  /** Find contact emails */
  findProspectEmail: Maybe<FindProspectEmailMutationPayload>;
  /** Find more prospects for a domain */
  findProspects: Maybe<FindProspectsMutationPayload>;
  /** Manually flag two contacts as duplicates */
  flagDuplicateContacts: Maybe<FlagDuplicateContactsMutationPayload>;
  /** Manually flag two people as duplicates */
  flagDuplicatePeople: Maybe<FlagDuplicatePeopleMutationPayload>;
  /** Force enrichment for a contact */
  forceEnrich: Maybe<ForceEnrichMutationPayload>;
  /** Generate a suggested email for a given contact */
  generateEmail: Maybe<GenerateEmailMutationPayload>;
  /** Generates a JWT for the currently authenticated user. */
  generateJwt: Maybe<GenerateJwtMutationPayload>;
  /** Hides contact from who knows */
  hideContactFromWhoKnows: Maybe<HideContactFromWhoKnowsMutationPayload>;
  /** Hide Employee from drop down selections and optional archive the contact as well */
  hideEmployee: Maybe<HideEmployeeMutationPayload>;
  /** Ignore contact requiring placement in an organizational unit */
  ignoreContactRequiringPlacement: Maybe<IgnoreContactRequiringPlacementMutationPayload>;
  /** Ignore incomplete companies */
  ignoreIncompleteCompany: Maybe<IgnoreIncompleteCompanyMutationPayload>;
  /** Ignore incomplete contacts */
  ignoreIncompleteContact: Maybe<IgnoreIncompleteContactMutationPayload>;
  /** Scan business cards and extract information into contacts and key activities */
  importBusinessCards: Maybe<ImportBusinessCardsMutationPayload>;
  /** Import workbook that was created with CreateFlatfileWorkbookForAdminImport */
  importFlatfileWorkbook: Maybe<ImportFlatfileWorkbookMutationPayload>;
  /** Install a EMS connector */
  installEmsConnector: Maybe<InstallEmsConnectorMutationPayload>;
  /** Link Projects to opportunity */
  linkProjectsToOpportunity: Maybe<LinkProjectsToOpportunityMutationPayload>;
  listCleanerOverrideContactVerification: Maybe<OverrideContactVerificationMutationPayload>;
  /** Bulk mark key activity with tracker */
  listContactsBulkMarkKeyActivityWithTracker: Maybe<ListContactsBulkMarkKeyActivityWithTrackerMutationPayload>;
  /** Mark as not contact job changed */
  markContactAsJobNotChange: Maybe<MarkContactAsJobNotChangedMutationPayload>;
  markKeyActivity: Maybe<MarkKeyActivityMutationPayload>;
  /** Mark upcoming meeting as key activity */
  markUpcomingMeetingAsKeyActivity: Maybe<MarkUpcomingMeetingAsKeyActivityMutationPayload>;
  /** Merge company */
  mergeCompany: Maybe<MergeCompanyMutationPayload>;
  /** Merge contact */
  mergeContact: Maybe<MergeContactMutationPayload>;
  /** Merge two people by transferring contacts and data from previous person to current person */
  mergePeople: Maybe<MergePeopleMutationPayload>;
  /** Move company in the company hierarchy */
  moveCompaniesToHierarchy: Maybe<MoveCompaniesToHierarchyMutationPayload>;
  /** Move company in the company hierarchy */
  moveCompanyToHierarchy: Maybe<MoveCompanyToHierarchyMutationPayload>;
  /** Move a contact from one person to another */
  moveContactToPerson: Maybe<MoveContactToPersonMutationPayload>;
  /** move an opportunities on my board */
  moveOpportunitiesOnMyCustomBoard: Maybe<OpportunityTrackingMoveOpportunitiesOnMyCustomBoardMutationPayload>;
  /** Bulk mark key activity for my contacts with tracker */
  myContactsBulkMarkKeyActivityWithTracker: Maybe<MyContactsBulkMarkKeyActivityWithTrackerMutationPayload>;
  /** Pin a note for the current user */
  pinNote: Maybe<PinNoteMutationPayload>;
  /** Clears all previous sync data and prepares for a new sync */
  prepareClientCompaniesForSync: Maybe<PrepareClientCompaniesForSyncMutationPayload>;
  /** Publishes a form */
  publishForm: Maybe<PublishFormMutationPayload>;
  /** Removes email addresses, activities history and audit trail from contact */
  purgeContact: Maybe<PurgeContactMutationPayload>;
  /** Re-assign opportunity company */
  reAssignOpportunityCompany: Maybe<OpportunityTrackingReAssignOpportunityCompanyMutationPayload>;
  /** Add a client company and sync the group it belongs to */
  reSyncClientCompany: Maybe<ReSyncClientCompanyMutationPayload>;
  /** This re-creates the key_activity/interaction. Then deletes the old record to fix stats */
  rebuildKeyActivity: Maybe<RebuildKeyActivityMutationPayload>;
  /** Sends device token to MagicBell */
  regiesterDeviceTokenMagicBell: Maybe<RegisterDeviceTokenMagicBellMutationPayload>;
  /** Sends device token to MagicBell */
  registerDeviceTokenMagicBell: Maybe<RegisterDeviceTokenMagicBellMutationPayload>;
  removeBlockPage: Maybe<RemoveBlockPageMutationPayload>;
  /** Remove an existing comment */
  removeComment: Maybe<RemoveCommentMutationPayload>;
  removeCompanyDocument: Maybe<RemoveCompanyDocumentMutationPayload>;
  /** Remove company from exclusion list. */
  removeCompanyFromExclusionList: Maybe<RemoveCompanyFromExclusionListMutationPayload>;
  /** Remove company from company hierarchy */
  removeCompanyFromHierarchy: Maybe<RemoveCompanyFromHierarchyMutationPayload>;
  removeCompanyKeyContact: Maybe<RemoveCompanyKeyContactMutationPayload>;
  /** Remove company list */
  removeCompanyList: Maybe<RemoveCompanyListMutationPayload>;
  /** Remove custom logo from company */
  removeCompanyLogo: Maybe<RemoveCompanyLogoMutationPayload>;
  /** Remove company location */
  removeCompanyOfficeLocation: Maybe<RemoveOfficeLocationMutationPayload>;
  /** Remove company relationship partner */
  removeCompanyRelationshipPartner: Maybe<RemoveCompanyRelationshipPartnerMutationPayload>;
  /** Remove a contact exclusion rule. */
  removeContactExclusionRule: Maybe<RemoveContactExclusionRuleMutationPayload>;
  /** Remove contact from requiring hierarchy placement. */
  removeContactFromRequireHierarchyPlacement: Maybe<RemoveContactFromRequireHierarchyPlacementMutationPayload>;
  removeCustomFieldSchema: Maybe<RemoveCustomFieldSchemaMutationPayload>;
  removeCustomOption: Maybe<RemoveOptionMutationPayload>;
  removeDuplicateCompany: Maybe<RemoveDuplicateCompanyMutationPayload>;
  removeDuplicateContact: Maybe<RemoveDuplicateContactMutationPayload>;
  removeEmailAddress: Maybe<RemoveEmailAddressMutationPayload>;
  removeGenericListItems: Maybe<RemoveGenericListItemsMutationPayload>;
  /** Remove assign lawyer from oppotunity tracking */
  removeIncludedLawyer: Maybe<OpportunityTrackingRemoveIncludedLawyerMutationPayload>;
  /** Remove key activity for a interaction and optionally from a list. */
  removeKeyActivity: Maybe<RemoveKeyActivityMutationPayload>;
  /** Remove key activity member from a list. */
  removeKeyActivityMember: Maybe<RemoveKeyActivityMemberMutationPayload>;
  /** Remove list */
  removeList: Maybe<RemoveListMutationPayload>;
  /** Removes a company from my contacts */
  removeMyCompany: Maybe<MyRemoveCompanyMutationPayload>;
  /** Removes a contact from my contacts */
  removeMyContact: Maybe<MyRemoveContactMutationPayload>;
  /** Remove a User's access from a shared list */
  removeMyListShareAccess: Maybe<RemoveMyListShareAccessMutationPayload>;
  removeObjectiveProgress: Maybe<RemoveProgressMutationPayload>;
  /** Remove file from oppotunity */
  removeOpportunityFile: Maybe<OpportunityTrackingRemoveGoalFileMutationPayload>;
  /** Remove a page tab */
  removePageTab: Maybe<RemovePageTabMutationPayload>;
  removeProject: Maybe<RemoveProjectMutationPayload>;
  removeProjectDocument: Maybe<RemoveProjectDocumentMutationPayload>;
  removeProjectFolder: Maybe<RemoveProjectFolderMutationPayload>;
  removeProjectMembers: Maybe<RemoveProjectMembersMutationPayload>;
  removeProjectNote: Maybe<RemoveProjectNoteMutationPayload>;
  removeProjectOpportunity: Maybe<RemoveProjectOpportunityMutationPayload>;
  removeProjectTaskSection: Maybe<RemoveProjectTaskSectionMutationPayload>;
  removeReminderSetting: Maybe<RemoveReminderSettingMutationPayload>;
  /** Remove Tag */
  removeTag: Maybe<RemoveTagMutationPayload>;
  /** Rename Tag */
  renameTag: Maybe<RenameTagMutationPayload>;
  /** Reopen my task */
  reopenMyTask: Maybe<ReopenMyTaskMutationPayload>;
  /** Reopen task */
  reopenTask: Maybe<ReopenTaskMutationPayload>;
  reorderGenericListItems: Maybe<ReorderGenericListItemsMutationPayload>;
  /** Enter Description Here */
  reportIncorrectCompanyData: Maybe<ReportIncorrectCompanyDataMutationPayload>;
  reportIncorrectContactData: Maybe<ReportIncorrectContactDataMutationPayload>;
  /** Restore Archived companies or my companies. */
  restoreArchivedCompany: Maybe<RestoreArchivedCompanyMutationPayload>;
  /** Removes bounced tag from email address */
  restoreBouncedEmail: Maybe<RestoreBouncedEmailMutationPayload>;
  /** Restore discarded list members to a list. */
  restoreDiscardedListMembers: Maybe<RestoreDiscardedListMembersMutationPayload>;
  restoreEmailMarketingTemplate: Maybe<RestoreTemplateMutationPayload>;
  saveCampaignAsTemplate: Maybe<SaveCampaignAsTemplateMutationPayload>;
  /** Create a recipient list filter for an email marketing campaign */
  saveCampaignRecipientListFilter: Maybe<SaveCampaignRecipientListFilterMutationPayload>;
  /** Schedules an existing draft email marketing campaign */
  scheduleEmailMarketingCampaign: Maybe<ScheduleCampaignMutationPayload>;
  /** Sends a test email for an existing draft email marketing campaign */
  sendEmailMarketingTestEmail: Maybe<SendTestEmailMutationPayload>;
  /** Add a contact */
  setAccountColour: Maybe<SetAccountColourMutationPayload>;
  /** Update a company list member custom fields */
  setCompanyListMemberCustomField: Maybe<SetCompanyListMemberCustomFieldMutationPayload>;
  /** Set a company logo */
  setCompanyLogo: Maybe<SetCompanyLogoMutationPayload>;
  setInteractionsConfig: Maybe<SetInteractionsConfigMutationPayload>;
  /** Update a key activity list member custom fields */
  setKeyActivityListMemberCustomField: Maybe<SetKeyActivityListMemberCustomFieldMutationPayload>;
  /** Update a list member custom fields */
  setListMemberCustomField: Maybe<SetListMemberCustomFieldMutationPayload>;
  /** Sets Current User's Timezone */
  setMyTimezone: Maybe<SetMyTimezoneMutationPayload>;
  /** Sets a stay in touch frequency to my contacts */
  setStayInTouch: Maybe<MySetStayInTouchMutationPayload>;
  /** Set UI configuration */
  setUiConfiguration: Maybe<SetUiConfigurationMutationPayload>;
  /**
   * Sets User Role. If User does not exist it will create it
   * @deprecated Use `updateUser` instead
   */
  setUserRole: Maybe<SetUserRoleMutationPayload>;
  /** Share a company list with other users */
  shareCompanyList: Maybe<ShareCompanyListMutationPayload>;
  /** Share a contact list with other users */
  shareContactList: Maybe<ShareContactListMutationPayload>;
  /** Share a generic list with other users */
  shareGenericList: Maybe<ShareGenericListMutationPayload>;
  /** Share a list or list view with other users */
  shareListView: Maybe<ShareListViewMutationPayload>;
  /** Show Employee in drop down selections and optional restore the contact as well */
  showEmployee: Maybe<ShowEmployeeMutationPayload>;
  /** Allow to switch users */
  switchAccount: Maybe<SwitchAccountMutationPayload>;
  /** Sync company in the company hierarchy */
  syncCompanyHierarchy: Maybe<SyncCompanyHierarchyMutationPayload>;
  syncConnectedListMembers: Maybe<SyncConnectedListMembersMutationPayload>;
  syncEmployee: Maybe<SyncEmployeeMutationPayload>;
  syncListActivities: Maybe<SyncListActivitiesMutationPayload>;
  syncListMembers: Maybe<SyncListMembersMutationPayload>;
  /** Sync contact from Nexl to Outlook Personal Contact */
  syncOutlookContact: Maybe<SyncOutlookContactMutationPayload>;
  /** Sync contact from Nexl to Outlook Personal Contact for a user */
  syncOutlookContactForUser: Maybe<SyncOutlookContactForUserMutationPayload>;
  /** Create a interaction */
  trackBouncedEmail: Maybe<TrackBouncedEmailMutationPayload>;
  /** Track an email message */
  trackEmailMessage: Maybe<TrackEmailMessageMutationPayload>;
  /** Tracks a past meeting */
  trackPastMeeting: Maybe<TrackPastMeetingMutationPayload>;
  triggerApiSource: Maybe<TriggerApiSourceMutationPayload>;
  /** Unarchive a contact */
  unarchiveContact: Maybe<UnarchiveContactMutationPayload>;
  unblockCompany: Maybe<UnblockCompanyMutationPayload>;
  /** Unblock domain and subdomains to start recording interactions again */
  unblockDomain: Maybe<UnblockDomainMutationPayload>;
  /** Unblocks email to start recording interactions again */
  unblockEmail: Maybe<UnblockEmailMutationPayload>;
  /** Install a EMS connector */
  uninstallEmsConnector: Maybe<UninstallEmsConnectorMutationPayload>;
  /** Unpin a note for the current user */
  unpinNote: Maybe<UnpinNoteMutationPayload>;
  /** Update a block page */
  updateBlockPage: Maybe<UpdateBlockPageMutationPayload>;
  /** Updates the position of a block page list */
  updateBlockPageListPositions: Maybe<UpdateBlockPageListPositionsMutationPayload>;
  /** Update an existing comment */
  updateComment: Maybe<UpdateCommentMutationPayload>;
  /** Update a company */
  updateCompany: Maybe<UpdateCompanyMutationPayload>;
  /** update a company document */
  updateCompanyDocument: Maybe<UpdateCompanyDocumentMutationPayload>;
  /** Update company exclusion mutation. */
  updateCompanyExclusion: Maybe<UpdateCompanyExclusionMutationPayload>;
  /** Update company hierarchy */
  updateCompanyHierarchy: Maybe<UpdateCompanyHierarchyMutationPayload>;
  /** Update a company list */
  updateCompanyList: Maybe<UpdateCompanyListMutationPayload>;
  /** Update a company note */
  updateCompanyNote: Maybe<UpdateCompanyNoteMutationPayload>;
  /** Update company office location */
  updateCompanyOfficeLocation: Maybe<UpdateOfficeLocationMutationPayload>;
  /** Update a list of third party ems details */
  updateConnectedList: Maybe<UpdateConnectedListMutationPayload>;
  /** Update a contact */
  updateContact: Maybe<UpdateContactMutationPayload>;
  /** Update or set a contact consent */
  updateContactConsent: Maybe<UpdateContactConsentMutationPayload>;
  /** Update a contact custom field using a string value */
  updateContactCustomField: Maybe<UpdateContactCustomFieldMutationPayload>;
  /** Update email addresses for a contact */
  updateContactEmails: Maybe<UpdateContactEmailsMutationPayload>;
  /** Update a contact exclusion rule. */
  updateContactExclusionRule: Maybe<UpdateContactExclusionRuleMutationPayload>;
  /** Update privacy of my contact */
  updateContactPrivacy: Maybe<MyUpdateContactPrivacyMutationPayload>;
  /** Updates core role permission for a role */
  updateCoreRolePermission: Maybe<UpdateCoreRolePermissionMutationPayload>;
  updateCustomFieldSchema: Maybe<UpdateCustomFieldSchemaMutationPayload>;
  updateCustomFieldSchemaPositions: Maybe<UpdateCustomFieldSchemaPositionsMutationPayload>;
  /** Update custom field schema name and options if it is an option field. */
  updateCustomFieldSchemaValues: Maybe<UpdateCustomFieldSchemaValuesMutationPayload>;
  updateCustomOption: Maybe<UpdateOptionMutationPayload>;
  /** Updates an existing email marketing campaign */
  updateEmailMarketingCampaign: Maybe<UpdateCampaignMutationPayload>;
  /** Updates an existing email marketing template */
  updateEmailMarketingTemplate: Maybe<UpdateTemplateMutationPayload>;
  /** Updates enrichment role permission for a role */
  updateEnrichmentRolePermission: Maybe<UpdateEnrichmentRolePermissionMutationPayload>;
  /** Update a form */
  updateForm: Maybe<UpdateFormMutationPayload>;
  /** Update the confirmation settings on a form */
  updateFormConfirmationSettings: Maybe<UpdateFormConfirmationSettingsMutationPayload>;
  /** Update expiry settings for a form */
  updateFormExpiry: Maybe<UpdateFormExpiryMutationPayload>;
  /** Update a form along with it's elements */
  updateFormInfo: Maybe<UpdateFormInfoMutationPayload>;
  /** Update the confirmation settings on a form */
  updateFormKeyActivitySettings: Maybe<UpdateFormKeyActivitySettingsMutationPayload>;
  /** Update a form */
  updateFormSettings: Maybe<UpdateFormSettingsMutationPayload>;
  /** Update waitlist settings for a form */
  updateFormWaitlist: Maybe<UpdateFormWaitlistMutationPayload>;
  /** Update a workflow for a form */
  updateFormWorkflow: Maybe<UpdateFormWorkflowMutationPayload>;
  /** Update a generic list */
  updateGenericList: Maybe<UpdateGenericListMutationPayload>;
  updateGenericListItems: Maybe<UpdateGenericListItemsMutationPayload>;
  /** Update company industries to an internal industry */
  updateIndustryMapping: Maybe<UpdateIndustryMappingMutationPayload>;
  /** Updates role permission for opportunity tracking */
  updateInteractionsRolePermission: Maybe<UpdateInteractionsRolePermissionMutationPayload>;
  updateKeyActivity: Maybe<UpdateKeyActivityMutationPayload>;
  /** Update a list */
  updateList: Maybe<UpdateListMutationPayload>;
  /** Updates a list view */
  updateListView: Maybe<UpdateListViewMutationPayload>;
  updateMarketingListsConfiguration: Maybe<UpdateMarketingListsConfigurationMutationPayload>;
  /** Updates role permission for marketing list */
  updateMarketingListsRolePermission: Maybe<UpdateMarketingListsRolePermissionMutationPayload>;
  /** update my task */
  updateMyTask: Maybe<UpdateMyTaskMutationPayload>;
  /** Update an existing note */
  updateNote: Maybe<UpdateNoteMutationPayload>;
  updateObjective: Maybe<UpdateObjectiveMutationPayload>;
  /** Allow to update objective management permissions for a role */
  updateObjectiveManagementRolePermission: Maybe<UpdateObjectiveManagementRolePermissionMutationPayload>;
  updateObjectiveProgress: Maybe<UpdateProgressMutationPayload>;
  /** Update company opportunity */
  updateOpportunity: Maybe<OpportunityTrackingUpdateOpportunityMutationPayload>;
  /** Update note on opportunity */
  updateOpportunityNote: Maybe<OpportunityTrackingUpdateOpportunityNoteMutationPayload>;
  /** Updates role permission for opportunity tracking */
  updateOpportunityTrackingRolePermission: Maybe<UpdateOpportunityTrackingRolePermissionMutationPayload>;
  /** Update a page tab name and reorder the tabs */
  updatePageTabs: Maybe<UpdatePageTabsMutationPayload>;
  /** Update saved view filter in a tab */
  updatePageViewTab: Maybe<UpdatePageViewTabMutationPayload>;
  /** Update a persons details */
  updatePerson: Maybe<UpdatePersonMutationPayload>;
  updateProject: Maybe<UpdateProjectMutationPayload>;
  /** update a project document */
  updateProjectDocument: Maybe<UpdateProjectDocumentMutationPayload>;
  updateProjectFolder: Maybe<UpdateProjectFolderMutationPayload>;
  /** Updates role permission for opportunity tracking */
  updateProjectManagementRolePermission: Maybe<UpdateProjectManagementRolePermissionMutationPayload>;
  updateProjectNote: Maybe<UpdateProjectNoteMutationPayload>;
  /** Updates custom fields for a Project Opportunity */
  updateProjectOpportunity: Maybe<UpdateProjectOpportunityMutationPayload>;
  /** Update a project task sections title */
  updateProjectTaskSection: Maybe<UpdateProjectTaskSectionMutationPayload>;
  /** Update project task section positions based on position in array. */
  updateProjectTaskSectionPositions: Maybe<UpdateProjectTaskSectionPositionsMutationPayload>;
  /** Updates role permission for opportunity tracking */
  updateReferralTrackingRolePermission: Maybe<UpdateReferralTrackingRolePermissionMutationPayload>;
  updateReminderSetting: Maybe<UpdateReminderSettingMutationPayload>;
  /** Updates an existing research report. */
  updateResearchReport: Maybe<UpdateReportMutationPayload>;
  /** Updates an existing research report section. */
  updateResearchReportSection: Maybe<UpdateReportSectionMutationPayload>;
  /** Update report section positions based on their order in an array. */
  updateResearchReportSectionPositions: Maybe<UpdateReportSectionPositionsMutationPayload>;
  /** Updates role permission for research reports */
  updateResearchReportsRolePermission: Maybe<UpdateResearchReportsRolePermissionMutationPayload>;
  /** Update Role Information */
  updateRole: Maybe<UpdateRoleMutationPayload>;
  updateSentReferral: Maybe<UpdateSentReferralMutationPayload>;
  /** Update a list of third party ems sync request details */
  updateSyncListRequest: Maybe<UpdateSyncListRequestMutationPayload>;
  updateTableLikeRollupField: Maybe<UpdateTableLikeRollupFieldMutationPayload>;
  updateTableLikeRows: Maybe<UpdateTableLikeRowsMutationPayload>;
  /** Add, remove or replace tags on companies */
  updateTagsOnCompanies: Maybe<UpdateTagsOnCompaniesMutationPayload>;
  /** Add, remove or replace tags on contacts */
  updateTagsOnContacts: Maybe<UpdateTagsOnContactsMutationPayload>;
  /** Update a task */
  updateTask: Maybe<UpdateTaskMutationPayload>;
  /** Update task positions based on position in array. */
  updateTaskPositions: Maybe<UpdateTaskPositionsMutationPayload>;
  updateThemeForForm: Maybe<UpdateThemeForFormMutationPayload>;
  /** Updates a role for a user */
  updateUser: Maybe<UpdateUserMutationPayload>;
  verifyList: Maybe<ExecuteListCleanMutationPayload>;
  /** Verify a prospect */
  verifyProspect: Maybe<VerifyProspectMutationPayload>;
};


export type MutationAddBlockPageToBlockPageListArgs = {
  attributes: BlockPageAttributes;
  blockPageListUid: Scalars['ID']['input'];
};


export type MutationAddClientCompanyForSyncArgs = {
  clientIdentifier: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  groupIdentifier: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
};


export type MutationAddCommentToCommentThreadArgs = {
  commentThreadUid: Scalars['ID']['input'];
  htmlContent: Scalars['String']['input'];
};


export type MutationAddCompanyContactToPersonArgs = {
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyUid: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  personUid: Scalars['ID']['input'];
};


export type MutationAddCompanyDocumentArgs = {
  attributes: CompanyDocumentAttributes;
  companyUid: Scalars['String']['input'];
};


export type MutationAddCompanyListMemberArgs = {
  companyUid: Scalars['ID']['input'];
  customFields?: InputMaybe<Array<CustomFieldAttribute>>;
  listUid: Scalars['ID']['input'];
};


export type MutationAddCompanyTagsArgs = {
  companyUid: Scalars['ID']['input'];
  tags: Scalars['String']['input'];
};


export type MutationAddCompanyToAssociationArgs = {
  associationUuid: Scalars['ID']['input'];
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddCompanyToExclusionListArgs = {
  companyUid: Scalars['ID']['input'];
  excludeEveryCategory: Scalars['Boolean']['input'];
  exclusionListCategories: Array<ListCategory>;
  exclusionType?: InputMaybe<ExclusionType>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCompanyToHierarchyArgs = {
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  parentUuid: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddContactArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  personUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddContactNewCompanySwitchArgs = {
  companyUid: Scalars['ID']['input'];
  contactUid: Scalars['ID']['input'];
  keepBoth?: InputMaybe<Scalars['Boolean']['input']>;
  linkedinUrl: Scalars['String']['input'];
};


export type MutationAddContactPersonalEmailCompanySwitchArgs = {
  contactUid: Scalars['ID']['input'];
  personalEmail: Scalars['String']['input'];
};


export type MutationAddContactToListArgs = {
  contactUid: Scalars['String']['input'];
  customFields?: InputMaybe<Array<CustomFieldAttribute>>;
  listUid: Scalars['ID']['input'];
  upsert: Scalars['Boolean']['input'];
};


export type MutationAddContactUnknownCompanySwitchArgs = {
  contactUid: Scalars['ID']['input'];
  removeFromMarketingList?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddContactWorkEmailCompanySwitchArgs = {
  contactUid: Scalars['ID']['input'];
  keepBoth?: InputMaybe<Scalars['Boolean']['input']>;
  workEmail: Scalars['String']['input'];
};


export type MutationAddContactsToHierarchyArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactEmails: Array<Scalars['String']['input']>;
};


export type MutationAddContactsToListArgs = {
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter>>;
  listUuid: Scalars['ID']['input'];
};


export type MutationAddContactsToListWithTrackerArgs = {
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  destinationListUid: Scalars['ID']['input'];
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter>>;
  ignoreContactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  progressTracker: ProgressTrackerAttributes;
};


export type MutationAddContactsWithCompanyToHierarchyArgs = {
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  contactEmails: Array<Scalars['String']['input']>;
  parentUuid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCustomOptionArgs = {
  options?: InputMaybe<Array<OptionsAttributes>>;
  schemaUuid: Scalars['ID']['input'];
};


export type MutationAddDataTemplatesTemplateFieldsArgs = {
  fields: Array<NewTemplateFieldInput>;
  templateUid: Scalars['ID']['input'];
};


export type MutationAddDuplicateCompaniesToHierarchyArgs = {
  duplicateCompanyUid: Scalars['ID']['input'];
};


export type MutationAddEmailAliasArgs = {
  contactUid: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationAddEmailMarketingCampaignAttachmentArgs = {
  file: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};


export type MutationAddEmailMarketingCampaignRecipientArgs = {
  campaignUid: Scalars['ID']['input'];
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAddFromTableLikeToAnotherArgs = {
  fromFiltering?: InputMaybe<ColumnsFilteringInput>;
  fromMemberColumnUid: Scalars['String']['input'];
  fromSearch?: InputMaybe<Scalars['String']['input']>;
  fromSource: TableLikeSourceInput;
  toSource: TableLikeSourceInput;
  toValues?: InputMaybe<Array<ColumnValueInput>>;
  trackerReturnPath?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddIncludedLawyerArgs = {
  goalUuid: Scalars['ID']['input'];
  lawyerUuid: Scalars['ID']['input'];
};


export type MutationAddInteractionKeyActivityArgs = {
  activityTitle: Scalars['String']['input'];
  category: KeyActivityCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  interactionUid: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddKeyActivityFromOutlookArgs = {
  activityTitle: Scalars['String']['input'];
  category: KeyActivityCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  interactionOn?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  itemId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddKeyActivityToListArgs = {
  keyActivityListUid?: InputMaybe<Scalars['ID']['input']>;
  keyActivityUid?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddListContactsToListArgs = {
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  destinationListUuid: Scalars['ID']['input'];
  filter?: InputMaybe<ListMembersFilter>;
  sourceListUuid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddListContactsToListWithTrackerArgs = {
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  destinationListUid: Scalars['ID']['input'];
  progressTracker: ProgressTrackerAttributes;
  sourceListUid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddMyContactArgs = {
  contactUid: Scalars['String']['input'];
};


export type MutationAddMyContactsToListArgs = {
  filter?: InputMaybe<MyContactsFiltering>;
  listUuid: Scalars['ID']['input'];
};


export type MutationAddMyContactsToListWithTrackerArgs = {
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  destinationListUid: Scalars['ID']['input'];
  filter?: InputMaybe<MyContactsFiltering>;
  progressTracker: ProgressTrackerAttributes;
};


export type MutationAddOpportunityFileArgs = {
  files: Array<Scalars['String']['input']>;
  goalUuid: Scalars['ID']['input'];
};


export type MutationAddOpportunityNoteArgs = {
  content: Scalars['String']['input'];
  opportunityId: Scalars['ID']['input'];
};


export type MutationAddProjectDocumentArgs = {
  attributes: ProjectDocumentAttributes;
  projectUid: Scalars['String']['input'];
};


export type MutationAddProjectMembersArgs = {
  memberEmails: Array<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};


export type MutationAddProjectNoteArgs = {
  attributes: ProjectNoteAttribute;
  uuid: Scalars['ID']['input'];
};


export type MutationAddProjectTaskArgs = {
  attributes: ProjectTaskAttribute;
  uuid: Scalars['ID']['input'];
};


export type MutationAddProjectTaskSectionArgs = {
  projectUid: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationAddTagsToAllContactsWithTrackerArgs = {
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter>>;
  ignoreContactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  progressTracker: ProgressTrackerAttributes;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAddTagsToContactsArgs = {
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUidsString?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsString?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddUserArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  roleUid: Scalars['ID']['input'];
};


export type MutationArchiveCompanyArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationArchiveCompanyListArgs = {
  companyListUid: Scalars['ID']['input'];
};


export type MutationArchiveCompanyNoteArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationArchiveContactArgs = {
  unarchiveOnInteraction?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};


export type MutationArchiveContactListArgs = {
  contactListUid: Scalars['ID']['input'];
};


export type MutationArchiveEmailMarketingCampaignArgs = {
  campaignUid: Scalars['ID']['input'];
};


export type MutationArchiveEmailMarketingTemplateArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationArchiveGenericListArgs = {
  genericListUid: Scalars['ID']['input'];
};


export type MutationArchiveOpportunityArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationArchiveOpportunityNoteArgs = {
  noteId: Scalars['ID']['input'];
};


export type MutationArchivePersonArgs = {
  archiveReason?: InputMaybe<Scalars['String']['input']>;
  personUid: Scalars['ID']['input'];
};


export type MutationArchiveUserArgs = {
  userUid: Scalars['ID']['input'];
};


export type MutationBlockCompanyArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationBlockDomainArgs = {
  value: Scalars['String']['input'];
};


export type MutationBulkAddCompanyListMemberArgs = {
  companyIds: Array<Scalars['ID']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationBulkAddListMemberArgs = {
  contactEmails: Array<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationBulkAddListMemberWithTrackerArgs = {
  contactUids: Array<Scalars['ID']['input']>;
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  destinationListUid: Scalars['ID']['input'];
  progressTracker: ProgressTrackerAttributes;
};


export type MutationBulkAddTagsToContactsWithTrackerArgs = {
  contactUids: Array<Scalars['ID']['input']>;
  progressTracker: ProgressTrackerAttributes;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationBulkArchiveCompaniesArgs = {
  uids: Array<Scalars['ID']['input']>;
};


export type MutationBulkArchiveContactArgs = {
  contactUuids: Array<Scalars['ID']['input']>;
  unarchiveOnInteraction?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBulkArchiveContactWithTrackerArgs = {
  contactUids: Array<Scalars['ID']['input']>;
  progressTracker: ProgressTrackerAttributes;
  unarchiveOnInteraction?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBulkAssociateCompaniesArgs = {
  companyUuids: Array<Scalars['ID']['input']>;
};


export type MutationBulkEditListMemberWithTrackerArgs = {
  customFieldAttributes: Array<CustomFieldAttribute>;
  listUid?: InputMaybe<Scalars['ID']['input']>;
  memberUids: Array<Scalars['ID']['input']>;
  progressTracker: ProgressTrackerAttributes;
};


export type MutationBulkIgnoreIncompleteCompaniesArgs = {
  companyIds: Array<Scalars['ID']['input']>;
};


export type MutationBulkIgnoreIncompleteContactsArgs = {
  uids: Array<Scalars['ID']['input']>;
};


export type MutationBulkMarkAllKeyActivityContactsArgs = {
  activityTitle: Scalars['String']['input'];
  category: KeyActivityCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionOn: Scalars['ISO8601DateTime']['input'];
  internalContacts?: InputMaybe<Array<Scalars['String']['input']>>;
  listId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkMarkKeyActivityArgs = {
  activityTitle: Scalars['String']['input'];
  category: KeyActivityCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  externalContacts: Array<Scalars['String']['input']>;
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionOn: Scalars['ISO8601DateTime']['input'];
  internalContacts?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkMarkKeyActivityWithTrackerArgs = {
  externalContactsUids: Array<Scalars['ID']['input']>;
  internalContactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyActivity: KeyActivityAttributes;
  progressTracker: ProgressTrackerAttributes;
};


export type MutationBulkRemoveCompanyListMemberArgs = {
  companyIds: Array<Scalars['ID']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationBulkRemoveContactListCleanedMembersArgs = {
  contactListUid: Scalars['ID']['input'];
  filter: VerificationFilterInput;
};


export type MutationBulkRemoveContactsFromListWithTrackerArgs = {
  contactUids: Array<Scalars['ID']['input']>;
  listUid: Scalars['ID']['input'];
  progressTracker: ProgressTrackerAttributes;
};


export type MutationBulkRemoveListMemberArgs = {
  listMemberEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  listMemberUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  uid: Scalars['ID']['input'];
};


export type MutationBulkRemoveMyContactArgs = {
  myContactUids: Array<Scalars['ID']['input']>;
};


export type MutationBulkRemoveTagArgs = {
  tagUids: Array<Scalars['ID']['input']>;
};


export type MutationBulkRemoveTagsFromContactsWithTrackerArgs = {
  contactUids: Array<Scalars['ID']['input']>;
  progressTracker: ProgressTrackerAttributes;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationBulkRestoreArchiveContactsArgs = {
  contactUids: Array<Scalars['ID']['input']>;
};


export type MutationBulkRestoreArchivedCompaniesArgs = {
  uids: Array<Scalars['ID']['input']>;
};


export type MutationBulkSetContactConsentWithTrackerArgs = {
  consentAttributes: ContactConsentAttribute;
  contactUids: Array<Scalars['ID']['input']>;
  progressTracker: ProgressTrackerAttributes;
};


export type MutationBulkStayInTouchArgs = {
  frequency: StayInTouchFrequency;
  myContactEmails: Array<Scalars['String']['input']>;
};


export type MutationBulkUpdateCompanyListMemberArgs = {
  companyMemberIds: Array<Scalars['ID']['input']>;
  customFieldAttributes: Array<CustomFieldAttribute>;
  listUid?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBulkUpdateCompanyTypeArgs = {
  companyTypeUid: Scalars['ID']['input'];
  uids: Array<Scalars['ID']['input']>;
};


export type MutationBulkUpdateContactArgs = {
  contactUids: Array<Scalars['ID']['input']>;
  updatableAttributes: BulkUpdateContactAttributes;
};


export type MutationBulkUpdateContactsPrivacyArgs = {
  contactUids: Array<Scalars['ID']['input']>;
  privacyStatus: ContactPrivacy;
  removeFromMyContacts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBulkUpdateContactsReviewRuleValueForContactsArgs = {
  contactUids: Array<Scalars['ID']['input']>;
};


export type MutationBulkUpdateListMemberArgs = {
  customFieldAttributes: Array<CustomFieldAttribute>;
  listUid?: InputMaybe<Scalars['ID']['input']>;
  memberIds: Array<Scalars['ID']['input']>;
};


export type MutationCancelScheduledEmailMarketingCampaignArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationChangeContactCompanyArgs = {
  contactUid: Scalars['String']['input'];
  toCompanyUid: Scalars['String']['input'];
};


export type MutationClassifyDomainArgs = {
  value: Scalars['String']['input'];
};


export type MutationClassifyDomainsArgs = {
  companyUid: Scalars['ID']['input'];
};


export type MutationClassifyEmailArgs = {
  value: Scalars['String']['input'];
};


export type MutationCloneEmailMarketingCampaignArgs = {
  includeProject?: InputMaybe<Scalars['Boolean']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationCloneEmailMarketingTemplateArgs = {
  templateUid: Scalars['ID']['input'];
};


export type MutationCompleteMyTaskArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationCompleteTaskArgs = {
  taskUid: Scalars['ID']['input'];
};


export type MutationConnectListArgs = {
  audienceId: Scalars['String']['input'];
  campaignManagerId?: InputMaybe<Scalars['String']['input']>;
  fieldMappings?: InputMaybe<Array<ConnectedListMappingInput>>;
  listUuid: Scalars['String']['input'];
  nameOnEms?: InputMaybe<Scalars['String']['input']>;
};


export type MutationContactsBulkMarkKeyActivityWithTrackerArgs = {
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter>>;
  ignoreContactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  internalContactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyActivity: KeyActivityAttributes;
  progressTracker: ProgressTrackerAttributes;
};


export type MutationCreateApiDefinitionArgs = {
  apiDefinitionAttributes: ApiDefinitionInput;
  apiSourceTableAttributes: ApiSourceTableInput;
  jsonMappings?: InputMaybe<Array<JsonMappingInput>>;
};


export type MutationCreateBlockPageListTabArgs = {
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};


export type MutationCreateCampaignTabArgs = {
  continuous?: InputMaybe<Scalars['Boolean']['input']>;
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ownedBy?: InputMaybe<OwnedByInput>;
  position: Scalars['Int']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCareerCompanyArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  contactUid: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  jobTitle: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationCreateCommentThreadArgs = {
  attachedToType: CommentThreadAttachable;
  attachedToUid: Scalars['ID']['input'];
  htmlContent: Scalars['String']['input'];
};


export type MutationCreateCompanyArgs = {
  additionalDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<CompanyAttributes>;
  companyDefaultType?: InputMaybe<CompanyTypeDefault>;
  companyTypeUid?: InputMaybe<Scalars['ID']['input']>;
  companyTypesUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  domain: Scalars['String']['input'];
  externalIdentifier?: InputMaybe<ExternalIdentifierInput>;
  secondaryCompanyTypeUids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCreateCompanyContactArgs = {
  companyId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCompanyKeyContactArgs = {
  companyUid: Scalars['String']['input'];
  contactUid: Scalars['String']['input'];
};


export type MutationCreateCompanyListArgs = {
  name: Scalars['String']['input'];
  projectUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCompanyListCustomFieldSchemaArgs = {
  companyListUuid: Scalars['ID']['input'];
  customFieldAttributes: CustomFieldSchemaAttributes;
};


export type MutationCreateCompanyListReminderSettingArgs = {
  companyListUid: Scalars['ID']['input'];
  dateProperty: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  employeeEmails: Array<Scalars['String']['input']>;
  reminderDays: Scalars['Int']['input'];
  timePreposition: ReminderSettingTimePreposition;
};


export type MutationCreateCompanyNoteArgs = {
  access?: InputMaybe<CompanyNoteAccess>;
  companyUid: Scalars['ID']['input'];
  contactUid?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
};


export type MutationCreateCompanyOfficeLocationArgs = {
  companyId: Scalars['ID']['input'];
  headquarterLocation?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  locationAttributes: LocationAttributes;
  primaryLocation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateCompanyOpportunityArgs = {
  attributes: CompanyGoalAttributes;
  companyUid: Scalars['ID']['input'];
  customStatusUid?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCompanyRelationshipPartnerArgs = {
  companyUid: Scalars['String']['input'];
  ownerUid: Scalars['String']['input'];
};


export type MutationCreateContactArgs = {
  attributes?: InputMaybe<ContactAttributes>;
  email: Scalars['String']['input'];
};


export type MutationCreateContactExclusionRuleArgs = {
  attributes: ContactExclusionAttributes;
  exclusionType?: InputMaybe<ExclusionType>;
};


export type MutationCreateContactListReminderSettingArgs = {
  contactListUid: Scalars['ID']['input'];
  dateProperty: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  employeeEmails: Array<Scalars['String']['input']>;
  reminderDays: Scalars['Int']['input'];
  timePreposition: ReminderSettingTimePreposition;
};


export type MutationCreateContactListWebhookArgs = {
  destinationUrl: Scalars['String']['input'];
  externalIdentifier?: InputMaybe<Scalars['ID']['input']>;
  fragmentFields: Scalars['String']['input'];
  listUid: Scalars['String']['input'];
  triggerEvent: WebhookTriggerEvent;
};


export type MutationCreateContactsArgs = {
  emails: Array<Scalars['String']['input']>;
};


export type MutationCreateCustomObjectRecordsArgs = {
  recordsValues: Array<CustomObjectsRecordValueInput>;
};


export type MutationCreateCustomUserRoleArgs = {
  baseLegacyRole: BaseLegacyRole;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateDataTemplatesRecordArgs = {
  fieldValues: Array<CustomObjectsFieldValueInput>;
  templateUid: Scalars['ID']['input'];
};


export type MutationCreateDataTemplatesTemplateArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateEmailMarketingCampaignArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateEmailMarketingTemplateArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateEmailMarketingTemplateSavedRowArgs = {
  content: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateEmbedUrlTabArgs = {
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};


export type MutationCreateEventPackRequestArgs = {
  attributes: EventPackRequestAttribute;
};


export type MutationCreateExportAuditArgs = {
  dataType: ExportDataEnum;
  primaryName: Scalars['String']['input'];
  rowCount: Scalars['Int']['input'];
  secondaryName: Scalars['String']['input'];
};


export type MutationCreateFlatfileWorkbookForAdminImportArgs = {
  importType: FlatFileImportType;
};


export type MutationCreateFlatfileWorkbookForCustomObjectsAdminImportArgs = {
  templateUid: Scalars['ID']['input'];
};


export type MutationCreateFlatfileWorkbookForListImportArgs = {
  importType: FlatFileImportType;
  listUid: Scalars['ID']['input'];
};


export type MutationCreateFormArgs = {
  contactListId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationCreateFormWorkflowArgs = {
  campaignUid?: InputMaybe<Scalars['ID']['input']>;
  conditions?: InputMaybe<Array<WorkflowConditionInput>>;
  formUid: Scalars['ID']['input'];
  listUid?: InputMaybe<Scalars['ID']['input']>;
  taskType: WorkflowTask;
  userUids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateGenericListArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateGenericListCustomFieldSchemaArgs = {
  genericListUid: Scalars['ID']['input'];
  schemaAttributes: CustomFieldSchemaAttributes;
};


export type MutationCreateGenericListItemArgs = {
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  genericListUid: Scalars['ID']['input'];
};


export type MutationCreateGenericListReminderSettingArgs = {
  dateProperty: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  employeeEmails: Array<Scalars['String']['input']>;
  genericListUid: Scalars['ID']['input'];
  reminderDays: Scalars['Int']['input'];
  timePreposition: ReminderSettingTimePreposition;
};


export type MutationCreateGenericListWebhookArgs = {
  destinationUrl: Scalars['String']['input'];
  externalIdentifier?: InputMaybe<Scalars['ID']['input']>;
  fragmentFields: Scalars['String']['input'];
  listUid: Scalars['String']['input'];
  triggerEvent: WebhookTriggerEvent;
};


export type MutationCreateInternalIndustryArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateKeyActivitiesArgs = {
  keyActivityBatchItems: Array<KeyActivityBatchItemInput>;
};


export type MutationCreateKeyActivityListCustomFieldSchemaArgs = {
  customFieldAttributes: CustomFieldSchemaAttributes;
  listUuid: Scalars['ID']['input'];
};


export type MutationCreateKeyActivityListTabArgs = {
  group: Scalars['String']['input'];
  keyActivityListAttributes?: InputMaybe<KeyActivityListAttributes>;
  name: Scalars['String']['input'];
  ownedBy?: InputMaybe<OwnedByInput>;
  position: Scalars['Int']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateLinkedinPostRequestArgs = {
  attributes: LinkedinPostRequestAttribute;
};


export type MutationCreateListArgs = {
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<ListCategory>;
  name: Scalars['String']['input'];
  usageMode: UsageModeInput;
};


export type MutationCreateListCustomFieldSchemaArgs = {
  customFieldAttributes: CustomFieldSchemaAttributes;
  listUuid: Scalars['ID']['input'];
};


export type MutationCreateListViewArgs = {
  attributes: ListViewAttributes;
};


export type MutationCreateMarketingContactListArgs = {
  category?: InputMaybe<ListCategory>;
  name: Scalars['String']['input'];
};


export type MutationCreateMarketingEmailRequestArgs = {
  attributes: MarketingEmailRequestAttribute;
};


export type MutationCreateNoteArgs = {
  access?: InputMaybe<NoteAccess>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentTypeEnum>;
  noteableId?: InputMaybe<Scalars['ID']['input']>;
  noteableType?: InputMaybe<NoteableTypeEnum>;
};


export type MutationCreateObjectiveArgs = {
  attributes: ObjectiveAttribute;
};


export type MutationCreateObjectiveProgressArgs = {
  objectiveUuid: Scalars['ID']['input'];
  progressAttributes: ProgressAttribute;
};


export type MutationCreateOpportunityCustomFieldSchemaArgs = {
  customFieldAttributes: CustomFieldSchemaAttributes;
};


export type MutationCreatePageViewTabArgs = {
  filter: Scalars['JSON']['input'];
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  renderMode?: InputMaybe<TabRenderMode>;
};


export type MutationCreatePersonArgs = {
  emails: Array<Scalars['String']['input']>;
};


export type MutationCreateProjectArgs = {
  attributes: ProjectAttribute;
};


export type MutationCreateProjectFolderArgs = {
  name: Scalars['String']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationCreateProjectFromTemplateArgs = {
  templateProjectId: Scalars['ID']['input'];
};


export type MutationCreateProjectOpportunityArgs = {
  companyUid: Scalars['ID']['input'];
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  customStatusUid?: InputMaybe<Scalars['ID']['input']>;
  opportunityAttributes: CompanyGoalAttributes;
  projectUid: Scalars['ID']['input'];
};


export type MutationCreateProjectOpportunityCustomFieldSchemaArgs = {
  customFieldAttributes: CustomFieldSchemaAttributes;
  projectUid: Scalars['ID']['input'];
};


export type MutationCreateResearchReportArgs = {
  researchReportableId: Scalars['ID']['input'];
  researchReportableType: ResearchReportableTypeEnum;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateResearchReportSectionArgs = {
  attributes: ResearchReportSectionAttributes;
  reportId: Scalars['ID']['input'];
};


export type MutationCreateSentReferralArgs = {
  clientCompanyUid?: InputMaybe<Scalars['ID']['input']>;
  clientContactUid?: InputMaybe<Scalars['ID']['input']>;
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  referredByEmployeeUid: Scalars['ID']['input'];
  resultStatus?: InputMaybe<SentReferralResultStatus>;
  sentAt: Scalars['ISO8601DateTime']['input'];
  sentToContactUid: Scalars['ID']['input'];
  typeOfLegalMatter?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateStaticCompanyListTabArgs = {
  companyListAttributes?: InputMaybe<CompanyListAttributes>;
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ownedBy?: InputMaybe<OwnedByInput>;
  position: Scalars['Int']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  usageMode: CompanyUsageModeInput;
};


export type MutationCreateStaticContactListTabArgs = {
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  contactListAttributes?: InputMaybe<ContactListAttributes>;
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ownedBy?: InputMaybe<OwnedByInput>;
  position: Scalars['Int']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  usageMode: UsageMode;
};


export type MutationCreateStaticGenericListTabArgs = {
  genericListAttributes?: InputMaybe<GenericListAttributes>;
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ownedBy?: InputMaybe<OwnedByInput>;
  position: Scalars['Int']['input'];
};


export type MutationCreateStaticMarketingListTabArgs = {
  group: Scalars['String']['input'];
  marketingListAttributes?: InputMaybe<MarketingListAttributes>;
  name: Scalars['String']['input'];
  ownedBy?: InputMaybe<OwnedByInput>;
  position: Scalars['Int']['input'];
  usageMode: UsageMode;
};


export type MutationCreateTableLikeRollupFieldArgs = {
  input: CreateTableLikeRollupFieldInput;
};


export type MutationCreateTagArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateTaskArgs = {
  assignedToUid?: InputMaybe<Scalars['ID']['input']>;
  attributes: CreateTaskAttributes;
  companyListMemberUid?: InputMaybe<Scalars['ID']['input']>;
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  contactListMemberUid?: InputMaybe<Scalars['ID']['input']>;
  contactUid?: InputMaybe<Scalars['ID']['input']>;
  genericListMemberUid?: InputMaybe<Scalars['ID']['input']>;
  projectTaskSectionUid?: InputMaybe<Scalars['ID']['input']>;
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  requestedByUid?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateTrackEventArgs = {
  event: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationCreateUserDelegateAccessArgs = {
  delegateUserUid: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationCreateWebhookArgs = {
  destinationUrl: Scalars['String']['input'];
  externalIdentifier?: InputMaybe<Scalars['ID']['input']>;
  fragmentFields: Scalars['String']['input'];
  triggerEvent: WebhookTriggerEvent;
};


export type MutationDeleteApiSourceArgs = {
  sourceUid: Scalars['ID']['input'];
};


export type MutationDeleteCareerCompanyArgs = {
  careerCompanyUid: Scalars['ID']['input'];
};


export type MutationDeleteEmailMarketingCampaignAttachmentArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFormWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteListViewArgs = {
  listViewUid: Scalars['ID']['input'];
};


export type MutationDeleteMyTaskArgs = {
  taskUid: Scalars['ID']['input'];
};


export type MutationDeleteResearchReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationDeleteResearchReportSectionArgs = {
  reportSectionId: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  roleUid: Scalars['ID']['input'];
};


export type MutationDeleteSentReferralArgs = {
  sentReferralUid: Scalars['ID']['input'];
};


export type MutationDeleteTableLikeRollupFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTableLikeRowsArgs = {
  filtering?: InputMaybe<ColumnsFilteringInput>;
  returnPath?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  selectedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  source: TableLikeSourceInput;
};


export type MutationDeleteTaskArgs = {
  taskUid: Scalars['ID']['input'];
};


export type MutationDeleteThemeCoverImageForFormArgs = {
  formUid: Scalars['ID']['input'];
};


export type MutationDeleteUserDelegateAccessArgs = {
  delegateUserUid: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationDiscardNoteArgs = {
  noteUid: Scalars['ID']['input'];
};


export type MutationDisconnectConnectedListArgs = {
  connectedListId: Scalars['String']['input'];
};


export type MutationDisconnectListArgs = {
  listUuid: Scalars['String']['input'];
};


export type MutationDismissReminderArgs = {
  reminderUid: Scalars['ID']['input'];
};


export type MutationDownloadEmailMarketingCampaignTemplateArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationExportCompaniesArgs = {
  filter?: InputMaybe<CompanyFiltering>;
};


export type MutationExportContactsArgs = {
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter>>;
};


export type MutationExportEmailMarketingCampaignRecipientsArgs = {
  campaignUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExportIncompleteCompaniesArgs = {
  filter?: InputMaybe<IncompleteCompanyFiltering>;
};


export type MutationExportIncompleteContactsArgs = {
  filter?: InputMaybe<IncompleteContactFiltering>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExportListArgs = {
  filter?: InputMaybe<ExportListFilter>;
  uid: Scalars['ID']['input'];
};


export type MutationExportMyContactsArgs = {
  filter?: InputMaybe<MyContactsFiltering>;
};


export type MutationExportTableLikeRowsArgs = {
  filtering?: InputMaybe<ColumnsFilteringInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  selectedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  source: TableLikeSourceInput;
};


export type MutationExportUnengagedContactsArgs = {
  filter?: InputMaybe<UnengagedContactsFiltering>;
};


export type MutationFindProspectEmailArgs = {
  domain: Scalars['String']['input'];
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  prospectId: Scalars['String']['input'];
};


export type MutationFindProspectsArgs = {
  domain: Scalars['String']['input'];
};


export type MutationFlagDuplicateContactsArgs = {
  duplicateContactUid: Scalars['ID']['input'];
  originalContactUid: Scalars['ID']['input'];
};


export type MutationFlagDuplicatePeopleArgs = {
  duplicatePersonUid: Scalars['ID']['input'];
  originalPersonUid: Scalars['ID']['input'];
};


export type MutationForceEnrichArgs = {
  contactUid: Scalars['ID']['input'];
};


export type MutationGenerateEmailArgs = {
  appendToPrompt?: InputMaybe<Scalars['String']['input']>;
  contactUid: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  style: Array<Scalars['String']['input']>;
};


export type MutationHideContactFromWhoKnowsArgs = {
  contactUid: Scalars['ID']['input'];
};


export type MutationHideEmployeeArgs = {
  andArchiveContact?: InputMaybe<Scalars['Boolean']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationIgnoreContactRequiringPlacementArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationIgnoreIncompleteCompanyArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationIgnoreIncompleteContactArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationImportBusinessCardsArgs = {
  contactListUid?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['String']['input'];
  followupDate?: InputMaybe<Scalars['String']['input']>;
  logKeyActivity?: InputMaybe<Scalars['Boolean']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportFlatfileWorkbookArgs = {
  workbookId: Scalars['ID']['input'];
};


export type MutationInstallEmsConnectorArgs = {
  connection: Scalars['String']['input'];
  connectorType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationLinkProjectsToOpportunityArgs = {
  opportunityUuid: Scalars['ID']['input'];
  projectUuids: Array<Scalars['ID']['input']>;
};


export type MutationListCleanerOverrideContactVerificationArgs = {
  contactUid: Scalars['ID']['input'];
  risk: VerificationRisk;
};


export type MutationListContactsBulkMarkKeyActivityWithTrackerArgs = {
  internalContactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyActivity: KeyActivityAttributes;
  progressTracker: ProgressTrackerAttributes;
  sourceListUid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkContactAsJobNotChangeArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationMarkKeyActivityArgs = {
  activityTitle: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalContacts?: InputMaybe<Array<Scalars['String']['input']>>;
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionOn: Scalars['ISO8601DateTime']['input'];
  internalContacts?: InputMaybe<Array<Scalars['String']['input']>>;
  keyActivityCategory: KeyActivityCategory;
  keyActivityListUid?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sourceReferenceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkUpcomingMeetingAsKeyActivityArgs = {
  activityTitle: Scalars['String']['input'];
  category: KeyActivityCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  upcomingMeetingUid: Scalars['ID']['input'];
};


export type MutationMergeCompanyArgs = {
  currentUid: Scalars['ID']['input'];
  previousUid: Scalars['ID']['input'];
};


export type MutationMergeContactArgs = {
  currentUuid: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  keepBoth?: InputMaybe<Scalars['Boolean']['input']>;
  previousUuid: Scalars['ID']['input'];
};


export type MutationMergePeopleArgs = {
  contactUids: Array<Scalars['String']['input']>;
  currentUid: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationUid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberUids?: InputMaybe<Array<Scalars['String']['input']>>;
  previousUid: Scalars['ID']['input'];
};


export type MutationMoveCompaniesToHierarchyArgs = {
  companyUuids: Array<Scalars['ID']['input']>;
  parentUuid: Scalars['ID']['input'];
};


export type MutationMoveCompanyToHierarchyArgs = {
  companyUuid: Scalars['ID']['input'];
  parentUuid: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMoveContactToPersonArgs = {
  contactUid: Scalars['String']['input'];
  personUid: Scalars['String']['input'];
};


export type MutationMoveOpportunitiesOnMyCustomBoardArgs = {
  opportunities: Array<MoveOpportunityInputCustom>;
};


export type MutationMyContactsBulkMarkKeyActivityWithTrackerArgs = {
  filter?: InputMaybe<MyContactsFiltering>;
  internalContactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyActivity: KeyActivityAttributes;
  progressTracker: ProgressTrackerAttributes;
};


export type MutationPinNoteArgs = {
  noteUid: Scalars['ID']['input'];
};


export type MutationPublishFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPurgeContactArgs = {
  contactUid: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationReAssignOpportunityCompanyArgs = {
  companyUid: Scalars['ID']['input'];
  keyContactIds: Array<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};


export type MutationReSyncClientCompanyArgs = {
  clientIdentifier: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  groupIdentifier: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
};


export type MutationRebuildKeyActivityArgs = {
  activityTitle: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalContacts?: InputMaybe<Array<Scalars['String']['input']>>;
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionOn: Scalars['ISO8601DateTime']['input'];
  internalContacts?: InputMaybe<Array<Scalars['String']['input']>>;
  keyActivityCategory: KeyActivityCategory;
  keyActivityUid: Scalars['ID']['input'];
  noRecreate?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sourceReferenceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegiesterDeviceTokenMagicBellArgs = {
  deviceToken: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterDeviceTokenMagicBellArgs = {
  deviceToken: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveBlockPageArgs = {
  blockPageUid: Scalars['ID']['input'];
};


export type MutationRemoveCommentArgs = {
  commentUid: Scalars['ID']['input'];
};


export type MutationRemoveCompanyDocumentArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationRemoveCompanyFromExclusionListArgs = {
  companyExclusionUid: Scalars['ID']['input'];
};


export type MutationRemoveCompanyFromHierarchyArgs = {
  companyUuid: Scalars['String']['input'];
};


export type MutationRemoveCompanyKeyContactArgs = {
  companyUid: Scalars['String']['input'];
  contactUid: Scalars['String']['input'];
};


export type MutationRemoveCompanyListArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationRemoveCompanyLogoArgs = {
  companyUid: Scalars['String']['input'];
};


export type MutationRemoveCompanyOfficeLocationArgs = {
  companyOfficeLocationId: Scalars['ID']['input'];
};


export type MutationRemoveCompanyRelationshipPartnerArgs = {
  companyUid: Scalars['String']['input'];
  ownerUid: Scalars['String']['input'];
};


export type MutationRemoveContactExclusionRuleArgs = {
  contactExclusionRuleUid: Scalars['ID']['input'];
};


export type MutationRemoveContactFromRequireHierarchyPlacementArgs = {
  contactUid: Scalars['ID']['input'];
};


export type MutationRemoveCustomFieldSchemaArgs = {
  schemaUuid: Scalars['ID']['input'];
};


export type MutationRemoveCustomOptionArgs = {
  optionChoiceUuid: Scalars['ID']['input'];
};


export type MutationRemoveDuplicateCompanyArgs = {
  duplicateUid: Scalars['ID']['input'];
};


export type MutationRemoveDuplicateContactArgs = {
  duplicateUid: Scalars['String']['input'];
};


export type MutationRemoveEmailAddressArgs = {
  value: Scalars['String']['input'];
};


export type MutationRemoveGenericListItemsArgs = {
  uids: Array<Scalars['ID']['input']>;
};


export type MutationRemoveIncludedLawyerArgs = {
  goalUuid: Scalars['ID']['input'];
  lawyerUuid: Scalars['ID']['input'];
};


export type MutationRemoveKeyActivityArgs = {
  keyActivityListUid?: InputMaybe<Scalars['ID']['input']>;
  keyActivityUid: Scalars['ID']['input'];
  removeFromEntities?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveKeyActivityMemberArgs = {
  memberUid: Scalars['ID']['input'];
};


export type MutationRemoveListArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationRemoveMyCompanyArgs = {
  myCompanyUid: Scalars['String']['input'];
};


export type MutationRemoveMyContactArgs = {
  myContactUid: Scalars['String']['input'];
};


export type MutationRemoveMyListShareAccessArgs = {
  listType: MyListList;
  listUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationRemoveObjectiveProgressArgs = {
  progressUuid: Scalars['ID']['input'];
};


export type MutationRemoveOpportunityFileArgs = {
  documentId: Scalars['ID']['input'];
  goalUuid: Scalars['ID']['input'];
};


export type MutationRemovePageTabArgs = {
  uid: Scalars['String']['input'];
};


export type MutationRemoveProjectArgs = {
  projectUuid: Scalars['ID']['input'];
};


export type MutationRemoveProjectDocumentArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationRemoveProjectFolderArgs = {
  folderUuid: Scalars['ID']['input'];
};


export type MutationRemoveProjectMembersArgs = {
  memberEmails: Array<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};


export type MutationRemoveProjectNoteArgs = {
  noteUuid: Scalars['ID']['input'];
};


export type MutationRemoveProjectOpportunityArgs = {
  goalUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};


export type MutationRemoveProjectTaskSectionArgs = {
  projectTaskSectionUid: Scalars['ID']['input'];
};


export type MutationRemoveReminderSettingArgs = {
  reminderSettingUid: Scalars['ID']['input'];
};


export type MutationRemoveTagArgs = {
  tagUid: Scalars['ID']['input'];
};


export type MutationRenameTagArgs = {
  name: Scalars['String']['input'];
  tagUid: Scalars['ID']['input'];
};


export type MutationReopenMyTaskArgs = {
  taskUid: Scalars['ID']['input'];
};


export type MutationReopenTaskArgs = {
  taskUid: Scalars['ID']['input'];
};


export type MutationReorderGenericListItemsArgs = {
  itemUids: Array<Scalars['ID']['input']>;
};


export type MutationReportIncorrectCompanyDataArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  companyUid: Scalars['ID']['input'];
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationReportIncorrectContactDataArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contactUid: Scalars['ID']['input'];
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  reporterUid: Scalars['ID']['input'];
};


export type MutationRestoreArchivedCompanyArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationRestoreBouncedEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationRestoreDiscardedListMembersArgs = {
  listMemberUids: Array<Scalars['ID']['input']>;
  listUid: Scalars['ID']['input'];
};


export type MutationRestoreEmailMarketingTemplateArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationSaveCampaignAsTemplateArgs = {
  templateTitle: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};


export type MutationSaveCampaignRecipientListFilterArgs = {
  input: CampaignRecipientListFilterInput;
};


export type MutationScheduleEmailMarketingCampaignArgs = {
  scheduledAt: Scalars['ISO8601DateTime']['input'];
  scheduledAtTimezone?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationSendEmailMarketingTestEmailArgs = {
  campaignUid: Scalars['ID']['input'];
  recipientEmail: Scalars['String']['input'];
};


export type MutationSetAccountColourArgs = {
  colour: AccountColour;
  uid: Scalars['String']['input'];
};


export type MutationSetCompanyListMemberCustomFieldArgs = {
  customFieldAttributes: Array<CustomFieldAttribute>;
  listMemberUid: Scalars['ID']['input'];
};


export type MutationSetCompanyLogoArgs = {
  companyUid: Scalars['ID']['input'];
  fileSignedId: Scalars['ID']['input'];
};


export type MutationSetInteractionsConfigArgs = {
  minimumInteractionDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetKeyActivityListMemberCustomFieldArgs = {
  customFieldAttributes: Array<CustomFieldAttribute>;
  listMemberUid: Scalars['ID']['input'];
};


export type MutationSetListMemberCustomFieldArgs = {
  customFieldAttributes: Array<CustomFieldAttribute>;
  listMemberUid: Scalars['ID']['input'];
};


export type MutationSetMyTimezoneArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetStayInTouchArgs = {
  frequency: StayInTouchFrequency;
  myContactUid: Scalars['String']['input'];
};


export type MutationSetUiConfigurationArgs = {
  configuration: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetUserRoleArgs = {
  email: Scalars['String']['input'];
  role?: InputMaybe<RoleCode>;
};


export type MutationShareCompanyListArgs = {
  companyListUid: Scalars['ID']['input'];
  permission: MyListPermission;
  sharedWithUids: Array<Scalars['String']['input']>;
};


export type MutationShareContactListArgs = {
  contactListUid: Scalars['ID']['input'];
  permission: MyListPermission;
  sharedWithUids: Array<Scalars['String']['input']>;
};


export type MutationShareGenericListArgs = {
  genericListUid: Scalars['ID']['input'];
  permission: MyListPermission;
  sharedWithUids: Array<Scalars['String']['input']>;
};


export type MutationShareListViewArgs = {
  listUid: Scalars['ID']['input'];
  listViewUid?: InputMaybe<Scalars['ID']['input']>;
  permission: SharedListViewPermission;
  sharedWithUids: Array<Scalars['ID']['input']>;
};


export type MutationShowEmployeeArgs = {
  andActivateContact?: InputMaybe<Scalars['Boolean']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationSwitchAccountArgs = {
  to: Scalars['String']['input'];
};


export type MutationSyncCompanyHierarchyArgs = {
  companyHierarchy: Array<HierarchyInput>;
};


export type MutationSyncConnectedListMembersArgs = {
  connectedListId: Scalars['String']['input'];
  newMappings: Array<ConnectedListMappingInput>;
};


export type MutationSyncEmployeeArgs = {
  aliasEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  department?: InputMaybe<Scalars['String']['input']>;
  externalIdentifier: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  office?: InputMaybe<Scalars['String']['input']>;
  otherEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryEmail: Scalars['String']['input'];
};


export type MutationSyncListActivitiesArgs = {
  listUuid: Scalars['String']['input'];
};


export type MutationSyncListMembersArgs = {
  listUuid: Scalars['String']['input'];
};


export type MutationSyncOutlookContactArgs = {
  contactUid: Scalars['ID']['input'];
};


export type MutationSyncOutlookContactForUserArgs = {
  contactUid: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
};


export type MutationTrackBouncedEmailArgs = {
  bouncedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  sentByEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTrackEmailMessageArgs = {
  conversationIdentifier: Scalars['String']['input'];
  headers?: InputMaybe<Array<EmailHeaderInput>>;
  internetMessageIdentifier: Scalars['String']['input'];
  mailboxEmail?: InputMaybe<Scalars['String']['input']>;
  recipientEmailAddresses: Array<Scalars['String']['input']>;
  senderEmailAddress: Scalars['String']['input'];
  sentAt: Scalars['ISO8601DateTime']['input'];
  webLink?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTrackPastMeetingArgs = {
  attendeeEmailAddresses: Array<Scalars['String']['input']>;
  endsAt: Scalars['ISO8601DateTime']['input'];
  icalUid: Scalars['String']['input'];
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  mailboxEmail?: InputMaybe<Scalars['String']['input']>;
  organizerEmailAddress: Scalars['String']['input'];
  startsAt: Scalars['ISO8601DateTime']['input'];
  webLink?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerApiSourceArgs = {
  sourceUid: Scalars['ID']['input'];
};


export type MutationUnarchiveContactArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationUnblockCompanyArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationUnblockDomainArgs = {
  value: Scalars['String']['input'];
};


export type MutationUnblockEmailArgs = {
  value: Scalars['String']['input'];
};


export type MutationUninstallEmsConnectorArgs = {
  uid: Scalars['String']['input'];
};


export type MutationUnpinNoteArgs = {
  noteUid: Scalars['ID']['input'];
};


export type MutationUpdateBlockPageArgs = {
  iconCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationUpdateBlockPageListPositionsArgs = {
  blockPageListUid?: InputMaybe<Scalars['ID']['input']>;
  pageUpdates: Array<BlockPagePositionAttributes>;
};


export type MutationUpdateCommentArgs = {
  commentUid: Scalars['ID']['input'];
  htmlContent: Scalars['String']['input'];
};


export type MutationUpdateCompanyArgs = {
  attributes?: InputMaybe<CompanyAttributes>;
  companyTypeUid?: InputMaybe<Scalars['ID']['input']>;
  companyTypesUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  externalIdentifier?: InputMaybe<ExternalIdentifierInput>;
  secondaryCompanyTypeUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  uid: Scalars['ID']['input'];
};


export type MutationUpdateCompanyDocumentArgs = {
  attributes: CompanyDocumentAttributes;
  uid: Scalars['String']['input'];
};


export type MutationUpdateCompanyExclusionArgs = {
  companyExclusionUuid: Scalars['ID']['input'];
  excludeEveryCategory?: InputMaybe<Scalars['Boolean']['input']>;
  exclusionListCategories: Array<ListCategory>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCompanyHierarchyArgs = {
  companyUid: Scalars['ID']['input'];
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
};


export type MutationUpdateCompanyListArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationUpdateCompanyNoteArgs = {
  access?: InputMaybe<CompanyNoteAccess>;
  content: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};


export type MutationUpdateCompanyOfficeLocationArgs = {
  companyOfficeLocationId: Scalars['ID']['input'];
  headquarterLocation?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  locationAttributes?: InputMaybe<LocationAttributes>;
  primaryLocation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateConnectedListArgs = {
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  lastSyncAt?: InputMaybe<Scalars['String']['input']>;
  listUid: Scalars['String']['input'];
  nameOnEms?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContactArgs = {
  attributes: ContactAttributes;
  companyName?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailAddresses?: InputMaybe<Array<EmailEntryInput>>;
  officeLocationId?: InputMaybe<Scalars['ID']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationUpdateContactConsentArgs = {
  attributes: ContactConsentAttribute;
  contactUid: Scalars['ID']['input'];
};


export type MutationUpdateContactCustomFieldArgs = {
  contactUid: Scalars['ID']['input'];
  schemaUid: Scalars['ID']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContactEmailsArgs = {
  contactUid: Scalars['ID']['input'];
  emailAddresses: Array<EmailEntryInput>;
};


export type MutationUpdateContactExclusionRuleArgs = {
  attributes: ContactExclusionAttributes;
  contactExclusionRuleUid: Scalars['ID']['input'];
};


export type MutationUpdateContactPrivacyArgs = {
  myContactUid: Scalars['ID']['input'];
  privacyStatus: ContactPrivacy;
};


export type MutationUpdateCoreRolePermissionArgs = {
  accessRoleUid: Scalars['ID']['input'];
  allCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  allContacts?: InputMaybe<Scalars['Boolean']['input']>;
  exportAllCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  exportAllContacts?: InputMaybe<Scalars['Boolean']['input']>;
  exportMyCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  exportMyContacts?: InputMaybe<Scalars['Boolean']['input']>;
  viewEmployeeEngagementTab?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateCustomFieldSchemaArgs = {
  name: Scalars['String']['input'];
  schemaId: Scalars['ID']['input'];
};


export type MutationUpdateCustomFieldSchemaPositionsArgs = {
  customSchemasPositions: Array<CustomFieldSchemaPosition>;
};


export type MutationUpdateCustomFieldSchemaValuesArgs = {
  schemaAttributes: CustomFieldSchemaInputAttributes;
};


export type MutationUpdateCustomOptionArgs = {
  optionChoiceUuid: Scalars['ID']['input'];
  optionColour: AccountColour;
  optionValue: Scalars['String']['input'];
};


export type MutationUpdateEmailMarketingCampaignArgs = {
  allowContinuousResend?: InputMaybe<Scalars['Boolean']['input']>;
  clickTracking?: InputMaybe<Scalars['Boolean']['input']>;
  continuous?: InputMaybe<Scalars['Boolean']['input']>;
  openTracking?: InputMaybe<Scalars['Boolean']['input']>;
  recipientListId?: InputMaybe<Scalars['ID']['input']>;
  senderId?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  templateJson?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationUpdateEmailMarketingTemplateArgs = {
  templateJson?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationUpdateEnrichmentRolePermissionArgs = {
  accessRoleUid: Scalars['ID']['input'];
  allProspects?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateFormArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateFormConfirmationSettingsArgs = {
  confirmationPageSettings: ConfirmationPageSettingsInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFormExpiryArgs = {
  date?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  enabled: Scalars['Boolean']['input'];
  formUid: Scalars['ID']['input'];
  pageDescription?: InputMaybe<Scalars['String']['input']>;
  pageHeader?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFormInfoArgs = {
  confirmationPageSettings?: InputMaybe<ConfirmationPageSettingsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  elements?: InputMaybe<Array<FormElementInput>>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFormKeyActivitySettingsArgs = {
  id: Scalars['ID']['input'];
  keyActivitySettings: KeyActivitySettingsInput;
};


export type MutationUpdateFormSettingsArgs = {
  disableRecaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  includeDefaultFooter?: InputMaybe<Scalars['Boolean']['input']>;
  setConsentToGiven: Scalars['Boolean']['input'];
};


export type MutationUpdateFormWaitlistArgs = {
  condition?: InputMaybe<WaitlistConditionInput>;
  enabled: Scalars['Boolean']['input'];
  formId: Scalars['ID']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFormWorkflowArgs = {
  campaignUid?: InputMaybe<Scalars['ID']['input']>;
  conditions?: InputMaybe<Array<WorkflowConditionInput>>;
  id: Scalars['ID']['input'];
  listUid?: InputMaybe<Scalars['ID']['input']>;
  userUids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateGenericListArgs = {
  genericListUid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateGenericListItemsArgs = {
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  uids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateIndustryMappingArgs = {
  companyIndustryNameUuids: Array<Scalars['String']['input']>;
  internalIndustryUuids: Array<Scalars['String']['input']>;
};


export type MutationUpdateInteractionsRolePermissionArgs = {
  accessRoleUid: Scalars['ID']['input'];
  exportAllActivities?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateKeyActivityArgs = {
  activityTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  keyActivityUid: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateListArgs = {
  category?: InputMaybe<ListCategory>;
  name?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationUpdateListViewArgs = {
  attributes: ListViewAttributes;
  listViewUid: Scalars['String']['input'];
};


export type MutationUpdateMarketingListsConfigurationArgs = {
  allowArchived?: InputMaybe<Scalars['Boolean']['input']>;
  allowUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateMarketingListsRolePermissionArgs = {
  accessRoleUid: Scalars['ID']['input'];
  exportMarketingLists?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateMyTaskArgs = {
  assigneeUid?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueOn?: InputMaybe<Scalars['String']['input']>;
  taskUid: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateNoteArgs = {
  access?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentTypeEnum>;
  noteUid: Scalars['ID']['input'];
  noteableId?: InputMaybe<Scalars['ID']['input']>;
  noteableType?: InputMaybe<NoteableTypeEnum>;
};


export type MutationUpdateObjectiveArgs = {
  attributes: ObjectiveAttribute;
  objectiveUuid: Scalars['ID']['input'];
};


export type MutationUpdateObjectiveManagementRolePermissionArgs = {
  accessRoleUid: Scalars['ID']['input'];
  allObjectives?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateObjectiveProgressArgs = {
  progressAttributes: ProgressAttribute;
  progressUuid: Scalars['ID']['input'];
};


export type MutationUpdateOpportunityArgs = {
  attributes?: InputMaybe<CompanyGoalAttributes>;
  customStatusUid?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};


export type MutationUpdateOpportunityNoteArgs = {
  content: Scalars['String']['input'];
  noteId: Scalars['ID']['input'];
};


export type MutationUpdateOpportunityTrackingRolePermissionArgs = {
  accessRoleUid: Scalars['ID']['input'];
  allOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  exportAllOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  viewEmployeeOpportunitiesTab?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdatePageTabsArgs = {
  pageTabs: Array<TabInput>;
};


export type MutationUpdatePageViewTabArgs = {
  filter: Scalars['JSON']['input'];
  uid: Scalars['ID']['input'];
};


export type MutationUpdatePersonArgs = {
  educations?: InputMaybe<Array<EducationAttributes>>;
  externalImageUrl?: InputMaybe<Scalars['Url']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationAttributes>;
  personUid: Scalars['ID']['input'];
  phoneNumbers?: InputMaybe<Array<PhoneNumberAttributes>>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  twitterUrl?: InputMaybe<Scalars['Url']['input']>;
};


export type MutationUpdateProjectArgs = {
  attributes: ProjectAttribute;
  uuid: Scalars['ID']['input'];
};


export type MutationUpdateProjectDocumentArgs = {
  attributes: ProjectDocumentAttributes;
  uid: Scalars['String']['input'];
};


export type MutationUpdateProjectFolderArgs = {
  folderUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateProjectManagementRolePermissionArgs = {
  accessRoleUid: Scalars['ID']['input'];
  exportCompanyLists?: InputMaybe<Scalars['Boolean']['input']>;
  exportContactLists?: InputMaybe<Scalars['Boolean']['input']>;
  exportGenericLists?: InputMaybe<Scalars['Boolean']['input']>;
  exportKeyActivityLists?: InputMaybe<Scalars['Boolean']['input']>;
  exportOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateProjectNoteArgs = {
  attributes: ProjectNoteAttribute;
  noteUuid: Scalars['ID']['input'];
};


export type MutationUpdateProjectOpportunityArgs = {
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  customStatusUid?: InputMaybe<Scalars['ID']['input']>;
  opportunityAttributes?: InputMaybe<CompanyGoalAttributes>;
  projectOpportunityUid: Scalars['ID']['input'];
};


export type MutationUpdateProjectTaskSectionArgs = {
  projectTaskSectionUid: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateProjectTaskSectionPositionsArgs = {
  projectTaskSectionUids: Array<Scalars['ID']['input']>;
  projectUid: Scalars['ID']['input'];
};


export type MutationUpdateReferralTrackingRolePermissionArgs = {
  accessRoleUid: Scalars['ID']['input'];
  exportReferrals?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateReminderSettingArgs = {
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  employeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderDays?: InputMaybe<Scalars['Int']['input']>;
  reminderSettingUid: Scalars['ID']['input'];
  timePreposition?: InputMaybe<ReminderSettingTimePreposition>;
};


export type MutationUpdateResearchReportArgs = {
  reportId: Scalars['ID']['input'];
  status?: InputMaybe<ResearchReportStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateResearchReportSectionArgs = {
  attributes: ResearchReportSectionAttributes;
  reportSectionId: Scalars['ID']['input'];
};


export type MutationUpdateResearchReportSectionPositionsArgs = {
  reportSectionUids: Array<Scalars['ID']['input']>;
  reportUid: Scalars['ID']['input'];
};


export type MutationUpdateResearchReportsRolePermissionArgs = {
  accessRoleUid: Scalars['ID']['input'];
  editCompanyReport?: InputMaybe<Scalars['Boolean']['input']>;
  readCompanyReport?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateRoleArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleUid: Scalars['ID']['input'];
};


export type MutationUpdateSentReferralArgs = {
  clientContactUid?: InputMaybe<Scalars['ID']['input']>;
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute>>;
  referredByEmployeeUid?: InputMaybe<Scalars['ID']['input']>;
  resultStatus?: InputMaybe<SentReferralResultStatus>;
  sentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sentReferralUid: Scalars['ID']['input'];
  typeOfLegalMatter?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSyncListRequestArgs = {
  completedAt?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationUpdateTableLikeRollupFieldArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateTableLikeRowsArgs = {
  filtering?: InputMaybe<ColumnsFilteringInput>;
  returnPath?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  selectedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  source: TableLikeSourceInput;
  values: Array<ColumnValueInput>;
};


export type MutationUpdateTagsOnCompaniesArgs = {
  add?: InputMaybe<Scalars['String']['input']>;
  companyUid: Scalars['ID']['input'];
  remove?: InputMaybe<Scalars['String']['input']>;
  replace?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTagsOnContactsArgs = {
  add?: InputMaybe<Scalars['String']['input']>;
  contactUid: Scalars['ID']['input'];
  remove?: InputMaybe<Scalars['String']['input']>;
  replace?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTaskArgs = {
  assignedToUid?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueOn?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<PriorityEnum>;
  requestedByUid?: InputMaybe<Scalars['ID']['input']>;
  taskUid: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTaskPositionsArgs = {
  projectTaskSectionUid: Scalars['ID']['input'];
  projectUid: Scalars['ID']['input'];
  taskUids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateThemeForFormArgs = {
  formUid: Scalars['ID']['input'];
  settings: FormThemeSettingsInput;
};


export type MutationUpdateUserArgs = {
  roleUid: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationVerifyListArgs = {
  contactListUid: Scalars['ID']['input'];
};


export type MutationVerifyProspectArgs = {
  uid: Scalars['ID']['input'];
};

export type MyActivityList = {
  __typename?: 'MyActivityList';
  entries: Array<MyInteraction>;
  pageInfo: PagingInfo;
};

/** Autogenerated return type of MyAddCampaignAttachmentMutation. */
export type MyAddCampaignAttachmentMutationPayload = {
  __typename?: 'MyAddCampaignAttachmentMutationPayload';
  campaign: Maybe<Campaign>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MyAddContactMutation. */
export type MyAddContactMutationPayload = {
  __typename?: 'MyAddContactMutationPayload';
  contactId: Maybe<Scalars['ID']['output']>;
  failReasons: Array<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

export type MyAllContactUpdateEvents = {
  __typename?: 'MyAllContactUpdateEvents';
  entries: Array<ContactUpdateEvent>;
  pageInfo: PagingInfo;
};

/** Autogenerated return type of MyBulkRemoveContactMutation. */
export type MyBulkRemoveContactMutationPayload = {
  __typename?: 'MyBulkRemoveContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MyBulkStayInTouchMutation. */
export type MyBulkStayInTouchMutationPayload = {
  __typename?: 'MyBulkStayInTouchMutationPayload';
  contactsAddedToMyContact: Maybe<Scalars['Int']['output']>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MyBulkUpdateContactsPrivacyMutation. */
export type MyBulkUpdateContactsPrivacyMutationPayload = {
  __typename?: 'MyBulkUpdateContactsPrivacyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Filtering Options for companies */
export type MyCompaniesFiltering = {
  companyTypeUid?: InputMaybe<Scalars['ID']['input']>;
  properties?: InputMaybe<Array<CompanyFilter>>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export enum MyCompaniesOrderBy {
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  LastInteractionAsc = 'LAST_INTERACTION_ASC',
  LastInteractionDesc = 'LAST_INTERACTION_DESC',
  TotalInteractionAsc = 'TOTAL_INTERACTION_ASC',
  TotalInteractionDesc = 'TOTAL_INTERACTION_DESC'
}

export type MyCompany = {
  __typename?: 'MyCompany';
  company: Company;
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interactionMaximum: Maybe<InteractionMaximum>;
  monthlyEngagement: Array<CompanyMonthlyInteractionDist>;
  openOpportunityCount: Scalars['Int']['output'];
  pendingTaskCount: Scalars['Int']['output'];
  upcomingMeetingCount: Scalars['Int']['output'];
};

export type MyCompanyList = {
  __typename?: 'MyCompanyList';
  entries: Array<MyCompany>;
  pageInfo: PagingInfo;
};

export type MyContact = {
  __typename?: 'MyContact';
  archived: Scalars['Boolean']['output'];
  classified: Scalars['Boolean']['output'];
  contact: Contact;
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interactionMaximum: Maybe<InteractionMaximum>;
  stayInTouch: Maybe<MyStayInTouch>;
};

export type MyContactList = {
  __typename?: 'MyContactList';
  entries: Array<MyContact>;
  pageInfo: PagingInfo;
};

/** Autogenerated return type of MyContactsBulkMarkKeyActivityWithTrackerMutation. */
export type MyContactsBulkMarkKeyActivityWithTrackerMutationPayload = {
  __typename?: 'MyContactsBulkMarkKeyActivityWithTrackerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Filtering Options for contacts */
export type MyContactsFiltering = {
  /** Company UID */
  belongToCompanyHierarchy?: InputMaybe<Scalars['ID']['input']>;
  companyTypeUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  consentStatuses?: InputMaybe<Array<ContactConsentStatus>>;
  excludeClassified?: InputMaybe<Scalars['Boolean']['input']>;
  properties?: InputMaybe<Array<ContactFilter>>;
  term?: InputMaybe<Scalars['String']['input']>;
  withCustomField?: InputMaybe<Array<CustomFieldTerm>>;
};

export enum MyContactsOrderBy {
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  LastInteractionAsc = 'LAST_INTERACTION_ASC',
  LastInteractionDesc = 'LAST_INTERACTION_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  TotalInteractionAsc = 'TOTAL_INTERACTION_ASC',
  TotalInteractionDesc = 'TOTAL_INTERACTION_DESC'
}

/** Autogenerated return type of MyDeleteCampaignAttachmentMutation. */
export type MyDeleteCampaignAttachmentMutationPayload = {
  __typename?: 'MyDeleteCampaignAttachmentMutationPayload';
  campaign: Maybe<Campaign>;
  failReasons: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of MyExportContactsMutation. */
export type MyExportContactsMutationPayload = {
  __typename?: 'MyExportContactsMutationPayload';
  export: Maybe<Export>;
  failReasons: Array<Scalars['String']['output']>;
};

export type MyInteraction = {
  __typename?: 'MyInteraction';
  id: Scalars['ID']['output'];
  interaction: Interaction;
};

export type MyKeyActivityPerformance = {
  __typename?: 'MyKeyActivityPerformance';
  currentConsecutiveWeeks: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  longestConsecutiveWeeksStreak: Scalars['Int']['output'];
  monthBestTotal: Scalars['Int']['output'];
  monthChallengeTotal: Scalars['Int']['output'];
  monthCurrentTotal: Scalars['Int']['output'];
};

export type MyList = {
  __typename?: 'MyList';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lastViewedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  listType: MyListList;
  locationInfo: MyListLocationInfo;
  name: Scalars['String']['output'];
  owner: Maybe<User>;
  permission: MyListPermission;
};

export type MyListEntries = {
  __typename?: 'MyListEntries';
  entries: Array<MyList>;
};

export enum MyListList {
  CompanyList = 'COMPANY_LIST',
  ContactList = 'CONTACT_LIST',
  GenericList = 'GENERIC_LIST'
}

export enum MyListLocation {
  App = 'APP',
  Company = 'COMPANY',
  FirmWide = 'FIRM_WIDE',
  Marketing = 'MARKETING',
  Personal = 'PERSONAL',
  Standalone = 'STANDALONE',
  Workspace = 'WORKSPACE'
}

export type MyListLocationInfo = {
  __typename?: 'MyListLocationInfo';
  displayName: Scalars['String']['output'];
  /** @deprecated Use locationTyped instead. */
  location: Scalars['String']['output'];
  locationTyped: MyListLocation;
  /** Deprecated: use tab_owned_by_uid */
  projectUid: Maybe<Scalars['String']['output']>;
  tabOwnedByUid: Maybe<Scalars['String']['output']>;
  tabUid: Maybe<Scalars['String']['output']>;
};

export enum MyListPermission {
  Manage = 'MANAGE',
  ReadOnly = 'READ_ONLY',
  ReadWrite = 'READ_WRITE'
}

export enum MyListScope {
  All = 'ALL',
  App = 'APP',
  Created = 'CREATED',
  FirmWide = 'FIRM_WIDE',
  Marketing = 'MARKETING',
  Shared = 'SHARED',
  Workspace = 'WORKSPACE'
}

/** Union type for different list types: List, CompanyList, and GenericList */
export type MyListUnion = CompanyListItem | GenericList | List;

/** Autogenerated return type of MyRemoveCompanyMutation. */
export type MyRemoveCompanyMutationPayload = {
  __typename?: 'MyRemoveCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MyRemoveContactMutation. */
export type MyRemoveContactMutationPayload = {
  __typename?: 'MyRemoveContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of MySetStayInTouchMutation. */
export type MySetStayInTouchMutationPayload = {
  __typename?: 'MySetStayInTouchMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type MySharedList = {
  __typename?: 'MySharedList';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  list: MyListUnion;
  name: Scalars['String']['output'];
  permission: MyListPermission;
};

export type MyStayInTouch = {
  __typename?: 'MyStayInTouch';
  contact: MyContact;
  frequency: StayInTouchFrequency;
  id: Scalars['ID']['output'];
  interactionDueDate: Scalars['ISO8601Date']['output'];
  overDue: Scalars['Boolean']['output'];
};

export type MyStayInTouchList = {
  __typename?: 'MyStayInTouchList';
  entries: Array<MyStayInTouch>;
  pageInfo: PagingInfo;
};

export type MyTask = {
  __typename?: 'MyTask';
  assignees: Array<Employee>;
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<RichContent>;
  dueOn: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  requestor: Maybe<Employee>;
  source: MyTaskSource;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MyTaskEntries = {
  __typename?: 'MyTaskEntries';
  entries: Array<MyTask>;
  id: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export enum MyTaskScope {
  DelegatedTasks = 'DELEGATED_TASKS',
  MyTasks = 'MY_TASKS'
}

export type MyTaskSource = {
  __typename?: 'MyTaskSource';
  id: Scalars['ID']['output'];
  imgUrl: Maybe<Scalars['String']['output']>;
  isKeyContact: Scalars['Boolean']['output'];
  subTitle: Scalars['ContactEmailScalar']['output'];
  title: Scalars['ContactEmailScalar']['output'];
  url: Maybe<Scalars['Url']['output']>;
};

export enum MyTaskStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/** Autogenerated return type of MyUpdateContactPrivacyMutation. */
export type MyUpdateContactPrivacyMutationPayload = {
  __typename?: 'MyUpdateContactPrivacyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type NewContact = {
  __typename?: 'NewContact';
  contactFirstName: Scalars['String']['output'];
  contactFullName: Scalars['String']['output'];
  myContact: MyContact;
  setStayInTouchUrl: Scalars['Url']['output'];
};

export type NewContacts = {
  __typename?: 'NewContacts';
  amount: Scalars['Int']['output'];
  entries: Array<NewContact>;
  viewAllUrl: Scalars['Url']['output'];
};

export type NewTemplateFieldInput = {
  currency?: InputMaybe<CurrencyCode>;
  fieldType: TemplateFieldType;
  multiple: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Note = {
  __typename?: 'Note';
  access: NoteAccess;
  content: Scalars['String']['output'];
  contentType: ContentTypeEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use creatorCard instead for public user information */
  creator: User;
  creatorCard: UserCard;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  noteables: Array<NoteableUnion>;
  pinnedByCurrentUser: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Manages access and visibility for notes */
export enum NoteAccess {
  Firmwide = 'FIRMWIDE',
  Personal = 'PERSONAL'
}

export type NoteFilterInput = {
  /** Filter to notes created by the current user */
  myNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by noteables (AND logic) */
  noteables?: InputMaybe<Array<NoteableInput>>;
  /** Filter to private notes only (personal access) */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search in note content */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type NoteList = {
  __typename?: 'NoteList';
  entries: Array<Note>;
  pageInfo: PagingInfo;
};

export type NoteableInput = {
  /** ID of the noteable */
  id: Scalars['ID']['input'];
  /** Type of the noteable (e.g., TenantContact, TenantCompany) */
  type: Scalars['String']['input'];
};

/** Type of object that a note can be attached to */
export enum NoteableTypeEnum {
  TenantCompany = 'TENANT_COMPANY',
  TenantContact = 'TENANT_CONTACT'
}

/** Objects that can have notes attached */
export type NoteableUnion = Company | Contact;

export type NullCell = {
  __typename?: 'NullCell';
  isNull: Scalars['Boolean']['output'];
  objectClass: Scalars['String']['output'];
};

export type Objective = {
  __typename?: 'Objective';
  appendValueType: Scalars['Boolean']['output'];
  archive: Scalars['Boolean']['output'];
  createdBy: User;
  currentProgress: Progress;
  description: Maybe<RichContent>;
  id: Scalars['ID']['output'];
  initialValue: Maybe<Scalars['Int']['output']>;
  objectiveProgresses: Array<Progress>;
  owners: Array<Employee>;
  projects: Array<Project>;
  targetDate: Scalars['ISO8601Date']['output'];
  targetValue: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  valueType: Scalars['String']['output'];
};

export type ObjectiveAttribute = {
  appendValueType?: InputMaybe<Scalars['Boolean']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  initialValue?: InputMaybe<Scalars['Int']['input']>;
  objectiveOwnersAttributes?: InputMaybe<Array<ObjectiveOwnerAttribute>>;
  objectiveProjectsAttributes?: InputMaybe<Array<ObjectiveProjectAttribute>>;
  targetDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  targetValue?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export enum ObjectiveGroupBy {
  Department = 'DEPARTMENT',
  Office = 'OFFICE',
  Owner = 'OWNER'
}

export type ObjectiveList = {
  __typename?: 'ObjectiveList';
  entries: Array<Objective>;
  pageInfo: PagingInfo;
};

/** Objective Management Permissions */
export type ObjectiveManagementPermission = {
  __typename?: 'ObjectiveManagementPermission';
  allObjectives: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  viewMyObjectives: Scalars['Boolean']['output'];
};

export type ObjectiveOwnerAttribute = {
  ownerId: Scalars['ID']['input'];
};

export type ObjectiveProjectAttribute = {
  projectId: Scalars['ID']['input'];
};

export enum ObjectiveStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type Office = {
  __typename?: 'Office';
  employees: Array<Employee>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type OfficeEmployeesArgs = {
  limit: Scalars['Int']['input'];
};

export type OfficeLabelsList = {
  __typename?: 'OfficeLabelsList';
  entries: Array<Scalars['String']['output']>;
};

export type OfficeList = {
  __typename?: 'OfficeList';
  entries: Array<Office>;
  pageInfo: PagingInfo;
};

export type OpenOpportunities = {
  __typename?: 'OpenOpportunities';
  entries: Array<OpenOpportunity>;
  url: Scalars['Url']['output'];
};

export type OpenOpportunity = {
  __typename?: 'OpenOpportunity';
  createdOn: Scalars['String']['output'];
  lastInteractionOn: Maybe<Scalars['String']['output']>;
  opportunity: CompanyGoal;
  url: Scalars['Url']['output'];
};


export type OpenOpportunityCreatedOnArgs = {
  format: Scalars['String']['input'];
};


export type OpenOpportunityLastInteractionOnArgs = {
  format: Scalars['String']['input'];
};

export enum OperationTypeEnum {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

/** Opportunity information */
export type Opportunity = {
  __typename?: 'Opportunity';
  archived: Scalars['Boolean']['output'];
  assignedTo: Maybe<Employee>;
  company: Company;
  contactLast: Maybe<LastAts>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Maybe<User>;
  customFields: Array<CustomField>;
  customStatus: Maybe<OpportunityTrackingCustomStatus>;
  date: Maybe<Scalars['ISO8601Date']['output']>;
  description: Maybe<RichContent>;
  documents: Array<GoalDocument>;
  emailBody: Maybe<RichContent>;
  id: Scalars['ID']['output'];
  includedLawyers: Array<Employee>;
  keyContacts: Maybe<Array<Contact>>;
  outcome: GoalOutcome;
  project: Maybe<Project>;
  proposedFee: Maybe<Scalars['Float']['output']>;
  proposedFeeAmount: Maybe<Money>;
  receivedReferral: Scalars['Boolean']['output'];
  referralSource: Maybe<Contact>;
  tags: Array<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OpportunityAudit = {
  __typename?: 'OpportunityAudit';
  action: AuditAction;
  auditedEntity: AuditEntity;
  category: OpportunityAuditCategory;
  changes: Array<AuditChange>;
  description: Scalars['String']['output'];
  performedAt: Scalars['ISO8601DateTime']['output'];
  performedBy: Maybe<Scalars['String']['output']>;
  performer: Maybe<User>;
};

export enum OpportunityAuditCategory {
  FileUploaded = 'FILE_UPLOADED',
  NoteArchived = 'NOTE_ARCHIVED',
  NoteCreated = 'NOTE_CREATED',
  NoteUpdated = 'NOTE_UPDATED',
  OpportunityActivity = 'OPPORTUNITY_ACTIVITY',
  OpportunityCreated = 'OPPORTUNITY_CREATED'
}

export type OpportunityAuditTrail = {
  __typename?: 'OpportunityAuditTrail';
  entries: Array<OpportunityAudit>;
};

export type OpportunityGrid = {
  __typename?: 'OpportunityGrid';
  assignedTo: Maybe<EmployeeGrid>;
  commsLast: Maybe<LastAts>;
  company: CompanyGrid;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Maybe<UserGrid>;
  customFields: Array<CustomFieldGrid>;
  customStatus: Maybe<OpportunityTrackingCustomStatus>;
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  keyContacts: Array<ContactGrid>;
  othersIncluded: Array<EmployeeGrid>;
  proposedFeeAmount: Maybe<Money>;
  referralSource: Maybe<ContactGrid>;
  tags: Array<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OpportunityGridTypeList = {
  __typename?: 'OpportunityGridTypeList';
  entries: Array<OpportunityGrid>;
  pageInfo: PagingInfo;
};

export type OpportunityNote = {
  __typename?: 'OpportunityNote';
  content: RichContent;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OpportunityNoteEntries = {
  __typename?: 'OpportunityNoteEntries';
  entries: Array<OpportunityNote>;
  pageInfo: Maybe<PagingInfo>;
};

export type OpportunityProjectEntries = {
  __typename?: 'OpportunityProjectEntries';
  entries: Array<Project>;
};

export type OpportunityStat = {
  __typename?: 'OpportunityStat';
  totalOpenCount: Scalars['Int']['output'];
  totalPercentageWon: Scalars['Float']['output'];
  totalProposalFee: Scalars['Float']['output'];
  totalWonCount: Scalars['Int']['output'];
  totalWonProposalFee: Maybe<Scalars['Float']['output']>;
};

/** Opportunity status change information */
export type OpportunityStatusChange = {
  __typename?: 'OpportunityStatusChange';
  createdAt: Scalars['ID']['output'];
  fromStatus: Maybe<OpportunityTrackingCustomStatus>;
  id: Scalars['ID']['output'];
  opportunity: Opportunity;
  toStatus: Maybe<OpportunityTrackingCustomStatus>;
};

/** Options for filtering by time */
export type OpportunityTimeFilter = {
  position: TimeFilterPosition;
  property: OpportunityTimeFilterProperty;
  value: Scalars['ISO8601DateTime']['input'];
};

export enum OpportunityTimeFilterProperty {
  Created = 'CREATED',
  Updated = 'UPDATED'
}

/** Autogenerated return type of OpportunityTrackingAddGoalFileMutation. */
export type OpportunityTrackingAddGoalFileMutationPayload = {
  __typename?: 'OpportunityTrackingAddGoalFileMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of OpportunityTrackingAddIncludedLawyerMutation. */
export type OpportunityTrackingAddIncludedLawyerMutationPayload = {
  __typename?: 'OpportunityTrackingAddIncludedLawyerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of OpportunityTrackingAddOpportunityNoteMutation. */
export type OpportunityTrackingAddOpportunityNoteMutationPayload = {
  __typename?: 'OpportunityTrackingAddOpportunityNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  note: Maybe<OpportunityNote>;
};

/** Autogenerated return type of OpportunityTrackingArchiveGoalMutation. */
export type OpportunityTrackingArchiveGoalMutationPayload = {
  __typename?: 'OpportunityTrackingArchiveGoalMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of OpportunityTrackingArchiveOpportunityNoteMutation. */
export type OpportunityTrackingArchiveOpportunityNoteMutationPayload = {
  __typename?: 'OpportunityTrackingArchiveOpportunityNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type OpportunityTrackingConfiguration = {
  __typename?: 'OpportunityTrackingConfiguration';
  customStatuses: Array<OpportunityTrackingCustomStatus>;
  id: Scalars['ID']['output'];
  visibleFirmWide: Scalars['Boolean']['output'];
};

/** Autogenerated return type of OpportunityTrackingCreateOpportunityCustomFieldSchemaMutation. */
export type OpportunityTrackingCreateOpportunityCustomFieldSchemaMutationPayload = {
  __typename?: 'OpportunityTrackingCreateOpportunityCustomFieldSchemaMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of OpportunityTrackingCreateOpportunityMutation. */
export type OpportunityTrackingCreateOpportunityMutationPayload = {
  __typename?: 'OpportunityTrackingCreateOpportunityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  gridRecord: Maybe<OpportunityGrid>;
  record: Maybe<CompanyGoal>;
  uid: Maybe<Scalars['ID']['output']>;
};

export type OpportunityTrackingCustomStatus = {
  __typename?: 'OpportunityTrackingCustomStatus';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  startingStatus: Scalars['Boolean']['output'];
};

/** Autogenerated return type of OpportunityTrackingMoveOpportunitiesOnMyCustomBoardMutation. */
export type OpportunityTrackingMoveOpportunitiesOnMyCustomBoardMutationPayload = {
  __typename?: 'OpportunityTrackingMoveOpportunitiesOnMyCustomBoardMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Opportunity Tracking Permission */
export type OpportunityTrackingPermission = {
  __typename?: 'OpportunityTrackingPermission';
  allOpportunities: Scalars['Boolean']['output'];
  exportAllOpportunities: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  viewEmployeeOpportunitiesTab: Scalars['Boolean']['output'];
  viewMyOpportunities: Scalars['Boolean']['output'];
};

/** Autogenerated return type of OpportunityTrackingReAssignOpportunityCompanyMutation. */
export type OpportunityTrackingReAssignOpportunityCompanyMutationPayload = {
  __typename?: 'OpportunityTrackingReAssignOpportunityCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CompanyGoal>;
};

/** Autogenerated return type of OpportunityTrackingRemoveGoalFileMutation. */
export type OpportunityTrackingRemoveGoalFileMutationPayload = {
  __typename?: 'OpportunityTrackingRemoveGoalFileMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of OpportunityTrackingRemoveIncludedLawyerMutation. */
export type OpportunityTrackingRemoveIncludedLawyerMutationPayload = {
  __typename?: 'OpportunityTrackingRemoveIncludedLawyerMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of OpportunityTrackingUpdateOpportunityMutation. */
export type OpportunityTrackingUpdateOpportunityMutationPayload = {
  __typename?: 'OpportunityTrackingUpdateOpportunityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  gridRecord: OpportunityGrid;
  record: CompanyGoal;
};

/** Autogenerated return type of OpportunityTrackingUpdateOpportunityNoteMutation. */
export type OpportunityTrackingUpdateOpportunityNoteMutationPayload = {
  __typename?: 'OpportunityTrackingUpdateOpportunityNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  note: Maybe<OpportunityNote>;
};

export type Option = {
  __typename?: 'Option';
  colour: AccountColour;
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type OptionChoice = {
  __typename?: 'OptionChoice';
  colour: AccountColour;
  id: Scalars['String']['output'];
  optionChoiceId: Scalars['String']['output'];
  orderRank: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type OptionChoiceAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  colour?: InputMaybe<AccountColour>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orderRank?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type OptionsAttributes = {
  colour?: InputMaybe<AccountColour>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of OverrideContactVerificationMutation. */
export type OverrideContactVerificationMutationPayload = {
  __typename?: 'OverrideContactVerificationMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  verification: Maybe<Verification>;
};

export type OwnedByInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type: OwnedByType;
};

export enum OwnedByType {
  Company = 'COMPANY',
  FirmWide = 'FIRM_WIDE',
  Project = 'PROJECT',
  User = 'USER'
}

/** Page description for form expiry with HTML content */
export type PageDescription = {
  __typename?: 'PageDescription';
  /** Raw HTML content for editor */
  htmlForEditor: Maybe<Scalars['String']['output']>;
  /** Sanitized HTML content for safe display */
  renderSafeHtml: Maybe<Scalars['String']['output']>;
};

/** Company list, contact list, or saved view fields value */
export type PageResult = BlockPageList | Campaign | CompanyListItem | EmbedUrl | GenericList | KeyActivityList | List | SaveView;

/** Pagination info */
export type PagingInfo = {
  __typename?: 'PagingInfo';
  totalEntries: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum ParticipantRole {
  Receiver = 'RECEIVER',
  Sender = 'SENDER'
}

export type PartitionedInteraction = {
  __typename?: 'PartitionedInteraction';
  companies: Array<Company>;
  contacts: Array<Contact>;
  direction: PartitionedInteractionDirection;
  id: Scalars['ID']['output'];
  interactionType: PartitionedInteractionType;
  keyActivity: Maybe<KeyActivity>;
  occuredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  occuredEndAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  occuredEndOn: Maybe<Scalars['ISO8601Date']['output']>;
  occuredOn: Maybe<Scalars['ISO8601Date']['output']>;
  receivers: Array<Contact>;
  sender: Maybe<Contact>;
  sourceReferenceId: Scalars['String']['output'];
  webLink: Maybe<Scalars['String']['output']>;
};

export enum PartitionedInteractionDirection {
  DirectionPending = 'DIRECTION_PENDING',
  EmployeeReceived = 'EMPLOYEE_RECEIVED',
  EmployeeSent = 'EMPLOYEE_SENT'
}

export type PartitionedInteractionList = {
  __typename?: 'PartitionedInteractionList';
  entries: Array<PartitionedInteraction>;
  pageInfo: PagingInfo;
};

export enum PartitionedInteractionType {
  Custom = 'CUSTOM',
  Email = 'EMAIL',
  Meeting = 'MEETING'
}

export type PastMeeting = {
  __typename?: 'PastMeeting';
  company: Company;
  newNoteUrl: Scalars['Url']['output'];
  newTaskUrl: Scalars['Url']['output'];
  withContacts: Array<Contact>;
  withNames: Scalars['String']['output'];
};

export type PastMeetings = {
  __typename?: 'PastMeetings';
  amount: Scalars['Int']['output'];
  entries: Array<PastMeeting>;
  position: Position;
  viewAllUrl: Maybe<Scalars['Url']['output']>;
};

export type PendingTask = {
  __typename?: 'PendingTask';
  dueOn: Maybe<Scalars['String']['output']>;
  forItem: PendingTaskFor;
  title: Scalars['String']['output'];
  url: Scalars['Url']['output'];
};


export type PendingTaskDueOnArgs = {
  format: Scalars['String']['input'];
};

export type PendingTaskFor = {
  __typename?: 'PendingTaskFor';
  imgSrc: Maybe<Scalars['Url']['output']>;
  subTitle: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PendingTasks = {
  __typename?: 'PendingTasks';
  allTasksUrl: Scalars['Url']['output'];
  entries: Array<PendingTask>;
};

export type Person = {
  __typename?: 'Person';
  activeContacts: Array<Contact>;
  careerCompanies: Array<CareerCompany>;
  /** @deprecated Use careerCompanies instead */
  companyContacts: Array<PersonCompanyContact>;
  contacts: Array<Contact>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  educations: Array<Education>;
  externalImageUrl: Maybe<Scalars['Url']['output']>;
  firstName: Scalars['String']['output'];
  gender: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  linkedinUrl: Maybe<Scalars['Url']['output']>;
  location: Maybe<Location>;
  phoneNumbers: Array<PhoneNumber>;
  skills: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  twitterUrl: Maybe<Scalars['Url']['output']>;
};

export type PersonCompanyContact = {
  __typename?: 'PersonCompanyContact';
  company: Maybe<Company>;
  companyDisplayName: Scalars['String']['output'];
  companyId: Maybe<Scalars['ID']['output']>;
  companyLinkedinUrl: Maybe<Scalars['Url']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use person { contacts } instead */
  contact: Maybe<Contact>;
  contactId: Maybe<Scalars['ID']['output']>;
  currentStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  jobTitles: Array<ContactJobTitle>;
  person: Person;
};

export type PersonCompanyContactEntries = {
  __typename?: 'PersonCompanyContactEntries';
  entries: Array<PersonCompanyContact>;
  pageInfo: PagingInfo;
};

/** A phone number associated with a person */
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  /** Unique identifier for the phone number */
  id: Scalars['ID']['output'];
  /** The person associated with this phone number */
  person: Person;
  /** Type of phone number (e.g., mobile, work) */
  phoneType: Maybe<Scalars['String']['output']>;
  /** The phone number value */
  value: Scalars['String']['output'];
};

export type PhoneNumberAttributes = {
  phoneType: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Autogenerated return type of PinNoteMutation. */
export type PinNoteMutationPayload = {
  __typename?: 'PinNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  note: Maybe<Note>;
};

export type Position = {
  __typename?: 'Position';
  amount: Scalars['Int']['output'];
  rank: Scalars['String']['output'];
};

/** Autogenerated return type of PrepareClientCompaniesForSyncMutation. */
export type PrepareClientCompaniesForSyncMutationPayload = {
  __typename?: 'PrepareClientCompaniesForSyncMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export enum PriorityEnum {
  Critical = 'critical',
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  None = 'none'
}

export type Progress = {
  __typename?: 'Progress';
  checkinDate: Scalars['ISO8601Date']['output'];
  comment: Maybe<RichContent>;
  createdBy: User;
  id: Scalars['ID']['output'];
  measureValue: Scalars['Int']['output'];
  progressStatus: ProgressStatus;
};

export type ProgressAttribute = {
  checkinDate: Scalars['ISO8601Date']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  measureValue?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProgressStatus {
  Lagging = 'LAGGING',
  Leading = 'LEADING',
  OnTrack = 'ON_TRACK'
}

export type ProgressTracker = {
  __typename?: 'ProgressTracker';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  expectedCount: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  percentageComplete: Maybe<Scalars['Int']['output']>;
  returnPath: Maybe<Scalars['String']['output']>;
  status: ProgressTrackerStatus;
  title: Scalars['String']['output'];
};

export type ProgressTrackerAttributes = {
  description?: InputMaybe<Scalars['String']['input']>;
  returnPath?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export enum ProgressTrackerStatus {
  Complete = 'complete',
  Pending = 'pending',
  Running = 'running'
}

/** Autogenerated return type of ProgressTrackersUpdated. */
export type ProgressTrackersUpdatedPayload = {
  __typename?: 'ProgressTrackersUpdatedPayload';
  entries: Array<ProgressTracker>;
};

export type Project = {
  __typename?: 'Project';
  colorCode: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Maybe<Employee>;
  description: Maybe<RichContent>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  documents: Array<ProjectDocument>;
  firmWide: Scalars['Boolean']['output'];
  folder: Folder;
  iconCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nexlApps: Scalars['Boolean']['output'];
  objectives: Array<Objective>;
  opportunityCustomFieldSchemas: Array<CustomFieldSchema>;
  overviewTab: Maybe<ProjectOverviewTab>;
  readOnly: Scalars['Boolean']['output'];
  tabGroupName: Scalars['String']['output'];
  tabs: Array<TabResult>;
  teamMembersCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Project attribute */
export type ProjectAttribute = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firmWide?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  iconCode?: InputMaybe<Scalars['String']['input']>;
  nexlApps?: InputMaybe<Scalars['Boolean']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sourceProjectId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCampaignEntries = {
  __typename?: 'ProjectCampaignEntries';
  entries: Array<Campaign>;
  pageInfo: PagingInfo;
};

export type ProjectCampaignsFilter = {
  continuousOnly?: InputMaybe<Scalars['Boolean']['input']>;
  projectUid: Scalars['ID']['input'];
  status?: InputMaybe<Array<CampaignStatus>>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectDocument = {
  __typename?: 'ProjectDocument';
  file: Maybe<File>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['Url']['output']>;
};

/** Project document attributes */
export type ProjectDocumentAttributes = {
  file?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectList = {
  __typename?: 'ProjectList';
  entries: Array<Project>;
  pageInfo: PagingInfo;
  rootFolderId: Maybe<Scalars['ID']['output']>;
  subFolders: Array<Folder>;
};

/** project management permissions */
export type ProjectManagementPermission = {
  __typename?: 'ProjectManagementPermission';
  exportCompanyLists: Scalars['Boolean']['output'];
  exportContactLists: Scalars['Boolean']['output'];
  exportGenericLists: Scalars['Boolean']['output'];
  exportKeyActivityLists: Scalars['Boolean']['output'];
  exportOpportunities: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type ProjectMembership = {
  __typename?: 'ProjectMembership';
  id: Scalars['ID']['output'];
  member: Employee;
};

export type ProjectMembershipList = {
  __typename?: 'ProjectMembershipList';
  entries: Array<ProjectMembership>;
  pageInfo: PagingInfo;
};

export type ProjectNote = {
  __typename?: 'ProjectNote';
  content: RichContent;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Employee;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Project note attribute */
export type ProjectNoteAttribute = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectNoteList = {
  __typename?: 'ProjectNoteList';
  entries: Array<ProjectNote>;
  pageInfo: PagingInfo;
};

export type ProjectOpportunityGrid = {
  __typename?: 'ProjectOpportunityGrid';
  createdAt: Scalars['ISO8601DateTime']['output'];
  customFields: Array<CustomFieldGrid>;
  id: Scalars['ID']['output'];
  opportunity: OpportunityGrid;
  projectId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProjectOpportunityGridTypeList = {
  __typename?: 'ProjectOpportunityGridTypeList';
  entries: Array<ProjectOpportunityGrid>;
  pageInfo: PagingInfo;
};

export type ProjectOverviewTab = {
  __typename?: 'ProjectOverviewTab';
  id: Scalars['ID']['output'];
};

export type ProjectTask = {
  __typename?: 'ProjectTask';
  assignedTo: Maybe<Employee>;
  completedOn: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Employee;
  description: Maybe<RichContent>;
  dueOn: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  project: Project;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Project task attribute */
export type ProjectTaskAttribute = {
  assignedToId?: InputMaybe<Scalars['ID']['input']>;
  completedOn?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueOn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Filtering Options for tasks */
export type ProjectTaskFiltering = {
  /** employee id */
  assignedToId?: InputMaybe<Scalars['ID']['input']>;
  /** employee email or employee id */
  creatorUid?: InputMaybe<Scalars['ID']['input']>;
  delegated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectTaskStatusEnum>;
};

export type ProjectTaskList = {
  __typename?: 'ProjectTaskList';
  entries: Array<ProjectTask>;
  pageInfo: PagingInfo;
};

export type ProjectTaskSection = {
  __typename?: 'ProjectTaskSection';
  /**
   * Identifier for the section that is unique
   *                                                        to the project to be used on pages
   */
  blockPageIdentifier: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  position: Maybe<Scalars['Int']['output']>;
  project: Project;
  title: Scalars['String']['output'];
};

export type ProjectTaskSectionEntries = {
  __typename?: 'ProjectTaskSectionEntries';
  entries: Array<ProjectTaskSection>;
};

export enum ProjectTaskStatusEnum {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type Prospect = {
  __typename?: 'Prospect';
  company: Maybe<Company>;
  country: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  headCount: Maybe<Scalars['Int']['output']>;
  industry: Maybe<Scalars['String']['output']>;
  linkedinUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type ProspectEmailRequest = {
  __typename?: 'ProspectEmailRequest';
  contactEmail: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['String']['output'];
  linkedinUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: ProspectEmailRequestStatus;
};

export enum ProspectEmailRequestStatus {
  Completed = 'COMPLETED',
  NotFound = 'NOT_FOUND',
  Pending = 'PENDING',
  Searching = 'SEARCHING',
  StillSearching = 'STILL_SEARCHING'
}

/** Autogenerated return type of PublishFormMutation. */
export type PublishFormMutationPayload = {
  __typename?: 'PublishFormMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Form>;
};

/** Autogenerated return type of PurgeContactMutation. */
export type PurgeContactMutationPayload = {
  __typename?: 'PurgeContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  accessConfiguration: Maybe<AccessConfig>;
  accessRole: Maybe<AccessRole>;
  accessRoles: AccessRoleEntries;
  /** Activity List */
  allActivityFeed: TimelineEntries;
  /** All Delegate Accesses */
  allDelegateAccesses: Maybe<UserDelegateAccessEntries>;
  allInteraction: PartitionedInteractionList;
  /** Returns objectives grouped by either department, owner or office */
  allObjectives: Array<GroupedObjective>;
  apiConnections: Array<ApiSourceTable>;
  /** Archived Company */
  archivedCompanies: CompanyEntries;
  /** Filtered Contacts */
  archivedContacts: ContactList;
  /** Audiences List */
  audienceList: AudienceList;
  /** Selectable Key Contacts for opportunity for company */
  availableOpportunityKeyContacts: ContactList;
  /** Fetch Bee Plugin authentication token */
  beeAuth: BeeAuth;
  /**
   * Audiences List
   * @deprecated switch to BeeAuth
   */
  beePlugin: BeePlugin;
  blockPage: Maybe<BlockPage>;
  blockPageList: Maybe<BlockPageList>;
  blockPageProvider: BlockPageProvider;
  /** Fix an Active Storage URL with invalid signature */
  blockPagesFixActiveStorageUrl: FixActiveStorageUrlResult;
  /** Fetch all Blocked Domains */
  blockedDomains: Maybe<BlockedDomainEntries>;
  /** Fetch All Blocked Emails */
  blockedEmails: Maybe<BlockedEmailEntries>;
  /** Fetch Bounced Emails For Contact */
  bouncedEmails: Maybe<BouncedEmailEntries>;
  campaign: Maybe<Campaign>;
  campaignLinks: Array<Scalars['NormalizedUrl']['output']>;
  campaignManager: Maybe<CampaignManager>;
  campaignManagerDetail: CampaignManagerDetail;
  /** Return campaigns for project */
  campaigns: Maybe<ProjectCampaignEntries>;
  /** Get a comment thread and its comments */
  commentThread: CommentThreadComments;
  /** Get a comment thread and its comments */
  commentThreadInfo: CommentThreadInfo;
  /** All companies */
  companies: CompanyEntries;
  /** Fetch Company */
  company: Maybe<Company>;
  /** Generate news using AI for a company */
  companyAiNews: Maybe<CompanyAiNewsResult>;
  /** Generate an AI summary for a company */
  companyAiSummary: Maybe<Scalars['String']['output']>;
  companyAuditTrail: Maybe<AuditTrail>;
  companyConnections: PersonCompanyContactEntries;
  /** Contact list */
  companyContacts: ContactList;
  /** Returns companies in exclusion list */
  companyExclusionList: Maybe<CompanyExclusionList>;
  /** Return all tenant opportunities */
  companyGoals: CompanyGoalList;
  companyHierarchy: Maybe<CompanyHierarchyEntries>;
  companyHierarchyNodes: CompanyNodeEntries;
  companyIndustryNames: CompanyIndustryNameList;
  companyInteractionDistribution: Array<CompanyInteractionDist>;
  companyKeyContacts: ContactList;
  companyList: Maybe<CompanyListItem>;
  companyListMember: Maybe<CompanyListMember>;
  companyListMembers: CompanyListMembers;
  /** Members in a company list */
  companyListMemberships: Maybe<CompanyListMembers>;
  companyListReminderSettings: Maybe<Array<ReminderSetting>>;
  companyLists: CompanyListEntries;
  /** Company notes */
  companyNotes: CompanyNoteList;
  /** company office locations */
  companyOfficeLocations: CompanyOfficeLocationList;
  /** opportunities for a company with details if have access */
  companyOpportunities: CompanyOpportunityList;
  /** Company profiles */
  companyProfiles: CompanyProfileList;
  /** Company prospects */
  companyProspects: CompanyProspectList;
  companyReengagement: CompanyReengagementList;
  /** Get a list of all relationship partners */
  companyRelationshipPartners: RelationshipPartnerList;
  /** Company upcoming meetings */
  companyUpcomingMeetings: UpcomingMeetingList;
  config: TenantConfig;
  connectedList: Maybe<ConnectedList>;
  /** Returns members of a connected list with mapped field values */
  connectedListMembersForSync: Maybe<ConnectedListMappings>;
  connectedLists: Array<ConnectedList>;
  /** Fetch Contact */
  contact: Maybe<Contact>;
  /** Generate an AI summary for a contact */
  contactAiSummary: Maybe<Scalars['String']['output']>;
  contactAuditTrail: Maybe<AuditTrail>;
  contactConsent: Maybe<ContactConsent>;
  contactExclusions: Maybe<ContactExclusions>;
  /** Contact last 5 key activities */
  contactLastKeyActivities: Maybe<ContactKeyActivityList>;
  /** Contact last 5 meetings */
  contactLastMeetings: Maybe<EmployeeMeetingList>;
  /** A complete representation of the form with the specified id */
  contactListForm: Maybe<Form>;
  /** Forms for a specific contact list */
  contactListForms: ContactListForms;
  /** Members in a contact list for AG Grid */
  contactListGridMembers: ContactListGridMemberEntries;
  /** Contact list members delta */
  contactListGridMembersDelta: Maybe<ContactListDelta>;
  contactListReminderSettings: Maybe<Array<ReminderSetting>>;
  /** Return unique contact locations */
  contactLocations: LocationOptionList;
  contactPreferences: Maybe<ContactPreferences>;
  /** Contact require hierarchy placements */
  contactRequireHierarchyPlacements: ContactRequireHierarchyPlacementList;
  /** Filtered Contacts */
  contacts: ContactList;
  /** Checks if contacts already exist in a list */
  contactsExistInList: ContactsExistInList;
  /** Find contacts by name or email address */
  contactsQuickSearch: ContactEntries;
  /** Contacts Review configuration for current tenant */
  contactsReviewConfiguration: Maybe<ContactsReviewConfiguration>;
  contactsReviewRule: Maybe<ContactsReviewRule>;
  /** Returns the Core feature Permissions for a specific role */
  coreRolePermissions: Maybe<CorePermission>;
  /** Return details of the current user */
  currentTenant: Maybe<Tenant>;
  /** Return details of the current user */
  currentUser: Maybe<User>;
  /** Returns a single custom field value */
  customFieldGridValue: Maybe<CustomFieldGrid>;
  /** Return custom fields */
  customFieldGridValues: CustomFieldGridTypeEntries;
  /** List of configured custom fields */
  customFieldSchemas: CustomFieldSchemasList;
  /** Returns a single custom field value */
  customFieldValue: Maybe<CustomField>;
  /** Return custom fields for grid */
  customFieldValues: CustomFieldTypeEntries;
  /** Returns list of dashboards for embedding reports */
  dashboardList: Maybe<EmbeddedReportingDashboardList>;
  dataCleanerConfiguration: DataCleanerConfiguration;
  /** Date Templates */
  dataTemplates: DataTemplateEntries;
  /** Date Template Permissions for Roles */
  dataTemplatesPermissions: DataTemplatePermissionsEntries;
  /** Returns date properties for company list */
  datePropertiesForCompanyListReminder: Maybe<Array<ListReminderSettingDateOption>>;
  /** Returns date properties for contact list */
  datePropertiesForContactListReminder: Maybe<Array<ListReminderSettingDateOption>>;
  /** Returns date properties for generic list */
  datePropertiesForGenericListReminder: Maybe<Array<ListReminderSettingDateOption>>;
  /** Return details of the current user */
  delegateAccesses: Maybe<Array<UserDelegateAccess>>;
  /** Fetch Department */
  department: Maybe<Department>;
  departments: DepartmentList;
  deploymentInfo: DeploymentInfo;
  duplicateCompanies: DuplicateCompaniesList;
  duplicateContacts: DuplicateContactsList;
  /** Returns duplicate contacts associated with a person */
  duplicateContactsForAPerson: Maybe<Array<Contact>>;
  eMarketingConnectors: Maybe<EMarketingConnectors>;
  /** get details about the email address */
  emailLookup: Maybe<EmailLookup>;
  emailMarketingCampaignRecipients: CampaignRecipientEntries;
  /** Email marketing campaigns */
  emailMarketingCampaigns: Maybe<Campaigns>;
  emailMarketingConfiguration: Maybe<EmailMarketingConfiguration>;
  emailMarketingContactAllowances: Maybe<MarketingContactAllowanceEntries>;
  emailMarketingFormUrl: Maybe<Scalars['String']['output']>;
  emailMarketingListMergeTags: Maybe<Array<MergeTag>>;
  /** Marketing lists from ems and project contact lists that are active */
  emailMarketingLists: ListEntries;
  /** Forms from the project */
  emailMarketingProjectForms: ContactListForms;
  emailMarketingRecipientWarnings: Maybe<RecipientWarnings>;
  emailMarketingTemplate: Maybe<Template>;
  /** Returns saved rows for tenant */
  emailMarketingTemplateSavedRows: Maybe<TemplateSavedRowEntries>;
  /**
   * List of email marketing templates
   * @deprecated use emailMarketingTemplatesV2 instead
   */
  emailMarketingTemplates: Array<Template>;
  /** List of email marketing templates with pagination */
  emailMarketingTemplatesV2: Templates;
  /** Returns dashboard details */
  embeddedReportingDashboard: Maybe<EmbeddedReportingDashboard>;
  employee: Maybe<Employee>;
  employeeCompanyStats: EmployeeCompanyStatsList;
  /** Employee meeting */
  employeeMeeting: Maybe<EmployeeMeeting>;
  /**
   * Employee meetings
   * @deprecated Use Meetings and filter by contactUid instead
   */
  employeeMeetings: MeetingList;
  employees: EmployeeList;
  enabledModules: EnabledModules;
  /** Returns the Enrichment feature Permissions for a specific role */
  enrichmentRolePermissions: Maybe<EnrichmentPermission>;
  /** Returns EverAfter status for the current tenant and current user */
  everAfterStatus: Status;
  excludedCompanyContactsCount: Maybe<Scalars['Int']['output']>;
  /** Export audtis */
  exportAudits: ExportAuditEntries;
  /** Exports */
  exports: ExportEntries;
  /** Returns wether the feature is enabled */
  featureEnabled: Scalars['Boolean']['output'];
  /** Returns list of feature flags for current user */
  features: Array<FeatureFlag>;
  /** Key Activity for an event */
  fetchMsEventKeyActivity: MsEventSourceReference;
  /**
   * Configuration for Flat File
   * @deprecated Being replaced by new Flat File implementation
   */
  flatFileConfig: FlatFileConfig;
  genericList: Maybe<GenericList>;
  genericListItem: Maybe<GenericListItem>;
  genericListItems: GenericListItemEntries;
  genericListReminderSettings: Maybe<Array<ReminderSetting>>;
  /** Imports List */
  importList: ImportListEntries;
  incompleteCompanies: IncompleteCompaniesList;
  /** Incomplete Contacts */
  incompleteContacts: IncompleteContactsList;
  /** Checks if user requires to consent */
  individualConsented: Maybe<IndividualConsented>;
  /** Industry list */
  industryList: Array<Scalars['String']['output']>;
  industryMappings: IndustryMappingList;
  interactionsConfiguration: Maybe<InteractionsConfiguration>;
  /** Returns the Interactions feature Permissions for a specific role */
  interactionsRolePermissions: Maybe<InteractionsPermission>;
  internalIndustries: InternalIndustryList;
  /** The JWT audience URLs for NEXL applications. */
  jwtAudience: JwtAudience;
  /** List of BD and marketing interactions */
  keyActivities: InteractionDetailList;
  keyActivity: Maybe<KeyActivity>;
  keyActivityDescriptions: KeyActivityDescriptionList;
  keyActivityList: Maybe<KeyActivityList>;
  keyActivityListMember: Maybe<KeyActivityListMember>;
  /** Members in key activity list */
  keyActivityListMembers: Maybe<KeyActivityListMembers>;
  /** Return key actvitiy list. */
  keyActivityLists: Maybe<KeyActivityLists>;
  /** Last 12 Month Stats for Key Activities */
  keyActivityMonthStats: Array<KeyActivityMonthStatsEntry>;
  keyActivityTitles: KeyActivityTitleList;
  list: Maybe<List>;
  listAudits: Maybe<ListAuditHistory>;
  listCleaner: Maybe<Verifications>;
  listMember: Maybe<ListMember>;
  /** Members in a contact list */
  listMembers: ListMembers;
  listMembership: Maybe<ListEntries>;
  /** List view */
  listView: Maybe<ListView>;
  /** List views list */
  listViews: Array<ListView>;
  /** Contact lists */
  lists: ListEntries;
  magicbell: Magicbell;
  /** Contact lists */
  marketingContactLists: ListEntries;
  marketingListConfiguration: Maybe<MarketingListConfiguration>;
  marketingListCounts: MarketingListCounts;
  marketingListSyncRequest: Maybe<MarketingListSyncRequest>;
  /** Returns the Marketing Lists feature Permissions for a specific role */
  marketingListsRolePermissions: Maybe<MarketingListsPermission>;
  matchingMarketingExclusions: Maybe<Array<MatchingExclusion>>;
  meetings: MeetingList;
  /** Details for microsoft admin consent */
  microsoftAdminConsentDetail: MicrosoftAdminConsentDetail;
  /** Returns mobile configuration */
  mobileConfigs: Maybe<MobileConfigs>;
  /** Multi my lists */
  multiMyContactList: Maybe<MultiMyContactList>;
  /** My Contact Activity List */
  myActivityFeed: MyActivityList;
  /** My contacts update events */
  myAllContactUpdateEvents: MyAllContactUpdateEvents;
  /** Fetch My Calendar */
  myCalendar: Maybe<Calendar>;
  /** My Company */
  myCompanies: MyCompanyList;
  /** Fetch My Company */
  myCompany: Maybe<MyCompany>;
  /** My Company Activity List */
  myCompanyActivityFeed: MyActivityList;
  /** Fetch My Contact */
  myContact: Maybe<MyContact>;
  /** My Contacts */
  myContacts: MyContactList;
  myEngagementReport: EngagementReport;
  /** My Key Activity Performance */
  myKeyActivityPerformance: MyKeyActivityPerformance;
  myLists: MyListEntries;
  myObjectives: ObjectiveList;
  myOpportunitiesCustomBoard: Array<CustomBoardColumn>;
  mySharedList: MySharedList;
  /** Fetch My stay in touch list */
  myStayInTouch: Maybe<MyStayInTouchList>;
  myTask: Maybe<MyTask>;
  myTasks: MyTaskEntries;
  /** Get a single note by ID */
  note: Maybe<Note>;
  /** List notes with pagination */
  notes: NoteList;
  objective: Maybe<Objective>;
  /** Returns the Objectives feature Permissions for a specific role */
  objectiveManagementRolePermissions: Maybe<ObjectiveManagementPermission>;
  /** Fetch Office */
  office: Maybe<Office>;
  /** Add description */
  officeLabels: Maybe<OfficeLabelsList>;
  offices: OfficeList;
  /** Return all tenant opportunities optimized for Ag-Grid */
  opportunitiesForGrid: OpportunityGridTypeList;
  /** Return company opportunity */
  opportunity: Maybe<Opportunity>;
  opportunityAuditTrail: Maybe<OpportunityAuditTrail>;
  /** Fetch notes for opportunity */
  opportunityNotes: Maybe<OpportunityNoteEntries>;
  /** Fetch projects for opportunity */
  opportunityProjects: Maybe<OpportunityProjectEntries>;
  /** Fetch projects for opportunity */
  opportunityProjectsForUid: Maybe<OpportunityProjectEntries>;
  opportunityStatusChange: Maybe<OpportunityStatusChange>;
  /** Return opportunity tags */
  opportunityTags: Array<Scalars['String']['output']>;
  opportunityTrackingConfiguration: Maybe<OpportunityTrackingConfiguration>;
  /** Returns the Opportunities feature Permissions for a specific role */
  opportunityTrackingRolePermissions: Maybe<OpportunityTrackingPermission>;
  /** Check if Outlook Sync Personal Contact is allowed */
  outlookSyncAllowed: Maybe<Scalars['Boolean']['output']>;
  person: Maybe<Person>;
  personNotes: CompanyNoteList;
  project: Maybe<Project>;
  /** Returns the Project management feature Permissions for a specific role */
  projectManagementRolePermissions: Maybe<ProjectManagementPermission>;
  projectMemberships: ProjectMembershipList;
  projectNotes: ProjectNoteList;
  /** Return all project opportunities optimized for Ag-Grid */
  projectOpportunities: ProjectOpportunityGridTypeList;
  /** Return project opportunity */
  projectOpportunity: Maybe<ProjectOpportunityGrid>;
  projectTask: Maybe<ProjectTask>;
  projectTaskSections: Maybe<ProjectTaskSectionEntries>;
  projectTasks: ProjectTaskList;
  projects: ProjectList;
  /** Fetch request */
  prospectEmailRequest: Maybe<ProspectEmailRequest>;
  /** Industry list */
  prospectIndustryList: Array<Scalars['String']['output']>;
  prospectSearch: Maybe<CompanySearchEntries>;
  /** Returns the Marketing Lists feature Permissions for a specific role */
  referralTrackingRolePermissions: Maybe<ReferralTrackingPermission>;
  reminderSetting: Maybe<ReminderSetting>;
  /** Custom field schema for the remote eMarketing service */
  remoteCustomFieldSchema: Maybe<RemoteCustomFieldSchemaList>;
  /** Returns incorrect company */
  reportedIncorrectCompanyInfos: Maybe<ReportedIncorrectCompanyInfoEntries>;
  /** Contacts that have been reported to have incorrect info */
  reportedIncorrectInfos: ReportedIncorrectInfoEntries;
  /** Returns a specific research report by ID */
  researchReport: Maybe<ResearchReport>;
  /** Returns a specific research report section by ID */
  researchReportSection: Maybe<ResearchReportSection>;
  /** Returns a paginated list of research reports */
  researchReports: ResearchReportEntries;
  /** Returns the Research Reports feature Permissions for a specific role */
  researchReportsRolePermissions: Maybe<ResearchReportsPermission>;
  /** Search list */
  search: SearchList;
  sentReferral: Maybe<SentReferral>;
  sentReferrals: SentReferralEntries;
  /** Returns a list of users and their permissions for a shared list */
  sharedMyListUsers: Maybe<SharedMyListUsers>;
  sharedTableLikeRows: TableLikeRowEntries;
  sourceTemplateProject: Maybe<TemplateProject>;
  /** Tab result */
  tab: Maybe<TabResult>;
  tableLikeColumnValueSuggestions: TableLikeColumnValueSuggestionsEntries;
  tableLikeDefinition: TableLikeDefinition;
  /** @deprecated use tableLikeColumnValueSuggestions instead */
  tableLikeFilterSuggestions: TableLikeColumnValueSuggestionsEntries;
  tableLikeRollupColumns: TableLikeRollupColumnsEntries;
  /** Rollup Fields */
  tableLikeRollupFields: TableLikeRollupFieldEntries;
  tableLikeRows: TableLikeRowEntries;
  /** Tabs list */
  tabs: TabList;
  /** Return all tags */
  tags: TagList;
  task: Maybe<Task>;
  tasks: TaskEntries;
  templateProject: Maybe<Project>;
  tenantConfiguration: Maybe<TenantConfiguration>;
  topClientCompanyList: Maybe<TopClientCompanyList>;
  /** Top contacts for employee */
  topContactList: Maybe<TopContactList>;
  uiConfiguration: Maybe<UiConfig>;
  unengagedContacts: ContactList;
  /** Return User */
  user: Maybe<UserResponse>;
  /** User role core permissions */
  userRoleCorePermissions: Maybe<CorePermission>;
  /** User role enrichment permissions */
  userRoleEnrichmentPermissions: Maybe<EnrichmentPermission>;
  /** User role Interactions permissions */
  userRoleInteractionsPermissions: Maybe<InteractionsPermission>;
  /** User role Marketing Lists permissions */
  userRoleMarketingListsPermissions: Maybe<MarketingListsPermission>;
  /** User role objective management permissions */
  userRoleObjectiveManagementPermissions: Maybe<ObjectiveManagementPermission>;
  /** User role opportunity permissions */
  userRoleOpportunityTrackingPermissions: Maybe<OpportunityTrackingPermission>;
  /** User role Project Management permissions */
  userRoleProjectManagementPermissions: Maybe<ProjectManagementPermission>;
  /** User role Referral Tracking permissions */
  userRoleReferralTrackingPermissions: Maybe<ReferralTrackingPermission>;
  /** User role research reports permissions */
  userRoleResearchReportsPermissions: Maybe<ResearchReportsPermission>;
  /** Return Users */
  users: UserEntries;
  /** Return limited user info */
  usersForSelection: UserSelectionEntries;
  webhookEvents: WebhookEventEntries;
  /** List of contact relationships */
  whoKnows: WhoKnowsList;
  whoPreviouslyKnew: WhoPreviouslyKnewList;
};


export type QueryAccessRoleArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryAllActivityFeedArgs = {
  contactUid: Scalars['ID']['input'];
  filter?: InputMaybe<InteractionsFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllDelegateAccessesArgs = {
  delegateUserUid?: InputMaybe<Scalars['ID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  userUid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllInteractionArgs = {
  companyUid?: InputMaybe<Scalars['String']['input']>;
  interactionType?: InputMaybe<PartitionedInteractionType>;
  keyActivityCategories?: InputMaybe<Array<KeyActivityCategory>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllObjectivesArgs = {
  groupBy?: InputMaybe<ObjectiveGroupBy>;
  status?: InputMaybe<ObjectiveStatus>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApiConnectionsArgs = {
  listUid: Scalars['ID']['input'];
};


export type QueryArchivedCompaniesArgs = {
  filter?: InputMaybe<CompanyFiltering>;
  orderBy?: InputMaybe<ArchivedCompaniesOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryArchivedContactsArgs = {
  companyUuid?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ArchivedContactsFiltering>;
  orderBy?: InputMaybe<ArchivedContactsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableOpportunityKeyContactsArgs = {
  companyUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBlockPageArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryBlockPageListArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryBlockPagesFixActiveStorageUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryBlockedDomainsArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryBlockedEmailsArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryBouncedEmailsArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryCampaignArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryCampaignLinksArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCampaignManagerDetailArgs = {
  listUid: Scalars['ID']['input'];
};


export type QueryCampaignsArgs = {
  filter: ProjectCampaignsFilter;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommentThreadArgs = {
  commentThreadUid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommentThreadInfoArgs = {
  attachedToType: CommentThreadAttachable;
  attachedToUid: Scalars['ID']['input'];
};


export type QueryCompaniesArgs = {
  filter?: InputMaybe<CompanyFiltering>;
  orderBy?: InputMaybe<CompaniesOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyArgs = {
  uid: Scalars['String']['input'];
};


export type QueryCompanyAiNewsArgs = {
  companyUid: Scalars['ID']['input'];
};


export type QueryCompanyAiSummaryArgs = {
  companyUid: Scalars['ID']['input'];
};


export type QueryCompanyAuditTrailArgs = {
  companyUid: Scalars['ID']['input'];
};


export type QueryCompanyConnectionsArgs = {
  companyUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyContactsArgs = {
  domain: Scalars['String']['input'];
  filter?: InputMaybe<GenericContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyExclusionListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyGoalsArgs = {
  filter?: InputMaybe<CompanyGoalFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyHierarchyArgs = {
  companyUid: Scalars['ID']['input'];
};


export type QueryCompanyHierarchyNodesArgs = {
  filter?: InputMaybe<CompanyHierarchyNodeFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyIndustryNamesArgs = {
  filter?: InputMaybe<CompanyIndustryNameFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyInteractionDistributionArgs = {
  companyUuid: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyKeyContactsArgs = {
  companyUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyListArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryCompanyListMemberArgs = {
  listMemberUid: Scalars['ID']['input'];
  listUid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompanyListMembersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type QueryCompanyListMembershipsArgs = {
  companyUid: Scalars['String']['input'];
  excludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyListReminderSettingsArgs = {
  companyListUid: Scalars['ID']['input'];
};


export type QueryCompanyListsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  projectUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompanyNotesArgs = {
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  contactUid?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyOfficeLocationsArgs = {
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyOpportunitiesArgs = {
  companyUid?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CompanyOpportunityFiltering>;
};


export type QueryCompanyProfilesArgs = {
  domain: Scalars['String']['input'];
  filter?: InputMaybe<CompanyProfileFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyProspectsArgs = {
  domain: Scalars['String']['input'];
  filter?: InputMaybe<CompanyProspectFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyReengagementArgs = {
  companyTypeUid?: InputMaybe<Scalars['ID']['input']>;
  ownerUid?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<RoleCode>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyRelationshipPartnersArgs = {
  companyUid?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyUpcomingMeetingsArgs = {
  companyUid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConnectedListArgs = {
  listUid: Scalars['ID']['input'];
};


export type QueryConnectedListMembersForSyncArgs = {
  connectedListId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  per: Scalars['Int']['input'];
};


export type QueryConnectedListsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listUid: Scalars['ID']['input'];
};


export type QueryContactArgs = {
  uid: Scalars['String']['input'];
};


export type QueryContactAiSummaryArgs = {
  contactUid: Scalars['ID']['input'];
};


export type QueryContactAuditTrailArgs = {
  contactUid: Scalars['ID']['input'];
};


export type QueryContactConsentArgs = {
  contactUid: Scalars['ID']['input'];
};


export type QueryContactExclusionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactLastKeyActivitiesArgs = {
  category: KeyActivityCategory;
  contactId: Scalars['ID']['input'];
  numberOfRecords?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactLastMeetingsArgs = {
  contactId: Scalars['ID']['input'];
  numberOfRecords?: InputMaybe<Scalars['Int']['input']>;
  withMe: Scalars['Boolean']['input'];
};


export type QueryContactListFormArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryContactListFormsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uid: Scalars['ID']['input'];
};


export type QueryContactListGridMembersArgs = {
  contactFilter?: InputMaybe<ContactListGridMembersFiltering>;
  contactListUid: Scalars['ID']['input'];
  listMemberFilter?: InputMaybe<ListMemberFilter>;
  page: Scalars['Int']['input'];
  per: Scalars['Int']['input'];
};


export type QueryContactListGridMembersDeltaArgs = {
  contactListUid: Scalars['ID']['input'];
  deltaAfter: Scalars['ISO8601DateTime']['input'];
  deltaSize: Scalars['Int']['input'];
};


export type QueryContactListReminderSettingsArgs = {
  contactListUid: Scalars['ID']['input'];
};


export type QueryContactLocationsArgs = {
  companyDomain: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactPreferencesArgs = {
  contactUid: Scalars['ID']['input'];
};


export type QueryContactRequireHierarchyPlacementsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactsArgs = {
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter>>;
  orderBy?: InputMaybe<ContactsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactsExistInListArgs = {
  contactUids: Array<Scalars['String']['input']>;
  listId: Scalars['ID']['input'];
};


export type QueryContactsQuickSearchArgs = {
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  includeEmployees: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  term: Scalars['String']['input'];
};


export type QueryCoreRolePermissionsArgs = {
  accessRoleUid: Scalars['ID']['input'];
};


export type QueryCustomFieldGridValueArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryCustomFieldGridValuesArgs = {
  uids: Array<Scalars['ID']['input']>;
};


export type QueryCustomFieldSchemasArgs = {
  ownerType: CustomFieldSchemaOwner;
};


export type QueryCustomFieldValueArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryCustomFieldValuesArgs = {
  uids: Array<Scalars['ID']['input']>;
};


export type QueryDataTemplatesArgs = {
  filter?: InputMaybe<DataTemplateEntriesFilter>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryDataTemplatesPermissionsArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  roleUid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDatePropertiesForCompanyListReminderArgs = {
  companyListUid: Scalars['ID']['input'];
};


export type QueryDatePropertiesForContactListReminderArgs = {
  contactListUid: Scalars['ID']['input'];
};


export type QueryDatePropertiesForGenericListReminderArgs = {
  genericListUid: Scalars['ID']['input'];
};


export type QueryDepartmentArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryDepartmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDuplicateCompaniesArgs = {
  filter?: InputMaybe<DuplicateCompaniesFiltering>;
  orderBy?: InputMaybe<DupilcateCompaniesOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDuplicateContactsArgs = {
  filter?: InputMaybe<DuplicateContactFiltering>;
  orderBy?: InputMaybe<DupilcateContactsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDuplicateContactsForAPersonArgs = {
  personUid: Scalars['ID']['input'];
};


export type QueryEMarketingConnectorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailLookupArgs = {
  email: Scalars['String']['input'];
};


export type QueryEmailMarketingCampaignRecipientsArgs = {
  campaignUid: Scalars['ID']['input'];
  filter?: InputMaybe<CampaignRecipientsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailMarketingCampaignsArgs = {
  filter?: InputMaybe<CampaignsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailMarketingContactAllowancesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailMarketingFormUrlArgs = {
  formSettings?: InputMaybe<FormSettings>;
  uid: Scalars['ID']['input'];
};


export type QueryEmailMarketingListMergeTagsArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmailMarketingListsArgs = {
  filter?: InputMaybe<EmailMarketingListFiltering>;
  orderBy?: InputMaybe<ListsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  projectUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmailMarketingProjectFormsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type QueryEmailMarketingRecipientWarningsArgs = {
  contactListUid: Scalars['ID']['input'];
};


export type QueryEmailMarketingTemplateArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryEmailMarketingTemplateSavedRowsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailMarketingTemplatesV2Args = {
  filter?: InputMaybe<TemplatesFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmbeddedReportingDashboardArgs = {
  dashboardUid: Scalars['String']['input'];
};


export type QueryEmployeeArgs = {
  id: Scalars['String']['input'];
};


export type QueryEmployeeCompanyStatsArgs = {
  filter?: InputMaybe<EmployeeCompanyStatsFilteringInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmployeeMeetingArgs = {
  meetingId: Scalars['ID']['input'];
};


export type QueryEmployeeMeetingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order: EmployeeMeetingsOrderBy;
  page?: InputMaybe<Scalars['Int']['input']>;
  startTimeAfter: Scalars['ISO8601DateTime']['input'];
  startTimeBefore: Scalars['ISO8601DateTime']['input'];
};


export type QueryEmployeesArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnrichmentRolePermissionsArgs = {
  accessRoleUid: Scalars['ID']['input'];
};


export type QueryExcludedCompanyContactsCountArgs = {
  listUid: Scalars['ID']['input'];
};


export type QueryExportAuditsArgs = {
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeatureEnabledArgs = {
  name: Scalars['String']['input'];
};


export type QueryFetchMsEventKeyActivityArgs = {
  itemId: Scalars['String']['input'];
};


export type QueryGenericListArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryGenericListItemArgs = {
  itemUid: Scalars['ID']['input'];
};


export type QueryGenericListItemsArgs = {
  genericListUid: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryGenericListReminderSettingsArgs = {
  genericListUid: Scalars['ID']['input'];
};


export type QueryImportListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIncompleteCompaniesArgs = {
  filter?: InputMaybe<IncompleteCompanyFiltering>;
  orderBy?: InputMaybe<CompaniesOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIncompleteContactsArgs = {
  datasourceVersion?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<IncompleteContactFiltering>;
  orderBy?: InputMaybe<ContactsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIndustryListArgs = {
  includeCommonIndustries?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInteractionsRolePermissionsArgs = {
  accessRoleUid: Scalars['ID']['input'];
};


export type QueryKeyActivitiesArgs = {
  filter?: InputMaybe<InteractionDetailsFilter>;
  orderBy?: InputMaybe<InteractionDetailsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKeyActivityArgs = {
  sourceReferenceId: Scalars['String']['input'];
};


export type QueryKeyActivityDescriptionsArgs = {
  activityTitle?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKeyActivityListArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryKeyActivityListMemberArgs = {
  listMemberUid: Scalars['ID']['input'];
};


export type QueryKeyActivityListMembersArgs = {
  keyActivityListUid?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKeyActivityListsArgs = {
  filter?: InputMaybe<KeyActivityListFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKeyActivityMonthStatsArgs = {
  employeeUid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryKeyActivityTitlesArgs = {
  categories?: InputMaybe<Array<KeyActivityCategory>>;
  searchMode?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryListAuditsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uid: Scalars['ID']['input'];
};


export type QueryListCleanerArgs = {
  contactListUid: Scalars['ID']['input'];
  filter?: InputMaybe<VerificationFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMemberArgs = {
  listMemberUid: Scalars['ID']['input'];
  listUid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListMembersArgs = {
  contactUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<ListMembersFilter>;
  orderBy?: InputMaybe<ListMembersOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['ID']['input']>;
  withMissingFields?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListMembershipArgs = {
  contactEmail: Scalars['String']['input'];
  marketingListOnly?: InputMaybe<Scalars['Boolean']['input']>;
  nonMarketingList?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListViewArgs = {
  listViewUid: Scalars['ID']['input'];
};


export type QueryListViewsArgs = {
  listUid: Scalars['String']['input'];
  renderMode?: InputMaybe<ListViewRenderMode>;
};


export type QueryListsArgs = {
  filter?: InputMaybe<ListFiltering>;
  orderBy?: InputMaybe<ListsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketingContactListsArgs = {
  filter?: InputMaybe<MarketingListFiltering>;
  orderBy?: InputMaybe<ListsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketingListCountsArgs = {
  listUid: Scalars['ID']['input'];
};


export type QueryMarketingListSyncRequestArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryMarketingListsRolePermissionsArgs = {
  accessRoleUid: Scalars['ID']['input'];
};


export type QueryMatchingMarketingExclusionsArgs = {
  contactUids: Array<Scalars['ID']['input']>;
  exclusionTypes: Array<ExclusionType>;
  listUid: Scalars['String']['input'];
};


export type QueryMeetingsArgs = {
  filter?: InputMaybe<MeetingsFiltering>;
  order: EmployeeMeetingsOrderBy;
  ownership: MeetingsOwnership;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  timeScope: MeetingsTimeScope;
};


export type QueryMultiMyContactListArgs = {
  myListUids: Array<Scalars['String']['input']>;
};


export type QueryMyActivityFeedArgs = {
  contactUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyAllContactUpdateEventsArgs = {
  filter?: InputMaybe<ContactUpdateEventFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyCalendarArgs = {
  filter: CalendarFieldFilter;
  order?: InputMaybe<CalendarFieldOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyCompaniesArgs = {
  filter?: InputMaybe<MyCompaniesFiltering>;
  orderBy?: InputMaybe<MyCompaniesOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyCompanyArgs = {
  uid: Scalars['String']['input'];
};


export type QueryMyCompanyActivityFeedArgs = {
  companyUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyContactArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  uid: Scalars['String']['input'];
};


export type QueryMyContactsArgs = {
  filter?: InputMaybe<MyContactsFiltering>;
  orderBy?: InputMaybe<MyContactsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyEngagementReportArgs = {
  beginOn: Scalars['String']['input'];
  endOn: Scalars['String']['input'];
};


export type QueryMyListsArgs = {
  listType?: InputMaybe<MyListList>;
  scope?: InputMaybe<MyListScope>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyObjectivesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ObjectiveStatus>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyOpportunitiesCustomBoardArgs = {
  filter?: InputMaybe<BoardFiltering>;
};


export type QueryMySharedListArgs = {
  listType: MyListList;
  listUid: Scalars['ID']['input'];
};


export type QueryMyStayInTouchArgs = {
  overDueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyTaskArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryMyTasksArgs = {
  dueOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  scope?: InputMaybe<MyTaskScope>;
  status?: InputMaybe<MyTaskStatus>;
};


export type QueryNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotesArgs = {
  filter?: InputMaybe<NoteFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryObjectiveArgs = {
  objectiveUuid: Scalars['ID']['input'];
};


export type QueryObjectiveManagementRolePermissionsArgs = {
  accessRoleUid: Scalars['ID']['input'];
};


export type QueryOfficeArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryOfficeLabelsArgs = {
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOfficesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpportunitiesForGridArgs = {
  filter?: InputMaybe<CompanyGoalFiltering>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryOpportunityArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryOpportunityAuditTrailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpportunityNotesArgs = {
  opportunityId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpportunityProjectsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOpportunityProjectsForUidArgs = {
  opportunityUid: Scalars['ID']['input'];
};


export type QueryOpportunityStatusChangeArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryOpportunityTagsArgs = {
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpportunityTrackingRolePermissionsArgs = {
  accessRoleUid: Scalars['ID']['input'];
};


export type QueryPersonArgs = {
  uid: Scalars['String']['input'];
};


export type QueryPersonNotesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  personUid: Scalars['String']['input'];
};


export type QueryProjectArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryProjectManagementRolePermissionsArgs = {
  accessRoleUid: Scalars['ID']['input'];
};


export type QueryProjectMembershipsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['ID']['input'];
};


export type QueryProjectNotesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['ID']['input'];
};


export type QueryProjectOpportunitiesArgs = {
  filter?: InputMaybe<CompanyGoalFiltering>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  projectUid: Scalars['ID']['input'];
};


export type QueryProjectOpportunityArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryProjectTaskArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryProjectTaskSectionsArgs = {
  projectUid: Scalars['String']['input'];
};


export type QueryProjectTasksArgs = {
  filter?: InputMaybe<ProjectTaskFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectsArgs = {
  folderUid?: InputMaybe<Scalars['ID']['input']>;
  nexlApps?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProspectEmailRequestArgs = {
  requestUid: Scalars['String']['input'];
};


export type QueryProspectSearchArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  headCount?: InputMaybe<HeadCountRange>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};


export type QueryReferralTrackingRolePermissionsArgs = {
  accessRoleUid: Scalars['ID']['input'];
};


export type QueryReminderSettingArgs = {
  reminderSettingUid: Scalars['ID']['input'];
};


export type QueryRemoteCustomFieldSchemaArgs = {
  campaignManagerUid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReportedIncorrectCompanyInfosArgs = {
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportedIncorrectInfosArgs = {
  filter?: InputMaybe<ReportedIncorrectInfosFiltering>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryResearchReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResearchReportSectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResearchReportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  researchReportableId?: InputMaybe<Scalars['ID']['input']>;
  researchReportableType?: InputMaybe<ResearchReportableTypeEnum>;
};


export type QueryResearchReportsRolePermissionsArgs = {
  accessRoleUid: Scalars['ID']['input'];
};


export type QuerySearchArgs = {
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchKind?: InputMaybe<SearchKind>;
  term: Scalars['String']['input'];
};


export type QuerySentReferralArgs = {
  sentReferralUid: Scalars['ID']['input'];
};


export type QuerySentReferralsArgs = {
  filter?: InputMaybe<SentReferralsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySharedMyListUsersArgs = {
  listType: MyListList;
  listUid: Scalars['ID']['input'];
};


export type QuerySharedTableLikeRowsArgs = {
  filtering?: InputMaybe<ColumnsFilteringInput>;
  ordering?: InputMaybe<Array<SortOrderInput>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  selectedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  source: TableLikeSourceInput;
};


export type QuerySourceTemplateProjectArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryTabArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryTableLikeColumnValueSuggestionsArgs = {
  category: ColumnValueSuggestionCategory;
  filter?: InputMaybe<SuggesterFilterInput>;
  limit: Scalars['Int']['input'];
  selectedColumnUid: Scalars['ID']['input'];
  source: TableLikeSourceInput;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTableLikeDefinitionArgs = {
  source: TableLikeSourceInput;
};


export type QueryTableLikeFilterSuggestionsArgs = {
  category?: InputMaybe<ColumnValueSuggestionCategory>;
  limit: Scalars['Int']['input'];
  selectedColumnUid: Scalars['ID']['input'];
  source: TableLikeSourceInput;
  text: Scalars['String']['input'];
};


export type QueryTableLikeRollupColumnsArgs = {
  projectUid: Scalars['ID']['input'];
  sourceListId?: InputMaybe<Scalars['ID']['input']>;
  sourceListType?: InputMaybe<TableLikeRollupSourceListTypeEnum>;
  sourceType?: InputMaybe<SourceTypeEnum>;
};


export type QueryTableLikeRollupFieldsArgs = {
  filters?: InputMaybe<RollupFieldFiltersInput>;
};


export type QueryTableLikeRowsArgs = {
  filtering?: InputMaybe<ColumnsFilteringInput>;
  ordering?: InputMaybe<Array<SortOrderInput>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  selectedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  source: TableLikeSourceInput;
};


export type QueryTabsArgs = {
  group?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  renderMode?: InputMaybe<TabRenderMode>;
};


export type QueryTagsArgs = {
  orderBy?: InputMaybe<TagOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskArgs = {
  taskUid: Scalars['ID']['input'];
};


export type QueryTasksArgs = {
  filter?: InputMaybe<TaskFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  primaryFilter?: InputMaybe<TaskPrimaryFilterInput>;
};


export type QueryTemplateProjectArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryTopClientCompanyListArgs = {
  employeeUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopContactListArgs = {
  employeeUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUiConfigurationArgs = {
  name: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnengagedContactsArgs = {
  filter?: InputMaybe<UnengagedContactsFiltering>;
  orderBy?: InputMaybe<UnengagedContactsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  scope: UsersScope;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersForSelectionArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWebhookEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWhoKnowsArgs = {
  contactUid?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WhoKnowsFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWhoPreviouslyKnewArgs = {
  contactUid: Scalars['String']['input'];
  filter?: InputMaybe<WhoKnowsFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ReSyncClientCompanyMutation. */
export type ReSyncClientCompanyMutationPayload = {
  __typename?: 'ReSyncClientCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RebuildKeyActivityMutation. */
export type RebuildKeyActivityMutationPayload = {
  __typename?: 'RebuildKeyActivityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  keyActivity: Maybe<KeyActivity>;
};

export type RecipientWarnings = {
  __typename?: 'RecipientWarnings';
  allRecipientsVerified: Scalars['Boolean']['output'];
  bouncedTotal: Scalars['Int']['output'];
  consentNotGivenTotal: Scalars['Int']['output'];
  consentUnsubscribedTotal: Scalars['Int']['output'];
  excludedContactsTotal: Scalars['Int']['output'];
  firstNameMissingTotal: Scalars['Int']['output'];
  lastNameMissingTotal: Scalars['Int']['output'];
};

/** marketing lists permissions */
export type ReferralTrackingPermission = {
  __typename?: 'ReferralTrackingPermission';
  exportReferrals: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

/** Autogenerated return type of RegisterDeviceTokenMagicBellMutation. */
export type RegisterDeviceTokenMagicBellMutationPayload = {
  __typename?: 'RegisterDeviceTokenMagicBellMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Relationship Partner of a Company */
export type RelationshipPartner = {
  __typename?: 'RelationshipPartner';
  company: Company;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  employee: Employee;
  id: Scalars['ID']['output'];
  interactionsLast: Maybe<LastAts>;
  interactionsTotal: Maybe<Totals>;
};

export type RelationshipPartnerList = {
  __typename?: 'RelationshipPartnerList';
  entries: Array<RelationshipPartner>;
  pageInfo: PagingInfo;
};

export type Reminder = {
  __typename?: 'Reminder';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  emailSentDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  reminderSetting: ReminderSetting;
  reminderSettingId: Scalars['ID']['output'];
};

export type ReminderSetting = {
  __typename?: 'ReminderSetting';
  dateProperty: Scalars['String']['output'];
  emailSubject: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owners: Array<ReminderSettingOwner>;
  reminderDays: Scalars['Int']['output'];
  timePreposition: ReminderSettingTimePreposition;
};

export type ReminderSettingOwner = {
  __typename?: 'ReminderSettingOwner';
  employee: Employee;
  id: Scalars['ID']['output'];
};

export enum ReminderSettingTimePreposition {
  After = 'AFTER',
  Before = 'BEFORE'
}

export type RemoteCustomFieldSchema = {
  __typename?: 'RemoteCustomFieldSchema';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optionChoices: Array<Scalars['String']['output']>;
  source: ConnectedListMappingSource;
  valueTypeEnum: CustomFieldSchemaValue;
};

export type RemoteCustomFieldSchemaList = {
  __typename?: 'RemoteCustomFieldSchemaList';
  entries: Array<RemoteCustomFieldSchema>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveBlockPageMutation. */
export type RemoveBlockPageMutationPayload = {
  __typename?: 'RemoveBlockPageMutationPayload';
  blockPage: Maybe<BlockPage>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveCommentMutation. */
export type RemoveCommentMutationPayload = {
  __typename?: 'RemoveCommentMutationPayload';
  comment: Maybe<Comment>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveCompanyDocumentMutation. */
export type RemoveCompanyDocumentMutationPayload = {
  __typename?: 'RemoveCompanyDocumentMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveCompanyFromExclusionListMutation. */
export type RemoveCompanyFromExclusionListMutationPayload = {
  __typename?: 'RemoveCompanyFromExclusionListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveCompanyFromHierarchyMutation. */
export type RemoveCompanyFromHierarchyMutationPayload = {
  __typename?: 'RemoveCompanyFromHierarchyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveCompanyKeyContactMutation. */
export type RemoveCompanyKeyContactMutationPayload = {
  __typename?: 'RemoveCompanyKeyContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveCompanyListMutation. */
export type RemoveCompanyListMutationPayload = {
  __typename?: 'RemoveCompanyListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveCompanyLogoMutation. */
export type RemoveCompanyLogoMutationPayload = {
  __typename?: 'RemoveCompanyLogoMutationPayload';
  company: Maybe<Company>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveCompanyRelationshipPartnerMutation. */
export type RemoveCompanyRelationshipPartnerMutationPayload = {
  __typename?: 'RemoveCompanyRelationshipPartnerMutationPayload';
  discarded: Maybe<RelationshipPartner>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveContactExclusionRuleMutation. */
export type RemoveContactExclusionRuleMutationPayload = {
  __typename?: 'RemoveContactExclusionRuleMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveContactFromRequireHierarchyPlacementMutation. */
export type RemoveContactFromRequireHierarchyPlacementMutationPayload = {
  __typename?: 'RemoveContactFromRequireHierarchyPlacementMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveCustomFieldSchemaMutation. */
export type RemoveCustomFieldSchemaMutationPayload = {
  __typename?: 'RemoveCustomFieldSchemaMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveDuplicateCompanyMutation. */
export type RemoveDuplicateCompanyMutationPayload = {
  __typename?: 'RemoveDuplicateCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveDuplicateContactMutation. */
export type RemoveDuplicateContactMutationPayload = {
  __typename?: 'RemoveDuplicateContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveEmailAddressMutation. */
export type RemoveEmailAddressMutationPayload = {
  __typename?: 'RemoveEmailAddressMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveGenericListItemsMutation. */
export type RemoveGenericListItemsMutationPayload = {
  __typename?: 'RemoveGenericListItemsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveKeyActivityMemberMutation. */
export type RemoveKeyActivityMemberMutationPayload = {
  __typename?: 'RemoveKeyActivityMemberMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  member: Maybe<KeyActivityListMember>;
};

/** Autogenerated return type of RemoveKeyActivityMutation. */
export type RemoveKeyActivityMutationPayload = {
  __typename?: 'RemoveKeyActivityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveListMutation. */
export type RemoveListMutationPayload = {
  __typename?: 'RemoveListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveMyListShareAccessMutation. */
export type RemoveMyListShareAccessMutationPayload = {
  __typename?: 'RemoveMyListShareAccessMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveOfficeLocationMutation. */
export type RemoveOfficeLocationMutationPayload = {
  __typename?: 'RemoveOfficeLocationMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveOptionMutation. */
export type RemoveOptionMutationPayload = {
  __typename?: 'RemoveOptionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemovePageTabMutation. */
export type RemovePageTabMutationPayload = {
  __typename?: 'RemovePageTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveProgressMutation. */
export type RemoveProgressMutationPayload = {
  __typename?: 'RemoveProgressMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveProjectDocumentMutation. */
export type RemoveProjectDocumentMutationPayload = {
  __typename?: 'RemoveProjectDocumentMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveProjectFolderMutation. */
export type RemoveProjectFolderMutationPayload = {
  __typename?: 'RemoveProjectFolderMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveProjectMembersMutation. */
export type RemoveProjectMembersMutationPayload = {
  __typename?: 'RemoveProjectMembersMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveProjectMutation. */
export type RemoveProjectMutationPayload = {
  __typename?: 'RemoveProjectMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveProjectNoteMutation. */
export type RemoveProjectNoteMutationPayload = {
  __typename?: 'RemoveProjectNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveProjectOpportunityMutation. */
export type RemoveProjectOpportunityMutationPayload = {
  __typename?: 'RemoveProjectOpportunityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveProjectTaskSectionMutation. */
export type RemoveProjectTaskSectionMutationPayload = {
  __typename?: 'RemoveProjectTaskSectionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveReminderSettingMutation. */
export type RemoveReminderSettingMutationPayload = {
  __typename?: 'RemoveReminderSettingMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RemoveTagMutation. */
export type RemoveTagMutationPayload = {
  __typename?: 'RemoveTagMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RenameTagMutation. */
export type RenameTagMutationPayload = {
  __typename?: 'RenameTagMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export enum RenderMode {
  ClientSide = 'CLIENT_SIDE',
  ServerSide = 'SERVER_SIDE'
}

/** Autogenerated return type of ReopenMyTaskMutation. */
export type ReopenMyTaskMutationPayload = {
  __typename?: 'ReopenMyTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  task: Maybe<MyTask>;
};

/** Autogenerated return type of ReopenTaskMutation. */
export type ReopenTaskMutationPayload = {
  __typename?: 'ReopenTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Task>;
};

/** Autogenerated return type of ReorderGenericListItemsMutation. */
export type ReorderGenericListItemsMutationPayload = {
  __typename?: 'ReorderGenericListItemsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ReportIncorrectCompanyDataMutation. */
export type ReportIncorrectCompanyDataMutationPayload = {
  __typename?: 'ReportIncorrectCompanyDataMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ReportIncorrectContactDataMutation. */
export type ReportIncorrectContactDataMutationPayload = {
  __typename?: 'ReportIncorrectContactDataMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type ReportedIncorrectCompanyInfo = {
  __typename?: 'ReportedIncorrectCompanyInfo';
  comment: Maybe<Scalars['String']['output']>;
  company: Company;
  fields: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reporter: User;
};

export type ReportedIncorrectCompanyInfoEntries = {
  __typename?: 'ReportedIncorrectCompanyInfoEntries';
  entries: Array<ReportedIncorrectCompanyInfo>;
  pageInfo: PagingInfo;
};

export type ReportedIncorrectInfo = {
  __typename?: 'ReportedIncorrectInfo';
  comment: Maybe<Scalars['String']['output']>;
  contact: Contact;
  fields: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reporter: UserInfo;
};

export type ReportedIncorrectInfoEntries = {
  __typename?: 'ReportedIncorrectInfoEntries';
  entries: Array<ReportedIncorrectInfo>;
  pageInfo: PagingInfo;
};

export type ReportedIncorrectInfosFiltering = {
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export enum RequestStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type ResearchReport = {
  __typename?: 'ResearchReport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  id: Scalars['ID']['output'];
  isDiscarded: Scalars['Boolean']['output'];
  researchReportable: Maybe<ResearchReportableUnion>;
  sections: Array<ResearchReportSection>;
  status: ResearchReportStatusEnum;
  tenant: Tenant;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ResearchReportEntries = {
  __typename?: 'ResearchReportEntries';
  entries: Array<ResearchReport>;
  pageInfo: PagingInfo;
};

export type ResearchReportSection = {
  __typename?: 'ResearchReportSection';
  aiPrompt: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fileSource: Maybe<File>;
  /** Deprecated: Use content */
  htmlForEditor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDiscarded: Scalars['Boolean']['output'];
  nexlSearchType: ResearchReportSectionNexlSearchTypeEnum;
  position: Scalars['Int']['output'];
  /** Deprecated: Use content */
  renderSafeHtml: Scalars['String']['output'];
  report: ResearchReport;
  sectionType: ResearchReportSectionTypeEnum;
  status: ResearchReportSectionStatusEnum;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  urlSources: Array<Scalars['String']['output']>;
  webSearchType: ResearchReportSectionWebSearchTypeEnum;
};

/** Research report section attributes */
export type ResearchReportSectionAttributes = {
  aiPrompt?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use content */
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  nexlSearchType?: InputMaybe<ResearchReportSectionNexlSearchTypeEnum>;
  /** Signed ID of an existing file to attach. */
  reportFileSignedId?: InputMaybe<Scalars['String']['input']>;
  sectionType?: InputMaybe<ResearchReportSectionTypeEnum>;
  status?: InputMaybe<ResearchReportSectionStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** A list of URL sources for the section. */
  urlSources?: InputMaybe<Array<Scalars['String']['input']>>;
  webSearchType?: InputMaybe<ResearchReportSectionWebSearchTypeEnum>;
};

export enum ResearchReportSectionNexlSearchTypeEnum {
  CompanyRelationships = 'COMPANY_RELATIONSHIPS',
  KeyActivities = 'KEY_ACTIVITIES',
  None = 'NONE',
  Opportunities = 'OPPORTUNITIES',
  PracticeAreaEngagement = 'PRACTICE_AREA_ENGAGEMENT',
  WhoKnowsWho = 'WHO_KNOWS_WHO'
}

export enum ResearchReportSectionStatusEnum {
  Draft = 'DRAFT',
  GeneratedDraft = 'GENERATED_DRAFT',
  InReview = 'IN_REVIEW',
  Verified = 'VERIFIED'
}

export enum ResearchReportSectionTypeEnum {
  Blank = 'BLANK',
  FileSummary = 'FILE_SUMMARY',
  NexlSearch = 'NEXL_SEARCH',
  WebSearch = 'WEB_SEARCH'
}

export enum ResearchReportSectionWebSearchTypeEnum {
  Blank = 'BLANK',
  Description = 'DESCRIPTION',
  FinancialPerformance = 'FINANCIAL_PERFORMANCE',
  GeographicReach = 'GEOGRAPHIC_REACH',
  LegalDepartment = 'LEGAL_DEPARTMENT',
  LegalNeeds = 'LEGAL_NEEDS',
  LitigationOverview = 'LITIGATION_OVERVIEW',
  News = 'NEWS',
  None = 'NONE',
  Strategy = 'STRATEGY',
  TransactionOverview = 'TRANSACTION_OVERVIEW'
}

export enum ResearchReportStatusEnum {
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Verified = 'VERIFIED'
}

export enum ResearchReportableTypeEnum {
  TenantCompany = 'TENANT_COMPANY'
}

export type ResearchReportableUnion = Company;

/** research reports permissions */
export type ResearchReportsPermission = {
  __typename?: 'ResearchReportsPermission';
  editCompanyReport: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  readCompanyReport: Scalars['Boolean']['output'];
};

/** Autogenerated return type of RestoreArchivedCompanyMutation. */
export type RestoreArchivedCompanyMutationPayload = {
  __typename?: 'RestoreArchivedCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RestoreBouncedEmailMutation. */
export type RestoreBouncedEmailMutationPayload = {
  __typename?: 'RestoreBouncedEmailMutationPayload';
  contact: Maybe<Contact>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of RestoreDiscardedListMembersMutation. */
export type RestoreDiscardedListMembersMutationPayload = {
  __typename?: 'RestoreDiscardedListMembersMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  members: Maybe<Array<ListMember>>;
};

/** Autogenerated return type of RestoreTemplateMutation. */
export type RestoreTemplateMutationPayload = {
  __typename?: 'RestoreTemplateMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  template: Maybe<Template>;
};

export type RichContent = {
  __typename?: 'RichContent';
  html: Scalars['String']['output'];
  plainText: Scalars['String']['output'];
  trixHtml: Scalars['String']['output'];
};

export type RichTextCell = {
  __typename?: 'RichTextCell';
  richText: Maybe<RichContent>;
};

export enum RoleCode {
  Admin = 'ADMIN',
  IndividualLawyer = 'INDIVIDUAL_LAWYER',
  Manager = 'MANAGER',
  Partner = 'PARTNER',
  RestrictedLawyer = 'RESTRICTED_LAWYER',
  Support = 'SUPPORT'
}

export type RollupFieldFiltersInput = {
  ownedById?: InputMaybe<Scalars['String']['input']>;
  ownedByType?: InputMaybe<TableLikeRollupOwnedByTypeEnum>;
  sourceListId?: InputMaybe<Scalars['String']['input']>;
  sourceListType?: InputMaybe<TableLikeRollupSourceListTypeEnum>;
};

export enum RowTypeEnum {
  Company = 'COMPANY',
  CompanyMember = 'COMPANY_MEMBER',
  Contact = 'CONTACT',
  ContactMember = 'CONTACT_MEMBER',
  ContactMemberEms = 'CONTACT_MEMBER_EMS',
  DataRecord = 'DATA_RECORD',
  GenericItem = 'GENERIC_ITEM',
  KeyActivityDashboard = 'KEY_ACTIVITY_DASHBOARD',
  KeyActivityMember = 'KEY_ACTIVITY_MEMBER',
  Opportunities = 'OPPORTUNITIES',
  ProjectOpportunity = 'PROJECT_OPPORTUNITY',
  SentReferrals = 'SENT_REFERRALS',
  SharedCompanyMember = 'SHARED_COMPANY_MEMBER',
  SharedContactMember = 'SHARED_CONTACT_MEMBER',
  SharedGenericItem = 'SHARED_GENERIC_ITEM',
  SharedKeyActivityMember = 'SHARED_KEY_ACTIVITY_MEMBER'
}

/** Autogenerated return type of SaveCampaignAsTemplateMutation. */
export type SaveCampaignAsTemplateMutationPayload = {
  __typename?: 'SaveCampaignAsTemplateMutationPayload';
  createdTemplate: Maybe<Template>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SaveCampaignRecipientListFilterMutation. */
export type SaveCampaignRecipientListFilterMutationPayload = {
  __typename?: 'SaveCampaignRecipientListFilterMutationPayload';
  campaignRecipientListFilter: Maybe<CampaignRecipientListFilter>;
  failReasons: Array<Scalars['String']['output']>;
};

export type SaveView = {
  __typename?: 'SaveView';
  filter: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
};

/** Autogenerated return type of ScheduleCampaignMutation. */
export type ScheduleCampaignMutationPayload = {
  __typename?: 'ScheduleCampaignMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  scheduledCampaign: Maybe<Campaign>;
};

export type SchemaOptionChoice = {
  __typename?: 'SchemaOptionChoice';
  colour: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orderRank: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export enum Scope {
  ColumnState = 'COLUMN_STATE',
  FilterModel = 'FILTER_MODEL',
  SearchState = 'SEARCH_STATE'
}

export enum SearchKind {
  Company = 'COMPANY',
  Contact = 'CONTACT'
}

export type SearchList = {
  __typename?: 'SearchList';
  entries: Array<SearchResult>;
  pageInfo: PagingInfo;
};

/** Objects which may be commented on */
export type SearchResult = Company | Contact;

export type SelectContactSearchFilter = {
  operator: SelectSearchOperator;
  property: SelectContactSearchableProperty;
  values: Array<Scalars['String']['input']>;
};

export enum SelectContactSearchableProperty {
  CompanyHierarchy = 'COMPANY_HIERARCHY',
  CompanyType = 'COMPANY_TYPE',
  ConsentStatus = 'CONSENT_STATUS',
  ContactStatus = 'CONTACT_STATUS',
  Industry = 'INDUSTRY',
  InternalIndustry = 'INTERNAL_INDUSTRY',
  KeyActivityTitle = 'KEY_ACTIVITY_TITLE',
  KnownBy = 'KNOWN_BY',
  ListMembership = 'LIST_MEMBERSHIP',
  MarketingListMembership = 'MARKETING_LIST_MEMBERSHIP',
  OfficeLocation = 'OFFICE_LOCATION',
  RelationshipPartner = 'RELATIONSHIP_PARTNER',
  WhoKnows = 'WHO_KNOWS'
}

export type SelectListMemberSearchFilter = {
  operator: SelectSearchOperator;
  property: SelectListMemberSearchableProperty;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SelectListMemberSearchableProperty {
  AddedBy = 'ADDED_BY'
}

export enum SelectSearchOperator {
  Is = 'IS',
  IsNot = 'IS_NOT'
}

/** Autogenerated return type of SendTestEmailMutation. */
export type SendTestEmailMutationPayload = {
  __typename?: 'SendTestEmailMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type Sender = {
  __typename?: 'Sender';
  /** @deprecated No longer used. */
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  replyTo: Scalars['String']['output'];
};

export type SentReferral = {
  __typename?: 'SentReferral';
  clientCompany: Maybe<Company>;
  clientContact: Maybe<Contact>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customFields: Array<CustomField>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalIdentifier: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  referredByEmployee: Employee;
  resultStatus: SentReferralResultStatus;
  sentAt: Scalars['ISO8601DateTime']['output'];
  sentToContact: Contact;
  typeOfLegalMatter: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SentReferralEntries = {
  __typename?: 'SentReferralEntries';
  entries: Array<SentReferral>;
  pageInfo: PagingInfo;
};

export enum SentReferralResultStatus {
  Sent = 'SENT',
  Successful = 'SUCCESSFUL',
  Unsuccessful = 'UNSUCCESSFUL'
}

/** Options for filtering by time */
export type SentReferralTimeFilter = {
  position: TimeFilterPosition;
  property: SentReferralTimeFilterProperty;
  value: Scalars['ISO8601DateTime']['input'];
};

export enum SentReferralTimeFilterProperty {
  Created = 'CREATED',
  Updated = 'UPDATED'
}

export type SentReferralsFilterInput = {
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  timeFilters?: InputMaybe<Array<SentReferralTimeFilter>>;
};

/** Autogenerated return type of SetAccountColourMutation. */
export type SetAccountColourMutationPayload = {
  __typename?: 'SetAccountColourMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SetCompanyListMemberCustomFieldMutation. */
export type SetCompanyListMemberCustomFieldMutationPayload = {
  __typename?: 'SetCompanyListMemberCustomFieldMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CompanyListMember>;
};

/** Autogenerated return type of SetCompanyLogoMutation. */
export type SetCompanyLogoMutationPayload = {
  __typename?: 'SetCompanyLogoMutationPayload';
  company: Maybe<Company>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SetInteractionsConfigMutation. */
export type SetInteractionsConfigMutationPayload = {
  __typename?: 'SetInteractionsConfigMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SetKeyActivityListMemberCustomFieldMutation. */
export type SetKeyActivityListMemberCustomFieldMutationPayload = {
  __typename?: 'SetKeyActivityListMemberCustomFieldMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<KeyActivityListMember>;
};

/** Autogenerated return type of SetListMemberCustomFieldMutation. */
export type SetListMemberCustomFieldMutationPayload = {
  __typename?: 'SetListMemberCustomFieldMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  gridMemberRecord: Maybe<ContactListGridMember>;
  record: Maybe<ListMember>;
};

/** Autogenerated return type of SetMyTimezoneMutation. */
export type SetMyTimezoneMutationPayload = {
  __typename?: 'SetMyTimezoneMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SetUiConfigurationMutation. */
export type SetUiConfigurationMutationPayload = {
  __typename?: 'SetUiConfigurationMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<UiConfig>;
};

/** Autogenerated return type of SetUserRoleMutation. */
export type SetUserRoleMutationPayload = {
  __typename?: 'SetUserRoleMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  user: Maybe<User>;
};

/** Autogenerated return type of ShareCompanyListMutation. */
export type ShareCompanyListMutationPayload = {
  __typename?: 'ShareCompanyListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ShareContactListMutation. */
export type ShareContactListMutationPayload = {
  __typename?: 'ShareContactListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ShareGenericListMutation. */
export type ShareGenericListMutationPayload = {
  __typename?: 'ShareGenericListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of ShareListViewMutation. */
export type ShareListViewMutationPayload = {
  __typename?: 'ShareListViewMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export enum SharedListViewPermission {
  Edit = 'EDIT',
  ReadOnly = 'READ_ONLY'
}

export type SharedMyListUser = {
  __typename?: 'SharedMyListUser';
  permission: MyListPermission;
  user: UserInfo;
};

export type SharedMyListUsers = {
  __typename?: 'SharedMyListUsers';
  entries: Array<SharedMyListUser>;
};

/** Autogenerated return type of ShowEmployeeMutation. */
export type ShowEmployeeMutationPayload = {
  __typename?: 'ShowEmployeeMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortOrderInput = {
  direction: SortDirectionEnum;
  orderOnUid: Scalars['ID']['input'];
};

export enum SourceTypeEnum {
  /** Rollup field is based on company lists */
  CompanyList = 'COMPANY_LIST',
  /** Rollup field is based on contact lists */
  ContactList = 'CONTACT_LIST',
  /** Rollup field is based on generic lists */
  GenericList = 'GENERIC_LIST',
  /** Rollup field is based on key activity lists */
  KeyActivityList = 'KEY_ACTIVITY_LIST',
  /** Rollup field is based on opportunities */
  Opportunities = 'OPPORTUNITIES'
}

/** Returns EverAfter status for the current tenant and user */
export type Status = {
  __typename?: 'Status';
  enabled: Scalars['Boolean']['output'];
  hasPersona: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  persona: Maybe<UserPersonaPersonaEnum>;
  personaLabel: Maybe<Scalars['String']['output']>;
  productAccountId: Maybe<Scalars['String']['output']>;
};

export enum StayInTouchFrequency {
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  SixMonthly = 'SIX_MONTHLY',
  ThreeMonthly = 'THREE_MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type StayInTouchReminder = {
  __typename?: 'StayInTouchReminder';
  companyUrl: Scalars['Url']['output'];
  contactFullName: Scalars['String']['output'];
  contactUrl: Scalars['Url']['output'];
  dueOn: Scalars['String']['output'];
  frequency: Scalars['String']['output'];
  lastInteractionOn: Maybe<Scalars['String']['output']>;
  stayInTouch: MyStayInTouch;
};


export type StayInTouchReminderDueOnArgs = {
  format: Scalars['String']['input'];
};


export type StayInTouchReminderLastInteractionOnArgs = {
  format: Scalars['String']['input'];
};

export type StayInTouchReminders = {
  __typename?: 'StayInTouchReminders';
  entries: Array<StayInTouchReminder>;
  total: Scalars['Int']['output'];
  viewAllUrl: Scalars['Url']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  connectedListUpdated: ConnectedList;
  eventPackRequestFinished: EventPackRequest;
  exportUpdated: Export;
  exportsUpdated: ExportsUpdatedPayload;
  linkedinPostRequestFinished: LinkedinPostRequest;
  marketingEmailRequestFinished: MarketingEmailRequest;
  progressTrackersUpdated: ProgressTrackersUpdatedPayload;
};


export type SubscriptionConnectedListUpdatedArgs = {
  listUid: Scalars['ID']['input'];
};


export type SubscriptionEventPackRequestFinishedArgs = {
  eventPackRequestUid: Scalars['ID']['input'];
};


export type SubscriptionExportUpdatedArgs = {
  exportUid: Scalars['ID']['input'];
};


export type SubscriptionLinkedinPostRequestFinishedArgs = {
  linkedinPostRequestUid: Scalars['ID']['input'];
};


export type SubscriptionMarketingEmailRequestFinishedArgs = {
  marketingEmailRequestUid: Scalars['ID']['input'];
};

/** Filter for suggester return values */
export type SuggesterFilterInput = {
  /** Search for records using ids */
  recordIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search for records using text */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SwitchAccountMutation. */
export type SwitchAccountMutationPayload = {
  __typename?: 'SwitchAccountMutationPayload';
  currentUser: User;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SyncCompanyHierarchyMutation. */
export type SyncCompanyHierarchyMutationPayload = {
  __typename?: 'SyncCompanyHierarchyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SyncConnectedListMembersMutation. */
export type SyncConnectedListMembersMutationPayload = {
  __typename?: 'SyncConnectedListMembersMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SyncEmployeeMutation. */
export type SyncEmployeeMutationPayload = {
  __typename?: 'SyncEmployeeMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SyncListActivitiesMutation. */
export type SyncListActivitiesMutationPayload = {
  __typename?: 'SyncListActivitiesMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SyncListMembersMutation. */
export type SyncListMembersMutationPayload = {
  __typename?: 'SyncListMembersMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SyncOutlookContactForUserMutation. */
export type SyncOutlookContactForUserMutationPayload = {
  __typename?: 'SyncOutlookContactForUserMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of SyncOutlookContactMutation. */
export type SyncOutlookContactMutationPayload = {
  __typename?: 'SyncOutlookContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type TabInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  renderMode?: InputMaybe<TabRenderMode>;
  uid: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type TabList = {
  __typename?: 'TabList';
  entries: Array<TabResult>;
  pageInfo: PagingInfo;
};

export enum TabRenderMode {
  Advanced = 'ADVANCED',
  Standard = 'STANDARD'
}

/** Tab Field Value */
export type TabResult = {
  __typename?: 'TabResult';
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['String']['output'];
  isAppTab: Scalars['Boolean']['output'];
  isWorkspaceTab: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pageResult: PageResult;
  position: Scalars['Int']['output'];
  renderMode: TabRenderMode;
};

export type TableCell = {
  __typename?: 'TableCell';
  column: Column;
  id: Scalars['ID']['output'];
  values: Array<TableCellValue>;
};

/** Table Cell Value */
export type TableCellValue = CompanyCell | CompanyOfficeLocationCell | ContactCell | CountryCell | CurrencyCell | DateOnlyCell | DateTimeCell | EmailCell | EmployeeCell | IntegerCell | ListCell | NullCell | RichTextCell | TextCell | UserCell;

export type TableLikeColumnValueSuggestionsEntries = {
  __typename?: 'TableLikeColumnValueSuggestionsEntries';
  entries: Array<TableCellValue>;
};

export type TableLikeDefinition = {
  __typename?: 'TableLikeDefinition';
  columns: Array<Column>;
  deleteable: Scalars['Boolean']['output'];
  exportable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  searchable: Scalars['Boolean']['output'];
  updatable: Scalars['Boolean']['output'];
};

export type TableLikeRollupColumn = {
  __typename?: 'TableLikeRollupColumn';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  valueType: ValueTypeEnum;
};

export type TableLikeRollupColumnsEntries = {
  __typename?: 'TableLikeRollupColumnsEntries';
  columns: Array<TableLikeRollupColumn>;
};

export type TableLikeRollupFieldEntries = {
  __typename?: 'TableLikeRollupFieldEntries';
  entries: Array<TableLikeRollupFieldType>;
};

export type TableLikeRollupFieldType = {
  __typename?: 'TableLikeRollupFieldType';
  conditions: Maybe<ColumnsFilteringOutput>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentValue: Scalars['String']['output'];
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operationType: OperationTypeEnum;
  ownedById: Scalars['ID']['output'];
  ownedByType: TableLikeRollupOwnedByTypeEnum;
  sourceListId: Maybe<Scalars['ID']['output']>;
  sourceListName: Maybe<Scalars['String']['output']>;
  sourceListType: Maybe<TableLikeRollupSourceListTypeEnum>;
  sourceType: SourceTypeEnum;
  targetColumnId: Maybe<Scalars['String']['output']>;
  targetColumnName: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Possible types for an owner of a rollup field */
export enum TableLikeRollupOwnedByTypeEnum {
  /** The rollup field is owned by a Project */
  Project = 'PROJECT'
}

/** Possible types for the source list of a rollup field */
export enum TableLikeRollupSourceListTypeEnum {
  /** The source for rollup is a Company List */
  CompanyList = 'COMPANY_LIST',
  /** The source for rollup is a Contact List */
  ContactList = 'CONTACT_LIST',
  /** The source for rollup is a Generic List */
  GenericList = 'GENERIC_LIST',
  /** The source for rollup is a Key Activity List */
  KeyActivityList = 'KEY_ACTIVITY_LIST',
  /** The source for rollup is a generic List */
  List = 'LIST'
}

export type TableLikeRow = {
  __typename?: 'TableLikeRow';
  cells: Array<TableCell>;
  id: Scalars['ID']['output'];
};

export type TableLikeRowEntries = {
  __typename?: 'TableLikeRowEntries';
  entries: Array<TableLikeRow>;
  pageInfo: PagingInfo;
};

export type TableLikeSourceInput = {
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  listUid?: InputMaybe<Scalars['ID']['input']>;
  listViewUid?: InputMaybe<Scalars['ID']['input']>;
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  rowType: RowTypeEnum;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  usedCount: Scalars['Int']['output'];
};

export type TagList = {
  __typename?: 'TagList';
  entries: Array<Tag>;
  pageInfo: PagingInfo;
};

export enum TagOrderBy {
  CountAsc = 'COUNT_ASC',
  CountDesc = 'COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type Task = {
  __typename?: 'Task';
  assignedTo: Maybe<Employee>;
  company: Maybe<Company>;
  companyListMember: Maybe<CompanyListMember>;
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  completer: Maybe<UserInfo>;
  contact: Maybe<Contact>;
  contactListMember: Maybe<ContactListGridMember>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Employee;
  description: Maybe<RichContent>;
  dueOn: Maybe<Scalars['ISO8601Date']['output']>;
  genericListMember: Maybe<GenericListItem>;
  id: Scalars['ID']['output'];
  position: Maybe<Scalars['Int']['output']>;
  priority: Maybe<PriorityEnum>;
  project: Maybe<Project>;
  projectTaskSection: Maybe<ProjectTaskSection>;
  requestedBy: Maybe<Employee>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TaskEntries = {
  __typename?: 'TaskEntries';
  entries: Array<Task>;
  pageInfo: PagingInfo;
};

/** Secondary options for filtering tasks */
export type TaskFiltering = {
  assignedToUid?: InputMaybe<Scalars['ID']['input']>;
  blockPageIdentifier?: InputMaybe<Scalars['ID']['input']>;
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  contactUid?: InputMaybe<Scalars['ID']['input']>;
  creatorUid?: InputMaybe<Scalars['ID']['input']>;
  delegated?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPending?: InputMaybe<Scalars['Boolean']['input']>;
  requestedByUid?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<TaskStatus>;
  timeFrame?: InputMaybe<TaskTimeFrameInput>;
};

export type TaskPrimaryFilterInput = {
  /** The type of the source */
  sourceType: TaskSourceType;
  /** The UID of the source */
  sourceUid: Scalars['ID']['input'];
};

export enum TaskSourceType {
  AssignedTo = 'ASSIGNED_TO',
  Company = 'COMPANY',
  CompanyListMember = 'COMPANY_LIST_MEMBER',
  Contact = 'CONTACT',
  ContactListMember = 'CONTACT_LIST_MEMBER',
  Creator = 'CREATOR',
  GenericListMember = 'GENERIC_LIST_MEMBER',
  /** Source uid will be the employee id */
  MyDelegatedTasks = 'MY_DELEGATED_TASKS',
  /** Source uid will be the employee id */
  MyTasks = 'MY_TASKS',
  Project = 'PROJECT',
  /**
   * if querying tasks on pages, use PROJECT and
   *                                                   filter { blockPagesIdentifier }
   */
  ProjectTaskSection = 'PROJECT_TASK_SECTION',
  RequestedBy = 'REQUESTED_BY'
}

export enum TaskStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum TaskTimeFrame {
  Overdue = 'OVERDUE',
  Today = 'TODAY',
  Upcoming = 'UPCOMING'
}

export type TaskTimeFrameInput = {
  timeFrame: TaskTimeFrame;
  todayStartTime: Scalars['ISO8601DateTime']['input'];
};

export type Template = {
  __typename?: 'Template';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  templateHtml: Maybe<Scalars['String']['output']>;
  templateJson: Maybe<Scalars['String']['output']>;
  thumbnail: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum TemplateFieldType {
  AnotherDataRecord = 'ANOTHER_DATA_RECORD',
  AssociationBigInt = 'ASSOCIATION_BIG_INT',
  AssociationUuid = 'ASSOCIATION_UUID',
  Currency = 'CURRENCY',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Number = 'NUMBER',
  Owner = 'OWNER',
  Select = 'SELECT',
  Text = 'TEXT',
  Unique = 'UNIQUE'
}

export type TemplateProject = {
  __typename?: 'TemplateProject';
  notes: Array<ProjectNote>;
  project: Project;
  tabs: Array<TabResult>;
  tasks: Array<Task>;
};

export type TemplateRolePermission = {
  __typename?: 'TemplateRolePermission';
  access: DataTemplatePermissionAccessEnum;
  accessRole: AccessRole;
  id: Scalars['ID']['output'];
  template: DataTemplate;
  visibility: DataTemplatePermissionVisibilityEnum;
};

export type TemplateSavedRow = {
  __typename?: 'TemplateSavedRow';
  content: Scalars['String']['output'];
  group: TemplateSavedRowGroup;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type TemplateSavedRowEntries = {
  __typename?: 'TemplateSavedRowEntries';
  entries: Array<TemplateSavedRow>;
  pageInfo: PagingInfo;
};

export type TemplateSavedRowGroup = {
  __typename?: 'TemplateSavedRowGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum TemplateStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type Templates = {
  __typename?: 'Templates';
  entries: Array<Template>;
  pageInfo: PagingInfo;
};

export type TemplatesFilterInput = {
  status?: InputMaybe<TemplateStatus>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  companyHierarchyCustomFields: Maybe<Array<CustomFieldSchema>>;
  contactInfoCustomFields: Maybe<Array<CustomFieldSchema>>;
  currency: Maybe<Currency>;
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  opportunityCustomFields: Maybe<Array<CustomFieldSchema>>;
  sentReferralCustomFields: Maybe<Array<CustomFieldSchema>>;
};

export type TenantConfig = {
  __typename?: 'TenantConfig';
  adminReportingEnabled: Scalars['Boolean']['output'];
  allowIndividualUserExport: Scalars['Boolean']['output'];
  allowPrivateContacts: Scalars['Boolean']['output'];
  currency: Maybe<Currency>;
  disallowMyContactsExport: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type TenantConfiguration = {
  __typename?: 'TenantConfiguration';
  clientAndGroupIds: Scalars['Boolean']['output'];
  companyTypes: Array<CompanyCustomType>;
  id: Scalars['ID']['output'];
  preferInternalIndustry: Scalars['Boolean']['output'];
  restrictTagCreation: Scalars['Boolean']['output'];
  showAllEmployeesTab: Scalars['Boolean']['output'];
  showInternalIndustries: Scalars['Boolean']['output'];
};

export type TextCell = {
  __typename?: 'TextCell';
  text: Maybe<Scalars['String']['output']>;
};

export type TextContactSearchFilter = {
  operator: TextSearchOperator;
  property: TextContactSearchableProperty;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum TextContactSearchableProperty {
  City = 'CITY',
  CompanyName = 'COMPANY_NAME',
  CompanyTags = 'COMPANY_TAGS',
  Country = 'COUNTRY',
  FirstName = 'FIRST_NAME',
  HeadquarterCity = 'HEADQUARTER_CITY',
  HeadquarterCountry = 'HEADQUARTER_COUNTRY',
  HeadquarterState = 'HEADQUARTER_STATE',
  JobTitle = 'JOB_TITLE',
  KeyActivityDescription = 'KEY_ACTIVITY_DESCRIPTION',
  KeyActivityType = 'KEY_ACTIVITY_TYPE',
  LastName = 'LAST_NAME',
  OfficeCity = 'OFFICE_CITY',
  OfficeCountry = 'OFFICE_COUNTRY',
  OfficeState = 'OFFICE_STATE',
  State = 'STATE',
  Tags = 'TAGS'
}

export type TextElement = {
  __typename?: 'TextElement';
  /** ID of the element (can be null when invalid) */
  id: Maybe<Scalars['ID']['output']>;
  /** The text to be displayed in the text element on the form */
  value: Scalars['String']['output'];
};

/** HTML Input Form Element Type */
export type TextElementInput = {
  /** The id of the form element */
  id?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
};

export enum TextSearchOperator {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  EndsWith = 'ENDS_WITH',
  HasAnyValue = 'HAS_ANY_VALUE',
  HasNoValue = 'HAS_NO_VALUE',
  Is = 'IS',
  IsNot = 'IS_NOT',
  IsOneOf = 'IS_ONE_OF',
  StartsWith = 'STARTS_WITH'
}

export enum TimeFilterPosition {
  After = 'AFTER',
  Before = 'BEFORE'
}

/** Time Range information */
export type TimeRange = {
  __typename?: 'TimeRange';
  endTime: Scalars['ISO8601DateTime']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
};

export type TimelineEntries = {
  __typename?: 'TimelineEntries';
  entries: Array<TimelineEvent>;
  pageInfo: PagingInfo;
};

export type TimelineEvent = {
  __typename?: 'TimelineEvent';
  action: Scalars['String']['output'];
  atTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item: EventItem;
};

export enum TitlesRecommendedGroupEnum {
  BuiltIn = 'BUILT_IN',
  ClientDefined = 'CLIENT_DEFINED'
}

export type TopClientCompany = {
  __typename?: 'TopClientCompany';
  company: Company;
  id: Scalars['ID']['output'];
  lastInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  monthlyEngagement: Array<CompanyMonthlyInteractionDist>;
};

export type TopClientCompanyList = {
  __typename?: 'TopClientCompanyList';
  entries: Array<TopClientCompany>;
  pageInfo: PagingInfo;
};

export type TopContact = {
  __typename?: 'TopContact';
  id: Scalars['ID']['output'];
  lastInteractionAt: Scalars['ISO8601DateTime']['output'];
  myContact: MyContact;
  numberOfInteractions: Scalars['Int']['output'];
};

export type TopContactList = {
  __typename?: 'TopContactList';
  entries: Array<TopContact>;
};

export type TotalWonOpportunities = {
  __typename?: 'TotalWonOpportunities';
  myOpportunitiesTabUrl: Scalars['Url']['output'];
  position: MoneyRank;
};

export type Totals = {
  __typename?: 'Totals';
  emails: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interactions: Scalars['Int']['output'];
  meetings: Scalars['Int']['output'];
  receivedEmails: Scalars['Int']['output'];
  sentEmails: Scalars['Int']['output'];
};

/** Autogenerated return type of TrackBouncedEmailMutation. */
export type TrackBouncedEmailMutationPayload = {
  __typename?: 'TrackBouncedEmailMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of TrackEmailMessageMutation. */
export type TrackEmailMessageMutationPayload = {
  __typename?: 'TrackEmailMessageMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of TrackPastMeetingMutation. */
export type TrackPastMeetingMutationPayload = {
  __typename?: 'TrackPastMeetingMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of TriggerApiSourceMutation. */
export type TriggerApiSourceMutationPayload = {
  __typename?: 'TriggerApiSourceMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export type UiConfig = {
  __typename?: 'UiConfig';
  configuration: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scope: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['String']['output']>;
};

export type UiConfiguration = {
  __typename?: 'UiConfiguration';
  configuration: Maybe<Scalars['String']['output']>;
  featureName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version: Maybe<Scalars['String']['output']>;
};

export type UiConfigurationAttributes = {
  /** configuration text */
  configuration: Scalars['String']['input'];
  /** additional text to scope the config */
  scope?: InputMaybe<Scope>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnarchiveContactMutation. */
export type UnarchiveContactMutationPayload = {
  __typename?: 'UnarchiveContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UnblockCompanyMutation. */
export type UnblockCompanyMutationPayload = {
  __typename?: 'UnblockCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UnblockDomainMutation. */
export type UnblockDomainMutationPayload = {
  __typename?: 'UnblockDomainMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UnblockEmailMutation. */
export type UnblockEmailMutationPayload = {
  __typename?: 'UnblockEmailMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Filtering Options for unengaged contacts */
export type UnengagedContactsFiltering = {
  term?: InputMaybe<Scalars['String']['input']>;
};

export enum UnengagedContactsOrderBy {
  ContactCreatedAtDesc = 'CONTACT_CREATED_AT_DESC',
  LastInteractionAtAsc = 'LAST_INTERACTION_AT_ASC',
  LastInteractionAtDesc = 'LAST_INTERACTION_AT_DESC'
}

/** Autogenerated return type of UninstallEmsConnectorMutation. */
export type UninstallEmsConnectorMutationPayload = {
  __typename?: 'UninstallEmsConnectorMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UnpinNoteMutation. */
export type UnpinNoteMutationPayload = {
  __typename?: 'UnpinNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpcomingMeeting = {
  __typename?: 'UpcomingMeeting';
  companies: Array<Company>;
  contacts: Array<Contact>;
  id: Scalars['ID']['output'];
  isCancelled: Scalars['Boolean']['output'];
  keyActivity: Maybe<KeyActivity>;
  sourceEventReference: Scalars['String']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
};

export type UpcomingMeetingList = {
  __typename?: 'UpcomingMeetingList';
  entries: Array<UpcomingMeeting>;
  pageInfo: PagingInfo;
};

/** Autogenerated return type of UpdateBlockPageListPositionsMutation. */
export type UpdateBlockPageListPositionsMutationPayload = {
  __typename?: 'UpdateBlockPageListPositionsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  pages: Array<BlockPage>;
};

/** Autogenerated return type of UpdateBlockPageMutation. */
export type UpdateBlockPageMutationPayload = {
  __typename?: 'UpdateBlockPageMutationPayload';
  blockPage: Maybe<BlockPage>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCampaignMutation. */
export type UpdateCampaignMutationPayload = {
  __typename?: 'UpdateCampaignMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  updatedCampaign: Maybe<Campaign>;
};

/** Autogenerated return type of UpdateCommentMutation. */
export type UpdateCommentMutationPayload = {
  __typename?: 'UpdateCommentMutationPayload';
  comment: Maybe<Comment>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCompanyDocumentMutation. */
export type UpdateCompanyDocumentMutationPayload = {
  __typename?: 'UpdateCompanyDocumentMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCompanyExclusionMutation. */
export type UpdateCompanyExclusionMutationPayload = {
  __typename?: 'UpdateCompanyExclusionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CompanyExclusion>;
};

/** Autogenerated return type of UpdateCompanyHierarchyMutation. */
export type UpdateCompanyHierarchyMutationPayload = {
  __typename?: 'UpdateCompanyHierarchyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCompanyListMutation. */
export type UpdateCompanyListMutationPayload = {
  __typename?: 'UpdateCompanyListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCompanyMutation. */
export type UpdateCompanyMutationPayload = {
  __typename?: 'UpdateCompanyMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Company>;
};

/** Autogenerated return type of UpdateCompanyNoteMutation. */
export type UpdateCompanyNoteMutationPayload = {
  __typename?: 'UpdateCompanyNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CompanyNote>;
};

/** Autogenerated return type of UpdateConnectedListMutation. */
export type UpdateConnectedListMutationPayload = {
  __typename?: 'UpdateConnectedListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateContactConsentMutation. */
export type UpdateContactConsentMutationPayload = {
  __typename?: 'UpdateContactConsentMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<ContactConsent>;
};

/** Autogenerated return type of UpdateContactCustomFieldMutation. */
export type UpdateContactCustomFieldMutationPayload = {
  __typename?: 'UpdateContactCustomFieldMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateContactEmailsMutation. */
export type UpdateContactEmailsMutationPayload = {
  __typename?: 'UpdateContactEmailsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Contact>;
};

/** Autogenerated return type of UpdateContactExclusionRuleMutation. */
export type UpdateContactExclusionRuleMutationPayload = {
  __typename?: 'UpdateContactExclusionRuleMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateContactMutation. */
export type UpdateContactMutationPayload = {
  __typename?: 'UpdateContactMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Contact>;
};

/** Autogenerated return type of UpdateCoreRolePermissionMutation. */
export type UpdateCoreRolePermissionMutationPayload = {
  __typename?: 'UpdateCoreRolePermissionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCustomFieldSchemaMutation. */
export type UpdateCustomFieldSchemaMutationPayload = {
  __typename?: 'UpdateCustomFieldSchemaMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CustomFieldSchema>;
};

/** Autogenerated return type of UpdateCustomFieldSchemaPositionsMutation. */
export type UpdateCustomFieldSchemaPositionsMutationPayload = {
  __typename?: 'UpdateCustomFieldSchemaPositionsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateCustomFieldSchemaValuesMutation. */
export type UpdateCustomFieldSchemaValuesMutationPayload = {
  __typename?: 'UpdateCustomFieldSchemaValuesMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateEnrichmentRolePermissionMutation. */
export type UpdateEnrichmentRolePermissionMutationPayload = {
  __typename?: 'UpdateEnrichmentRolePermissionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export enum UpdateEvent {
  JobChange = 'JOB_CHANGE',
  JobTitleChange = 'JOB_TITLE_CHANGE'
}

export type UpdateEventChange = JobChangeUpdate | JobTitleUpdate;

/** Autogenerated return type of UpdateFormConfirmationSettingsMutation. */
export type UpdateFormConfirmationSettingsMutationPayload = {
  __typename?: 'UpdateFormConfirmationSettingsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateFormExpiryMutation. */
export type UpdateFormExpiryMutationPayload = {
  __typename?: 'UpdateFormExpiryMutationPayload';
  /** The updated expiry settings */
  expirySettings: Maybe<FormExpirySettings>;
  /** Reasons for failure if unsuccessful */
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateFormInfoMutation. */
export type UpdateFormInfoMutationPayload = {
  __typename?: 'UpdateFormInfoMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Form>;
};

/** Autogenerated return type of UpdateFormKeyActivitySettingsMutation. */
export type UpdateFormKeyActivitySettingsMutationPayload = {
  __typename?: 'UpdateFormKeyActivitySettingsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateFormMutation. */
export type UpdateFormMutationPayload = {
  __typename?: 'UpdateFormMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Form>;
};

/** Autogenerated return type of UpdateFormSettingsMutation. */
export type UpdateFormSettingsMutationPayload = {
  __typename?: 'UpdateFormSettingsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  updatedForm: Maybe<Form>;
};

/** Autogenerated return type of UpdateFormWaitlistMutation. */
export type UpdateFormWaitlistMutationPayload = {
  __typename?: 'UpdateFormWaitlistMutationPayload';
  /** Reasons for failure if unsuccessful */
  failReasons: Array<Scalars['String']['output']>;
  /** The updated waitlist settings */
  waitlistSettings: Maybe<FormWaitlistSettings>;
};

/** Autogenerated return type of UpdateFormWorkflowMutation. */
export type UpdateFormWorkflowMutationPayload = {
  __typename?: 'UpdateFormWorkflowMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  workflow: Maybe<Workflow>;
};

/** Autogenerated return type of UpdateGenericListItemsMutation. */
export type UpdateGenericListItemsMutationPayload = {
  __typename?: 'UpdateGenericListItemsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  records: Array<GenericListItem>;
};

/** Autogenerated return type of UpdateGenericListMutation. */
export type UpdateGenericListMutationPayload = {
  __typename?: 'UpdateGenericListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateIndustryMappingMutation. */
export type UpdateIndustryMappingMutationPayload = {
  __typename?: 'UpdateIndustryMappingMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateInteractionsRolePermissionMutation. */
export type UpdateInteractionsRolePermissionMutationPayload = {
  __typename?: 'UpdateInteractionsRolePermissionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateKeyActivityMutation. */
export type UpdateKeyActivityMutationPayload = {
  __typename?: 'UpdateKeyActivityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<KeyActivity>;
};

/** Autogenerated return type of UpdateListMutation. */
export type UpdateListMutationPayload = {
  __typename?: 'UpdateListMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  list: List;
};

/** Autogenerated return type of UpdateListViewMutation. */
export type UpdateListViewMutationPayload = {
  __typename?: 'UpdateListViewMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  listView: Maybe<ListView>;
};

/** Autogenerated return type of UpdateMarketingListsConfigurationMutation. */
export type UpdateMarketingListsConfigurationMutationPayload = {
  __typename?: 'UpdateMarketingListsConfigurationMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateMarketingListsRolePermissionMutation. */
export type UpdateMarketingListsRolePermissionMutationPayload = {
  __typename?: 'UpdateMarketingListsRolePermissionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateMyTaskMutation. */
export type UpdateMyTaskMutationPayload = {
  __typename?: 'UpdateMyTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  task: Maybe<MyTask>;
};

/** Autogenerated return type of UpdateNoteMutation. */
export type UpdateNoteMutationPayload = {
  __typename?: 'UpdateNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  note: Maybe<Note>;
};

/** Autogenerated return type of UpdateObjectiveManagementRolePermissionMutation. */
export type UpdateObjectiveManagementRolePermissionMutationPayload = {
  __typename?: 'UpdateObjectiveManagementRolePermissionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateObjectiveMutation. */
export type UpdateObjectiveMutationPayload = {
  __typename?: 'UpdateObjectiveMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateOfficeLocationMutation. */
export type UpdateOfficeLocationMutationPayload = {
  __typename?: 'UpdateOfficeLocationMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<CompanyOfficeLocation>;
};

/** Autogenerated return type of UpdateOpportunityTrackingRolePermissionMutation. */
export type UpdateOpportunityTrackingRolePermissionMutationPayload = {
  __typename?: 'UpdateOpportunityTrackingRolePermissionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateOptionMutation. */
export type UpdateOptionMutationPayload = {
  __typename?: 'UpdateOptionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdatePageTabsMutation. */
export type UpdatePageTabsMutationPayload = {
  __typename?: 'UpdatePageTabsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  tabs: Maybe<Array<TabResult>>;
};

/** Autogenerated return type of UpdatePageViewTabMutation. */
export type UpdatePageViewTabMutationPayload = {
  __typename?: 'UpdatePageViewTabMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdatePersonMutation. */
export type UpdatePersonMutationPayload = {
  __typename?: 'UpdatePersonMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateProgressMutation. */
export type UpdateProgressMutationPayload = {
  __typename?: 'UpdateProgressMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateProjectDocumentMutation. */
export type UpdateProjectDocumentMutationPayload = {
  __typename?: 'UpdateProjectDocumentMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateProjectFolderMutation. */
export type UpdateProjectFolderMutationPayload = {
  __typename?: 'UpdateProjectFolderMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateProjectManagementRolePermissionMutation. */
export type UpdateProjectManagementRolePermissionMutationPayload = {
  __typename?: 'UpdateProjectManagementRolePermissionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateProjectMutation. */
export type UpdateProjectMutationPayload = {
  __typename?: 'UpdateProjectMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateProjectNoteMutation. */
export type UpdateProjectNoteMutationPayload = {
  __typename?: 'UpdateProjectNoteMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateProjectOpportunityMutation. */
export type UpdateProjectOpportunityMutationPayload = {
  __typename?: 'UpdateProjectOpportunityMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<ProjectOpportunityGrid>;
};

/** Autogenerated return type of UpdateProjectTaskSectionMutation. */
export type UpdateProjectTaskSectionMutationPayload = {
  __typename?: 'UpdateProjectTaskSectionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<ProjectTaskSection>;
};

/** Autogenerated return type of UpdateProjectTaskSectionPositionsMutation. */
export type UpdateProjectTaskSectionPositionsMutationPayload = {
  __typename?: 'UpdateProjectTaskSectionPositionsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  updatedProjectTaskSections: Maybe<Array<ProjectTaskSection>>;
};

/** Autogenerated return type of UpdateReferralTrackingRolePermissionMutation. */
export type UpdateReferralTrackingRolePermissionMutationPayload = {
  __typename?: 'UpdateReferralTrackingRolePermissionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateReminderSettingMutation. */
export type UpdateReminderSettingMutationPayload = {
  __typename?: 'UpdateReminderSettingMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateReportMutation. */
export type UpdateReportMutationPayload = {
  __typename?: 'UpdateReportMutationPayload';
  /** Errors encountered during update. */
  failReasons: Array<Scalars['String']['output']>;
  /** The updated report. */
  report: Maybe<ResearchReport>;
};

/** Autogenerated return type of UpdateReportSectionMutation. */
export type UpdateReportSectionMutationPayload = {
  __typename?: 'UpdateReportSectionMutationPayload';
  /** Errors encountered during update. */
  failReasons: Array<Scalars['String']['output']>;
  /** The updated report section. */
  reportSection: Maybe<ResearchReportSection>;
};

/** Autogenerated return type of UpdateReportSectionPositionsMutation. */
export type UpdateReportSectionPositionsMutationPayload = {
  __typename?: 'UpdateReportSectionPositionsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  /** The report sections in their new order. Null if the operation failed. */
  reportSections: Maybe<Array<ResearchReportSection>>;
};

/** Autogenerated return type of UpdateResearchReportsRolePermissionMutation. */
export type UpdateResearchReportsRolePermissionMutationPayload = {
  __typename?: 'UpdateResearchReportsRolePermissionMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateRoleMutation. */
export type UpdateRoleMutationPayload = {
  __typename?: 'UpdateRoleMutationPayload';
  accessRole: Maybe<AccessRole>;
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateSentReferralMutation. */
export type UpdateSentReferralMutationPayload = {
  __typename?: 'UpdateSentReferralMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<SentReferral>;
};

/** Autogenerated return type of UpdateSyncListRequestMutation. */
export type UpdateSyncListRequestMutationPayload = {
  __typename?: 'UpdateSyncListRequestMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateTableLikeRollupFieldMutation. */
export type UpdateTableLikeRollupFieldMutationPayload = {
  __typename?: 'UpdateTableLikeRollupFieldMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  rollupField: Maybe<TableLikeRollupFieldType>;
};

/** Autogenerated return type of UpdateTableLikeRowsMutation. */
export type UpdateTableLikeRowsMutationPayload = {
  __typename?: 'UpdateTableLikeRowsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  progressTracker: Maybe<ProgressTracker>;
  rowIdsUpdated: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of UpdateTagsOnCompaniesMutation. */
export type UpdateTagsOnCompaniesMutationPayload = {
  __typename?: 'UpdateTagsOnCompaniesMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  infos: Array<CompanyInfo>;
};

/** Autogenerated return type of UpdateTagsOnContactsMutation. */
export type UpdateTagsOnContactsMutationPayload = {
  __typename?: 'UpdateTagsOnContactsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  infos: Array<ContactInfo>;
};

/** Autogenerated return type of UpdateTaskMutation. */
export type UpdateTaskMutationPayload = {
  __typename?: 'UpdateTaskMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  record: Maybe<Task>;
};

/** Autogenerated return type of UpdateTaskPositionsMutation. */
export type UpdateTaskPositionsMutationPayload = {
  __typename?: 'UpdateTaskPositionsMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  updatedTasks: Maybe<Array<Task>>;
};

/** Autogenerated return type of UpdateTemplateMutation. */
export type UpdateTemplateMutationPayload = {
  __typename?: 'UpdateTemplateMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  template: Maybe<Template>;
};

/** Autogenerated return type of UpdateThemeForFormMutation. */
export type UpdateThemeForFormMutationPayload = {
  __typename?: 'UpdateThemeForFormMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  form: Maybe<Form>;
};

/** Autogenerated return type of UpdateUserMutation. */
export type UpdateUserMutationPayload = {
  __typename?: 'UpdateUserMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  user: Maybe<User>;
};

export enum UsageMode {
  Marketing = 'MARKETING',
  Personal = 'PERSONAL',
  Project = 'PROJECT',
  Tab = 'TAB'
}

export enum UsageModeFilter {
  Marketing = 'MARKETING',
  Personal = 'PERSONAL',
  Project = 'PROJECT'
}

export enum UsageModeInput {
  Marketing = 'MARKETING',
  Personal = 'PERSONAL',
  Project = 'PROJECT'
}

export type User = {
  __typename?: 'User';
  accessRole: Maybe<AccessRole>;
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchiveContactsAndCompanies: Scalars['Boolean']['output'];
  canUpdateCompanyName: Scalars['Boolean']['output'];
  canViewActivityViewDetail: Scalars['Boolean']['output'];
  canViewEmbeddedReport: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  employee: Maybe<Employee>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLoginAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  profileImageUrl: Maybe<Scalars['String']['output']>;
  profileName: Scalars['String']['output'];
  role: RoleCode;
  userId: Scalars['ID']['output'];
};

export type UserCard = {
  __typename?: 'UserCard';
  contactId: Maybe<Scalars['Int']['output']>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Maybe<Scalars['ContactEmailScalar']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type UserCell = {
  __typename?: 'UserCell';
  userCard: Maybe<UserCard>;
};

export type UserDelegateAccess = {
  __typename?: 'UserDelegateAccess';
  colour: AccountColour;
  delegateUserInfo: UserInfo;
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export type UserDelegateAccessEntries = {
  __typename?: 'UserDelegateAccessEntries';
  entries: Array<UserDelegateAccess>;
  pageInfo: PagingInfo;
};

export type UserEntries = {
  __typename?: 'UserEntries';
  adminEntries: Array<User>;
  entries: Array<UserInfo>;
  pageInfo: PagingInfo;
};

export type UserGrid = {
  __typename?: 'UserGrid';
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  /** @deprecated No longer available */
  canArchiveContactsAndCompanies: Scalars['String']['output'];
  /** @deprecated No longer available */
  canUpdateCompanyName: Scalars['String']['output'];
  /** @deprecated No longer available */
  canViewActivityViewDetail: Scalars['String']['output'];
  email: Scalars['String']['output'];
  employee: Maybe<Employee>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  profileImageUrl: Maybe<Scalars['String']['output']>;
  profileName: Scalars['String']['output'];
  role: RoleCode;
  userId: Scalars['ID']['output'];
};

/** Persona options for EverAfter user personas */
export enum UserPersonaPersonaEnum {
  Admin = 'ADMIN',
  BusinessDevelopment = 'BUSINESS_DEVELOPMENT',
  Lawyer = 'LAWYER',
  Marketing = 'MARKETING',
  Support = 'SUPPORT'
}

export type UserResponse = {
  __typename?: 'UserResponse';
  card: UserCard;
  info: UserInfo;
};

export type UserSelection = {
  __typename?: 'UserSelection';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  profileImageUrl: Maybe<Scalars['String']['output']>;
  profileName: Scalars['String']['output'];
};

export type UserSelectionEntries = {
  __typename?: 'UserSelectionEntries';
  entries: Array<UserSelection>;
  pageInfo: PagingInfo;
};

export enum UsersScope {
  Active = 'ACTIVE',
  All = 'ALL'
}

export enum ValueTypeEnum {
  Association = 'ASSOCIATION',
  Boolean = 'BOOLEAN',
  Country = 'COUNTRY',
  Currency = 'CURRENCY',
  Datetime = 'DATETIME',
  DateOnly = 'DATE_ONLY',
  Email = 'EMAIL',
  Number = 'NUMBER',
  RichText = 'RICH_TEXT',
  Select = 'SELECT',
  Text = 'TEXT'
}

export type Verification = {
  __typename?: 'Verification';
  contact: Contact;
  id: Maybe<Scalars['ID']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  result: Maybe<VerificationResult>;
  risk: Maybe<VerificationRisk>;
};

export enum VerificationContactStatus {
  Bounced = 'BOUNCED',
  ConsentNotGiven = 'CONSENT_NOT_GIVEN',
  Total = 'TOTAL',
  Unengaged = 'UNENGAGED',
  UserUnsubscribed = 'USER_UNSUBSCRIBED'
}

export type VerificationFilterInput = {
  contactStatus?: InputMaybe<VerificationContactStatus>;
  risk?: InputMaybe<VerificationRisk>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export enum VerificationResult {
  CatchAll = 'CATCH_ALL',
  Deliverable = 'DELIVERABLE',
  DoNotSend = 'DO_NOT_SEND',
  Undeliverable = 'UNDELIVERABLE',
  Unknown = 'UNKNOWN'
}

export enum VerificationRisk {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Unknown = 'UNKNOWN'
}

export type Verifications = {
  __typename?: 'Verifications';
  clean: Maybe<Clean>;
  entries: Array<Verification>;
  pageInfo: PagingInfo;
};

export type VerifiedProspectDetails = {
  __typename?: 'VerifiedProspectDetails';
  country: Maybe<Country>;
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  linkedinUrl: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  twitterUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of VerifyProspectMutation. */
export type VerifyProspectMutationPayload = {
  __typename?: 'VerifyProspectMutationPayload';
  /** This will be null if prospect is not valid */
  verifiedDetails: Maybe<VerifiedProspectDetails>;
};

export type WaitlistCondition = {
  __typename?: 'WaitlistCondition';
  operator: Maybe<WaitlistConditionOperatorEnum>;
  /** The rollup field used for the waitlist condition */
  rollupField: Maybe<TableLikeRollupFieldType>;
  value: Maybe<Scalars['Int']['output']>;
};

/** Input type for waitlist condition */
export type WaitlistConditionInput = {
  /** Comparison operator to use */
  operator: WaitlistConditionOperatorEnum;
  /** ID of the rollup field to use for waitlist condition */
  rollupFieldId: Scalars['ID']['input'];
  /** Threshold value for comparison */
  value: Scalars['Int']['input'];
};

/** Operators for waitlist condition comparison */
export enum WaitlistConditionOperatorEnum {
  /** Greater than or equal to the threshold value */
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL'
}

export type WebhookEvent = {
  __typename?: 'WebhookEvent';
  destinationUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['String']['output'];
  triggerEvent: WebhookTriggerEvent;
};

export type WebhookEventEntries = {
  __typename?: 'WebhookEventEntries';
  entries: Array<WebhookEvent>;
  pageInfo: PagingInfo;
};

export type WebhookTrigger = {
  __typename?: 'WebhookTrigger';
  id: Maybe<Scalars['ID']['output']>;
};

export enum WebhookTriggerEvent {
  GenericListsItemCreated = 'GENERIC_LISTS_ITEM_CREATED',
  ListsContactMembersRemoved = 'LISTS_CONTACT_MEMBERS_REMOVED',
  ListsContactMembersUpdated = 'LISTS_CONTACT_MEMBERS_UPDATED',
  ListsContactMemberCreated = 'LISTS_CONTACT_MEMBER_CREATED',
  MarketingListsSyncRequest = 'MARKETING_LISTS_SYNC_REQUEST',
  OpportunityTrackingStatusChanged = 'OPPORTUNITY_TRACKING_STATUS_CHANGED'
}

export type WhoKnows = {
  __typename?: 'WhoKnows';
  contact: Contact;
  contactCard: ContactCard;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastInteraction: Scalars['ISO8601DateTime']['output'];
  numberOfInteractions: Scalars['Int']['output'];
  ownerContactCard: ContactCard;
};

export enum WhoKnowsCategory {
  Colleagues = 'COLLEAGUES',
  Employees = 'EMPLOYEES',
  ThirdParty = 'THIRD_PARTY'
}

export type WhoKnowsFiltering = {
  /** Company domain or company id */
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  connectionCategory?: InputMaybe<WhoKnowsCategory>;
};

export type WhoKnowsList = {
  __typename?: 'WhoKnowsList';
  entries: Array<WhoKnows>;
  pageInfo: PagingInfo;
};

export type WhoPreviouslyKnew = {
  __typename?: 'WhoPreviouslyKnew';
  previousContact: Contact;
  whoKnew: Array<WhoKnows>;
};

export type WhoPreviouslyKnewList = {
  __typename?: 'WhoPreviouslyKnewList';
  entries: Array<WhoPreviouslyKnew>;
  pageInfo: PagingInfo;
};

export type Workflow = {
  __typename?: 'Workflow';
  /** The conditions for the workflow */
  conditions: Maybe<Array<WorkflowCondition>>;
  /** ID of the workflow */
  id: Scalars['ID']['output'];
  /** The recipient associated with this form (eg. contact list, or EMS campaign) */
  recipient: Maybe<WorkflowRecipient>;
  /** Deprecated: using UserSelectionType instead on subscribed_users_v2 */
  subscribedUsers: Maybe<Array<User>>;
  /** Users subscribed to this workflow */
  subscribedUsersV2: Maybe<Array<UserSelection>>;
  /** Deprecated: using UserSelectionType instead on subscribed_users_v2 */
  subscribers: Maybe<Array<UserInfo>>;
  /** The type of workflow to create */
  taskType: Maybe<WorkflowTask>;
};

export type WorkflowCondition = {
  __typename?: 'WorkflowCondition';
  /** The value of the condition */
  conditionValue: Scalars['String']['output'];
  /** The form field to which the condition is applied */
  customFieldSchema: CustomFieldSchema;
  /** ID of the workflow */
  id: Scalars['ID']['output'];
};

export type WorkflowConditionInput = {
  /** The value of the condition to check for */
  conditionValue: Scalars['String']['input'];
  /** The custom field id to which the condition is applied */
  customFieldSchemaId: Scalars['ID']['input'];
};

/** Contact list, or EMS campaign fields value */
export type WorkflowRecipient = Campaign | List;

export enum WorkflowTask {
  AddToList = 'ADD_TO_LIST',
  FollowUpCampaign = 'FOLLOW_UP_CAMPAIGN',
  SendNotification = 'SEND_NOTIFICATION'
}

export type DocumentUploadBlockQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type DocumentUploadBlockQuery = { __typename?: 'Query', blockPagesFixActiveStorageUrl: { __typename?: 'FixActiveStorageUrlResult', failReasons: Array<string>, fixedUrl: string | null } };

export type ImagesBlockQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type ImagesBlockQuery = { __typename?: 'Query', blockPagesFixActiveStorageUrl: { __typename?: 'FixActiveStorageUrlResult', failReasons: Array<string>, fixedUrl: string | null } };

export type RollupFieldBlockTableQueryVariables = Exact<{
  filters: RollupFieldFiltersInput;
}>;


export type RollupFieldBlockTableQuery = { __typename?: 'Query', tableLikeRollupFields: { __typename?: 'TableLikeRollupFieldEntries', entries: Array<{ __typename?: 'TableLikeRollupFieldType', id: string, name: string, sourceListName: string | null, currentValue: string, sourceType: SourceTypeEnum }> } };

export type RollupFieldBlockTableRowFragment = { __typename?: 'TableLikeRollupFieldType', id: string, name: string, sourceListName: string | null, currentValue: string, sourceType: SourceTypeEnum };

export type BlockPageListQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type BlockPageListQuery = { __typename?: 'Query', blockPageList: { __typename?: 'BlockPageList', id: string, name: string, pages: Array<{ __typename?: 'BlockPage', id: string, name: string | null, iconCode: string | null, discardedAt: string | null, position: number | null }> } | null };

export type BlockPagePagesFragment = { __typename?: 'BlockPage', id: string, name: string | null, iconCode: string | null, discardedAt: string | null, position: number | null };

export type UpdateEmailMarketingCampaignSettingsMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  continuous?: InputMaybe<Scalars['Boolean']['input']>;
  openTracking?: InputMaybe<Scalars['Boolean']['input']>;
  clickTracking?: InputMaybe<Scalars['Boolean']['input']>;
  allowContinuousResend?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateEmailMarketingCampaignSettingsMutation = { __typename?: 'Mutation', updateEmailMarketingCampaign: { __typename?: 'UpdateCampaignMutationPayload', failReasons: Array<string>, updatedCampaign: { __typename?: 'Campaign', projectUrl: string, id: string, title: string, subject: string | null, templateHtml: string | null, templateJson: string | null, scheduledAt: string | null, status: CampaignStatus, usageMode: CampaignUsage | null, continuous: boolean, allowContinuousResend: boolean, openTracking: boolean, clickTracking: boolean, sender: { __typename?: 'Sender', id: string, email: string, replyTo: string } | null, createdBy: { __typename?: 'User', email: string }, recipientList: { __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, percentUnsubscribed: number, percentSkipped: number, percentFailed: number, percentComplained: number, totalFailed: number, totalClicked: number, totalDelivered: number, totalOpened: number, totalRecipients: number, totalUnsubscribed: number, totalSkipped: number, totalComplained: number, totalAccepted: number } | null, attachment: { __typename?: 'File', name: string, url: string, contentType: string | null } | null, recipientListFilter: { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } } | null } | null } | null };

export type CreateCommentMutationVariables = Exact<{
  commentThreadUid: Scalars['ID']['input'];
  htmlContent: Scalars['String']['input'];
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', addCommentToCommentThread: { __typename?: 'AddCommentToCommentThreadMutationPayload', failReasons: Array<string>, comment: { __typename?: 'Comment', id: string, htmlForEditor: string, renderSafeHtml: string, edited: boolean, createdAt: string, discardedAt: string | null, creator: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } } | null } | null };

export type RemoveCommentMutationVariables = Exact<{
  commentUid: Scalars['ID']['input'];
}>;


export type RemoveCommentMutation = { __typename?: 'Mutation', removeComment: { __typename?: 'RemoveCommentMutationPayload', failReasons: Array<string>, comment: { __typename?: 'Comment', id: string, discardedAt: string | null } | null } | null };

export type UpdateCommentMutationVariables = Exact<{
  commentUid: Scalars['ID']['input'];
  htmlContent: Scalars['String']['input'];
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'UpdateCommentMutationPayload', failReasons: Array<string>, comment: { __typename?: 'Comment', id: string, htmlForEditor: string, renderSafeHtml: string, edited: boolean } | null } | null };

export type CommentPreviewFragment = { __typename?: 'Comment', id: string, htmlForEditor: string, renderSafeHtml: string, edited: boolean, createdAt: string, discardedAt: string | null, creator: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } };

export type CommentThreadQueryVariables = Exact<{
  commentThreadUid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommentThreadQuery = { __typename?: 'Query', commentThread: { __typename?: 'CommentThreadComments', pageInfo: { __typename?: 'PagingInfo', totalEntries: number }, entries: Array<{ __typename?: 'Comment', id: string, htmlForEditor: string, renderSafeHtml: string, edited: boolean, createdAt: string, discardedAt: string | null, creator: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } }> }, currentUser: { __typename?: 'User', id: string, userId: string } | null };

export type FormikInternalIndustryAutocompleteFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type FormikInternalIndustryAutocompleteFieldQuery = { __typename?: 'Query', internalIndustries: { __typename?: 'InternalIndustryList', entries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> } };

export type FormikUserFieldFragment = { __typename?: 'UserSelection', id: string, profileName: string, profileImageUrl: string | null, email: string };

export type UserAutocompleteFieldWithOptionQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserAutocompleteFieldWithOptionQuery = { __typename?: 'Query', usersForSelection: { __typename?: 'UserSelectionEntries', entries: Array<{ __typename?: 'UserSelection', id: string, profileName: string, profileImageUrl: string | null, email: string }> } };

export type CreateListViewRenderModeLargeMutationVariables = Exact<{
  listUid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  viewType: ListViewType;
  schemaUid?: InputMaybe<Scalars['ID']['input']>;
  columnStateConfiguration: Scalars['String']['input'];
  filterModelConfiguration: Scalars['String']['input'];
  searchStateConfiguration: Scalars['String']['input'];
}>;


export type CreateListViewRenderModeLargeMutation = { __typename?: 'Mutation', createListView: { __typename?: 'CreateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type UpdateListViewMutationVariables = Exact<{
  listViewUid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  schemaUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateListViewMutation = { __typename?: 'Mutation', updateListView: { __typename?: 'UpdateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type AddFromTableLikeToAnotherMutationVariables = Exact<{
  fromSource: TableLikeSourceInput;
  fromMemberColumnUid: Scalars['String']['input'];
  fromFiltering?: InputMaybe<ColumnsFilteringInput>;
  fromSearch?: InputMaybe<Scalars['String']['input']>;
  toSource: TableLikeSourceInput;
  toValues?: InputMaybe<Array<ColumnValueInput> | ColumnValueInput>;
  trackerReturnPath?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddFromTableLikeToAnotherMutation = { __typename?: 'Mutation', addFromTableLikeToAnother: { __typename?: 'AddFromTableLikeToAnotherMutationPayload', failReasons: Array<string>, progressTracker: { __typename?: 'ProgressTracker', id: string, title: string, status: ProgressTrackerStatus, percentageComplete: number | null, returnPath: string | null } | null } | null };

export type ColumnDefinitionFragment = { __typename?: 'Column', id: string, name: string, filterOperations: Array<ColumnFilterOperationEnum>, columnValueSuggestions: boolean, orderable: boolean, multiple: boolean, valueType: ValueTypeEnum, groupName: string, updateable: boolean, filterOnly: boolean, useSnakeCase: boolean, emsAccessible: boolean, optionChoices: Array<{ __typename?: 'SchemaOptionChoice', id: string, value: string, colour: string, orderRank: number }> };

export type CompanyCellContentFragment = { __typename?: 'CompanyCard', id: string, logoUrl: string | null, name: string, domain: string | null };

export type CompanyCellFragment = { __typename?: 'CompanyCell', companyCard: { __typename?: 'CompanyCard', id: string, logoUrl: string | null, name: string, domain: string | null } | null };

export type CompanyOfficeLocationCellFragment = { __typename?: 'CompanyOfficeLocationCell', locationCard: { __typename?: 'CompanyOfficeLocationCard', id: string, brief: string } | null };

export type ContactCellContentFragment = { __typename?: 'ContactCard', id: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, imageUrl: string };

export type ContactCellFragment = { __typename?: 'ContactCell', contactCard: { __typename?: 'ContactCard', id: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, imageUrl: string } | null };

export type CountryCellContentFragment = { __typename?: 'Country', emojiFlag: string, name: string, code: CountryCode };

export type CountryCellFragment = { __typename?: 'CountryCell', country: { __typename?: 'Country', emojiFlag: string, name: string, code: CountryCode } | null };

export type CreateKeyActivityListCustomFieldSchemaMutationVariables = Exact<{
  listUuid: Scalars['ID']['input'];
  customFieldAttributes: CustomFieldSchemaAttributes;
}>;


export type CreateKeyActivityListCustomFieldSchemaMutation = { __typename?: 'Mutation', createKeyActivityListCustomFieldSchema: { __typename?: 'CreateKeyActivityListCustomFieldSchemaMutationPayload', failReasons: Array<string> } | null };

export type CurrencyCellContentFragment = { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', name: string, symbol: string, isoCode: CurrencyCode, exponent: number, decimalMark: string, symbolFirst: boolean, thousandsSeparator: string } };

export type CurrencyCellFragment = { __typename?: 'CurrencyCell', money: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', name: string, symbol: string, isoCode: CurrencyCode, exponent: number, decimalMark: string, symbolFirst: boolean, thousandsSeparator: string } } | null };

export type DeleteTableLikeRowsMutationVariables = Exact<{
  source: TableLikeSourceInput;
  search?: InputMaybe<Scalars['String']['input']>;
  filtering?: InputMaybe<ColumnsFilteringInput>;
}>;


export type DeleteTableLikeRowsMutation = { __typename?: 'Mutation', deleteTableLikeRows: { __typename?: 'DeleteTableLikeRowsMutationPayload', rowIdsDeleted: Array<string> | null, failReasons: Array<string>, progressTracker: { __typename?: 'ProgressTracker', id: string, title: string, status: ProgressTrackerStatus, percentageComplete: number | null, returnPath: string | null } | null } | null };

export type EmployeeCellContentFragment = { __typename?: 'EmployeeGrid', id: string, departmentName: string | null, officeName: string | null, jobTitle: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, email: string | null };

export type EmployeeCellFragment = { __typename?: 'EmployeeCell', employeeCard: { __typename?: 'EmployeeGrid', id: string, departmentName: string | null, officeName: string | null, jobTitle: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, email: string | null } | null };

export type LocationInfoContentFragment = { __typename?: 'MyListLocationInfo', displayName: string, locationTyped: MyListLocation };

export type ListCellFragment = { __typename?: 'ListCell', listCard: { __typename?: 'MyList', id: string, name: string, locationInfo: { __typename?: 'MyListLocationInfo', displayName: string, locationTyped: MyListLocation } } | null };

export type ListViewsRenderModeLargeQueryVariables = Exact<{
  listUid: Scalars['String']['input'];
}>;


export type ListViewsRenderModeLargeQuery = { __typename?: 'Query', listViews: Array<{ __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null }> };

export type RichTextCellContentFragment = { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string };

export type RichTextCellFragment = { __typename?: 'RichTextCell', richText: { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string } | null };

export type SharedTableLikeRowsQueryVariables = Exact<{
  source: TableLikeSourceInput;
  selectedColumns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  ordering?: InputMaybe<Array<SortOrderInput> | SortOrderInput>;
  filtering?: InputMaybe<ColumnsFilteringInput>;
}>;


export type SharedTableLikeRowsQuery = { __typename?: 'Query', sharedTableLikeRows: { __typename?: 'TableLikeRowEntries', entries: Array<{ __typename?: 'TableLikeRow', id: string, cells: Array<{ __typename?: 'TableCell', id: string, column: { __typename?: 'Column', id: string, name: string, filterOperations: Array<ColumnFilterOperationEnum>, columnValueSuggestions: boolean, orderable: boolean, multiple: boolean, valueType: ValueTypeEnum, updateable: boolean, optionChoices: Array<{ __typename?: 'SchemaOptionChoice', id: string, value: string, colour: string, orderRank: number }> }, values: Array<{ __typename?: 'CompanyCell', companyCard: { __typename?: 'CompanyCard', id: string, logoUrl: string | null, name: string, domain: string | null } | null } | { __typename?: 'CompanyOfficeLocationCell', locationCard: { __typename?: 'CompanyOfficeLocationCard', id: string, brief: string } | null } | { __typename?: 'ContactCell', contactCard: { __typename?: 'ContactCard', id: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, imageUrl: string } | null } | { __typename?: 'CountryCell', country: { __typename?: 'Country', emojiFlag: string, name: string, code: CountryCode } | null } | { __typename?: 'CurrencyCell', money: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', name: string, symbol: string, isoCode: CurrencyCode, exponent: number, decimalMark: string, symbolFirst: boolean, thousandsSeparator: string } } | null } | { __typename?: 'DateOnlyCell', date: string | null } | { __typename?: 'DateTimeCell', dateTime: string | null } | { __typename?: 'EmailCell', email: any | null } | { __typename?: 'EmployeeCell', employeeCard: { __typename?: 'EmployeeGrid', id: string, departmentName: string | null, officeName: string | null, jobTitle: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, email: string | null } | null } | { __typename?: 'IntegerCell', integer: number | null } | { __typename?: 'ListCell' } | { __typename?: 'NullCell', isNull: boolean, objectClass: string } | { __typename?: 'RichTextCell', richText: { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string } | null } | { __typename?: 'TextCell', text: string | null } | { __typename?: 'UserCell', userCard: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null }> }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number, totalPages: number } } };

export type TableCellFragment = { __typename?: 'TableCell', id: string, column: { __typename?: 'Column', id: string, name: string, filterOperations: Array<ColumnFilterOperationEnum>, columnValueSuggestions: boolean, orderable: boolean, multiple: boolean, valueType: ValueTypeEnum, updateable: boolean, optionChoices: Array<{ __typename?: 'SchemaOptionChoice', id: string, value: string, colour: string, orderRank: number }> }, values: Array<{ __typename?: 'CompanyCell', companyCard: { __typename?: 'CompanyCard', id: string, logoUrl: string | null, name: string, domain: string | null } | null } | { __typename?: 'CompanyOfficeLocationCell', locationCard: { __typename?: 'CompanyOfficeLocationCard', id: string, brief: string } | null } | { __typename?: 'ContactCell', contactCard: { __typename?: 'ContactCard', id: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, imageUrl: string } | null } | { __typename?: 'CountryCell', country: { __typename?: 'Country', emojiFlag: string, name: string, code: CountryCode } | null } | { __typename?: 'CurrencyCell', money: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', name: string, symbol: string, isoCode: CurrencyCode, exponent: number, decimalMark: string, symbolFirst: boolean, thousandsSeparator: string } } | null } | { __typename?: 'DateOnlyCell', date: string | null } | { __typename?: 'DateTimeCell', dateTime: string | null } | { __typename?: 'EmailCell', email: any | null } | { __typename?: 'EmployeeCell', employeeCard: { __typename?: 'EmployeeGrid', id: string, departmentName: string | null, officeName: string | null, jobTitle: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, email: string | null } | null } | { __typename?: 'IntegerCell', integer: number | null } | { __typename?: 'ListCell' } | { __typename?: 'NullCell', isNull: boolean, objectClass: string } | { __typename?: 'RichTextCell', richText: { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string } | null } | { __typename?: 'TextCell', text: string | null } | { __typename?: 'UserCell', userCard: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null }> };

type TableCellValue_CompanyCell_Fragment = { __typename: 'CompanyCell', companyCard: { __typename?: 'CompanyCard', id: string, logoUrl: string | null, name: string, domain: string | null } | null };

type TableCellValue_CompanyOfficeLocationCell_Fragment = { __typename: 'CompanyOfficeLocationCell' };

type TableCellValue_ContactCell_Fragment = { __typename: 'ContactCell', contactCard: { __typename?: 'ContactCard', id: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, imageUrl: string } | null };

type TableCellValue_CountryCell_Fragment = { __typename: 'CountryCell', country: { __typename?: 'Country', emojiFlag: string, name: string, code: CountryCode } | null };

type TableCellValue_CurrencyCell_Fragment = { __typename: 'CurrencyCell', money: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', name: string, symbol: string, isoCode: CurrencyCode, exponent: number, decimalMark: string, symbolFirst: boolean, thousandsSeparator: string } } | null };

type TableCellValue_DateOnlyCell_Fragment = { __typename: 'DateOnlyCell', date: string | null };

type TableCellValue_DateTimeCell_Fragment = { __typename: 'DateTimeCell', dateTime: string | null };

type TableCellValue_EmailCell_Fragment = { __typename: 'EmailCell', email: any | null };

type TableCellValue_EmployeeCell_Fragment = { __typename: 'EmployeeCell', employeeCard: { __typename?: 'EmployeeGrid', id: string, departmentName: string | null, officeName: string | null, jobTitle: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, email: string | null } | null };

type TableCellValue_IntegerCell_Fragment = { __typename: 'IntegerCell', integer: number | null };

type TableCellValue_ListCell_Fragment = { __typename: 'ListCell', listCard: { __typename?: 'MyList', id: string, name: string, locationInfo: { __typename?: 'MyListLocationInfo', displayName: string, locationTyped: MyListLocation } } | null };

type TableCellValue_NullCell_Fragment = { __typename: 'NullCell', isNull: boolean, objectClass: string };

type TableCellValue_RichTextCell_Fragment = { __typename: 'RichTextCell', richText: { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string } | null };

type TableCellValue_TextCell_Fragment = { __typename: 'TextCell', text: string | null };

type TableCellValue_UserCell_Fragment = { __typename: 'UserCell', userCard: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null };

export type TableCellValueFragment = TableCellValue_CompanyCell_Fragment | TableCellValue_CompanyOfficeLocationCell_Fragment | TableCellValue_ContactCell_Fragment | TableCellValue_CountryCell_Fragment | TableCellValue_CurrencyCell_Fragment | TableCellValue_DateOnlyCell_Fragment | TableCellValue_DateTimeCell_Fragment | TableCellValue_EmailCell_Fragment | TableCellValue_EmployeeCell_Fragment | TableCellValue_IntegerCell_Fragment | TableCellValue_ListCell_Fragment | TableCellValue_NullCell_Fragment | TableCellValue_RichTextCell_Fragment | TableCellValue_TextCell_Fragment | TableCellValue_UserCell_Fragment;

export type TableLikeColumnValueSuggestionsQueryVariables = Exact<{
  source: TableLikeSourceInput;
  selectedColumnUid: Scalars['ID']['input'];
  category: ColumnValueSuggestionCategory;
  text: Scalars['String']['input'];
  filter?: InputMaybe<SuggesterFilterInput>;
}>;


export type TableLikeColumnValueSuggestionsQuery = { __typename?: 'Query', tableLikeColumnValueSuggestions: { __typename?: 'TableLikeColumnValueSuggestionsEntries', entries: Array<{ __typename: 'CompanyCell', companyCard: { __typename?: 'CompanyCard', id: string, logoUrl: string | null, name: string, domain: string | null } | null } | { __typename: 'CompanyOfficeLocationCell' } | { __typename: 'ContactCell', contactCard: { __typename?: 'ContactCard', id: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, imageUrl: string } | null } | { __typename: 'CountryCell', country: { __typename?: 'Country', emojiFlag: string, name: string, code: CountryCode } | null } | { __typename: 'CurrencyCell', money: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', name: string, symbol: string, isoCode: CurrencyCode, exponent: number, decimalMark: string, symbolFirst: boolean, thousandsSeparator: string } } | null } | { __typename: 'DateOnlyCell', date: string | null } | { __typename: 'DateTimeCell', dateTime: string | null } | { __typename: 'EmailCell', email: any | null } | { __typename: 'EmployeeCell', employeeCard: { __typename?: 'EmployeeGrid', id: string, departmentName: string | null, officeName: string | null, jobTitle: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, email: string | null } | null } | { __typename: 'IntegerCell', integer: number | null } | { __typename: 'ListCell', listCard: { __typename?: 'MyList', id: string, name: string, locationInfo: { __typename?: 'MyListLocationInfo', displayName: string, locationTyped: MyListLocation } } | null } | { __typename: 'NullCell', isNull: boolean, objectClass: string } | { __typename: 'RichTextCell', richText: { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string } | null } | { __typename: 'TextCell', text: string | null } | { __typename: 'UserCell', userCard: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null }> } };

export type TableLikeDefinitionQueryVariables = Exact<{
  source: TableLikeSourceInput;
}>;


export type TableLikeDefinitionQuery = { __typename?: 'Query', tableLikeDefinition: { __typename?: 'TableLikeDefinition', id: string, exportable: boolean, deleteable: boolean, searchable: boolean, updatable: boolean, columns: Array<{ __typename?: 'Column', id: string, name: string, filterOperations: Array<ColumnFilterOperationEnum>, columnValueSuggestions: boolean, orderable: boolean, multiple: boolean, valueType: ValueTypeEnum, groupName: string, updateable: boolean, filterOnly: boolean, useSnakeCase: boolean, emsAccessible: boolean, optionChoices: Array<{ __typename?: 'SchemaOptionChoice', id: string, value: string, colour: string, orderRank: number }> }> } };

export type TableLikeDefinitionFragment = { __typename?: 'TableLikeDefinition', id: string, exportable: boolean, deleteable: boolean, searchable: boolean, updatable: boolean, columns: Array<{ __typename?: 'Column', id: string, name: string, filterOperations: Array<ColumnFilterOperationEnum>, columnValueSuggestions: boolean, orderable: boolean, multiple: boolean, valueType: ValueTypeEnum, groupName: string, updateable: boolean, filterOnly: boolean, useSnakeCase: boolean, emsAccessible: boolean, optionChoices: Array<{ __typename?: 'SchemaOptionChoice', id: string, value: string, colour: string, orderRank: number }> }> };

export type TableLikeExportMutationVariables = Exact<{
  source: TableLikeSourceInput;
  filtering?: InputMaybe<ColumnsFilteringInput>;
  selectedColumns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type TableLikeExportMutation = { __typename?: 'Mutation', exportTableLikeRows: { __typename?: 'ExportTableLikeRowsMutationPayload', failReasons: Array<string>, export: { __typename?: 'Export', id: string } | null } | null };

export type TableLikeRowsQueryVariables = Exact<{
  source: TableLikeSourceInput;
  ordering?: InputMaybe<Array<SortOrderInput> | SortOrderInput>;
  filtering?: InputMaybe<ColumnsFilteringInput>;
  selectedColumns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type TableLikeRowsQuery = { __typename?: 'Query', tableLikeRows: { __typename?: 'TableLikeRowEntries', entries: Array<{ __typename?: 'TableLikeRow', id: string, cells: Array<{ __typename?: 'TableCell', id: string, column: { __typename?: 'Column', id: string, name: string, filterOperations: Array<ColumnFilterOperationEnum>, columnValueSuggestions: boolean, orderable: boolean, multiple: boolean, valueType: ValueTypeEnum, updateable: boolean, optionChoices: Array<{ __typename?: 'SchemaOptionChoice', id: string, value: string, colour: string, orderRank: number }> }, values: Array<{ __typename?: 'CompanyCell', companyCard: { __typename?: 'CompanyCard', id: string, logoUrl: string | null, name: string, domain: string | null } | null } | { __typename?: 'CompanyOfficeLocationCell', locationCard: { __typename?: 'CompanyOfficeLocationCard', id: string, brief: string } | null } | { __typename?: 'ContactCell', contactCard: { __typename?: 'ContactCard', id: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, imageUrl: string } | null } | { __typename?: 'CountryCell', country: { __typename?: 'Country', emojiFlag: string, name: string, code: CountryCode } | null } | { __typename?: 'CurrencyCell', money: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', name: string, symbol: string, isoCode: CurrencyCode, exponent: number, decimalMark: string, symbolFirst: boolean, thousandsSeparator: string } } | null } | { __typename?: 'DateOnlyCell', date: string | null } | { __typename?: 'DateTimeCell', dateTime: string | null } | { __typename?: 'EmailCell', email: any | null } | { __typename?: 'EmployeeCell', employeeCard: { __typename?: 'EmployeeGrid', id: string, departmentName: string | null, officeName: string | null, jobTitle: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, email: string | null } | null } | { __typename?: 'IntegerCell', integer: number | null } | { __typename?: 'ListCell' } | { __typename?: 'NullCell', isNull: boolean, objectClass: string } | { __typename?: 'RichTextCell', richText: { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string } | null } | { __typename?: 'TextCell', text: string | null } | { __typename?: 'UserCell', userCard: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null }> }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number, totalPages: number } } };

export type TableRowFragment = { __typename?: 'TableLikeRow', id: string, cells: Array<{ __typename?: 'TableCell', id: string, column: { __typename?: 'Column', id: string, name: string, filterOperations: Array<ColumnFilterOperationEnum>, columnValueSuggestions: boolean, orderable: boolean, multiple: boolean, valueType: ValueTypeEnum, updateable: boolean, optionChoices: Array<{ __typename?: 'SchemaOptionChoice', id: string, value: string, colour: string, orderRank: number }> }, values: Array<{ __typename?: 'CompanyCell', companyCard: { __typename?: 'CompanyCard', id: string, logoUrl: string | null, name: string, domain: string | null } | null } | { __typename?: 'CompanyOfficeLocationCell', locationCard: { __typename?: 'CompanyOfficeLocationCard', id: string, brief: string } | null } | { __typename?: 'ContactCell', contactCard: { __typename?: 'ContactCard', id: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, imageUrl: string } | null } | { __typename?: 'CountryCell', country: { __typename?: 'Country', emojiFlag: string, name: string, code: CountryCode } | null } | { __typename?: 'CurrencyCell', money: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', name: string, symbol: string, isoCode: CurrencyCode, exponent: number, decimalMark: string, symbolFirst: boolean, thousandsSeparator: string } } | null } | { __typename?: 'DateOnlyCell', date: string | null } | { __typename?: 'DateTimeCell', dateTime: string | null } | { __typename?: 'EmailCell', email: any | null } | { __typename?: 'EmployeeCell', employeeCard: { __typename?: 'EmployeeGrid', id: string, departmentName: string | null, officeName: string | null, jobTitle: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, email: string | null } | null } | { __typename?: 'IntegerCell', integer: number | null } | { __typename?: 'ListCell' } | { __typename?: 'NullCell', isNull: boolean, objectClass: string } | { __typename?: 'RichTextCell', richText: { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string } | null } | { __typename?: 'TextCell', text: string | null } | { __typename?: 'UserCell', userCard: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null }> }> };

export type UpdateListViewColumnStateRenderModeLargeMutationVariables = Exact<{
  listViewUid: Scalars['String']['input'];
  columnState: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateListViewColumnStateRenderModeLargeMutation = { __typename?: 'Mutation', updateListView: { __typename?: 'UpdateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type UpdateListViewFilterModelRenderModeLargeMutationVariables = Exact<{
  listViewUid: Scalars['String']['input'];
  filterModel: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateListViewFilterModelRenderModeLargeMutation = { __typename?: 'Mutation', updateListView: { __typename?: 'UpdateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type UpdateListViewSearchStateRenderModeLargeMutationVariables = Exact<{
  listViewUid: Scalars['String']['input'];
  searchState: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateListViewSearchStateRenderModeLargeMutation = { __typename?: 'Mutation', updateListView: { __typename?: 'UpdateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type UpdateTableLikeRowsMutationVariables = Exact<{
  source: TableLikeSourceInput;
  search?: InputMaybe<Scalars['String']['input']>;
  filtering?: InputMaybe<ColumnsFilteringInput>;
  values: Array<ColumnValueInput> | ColumnValueInput;
}>;


export type UpdateTableLikeRowsMutation = { __typename?: 'Mutation', updateTableLikeRows: { __typename?: 'UpdateTableLikeRowsMutationPayload', failReasons: Array<string> } | null };

export type UserCellContentFragment = { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null };

export type UserCellFragment = { __typename?: 'UserCell', userCard: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null };

export type CompanyAutocompleteFieldWithOptionsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyAutocompleteFieldWithOptionsQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }> } };

export type CreateCompanyListCustomFieldSchemaMutationVariables = Exact<{
  companyListUuid: Scalars['ID']['input'];
  customFieldAttributes: CustomFieldSchemaAttributes;
}>;


export type CreateCompanyListCustomFieldSchemaMutation = { __typename?: 'Mutation', createCompanyListCustomFieldSchema: { __typename?: 'CreateCompanyListCustomFieldSchemaMutationPayload', failReasons: Array<string> } | null };

export type RebuildKeyActivityMutationVariables = Exact<{
  keyActivityUid: Scalars['ID']['input'];
  activityTitle: Scalars['String']['input'];
  keyActivityCategory: KeyActivityCategory;
  notes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  interactionOn: Scalars['ISO8601DateTime']['input'];
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalContacts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  internalContacts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  noRecreate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RebuildKeyActivityMutation = { __typename?: 'Mutation', rebuildKeyActivity: { __typename?: 'RebuildKeyActivityMutationPayload', failReasons: Array<string>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }>, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null, keyActivityListMember: { __typename?: 'KeyActivityListMember', id: string } | null } | null } | null };

export type RebuildKeyActivityFragment = { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }>, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null, keyActivityListMember: { __typename?: 'KeyActivityListMember', id: string } | null };

export type MarkChangedCompanyMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  removeFromMarketingList?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkChangedCompanyMutation = { __typename?: 'Mutation', addContactUnknownCompanySwitch: { __typename?: 'AddContactUnknownCompanySwitchMutationPayload', failReasons: Array<string> } | null };

export type ArchivePersonMutationVariables = Exact<{
  personUid: Scalars['ID']['input'];
}>;


export type ArchivePersonMutation = { __typename?: 'Mutation', result: { __typename?: 'ArchivePersonMutationPayload', failReasons: Array<string> } | null };

export type PersonQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type PersonQuery = { __typename?: 'Query', person: { __typename?: 'Person', id: string, contacts: Array<{ __typename?: 'Contact', id: string, isPersonal: boolean, isEmployee: boolean, primaryEmail: any | null, emailAddresses: Array<any>, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, linkedinUrl: string | null, twitterUrl: string | null, educations: Array<string>, tags: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } | null };

export type PersonPreviewFragment = { __typename?: 'Person', id: string, contacts: Array<{ __typename?: 'Contact', id: string, isPersonal: boolean, isEmployee: boolean, primaryEmail: any | null, emailAddresses: Array<any>, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, linkedinUrl: string | null, twitterUrl: string | null, educations: Array<string>, tags: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> };

export type CustomObjectsImporterMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type CustomObjectsImporterMutation = { __typename?: 'Mutation', result: { __typename?: 'CreateFlatfileWorkbookForCustomObjectsAdminImportMutationPayload', failReasons: Array<string>, workbook: { __typename?: 'FlatFileWorkbook', id: string, accessToken: string, spaceIdentifier: string, apiUrl: string, spaceUrl: string, metadata: any | null } | null } | null };

export type CustomObjectsImporterTemplateFragment = { __typename?: 'DataTemplate', id: string };

export type CreateGenericListCustomFieldSchemaMutationVariables = Exact<{
  genericListUid: Scalars['ID']['input'];
  schemaAttributes: CustomFieldSchemaAttributes;
}>;


export type CreateGenericListCustomFieldSchemaMutation = { __typename?: 'Mutation', createGenericListCustomFieldSchema: { __typename?: 'CreateGenericListCustomFieldSchemaMutationPayload', failReasons: Array<string> } | null };

export type AddCompanyContactToPersonMutationVariables = Exact<{
  personUid: Scalars['ID']['input'];
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyUid: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddCompanyContactToPersonMutation = { __typename?: 'Mutation', addCompanyContactToPerson: { __typename?: 'AddCompanyContactToPersonMutationPayload', failReasons: Array<string> } | null };

export type AddCompanyDocumentMutationVariables = Exact<{
  companyUid: Scalars['String']['input'];
  attributes: CompanyDocumentAttributes;
}>;


export type AddCompanyDocumentMutation = { __typename?: 'Mutation', addCompanyDocument: { __typename?: 'AddCompanyDocumentMutationPayload', failReasons: Array<string> } | null };

export type AddContactMutationVariables = Exact<{
  email: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  personUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddContactMutation = { __typename?: 'Mutation', addContact: { __typename?: 'AddContactMutationPayload', failReasons: Array<string>, uid: string | null } | null };

export type AddContactToListMutationVariables = Exact<{
  listUid: Scalars['ID']['input'];
  contactUid: Scalars['String']['input'];
}>;


export type AddContactToListMutation = { __typename?: 'Mutation', addContactToList: { __typename?: 'AddContactToListMutationPayload', failReasons: Array<string>, record: { __typename?: 'ListMember', id: string, createdAt: string, listId: string, contact: { __typename?: 'Contact', primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, whoKnows: Array<{ __typename?: 'WhoKnows', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null } | null } | null };

export type AddContactToListWithCustomFieldsMutationVariables = Exact<{
  listUid: Scalars['ID']['input'];
  contactUid: Scalars['String']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type AddContactToListWithCustomFieldsMutation = { __typename?: 'Mutation', addContactToList: { __typename?: 'AddContactToListMutationPayload', failReasons: Array<string>, record: { __typename?: 'ListMember', id: string, createdAt: string, listId: string, contact: { __typename?: 'Contact', primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, whoKnows: Array<{ __typename?: 'WhoKnows', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null } | null, gridMemberRecord: { __typename?: 'ContactListGridMember', id: string, listId: string, contactId: string, createdAt: string, updatedAt: string, completedTasksCount: number, tasksCount: number, inMyContacts: boolean | null, officeLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, contactCard: { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, contactInteractionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null } | null, contactInteractionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number } | null, contactCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, addedBy: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null, marketingListContactConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, topKnowBy: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> } | null } | null };

export type AddCustomOptionMutationVariables = Exact<{
  schemaUuid: Scalars['ID']['input'];
  options: Array<OptionsAttributes> | OptionsAttributes;
}>;


export type AddCustomOptionMutation = { __typename?: 'Mutation', addCustomOption: { __typename?: 'AddOptionMutationPayload', failReasons: Array<string> } | null };

export type AddGoalFileMutationVariables = Exact<{
  goalUuid: Scalars['ID']['input'];
  files: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddGoalFileMutation = { __typename?: 'Mutation', addGoalFile: { __typename?: 'OpportunityTrackingAddGoalFileMutationPayload', failReasons: Array<string> } | null };

export type AddMyContactMutationVariables = Exact<{
  contactUid: Scalars['String']['input'];
}>;


export type AddMyContactMutation = { __typename?: 'Mutation', addMyContact: { __typename?: 'MyAddContactMutationPayload', failReasons: Array<string>, id: string | null, contactId: string | null } | null };

export type AdminCompanyGoalRowFragment = { __typename?: 'CompanyGoal', id: string, date: string | null, tags: Array<string>, trackingNumber: string, title: string | null, receivedReferral: boolean, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', typeName: string, id: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', typeName: string, id: string }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null }, last: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null, lastInteraction: string | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, internalContact: { __typename?: 'Employee', id: string, email: string, department: { __typename?: 'Department', id: string, name: string } | null, office: { __typename?: 'Office', id: string, name: string } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, referralSource: { __typename?: 'Contact', id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, primaryEmail: any | null, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null };

export type AllActivityFeedQueryVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<InteractionsFilter>;
}>;


export type AllActivityFeedQuery = { __typename?: 'Query', allActivityFeed: { __typename?: 'TimelineEntries', entries: Array<{ __typename: 'TimelineEvent', action: string, atTime: string | null, comment: string | null, id: string, item: { __typename?: 'Interaction', id: string, occuredAt: string | null, occuredEndAt: string | null, interactionType: string, direction: InteractionDirection, webLink: string | null, participants: Array<{ __typename?: 'InteractionParticipant', id: string, email: any, role: ParticipantRole, contact: { __typename?: 'Contact', id: string, emailAddresses: Array<any>, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null }>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, webLink: string | null, direction: PartitionedInteractionDirection, interactionType: PartitionedInteractionType, occuredAt: string | null, sender: { __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } } | null, receivers: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }> } | null } | null } | { __typename?: 'KeyActivity' } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ApiConnectionsQueryVariables = Exact<{
  listUid: Scalars['ID']['input'];
}>;


export type ApiConnectionsQuery = { __typename?: 'Query', apiConnections: Array<{ __typename?: 'ApiSourceTable', id: string, name: string | null, tableKey: string, apiDefinition: { __typename?: 'ApiDefinition', id: string, apiUrl: string | null, httpMethod: string | null }, jsonPathColumnMappings: Array<{ __typename?: 'JsonPathColumnMapping', jsonPath: string, columnId: string }> }> };

export type ArchiveCompanyMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type ArchiveCompanyMutation = { __typename?: 'Mutation', archiveCompany: { __typename?: 'ArchiveCompanyMutationPayload', failReasons: Array<string> } | null };

export type ArchiveContactMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  unarchiveOnInteraction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchiveContactMutation = { __typename?: 'Mutation', archiveContact: { __typename?: 'ArchiveContactMutationPayload', failReasons: Array<string>, contact: { __typename?: 'Contact', id: string, isArchived: boolean } | null } | null };

export type ArchiveGoalMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type ArchiveGoalMutation = { __typename?: 'Mutation', archiveGoal: { __typename?: 'OpportunityTrackingArchiveGoalMutationPayload', failReasons: Array<string> } | null };

export type ArchivedContactRowFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, nextCompanyContact: { __typename?: 'PersonCompanyContact', companyName: string | null, contact: { __typename?: 'Contact', id: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null } | null, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type BulkAddListMemberMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  contactEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkAddListMemberMutation = { __typename?: 'Mutation', bulkAddListMember: { __typename?: 'BulkAddListMemberMutationPayload', failReasons: Array<string>, members: Array<{ __typename?: 'ListMember', id: string, createdAt: string, listId: string, contact: { __typename?: 'Contact', primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, whoKnows: Array<{ __typename?: 'WhoKnows', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null }>, blockedContacts: Array<{ __typename?: 'BlockedContact', id: string, errors: Array<string>, contact: { __typename?: 'Contact', inMyContacts: boolean | null, primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, gridMemberRecords: Array<{ __typename?: 'ContactListGridMember', id: string, listId: string, contactId: string, createdAt: string, updatedAt: string, completedTasksCount: number, tasksCount: number, inMyContacts: boolean | null, officeLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, contactCard: { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, contactInteractionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null } | null, contactInteractionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number } | null, contactCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, addedBy: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null, marketingListContactConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, topKnowBy: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> }> } | null };

export type BulkStayInTouchMutationVariables = Exact<{
  myContactEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  frequency: StayInTouchFrequency;
}>;


export type BulkStayInTouchMutation = { __typename?: 'Mutation', bulkStayInTouch: { __typename?: 'MyBulkStayInTouchMutationPayload', failReasons: Array<string> } | null };

export type CareerCompanyFragment = { __typename?: 'CareerCompany', id: string, companyName: string | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, jobTitles: Array<{ __typename?: 'ContactJobTitle', id: string, name: string, startDate: string | null, endDate: string | null }> };

export type CheckNewVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckNewVersionQuery = { __typename?: 'Query', deploymentInfo: { __typename?: 'DeploymentInfo', commit: string | null } };

export type CompanyDocumentOverviewFragment = { __typename?: 'CompanyDocument', id: string, name: string | null, url: string | null, file: { __typename?: 'File', url: string, contentType: string | null } | null };

export type CompanyDocumentsQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type CompanyDocumentsQuery = { __typename?: 'Query', company: { __typename?: 'Company', documents: Array<{ __typename?: 'CompanyDocument', id: string, name: string | null, url: string | null, file: { __typename?: 'File', url: string, contentType: string | null } | null }> } | null };

export type CompanyEnagegementOverviewFragment = { __typename?: 'Company', openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } };

export type CompanyListMembershipsQueryVariables = Exact<{
  companyUid: Scalars['String']['input'];
  excludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompanyListMembershipsQuery = { __typename?: 'Query', companyListMemberships: { __typename?: 'CompanyListMembers', entries: Array<{ __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', id: string, name: string, usageMode: CompanyUsageModeInput, tabUid: string | null, project: { __typename?: 'Project', id: string, nexlApps: boolean } | null } }> } | null };

export type CompanyNoteFragment = { __typename?: 'CompanyNote', id: string, access: CompanyNoteAccess, createdAt: string, updatedAt: string, richContent: { __typename?: 'RichContent', html: string, trixHtml: string }, company: { __typename?: 'Company', id: string, logoUrl: string | null, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, updater: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null };

export type CompanyOfficeLocationRowFragment = { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } };

export type CompanyOfficeLocationsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type CompanyOfficeLocationsQuery = { __typename?: 'Query', companyOfficeLocations: { __typename?: 'CompanyOfficeLocationList', entries: Array<{ __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } }> } };

export type CompanyProfileRowFragment = { __typename?: 'CompanyProfile', id: string, jobTitle: string | null, linkedinUrl: string | null, location: string | null, name: string | null, profileImgUrl: string | null, profileEmail: string | null, prospectEmailRequest: { __typename?: 'ProspectEmailRequest', status: ProspectEmailRequestStatus, id: string } | null };

export type ContactLocationsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactLocationsQuery = { __typename?: 'Query', contactLocations: { __typename?: 'LocationOptionList', entries: Array<{ __typename?: 'LocationOption', city: string | null, country: { __typename?: 'Country', name: string } }> } };

export type ContactOptionsQueryVariables = Exact<{
  filters?: InputMaybe<Array<ContactFilter> | ContactFilter>;
  filter?: InputMaybe<ContactsFiltering>;
}>;


export type ContactOptionsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } };

export type ContactPreviewFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type CreateApiDefinitionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  method: HttpMethodEnum;
  body?: InputMaybe<Scalars['String']['input']>;
  listId: Scalars['ID']['input'];
  tableKey: RowTypeEnum;
  jsonMappings: Array<JsonMappingInput> | JsonMappingInput;
  definitionHeaders: Array<ApiHeaderInput> | ApiHeaderInput;
  definitionSecrets: Array<ApiSecretInput> | ApiSecretInput;
  sourceTableHeaders: Array<ApiHeaderInput> | ApiHeaderInput;
  sourceTableSecrets: Array<ApiSecretInput> | ApiSecretInput;
}>;


export type CreateApiDefinitionMutation = { __typename?: 'Mutation', createApiDefinition: { __typename?: 'CreateApiDefinitionMutationPayload', failReasons: Array<string>, apiConnection: { __typename?: 'ApiSourceTable', id: string, name: string | null, tableKey: string, apiDefinition: { __typename?: 'ApiDefinition', id: string, apiUrl: string | null, httpMethod: string | null }, jsonPathColumnMappings: Array<{ __typename?: 'JsonPathColumnMapping', jsonPath: string, columnId: string }> } | null } | null };

export type CreateCompanyMutationVariables = Exact<{
  domain: Scalars['String']['input'];
  attributes: CompanyAttributes;
  companyDefaultType?: InputMaybe<CompanyTypeDefault>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  companyTypeUid?: InputMaybe<Scalars['ID']['input']>;
  externalIdentifier?: InputMaybe<ExternalIdentifierInput>;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'CreateCompanyMutationPayload', uid: string | null, failReasons: Array<string> } | null };

export type CreateCompanyContactMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  companyUid: Scalars['ID']['input'];
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCompanyContactMutation = { __typename?: 'Mutation', createCompanyContact: { __typename?: 'CreateCompanyContactMutationPayload', uid: string | null, failReasons: Array<string> } | null };

export type CreateCompanyOfficeLocationMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  primaryLocation?: InputMaybe<Scalars['Boolean']['input']>;
  headquarterLocation?: InputMaybe<Scalars['Boolean']['input']>;
  locationAttributes: LocationAttributes;
  labels?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateCompanyOfficeLocationMutation = { __typename?: 'Mutation', createCompanyOfficeLocation: { __typename?: 'CreateOfficeLocationMutationPayload', failReasons: Array<string> } | null };

export type CreateCompanyOpportunityMutationVariables = Exact<{
  companyUid: Scalars['ID']['input'];
  attributes: CompanyGoalAttributes;
}>;


export type CreateCompanyOpportunityMutation = { __typename?: 'Mutation', createCompanyOpportunity: { __typename?: 'OpportunityTrackingCreateOpportunityMutationPayload', failReasons: Array<string>, uid: string | null, record: { __typename?: 'CompanyGoal', id: string, date: string | null, tags: Array<string>, trackingNumber: string, title: string | null, receivedReferral: boolean, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', typeName: string, id: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', typeName: string, id: string }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null }, last: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null, lastInteraction: string | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, internalContact: { __typename?: 'Employee', id: string, email: string, department: { __typename?: 'Department', id: string, name: string } | null, office: { __typename?: 'Office', id: string, name: string } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, referralSource: { __typename?: 'Contact', id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, primaryEmail: any | null, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null, basicOppRecord: { __typename?: 'CompanyGoal', id: string, date: string | null, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, assignedTo: { __typename?: 'Employee', id: string, email: string, office: { __typename?: 'Office', id: string, name: string } | null, department: { __typename?: 'Department', id: string, name: string } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', id: string, city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactLast: { __typename?: 'LastAts', id: string, sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null, gridRecord: { __typename?: 'OpportunityGrid', id: string, date: string, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null } | null, company: { __typename?: 'CompanyGrid', domain: string | null, id: string, typeName: string, typeNames: Array<string>, logoUrl: string | null, name: string, industryNames: Array<string>, internalIndustryNames: Array<string>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }, assignedTo: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null, keyContacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }>, referralSource: { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null, company: { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string } } | null, othersIncluded: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }>, commsLast: { __typename?: 'LastAts', sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> } | null } | null };

export type CreateContactMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'CreateContactMutationPayload', failReasons: Array<string>, record: { __typename?: 'Contact', id: string } | null } | null };

export type CreateExportAuditMutationVariables = Exact<{
  dataType: ExportDataEnum;
  primaryName: Scalars['String']['input'];
  secondaryName: Scalars['String']['input'];
  rowCount: Scalars['Int']['input'];
}>;


export type CreateExportAuditMutation = { __typename?: 'Mutation', createExportAudit: { __typename?: 'CreateExportAuditMutationPayload', failReasons: Array<string> } | null };

export type CurrencyFragment = { __typename?: 'Currency', symbol: string, symbolFirst: boolean, name: string, isoCode: CurrencyCode, thousandsSeparator: string, decimalMark: string, exponent: number };

export type CurrentUserContactIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserContactIdQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, contact: { __typename?: 'Contact', id: string } } | null } | null };

export type CurrentUserEmployeeIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserEmployeeIdQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string } | null } | null };

export type DeleteApiConnectionMutationVariables = Exact<{
  sourceUid: Scalars['ID']['input'];
}>;


export type DeleteApiConnectionMutation = { __typename?: 'Mutation', deleteApiConnection: { __typename?: 'DeleteApiSourceMutationPayload', failReasons: Array<string> } | null };

type EventItemByType_Interaction_Fragment = { __typename?: 'Interaction', id: string, occuredAt: string | null, occuredEndAt: string | null, interactionType: string, direction: InteractionDirection, webLink: string | null, participants: Array<{ __typename?: 'InteractionParticipant', id: string, email: any, role: ParticipantRole, contact: { __typename?: 'Contact', id: string, emailAddresses: Array<any>, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null }>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, webLink: string | null, direction: PartitionedInteractionDirection, interactionType: PartitionedInteractionType, occuredAt: string | null, sender: { __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } } | null, receivers: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }> } | null } | null };

type EventItemByType_KeyActivity_Fragment = { __typename?: 'KeyActivity' };

export type EventItemByTypeFragment = EventItemByType_Interaction_Fragment | EventItemByType_KeyActivity_Fragment;

export type ExportCompaniesMutationVariables = Exact<{
  filter?: InputMaybe<CompanyFiltering>;
}>;


export type ExportCompaniesMutation = { __typename?: 'Mutation', exportCompanies: { __typename?: 'ExportCompaniesMutationPayload', failReasons: Array<string>, export: { __typename?: 'Export', id: string } | null } | null };

export type ExportContactsMutationVariables = Exact<{
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter> | ContactFilter>;
}>;


export type ExportContactsMutation = { __typename?: 'Mutation', exportContacts: { __typename?: 'ExportContactsMutationPayload', failReasons: Array<string>, export: { __typename?: 'Export', id: string } | null } | null };

export type ExportListMutationVariables = Exact<{
  listId: Scalars['ID']['input'];
  filter?: InputMaybe<ExportListFilter>;
}>;


export type ExportListMutation = { __typename?: 'Mutation', exportList: { __typename?: 'ExportListMutationPayload', failReasons: Array<string>, export: { __typename?: 'Export', id: string } | null } | null };

export type ExportMyContactsMutationVariables = Exact<{
  filter?: InputMaybe<MyContactsFiltering>;
}>;


export type ExportMyContactsMutation = { __typename?: 'Mutation', exportMyContacts: { __typename?: 'MyExportContactsMutationPayload', failReasons: Array<string>, export: { __typename?: 'Export', id: string } | null } | null };

export type OnExportsUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnExportsUpdateSubscription = { __typename?: 'Subscription', exportsUpdated: { __typename?: 'ExportsUpdatedPayload', entries: Array<{ __typename?: 'Export', id: string, displayName: string, status: ExportStatus, percentageComplete: number | null, createdAt: string, expectedCount: number, file: { __typename?: 'File', name: string, url: string } | null }> } };

export type FindProspectEmailMutationVariables = Exact<{
  name: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  prospectId: Scalars['String']['input'];
}>;


export type FindProspectEmailMutation = { __typename?: 'Mutation', findProspectEmail: { __typename?: 'FindProspectEmailMutationPayload', failReasons: Array<string>, request: { __typename?: 'ProspectEmailRequest', status: ProspectEmailRequestStatus, id: string } } | null };

export type GetAllowIndividualUserExportConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllowIndividualUserExportConfigQuery = { __typename?: 'Query', config: { __typename?: 'TenantConfig', id: string, allowIndividualUserExport: boolean } };

export type GetArchivedContactsQueryVariables = Exact<{
  companyUuid?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetArchivedContactsQuery = { __typename?: 'Query', archivedContacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, nextCompanyContact: { __typename?: 'PersonCompanyContact', companyName: string | null, contact: { __typename?: 'Contact', id: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null } | null, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type GetAudienceListOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAudienceListOptionsQuery = { __typename?: 'Query', audienceList: { __typename?: 'AudienceList', entries: Array<{ __typename?: 'Audience', id: string, name: string }> } };

export type GetCompanyInteractionDistributionQueryVariables = Exact<{
  companyUuid: Scalars['ID']['input'];
}>;


export type GetCompanyInteractionDistributionQuery = { __typename?: 'Query', companyInteractionDistribution: Array<{ __typename?: 'CompanyInteractionDist', day: string, interactionCount: number }> };

export type GetCompanyLastYearDepartmentStatsQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetCompanyLastYearDepartmentStatsQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, lastYearDepartmentsStats: Array<{ __typename?: 'LastYearCompanyDepartmentStat', id: string | null, interactionCount: number | null, department: { __typename?: 'Department', id: string, name: string } }> } | null };

export type GetCompanyOpportunityStatsQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetCompanyOpportunityStatsQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, domain: string | null, referredOpportunityStats: { __typename?: 'OpportunityStat', totalProposalFee: number, totalPercentageWon: number, totalWonProposalFee: number | null, totalOpenCount: number, totalWonCount: number }, opportunityStats: { __typename?: 'OpportunityStat', totalProposalFee: number, totalWonProposalFee: number | null, totalPercentageWon: number, totalOpenCount: number, totalWonCount: number } } | null };

export type GetCompanyPreviewQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetCompanyPreviewQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null };

export type GetCompanyProfilesQueryVariables = Exact<{
  domain: Scalars['String']['input'];
  filter?: InputMaybe<CompanyProfileFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCompanyProfilesQuery = { __typename?: 'Query', companyProfiles: { __typename?: 'CompanyProfileList', entries: Array<{ __typename?: 'CompanyProfile', id: string, jobTitle: string | null, linkedinUrl: string | null, location: string | null, name: string | null, profileImgUrl: string | null, profileEmail: string | null, prospectEmailRequest: { __typename?: 'ProspectEmailRequest', status: ProspectEmailRequestStatus, id: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type GetContactMoreActionsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactMoreActionsConfigQuery = { __typename?: 'Query', config: { __typename?: 'TenantConfig', id: string, allowPrivateContacts: boolean } };

export type GetContactOptionQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetContactOptionQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null };

export type GetCurrentUserCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserCurrencyQuery = { __typename?: 'Query', currentUser: { __typename?: 'Tenant', id: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, name: string, isoCode: CurrencyCode, thousandsSeparator: string, decimalMark: string, exponent: number } | null } | null };

export type GetCurrentUserEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserEmailQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, userId: string, email: string, employee: { __typename?: 'Employee', id: string } | null } | null };

export type GetIndustryListQueryVariables = Exact<{
  withCommon?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetIndustryListQuery = { __typename?: 'Query', industryList: Array<string> };

export type GetListOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListFiltering>;
}>;


export type GetListOptionsQuery = { __typename?: 'Query', lists: { __typename?: 'ListEntries', entries: Array<{ __typename?: 'List', id: string, name: string, usageMode: UsageMode, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, project: { __typename?: 'Project', title: string } | null }> } };

export type GetMyCompaniesQueryVariables = Exact<{
  filter?: InputMaybe<MyCompaniesFiltering>;
  orderBy?: InputMaybe<MyCompaniesOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMyCompaniesQuery = { __typename?: 'Query', myCompanies: { __typename?: 'MyCompanyList', entries: Array<{ __typename?: 'MyCompany', id: string, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, interactionMaximum: { __typename?: 'InteractionMaximum', id: string, lastAt: string | null, total: number | null } | null, company: { __typename?: 'Company', domain: string | null, domains: Array<string>, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, interactionsLast: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type GetMyContactLastInteractionQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetMyContactLastInteractionQuery = { __typename?: 'Query', myContact: { __typename?: 'MyContact', id: string, interactionMaximum: { __typename?: 'InteractionMaximum', lastAt: string | null } | null } | null };

export type MyContactStayInTouchFrequencyQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type MyContactStayInTouchFrequencyQuery = { __typename?: 'Query', myContact: { __typename?: 'MyContact', id: string, stayInTouch: { __typename?: 'MyStayInTouch', frequency: StayInTouchFrequency } | null } | null };

export type GetMyContactsNavKeyNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyContactsNavKeyNumbersQuery = { __typename?: 'Query', myStayInTouch: { __typename?: 'MyStayInTouchList', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } | null, upcomingMeetings: { __typename?: 'MeetingList', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type GetMyOpportunitiesCustomBoardQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
}>;


export type GetMyOpportunitiesCustomBoardQuery = { __typename?: 'Query', myOpportunitiesCustomBoard: Array<{ __typename?: 'CustomBoardColumn', count: number, displayLimitExceeded: boolean | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, position: number, outcome: string, startingStatus: boolean }, items: Array<{ __typename?: 'CustomBoardItem', index: number | null, opportunity: { __typename?: 'CompanyGoal', id: string, title: string | null, proposed: { __typename?: 'Money', cents: string, fee: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string } } | null, company: { __typename?: 'Company', id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, last: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null } }>, totalProposedFees: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } }> };

export type GetMyStayInTouchQueryVariables = Exact<{
  overDueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMyStayInTouchQuery = { __typename?: 'Query', myStayInTouch: { __typename?: 'MyStayInTouchList', entries: Array<{ __typename?: 'MyStayInTouch', frequency: StayInTouchFrequency, id: string, interactionDueDate: string, overDue: boolean, contact: { __typename?: 'MyContact', id: string, interactionMaximum: { __typename?: 'InteractionMaximum', lastAt: string | null } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } | null };

export type GetOpportunityCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpportunityCustomFieldsQuery = { __typename?: 'Query', currentTenant: { __typename?: 'Tenant', id: string, opportunityCustomFields: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> | null } | null };

export type GetPersonCompaniesQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetPersonCompaniesQuery = { __typename?: 'Query', person: { __typename?: 'Person', id: string, companyContacts: Array<{ __typename?: 'CareerCompany', id: string, companyName: string | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, jobTitles: Array<{ __typename?: 'ContactJobTitle', id: string, name: string, startDate: string | null, endDate: string | null }> }> } | null };

export type GetProspectEmailRequestQueryVariables = Exact<{
  requestUid: Scalars['String']['input'];
}>;


export type GetProspectEmailRequestQuery = { __typename?: 'Query', prospectEmailRequest: { __typename?: 'ProspectEmailRequest', contactEmail: string | null, status: ProspectEmailRequestStatus } | null };

export type GetProspectIndustryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProspectIndustryListQuery = { __typename?: 'Query', prospectIndustryList: Array<string> };

export type GetProspectSearchListQueryVariables = Exact<{
  term: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  headCount?: InputMaybe<HeadCountRange>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProspectSearchListQuery = { __typename?: 'Query', prospectSearch: { __typename?: 'CompanySearchEntries', entries: Array<{ __typename?: 'Prospect', domain: string, country: string | null, industry: string | null, name: string | null, headCount: number | null, linkedinUrl: string | null, company: { __typename?: 'Company', id: string } | null }> } | null };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagList', entries: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null };

export type InteractionDetailTimelinePreviewFragment = { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, webLink: string | null, direction: PartitionedInteractionDirection, interactionType: PartitionedInteractionType, occuredAt: string | null, sender: { __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } } | null, receivers: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }> } | null };

export type InteractionFragment = { __typename?: 'Interaction', id: string, occuredAt: string | null, occuredEndAt: string | null, interactionType: string, direction: InteractionDirection, webLink: string | null, participants: Array<{ __typename?: 'InteractionParticipant', id: string, email: any, role: ParticipantRole, contact: { __typename?: 'Contact', id: string, emailAddresses: Array<any>, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null }>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, webLink: string | null, direction: PartitionedInteractionDirection, interactionType: PartitionedInteractionType, occuredAt: string | null, sender: { __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } } | null, receivers: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }> } | null } | null };

export type InternalIndustryFragment = { __typename?: 'InternalIndustry', id: string | null, name: string };

export type IsDuplicateContactListQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type IsDuplicateContactListQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, allowDuplicates: boolean } | null };

export type IsLoggedOutQueryVariables = Exact<{ [key: string]: never; }>;


export type IsLoggedOutQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, userId: string, email: string } | null };

export type KeyContactFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ListOptionFragment = { __typename?: 'List', id: string, name: string, usageMode: UsageMode, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, project: { __typename?: 'Project', title: string } | null };

export type MagicbellQueryVariables = Exact<{ [key: string]: never; }>;


export type MagicbellQuery = { __typename?: 'Query', magicbell: { __typename?: 'Magicbell', apiKey: string | null, userExternalId: string, userKey: string } };

export type MembershipCompanyListFragment = { __typename?: 'CompanyListItem', id: string, name: string, usageMode: CompanyUsageModeInput, tabUid: string | null, project: { __typename?: 'Project', id: string, nexlApps: boolean } | null };

export type MergeContactMutationVariables = Exact<{
  previousUuid: Scalars['ID']['input'];
  currentUuid: Scalars['ID']['input'];
  keepBoth?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MergeContactMutation = { __typename?: 'Mutation', mergeContact: { __typename?: 'MergeContactMutationPayload', failReasons: Array<string>, currentRecord: { __typename?: 'Contact', isPersonal: boolean, isEmployee: boolean, emailAddresses: Array<any>, id: string, primaryEmail: any | null, archivedAt: string | null, changedJob: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, imageUrl: string | null, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, correspondenceNumbers: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null } | null };

export type MicrosoftAdminConsentDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type MicrosoftAdminConsentDetailQuery = { __typename?: 'Query', microsoftAdminConsentDetail: { __typename?: 'MicrosoftAdminConsentDetail', consents: Array<{ __typename?: 'MicrosoftAdminConsent', name: string, consentUrl: string }> } };

export type MyContactsQueryVariables = Exact<{
  filter?: InputMaybe<MyContactsFiltering>;
  orderBy?: InputMaybe<MyContactsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyContactsQuery = { __typename?: 'Query', myContacts: { __typename?: 'MyContactList', entries: Array<{ __typename?: 'MyContact', classified: boolean, contact: { __typename?: 'Contact', id: string, emailAddresses: Array<any>, primaryEmail: any | null, createdAt: string, archivedAt: string | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, company: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, interactionMaximum: { __typename?: 'InteractionMaximum', id: string, lastAt: string | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type MyCustomBoardColumnFragment = { __typename?: 'CustomBoardColumn', count: number, displayLimitExceeded: boolean | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, position: number, outcome: string, startingStatus: boolean }, items: Array<{ __typename?: 'CustomBoardItem', index: number | null, opportunity: { __typename?: 'CompanyGoal', id: string, title: string | null, proposed: { __typename?: 'Money', cents: string, fee: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string } } | null, company: { __typename?: 'Company', id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, last: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null } }>, totalProposedFees: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } };

export type MyCustomBoardItemFragment = { __typename?: 'CustomBoardItem', index: number | null, opportunity: { __typename?: 'CompanyGoal', id: string, title: string | null, proposed: { __typename?: 'Money', cents: string, fee: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string } } | null, company: { __typename?: 'Company', id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, last: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null } };

export type MyStayInTouchRowFragment = { __typename?: 'MyStayInTouch', frequency: StayInTouchFrequency, id: string, interactionDueDate: string, overDue: boolean, contact: { __typename?: 'MyContact', id: string, interactionMaximum: { __typename?: 'InteractionMaximum', lastAt: string | null } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } } };

export type OpportunityItemCompanyFragment = { __typename?: 'Company', id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, last: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> };

export type OpportunityItemFragment = { __typename?: 'CompanyGoal', id: string, title: string | null, proposed: { __typename?: 'Money', cents: string, fee: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string } } | null, company: { __typename?: 'Company', id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, last: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null };

export type ParticipantFragment = { __typename?: 'InteractionParticipant', id: string, email: any, role: ParticipantRole, contact: { __typename?: 'Contact', id: string, emailAddresses: Array<any>, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null };

export type ProspectRowFragment = { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, interactionsLast: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> };

export type ProspectsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<CompanyFilter> | CompanyFilter>;
  ownerUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProspectsQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, interactionsLast: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ReAssignOpportunityCompanyMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  companyUid: Scalars['ID']['input'];
  keyContactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReAssignOpportunityCompanyMutation = { __typename?: 'Mutation', reAssignOpportunityCompany: { __typename?: 'OpportunityTrackingReAssignOpportunityCompanyMutationPayload', failReasons: Array<string>, record: { __typename?: 'CompanyGoal', id: string, date: string | null, tags: Array<string>, trackingNumber: string, title: string | null, receivedReferral: boolean, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', typeName: string, id: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', typeName: string, id: string }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null }, last: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null, lastInteraction: string | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, internalContact: { __typename?: 'Employee', id: string, email: string, department: { __typename?: 'Department', id: string, name: string } | null, office: { __typename?: 'Office', id: string, name: string } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, referralSource: { __typename?: 'Contact', id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, primaryEmail: any | null, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null } | null };

export type RemoveCompanyDocumentMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type RemoveCompanyDocumentMutation = { __typename?: 'Mutation', removeCompanyDocument: { __typename?: 'RemoveCompanyDocumentMutationPayload', failReasons: Array<string> } | null };

export type RemoveCompanyListMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type RemoveCompanyListMutation = { __typename?: 'Mutation', removeCompanyList: { __typename?: 'RemoveCompanyListMutationPayload', failReasons: Array<string> } | null };

export type RemoveCompanyOfficeLocationMutationVariables = Exact<{
  companyOfficeLocationId: Scalars['ID']['input'];
}>;


export type RemoveCompanyOfficeLocationMutation = { __typename?: 'Mutation', removeCompanyOfficeLocation: { __typename?: 'RemoveOfficeLocationMutationPayload', failReasons: Array<string> } | null };

export type RemoveCustomFieldSchemaMutationVariables = Exact<{
  schemaUuid: Scalars['ID']['input'];
}>;


export type RemoveCustomFieldSchemaMutation = { __typename?: 'Mutation', removeCustomFieldSchema: { __typename?: 'RemoveCustomFieldSchemaMutationPayload', failReasons: Array<string> } | null };

export type RemoveCustomOptionMutationVariables = Exact<{
  optionChoiceUuid: Scalars['ID']['input'];
}>;


export type RemoveCustomOptionMutation = { __typename?: 'Mutation', removeCustomOption: { __typename?: 'RemoveOptionMutationPayload', failReasons: Array<string> } | null };

export type RemoveListMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type RemoveListMutation = { __typename?: 'Mutation', removeList: { __typename?: 'RemoveListMutationPayload', failReasons: Array<string> } | null };

export type RemoveMyCompanyMutationVariables = Exact<{
  myCompanyUid: Scalars['String']['input'];
}>;


export type RemoveMyCompanyMutation = { __typename?: 'Mutation', removeMyCompany: { __typename?: 'MyRemoveCompanyMutationPayload', failReasons: Array<string> } | null };

export type RemoveMyContactMutationVariables = Exact<{
  myContactUid: Scalars['String']['input'];
}>;


export type RemoveMyContactMutation = { __typename?: 'Mutation', removeMyContact: { __typename?: 'MyRemoveContactMutationPayload', failReasons: Array<string> } | null };

export type SearchOpportunityKeyContactsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  companyDomain: Scalars['String']['input'];
}>;


export type SearchOpportunityKeyContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } };

export type SearchProspectRowFragment = { __typename?: 'Prospect', domain: string, country: string | null, industry: string | null, name: string | null, headCount: number | null, linkedinUrl: string | null, company: { __typename?: 'Company', id: string } | null };

type SearchResult_Company_Fragment = { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } };

type SearchResult_Contact_Fragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type SearchResultFragment = SearchResult_Company_Fragment | SearchResult_Contact_Fragment;

export type SetStayInTouchMutationVariables = Exact<{
  myContactUid: Scalars['String']['input'];
  frequency: StayInTouchFrequency;
}>;


export type SetStayInTouchMutation = { __typename?: 'Mutation', setStayInTouch: { __typename?: 'MySetStayInTouchMutationPayload', failReasons: Array<string> } | null };

export type StatusBadgeFragment = { __typename?: 'Contact', isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type SyncListActivitiesMutationVariables = Exact<{
  listUuid: Scalars['String']['input'];
}>;


export type SyncListActivitiesMutation = { __typename?: 'Mutation', syncListActivities: { __typename?: 'SyncListActivitiesMutationPayload', failReasons: Array<string> } | null };

export type TimelineEventEntryFragment = { __typename: 'TimelineEvent', action: string, atTime: string | null, comment: string | null, id: string, item: { __typename?: 'Interaction', id: string, occuredAt: string | null, occuredEndAt: string | null, interactionType: string, direction: InteractionDirection, webLink: string | null, participants: Array<{ __typename?: 'InteractionParticipant', id: string, email: any, role: ParticipantRole, contact: { __typename?: 'Contact', id: string, emailAddresses: Array<any>, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null }>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, webLink: string | null, direction: PartitionedInteractionDirection, interactionType: PartitionedInteractionType, occuredAt: string | null, sender: { __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } } | null, receivers: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }> } | null } | null } | { __typename?: 'KeyActivity' } };

export type TriggerApiSourceMutationVariables = Exact<{
  sourceUid: Scalars['ID']['input'];
}>;


export type TriggerApiSourceMutation = { __typename?: 'Mutation', triggerApiSource: { __typename?: 'TriggerApiSourceMutationPayload', failReasons: Array<string> } | null };

export type UpcomingKeyActivitiesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<InteractionDetailsFilter>;
  orderBy?: InputMaybe<InteractionDetailsOrderBy>;
}>;


export type UpcomingKeyActivitiesQuery = { __typename?: 'Query', keyActivities: { __typename?: 'InteractionDetailList', entries: Array<{ __typename?: 'KeyActivity', id: string, activityTitle: string, interactionOn: string, interactionEndAt: string | null, category: KeyActivityCategory, description: string | null, involvedContacts: Array<{ __typename?: 'Contact', isEmployee: boolean, id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null, calendarMeeting: { __typename?: 'EmployeeMeeting', id: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type UpdateCompanyDocumentMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  attributes: CompanyDocumentAttributes;
}>;


export type UpdateCompanyDocumentMutation = { __typename?: 'Mutation', updateCompanyDocument: { __typename?: 'UpdateCompanyDocumentMutationPayload', failReasons: Array<string> } | null };

export type UpdateCompanyOfficeLocationMutationVariables = Exact<{
  companyOfficeLocationId: Scalars['ID']['input'];
  primaryLocation?: InputMaybe<Scalars['Boolean']['input']>;
  headquarterLocation?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locationAttributes?: InputMaybe<LocationAttributes>;
}>;


export type UpdateCompanyOfficeLocationMutation = { __typename?: 'Mutation', updateCompanyOfficeLocation: { __typename?: 'UpdateOfficeLocationMutationPayload', failReasons: Array<string> } | null };

export type UpdateCustomFieldSchemaMutationVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateCustomFieldSchemaMutation = { __typename?: 'Mutation', updateCustomFieldSchema: { __typename?: 'UpdateCustomFieldSchemaMutationPayload', failReasons: Array<string>, record: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null } | null } | null };

export type UpdateCustomFieldSchemaValuesMutationVariables = Exact<{
  schemaUid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<OptionChoiceAttributes> | OptionChoiceAttributes>;
}>;


export type UpdateCustomFieldSchemaValuesMutation = { __typename?: 'Mutation', result: { __typename?: 'UpdateCustomFieldSchemaValuesMutationPayload', failReasons: Array<string> } | null };

export type UpdateCustomOptionMutationVariables = Exact<{
  optionChoiceUuid: Scalars['ID']['input'];
  optionValue: Scalars['String']['input'];
  optionColour: AccountColour;
}>;


export type UpdateCustomOptionMutation = { __typename?: 'Mutation', updateCustomOption: { __typename?: 'UpdateOptionMutationPayload', failReasons: Array<string> } | null };

export type UpdateTagsMutationVariables = Exact<{
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
  uid: Scalars['ID']['input'];
}>;


export type UpdateTagsMutation = { __typename?: 'Mutation', addTagCompany: { __typename?: 'UpdateCompanyMutationPayload', failReasons: Array<string> } | null };

export type CreateEventPackRequestMutationVariables = Exact<{
  attributes: EventPackRequestAttribute;
}>;


export type CreateEventPackRequestMutation = { __typename?: 'Mutation', createEventPackRequest: { __typename?: 'CreateEventPackRequestMutationPayload', failReasons: Array<string>, record: { __typename?: 'EventPackRequest', id: string } | null } | null };

export type EventPackRequestFinishedSubscriptionVariables = Exact<{
  eventPackRequestUid: Scalars['ID']['input'];
}>;


export type EventPackRequestFinishedSubscription = { __typename?: 'Subscription', eventPackRequestFinished: { __typename?: 'EventPackRequest', id: string, requestStatus: RequestStatus, eventPackResponse: { __typename?: 'EventPackResponse', id: string, email: string, linkedinPost: string, website: string } | null } };

export type EventPackResponseFragment = { __typename?: 'EventPackResponse', id: string, email: string, linkedinPost: string, website: string };

export type CreateLinkedinPostRequestMutationVariables = Exact<{
  attributes: LinkedinPostRequestAttribute;
}>;


export type CreateLinkedinPostRequestMutation = { __typename?: 'Mutation', createLinkedinPostRequest: { __typename?: 'CreateLinkedinPostRequestMutationPayload', failReasons: Array<string>, record: { __typename?: 'LinkedinPostRequest', id: string } | null } | null };

export type LinkedinPostRequestFinishedSubscriptionVariables = Exact<{
  linkedinPostRequestUid: Scalars['ID']['input'];
}>;


export type LinkedinPostRequestFinishedSubscription = { __typename?: 'Subscription', linkedinPostRequestFinished: { __typename?: 'LinkedinPostRequest', id: string, requestStatus: RequestStatus, linkedinPostResponse: { __typename?: 'LinkedinPostResponse', id: string, postResponse: string } | null } };

export type LinkedinPostResponseFragment = { __typename?: 'LinkedinPostResponse', id: string, postResponse: string };

export type CreateMarketingEmailRequestMutationVariables = Exact<{
  attributes: MarketingEmailRequestAttribute;
}>;


export type CreateMarketingEmailRequestMutation = { __typename?: 'Mutation', createMarketingEmailRequest: { __typename?: 'CreateMarketingEmailRequestMutationPayload', failReasons: Array<string>, record: { __typename?: 'MarketingEmailRequest', id: string } | null } | null };

export type MarketingEmailRequestFinishedSubscriptionVariables = Exact<{
  marketingEmailRequestUid: Scalars['ID']['input'];
}>;


export type MarketingEmailRequestFinishedSubscription = { __typename?: 'Subscription', marketingEmailRequestFinished: { __typename?: 'MarketingEmailRequest', id: string, requestStatus: RequestStatus, marketingEmailResponse: { __typename?: 'MarketingEmailResponse', id: string, emailResponse: string } | null } };

export type MarketingEmailResponseFragment = { __typename?: 'MarketingEmailResponse', id: string, emailResponse: string };

export type AddBlockPageToBlockPageListMutationVariables = Exact<{
  blockPageListUid: Scalars['ID']['input'];
  attributes: BlockPageAttributes;
}>;


export type AddBlockPageToBlockPageListMutation = { __typename?: 'Mutation', addBlockPageToBlockPageList: { __typename?: 'AddBlockPageToBlockPageListMutationPayload', failReasons: Array<string>, blockPage: { __typename?: 'BlockPage', id: string } | null } | null };

export type BlockPageQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type BlockPageQuery = { __typename?: 'Query', blockPage: { __typename?: 'BlockPage', id: string, name: string | null, iconCode: string | null, position: number | null } | null };

export type BlockPageFragment = { __typename?: 'BlockPage', id: string, name: string | null, iconCode: string | null, position: number | null };

export type CreateBlockPageListTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  group: Scalars['String']['input'];
}>;


export type CreateBlockPageListTabMutation = { __typename?: 'Mutation', createBlockPageListTab: { __typename?: 'CreateBlockPageListTabMutationPayload', failReasons: Array<string>, id: string | null } | null };

export type CurrentUserProfileNameQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserProfileNameQuery = { __typename?: 'Query', info: { __typename?: 'User', id: string, profileName: string } | null, provider: { __typename?: 'BlockPageProvider', id: string, url: string, token: string } };

export type RemoveBlockPageMutationVariables = Exact<{
  blockPageUid: Scalars['ID']['input'];
}>;


export type RemoveBlockPageMutation = { __typename?: 'Mutation', removeBlockPage: { __typename?: 'RemoveBlockPageMutationPayload', failReasons: Array<string>, blockPage: { __typename?: 'BlockPage', id: string, name: string | null, iconCode: string | null, discardedAt: string | null, position: number | null } | null } | null };

export type UpdateBlockPageMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
  pageName?: InputMaybe<Scalars['String']['input']>;
  iconCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBlockPageMutation = { __typename?: 'Mutation', updateBlockPage: { __typename?: 'UpdateBlockPageMutationPayload', failReasons: Array<string>, blockPage: { __typename?: 'BlockPage', id: string, name: string | null, iconCode: string | null, discardedAt: string | null, position: number | null } | null } | null };

export type UpdateBlockPageListPositionsMutationVariables = Exact<{
  pageUpdates: Array<BlockPagePositionAttributes> | BlockPagePositionAttributes;
  blockPageListUid: Scalars['ID']['input'];
}>;


export type UpdateBlockPageListPositionsMutation = { __typename?: 'Mutation', updateBlockPageListPositions: { __typename?: 'UpdateBlockPageListPositionsMutationPayload', failReasons: Array<string>, pages: Array<{ __typename?: 'BlockPage', id: string, name: string | null, iconCode: string | null, discardedAt: string | null, position: number | null }> } | null };

export type AddEmailMarketingCampaignRecipientMutationVariables = Exact<{
  campaignUid: Scalars['ID']['input'];
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AddEmailMarketingCampaignRecipientMutation = { __typename?: 'Mutation', result: { __typename?: 'AddRecipientMutationPayload', failReasons: Array<string> } | null };

export type AnalyticsDetailsFragment = { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, percentUnsubscribed: number, percentSkipped: number, percentFailed: number, percentComplained: number, totalFailed: number, totalClicked: number, totalDelivered: number, totalOpened: number, totalRecipients: number, totalUnsubscribed: number, totalSkipped: number, totalComplained: number, totalAccepted: number };

export type ArchiveEmailMarketingCampaignMutationVariables = Exact<{
  campaignUid: Scalars['ID']['input'];
}>;


export type ArchiveEmailMarketingCampaignMutation = { __typename?: 'Mutation', result: { __typename?: 'ArchiveCampaignMutationPayload', failReasons: Array<string> | null, archivedCampaign: { __typename?: 'Campaign', id: string, status: CampaignStatus } | null } | null };

export type CampaignQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', projectUrl: string, id: string, title: string, subject: string | null, templateHtml: string | null, templateJson: string | null, scheduledAt: string | null, status: CampaignStatus, usageMode: CampaignUsage | null, continuous: boolean, allowContinuousResend: boolean, openTracking: boolean, clickTracking: boolean, sender: { __typename?: 'Sender', id: string, email: string, replyTo: string } | null, createdBy: { __typename?: 'User', email: string }, recipientList: { __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, percentUnsubscribed: number, percentSkipped: number, percentFailed: number, percentComplained: number, totalFailed: number, totalClicked: number, totalDelivered: number, totalOpened: number, totalRecipients: number, totalUnsubscribed: number, totalSkipped: number, totalComplained: number, totalAccepted: number } | null, attachment: { __typename?: 'File', name: string, url: string, contentType: string | null } | null, recipientListFilter: { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } } | null } | null };

export type CampaignDetailsFragment = { __typename?: 'Campaign', projectUrl: string, id: string, title: string, subject: string | null, templateHtml: string | null, templateJson: string | null, scheduledAt: string | null, status: CampaignStatus, usageMode: CampaignUsage | null, continuous: boolean, allowContinuousResend: boolean, openTracking: boolean, clickTracking: boolean, sender: { __typename?: 'Sender', id: string, email: string, replyTo: string } | null, createdBy: { __typename?: 'User', email: string }, recipientList: { __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, percentUnsubscribed: number, percentSkipped: number, percentFailed: number, percentComplained: number, totalFailed: number, totalClicked: number, totalDelivered: number, totalOpened: number, totalRecipients: number, totalUnsubscribed: number, totalSkipped: number, totalComplained: number, totalAccepted: number } | null, attachment: { __typename?: 'File', name: string, url: string, contentType: string | null } | null, recipientListFilter: { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } } | null };

export type CampaignEditContentQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignEditContentQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, title: string, templateJson: string | null, status: CampaignStatus, recipientList: { __typename?: 'List', id: string } | null } | null };

export type CampaignInfoFragment = { __typename?: 'Campaign', id: string, title: string, status: CampaignStatus };

export type CampaignLinksQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignLinksQuery = { __typename?: 'Query', campaignLinks: Array<any> };

export type CampaignRecipientFragment = { __typename?: 'CampaignRecipient', emailAddresses: Array<any>, primaryEmail: any | null, status: CampaignRecipientStatus, changedJob: boolean, isArchived: boolean, id: string, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } };

export type CampaignsQueryVariables = Exact<{
  filter: ProjectCampaignsFilter;
}>;


export type CampaignsQuery = { __typename?: 'Query', campaigns: { __typename?: 'ProjectCampaignEntries', entries: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> } | null };

export type CloneEmailMarketingCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  includeProject?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CloneEmailMarketingCampaignMutation = { __typename?: 'Mutation', result: { __typename?: 'CloneCampaignMutationPayload', failReasons: Array<string>, clonedCampaign: { __typename?: 'Campaign', projectUrl: string, id: string, title: string, subject: string | null, templateHtml: string | null, templateJson: string | null, scheduledAt: string | null, status: CampaignStatus, usageMode: CampaignUsage | null, continuous: boolean, allowContinuousResend: boolean, openTracking: boolean, clickTracking: boolean, sender: { __typename?: 'Sender', id: string, email: string, replyTo: string } | null, createdBy: { __typename?: 'User', email: string }, recipientList: { __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, percentUnsubscribed: number, percentSkipped: number, percentFailed: number, percentComplained: number, totalFailed: number, totalClicked: number, totalDelivered: number, totalOpened: number, totalRecipients: number, totalUnsubscribed: number, totalSkipped: number, totalComplained: number, totalAccepted: number } | null, attachment: { __typename?: 'File', name: string, url: string, contentType: string | null } | null, recipientListFilter: { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } } | null } | null } | null };

export type EmailMarketingCampaignRecipientsQueryVariables = Exact<{
  campaignUid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CampaignRecipientsFilterInput>;
}>;


export type EmailMarketingCampaignRecipientsQuery = { __typename?: 'Query', emailMarketingCampaignRecipients: { __typename?: 'CampaignRecipientEntries', entries: Array<{ __typename?: 'CampaignRecipient', emailAddresses: Array<any>, primaryEmail: any | null, status: CampaignRecipientStatus, changedJob: boolean, isArchived: boolean, id: string, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } }>, pageInfo: { __typename?: 'PagingInfo', totalPages: number, totalEntries: number } } };

export type EmailMarketingConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailMarketingConfigurationQuery = { __typename?: 'Query', emailMarketingConfiguration: { __typename?: 'EmailMarketingConfiguration', enabled: boolean, id: string } | null };

export type EmailMarketingRecipientWarningsQueryVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
}>;


export type EmailMarketingRecipientWarningsQuery = { __typename?: 'Query', result: { __typename?: 'RecipientWarnings', firstNameMissingTotal: number, lastNameMissingTotal: number, bouncedTotal: number, consentUnsubscribedTotal: number, consentNotGivenTotal: number, allRecipientsVerified: boolean, excludedContactsTotal: number } | null };

export type EmailMarketingTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailMarketingTemplatesQuery = { __typename?: 'Query', emailMarketingTemplatesV2: { __typename?: 'Templates', entries: Array<{ __typename?: 'Template', id: string, title: string, templateJson: string | null, thumbnail: string | null }> } };

export type EmailTemplateFragment = { __typename?: 'Template', id: string, title: string, templateJson: string | null, thumbnail: string | null };

export type EmsCampaignUpdateQueryVariables = Exact<{ [key: string]: never; }>;


export type EmsCampaignUpdateQuery = { __typename?: 'Query', emailMarketingConfiguration: { __typename?: 'EmailMarketingConfiguration', id: string, senders: Array<{ __typename?: 'Sender', id: string, email: string, replyTo: string }> } | null };

export type ExportEmailMarketingCampaignRecipientsMutationVariables = Exact<{
  campaignUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportEmailMarketingCampaignRecipientsMutation = { __typename?: 'Mutation', exportEmailMarketingCampaignRecipients: { __typename?: 'ExportCampaignRecipientsMutationPayload', failReasons: Array<string>, export: { __typename?: 'Export', id: string } | null } | null };

export type RecipientListFilterFragment = { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } };

export type RecipientWarningsFragment = { __typename?: 'RecipientWarnings', firstNameMissingTotal: number, lastNameMissingTotal: number, bouncedTotal: number, consentUnsubscribedTotal: number, consentNotGivenTotal: number, allRecipientsVerified: boolean, excludedContactsTotal: number };

export type SaveCampaignAsTemplateMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  templateTitle: Scalars['String']['input'];
}>;


export type SaveCampaignAsTemplateMutation = { __typename?: 'Mutation', saveCampaignAsTemplate: { __typename?: 'SaveCampaignAsTemplateMutationPayload', failReasons: Array<string>, createdTemplate: { __typename?: 'Template', id: string, title: string, templateHtml: string | null } | null } | null };

export type SaveCampaignRecipientListFilterMutationVariables = Exact<{
  input: CampaignRecipientListFilterInput;
}>;


export type SaveCampaignRecipientListFilterMutation = { __typename?: 'Mutation', saveCampaignRecipientListFilter: { __typename?: 'SaveCampaignRecipientListFilterMutationPayload', failReasons: Array<string>, campaignRecipientListFilter: { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } } | null } | null };

export type ScheduleEmailMarketingCampaignMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  scheduledAt: Scalars['ISO8601DateTime']['input'];
}>;


export type ScheduleEmailMarketingCampaignMutation = { __typename?: 'Mutation', result: { __typename?: 'ScheduleCampaignMutationPayload', failReasons: Array<string>, scheduledCampaign: { __typename?: 'Campaign', id: string, status: CampaignStatus, scheduledAt: string | null } | null } | null };

export type SendEmailMarketingTestEmailMutationVariables = Exact<{
  campaignUid: Scalars['ID']['input'];
  recipientEmail: Scalars['String']['input'];
}>;


export type SendEmailMarketingTestEmailMutation = { __typename?: 'Mutation', result: { __typename?: 'SendTestEmailMutationPayload', failReasons: Array<string> } | null };

export type SendersAutocompleteFieldFragment = { __typename?: 'Sender', id: string, email: string, replyTo: string };

export type UpdateEmailMarketingCampaignMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  continuous?: InputMaybe<Scalars['Boolean']['input']>;
  recipientListId?: InputMaybe<Scalars['ID']['input']>;
  templateJson?: InputMaybe<Scalars['String']['input']>;
  senderID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateEmailMarketingCampaignMutation = { __typename?: 'Mutation', result: { __typename?: 'UpdateCampaignMutationPayload', failReasons: Array<string>, updatedCampaign: { __typename?: 'Campaign', projectUrl: string, id: string, title: string, subject: string | null, templateHtml: string | null, templateJson: string | null, scheduledAt: string | null, status: CampaignStatus, usageMode: CampaignUsage | null, continuous: boolean, allowContinuousResend: boolean, openTracking: boolean, clickTracking: boolean, sender: { __typename?: 'Sender', id: string, email: string, replyTo: string } | null, createdBy: { __typename?: 'User', email: string }, recipientList: { __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, percentUnsubscribed: number, percentSkipped: number, percentFailed: number, percentComplained: number, totalFailed: number, totalClicked: number, totalDelivered: number, totalOpened: number, totalRecipients: number, totalUnsubscribed: number, totalSkipped: number, totalComplained: number, totalAccepted: number } | null, attachment: { __typename?: 'File', name: string, url: string, contentType: string | null } | null, recipientListFilter: { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } } | null } | null } | null };

export type UpdateEmailMarketingCampaignEmailMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  templateJson?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEmailMarketingCampaignEmailMutation = { __typename?: 'Mutation', result: { __typename?: 'UpdateCampaignMutationPayload', failReasons: Array<string>, updatedCampaign: { __typename?: 'Campaign', projectUrl: string, id: string, title: string, subject: string | null, templateHtml: string | null, templateJson: string | null, scheduledAt: string | null, status: CampaignStatus, usageMode: CampaignUsage | null, continuous: boolean, allowContinuousResend: boolean, openTracking: boolean, clickTracking: boolean, sender: { __typename?: 'Sender', id: string, email: string, replyTo: string } | null, createdBy: { __typename?: 'User', email: string }, recipientList: { __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, percentUnsubscribed: number, percentSkipped: number, percentFailed: number, percentComplained: number, totalFailed: number, totalClicked: number, totalDelivered: number, totalOpened: number, totalRecipients: number, totalUnsubscribed: number, totalSkipped: number, totalComplained: number, totalAccepted: number } | null, attachment: { __typename?: 'File', name: string, url: string, contentType: string | null } | null, recipientListFilter: { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } } | null } | null } | null };

export type AddEmailMarketingCampaignAttachmentMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  file: Scalars['String']['input'];
}>;


export type AddEmailMarketingCampaignAttachmentMutation = { __typename?: 'Mutation', addEmailMarketingCampaignAttachment: { __typename?: 'MyAddCampaignAttachmentMutationPayload', failReasons: Array<string>, campaign: { __typename?: 'Campaign', projectUrl: string, id: string, title: string, subject: string | null, templateHtml: string | null, templateJson: string | null, scheduledAt: string | null, status: CampaignStatus, usageMode: CampaignUsage | null, continuous: boolean, allowContinuousResend: boolean, openTracking: boolean, clickTracking: boolean, sender: { __typename?: 'Sender', id: string, email: string, replyTo: string } | null, createdBy: { __typename?: 'User', email: string }, recipientList: { __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, percentUnsubscribed: number, percentSkipped: number, percentFailed: number, percentComplained: number, totalFailed: number, totalClicked: number, totalDelivered: number, totalOpened: number, totalRecipients: number, totalUnsubscribed: number, totalSkipped: number, totalComplained: number, totalAccepted: number } | null, attachment: { __typename?: 'File', name: string, url: string, contentType: string | null } | null, recipientListFilter: { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } } | null } | null } | null };

export type DeleteEmailMarketingCampaignAttachmentMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type DeleteEmailMarketingCampaignAttachmentMutation = { __typename?: 'Mutation', deleteEmailMarketingCampaignAttachment: { __typename?: 'MyDeleteCampaignAttachmentMutationPayload', failReasons: Array<string> | null, campaign: { __typename?: 'Campaign', projectUrl: string, id: string, title: string, subject: string | null, templateHtml: string | null, templateJson: string | null, scheduledAt: string | null, status: CampaignStatus, usageMode: CampaignUsage | null, continuous: boolean, allowContinuousResend: boolean, openTracking: boolean, clickTracking: boolean, sender: { __typename?: 'Sender', id: string, email: string, replyTo: string } | null, createdBy: { __typename?: 'User', email: string }, recipientList: { __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, percentUnsubscribed: number, percentSkipped: number, percentFailed: number, percentComplained: number, totalFailed: number, totalClicked: number, totalDelivered: number, totalOpened: number, totalRecipients: number, totalUnsubscribed: number, totalSkipped: number, totalComplained: number, totalAccepted: number } | null, attachment: { __typename?: 'File', name: string, url: string, contentType: string | null } | null, recipientListFilter: { __typename?: 'CampaignRecipientListFilter', id: string, conditions: any, campaign: { __typename?: 'Campaign', id: string }, recipientList: { __typename?: 'List', id: string } } | null } | null } | null };

export type FilePreviewFragment = { __typename?: 'File', name: string, url: string, contentType: string | null };

export type EmailMarketingFormUrlQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
  formSettings: FormSettings;
}>;


export type EmailMarketingFormUrlQuery = { __typename?: 'Query', emailMarketingFormUrl: string | null };

export type EmailMarketingProjectFormsQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailMarketingProjectFormsQuery = { __typename?: 'Query', emailMarketingProjectForms: { __typename?: 'ContactListForms', entries: Array<{ __typename?: 'Form', id: string, title: string }> } };

export type ProjectFormOptionFragment = { __typename?: 'Form', id: string, title: string };

export type EmailMarketingListMergeTagsQueryVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailMarketingListMergeTagsQuery = { __typename?: 'Query', emailMarketingListMergeTags: Array<{ __typename?: 'MergeTag', name: string, value: string }> | null };

export type EmailMarketingListsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  projectUuid?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<ListsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmailMarketingListsQuery = { __typename?: 'Query', result: { __typename?: 'ListEntries', entries: Array<{ __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number, totalPages: number } } };

export type RecipientListOptionFragment = { __typename?: 'List', id: string, name: string, usageMode: UsageMode, tabUid: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null, cleanEnd: string | null, beenCleaned: boolean } | null, project: { __typename?: 'Project', title: string, id: string, nexlApps: boolean } | null };

export type CreateEmailMarketingCampaignMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateEmailMarketingCampaignMutation = { __typename?: 'Mutation', createEmailMarketingCampaign: { __typename?: 'CreateCampaignMutationPayload', failReasons: Array<string>, campaign: { __typename?: 'Campaign', id: string, title: string } | null } | null };

export type EmailMarketingCampaignsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CampaignsFilterInput>;
}>;


export type EmailMarketingCampaignsQuery = { __typename?: 'Query', emailMarketingCampaigns: { __typename?: 'Campaigns', entries: Array<{ __typename?: 'Campaign', id: string, title: string, usageMode: CampaignUsage | null, continuous: boolean, createdAt: string, status: CampaignStatus, sentAt: string | null, updatedAt: string, scheduledAt: string | null, createdBy: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, contact: { __typename?: 'Contact', id: string, isKeyContact: boolean, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null }, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string, tabs: Array<{ __typename?: 'TabResult', id: string }> } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, totalRecipients: number, percentFailed: number, percentUnsubscribed: number } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } | null };

export type RenameCampaignMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameCampaignMutation = { __typename?: 'Mutation', updateEmailMarketingCampaign: { __typename?: 'UpdateCampaignMutationPayload', failReasons: Array<string>, updatedCampaign: { __typename?: 'Campaign', id: string, title: string } | null } | null };

export type CancelScheduledCampaignMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type CancelScheduledCampaignMutation = { __typename?: 'Mutation', cancelScheduledEmailMarketingCampaign: { __typename?: 'DescheduleCampaignMutationPayload', failReasons: Array<string>, campaign: { __typename?: 'Campaign', id: string } | null } | null };

export type SendNowMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  scheduledAt: Scalars['ISO8601DateTime']['input'];
}>;


export type SendNowMutation = { __typename?: 'Mutation', scheduleEmailMarketingCampaign: { __typename?: 'ScheduleCampaignMutationPayload', failReasons: Array<string>, scheduledCampaign: { __typename?: 'Campaign', id: string, status: CampaignStatus, scheduledAt: string | null } | null } | null };

export type CreatedByIdFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type CreatedByIdFieldQuery = { __typename?: 'Query', users: { __typename?: 'UserEntries', entries: Array<{ __typename?: 'UserInfo', id: string, profileName: string, profileImageUrl: string | null, email: string }> } };

export type CreatedByIdFieldOptionFragment = { __typename?: 'UserInfo', id: string, profileName: string, profileImageUrl: string | null, email: string };

export type CreatedByIdFieldUserQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type CreatedByIdFieldUserQuery = { __typename?: 'Query', user: { __typename?: 'UserResponse', info: { __typename?: 'UserInfo', id: string, profileName: string, profileImageUrl: string | null, email: string } } | null };

export type WorkspaceIdFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceIdFieldQuery = { __typename?: 'Query', apps: { __typename?: 'ProjectList', entries: Array<{ __typename?: 'Project', id: string, title: string }> }, projects: { __typename?: 'ProjectList', entries: Array<{ __typename?: 'Project', id: string, title: string }> } };

export type WorkspaceIdFieldOptionFragment = { __typename?: 'Project', id: string, title: string };

export type WorkspaceIdFieldWorkspaceQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type WorkspaceIdFieldWorkspaceQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, title: string } | null };

export type CampaignRowFragment = { __typename?: 'Campaign', id: string, title: string, usageMode: CampaignUsage | null, continuous: boolean, createdAt: string, status: CampaignStatus, sentAt: string | null, updatedAt: string, scheduledAt: string | null, createdBy: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, contact: { __typename?: 'Contact', id: string, isKeyContact: boolean, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null }, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string, tabs: Array<{ __typename?: 'TabResult', id: string }> } | null, analytics: { __typename?: 'CampaignAnalytics', percentDelivered: number, percentOpened: number, percentClicked: number, totalRecipients: number, percentFailed: number, percentUnsubscribed: number } | null };

export type CreatedByFragment = { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, contact: { __typename?: 'Contact', id: string, isKeyContact: boolean, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null };

export type ArchiveTemplateMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ArchiveTemplateMutation = { __typename?: 'Mutation', archiveEmailMarketingTemplate: { __typename?: 'ArchiveTemplateMutationPayload', failReasons: Array<string>, template: { __typename?: 'Template', id: string } | null } | null };

export type CreateTemplateMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createEmailMarketingTemplate: { __typename?: 'CreateTemplateMutationPayload', failReasons: Array<string>, template: { __typename?: 'Template', id: string, title: string, templateJson: string | null } | null } | null };

export type TemplateFragment = { __typename?: 'Template', id: string, title: string, templateJson: string | null, thumbnail: string | null, archivedAt: string | null };

export type TemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TemplatesFilterInput>;
}>;


export type TemplatesQuery = { __typename?: 'Query', emailMarketingTemplatesV2: { __typename?: 'Templates', entries: Array<{ __typename?: 'Template', id: string, title: string, templateJson: string | null, thumbnail: string | null, archivedAt: string | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type CloneTemplateMutationVariables = Exact<{
  templateUid: Scalars['ID']['input'];
}>;


export type CloneTemplateMutation = { __typename?: 'Mutation', cloneEmailMarketingTemplate: { __typename?: 'CloneTemplateMutationPayload', failReasons: Array<string>, clonedTemplate: { __typename?: 'Template', id: string, title: string } | null } | null };

export type RenameTemplateMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameTemplateMutation = { __typename?: 'Mutation', updateEmailMarketingTemplate: { __typename?: 'UpdateTemplateMutationPayload', failReasons: Array<string>, template: { __typename?: 'Template', id: string, title: string } | null } | null };

export type RestoreTemplateMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type RestoreTemplateMutation = { __typename?: 'Mutation', restoreEmailMarketingTemplate: { __typename?: 'RestoreTemplateMutationPayload', failReasons: Array<string>, template: { __typename?: 'Template', id: string } | null } | null };

export type TemplateEditContentQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type TemplateEditContentQuery = { __typename?: 'Query', emailMarketingTemplate: { __typename?: 'Template', id: string, templateJson: string | null, title: string } | null, beePlugin: { __typename?: 'BeePlugin', id: string, clientId: string, clientSecret: string, beeUserUid: string }, beeAuth: { __typename?: 'BeeAuth', accessToken: string, v2: boolean }, emailMarketingConfiguration: { __typename?: 'EmailMarketingConfiguration', id: string, fonts: Array<{ __typename?: 'Font', name: string, url: string, family: string }> } | null };

export type UpdateTemplateContentMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  templateJson?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTemplateContentMutation = { __typename?: 'Mutation', updateEmailMarketingTemplate: { __typename?: 'UpdateTemplateMutationPayload', failReasons: Array<string>, template: { __typename?: 'Template', id: string, templateJson: string | null } | null } | null };

export type CleanerCompanyRowFragment = { __typename?: 'Company', domain: string | null, id: string, archivedAt: string | null, isBlocked: boolean, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null } };

export type ArchivedCompaniesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CompanyFiltering>;
  orderBy?: InputMaybe<ArchivedCompaniesOrderBy>;
}>;


export type ArchivedCompaniesQuery = { __typename?: 'Query', archivedCompanies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', domain: string | null, id: string, archivedAt: string | null, isBlocked: boolean, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type BulkArchiveCompaniesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkArchiveCompaniesMutation = { __typename?: 'Mutation', bulkArchiveCompanies: { __typename?: 'BulkArchiveCompaniesMutationPayload', failReasons: Array<string> } | null };

export type BulkRestoreArchiveContactsMutationVariables = Exact<{
  contact_uids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkRestoreArchiveContactsMutation = { __typename?: 'Mutation', bulkRestoreArchiveContacts: { __typename?: 'BulkRestoreArchivedContactsMutationPayload', failReasons: Array<string> } | null };

export type BulkRestoreArchivedCompaniesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkRestoreArchivedCompaniesMutation = { __typename?: 'Mutation', bulkRestoreArchivedCompanies: { __typename?: 'BulkRestoreArchivedCompaniesMutationPayload', failReasons: Array<string> } | null };

export type PurgeContactMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type PurgeContactMutation = { __typename?: 'Mutation', purgeContact: { __typename?: 'PurgeContactMutationPayload', failReasons: Array<string> } | null };

export type RestoreArchivedCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreArchivedCompanyMutation = { __typename?: 'Mutation', restoreArchivedCompany: { __typename?: 'RestoreArchivedCompanyMutationPayload', failReasons: Array<string> } | null };

export type ArchivedContactCleanerRowFragment = { __typename?: 'Contact', id: string, emailAddresses: Array<any>, primaryEmail: any | null, createdAt: string, archivedAt: string | null, unarchiveOnNextInteraction: boolean | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, company: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ArchivedContactsCleanerQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ArchivedContactsOrderBy>;
  filter?: InputMaybe<ArchivedContactsFiltering>;
}>;


export type ArchivedContactsCleanerQuery = { __typename?: 'Query', archivedContacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, emailAddresses: Array<any>, primaryEmail: any | null, createdAt: string, archivedAt: string | null, unarchiveOnNextInteraction: boolean | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, company: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type AddDuplicateCompaniesToHierarchyMutationVariables = Exact<{
  duplicateCompanyUid: Scalars['ID']['input'];
}>;


export type AddDuplicateCompaniesToHierarchyMutation = { __typename?: 'Mutation', addDuplicateCompaniesToHierarchy: { __typename?: 'AddDuplicateCompaniesToHierarchyMutationPayload', failReasons: Array<string> } | null };

export type DuplicateCompaniesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DupilcateCompaniesOrderBy>;
  filter?: InputMaybe<DuplicateCompaniesFiltering>;
}>;


export type DuplicateCompaniesQuery = { __typename?: 'Query', duplicateCompanies: { __typename?: 'DuplicateCompaniesList', entries: Array<{ __typename?: 'DuplicateCompany', id: string, duplicate: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, original: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type DuplicateCompaniesRowFragment = { __typename?: 'DuplicateCompany', id: string, duplicate: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, original: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } };

export type DuplicateCompanyPreviewFragment = { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string } };

export type DuplicateContactPreviewFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', displayName: string, id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string }>, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type DuplicateContactRowFragment = { __typename?: 'DuplicateContact', id: string, duplicate: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', displayName: string, id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string }>, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, original: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', displayName: string, id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string }>, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } };

export type DuplicateContactsQueryVariables = Exact<{
  filter?: InputMaybe<DuplicateContactFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DupilcateContactsOrderBy>;
}>;


export type DuplicateContactsQuery = { __typename?: 'Query', duplicateContacts: { __typename?: 'DuplicateContactsList', entries: Array<{ __typename?: 'DuplicateContact', id: string, duplicate: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', displayName: string, id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string }>, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, original: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', displayName: string, id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string }>, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type MergeCompanyMutationVariables = Exact<{
  previousUid: Scalars['ID']['input'];
  currentUid: Scalars['ID']['input'];
}>;


export type MergeCompanyMutation = { __typename?: 'Mutation', mergeCompany: { __typename?: 'MergeCompanyMutationPayload', failReasons: Array<string> } | null };

export type RemoveDuplicateCompanyMutationVariables = Exact<{
  duplicateUid: Scalars['ID']['input'];
}>;


export type RemoveDuplicateCompanyMutation = { __typename?: 'Mutation', removeDuplicateCompany: { __typename?: 'RemoveDuplicateCompanyMutationPayload', failReasons: Array<string> } | null };

export type RemoveDuplicateContactMutationVariables = Exact<{
  duplicateUid: Scalars['String']['input'];
}>;


export type RemoveDuplicateContactMutation = { __typename?: 'Mutation', removeDuplicateContact: { __typename?: 'RemoveDuplicateContactMutationPayload', failReasons: Array<string> } | null };

export type BulkIgnoreIncompleteCompaniesMutationVariables = Exact<{
  company_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkIgnoreIncompleteCompaniesMutation = { __typename?: 'Mutation', bulkIgnoreIncompleteCompanies: { __typename?: 'BulkIgnoreIncompleteCompaniesMutationPayload', failReasons: Array<string> } | null };

export type BulkIgnoreIncompleteContactsMutationVariables = Exact<{
  uids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkIgnoreIncompleteContactsMutation = { __typename?: 'Mutation', bulkIgnoreIncompleteContacts: { __typename?: 'BulkIgnoreIncompleteContactsMutationPayload', failReasons: Array<string> } | null };

export type ExportIncompleteCompaniesMutationVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportIncompleteCompaniesMutation = { __typename?: 'Mutation', exportIncompleteCompanies: { __typename?: 'ExportIncompleteCompaniesMutationPayload', failReasons: Array<string>, export: { __typename?: 'Export', id: string } | null } | null };

export type ExportIncompleteContactsMutationVariables = Exact<{
  filter?: InputMaybe<IncompleteContactFiltering>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportIncompleteContactsMutation = { __typename?: 'Mutation', exportIncompleteContacts: { __typename?: 'ExportIncompleteContactsMutationPayload', failReasons: Array<string>, export: { __typename?: 'Export', id: string } | null } | null };

export type IgnoreIncompleteCompanyMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type IgnoreIncompleteCompanyMutation = { __typename?: 'Mutation', ignoreIncompleteCompany: { __typename?: 'IgnoreIncompleteCompanyMutationPayload', failReasons: Array<string> } | null };

export type IgnoreIncompleteContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IgnoreIncompleteContactMutation = { __typename?: 'Mutation', ignoreIncompleteContact: { __typename?: 'IgnoreIncompleteContactMutationPayload', failReasons: Array<string> } | null };

export type IncompleteCompaniesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CompaniesOrderBy>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type IncompleteCompaniesQuery = { __typename?: 'Query', incompleteCompanies: { __typename?: 'IncompleteCompaniesList', entries: Array<{ __typename?: 'IncompleteCompany', domain: string | null, id: string, createdAt: string, logoUrl: string | null, missing: Array<MissingCompanyKind>, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null } }>, pageInfo: { __typename?: 'PagingInfo', totalPages: number, totalEntries: number } } };

export type IncompleteCompanyRowFragment = { __typename?: 'IncompleteCompany', domain: string | null, id: string, createdAt: string, logoUrl: string | null, missing: Array<MissingCompanyKind>, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null } };

export type IncompleteContactRowFragment = { __typename?: 'IncompleteContact', emailAddresses: Array<any>, primaryEmail: any | null, createdAt: string, changedJob: boolean, missing: Array<MissingContactInfo>, isArchived: boolean, isKeyContact: boolean, id: string, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, company: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number } };

export type IncompleteContactsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<IncompleteContactFiltering>;
  orderBy?: InputMaybe<ContactsOrderBy>;
}>;


export type IncompleteContactsQuery = { __typename?: 'Query', incompleteContacts: { __typename?: 'IncompleteContactsList', entries: Array<{ __typename?: 'IncompleteContact', emailAddresses: Array<any>, primaryEmail: any | null, createdAt: string, changedJob: boolean, missing: Array<MissingContactInfo>, isArchived: boolean, isKeyContact: boolean, id: string, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, company: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type BulkUpdateIncompleteContactsMutationVariables = Exact<{
  contactUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  updatableAttributes: BulkUpdateContactAttributes;
}>;


export type BulkUpdateIncompleteContactsMutation = { __typename?: 'Mutation', bulkUpdateContact: { __typename?: 'BulkUpdateContactMutationPayload', failReasons: Array<string> } | null };

export type IncompleteContactGridRowFragment = { __typename?: 'IncompleteContact', primaryEmail: any | null, createdAt: string, updatedAt: string | null, id: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, marketingListConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, company: { __typename?: 'Company', id: string, logoUrl: string | null, domain: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number, meetings: number }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }> };

export type IncompleteContactsGridQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<IncompleteContactFiltering>;
  orderBy?: InputMaybe<ContactsOrderBy>;
  datasourceVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IncompleteContactsGridQuery = { __typename?: 'Query', incompleteContacts: { __typename?: 'IncompleteContactsList', entries: Array<{ __typename?: 'IncompleteContact', primaryEmail: any | null, createdAt: string, updatedAt: string | null, id: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, marketingListConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, company: { __typename?: 'Company', id: string, logoUrl: string | null, domain: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number, meetings: number }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ContactRequireHierarchyPlacementFragment = { __typename?: 'Contact', isPersonal: boolean, isEmployee: boolean, emailAddresses: Array<any>, id: string, primaryEmail: any | null, archivedAt: string | null, changedJob: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, imageUrl: string | null, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ContactRequireHierarchyPlacementsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactRequireHierarchyPlacementsQuery = { __typename?: 'Query', contactRequireHierarchyPlacements: { __typename?: 'ContactRequireHierarchyPlacementList', entries: Array<{ __typename?: 'ContactRequireHierarchyPlacement', id: string, contact: { __typename?: 'Contact', isPersonal: boolean, isEmployee: boolean, emailAddresses: Array<any>, id: string, primaryEmail: any | null, archivedAt: string | null, changedJob: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, imageUrl: string | null, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }> | null, pageInfo: { __typename?: 'PagingInfo', totalEntries: number, totalPages: number } | null } };

export type ExportUnengagedContactsMutationVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportUnengagedContactsMutation = { __typename?: 'Mutation', exportUnengagedContacts: { __typename?: 'ExportUnengagedContactsMutationPayload', failReasons: Array<string>, export: { __typename?: 'Export', id: string } | null } | null };

export type UnengagedContactRowFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type UnengagedContactsQueryVariables = Exact<{
  orderBy?: InputMaybe<UnengagedContactsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<UnengagedContactsFiltering>;
}>;


export type UnengagedContactsQuery = { __typename?: 'Query', unengagedContacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type CommentThreadCountQueryVariables = Exact<{
  attachedToUid: Scalars['ID']['input'];
  attachedToType: CommentThreadAttachable;
}>;


export type CommentThreadCountQuery = { __typename?: 'Query', commentThreadInfo: { __typename?: 'CommentThreadInfo', id: string | null, commentsCount: number | null } };

export type CommentThreadInfoQueryVariables = Exact<{
  attachedToUid: Scalars['ID']['input'];
  attachedToType: CommentThreadAttachable;
  ff_release_12_faster_comment_threads: Scalars['Boolean']['input'];
}>;


export type CommentThreadInfoQuery = { __typename?: 'Query', commentThreadInfo: { __typename?: 'CommentThreadInfo', id: string | null, mentionables?: Array<{ __typename?: 'UserInfo', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null, jobTitle: string | null } } | null }>, mentionableUsers?: Array<{ __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null, jobTitle: string | null } } | null }> | null } };

export type CreateCommentThreadMutationVariables = Exact<{
  attachedToUid: Scalars['ID']['input'];
  attachedToType: CommentThreadAttachable;
  htmlContent: Scalars['String']['input'];
}>;


export type CreateCommentThreadMutation = { __typename?: 'Mutation', createCommentThread: { __typename?: 'CreateCommentThreadMutationPayload', failReasons: Array<string>, commentThread: { __typename?: 'CommentThread', id: string } | null } | null };

export type MentionableFragment = { __typename?: 'UserInfo', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null, jobTitle: string | null } } | null };

export type MentionableUserFragment = { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null, jobTitle: string | null } } | null };

export type BulkUpdateCompanyTypeMutationVariables = Exact<{
  uids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  companyTypeUid: Scalars['ID']['input'];
}>;


export type BulkUpdateCompanyTypeMutation = { __typename?: 'Mutation', bulkUpdateCompanyType: { __typename?: 'BulkUpdateCompanyTypeMutationPayload', failReasons: Array<string> } | null };

export type CompanyQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type CompanyQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, canManageRelationshipPartners: boolean, logoUrl: string | null, archivedAt: string | null, isInternal: boolean, isSubDomainCompany: boolean, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, info: { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null }, insightStat: { __typename?: 'InsightStat', previousTotalEmails: number, previousTotalInteractions: number, previousTotalMeetings: number, totalEmails: number, totalEmailsIncrease: number, totalInteractionIncrease: number, totalInteractions: number, totalMeetings: number, totalMeetingsIncrease: number, lastInteractionAt: string | null, lastBdInteractionAt: string | null }, lastReferralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, reporting: { __typename?: 'CompanyReporting', url: string | null }, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null } | null, myCompany: { __typename?: 'MyCompany', id: string } | null };

export type CompanyCustomTypeFragment = { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null };

export type CompanyCustomTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyCustomTypesQuery = { __typename?: 'Query', tenantConfiguration: { __typename?: 'TenantConfiguration', id: string, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }> } | null };

export type CompanyFormikFieldWithOptionsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyFormikFieldWithOptionsQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, contacts: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } }> } };

export type CompanyFormikFieldWithOptionsFragment = { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, contacts: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } };

export type CompanyInfoToUpdateFragment = { __typename?: 'CompanyInfo', id: string | null, name: string, description: string | null, numberOfEmployees: number | null, linkedinUrl: string | null, twitterUrl: string | null, website: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, industryNames: Array<string> | null, tags: Array<string>, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null };

export type CompanyInsightStatFragment = { __typename?: 'InsightStat', previousTotalEmails: number, previousTotalInteractions: number, previousTotalMeetings: number, totalEmails: number, totalEmailsIncrease: number, totalInteractionIncrease: number, totalInteractions: number, totalMeetings: number, totalMeetingsIncrease: number, lastInteractionAt: string | null, lastBdInteractionAt: string | null };

export type CompanyNotesQueryVariables = Exact<{
  companyUid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyNotesQuery = { __typename?: 'Query', companyNotes: { __typename?: 'CompanyNoteList', entries: Array<{ __typename?: 'CompanyNote', id: string, access: CompanyNoteAccess, createdAt: string, updatedAt: string, richContent: { __typename?: 'RichContent', html: string, trixHtml: string }, company: { __typename?: 'Company', id: string, logoUrl: string | null, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, updater: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type CompanyOpportunitiesQueryVariables = Exact<{
  companyUid?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CompanyOpportunityFiltering>;
}>;


export type CompanyOpportunitiesQuery = { __typename?: 'Query', companyOpportunities: { __typename?: 'CompanyOpportunityList', entries: Array<{ __typename?: 'CompanyOpportunity', id: string, trackingNumber: string, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, opportunity: { __typename?: 'Opportunity', id: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', format: string, cents: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null }> } };

export type CompanyOptionsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyOptionsQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }> } };

export type CompanyOverviewFragment = { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null };

export type CompanyPreviewFragment = { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } };

export type CompanyProfileFragment = { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, canManageRelationshipPartners: boolean, logoUrl: string | null, archivedAt: string | null, isInternal: boolean, isSubDomainCompany: boolean, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, info: { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null }, insightStat: { __typename?: 'InsightStat', previousTotalEmails: number, previousTotalInteractions: number, previousTotalMeetings: number, totalEmails: number, totalEmailsIncrease: number, totalInteractionIncrease: number, totalInteractions: number, totalMeetings: number, totalMeetingsIncrease: number, lastInteractionAt: string | null, lastBdInteractionAt: string | null }, lastReferralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, reporting: { __typename?: 'CompanyReporting', url: string | null }, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null };

export type CompanyRelationshipPartnerFragment = { __typename?: 'RelationshipPartner', id: string, discardedAt: string | null, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, interactionsLast: { __typename?: 'LastAts', interactionAt: string | null } | null };

export type CompanyRelationshipPartnersQueryVariables = Exact<{
  companyUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyRelationshipPartnersQuery = { __typename?: 'Query', companyRelationshipPartners: { __typename?: 'RelationshipPartnerList', entries: Array<{ __typename?: 'RelationshipPartner', id: string, discardedAt: string | null, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, interactionsLast: { __typename?: 'LastAts', interactionAt: string | null } | null }> } };

export type CompanySlideQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type CompanySlideQuery = { __typename?: 'Query', company: { __typename?: 'Company', isInternal: boolean, id: string, domain: string | null, contacts: number, archivedAt: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> } | null };

export type CompanySlideProfileFragment = { __typename?: 'Company', isInternal: boolean, id: string, domain: string | null, contacts: number, archivedAt: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> };

export type CompanyToUpdateQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type CompanyToUpdateQuery = { __typename?: 'Query', company: { __typename?: 'Company', domain: string | null, id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, description: string | null, numberOfEmployees: number | null, linkedinUrl: string | null, twitterUrl: string | null, website: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, industryNames: Array<string> | null, tags: Array<string>, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null } | null };

export type CompanyWhoKnowsQueryVariables = Exact<{
  contactUid: Scalars['String']['input'];
  filter?: InputMaybe<WhoKnowsFiltering>;
}>;


export type CompanyWhoKnowsQuery = { __typename?: 'Query', whoKnows: { __typename?: 'WhoKnowsList', entries: Array<{ __typename?: 'WhoKnows', id: string, lastInteraction: string, numberOfInteractions: number, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }> } };

export type CreateCompany2MutationVariables = Exact<{
  domain: Scalars['String']['input'];
  attributes: CompanyAttributes;
  companyDefaultType?: InputMaybe<CompanyTypeDefault>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  companyTypeUid?: InputMaybe<Scalars['ID']['input']>;
  companyTypesUids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  externalIdentifier?: InputMaybe<ExternalIdentifierInput>;
}>;


export type CreateCompany2Mutation = { __typename?: 'Mutation', createCompany: { __typename?: 'CreateCompanyMutationPayload', uid: string | null, failReasons: Array<string> } | null };

export type EmployeeCompanyStatsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<EmployeeCompanyStatsFilteringInput>;
}>;


export type EmployeeCompanyStatsQuery = { __typename?: 'Query', employeeCompanyStats: { __typename?: 'EmployeeCompanyStatsList', entries: Array<{ __typename?: 'EmployeeCompanyStats', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, last: { __typename?: 'LastAts', interactionAt: string | null } | null, total: { __typename?: 'Totals', interactions: number } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type EmployeeCompanyStatsEntryFragment = { __typename?: 'EmployeeCompanyStats', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, last: { __typename?: 'LastAts', interactionAt: string | null } | null, total: { __typename?: 'Totals', interactions: number } };

export type ExternalIdentifierConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalIdentifierConfigurationQuery = { __typename?: 'Query', tenantConfiguration: { __typename?: 'TenantConfiguration', id: string, clientAndGroupIds: boolean, preferInternalIndustry: boolean } | null };

export type FullAddressFragment = { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null };

export type GetCompanyMostActiveContactsQueryVariables = Exact<{
  domain: Scalars['String']['input'];
  top: Scalars['Int']['input'];
}>;


export type GetCompanyMostActiveContactsQuery = { __typename?: 'Query', companyContacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, emailAddresses: Array<any>, isEmployee: boolean, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, department: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string, lastInteraction: string, numberOfInteractions: number, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type MostActiveContactTableRowFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, emailAddresses: Array<any>, isEmployee: boolean, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, department: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string, lastInteraction: string, numberOfInteractions: number, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type MyCompanyExistsFragment = { __typename?: 'MyCompany', id: string };

export type OfficeLabelsAutocompleteQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type OfficeLabelsAutocompleteQuery = { __typename?: 'Query', officeLabels: { __typename?: 'OfficeLabelsList', entries: Array<string> } | null };

export type ReportIncorrectCompanyInfoMutationVariables = Exact<{
  companyUid: Scalars['ID']['input'];
  fields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportIncorrectCompanyInfoMutation = { __typename?: 'Mutation', reportIncorrectCompanyData: { __typename?: 'ReportIncorrectCompanyDataMutationPayload', failReasons: Array<string> } | null };

export type TabsCompanyOpportunitiesCountQueryVariables = Exact<{
  companyUid: Scalars['String']['input'];
  filter?: InputMaybe<CompanyOpportunityFiltering>;
}>;


export type TabsCompanyOpportunitiesCountQuery = { __typename?: 'Query', companyOpportunities: { __typename?: 'CompanyOpportunityList', entries: Array<{ __typename?: 'CompanyOpportunity', id: string }> } };

export type TabsCompanyPendingTasksCountQueryVariables = Exact<{
  filter?: InputMaybe<TaskFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TabsCompanyPendingTasksCountQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskEntries', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type UpdateCompanyMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: CompanyAttributes;
  companyTypeUid?: InputMaybe<Scalars['ID']['input']>;
  companyTypesUids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  externalIdentifier?: InputMaybe<ExternalIdentifierInput>;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'UpdateCompanyMutationPayload', failReasons: Array<string> } | null };

export type UpdateCompanyDetailsMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: CompanyAttributes;
  companyTypeUid?: InputMaybe<Scalars['ID']['input']>;
  externalIdentifier?: InputMaybe<ExternalIdentifierInput>;
}>;


export type UpdateCompanyDetailsMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'UpdateCompanyMutationPayload', failReasons: Array<string>, companyUpdated: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string } } | null } | null };

export type UpdateCompanyIndustryMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: CompanyAttributes;
}>;


export type UpdateCompanyIndustryMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'UpdateCompanyMutationPayload', failReasons: Array<string> } | null };

export type UpdateCompanyTypesMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  companyTypeUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateCompanyTypesMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'UpdateCompanyMutationPayload', failReasons: Array<string> } | null };

export type UpdateCompanyTypesDataQueryVariables = Exact<{
  companyUid: Scalars['String']['input'];
}>;


export type UpdateCompanyTypesDataQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }> } | null };

export type CompanyAuditTrailQueryVariables = Exact<{
  company_uid: Scalars['ID']['input'];
}>;


export type CompanyAuditTrailQuery = { __typename?: 'Query', companyAuditTrail: { __typename?: 'AuditTrail', entries: Array<{ __typename?: 'Audit', auditedEntity: AuditEntity, action: AuditAction, performedAt: string, performedBy: string | null, changes: Array<{ __typename?: 'AuditChange', name: string, newValue: string, oldValue: string }> }> } | null };

export type BlockCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BlockCompanyMutation = { __typename?: 'Mutation', blockCompany: { __typename?: 'BlockCompanyMutationPayload', failReasons: Array<string> } | null };

export type UnBlockCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnBlockCompanyMutation = { __typename?: 'Mutation', unblockCompany: { __typename?: 'UnblockCompanyMutationPayload', failReasons: Array<string> } | null };

export type CompanyOpportunityPreviewFragment = { __typename?: 'CompanyOpportunity', id: string, trackingNumber: string, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, opportunity: { __typename?: 'Opportunity', id: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', format: string, cents: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null };

export type CompanyOpportunityStatsFragment = { __typename?: 'Company', id: string, domain: string | null, referredOpportunityStats: { __typename?: 'OpportunityStat', totalProposalFee: number, totalPercentageWon: number, totalWonProposalFee: number | null, totalOpenCount: number, totalWonCount: number }, opportunityStats: { __typename?: 'OpportunityStat', totalProposalFee: number, totalWonProposalFee: number | null, totalPercentageWon: number, totalOpenCount: number, totalWonCount: number } };

export type CompanyConnectionRowFragment = { __typename?: 'PersonCompanyContact', id: string, jobTitles: Array<{ __typename?: 'ContactJobTitle', id: string, name: string, endDate: string | null, startDate: string | null }>, person: { __typename?: 'Person', id: string, activeContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, interactionsTotal: { __typename?: 'Totals', interactions: number }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } };

export type CompanyConnectionsQueryVariables = Exact<{
  companyUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyConnectionsQuery = { __typename?: 'Query', companyConnections: { __typename?: 'PersonCompanyContactEntries', entries: Array<{ __typename?: 'PersonCompanyContact', id: string, jobTitles: Array<{ __typename?: 'ContactJobTitle', id: string, name: string, endDate: string | null, startDate: string | null }>, person: { __typename?: 'Person', id: string, activeContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, interactionsTotal: { __typename?: 'Totals', interactions: number }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type CompanyFilterWithOptionsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyFilterWithOptionsQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null } | null } }> } };

export type CompanyFilterWithOptionsFragment = { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null } | null } };

export type CompanyHierarchyByUidsQueryVariables = Exact<{
  companyUids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CompanyHierarchyByUidsQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null } | null } }> } };

export type CompanyHierarchyByUidsFragment = { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null } | null } };

export type AddCompanyToAssociationMutationVariables = Exact<{
  associationUuid: Scalars['ID']['input'];
  companyName: Scalars['String']['input'];
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddCompanyToAssociationMutation = { __typename?: 'Mutation', addCompanyToAssociation: { __typename?: 'AddCompanyToAssociationMutationPayload', failReasons: Array<string> } | null };

export type AddCompanyToHierarchyMutationVariables = Exact<{
  parentUuid: Scalars['ID']['input'];
  companyName: Scalars['String']['input'];
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddCompanyToHierarchyMutation = { __typename?: 'Mutation', addCompanyToHierarchy: { __typename?: 'AddCompanyToHierarchyMutationPayload', failReasons: Array<string> } | null };

export type AddContactsToHierarchyMutationVariables = Exact<{
  contactEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  companyUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddContactsToHierarchyMutation = { __typename?: 'Mutation', addContactsToHierarchy: { __typename?: 'AddContactsToHierarchyMutationPayload', failReasons: Array<string> } | null };

export type AddContactsWithCompanyToHierarchyMutationVariables = Exact<{
  contactEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  parentUuid?: InputMaybe<Scalars['String']['input']>;
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
}>;


export type AddContactsWithCompanyToHierarchyMutation = { __typename?: 'Mutation', addContactsWithCompanyToHierarchy: { __typename?: 'AddContactsWithCompanyToHierarchyMutationPayload', failReasons: Array<string> } | null };

export type BulkAssociateCompaniesMutationVariables = Exact<{
  companyUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkAssociateCompaniesMutation = { __typename?: 'Mutation', bulkAssociateCompanies: { __typename?: 'BulkAssociateCompaniesMutationPayload', failReasons: Array<string> } | null };

export type CompanyHierarchyQueryVariables = Exact<{
  companyUid: Scalars['ID']['input'];
}>;


export type CompanyHierarchyQuery = { __typename?: 'Query', companyHierarchy: { __typename?: 'CompanyHierarchyEntries', entries: Array<{ __typename?: 'CompanyHierarchy', id: string, position: number, parent: { __typename?: 'Company', id: string } | null, company: { __typename?: 'Company', contacts: number, id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, location: { __typename?: 'Location', id: string, country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> }> } | null, currentTenant: { __typename?: 'Tenant', id: string, companyHierarchyCustomFields: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> | null } | null };

export type CompanyHierarchyCountQueryVariables = Exact<{
  companyUid: Scalars['ID']['input'];
}>;


export type CompanyHierarchyCountQuery = { __typename?: 'Query', companyHierarchy: { __typename?: 'CompanyHierarchyEntries', count: number } | null };

export type CompanyHierarchyEntryFragment = { __typename?: 'CompanyHierarchy', id: string, position: number, parent: { __typename?: 'Company', id: string } | null, company: { __typename?: 'Company', contacts: number, id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, location: { __typename?: 'Location', id: string, country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> };

export type CompanyHierarchyOptionFragment = { __typename?: 'CompanyHierarchy', id: string, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } };

export type CompanyHierarchyOptionsQueryVariables = Exact<{
  companyUid: Scalars['ID']['input'];
}>;


export type CompanyHierarchyOptionsQuery = { __typename?: 'Query', companyHierarchy: { __typename?: 'CompanyHierarchyEntries', entries: Array<{ __typename?: 'CompanyHierarchy', id: string, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } }> } | null };

export type MoveCompaniesToHierarchyMutationVariables = Exact<{
  companyUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  parentUuid: Scalars['ID']['input'];
}>;


export type MoveCompaniesToHierarchyMutation = { __typename?: 'Mutation', moveCompaniesToHierarchy: { __typename?: 'MoveCompaniesToHierarchyMutationPayload', failReasons: Array<string> } | null };

export type RemoveCompanyFromHierarchyMutationVariables = Exact<{
  companyUuid: Scalars['String']['input'];
}>;


export type RemoveCompanyFromHierarchyMutation = { __typename?: 'Mutation', removeCompanyFromHierarchy: { __typename?: 'RemoveCompanyFromHierarchyMutationPayload', failReasons: Array<string> } | null };

export type RemoveContactFromRequireHierarchyPlacementMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
}>;


export type RemoveContactFromRequireHierarchyPlacementMutation = { __typename?: 'Mutation', removeContactFromRequireHierarchyPlacement: { __typename?: 'RemoveContactFromRequireHierarchyPlacementMutationPayload', failReasons: Array<string> } | null };

export type SyncCompanyHierarchyMutationVariables = Exact<{
  companyHierarchy: Array<HierarchyInput> | HierarchyInput;
}>;


export type SyncCompanyHierarchyMutation = { __typename?: 'Mutation', syncCompanyHierarchy: { __typename?: 'SyncCompanyHierarchyMutationPayload', failReasons: Array<string> } | null };

export type TreeItemCompanyFragment = { __typename?: 'Company', contacts: number, id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, location: { __typename?: 'Location', id: string, country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> };

export type UpdateCompanyHierarchyCustomFieldsMutationVariables = Exact<{
  companyUid: Scalars['ID']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type UpdateCompanyHierarchyCustomFieldsMutation = { __typename?: 'Mutation', updateCompanyHierarchy: { __typename?: 'UpdateCompanyHierarchyMutationPayload', failReasons: Array<string> } | null };

export type InternalIndustriesQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalIndustriesQuery = { __typename?: 'Query', internalIndustries: { __typename?: 'InternalIndustryList', entries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> } };

export type InternalIndustriesConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalIndustriesConfigurationQuery = { __typename?: 'Query', tenantConfiguration: { __typename?: 'TenantConfiguration', id: string, showInternalIndustries: boolean } | null };

export type AddInteractionKeyActivityMutationVariables = Exact<{
  interactionUid: Scalars['ID']['input'];
  activityTitle: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  category: KeyActivityCategory;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddInteractionKeyActivityMutation = { __typename?: 'Mutation', addInteractionKeyActivity: { __typename?: 'AddInteractionKeyActivityMutationPayload', failReasons: Array<string>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null } | null } | null };

export type AllInteractionQueryVariables = Exact<{
  interactionType?: InputMaybe<PartitionedInteractionType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  companyUid?: InputMaybe<Scalars['String']['input']>;
  keyActivityCategories?: InputMaybe<Array<KeyActivityCategory> | KeyActivityCategory>;
}>;


export type AllInteractionQuery = { __typename?: 'Query', allInteraction: { __typename?: 'PartitionedInteractionList', entries: Array<{ __typename?: 'PartitionedInteraction', id: string, interactionType: PartitionedInteractionType, direction: PartitionedInteractionDirection, occuredAt: string | null, occuredEndAt: string | null, webLink: string | null, sender: { __typename?: 'Contact', id: string, primaryEmail: any | null, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } } | null, receivers: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } }, currentUser: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, contact: { __typename?: 'Contact', id: string } } | null } | null };

export type BulkMarkAllKeyActivityContactsMutationVariables = Exact<{
  interactionOn: Scalars['ISO8601DateTime']['input'];
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  category: KeyActivityCategory;
  listId: Scalars['ID']['input'];
  activityTitle: Scalars['String']['input'];
  term: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  internalContacts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BulkMarkAllKeyActivityContactsMutation = { __typename?: 'Mutation', bulkMarkAllKeyActivityContacts: { __typename?: 'BulkMarkAllKeyActivityContactsMutationPayload', failReasons: Array<string> } | null };

export type BulkMarkKeyActivityMutationVariables = Exact<{
  activityTitle: Scalars['String']['input'];
  interactionOn: Scalars['ISO8601DateTime']['input'];
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  category: KeyActivityCategory;
  externalContacts: Array<Scalars['String']['input']> | Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  internalContacts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BulkMarkKeyActivityMutation = { __typename?: 'Mutation', bulkMarkKeyActivity: { __typename?: 'BulkMarkKeyActivityMutationPayload', failReasons: Array<string> } | null };

export type BulkMarkKeyActivityWithTrackerMutationVariables = Exact<{
  activityTitle: Scalars['String']['input'];
  interactionOn: Scalars['ISO8601DateTime']['input'];
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  category: KeyActivityCategory;
  externalContacts: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  internalContacts?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  progressTracker: ProgressTrackerAttributes;
}>;


export type BulkMarkKeyActivityWithTrackerMutation = { __typename?: 'Mutation', bulkMarkKeyActivityWithTracker: { __typename?: 'BulkMarkKeyActivityWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type ContactForKeyActivityFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } };

export type ContactNamePreviewFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } };

export type ContactsBulkLogNewActivityWithTrackerMutationVariables = Exact<{
  activityTitle: Scalars['String']['input'];
  interactionOn: Scalars['ISO8601DateTime']['input'];
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  category: KeyActivityCategory;
  notes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  internalContacts?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  progressTracker: ProgressTrackerAttributes;
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter> | ContactFilter>;
}>;


export type ContactsBulkLogNewActivityWithTrackerMutation = { __typename?: 'Mutation', contactsBulkMarkKeyActivityWithTracker: { __typename?: 'ContactsBulkMarkKeyActivityWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type EmployeeKeyActivitiesQueryVariables = Exact<{
  occurredAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  occurredBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  contactUid: Scalars['ID']['input'];
  category: KeyActivityCategory;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmployeeKeyActivitiesQuery = { __typename?: 'Query', keyActivities: { __typename?: 'InteractionDetailList', entries: Array<{ __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }>, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null }> } };

export type EmployeeKeyActivitiesTotalQueryVariables = Exact<{
  occurredAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  occurredBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  contactUid: Scalars['ID']['input'];
  category: KeyActivityCategory;
}>;


export type EmployeeKeyActivitiesTotalQuery = { __typename?: 'Query', keyActivities: { __typename?: 'InteractionDetailList', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type EmployeeKeyActivityFragment = { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }>, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null };

export type InteractionPreviewFragment = { __typename?: 'PartitionedInteraction', id: string, interactionType: PartitionedInteractionType, direction: PartitionedInteractionDirection, occuredAt: string | null, occuredEndAt: string | null, webLink: string | null, sender: { __typename?: 'Contact', id: string, primaryEmail: any | null, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } } | null, receivers: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null } | null };

export type KeyActivityPreviewFragment = { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null };

export type KeyActivityTitlesQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<KeyActivityCategory> | KeyActivityCategory>;
}>;


export type KeyActivityTitlesQuery = { __typename?: 'Query', keyActivityTitles: { __typename?: 'KeyActivityTitleList', entries: Array<string> } };

export type LastActivitiesAtQueryVariables = Exact<{
  companyUid: Scalars['String']['input'];
}>;


export type LastActivitiesAtQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, insightStat: { __typename?: 'InsightStat', lastBdInteractionAt: string | null, lastMarketingInteractionAt: string | null } } | null };

export type MarkKeyActivityMutationVariables = Exact<{
  activityTitle: Scalars['String']['input'];
  interactionOn: Scalars['ISO8601DateTime']['input'];
  interactionEndAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  keyActivityCategory: KeyActivityCategory;
  externalContacts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  internalContacts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  keyActivityListUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MarkKeyActivityMutation = { __typename?: 'Mutation', markKeyActivity: { __typename?: 'MarkKeyActivityMutationPayload', failReasons: Array<string>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null } | null, keyActitivityListMember: { __typename?: 'KeyActivityListMember', id: string, isPersisted: boolean, keyActivity: { __typename?: 'KeyActivity', id: string, activityTitle: string, description: string | null, category: KeyActivityCategory, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }> } } | null } | null };

export type MarkMeetingAsKeyActivityMutationVariables = Exact<{
  upcomingMeetingUid: Scalars['ID']['input'];
  activityTitle: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  category: KeyActivityCategory;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarkMeetingAsKeyActivityMutation = { __typename?: 'Mutation', markUpcomingMeetingAsKeyActivity: { __typename?: 'MarkUpcomingMeetingAsKeyActivityMutationPayload', failReasons: Array<string>, keyActivity: { __typename?: 'KeyActivity', id: string } | null } | null };

export type MarkUpcomingMeetingAsKeyActivityMutationVariables = Exact<{
  upcomingMeetingUid: Scalars['ID']['input'];
  activityTitle: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  category: KeyActivityCategory;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarkUpcomingMeetingAsKeyActivityMutation = { __typename?: 'Mutation', markUpcomingMeetingAsKeyActivity: { __typename?: 'MarkUpcomingMeetingAsKeyActivityMutationPayload', failReasons: Array<string>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null } | null } | null };

export type RemoveKeyActivityMutationVariables = Exact<{
  keyActivityUid: Scalars['ID']['input'];
}>;


export type RemoveKeyActivityMutation = { __typename?: 'Mutation', removeKeyActivity: { __typename?: 'RemoveKeyActivityMutationPayload', failReasons: Array<string> } | null };

export type UpcomingKeyActivityFragment = { __typename?: 'KeyActivity', id: string, activityTitle: string, interactionOn: string, interactionEndAt: string | null, category: KeyActivityCategory, description: string | null, involvedContacts: Array<{ __typename?: 'Contact', isEmployee: boolean, id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null, calendarMeeting: { __typename?: 'EmployeeMeeting', id: string } | null };

export type UpdateKeyActivityMutationVariables = Exact<{
  keyActivityUid: Scalars['ID']['input'];
  activityTitle?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateKeyActivityMutation = { __typename?: 'Mutation', updateKeyActivity: { __typename?: 'UpdateKeyActivityMutationPayload', failReasons: Array<string>, record: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }>, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null } | null } | null };

export type CompanyKeyContactsQueryVariables = Exact<{
  companyUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyKeyContactsQuery = { __typename?: 'Query', companyKeyContacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', meetingAt: string | null, interactionAt: string | null }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type CreateCompanyKeyContactMutationVariables = Exact<{
  companyUid: Scalars['String']['input'];
  contactUid: Scalars['String']['input'];
}>;


export type CreateCompanyKeyContactMutation = { __typename?: 'Mutation', createCompanyKeyContact: { __typename?: 'CreateCompanyKeyContactMutationPayload', failReasons: Array<string> } | null };

export type RemoveCompanyKeyContactMutationVariables = Exact<{
  companyUid: Scalars['String']['input'];
  contactUid: Scalars['String']['input'];
}>;


export type RemoveCompanyKeyContactMutation = { __typename?: 'Mutation', removeCompanyKeyContact: { __typename?: 'RemoveCompanyKeyContactMutationPayload', failReasons: Array<string> } | null };

export type DataCleanerConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type DataCleanerConfigurationQuery = { __typename?: 'Query', dataCleanerConfiguration: { __typename?: 'DataCleanerConfiguration', showContactsRequiringPlacement: boolean } };

export type KeyActivityBoxFragment = { __typename?: 'KeyActivity', id: string, activityTitle: string, description: string | null, category: KeyActivityCategory, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', trixHtml: string, html: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, interactionType: PartitionedInteractionType, webLink: string | null, direction: PartitionedInteractionDirection } | null, involvedContacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }> };

export type KeyActivityHistoryQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  companyUid: Scalars['ID']['input'];
}>;


export type KeyActivityHistoryQuery = { __typename?: 'Query', keyActivities: { __typename?: 'InteractionDetailList', entries: Array<{ __typename?: 'KeyActivity', id: string, activityTitle: string, description: string | null, category: KeyActivityCategory, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', trixHtml: string, html: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, interactionType: PartitionedInteractionType, webLink: string | null, direction: PartitionedInteractionDirection } | null, involvedContacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } }, currentUser: { __typename?: 'User', id: string, canViewActivityViewDetail: boolean, employee: { __typename?: 'Employee', id: string, contact: { __typename?: 'Contact', id: string } } | null } | null };

export type KeyActivityLatestThreeQueryVariables = Exact<{
  companyUid: Scalars['ID']['input'];
}>;


export type KeyActivityLatestThreeQuery = { __typename?: 'Query', keyActivities: { __typename?: 'InteractionDetailList', entries: Array<{ __typename?: 'KeyActivity', id: string, activityTitle: string, description: string | null, category: KeyActivityCategory, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', trixHtml: string, html: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, interactionType: PartitionedInteractionType, webLink: string | null, direction: PartitionedInteractionDirection } | null, involvedContacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } }, currentUser: { __typename?: 'User', id: string, canViewActivityViewDetail: boolean, employee: { __typename?: 'Employee', id: string, contact: { __typename?: 'Contact', id: string } } | null } | null };

export type CreateCompanyRelationshipPartnerMutationVariables = Exact<{
  companyUid: Scalars['String']['input'];
  ownerUid: Scalars['String']['input'];
}>;


export type CreateCompanyRelationshipPartnerMutation = { __typename?: 'Mutation', createCompanyRelationshipPartner: { __typename?: 'CreateCompanyRelationshipPartnerMutationPayload', failReasons: Array<string>, relationshipPartnerCreated: { __typename?: 'RelationshipPartner', id: string, discardedAt: string | null, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, interactionsLast: { __typename?: 'LastAts', interactionAt: string | null } | null } | null } | null };

export type RemoveCompanyRelationshipPartnerMutationVariables = Exact<{
  companyUid: Scalars['String']['input'];
  ownerUid: Scalars['String']['input'];
}>;


export type RemoveCompanyRelationshipPartnerMutation = { __typename?: 'Mutation', removeCompanyRelationshipPartner: { __typename?: 'RemoveCompanyRelationshipPartnerMutationPayload', failReasons: Array<string>, discarded: { __typename?: 'RelationshipPartner', id: string, discardedAt: string | null } | null } | null };

export type CompanyHasCustomLogoQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type CompanyHasCustomLogoQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, hasCustomLogo: boolean, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null };

export type RemoveCompanyLogoMutationVariables = Exact<{
  companyUid: Scalars['String']['input'];
}>;


export type RemoveCompanyLogoMutation = { __typename?: 'Mutation', removeCompanyLogo: { __typename?: 'RemoveCompanyLogoMutationPayload', failReasons: Array<string>, company: { __typename?: 'Company', id: string, hasCustomLogo: boolean, logoUrl: string | null } | null } | null };

export type SetCompanyLogoMutationVariables = Exact<{
  companyUid: Scalars['ID']['input'];
  fileSignedId: Scalars['ID']['input'];
}>;


export type SetCompanyLogoMutation = { __typename?: 'Mutation', setCompanyLogo: { __typename?: 'SetCompanyLogoMutationPayload', failReasons: Array<string>, company: { __typename?: 'Company', id: string, hasCustomLogo: boolean, logoUrl: string | null } | null } | null };

export type AddCompanyListMemberWithCustomFieldsMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type AddCompanyListMemberWithCustomFieldsMutation = { __typename?: 'Mutation', addCompanyListMember: { __typename?: 'AddCompanyListMemberMutationPayload', failReasons: Array<string>, record: { __typename?: 'CompanyListMember', id: string, companyListId: string, completedTasksCount: number, tasksCount: number, updatedAt: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, company: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, insightStat: { __typename?: 'InsightStat', lastBdInteractionAt: string | null, lastMarketingInteractionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, headquarterLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, interactionsLast: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null } | null };

export type BulkAddCompanyListMemberMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  companyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkAddCompanyListMemberMutation = { __typename?: 'Mutation', bulkAddCompanyListMember: { __typename?: 'BulkAddCompanyListMemberMutationPayload', failReasons: Array<string>, records: Array<{ __typename?: 'CompanyListMember', id: string, companyListId: string, completedTasksCount: number, tasksCount: number, updatedAt: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, company: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, insightStat: { __typename?: 'InsightStat', lastBdInteractionAt: string | null, lastMarketingInteractionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, headquarterLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, interactionsLast: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> }> } | null };

export type BulkRemoveCompanyListMemberMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  companyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkRemoveCompanyListMemberMutation = { __typename?: 'Mutation', bulkRemoveCompanyListMember: { __typename?: 'BulkRemoveCompanyListMemberMutationPayload', failReasons: Array<string> } | null };

export type BulkUpdateCompanyListMemberMutationVariables = Exact<{
  listUid?: InputMaybe<Scalars['ID']['input']>;
  companyMemberIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type BulkUpdateCompanyListMemberMutation = { __typename?: 'Mutation', bulkUpdateCompanyListMember: { __typename?: 'BulkUpdateCompanyListMemberMutationPayload', failReasons: Array<string>, records: Array<{ __typename?: 'CompanyListMember', id: string, companyListId: string, completedTasksCount: number, tasksCount: number, updatedAt: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, company: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, insightStat: { __typename?: 'InsightStat', lastBdInteractionAt: string | null, lastMarketingInteractionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, headquarterLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, interactionsLast: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> }> } | null };

export type CompaniesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CompanyFiltering>;
  orderBy?: InputMaybe<CompaniesOrderBy>;
}>;


export type CompaniesQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', domain: string | null, domains: Array<string>, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, interactionsLast: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }>, pageInfo: { __typename?: 'PagingInfo', totalPages: number, totalEntries: number } } };

export type CompanyListCustomFieldSchemasQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type CompanyListCustomFieldSchemasQuery = { __typename?: 'Query', companyList: { __typename?: 'CompanyListItem', id: string, memberCustomFields: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> | null } | null };

export type CompanyListMemberCustomFieldsQueryVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
}>;


export type CompanyListMemberCustomFieldsQuery = { __typename?: 'Query', companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', id: string }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null };

export type CompanyListMemberRemindersQueryVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
}>;


export type CompanyListMemberRemindersQuery = { __typename?: 'Query', companyListMember: { __typename?: 'CompanyListMember', id: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean, reminderSetting: { __typename?: 'ReminderSetting', id: string, emailSubject: string, dateProperty: string } }> } | null };

export type CompanyListOptionFragment = { __typename?: 'CompanyListItem', id: string, name: string, project: { __typename?: 'Project', id: string, title: string } | null, creator: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, email: string } };

export type CompanyTableRowFragment = { __typename?: 'Company', domain: string | null, domains: Array<string>, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, interactionsLast: { __typename?: 'LastAts', id: string, lastInteraction: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> };

export type CreateCompanyListMutationVariables = Exact<{
  name: Scalars['String']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateCompanyListMutation = { __typename?: 'Mutation', createCompanyList: { __typename?: 'CreateCompanyListMutationPayload', id: string | null, failReasons: Array<string> } | null };

export type CreateCompanyListReminderSettingMutationVariables = Exact<{
  listUid: Scalars['ID']['input'];
  timePreposition: ReminderSettingTimePreposition;
  emailSubject: Scalars['String']['input'];
  reminderDays: Scalars['Int']['input'];
  employeeEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateProperty: Scalars['String']['input'];
}>;


export type CreateCompanyListReminderSettingMutation = { __typename?: 'Mutation', result: { __typename?: 'CreateCompanyListReminderSettingMutationPayload', failReasons: Array<string> } | null };

export type CustomFieldSchemaFragment = { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null };

export type DatePropertiesForCompanyListReminderQueryVariables = Exact<{
  listUid: Scalars['ID']['input'];
}>;


export type DatePropertiesForCompanyListReminderQuery = { __typename?: 'Query', datePropertiesForCompanyListReminder: Array<{ __typename?: 'ListReminderSettingDateOption', name: string, value: string }> | null };

export type DatePropertyOptionFragment = { __typename?: 'ListReminderSettingDateOption', name: string, value: string };

export type EngagementOverviewFragment = { __typename?: 'Company', openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, id: string, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> };

export type GetCompanyListOptionsQueryVariables = Exact<{
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  personalOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCompanyListOptionsQuery = { __typename?: 'Query', companyLists: { __typename?: 'CompanyListEntries', entries: Array<{ __typename?: 'CompanyListItem', id: string, name: string, project: { __typename?: 'Project', id: string, title: string } | null, creator: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, email: string } }> } };

export type ListMemberReminderPreviewFragment = { __typename?: 'Reminder', id: string, active: boolean, reminderSetting: { __typename?: 'ReminderSetting', id: string, emailSubject: string, dateProperty: string } };

export type SetCompanyListMemberCustomFieldMutationVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type SetCompanyListMemberCustomFieldMutation = { __typename?: 'Mutation', setCompanyListMemberCustomField: { __typename?: 'SetCompanyListMemberCustomFieldMutationPayload', failReasons: Array<string>, record: { __typename?: 'CompanyListMember', id: string, companyListId: string, completedTasksCount: number, tasksCount: number, updatedAt: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, company: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, insightStat: { __typename?: 'InsightStat', lastBdInteractionAt: string | null, lastMarketingInteractionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, headquarterLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, interactionsLast: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null } | null };

export type UpdateCompanyListMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCompanyListMutation = { __typename?: 'Mutation', updateCompanyList: { __typename?: 'UpdateCompanyListMutationPayload', failReasons: Array<string> } | null };

export type CompanyListMemberRowCompanyFragment = { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, insightStat: { __typename?: 'InsightStat', lastBdInteractionAt: string | null, lastMarketingInteractionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, headquarterLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, interactionsLast: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> };

export type CompanyListMemberRowFragment = { __typename?: 'CompanyListMember', id: string, companyListId: string, completedTasksCount: number, tasksCount: number, updatedAt: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, company: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, insightStat: { __typename?: 'InsightStat', lastBdInteractionAt: string | null, lastMarketingInteractionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, headquarterLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, interactionsLast: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> };

export type CompanyListMembersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyListMembersQuery = { __typename?: 'Query', companyListMembers: { __typename?: 'CompanyListMembers', entries: Array<{ __typename?: 'CompanyListMember', id: string, companyListId: string, completedTasksCount: number, tasksCount: number, updatedAt: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, company: { __typename?: 'Company', domain: string | null, id: string, contacts: number, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, insightStat: { __typename?: 'InsightStat', lastBdInteractionAt: string | null, lastMarketingInteractionAt: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, tags: Array<string>, name: string, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, headquarterLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, interactionsLast: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, externalIdentifier: { __typename?: 'ExternalIdentifier', id: string, client: string, group: string | null } | null, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type CompanyListMembersTotalQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type CompanyListMembersTotalQuery = { __typename?: 'Query', companyListMembers: { __typename?: 'CompanyListMembers', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type BulkArchiveContactMutationVariables = Exact<{
  contactUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  unarchiveOnInteraction: Scalars['Boolean']['input'];
}>;


export type BulkArchiveContactMutation = { __typename?: 'Mutation', bulkArchiveContact: { __typename?: 'BulkArchiveContactMutationPayload', failReasons: Array<string> } | null };

export type CompanyContactRowFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type CompanyContactsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<ContactsOrderBy>;
  country?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type CompanyPreviewForEditFragment = { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } };

export type ContactQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type ContactQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', isPersonal: boolean, isEmployee: boolean, emailAddresses: Array<any>, id: string, primaryEmail: any | null, archivedAt: string | null, changedJob: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, imageUrl: string | null, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, correspondenceNumbers: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, myContact: { __typename?: 'MyContact', id: string, classified: boolean } | null };

export type ContactChipFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } };

export type ContactForEditFragment = { __typename?: 'Contact', emailAddresses: Array<any>, id: string, primaryEmail: any | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null } };

export type ContactListRowFragment = { __typename?: 'Contact', id: string, emailAddresses: Array<any>, primaryEmail: any | null, createdAt: string, archivedAt: string | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, company: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ContactProfileFragment = { __typename?: 'Contact', isPersonal: boolean, isEmployee: boolean, emailAddresses: Array<any>, id: string, primaryEmail: any | null, archivedAt: string | null, changedJob: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, imageUrl: string | null, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, correspondenceNumbers: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ContactWhoKnowsUserFragment = { __typename?: 'WhoKnows', id: string, lastInteraction: string, numberOfInteractions: number, contact: { __typename?: 'Contact', isArchived: boolean, isKeyContact: boolean, changedJob: boolean, id: string, primaryEmail: any | null, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } };

export type ContactsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<ContactFilter> | ContactFilter>;
  filter?: InputMaybe<ContactsFiltering>;
  orderBy?: InputMaybe<ContactsOrderBy>;
}>;


export type ContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, emailAddresses: Array<any>, primaryEmail: any | null, createdAt: string, archivedAt: string | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, company: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ContactsWithGroupsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContactsOrderBy>;
  filter?: InputMaybe<ContactsFiltering>;
}>;


export type ContactsWithGroupsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, emailAddresses: Array<any>, primaryEmail: any | null, createdAt: string, archivedAt: string | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, company: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type EnterEmailQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type EnterEmailQuery = { __typename?: 'Query', person: { __typename?: 'Person', id: string } | null };

export type FlagDuplicatePeopleMutationVariables = Exact<{
  originalPersonUid: Scalars['ID']['input'];
  duplicatePersonUid: Scalars['ID']['input'];
}>;


export type FlagDuplicatePeopleMutation = { __typename?: 'Mutation', flagDuplicatePeople: { __typename?: 'FlagDuplicatePeopleMutationPayload', failReasons: Array<string> } | null };

export type GetContactForEditQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetContactForEditQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', emailAddresses: Array<any>, id: string, primaryEmail: any | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null } } | null };

export type GetContactIdQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetContactIdQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: string } | null };

export type KeyActivityDescriptionsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  activityTitle?: InputMaybe<Scalars['String']['input']>;
}>;


export type KeyActivityDescriptionsQuery = { __typename?: 'Query', keyActivityDescriptions: { __typename?: 'KeyActivityDescriptionList', entries: Array<string> } };

export type KeyActivityTitleQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  searchMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type KeyActivityTitleQuery = { __typename?: 'Query', keyActivityTitles: { __typename?: 'KeyActivityTitleList', entries: Array<string> } };

export type MarkContactAsJobNotChangeMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type MarkContactAsJobNotChangeMutation = { __typename?: 'Mutation', markContactAsJobNotChange: { __typename?: 'MarkContactAsJobNotChangedMutationPayload', failReasons: Array<string> } | null };

export type MyContactExistsFragment = { __typename?: 'MyContact', id: string, classified: boolean };

export type OutlookSyncAllowedQueryVariables = Exact<{ [key: string]: never; }>;


export type OutlookSyncAllowedQuery = { __typename?: 'Query', outlookSyncAllowed: boolean | null };

export type PersonContactFragment = { __typename?: 'Contact', id: string, isPersonal: boolean, isEmployee: boolean, primaryEmail: any | null, emailAddresses: Array<any>, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, linkedinUrl: string | null, twitterUrl: string | null, educations: Array<string>, tags: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type PersonContactsQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type PersonContactsQuery = { __typename?: 'Query', person: { __typename?: 'Person', id: string, contacts: Array<{ __typename?: 'Contact', id: string, isPersonal: boolean, isEmployee: boolean, primaryEmail: any | null, emailAddresses: Array<any>, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, linkedinUrl: string | null, twitterUrl: string | null, educations: Array<string>, tags: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } | null };

export type RemoveEmailAddressMutationVariables = Exact<{
  value: Scalars['String']['input'];
}>;


export type RemoveEmailAddressMutation = { __typename?: 'Mutation', removeEmailAddress: { __typename?: 'RemoveEmailAddressMutationPayload', failReasons: Array<string> } | null };

export type ReportIncorrectContactDataMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  reporterUid: Scalars['ID']['input'];
  fields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportIncorrectContactDataMutation = { __typename?: 'Mutation', reportIncorrectContactData: { __typename?: 'ReportIncorrectContactDataMutationPayload', failReasons: Array<string> } | null };

export type RestoreBouncedEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RestoreBouncedEmailMutation = { __typename?: 'Mutation', restoreBouncedEmail: { __typename?: 'RestoreBouncedEmailMutationPayload', failReasons: Array<string>, contact: { __typename?: 'Contact', id: string, bounce: { __typename?: 'BounceCount', id: string, count: number } | null } | null } | null };

export type SyncOutlookContactMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
}>;


export type SyncOutlookContactMutation = { __typename?: 'Mutation', syncOutlookContact: { __typename?: 'SyncOutlookContactMutationPayload', failReasons: Array<string> } | null };

export type UnarchiveContactMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type UnarchiveContactMutation = { __typename?: 'Mutation', unarchiveContact: { __typename?: 'UnarchiveContactMutationPayload', failReasons: Array<string> } | null };

export type UpdateContactDetailsMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: ContactAttributes;
  emailAddresses?: InputMaybe<Array<EmailEntryInput> | EmailEntryInput>;
}>;


export type UpdateContactDetailsMutation = { __typename?: 'Mutation', updateTenantContact: { __typename?: 'UpdateContactMutationPayload', failReasons: Array<string> } | null };

export type UpdateContactEmailMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: ContactAttributes;
  emailAddress: Scalars['String']['input'];
}>;


export type UpdateContactEmailMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'UpdateContactMutationPayload', failReasons: Array<string> } | null };

export type UpdateContactEmailsMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  emailAddresses: Array<EmailEntryInput> | EmailEntryInput;
}>;


export type UpdateContactEmailsMutation = { __typename?: 'Mutation', updateContactEmails: { __typename?: 'UpdateContactEmailsMutationPayload', failReasons: Array<string>, record: { __typename?: 'Contact', id: string, emailAddresses: Array<any> } | null } | null };

export type UpdateContactPrivacyMutationVariables = Exact<{
  myContactUid: Scalars['ID']['input'];
  privacyStatus: ContactPrivacy;
}>;


export type UpdateContactPrivacyMutation = { __typename?: 'Mutation', updateContactPrivacy: { __typename?: 'MyUpdateContactPrivacyMutationPayload', failReasons: Array<string> } | null };

export type UpdatePersonDetailsMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: ContactAttributes;
}>;


export type UpdatePersonDetailsMutation = { __typename?: 'Mutation', updateTenantContact: { __typename?: 'UpdateContactMutationPayload', failReasons: Array<string> } | null };

export type WhoKnowsQueryVariables = Exact<{
  contactUid: Scalars['String']['input'];
  filter?: InputMaybe<WhoKnowsFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WhoKnowsQuery = { __typename?: 'Query', whoKnows: { __typename?: 'WhoKnowsList', entries: Array<{ __typename?: 'WhoKnows', id: string, lastInteraction: string, numberOfInteractions: number, contact: { __typename?: 'Contact', isArchived: boolean, isKeyContact: boolean, changedJob: boolean, id: string, primaryEmail: any | null, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }> } };

export type WhoKnowsUserFragment = { __typename?: 'WhoKnows', id: string, lastInteraction: string, numberOfInteractions: number, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } };

export type WhoPreviouslyKnewQueryVariables = Exact<{
  contactUid: Scalars['String']['input'];
  filter?: InputMaybe<WhoKnowsFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WhoPreviouslyKnewQuery = { __typename?: 'Query', whoPreviouslyKnew: { __typename?: 'WhoPreviouslyKnewList', entries: Array<{ __typename?: 'WhoPreviouslyKnew', previousContact: { __typename?: 'Contact', id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, whoKnew: Array<{ __typename?: 'WhoKnows', id: string, lastInteraction: string, numberOfInteractions: number, contact: { __typename?: 'Contact', isArchived: boolean, isKeyContact: boolean, changedJob: boolean, id: string, primaryEmail: any | null, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }> }> } };

export type WhoPreviouslyKnewByJobFragment = { __typename?: 'WhoPreviouslyKnew', previousContact: { __typename?: 'Contact', id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, whoKnew: Array<{ __typename?: 'WhoKnows', id: string, lastInteraction: string, numberOfInteractions: number, contact: { __typename?: 'Contact', isArchived: boolean, isKeyContact: boolean, changedJob: boolean, id: string, primaryEmail: any | null, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }> };

export type WhoPreviouslyKnewJobFragment = { __typename?: 'Contact', id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type EmailLookupQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type EmailLookupQuery = { __typename?: 'Query', emailLookup: { __typename?: 'EmailLookup', isPersonal: boolean | null, isExceptional: boolean | null } | null };

export type AuditChangeFragment = { __typename?: 'AuditChange', name: string, newValue: string, oldValue: string };

export type AuditFragment = { __typename?: 'Audit', auditedEntity: AuditEntity, action: AuditAction, performedAt: string, performedBy: string | null, changes: Array<{ __typename?: 'AuditChange', name: string, newValue: string, oldValue: string }> };

export type ContactAuditTrailQueryVariables = Exact<{
  contactUid: Scalars['ID']['input'];
}>;


export type ContactAuditTrailQuery = { __typename?: 'Query', contactAuditTrail: { __typename?: 'AuditTrail', entries: Array<{ __typename?: 'Audit', auditedEntity: AuditEntity, action: AuditAction, performedAt: string, performedBy: string | null, changes: Array<{ __typename?: 'AuditChange', name: string, newValue: string, oldValue: string }> }> } | null };

export type ContactCompanyProfileFragment = { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, correspondenceNumbers: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } };

export type ContactConsentQueryVariables = Exact<{
  contactUid: Scalars['ID']['input'];
}>;


export type ContactConsentQuery = { __typename?: 'Query', contactConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus, whenWasConsentGiven: string | null, howWasConsentGiven: string | null, id: string | null, autoChangedReason: string | null } | null, config: { __typename?: 'MarketingListConfiguration', id: string, allowUnsubscribed: boolean, consentLegitimateInterestText: string, consentConsentGivenText: string, consentUserUnsubscribedText: string, enableMarketingExclusion: boolean } | null };

export type ContactConsentFragment = { __typename?: 'ContactConsent', status: ContactConsentStatus, whenWasConsentGiven: string | null, howWasConsentGiven: string | null, id: string | null, autoChangedReason: string | null };

export type UpdateContactConsentMutationVariables = Exact<{
  attributes: ContactConsentAttribute;
  contactUid: Scalars['ID']['input'];
}>;


export type UpdateContactConsentMutation = { __typename?: 'Mutation', updateContactConsent: { __typename?: 'UpdateContactConsentMutationPayload', failReasons: Array<string>, record: { __typename?: 'ContactConsent', status: ContactConsentStatus } | null } | null };

export type ContactCustomFieldSchemaQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactCustomFieldSchemaQuery = { __typename?: 'Query', currentTenant: { __typename?: 'Tenant', id: string, contactInfoCustomFields: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> | null } | null };

export type MarketingContactAllowanceQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarketingContactAllowanceQuery = { __typename?: 'Query', emailMarketingContactAllowances: { __typename?: 'MarketingContactAllowanceEntries', entries: Array<{ __typename?: 'MarketingContactAllowance', utilisation: number, allowance: number, usage: number, activeFrom: string }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } | null };

export type MarketingContactAllowanceRowFragment = { __typename?: 'MarketingContactAllowance', utilisation: number, allowance: number, usage: number, activeFrom: string };

export type ContactFormikFieldWithOptionsQueryVariables = Exact<{
  term: Scalars['String']['input'];
  companyDomain?: InputMaybe<Scalars['ID']['input']>;
  includeInternalContact?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactFormikFieldWithOptionsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactEntries', entries: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } };

export type ContactAvatarFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type BouncedContactsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ContactsOrderBy>;
}>;


export type BouncedContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, createdAt: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type BouncedContactsRowFragment = { __typename?: 'Contact', id: string, createdAt: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type SelectedContactsModalFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ContactPreferenceFragment = { __typename?: 'ContactPreference', customFieldValue: { __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null } | null, customFieldSchema: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null } };

export type ContactPreferencesQueryVariables = Exact<{
  contactUid: Scalars['ID']['input'];
}>;


export type ContactPreferencesQuery = { __typename?: 'Query', contactPreferences: { __typename?: 'ContactPreferences', schemaCount: number, entries: Array<{ __typename?: 'ContactPreference', customFieldValue: { __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null } | null, customFieldSchema: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null } }> } | null };

export type BouncedEmailFragment = { __typename?: 'BouncedEmail', count: number, email: string };

export type ContactSlideQueryVariables = Exact<{
  uid: Scalars['String']['input'];
  bouncedUid: Scalars['ID']['input'];
}>;


export type ContactSlideQuery = { __typename?: 'Query', userRoleCorePermissions: { __typename?: 'CorePermission', id: string, viewEmployeeEngagementTab: boolean } | null, userRoleOpportunityTrackingPermissions: { __typename?: 'OpportunityTrackingPermission', id: string, viewEmployeeOpportunitiesTab: boolean } | null, bouncedEmails: { __typename?: 'BouncedEmailEntries', entries: Array<{ __typename?: 'BouncedEmail', count: number, email: string }> } | null, contact: { __typename?: 'Contact', isPersonal: boolean, isEmployee: boolean, emailAddresses: Array<any>, id: string, primaryEmail: any | null, archivedAt: string | null, changedJob: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, imageUrl: string | null, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, correspondenceNumbers: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, myContact: { __typename?: 'MyContact', id: string, classified: boolean } | null };

export type CreateCareerCompanyMutationVariables = Exact<{
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactUid: Scalars['ID']['input'];
  jobTitle: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
}>;


export type CreateCareerCompanyMutation = { __typename?: 'Mutation', createCareerCompany: { __typename?: 'CreateCareerCompanyMutationPayload', failReasons: Array<string>, record: { __typename?: 'PersonCompanyContact', id: string, jobTitle: string | null, jobTitles: Array<{ __typename?: 'ContactJobTitle', id: string, name: string, startDate: string | null, endDate: string | null }> } | null } | null };

export type DeleteCareerCompanyMutationVariables = Exact<{
  careerCompanyUid: Scalars['ID']['input'];
}>;


export type DeleteCareerCompanyMutation = { __typename?: 'Mutation', deleteCareerCompany: { __typename?: 'DeleteCareerCompanyMutationPayload', failReasons: Array<string> } | null };

export type ContactForIncompleteContactRowFragment = { __typename?: 'Contact', primaryEmail: any | null, createdAt: string, updatedAt: string | null, id: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, marketingListConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, company: { __typename?: 'Company', id: string, logoUrl: string | null, domain: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }> };

export type UpdateContactDetailsAndLocationMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  officeLocationId?: InputMaybe<Scalars['ID']['input']>;
  attributes: ContactAttributes;
}>;


export type UpdateContactDetailsAndLocationMutation = { __typename?: 'Mutation', updateTenantContact: { __typename?: 'UpdateContactMutationPayload', failReasons: Array<string>, record: { __typename?: 'Contact', primaryEmail: any | null, createdAt: string, updatedAt: string | null, id: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, marketingListConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, company: { __typename?: 'Company', id: string, logoUrl: string | null, domain: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }> } | null } | null };

export type CanArchiveContactsAndCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CanArchiveContactsAndCompaniesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canArchiveContactsAndCompanies: boolean } | null };

export type CanUpdateCompanyNameQueryVariables = Exact<{ [key: string]: never; }>;


export type CanUpdateCompanyNameQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canUpdateCompanyName: boolean } | null };

export type CanViewActivityDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type CanViewActivityDetailsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canViewActivityViewDetail: boolean } | null };

export type OptionChoiceFragment = { __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number };

export type UpdateCustomFieldSchemaPositionsMutationVariables = Exact<{
  customSchemasPositions: Array<CustomFieldSchemaPosition> | CustomFieldSchemaPosition;
}>;


export type UpdateCustomFieldSchemaPositionsMutation = { __typename?: 'Mutation', updateCustomFieldSchemaPositions: { __typename?: 'UpdateCustomFieldSchemaPositionsMutationPayload', failReasons: Array<string> } | null };

export type CompanyGridFragment = { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null };

export type ContactGridFragment = { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null };

export type CustomFieldGridFragment = { __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null };

type CustomFieldGridValueUnion_CustomCurrencyFieldGrid_Fragment = { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null };

type CustomFieldGridValueUnion_CustomDatetimeFieldGrid_Fragment = { __typename: 'CustomDatetimeFieldGrid', date: string | null };

type CustomFieldGridValueUnion_CustomEmployeeFieldGrid_Fragment = { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null };

type CustomFieldGridValueUnion_CustomFullDateTimeFieldGrid_Fragment = { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null };

type CustomFieldGridValueUnion_CustomMultiCompanyFieldGrid_Fragment = { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> };

type CustomFieldGridValueUnion_CustomMultiContactFieldGrid_Fragment = { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> };

type CustomFieldGridValueUnion_CustomMultiCountryFieldGrid_Fragment = { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> };

type CustomFieldGridValueUnion_CustomMultiEmployeeFieldGrid_Fragment = { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> };

type CustomFieldGridValueUnion_CustomMultiOptionalValueFieldGrid_Fragment = { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> };

type CustomFieldGridValueUnion_CustomNewlyDefinedFieldGrid_Fragment = { __typename: 'CustomNewlyDefinedFieldGrid' };

type CustomFieldGridValueUnion_CustomNumberFieldGrid_Fragment = { __typename: 'CustomNumberFieldGrid', number: string | null };

type CustomFieldGridValueUnion_CustomOptionalValueFieldGrid_Fragment = { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null };

type CustomFieldGridValueUnion_CustomRichTextFieldGrid_Fragment = { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string };

type CustomFieldGridValueUnion_CustomTextFieldGrid_Fragment = { __typename: 'CustomTextFieldGrid', text: string | null };

export type CustomFieldGridValueUnionFragment = CustomFieldGridValueUnion_CustomCurrencyFieldGrid_Fragment | CustomFieldGridValueUnion_CustomDatetimeFieldGrid_Fragment | CustomFieldGridValueUnion_CustomEmployeeFieldGrid_Fragment | CustomFieldGridValueUnion_CustomFullDateTimeFieldGrid_Fragment | CustomFieldGridValueUnion_CustomMultiCompanyFieldGrid_Fragment | CustomFieldGridValueUnion_CustomMultiContactFieldGrid_Fragment | CustomFieldGridValueUnion_CustomMultiCountryFieldGrid_Fragment | CustomFieldGridValueUnion_CustomMultiEmployeeFieldGrid_Fragment | CustomFieldGridValueUnion_CustomMultiOptionalValueFieldGrid_Fragment | CustomFieldGridValueUnion_CustomNewlyDefinedFieldGrid_Fragment | CustomFieldGridValueUnion_CustomNumberFieldGrid_Fragment | CustomFieldGridValueUnion_CustomOptionalValueFieldGrid_Fragment | CustomFieldGridValueUnion_CustomRichTextFieldGrid_Fragment | CustomFieldGridValueUnion_CustomTextFieldGrid_Fragment;

export type EmployeeGridFragment = { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null };

export type DataRecordsGridTemplateFragment = { __typename?: 'DataTemplate', id: string, columns: Array<{ __typename?: 'DataTemplateColumn', id: string, headerName: string, sortable: boolean, initialHide: boolean, filterOperations: Array<ColumnFilterOperationEnum>, templateFieldType: TemplateFieldType }> };

export type DataTemplatesDataRecordsPageQueryVariables = Exact<{
  dataTemplateUid: Scalars['ID']['input'];
}>;


export type DataTemplatesDataRecordsPageQuery = { __typename?: 'Query', dataTemplates: { __typename?: 'DataTemplateEntries', entries: Array<{ __typename?: 'DataTemplate', id: string, name: string, title: string, columns: Array<{ __typename?: 'DataTemplateColumn', id: string, headerName: string, sortable: boolean, initialHide: boolean, filterOperations: Array<ColumnFilterOperationEnum>, templateFieldType: TemplateFieldType }> }> } };

export type DashboardEngagementReportQueryVariables = Exact<{
  beginOn: Scalars['String']['input'];
  endOn: Scalars['String']['input'];
}>;


export type DashboardEngagementReportQuery = { __typename?: 'Query', myEngagementReport: { __typename?: 'EngagementReport', activityTotals: { __typename?: 'ActivityTotals', existingContacts: number, meetings: number, newContacts: number, newOpportunities: number } | null } };

export type DashboardUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardUserInfoQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', id: string, city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, department: { __typename?: 'Department', id: string, name: string } | null } | null } | null };

export type MyOpenTasksQueryVariables = Exact<{
  primaryFilter?: InputMaybe<TaskPrimaryFilterInput>;
}>;


export type MyOpenTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, description: { __typename?: 'RichContent', plainText: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null }> } };

export type QuickSearchCompaniesQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type QuickSearchCompaniesQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }> } };

export type QuickSearchContactsQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type QuickSearchContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactEntries', entries: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } };

export type QuickSearchEmployeeFragment = { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, contact: { __typename?: 'Contact', id: string } };

export type QuickSearchEmployeesQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type QuickSearchEmployeesQuery = { __typename?: 'Query', employees: { __typename?: 'EmployeeList', entries: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, contact: { __typename?: 'Contact', id: string } }> } };

export type QuickSearchGroupLabelAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickSearchGroupLabelAccessQuery = { __typename?: 'Query', userRoleCorePermissions: { __typename?: 'CorePermission', id: string, allCompanies: boolean, allContacts: boolean } | null, tenantConfiguration: { __typename?: 'TenantConfiguration', id: string, showAllEmployeesTab: boolean } | null };

export type SearchResultCompanyFragment = { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } };

export type SearchResultContactFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, company: { __typename?: 'Company', info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ConnectListWithFieldMappingsMutationVariables = Exact<{
  fieldMappings?: InputMaybe<Array<ConnectedListMappingInput> | ConnectedListMappingInput>;
  nameOnEms?: InputMaybe<Scalars['String']['input']>;
  listUuid: Scalars['String']['input'];
  audienceId: Scalars['String']['input'];
  campaignManagerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConnectListWithFieldMappingsMutation = { __typename?: 'Mutation', connectList: { __typename?: 'ConnectListMutationPayload', failReasons: Array<string> } | null };

export type ConnectListWithFieldMappingsModalQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ConnectListWithFieldMappingsModalQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, allowDuplicates: boolean, name: string } | null, eMarketingConnectors: { __typename?: 'EMarketingConnectors', entries: Array<{ __typename?: 'CampaignManager', id: string, name: string, mappingEnabled: boolean }> } | null };

export type EMarketingConnectedListQueryVariables = Exact<{
  listUid: Scalars['ID']['input'];
}>;


export type EMarketingConnectedListQuery = { __typename?: 'Query', connectedLists: Array<{ __typename?: 'ConnectedList', id: string, outOfSync: boolean | null, syncing: boolean, connected: boolean | null, lastSyncError: string | null, lastSyncAt: string | null, nameOnEms: string | null, list: { __typename?: 'List', id: string } | null, campaignManager: { __typename?: 'CampaignManager', id: string, mappingEnabled: boolean, name: string } | null }> };

export type EMarketingConnectedListFragment = { __typename?: 'ConnectedList', id: string, outOfSync: boolean | null, syncing: boolean, connected: boolean | null, lastSyncError: string | null, lastSyncAt: string | null, nameOnEms: string | null, list: { __typename?: 'List', id: string } | null, campaignManager: { __typename?: 'CampaignManager', id: string, mappingEnabled: boolean, name: string } | null };

export type EMarketingConnectedListMappingFragment = { __typename?: 'ConnectedListMapping', id: string, nexlFieldName: ContactFieldsForSync | null, remoteCustomFieldSchemaUid: string | null, customFieldSchema: { __typename?: 'CustomFieldSchema', id: string } | null };

export type EMarketingConnectedListStatusFragment = { __typename?: 'ConnectedList', id: string, outOfSync: boolean | null, syncing: boolean, connected: boolean | null, lastSyncError: string | null, lastSyncAt: string | null, nameOnEms: string | null, list: { __typename?: 'List', id: string } | null, campaignManager: { __typename?: 'CampaignManager', id: string, name: string, mappingEnabled: boolean } | null };

export type EMarketingConnectorFragment = { __typename?: 'CampaignManager', id: string, name: string, mappingEnabled: boolean };

export type EMarketingCustomFieldSchemaFragment = { __typename?: 'CustomFieldSchema', id: string, name: string, valueTypeEnum: CustomFieldSchemaValue };

export type RemoteCustomFieldSchemaFragment = { __typename?: 'RemoteCustomFieldSchema', id: string, name: string, valueTypeEnum: CustomFieldSchemaValue, optionChoices: Array<string>, source: ConnectedListMappingSource };

export type EMarketingCustomFieldSchemasQueryVariables = Exact<{
  campaignManagerUid: Scalars['ID']['input'];
  uid: Scalars['ID']['input'];
}>;


export type EMarketingCustomFieldSchemasQuery = { __typename?: 'Query', remoteCustomFieldSchema: { __typename?: 'RemoteCustomFieldSchemaList', entries: Array<{ __typename?: 'RemoteCustomFieldSchema', id: string, name: string, valueTypeEnum: CustomFieldSchemaValue, optionChoices: Array<string>, source: ConnectedListMappingSource }> } | null, contactCustomFieldSchemas: { __typename?: 'CustomFieldSchemasList', entries: Array<{ __typename?: 'CustomFieldSchema', id: string, name: string, valueTypeEnum: CustomFieldSchemaValue }> }, listCustomFieldSchemas: { __typename?: 'List', id: string, memberCustomFields: Array<{ __typename?: 'CustomFieldSchema', id: string, name: string, valueTypeEnum: CustomFieldSchemaValue }> | null } | null };

export type SyncEMarketingListMembersMutationVariables = Exact<{
  connectedListId: Scalars['String']['input'];
  fieldMappings: Array<ConnectedListMappingInput> | ConnectedListMappingInput;
}>;


export type SyncEMarketingListMembersMutation = { __typename?: 'Mutation', syncConnectedListMembers: { __typename?: 'SyncConnectedListMembersMutationPayload', failReasons: Array<string> } | null };

export type SyncEMarketingListMembersModalQueryVariables = Exact<{
  listUid: Scalars['ID']['input'];
  campaignManagerUid: Scalars['ID']['input'];
}>;


export type SyncEMarketingListMembersModalQuery = { __typename?: 'Query', connectedLists: Array<{ __typename?: 'ConnectedList', id: string, mappings: Array<{ __typename?: 'ConnectedListMapping', id: string, nexlFieldName: ContactFieldsForSync | null, remoteCustomFieldSchemaUid: string | null, customFieldSchema: { __typename?: 'CustomFieldSchema', id: string } | null }> }>, remoteCustomFieldSchema: { __typename?: 'RemoteCustomFieldSchemaList', entries: Array<{ __typename?: 'RemoteCustomFieldSchema', id: string, name: string, valueTypeEnum: CustomFieldSchemaValue, optionChoices: Array<string>, source: ConnectedListMappingSource }> } | null, contactCustomFieldSchemas: { __typename?: 'CustomFieldSchemasList', entries: Array<{ __typename?: 'CustomFieldSchema', id: string, name: string, valueTypeEnum: CustomFieldSchemaValue }> }, listCustomFieldSchemas: { __typename?: 'List', id: string, memberCustomFields: Array<{ __typename?: 'CustomFieldSchema', id: string, name: string, valueTypeEnum: CustomFieldSchemaValue }> | null } | null };

export type AllEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEmployeesQuery = { __typename?: 'Query', employees: { __typename?: 'EmployeeList', entries: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> } };

export type EmployeeFieldWithOptionsFragment = { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, contact: { __typename?: 'Contact', id: string } };

export type EmployeePreviewFragment = { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } };

export type EmployeesQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EmployeesQuery = { __typename?: 'Query', employees: { __typename?: 'EmployeeList', entries: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> } };

export type EmployeesFieldWithOptionsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EmployeesFieldWithOptionsQuery = { __typename?: 'Query', employees: { __typename?: 'EmployeeList', entries: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, contact: { __typename?: 'Contact', id: string } }> } };

export type RelationshipPartnerCompanyFragment = { __typename?: 'Company', id: string, isBlocked: boolean, domain: string | null, domains: Array<string>, logoUrl: string | null, openOpportunityCount: number, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, relationshipPartners: Array<{ __typename?: 'Employee', id: string, info: { __typename?: 'ContactInfo', id: string | null, displayName: string, imageUrl: string | null } }> | null };

export type RelationshipPartnerCompanyListQueryVariables = Exact<{
  employeeEmail: Scalars['String']['input'];
}>;


export type RelationshipPartnerCompanyListQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyEntries', entries: Array<{ __typename?: 'Company', id: string, isBlocked: boolean, domain: string | null, domains: Array<string>, logoUrl: string | null, openOpportunityCount: number, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, relationshipPartners: Array<{ __typename?: 'Employee', id: string, info: { __typename?: 'ContactInfo', id: string | null, displayName: string, imageUrl: string | null } }> | null }> } };

export type TopClientCompanyFragment = { __typename?: 'TopClientCompany', id: string, company: { __typename?: 'Company', isBlocked: boolean, id: string, domain: string | null, domains: Array<string>, logoUrl: string | null, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null } }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> };

export type TopClientCompanyListQueryVariables = Exact<{
  employeeUid: Scalars['String']['input'];
}>;


export type TopClientCompanyListQuery = { __typename?: 'Query', topClientCompanyList: { __typename?: 'TopClientCompanyList', entries: Array<{ __typename?: 'TopClientCompany', id: string, company: { __typename?: 'Company', isBlocked: boolean, id: string, domain: string | null, domains: Array<string>, logoUrl: string | null, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null } }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }> } | null, tenantConfiguration: { __typename?: 'TenantConfiguration', id: string, preferInternalIndustry: boolean } | null };

export type TopContactFragment = { __typename?: 'TopContact', id: string, numberOfInteractions: number, myContact: { __typename?: 'MyContact', id: string, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string, contact: { __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', id: string | null, displayName: string, imageUrl: string | null } } }>, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } } };

export type TopContactListQueryVariables = Exact<{
  employeeUid: Scalars['String']['input'];
}>;


export type TopContactListQuery = { __typename?: 'Query', topContactList: { __typename?: 'TopContactList', entries: Array<{ __typename?: 'TopContact', id: string, numberOfInteractions: number, myContact: { __typename?: 'MyContact', id: string, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, whoKnows: Array<{ __typename?: 'WhoKnows', id: string, contact: { __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', id: string | null, displayName: string, imageUrl: string | null } } }>, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } } }> } | null };

export type FeaturesContextQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturesContextQuery = { __typename?: 'Query', enabledModules: { __typename?: 'EnabledModules', marketingLists: boolean, projects: boolean, objectives: boolean, opportunities: boolean, prospecting: boolean, referrals: boolean, apps: boolean }, features: Array<{ __typename?: 'FeatureFlag', key: string, enabled: boolean, id: string }> };

export type CreateGenericListItemMutationVariables = Exact<{
  genericListUid: Scalars['ID']['input'];
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute> | CustomFieldAttribute>;
}>;


export type CreateGenericListItemMutation = { __typename?: 'Mutation', createGenericListItem: { __typename?: 'CreateGenericListItemMutationPayload', failReasons: Array<string>, record: { __typename?: 'GenericListItem', id: string, completedTasksCount: number, tasksCount: number, updatedAt: string, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> } | null } | null };

export type CreateGenericListReminderSetttingMutationVariables = Exact<{
  genericListUid: Scalars['ID']['input'];
  timePreposition: ReminderSettingTimePreposition;
  emailSubject: Scalars['String']['input'];
  reminderDays: Scalars['Int']['input'];
  employeeEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateProperty: Scalars['String']['input'];
}>;


export type CreateGenericListReminderSetttingMutation = { __typename?: 'Mutation', result: { __typename?: 'CreateGenericListReminderSettingMutationPayload', failReasons: Array<string> } | null };

export type DatePropertiesForGenericListReminderQueryVariables = Exact<{
  genericListUid: Scalars['ID']['input'];
}>;


export type DatePropertiesForGenericListReminderQuery = { __typename?: 'Query', datePropertiesForGenericListReminder: Array<{ __typename?: 'ListReminderSettingDateOption', name: string, value: string }> | null };

export type GenericListQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type GenericListQuery = { __typename?: 'Query', genericList: { __typename?: 'GenericList', id: string, items: Array<{ __typename?: 'GenericListItem', id: string, completedTasksCount: number, tasksCount: number, updatedAt: string, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> }> } | null };

export type GenericListCustomFieldSchemasQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type GenericListCustomFieldSchemasQuery = { __typename?: 'Query', genericList: { __typename?: 'GenericList', id: string, customFieldSchemas: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> } | null };

export type GenericListItemQueryVariables = Exact<{
  itemUid: Scalars['ID']['input'];
}>;


export type GenericListItemQuery = { __typename?: 'Query', genericListItem: { __typename?: 'GenericListItem', id: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean, reminderSetting: { __typename?: 'ReminderSetting', id: string, emailSubject: string, dateProperty: string } }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, genericList: { __typename?: 'GenericList', customFieldSchemas: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> } } | null, tasks: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, description: { __typename?: 'RichContent', plainText: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null }> } };

export type GenericListItemCustomFieldsQueryVariables = Exact<{
  itemUid: Scalars['ID']['input'];
}>;


export type GenericListItemCustomFieldsQuery = { __typename?: 'Query', genericListItem: { __typename?: 'GenericListItem', id: string, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null };

export type GenericListItemFragment = { __typename?: 'GenericListItem', id: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean, reminderSetting: { __typename?: 'ReminderSetting', id: string, emailSubject: string, dateProperty: string } }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, genericList: { __typename?: 'GenericList', customFieldSchemas: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> } };

export type GenericListItemRowFragment = { __typename?: 'GenericListItem', id: string, completedTasksCount: number, tasksCount: number, updatedAt: string, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> };

export type GenericListItemSlideQueryVariables = Exact<{
  itemUid: Scalars['ID']['input'];
}>;


export type GenericListItemSlideQuery = { __typename?: 'Query', genericListItem: { __typename?: 'GenericListItem', id: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean, reminderSetting: { __typename?: 'ReminderSetting', id: string, emailSubject: string, dateProperty: string } }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, genericList: { __typename?: 'GenericList', customFieldSchemas: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> } } | null };

export type GenericListItemsQueryVariables = Exact<{
  genericListUid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GenericListItemsQuery = { __typename?: 'Query', genericListItems: { __typename?: 'GenericListItemEntries', entries: Array<{ __typename?: 'GenericListItem', id: string, completedTasksCount: number, tasksCount: number, updatedAt: string, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> }> } };

export type GenericListItemsTotalQueryVariables = Exact<{
  genericListUid: Scalars['ID']['input'];
}>;


export type GenericListItemsTotalQuery = { __typename?: 'Query', genericListItems: { __typename?: 'GenericListItemEntries', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type GenericListReminderSettingsQueryVariables = Exact<{
  genericListUid: Scalars['ID']['input'];
}>;


export type GenericListReminderSettingsQuery = { __typename?: 'Query', genericListReminderSettings: Array<{ __typename?: 'ReminderSetting', id: string, emailSubject: string, dateProperty: string, reminderDays: number, timePreposition: ReminderSettingTimePreposition, owners: Array<{ __typename?: 'ReminderSettingOwner', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }> }> | null };

export type RemoveGenericListItemsMutationVariables = Exact<{
  uids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveGenericListItemsMutation = { __typename?: 'Mutation', removeGenericListItems: { __typename?: 'RemoveGenericListItemsMutationPayload', failReasons: Array<string> } | null };

export type ReorderGenericListItemsMutationVariables = Exact<{
  uids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderGenericListItemsMutation = { __typename?: 'Mutation', reorderGenericListItems: { __typename?: 'ReorderGenericListItemsMutationPayload', failReasons: Array<string> } | null };

export type UpdateGenericListItemsMutationVariables = Exact<{
  uids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute> | CustomFieldAttribute>;
}>;


export type UpdateGenericListItemsMutation = { __typename?: 'Mutation', updateGenericListItems: { __typename?: 'UpdateGenericListItemsMutationPayload', failReasons: Array<string>, records: Array<{ __typename?: 'GenericListItem', id: string, completedTasksCount: number, tasksCount: number, updatedAt: string, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, gridCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> }> } | null };

export type CreateFlatfileWorkbookForListMutationVariables = Exact<{
  importType: FlatFileImportType;
  listUid: Scalars['ID']['input'];
}>;


export type CreateFlatfileWorkbookForListMutation = { __typename?: 'Mutation', result: { __typename?: 'CreateFlatfileWorkbookForListImportMutationPayload', failReasons: Array<string>, workbook: { __typename?: 'FlatFileWorkbook', id: string, accessToken: string, spaceIdentifier: string, apiUrl: string, spaceUrl: string, metadata: any | null } | null } | null };

export type CreatedWorkbookFragment = { __typename?: 'FlatFileWorkbook', id: string, accessToken: string, spaceIdentifier: string, apiUrl: string, spaceUrl: string, metadata: any | null };

export type FlatfileAdminImporterMutationVariables = Exact<{
  importType: FlatFileImportType;
}>;


export type FlatfileAdminImporterMutation = { __typename?: 'Mutation', result: { __typename?: 'CreateFlatfileWorkbookForAdminImportMutationPayload', failReasons: Array<string>, workbook: { __typename?: 'FlatFileWorkbook', id: string, accessToken: string, spaceIdentifier: string, apiUrl: string, spaceUrl: string, metadata: any | null } | null } | null };

export type FlatfileSpaceMutationVariables = Exact<{
  workbookId: Scalars['ID']['input'];
}>;


export type FlatfileSpaceMutation = { __typename?: 'Mutation', result: { __typename?: 'ImportFlatfileWorkbookMutationPayload', failReasons: Array<string> } | null };

export type ImportListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ImportListQuery = { __typename?: 'Query', importList: { __typename?: 'ImportListEntries', entries: Array<{ __typename?: 'Import', id: string, originalFileName: string | null, createdAt: string, processedCount: number, totalCount: number, createdBy: { __typename?: 'User', email: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ImportListRowFragment = { __typename?: 'Import', id: string, originalFileName: string | null, createdAt: string, processedCount: number, totalCount: number, createdBy: { __typename?: 'User', email: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } };

export type BulkAddIndustryMappingMutationVariables = Exact<{
  companyIndustryNameUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  internalIndustryUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkAddIndustryMappingMutation = { __typename?: 'Mutation', updateIndustryMapping: { __typename?: 'UpdateIndustryMappingMutationPayload', failReasons: Array<string> } | null };

export type CompanyIndustryNameFragment = { __typename?: 'CompanyIndustryName', createdAt: string | null, id: string, value: string, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> };

export type CompanyIndustryNamesQueryVariables = Exact<{
  filter?: InputMaybe<CompanyIndustryNameFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyIndustryNamesQuery = { __typename?: 'Query', companyIndustryNames: { __typename?: 'CompanyIndustryNameList', entries: Array<{ __typename?: 'CompanyIndustryName', createdAt: string | null, id: string, value: string, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type AddContactNewCompanySwitchMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  companyUid: Scalars['ID']['input'];
  linkedinUrl: Scalars['String']['input'];
  keepBoth?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddContactNewCompanySwitchMutation = { __typename?: 'Mutation', addContactNewCompanySwitch: { __typename?: 'AddContactNewCompanySwitchMutationPayload', failReasons: Array<string>, record: { __typename?: 'Contact', isPersonal: boolean, isEmployee: boolean, emailAddresses: Array<any>, id: string, primaryEmail: any | null, archivedAt: string | null, changedJob: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, imageUrl: string | null, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, correspondenceNumbers: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null } | null };

export type AddContactPersonalEmailCompanySwitchMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  personalEmail: Scalars['String']['input'];
}>;


export type AddContactPersonalEmailCompanySwitchMutation = { __typename?: 'Mutation', addContactPersonalEmailCompanySwitch: { __typename?: 'AddContactPersonalEmailCompanySwitchMutationPayload', failReasons: Array<string>, record: { __typename?: 'Contact', isPersonal: boolean, isEmployee: boolean, emailAddresses: Array<any>, id: string, primaryEmail: any | null, archivedAt: string | null, changedJob: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, imageUrl: string | null, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, correspondenceNumbers: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null } | null };

export type AddContactUnknownCompanySwitchMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  removeFromMarketingList?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddContactUnknownCompanySwitchMutation = { __typename?: 'Mutation', addContactUnknownCompanySwitch: { __typename?: 'AddContactUnknownCompanySwitchMutationPayload', failReasons: Array<string> } | null };

export type AddContactWorkEmailCompanySwitchMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  workEmail: Scalars['String']['input'];
  keepBoth?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddContactWorkEmailCompanySwitchMutation = { __typename?: 'Mutation', addContactWorkEmailCompanySwitch: { __typename?: 'AddContactWorkEmailCompanySwitchMutationPayload', failReasons: Array<string>, record: { __typename?: 'Contact', isPersonal: boolean, isEmployee: boolean, emailAddresses: Array<any>, id: string, primaryEmail: any | null, archivedAt: string | null, changedJob: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', interactions: number }, officeLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, info: { __typename?: 'ContactInfo', id: string | null, tags: Array<string>, firstName: string | null, lastName: string | null, jobTitle: string | null, phoneNumbers: Array<string>, imageUrl: string | null, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, displayName: string, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, domain: string | null, domains: Array<string>, isInternal: boolean, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, correspondenceNumbers: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null } | null };

export type KeyActivityCategoryTotalFragment = { __typename?: 'KeyActivityCategoryTotal', id: string, category: KeyActivityCategory, total: number };

export type KeyActivityMonthStatsQueryVariables = Exact<{
  employeeUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type KeyActivityMonthStatsQuery = { __typename?: 'Query', keyActivityMonthStats: Array<{ __typename?: 'KeyActivityMonthStatsEntry', id: string, month: string, totals: Array<{ __typename?: 'KeyActivityCategoryTotal', id: string, category: KeyActivityCategory, total: number }> | null }> };

export type KeyActivityToUpdateQueryVariables = Exact<{
  sourceReferenceId: Scalars['String']['input'];
}>;


export type KeyActivityToUpdateQuery = { __typename?: 'Query', keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', trixHtml: string } | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, calendarMeeting: { __typename?: 'EmployeeMeeting', id: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, interactionType: PartitionedInteractionType } | null } | null };

export type KeyActivityToUpdateFragment = { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', trixHtml: string } | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, calendarMeeting: { __typename?: 'EmployeeMeeting', id: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, interactionType: PartitionedInteractionType } | null };

export type MyKeyActivityPerformanceQueryVariables = Exact<{ [key: string]: never; }>;


export type MyKeyActivityPerformanceQuery = { __typename?: 'Query', myKeyActivityPerformance: { __typename?: 'MyKeyActivityPerformance', monthCurrentTotal: number, monthBestTotal: number, currentConsecutiveWeeks: number, longestConsecutiveWeeksStreak: number } };

export type AddContactsToListMutationVariables = Exact<{
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter> | ContactFilter>;
  listUuid: Scalars['ID']['input'];
}>;


export type AddContactsToListMutation = { __typename?: 'Mutation', addContactsToList: { __typename?: 'AddContactsToListMutationPayload', failReasons: Array<string> } | null };

export type AddContactsToListWithTrackerMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter> | ContactFilter>;
  returnPath?: InputMaybe<Scalars['String']['input']>;
  destinationListUid: Scalars['ID']['input'];
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute> | CustomFieldAttribute>;
}>;


export type AddContactsToListWithTrackerMutation = { __typename?: 'Mutation', addContactsToListWithTracker: { __typename?: 'AddContactsToListWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type AddListContactsToListMutationVariables = Exact<{
  sourceListUuid: Scalars['ID']['input'];
  destinationListUuid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListMembersFilter>;
}>;


export type AddListContactsToListMutation = { __typename?: 'Mutation', addListContactsToList: { __typename?: 'AddListContactsToListMutationPayload', failReasons: Array<string> } | null };

export type AddListContactsToListWithCustomFieldsMutationVariables = Exact<{
  sourceListUuid: Scalars['ID']['input'];
  destinationListUuid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type AddListContactsToListWithCustomFieldsMutation = { __typename?: 'Mutation', addListContactsToList: { __typename?: 'AddListContactsToListMutationPayload', failReasons: Array<string> } | null };

export type AddListContactsToListWithTrackerMutationVariables = Exact<{
  title: Scalars['String']['input'];
  returnPath: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  sourceListUuid: Scalars['ID']['input'];
  destinationListUuid: Scalars['ID']['input'];
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute> | CustomFieldAttribute>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddListContactsToListWithTrackerMutation = { __typename?: 'Mutation', addListContactsToListWithTracker: { __typename?: 'AddListContactsToListWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type AddMyContactsToListMutationVariables = Exact<{
  filter?: InputMaybe<MyContactsFiltering>;
  listUuid: Scalars['ID']['input'];
}>;


export type AddMyContactsToListMutation = { __typename?: 'Mutation', addMyContactsToList: { __typename?: 'AddMyContactsToListMutationPayload', failReasons: Array<string> } | null };

export type AddMyContactsToListWithTrackerMutationVariables = Exact<{
  filter?: InputMaybe<MyContactsFiltering>;
  listUuid: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  returnPath: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddMyContactsToListWithTrackerMutation = { __typename?: 'Mutation', addMyContactsToListWithTracker: { __typename?: 'AddMyContactsToListWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type BulkAddListMembersWithTrackerMutationVariables = Exact<{
  progressTracker: ProgressTrackerAttributes;
  destinationListUid: Scalars['ID']['input'];
  contactUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type BulkAddListMembersWithTrackerMutation = { __typename?: 'Mutation', bulkAddListMemberWithTracker: { __typename?: 'BulkAddListMemberWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type BulkEditListMemberWithTrackerMutationVariables = Exact<{
  progressTracker: ProgressTrackerAttributes;
  memberUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
  listUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BulkEditListMemberWithTrackerMutation = { __typename?: 'Mutation', bulkEditListMemberWithTracker: { __typename?: 'BulkEditListMemberWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type BulkRemoveContactsFromListWithTrackerMutationVariables = Exact<{
  progressTracker: ProgressTrackerAttributes;
  listUid: Scalars['ID']['input'];
  contactUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkRemoveContactsFromListWithTrackerMutation = { __typename?: 'Mutation', bulkRemoveContactsFromListWithTracker: { __typename?: 'BulkRemoveContactsFromListWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type BulkRemoveListMemberMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  listMemberEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkRemoveListMemberMutation = { __typename?: 'Mutation', bulkRemoveListMember: { __typename?: 'BulkRemoveListMemberMutationPayload', failReasons: Array<string> } | null };

export type BulkUpdateListMemberMutationVariables = Exact<{
  listUid?: InputMaybe<Scalars['ID']['input']>;
  memberIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type BulkUpdateListMemberMutation = { __typename?: 'Mutation', bulkUpdateListMember: { __typename?: 'BulkUpdateListMemberMutationPayload', failReasons: Array<string>, records: Array<{ __typename?: 'ListMember', id: string, createdAt: string, listId: string, contact: { __typename?: 'Contact', primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, whoKnows: Array<{ __typename?: 'WhoKnows', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null }>, gridMemberRecords: Array<{ __typename?: 'ContactListGridMember', id: string, listId: string, contactId: string, createdAt: string, updatedAt: string, completedTasksCount: number, tasksCount: number, inMyContacts: boolean | null, officeLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, contactCard: { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, contactInteractionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null } | null, contactInteractionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number } | null, contactCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, addedBy: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null, marketingListContactConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, topKnowBy: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> }> } | null };

export type CreateListMutationVariables = Exact<{
  name: Scalars['String']['input'];
  category?: InputMaybe<ListCategory>;
}>;


export type CreateListMutation = { __typename?: 'Mutation', createList: { __typename?: 'CreateContactListMutationPayload', id: string | null, failReasons: Array<string> } | null };

export type CreatorDetailsFragment = { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null };

export type ListCustomFieldSchemasQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ListCustomFieldSchemasQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, name: string, tabUid: string | null, usageMode: UsageMode, memberCustomFields: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> | null, project: { __typename?: 'Project', id: string, title: string } | null } | null };

export type ListMemberCustomFieldsQueryVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
}>;


export type ListMemberCustomFieldsQuery = { __typename?: 'Query', listMember: { __typename?: 'ListMember', id: string, list: { __typename?: 'List', id: string }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null } | null };

export type ListNameQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ListNameQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, name: string } | null };

export type ListUsageInfoQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ListUsageInfoQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, tabUid: string | null, name: string, usageMode: UsageMode, project: { __typename?: 'Project', id: string, title: string, nexlApps: boolean } | null } | null };

export type SetListMemberCustomFieldMutationVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type SetListMemberCustomFieldMutation = { __typename?: 'Mutation', setListMemberCustomField: { __typename?: 'SetListMemberCustomFieldMutationPayload', failReasons: Array<string>, record: { __typename?: 'ListMember', id: string, createdAt: string, listId: string, contact: { __typename?: 'Contact', primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, whoKnows: Array<{ __typename?: 'WhoKnows', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null } | null, gridMemberRecord: { __typename?: 'ContactListGridMember', id: string, listId: string, contactId: string, createdAt: string, updatedAt: string, completedTasksCount: number, tasksCount: number, inMyContacts: boolean | null, officeLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, contactCard: { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, contactInteractionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null } | null, contactInteractionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number } | null, contactCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, addedBy: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null, marketingListContactConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, topKnowBy: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> } | null } | null };

export type UpdateListMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<ListCategory>;
}>;


export type UpdateListMutation = { __typename?: 'Mutation', updateList: { __typename?: 'UpdateListMutationPayload', failReasons: Array<string>, list: { __typename?: 'List', id: string, name: string, category: ListCategory | null } } | null };

export type CompanyCardFragment = { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null };

export type CompanyDetailFragment = { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null };

export type ContactCardAvatarFragment = { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null };

export type ContactCardFragment = { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null };

export type ContactListGridMemberRowFragment = { __typename?: 'ContactListGridMember', id: string, listId: string, contactId: string, createdAt: string, updatedAt: string, completedTasksCount: number, tasksCount: number, inMyContacts: boolean | null, officeLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, contactCard: { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, contactInteractionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null } | null, contactInteractionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number } | null, contactCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, addedBy: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null, marketingListContactConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, topKnowBy: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> };

export type ContactListGridMembersQueryVariables = Exact<{
  listId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactListGridMembersQuery = { __typename?: 'Query', contactListGridMembers: { __typename?: 'ContactListGridMemberEntries', id: string, entries: Array<{ __typename?: 'ContactListGridMember', id: string, listId: string, contactId: string, createdAt: string, updatedAt: string, completedTasksCount: number, tasksCount: number, inMyContacts: boolean | null, officeLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, contactCard: { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, contactInteractionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null } | null, contactInteractionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number } | null, contactCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, addedBy: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null, marketingListContactConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, topKnowBy: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> }> } };

export type ContactListGridMembersDeltaQueryVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
  deltaAfter: Scalars['ISO8601DateTime']['input'];
  deltaSize: Scalars['Int']['input'];
}>;


export type ContactListGridMembersDeltaQuery = { __typename?: 'Query', contactListGridMembersDelta: { __typename?: 'ContactListDelta', exceeded: boolean, added: Array<{ __typename?: 'ContactListGridMember', id: string, listId: string, contactId: string, createdAt: string, updatedAt: string, completedTasksCount: number, tasksCount: number, inMyContacts: boolean | null, officeLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, contactCard: { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, contactInteractionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null } | null, contactInteractionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number } | null, contactCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, addedBy: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null, marketingListContactConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, topKnowBy: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> }>, removed: Array<{ __typename?: 'ContactListGridMember', id: string }>, updated: Array<{ __typename?: 'ContactListGridMember', id: string, listId: string, contactId: string, createdAt: string, updatedAt: string, completedTasksCount: number, tasksCount: number, inMyContacts: boolean | null, officeLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, contactCard: { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, contactInteractionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null } | null, contactInteractionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number } | null, contactCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, addedBy: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null, marketingListContactConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, topKnowBy: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> }> } | null };

export type ContactListGridMembersTotalQueryVariables = Exact<{
  listId: Scalars['ID']['input'];
}>;


export type ContactListGridMembersTotalQuery = { __typename?: 'Query', contactListGridMembers: { __typename?: 'ContactListGridMemberEntries', deltaAfter: string, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } }, currentUser: { __typename?: 'User', userId: string } | null };

export type ContactListGridMembersWithFiltersQueryVariables = Exact<{
  listId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  contactFilter?: InputMaybe<ContactListGridMembersFiltering>;
  listMemberFilter?: InputMaybe<ListMemberFilter>;
}>;


export type ContactListGridMembersWithFiltersQuery = { __typename?: 'Query', contactListGridMembers: { __typename?: 'ContactListGridMemberEntries', id: string, entries: Array<{ __typename?: 'ContactListGridMember', id: string, listId: string, contactId: string, createdAt: string, updatedAt: string, completedTasksCount: number, tasksCount: number, inMyContacts: boolean | null, officeLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, contactCard: { __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, contactInteractionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null } | null, contactInteractionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number } | null, contactCustomFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, addedBy: { __typename?: 'UserCard', id: string, email: any | null, firstName: string | null, lastName: string | null, imageUrl: string | null } | null, marketingListContactConsent: { __typename?: 'ContactConsent', id: string | null, status: ContactConsentStatus }, topKnowBy: Array<{ __typename?: 'WhoKnows', id: string, contactCard: { __typename?: 'ContactCard', id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null } }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ConfirmationPageSettingsFragment = { __typename?: 'ConfirmationPageSettings', redirectUrl: string | null, thankYouMessage: string | null, thankYouHeader: string | null };

export type ContactListFormQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ContactListFormQuery = { __typename?: 'Query', contactListForm: { __typename?: 'Form', id: string, title: string, contactListId: string | null, status: FormStatusEnum | null, expired: boolean, description: string | null, setConsentToGiven: boolean, includeDefaultFooter: boolean, disableRecaptcha: boolean, contactList: { __typename?: 'List', project: { __typename?: 'Project', id: string } | null } | null, elements: Array<{ __typename?: 'InputElement', id: string | null, defaultValue: string | null, displayAs: DisplayAs | null, field: string, hidden: boolean, label: string | null, placeholder: string | null, description: string | null, required: boolean, customFieldSchemaId: string | null, customField: { __typename?: 'CustomFieldSchema', name: string } | null } | { __typename?: 'TextElement', id: string | null, value: string }>, confirmationPageSettings: { __typename?: 'ConfirmationPageSettings', redirectUrl: string | null, thankYouMessage: string | null, thankYouHeader: string | null } | null, waitlistSettings: { __typename?: 'FormWaitlistSettings', enabled: boolean, redirectUrl: string | null, condition: { __typename?: 'WaitlistCondition', operator: WaitlistConditionOperatorEnum | null, value: number | null, rollupField: { __typename?: 'TableLikeRollupFieldType', id: string, name: string } | null } | null } | null, expirySettings: { __typename?: 'FormExpirySettings', enabled: boolean, date: string | null, pageHeader: string | null, pageDescription: { __typename?: 'PageDescription', htmlForEditor: string | null, renderSafeHtml: string | null } | null } | null, keyActivitySettings: { __typename?: 'KeyActivitySettings', title: string | null, category: KeyActivityCategory | null, description: string | null, enabled: boolean | null } | null, workflows: Array<{ __typename?: 'Workflow', id: string, taskType: WorkflowTask | null, conditions: Array<{ __typename?: 'WorkflowCondition', conditionValue: string, customFieldSchema: { __typename?: 'CustomFieldSchema', id: string } }> | null, subscribedUsersV2: Array<{ __typename?: 'UserSelection', id: string, profileName: string, profileImageUrl: string | null, email: string }> | null, recipient: { __typename?: 'Campaign', id: string, title: string, status: CampaignStatus } | { __typename?: 'List', id: string, name: string, usageMode: UsageMode, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, project: { __typename?: 'Project', title: string } | null } | null }> | null, theme: { __typename?: 'FormTheme', id: string, coverImage: { __typename?: 'File', url: string } | null } } | null };

export type ContactListFormDetailsFragment = { __typename?: 'Form', id: string, title: string, contactListId: string | null, status: FormStatusEnum | null, expired: boolean, description: string | null, setConsentToGiven: boolean, includeDefaultFooter: boolean, disableRecaptcha: boolean, contactList: { __typename?: 'List', project: { __typename?: 'Project', id: string } | null } | null, elements: Array<{ __typename?: 'InputElement', id: string | null, defaultValue: string | null, displayAs: DisplayAs | null, field: string, hidden: boolean, label: string | null, placeholder: string | null, description: string | null, required: boolean, customFieldSchemaId: string | null, customField: { __typename?: 'CustomFieldSchema', name: string } | null } | { __typename?: 'TextElement', id: string | null, value: string }>, confirmationPageSettings: { __typename?: 'ConfirmationPageSettings', redirectUrl: string | null, thankYouMessage: string | null, thankYouHeader: string | null } | null, waitlistSettings: { __typename?: 'FormWaitlistSettings', enabled: boolean, redirectUrl: string | null, condition: { __typename?: 'WaitlistCondition', operator: WaitlistConditionOperatorEnum | null, value: number | null, rollupField: { __typename?: 'TableLikeRollupFieldType', id: string, name: string } | null } | null } | null, expirySettings: { __typename?: 'FormExpirySettings', enabled: boolean, date: string | null, pageHeader: string | null, pageDescription: { __typename?: 'PageDescription', htmlForEditor: string | null, renderSafeHtml: string | null } | null } | null, keyActivitySettings: { __typename?: 'KeyActivitySettings', title: string | null, category: KeyActivityCategory | null, description: string | null, enabled: boolean | null } | null, workflows: Array<{ __typename?: 'Workflow', id: string, taskType: WorkflowTask | null, conditions: Array<{ __typename?: 'WorkflowCondition', conditionValue: string, customFieldSchema: { __typename?: 'CustomFieldSchema', id: string } }> | null, subscribedUsersV2: Array<{ __typename?: 'UserSelection', id: string, profileName: string, profileImageUrl: string | null, email: string }> | null, recipient: { __typename?: 'Campaign', id: string, title: string, status: CampaignStatus } | { __typename?: 'List', id: string, name: string, usageMode: UsageMode, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, project: { __typename?: 'Project', title: string } | null } | null }> | null, theme: { __typename?: 'FormTheme', id: string, coverImage: { __typename?: 'File', url: string } | null } };

export type ContactListFormInfoFragment = { __typename?: 'Form', id: string, title: string, description: string | null, status: FormStatusEnum | null, expired: boolean, confirmationPageSettings: { __typename?: 'ConfirmationPageSettings', redirectUrl: string | null, thankYouMessage: string | null, thankYouHeader: string | null } | null };

export type ContactListFormsQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactListFormsQuery = { __typename?: 'Query', contactListForms: { __typename?: 'ContactListForms', entries: Array<{ __typename?: 'Form', id: string, title: string, description: string | null, status: FormStatusEnum | null, expired: boolean, confirmationPageSettings: { __typename?: 'ConfirmationPageSettings', redirectUrl: string | null, thankYouMessage: string | null, thankYouHeader: string | null } | null }> } };

export type CreateFormMutationVariables = Exact<{
  contact_list_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFormMutation = { __typename?: 'Mutation', result: { __typename?: 'CreateFormMutationPayload', failReasons: Array<string>, record: { __typename?: 'Form', id: string } | null } | null };

export type DeleteFormMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFormMutation = { __typename?: 'Mutation', result: { __typename?: 'DeleteFormMutationPayload', failReasons: Array<string> } | null };

export type FormInputElementFragment = { __typename?: 'InputElement', id: string | null, defaultValue: string | null, displayAs: DisplayAs | null, field: string, hidden: boolean, label: string | null, placeholder: string | null, description: string | null, required: boolean, customFieldSchemaId: string | null, customField: { __typename?: 'CustomFieldSchema', name: string } | null };

export type FormTextElementFragment = { __typename?: 'TextElement', id: string | null, value: string };

export type KeyActivitySettingsFragment = { __typename?: 'KeyActivitySettings', title: string | null, category: KeyActivityCategory | null, description: string | null, enabled: boolean | null };

export type PublishFormMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishFormMutation = { __typename?: 'Mutation', publishForm: { __typename?: 'PublishFormMutationPayload', failReasons: Array<string>, record: { __typename?: 'Form', title: string, description: string | null } | null } | null };

export type UpdateFormMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFormMutation = { __typename?: 'Mutation', result: { __typename?: 'UpdateFormMutationPayload', failReasons: Array<string>, record: { __typename?: 'Form', id: string } | null } | null };

export type UpdateFormConfirmationSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  confirmationPageSettings: ConfirmationPageSettingsInput;
}>;


export type UpdateFormConfirmationSettingsMutation = { __typename?: 'Mutation', result: { __typename?: 'UpdateFormConfirmationSettingsMutationPayload', failReasons: Array<string> } | null };

export type UpdateFormInfoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  elements?: InputMaybe<Array<FormElementInput> | FormElementInput>;
  confirmationPageSettings?: InputMaybe<ConfirmationPageSettingsInput>;
}>;


export type UpdateFormInfoMutation = { __typename?: 'Mutation', result: { __typename?: 'UpdateFormInfoMutationPayload', failReasons: Array<string>, record: { __typename?: 'Form', id: string } | null } | null };

export type UpdateFormKeyActivitySettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  keyActivitySettings: KeyActivitySettingsInput;
}>;


export type UpdateFormKeyActivitySettingsMutation = { __typename?: 'Mutation', result: { __typename?: 'UpdateFormKeyActivitySettingsMutationPayload', failReasons: Array<string> } | null };

export type UpdateFormSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  includeDefaultFooter?: InputMaybe<Scalars['Boolean']['input']>;
  setConsentToGiven: Scalars['Boolean']['input'];
}>;


export type UpdateFormSettingsMutation = { __typename?: 'Mutation', result: { __typename?: 'UpdateFormSettingsMutationPayload', failReasons: Array<string> } | null };

export type UpdateFormThemeSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  includeDefaultFooter?: InputMaybe<Scalars['Boolean']['input']>;
  setConsentToGiven: Scalars['Boolean']['input'];
  disableRecaptcha?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateFormThemeSettingsMutation = { __typename?: 'Mutation', result: { __typename?: 'UpdateFormSettingsMutationPayload', failReasons: Array<string>, updatedForm: { __typename?: 'Form', id: string, setConsentToGiven: boolean, includeDefaultFooter: boolean, disableRecaptcha: boolean, status: FormStatusEnum | null } | null } | null };

export type DeleteThemeCoverImageForFormMutationVariables = Exact<{
  formUid: Scalars['ID']['input'];
}>;


export type DeleteThemeCoverImageForFormMutation = { __typename?: 'Mutation', deleteThemeCoverImageForForm: { __typename?: 'DeleteThemeCoverImageForFormMutationPayload', failReasons: Array<string>, form: { __typename?: 'Form', id: string, status: FormStatusEnum | null, theme: { __typename?: 'FormTheme', id: string, coverImage: { __typename?: 'File', url: string } | null } } | null } | null };

export type UpdateThemeForFormMutationVariables = Exact<{
  formUid: Scalars['ID']['input'];
  settings: FormThemeSettingsInput;
}>;


export type UpdateThemeForFormMutation = { __typename?: 'Mutation', updateThemeForForm: { __typename?: 'UpdateThemeForFormMutationPayload', failReasons: Array<string>, form: { __typename?: 'Form', id: string, status: FormStatusEnum | null, theme: { __typename?: 'FormTheme', id: string, coverImage: { __typename?: 'File', url: string } | null } } | null } | null };

export type CreateFormWorkflowMutationVariables = Exact<{
  formUid: Scalars['ID']['input'];
  taskType: WorkflowTask;
  listUid?: InputMaybe<Scalars['ID']['input']>;
  campaignUid?: InputMaybe<Scalars['ID']['input']>;
  conditions?: InputMaybe<Array<WorkflowConditionInput> | WorkflowConditionInput>;
  userUids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateFormWorkflowMutation = { __typename?: 'Mutation', createFormWorkflow: { __typename?: 'CreateFormWorkflowMutationPayload', failReasons: Array<string> } | null };

export type DeleteFormWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFormWorkflowMutation = { __typename?: 'Mutation', deleteFormWorkflow: { __typename?: 'DeleteFormWorkflowMutationPayload', failReasons: Array<string> } | null };

export type UpdateFormWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  listUid?: InputMaybe<Scalars['ID']['input']>;
  campaignUid?: InputMaybe<Scalars['ID']['input']>;
  conditions?: InputMaybe<Array<WorkflowConditionInput> | WorkflowConditionInput>;
  userUids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateFormWorkflowMutation = { __typename?: 'Mutation', updateFormWorkflow: { __typename?: 'UpdateFormWorkflowMutationPayload', failReasons: Array<string>, workflow: { __typename?: 'Workflow', id: string, taskType: WorkflowTask | null, conditions: Array<{ __typename?: 'WorkflowCondition', conditionValue: string, customFieldSchema: { __typename?: 'CustomFieldSchema', id: string } }> | null, subscribedUsersV2: Array<{ __typename?: 'UserSelection', id: string, profileName: string, profileImageUrl: string | null, email: string }> | null, recipient: { __typename?: 'Campaign', id: string, title: string, status: CampaignStatus } | { __typename?: 'List', id: string, name: string, usageMode: UsageMode, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, project: { __typename?: 'Project', title: string } | null } | null } | null } | null };

export type WorkflowConditionFragment = { __typename?: 'WorkflowCondition', conditionValue: string, customFieldSchema: { __typename?: 'CustomFieldSchema', id: string } };

export type WorkflowDetailsFragment = { __typename?: 'Workflow', id: string, taskType: WorkflowTask | null, conditions: Array<{ __typename?: 'WorkflowCondition', conditionValue: string, customFieldSchema: { __typename?: 'CustomFieldSchema', id: string } }> | null, subscribedUsersV2: Array<{ __typename?: 'UserSelection', id: string, profileName: string, profileImageUrl: string | null, email: string }> | null, recipient: { __typename?: 'Campaign', id: string, title: string, status: CampaignStatus } | { __typename?: 'List', id: string, name: string, usageMode: UsageMode, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, project: { __typename?: 'Project', title: string } | null } | null };

export type AddKeyActivityToListMutationVariables = Exact<{
  keyActivityUid?: InputMaybe<Scalars['ID']['input']>;
  keyActivityListUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddKeyActivityToListMutation = { __typename?: 'Mutation', addKeyActivityToList: { __typename?: 'AddKeyActivityToListMutationPayload', failReasons: Array<string>, record: { __typename?: 'KeyActivityListMember', id: string, isPersisted: boolean, keyActivity: { __typename?: 'KeyActivity', id: string, activityTitle: string, description: string | null, category: KeyActivityCategory, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }> } } | null } | null };

export type ContactInvolvedFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } };

export type KeyActivityListMemberFragment = { __typename?: 'KeyActivityListMember', id: string, isPersisted: boolean, keyActivity: { __typename?: 'KeyActivity', id: string, activityTitle: string, description: string | null, category: KeyActivityCategory, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }> } };

export type KeyActivityListMembersQueryVariables = Exact<{
  keyActivityListUid?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type KeyActivityListMembersQuery = { __typename?: 'Query', keyActivityListMembers: { __typename?: 'KeyActivityListMembers', entries: Array<{ __typename?: 'KeyActivityListMember', id: string, isPersisted: boolean, keyActivity: { __typename?: 'KeyActivity', id: string, activityTitle: string, description: string | null, category: KeyActivityCategory, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', plainText: string, html: string, trixHtml: string } | null, staffInvolved: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactsInvolved: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } }> } }> } | null };

export type KeyActivityListMembersTotalQueryVariables = Exact<{
  keyActivityListUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type KeyActivityListMembersTotalQuery = { __typename?: 'Query', keyActivityListMembers: { __typename?: 'KeyActivityListMembers', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } | null };

export type KeyActivityMeetingOrEmailActionsCellRendererQueryVariables = Exact<{
  sourceReferenceId: Scalars['String']['input'];
}>;


export type KeyActivityMeetingOrEmailActionsCellRendererQuery = { __typename?: 'Query', keyActivity: { __typename?: 'KeyActivity', id: string, calendarMeeting: { __typename?: 'EmployeeMeeting', id: string } | null, interaction: { __typename?: 'PartitionedInteraction', id: string, interactionType: PartitionedInteractionType } | null } | null };

export type RemoveKeyActivityFromListMutationVariables = Exact<{
  keyActivityMemberUid: Scalars['ID']['input'];
}>;


export type RemoveKeyActivityFromListMutation = { __typename?: 'Mutation', removeKeyActivityMember: { __typename?: 'RemoveKeyActivityMemberMutationPayload', failReasons: Array<string>, member: { __typename?: 'KeyActivityListMember', id: string, isPersisted: boolean } | null } | null };

export type StaffInvolvedFragment = { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } };

export type ListAutocompleteOptionFragment = { __typename?: 'MyList', id: string, name: string, locationInfo: { __typename?: 'MyListLocationInfo', displayName: string, locationTyped: MyListLocation } };

export type ListAutocompleteOptionsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListAutocompleteOptionsQuery = { __typename?: 'Query', myLists: { __typename?: 'MyListEntries', entries: Array<{ __typename?: 'MyList', id: string, name: string, locationInfo: { __typename?: 'MyListLocationInfo', displayName: string, locationTyped: MyListLocation } }> } };

export type ListAutocompleteValueByIdsQueryVariables = Exact<{
  myListUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ListAutocompleteValueByIdsQuery = { __typename?: 'Query', multiMyContactList: { __typename?: 'MultiMyContactList', entries: Array<{ __typename?: 'MyList', id: string, name: string, locationInfo: { __typename?: 'MyListLocationInfo', displayName: string, locationTyped: MyListLocation } }> | null } | null };

export type BulkRemoveCleanedMembersMutationVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
  filter: VerificationFilterInput;
}>;


export type BulkRemoveCleanedMembersMutation = { __typename?: 'Mutation', bulkRemoveContactListCleanedMembers: { __typename?: 'BulkRemoveContactListMembersMutationPayload', failReasons: Array<string> } | null };

export type BulkRemoveFromListMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  listMemberUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkRemoveFromListMutation = { __typename?: 'Mutation', bulkRemoveListMember: { __typename?: 'BulkRemoveListMemberMutationPayload', failReasons: Array<string> } | null };

export type ListCleanStatusQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ListCleanStatusQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null } | null } | null };

export type ListCleanerQueryVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<VerificationFilterInput>;
}>;


export type ListCleanerQuery = { __typename?: 'Query', listCleaner: { __typename?: 'Verifications', entries: Array<{ __typename?: 'Verification', id: string | null, reason: string | null, result: VerificationResult | null, risk: VerificationRisk | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, isPersonal: boolean, isArchived: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } | null };

export type ListCleanerContactFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, isPersonal: boolean, isArchived: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ListCleanerFragment = { __typename?: 'Verification', id: string | null, reason: string | null, result: VerificationResult | null, risk: VerificationRisk | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, isPersonal: boolean, isArchived: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } };

export type ListCleanerHeaderQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ListCleanerHeaderQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, name: string } | null };

export type ListCleanerHeaderFragment = { __typename?: 'List', id: string, name: string };

export type ListCleanerInfoQueryVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
}>;


export type ListCleanerInfoQuery = { __typename?: 'Query', listCleaner: { __typename?: 'Verifications', clean: { __typename?: 'Clean', id: string | null, cleanEnd: string | null, totalBounced: number, totalUnsubscribed: number, totalConsentNotGiven: number, totalUnengaged: number, totalMembers: number } | null } | null };

export type ListCleanerInfoFragment = { __typename?: 'Clean', id: string | null, cleanEnd: string | null, totalBounced: number, totalUnsubscribed: number, totalConsentNotGiven: number, totalUnengaged: number, totalMembers: number };

export type OverrideContactVerificationMutationVariables = Exact<{
  contactUid: Scalars['ID']['input'];
  risk: VerificationRisk;
}>;


export type OverrideContactVerificationMutation = { __typename?: 'Mutation', listCleanerOverrideContactVerification: { __typename?: 'OverrideContactVerificationMutationPayload', failReasons: Array<string>, verification: { __typename?: 'Verification', id: string | null, reason: string | null, result: VerificationResult | null, risk: VerificationRisk | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, isPersonal: boolean, isArchived: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } } | null } | null };

export type VerifyListMutationVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
}>;


export type VerifyListMutation = { __typename?: 'Mutation', verifyList: { __typename?: 'ExecuteListCleanMutationPayload', failReasons: Array<string>, clean: { __typename?: 'Clean', id: string | null, status: ExecutionStatus | null } } | null };

export type ListCleanerRiskFiltersQueryVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
  contactStatus?: InputMaybe<VerificationContactStatus>;
}>;


export type ListCleanerRiskFiltersQuery = { __typename?: 'Query', listCleaner: { __typename?: 'Verifications', clean: { __typename?: 'Clean', id: string | null, totalHighRisk: number, totalMediumRisk: number, totalLowRisk: number } | null } | null };

export type ListCleanerRiskFiltersFragment = { __typename?: 'Clean', id: string | null, totalHighRisk: number, totalMediumRisk: number, totalLowRisk: number };

export type ContactProjectListMemberRowContactFragment = { __typename?: 'Contact', primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, whoKnows: Array<{ __typename?: 'WhoKnows', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ContactProjectListMemberRowFragment = { __typename?: 'ListMember', id: string, createdAt: string, listId: string, contact: { __typename?: 'Contact', primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, whoKnows: Array<{ __typename?: 'WhoKnows', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null };

export type ContactsExistInListQueryVariables = Exact<{
  contactUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  listId: Scalars['ID']['input'];
}>;


export type ContactsExistInListQuery = { __typename?: 'Query', contactsExistInList: { __typename?: 'ContactsExistInList', entries: Array<string> } };

export type ListMembersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ListMembersOrderBy>;
  filter?: InputMaybe<ListMembersFilter>;
}>;


export type ListMembersQuery = { __typename?: 'Query', listMembers: { __typename?: 'ListMembers', entries: Array<{ __typename?: 'ListMember', id: string, createdAt: string, listId: string, contact: { __typename?: 'Contact', primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, tags: Array<string>, phoneNumbers: Array<string>, twitterUrl: string | null, linkedinUrl: string | null, educations: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, emails: number, interactions: number, meetings: number, receivedEmails: number, sentEmails: number }, whoKnows: Array<{ __typename?: 'WhoKnows', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }>, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string, tags: Array<string>, numberOfEmployees: number | null, description: string | null, industryNames: Array<string> | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: Array<string> | null, correspondenceEmails: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', brief: string } } | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean }>, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ListMembersInContactsQueryVariables = Exact<{
  contactUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  uid: Scalars['ID']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListMembersInContactsQuery = { __typename?: 'Query', listMembers: { __typename?: 'ListMembers', entries: Array<{ __typename?: 'ListMember', contact: { __typename?: 'Contact', id: string } }> } };

export type ListMembersTotalQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ListMembersTotalQuery = { __typename?: 'Query', listMembers: { __typename?: 'ListMembers', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ListMembershipQueryVariables = Exact<{
  contactEmail: Scalars['ID']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  marketingListOnly?: InputMaybe<Scalars['Boolean']['input']>;
  excludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListMembershipQuery = { __typename?: 'Query', listMembers: { __typename?: 'ListMembers', entries: Array<{ __typename?: 'ListMember', memberId: string, list: { __typename?: 'List', name: string, id: string, usageMode: UsageMode, tabUid: string | null, project: { __typename?: 'Project', id: string, title: string, nexlApps: boolean } | null } }> } };

export type ListMembershipPreviewFragment = { __typename?: 'List', name: string, id: string, usageMode: UsageMode, tabUid: string | null, project: { __typename?: 'Project', id: string, title: string, nexlApps: boolean } | null };

export type CreateListViewMutationVariables = Exact<{
  listUid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  viewType: ListViewType;
  renderMode?: InputMaybe<ListViewRenderMode>;
  schemaUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateListViewMutation = { __typename?: 'Mutation', createListView: { __typename?: 'CreateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type DeleteListViewMutationVariables = Exact<{
  listViewUid: Scalars['ID']['input'];
}>;


export type DeleteListViewMutation = { __typename?: 'Mutation', deleteListView: { __typename?: 'DeleteListViewMutationPayload', failReasons: Array<string> | null } | null };

export type ListViewQueryVariables = Exact<{
  listViewUid: Scalars['ID']['input'];
}>;


export type ListViewQuery = { __typename?: 'Query', listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null };

export type ListViewFragment = { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null };

export type ListViewsQueryVariables = Exact<{
  listUid: Scalars['String']['input'];
}>;


export type ListViewsQuery = { __typename?: 'Query', listViews: Array<{ __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null }> };

export type UpdateListViewColumnStateMutationVariables = Exact<{
  listViewUid: Scalars['String']['input'];
  columnState: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateListViewColumnStateMutation = { __typename?: 'Mutation', updateListView: { __typename?: 'UpdateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type UpdateListViewFilterModelMutationVariables = Exact<{
  listViewUid: Scalars['String']['input'];
  filterModel: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateListViewFilterModelMutation = { __typename?: 'Mutation', updateListView: { __typename?: 'UpdateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type UpdateListViewInfoMutationVariables = Exact<{
  listViewUid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  schemaUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateListViewInfoMutation = { __typename?: 'Mutation', updateListView: { __typename?: 'UpdateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type UpdateListViewSearchStateMutationVariables = Exact<{
  listViewUid: Scalars['String']['input'];
  searchState: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateListViewSearchStateMutation = { __typename?: 'Mutation', updateListView: { __typename?: 'UpdateListViewMutationPayload', failReasons: Array<string>, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null } | null };

export type RemovedHistoryPageQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uid: Scalars['ID']['input'];
}>;


export type RemovedHistoryPageQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, name: string } | null, listMembers: { __typename?: 'ListMembers', entries: Array<{ __typename?: 'ListMember', id: string, discardedAt: string | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, remover: { __typename?: 'User', id: string, profileImageUrl: string | null, profileName: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type RemovedHistoryRowFragment = { __typename?: 'ListMember', id: string, discardedAt: string | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, remover: { __typename?: 'User', id: string, profileImageUrl: string | null, profileName: string } | null };

export type RestoreDiscardedListMembersMutationVariables = Exact<{
  listMemberUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  listUid: Scalars['ID']['input'];
}>;


export type RestoreDiscardedListMembersMutation = { __typename?: 'Mutation', restoreDiscardedListMembers: { __typename?: 'RestoreDiscardedListMembersMutationPayload', failReasons: Array<string> } | null };

export type ShareListViewMutationVariables = Exact<{
  listUid: Scalars['ID']['input'];
  sharedWithUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  listViewUid?: InputMaybe<Scalars['ID']['input']>;
  permission: SharedListViewPermission;
}>;


export type ShareListViewMutation = { __typename?: 'Mutation', shareListView: { __typename?: 'ShareListViewMutationPayload', failReasons: Array<string> } | null };

export type ShareListViewByInviteTabQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ShareListViewByInviteTabQuery = { __typename?: 'Query', tab: { __typename?: 'TabResult', id: string, isAppTab: boolean, isWorkspaceTab: boolean } | null };

export type UserForSelectionFragment = { __typename?: 'UserSelection', id: string, profileName: string, profileImageUrl: string | null, email: string };

export type UsersForSelectionQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersForSelectionQuery = { __typename?: 'Query', usersForSelection: { __typename?: 'UserSelectionEntries', entries: Array<{ __typename?: 'UserSelection', id: string, profileName: string, profileImageUrl: string | null, email: string }> } };

export type UsersForSelectionByEmailQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UsersForSelectionByEmailQuery = { __typename?: 'Query', usersForSelection: { __typename?: 'UserSelectionEntries', entries: Array<{ __typename?: 'UserSelection', id: string, profileName: string, profileImageUrl: string | null, email: string }> } };

export type AddFilteredContactsToListTableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<ContactFilter> | ContactFilter>;
  filter?: InputMaybe<ContactsFiltering>;
  orderBy?: InputMaybe<ContactsOrderBy>;
}>;


export type AddFilteredContactsToListTableQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactList', entries: Array<{ __typename?: 'Contact', id: string, emailAddresses: Array<any>, primaryEmail: any | null, createdAt: string, archivedAt: string | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null }, company: { __typename?: 'Company', id: string, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, companyHierarchy: { __typename?: 'CompanyHierarchy', hierarchy: { __typename?: 'Hierarchy', id: string | null, partOfHierarchy: boolean } | null } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type AddFilteredContactsToListTableContactRowFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, changedJob: boolean, isPersonal: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null, phoneNumbers: Array<string>, jobTitle: string | null, location: { __typename?: 'Location', id: string, city: string | null, state: string | null, country: { __typename?: 'Country', name: string } | null } | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string, id: string | null } }, bounce: { __typename?: 'BounceCount', id: string, isLimitReached: boolean, count: number } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type AddFilteredContactsToListTableContactsTableFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, changedJob: boolean, isPersonal: boolean, isArchived: boolean, isKeyContact: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null, phoneNumbers: Array<string>, jobTitle: string | null, location: { __typename?: 'Location', id: string, city: string | null, state: string | null, country: { __typename?: 'Country', name: string } | null } | null }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, bounce: { __typename?: 'BounceCount', id: string, isLimitReached: boolean, count: number } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type AddCompanyToExclusionListMutationVariables = Exact<{
  companyUid: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  exclusionListCategories: Array<ListCategory> | ListCategory;
  excludeEveryCategory: Scalars['Boolean']['input'];
  exclusionType?: InputMaybe<ExclusionType>;
}>;


export type AddCompanyToExclusionListMutation = { __typename?: 'Mutation', addCompanyToExclusionList: { __typename?: 'AddCompanyToExclusionListMutationPayload', failReasons: Array<string>, record: { __typename?: 'CompanyExclusion', id: string, reason: string, createdAt: string, excludeFromEveryListCategory: boolean, exclusionListCategories: Array<ListCategory>, exclusionType: ExclusionType, company: { __typename?: 'Company', id: string, isBlocked: boolean, domain: string | null, domains: Array<string>, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string, profileImageUrl: string | null } } | null } | null };

export type CompanyExclusionListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyExclusionListQuery = { __typename?: 'Query', companyExclusionList: { __typename?: 'CompanyExclusionList', entries: Array<{ __typename?: 'CompanyExclusion', id: string, reason: string, createdAt: string, excludeFromEveryListCategory: boolean, exclusionListCategories: Array<ListCategory>, exclusionType: ExclusionType, company: { __typename?: 'Company', id: string, isBlocked: boolean, domain: string | null, domains: Array<string>, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string, profileImageUrl: string | null } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number, totalPages: number } } | null };

export type CompanyExclusionRowFragment = { __typename?: 'CompanyExclusion', id: string, reason: string, createdAt: string, excludeFromEveryListCategory: boolean, exclusionListCategories: Array<ListCategory>, exclusionType: ExclusionType, company: { __typename?: 'Company', id: string, isBlocked: boolean, domain: string | null, domains: Array<string>, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string, profileImageUrl: string | null } };

export type RemoveCompanyFromExclusionListMutationVariables = Exact<{
  companyExclusionUid: Scalars['ID']['input'];
}>;


export type RemoveCompanyFromExclusionListMutation = { __typename?: 'Mutation', removeCompanyFromExclusionList: { __typename?: 'RemoveCompanyFromExclusionListMutationPayload', failReasons: Array<string> } | null };

export type UpdateCompanyExclusionMutationVariables = Exact<{
  companyExclusionUuid: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  exclusionListCategories: Array<ListCategory> | ListCategory;
  excludeEveryCategory: Scalars['Boolean']['input'];
}>;


export type UpdateCompanyExclusionMutation = { __typename?: 'Mutation', updateCompanyExclusion: { __typename?: 'UpdateCompanyExclusionMutationPayload', failReasons: Array<string>, record: { __typename?: 'CompanyExclusion', id: string, excludeFromEveryListCategory: boolean, exclusionListCategories: Array<ListCategory>, reason: string } | null } | null };

export type BlockedContactFragment = { __typename?: 'BlockedContact', errors: Array<string>, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', lastName: string | null, firstName: string | null, imageUrl: string | null, id: string | null, jobTitle: string | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', name: string, id: string | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } };

export type BlockedContactInfoFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', lastName: string | null, firstName: string | null, imageUrl: string | null, id: string | null, jobTitle: string | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', name: string, id: string | null } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type BlockedContactListFragment = { __typename?: 'BlockedContact', errors: Array<string>, contact: { __typename?: 'Contact', inMyContacts: boolean | null, primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } };

export type BlockedContactListRowFragment = { __typename?: 'Contact', inMyContacts: boolean | null, primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type ContactExclusionRowFragment = { __typename?: 'ContactExclusion', id: string, reason: string, exclusionType: ExclusionType, createdAt: string, exclusionListCategories: Array<ListCategory>, excludeFromEveryListCategory: boolean, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string, profileImageUrl: string | null }, schema: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> };

export type ContactExclusionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactExclusionsQuery = { __typename?: 'Query', contactExclusions: { __typename?: 'ContactExclusions', entries: Array<{ __typename?: 'ContactExclusion', id: string, reason: string, exclusionType: ExclusionType, createdAt: string, exclusionListCategories: Array<ListCategory>, excludeFromEveryListCategory: boolean, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string, profileImageUrl: string | null }, schema: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number, totalPages: number } } | null };

export type CreateContactExclusionRuleMutationVariables = Exact<{
  schemaUid: Scalars['ID']['input'];
  optionChoiceUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  exclusionListCategories: Array<ListCategory> | ListCategory;
  excludeFromEveryCategory: Scalars['Boolean']['input'];
  exclusionType?: InputMaybe<ExclusionType>;
}>;


export type CreateContactExclusionRuleMutation = { __typename?: 'Mutation', createContactExclusionRule: { __typename?: 'CreateContactExclusionRuleMutationPayload', failReasons: Array<string>, record: { __typename?: 'ContactExclusion', id: string, reason: string, exclusionType: ExclusionType, createdAt: string, exclusionListCategories: Array<ListCategory>, excludeFromEveryListCategory: boolean, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string, profileImageUrl: string | null }, schema: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> } | null } | null };

export type ExcludedContactsModalQueryVariables = Exact<{
  contactUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  listId: Scalars['String']['input'];
  exclusionTypes: Array<ExclusionType> | ExclusionType;
}>;


export type ExcludedContactsModalQuery = { __typename?: 'Query', matchingMarketingExclusions: Array<{ __typename: 'CompanyExclusion', id: string, reason: string, matchedContact: { __typename?: 'Contact', id: string }, creator: { __typename?: 'User', id: string, profileImageUrl: string | null, firstName: string | null, lastName: string | null, email: string } } | { __typename: 'ContactExclusion', id: string, reason: string, matchedContact: { __typename?: 'Contact', id: string }, creator: { __typename?: 'User', id: string, profileImageUrl: string | null, firstName: string | null, lastName: string | null, email: string }, schema: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null } }> | null, marketingListConfiguration: { __typename?: 'MarketingListConfiguration', id: string, allowUnsubscribed: boolean, consentLegitimateInterestText: string } | null };

type MatchingExclusion_CompanyExclusion_Fragment = { __typename: 'CompanyExclusion', id: string, reason: string, matchedContact: { __typename?: 'Contact', id: string }, creator: { __typename?: 'User', id: string, profileImageUrl: string | null, firstName: string | null, lastName: string | null, email: string } };

type MatchingExclusion_ContactExclusion_Fragment = { __typename: 'ContactExclusion', id: string, reason: string, matchedContact: { __typename?: 'Contact', id: string }, creator: { __typename?: 'User', id: string, profileImageUrl: string | null, firstName: string | null, lastName: string | null, email: string }, schema: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null } };

export type MatchingExclusionFragment = MatchingExclusion_CompanyExclusion_Fragment | MatchingExclusion_ContactExclusion_Fragment;

export type MatchingMarketingCompanyExclusionFragment = { __typename?: 'CompanyExclusion', id: string, reason: string, creator: { __typename?: 'User', id: string, profileImageUrl: string | null, firstName: string | null, lastName: string | null, email: string } };

export type MatchingMarketingContactExclusionFragment = { __typename?: 'ContactExclusion', id: string, reason: string, creator: { __typename?: 'User', id: string, profileImageUrl: string | null, firstName: string | null, lastName: string | null, email: string }, schema: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null } };

export type MatchingMarketingExclusionCreatorFragment = { __typename?: 'User', id: string, profileImageUrl: string | null, firstName: string | null, lastName: string | null, email: string };

export type RemoveContactExclusionRuleMutationVariables = Exact<{
  contactExclusionRuleUid: Scalars['ID']['input'];
}>;


export type RemoveContactExclusionRuleMutation = { __typename?: 'Mutation', removeContactExclusionRule: { __typename?: 'RemoveContactExclusionRuleMutationPayload', failReasons: Array<string> } | null };

export type UpdateContactExclusionRuleMutationVariables = Exact<{
  contactExclusionRuleUid: Scalars['ID']['input'];
  schemaUid: Scalars['ID']['input'];
  optionChoiceUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  exclusionListCategories: Array<ListCategory> | ListCategory;
  excludeFromEveryListCategory: Scalars['Boolean']['input'];
}>;


export type UpdateContactExclusionRuleMutation = { __typename?: 'Mutation', updateContactExclusionRule: { __typename?: 'UpdateContactExclusionRuleMutationPayload', failReasons: Array<string> } | null };

export type BeeAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type BeeAuthQuery = { __typename?: 'Query', beeAuth: { __typename?: 'BeeAuth', accessToken: string, v2: boolean }, emailMarketingConfiguration: { __typename?: 'EmailMarketingConfiguration', id: string, fonts: Array<{ __typename?: 'Font', name: string, url: string, family: string }> } | null };

export type BeeAuthFragment = { __typename?: 'BeeAuth', accessToken: string, v2: boolean };

export type ConnectListMutationVariables = Exact<{
  listUuid: Scalars['String']['input'];
  audienceId: Scalars['String']['input'];
}>;


export type ConnectListMutation = { __typename?: 'Mutation', connectList: { __typename?: 'ConnectListMutationPayload', failReasons: Array<string> } | null };

export type ConnectedListInfoFragment = { __typename?: 'ConnectedList', id: string, syncing: boolean, nameOnEms: string | null, connected: boolean | null, outOfSync: boolean | null, lastSyncAt: string | null, lastSyncError: string | null, externalUrl: string | null, list: { __typename?: 'List', id: string } | null, campaignManager: { __typename?: 'CampaignManager', id: string, name: string, mappingEnabled: boolean } | null };

export type ConnectedListUpdatedSubscriptionVariables = Exact<{
  listUid: Scalars['ID']['input'];
}>;


export type ConnectedListUpdatedSubscription = { __typename?: 'Subscription', connectedListUpdated: { __typename?: 'ConnectedList', id: string, syncing: boolean, nameOnEms: string | null, connected: boolean | null, outOfSync: boolean | null, lastSyncAt: string | null, lastSyncError: string | null, externalUrl: string | null, list: { __typename?: 'List', id: string } | null, campaignManager: { __typename?: 'CampaignManager', id: string, name: string, mappingEnabled: boolean } | null } };

export type ConsentLegitimateInterestTextQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsentLegitimateInterestTextQuery = { __typename?: 'Query', marketingListConfiguration: { __typename?: 'MarketingListConfiguration', id: string, allowUnsubscribed: boolean, consentLegitimateInterestText: string, consentConsentGivenText: string, consentUserUnsubscribedText: string, enableMarketingExclusion: boolean } | null };

export type DisconnectConnectedListMutationVariables = Exact<{
  connectedListId: Scalars['String']['input'];
}>;


export type DisconnectConnectedListMutation = { __typename?: 'Mutation', disconnectConnectedList: { __typename?: 'DisconnectConnectedListMutationPayload', failReasons: Array<string> } | null };

export type DisconnectListMutationVariables = Exact<{
  listUuid: Scalars['String']['input'];
}>;


export type DisconnectListMutation = { __typename?: 'Mutation', disconnectList: { __typename?: 'DisconnectListMutationPayload', failReasons: Array<string> } | null };

export type EmailMarketingConfigurationFragment = { __typename?: 'EmailMarketingConfiguration', id: string, fonts: Array<{ __typename?: 'Font', name: string, url: string, family: string }> };

export type EnableMarketingExclusionQueryVariables = Exact<{ [key: string]: never; }>;


export type EnableMarketingExclusionQuery = { __typename?: 'Query', marketingListConfiguration: { __typename?: 'MarketingListConfiguration', id: string, enableMarketingExclusion: boolean } | null };

export type GetCurrentUserCampaignManagerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserCampaignManagerQuery = { __typename?: 'Query', campaignManager: { __typename?: 'CampaignManager', id: string, name: string } | null };

export type GetListInfoQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type GetListInfoQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, name: string, contactsCount: number, updatedAt: string, category: ListCategory | null, discardedAt: string | null } | null };

export type GetListsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListFiltering>;
  orderBy?: InputMaybe<ListsOrderBy>;
}>;


export type GetListsQuery = { __typename?: 'Query', lists: { __typename?: 'ListEntries', entries: Array<{ __typename?: 'List', id: string, name: string, updatedAt: string, category: ListCategory | null, discardedAt: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, profileImageUrl: string | null, email: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ListInfoFragment = { __typename?: 'List', id: string, name: string, contactsCount: number, updatedAt: string, category: ListCategory | null, discardedAt: string | null };

export type ListRowFragment = { __typename?: 'List', id: string, name: string, updatedAt: string, category: ListCategory | null, discardedAt: string | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, profileImageUrl: string | null, email: string } | null };

export type MarketingListConfigurationFragment = { __typename?: 'MarketingListConfiguration', id: string, allowUnsubscribed: boolean, consentLegitimateInterestText: string, consentConsentGivenText: string, consentUserUnsubscribedText: string, enableMarketingExclusion: boolean };

export type MarketingListExcludedContactsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  withMissingFields?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ListMembersOrderBy>;
  filter?: InputMaybe<ListMembersFilter>;
}>;


export type MarketingListExcludedContactsQuery = { __typename?: 'Query', listMembers: { __typename?: 'ListMembers', entries: Array<{ __typename?: 'ListMember', contact: { __typename?: 'Contact', inMyContacts: boolean | null, primaryEmail: any | null, id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } }> } };

export type MarketingListInfoQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type MarketingListInfoQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, name: string, contactsCount: number, updatedAt: string, category: ListCategory | null, discardedAt: string | null } | null, marketingListCounts: { __typename?: 'MarketingListCounts', excludedContactsCount: number, excludedCompaniesCount: number, totalExcludedContactsCount: number }, marketingListConfiguration: { __typename?: 'MarketingListConfiguration', id: string, enableMarketingExclusion: boolean } | null };

export type MarketingListMemberRowContactFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type MarketingListMemberRowFragment = { __typename?: 'ListMember', id: string, missingRequiredFields: Array<string>, createdAt: string, subscriptionErrorMessage: string | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null };

export type MarketingListMembersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  withMissingFields?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ListMembersOrderBy>;
  filter?: InputMaybe<ListMembersFilter>;
}>;


export type MarketingListMembersQuery = { __typename?: 'Query', listMembers: { __typename?: 'ListMembers', entries: Array<{ __typename?: 'ListMember', id: string, missingRequiredFields: Array<string>, createdAt: string, subscriptionErrorMessage: string | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, isPersonal: boolean, changedJob: boolean, isArchived: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, phoneNumbers: Array<string>, tags: Array<string>, location: { __typename?: 'Location', state: string | null, city: string | null, country: { __typename?: 'Country', name: string } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null }, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, marketingListConsent: { __typename?: 'ContactConsent', status: ContactConsentStatus }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, employee: { __typename?: 'Employee', email: string, id: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, imageUrl: string | null } } | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type OutOfSyncMemberCountQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type OutOfSyncMemberCountQuery = { __typename?: 'Query', listMembers: { __typename?: 'ListMembers', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type SharedMarketingListInfoQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type SharedMarketingListInfoQuery = { __typename?: 'Query', marketingListCounts: { __typename?: 'MarketingListCounts', excludedContactsCount: number, excludedCompaniesCount: number, totalExcludedContactsCount: number }, marketingListConfiguration: { __typename?: 'MarketingListConfiguration', id: string, enableMarketingExclusion: boolean } | null };

export type SharedMarketingListNameQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type SharedMarketingListNameQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, name: string } | null };

export type SyncListMembersMutationVariables = Exact<{
  listUuid: Scalars['String']['input'];
}>;


export type SyncListMembersMutation = { __typename?: 'Mutation', syncListMembers: { __typename?: 'SyncListMembersMutationPayload', failReasons: Array<string> } | null };

export type EmployeeMeetingCompanyPreviewFragment = { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', id: string, country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } };

export type EmployeeMeetingContactPreviewFragment = { __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type EmployeeMeetingListItemFragment = { __typename?: 'EmployeeMeeting', sourceEventReference: string, id: string, isCancelled: boolean, endTime: string, startTime: string, companies: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', id: string, country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } }>, contacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null } | null };

export type EmployeeMeetingsQueryVariables = Exact<{
  startTimeAfter: Scalars['ISO8601DateTime']['input'];
  startTimeBefore: Scalars['ISO8601DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmployeeMeetingsQuery = { __typename?: 'Query', employeeMeetings: { __typename?: 'MeetingList', entries: Array<{ __typename?: 'EmployeeMeeting', sourceEventReference: string, id: string, isCancelled: boolean, endTime: string, startTime: string, companies: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string, primaryLocation: { __typename?: 'CompanyOfficeLocation', location: { __typename?: 'Location', id: string, country: { __typename?: 'Country', name: string } | null } } | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } }>, contacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null } | null }> } };

export type InteractionPreviewQueryVariables = Exact<{
  sourceReferenceId: Scalars['String']['input'];
}>;


export type InteractionPreviewQuery = { __typename?: 'Query', keyActivity: { __typename?: 'KeyActivity', interaction: { __typename?: 'PartitionedInteraction', id: string, interactionType: PartitionedInteractionType, direction: PartitionedInteractionDirection, occuredAt: string | null, occuredEndAt: string | null, webLink: string | null, sender: { __typename?: 'Contact', id: string, primaryEmail: any | null, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } } | null, receivers: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isEmployee: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }>, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null } | null } | null } | null };

export type KeyActivityPreviewQueryVariables = Exact<{
  sourceReferenceId: Scalars['String']['input'];
}>;


export type KeyActivityPreviewQuery = { __typename?: 'Query', keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null } | null };

export type MeetingSlideQueryVariables = Exact<{
  meetingUid: Scalars['ID']['input'];
}>;


export type MeetingSlideQuery = { __typename?: 'Query', employeeMeeting: { __typename?: 'EmployeeMeeting', id: string, endTime: string, startTime: string, sourceEventReference: string, companies: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }>, contacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } | null };

export type MeetingSlideCompanyPreviewFragment = { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } };

export type MeetingSlideFragment = { __typename?: 'EmployeeMeeting', id: string, endTime: string, startTime: string, sourceEventReference: string, companies: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }>, contacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> };

export type MyRecentMeetingsQueryVariables = Exact<{
  startTimeAfter: Scalars['ISO8601DateTime']['input'];
  startTimeBefore: Scalars['ISO8601DateTime']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyRecentMeetingsQuery = { __typename?: 'Query', myRecentMeetings: { __typename?: 'MeetingList', entries: Array<{ __typename?: 'EmployeeMeeting', id: string, sourceEventReference: string, occuredAt: string, companies: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } }>, contacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }>, keyActivity: { __typename?: 'KeyActivity', id: string, sourceReferenceId: string, category: KeyActivityCategory } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type RecentMeetingListItemFragment = { __typename?: 'EmployeeMeeting', id: string, sourceEventReference: string, occuredAt: string, companies: Array<{ __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }>, interactionsTotal: { __typename?: 'Totals', id: string, interactions: number }, interactionsLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } }>, contacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } }>, keyActivity: { __typename?: 'KeyActivity', id: string, sourceReferenceId: string, category: KeyActivityCategory } | null };

export type MyContactsListMembersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  uid: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  withMissingFields?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ListMembersOrderBy>;
  filter?: InputMaybe<ListMembersFilter>;
}>;


export type MyContactsListMembersQuery = { __typename?: 'Query', listMembers: { __typename?: 'ListMembers', entries: Array<{ __typename?: 'ListMember', id: string, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, jobTitle: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null, location: { __typename?: 'Location', id: string, city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, myContact: { __typename?: 'MyContact', id: string, classified: boolean, interactionMaximum: { __typename?: 'InteractionMaximum', id: string, lastAt: string | null } | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type MyContactsViewQueryVariables = Exact<{
  filter?: InputMaybe<MyContactsFiltering>;
  orderBy?: InputMaybe<MyContactsOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyContactsViewQuery = { __typename?: 'Query', myContacts: { __typename?: 'MyContactList', entries: Array<{ __typename?: 'MyContact', id: string, classified: boolean, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, jobTitle: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null, location: { __typename?: 'Location', id: string, city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, interactionMaximum: { __typename?: 'InteractionMaximum', id: string, lastAt: string | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ContactRequestContactRowFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, jobTitle: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null, location: { __typename?: 'Location', id: string, city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type MyCalendarQueryVariables = Exact<{
  filter: CalendarFieldFilter;
  order?: InputMaybe<CalendarFieldOrderBy>;
}>;


export type MyCalendarQuery = { __typename?: 'Query', myCalendar: { __typename?: 'Calendar', entries: Array<{ __typename?: 'CalendarEntry', title: string, endTime: string, startTime: string, isAllDay: boolean, id: string, calendarAttachable: { __typename?: 'EmployeeMeeting', id: string } | { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory } | { __typename?: 'Task', id: string } }> } | null };

export type MyCalendarItemFragment = { __typename?: 'CalendarEntry', title: string, endTime: string, startTime: string, isAllDay: boolean, id: string, calendarAttachable: { __typename?: 'EmployeeMeeting', id: string } | { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory } | { __typename?: 'Task', id: string } };

export type BulkRemoveMyContactMutationVariables = Exact<{
  myContactUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkRemoveMyContactMutation = { __typename?: 'Mutation', bulkRemoveMyContact: { __typename?: 'MyBulkRemoveContactMutationPayload', failReasons: Array<string> } | null };

export type ContactCustomFieldOnlyProfileFragment = { __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', id: string | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null } };

export type ContactUnderReviewQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type ContactUnderReviewQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', id: string | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> | null } } | null, myContact: { __typename?: 'MyContact', id: string, classified: boolean } | null };

export type CompleteMyTaskMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type CompleteMyTaskMutation = { __typename?: 'Mutation', completeMyTask: { __typename?: 'CompleteMyTaskMutationPayload', failReasons: Array<string> } | null };

export type MyTaskQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type MyTaskQuery = { __typename?: 'Query', myTask: { __typename?: 'MyTask', completedAt: string | null, createdAt: string, dueOn: string | null, id: string, title: string, assignees: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, requestor: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, source: { __typename?: 'MyTaskSource', id: string, isKeyContact: boolean, title: any, subTitle: any, imgUrl: string | null, url: string | null } } | null };

export type MyTaskListRowFragment = { __typename?: 'MyTask', completedAt: string | null, createdAt: string, dueOn: string | null, id: string, title: string, assignees: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, requestor: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, source: { __typename?: 'MyTaskSource', id: string, isKeyContact: boolean, title: any, subTitle: any, imgUrl: string | null, url: string | null } };

export type ReopenMyTaskMutationVariables = Exact<{
  taskUid: Scalars['ID']['input'];
}>;


export type ReopenMyTaskMutation = { __typename?: 'Mutation', reopenMyTask: { __typename?: 'ReopenMyTaskMutationPayload', failReasons: Array<string> } | null };

export type UpdateMyTaskMutationVariables = Exact<{
  taskUid: Scalars['ID']['input'];
  assigneeUid?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueOn?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMyTaskMutation = { __typename?: 'Mutation', updateMyTask: { __typename?: 'UpdateMyTaskMutationPayload', failReasons: Array<string>, task: { __typename?: 'MyTask', completedAt: string | null, createdAt: string, dueOn: string | null, id: string, title: string, assignees: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, requestor: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, source: { __typename?: 'MyTaskSource', id: string, isKeyContact: boolean, title: any, subTitle: any, imgUrl: string | null, url: string | null } } | null } | null };

export type CreateMyTaskByDateMutationVariables = Exact<{
  assignedToUid?: InputMaybe<Scalars['ID']['input']>;
  requestedByUid?: InputMaybe<Scalars['ID']['input']>;
  attributes: CreateTaskAttributes;
}>;


export type CreateMyTaskByDateMutation = { __typename?: 'Mutation', createTask: { __typename?: 'CreateTaskMutationPayload', failReasons: Array<string> } | null };

export type MyCompletedTasksQueryVariables = Exact<{
  primaryFilter?: InputMaybe<TaskPrimaryFilterInput>;
}>;


export type MyCompletedTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, completedAt: string | null, dueOn: string | null, priority: PriorityEnum | null, position: number | null, title: string, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type MyOpenTasksByDateQueryVariables = Exact<{
  primaryFilter?: InputMaybe<TaskPrimaryFilterInput>;
  todayStartTime: Scalars['ISO8601DateTime']['input'];
}>;


export type MyOpenTasksByDateQuery = { __typename?: 'Query', tasksOverdue: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, completedAt: string | null, dueOn: string | null, priority: PriorityEnum | null, position: number | null, title: string, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } }, tasksToday: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, completedAt: string | null, dueOn: string | null, priority: PriorityEnum | null, position: number | null, title: string, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } }, tasksUpcoming: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, completedAt: string | null, dueOn: string | null, priority: PriorityEnum | null, position: number | null, title: string, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type MyTaskListRowByDateFragment = { __typename?: 'Task', id: string, completedAt: string | null, dueOn: string | null, priority: PriorityEnum | null, position: number | null, title: string, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null };

export type CreateContactListMutationVariables = Exact<{
  name: Scalars['String']['input'];
  usageMode?: InputMaybe<UsageModeInput>;
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateContactListMutation = { __typename?: 'Mutation', createList: { __typename?: 'CreateContactListMutationPayload', id: string | null, failReasons: Array<string> } | null };

export type CreateMyListCompanyListMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateMyListCompanyListMutation = { __typename?: 'Mutation', createCompanyList: { __typename?: 'CreateCompanyListMutationPayload', id: string | null, failReasons: Array<string> } | null };

export type CreateMyListGenericListMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateMyListGenericListMutation = { __typename?: 'Mutation', createGenericList: { __typename?: 'CreateGenericListMutationPayload', failReasons: Array<string>, record: { __typename?: 'GenericList', id: string, title: string } | null } | null };

export type CreatorFragment = { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, email: string, profileImageUrl: string | null };

export type MyListCompanyListQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type MyListCompanyListQuery = { __typename?: 'Query', companyList: { __typename?: 'CompanyListItem', id: string, name: string } | null };

export type MyListGenericListQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type MyListGenericListQuery = { __typename?: 'Query', genericList: { __typename?: 'GenericList', id: string, title: string } | null };

export type MyListsQueryVariables = Exact<{
  scope?: InputMaybe<MyListScope>;
  listType?: InputMaybe<MyListList>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyListsQuery = { __typename?: 'Query', myLists: { __typename?: 'MyListEntries', entries: Array<{ __typename?: 'MyList', id: string, lastViewedAt: string | null, createdAt: string, listType: MyListList, name: string, permission: MyListPermission, owner: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, email: string, profileImageUrl: string | null } | null, locationInfo: { __typename?: 'MyListLocationInfo', displayName: string, tabUid: string | null, tabOwnedByUid: string | null, location: MyListLocation } }> } };

export type MyListsRowFragment = { __typename?: 'MyList', id: string, lastViewedAt: string | null, createdAt: string, listType: MyListList, name: string, permission: MyListPermission, owner: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, email: string, profileImageUrl: string | null } | null, locationInfo: { __typename?: 'MyListLocationInfo', displayName: string, tabUid: string | null, tabOwnedByUid: string | null, location: MyListLocation } };

export type ArchiveGenericListMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ArchiveGenericListMutation = { __typename?: 'Mutation', archiveGenericList: { __typename?: 'ArchiveGenericListMutationPayload', failReasons: Array<string> } | null };

export type RenameCompanyListMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameCompanyListMutation = { __typename?: 'Mutation', updateCompanyList: { __typename?: 'UpdateCompanyListMutationPayload', failReasons: Array<string> } | null };

export type RenameContactListMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameContactListMutation = { __typename?: 'Mutation', updateList: { __typename?: 'UpdateListMutationPayload', failReasons: Array<string> } | null };

export type RenameGenericListMutationVariables = Exact<{
  genericListUid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameGenericListMutation = { __typename?: 'Mutation', updateGenericList: { __typename?: 'UpdateGenericListMutationPayload', failReasons: Array<string> } | null };

export type RemoveUserAccessMutationVariables = Exact<{
  userUid: Scalars['String']['input'];
  listUid: Scalars['String']['input'];
  listType: MyListList;
}>;


export type RemoveUserAccessMutation = { __typename?: 'Mutation', removeMyListShareAccess: { __typename?: 'RemoveMyListShareAccessMutationPayload', failReasons: Array<string> } | null };

export type ShareAccessUsersQueryVariables = Exact<{
  listUid: Scalars['ID']['input'];
  listType: MyListList;
}>;


export type ShareAccessUsersQuery = { __typename?: 'Query', sharedMyListUsers: { __typename?: 'SharedMyListUsers', entries: Array<{ __typename?: 'SharedMyListUser', permission: MyListPermission, user: { __typename?: 'UserInfo', id: string, email: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null, role: RoleCode } }> } | null };

export type ShareAccessUsersRowFragment = { __typename?: 'SharedMyListUser', permission: MyListPermission, user: { __typename?: 'UserInfo', id: string, email: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null, role: RoleCode } };

export type ShareListCompanyMutationVariables = Exact<{
  companyListUid: Scalars['ID']['input'];
  permission: MyListPermission;
  sharedWithUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ShareListCompanyMutation = { __typename?: 'Mutation', shareCompanyList: { __typename?: 'ShareCompanyListMutationPayload', failReasons: Array<string> } | null };

export type ShareListContactMutationVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
  permission: MyListPermission;
  sharedWithUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ShareListContactMutation = { __typename?: 'Mutation', shareContactList: { __typename?: 'ShareContactListMutationPayload', failReasons: Array<string> } | null };

export type ShareListGenericMutationVariables = Exact<{
  genericListUid: Scalars['ID']['input'];
  permission: MyListPermission;
  sharedWithUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ShareListGenericMutation = { __typename?: 'Mutation', shareGenericList: { __typename?: 'ShareGenericListMutationPayload', failReasons: Array<string> } | null };

export type AdminMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMenuQuery = { __typename?: 'Query', config: { __typename?: 'TenantConfig', id: string, adminReportingEnabled: boolean }, interactionsConfig: { __typename?: 'InteractionsConfiguration', id: string, keyActivityTitlesRecommendedGroup: TitlesRecommendedGroupEnum } | null, tenantConfiguration: { __typename?: 'TenantConfiguration', id: string, showInternalIndustries: boolean } | null, marketingListConfiguration: { __typename?: 'MarketingListConfiguration', id: string, enableEms: boolean } | null };

export type NavUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type NavUserInfoQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null, email: string } | null };

export type SideNavQueryVariables = Exact<{
  currentUserEmployeeId: Scalars['ID']['input'];
}>;


export type SideNavQuery = { __typename?: 'Query', individualConsented: { __typename?: 'IndividualConsented', isRequired: boolean, url: string | null } | null, myTasks: { __typename?: 'MyTaskEntries', id: string, total: number }, tasks: { __typename?: 'TaskEntries', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } }, myStayInTouch: { __typename?: 'MyStayInTouchList', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } | null, upcomingMeetings: { __typename?: 'MeetingList', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } }, opportunityTrackingConfiguration: { __typename?: 'OpportunityTrackingConfiguration', id: string, visibleFirmWide: boolean } | null, microsoftAdminConsentDetail: { __typename?: 'MicrosoftAdminConsentDetail', consents: Array<{ __typename?: 'MicrosoftAdminConsent', name: string, consentUrl: string }> }, emailMarketingConfiguration: { __typename?: 'EmailMarketingConfiguration', id: string, enabled: boolean } | null, userRoleCorePermissions: { __typename?: 'CorePermission', id: string, allContacts: boolean, allCompanies: boolean } | null, userRoleObjectiveManagementPermissions: { __typename?: 'ObjectiveManagementPermission', id: string, allObjectives: boolean } | null, userRoleOpportunityTrackingPermissions: { __typename?: 'OpportunityTrackingPermission', id: string, allOpportunities: boolean } | null, userRoleEnrichmentPermissions: { __typename?: 'EnrichmentPermission', id: string, allProspects: boolean } | null, everAfterStatus: { __typename?: 'Status', id: string, enabled: boolean, hasPersona: boolean } };

export type ArchiveCompanyNoteMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type ArchiveCompanyNoteMutation = { __typename?: 'Mutation', archiveCompanyNote: { __typename?: 'ArchiveCompanyNoteMutationPayload', failReasons: Array<string> } | null };

export type CreateNoteMutationVariables = Exact<{
  companyUid: Scalars['ID']['input'];
  contactUid?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  access?: InputMaybe<CompanyNoteAccess>;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createCompanyNote: { __typename?: 'CreateCompanyNoteMutationPayload', failReasons: Array<string> } | null };

export type GetPersonNotesQueryVariables = Exact<{
  personUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPersonNotesQuery = { __typename?: 'Query', notes: { __typename?: 'CompanyNoteList', entries: Array<{ __typename?: 'CompanyNote', id: string, access: CompanyNoteAccess, createdAt: string, updatedAt: string, richContent: { __typename?: 'RichContent', html: string, trixHtml: string }, company: { __typename?: 'Company', id: string, logoUrl: string | null, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, creator: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, updater: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type UpdateCompanyNoteMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  access?: InputMaybe<CompanyNoteAccess>;
}>;


export type UpdateCompanyNoteMutation = { __typename?: 'Mutation', updateCompanyNote: { __typename?: 'UpdateCompanyNoteMutationPayload', failReasons: Array<string> } | null };

export type AllObjectivesQueryVariables = Exact<{
  groupBy?: InputMaybe<ObjectiveGroupBy>;
  status?: InputMaybe<ObjectiveStatus>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllObjectivesQuery = { __typename?: 'Query', allObjectives: Array<{ __typename?: 'GroupedObjective', group: string, objectives: Array<{ __typename?: 'Objective', id: string, title: string, targetDate: string, targetValue: number, currentProgress: { __typename?: 'Progress', id: string, value: number, status: ProgressStatus } }> }> };

export type CreateObjectiveMutationVariables = Exact<{
  attributes: ObjectiveAttribute;
}>;


export type CreateObjectiveMutation = { __typename?: 'Mutation', createObjective: { __typename?: 'CreateObjectiveMutationPayload', failReasons: Array<string>, objectiveUuid: string | null } | null };

export type MyObjectivesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ObjectiveStatus>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyObjectivesQuery = { __typename?: 'Query', myObjectives: { __typename?: 'ObjectiveList', entries: Array<{ __typename?: 'Objective', id: string, title: string, targetDate: string, targetValue: number, currentProgress: { __typename?: 'Progress', id: string, value: number, status: ProgressStatus } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ObjectiveQueryVariables = Exact<{
  objectiveUuid: Scalars['ID']['input'];
}>;


export type ObjectiveQuery = { __typename?: 'Query', objective: { __typename?: 'Objective', id: string, title: string, valueType: string, targetDate: string, targetValue: number, initialValue: number | null, appendValueType: boolean, archive: boolean, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, owners: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, currentProgress: { __typename?: 'Progress', id: string, value: number, status: ProgressStatus }, objectiveProgresses: Array<{ __typename?: 'Progress', id: string, checkinDate: string, measureValue: number, comment: { __typename?: 'RichContent', html: string, trixHtml: string } | null, createdBy: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } }>, projects: Array<{ __typename?: 'Project', id: string, title: string }> } | null };

export type ObjectiveDetailsFragment = { __typename?: 'Objective', id: string, title: string, valueType: string, targetDate: string, targetValue: number, initialValue: number | null, appendValueType: boolean, archive: boolean, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, owners: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, currentProgress: { __typename?: 'Progress', id: string, value: number, status: ProgressStatus }, objectiveProgresses: Array<{ __typename?: 'Progress', id: string, checkinDate: string, measureValue: number, comment: { __typename?: 'RichContent', html: string, trixHtml: string } | null, createdBy: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } }>, projects: Array<{ __typename?: 'Project', id: string, title: string }> };

export type ObjectiveListItemFragment = { __typename?: 'Objective', id: string, title: string, targetDate: string, targetValue: number, currentProgress: { __typename?: 'Progress', id: string, value: number, status: ProgressStatus } };

export type ObjectiveProgressDetailsFragment = { __typename?: 'Progress', id: string, checkinDate: string, measureValue: number, comment: { __typename?: 'RichContent', html: string, trixHtml: string } | null, createdBy: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } };

export type ObjectiveProjectOverviewFragment = { __typename?: 'Project', id: string, title: string };

export type UpdateObjectiveMutationVariables = Exact<{
  objectiveUuid: Scalars['ID']['input'];
  attributes: ObjectiveAttribute;
}>;


export type UpdateObjectiveMutation = { __typename?: 'Mutation', updateObjective: { __typename?: 'UpdateObjectiveMutationPayload', failReasons: Array<string> } | null };

export type CreateObjectiveProgressMutationVariables = Exact<{
  objectiveUuid: Scalars['ID']['input'];
  progressAttributes: ProgressAttribute;
}>;


export type CreateObjectiveProgressMutation = { __typename?: 'Mutation', createObjectiveProgress: { __typename?: 'CreateProgressMutationPayload', failReasons: Array<string> } | null };

export type RemoveObjectiveProgressMutationVariables = Exact<{
  progressUuid: Scalars['ID']['input'];
}>;


export type RemoveObjectiveProgressMutation = { __typename?: 'Mutation', removeObjectiveProgress: { __typename?: 'RemoveProgressMutationPayload', failReasons: Array<string> } | null };

export type UpdateObjectiveProgressMutationVariables = Exact<{
  progressUuid: Scalars['ID']['input'];
  progressAttributes: ProgressAttribute;
}>;


export type UpdateObjectiveProgressMutation = { __typename?: 'Mutation', updateObjectiveProgress: { __typename?: 'UpdateProgressMutationPayload', failReasons: Array<string> } | null };

export type OnExportUpdateSubscriptionVariables = Exact<{
  exportId: Scalars['ID']['input'];
}>;


export type OnExportUpdateSubscription = { __typename?: 'Subscription', exportUpdated: { __typename?: 'Export', id: string, displayName: string, status: ExportStatus, percentageComplete: number | null, createdAt: string, file: { __typename?: 'File', name: string, url: string } | null } };

export type CompanyCustomFieldPreviewFragment = { __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } };

export type CompanyGoalPreviewFragment = { __typename?: 'Opportunity', title: string | null, date: string | null, id: string, trackingNumber: string, createdAt: string, tags: Array<string>, emailBody: { __typename?: 'RichContent', html: string } | null, createdBy: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null } }, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string } | null, documents: Array<{ __typename?: 'DocumentFile', documentId: string, filename: string | null, url: string, contentType: string | null } | { __typename?: 'DocumentUrl', link: string }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> };

export type CompanyGoalsCustomStatusDistributionQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  internalContactEmail?: InputMaybe<Scalars['String']['input']>;
  employeeEmail?: InputMaybe<Scalars['ID']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  projectUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CompanyGoalsCustomStatusDistributionQuery = { __typename?: 'Query', companyGoals: { __typename?: 'CompanyGoalList', customStatusDistribution: Array<{ __typename?: 'CustomStatusDistribution', count: number, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean }, totalProposedFeeAmount: { __typename?: 'Money', format: string } }>, totalProposedFeeAmount: { __typename?: 'Money', format: string } } };

export type ContactCustomFieldPreviewFragment = { __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } };

export type CountryPreviewFragment = { __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode };

export type CustomFieldFragment = { __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null };

type CustomFieldValue_CustomFieldCompany_Fragment = { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null };

type CustomFieldValue_CustomFieldContact_Fragment = { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null };

type CustomFieldValue_CustomFieldDate_Fragment = { __typename: 'CustomFieldDate', dateValue: string | null };

type CustomFieldValue_CustomFieldEmployee_Fragment = { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null };

type CustomFieldValue_CustomFieldFullDateTime_Fragment = { __typename: 'CustomFieldFullDateTime', dateTime: string | null };

type CustomFieldValue_CustomFieldMoney_Fragment = { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null };

type CustomFieldValue_CustomFieldMulti_Fragment = { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null };

type CustomFieldValue_CustomFieldMultiCountry_Fragment = { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null };

type CustomFieldValue_CustomFieldMultiEmployee_Fragment = { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null };

type CustomFieldValue_CustomFieldNumber_Fragment = { __typename: 'CustomFieldNumber', numberValue: string | null };

type CustomFieldValue_CustomFieldOptional_Fragment = { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null };

type CustomFieldValue_CustomFieldRichText_Fragment = { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } };

type CustomFieldValue_CustomFieldString_Fragment = { __typename: 'CustomFieldString', stringValue: string | null };

type CustomFieldValue_CustomFieldTimeRange_Fragment = { __typename: 'CustomFieldTimeRange' };

export type CustomFieldValueFragment = CustomFieldValue_CustomFieldCompany_Fragment | CustomFieldValue_CustomFieldContact_Fragment | CustomFieldValue_CustomFieldDate_Fragment | CustomFieldValue_CustomFieldEmployee_Fragment | CustomFieldValue_CustomFieldFullDateTime_Fragment | CustomFieldValue_CustomFieldMoney_Fragment | CustomFieldValue_CustomFieldMulti_Fragment | CustomFieldValue_CustomFieldMultiCountry_Fragment | CustomFieldValue_CustomFieldMultiEmployee_Fragment | CustomFieldValue_CustomFieldNumber_Fragment | CustomFieldValue_CustomFieldOptional_Fragment | CustomFieldValue_CustomFieldRichText_Fragment | CustomFieldValue_CustomFieldString_Fragment | CustomFieldValue_CustomFieldTimeRange_Fragment;

export type EmployeeCustomFieldPreviewFragment = { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } };

export type GetCompanyGoalQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type GetCompanyGoalQuery = { __typename?: 'Query', companyGoal: { __typename?: 'Opportunity', title: string | null, date: string | null, id: string, trackingNumber: string, createdAt: string, tags: Array<string>, emailBody: { __typename?: 'RichContent', html: string } | null, createdBy: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null } }, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string } | null, documents: Array<{ __typename?: 'DocumentFile', documentId: string, filename: string | null, url: string, contentType: string | null } | { __typename?: 'DocumentUrl', link: string }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null };

export type GoalReferralSourceAvatarFragment = { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null };

export type LinkProjectsToOpportunityMutationVariables = Exact<{
  projectUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  opportunityUuid: Scalars['ID']['input'];
}>;


export type LinkProjectsToOpportunityMutation = { __typename?: 'Mutation', linkProjectsToOpportunity: { __typename?: 'LinkProjectsToOpportunityMutationPayload', failReasons: Array<string> } | null };

export type MoneyPreviewFragment = { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } };

export type MoveOpportunitiesOnMyCustomBoardMutationVariables = Exact<{
  opportunities: Array<MoveOpportunityInputCustom> | MoveOpportunityInputCustom;
}>;


export type MoveOpportunitiesOnMyCustomBoardMutation = { __typename?: 'Mutation', moveOpportunitiesOnMyCustomBoard: { __typename?: 'OpportunityTrackingMoveOpportunitiesOnMyCustomBoardMutationPayload', failReasons: Array<string> } | null };

export type OpportunityAuditFragment = { __typename?: 'OpportunityAudit', auditedEntity: AuditEntity, action: AuditAction, performedAt: string, performedBy: string | null, category: OpportunityAuditCategory, description: string, changes: Array<{ __typename?: 'AuditChange', name: string, newValue: string, oldValue: string }> };

export type OpportunityAuditTrailQueryVariables = Exact<{
  opportunityUid: Scalars['ID']['input'];
}>;


export type OpportunityAuditTrailQuery = { __typename?: 'Query', opportunityAuditTrail: { __typename?: 'OpportunityAuditTrail', entries: Array<{ __typename?: 'OpportunityAudit', auditedEntity: AuditEntity, action: AuditAction, performedAt: string, performedBy: string | null, category: OpportunityAuditCategory, description: string, changes: Array<{ __typename?: 'AuditChange', name: string, newValue: string, oldValue: string }> }> } | null };

export type OpportunityProjectsQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OpportunityProjectsQuery = { __typename?: 'Query', opportunityProjects: { __typename?: 'OpportunityProjectEntries', entries: Array<{ __typename?: 'Project', id: string, title: string, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null }> } | null };

export type OpportunityProjectsForUidQueryVariables = Exact<{
  opportunityUid: Scalars['ID']['input'];
}>;


export type OpportunityProjectsForUidQuery = { __typename?: 'Query', opportunityProjectsForUid: { __typename?: 'OpportunityProjectEntries', entries: Array<{ __typename?: 'Project', id: string, title: string, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null }> } | null };

export type OpportunityTrackingCustomStatusFragment = { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean };

export type OpportunityTrackingCustomStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type OpportunityTrackingCustomStatusesQuery = { __typename?: 'Query', opportunityTrackingConfiguration: { __typename?: 'OpportunityTrackingConfiguration', id: string, customStatuses: Array<{ __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean }> } | null };

export type UpdateOpportunityMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: CompanyGoalAttributes;
}>;


export type UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityTrackingUpdateOpportunityMutationPayload', failReasons: Array<string>, record: { __typename?: 'CompanyGoal', id: string, date: string | null, tags: Array<string>, trackingNumber: string, title: string | null, receivedReferral: boolean, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', typeName: string, id: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', typeName: string, id: string }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustries: Array<{ __typename?: 'InternalIndustry', id: string | null, name: string }> | null }, last: { __typename?: 'LastAts', id: string, meetingAt: string | null, sentEmailAt: string | null, receivedEmailAt: string | null, interactionAt: string | null, lastInteraction: string | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, internalContact: { __typename?: 'Employee', id: string, email: string, department: { __typename?: 'Department', id: string, name: string } | null, office: { __typename?: 'Office', id: string, name: string } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, referralSource: { __typename?: 'Contact', id: string, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, primaryEmail: any | null, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null }, basicOppRecord: { __typename?: 'CompanyGoal', id: string, date: string | null, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, assignedTo: { __typename?: 'Employee', id: string, email: string, office: { __typename?: 'Office', id: string, name: string } | null, department: { __typename?: 'Department', id: string, name: string } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', id: string, city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactLast: { __typename?: 'LastAts', id: string, sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> }, gridRecord: { __typename?: 'OpportunityGrid', id: string, date: string, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null } | null, company: { __typename?: 'CompanyGrid', domain: string | null, id: string, typeName: string, typeNames: Array<string>, logoUrl: string | null, name: string, industryNames: Array<string>, internalIndustryNames: Array<string>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }, assignedTo: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null, keyContacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }>, referralSource: { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null, company: { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string } } | null, othersIncluded: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }>, commsLast: { __typename?: 'LastAts', sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> } } | null };

export type BasicOpportunitiesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CompanyGoalFiltering>;
}>;


export type BasicOpportunitiesQuery = { __typename?: 'Query', companyGoals: { __typename?: 'CompanyGoalList', entries: Array<{ __typename?: 'CompanyGoal', id: string, date: string | null, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, assignedTo: { __typename?: 'Employee', id: string, email: string, office: { __typename?: 'Office', id: string, name: string } | null, department: { __typename?: 'Department', id: string, name: string } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', id: string, city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactLast: { __typename?: 'LastAts', id: string, sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type BasicOpportunityFragment = { __typename?: 'CompanyGoal', id: string, date: string | null, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, internalIndustryNames: Array<string> | null }, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, assignedTo: { __typename?: 'Employee', id: string, email: string, office: { __typename?: 'Office', id: string, name: string } | null, department: { __typename?: 'Department', id: string, name: string } | null, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', id: string, city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, contactLast: { __typename?: 'LastAts', id: string, sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> };

export type AddOpportunityNoteMutationVariables = Exact<{
  opportunityId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type AddOpportunityNoteMutation = { __typename?: 'Mutation', addOpportunityNote: { __typename?: 'OpportunityTrackingAddOpportunityNoteMutationPayload', failReasons: Array<string> } | null };

export type OpportunityNotePreviewFragment = { __typename?: 'OpportunityNote', id: string, createdAt: string, content: { __typename?: 'RichContent', html: string, trixHtml: string }, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null } };

export type OpportunityNotesQueryVariables = Exact<{
  opportunityId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OpportunityNotesQuery = { __typename?: 'Query', opportunityNotes: { __typename?: 'OpportunityNoteEntries', entries: Array<{ __typename?: 'OpportunityNote', id: string, createdAt: string, content: { __typename?: 'RichContent', html: string, trixHtml: string }, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } | null } | null };

export type ArchiveOpportunityNoteMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
}>;


export type ArchiveOpportunityNoteMutation = { __typename?: 'Mutation', archiveOpportunityNote: { __typename?: 'OpportunityTrackingArchiveOpportunityNoteMutationPayload', failReasons: Array<string> } | null };

export type UpdateOpportunityNoteMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type UpdateOpportunityNoteMutation = { __typename?: 'Mutation', updateOpportunityNote: { __typename?: 'OpportunityTrackingUpdateOpportunityNoteMutationPayload', failReasons: Array<string>, note: { __typename?: 'OpportunityNote', id: string, createdAt: string, content: { __typename?: 'RichContent', html: string, trixHtml: string }, creator: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null } } | null } | null };

export type OpportunitiesForGridQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  internalContactEmail?: InputMaybe<Scalars['String']['input']>;
  employeeEmail?: InputMaybe<Scalars['ID']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  customStatusId?: InputMaybe<Scalars['ID']['input']>;
  projectUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OpportunitiesForGridQuery = { __typename?: 'Query', opportunitiesForGrid: { __typename?: 'OpportunityGridTypeList', entries: Array<{ __typename?: 'OpportunityGrid', id: string, date: string, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null } | null, company: { __typename?: 'CompanyGrid', domain: string | null, id: string, typeName: string, typeNames: Array<string>, logoUrl: string | null, name: string, industryNames: Array<string>, internalIndustryNames: Array<string>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }, assignedTo: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null, keyContacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }>, referralSource: { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null, company: { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string } } | null, othersIncluded: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }>, commsLast: { __typename?: 'LastAts', sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> }> } };

export type OpportunitiesForGridTotalQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  internalContactEmail?: InputMaybe<Scalars['String']['input']>;
  employeeEmail?: InputMaybe<Scalars['ID']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  customStatusId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OpportunitiesForGridTotalQuery = { __typename?: 'Query', opportunitiesForGrid: { __typename?: 'OpportunityGridTypeList', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } }, opportunityTrackingConfiguration: { __typename?: 'OpportunityTrackingConfiguration', id: string, customStatuses: Array<{ __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean }> } | null };

export type OpportunityGridFragment = { __typename?: 'OpportunityGrid', id: string, date: string, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null } | null, company: { __typename?: 'CompanyGrid', domain: string | null, id: string, typeName: string, typeNames: Array<string>, logoUrl: string | null, name: string, industryNames: Array<string>, internalIndustryNames: Array<string>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }, assignedTo: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null, keyContacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }>, referralSource: { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null, company: { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string } } | null, othersIncluded: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }>, commsLast: { __typename?: 'LastAts', sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> };

export type UserGridFragment = { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null };

export type ProgressTrackerUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ProgressTrackerUpdatedSubscription = { __typename?: 'Subscription', progressTrackersUpdated: { __typename?: 'ProgressTrackersUpdatedPayload', entries: Array<{ __typename?: 'ProgressTracker', id: string, title: string, description: string | null, status: ProgressTrackerStatus, percentageComplete: number | null, expectedCount: number | null, returnPath: string | null, createdAt: string }> } };

export type AddProjectDocumentMutationVariables = Exact<{
  projectUid: Scalars['String']['input'];
  attributes: ProjectDocumentAttributes;
}>;


export type AddProjectDocumentMutation = { __typename?: 'Mutation', addProjectDocument: { __typename?: 'AddProjectDocumentMutationPayload', failReasons: Array<string> } | null };

export type AddProjectMembersMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  memberEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddProjectMembersMutation = { __typename?: 'Mutation', addProjectMembers: { __typename?: 'AddProjectMembersMutationPayload', failReasons: Array<string> } | null };

export type CreateProjectMutationVariables = Exact<{
  attributes: ProjectAttribute;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'CreateProjectMutationPayload', failReasons: Array<string>, record: { __typename?: 'Project', id: string } | null } | null };

export type CreateProjectFromTemplateMutationVariables = Exact<{
  templateProjectId: Scalars['ID']['input'];
}>;


export type CreateProjectFromTemplateMutation = { __typename?: 'Mutation', createProjectFromTemplate: { __typename?: 'CreateProjectFromTemplateMutationPayload', failReasons: Array<string>, record: { __typename?: 'Project', id: string, nexlApps: boolean } | null } | null };

export type GetProjectOptionsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProjectOptionsQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectList', entries: Array<{ __typename?: 'Project', id: string, title: string, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type MoveProjectMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MoveProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'UpdateProjectMutationPayload', failReasons: Array<string> } | null };

export type ProjectQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ProjectQuery = { __typename?: 'Query', project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string, nexlApps: boolean, firmWide: boolean, readOnly: boolean, description: { __typename?: 'RichContent', trixHtml: string, plainText: string, html: string } | null, objectives: Array<{ __typename?: 'Objective', id: string, title: string, targetDate: string, targetValue: number, currentProgress: { __typename?: 'Progress', id: string, value: number, status: ProgressStatus } }>, folder: { __typename?: 'Folder', id: string, name: string, projectsCount: number, subFoldersCount: number, parent: { __typename?: 'Folder', id: string, name: string, projectsCount: number } | null }, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null } | null };

export type ProjectDocumentOverviewFragment = { __typename?: 'ProjectDocument', id: string, name: string | null, url: string | null, file: { __typename?: 'File', url: string, contentType: string | null } | null };

export type ProjectDocumentsQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type ProjectDocumentsQuery = { __typename?: 'Query', project: { __typename?: 'Project', documents: Array<{ __typename?: 'ProjectDocument', id: string, name: string | null, url: string | null, file: { __typename?: 'File', url: string, contentType: string | null } | null }> } | null };

export type ProjectListRowFragment = { __typename?: 'Project', id: string, title: string, iconCode: string | null, colorCode: string | null, createdAt: string, updatedAt: string, teamMembersCount: number, readOnly: boolean, firmWide: boolean, description: { __typename?: 'RichContent', trixHtml: string, plainText: string, html: string } | null, folder: { __typename?: 'Folder', id: string, name: string, projectsCount: number, subFoldersCount: number, parent: { __typename?: 'Folder', id: string, name: string, projectsCount: number } | null }, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null };

export type ProjectMembershipFragment = { __typename?: 'ProjectMembership', id: string, member: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } };

export type ProjectMembershipsQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ProjectMembershipsQuery = { __typename?: 'Query', projectMemberships: { __typename?: 'ProjectMembershipList', entries: Array<{ __typename?: 'ProjectMembership', id: string, member: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }> } };

export type ProjectOptionFragment = { __typename?: 'Project', id: string, title: string, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null };

export type ProjectOverviewFragment = { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string, nexlApps: boolean, firmWide: boolean, readOnly: boolean, description: { __typename?: 'RichContent', trixHtml: string, plainText: string, html: string } | null, objectives: Array<{ __typename?: 'Objective', id: string, title: string, targetDate: string, targetValue: number, currentProgress: { __typename?: 'Progress', id: string, value: number, status: ProgressStatus } }>, folder: { __typename?: 'Folder', id: string, name: string, projectsCount: number, subFoldersCount: number, parent: { __typename?: 'Folder', id: string, name: string, projectsCount: number } | null }, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null };

export type ProjectPreviewFragment = { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string };

export type ProjectsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  nexlApps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProjectsQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectList', entries: Array<{ __typename?: 'Project', id: string, title: string, iconCode: string | null, colorCode: string | null, createdAt: string, updatedAt: string, teamMembersCount: number, readOnly: boolean, firmWide: boolean, description: { __typename?: 'RichContent', trixHtml: string, plainText: string, html: string } | null, folder: { __typename?: 'Folder', id: string, name: string, projectsCount: number, subFoldersCount: number, parent: { __typename?: 'Folder', id: string, name: string, projectsCount: number } | null }, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number }, subFolders: Array<{ __typename?: 'Folder', id: string, name: string, projectsCount: number, subFoldersCount: number, parent: { __typename?: 'Folder', id: string, name: string, projectsCount: number } | null }> } };

export type ProjectsInFolderQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  nexlApps?: InputMaybe<Scalars['Boolean']['input']>;
  folderUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProjectsInFolderQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectList', rootFolderId: string | null, entries: Array<{ __typename?: 'Project', id: string, title: string, iconCode: string | null, colorCode: string | null, createdAt: string, updatedAt: string, teamMembersCount: number, readOnly: boolean, firmWide: boolean, description: { __typename?: 'RichContent', trixHtml: string, plainText: string, html: string } | null, folder: { __typename?: 'Folder', id: string, name: string, projectsCount: number, subFoldersCount: number, parent: { __typename?: 'Folder', id: string, name: string, projectsCount: number } | null }, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number }, subFolders: Array<{ __typename?: 'Folder', id: string, name: string, projectsCount: number, subFoldersCount: number, parent: { __typename?: 'Folder', id: string, name: string, projectsCount: number } | null }> } };

export type RemoveProjectMutationVariables = Exact<{
  projectUuid: Scalars['ID']['input'];
}>;


export type RemoveProjectMutation = { __typename?: 'Mutation', removeProject: { __typename?: 'RemoveProjectMutationPayload', failReasons: Array<string> } | null };

export type RemoveProjectDocumentMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type RemoveProjectDocumentMutation = { __typename?: 'Mutation', removeProjectDocument: { __typename?: 'RemoveProjectDocumentMutationPayload', failReasons: Array<string> } | null };

export type RemoveProjectMembersMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  memberEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveProjectMembersMutation = { __typename?: 'Mutation', removeProjectMembers: { __typename?: 'RemoveProjectMembersMutationPayload', failReasons: Array<string> } | null };

export type RemoveProjectOpportunityMutationVariables = Exact<{
  projectUid: Scalars['ID']['input'];
  opportunityUid: Scalars['ID']['input'];
}>;


export type RemoveProjectOpportunityMutation = { __typename?: 'Mutation', removeProjectOpportunity: { __typename?: 'RemoveProjectOpportunityMutationPayload', failReasons: Array<string> } | null };

export type UpdateProjectMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: ProjectAttribute;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'UpdateProjectMutationPayload', failReasons: Array<string> } | null };

export type UpdateProjectDocumentMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  attributes: ProjectDocumentAttributes;
}>;


export type UpdateProjectDocumentMutation = { __typename?: 'Mutation', updateProjectDocument: { __typename?: 'UpdateProjectDocumentMutationPayload', failReasons: Array<string> } | null };

export type CreateProjectFolderMutationVariables = Exact<{
  name: Scalars['String']['input'];
  parentId: Scalars['ID']['input'];
}>;


export type CreateProjectFolderMutation = { __typename?: 'Mutation', createProjectFolder: { __typename?: 'CreateProjectFolderMutationPayload', failReasons: Array<string> } | null };

export type RemoveProjectFolderMutationVariables = Exact<{
  folderUuid: Scalars['ID']['input'];
}>;


export type RemoveProjectFolderMutation = { __typename?: 'Mutation', removeProjectFolder: { __typename?: 'RemoveProjectFolderMutationPayload', failReasons: Array<string> } | null };

export type ProjectFolderFragment = { __typename?: 'Folder', id: string, name: string, projectsCount: number, subFoldersCount: number, parent: { __typename?: 'Folder', id: string, name: string, projectsCount: number } | null };

export type UpdateFolderMutationVariables = Exact<{
  folderUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateFolderMutation = { __typename?: 'Mutation', updateProjectFolder: { __typename?: 'UpdateProjectFolderMutationPayload', failReasons: Array<string> } | null };

export type AddProjectNoteMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: ProjectNoteAttribute;
}>;


export type AddProjectNoteMutation = { __typename?: 'Mutation', addProjectNote: { __typename?: 'AddProjectNoteMutationPayload', failReasons: Array<string> } | null };

export type GetProjectNotesQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProjectNotesQuery = { __typename?: 'Query', projectNotes: { __typename?: 'ProjectNoteList', entries: Array<{ __typename?: 'ProjectNote', id: string, createdAt: string, content: { __typename?: 'RichContent', html: string, trixHtml: string }, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null } } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ProjectNotePreviewFragment = { __typename?: 'ProjectNote', id: string, createdAt: string, content: { __typename?: 'RichContent', html: string, trixHtml: string }, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null } } };

export type RemoveProjectNoteMutationVariables = Exact<{
  noteUid: Scalars['ID']['input'];
}>;


export type RemoveProjectNoteMutation = { __typename?: 'Mutation', removeProjectNote: { __typename?: 'RemoveProjectNoteMutationPayload', failReasons: Array<string> } | null };

export type UpdateProjectNoteMutationVariables = Exact<{
  noteUuid: Scalars['ID']['input'];
  attributes: ProjectNoteAttribute;
}>;


export type UpdateProjectNoteMutation = { __typename?: 'Mutation', updateProjectNote: { __typename?: 'UpdateProjectNoteMutationPayload', failReasons: Array<string> } | null };

export type CreateProjectOpportunityMutationVariables = Exact<{
  projectUid: Scalars['ID']['input'];
  companyUid: Scalars['ID']['input'];
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute> | CustomFieldAttribute>;
  opportunityAttributes: CompanyGoalAttributes;
  customStatusUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateProjectOpportunityMutation = { __typename?: 'Mutation', createProjectOpportunity: { __typename?: 'CreateProjectOpportunityMutationPayload', failReasons: Array<string>, record: { __typename?: 'ProjectOpportunityGrid', id: string, opportunity: { __typename?: 'OpportunityGrid', id: string, date: string, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null } | null, company: { __typename?: 'CompanyGrid', domain: string | null, id: string, typeName: string, typeNames: Array<string>, logoUrl: string | null, name: string, industryNames: Array<string>, internalIndustryNames: Array<string>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }, assignedTo: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null, keyContacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }>, referralSource: { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null, company: { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string } } | null, othersIncluded: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }>, commsLast: { __typename?: 'LastAts', sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> } | null } | null };

export type ProjectOpportunitiesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  internalContactEmail?: InputMaybe<Scalars['String']['input']>;
  employeeEmail?: InputMaybe<Scalars['ID']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  customStatusId?: InputMaybe<Scalars['ID']['input']>;
  projectUid: Scalars['ID']['input'];
}>;


export type ProjectOpportunitiesQuery = { __typename?: 'Query', projectOpportunities: { __typename?: 'ProjectOpportunityGridTypeList', entries: Array<{ __typename?: 'ProjectOpportunityGrid', id: string, opportunity: { __typename?: 'OpportunityGrid', id: string, date: string, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null } | null, company: { __typename?: 'CompanyGrid', domain: string | null, id: string, typeName: string, typeNames: Array<string>, logoUrl: string | null, name: string, industryNames: Array<string>, internalIndustryNames: Array<string>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }, assignedTo: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null, keyContacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }>, referralSource: { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null, company: { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string } } | null, othersIncluded: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }>, commsLast: { __typename?: 'LastAts', sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> }> }, opportunityTrackingConfiguration: { __typename?: 'OpportunityTrackingConfiguration', id: string, customStatuses: Array<{ __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean }> } | null };

export type ProjectOpportunityQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ProjectOpportunityQuery = { __typename?: 'Query', projectOpportunity: { __typename?: 'ProjectOpportunityGrid', id: string, opportunity: { __typename?: 'OpportunityGrid', id: string, date: string, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null } | null, company: { __typename?: 'CompanyGrid', domain: string | null, id: string, typeName: string, typeNames: Array<string>, logoUrl: string | null, name: string, industryNames: Array<string>, internalIndustryNames: Array<string>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }, assignedTo: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null, keyContacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }>, referralSource: { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null, company: { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string } } | null, othersIncluded: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }>, commsLast: { __typename?: 'LastAts', sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> } | null };

export type ProjectOpportunityCustomFieldSchemasQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type ProjectOpportunityCustomFieldSchemasQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, opportunityCustomFieldSchemas: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> } | null };

export type ProjectOpportunityCustomFieldsForEditQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ProjectOpportunityCustomFieldsForEditQuery = { __typename?: 'Query', projectOpportunity: { __typename?: 'ProjectOpportunityGrid', id: string, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, opportunity: { __typename?: 'OpportunityGrid', customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> } } | null };

export type ProjectOpportunityGridRowFragment = { __typename?: 'ProjectOpportunityGrid', id: string, opportunity: { __typename?: 'OpportunityGrid', id: string, date: string, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null } | null, company: { __typename?: 'CompanyGrid', domain: string | null, id: string, typeName: string, typeNames: Array<string>, logoUrl: string | null, name: string, industryNames: Array<string>, internalIndustryNames: Array<string>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }, assignedTo: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null, keyContacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }>, referralSource: { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null, company: { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string } } | null, othersIncluded: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }>, commsLast: { __typename?: 'LastAts', sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> };

export type UpdateProjectOpportunityMutationVariables = Exact<{
  projectOpportunityUid: Scalars['ID']['input'];
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute> | CustomFieldAttribute>;
  opportunityAttributes?: InputMaybe<CompanyGoalAttributes>;
  customStatusUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateProjectOpportunityMutation = { __typename?: 'Mutation', updateProjectOpportunity: { __typename?: 'UpdateProjectOpportunityMutationPayload', failReasons: Array<string>, record: { __typename?: 'ProjectOpportunityGrid', id: string, opportunity: { __typename?: 'OpportunityGrid', id: string, date: string, updatedAt: string, tags: Array<string>, trackingNumber: string, title: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, createdBy: { __typename?: 'UserGrid', email: string, firstName: string | null, id: string, imageUrl: string, jobTitle: string | null, lastName: string | null } | null, company: { __typename?: 'CompanyGrid', domain: string | null, id: string, typeName: string, typeNames: Array<string>, logoUrl: string | null, name: string, industryNames: Array<string>, internalIndustryNames: Array<string>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', month: string, interactionCount: number }> }, assignedTo: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null, keyContacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }>, referralSource: { __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null, company: { __typename?: 'CompanyGrid', id: string, domain: string | null, name: string } } | null, othersIncluded: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }>, commsLast: { __typename?: 'LastAts', sentEmailAt: string | null, receivedEmailAt: string | null, meetingAt: string | null, interactionAt: string | null } | null, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> }, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }> } | null } | null };

export type AddProjectTaskSectionMutationVariables = Exact<{
  projectUid: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type AddProjectTaskSectionMutation = { __typename?: 'Mutation', addProjectTaskSection: { __typename?: 'AddProjectTaskSectionMutationPayload', failReasons: Array<string>, record: { __typename?: 'ProjectTaskSection', id: string, blockPageIdentifier: string | null } | null } | null };

export type BlockPageProjectSectionFragment = { __typename?: 'ProjectTaskSection', id: string, title: string, blockPageIdentifier: string | null };

export type BlockPageProjectTaskSectionsQueryVariables = Exact<{
  projectUid: Scalars['String']['input'];
}>;


export type BlockPageProjectTaskSectionsQuery = { __typename?: 'Query', projectTaskSections: { __typename?: 'ProjectTaskSectionEntries', entries: Array<{ __typename?: 'ProjectTaskSection', id: string, title: string, blockPageIdentifier: string | null }> } | null };

export type BlockPageTasksBySourceTypeAndIdQueryVariables = Exact<{
  primaryFilter?: InputMaybe<TaskPrimaryFilterInput>;
  filter?: InputMaybe<TaskFiltering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BlockPageTasksBySourceTypeAndIdQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, title: string, createdAt: string, priority: PriorityEnum | null, completedAt: string | null, dueOn: string | null, position: number | null, projectTaskSection: { __typename?: 'ProjectTaskSection', id: string, title: string, position: number | null } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, project: { __typename?: 'Project', id: string, colorCode: string | null, iconCode: string | null, title: string } | null, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null }> } };

export type CreateTaskWithSectionMutationVariables = Exact<{
  assignedToUid: Scalars['ID']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  projectTaskSectionUid?: InputMaybe<Scalars['ID']['input']>;
  requestedByUid: Scalars['ID']['input'];
  attributes: CreateTaskAttributes;
}>;


export type CreateTaskWithSectionMutation = { __typename?: 'Mutation', createTask: { __typename?: 'CreateTaskMutationPayload', failReasons: Array<string> } | null };

export type GetTasksBySourceTypeAndIdQueryVariables = Exact<{
  primaryFilter?: InputMaybe<TaskPrimaryFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTasksBySourceTypeAndIdQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, title: string, createdAt: string, priority: PriorityEnum | null, completedAt: string | null, dueOn: string | null, position: number | null, projectTaskSection: { __typename?: 'ProjectTaskSection', id: string, title: string, position: number | null } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, project: { __typename?: 'Project', id: string, colorCode: string | null, iconCode: string | null, title: string } | null, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ProjectSectionFragment = { __typename?: 'ProjectTaskSection', id: string, title: string, position: number | null };

export type ProjectTaskSectionsQueryVariables = Exact<{
  projectUid: Scalars['String']['input'];
}>;


export type ProjectTaskSectionsQuery = { __typename?: 'Query', projectTaskSections: { __typename?: 'ProjectTaskSectionEntries', entries: Array<{ __typename?: 'ProjectTaskSection', id: string, title: string, position: number | null }> } | null };

export type RemoveProjectTaskSectionMutationVariables = Exact<{
  projectTaskSectionUid: Scalars['ID']['input'];
}>;


export type RemoveProjectTaskSectionMutation = { __typename?: 'Mutation', removeProjectTaskSection: { __typename?: 'RemoveProjectTaskSectionMutationPayload', failReasons: Array<string> } | null };

export type RenameProjectTaskSectionMutationVariables = Exact<{
  projectTaskSectionUid: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type RenameProjectTaskSectionMutation = { __typename?: 'Mutation', updateProjectTaskSection: { __typename?: 'UpdateProjectTaskSectionMutationPayload', failReasons: Array<string>, record: { __typename?: 'ProjectTaskSection', id: string, title: string } | null } | null };

export type TaskWithProjectTaskSectionFragment = { __typename?: 'Task', id: string, title: string, createdAt: string, priority: PriorityEnum | null, completedAt: string | null, dueOn: string | null, position: number | null, projectTaskSection: { __typename?: 'ProjectTaskSection', id: string, title: string, position: number | null } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, project: { __typename?: 'Project', id: string, colorCode: string | null, iconCode: string | null, title: string } | null, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null };

export type UpdateProjectTaskSectionPositionsMutationVariables = Exact<{
  projectUid: Scalars['ID']['input'];
  projectTaskSectionUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateProjectTaskSectionPositionsMutation = { __typename?: 'Mutation', updateProjectTaskSectionPositions: { __typename?: 'UpdateProjectTaskSectionPositionsMutationPayload', failReasons: Array<string>, updatedProjectTaskSections: Array<{ __typename?: 'ProjectTaskSection', id: string, title: string, position: number | null }> | null } | null };

export type UpdateTaskPositionsMutationVariables = Exact<{
  projectTaskSectionUid: Scalars['ID']['input'];
  projectUid: Scalars['ID']['input'];
  taskUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateTaskPositionsMutation = { __typename?: 'Mutation', updateTaskPositions: { __typename?: 'UpdateTaskPositionsMutationPayload', failReasons: Array<string> } | null };

export type AddProjectTaskMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  attributes: ProjectTaskAttribute;
}>;


export type AddProjectTaskMutation = { __typename?: 'Mutation', addProjectTask: { __typename?: 'AddProjectTaskMutationPayload', failReasons: Array<string> } | null };

export type GetProjectTasksQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProjectTaskFiltering>;
}>;


export type GetProjectTasksQuery = { __typename?: 'Query', projectTasks: { __typename?: 'ProjectTaskList', entries: Array<{ __typename?: 'ProjectTask', id: string, completedOn: string | null, createdAt: string, title: string, dueOn: string | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, description: { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ProjectOverviewTasksQueryVariables = Exact<{
  primaryFilter?: InputMaybe<TaskPrimaryFilterInput>;
}>;


export type ProjectOverviewTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, description: { __typename?: 'RichContent', plainText: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null }> } };

export type ProjectTaskPreviewFragment = { __typename?: 'ProjectTask', id: string, completedOn: string | null, createdAt: string, title: string, dueOn: string | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, description: { __typename?: 'RichContent', html: string, trixHtml: string, plainText: string } | null };

export type CreateSentReferralMutationVariables = Exact<{
  sentToContactUid: Scalars['ID']['input'];
  clientContactUid?: InputMaybe<Scalars['ID']['input']>;
  clientCompanyUid: Scalars['ID']['input'];
  referredByEmployeeUid: Scalars['ID']['input'];
  sentAt: Scalars['ISO8601DateTime']['input'];
  typeOfLegalMatter?: InputMaybe<Scalars['String']['input']>;
  resultStatus?: InputMaybe<SentReferralResultStatus>;
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute> | CustomFieldAttribute>;
}>;


export type CreateSentReferralMutation = { __typename?: 'Mutation', createSentReferral: { __typename?: 'CreateSentReferralMutationPayload', failReasons: Array<string> } | null };

export type DeleteSentReferralMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSentReferralMutation = { __typename?: 'Mutation', deleteSentReferral: { __typename?: 'DeleteSentReferralMutationPayload', failReasons: Array<string> } | null };

export type ReceivedReferralsTotalQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReceivedReferralsTotalQuery = { __typename?: 'Query', companyGoals: { __typename?: 'CompanyGoalList', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type SentReferralQueryVariables = Exact<{
  sentReferralUid: Scalars['ID']['input'];
}>;


export type SentReferralQuery = { __typename?: 'Query', sentReferral: { __typename?: 'SentReferral', id: string, typeOfLegalMatter: string, resultStatus: SentReferralResultStatus, sentAt: string, sentToContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, clientContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, clientCompany: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, referredByEmployee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null };

export type SentReferralCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type SentReferralCustomFieldsQuery = { __typename?: 'Query', currentTenant: { __typename?: 'Tenant', id: string, sentReferralCustomFields: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> | null } | null };

export type SentReferralForFormFragment = { __typename?: 'SentReferral', id: string, typeOfLegalMatter: string, resultStatus: SentReferralResultStatus, sentAt: string, sentToContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, clientContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, clientCompany: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, referredByEmployee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> };

export type SentReferralRowFragment = { __typename?: 'SentReferral', id: string, sentAt: string, resultStatus: SentReferralResultStatus, typeOfLegalMatter: string, clientCompany: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> } | null, clientContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, sentToContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, companyType: { __typename?: 'CompanyCustomType', typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, referredByEmployee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', department: string | null, office: string | null, id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } };

export type SentReferralsQueryVariables = Exact<{
  filter?: InputMaybe<SentReferralsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SentReferralsQuery = { __typename?: 'Query', sentReferrals: { __typename?: 'SentReferralEntries', entries: Array<{ __typename?: 'SentReferral', id: string, sentAt: string, resultStatus: SentReferralResultStatus, typeOfLegalMatter: string, clientCompany: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> } | null, clientContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, sentToContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, companyType: { __typename?: 'CompanyCustomType', typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, referredByEmployee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', department: string | null, office: string | null, id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type SentReferralsTotalQueryVariables = Exact<{
  filter?: InputMaybe<SentReferralsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SentReferralsTotalQuery = { __typename?: 'Query', sentReferrals: { __typename?: 'SentReferralEntries', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type UpdateSentReferralMutationVariables = Exact<{
  sentReferralUid: Scalars['ID']['input'];
  clientContactUid?: InputMaybe<Scalars['ID']['input']>;
  referredByEmployeeUid?: InputMaybe<Scalars['ID']['input']>;
  sentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  typeOfLegalMatter?: InputMaybe<Scalars['String']['input']>;
  resultStatus?: InputMaybe<SentReferralResultStatus>;
  customFieldAttributes?: InputMaybe<Array<CustomFieldAttribute> | CustomFieldAttribute>;
}>;


export type UpdateSentReferralMutation = { __typename?: 'Mutation', updateSentReferral: { __typename?: 'UpdateSentReferralMutationPayload', failReasons: Array<string>, record: { __typename?: 'SentReferral', id: string, sentAt: string, resultStatus: SentReferralResultStatus, typeOfLegalMatter: string, clientCompany: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> } | null, clientContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, sentToContact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, openOpportunityCount: number, pendingTaskCount: number, upcomingMeetingCount: number, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null, primaryLocation: { __typename?: 'CompanyOfficeLocation', companyOfficeLocationId: string, headquarter: boolean, primary: boolean, labels: Array<string>, location: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } } | null }, companyType: { __typename?: 'CompanyCustomType', typeName: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string }>, monthlyEngagement: Array<{ __typename?: 'CompanyMonthlyInteractionDist', interactionCount: number, month: string }> }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, referredByEmployee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', department: string | null, office: string | null, id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } } | null } | null };

export type CompanyListReminderSettingsQueryVariables = Exact<{
  companyListUid: Scalars['ID']['input'];
}>;


export type CompanyListReminderSettingsQuery = { __typename?: 'Query', companyListReminderSettings: Array<{ __typename?: 'ReminderSetting', id: string, emailSubject: string, dateProperty: string, reminderDays: number, timePreposition: ReminderSettingTimePreposition, owners: Array<{ __typename?: 'ReminderSettingOwner', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }> }> | null };

export type ContactListReminderSettingsQueryVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
}>;


export type ContactListReminderSettingsQuery = { __typename?: 'Query', contactListReminderSettings: Array<{ __typename?: 'ReminderSetting', id: string, emailSubject: string, dateProperty: string, reminderDays: number, timePreposition: ReminderSettingTimePreposition, owners: Array<{ __typename?: 'ReminderSettingOwner', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }> }> | null };

export type CreateContactListReminderSettingMutationVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
  timePreposition: ReminderSettingTimePreposition;
  emailSubject: Scalars['String']['input'];
  reminderDays: Scalars['Int']['input'];
  employeeEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateProperty: Scalars['String']['input'];
}>;


export type CreateContactListReminderSettingMutation = { __typename?: 'Mutation', result: { __typename?: 'CreateContactListReminderSettingMutationPayload', failReasons: Array<string> } | null };

export type DatePropertiesForContactListReminderQueryVariables = Exact<{
  contactListUid: Scalars['ID']['input'];
}>;


export type DatePropertiesForContactListReminderQuery = { __typename?: 'Query', datePropertiesForContactListReminder: Array<{ __typename?: 'ListReminderSettingDateOption', name: string, value: string }> | null };

export type DismissReminderMutationVariables = Exact<{
  reminderUid: Scalars['ID']['input'];
}>;


export type DismissReminderMutation = { __typename?: 'Mutation', dismissReminder: { __typename?: 'DismissReminderMutationPayload', failReasons: Array<string> } | null };

export type ContactListMemberRemindersQueryVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
}>;


export type ContactListMemberRemindersQuery = { __typename?: 'Query', listMember: { __typename?: 'ListMember', id: string, listReminders: Array<{ __typename?: 'Reminder', id: string, active: boolean, reminderSetting: { __typename?: 'ReminderSetting', emailSubject: string, id: string, dateProperty: string } }> } | null };

export type ReminderSettingPreviewFragment = { __typename?: 'ReminderSetting', id: string, emailSubject: string, dateProperty: string, reminderDays: number, timePreposition: ReminderSettingTimePreposition, owners: Array<{ __typename?: 'ReminderSettingOwner', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }> };

export type RemoveCompanyReminderSettingMutationVariables = Exact<{
  reminderSettingUid: Scalars['ID']['input'];
}>;


export type RemoveCompanyReminderSettingMutation = { __typename?: 'Mutation', removeReminderSetting: { __typename?: 'RemoveReminderSettingMutationPayload', failReasons: Array<string> } | null };

export type UpdateCompanyReminderSettingMutationVariables = Exact<{
  reminderSettingUid: Scalars['ID']['input'];
  timePreposition?: InputMaybe<ReminderSettingTimePreposition>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  reminderDays?: InputMaybe<Scalars['Int']['input']>;
  employeeEmails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateCompanyReminderSettingMutation = { __typename?: 'Mutation', updateReminderSetting: { __typename?: 'UpdateReminderSettingMutationPayload', failReasons: Array<string> } | null };

export type CanViewEmbeddedReportQueryVariables = Exact<{ [key: string]: never; }>;


export type CanViewEmbeddedReportQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canViewEmbeddedReport: boolean } | null };

export type DashboardListQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardListQuery = { __typename?: 'Query', dashboardList: { __typename?: 'EmbeddedReportingDashboardList', entries: Array<{ __typename?: 'EmbeddedReportingDashboard', id: string, title: string, previewUrl: string | null, description: { __typename?: 'RichContent', html: string } | null }> } | null };

export type EmbeddedReportingDashboardQueryVariables = Exact<{
  dashboardUid: Scalars['String']['input'];
}>;


export type EmbeddedReportingDashboardQuery = { __typename?: 'Query', embeddedReportingDashboard: { __typename?: 'EmbeddedReportingDashboard', id: string, title: string, embeddedPath: string, description: { __typename?: 'RichContent', html: string } | null } | null };

export type ReportFragment = { __typename?: 'EmbeddedReportingDashboard', id: string, title: string, previewUrl: string | null, description: { __typename?: 'RichContent', html: string } | null };

export type BulkAllowReviewContactsMutationVariables = Exact<{
  contactUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkAllowReviewContactsMutation = { __typename?: 'Mutation', bulkUpdateContactsReviewRuleValueForContacts: { __typename?: 'BulkUpdateContactsReviewRuleValueForContactsMutationPayload', failReasons: Array<string> } | null };

export type BulkSetContactsPrivacyMutationVariables = Exact<{
  contactUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  privacyStatus: ContactPrivacy;
  removeFromMyContacts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BulkSetContactsPrivacyMutation = { __typename?: 'Mutation', bulkUpdateContactsPrivacy: { __typename?: 'MyBulkUpdateContactsPrivacyMutationPayload', failReasons: Array<string> } | null };

export type ReviewContactsContextQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewContactsContextQuery = { __typename?: 'Query', contactsReviewConfiguration: { __typename?: 'ContactsReviewConfiguration', allowContactsReview: boolean, id: string } | null, contactsReviewRule: { __typename?: 'ContactsReviewRule', id: string, title: string, subTitle: string, optionChoice: { __typename?: 'OptionChoice', id: string, value: string }, schema: { __typename?: 'CustomFieldSchema', id: string, name: string } } | null };

export type ReviewContactsContextReviewableMyContactsQueryVariables = Exact<{
  withCustomField: CustomFieldTerm;
}>;


export type ReviewContactsContextReviewableMyContactsQuery = { __typename?: 'Query', myContacts: { __typename?: 'MyContactList', pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type CurrentAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null } | null };

export type CurrentAccountBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountBannerQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null } | null, delegateAccesses: Array<{ __typename?: 'UserDelegateAccess', id: string, colour: AccountColour, isEditable: boolean, delegateUser: { __typename?: 'UserInfo', id: string, email: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null } }> | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null };

export type DelegateAccessFragment = { __typename?: 'UserDelegateAccess', id: string, colour: AccountColour, isEditable: boolean, delegateUser: { __typename?: 'UserInfo', id: string, email: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null } };

export type DelegateUserInfoFragment = { __typename?: 'UserInfo', id: string, email: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null };

export type DelegatedAccessesQueryVariables = Exact<{ [key: string]: never; }>;


export type DelegatedAccessesQuery = { __typename?: 'Query', delegateAccesses: Array<{ __typename?: 'UserDelegateAccess', id: string, colour: AccountColour, isEditable: boolean, delegateUser: { __typename?: 'UserInfo', id: string, email: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null } }> | null };

export type SetAccountColourMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  colour: AccountColour;
}>;


export type SetAccountColourMutation = { __typename?: 'Mutation', setAccountColour: { __typename?: 'SetAccountColourMutationPayload', failReasons: Array<string> } | null };

export type SetMyTimezoneMutationVariables = Exact<{
  timezone: Scalars['String']['input'];
}>;


export type SetMyTimezoneMutation = { __typename?: 'Mutation', setMyTimezone: { __typename?: 'SetMyTimezoneMutationPayload', failReasons: Array<string> } | null };

export type SwitchAccountMutationVariables = Exact<{
  to: Scalars['String']['input'];
}>;


export type SwitchAccountMutation = { __typename?: 'Mutation', switchAccount: { __typename?: 'SwitchAccountMutationPayload', failReasons: Array<string>, currentUser: { __typename?: 'User', email: string, firstName: string | null, lastName: string | null } } | null };

export type UserFragment = { __typename?: 'User', id: string, email: string, firstName: string | null, lastName: string | null, profileImageUrl: string | null };

export type BlockPageListTabFragment = { __typename?: 'BlockPageList', id: string, name: string };

export type CampaignTabFragment = { __typename?: 'Campaign', id: string, title: string, projectUrl: string };

export type CompanyListTabFragment = { __typename?: 'CompanyListItem', id: string, name: string };

export type CreateCampaignTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  ownedBy?: InputMaybe<OwnedByInput>;
  continuous?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCampaignTabMutation = { __typename?: 'Mutation', createCampaignTab: { __typename?: 'CreateCampaignTabMutationPayload', id: string | null, failReasons: Array<string> } | null };

export type CreateCompanyListTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  usageMode: CompanyUsageModeInput;
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  ownedBy: OwnedByInput;
  renderMode: RenderMode;
}>;


export type CreateCompanyListTabMutation = { __typename?: 'Mutation', createStaticCompanyListTab: { __typename?: 'CreateStaticCompanyListTabMutationPayload', id: string | null, failReasons: Array<string>, record: { __typename?: 'TabResult', pageResult: { __typename?: 'BlockPageList' } | { __typename?: 'Campaign' } | { __typename?: 'CompanyListItem', id: string } | { __typename?: 'EmbedUrl' } | { __typename?: 'GenericList' } | { __typename?: 'KeyActivityList' } | { __typename?: 'List' } | { __typename?: 'SaveView' } } | null } | null };

export type CreateContactListTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  usageMode: UsageMode;
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  ownedBy: OwnedByInput;
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateContactListTabMutation = { __typename?: 'Mutation', createStaticContactListTab: { __typename?: 'CreateStaticContactListTabMutationPayload', id: string | null, failReasons: Array<string>, record: { __typename?: 'TabResult', pageResult: { __typename?: 'BlockPageList' } | { __typename?: 'Campaign' } | { __typename?: 'CompanyListItem' } | { __typename?: 'EmbedUrl' } | { __typename?: 'GenericList' } | { __typename?: 'KeyActivityList' } | { __typename?: 'List', id: string } | { __typename?: 'SaveView' } } | null } | null };

export type CreateContactListTabWithRenderModesMutationVariables = Exact<{
  name: Scalars['String']['input'];
  usageMode: UsageMode;
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  ownedBy?: InputMaybe<OwnedByInput>;
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  contactListAttributes?: InputMaybe<ContactListAttributes>;
}>;


export type CreateContactListTabWithRenderModesMutation = { __typename?: 'Mutation', createStaticContactListTab: { __typename?: 'CreateStaticContactListTabMutationPayload', id: string | null, failReasons: Array<string>, record: { __typename?: 'TabResult', pageResult: { __typename?: 'BlockPageList' } | { __typename?: 'Campaign' } | { __typename?: 'CompanyListItem' } | { __typename?: 'EmbedUrl' } | { __typename?: 'GenericList' } | { __typename?: 'KeyActivityList' } | { __typename?: 'List', id: string } | { __typename?: 'SaveView' } } | null } | null };

export type CreateEmbedUrlTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  url: Scalars['String']['input'];
}>;


export type CreateEmbedUrlTabMutation = { __typename?: 'Mutation', createEmbedUrlTab: { __typename?: 'CreateEmbedUrlTabMutationPayload', id: string | null, failReasons: Array<string> } | null };

export type CreateGenericListTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  ownedBy: OwnedByInput;
  renderMode: RenderMode;
}>;


export type CreateGenericListTabMutation = { __typename?: 'Mutation', createStaticGenericListTab: { __typename?: 'CreateStaticGenericListTabMutationPayload', id: string | null, failReasons: Array<string>, record: { __typename?: 'TabResult', pageResult: { __typename?: 'BlockPageList' } | { __typename?: 'Campaign' } | { __typename?: 'CompanyListItem' } | { __typename?: 'EmbedUrl' } | { __typename?: 'GenericList', id: string } | { __typename?: 'KeyActivityList' } | { __typename?: 'List' } | { __typename?: 'SaveView' } } | null } | null };

export type CreateKeyActivityListTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  ownedBy?: InputMaybe<OwnedByInput>;
  renderMode: RenderMode;
}>;


export type CreateKeyActivityListTabMutation = { __typename?: 'Mutation', createKeyActivityListTab: { __typename?: 'CreateKeyActivityListTabMutationPayload', failReasons: Array<string>, record: { __typename?: 'TabResult', id: string, name: string, position: number, isWorkspaceTab: boolean, isAppTab: boolean, discardedAt: string | null, renderMode: TabRenderMode, pageResult: { __typename?: 'BlockPageList', id: string, name: string } | { __typename?: 'Campaign', id: string, title: string, projectUrl: string } | { __typename?: 'CompanyListItem', id: string, name: string } | { __typename?: 'EmbedUrl', id: string, title: string, url: string } | { __typename?: 'GenericList', id: string, title: string } | { __typename?: 'KeyActivityList', id: string, name: string } | { __typename?: 'List', id: string, name: string, allowDuplicates: boolean, renderMode: RenderMode, usageMode: UsageMode } | { __typename?: 'SaveView', id: string, filter: any } } | null } | null };

export type CreateMarketingListTabWithRenderModesMutationVariables = Exact<{
  name: Scalars['String']['input'];
  usageMode: UsageMode;
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  marketingListAttributes?: InputMaybe<MarketingListAttributes>;
  ownedBy?: InputMaybe<OwnedByInput>;
}>;


export type CreateMarketingListTabWithRenderModesMutation = { __typename?: 'Mutation', createStaticMarketingListTab: { __typename?: 'CreateStaticMarketingListTabMutationPayload', id: string | null, failReasons: Array<string>, record: { __typename?: 'TabResult', pageResult: { __typename?: 'BlockPageList' } | { __typename?: 'Campaign' } | { __typename?: 'CompanyListItem' } | { __typename?: 'EmbedUrl' } | { __typename?: 'GenericList' } | { __typename?: 'KeyActivityList' } | { __typename?: 'List', id: string } | { __typename?: 'SaveView' } } | null } | null };

export type CreatePageViewTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  group: Scalars['String']['input'];
  filter: Scalars['JSON']['input'];
  tabRenderMode?: InputMaybe<TabRenderMode>;
}>;


export type CreatePageViewTabMutation = { __typename?: 'Mutation', createPageViewTab: { __typename?: 'CreatePageViewTabMutationPayload', failReasons: Array<string>, id: string | null } | null };

export type CreateStaticCompanyListTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  usageMode: CompanyUsageModeInput;
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  renderMode: RenderMode;
}>;


export type CreateStaticCompanyListTabMutation = { __typename?: 'Mutation', createStaticCompanyListTab: { __typename?: 'CreateStaticCompanyListTabMutationPayload', id: string | null, failReasons: Array<string>, record: { __typename?: 'TabResult', pageResult: { __typename?: 'BlockPageList' } | { __typename?: 'Campaign' } | { __typename?: 'CompanyListItem', id: string } | { __typename?: 'EmbedUrl' } | { __typename?: 'GenericList' } | { __typename?: 'KeyActivityList' } | { __typename?: 'List' } | { __typename?: 'SaveView' } } | null } | null };

export type CreateStaticContactListTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  usageMode: UsageMode;
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateStaticContactListTabMutation = { __typename?: 'Mutation', createStaticContactListTab: { __typename?: 'CreateStaticContactListTabMutationPayload', id: string | null, failReasons: Array<string>, record: { __typename?: 'TabResult', pageResult: { __typename?: 'BlockPageList' } | { __typename?: 'Campaign' } | { __typename?: 'CompanyListItem' } | { __typename?: 'EmbedUrl' } | { __typename?: 'GenericList' } | { __typename?: 'KeyActivityList' } | { __typename?: 'List', id: string } | { __typename?: 'SaveView' } } | null } | null };

export type CreateStaticGenericListTabMutationVariables = Exact<{
  name: Scalars['String']['input'];
  group: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  renderMode: RenderMode;
}>;


export type CreateStaticGenericListTabMutation = { __typename?: 'Mutation', createStaticGenericListTab: { __typename?: 'CreateStaticGenericListTabMutationPayload', id: string | null, failReasons: Array<string>, record: { __typename?: 'TabResult', pageResult: { __typename?: 'BlockPageList' } | { __typename?: 'Campaign' } | { __typename?: 'CompanyListItem' } | { __typename?: 'EmbedUrl' } | { __typename?: 'GenericList', id: string } | { __typename?: 'KeyActivityList' } | { __typename?: 'List' } | { __typename?: 'SaveView' } } | null } | null };

export type EmbedUrlTabFragment = { __typename?: 'EmbedUrl', id: string, title: string, url: string };

export type GenericListTabFragment = { __typename?: 'GenericList', id: string, title: string };

export type KeyActivityListTabFragment = { __typename?: 'KeyActivityList', id: string, name: string };

export type ListTabFragment = { __typename?: 'List', id: string, name: string, allowDuplicates: boolean, renderMode: RenderMode, usageMode: UsageMode };

export type RemovePageTabMutationVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type RemovePageTabMutation = { __typename?: 'Mutation', removePageTab: { __typename?: 'RemovePageTabMutationPayload', failReasons: Array<string> } | null };

export type SaveViewTabFragment = { __typename?: 'SaveView', id: string, filter: any };

export type ShowAllEmployeesTabConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowAllEmployeesTabConfigurationQuery = { __typename?: 'Query', tenantConfiguration: { __typename?: 'TenantConfiguration', id: string, showAllEmployeesTab: boolean } | null };

export type TabQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type TabQuery = { __typename?: 'Query', tab: { __typename?: 'TabResult', id: string, name: string, position: number, isWorkspaceTab: boolean, isAppTab: boolean, discardedAt: string | null, renderMode: TabRenderMode, pageResult: { __typename?: 'BlockPageList', id: string, name: string } | { __typename?: 'Campaign', id: string, title: string, projectUrl: string } | { __typename?: 'CompanyListItem', id: string, name: string } | { __typename?: 'EmbedUrl', id: string, title: string, url: string } | { __typename?: 'GenericList', id: string, title: string } | { __typename?: 'KeyActivityList', id: string, name: string } | { __typename?: 'List', id: string, name: string, allowDuplicates: boolean, renderMode: RenderMode, usageMode: UsageMode } | { __typename?: 'SaveView', id: string, filter: any } } | null };

export type TabResultItemFragment = { __typename?: 'TabResult', id: string, name: string, position: number, isWorkspaceTab: boolean, isAppTab: boolean, discardedAt: string | null, renderMode: TabRenderMode, pageResult: { __typename?: 'BlockPageList', id: string, name: string } | { __typename?: 'Campaign', id: string, title: string, projectUrl: string } | { __typename?: 'CompanyListItem', id: string, name: string } | { __typename?: 'EmbedUrl', id: string, title: string, url: string } | { __typename?: 'GenericList', id: string, title: string } | { __typename?: 'KeyActivityList', id: string, name: string } | { __typename?: 'List', id: string, name: string, allowDuplicates: boolean, renderMode: RenderMode, usageMode: UsageMode } | { __typename?: 'SaveView', id: string, filter: any } };

export type TabsQueryVariables = Exact<{
  group?: InputMaybe<Scalars['String']['input']>;
  renderMode?: InputMaybe<TabRenderMode>;
}>;


export type TabsQuery = { __typename?: 'Query', tabs: { __typename?: 'TabList', entries: Array<{ __typename?: 'TabResult', id: string, name: string, position: number, isWorkspaceTab: boolean, isAppTab: boolean, discardedAt: string | null, renderMode: TabRenderMode, pageResult: { __typename?: 'BlockPageList', id: string, name: string } | { __typename?: 'Campaign', id: string, title: string, projectUrl: string } | { __typename?: 'CompanyListItem', id: string, name: string } | { __typename?: 'EmbedUrl', id: string, title: string, url: string } | { __typename?: 'GenericList', id: string, title: string } | { __typename?: 'KeyActivityList', id: string, name: string } | { __typename?: 'List', id: string, name: string, allowDuplicates: boolean, renderMode: RenderMode, usageMode: UsageMode } | { __typename?: 'SaveView', id: string, filter: any } }> } };

export type UpdatePageTabsMutationVariables = Exact<{
  pageTabs: Array<TabInput> | TabInput;
}>;


export type UpdatePageTabsMutation = { __typename?: 'Mutation', updatePageTabs: { __typename?: 'UpdatePageTabsMutationPayload', failReasons: Array<string>, tabs: Array<{ __typename?: 'TabResult', id: string, name: string, position: number, renderMode: TabRenderMode }> | null } | null };

export type UpdatePageViewTabMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  filter: Scalars['JSON']['input'];
}>;


export type UpdatePageViewTabMutation = { __typename?: 'Mutation', updatePageViewTab: { __typename?: 'UpdatePageViewTabMutationPayload', failReasons: Array<string> } | null };

export type AddTagsToAllContactsWithTrackerMutationVariables = Exact<{
  progressTracker: ProgressTrackerAttributes;
  filter?: InputMaybe<ContactsFiltering>;
  filters?: InputMaybe<Array<ContactFilter> | ContactFilter>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AddTagsToAllContactsWithTrackerMutation = { __typename?: 'Mutation', addTagsToAllContactsWithTracker: { __typename?: 'AddTagsToAllContactsWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type AddTagsToContactsMutationVariables = Exact<{
  contactEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddTagsToContactsMutation = { __typename?: 'Mutation', addTagsToContacts: { __typename?: 'AddTagsToContactsMutationPayload', failReasons: Array<string>, contactCards: Array<{ __typename?: 'ContactCard', archivedAt: string | null, lastInteractionAt: string | null, isInteractionsEngaged: boolean, isBounced: boolean | null, tags: any | null, phoneNumbers: any | null, twitterUrl: string | null, linkedinUrl: string | null, educations: any | null, companySwitchKnownDetail: CompanySwitchKnownDetail | null, id: string, contactId: string, primaryEmail: any | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, companyKeyContactSince: string | null, contactLocation: { __typename?: 'Location', id: string, streetAddress: string | null, city: string | null, state: string | null, postCode: string | null, country: { __typename?: 'Country', name: string, code: CountryCode, emojiFlag: string } | null } | null, companyCard: { __typename?: 'CompanyCard', id: string, domain: string | null, name: string, logoUrl: string | null }, companyDetail: { __typename?: 'CompanyDetail', id: string, tags: any, industryNames: any | null, internalIndustryNames: any | null, website: string | null, linkedinUrl: string | null, twitterUrl: string | null, correspondenceNumbers: any | null, correspondenceEmails: any | null, companyTypes: any | null }, companyExternalIdentifier: { __typename?: 'ExternalIdentifier', client: string, group: string | null } | null }> | null } | null };

export type BullkAddTagsToContactsWithTrackerMutationVariables = Exact<{
  progressTracker: ProgressTrackerAttributes;
  contactUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BullkAddTagsToContactsWithTrackerMutation = { __typename?: 'Mutation', bulkAddTagsToContactsWithTracker: { __typename?: 'BulkAddTagsToContactsWithTrackerMutationPayload', failReasons: Array<string> } | null };

export type BulkRemoveTagMutationVariables = Exact<{
  tagUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkRemoveTagMutation = { __typename?: 'Mutation', bulkRemoveTag: { __typename?: 'BulkRemoveTagMutationPayload', failReasons: Array<string> } | null };

export type CreateTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'CreateTagMutationPayload', failReasons: Array<string> } | null };

export type RemoveTagMutationVariables = Exact<{
  tagUid: Scalars['ID']['input'];
}>;


export type RemoveTagMutation = { __typename?: 'Mutation', removeTag: { __typename?: 'RemoveTagMutationPayload', failReasons: Array<string> } | null };

export type RenameTagMutationVariables = Exact<{
  tagUid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameTagMutation = { __typename?: 'Mutation', renameTag: { __typename?: 'RenameTagMutationPayload', failReasons: Array<string> } | null };

export type RestrictTagCreationConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type RestrictTagCreationConfigurationQuery = { __typename?: 'Query', tenantConfiguration: { __typename?: 'TenantConfiguration', id: string, restrictTagCreation: boolean } | null };

export type TagOptionFragment = { __typename?: 'Tag', id: string, name: string };

export type TagsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<TagOrderBy>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagList', entries: Array<{ __typename?: 'Tag', id: string, name: string, usedCount: number, createdAt: string }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type TagsAutocompleteQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagsAutocompleteQuery = { __typename?: 'Query', tags: { __typename?: 'TagList', entries: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type CompleteTaskMutationVariables = Exact<{
  taskUid: Scalars['ID']['input'];
}>;


export type CompleteTaskMutation = { __typename?: 'Mutation', completeTask: { __typename?: 'CompleteTaskMutationPayload', failReasons: Array<string> } | null };

export type ContactListNameChipQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type ContactListNameChipQuery = { __typename?: 'Query', list: { __typename?: 'List', id: string, name: string } | null };

export type CreateTaskMutationVariables = Exact<{
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  assignedToUid?: InputMaybe<Scalars['ID']['input']>;
  requestedByUid?: InputMaybe<Scalars['ID']['input']>;
  contactUid?: InputMaybe<Scalars['ID']['input']>;
  projectUid?: InputMaybe<Scalars['ID']['input']>;
  attributes: CreateTaskAttributes;
  contactListMemberUid?: InputMaybe<Scalars['ID']['input']>;
  companyListMemberUid?: InputMaybe<Scalars['ID']['input']>;
  genericListMemberUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'CreateTaskMutationPayload', failReasons: Array<string>, record: { __typename?: 'Task', id: string } | null } | null };

export type CreateTaskCreatorDisplayNameQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateTaskCreatorDisplayNameQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null } } | null } | null };

export type DeleteTaskMutationVariables = Exact<{
  taskUid: Scalars['ID']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'DeleteTaskMutationPayload', failReasons: Array<string> } | null };

export type ReopenTaskMutationVariables = Exact<{
  taskUid: Scalars['ID']['input'];
}>;


export type ReopenTaskMutation = { __typename?: 'Mutation', reopenTask: { __typename?: 'ReopenTaskMutationPayload', failReasons: Array<string> } | null };

export type TaskQueryVariables = Exact<{
  taskUid: Scalars['ID']['input'];
}>;


export type TaskQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, createdAt: string, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, completer: { __typename?: 'UserInfo', employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, requestedBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null } | null };

export type TaskListRowFragment = { __typename?: 'Task', completedAt: string | null, createdAt: string, dueOn: string | null, id: string, taskTitle: string, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, description: { __typename?: 'RichContent', html: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } };

export type TaskPreviewFragment = { __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, description: { __typename?: 'RichContent', plainText: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null };

export type TaskSlideFragment = { __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, createdAt: string, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, completer: { __typename?: 'UserInfo', employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, requestedBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null };

export type TasksQueryVariables = Exact<{
  filter?: InputMaybe<TaskFiltering>;
  primaryFilter?: InputMaybe<TaskPrimaryFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', completedAt: string | null, createdAt: string, dueOn: string | null, id: string, taskTitle: string, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, description: { __typename?: 'RichContent', html: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type TasksByDateQueryVariables = Exact<{
  primaryFilter?: InputMaybe<TaskPrimaryFilterInput>;
  contactUid?: InputMaybe<Scalars['ID']['input']>;
  companyUid?: InputMaybe<Scalars['ID']['input']>;
  todayStartTime: Scalars['ISO8601DateTime']['input'];
}>;


export type TasksByDateQuery = { __typename?: 'Query', tasksOverdue: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, description: { __typename?: 'RichContent', plainText: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null }> }, tasksToday: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, description: { __typename?: 'RichContent', plainText: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null }> }, tasksUpcoming: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, description: { __typename?: 'RichContent', plainText: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null }> }, tasksCompleted: { __typename?: 'TaskEntries', entries: Array<{ __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, description: { __typename?: 'RichContent', plainText: string } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null }> } };

export type UpdateTaskMutationVariables = Exact<{
  taskUid: Scalars['ID']['input'];
  assignedToUid?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueOn?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<PriorityEnum>;
  requestedByUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'UpdateTaskMutationPayload', failReasons: Array<string>, record: { __typename?: 'Task', id: string, priority: PriorityEnum | null, title: string, dueOn: string | null, completedAt: string | null, createdAt: string, description: { __typename?: 'RichContent', html: string, trixHtml: string } | null, assignedTo: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, completer: { __typename?: 'UserInfo', employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | null, createdBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }, requestedBy: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } | null, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, imageUrl: string | null } } | null, project: { __typename?: 'Project', colorCode: string | null, iconCode: string | null, title: string, id: string } | null, companyListMember: { __typename?: 'CompanyListMember', id: string, companyList: { __typename?: 'CompanyListItem', name: string } } | null, contactListMember: { __typename?: 'ContactListGridMember', id: string, listId: string } | null, genericListMember: { __typename?: 'GenericListItem', id: string, genericList: { __typename?: 'GenericList', title: string } } | null } | null } | null };

export type TemplateProjectQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type TemplateProjectQuery = { __typename?: 'Query', templateProject: { __typename?: 'Project', iconCode: string | null, colorCode: string | null, title: string, id: string, nexlApps: boolean, firmWide: boolean, description: { __typename?: 'RichContent', trixHtml: string, plainText: string, html: string } | null, documents: Array<{ __typename?: 'ProjectDocument', id: string, name: string | null, url: string | null, file: { __typename?: 'File', url: string, contentType: string | null } | null }>, objectives: Array<{ __typename?: 'Objective', id: string, title: string, targetDate: string, targetValue: number, currentProgress: { __typename?: 'Progress', id: string, value: number, status: ProgressStatus } }> } | null };

export type InteractionsConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type InteractionsConfigurationQuery = { __typename?: 'Query', interactionsConfiguration: { __typename?: 'InteractionsConfiguration', id: string, keyActivityTitlesOnlyUseRecommended: boolean } | null };

export type PagesQueryVariables = Exact<{ [key: string]: never; }>;


export type PagesQuery = { __typename?: 'Query', opportunityTrackingConfiguration: { __typename?: 'OpportunityTrackingConfiguration', id: string, visibleFirmWide: boolean } | null, userRoleCorePermissions: { __typename?: 'CorePermission', id: string, allContacts: boolean, allCompanies: boolean } | null, userRoleObjectiveManagementPermissions: { __typename?: 'ObjectiveManagementPermission', id: string, allObjectives: boolean } | null, userRoleOpportunityTrackingPermissions: { __typename?: 'OpportunityTrackingPermission', id: string, allOpportunities: boolean } | null, userRoleEnrichmentPermissions: { __typename?: 'EnrichmentPermission', id: string, allProspects: boolean } | null, accessConfiguration: { __typename?: 'AccessConfig', id: string, showRoleAdmin: boolean } | null, currentUser: { __typename?: 'User', id: string, canViewEmbeddedReport: boolean } | null };

export type SetUiConfigurationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  configuration: Scalars['String']['input'];
  scope: Scalars['String']['input'];
}>;


export type SetUiConfigurationMutation = { __typename?: 'Mutation', setUiConfiguration: { __typename?: 'SetUiConfigurationMutationPayload', failReasons: Array<string>, record: { __typename?: 'UiConfig', id: string, configuration: string } | null } | null };

export type UiConfigFragment = { __typename?: 'UiConfig', id: string, configuration: string };

export type UiConfigurationQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type UiConfigurationQuery = { __typename?: 'Query', columnState: { __typename?: 'UiConfig', id: string, configuration: string } | null, filterModel: { __typename?: 'UiConfig', id: string, configuration: string } | null, searchState: { __typename?: 'UiConfig', id: string, configuration: string } | null, calendarView: { __typename?: 'UiConfig', id: string, configuration: string } | null };

export type ContactUpdateEventRowFragment = { __typename?: 'ContactUpdateEvent', eventDate: string, eventType: UpdateEvent, nextValue: string, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, change: { __typename?: 'JobChangeUpdate', nextContacts: Array<{ __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } }>, previousContact: { __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } } } | { __typename?: 'JobTitleUpdate', nextJobTitle: string, previousJobTitle: string } | null };

export type JobChangeContactInfoFragment = { __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } };

export type JobChangeUpdatePreviewFragment = { __typename?: 'JobChangeUpdate', nextContacts: Array<{ __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } }>, previousContact: { __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } } };

export type MyAllContactUpdateEventsQueryVariables = Exact<{
  filter?: InputMaybe<ContactUpdateEventFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyAllContactUpdateEventsQuery = { __typename?: 'Query', myAllContactUpdateEvents: { __typename?: 'MyAllContactUpdateEvents', entries: Array<{ __typename?: 'ContactUpdateEvent', eventDate: string, eventType: UpdateEvent, nextValue: string, contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }, change: { __typename?: 'JobChangeUpdate', nextContacts: Array<{ __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } }>, previousContact: { __typename?: 'Contact', id: string, info: { __typename?: 'ContactInfo', jobTitle: string | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } } } } | { __typename?: 'JobTitleUpdate', nextJobTitle: string, previousJobTitle: string } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type AccessConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessConfigurationQuery = { __typename?: 'Query', accessConfiguration: { __typename?: 'AccessConfig', id: string, showRoleAdmin: boolean } | null };

export type AccessRoleFieldOptionFragment = { __typename?: 'AccessRole', id: string, name: string };

export type AccessRoleFieldOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessRoleFieldOptionsQuery = { __typename?: 'Query', accessRoles: { __typename?: 'AccessRoleEntries', entries: Array<{ __typename?: 'AccessRole', id: string, name: string }> } };

export type AccessRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessRolesQuery = { __typename?: 'Query', accessRoles: { __typename?: 'AccessRoleEntries', entries: Array<{ __typename?: 'AccessRole', id: string, description: string | null, name: string }> } };

export type AddUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  roleUid: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddUserMutation = { __typename?: 'Mutation', addUser: { __typename?: 'AddUserMutationPayload', failReasons: Array<string>, user: { __typename?: 'User', lastLoginAt: string | null, id: string, profileName: string, profileImageUrl: string | null, email: string, accessRole: { __typename?: 'AccessRole', id: string, name: string } | null, employee: { __typename?: 'Employee', contact: { __typename?: 'Contact', id: string } } | null } | null } | null };

export type ArchiveUserMutationVariables = Exact<{
  userUid: Scalars['ID']['input'];
}>;


export type ArchiveUserMutation = { __typename?: 'Mutation', archiveUser: { __typename?: 'ArchiveUserMutationPayload', failReasons: Array<string>, user: { __typename?: 'User', lastLoginAt: string | null, id: string, profileName: string, profileImageUrl: string | null, email: string, accessRole: { __typename?: 'AccessRole', id: string, name: string } | null, employee: { __typename?: 'Employee', contact: { __typename?: 'Contact', id: string } } | null } | null } | null };

export type CreateCustomUserRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  baseLegacyRole: BaseLegacyRole;
}>;


export type CreateCustomUserRoleMutation = { __typename?: 'Mutation', createCustomUserRole: { __typename?: 'CreateCustomUserRoleMutationPayload', failReasons: Array<string>, role: { __typename?: 'AccessRole', id: string } | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  roleUid: Scalars['ID']['input'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: { __typename?: 'DeleteRoleMutationPayload', failReasons: Array<string> } | null };

export type UpdateRoleMutationVariables = Exact<{
  roleUid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'UpdateRoleMutationPayload', failReasons: Array<string>, accessRole: { __typename?: 'AccessRole', id: string, name: string, description: string | null } | null } | null };

export type UpdateRolePermissionsMutationVariables = Exact<{
  accessRoleUid: Scalars['ID']['input'];
  allContacts?: InputMaybe<Scalars['Boolean']['input']>;
  allCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  allProspects?: InputMaybe<Scalars['Boolean']['input']>;
  allOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  allObjectives?: InputMaybe<Scalars['Boolean']['input']>;
  viewEmployeeEngagementTab?: InputMaybe<Scalars['Boolean']['input']>;
  viewEmployeeOpportunitiesTab?: InputMaybe<Scalars['Boolean']['input']>;
  exportCompanyLists?: InputMaybe<Scalars['Boolean']['input']>;
  exportContactLists?: InputMaybe<Scalars['Boolean']['input']>;
  exportGenericLists?: InputMaybe<Scalars['Boolean']['input']>;
  exportKeyActivityLists?: InputMaybe<Scalars['Boolean']['input']>;
  exportOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  exportAllActivities?: InputMaybe<Scalars['Boolean']['input']>;
  exportMarketingLists?: InputMaybe<Scalars['Boolean']['input']>;
  exportReferrals?: InputMaybe<Scalars['Boolean']['input']>;
  exportAllOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readCompanyReport?: InputMaybe<Scalars['Boolean']['input']>;
  editCompanyReport?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRolePermissionsMutation = { __typename?: 'Mutation', core: { __typename?: 'UpdateCoreRolePermissionMutationPayload', failReasons: Array<string> } | null, enrichment: { __typename?: 'UpdateEnrichmentRolePermissionMutationPayload', failReasons: Array<string> } | null, opportunityTracking: { __typename?: 'UpdateOpportunityTrackingRolePermissionMutationPayload', failReasons: Array<string> } | null, objectiveManagement: { __typename?: 'UpdateObjectiveManagementRolePermissionMutationPayload', failReasons: Array<string> } | null, projectManagement: { __typename?: 'UpdateProjectManagementRolePermissionMutationPayload', failReasons: Array<string> } | null, interactions: { __typename?: 'UpdateInteractionsRolePermissionMutationPayload', failReasons: Array<string> } | null, marketingLists: { __typename?: 'UpdateMarketingListsRolePermissionMutationPayload', failReasons: Array<string> } | null, referralTracking: { __typename?: 'UpdateReferralTrackingRolePermissionMutationPayload', failReasons: Array<string> } | null, researchReports: { __typename?: 'UpdateResearchReportsRolePermissionMutationPayload', failReasons: Array<string> } | null };

export type UpdateUserRoleMutationVariables = Exact<{
  roleUid: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserMutationPayload', failReasons: Array<string>, user: { __typename?: 'User', lastLoginAt: string | null, id: string, profileName: string, profileImageUrl: string | null, email: string, accessRole: { __typename?: 'AccessRole', id: string, name: string } | null, employee: { __typename?: 'Employee', contact: { __typename?: 'Contact', id: string } } | null } | null } | null };

export type UserGridRowAvatarCardFragment = { __typename?: 'User', id: string, profileName: string, profileImageUrl: string | null, email: string };

export type UserGridRowFragment = { __typename?: 'User', lastLoginAt: string | null, id: string, profileName: string, profileImageUrl: string | null, email: string, accessRole: { __typename?: 'AccessRole', id: string, name: string } | null, employee: { __typename?: 'Employee', contact: { __typename?: 'Contact', id: string } } | null };

export type UsersGridQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersGridQuery = { __typename?: 'Query', users: { __typename?: 'UserEntries', pageInfo: { __typename?: 'PagingInfo', totalEntries: number }, entries: Array<{ __typename?: 'User', lastLoginAt: string | null, id: string, profileName: string, profileImageUrl: string | null, email: string, accessRole: { __typename?: 'AccessRole', id: string, name: string } | null, employee: { __typename?: 'Employee', contact: { __typename?: 'Contact', id: string } } | null }> } };

export type AccessRoleCompanyPermissionsFragment = { __typename?: 'CorePermission', exportMyCompanies: boolean, exportAllCompanies: boolean, viewCompanyRecords: boolean, viewCompanyWhoKnows: boolean, viewAllCompanies: boolean, viewMyCompanies: boolean };

export type AccessRoleContactPermissionsFragment = { __typename?: 'CorePermission', viewContactActivities: boolean, viewContactEmailAddresses: boolean, viewContactRecords: boolean, viewContactWhoKnows: boolean, viewLastInteractionDateFirm: boolean, viewLastInteractionDateUser: boolean, exportAllContacts: boolean, exportMyContacts: boolean, viewEmployeeEngagementTab: boolean, viewAllContacts: boolean, viewMyContacts: boolean };

export type AccessRoleDetailsFragment = { __typename?: 'AccessRole', id: string, description: string | null, name: string };

export type AccessRoleEnrichmentPermissionsFragment = { __typename?: 'EnrichmentPermission', viewMyProspects: boolean, viewAllProspects: boolean };

export type AccessRoleFragment = { __typename?: 'AccessRole', id: string, description: string | null, name: string };

export type AccessRoleInteractionsPermissionsFragment = { __typename?: 'InteractionsPermission', exportAllActivities: boolean };

export type AccessRoleMarketingListsPermissionsFragment = { __typename?: 'MarketingListsPermission', exportMarketingLists: boolean };

export type AccessRoleObjectiveManagementPermissionsFragment = { __typename?: 'ObjectiveManagementPermission', viewMyObjectives: boolean, viewAllObjectives: boolean };

export type AccessRoleOpportunityTrackingPermissionsFragment = { __typename?: 'OpportunityTrackingPermission', viewMyOpportunities: boolean, viewEmployeeOpportunitiesTab: boolean, exportAllOpportunities: boolean, viewAllOpportunities: boolean };

export type AccessRolePageQueryVariables = Exact<{
  accessRoleUid: Scalars['ID']['input'];
}>;


export type AccessRolePageQuery = { __typename?: 'Query', tenantConfiguration: { __typename?: 'TenantConfiguration', id: string, showAllEmployeesTab: boolean } | null, accessRole: { __typename?: 'AccessRole', id: string, description: string | null, name: string } | null, coreRolePermissions: { __typename?: 'CorePermission', id: string, viewContactActivities: boolean, viewContactEmailAddresses: boolean, viewContactRecords: boolean, viewContactWhoKnows: boolean, viewLastInteractionDateFirm: boolean, viewLastInteractionDateUser: boolean, exportAllContacts: boolean, exportMyContacts: boolean, viewEmployeeEngagementTab: boolean, exportMyCompanies: boolean, exportAllCompanies: boolean, viewCompanyRecords: boolean, viewCompanyWhoKnows: boolean, viewAllContacts: boolean, viewMyContacts: boolean, viewAllCompanies: boolean, viewMyCompanies: boolean } | null, opportunityTrackingRolePermissions: { __typename?: 'OpportunityTrackingPermission', id: string, viewMyOpportunities: boolean, viewEmployeeOpportunitiesTab: boolean, exportAllOpportunities: boolean, viewAllOpportunities: boolean } | null, objectiveManagementRolePermissions: { __typename?: 'ObjectiveManagementPermission', id: string, viewMyObjectives: boolean, viewAllObjectives: boolean } | null, enrichmentRolePermissions: { __typename?: 'EnrichmentPermission', id: string, viewMyProspects: boolean, viewAllProspects: boolean } | null, projectManagementRolePermissions: { __typename?: 'ProjectManagementPermission', id: string, exportCompanyLists: boolean, exportContactLists: boolean, exportGenericLists: boolean, exportKeyActivityLists: boolean, exportOpportunities: boolean } | null, interactionsRolePermissions: { __typename?: 'InteractionsPermission', id: string, exportAllActivities: boolean } | null, marketingListsRolePermissions: { __typename?: 'MarketingListsPermission', id: string, exportMarketingLists: boolean } | null, referralTrackingRolePermissions: { __typename?: 'ReferralTrackingPermission', id: string, exportReferrals: boolean } | null, researchReportsRolePermissions: { __typename?: 'ResearchReportsPermission', id: string, readCompanyReport: boolean, editCompanyReport: boolean } | null };

export type AccessRoleProjectManagementPermissionsFragment = { __typename?: 'ProjectManagementPermission', exportCompanyLists: boolean, exportContactLists: boolean, exportGenericLists: boolean, exportKeyActivityLists: boolean, exportOpportunities: boolean };

export type AccessRoleReferralTrackingPermissionsFragment = { __typename?: 'ReferralTrackingPermission', exportReferrals: boolean };

export type AccessRoleResearchReportsPermissionsFragment = { __typename?: 'ResearchReportsPermission', readCompanyReport: boolean, editCompanyReport: boolean };

export type CreateUserDelegateAccessMutationVariables = Exact<{
  delegateUserUid: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
}>;


export type CreateUserDelegateAccessMutation = { __typename?: 'Mutation', createUserDelegateAccess: { __typename?: 'CreateUserDelegateAccessMutationPayload', failReasons: Array<string> } | null };

export type DelegateAccessInfoFragment = { __typename?: 'UserInfo', id: string, profileImageUrl: string | null, profileName: string, email: string };

export type DelegateAccessesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type DelegateAccessesQuery = { __typename?: 'Query', allDelegateAccesses: { __typename?: 'UserDelegateAccessEntries', entries: Array<{ __typename?: 'UserDelegateAccess', id: string, delegateUserInfo: { __typename?: 'UserInfo', id: string, profileImageUrl: string | null, profileName: string, email: string } }> } | null };

export type DeleteUserDelegateAccessMutationVariables = Exact<{
  delegateUserUid: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
}>;


export type DeleteUserDelegateAccessMutation = { __typename?: 'Mutation', deleteUserDelegateAccess: { __typename?: 'DeleteUserDelegateAccessMutationPayload', failReasons: Array<string> } | null };

export type GetCurrentUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserRolesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, role: RoleCode } | null };

export type UserRoleContextRolePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRoleContextRolePermissionsQuery = { __typename?: 'Query', userRoleCorePermissions: { __typename?: 'CorePermission', id: string, allContacts: boolean, allCompanies: boolean, exportAllContacts: boolean, exportMyCompanies: boolean, exportAllCompanies: boolean, exportMyContacts: boolean } | null, userRoleObjectiveManagementPermissions: { __typename?: 'ObjectiveManagementPermission', id: string, allObjectives: boolean } | null, userRoleOpportunityTrackingPermissions: { __typename?: 'OpportunityTrackingPermission', id: string, allOpportunities: boolean, exportAllOpportunities: boolean } | null, userRoleEnrichmentPermissions: { __typename?: 'EnrichmentPermission', id: string, allProspects: boolean } | null, userRoleProjectManagementPermissions: { __typename?: 'ProjectManagementPermission', id: string, exportCompanyLists: boolean, exportContactLists: boolean, exportGenericLists: boolean, exportKeyActivityLists: boolean, exportOpportunities: boolean } | null, userRoleInteractionsPermissions: { __typename?: 'InteractionsPermission', id: string, exportAllActivities: boolean } | null, userRoleMarketingListsPermissions: { __typename?: 'MarketingListsPermission', id: string, exportMarketingLists: boolean } | null, userRoleReferralTrackingPermissions: { __typename?: 'ReferralTrackingPermission', id: string, exportReferrals: boolean } | null, userRoleResearchReportsPermissions: { __typename?: 'ResearchReportsPermission', id: string, readCompanyReport: boolean, editCompanyReport: boolean } | null };

export type KeyActivityDetailsFragment = { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null, involvedContacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> };

export type KeyActivityListMemberSlideQueryVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
}>;


export type KeyActivityListMemberSlideQuery = { __typename?: 'Query', keyActivityListMember: { __typename?: 'KeyActivityListMember', id: string, keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null, involvedContacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> }, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, list: { __typename?: 'KeyActivityList', id: string } } | null };

export type KeyActivitySlideQueryVariables = Exact<{
  sourceReferenceId: Scalars['String']['input'];
}>;


export type KeyActivitySlideQuery = { __typename?: 'Query', keyActivity: { __typename?: 'KeyActivity', id: string, category: KeyActivityCategory, activityTitle: string, description: string | null, interactionOn: string, interactionEndAt: string | null, notes: { __typename?: 'RichContent', html: string, trixHtml: string } | null, involvedContacts: Array<{ __typename?: 'Contact', id: string, isEmployee: boolean, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, company: { __typename?: 'Company', id: string, info: { __typename?: 'CompanyInfo', name: string } }, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> } | null };

export type KeyActivityListCustomFieldSchemasQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type KeyActivityListCustomFieldSchemasQuery = { __typename?: 'Query', keyActivityList: { __typename?: 'KeyActivityList', id: string, memberCustomFields: Array<{ __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, usage: CustomFieldSchemaUsage, hideFromForm: boolean, currency: { __typename?: 'Currency', name: string } | null, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, status: CampaignStatus }> | null }> | null } | null };

export type SetKeyActivityListMemberCustomFieldMutationVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
  customFieldAttributes: Array<CustomFieldAttribute> | CustomFieldAttribute;
}>;


export type SetKeyActivityListMemberCustomFieldMutation = { __typename?: 'Mutation', setKeyActivityListMemberCustomField: { __typename?: 'SetKeyActivityListMemberCustomFieldMutationPayload', failReasons: Array<string>, record: { __typename?: 'KeyActivityListMember', id: string, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null } | null };

export type CreateListCustomFieldSchemaMutationVariables = Exact<{
  listUuid: Scalars['ID']['input'];
  customFieldAttributes: CustomFieldSchemaAttributes;
}>;


export type CreateListCustomFieldSchemaMutation = { __typename?: 'Mutation', createListCustomFieldSchema: { __typename?: 'CreateListCustomFieldSchemaMutationPayload', failReasons: Array<string> } | null };

export type ApiConnectionFragment = { __typename?: 'ApiSourceTable', id: string, name: string | null, tableKey: string, apiDefinition: { __typename?: 'ApiDefinition', id: string, apiUrl: string | null, httpMethod: string | null }, jsonPathColumnMappings: Array<{ __typename?: 'JsonPathColumnMapping', jsonPath: string, columnId: string }> };

export type ExpirySettingsFragment = { __typename?: 'FormExpirySettings', enabled: boolean, date: string | null, pageHeader: string | null, pageDescription: { __typename?: 'PageDescription', htmlForEditor: string | null, renderSafeHtml: string | null } | null };

export type UpdateFormExpiryMutationVariables = Exact<{
  formUid: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
  date?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  pageHeader?: InputMaybe<Scalars['String']['input']>;
  pageDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFormExpiryMutation = { __typename?: 'Mutation', updateFormExpiry: { __typename?: 'UpdateFormExpiryMutationPayload', failReasons: Array<string> } | null };

export type UpdateFormWaitlistMutationVariables = Exact<{
  formId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<WaitlistConditionInput>;
}>;


export type UpdateFormWaitlistMutation = { __typename?: 'Mutation', updateFormWaitlist: { __typename?: 'UpdateFormWaitlistMutationPayload', failReasons: Array<string> } | null };

export type WaitlistSettingsFragment = { __typename?: 'FormWaitlistSettings', enabled: boolean, redirectUrl: string | null, condition: { __typename?: 'WaitlistCondition', operator: WaitlistConditionOperatorEnum | null, value: number | null, rollupField: { __typename?: 'TableLikeRollupFieldType', id: string, name: string } | null } | null };

export type WaitlistConditionFormRollupFieldOptionFragment = { __typename?: 'TableLikeRollupFieldType', id: string, name: string };

export type WaitlistConditionFormRollupFieldOptionsQueryVariables = Exact<{
  filters?: InputMaybe<RollupFieldFiltersInput>;
}>;


export type WaitlistConditionFormRollupFieldOptionsQuery = { __typename?: 'Query', tableLikeRollupFields: { __typename?: 'TableLikeRollupFieldEntries', entries: Array<{ __typename?: 'TableLikeRollupFieldType', id: string, name: string }> } };

export type KeyActivityListAutocompleteQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  keyActivityUid?: InputMaybe<Scalars['ID']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type KeyActivityListAutocompleteQuery = { __typename?: 'Query', keyActivityLists: { __typename?: 'KeyActivityLists', entries: Array<{ __typename?: 'KeyActivityList', id: string, name: string, includesKeyActivity: boolean, project: { __typename?: 'Project', id: string, title: string } | null }> | null } | null };

export type KeyActivityListAutocompleteOptionFragment = { __typename?: 'KeyActivityList', id: string, name: string, includesKeyActivity: boolean, project: { __typename?: 'Project', id: string, title: string } | null };

export type GetCompanyIdFromListMemberIdQueryVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
}>;


export type GetCompanyIdFromListMemberIdQuery = { __typename?: 'Query', companyListMember: { __typename?: 'CompanyListMember', company: { __typename?: 'Company', id: string } } | null };

export type GetContactIdFromListMemberIdQueryVariables = Exact<{
  listMemberUid: Scalars['ID']['input'];
}>;


export type GetContactIdFromListMemberIdQuery = { __typename?: 'Query', listMember: { __typename?: 'ListMember', contact: { __typename?: 'Contact', id: string } } | null };

export type OpportunityFormQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
  includeCompanyGoal: Scalars['Boolean']['input'];
}>;


export type OpportunityFormQuery = { __typename?: 'Query', companyGoal: { __typename?: 'Opportunity', title: string | null, date: string | null, id: string, trackingNumber: string, createdAt: string, tags: Array<string>, emailBody: { __typename?: 'RichContent', html: string } | null, createdBy: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null } }, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string } | null, documents: Array<{ __typename?: 'DocumentFile', documentId: string, filename: string | null, url: string, contentType: string | null } | { __typename?: 'DocumentUrl', link: string }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null, opportunityTrackingConfiguration: { __typename?: 'OpportunityTrackingConfiguration', id: string, customStatuses: Array<{ __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean }> } | null };

export type OpportunityPreviewFragment = { __typename?: 'Opportunity', title: string | null, date: string | null, id: string, trackingNumber: string, createdAt: string, tags: Array<string>, emailBody: { __typename?: 'RichContent', html: string } | null, createdBy: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null } }, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string } | null, documents: Array<{ __typename?: 'DocumentFile', documentId: string, filename: string | null, url: string, contentType: string | null } | { __typename?: 'DocumentUrl', link: string }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> };

export type OpportunitySlideQueryVariables = Exact<{
  opportunityUid: Scalars['ID']['input'];
  workspaceOpportunityUid: Scalars['ID']['input'];
  shouldFetchOpportunity: Scalars['Boolean']['input'];
  shouldFetchProjects: Scalars['Boolean']['input'];
  shouldFetchCustomFields: Scalars['Boolean']['input'];
}>;


export type OpportunitySlideQuery = { __typename?: 'Query', opportunity?: { __typename?: 'Opportunity', title: string | null, date: string | null, id: string, trackingNumber: string, createdAt: string, tags: Array<string>, emailBody: { __typename?: 'RichContent', html: string } | null, createdBy: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }>, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, company: { __typename?: 'Company', domain: string | null, id: string, logoUrl: string | null, companyType: { __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }, companyTypes: Array<{ __typename?: 'CompanyCustomType', id: string, typeName: string, defaultType: string | null }>, info: { __typename?: 'CompanyInfo', id: string | null, name: string, industryNames: Array<string> | null } }, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfo', id: string | null, name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string } | null, documents: Array<{ __typename?: 'DocumentFile', documentId: string, filename: string | null, url: string, contentType: string | null } | { __typename?: 'DocumentUrl', link: string }>, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }> } | null, opportunityProjectsForUid?: { __typename?: 'OpportunityProjectEntries', entries: Array<{ __typename?: 'Project', id: string, title: string, overviewTab: { __typename?: 'ProjectOverviewTab', id: string } | null }> } | null, workspaceOpportunity: { __typename?: 'ProjectOpportunityGrid', id: string, projectId: string, customFields: Array<{ __typename?: 'CustomFieldGrid', name: string, id: string, schemaId: string, schemaValueType: CustomFieldSchemaValue, value: { __typename: 'CustomCurrencyFieldGrid', amount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomDatetimeFieldGrid', date: string | null } | { __typename: 'CustomEmployeeFieldGrid', employee: { __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null } | null } | { __typename: 'CustomFullDateTimeFieldGrid', dateTime: string | null } | { __typename: 'CustomMultiCompanyFieldGrid', companies: Array<{ __typename?: 'CompanyGrid', id: string, domain: string | null, name: string, logoUrl: string | null }> } | { __typename: 'CustomMultiContactFieldGrid', contacts: Array<{ __typename?: 'ContactGrid', id: string, primaryEmail: any, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string, isActive: boolean, isArchived: boolean, isKeyContact: boolean, city: string | null, country: string | null }> } | { __typename: 'CustomMultiCountryFieldGrid', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> } | { __typename: 'CustomMultiEmployeeFieldGrid', employees: Array<{ __typename?: 'EmployeeGrid', id: string, email: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null, officeName: string | null, departmentName: string | null }> } | { __typename: 'CustomMultiOptionalValueFieldGrid', multiSelected: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> } | { __typename: 'CustomNewlyDefinedFieldGrid' } | { __typename: 'CustomNumberFieldGrid', number: string | null } | { __typename: 'CustomOptionalValueFieldGrid', selected: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomRichTextFieldGrid', html: string, plainText: string } | { __typename: 'CustomTextFieldGrid', text: string | null } | null }>, opportunity: { __typename?: 'OpportunityGrid', id: string } } | null };

export type CustomOpportunityStatsQueryVariables = Exact<{
  withEmployeeUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CustomOpportunityStatsQuery = { __typename?: 'Query', companyGoals: { __typename?: 'CompanyGoalList', customStatusDistribution: Array<{ __typename?: 'CustomStatusDistribution', count: number, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean }, totalProposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } }> } };

export type CustomOpportunityStatsUiFragment = { __typename?: 'CustomStatusDistribution', count: number, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean }, totalProposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } };

export type DownloadEmailMarketingCampaignTemplateMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type DownloadEmailMarketingCampaignTemplateMutation = { __typename?: 'Mutation', downloadEmailMarketingCampaignTemplate: { __typename?: 'DownloadCampaignTemplateMutationPayload', failReasons: Array<string> | null, templateHtml: string | null } | null };

export type MyJourneyPageQueryVariables = Exact<{ [key: string]: never; }>;


export type MyJourneyPageQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', firstName: string | null, lastName: string | null, email: string } | null, mobileConfigs: { __typename?: 'MobileConfigs', entries: Array<{ __typename?: 'MobileConfig', name: string, value: string | null }> } | null, everAfterStatus: { __typename?: 'Status', enabled: boolean, hasPersona: boolean, persona: UserPersonaPersonaEnum | null, personaLabel: string | null, productAccountId: string | null } };

export type OpportunityIdFromWorkspaceOpportunityQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type OpportunityIdFromWorkspaceOpportunityQuery = { __typename?: 'Query', projectOpportunity: { __typename?: 'ProjectOpportunityGrid', opportunity: { __typename?: 'OpportunityGrid', id: string } } | null };

export type SharedViewPageQueryVariables = Exact<{
  tabUid: Scalars['ID']['input'];
  listViewUid: Scalars['ID']['input'];
}>;


export type SharedViewPageQuery = { __typename?: 'Query', tab: { __typename?: 'TabResult', id: string, name: string, position: number, isWorkspaceTab: boolean, isAppTab: boolean, discardedAt: string | null, renderMode: TabRenderMode, pageResult: { __typename?: 'BlockPageList', id: string, name: string } | { __typename?: 'Campaign', id: string, title: string, projectUrl: string } | { __typename?: 'CompanyListItem', id: string, name: string } | { __typename?: 'EmbedUrl', id: string, title: string, url: string } | { __typename?: 'GenericList', id: string, title: string } | { __typename?: 'KeyActivityList', id: string, name: string } | { __typename?: 'List', id: string, name: string, allowDuplicates: boolean, renderMode: RenderMode, usageMode: UsageMode } | { __typename?: 'SaveView', id: string, filter: any } } | null, listView: { __typename?: 'ListView', id: string, name: string, viewType: ListViewType, schemaUid: string | null, renderMode: ListViewRenderMode, columnStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, filterModelConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null, searchStateConfiguration: { __typename?: 'UiConfiguration', id: string, configuration: string | null } | null } | null };

export type UpdateProjectFoldersQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']['input']>;
  folderUid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateProjectFoldersQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectList', subFolders: Array<{ __typename?: 'Folder', id: string, name: string, projectsCount: number, subFoldersCount: number, parent: { __typename?: 'Folder', id: string, name: string, projectsCount: number } | null }> } };

export type CreateProjectOpportunityCustomFieldSchemaMutationVariables = Exact<{
  projectUid: Scalars['ID']['input'];
  customFieldAttributes: CustomFieldSchemaAttributes;
}>;


export type CreateProjectOpportunityCustomFieldSchemaMutation = { __typename?: 'Mutation', createProjectOpportunityCustomFieldSchema: { __typename?: 'CreateProjectOpportunityCustomFieldSchemaMutationPayload', failReasons: Array<string> } | null };

export type TableLikeRollupFieldConditionFragment = { __typename?: 'ColumnsFilteringOutput', joinOperator: ColumnJoinOperatorEnum, filters: Array<{ __typename?: 'ColumnFilterOutput', columnUid: string, columnName: string, joinOperator: ColumnJoinOperatorEnum, conditions: Array<{ __typename?: 'ColumnConditionOutput', operation: ColumnFilterOperationEnum, value: string | null, valueTo: string | null }> }> };

export type TableLikeRollupFieldFragment = { __typename?: 'TableLikeRollupFieldType', id: string, name: string, discardedAt: string | null, sourceListName: string | null, sourceType: SourceTypeEnum, targetColumnName: string | null, operationType: OperationTypeEnum, currentValue: string, conditions: { __typename?: 'ColumnsFilteringOutput', joinOperator: ColumnJoinOperatorEnum, filters: Array<{ __typename?: 'ColumnFilterOutput', columnUid: string, columnName: string, joinOperator: ColumnJoinOperatorEnum, conditions: Array<{ __typename?: 'ColumnConditionOutput', operation: ColumnFilterOperationEnum, value: string | null, valueTo: string | null }> }> } | null };

export type TableLikeRollupFieldsQueryVariables = Exact<{
  filter?: InputMaybe<RollupFieldFiltersInput>;
}>;


export type TableLikeRollupFieldsQuery = { __typename?: 'Query', tableLikeRollupFields: { __typename?: 'TableLikeRollupFieldEntries', entries: Array<{ __typename?: 'TableLikeRollupFieldType', id: string, name: string, discardedAt: string | null, sourceListName: string | null, sourceType: SourceTypeEnum, targetColumnName: string | null, operationType: OperationTypeEnum, currentValue: string, conditions: { __typename?: 'ColumnsFilteringOutput', joinOperator: ColumnJoinOperatorEnum, filters: Array<{ __typename?: 'ColumnFilterOutput', columnUid: string, columnName: string, joinOperator: ColumnJoinOperatorEnum, conditions: Array<{ __typename?: 'ColumnConditionOutput', operation: ColumnFilterOperationEnum, value: string | null, valueTo: string | null }> }> } | null }> } };

export type DeleteTableLikeRollupFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTableLikeRollupFieldMutation = { __typename?: 'Mutation', deleteTableLikeRollupField: { __typename?: 'DeleteTableLikeRollupFieldMutationPayload', failReasons: Array<string>, rollupField: { __typename?: 'TableLikeRollupFieldType', id: string, discardedAt: string | null } | null } | null };

export type UpdateTableLikeRollupFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateTableLikeRollupFieldMutation = { __typename?: 'Mutation', updateTableLikeRollupField: { __typename?: 'UpdateTableLikeRollupFieldMutationPayload', failReasons: Array<string>, rollupField: { __typename?: 'TableLikeRollupFieldType', id: string, name: string } | null } | null };

export type CreateTableLikeRollupFieldMutationVariables = Exact<{
  input: CreateTableLikeRollupFieldInput;
}>;


export type CreateTableLikeRollupFieldMutation = { __typename?: 'Mutation', createTableLikeRollupField: { __typename?: 'CreateTableLikeRollupFieldMutationPayload', failReasons: Array<string>, rollupField: { __typename?: 'TableLikeRollupFieldType', id: string, name: string, discardedAt: string | null, sourceListName: string | null, sourceType: SourceTypeEnum, targetColumnName: string | null, operationType: OperationTypeEnum, currentValue: string, conditions: { __typename?: 'ColumnsFilteringOutput', joinOperator: ColumnJoinOperatorEnum, filters: Array<{ __typename?: 'ColumnFilterOutput', columnUid: string, columnName: string, joinOperator: ColumnJoinOperatorEnum, conditions: Array<{ __typename?: 'ColumnConditionOutput', operation: ColumnFilterOperationEnum, value: string | null, valueTo: string | null }> }> } | null } | null } | null };

export type CreateTableLikeRollupFieldSourceListOptionsQueryVariables = Exact<{
  projectUid: Scalars['ID']['input'];
}>;


export type CreateTableLikeRollupFieldSourceListOptionsQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, tabs: Array<{ __typename?: 'TabResult', id: string, pageResult: { __typename: 'BlockPageList' } | { __typename: 'Campaign' } | { __typename: 'CompanyListItem', id: string, name: string, discardedAt: string | null } | { __typename: 'EmbedUrl' } | { __typename: 'GenericList', id: string, title: string, discardedAt: string | null } | { __typename: 'KeyActivityList', id: string, name: string, discardedAt: string | null } | { __typename: 'List', id: string, name: string, discardedAt: string | null } | { __typename: 'SaveView' } }> } | null };

export type CreateTableLikeRollupFieldSourceListTabFragment = { __typename?: 'TabResult', id: string, pageResult: { __typename: 'BlockPageList' } | { __typename: 'Campaign' } | { __typename: 'CompanyListItem', id: string, name: string, discardedAt: string | null } | { __typename: 'EmbedUrl' } | { __typename: 'GenericList', id: string, title: string, discardedAt: string | null } | { __typename: 'KeyActivityList', id: string, name: string, discardedAt: string | null } | { __typename: 'List', id: string, name: string, discardedAt: string | null } | { __typename: 'SaveView' } };

export type RollupColumnsSelectFieldQueryVariables = Exact<{
  projectUid: Scalars['ID']['input'];
  sourceType?: InputMaybe<SourceTypeEnum>;
  sourceListType?: InputMaybe<TableLikeRollupSourceListTypeEnum>;
  sourceListId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RollupColumnsSelectFieldQuery = { __typename?: 'Query', tableLikeRollupColumns: { __typename?: 'TableLikeRollupColumnsEntries', columns: Array<{ __typename?: 'TableLikeRollupColumn', id: string, name: string, valueType: ValueTypeEnum }> } };

export type RollupColumnsSelectFieldOptionFragment = { __typename?: 'TableLikeRollupColumn', id: string, name: string, valueType: ValueTypeEnum };

export type ReceivedReferralsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReceivedReferralsQuery = { __typename?: 'Query', companyGoals: { __typename?: 'CompanyGoalList', entries: Array<{ __typename?: 'CompanyGoal', id: string, trackingNumber: string, title: string | null, tags: Array<string>, date: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string, industryNames: Array<string> | null }, companyType: { __typename?: 'CompanyCustomType', typeName: string, id: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', typeName: string, id: string }>, last: { __typename?: 'LastAts', lastInteraction: string | null } }, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null }, office: { __typename?: 'Office', name: string } | null, department: { __typename?: 'Department', name: string } | null } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null } }>, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ReceivedReferralGridFragment = { __typename?: 'CompanyGoal', id: string, trackingNumber: string, title: string | null, tags: Array<string>, date: string | null, proposedFeeAmount: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null, customStatus: { __typename?: 'OpportunityTrackingCustomStatus', id: string, name: string, outcome: string, position: number, startingStatus: boolean } | null, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string, industryNames: Array<string> | null }, companyType: { __typename?: 'CompanyCustomType', typeName: string, id: string }, companyTypes: Array<{ __typename?: 'CompanyCustomType', typeName: string, id: string }>, last: { __typename?: 'LastAts', lastInteraction: string | null } }, contactLast: { __typename?: 'LastAts', id: string, interactionAt: string | null } | null, internalContact: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null }, office: { __typename?: 'Office', name: string } | null, department: { __typename?: 'Department', name: string } | null } | null, includedLawyers: Array<{ __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null } }>, keyContacts: Array<{ __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, imageUrl: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, location: { __typename?: 'Location', city: string | null, country: { __typename?: 'Country', name: string } | null } | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null }> | null, customFields: Array<{ __typename?: 'CustomField', name: string, id: string, schemaId: string, valueTypeEnum: CustomFieldSchemaValue | null, value: { __typename: 'CustomFieldCompany', companies: Array<{ __typename?: 'CompanyForCustomField', id: string, domain: string | null, logoUrl: string | null, info: { __typename?: 'CompanyInfoForCustomField', name: string } }> | null } | { __typename: 'CustomFieldContact', contacts: Array<{ __typename?: 'ContactForCustomField', id: string, primaryEmail: any | null, isKeyContact: boolean, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldDate', dateValue: string | null } | { __typename: 'CustomFieldEmployee', employee: { __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } } | null } | { __typename: 'CustomFieldFullDateTime', dateTime: string | null } | { __typename: 'CustomFieldMoney', moneyValue: { __typename?: 'Money', cents: string, format: string, currency: { __typename?: 'Currency', symbol: string, symbolFirst: boolean, thousandsSeparator: string, decimalMark: string, isoCode: CurrencyCode, exponent: number } } | null } | { __typename: 'CustomFieldMulti', multiOption: Array<{ __typename?: 'Option', id: string, value: string, colour: AccountColour }> | null } | { __typename: 'CustomFieldMultiCountry', countries: Array<{ __typename?: 'Country', name: string, emojiFlag: string, code: CountryCode }> | null } | { __typename: 'CustomFieldMultiEmployee', employees: Array<{ __typename?: 'EmployeeForCustomField', id: string, email: string, info: { __typename?: 'ContactInfoForCustomField', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null } }> | null } | { __typename: 'CustomFieldNumber', numberValue: string | null } | { __typename: 'CustomFieldOptional', option: { __typename?: 'Option', id: string, value: string, colour: AccountColour } | null } | { __typename: 'CustomFieldRichText', richContent: { __typename?: 'RichContent', html: string, plainText: string, trixHtml: string } } | { __typename: 'CustomFieldString', stringValue: string | null } | { __typename: 'CustomFieldTimeRange' } | null }>, referralSource: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', firstName: string | null, lastName: string | null, location: { __typename?: 'Location', country: { __typename?: 'Country', name: string } | null } | null }, company: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } | null };

export type GenerateJwtMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateJwtMutation = { __typename?: 'Mutation', generateJwt: { __typename?: 'GenerateJwtMutationPayload', expiresAt: string | null, token: string | null, failReasons: Array<string> | null } | null };

export type JwtAudienceQueryVariables = Exact<{ [key: string]: never; }>;


export type JwtAudienceQuery = { __typename?: 'Query', jwtAudience: { __typename?: 'JwtAudience', nexlAi: string, nexl360: string } };

export type CreateResearchReportMutationVariables = Exact<{
  title: Scalars['String']['input'];
  researchReportableId: Scalars['ID']['input'];
  researchReportableType: ResearchReportableTypeEnum;
}>;


export type CreateResearchReportMutation = { __typename?: 'Mutation', createResearchReport: { __typename?: 'CreateReportMutationPayload', failReasons: Array<string>, report: { __typename?: 'ResearchReport', id: string } | null } | null };

export type CreateResearchReportSectionMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  attributes: ResearchReportSectionAttributes;
}>;


export type CreateResearchReportSectionMutation = { __typename?: 'Mutation', createResearchReportSection: { __typename?: 'CreateReportSectionMutationPayload', failReasons: Array<string>, reportSection: { __typename?: 'ResearchReportSection', id: string, title: string, position: number, sectionType: ResearchReportSectionTypeEnum, status: ResearchReportSectionStatusEnum, htmlForEditor: string, renderSafeHtml: string, nexlSearchType: ResearchReportSectionNexlSearchTypeEnum, webSearchType: ResearchReportSectionWebSearchTypeEnum, aiPrompt: string, isDiscarded: boolean, urlSources: Array<string>, fileSource: { __typename?: 'File', name: string, fileUuid: string, url: string, contentType: string | null } | null } | null } | null };

export type DeleteResearchReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type DeleteResearchReportMutation = { __typename?: 'Mutation', deleteResearchReport: { __typename?: 'DeleteReportMutationPayload', failReasons: Array<string>, report: { __typename?: 'ResearchReport', id: string, isDiscarded: boolean } | null } | null };

export type DeleteResearchReportSectionMutationVariables = Exact<{
  reportSectionId: Scalars['ID']['input'];
}>;


export type DeleteResearchReportSectionMutation = { __typename?: 'Mutation', deleteResearchReportSection: { __typename?: 'DeleteReportSectionMutationPayload', failReasons: Array<string>, reportSection: { __typename?: 'ResearchReportSection', id: string, isDiscarded: boolean } | null } | null };

export type ResearchReportsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  researchReportableId?: InputMaybe<Scalars['ID']['input']>;
  researchReportableType?: InputMaybe<ResearchReportableTypeEnum>;
}>;


export type ResearchReportsQuery = { __typename?: 'Query', researchReports: { __typename?: 'ResearchReportEntries', entries: Array<{ __typename?: 'ResearchReport', id: string, title: string, createdAt: string, updatedAt: string, status: ResearchReportStatusEnum, isDiscarded: boolean, creator: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, displayName: string, imageUrl: string | null } } | null } }>, pageInfo: { __typename?: 'PagingInfo', totalEntries: number } } };

export type ResearchReportGridFragment = { __typename?: 'ResearchReport', id: string, title: string, createdAt: string, updatedAt: string, status: ResearchReportStatusEnum, isDiscarded: boolean, creator: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, displayName: string, imageUrl: string | null } } | null } };

export type ResearchReportCreatorEmployeeFragment = { __typename?: 'Employee', id: string, email: string, info: { __typename?: 'ContactInfo', id: string | null, displayName: string, imageUrl: string | null } };

export type GetContactForCreatorQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type GetContactForCreatorQuery = { __typename?: 'Query', user: { __typename?: 'UserResponse', info: { __typename?: 'UserInfo', employee: { __typename?: 'Employee', contact: { __typename?: 'Contact', id: string, primaryEmail: any | null, isArchived: boolean, isKeyContact: boolean, changedJob: boolean, isActive: boolean, info: { __typename?: 'ContactInfo', id: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, imageUrl: string | null }, bounce: { __typename?: 'BounceCount', id: string, count: number, isLimitReached: boolean } | null, contactCompanySwitch: { __typename?: 'ContactCompanySwitch', id: string, knownDetail: CompanySwitchKnownDetail | null } | null } } | null } } | null };

export type ResearchReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResearchReportQuery = { __typename?: 'Query', researchReport: { __typename?: 'ResearchReport', id: string, title: string, createdAt: string, updatedAt: string, status: ResearchReportStatusEnum, sections: Array<{ __typename?: 'ResearchReportSection', id: string, title: string, position: number, sectionType: ResearchReportSectionTypeEnum, status: ResearchReportSectionStatusEnum, htmlForEditor: string, renderSafeHtml: string, nexlSearchType: ResearchReportSectionNexlSearchTypeEnum, webSearchType: ResearchReportSectionWebSearchTypeEnum, aiPrompt: string, isDiscarded: boolean, urlSources: Array<string>, fileSource: { __typename?: 'File', name: string, fileUuid: string, url: string, contentType: string | null } | null }>, researchReportable: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } } | null, creator: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, info: { __typename?: 'ContactInfo', id: string | null, displayName: string } } | null } } | null };

export type ResearchReportFragment = { __typename?: 'ResearchReport', id: string, title: string, createdAt: string, updatedAt: string, status: ResearchReportStatusEnum, sections: Array<{ __typename?: 'ResearchReportSection', id: string, title: string, position: number, sectionType: ResearchReportSectionTypeEnum, status: ResearchReportSectionStatusEnum, htmlForEditor: string, renderSafeHtml: string, nexlSearchType: ResearchReportSectionNexlSearchTypeEnum, webSearchType: ResearchReportSectionWebSearchTypeEnum, aiPrompt: string, isDiscarded: boolean, urlSources: Array<string>, fileSource: { __typename?: 'File', name: string, fileUuid: string, url: string, contentType: string | null } | null }>, researchReportable: { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } } | null, creator: { __typename?: 'User', id: string, employee: { __typename?: 'Employee', id: string, info: { __typename?: 'ContactInfo', id: string | null, displayName: string } } | null } };

export type ResearchReportSectionFragment = { __typename?: 'ResearchReportSection', id: string, title: string, position: number, sectionType: ResearchReportSectionTypeEnum, status: ResearchReportSectionStatusEnum, htmlForEditor: string, renderSafeHtml: string, nexlSearchType: ResearchReportSectionNexlSearchTypeEnum, webSearchType: ResearchReportSectionWebSearchTypeEnum, aiPrompt: string, isDiscarded: boolean, urlSources: Array<string>, fileSource: { __typename?: 'File', name: string, fileUuid: string, url: string, contentType: string | null } | null };

export type ResearchReportableUnionFragment = { __typename?: 'Company', id: string, domain: string | null, info: { __typename?: 'CompanyInfo', name: string } };

export type UpdateResearchReportSectionPositionsMutationVariables = Exact<{
  reportUid: Scalars['ID']['input'];
  reportSectionUids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateResearchReportSectionPositionsMutation = { __typename?: 'Mutation', updateResearchReportSectionPositions: { __typename?: 'UpdateReportSectionPositionsMutationPayload', failReasons: Array<string>, reportSections: Array<{ __typename?: 'ResearchReportSection', id: string, title: string, position: number }> | null } | null };

export type UpdateResearchReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResearchReportStatusEnum>;
}>;


export type UpdateResearchReportMutation = { __typename?: 'Mutation', updateResearchReport: { __typename?: 'UpdateReportMutationPayload', failReasons: Array<string>, report: { __typename?: 'ResearchReport', id: string, title: string, status: ResearchReportStatusEnum } | null } | null };

export type UpdateResearchReportSectionMutationVariables = Exact<{
  reportSectionId: Scalars['ID']['input'];
  attributes: ResearchReportSectionAttributes;
}>;


export type UpdateResearchReportSectionMutation = { __typename?: 'Mutation', updateResearchReportSection: { __typename?: 'UpdateReportSectionMutationPayload', failReasons: Array<string>, reportSection: { __typename?: 'ResearchReportSection', id: string, title: string, position: number, sectionType: ResearchReportSectionTypeEnum, status: ResearchReportSectionStatusEnum, htmlForEditor: string, renderSafeHtml: string, nexlSearchType: ResearchReportSectionNexlSearchTypeEnum, webSearchType: ResearchReportSectionWebSearchTypeEnum, aiPrompt: string, isDiscarded: boolean, urlSources: Array<string>, fileSource: { __typename?: 'File', name: string, fileUuid: string, url: string, contentType: string | null } | null } | null } | null };

export const RollupFieldBlockTableRowFragmentDoc = gql`
    fragment RollupFieldBlockTableRow on TableLikeRollupFieldType {
  id
  name
  sourceListName
  currentValue
  sourceType
}
    `;
export const BlockPagePagesFragmentDoc = gql`
    fragment BlockPagePages on BlockPage {
  id
  name
  iconCode
  discardedAt
  position
}
    `;
export const CommentPreviewFragmentDoc = gql`
    fragment CommentPreview on Comment {
  id
  htmlForEditor
  renderSafeHtml
  edited
  createdAt
  discardedAt
  creator {
    id
    employee {
      id
      email
      info {
        id
        firstName
        lastName
        imageUrl
      }
    }
  }
}
    `;
export const UserCellContentFragmentDoc = gql`
    fragment UserCellContent on UserCard {
  id
  email
  firstName
  lastName
  imageUrl
}
    `;
export const UserCellFragmentDoc = gql`
    fragment UserCell on UserCell {
  userCard {
    ...UserCellContent
  }
}
    ${UserCellContentFragmentDoc}`;
export const ContactCellContentFragmentDoc = gql`
    fragment ContactCellContent on ContactCard {
  id
  primaryEmail
  firstName
  lastName
  imageUrl
}
    `;
export const ContactCellFragmentDoc = gql`
    fragment ContactCell on ContactCell {
  contactCard {
    ...ContactCellContent
  }
}
    ${ContactCellContentFragmentDoc}`;
export const CompanyCellContentFragmentDoc = gql`
    fragment CompanyCellContent on CompanyCard {
  id
  logoUrl
  name
  domain
}
    `;
export const CompanyCellFragmentDoc = gql`
    fragment CompanyCell on CompanyCell {
  companyCard {
    ...CompanyCellContent
  }
}
    ${CompanyCellContentFragmentDoc}`;
export const CountryCellContentFragmentDoc = gql`
    fragment CountryCellContent on Country {
  emojiFlag
  name
  code
}
    `;
export const CountryCellFragmentDoc = gql`
    fragment CountryCell on CountryCell {
  country {
    ...CountryCellContent
  }
}
    ${CountryCellContentFragmentDoc}`;
export const RichTextCellContentFragmentDoc = gql`
    fragment RichTextCellContent on RichContent {
  html
  trixHtml
  plainText
}
    `;
export const RichTextCellFragmentDoc = gql`
    fragment RichTextCell on RichTextCell {
  richText {
    ...RichTextCellContent
  }
}
    ${RichTextCellContentFragmentDoc}`;
export const CurrencyCellContentFragmentDoc = gql`
    fragment CurrencyCellContent on Money {
  cents
  format
  currency {
    name
    symbol
    isoCode
    exponent
    decimalMark
    symbolFirst
    thousandsSeparator
  }
}
    `;
export const CurrencyCellFragmentDoc = gql`
    fragment CurrencyCell on CurrencyCell {
  money {
    ...CurrencyCellContent
  }
}
    ${CurrencyCellContentFragmentDoc}`;
export const EmployeeCellContentFragmentDoc = gql`
    fragment EmployeeCellContent on EmployeeGrid {
  id
  departmentName
  officeName
  jobTitle
  imageUrl
  firstName
  lastName
  email
}
    `;
export const EmployeeCellFragmentDoc = gql`
    fragment EmployeeCell on EmployeeCell {
  employeeCard {
    ...EmployeeCellContent
  }
}
    ${EmployeeCellContentFragmentDoc}`;
export const LocationInfoContentFragmentDoc = gql`
    fragment LocationInfoContent on MyListLocationInfo {
  displayName
  locationTyped
}
    `;
export const ListCellFragmentDoc = gql`
    fragment ListCell on ListCell {
  listCard {
    id
    name
    locationInfo {
      ...LocationInfoContent
    }
  }
}
    ${LocationInfoContentFragmentDoc}`;
export const TableCellValueFragmentDoc = gql`
    fragment TableCellValue on TableCellValue {
  __typename
  ... on NullCell {
    isNull
    objectClass
  }
  ... on TextCell {
    text
  }
  ... on IntegerCell {
    integer
  }
  ... on DateTimeCell {
    dateTime
  }
  ... on DateOnlyCell {
    date
  }
  ... on UserCell {
    ...UserCell
  }
  ... on ContactCell {
    ...ContactCell
  }
  ... on CompanyCell {
    ...CompanyCell
  }
  ... on CountryCell {
    ...CountryCell
  }
  ... on RichTextCell {
    ...RichTextCell
  }
  ... on EmailCell {
    email
  }
  ... on CurrencyCell {
    ...CurrencyCell
  }
  ... on EmployeeCell {
    ...EmployeeCell
  }
  ... on ListCell {
    ...ListCell
  }
}
    ${UserCellFragmentDoc}
${ContactCellFragmentDoc}
${CompanyCellFragmentDoc}
${CountryCellFragmentDoc}
${RichTextCellFragmentDoc}
${CurrencyCellFragmentDoc}
${EmployeeCellFragmentDoc}
${ListCellFragmentDoc}`;
export const ColumnDefinitionFragmentDoc = gql`
    fragment ColumnDefinition on Column {
  id
  name
  filterOperations
  columnValueSuggestions
  orderable
  multiple
  valueType
  groupName
  optionChoices {
    id
    value
    colour
    orderRank
  }
  updateable
  filterOnly
  useSnakeCase
  emsAccessible
}
    `;
export const TableLikeDefinitionFragmentDoc = gql`
    fragment TableLikeDefinition on TableLikeDefinition {
  id
  columns {
    ...ColumnDefinition
  }
  exportable
  deleteable
  searchable
  updatable
}
    ${ColumnDefinitionFragmentDoc}`;
export const CompanyOfficeLocationCellFragmentDoc = gql`
    fragment CompanyOfficeLocationCell on CompanyOfficeLocationCell {
  locationCard {
    id
    brief
  }
}
    `;
export const TableCellFragmentDoc = gql`
    fragment TableCell on TableCell {
  id
  column {
    id
    name
    filterOperations
    columnValueSuggestions
    orderable
    multiple
    valueType
    optionChoices {
      id
      value
      colour
      orderRank
    }
    updateable
  }
  values {
    ... on NullCell {
      isNull
      objectClass
    }
    ... on TextCell {
      text
    }
    ... on IntegerCell {
      integer
    }
    ... on DateTimeCell {
      dateTime
    }
    ... on DateOnlyCell {
      date
    }
    ... on UserCell {
      ...UserCell
    }
    ... on ContactCell {
      ...ContactCell
    }
    ... on CompanyCell {
      ...CompanyCell
    }
    ... on CountryCell {
      ...CountryCell
    }
    ... on RichTextCell {
      ...RichTextCell
    }
    ... on EmailCell {
      email
    }
    ... on CurrencyCell {
      ...CurrencyCell
    }
    ... on EmployeeCell {
      ...EmployeeCell
    }
    ... on CompanyOfficeLocationCell {
      ...CompanyOfficeLocationCell
    }
  }
}
    ${UserCellFragmentDoc}
${ContactCellFragmentDoc}
${CompanyCellFragmentDoc}
${CountryCellFragmentDoc}
${RichTextCellFragmentDoc}
${CurrencyCellFragmentDoc}
${EmployeeCellFragmentDoc}
${CompanyOfficeLocationCellFragmentDoc}`;
export const TableRowFragmentDoc = gql`
    fragment TableRow on TableLikeRow {
  id
  cells {
    ...TableCell
  }
}
    ${TableCellFragmentDoc}`;
export const StaffInvolvedFragmentDoc = gql`
    fragment StaffInvolved on Employee {
  id
  email
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
}
    `;
export const ContactInvolvedFragmentDoc = gql`
    fragment ContactInvolved on Contact {
  id
  primaryEmail
  isKeyContact
  info {
    id
    firstName
    lastName
    imageUrl
  }
}
    `;
export const RebuildKeyActivityFragmentDoc = gql`
    fragment RebuildKeyActivity on KeyActivity {
  id
  category
  activityTitle
  description
  interactionOn
  interactionEndAt
  staffInvolved {
    ...StaffInvolved
  }
  contactsInvolved {
    ...ContactInvolved
  }
  notes {
    plainText
    html
    trixHtml
  }
  keyActivityListMember {
    id
  }
}
    ${StaffInvolvedFragmentDoc}
${ContactInvolvedFragmentDoc}`;
export const StatusBadgeFragmentDoc = gql`
    fragment StatusBadge on Contact {
  isActive: interactionsIsEngaged
  isArchived
  isKeyContact
  changedJob
  bounce: interactionsBounce {
    id
    count
    isLimitReached
  }
  contactCompanySwitch {
    id
    knownDetail
  }
}
    `;
export const FullAddressFragmentDoc = gql`
    fragment FullAddress on Location {
  id
  streetAddress
  city
  state
  postCode
  country {
    name
    code
    emojiFlag
  }
}
    `;
export const EmployeeCustomFieldPreviewFragmentDoc = gql`
    fragment EmployeeCustomFieldPreview on EmployeeForCustomField {
  id
  email
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
}
    `;
export const ContactCustomFieldPreviewFragmentDoc = gql`
    fragment ContactCustomFieldPreview on ContactForCustomField {
  id
  primaryEmail
  isKeyContact
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
}
    `;
export const CompanyCustomFieldPreviewFragmentDoc = gql`
    fragment CompanyCustomFieldPreview on CompanyForCustomField {
  id
  domain
  logoUrl
  info {
    name
  }
}
    `;
export const MoneyPreviewFragmentDoc = gql`
    fragment MoneyPreview on Money {
  cents
  format
  currency {
    symbol
    symbolFirst
    thousandsSeparator
    decimalMark
    isoCode
    exponent
  }
}
    `;
export const CountryPreviewFragmentDoc = gql`
    fragment CountryPreview on Country {
  name
  emojiFlag
  code
}
    `;
export const CustomFieldValueFragmentDoc = gql`
    fragment CustomFieldValue on CustomFieldValue {
  __typename
  ... on CustomFieldString {
    stringValue
  }
  ... on CustomFieldNumber {
    numberValue
  }
  ... on CustomFieldDate {
    dateValue
  }
  ... on CustomFieldOptional {
    option {
      id
      value
      colour
    }
  }
  ... on CustomFieldMulti {
    multiOption {
      id
      value
      colour
    }
  }
  ... on CustomFieldRichText {
    richContent {
      html
      plainText
      trixHtml
    }
  }
  ... on CustomFieldEmployee {
    employee {
      ...EmployeeCustomFieldPreview
    }
  }
  ... on CustomFieldMultiEmployee {
    employees {
      ...EmployeeCustomFieldPreview
    }
  }
  ... on CustomFieldContact {
    contacts {
      ...ContactCustomFieldPreview
    }
  }
  ... on CustomFieldCompany {
    companies {
      ...CompanyCustomFieldPreview
    }
  }
  ... on CustomFieldMoney {
    moneyValue {
      ...MoneyPreview
    }
  }
  ... on CustomFieldMultiCountry {
    countries {
      ...CountryPreview
    }
  }
  ... on CustomFieldFullDateTime {
    dateTime
  }
}
    ${EmployeeCustomFieldPreviewFragmentDoc}
${ContactCustomFieldPreviewFragmentDoc}
${CompanyCustomFieldPreviewFragmentDoc}
${MoneyPreviewFragmentDoc}
${CountryPreviewFragmentDoc}`;
export const CustomFieldFragmentDoc = gql`
    fragment CustomField on CustomField {
  name
  id
  schemaId
  value {
    ...CustomFieldValue
  }
  valueTypeEnum
}
    ${CustomFieldValueFragmentDoc}`;
export const PersonContactFragmentDoc = gql`
    fragment PersonContact on Contact {
  id
  company {
    id
    domain
    domains
    info {
      id
      name
    }
  }
  interactionsLast {
    id
    interactionAt
  }
  id
  isPersonal
  isEmployee
  primaryEmail
  ...StatusBadge
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    location {
      ...FullAddress
    }
    phoneNumbers
    linkedinUrl
    twitterUrl
    educations
    tags
    customFields {
      ...CustomField
    }
    displayName
  }
  emailAddresses
}
    ${StatusBadgeFragmentDoc}
${FullAddressFragmentDoc}
${CustomFieldFragmentDoc}`;
export const PersonPreviewFragmentDoc = gql`
    fragment PersonPreview on Person {
  id
  contacts {
    ...PersonContact
  }
}
    ${PersonContactFragmentDoc}`;
export const CustomObjectsImporterTemplateFragmentDoc = gql`
    fragment CustomObjectsImporterTemplate on DataTemplate {
  id
}
    `;
export const OpportunityTrackingCustomStatusFragmentDoc = gql`
    fragment OpportunityTrackingCustomStatus on OpportunityTrackingCustomStatus {
  id
  name
  outcome
  position
  startingStatus
}
    `;
export const EmployeePreviewFragmentDoc = gql`
    fragment EmployeePreview on Employee {
  id
  email
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
}
    `;
export const KeyContactFragmentDoc = gql`
    fragment KeyContact on Contact {
  id
  primaryEmail
  ...StatusBadge
  info {
    id
    imageUrl
    firstName
    lastName
    jobTitle
    location {
      city
      country {
        name
      }
    }
  }
}
    ${StatusBadgeFragmentDoc}`;
export const ContactAvatarFragmentDoc = gql`
    fragment ContactAvatar on Contact {
  id
  primaryEmail
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
  ...StatusBadge
}
    ${StatusBadgeFragmentDoc}`;
export const ContactPreviewFragmentDoc = gql`
    fragment ContactPreview on Contact {
  id
  ...ContactAvatar
}
    ${ContactAvatarFragmentDoc}`;
export const AdminCompanyGoalRowFragmentDoc = gql`
    fragment AdminCompanyGoalRow on CompanyGoal {
  id
  proposedFeeAmount {
    ...MoneyPreview
  }
  date
  customStatus {
    ...OpportunityTrackingCustomStatus
  }
  contactLast {
    id
    interactionAt
  }
  company {
    domain
    id
    companyType {
      typeName
      id
    }
    companyTypes {
      typeName
      id
    }
    logoUrl
    info {
      id
      name
      industryNames
      internalIndustries {
        id
        name
      }
    }
    last: interactionsLast {
      id
      meetingAt
      sentEmailAt
      receivedEmailAt
      interactionAt
      lastInteraction: interactionAt
    }
    monthlyEngagement {
      interactionCount
      month
    }
  }
  tags
  internalContact: assignedTo {
    ...EmployeePreview
    department {
      id
      name
    }
    office {
      id
      name
    }
  }
  trackingNumber
  customFields {
    ...CustomField
  }
  title
  keyContacts {
    ...KeyContact
  }
  includedLawyers {
    ...EmployeePreview
  }
  receivedReferral
  referralSource {
    ...ContactPreview
    ...StatusBadge
    company {
      id
      domain
      info {
        id
        name
      }
    }
  }
}
    ${MoneyPreviewFragmentDoc}
${OpportunityTrackingCustomStatusFragmentDoc}
${EmployeePreviewFragmentDoc}
${CustomFieldFragmentDoc}
${KeyContactFragmentDoc}
${ContactPreviewFragmentDoc}
${StatusBadgeFragmentDoc}`;
export const CompanyPreviewFragmentDoc = gql`
    fragment CompanyPreview on Company {
  id
  domain
  logoUrl
  info {
    id
    name
  }
}
    `;
export const ArchivedContactRowFragmentDoc = gql`
    fragment ArchivedContactRow on Contact {
  id
  primaryEmail
  ...StatusBadge
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
  nextCompanyContact {
    contact {
      id
    }
    company {
      ...CompanyPreview
    }
    companyName
  }
  interactionsTotal {
    id
    interactions
  }
  interactionsLast {
    id
    interactionAt
  }
}
    ${StatusBadgeFragmentDoc}
${CompanyPreviewFragmentDoc}`;
export const CareerCompanyFragmentDoc = gql`
    fragment CareerCompany on CareerCompany {
  id
  company {
    ...CompanyPreview
  }
  companyName
  jobTitles {
    id
    name
    startDate
    endDate
  }
}
    ${CompanyPreviewFragmentDoc}`;
export const CompanyDocumentOverviewFragmentDoc = gql`
    fragment CompanyDocumentOverview on CompanyDocument {
  id
  name
  url
  file {
    url
    contentType
  }
}
    `;
export const CompanyNoteFragmentDoc = gql`
    fragment CompanyNote on CompanyNote {
  id
  richContent: content {
    html
    trixHtml
  }
  access
  createdAt
  company {
    id
    logoUrl
    info {
      id
      name
    }
    domain
  }
  contact {
    ...ContactPreview
  }
  creator {
    firstName
    lastName
    email
  }
  updatedAt
  updater {
    firstName
    lastName
    email
  }
}
    ${ContactPreviewFragmentDoc}`;
export const CompanyProfileRowFragmentDoc = gql`
    fragment CompanyProfileRow on CompanyProfile {
  id
  jobTitle
  linkedinUrl
  location
  name
  profileImgUrl
  profileEmail
  prospectEmailRequest {
    status
    id
  }
}
    `;
export const CurrencyFragmentDoc = gql`
    fragment Currency on Currency {
  symbol
  symbolFirst
  name
  isoCode
  thousandsSeparator
  decimalMark
  exponent
}
    `;
export const MembershipCompanyListFragmentDoc = gql`
    fragment MembershipCompanyList on CompanyListItem {
  id
  name
  usageMode
  tabUid
  project {
    id
    nexlApps
  }
}
    `;
export const EngagementOverviewFragmentDoc = gql`
    fragment EngagementOverview on Company {
  openOpportunityCount
  pendingTaskCount
  upcomingMeetingCount
  monthlyEngagement {
    interactionCount
    month
  }
  id
}
    `;
export const OpportunityItemCompanyFragmentDoc = gql`
    fragment OpportunityItemCompany on Company {
  id
  logoUrl
  info {
    id
    name
  }
  last: interactionsLast {
    id
    lastInteraction: interactionAt
  }
  ...EngagementOverview
}
    ${EngagementOverviewFragmentDoc}`;
export const OpportunityItemFragmentDoc = gql`
    fragment OpportunityItem on CompanyGoal {
  id
  title
  proposed: proposedFeeAmount {
    fee: format
    cents
    currency {
      symbol
      symbolFirst
      thousandsSeparator
    }
  }
  company {
    ...OpportunityItemCompany
  }
  contactLast {
    id
    interactionAt
  }
}
    ${OpportunityItemCompanyFragmentDoc}`;
export const MyCustomBoardItemFragmentDoc = gql`
    fragment MyCustomBoardItem on CustomBoardItem {
  index
  opportunity {
    ...OpportunityItem
  }
}
    ${OpportunityItemFragmentDoc}`;
export const MyCustomBoardColumnFragmentDoc = gql`
    fragment MyCustomBoardColumn on CustomBoardColumn {
  count
  customStatus {
    id
    name
    position
    outcome
    startingStatus
  }
  displayLimitExceeded
  items {
    ...MyCustomBoardItem
  }
  totalProposedFees {
    ...MoneyPreview
  }
}
    ${MyCustomBoardItemFragmentDoc}
${MoneyPreviewFragmentDoc}`;
export const MyStayInTouchRowFragmentDoc = gql`
    fragment MyStayInTouchRow on MyStayInTouch {
  contact {
    id
    interactionMaximum {
      lastAt
    }
    contact {
      ...ContactPreview
      company {
        ...CompanyPreview
      }
    }
  }
  frequency
  id
  interactionDueDate
  overDue
}
    ${ContactPreviewFragmentDoc}
${CompanyPreviewFragmentDoc}`;
export const ProspectRowFragmentDoc = gql`
    fragment ProspectRow on Company {
  domain
  id
  interactionsLast {
    id
    lastInteraction: interactionAt
  }
  internalContact: relationshipPartner {
    id
    email
    info {
      id
      firstName
      lastName
      imageUrl
    }
  }
  logoUrl
  info {
    id
    name
    industryNames
    primaryLocation {
      location {
        country {
          name
        }
      }
    }
  }
  openOpportunityCount
  pendingTaskCount
  upcomingMeetingCount
  monthlyEngagement {
    interactionCount
    month
  }
}
    `;
export const SearchProspectRowFragmentDoc = gql`
    fragment SearchProspectRow on Prospect {
  domain
  country
  industry
  name
  headCount
  company {
    id
  }
  linkedinUrl
}
    `;
export const SearchResultCompanyFragmentDoc = gql`
    fragment SearchResultCompany on Company {
  domain
  id
  logoUrl
  info {
    id
    name
  }
}
    `;
export const SearchResultContactFragmentDoc = gql`
    fragment SearchResultContact on Contact {
  id
  primaryEmail
  ...StatusBadge
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
  company {
    info {
      id
      name
    }
  }
}
    ${StatusBadgeFragmentDoc}`;
export const SearchResultFragmentDoc = gql`
    fragment SearchResult on SearchResult {
  ... on Company {
    ...SearchResultCompany
  }
  ... on Contact {
    ...SearchResultContact
  }
}
    ${SearchResultCompanyFragmentDoc}
${SearchResultContactFragmentDoc}`;
export const ParticipantFragmentDoc = gql`
    fragment Participant on InteractionParticipant {
  id
  email
  role
  contact {
    id
    emailAddresses
    isEmployee
    info {
      id
      firstName
      lastName
      jobTitle
      imageUrl
    }
  }
}
    `;
export const ContactNamePreviewFragmentDoc = gql`
    fragment ContactNamePreview on Contact {
  id
  primaryEmail
  info {
    id
    firstName
    lastName
  }
}
    `;
export const InteractionDetailTimelinePreviewFragmentDoc = gql`
    fragment InteractionDetailTimelinePreview on KeyActivity {
  id
  category
  activityTitle
  description
  interactionOn
  interactionEndAt
  notes {
    html
    trixHtml
  }
  interaction {
    id
    webLink
    direction
    sender {
      ...ContactNamePreview
    }
    receivers {
      ...ContactNamePreview
    }
    interactionType
    occuredAt
  }
}
    ${ContactNamePreviewFragmentDoc}`;
export const InteractionFragmentDoc = gql`
    fragment Interaction on Interaction {
  id
  occuredAt
  occuredEndAt
  interactionType
  direction
  participants {
    ...Participant
  }
  webLink
  keyActivity {
    ...InteractionDetailTimelinePreview
  }
}
    ${ParticipantFragmentDoc}
${InteractionDetailTimelinePreviewFragmentDoc}`;
export const EventItemByTypeFragmentDoc = gql`
    fragment EventItemByType on EventItem {
  ... on Interaction {
    ...Interaction
  }
}
    ${InteractionFragmentDoc}`;
export const TimelineEventEntryFragmentDoc = gql`
    fragment TimelineEventEntry on TimelineEvent {
  action
  atTime
  comment
  __typename
  id
  item {
    ...EventItemByType
  }
}
    ${EventItemByTypeFragmentDoc}`;
export const EventPackResponseFragmentDoc = gql`
    fragment EventPackResponse on EventPackResponse {
  id
  email
  linkedinPost
  website
}
    `;
export const LinkedinPostResponseFragmentDoc = gql`
    fragment LinkedinPostResponse on LinkedinPostResponse {
  id
  postResponse
}
    `;
export const MarketingEmailResponseFragmentDoc = gql`
    fragment MarketingEmailResponse on MarketingEmailResponse {
  id
  emailResponse
}
    `;
export const BlockPageFragmentDoc = gql`
    fragment BlockPage on BlockPage {
  id
  name
  iconCode
  position
}
    `;
export const SendersAutocompleteFieldFragmentDoc = gql`
    fragment SendersAutocompleteField on Sender {
  id
  email
  replyTo
}
    `;
export const RecipientListOptionFragmentDoc = gql`
    fragment RecipientListOption on List {
  id
  name
  usageMode
  creator {
    firstName
    lastName
    email
  }
  clean {
    id
    status
    cleanEnd
    beenCleaned
  }
  project {
    title
    id
    nexlApps
  }
  tabUid
}
    `;
export const AnalyticsDetailsFragmentDoc = gql`
    fragment AnalyticsDetails on CampaignAnalytics {
  percentDelivered
  percentOpened
  percentClicked
  percentUnsubscribed
  percentSkipped
  percentFailed
  percentComplained
  totalFailed
  totalClicked
  totalDelivered
  totalOpened
  totalRecipients
  totalUnsubscribed
  totalSkipped
  totalComplained
  totalAccepted
}
    `;
export const FilePreviewFragmentDoc = gql`
    fragment FilePreview on File {
  name
  url
  contentType
}
    `;
export const RecipientListFilterFragmentDoc = gql`
    fragment RecipientListFilter on CampaignRecipientListFilter {
  id
  conditions
  campaign {
    id
  }
  recipientList {
    id
  }
}
    `;
export const CampaignDetailsFragmentDoc = gql`
    fragment CampaignDetails on Campaign {
  projectUrl
  id
  title
  subject
  templateHtml
  templateJson
  scheduledAt
  status
  usageMode
  continuous
  allowContinuousResend
  sender {
    ...SendersAutocompleteField
  }
  openTracking
  clickTracking
  createdBy {
    email
  }
  recipientList {
    ...RecipientListOption
  }
  analytics {
    ...AnalyticsDetails
  }
  attachment {
    ...FilePreview
  }
  recipientListFilter {
    ...RecipientListFilter
  }
}
    ${SendersAutocompleteFieldFragmentDoc}
${RecipientListOptionFragmentDoc}
${AnalyticsDetailsFragmentDoc}
${FilePreviewFragmentDoc}
${RecipientListFilterFragmentDoc}`;
export const CampaignRecipientFragmentDoc = gql`
    fragment CampaignRecipient on CampaignRecipient {
  emailAddresses
  primaryEmail
  status
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    location {
      city
      country {
        name
      }
    }
  }
  changedJob
  company {
    id
    info {
      id
      name
    }
  }
  isArchived
  bounce: interactionsBounce {
    id
    isLimitReached
  }
  isActive: interactionsIsEngaged
  contactCompanySwitch {
    id
    knownDetail
  }
  interactionsLast {
    id
    interactionAt
  }
  id
}
    `;
export const EmailTemplateFragmentDoc = gql`
    fragment EmailTemplate on Template {
  id
  title
  templateJson
  thumbnail
}
    `;
export const RecipientWarningsFragmentDoc = gql`
    fragment RecipientWarnings on RecipientWarnings {
  firstNameMissingTotal
  lastNameMissingTotal
  bouncedTotal
  consentUnsubscribedTotal
  consentNotGivenTotal
  allRecipientsVerified
  excludedContactsTotal
}
    `;
export const ProjectFormOptionFragmentDoc = gql`
    fragment ProjectFormOption on Form {
  id
  title
}
    `;
export const CreatedByIdFieldOptionFragmentDoc = gql`
    fragment CreatedByIdFieldOption on UserInfo {
  id
  profileName
  profileImageUrl
  email
}
    `;
export const WorkspaceIdFieldOptionFragmentDoc = gql`
    fragment WorkspaceIdFieldOption on Project {
  id
  title
}
    `;
export const CreatedByFragmentDoc = gql`
    fragment CreatedBy on User {
  id
  employee {
    id
    contact {
      id
      isKeyContact
      primaryEmail
      info {
        id
        firstName
        lastName
        imageUrl
      }
    }
    email
    info {
      id
      firstName
      lastName
      imageUrl
    }
  }
}
    `;
export const ProjectPreviewFragmentDoc = gql`
    fragment ProjectPreview on Project {
  colorCode
  iconCode
  title
  id
}
    `;
export const CampaignRowFragmentDoc = gql`
    fragment CampaignRow on Campaign {
  id
  title
  usageMode
  continuous
  createdAt
  status
  createdBy {
    ...CreatedBy
  }
  project {
    ...ProjectPreview
    tabs {
      id
    }
  }
  sentAt
  updatedAt
  scheduledAt
  analytics {
    percentDelivered
    percentOpened
    percentClicked
    totalRecipients
    percentFailed
    percentUnsubscribed
  }
}
    ${CreatedByFragmentDoc}
${ProjectPreviewFragmentDoc}`;
export const TemplateFragmentDoc = gql`
    fragment Template on Template {
  id
  title
  templateJson
  thumbnail
  archivedAt
}
    `;
export const CompanyCustomTypeFragmentDoc = gql`
    fragment CompanyCustomType on CompanyCustomType {
  id
  typeName
  defaultType
}
    `;
export const CompanyOfficeLocationRowFragmentDoc = gql`
    fragment CompanyOfficeLocationRow on CompanyOfficeLocation {
  companyOfficeLocationId
  headquarter
  primary
  location {
    ...FullAddress
  }
  labels
}
    ${FullAddressFragmentDoc}`;
export const CleanerCompanyRowFragmentDoc = gql`
    fragment CleanerCompanyRow on Company {
  domain
  id
  companyType {
    ...CompanyCustomType
  }
  companyTypes {
    ...CompanyCustomType
  }
  archivedAt
  interactionsTotal {
    id
    interactions
  }
  interactionsLast {
    id
    interactionAt
  }
  isBlocked
  logoUrl
  info {
    id
    name
    primaryLocation {
      ...CompanyOfficeLocationRow
    }
    industryNames
  }
}
    ${CompanyCustomTypeFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}`;
export const ArchivedContactCleanerRowFragmentDoc = gql`
    fragment ArchivedContactCleanerRow on Contact {
  id
  emailAddresses
  primaryEmail
  createdAt
  archivedAt
  ...StatusBadge
  unarchiveOnNextInteraction
  isKeyContact
  isPersonal
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    phoneNumbers
    tags
    location {
      ...FullAddress
    }
  }
  changedJob
  company {
    id
    companyType {
      ...CompanyCustomType
    }
    info {
      id
      name
    }
    companyHierarchy {
      hierarchy {
        id
        partOfHierarchy
      }
    }
  }
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    id
    interactions
  }
  id
  marketingListConsent {
    status
  }
}
    ${StatusBadgeFragmentDoc}
${FullAddressFragmentDoc}
${CompanyCustomTypeFragmentDoc}`;
export const DuplicateCompanyPreviewFragmentDoc = gql`
    fragment DuplicateCompanyPreview on Company {
  domain
  id
  contacts
  companyType {
    ...CompanyCustomType
  }
  interactionsLast {
    id
    interactionAt
  }
  logoUrl
  info {
    id
    name
  }
}
    ${CompanyCustomTypeFragmentDoc}`;
export const DuplicateCompaniesRowFragmentDoc = gql`
    fragment DuplicateCompaniesRow on DuplicateCompany {
  id
  duplicate {
    ...DuplicateCompanyPreview
  }
  original {
    ...DuplicateCompanyPreview
  }
}
    ${DuplicateCompanyPreviewFragmentDoc}`;
export const DuplicateContactPreviewFragmentDoc = gql`
    fragment DuplicateContactPreview on Contact {
  ...ContactPreview
  info {
    displayName
  }
  company {
    id
    domain
    info {
      name
    }
  }
  interactionsLast {
    id
    interactionAt
  }
  whoKnows {
    id
  }
}
    ${ContactPreviewFragmentDoc}`;
export const DuplicateContactRowFragmentDoc = gql`
    fragment DuplicateContactRow on DuplicateContact {
  id
  duplicate {
    ...DuplicateContactPreview
  }
  original {
    ...DuplicateContactPreview
  }
}
    ${DuplicateContactPreviewFragmentDoc}`;
export const IncompleteCompanyRowFragmentDoc = gql`
    fragment IncompleteCompanyRow on IncompleteCompany {
  domain
  id
  companyType {
    ...CompanyCustomType
  }
  companyTypes {
    ...CompanyCustomType
  }
  createdAt
  interactionsTotal {
    id
    interactions
  }
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    id
    interactions
  }
  logoUrl
  missing
  info {
    id
    name
    primaryLocation {
      ...CompanyOfficeLocationRow
    }
    industryNames
  }
}
    ${CompanyCustomTypeFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}`;
export const IncompleteContactRowFragmentDoc = gql`
    fragment IncompleteContactRow on IncompleteContact {
  emailAddresses
  primaryEmail
  createdAt
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    location {
      city
      country {
        name
      }
    }
  }
  changedJob
  missing
  isActive: interactionsIsEngaged
  isArchived
  isKeyContact
  bounce: interactionsBounce {
    id
    count
    isLimitReached
  }
  contactCompanySwitch {
    id
    knownDetail
  }
  company {
    id
    companyType {
      ...CompanyCustomType
    }
    info {
      id
      name
    }
  }
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    id
    interactions
  }
  id
}
    ${CompanyCustomTypeFragmentDoc}`;
export const ContactCardAvatarFragmentDoc = gql`
    fragment ContactCardAvatar on ContactCard {
  id
  contactId
  primaryEmail
  firstName
  lastName
  jobTitle
  imageUrl
  companyKeyContactSince
}
    `;
export const IncompleteContactGridRowFragmentDoc = gql`
    fragment IncompleteContactGridRow on IncompleteContact {
  primaryEmail
  createdAt
  updatedAt
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    location {
      ...FullAddress
    }
    tags
  }
  officeLocation {
    ...CompanyOfficeLocationRow
  }
  marketingListConsent {
    id
    status
  }
  company {
    id
    companyType {
      ...CompanyCustomType
    }
    info {
      id
      name
      tags
      industryNames
      internalIndustryNames
    }
    logoUrl
    domain
  }
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    id
    interactions
    meetings
  }
  id
  whoKnows {
    id
    contactCard {
      ...ContactCardAvatar
    }
  }
}
    ${FullAddressFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}
${CompanyCustomTypeFragmentDoc}
${ContactCardAvatarFragmentDoc}`;
export const ContactRequireHierarchyPlacementFragmentDoc = gql`
    fragment ContactRequireHierarchyPlacement on Contact {
  isPersonal
  isEmployee
  emailAddresses
  id
  primaryEmail
  ...StatusBadge
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    interactions
  }
  archivedAt
  info {
    id
    tags
    firstName
    lastName
    jobTitle
    location {
      ...FullAddress
    }
    phoneNumbers
    imageUrl
    twitterUrl
    linkedinUrl
    educations
  }
  changedJob
  company {
    id
    domain
    isInternal
    info {
      id
      name
      primaryLocation {
        ...CompanyOfficeLocationRow
      }
    }
  }
}
    ${StatusBadgeFragmentDoc}
${FullAddressFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}`;
export const UnengagedContactRowFragmentDoc = gql`
    fragment UnengagedContactRow on Contact {
  id
  primaryEmail
  ...StatusBadge
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
  company {
    id
    info {
      id
      name
    }
  }
  interactionsLast {
    id
    interactionAt
  }
}
    ${StatusBadgeFragmentDoc}`;
export const MentionableFragmentDoc = gql`
    fragment Mentionable on UserInfo {
  id
  employee {
    id
    email
    info {
      id
      firstName
      lastName
      imageUrl
      jobTitle
    }
  }
}
    `;
export const MentionableUserFragmentDoc = gql`
    fragment MentionableUser on User {
  id
  employee {
    id
    email
    info {
      id
      firstName
      lastName
      imageUrl
      jobTitle
    }
  }
}
    `;
export const CompanyFormikFieldWithOptionsFragmentDoc = gql`
    fragment CompanyFormikFieldWithOptions on Company {
  id
  domain
  logoUrl
  info {
    id
    name
  }
  companyType {
    id
    typeName
  }
  companyTypes {
    ...CompanyCustomType
  }
  contacts
  interactionsLast {
    id
    interactionAt
  }
}
    ${CompanyCustomTypeFragmentDoc}`;
export const CompanyInfoToUpdateFragmentDoc = gql`
    fragment CompanyInfoToUpdate on CompanyInfo {
  id
  name
  description
  numberOfEmployees
  linkedinUrl
  twitterUrl
  website
  correspondenceNumbers
  correspondenceEmails
  industryNames
  internalIndustries {
    id
    name
  }
  primaryLocation {
    ...CompanyOfficeLocationRow
  }
  tags
}
    ${CompanyOfficeLocationRowFragmentDoc}`;
export const CompanyOverviewFragmentDoc = gql`
    fragment CompanyOverview on CompanyInfo {
  id
  tags
  name
  numberOfEmployees
  description
  primaryLocation {
    ...CompanyOfficeLocationRow
  }
  industryNames
  internalIndustries {
    id
    name
  }
  website
  linkedinUrl
  twitterUrl
  correspondenceNumbers
  correspondenceEmails
}
    ${CompanyOfficeLocationRowFragmentDoc}`;
export const CompanyInsightStatFragmentDoc = gql`
    fragment CompanyInsightStat on InsightStat {
  previousTotalEmails
  previousTotalInteractions
  previousTotalMeetings
  totalEmails
  totalEmailsIncrease
  totalInteractionIncrease
  totalInteractions
  totalMeetings
  totalMeetingsIncrease
  lastInteractionAt
  lastBdInteractionAt
}
    `;
export const CompanyProfileFragmentDoc = gql`
    fragment CompanyProfile on Company {
  id
  domain
  domains
  interactionsTotal {
    id
    interactions
  }
  interactionsLast {
    id
    lastInteraction: interactionAt
  }
  companyType {
    id
    typeName
  }
  companyTypes {
    id
    typeName
  }
  canManageRelationshipPartners
  logoUrl
  info {
    ...CompanyOverview
  }
  insightStat {
    ...CompanyInsightStat
  }
  lastReferralSource {
    ...ContactPreview
  }
  reporting {
    url
  }
  archivedAt
  isInternal
  isSubDomainCompany
  externalIdentifier {
    id
    client
    group
  }
}
    ${CompanyOverviewFragmentDoc}
${CompanyInsightStatFragmentDoc}
${ContactPreviewFragmentDoc}`;
export const CompanyRelationshipPartnerFragmentDoc = gql`
    fragment CompanyRelationshipPartner on RelationshipPartner {
  id
  employee {
    ...EmployeePreview
  }
  interactionsLast {
    interactionAt
  }
  discardedAt
}
    ${EmployeePreviewFragmentDoc}`;
export const CompanySlideProfileFragmentDoc = gql`
    fragment CompanySlideProfile on Company {
  isInternal
  id
  domain
  contacts
  companyType {
    id
    typeName
  }
  companyTypes {
    id
    typeName
  }
  archivedAt
  interactionsLast {
    id
    interactionAt
    meetingAt
  }
  ...EngagementOverview
  logoUrl
  info {
    id
    name
    industryNames
    primaryLocation {
      location {
        country {
          name
        }
      }
    }
  }
}
    ${EngagementOverviewFragmentDoc}`;
export const EmployeeCompanyStatsEntryFragmentDoc = gql`
    fragment EmployeeCompanyStatsEntry on EmployeeCompanyStats {
  employee {
    ...EmployeePreview
  }
  id
  last {
    interactionAt
  }
  total {
    interactions
  }
}
    ${EmployeePreviewFragmentDoc}`;
export const WhoKnowsUserFragmentDoc = gql`
    fragment WhoKnowsUser on WhoKnows {
  id
  lastInteraction
  numberOfInteractions
  contact {
    ...ContactPreview
  }
}
    ${ContactPreviewFragmentDoc}`;
export const MostActiveContactTableRowFragmentDoc = gql`
    fragment MostActiveContactTableRow on Contact {
  id
  primaryEmail
  emailAddresses
  isEmployee
  ...StatusBadge
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    department
  }
  interactionsTotal {
    id
    interactions
  }
  interactionsLast {
    id
    interactionAt
  }
  whoKnows {
    ...WhoKnowsUser
  }
}
    ${StatusBadgeFragmentDoc}
${WhoKnowsUserFragmentDoc}`;
export const MyCompanyExistsFragmentDoc = gql`
    fragment MyCompanyExists on MyCompany {
  id
}
    `;
export const CompanyOpportunityPreviewFragmentDoc = gql`
    fragment CompanyOpportunityPreview on CompanyOpportunity {
  id
  customStatus {
    ...OpportunityTrackingCustomStatus
  }
  trackingNumber
  opportunity {
    id
    proposedFeeAmount {
      format
      cents
    }
    title
    assignedTo {
      ...EmployeePreview
    }
  }
}
    ${OpportunityTrackingCustomStatusFragmentDoc}
${EmployeePreviewFragmentDoc}`;
export const CompanyOpportunityStatsFragmentDoc = gql`
    fragment CompanyOpportunityStats on Company {
  id
  domain
  referredOpportunityStats {
    totalProposalFee
    totalPercentageWon
    totalWonProposalFee
    totalOpenCount
    totalWonCount
  }
  opportunityStats {
    totalProposalFee
    totalWonProposalFee
    totalPercentageWon
    totalOpenCount
    totalWonCount
  }
}
    `;
export const CompanyConnectionRowFragmentDoc = gql`
    fragment CompanyConnectionRow on PersonCompanyContact {
  id
  jobTitles {
    id
    name
    endDate
    startDate
  }
  person {
    id
    activeContacts {
      id
      interactionsTotal {
        interactions
      }
      ...ContactPreview
      company {
        id
        info {
          id
          name
        }
      }
    }
  }
}
    ${ContactPreviewFragmentDoc}`;
export const CompanyFilterWithOptionsFragmentDoc = gql`
    fragment CompanyFilterWithOptions on Company {
  id
  domain
  logoUrl
  info {
    id
    name
  }
  companyHierarchy {
    hierarchy {
      id
    }
  }
}
    `;
export const CompanyHierarchyByUidsFragmentDoc = gql`
    fragment CompanyHierarchyByUids on Company {
  id
  info {
    id
    name
  }
  companyHierarchy {
    hierarchy {
      id
    }
  }
}
    `;
export const TreeItemCompanyFragmentDoc = gql`
    fragment TreeItemCompany on Company {
  ...CompanyPreview
  ...EngagementOverview
  interactionsLast {
    id
    interactionAt
  }
  contacts
  info {
    id
    name
    primaryLocation {
      companyOfficeLocationId
      location {
        id
        country {
          name
        }
      }
    }
  }
}
    ${CompanyPreviewFragmentDoc}
${EngagementOverviewFragmentDoc}`;
export const CompanyHierarchyEntryFragmentDoc = gql`
    fragment CompanyHierarchyEntry on CompanyHierarchy {
  id
  position
  parent {
    ... on Company {
      id
    }
  }
  company {
    ...TreeItemCompany
  }
  customFields {
    ...CustomField
  }
}
    ${TreeItemCompanyFragmentDoc}
${CustomFieldFragmentDoc}`;
export const CompanyHierarchyOptionFragmentDoc = gql`
    fragment CompanyHierarchyOption on CompanyHierarchy {
  id
  company {
    ...CompanyPreview
  }
}
    ${CompanyPreviewFragmentDoc}`;
export const EmployeeKeyActivityFragmentDoc = gql`
    fragment EmployeeKeyActivity on KeyActivity {
  id
  category
  activityTitle
  description
  interactionOn
  interactionEndAt
  staffInvolved {
    ...StaffInvolved
  }
  contactsInvolved {
    ...ContactInvolved
  }
  notes {
    plainText
    html
    trixHtml
  }
}
    ${StaffInvolvedFragmentDoc}
${ContactInvolvedFragmentDoc}`;
export const ContactForKeyActivityFragmentDoc = gql`
    fragment ContactForKeyActivity on Contact {
  id
  primaryEmail
  isEmployee
  info {
    id
    firstName
    lastName
  }
}
    `;
export const KeyActivityPreviewFragmentDoc = gql`
    fragment KeyActivityPreview on KeyActivity {
  id
  category
  activityTitle
  description
  notes {
    html
    trixHtml
  }
  interactionOn
  interactionEndAt
}
    `;
export const InteractionPreviewFragmentDoc = gql`
    fragment InteractionPreview on PartitionedInteraction {
  id
  interactionType
  direction
  occuredAt
  occuredEndAt
  webLink
  sender {
    ...ContactForKeyActivity
  }
  receivers {
    ...ContactForKeyActivity
  }
  keyActivity {
    ...KeyActivityPreview
  }
}
    ${ContactForKeyActivityFragmentDoc}
${KeyActivityPreviewFragmentDoc}`;
export const UpcomingKeyActivityFragmentDoc = gql`
    fragment UpcomingKeyActivity on KeyActivity {
  id
  activityTitle
  interactionOn
  interactionEndAt
  category
  description
  involvedContacts {
    isEmployee
    ...ContactPreview
  }
  notes {
    plainText
    html
    trixHtml
  }
  calendarMeeting {
    id
  }
}
    ${ContactPreviewFragmentDoc}`;
export const KeyActivityBoxFragmentDoc = gql`
    fragment KeyActivityBox on KeyActivity {
  id
  activityTitle
  description
  notes {
    trixHtml
    html
  }
  category
  interactionOn
  interaction {
    id
    interactionType
    webLink
    direction
  }
  involvedContacts {
    id
    isEmployee
    ...ContactNamePreview
  }
  ...KeyActivityPreview
}
    ${ContactNamePreviewFragmentDoc}
${KeyActivityPreviewFragmentDoc}`;
export const CompanyListOptionFragmentDoc = gql`
    fragment CompanyListOption on CompanyListItem {
  id
  name
  project {
    id
    title
  }
  creator {
    id
    firstName
    lastName
    email
  }
}
    `;
export const CompanyTableRowFragmentDoc = gql`
    fragment CompanyTableRow on Company {
  domain
  domains
  id
  contacts
  companyType {
    ...CompanyCustomType
  }
  companyTypes {
    ...CompanyCustomType
  }
  interactionsLast {
    id
    lastInteraction: interactionAt
  }
  interactionsTotal {
    id
    interactions
  }
  logoUrl
  info {
    id
    name
    primaryLocation {
      ...CompanyOfficeLocationRow
    }
  }
  openOpportunityCount
  pendingTaskCount
  upcomingMeetingCount
  companyHierarchy {
    hierarchy {
      id
      partOfHierarchy
    }
  }
  monthlyEngagement {
    interactionCount
    month
  }
}
    ${CompanyCustomTypeFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}`;
export const DatePropertyOptionFragmentDoc = gql`
    fragment DatePropertyOption on ListReminderSettingDateOption {
  name
  value
}
    `;
export const ListMemberReminderPreviewFragmentDoc = gql`
    fragment ListMemberReminderPreview on Reminder {
  id
  active
  reminderSetting {
    id
    emailSubject
    dateProperty
  }
}
    `;
export const CompanyListMemberRowCompanyFragmentDoc = gql`
    fragment CompanyListMemberRowCompany on Company {
  domain
  id
  contacts
  companyType {
    ...CompanyCustomType
  }
  companyTypes {
    ...CompanyCustomType
  }
  insightStat {
    lastBdInteractionAt
    lastMarketingInteractionAt
  }
  logoUrl
  info {
    id
    tags
    name
    numberOfEmployees
    description
    headquarterLocation {
      location {
        brief
      }
    }
    industryNames
    internalIndustries {
      id
      name
    }
    website
    linkedinUrl
    twitterUrl
    correspondenceNumbers
    correspondenceEmails
    primaryLocation {
      ...CompanyOfficeLocationRow
    }
  }
  ...EngagementOverview
  interactionsLast {
    id
    meetingAt
    sentEmailAt
    receivedEmailAt
    interactionAt
  }
  interactionsTotal {
    id
    emails
    interactions
    meetings
    receivedEmails
    sentEmails
  }
  internalContact: relationshipPartner {
    ...EmployeePreview
  }
  externalIdentifier {
    id
    client
    group
  }
}
    ${CompanyCustomTypeFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}
${EngagementOverviewFragmentDoc}
${EmployeePreviewFragmentDoc}`;
export const EmployeeGridFragmentDoc = gql`
    fragment EmployeeGrid on EmployeeGrid {
  id
  email
  firstName
  lastName
  jobTitle
  imageUrl
  officeName
  departmentName
}
    `;
export const ContactGridFragmentDoc = gql`
    fragment ContactGrid on ContactGrid {
  id
  primaryEmail
  firstName
  lastName
  jobTitle
  imageUrl
  isActive
  isArchived
  isKeyContact
  city
  country
}
    `;
export const CompanyGridFragmentDoc = gql`
    fragment CompanyGrid on CompanyGrid {
  id
  domain
  name
  logoUrl
}
    `;
export const CustomFieldGridValueUnionFragmentDoc = gql`
    fragment CustomFieldGridValueUnion on CustomFieldGridValueUnion {
  __typename
  ... on CustomTextFieldGrid {
    text
  }
  ... on CustomNumberFieldGrid {
    number: numberValue
  }
  ... on CustomDatetimeFieldGrid {
    date
  }
  ... on CustomOptionalValueFieldGrid {
    selected {
      id
      value
      colour
    }
  }
  ... on CustomMultiOptionalValueFieldGrid {
    multiSelected: selected {
      id
      value
      colour
    }
  }
  ... on CustomRichTextFieldGrid {
    html
    plainText
  }
  ... on CustomEmployeeFieldGrid {
    employee {
      ...EmployeeGrid
    }
  }
  ... on CustomMultiEmployeeFieldGrid {
    employees {
      ...EmployeeGrid
    }
  }
  ... on CustomMultiContactFieldGrid {
    contacts {
      ...ContactGrid
    }
  }
  ... on CustomMultiCompanyFieldGrid {
    companies {
      ...CompanyGrid
    }
  }
  ... on CustomCurrencyFieldGrid {
    amount {
      ...MoneyPreview
    }
  }
  ... on CustomMultiCountryFieldGrid {
    countries {
      ...CountryPreview
    }
  }
  ... on CustomFullDateTimeFieldGrid {
    dateTime
  }
}
    ${EmployeeGridFragmentDoc}
${ContactGridFragmentDoc}
${CompanyGridFragmentDoc}
${MoneyPreviewFragmentDoc}
${CountryPreviewFragmentDoc}`;
export const CustomFieldGridFragmentDoc = gql`
    fragment CustomFieldGrid on CustomFieldGrid {
  name
  id
  schemaId
  value {
    ...CustomFieldGridValueUnion
  }
  schemaValueType
}
    ${CustomFieldGridValueUnionFragmentDoc}`;
export const CompanyListMemberRowFragmentDoc = gql`
    fragment CompanyListMemberRow on CompanyListMember {
  id
  listReminders {
    id
    active
  }
  company {
    ...CompanyListMemberRowCompany
  }
  gridCustomFields {
    ...CustomFieldGrid
  }
  customFields {
    ...CustomField
  }
  companyListId
  completedTasksCount
  tasksCount
  updatedAt
}
    ${CompanyListMemberRowCompanyFragmentDoc}
${CustomFieldGridFragmentDoc}
${CustomFieldFragmentDoc}`;
export const CompanyContactRowFragmentDoc = gql`
    fragment CompanyContactRow on Contact {
  id
  primaryEmail
  ...StatusBadge
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    phoneNumbers
    tags
    location {
      city
      country {
        name
      }
    }
  }
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    interactions
  }
}
    ${StatusBadgeFragmentDoc}`;
export const CompanyPreviewForEditFragmentDoc = gql`
    fragment CompanyPreviewForEdit on Company {
  id
  domain
  logoUrl
  info {
    id
    name
  }
}
    `;
export const ContactForEditFragmentDoc = gql`
    fragment ContactForEdit on Contact {
  emailAddresses
  id
  primaryEmail
  company {
    ...CompanyPreviewForEdit
  }
  officeLocation {
    ...CompanyOfficeLocationRow
  }
  info {
    id
    tags
    firstName
    lastName
    jobTitle
    location {
      ...FullAddress
    }
    phoneNumbers
    twitterUrl
    linkedinUrl
    educations
    customFields {
      ...CustomField
    }
  }
}
    ${CompanyPreviewForEditFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}
${FullAddressFragmentDoc}
${CustomFieldFragmentDoc}`;
export const ContactListRowFragmentDoc = gql`
    fragment ContactListRow on Contact {
  id
  emailAddresses
  primaryEmail
  createdAt
  archivedAt
  ...StatusBadge
  isKeyContact
  isPersonal
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    phoneNumbers
    tags
    location {
      ...FullAddress
    }
  }
  changedJob
  company {
    id
    companyType {
      ...CompanyCustomType
    }
    info {
      id
      name
    }
    companyHierarchy {
      hierarchy {
        id
        partOfHierarchy
      }
    }
  }
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    id
    interactions
  }
  id
  marketingListConsent {
    status
  }
}
    ${StatusBadgeFragmentDoc}
${FullAddressFragmentDoc}
${CompanyCustomTypeFragmentDoc}`;
export const InternalIndustryFragmentDoc = gql`
    fragment InternalIndustry on InternalIndustry {
  id
  name
}
    `;
export const ContactCompanyProfileFragmentDoc = gql`
    fragment ContactCompanyProfile on Company {
  id
  domain
  domains
  isInternal
  info {
    id
    name
    primaryLocation {
      ...CompanyOfficeLocationRow
    }
    industryNames
    internalIndustries {
      ...InternalIndustry
    }
    correspondenceNumbers
  }
}
    ${CompanyOfficeLocationRowFragmentDoc}
${InternalIndustryFragmentDoc}`;
export const ContactProfileFragmentDoc = gql`
    fragment ContactProfile on Contact {
  isPersonal
  isEmployee
  emailAddresses
  id
  primaryEmail
  ...StatusBadge
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    interactions
  }
  archivedAt
  officeLocation {
    ...CompanyOfficeLocationRow
  }
  officeLocation {
    ...CompanyOfficeLocationRow
  }
  info {
    id
    tags
    firstName
    lastName
    jobTitle
    location {
      ...FullAddress
    }
    phoneNumbers
    imageUrl
    twitterUrl
    linkedinUrl
    educations
    customFields {
      ...CustomField
    }
    displayName
  }
  changedJob
  company {
    ...ContactCompanyProfile
  }
}
    ${StatusBadgeFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}
${FullAddressFragmentDoc}
${CustomFieldFragmentDoc}
${ContactCompanyProfileFragmentDoc}`;
export const MyContactExistsFragmentDoc = gql`
    fragment MyContactExists on MyContact {
  id
  classified
}
    `;
export const WhoPreviouslyKnewJobFragmentDoc = gql`
    fragment WhoPreviouslyKnewJob on Contact {
  id
  info {
    id
    jobTitle
  }
  ...StatusBadge
  company {
    id
    domain
    info {
      id
      name
    }
  }
}
    ${StatusBadgeFragmentDoc}`;
export const ContactWhoKnowsUserFragmentDoc = gql`
    fragment ContactWhoKnowsUser on WhoKnows {
  ...WhoKnowsUser
  contact {
    ...StatusBadge
    company {
      id
      domain
      info {
        id
        name
      }
    }
  }
}
    ${WhoKnowsUserFragmentDoc}
${StatusBadgeFragmentDoc}`;
export const WhoPreviouslyKnewByJobFragmentDoc = gql`
    fragment WhoPreviouslyKnewByJob on WhoPreviouslyKnew {
  previousContact {
    ...WhoPreviouslyKnewJob
  }
  whoKnew {
    ...ContactWhoKnowsUser
  }
}
    ${WhoPreviouslyKnewJobFragmentDoc}
${ContactWhoKnowsUserFragmentDoc}`;
export const AuditChangeFragmentDoc = gql`
    fragment AuditChange on AuditChange {
  name
  newValue
  oldValue
}
    `;
export const AuditFragmentDoc = gql`
    fragment Audit on Audit {
  auditedEntity
  action
  performedAt
  performedBy
  changes {
    ...AuditChange
  }
}
    ${AuditChangeFragmentDoc}`;
export const ContactConsentFragmentDoc = gql`
    fragment ContactConsent on ContactConsent {
  status
  whenWasConsentGiven
  howWasConsentGiven
  id
  autoChangedReason
}
    `;
export const MarketingContactAllowanceRowFragmentDoc = gql`
    fragment MarketingContactAllowanceRow on MarketingContactAllowance {
  utilisation
  allowance
  usage
  activeFrom
}
    `;
export const BouncedContactsRowFragmentDoc = gql`
    fragment BouncedContactsRow on Contact {
  id
  info {
    id
    firstName
    lastName
  }
  interactionsLast {
    id
    interactionAt
  }
  company {
    id
    info {
      id
      name
    }
  }
  createdAt
  primaryEmail
  isArchived
  bounce: interactionsBounce {
    id
    count
  }
  ...ContactAvatar
}
    ${ContactAvatarFragmentDoc}`;
export const OptionChoiceFragmentDoc = gql`
    fragment OptionChoice on OptionChoice {
  id
  optionChoiceId
  value
  colour
  orderRank
}
    `;
export const CustomFieldSchemaFragmentDoc = gql`
    fragment CustomFieldSchema on CustomFieldSchema {
  id
  schemaId
  name
  searchable
  valueTypeEnum
  usage
  hideFromForm
  currency {
    name
  }
  optionChoices {
    ...OptionChoice
  }
  campaigns {
    id
    title
    status
  }
}
    ${OptionChoiceFragmentDoc}`;
export const ContactPreferenceFragmentDoc = gql`
    fragment ContactPreference on ContactPreference {
  customFieldValue {
    ...CustomField
  }
  customFieldSchema {
    ...CustomFieldSchema
  }
}
    ${CustomFieldFragmentDoc}
${CustomFieldSchemaFragmentDoc}`;
export const BouncedEmailFragmentDoc = gql`
    fragment BouncedEmail on BouncedEmail {
  count
  email
}
    `;
export const ContactForIncompleteContactRowFragmentDoc = gql`
    fragment ContactForIncompleteContactRow on Contact {
  primaryEmail
  createdAt
  updatedAt
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    location {
      ...FullAddress
    }
    tags
  }
  officeLocation {
    ...CompanyOfficeLocationRow
  }
  marketingListConsent {
    id
    status
  }
  company {
    id
    companyType {
      ...CompanyCustomType
    }
    info {
      id
      name
      tags
      industryNames
      internalIndustryNames
    }
    logoUrl
    domain
  }
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    id
    interactions
  }
  id
  whoKnows {
    id
    contactCard {
      ...ContactCardAvatar
    }
  }
}
    ${FullAddressFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}
${CompanyCustomTypeFragmentDoc}
${ContactCardAvatarFragmentDoc}`;
export const DataRecordsGridTemplateFragmentDoc = gql`
    fragment DataRecordsGridTemplate on DataTemplate {
  id
  columns {
    id
    headerName
    sortable
    initialHide
    filterOperations
    templateFieldType
  }
}
    `;
export const QuickSearchEmployeeFragmentDoc = gql`
    fragment QuickSearchEmployee on Employee {
  id
  email
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
  contact {
    id
  }
}
    `;
export const EMarketingConnectedListStatusFragmentDoc = gql`
    fragment EMarketingConnectedListStatus on ConnectedList {
  id
  list {
    id
  }
  outOfSync
  syncing
  connected
  lastSyncError
  lastSyncAt
  nameOnEms
  campaignManager {
    id
    name
    mappingEnabled
  }
}
    `;
export const EMarketingConnectedListFragmentDoc = gql`
    fragment EMarketingConnectedList on ConnectedList {
  id
  list {
    id
  }
  campaignManager {
    id
    mappingEnabled
  }
  ...EMarketingConnectedListStatus
}
    ${EMarketingConnectedListStatusFragmentDoc}`;
export const EMarketingConnectedListMappingFragmentDoc = gql`
    fragment EMarketingConnectedListMapping on ConnectedListMapping {
  id
  nexlFieldName
  remoteCustomFieldSchemaUid
  customFieldSchema {
    id
  }
}
    `;
export const EMarketingConnectorFragmentDoc = gql`
    fragment EMarketingConnector on CampaignManager {
  id
  name
  mappingEnabled
}
    `;
export const EMarketingCustomFieldSchemaFragmentDoc = gql`
    fragment EMarketingCustomFieldSchema on CustomFieldSchema {
  id
  name
  valueTypeEnum
}
    `;
export const RemoteCustomFieldSchemaFragmentDoc = gql`
    fragment RemoteCustomFieldSchema on RemoteCustomFieldSchema {
  id
  name
  valueTypeEnum
  optionChoices
  source
}
    `;
export const EmployeeFieldWithOptionsFragmentDoc = gql`
    fragment EmployeeFieldWithOptions on Employee {
  id
  email
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
  }
  contact {
    id
  }
}
    `;
export const RelationshipPartnerCompanyFragmentDoc = gql`
    fragment RelationshipPartnerCompany on Company {
  id
  isBlocked
  domain
  domains
  logoUrl
  openOpportunityCount
  companyTypes {
    id
    typeName
  }
  info {
    id
    name
  }
  relationshipPartners {
    id
    info {
      id
      displayName
      imageUrl
    }
  }
}
    `;
export const TopClientCompanyFragmentDoc = gql`
    fragment TopClientCompany on TopClientCompany {
  id
  company {
    isBlocked
    id
    domain
    domains
    logoUrl
    companyTypes {
      id
      typeName
    }
    info {
      id
      name
      industryNames
      internalIndustryNames
    }
  }
  monthlyEngagement {
    month
    interactionCount
  }
}
    `;
export const TopContactFragmentDoc = gql`
    fragment TopContact on TopContact {
  id
  numberOfInteractions
  myContact {
    id
    contact {
      ...ContactAvatar
      company {
        id
        info {
          id
          name
        }
      }
      whoKnows {
        id
        contact {
          id
          info {
            id
            displayName
            imageUrl
          }
        }
      }
    }
  }
}
    ${ContactAvatarFragmentDoc}`;
export const GenericListItemFragmentDoc = gql`
    fragment GenericListItem on GenericListItem {
  id
  listReminders {
    id
    active
    reminderSetting {
      id
      emailSubject
      dateProperty
    }
  }
  customFields {
    ...CustomField
  }
  genericList {
    customFieldSchemas {
      ...CustomFieldSchema
    }
  }
}
    ${CustomFieldFragmentDoc}
${CustomFieldSchemaFragmentDoc}`;
export const GenericListItemRowFragmentDoc = gql`
    fragment GenericListItemRow on GenericListItem {
  id
  customFields {
    ...CustomField
  }
  gridCustomFields {
    ...CustomFieldGrid
  }
  listReminders {
    id
    active
  }
  completedTasksCount
  tasksCount
  updatedAt
}
    ${CustomFieldFragmentDoc}
${CustomFieldGridFragmentDoc}`;
export const CreatedWorkbookFragmentDoc = gql`
    fragment CreatedWorkbook on FlatFileWorkbook {
  id
  accessToken
  spaceIdentifier
  apiUrl
  spaceUrl
  metadata
}
    `;
export const ImportListRowFragmentDoc = gql`
    fragment ImportListRow on Import {
  id
  originalFileName
  createdBy {
    email
    employee {
      ...EmployeePreview
    }
  }
  createdAt
  processedCount
  totalCount
}
    ${EmployeePreviewFragmentDoc}`;
export const CompanyIndustryNameFragmentDoc = gql`
    fragment CompanyIndustryName on CompanyIndustryName {
  createdAt
  id
  internalIndustries {
    id
    name
  }
  value
}
    `;
export const KeyActivityCategoryTotalFragmentDoc = gql`
    fragment KeyActivityCategoryTotal on KeyActivityCategoryTotal {
  id
  category
  total
}
    `;
export const KeyActivityToUpdateFragmentDoc = gql`
    fragment KeyActivityToUpdate on KeyActivity {
  id
  category
  activityTitle
  notes {
    trixHtml
  }
  description
  interactionOn
  interactionEndAt
  staffInvolved {
    id
    email
    info {
      id
      firstName
      lastName
      jobTitle
      imageUrl
    }
  }
  contactsInvolved {
    id
    primaryEmail
    info {
      id
      firstName
      lastName
      jobTitle
      imageUrl
    }
  }
  calendarMeeting {
    id
  }
  interaction {
    id
    interactionType
  }
}
    `;
export const CompanyCardFragmentDoc = gql`
    fragment CompanyCard on CompanyCard {
  id
  domain
  name
  logoUrl
}
    `;
export const CompanyDetailFragmentDoc = gql`
    fragment CompanyDetail on CompanyDetail {
  id
  tags
  industryNames
  internalIndustryNames
  website
  linkedinUrl
  twitterUrl
  correspondenceNumbers
  correspondenceEmails
  companyTypes
}
    `;
export const ContactCardFragmentDoc = gql`
    fragment ContactCard on ContactCard {
  ...ContactCardAvatar
  archivedAt
  lastInteractionAt
  isInteractionsEngaged
  isBounced
  contactLocation {
    ...FullAddress
  }
  tags
  phoneNumbers
  twitterUrl
  linkedinUrl
  educations
  companySwitchKnownDetail
  companyCard {
    ...CompanyCard
  }
  companyDetail {
    ...CompanyDetail
  }
  companyExternalIdentifier {
    client
    group
  }
}
    ${ContactCardAvatarFragmentDoc}
${FullAddressFragmentDoc}
${CompanyCardFragmentDoc}
${CompanyDetailFragmentDoc}`;
export const ContactListGridMemberRowFragmentDoc = gql`
    fragment ContactListGridMemberRow on ContactListGridMember {
  id
  listId
  contactId
  officeLocation {
    ...FullAddress
  }
  contactCard {
    ...ContactCard
  }
  customFields {
    ...CustomFieldGrid
  }
  contactInteractionsLast {
    id
    interactionAt
    meetingAt
    sentEmailAt
    receivedEmailAt
  }
  contactInteractionsTotal {
    id
    emails
    interactions
    meetings
    receivedEmails
    sentEmails
  }
  contactCustomFields {
    ...CustomFieldGrid
  }
  createdAt
  updatedAt
  addedBy {
    id
    email
    firstName
    lastName
    imageUrl
  }
  marketingListContactConsent {
    id
    status
  }
  topKnowBy {
    id
    contactCard {
      ...ContactCardAvatar
    }
  }
  listReminders {
    id
    active
  }
  completedTasksCount
  tasksCount
  inMyContacts
}
    ${FullAddressFragmentDoc}
${ContactCardFragmentDoc}
${CustomFieldGridFragmentDoc}
${ContactCardAvatarFragmentDoc}`;
export const FormInputElementFragmentDoc = gql`
    fragment FormInputElement on InputElement {
  id
  defaultValue
  displayAs
  field
  hidden
  label
  placeholder
  description
  required
  customFieldSchemaId
  customField {
    name
  }
}
    `;
export const FormTextElementFragmentDoc = gql`
    fragment FormTextElement on TextElement {
  id
  value
}
    `;
export const ConfirmationPageSettingsFragmentDoc = gql`
    fragment ConfirmationPageSettings on ConfirmationPageSettings {
  redirectUrl
  thankYouMessage
  thankYouHeader
}
    `;
export const WaitlistSettingsFragmentDoc = gql`
    fragment WaitlistSettings on FormWaitlistSettings {
  enabled
  redirectUrl
  condition {
    operator
    rollupField {
      id
      name
    }
    value
  }
}
    `;
export const ExpirySettingsFragmentDoc = gql`
    fragment ExpirySettings on FormExpirySettings {
  enabled
  date
  pageHeader
  pageDescription {
    htmlForEditor
    renderSafeHtml
  }
}
    `;
export const KeyActivitySettingsFragmentDoc = gql`
    fragment KeyActivitySettings on KeyActivitySettings {
  title
  category
  description
  enabled
}
    `;
export const WorkflowConditionFragmentDoc = gql`
    fragment WorkflowCondition on WorkflowCondition {
  conditionValue
  customFieldSchema {
    id
  }
}
    `;
export const FormikUserFieldFragmentDoc = gql`
    fragment FormikUserField on UserSelection {
  id
  profileName
  profileImageUrl
  email
}
    `;
export const ListOptionFragmentDoc = gql`
    fragment ListOption on List {
  id
  name
  usageMode
  creator {
    firstName
    lastName
    email
  }
  project {
    title
  }
}
    `;
export const CampaignInfoFragmentDoc = gql`
    fragment CampaignInfo on Campaign {
  id
  title
  status
}
    `;
export const WorkflowDetailsFragmentDoc = gql`
    fragment WorkflowDetails on Workflow {
  id
  taskType
  conditions {
    ...WorkflowCondition
  }
  subscribedUsersV2 {
    ...FormikUserField
  }
  recipient: recipient {
    ... on List {
      ...ListOption
    }
    ... on Campaign {
      ...CampaignInfo
    }
  }
}
    ${WorkflowConditionFragmentDoc}
${FormikUserFieldFragmentDoc}
${ListOptionFragmentDoc}
${CampaignInfoFragmentDoc}`;
export const ContactListFormDetailsFragmentDoc = gql`
    fragment ContactListFormDetails on Form {
  id
  title
  contactList {
    project {
      id
    }
  }
  contactListId
  status
  expired
  description
  elements {
    ...FormInputElement
    ...FormTextElement
  }
  confirmationPageSettings {
    ...ConfirmationPageSettings
  }
  waitlistSettings {
    ...WaitlistSettings
  }
  expirySettings {
    ...ExpirySettings
  }
  keyActivitySettings {
    ...KeyActivitySettings
  }
  workflows {
    ...WorkflowDetails
  }
  setConsentToGiven
  includeDefaultFooter
  disableRecaptcha
  theme {
    id
    coverImage {
      url
    }
  }
}
    ${FormInputElementFragmentDoc}
${FormTextElementFragmentDoc}
${ConfirmationPageSettingsFragmentDoc}
${WaitlistSettingsFragmentDoc}
${ExpirySettingsFragmentDoc}
${KeyActivitySettingsFragmentDoc}
${WorkflowDetailsFragmentDoc}`;
export const ContactListFormInfoFragmentDoc = gql`
    fragment ContactListFormInfo on Form {
  id
  title
  description
  status
  expired
  confirmationPageSettings {
    ...ConfirmationPageSettings
  }
}
    ${ConfirmationPageSettingsFragmentDoc}`;
export const KeyActivityListMemberFragmentDoc = gql`
    fragment KeyActivityListMember on KeyActivityListMember {
  id
  isPersisted
  keyActivity {
    id
    activityTitle
    description
    category
    notes {
      plainText
      html
      trixHtml
    }
    interactionOn
    interactionEndAt
    staffInvolved {
      ...StaffInvolved
    }
    contactsInvolved {
      ...ContactInvolved
    }
  }
}
    ${StaffInvolvedFragmentDoc}
${ContactInvolvedFragmentDoc}`;
export const ListAutocompleteOptionFragmentDoc = gql`
    fragment ListAutocompleteOption on MyList {
  id
  name
  locationInfo {
    displayName
    locationTyped
  }
}
    `;
export const ListCleanerContactFragmentDoc = gql`
    fragment ListCleanerContact on Contact {
  id
  primaryEmail
  ...StatusBadge
  isKeyContact
  isPersonal
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    location {
      city
      country {
        name
      }
    }
  }
  company {
    id
    info {
      id
      name
    }
  }
  interactionsLast {
    id
    interactionAt
  }
  marketingListConsent {
    status
  }
}
    ${StatusBadgeFragmentDoc}`;
export const ListCleanerFragmentDoc = gql`
    fragment ListCleaner on Verification {
  id
  contact {
    ...ListCleanerContact
  }
  reason
  result
  risk
}
    ${ListCleanerContactFragmentDoc}`;
export const ListCleanerHeaderFragmentDoc = gql`
    fragment ListCleanerHeader on List {
  id
  name
}
    `;
export const ListCleanerInfoFragmentDoc = gql`
    fragment ListCleanerInfo on Clean {
  id
  cleanEnd
  totalBounced
  totalUnsubscribed
  totalConsentNotGiven
  totalUnengaged
  totalMembers
}
    `;
export const ListCleanerRiskFiltersFragmentDoc = gql`
    fragment ListCleanerRiskFilters on Clean {
  id
  totalHighRisk
  totalMediumRisk
  totalLowRisk
}
    `;
export const ContactProjectListMemberRowContactFragmentDoc = gql`
    fragment ContactProjectListMemberRowContact on Contact {
  primaryEmail
  id
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    location {
      state
      city
      country {
        name
      }
    }
    tags
    phoneNumbers
    twitterUrl
    linkedinUrl
    educations
    customFields {
      ...CustomField
    }
  }
  ...StatusBadge
  interactionsLast {
    id
    interactionAt
    meetingAt
    sentEmailAt
    receivedEmailAt
  }
  interactionsTotal {
    id
    emails
    interactions
    meetings
    receivedEmails
    sentEmails
  }
  whoKnows(limit: 3) {
    contact {
      ...ContactPreview
    }
  }
  company {
    id
    domain
    logoUrl
    info {
      id
      name
      tags
      numberOfEmployees
      description
      primaryLocation {
        location {
          brief
        }
      }
      industryNames
      internalIndustries {
        id
        name
      }
      website
      linkedinUrl
      twitterUrl
      correspondenceNumbers
      correspondenceEmails
    }
  }
  marketingListConsent {
    status
  }
}
    ${CustomFieldFragmentDoc}
${StatusBadgeFragmentDoc}
${ContactPreviewFragmentDoc}`;
export const CreatorDetailsFragmentDoc = gql`
    fragment CreatorDetails on User {
  id
  email
  firstName
  lastName
  employee {
    email
    id
    info {
      firstName
      lastName
      imageUrl
    }
  }
}
    `;
export const ContactProjectListMemberRowFragmentDoc = gql`
    fragment ContactProjectListMemberRow on ListMember {
  id
  createdAt
  contact {
    ...ContactProjectListMemberRowContact
  }
  customFields {
    ...CustomField
  }
  listId
  listReminders {
    id
    active
  }
  creator {
    ...CreatorDetails
  }
}
    ${ContactProjectListMemberRowContactFragmentDoc}
${CustomFieldFragmentDoc}
${CreatorDetailsFragmentDoc}`;
export const ListMembershipPreviewFragmentDoc = gql`
    fragment ListMembershipPreview on List {
  name
  id
  usageMode
  project {
    id
    title
    nexlApps
  }
  tabUid
}
    `;
export const ListViewFragmentDoc = gql`
    fragment ListView on ListView {
  id
  name
  viewType
  schemaUid
  renderMode
  columnStateConfiguration {
    id
    configuration
  }
  filterModelConfiguration {
    id
    configuration
  }
  searchStateConfiguration {
    id
    configuration
  }
}
    `;
export const RemovedHistoryRowFragmentDoc = gql`
    fragment RemovedHistoryRow on ListMember {
  id
  contact {
    ...ContactAvatar
    company {
      id
      info {
        name
      }
    }
  }
  remover {
    id
    profileImageUrl
    profileName
  }
  discardedAt
}
    ${ContactAvatarFragmentDoc}`;
export const UserForSelectionFragmentDoc = gql`
    fragment UserForSelection on UserSelection {
  id
  profileName
  profileImageUrl
  email
}
    `;
export const SelectedContactsModalFragmentDoc = gql`
    fragment SelectedContactsModal on Contact {
  id
  company {
    id
    info {
      id
      name
    }
  }
  ...ContactAvatar
}
    ${ContactAvatarFragmentDoc}`;
export const AddFilteredContactsToListTableContactRowFragmentDoc = gql`
    fragment AddFilteredContactsToListTableContactRow on Contact {
  id
  info {
    id
    firstName
    lastName
    imageUrl
    phoneNumbers
    location {
      id
      city
      country {
        name
      }
      state
    }
  }
  primaryEmail
  interactionsLast {
    id
    interactionAt
  }
  company {
    id
    info {
      name
    }
  }
  bounce: interactionsBounce {
    id
    isLimitReached
  }
  changedJob
  isPersonal
  ...SelectedContactsModal
  ...StatusBadge
}
    ${SelectedContactsModalFragmentDoc}
${StatusBadgeFragmentDoc}`;
export const AddFilteredContactsToListTableContactsTableFragmentDoc = gql`
    fragment AddFilteredContactsToListTableContactsTable on Contact {
  id
  primaryEmail
  ...SelectedContactsModal
  ...AddFilteredContactsToListTableContactRow
}
    ${SelectedContactsModalFragmentDoc}
${AddFilteredContactsToListTableContactRowFragmentDoc}`;
export const CompanyExclusionRowFragmentDoc = gql`
    fragment CompanyExclusionRow on CompanyExclusion {
  company {
    id
    isBlocked
    info {
      id
      name
    }
    domain
    domains
    logoUrl
  }
  id
  reason
  creator {
    firstName
    lastName
    email
    profileImageUrl
  }
  createdAt
  excludeFromEveryListCategory
  exclusionListCategories
  exclusionType
}
    `;
export const BlockedContactInfoFragmentDoc = gql`
    fragment BlockedContactInfo on Contact {
  id
  primaryEmail
  info {
    lastName
    firstName
    imageUrl
  }
  company {
    id
    domain
    info {
      name
    }
  }
  ...StatusBadge
  marketingListConsent {
    status
  }
  info {
    id
    jobTitle
    customFields {
      ...CustomField
    }
  }
  company {
    id
    logoUrl
    info {
      id
    }
  }
}
    ${StatusBadgeFragmentDoc}
${CustomFieldFragmentDoc}`;
export const BlockedContactFragmentDoc = gql`
    fragment BlockedContact on BlockedContact {
  contact {
    ...BlockedContactInfo
  }
  errors
}
    ${BlockedContactInfoFragmentDoc}`;
export const BlockedContactListRowFragmentDoc = gql`
    fragment BlockedContactListRow on Contact {
  inMyContacts
  primaryEmail
  id
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    customFields {
      ...CustomField
    }
  }
  ...StatusBadge
  company {
    id
    info {
      id
      name
    }
  }
  marketingListConsent {
    status
  }
}
    ${CustomFieldFragmentDoc}
${StatusBadgeFragmentDoc}`;
export const BlockedContactListFragmentDoc = gql`
    fragment BlockedContactList on BlockedContact {
  contact {
    ...BlockedContactListRow
  }
  errors
}
    ${BlockedContactListRowFragmentDoc}`;
export const ContactExclusionRowFragmentDoc = gql`
    fragment ContactExclusionRow on ContactExclusion {
  id
  reason
  exclusionType
  creator {
    firstName
    lastName
    email
    profileImageUrl
  }
  createdAt
  exclusionListCategories
  schema {
    ...CustomFieldSchema
  }
  optionChoices {
    ...OptionChoice
  }
  excludeFromEveryListCategory
}
    ${CustomFieldSchemaFragmentDoc}
${OptionChoiceFragmentDoc}`;
export const MatchingMarketingExclusionCreatorFragmentDoc = gql`
    fragment MatchingMarketingExclusionCreator on User {
  id
  profileImageUrl
  firstName
  lastName
  email
}
    `;
export const MatchingMarketingContactExclusionFragmentDoc = gql`
    fragment MatchingMarketingContactExclusion on ContactExclusion {
  id
  reason
  creator {
    ...MatchingMarketingExclusionCreator
  }
  schema {
    ...CustomFieldSchema
  }
}
    ${MatchingMarketingExclusionCreatorFragmentDoc}
${CustomFieldSchemaFragmentDoc}`;
export const MatchingMarketingCompanyExclusionFragmentDoc = gql`
    fragment MatchingMarketingCompanyExclusion on CompanyExclusion {
  id
  reason
  creator {
    ...MatchingMarketingExclusionCreator
  }
}
    ${MatchingMarketingExclusionCreatorFragmentDoc}`;
export const MatchingExclusionFragmentDoc = gql`
    fragment MatchingExclusion on MatchingExclusion {
  __typename
  ... on ContactExclusion {
    ...MatchingMarketingContactExclusion
  }
  ... on CompanyExclusion {
    ...MatchingMarketingCompanyExclusion
  }
  matchedContact {
    id
  }
}
    ${MatchingMarketingContactExclusionFragmentDoc}
${MatchingMarketingCompanyExclusionFragmentDoc}`;
export const BeeAuthFragmentDoc = gql`
    fragment BeeAuth on BeeAuth {
  accessToken
  v2
}
    `;
export const ConnectedListInfoFragmentDoc = gql`
    fragment ConnectedListInfo on ConnectedList {
  id
  list {
    id
  }
  syncing
  nameOnEms
  connected
  outOfSync
  lastSyncAt
  lastSyncError
  externalUrl
  campaignManager {
    id
    name
    mappingEnabled
  }
}
    `;
export const EmailMarketingConfigurationFragmentDoc = gql`
    fragment EmailMarketingConfiguration on EmailMarketingConfiguration {
  id
  fonts {
    name
    url
    family
  }
}
    `;
export const ListInfoFragmentDoc = gql`
    fragment ListInfo on List {
  id
  name
  contactsCount
  updatedAt
  category
  discardedAt
}
    `;
export const ListRowFragmentDoc = gql`
    fragment ListRow on List {
  id
  name
  creator {
    firstName
    lastName
    profileImageUrl
    email
  }
  updatedAt
  category
  discardedAt
}
    `;
export const MarketingListConfigurationFragmentDoc = gql`
    fragment MarketingListConfiguration on MarketingListConfiguration {
  id
  allowUnsubscribed
  consentLegitimateInterestText
  consentConsentGivenText
  consentUserUnsubscribedText
  enableMarketingExclusion
}
    `;
export const MarketingListMemberRowContactFragmentDoc = gql`
    fragment MarketingListMemberRowContact on Contact {
  id
  primaryEmail
  ...StatusBadge
  isKeyContact
  isPersonal
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    phoneNumbers
    tags
    location {
      state
      city
      country {
        name
      }
    }
    customFields {
      ...CustomField
    }
  }
  changedJob
  company {
    id
    info {
      id
      name
    }
  }
  interactionsLast {
    id
    interactionAt
  }
  interactionsTotal {
    id
    interactions
  }
  id
  marketingListConsent {
    status
  }
}
    ${StatusBadgeFragmentDoc}
${CustomFieldFragmentDoc}`;
export const MarketingListMemberRowFragmentDoc = gql`
    fragment MarketingListMemberRow on ListMember {
  id
  missingRequiredFields
  createdAt
  subscriptionErrorMessage
  contact {
    ...MarketingListMemberRowContact
  }
  creator {
    ...CreatorDetails
  }
}
    ${MarketingListMemberRowContactFragmentDoc}
${CreatorDetailsFragmentDoc}`;
export const CompanyEnagegementOverviewFragmentDoc = gql`
    fragment CompanyEnagegementOverview on Company {
  openOpportunityCount
  pendingTaskCount
  upcomingMeetingCount
  monthlyEngagement {
    interactionCount
    month
  }
  interactionsTotal {
    id
    interactions
  }
  interactionsLast {
    id
    interactionAt
  }
}
    `;
export const EmployeeMeetingCompanyPreviewFragmentDoc = gql`
    fragment EmployeeMeetingCompanyPreview on Company {
  id
  domain
  logoUrl
  info {
    id
    name
    primaryLocation {
      location {
        id
        country {
          name
        }
      }
    }
  }
  ...CompanyEnagegementOverview
}
    ${CompanyEnagegementOverviewFragmentDoc}`;
export const EmployeeMeetingContactPreviewFragmentDoc = gql`
    fragment EmployeeMeetingContactPreview on Contact {
  id
  ...ContactAvatar
  company {
    id
    info {
      name
    }
  }
  isEmployee
}
    ${ContactAvatarFragmentDoc}`;
export const EmployeeMeetingListItemFragmentDoc = gql`
    fragment EmployeeMeetingListItem on EmployeeMeeting {
  companies {
    ...EmployeeMeetingCompanyPreview
  }
  contacts {
    ...EmployeeMeetingContactPreview
  }
  keyActivity {
    ...KeyActivityPreview
  }
  sourceEventReference
  id
  isCancelled
  endTime
  startTime
}
    ${EmployeeMeetingCompanyPreviewFragmentDoc}
${EmployeeMeetingContactPreviewFragmentDoc}
${KeyActivityPreviewFragmentDoc}`;
export const MeetingSlideCompanyPreviewFragmentDoc = gql`
    fragment MeetingSlideCompanyPreview on Company {
  id
  domain
  logoUrl
  info {
    id
    name
  }
}
    `;
export const MeetingSlideFragmentDoc = gql`
    fragment MeetingSlide on EmployeeMeeting {
  companies {
    ...MeetingSlideCompanyPreview
  }
  contacts {
    ...EmployeeMeetingContactPreview
  }
  id
  endTime
  startTime
  sourceEventReference
}
    ${MeetingSlideCompanyPreviewFragmentDoc}
${EmployeeMeetingContactPreviewFragmentDoc}`;
export const RecentMeetingListItemFragmentDoc = gql`
    fragment RecentMeetingListItem on EmployeeMeeting {
  companies {
    ...CompanyPreview
    ...CompanyEnagegementOverview
  }
  contacts {
    ...ContactNamePreview
  }
  id
  occuredAt: startTime
  sourceEventReference
  keyActivity {
    id
    sourceReferenceId
    category
  }
}
    ${CompanyPreviewFragmentDoc}
${CompanyEnagegementOverviewFragmentDoc}
${ContactNamePreviewFragmentDoc}`;
export const ContactRequestContactRowFragmentDoc = gql`
    fragment ContactRequestContactRow on Contact {
  id
  primaryEmail
  info {
    id
    jobTitle
    location {
      id
      city
      country {
        name
      }
    }
  }
  company {
    id
    info {
      id
      name
    }
  }
  ...ContactNamePreview
  ...SelectedContactsModal
  ...ContactAvatar
}
    ${ContactNamePreviewFragmentDoc}
${SelectedContactsModalFragmentDoc}
${ContactAvatarFragmentDoc}`;
export const MyCalendarItemFragmentDoc = gql`
    fragment MyCalendarItem on CalendarEntry {
  calendarAttachable {
    ... on EmployeeMeeting {
      id
    }
    ... on KeyActivity {
      id
      category
    }
    ... on Task {
      id
    }
  }
  title
  endTime
  startTime
  isAllDay
  id
}
    `;
export const ContactCustomFieldOnlyProfileFragmentDoc = gql`
    fragment ContactCustomFieldOnlyProfile on Contact {
  id
  info {
    id
    customFields {
      ...CustomField
    }
  }
}
    ${CustomFieldFragmentDoc}`;
export const MyTaskListRowFragmentDoc = gql`
    fragment MyTaskListRow on MyTask {
  assignees {
    ...EmployeePreview
  }
  completedAt
  createdAt
  description {
    html
    trixHtml
  }
  dueOn
  id
  requestor {
    ...EmployeePreview
  }
  source {
    id
    isKeyContact
    title
    subTitle
    imgUrl
    url
  }
  title
}
    ${EmployeePreviewFragmentDoc}`;
export const ContactChipFragmentDoc = gql`
    fragment ContactChip on Contact {
  id
  primaryEmail
  isKeyContact
  info {
    id
    firstName
    lastName
    imageUrl
  }
}
    `;
export const MyTaskListRowByDateFragmentDoc = gql`
    fragment MyTaskListRowByDate on Task {
  id
  completedAt
  description {
    html
    trixHtml
  }
  dueOn
  priority
  position
  title
  assignedTo {
    ...EmployeePreview
  }
  contactListMember {
    id
    listId
  }
  companyListMember {
    id
    companyList {
      name
    }
  }
  genericListMember {
    id
    genericList {
      title
    }
  }
  contact {
    ...ContactChip
  }
  company {
    ...CompanyPreview
  }
  project {
    ...ProjectPreview
  }
}
    ${EmployeePreviewFragmentDoc}
${ContactChipFragmentDoc}
${CompanyPreviewFragmentDoc}
${ProjectPreviewFragmentDoc}`;
export const CreatorFragmentDoc = gql`
    fragment Creator on User {
  id
  firstName
  lastName
  email
  profileImageUrl
}
    `;
export const MyListsRowFragmentDoc = gql`
    fragment MyListsRow on MyList {
  id
  lastViewedAt
  createdAt
  listType
  name
  owner {
    ...Creator
  }
  permission
  locationInfo {
    displayName
    location: locationTyped
    tabUid
    tabOwnedByUid
  }
}
    ${CreatorFragmentDoc}`;
export const ShareAccessUsersRowFragmentDoc = gql`
    fragment ShareAccessUsersRow on SharedMyListUser {
  permission
  user {
    id
    email
    firstName
    lastName
    profileImageUrl
    role
  }
}
    `;
export const ObjectiveProgressDetailsFragmentDoc = gql`
    fragment ObjectiveProgressDetails on Progress {
  id
  checkinDate
  comment {
    html
    trixHtml
  }
  measureValue
  createdBy {
    id
    employee {
      ...EmployeePreview
    }
  }
}
    ${EmployeePreviewFragmentDoc}`;
export const ObjectiveProjectOverviewFragmentDoc = gql`
    fragment ObjectiveProjectOverview on Project {
  id
  title
}
    `;
export const ObjectiveDetailsFragmentDoc = gql`
    fragment ObjectiveDetails on Objective {
  id
  title
  description {
    html
    trixHtml
  }
  owners {
    ...EmployeePreview
  }
  valueType
  targetDate
  targetValue
  initialValue
  appendValueType
  archive
  currentProgress {
    id
    value: measureValue
    status: progressStatus
  }
  objectiveProgresses {
    ...ObjectiveProgressDetails
  }
  projects {
    ...ObjectiveProjectOverview
  }
}
    ${EmployeePreviewFragmentDoc}
${ObjectiveProgressDetailsFragmentDoc}
${ObjectiveProjectOverviewFragmentDoc}`;
export const GoalReferralSourceAvatarFragmentDoc = gql`
    fragment GoalReferralSourceAvatar on Contact {
  id
  primaryEmail
  ...StatusBadge
  info {
    id
    firstName
    lastName
    jobTitle
    imageUrl
    location {
      country {
        name
      }
    }
  }
  company {
    id
    domain
    logoUrl
    info {
      id
      name
    }
  }
}
    ${StatusBadgeFragmentDoc}`;
export const CompanyGoalPreviewFragmentDoc = gql`
    fragment CompanyGoalPreview on Opportunity {
  title
  date
  id
  emailBody {
    html
  }
  trackingNumber
  createdAt
  createdBy {
    firstName
    lastName
    email
  }
  includedLawyers {
    ...EmployeePreview
  }
  internalContact: assignedTo {
    ...EmployeePreview
  }
  customStatus {
    ...OpportunityTrackingCustomStatus
  }
  company {
    domain
    id
    companyType {
      ...CompanyCustomType
    }
    companyTypes {
      ...CompanyCustomType
    }
    logoUrl
    info {
      id
      name
      industryNames
    }
  }
  keyContacts {
    ...ContactPreview
  }
  referralSource {
    ...GoalReferralSourceAvatar
  }
  tags
  proposedFeeAmount {
    cents
    format
  }
  documents {
    ... on DocumentFile {
      documentId
      filename
      url
      contentType
    }
    ... on DocumentUrl {
      link
    }
  }
  customFields {
    ...CustomField
  }
}
    ${EmployeePreviewFragmentDoc}
${OpportunityTrackingCustomStatusFragmentDoc}
${CompanyCustomTypeFragmentDoc}
${ContactPreviewFragmentDoc}
${GoalReferralSourceAvatarFragmentDoc}
${CustomFieldFragmentDoc}`;
export const OpportunityAuditFragmentDoc = gql`
    fragment OpportunityAudit on OpportunityAudit {
  auditedEntity
  action
  performedAt
  performedBy
  category
  description
  changes {
    ...AuditChange
  }
}
    ${AuditChangeFragmentDoc}`;
export const BasicOpportunityFragmentDoc = gql`
    fragment BasicOpportunity on CompanyGoal {
  id
  proposedFeeAmount {
    ...MoneyPreview
  }
  date
  updatedAt
  customStatus {
    ...OpportunityTrackingCustomStatus
  }
  createdBy {
    id
    employee {
      ...EmployeePreview
    }
  }
  company {
    domain
    id
    companyType {
      ...CompanyCustomType
    }
    companyTypes {
      ...CompanyCustomType
    }
    logoUrl
    info {
      id
      name
      industryNames
      internalIndustryNames
    }
    ...EngagementOverview
  }
  tags
  assignedTo {
    ...EmployeePreview
    office {
      id
      name
    }
    department {
      id
      name
    }
  }
  trackingNumber
  title
  keyContacts {
    ...ContactPreview
    info {
      location {
        id
        city
        country {
          name
        }
      }
    }
  }
  referralSource {
    ...ContactPreview
    company {
      id
      domain
      info {
        name
      }
    }
  }
  includedLawyers {
    ...EmployeePreview
  }
  contactLast {
    id
    sentEmailAt
    receivedEmailAt
    meetingAt
    interactionAt
  }
  customFields {
    ...CustomField
  }
}
    ${MoneyPreviewFragmentDoc}
${OpportunityTrackingCustomStatusFragmentDoc}
${EmployeePreviewFragmentDoc}
${CompanyCustomTypeFragmentDoc}
${EngagementOverviewFragmentDoc}
${ContactPreviewFragmentDoc}
${CustomFieldFragmentDoc}`;
export const OpportunityNotePreviewFragmentDoc = gql`
    fragment OpportunityNotePreview on OpportunityNote {
  id
  content {
    html
    trixHtml
  }
  createdAt
  creator {
    id
    email
    firstName
    lastName
  }
}
    `;
export const ProjectDocumentOverviewFragmentDoc = gql`
    fragment ProjectDocumentOverview on ProjectDocument {
  id
  name
  url
  file {
    url
    contentType
  }
}
    `;
export const ProjectFolderFragmentDoc = gql`
    fragment ProjectFolder on Folder {
  id
  name
  projectsCount
  subFoldersCount
  parent {
    id
    name
    projectsCount
  }
}
    `;
export const ProjectListRowFragmentDoc = gql`
    fragment ProjectListRow on Project {
  id
  title
  description {
    trixHtml
    plainText
    html
  }
  iconCode
  colorCode
  folder {
    ...ProjectFolder
  }
  createdAt
  updatedAt
  teamMembersCount
  createdBy {
    ...EmployeePreview
  }
  readOnly
  firmWide
  overviewTab {
    id
  }
}
    ${ProjectFolderFragmentDoc}
${EmployeePreviewFragmentDoc}`;
export const ProjectMembershipFragmentDoc = gql`
    fragment ProjectMembership on ProjectMembership {
  id
  member {
    ...EmployeePreview
  }
}
    ${EmployeePreviewFragmentDoc}`;
export const ProjectOptionFragmentDoc = gql`
    fragment ProjectOption on Project {
  id
  title
  overviewTab {
    id
  }
}
    `;
export const ObjectiveListItemFragmentDoc = gql`
    fragment ObjectiveListItem on Objective {
  id
  title
  targetDate
  targetValue
  currentProgress {
    id
    value: measureValue
    status: progressStatus
  }
}
    `;
export const ProjectOverviewFragmentDoc = gql`
    fragment ProjectOverview on Project {
  colorCode
  iconCode
  title
  description {
    trixHtml
    plainText
    html
  }
  id
  objectives {
    ...ObjectiveListItem
  }
  nexlApps
  firmWide
  folder {
    ...ProjectFolder
  }
  readOnly
  overviewTab {
    id
  }
}
    ${ObjectiveListItemFragmentDoc}
${ProjectFolderFragmentDoc}`;
export const ProjectNotePreviewFragmentDoc = gql`
    fragment ProjectNotePreview on ProjectNote {
  id
  content {
    html
    trixHtml
  }
  createdAt
  createdBy {
    id
    email
    info {
      firstName
      lastName
    }
  }
}
    `;
export const UserGridFragmentDoc = gql`
    fragment UserGrid on UserGrid {
  email
  firstName
  id
  imageUrl
  jobTitle
  lastName
}
    `;
export const OpportunityGridFragmentDoc = gql`
    fragment OpportunityGrid on OpportunityGrid {
  id
  proposedFeeAmount {
    ...MoneyPreview
  }
  date
  updatedAt
  customStatus {
    ...OpportunityTrackingCustomStatus
  }
  createdBy {
    ...UserGrid
  }
  company {
    domain
    id
    typeName
    typeNames
    logoUrl
    name
    industryNames
    internalIndustryNames
    monthlyEngagement {
      month
      interactionCount
    }
  }
  tags
  assignedTo {
    ...EmployeeGrid
  }
  trackingNumber
  title
  keyContacts {
    ...ContactGrid
  }
  referralSource {
    ...ContactGrid
    company {
      id
      domain
      name
    }
  }
  othersIncluded {
    ...EmployeeGrid
  }
  commsLast {
    sentEmailAt
    receivedEmailAt
    meetingAt
    interactionAt
  }
  customFields {
    ...CustomFieldGrid
  }
}
    ${MoneyPreviewFragmentDoc}
${OpportunityTrackingCustomStatusFragmentDoc}
${UserGridFragmentDoc}
${EmployeeGridFragmentDoc}
${ContactGridFragmentDoc}
${CustomFieldGridFragmentDoc}`;
export const ProjectOpportunityGridRowFragmentDoc = gql`
    fragment ProjectOpportunityGridRow on ProjectOpportunityGrid {
  id
  opportunity {
    ...OpportunityGrid
  }
  customFields {
    ...CustomFieldGrid
  }
}
    ${OpportunityGridFragmentDoc}
${CustomFieldGridFragmentDoc}`;
export const BlockPageProjectSectionFragmentDoc = gql`
    fragment BlockPageProjectSection on ProjectTaskSection {
  id
  title
  blockPageIdentifier
}
    `;
export const ProjectSectionFragmentDoc = gql`
    fragment ProjectSection on ProjectTaskSection {
  id
  title
  position
}
    `;
export const TaskWithProjectTaskSectionFragmentDoc = gql`
    fragment TaskWithProjectTaskSection on Task {
  id
  title
  createdAt
  projectTaskSection {
    id
    title
    position
  }
  priority
  completedAt
  dueOn
  position
  assignedTo {
    ...EmployeePreview
  }
  createdBy {
    ...EmployeePreview
  }
  project {
    id
    colorCode
    iconCode
    title
  }
  description {
    html
    trixHtml
  }
}
    ${EmployeePreviewFragmentDoc}`;
export const ProjectTaskPreviewFragmentDoc = gql`
    fragment ProjectTaskPreview on ProjectTask {
  id
  completedOn
  createdAt
  createdBy {
    ...EmployeePreview
  }
  assignedTo {
    ...EmployeePreview
  }
  title
  dueOn
  description {
    html
    trixHtml
    plainText
  }
}
    ${EmployeePreviewFragmentDoc}`;
export const SentReferralForFormFragmentDoc = gql`
    fragment SentReferralForForm on SentReferral {
  id
  sentToContact {
    ...ContactPreview
  }
  clientContact {
    ...ContactPreview
  }
  clientCompany {
    ...CompanyPreview
  }
  referredByEmployee {
    ...EmployeePreview
  }
  customFields {
    ...CustomField
  }
  typeOfLegalMatter
  resultStatus
  sentAt
}
    ${ContactPreviewFragmentDoc}
${CompanyPreviewFragmentDoc}
${EmployeePreviewFragmentDoc}
${CustomFieldFragmentDoc}`;
export const SentReferralRowFragmentDoc = gql`
    fragment SentReferralRow on SentReferral {
  clientCompany {
    ...CompanyPreview
    info {
      id
      name
      industryNames
      primaryLocation {
        ...CompanyOfficeLocationRow
      }
    }
    companyType {
      id
      typeName
    }
    companyTypes {
      id
      typeName
    }
    ...EngagementOverview
  }
  clientContact {
    ...ContactPreview
    info {
      location {
        country {
          name
        }
        city
      }
    }
  }
  id
  sentAt
  resultStatus
  typeOfLegalMatter
  customFields {
    ...CustomField
  }
  sentToContact {
    id
    ...ContactPreview
    company {
      ...CompanyPreview
      info {
        id
        name
        industryNames
        primaryLocation {
          ...CompanyOfficeLocationRow
        }
      }
      companyType {
        typeName
      }
      companyTypes {
        id
        typeName
      }
      ...EngagementOverview
    }
    info {
      location {
        country {
          name
        }
        city
      }
    }
  }
  referredByEmployee {
    ...EmployeePreview
    info {
      department
      office
    }
  }
}
    ${CompanyPreviewFragmentDoc}
${CompanyOfficeLocationRowFragmentDoc}
${EngagementOverviewFragmentDoc}
${ContactPreviewFragmentDoc}
${CustomFieldFragmentDoc}
${EmployeePreviewFragmentDoc}`;
export const ReminderSettingPreviewFragmentDoc = gql`
    fragment ReminderSettingPreview on ReminderSetting {
  id
  emailSubject
  dateProperty
  reminderDays
  timePreposition
  owners {
    id
    employee {
      ...EmployeePreview
    }
  }
}
    ${EmployeePreviewFragmentDoc}`;
export const ReportFragmentDoc = gql`
    fragment Report on EmbeddedReportingDashboard {
  id
  title
  description {
    html
  }
  previewUrl
}
    `;
export const DelegateUserInfoFragmentDoc = gql`
    fragment DelegateUserInfo on UserInfo {
  id
  email
  firstName
  lastName
  profileImageUrl
}
    `;
export const DelegateAccessFragmentDoc = gql`
    fragment DelegateAccess on UserDelegateAccess {
  id
  colour
  delegateUser: delegateUserInfo {
    ...DelegateUserInfo
  }
  isEditable
}
    ${DelegateUserInfoFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  email
  firstName
  lastName
  profileImageUrl
}
    `;
export const CompanyListTabFragmentDoc = gql`
    fragment CompanyListTab on CompanyListItem {
  id
  name
}
    `;
export const SaveViewTabFragmentDoc = gql`
    fragment SaveViewTab on SaveView {
  id
  filter
}
    `;
export const ListTabFragmentDoc = gql`
    fragment ListTab on List {
  id
  name
  allowDuplicates
  renderMode
  usageMode
}
    `;
export const GenericListTabFragmentDoc = gql`
    fragment GenericListTab on GenericList {
  id
  title
}
    `;
export const EmbedUrlTabFragmentDoc = gql`
    fragment EmbedUrlTab on EmbedUrl {
  id
  title
  url
}
    `;
export const BlockPageListTabFragmentDoc = gql`
    fragment BlockPageListTab on BlockPageList {
  id
  name
}
    `;
export const CampaignTabFragmentDoc = gql`
    fragment CampaignTab on Campaign {
  id
  title
  projectUrl
}
    `;
export const KeyActivityListTabFragmentDoc = gql`
    fragment KeyActivityListTab on KeyActivityList {
  id
  name
}
    `;
export const TabResultItemFragmentDoc = gql`
    fragment TabResultItem on TabResult {
  id
  name
  position
  isWorkspaceTab
  isAppTab
  discardedAt
  renderMode
  pageResult {
    ... on CompanyListItem {
      ...CompanyListTab
    }
    ... on SaveView {
      ...SaveViewTab
    }
    ... on List {
      ...ListTab
    }
    ... on GenericList {
      ...GenericListTab
    }
    ... on EmbedUrl {
      ...EmbedUrlTab
    }
    ... on BlockPageList {
      ...BlockPageListTab
    }
    ... on Campaign {
      ...CampaignTab
    }
    ... on KeyActivityList {
      ...KeyActivityListTab
    }
  }
}
    ${CompanyListTabFragmentDoc}
${SaveViewTabFragmentDoc}
${ListTabFragmentDoc}
${GenericListTabFragmentDoc}
${EmbedUrlTabFragmentDoc}
${BlockPageListTabFragmentDoc}
${CampaignTabFragmentDoc}
${KeyActivityListTabFragmentDoc}`;
export const TagOptionFragmentDoc = gql`
    fragment TagOption on Tag {
  id
  name
}
    `;
export const TaskListRowFragmentDoc = gql`
    fragment TaskListRow on Task {
  assignedTo {
    ...EmployeePreview
  }
  completedAt
  createdAt
  description {
    html
  }
  company {
    ...CompanyPreview
  }
  contact {
    ...ContactPreview
  }
  dueOn
  id
  taskTitle: title
  createdBy {
    ...EmployeePreview
  }
}
    ${EmployeePreviewFragmentDoc}
${CompanyPreviewFragmentDoc}
${ContactPreviewFragmentDoc}`;
export const TaskPreviewFragmentDoc = gql`
    fragment TaskPreview on Task {
  id
  priority
  title
  description {
    plainText
  }
  dueOn
  completedAt
  company {
    ...CompanyPreview
  }
  contact {
    ...ContactChip
  }
  project {
    ...ProjectPreview
  }
  companyListMember {
    id
    companyList {
      name
    }
  }
  contactListMember {
    id
    listId
  }
  genericListMember {
    id
    genericList {
      title
    }
  }
}
    ${CompanyPreviewFragmentDoc}
${ContactChipFragmentDoc}
${ProjectPreviewFragmentDoc}`;
export const TaskSlideFragmentDoc = gql`
    fragment TaskSlide on Task {
  id
  priority
  title
  description {
    html
    trixHtml
  }
  assignedTo {
    ...EmployeePreview
  }
  dueOn
  completedAt
  completer {
    employee {
      ...EmployeePreview
    }
  }
  createdAt
  createdBy {
    ...EmployeePreview
  }
  requestedBy {
    ...EmployeePreview
  }
  company {
    ...CompanyPreview
  }
  contact {
    ...ContactChip
  }
  project {
    ...ProjectPreview
  }
  companyListMember {
    id
    companyList {
      name
    }
  }
  contactListMember {
    id
    listId
  }
  genericListMember {
    id
    genericList {
      title
    }
  }
}
    ${EmployeePreviewFragmentDoc}
${CompanyPreviewFragmentDoc}
${ContactChipFragmentDoc}
${ProjectPreviewFragmentDoc}`;
export const UiConfigFragmentDoc = gql`
    fragment UiConfig on UiConfig {
  id
  configuration
}
    `;
export const JobChangeContactInfoFragmentDoc = gql`
    fragment JobChangeContactInfo on Contact {
  id
  info {
    jobTitle
  }
  company {
    id
    domain
    info {
      id
      name
    }
  }
}
    `;
export const JobChangeUpdatePreviewFragmentDoc = gql`
    fragment JobChangeUpdatePreview on JobChangeUpdate {
  nextContacts {
    ...JobChangeContactInfo
  }
  previousContact {
    ...JobChangeContactInfo
  }
}
    ${JobChangeContactInfoFragmentDoc}`;
export const ContactUpdateEventRowFragmentDoc = gql`
    fragment ContactUpdateEventRow on ContactUpdateEvent {
  contact {
    ...ContactPreview
    company {
      id
      domain
      info {
        id
        name
      }
    }
  }
  eventDate
  eventType
  nextValue
  change {
    ... on JobChangeUpdate {
      ...JobChangeUpdatePreview
    }
    ... on JobTitleUpdate {
      nextJobTitle
      previousJobTitle
    }
  }
}
    ${ContactPreviewFragmentDoc}
${JobChangeUpdatePreviewFragmentDoc}`;
export const AccessRoleFieldOptionFragmentDoc = gql`
    fragment AccessRoleFieldOption on AccessRole {
  id
  name
}
    `;
export const UserGridRowAvatarCardFragmentDoc = gql`
    fragment UserGridRowAvatarCard on User {
  id
  profileName
  profileImageUrl
  email
}
    `;
export const UserGridRowFragmentDoc = gql`
    fragment UserGridRow on User {
  ...UserGridRowAvatarCard
  accessRole {
    id
    name
  }
  lastLoginAt
  employee {
    contact {
      id
    }
  }
}
    ${UserGridRowAvatarCardFragmentDoc}`;
export const AccessRoleCompanyPermissionsFragmentDoc = gql`
    fragment AccessRoleCompanyPermissions on CorePermission {
  viewAllCompanies: allCompanies
  viewMyCompanies: showMyCompanies
  exportMyCompanies
  exportAllCompanies
  viewCompanyRecords
  viewCompanyWhoKnows
}
    `;
export const AccessRoleContactPermissionsFragmentDoc = gql`
    fragment AccessRoleContactPermissions on CorePermission {
  viewAllContacts: allContacts
  viewMyContacts: showMyContacts
  viewContactActivities
  viewContactEmailAddresses
  viewContactRecords
  viewContactWhoKnows
  viewLastInteractionDateFirm
  viewLastInteractionDateUser
  exportAllContacts
  exportMyContacts
  viewEmployeeEngagementTab
}
    `;
export const AccessRoleDetailsFragmentDoc = gql`
    fragment AccessRoleDetails on AccessRole {
  id
  description
  name
}
    `;
export const AccessRoleEnrichmentPermissionsFragmentDoc = gql`
    fragment AccessRoleEnrichmentPermissions on EnrichmentPermission {
  viewAllProspects: allProspects
  viewMyProspects
}
    `;
export const AccessRoleFragmentDoc = gql`
    fragment AccessRole on AccessRole {
  id
  description
  name
}
    `;
export const AccessRoleInteractionsPermissionsFragmentDoc = gql`
    fragment AccessRoleInteractionsPermissions on InteractionsPermission {
  exportAllActivities
}
    `;
export const AccessRoleMarketingListsPermissionsFragmentDoc = gql`
    fragment AccessRoleMarketingListsPermissions on MarketingListsPermission {
  exportMarketingLists
}
    `;
export const AccessRoleObjectiveManagementPermissionsFragmentDoc = gql`
    fragment AccessRoleObjectiveManagementPermissions on ObjectiveManagementPermission {
  viewAllObjectives: allObjectives
  viewMyObjectives
}
    `;
export const AccessRoleOpportunityTrackingPermissionsFragmentDoc = gql`
    fragment AccessRoleOpportunityTrackingPermissions on OpportunityTrackingPermission {
  viewAllOpportunities: allOpportunities
  viewMyOpportunities
  viewEmployeeOpportunitiesTab
  exportAllOpportunities
}
    `;
export const AccessRoleProjectManagementPermissionsFragmentDoc = gql`
    fragment AccessRoleProjectManagementPermissions on ProjectManagementPermission {
  exportCompanyLists
  exportContactLists
  exportGenericLists
  exportKeyActivityLists
  exportOpportunities
}
    `;
export const AccessRoleReferralTrackingPermissionsFragmentDoc = gql`
    fragment AccessRoleReferralTrackingPermissions on ReferralTrackingPermission {
  exportReferrals
}
    `;
export const AccessRoleResearchReportsPermissionsFragmentDoc = gql`
    fragment AccessRoleResearchReportsPermissions on ResearchReportsPermission {
  readCompanyReport
  editCompanyReport
}
    `;
export const DelegateAccessInfoFragmentDoc = gql`
    fragment DelegateAccessInfo on UserInfo {
  id
  profileImageUrl
  profileName
  email
}
    `;
export const KeyActivityDetailsFragmentDoc = gql`
    fragment KeyActivityDetails on KeyActivity {
  id
  category
  activityTitle
  notes {
    html
    trixHtml
  }
  description
  interactionOn
  interactionEndAt
  involvedContacts {
    ...EmployeeMeetingContactPreview
  }
}
    ${EmployeeMeetingContactPreviewFragmentDoc}`;
export const ApiConnectionFragmentDoc = gql`
    fragment ApiConnection on ApiSourceTable {
  id
  name
  tableKey
  apiDefinition {
    id
    apiUrl
    httpMethod
  }
  jsonPathColumnMappings {
    jsonPath
    columnId
  }
}
    `;
export const WaitlistConditionFormRollupFieldOptionFragmentDoc = gql`
    fragment WaitlistConditionFormRollupFieldOption on TableLikeRollupFieldType {
  id
  name
}
    `;
export const KeyActivityListAutocompleteOptionFragmentDoc = gql`
    fragment KeyActivityListAutocompleteOption on KeyActivityList {
  id
  name
  includesKeyActivity(keyActivityUid: $keyActivityUid)
  project {
    id
    title
  }
}
    `;
export const OpportunityPreviewFragmentDoc = gql`
    fragment OpportunityPreview on Opportunity {
  title
  date
  id
  emailBody {
    html
  }
  trackingNumber
  createdAt
  createdBy {
    firstName
    lastName
    email
  }
  includedLawyers {
    ...EmployeePreview
  }
  internalContact: assignedTo {
    ...EmployeePreview
  }
  customStatus {
    ...OpportunityTrackingCustomStatus
  }
  company {
    domain
    id
    companyType {
      ...CompanyCustomType
    }
    companyTypes {
      ...CompanyCustomType
    }
    logoUrl
    info {
      id
      name
      industryNames
    }
  }
  keyContacts {
    ...ContactPreview
  }
  referralSource {
    ...GoalReferralSourceAvatar
  }
  tags
  proposedFeeAmount {
    cents
    format
  }
  documents {
    ... on DocumentFile {
      documentId
      filename
      url
      contentType
    }
    ... on DocumentUrl {
      link
    }
  }
  customFields {
    ...CustomField
  }
}
    ${EmployeePreviewFragmentDoc}
${OpportunityTrackingCustomStatusFragmentDoc}
${CompanyCustomTypeFragmentDoc}
${ContactPreviewFragmentDoc}
${GoalReferralSourceAvatarFragmentDoc}
${CustomFieldFragmentDoc}`;
export const CustomOpportunityStatsUiFragmentDoc = gql`
    fragment CustomOpportunityStatsUI on CustomStatusDistribution {
  count
  customStatus {
    ...OpportunityTrackingCustomStatus
  }
  totalProposedFeeAmount {
    ...MoneyPreview
  }
}
    ${OpportunityTrackingCustomStatusFragmentDoc}
${MoneyPreviewFragmentDoc}`;
export const TableLikeRollupFieldConditionFragmentDoc = gql`
    fragment TableLikeRollupFieldCondition on ColumnsFilteringOutput {
  filters {
    columnUid
    columnName
    joinOperator
    conditions {
      operation
      value
      valueTo
    }
  }
  joinOperator
}
    `;
export const TableLikeRollupFieldFragmentDoc = gql`
    fragment TableLikeRollupField on TableLikeRollupFieldType {
  id
  name
  discardedAt
  sourceListName
  sourceType
  targetColumnName
  operationType
  currentValue
  conditions {
    ...TableLikeRollupFieldCondition
  }
}
    ${TableLikeRollupFieldConditionFragmentDoc}`;
export const CreateTableLikeRollupFieldSourceListTabFragmentDoc = gql`
    fragment CreateTableLikeRollupFieldSourceListTab on TabResult {
  id
  pageResult {
    __typename
    ... on List {
      id
      name
      discardedAt
    }
    ... on GenericList {
      id
      title
      discardedAt
    }
    ... on CompanyListItem {
      id
      name
      discardedAt
    }
    ... on KeyActivityList {
      id
      name
      discardedAt
    }
  }
}
    `;
export const RollupColumnsSelectFieldOptionFragmentDoc = gql`
    fragment RollupColumnsSelectFieldOption on TableLikeRollupColumn {
  id
  name
  valueType
}
    `;
export const ReceivedReferralGridFragmentDoc = gql`
    fragment ReceivedReferralGrid on CompanyGoal {
  id
  trackingNumber
  proposedFeeAmount {
    ...MoneyPreview
  }
  title
  tags
  date
  customStatus {
    ...OpportunityTrackingCustomStatus
  }
  company {
    id
    domain
    info {
      name
      industryNames
    }
    companyType {
      typeName
      id
    }
    companyTypes {
      typeName
      id
    }
    last: interactionsLast {
      lastInteraction: interactionAt
    }
  }
  contactLast {
    id
    interactionAt
  }
  internalContact: assignedTo {
    id
    email
    info {
      firstName
      lastName
    }
    office {
      name
    }
    department {
      name
    }
  }
  includedLawyers {
    id
    email
    info {
      firstName
      lastName
    }
  }
  keyContacts {
    ...KeyContact
  }
  customFields {
    ...CustomField
  }
  referralSource {
    id
    ...StatusBadge
    info {
      firstName
      lastName
      location {
        country {
          name
        }
      }
    }
    primaryEmail
    company {
      id
      domain
      info {
        name
      }
    }
  }
}
    ${MoneyPreviewFragmentDoc}
${OpportunityTrackingCustomStatusFragmentDoc}
${KeyContactFragmentDoc}
${CustomFieldFragmentDoc}
${StatusBadgeFragmentDoc}`;
export const ResearchReportCreatorEmployeeFragmentDoc = gql`
    fragment ResearchReportCreatorEmployee on Employee {
  id
  email
  info {
    id
    displayName
    imageUrl
  }
}
    `;
export const ResearchReportGridFragmentDoc = gql`
    fragment ResearchReportGrid on ResearchReport {
  id
  title
  createdAt
  updatedAt
  status
  creator {
    id
    employee {
      ...ResearchReportCreatorEmployee
    }
  }
  isDiscarded
}
    ${ResearchReportCreatorEmployeeFragmentDoc}`;
export const ResearchReportSectionFragmentDoc = gql`
    fragment ResearchReportSection on ResearchReportSection {
  id
  title
  position
  sectionType
  status
  htmlForEditor
  renderSafeHtml
  nexlSearchType
  webSearchType
  aiPrompt
  isDiscarded
  urlSources
  fileSource {
    name
    fileUuid
    url
    contentType
  }
}
    `;
export const ResearchReportableUnionFragmentDoc = gql`
    fragment ResearchReportableUnion on ResearchReportableUnion {
  ... on Company {
    id
    domain
    info {
      name
    }
  }
}
    `;
export const ResearchReportFragmentDoc = gql`
    fragment ResearchReport on ResearchReport {
  id
  title
  createdAt
  updatedAt
  status
  sections {
    ...ResearchReportSection
  }
  researchReportable {
    ...ResearchReportableUnion
  }
  creator {
    id
    employee {
      id
      info {
        id
        displayName
      }
    }
  }
}
    ${ResearchReportSectionFragmentDoc}
${ResearchReportableUnionFragmentDoc}`;
export const DocumentUploadBlockDocument = gql`
    query DocumentUploadBlock($url: String!) {
  blockPagesFixActiveStorageUrl(url: $url) {
    failReasons
    fixedUrl
  }
}
    `;

/**
 * __useDocumentUploadBlockQuery__
 *
 * To run a query within a React component, call `useDocumentUploadBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentUploadBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentUploadBlockQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useDocumentUploadBlockQuery(baseOptions: Apollo.QueryHookOptions<DocumentUploadBlockQuery, DocumentUploadBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentUploadBlockQuery, DocumentUploadBlockQueryVariables>(DocumentUploadBlockDocument, options);
      }
export function useDocumentUploadBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentUploadBlockQuery, DocumentUploadBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentUploadBlockQuery, DocumentUploadBlockQueryVariables>(DocumentUploadBlockDocument, options);
        }
export type DocumentUploadBlockQueryHookResult = ReturnType<typeof useDocumentUploadBlockQuery>;
export type DocumentUploadBlockLazyQueryHookResult = ReturnType<typeof useDocumentUploadBlockLazyQuery>;
export type DocumentUploadBlockQueryResult = Apollo.QueryResult<DocumentUploadBlockQuery, DocumentUploadBlockQueryVariables>;
export const ImagesBlockDocument = gql`
    query ImagesBlock($url: String!) {
  blockPagesFixActiveStorageUrl(url: $url) {
    failReasons
    fixedUrl
  }
}
    `;

/**
 * __useImagesBlockQuery__
 *
 * To run a query within a React component, call `useImagesBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useImagesBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImagesBlockQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useImagesBlockQuery(baseOptions: Apollo.QueryHookOptions<ImagesBlockQuery, ImagesBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImagesBlockQuery, ImagesBlockQueryVariables>(ImagesBlockDocument, options);
      }
export function useImagesBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImagesBlockQuery, ImagesBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImagesBlockQuery, ImagesBlockQueryVariables>(ImagesBlockDocument, options);
        }
export type ImagesBlockQueryHookResult = ReturnType<typeof useImagesBlockQuery>;
export type ImagesBlockLazyQueryHookResult = ReturnType<typeof useImagesBlockLazyQuery>;
export type ImagesBlockQueryResult = Apollo.QueryResult<ImagesBlockQuery, ImagesBlockQueryVariables>;
export const RollupFieldBlockTableDocument = gql`
    query RollupFieldBlockTable($filters: RollupFieldFiltersInput!) {
  tableLikeRollupFields(filters: $filters) {
    entries {
      ...RollupFieldBlockTableRow
    }
  }
}
    ${RollupFieldBlockTableRowFragmentDoc}`;

/**
 * __useRollupFieldBlockTableQuery__
 *
 * To run a query within a React component, call `useRollupFieldBlockTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useRollupFieldBlockTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRollupFieldBlockTableQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRollupFieldBlockTableQuery(baseOptions: Apollo.QueryHookOptions<RollupFieldBlockTableQuery, RollupFieldBlockTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RollupFieldBlockTableQuery, RollupFieldBlockTableQueryVariables>(RollupFieldBlockTableDocument, options);
      }
export function useRollupFieldBlockTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RollupFieldBlockTableQuery, RollupFieldBlockTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RollupFieldBlockTableQuery, RollupFieldBlockTableQueryVariables>(RollupFieldBlockTableDocument, options);
        }
export type RollupFieldBlockTableQueryHookResult = ReturnType<typeof useRollupFieldBlockTableQuery>;
export type RollupFieldBlockTableLazyQueryHookResult = ReturnType<typeof useRollupFieldBlockTableLazyQuery>;
export type RollupFieldBlockTableQueryResult = Apollo.QueryResult<RollupFieldBlockTableQuery, RollupFieldBlockTableQueryVariables>;
export const BlockPageListDocument = gql`
    query BlockPageList($uid: ID!) {
  blockPageList(uid: $uid) {
    id
    name
    pages {
      ...BlockPagePages
    }
  }
}
    ${BlockPagePagesFragmentDoc}`;

/**
 * __useBlockPageListQuery__
 *
 * To run a query within a React component, call `useBlockPageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockPageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockPageListQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useBlockPageListQuery(baseOptions: Apollo.QueryHookOptions<BlockPageListQuery, BlockPageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockPageListQuery, BlockPageListQueryVariables>(BlockPageListDocument, options);
      }
export function useBlockPageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockPageListQuery, BlockPageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockPageListQuery, BlockPageListQueryVariables>(BlockPageListDocument, options);
        }
export type BlockPageListQueryHookResult = ReturnType<typeof useBlockPageListQuery>;
export type BlockPageListLazyQueryHookResult = ReturnType<typeof useBlockPageListLazyQuery>;
export type BlockPageListQueryResult = Apollo.QueryResult<BlockPageListQuery, BlockPageListQueryVariables>;
export const UpdateEmailMarketingCampaignSettingsDocument = gql`
    mutation UpdateEmailMarketingCampaignSettings($uid: ID!, $continuous: Boolean, $openTracking: Boolean, $clickTracking: Boolean, $allowContinuousResend: Boolean) {
  updateEmailMarketingCampaign(
    uid: $uid
    continuous: $continuous
    allowContinuousResend: $allowContinuousResend
    openTracking: $openTracking
    clickTracking: $clickTracking
  ) {
    updatedCampaign {
      ...CampaignDetails
    }
    failReasons
  }
}
    ${CampaignDetailsFragmentDoc}`;
export type UpdateEmailMarketingCampaignSettingsMutationFn = Apollo.MutationFunction<UpdateEmailMarketingCampaignSettingsMutation, UpdateEmailMarketingCampaignSettingsMutationVariables>;

/**
 * __useUpdateEmailMarketingCampaignSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMarketingCampaignSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMarketingCampaignSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMarketingCampaignSettingsMutation, { data, loading, error }] = useUpdateEmailMarketingCampaignSettingsMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      continuous: // value for 'continuous'
 *      openTracking: // value for 'openTracking'
 *      clickTracking: // value for 'clickTracking'
 *      allowContinuousResend: // value for 'allowContinuousResend'
 *   },
 * });
 */
export function useUpdateEmailMarketingCampaignSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMarketingCampaignSettingsMutation, UpdateEmailMarketingCampaignSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMarketingCampaignSettingsMutation, UpdateEmailMarketingCampaignSettingsMutationVariables>(UpdateEmailMarketingCampaignSettingsDocument, options);
      }
export type UpdateEmailMarketingCampaignSettingsMutationHookResult = ReturnType<typeof useUpdateEmailMarketingCampaignSettingsMutation>;
export type UpdateEmailMarketingCampaignSettingsMutationResult = Apollo.MutationResult<UpdateEmailMarketingCampaignSettingsMutation>;
export type UpdateEmailMarketingCampaignSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMarketingCampaignSettingsMutation, UpdateEmailMarketingCampaignSettingsMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($commentThreadUid: ID!, $htmlContent: String!) {
  addCommentToCommentThread(
    commentThreadUid: $commentThreadUid
    htmlContent: $htmlContent
  ) {
    failReasons
    comment {
      ...CommentPreview
    }
  }
}
    ${CommentPreviewFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      commentThreadUid: // value for 'commentThreadUid'
 *      htmlContent: // value for 'htmlContent'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const RemoveCommentDocument = gql`
    mutation RemoveComment($commentUid: ID!) {
  removeComment(commentUid: $commentUid) {
    failReasons
    comment {
      id
      discardedAt
    }
  }
}
    `;
export type RemoveCommentMutationFn = Apollo.MutationFunction<RemoveCommentMutation, RemoveCommentMutationVariables>;

/**
 * __useRemoveCommentMutation__
 *
 * To run a mutation, you first call `useRemoveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommentMutation, { data, loading, error }] = useRemoveCommentMutation({
 *   variables: {
 *      commentUid: // value for 'commentUid'
 *   },
 * });
 */
export function useRemoveCommentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommentMutation, RemoveCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommentMutation, RemoveCommentMutationVariables>(RemoveCommentDocument, options);
      }
export type RemoveCommentMutationHookResult = ReturnType<typeof useRemoveCommentMutation>;
export type RemoveCommentMutationResult = Apollo.MutationResult<RemoveCommentMutation>;
export type RemoveCommentMutationOptions = Apollo.BaseMutationOptions<RemoveCommentMutation, RemoveCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($commentUid: ID!, $htmlContent: String!) {
  updateComment(commentUid: $commentUid, htmlContent: $htmlContent) {
    failReasons
    comment {
      id
      htmlForEditor
      renderSafeHtml
      edited
    }
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      commentUid: // value for 'commentUid'
 *      htmlContent: // value for 'htmlContent'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const CommentThreadDocument = gql`
    query CommentThread($commentThreadUid: ID!, $page: Int, $perPage: Int) {
  commentThread(
    commentThreadUid: $commentThreadUid
    page: $page
    perPage: $perPage
  ) {
    pageInfo {
      totalEntries
    }
    entries {
      ...CommentPreview
    }
  }
  currentUser {
    id
    userId
  }
}
    ${CommentPreviewFragmentDoc}`;

/**
 * __useCommentThreadQuery__
 *
 * To run a query within a React component, call `useCommentThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentThreadQuery({
 *   variables: {
 *      commentThreadUid: // value for 'commentThreadUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCommentThreadQuery(baseOptions: Apollo.QueryHookOptions<CommentThreadQuery, CommentThreadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentThreadQuery, CommentThreadQueryVariables>(CommentThreadDocument, options);
      }
export function useCommentThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentThreadQuery, CommentThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentThreadQuery, CommentThreadQueryVariables>(CommentThreadDocument, options);
        }
export type CommentThreadQueryHookResult = ReturnType<typeof useCommentThreadQuery>;
export type CommentThreadLazyQueryHookResult = ReturnType<typeof useCommentThreadLazyQuery>;
export type CommentThreadQueryResult = Apollo.QueryResult<CommentThreadQuery, CommentThreadQueryVariables>;
export const FormikInternalIndustryAutocompleteFieldDocument = gql`
    query FormikInternalIndustryAutocompleteField {
  internalIndustries {
    entries {
      ...InternalIndustry
    }
  }
}
    ${InternalIndustryFragmentDoc}`;

/**
 * __useFormikInternalIndustryAutocompleteFieldQuery__
 *
 * To run a query within a React component, call `useFormikInternalIndustryAutocompleteFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormikInternalIndustryAutocompleteFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormikInternalIndustryAutocompleteFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useFormikInternalIndustryAutocompleteFieldQuery(baseOptions?: Apollo.QueryHookOptions<FormikInternalIndustryAutocompleteFieldQuery, FormikInternalIndustryAutocompleteFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormikInternalIndustryAutocompleteFieldQuery, FormikInternalIndustryAutocompleteFieldQueryVariables>(FormikInternalIndustryAutocompleteFieldDocument, options);
      }
export function useFormikInternalIndustryAutocompleteFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormikInternalIndustryAutocompleteFieldQuery, FormikInternalIndustryAutocompleteFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormikInternalIndustryAutocompleteFieldQuery, FormikInternalIndustryAutocompleteFieldQueryVariables>(FormikInternalIndustryAutocompleteFieldDocument, options);
        }
export type FormikInternalIndustryAutocompleteFieldQueryHookResult = ReturnType<typeof useFormikInternalIndustryAutocompleteFieldQuery>;
export type FormikInternalIndustryAutocompleteFieldLazyQueryHookResult = ReturnType<typeof useFormikInternalIndustryAutocompleteFieldLazyQuery>;
export type FormikInternalIndustryAutocompleteFieldQueryResult = Apollo.QueryResult<FormikInternalIndustryAutocompleteFieldQuery, FormikInternalIndustryAutocompleteFieldQueryVariables>;
export const UserAutocompleteFieldWithOptionDocument = gql`
    query UserAutocompleteFieldWithOption($term: String) {
  usersForSelection(term: $term) {
    entries {
      ...FormikUserField
    }
  }
}
    ${FormikUserFieldFragmentDoc}`;

/**
 * __useUserAutocompleteFieldWithOptionQuery__
 *
 * To run a query within a React component, call `useUserAutocompleteFieldWithOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAutocompleteFieldWithOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAutocompleteFieldWithOptionQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useUserAutocompleteFieldWithOptionQuery(baseOptions?: Apollo.QueryHookOptions<UserAutocompleteFieldWithOptionQuery, UserAutocompleteFieldWithOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAutocompleteFieldWithOptionQuery, UserAutocompleteFieldWithOptionQueryVariables>(UserAutocompleteFieldWithOptionDocument, options);
      }
export function useUserAutocompleteFieldWithOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAutocompleteFieldWithOptionQuery, UserAutocompleteFieldWithOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAutocompleteFieldWithOptionQuery, UserAutocompleteFieldWithOptionQueryVariables>(UserAutocompleteFieldWithOptionDocument, options);
        }
export type UserAutocompleteFieldWithOptionQueryHookResult = ReturnType<typeof useUserAutocompleteFieldWithOptionQuery>;
export type UserAutocompleteFieldWithOptionLazyQueryHookResult = ReturnType<typeof useUserAutocompleteFieldWithOptionLazyQuery>;
export type UserAutocompleteFieldWithOptionQueryResult = Apollo.QueryResult<UserAutocompleteFieldWithOptionQuery, UserAutocompleteFieldWithOptionQueryVariables>;
export const CreateListViewRenderModeLargeDocument = gql`
    mutation CreateListViewRenderModeLarge($listUid: ID!, $name: String!, $viewType: ListViewType!, $schemaUid: ID, $columnStateConfiguration: String!, $filterModelConfiguration: String!, $searchStateConfiguration: String!) {
  createListView(
    attributes: {listUid: $listUid, name: $name, viewType: $viewType, schemaUid: $schemaUid, renderMode: LARGE, columnStateConfiguration: {scope: COLUMN_STATE, configuration: $columnStateConfiguration}, filterModelConfiguration: {scope: FILTER_MODEL, configuration: $filterModelConfiguration}, searchStateConfiguration: {scope: SEARCH_STATE, configuration: $searchStateConfiguration}}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type CreateListViewRenderModeLargeMutationFn = Apollo.MutationFunction<CreateListViewRenderModeLargeMutation, CreateListViewRenderModeLargeMutationVariables>;

/**
 * __useCreateListViewRenderModeLargeMutation__
 *
 * To run a mutation, you first call `useCreateListViewRenderModeLargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListViewRenderModeLargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListViewRenderModeLargeMutation, { data, loading, error }] = useCreateListViewRenderModeLargeMutation({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      name: // value for 'name'
 *      viewType: // value for 'viewType'
 *      schemaUid: // value for 'schemaUid'
 *      columnStateConfiguration: // value for 'columnStateConfiguration'
 *      filterModelConfiguration: // value for 'filterModelConfiguration'
 *      searchStateConfiguration: // value for 'searchStateConfiguration'
 *   },
 * });
 */
export function useCreateListViewRenderModeLargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateListViewRenderModeLargeMutation, CreateListViewRenderModeLargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListViewRenderModeLargeMutation, CreateListViewRenderModeLargeMutationVariables>(CreateListViewRenderModeLargeDocument, options);
      }
export type CreateListViewRenderModeLargeMutationHookResult = ReturnType<typeof useCreateListViewRenderModeLargeMutation>;
export type CreateListViewRenderModeLargeMutationResult = Apollo.MutationResult<CreateListViewRenderModeLargeMutation>;
export type CreateListViewRenderModeLargeMutationOptions = Apollo.BaseMutationOptions<CreateListViewRenderModeLargeMutation, CreateListViewRenderModeLargeMutationVariables>;
export const UpdateListViewDocument = gql`
    mutation UpdateListView($listViewUid: String!, $name: String!, $schemaUid: ID) {
  updateListView(
    listViewUid: $listViewUid
    attributes: {name: $name, schemaUid: $schemaUid, renderMode: LARGE}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type UpdateListViewMutationFn = Apollo.MutationFunction<UpdateListViewMutation, UpdateListViewMutationVariables>;

/**
 * __useUpdateListViewMutation__
 *
 * To run a mutation, you first call `useUpdateListViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListViewMutation, { data, loading, error }] = useUpdateListViewMutation({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *      name: // value for 'name'
 *      schemaUid: // value for 'schemaUid'
 *   },
 * });
 */
export function useUpdateListViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListViewMutation, UpdateListViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListViewMutation, UpdateListViewMutationVariables>(UpdateListViewDocument, options);
      }
export type UpdateListViewMutationHookResult = ReturnType<typeof useUpdateListViewMutation>;
export type UpdateListViewMutationResult = Apollo.MutationResult<UpdateListViewMutation>;
export type UpdateListViewMutationOptions = Apollo.BaseMutationOptions<UpdateListViewMutation, UpdateListViewMutationVariables>;
export const AddFromTableLikeToAnotherDocument = gql`
    mutation AddFromTableLikeToAnother($fromSource: TableLikeSourceInput!, $fromMemberColumnUid: String!, $fromFiltering: ColumnsFilteringInput, $fromSearch: String, $toSource: TableLikeSourceInput!, $toValues: [ColumnValueInput!], $trackerReturnPath: String) {
  addFromTableLikeToAnother(
    fromSource: $fromSource
    fromMemberColumnUid: $fromMemberColumnUid
    fromFiltering: $fromFiltering
    fromSearch: $fromSearch
    toSource: $toSource
    toValues: $toValues
    trackerReturnPath: $trackerReturnPath
  ) {
    failReasons
    progressTracker {
      id
      title
      status
      percentageComplete
      returnPath
    }
  }
}
    `;
export type AddFromTableLikeToAnotherMutationFn = Apollo.MutationFunction<AddFromTableLikeToAnotherMutation, AddFromTableLikeToAnotherMutationVariables>;

/**
 * __useAddFromTableLikeToAnotherMutation__
 *
 * To run a mutation, you first call `useAddFromTableLikeToAnotherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFromTableLikeToAnotherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFromTableLikeToAnotherMutation, { data, loading, error }] = useAddFromTableLikeToAnotherMutation({
 *   variables: {
 *      fromSource: // value for 'fromSource'
 *      fromMemberColumnUid: // value for 'fromMemberColumnUid'
 *      fromFiltering: // value for 'fromFiltering'
 *      fromSearch: // value for 'fromSearch'
 *      toSource: // value for 'toSource'
 *      toValues: // value for 'toValues'
 *      trackerReturnPath: // value for 'trackerReturnPath'
 *   },
 * });
 */
export function useAddFromTableLikeToAnotherMutation(baseOptions?: Apollo.MutationHookOptions<AddFromTableLikeToAnotherMutation, AddFromTableLikeToAnotherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFromTableLikeToAnotherMutation, AddFromTableLikeToAnotherMutationVariables>(AddFromTableLikeToAnotherDocument, options);
      }
export type AddFromTableLikeToAnotherMutationHookResult = ReturnType<typeof useAddFromTableLikeToAnotherMutation>;
export type AddFromTableLikeToAnotherMutationResult = Apollo.MutationResult<AddFromTableLikeToAnotherMutation>;
export type AddFromTableLikeToAnotherMutationOptions = Apollo.BaseMutationOptions<AddFromTableLikeToAnotherMutation, AddFromTableLikeToAnotherMutationVariables>;
export const CreateKeyActivityListCustomFieldSchemaDocument = gql`
    mutation CreateKeyActivityListCustomFieldSchema($listUuid: ID!, $customFieldAttributes: CustomFieldSchemaAttributes!) {
  createKeyActivityListCustomFieldSchema(
    listUuid: $listUuid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
  }
}
    `;
export type CreateKeyActivityListCustomFieldSchemaMutationFn = Apollo.MutationFunction<CreateKeyActivityListCustomFieldSchemaMutation, CreateKeyActivityListCustomFieldSchemaMutationVariables>;

/**
 * __useCreateKeyActivityListCustomFieldSchemaMutation__
 *
 * To run a mutation, you first call `useCreateKeyActivityListCustomFieldSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeyActivityListCustomFieldSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeyActivityListCustomFieldSchemaMutation, { data, loading, error }] = useCreateKeyActivityListCustomFieldSchemaMutation({
 *   variables: {
 *      listUuid: // value for 'listUuid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useCreateKeyActivityListCustomFieldSchemaMutation(baseOptions?: Apollo.MutationHookOptions<CreateKeyActivityListCustomFieldSchemaMutation, CreateKeyActivityListCustomFieldSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeyActivityListCustomFieldSchemaMutation, CreateKeyActivityListCustomFieldSchemaMutationVariables>(CreateKeyActivityListCustomFieldSchemaDocument, options);
      }
export type CreateKeyActivityListCustomFieldSchemaMutationHookResult = ReturnType<typeof useCreateKeyActivityListCustomFieldSchemaMutation>;
export type CreateKeyActivityListCustomFieldSchemaMutationResult = Apollo.MutationResult<CreateKeyActivityListCustomFieldSchemaMutation>;
export type CreateKeyActivityListCustomFieldSchemaMutationOptions = Apollo.BaseMutationOptions<CreateKeyActivityListCustomFieldSchemaMutation, CreateKeyActivityListCustomFieldSchemaMutationVariables>;
export const DeleteTableLikeRowsDocument = gql`
    mutation deleteTableLikeRows($source: TableLikeSourceInput!, $search: String, $filtering: ColumnsFilteringInput) {
  deleteTableLikeRows(source: $source, search: $search, filtering: $filtering) {
    rowIdsDeleted
    failReasons
    progressTracker {
      id
      title
      status
      percentageComplete
      returnPath
    }
  }
}
    `;
export type DeleteTableLikeRowsMutationFn = Apollo.MutationFunction<DeleteTableLikeRowsMutation, DeleteTableLikeRowsMutationVariables>;

/**
 * __useDeleteTableLikeRowsMutation__
 *
 * To run a mutation, you first call `useDeleteTableLikeRowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableLikeRowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableLikeRowsMutation, { data, loading, error }] = useDeleteTableLikeRowsMutation({
 *   variables: {
 *      source: // value for 'source'
 *      search: // value for 'search'
 *      filtering: // value for 'filtering'
 *   },
 * });
 */
export function useDeleteTableLikeRowsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableLikeRowsMutation, DeleteTableLikeRowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableLikeRowsMutation, DeleteTableLikeRowsMutationVariables>(DeleteTableLikeRowsDocument, options);
      }
export type DeleteTableLikeRowsMutationHookResult = ReturnType<typeof useDeleteTableLikeRowsMutation>;
export type DeleteTableLikeRowsMutationResult = Apollo.MutationResult<DeleteTableLikeRowsMutation>;
export type DeleteTableLikeRowsMutationOptions = Apollo.BaseMutationOptions<DeleteTableLikeRowsMutation, DeleteTableLikeRowsMutationVariables>;
export const ListViewsRenderModeLargeDocument = gql`
    query ListViewsRenderModeLarge($listUid: String!) {
  listViews(listUid: $listUid, renderMode: LARGE) {
    ...ListView
  }
}
    ${ListViewFragmentDoc}`;

/**
 * __useListViewsRenderModeLargeQuery__
 *
 * To run a query within a React component, call `useListViewsRenderModeLargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListViewsRenderModeLargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListViewsRenderModeLargeQuery({
 *   variables: {
 *      listUid: // value for 'listUid'
 *   },
 * });
 */
export function useListViewsRenderModeLargeQuery(baseOptions: Apollo.QueryHookOptions<ListViewsRenderModeLargeQuery, ListViewsRenderModeLargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListViewsRenderModeLargeQuery, ListViewsRenderModeLargeQueryVariables>(ListViewsRenderModeLargeDocument, options);
      }
export function useListViewsRenderModeLargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListViewsRenderModeLargeQuery, ListViewsRenderModeLargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListViewsRenderModeLargeQuery, ListViewsRenderModeLargeQueryVariables>(ListViewsRenderModeLargeDocument, options);
        }
export type ListViewsRenderModeLargeQueryHookResult = ReturnType<typeof useListViewsRenderModeLargeQuery>;
export type ListViewsRenderModeLargeLazyQueryHookResult = ReturnType<typeof useListViewsRenderModeLargeLazyQuery>;
export type ListViewsRenderModeLargeQueryResult = Apollo.QueryResult<ListViewsRenderModeLargeQuery, ListViewsRenderModeLargeQueryVariables>;
export const SharedTableLikeRowsDocument = gql`
    query SharedTableLikeRows($source: TableLikeSourceInput!, $selectedColumns: [String!], $page: Int!, $perPage: Int!, $search: String, $ordering: [SortOrderInput!], $filtering: ColumnsFilteringInput) {
  sharedTableLikeRows(
    source: $source
    selectedColumns: $selectedColumns
    page: $page
    perPage: $perPage
    search: $search
    ordering: $ordering
    filtering: $filtering
  ) {
    entries {
      ...TableRow
    }
    pageInfo {
      totalEntries
      totalPages
    }
  }
}
    ${TableRowFragmentDoc}`;

/**
 * __useSharedTableLikeRowsQuery__
 *
 * To run a query within a React component, call `useSharedTableLikeRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedTableLikeRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedTableLikeRowsQuery({
 *   variables: {
 *      source: // value for 'source'
 *      selectedColumns: // value for 'selectedColumns'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      ordering: // value for 'ordering'
 *      filtering: // value for 'filtering'
 *   },
 * });
 */
export function useSharedTableLikeRowsQuery(baseOptions: Apollo.QueryHookOptions<SharedTableLikeRowsQuery, SharedTableLikeRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedTableLikeRowsQuery, SharedTableLikeRowsQueryVariables>(SharedTableLikeRowsDocument, options);
      }
export function useSharedTableLikeRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedTableLikeRowsQuery, SharedTableLikeRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedTableLikeRowsQuery, SharedTableLikeRowsQueryVariables>(SharedTableLikeRowsDocument, options);
        }
export type SharedTableLikeRowsQueryHookResult = ReturnType<typeof useSharedTableLikeRowsQuery>;
export type SharedTableLikeRowsLazyQueryHookResult = ReturnType<typeof useSharedTableLikeRowsLazyQuery>;
export type SharedTableLikeRowsQueryResult = Apollo.QueryResult<SharedTableLikeRowsQuery, SharedTableLikeRowsQueryVariables>;
export const TableLikeColumnValueSuggestionsDocument = gql`
    query tableLikeColumnValueSuggestions($source: TableLikeSourceInput!, $selectedColumnUid: ID!, $category: ColumnValueSuggestionCategory!, $text: String!, $filter: SuggesterFilterInput) {
  tableLikeColumnValueSuggestions(
    source: $source
    selectedColumnUid: $selectedColumnUid
    limit: 5
    category: $category
    text: $text
    filter: $filter
  ) {
    entries {
      ...TableCellValue
    }
  }
}
    ${TableCellValueFragmentDoc}`;

/**
 * __useTableLikeColumnValueSuggestionsQuery__
 *
 * To run a query within a React component, call `useTableLikeColumnValueSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableLikeColumnValueSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableLikeColumnValueSuggestionsQuery({
 *   variables: {
 *      source: // value for 'source'
 *      selectedColumnUid: // value for 'selectedColumnUid'
 *      category: // value for 'category'
 *      text: // value for 'text'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTableLikeColumnValueSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<TableLikeColumnValueSuggestionsQuery, TableLikeColumnValueSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableLikeColumnValueSuggestionsQuery, TableLikeColumnValueSuggestionsQueryVariables>(TableLikeColumnValueSuggestionsDocument, options);
      }
export function useTableLikeColumnValueSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableLikeColumnValueSuggestionsQuery, TableLikeColumnValueSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableLikeColumnValueSuggestionsQuery, TableLikeColumnValueSuggestionsQueryVariables>(TableLikeColumnValueSuggestionsDocument, options);
        }
export type TableLikeColumnValueSuggestionsQueryHookResult = ReturnType<typeof useTableLikeColumnValueSuggestionsQuery>;
export type TableLikeColumnValueSuggestionsLazyQueryHookResult = ReturnType<typeof useTableLikeColumnValueSuggestionsLazyQuery>;
export type TableLikeColumnValueSuggestionsQueryResult = Apollo.QueryResult<TableLikeColumnValueSuggestionsQuery, TableLikeColumnValueSuggestionsQueryVariables>;
export const TableLikeDefinitionDocument = gql`
    query TableLikeDefinition($source: TableLikeSourceInput!) {
  tableLikeDefinition(source: $source) {
    ...TableLikeDefinition
  }
}
    ${TableLikeDefinitionFragmentDoc}`;

/**
 * __useTableLikeDefinitionQuery__
 *
 * To run a query within a React component, call `useTableLikeDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableLikeDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableLikeDefinitionQuery({
 *   variables: {
 *      source: // value for 'source'
 *   },
 * });
 */
export function useTableLikeDefinitionQuery(baseOptions: Apollo.QueryHookOptions<TableLikeDefinitionQuery, TableLikeDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableLikeDefinitionQuery, TableLikeDefinitionQueryVariables>(TableLikeDefinitionDocument, options);
      }
export function useTableLikeDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableLikeDefinitionQuery, TableLikeDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableLikeDefinitionQuery, TableLikeDefinitionQueryVariables>(TableLikeDefinitionDocument, options);
        }
export type TableLikeDefinitionQueryHookResult = ReturnType<typeof useTableLikeDefinitionQuery>;
export type TableLikeDefinitionLazyQueryHookResult = ReturnType<typeof useTableLikeDefinitionLazyQuery>;
export type TableLikeDefinitionQueryResult = Apollo.QueryResult<TableLikeDefinitionQuery, TableLikeDefinitionQueryVariables>;
export const TableLikeExportDocument = gql`
    mutation TableLikeExport($source: TableLikeSourceInput!, $filtering: ColumnsFilteringInput, $selectedColumns: [String!], $search: String) {
  exportTableLikeRows(
    source: $source
    filtering: $filtering
    selectedColumns: $selectedColumns
    search: $search
  ) {
    failReasons
    export {
      id
    }
  }
}
    `;
export type TableLikeExportMutationFn = Apollo.MutationFunction<TableLikeExportMutation, TableLikeExportMutationVariables>;

/**
 * __useTableLikeExportMutation__
 *
 * To run a mutation, you first call `useTableLikeExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTableLikeExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tableLikeExportMutation, { data, loading, error }] = useTableLikeExportMutation({
 *   variables: {
 *      source: // value for 'source'
 *      filtering: // value for 'filtering'
 *      selectedColumns: // value for 'selectedColumns'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTableLikeExportMutation(baseOptions?: Apollo.MutationHookOptions<TableLikeExportMutation, TableLikeExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TableLikeExportMutation, TableLikeExportMutationVariables>(TableLikeExportDocument, options);
      }
export type TableLikeExportMutationHookResult = ReturnType<typeof useTableLikeExportMutation>;
export type TableLikeExportMutationResult = Apollo.MutationResult<TableLikeExportMutation>;
export type TableLikeExportMutationOptions = Apollo.BaseMutationOptions<TableLikeExportMutation, TableLikeExportMutationVariables>;
export const TableLikeRowsDocument = gql`
    query TableLikeRows($source: TableLikeSourceInput!, $ordering: [SortOrderInput!], $filtering: ColumnsFilteringInput, $selectedColumns: [String!], $search: String, $page: Int!, $perPage: Int!) {
  tableLikeRows(
    source: $source
    ordering: $ordering
    filtering: $filtering
    selectedColumns: $selectedColumns
    search: $search
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...TableRow
    }
    pageInfo {
      totalEntries
      totalPages
    }
  }
}
    ${TableRowFragmentDoc}`;

/**
 * __useTableLikeRowsQuery__
 *
 * To run a query within a React component, call `useTableLikeRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableLikeRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableLikeRowsQuery({
 *   variables: {
 *      source: // value for 'source'
 *      ordering: // value for 'ordering'
 *      filtering: // value for 'filtering'
 *      selectedColumns: // value for 'selectedColumns'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useTableLikeRowsQuery(baseOptions: Apollo.QueryHookOptions<TableLikeRowsQuery, TableLikeRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableLikeRowsQuery, TableLikeRowsQueryVariables>(TableLikeRowsDocument, options);
      }
export function useTableLikeRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableLikeRowsQuery, TableLikeRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableLikeRowsQuery, TableLikeRowsQueryVariables>(TableLikeRowsDocument, options);
        }
export type TableLikeRowsQueryHookResult = ReturnType<typeof useTableLikeRowsQuery>;
export type TableLikeRowsLazyQueryHookResult = ReturnType<typeof useTableLikeRowsLazyQuery>;
export type TableLikeRowsQueryResult = Apollo.QueryResult<TableLikeRowsQuery, TableLikeRowsQueryVariables>;
export const UpdateListViewColumnStateRenderModeLargeDocument = gql`
    mutation UpdateListViewColumnStateRenderModeLarge($listViewUid: String!, $columnState: String!, $name: String!) {
  updateListView(
    listViewUid: $listViewUid
    attributes: {renderMode: LARGE, name: $name, columnStateConfiguration: {scope: COLUMN_STATE, configuration: $columnState}}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type UpdateListViewColumnStateRenderModeLargeMutationFn = Apollo.MutationFunction<UpdateListViewColumnStateRenderModeLargeMutation, UpdateListViewColumnStateRenderModeLargeMutationVariables>;

/**
 * __useUpdateListViewColumnStateRenderModeLargeMutation__
 *
 * To run a mutation, you first call `useUpdateListViewColumnStateRenderModeLargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListViewColumnStateRenderModeLargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListViewColumnStateRenderModeLargeMutation, { data, loading, error }] = useUpdateListViewColumnStateRenderModeLargeMutation({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *      columnState: // value for 'columnState'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateListViewColumnStateRenderModeLargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListViewColumnStateRenderModeLargeMutation, UpdateListViewColumnStateRenderModeLargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListViewColumnStateRenderModeLargeMutation, UpdateListViewColumnStateRenderModeLargeMutationVariables>(UpdateListViewColumnStateRenderModeLargeDocument, options);
      }
export type UpdateListViewColumnStateRenderModeLargeMutationHookResult = ReturnType<typeof useUpdateListViewColumnStateRenderModeLargeMutation>;
export type UpdateListViewColumnStateRenderModeLargeMutationResult = Apollo.MutationResult<UpdateListViewColumnStateRenderModeLargeMutation>;
export type UpdateListViewColumnStateRenderModeLargeMutationOptions = Apollo.BaseMutationOptions<UpdateListViewColumnStateRenderModeLargeMutation, UpdateListViewColumnStateRenderModeLargeMutationVariables>;
export const UpdateListViewFilterModelRenderModeLargeDocument = gql`
    mutation UpdateListViewFilterModelRenderModeLarge($listViewUid: String!, $filterModel: String!, $name: String!) {
  updateListView(
    listViewUid: $listViewUid
    attributes: {renderMode: LARGE, name: $name, filterModelConfiguration: {scope: FILTER_MODEL, configuration: $filterModel}}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type UpdateListViewFilterModelRenderModeLargeMutationFn = Apollo.MutationFunction<UpdateListViewFilterModelRenderModeLargeMutation, UpdateListViewFilterModelRenderModeLargeMutationVariables>;

/**
 * __useUpdateListViewFilterModelRenderModeLargeMutation__
 *
 * To run a mutation, you first call `useUpdateListViewFilterModelRenderModeLargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListViewFilterModelRenderModeLargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListViewFilterModelRenderModeLargeMutation, { data, loading, error }] = useUpdateListViewFilterModelRenderModeLargeMutation({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *      filterModel: // value for 'filterModel'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateListViewFilterModelRenderModeLargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListViewFilterModelRenderModeLargeMutation, UpdateListViewFilterModelRenderModeLargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListViewFilterModelRenderModeLargeMutation, UpdateListViewFilterModelRenderModeLargeMutationVariables>(UpdateListViewFilterModelRenderModeLargeDocument, options);
      }
export type UpdateListViewFilterModelRenderModeLargeMutationHookResult = ReturnType<typeof useUpdateListViewFilterModelRenderModeLargeMutation>;
export type UpdateListViewFilterModelRenderModeLargeMutationResult = Apollo.MutationResult<UpdateListViewFilterModelRenderModeLargeMutation>;
export type UpdateListViewFilterModelRenderModeLargeMutationOptions = Apollo.BaseMutationOptions<UpdateListViewFilterModelRenderModeLargeMutation, UpdateListViewFilterModelRenderModeLargeMutationVariables>;
export const UpdateListViewSearchStateRenderModeLargeDocument = gql`
    mutation UpdateListViewSearchStateRenderModeLarge($listViewUid: String!, $searchState: String!, $name: String!) {
  updateListView(
    listViewUid: $listViewUid
    attributes: {renderMode: LARGE, name: $name, searchStateConfiguration: {scope: SEARCH_STATE, configuration: $searchState}}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type UpdateListViewSearchStateRenderModeLargeMutationFn = Apollo.MutationFunction<UpdateListViewSearchStateRenderModeLargeMutation, UpdateListViewSearchStateRenderModeLargeMutationVariables>;

/**
 * __useUpdateListViewSearchStateRenderModeLargeMutation__
 *
 * To run a mutation, you first call `useUpdateListViewSearchStateRenderModeLargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListViewSearchStateRenderModeLargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListViewSearchStateRenderModeLargeMutation, { data, loading, error }] = useUpdateListViewSearchStateRenderModeLargeMutation({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *      searchState: // value for 'searchState'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateListViewSearchStateRenderModeLargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListViewSearchStateRenderModeLargeMutation, UpdateListViewSearchStateRenderModeLargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListViewSearchStateRenderModeLargeMutation, UpdateListViewSearchStateRenderModeLargeMutationVariables>(UpdateListViewSearchStateRenderModeLargeDocument, options);
      }
export type UpdateListViewSearchStateRenderModeLargeMutationHookResult = ReturnType<typeof useUpdateListViewSearchStateRenderModeLargeMutation>;
export type UpdateListViewSearchStateRenderModeLargeMutationResult = Apollo.MutationResult<UpdateListViewSearchStateRenderModeLargeMutation>;
export type UpdateListViewSearchStateRenderModeLargeMutationOptions = Apollo.BaseMutationOptions<UpdateListViewSearchStateRenderModeLargeMutation, UpdateListViewSearchStateRenderModeLargeMutationVariables>;
export const UpdateTableLikeRowsDocument = gql`
    mutation updateTableLikeRows($source: TableLikeSourceInput!, $search: String, $filtering: ColumnsFilteringInput, $values: [ColumnValueInput!]!) {
  updateTableLikeRows(
    source: $source
    search: $search
    filtering: $filtering
    values: $values
  ) {
    failReasons
  }
}
    `;
export type UpdateTableLikeRowsMutationFn = Apollo.MutationFunction<UpdateTableLikeRowsMutation, UpdateTableLikeRowsMutationVariables>;

/**
 * __useUpdateTableLikeRowsMutation__
 *
 * To run a mutation, you first call `useUpdateTableLikeRowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableLikeRowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableLikeRowsMutation, { data, loading, error }] = useUpdateTableLikeRowsMutation({
 *   variables: {
 *      source: // value for 'source'
 *      search: // value for 'search'
 *      filtering: // value for 'filtering'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateTableLikeRowsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTableLikeRowsMutation, UpdateTableLikeRowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTableLikeRowsMutation, UpdateTableLikeRowsMutationVariables>(UpdateTableLikeRowsDocument, options);
      }
export type UpdateTableLikeRowsMutationHookResult = ReturnType<typeof useUpdateTableLikeRowsMutation>;
export type UpdateTableLikeRowsMutationResult = Apollo.MutationResult<UpdateTableLikeRowsMutation>;
export type UpdateTableLikeRowsMutationOptions = Apollo.BaseMutationOptions<UpdateTableLikeRowsMutation, UpdateTableLikeRowsMutationVariables>;
export const CompanyAutocompleteFieldWithOptionsDocument = gql`
    query CompanyAutocompleteFieldWithOptions($term: String, $page: Int, $perPage: Int) {
  companies(filter: {term: $term}, page: $page, perPage: $perPage) {
    entries {
      ...CompanyPreview
    }
  }
}
    ${CompanyPreviewFragmentDoc}`;

/**
 * __useCompanyAutocompleteFieldWithOptionsQuery__
 *
 * To run a query within a React component, call `useCompanyAutocompleteFieldWithOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAutocompleteFieldWithOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAutocompleteFieldWithOptionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCompanyAutocompleteFieldWithOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyAutocompleteFieldWithOptionsQuery, CompanyAutocompleteFieldWithOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAutocompleteFieldWithOptionsQuery, CompanyAutocompleteFieldWithOptionsQueryVariables>(CompanyAutocompleteFieldWithOptionsDocument, options);
      }
export function useCompanyAutocompleteFieldWithOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAutocompleteFieldWithOptionsQuery, CompanyAutocompleteFieldWithOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAutocompleteFieldWithOptionsQuery, CompanyAutocompleteFieldWithOptionsQueryVariables>(CompanyAutocompleteFieldWithOptionsDocument, options);
        }
export type CompanyAutocompleteFieldWithOptionsQueryHookResult = ReturnType<typeof useCompanyAutocompleteFieldWithOptionsQuery>;
export type CompanyAutocompleteFieldWithOptionsLazyQueryHookResult = ReturnType<typeof useCompanyAutocompleteFieldWithOptionsLazyQuery>;
export type CompanyAutocompleteFieldWithOptionsQueryResult = Apollo.QueryResult<CompanyAutocompleteFieldWithOptionsQuery, CompanyAutocompleteFieldWithOptionsQueryVariables>;
export const CreateCompanyListCustomFieldSchemaDocument = gql`
    mutation CreateCompanyListCustomFieldSchema($companyListUuid: ID!, $customFieldAttributes: CustomFieldSchemaAttributes!) {
  createCompanyListCustomFieldSchema(
    companyListUuid: $companyListUuid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
  }
}
    `;
export type CreateCompanyListCustomFieldSchemaMutationFn = Apollo.MutationFunction<CreateCompanyListCustomFieldSchemaMutation, CreateCompanyListCustomFieldSchemaMutationVariables>;

/**
 * __useCreateCompanyListCustomFieldSchemaMutation__
 *
 * To run a mutation, you first call `useCreateCompanyListCustomFieldSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyListCustomFieldSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyListCustomFieldSchemaMutation, { data, loading, error }] = useCreateCompanyListCustomFieldSchemaMutation({
 *   variables: {
 *      companyListUuid: // value for 'companyListUuid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useCreateCompanyListCustomFieldSchemaMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyListCustomFieldSchemaMutation, CreateCompanyListCustomFieldSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyListCustomFieldSchemaMutation, CreateCompanyListCustomFieldSchemaMutationVariables>(CreateCompanyListCustomFieldSchemaDocument, options);
      }
export type CreateCompanyListCustomFieldSchemaMutationHookResult = ReturnType<typeof useCreateCompanyListCustomFieldSchemaMutation>;
export type CreateCompanyListCustomFieldSchemaMutationResult = Apollo.MutationResult<CreateCompanyListCustomFieldSchemaMutation>;
export type CreateCompanyListCustomFieldSchemaMutationOptions = Apollo.BaseMutationOptions<CreateCompanyListCustomFieldSchemaMutation, CreateCompanyListCustomFieldSchemaMutationVariables>;
export const RebuildKeyActivityDocument = gql`
    mutation RebuildKeyActivity($keyActivityUid: ID!, $activityTitle: String!, $keyActivityCategory: KeyActivityCategory!, $notes: String, $description: String, $interactionOn: ISO8601DateTime!, $interactionEndAt: ISO8601DateTime, $externalContacts: [String!], $internalContacts: [String!], $noRecreate: Boolean = false) {
  rebuildKeyActivity(
    keyActivityUid: $keyActivityUid
    activityTitle: $activityTitle
    keyActivityCategory: $keyActivityCategory
    notes: $notes
    description: $description
    interactionOn: $interactionOn
    interactionEndAt: $interactionEndAt
    externalContacts: $externalContacts
    internalContacts: $internalContacts
    noRecreate: $noRecreate
  ) {
    failReasons
    keyActivity {
      ...RebuildKeyActivity
    }
  }
}
    ${RebuildKeyActivityFragmentDoc}`;
export type RebuildKeyActivityMutationFn = Apollo.MutationFunction<RebuildKeyActivityMutation, RebuildKeyActivityMutationVariables>;

/**
 * __useRebuildKeyActivityMutation__
 *
 * To run a mutation, you first call `useRebuildKeyActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRebuildKeyActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rebuildKeyActivityMutation, { data, loading, error }] = useRebuildKeyActivityMutation({
 *   variables: {
 *      keyActivityUid: // value for 'keyActivityUid'
 *      activityTitle: // value for 'activityTitle'
 *      keyActivityCategory: // value for 'keyActivityCategory'
 *      notes: // value for 'notes'
 *      description: // value for 'description'
 *      interactionOn: // value for 'interactionOn'
 *      interactionEndAt: // value for 'interactionEndAt'
 *      externalContacts: // value for 'externalContacts'
 *      internalContacts: // value for 'internalContacts'
 *      noRecreate: // value for 'noRecreate'
 *   },
 * });
 */
export function useRebuildKeyActivityMutation(baseOptions?: Apollo.MutationHookOptions<RebuildKeyActivityMutation, RebuildKeyActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RebuildKeyActivityMutation, RebuildKeyActivityMutationVariables>(RebuildKeyActivityDocument, options);
      }
export type RebuildKeyActivityMutationHookResult = ReturnType<typeof useRebuildKeyActivityMutation>;
export type RebuildKeyActivityMutationResult = Apollo.MutationResult<RebuildKeyActivityMutation>;
export type RebuildKeyActivityMutationOptions = Apollo.BaseMutationOptions<RebuildKeyActivityMutation, RebuildKeyActivityMutationVariables>;
export const MarkChangedCompanyDocument = gql`
    mutation MarkChangedCompany($contactUid: ID!, $removeFromMarketingList: Boolean) {
  addContactUnknownCompanySwitch(
    contactUid: $contactUid
    removeFromMarketingList: $removeFromMarketingList
  ) {
    failReasons
  }
}
    `;
export type MarkChangedCompanyMutationFn = Apollo.MutationFunction<MarkChangedCompanyMutation, MarkChangedCompanyMutationVariables>;

/**
 * __useMarkChangedCompanyMutation__
 *
 * To run a mutation, you first call `useMarkChangedCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChangedCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChangedCompanyMutation, { data, loading, error }] = useMarkChangedCompanyMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      removeFromMarketingList: // value for 'removeFromMarketingList'
 *   },
 * });
 */
export function useMarkChangedCompanyMutation(baseOptions?: Apollo.MutationHookOptions<MarkChangedCompanyMutation, MarkChangedCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkChangedCompanyMutation, MarkChangedCompanyMutationVariables>(MarkChangedCompanyDocument, options);
      }
export type MarkChangedCompanyMutationHookResult = ReturnType<typeof useMarkChangedCompanyMutation>;
export type MarkChangedCompanyMutationResult = Apollo.MutationResult<MarkChangedCompanyMutation>;
export type MarkChangedCompanyMutationOptions = Apollo.BaseMutationOptions<MarkChangedCompanyMutation, MarkChangedCompanyMutationVariables>;
export const ArchivePersonDocument = gql`
    mutation ArchivePerson($personUid: ID!) {
  result: archivePerson(personUid: $personUid) {
    failReasons
  }
}
    `;
export type ArchivePersonMutationFn = Apollo.MutationFunction<ArchivePersonMutation, ArchivePersonMutationVariables>;

/**
 * __useArchivePersonMutation__
 *
 * To run a mutation, you first call `useArchivePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePersonMutation, { data, loading, error }] = useArchivePersonMutation({
 *   variables: {
 *      personUid: // value for 'personUid'
 *   },
 * });
 */
export function useArchivePersonMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePersonMutation, ArchivePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePersonMutation, ArchivePersonMutationVariables>(ArchivePersonDocument, options);
      }
export type ArchivePersonMutationHookResult = ReturnType<typeof useArchivePersonMutation>;
export type ArchivePersonMutationResult = Apollo.MutationResult<ArchivePersonMutation>;
export type ArchivePersonMutationOptions = Apollo.BaseMutationOptions<ArchivePersonMutation, ArchivePersonMutationVariables>;
export const PersonDocument = gql`
    query Person($uid: String!) {
  person(uid: $uid) {
    ...PersonPreview
  }
}
    ${PersonPreviewFragmentDoc}`;

/**
 * __usePersonQuery__
 *
 * To run a query within a React component, call `usePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function usePersonQuery(baseOptions: Apollo.QueryHookOptions<PersonQuery, PersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonQuery, PersonQueryVariables>(PersonDocument, options);
      }
export function usePersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonQuery, PersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonQuery, PersonQueryVariables>(PersonDocument, options);
        }
export type PersonQueryHookResult = ReturnType<typeof usePersonQuery>;
export type PersonLazyQueryHookResult = ReturnType<typeof usePersonLazyQuery>;
export type PersonQueryResult = Apollo.QueryResult<PersonQuery, PersonQueryVariables>;
export const CustomObjectsImporterDocument = gql`
    mutation CustomObjectsImporter($templateId: ID!) {
  result: createFlatfileWorkbookForCustomObjectsAdminImport(
    templateUid: $templateId
  ) {
    failReasons
    workbook {
      ...CreatedWorkbook
    }
  }
}
    ${CreatedWorkbookFragmentDoc}`;
export type CustomObjectsImporterMutationFn = Apollo.MutationFunction<CustomObjectsImporterMutation, CustomObjectsImporterMutationVariables>;

/**
 * __useCustomObjectsImporterMutation__
 *
 * To run a mutation, you first call `useCustomObjectsImporterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomObjectsImporterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customObjectsImporterMutation, { data, loading, error }] = useCustomObjectsImporterMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useCustomObjectsImporterMutation(baseOptions?: Apollo.MutationHookOptions<CustomObjectsImporterMutation, CustomObjectsImporterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomObjectsImporterMutation, CustomObjectsImporterMutationVariables>(CustomObjectsImporterDocument, options);
      }
export type CustomObjectsImporterMutationHookResult = ReturnType<typeof useCustomObjectsImporterMutation>;
export type CustomObjectsImporterMutationResult = Apollo.MutationResult<CustomObjectsImporterMutation>;
export type CustomObjectsImporterMutationOptions = Apollo.BaseMutationOptions<CustomObjectsImporterMutation, CustomObjectsImporterMutationVariables>;
export const CreateGenericListCustomFieldSchemaDocument = gql`
    mutation CreateGenericListCustomFieldSchema($genericListUid: ID!, $schemaAttributes: CustomFieldSchemaAttributes!) {
  createGenericListCustomFieldSchema(
    genericListUid: $genericListUid
    schemaAttributes: $schemaAttributes
  ) {
    failReasons
  }
}
    `;
export type CreateGenericListCustomFieldSchemaMutationFn = Apollo.MutationFunction<CreateGenericListCustomFieldSchemaMutation, CreateGenericListCustomFieldSchemaMutationVariables>;

/**
 * __useCreateGenericListCustomFieldSchemaMutation__
 *
 * To run a mutation, you first call `useCreateGenericListCustomFieldSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericListCustomFieldSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericListCustomFieldSchemaMutation, { data, loading, error }] = useCreateGenericListCustomFieldSchemaMutation({
 *   variables: {
 *      genericListUid: // value for 'genericListUid'
 *      schemaAttributes: // value for 'schemaAttributes'
 *   },
 * });
 */
export function useCreateGenericListCustomFieldSchemaMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericListCustomFieldSchemaMutation, CreateGenericListCustomFieldSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericListCustomFieldSchemaMutation, CreateGenericListCustomFieldSchemaMutationVariables>(CreateGenericListCustomFieldSchemaDocument, options);
      }
export type CreateGenericListCustomFieldSchemaMutationHookResult = ReturnType<typeof useCreateGenericListCustomFieldSchemaMutation>;
export type CreateGenericListCustomFieldSchemaMutationResult = Apollo.MutationResult<CreateGenericListCustomFieldSchemaMutation>;
export type CreateGenericListCustomFieldSchemaMutationOptions = Apollo.BaseMutationOptions<CreateGenericListCustomFieldSchemaMutation, CreateGenericListCustomFieldSchemaMutationVariables>;
export const AddCompanyContactToPersonDocument = gql`
    mutation AddCompanyContactToPerson($personUid: ID!, $companyEmail: String, $companyUid: String!, $jobTitle: String) {
  addCompanyContactToPerson(
    personUid: $personUid
    companyEmail: $companyEmail
    companyUid: $companyUid
    jobTitle: $jobTitle
  ) {
    failReasons
  }
}
    `;
export type AddCompanyContactToPersonMutationFn = Apollo.MutationFunction<AddCompanyContactToPersonMutation, AddCompanyContactToPersonMutationVariables>;

/**
 * __useAddCompanyContactToPersonMutation__
 *
 * To run a mutation, you first call `useAddCompanyContactToPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyContactToPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyContactToPersonMutation, { data, loading, error }] = useAddCompanyContactToPersonMutation({
 *   variables: {
 *      personUid: // value for 'personUid'
 *      companyEmail: // value for 'companyEmail'
 *      companyUid: // value for 'companyUid'
 *      jobTitle: // value for 'jobTitle'
 *   },
 * });
 */
export function useAddCompanyContactToPersonMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyContactToPersonMutation, AddCompanyContactToPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyContactToPersonMutation, AddCompanyContactToPersonMutationVariables>(AddCompanyContactToPersonDocument, options);
      }
export type AddCompanyContactToPersonMutationHookResult = ReturnType<typeof useAddCompanyContactToPersonMutation>;
export type AddCompanyContactToPersonMutationResult = Apollo.MutationResult<AddCompanyContactToPersonMutation>;
export type AddCompanyContactToPersonMutationOptions = Apollo.BaseMutationOptions<AddCompanyContactToPersonMutation, AddCompanyContactToPersonMutationVariables>;
export const AddCompanyDocumentDocument = gql`
    mutation AddCompanyDocument($companyUid: String!, $attributes: CompanyDocumentAttributes!) {
  addCompanyDocument(companyUid: $companyUid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type AddCompanyDocumentMutationFn = Apollo.MutationFunction<AddCompanyDocumentMutation, AddCompanyDocumentMutationVariables>;

/**
 * __useAddCompanyDocumentMutation__
 *
 * To run a mutation, you first call `useAddCompanyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyDocumentMutation, { data, loading, error }] = useAddCompanyDocumentMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddCompanyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyDocumentMutation, AddCompanyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyDocumentMutation, AddCompanyDocumentMutationVariables>(AddCompanyDocumentDocument, options);
      }
export type AddCompanyDocumentMutationHookResult = ReturnType<typeof useAddCompanyDocumentMutation>;
export type AddCompanyDocumentMutationResult = Apollo.MutationResult<AddCompanyDocumentMutation>;
export type AddCompanyDocumentMutationOptions = Apollo.BaseMutationOptions<AddCompanyDocumentMutation, AddCompanyDocumentMutationVariables>;
export const AddContactDocument = gql`
    mutation AddContact($email: String!, $companyName: String, $personUid: String) {
  addContact(email: $email, companyName: $companyName, personUid: $personUid) {
    failReasons
    uid
  }
}
    `;
export type AddContactMutationFn = Apollo.MutationFunction<AddContactMutation, AddContactMutationVariables>;

/**
 * __useAddContactMutation__
 *
 * To run a mutation, you first call `useAddContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactMutation, { data, loading, error }] = useAddContactMutation({
 *   variables: {
 *      email: // value for 'email'
 *      companyName: // value for 'companyName'
 *      personUid: // value for 'personUid'
 *   },
 * });
 */
export function useAddContactMutation(baseOptions?: Apollo.MutationHookOptions<AddContactMutation, AddContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactMutation, AddContactMutationVariables>(AddContactDocument, options);
      }
export type AddContactMutationHookResult = ReturnType<typeof useAddContactMutation>;
export type AddContactMutationResult = Apollo.MutationResult<AddContactMutation>;
export type AddContactMutationOptions = Apollo.BaseMutationOptions<AddContactMutation, AddContactMutationVariables>;
export const AddContactToListDocument = gql`
    mutation AddContactToList($listUid: ID!, $contactUid: String!) {
  addContactToList(listUid: $listUid, contactUid: $contactUid) {
    failReasons
    record {
      ...ContactProjectListMemberRow
    }
  }
}
    ${ContactProjectListMemberRowFragmentDoc}`;
export type AddContactToListMutationFn = Apollo.MutationFunction<AddContactToListMutation, AddContactToListMutationVariables>;

/**
 * __useAddContactToListMutation__
 *
 * To run a mutation, you first call `useAddContactToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactToListMutation, { data, loading, error }] = useAddContactToListMutation({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useAddContactToListMutation(baseOptions?: Apollo.MutationHookOptions<AddContactToListMutation, AddContactToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactToListMutation, AddContactToListMutationVariables>(AddContactToListDocument, options);
      }
export type AddContactToListMutationHookResult = ReturnType<typeof useAddContactToListMutation>;
export type AddContactToListMutationResult = Apollo.MutationResult<AddContactToListMutation>;
export type AddContactToListMutationOptions = Apollo.BaseMutationOptions<AddContactToListMutation, AddContactToListMutationVariables>;
export const AddContactToListWithCustomFieldsDocument = gql`
    mutation AddContactToListWithCustomFields($listUid: ID!, $contactUid: String!, $customFieldAttributes: [CustomFieldAttribute!]!) {
  addContactToList(
    listUid: $listUid
    contactUid: $contactUid
    customFields: $customFieldAttributes
    upsert: false
  ) {
    failReasons
    record {
      ...ContactProjectListMemberRow
    }
    gridMemberRecord {
      ...ContactListGridMemberRow
    }
  }
}
    ${ContactProjectListMemberRowFragmentDoc}
${ContactListGridMemberRowFragmentDoc}`;
export type AddContactToListWithCustomFieldsMutationFn = Apollo.MutationFunction<AddContactToListWithCustomFieldsMutation, AddContactToListWithCustomFieldsMutationVariables>;

/**
 * __useAddContactToListWithCustomFieldsMutation__
 *
 * To run a mutation, you first call `useAddContactToListWithCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactToListWithCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactToListWithCustomFieldsMutation, { data, loading, error }] = useAddContactToListWithCustomFieldsMutation({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      contactUid: // value for 'contactUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useAddContactToListWithCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<AddContactToListWithCustomFieldsMutation, AddContactToListWithCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactToListWithCustomFieldsMutation, AddContactToListWithCustomFieldsMutationVariables>(AddContactToListWithCustomFieldsDocument, options);
      }
export type AddContactToListWithCustomFieldsMutationHookResult = ReturnType<typeof useAddContactToListWithCustomFieldsMutation>;
export type AddContactToListWithCustomFieldsMutationResult = Apollo.MutationResult<AddContactToListWithCustomFieldsMutation>;
export type AddContactToListWithCustomFieldsMutationOptions = Apollo.BaseMutationOptions<AddContactToListWithCustomFieldsMutation, AddContactToListWithCustomFieldsMutationVariables>;
export const AddCustomOptionDocument = gql`
    mutation AddCustomOption($schemaUuid: ID!, $options: [OptionsAttributes!]!) {
  addCustomOption(schemaUuid: $schemaUuid, options: $options) {
    failReasons
  }
}
    `;
export type AddCustomOptionMutationFn = Apollo.MutationFunction<AddCustomOptionMutation, AddCustomOptionMutationVariables>;

/**
 * __useAddCustomOptionMutation__
 *
 * To run a mutation, you first call `useAddCustomOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomOptionMutation, { data, loading, error }] = useAddCustomOptionMutation({
 *   variables: {
 *      schemaUuid: // value for 'schemaUuid'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useAddCustomOptionMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomOptionMutation, AddCustomOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomOptionMutation, AddCustomOptionMutationVariables>(AddCustomOptionDocument, options);
      }
export type AddCustomOptionMutationHookResult = ReturnType<typeof useAddCustomOptionMutation>;
export type AddCustomOptionMutationResult = Apollo.MutationResult<AddCustomOptionMutation>;
export type AddCustomOptionMutationOptions = Apollo.BaseMutationOptions<AddCustomOptionMutation, AddCustomOptionMutationVariables>;
export const AddGoalFileDocument = gql`
    mutation AddGoalFile($goalUuid: ID!, $files: [String!]!) {
  addGoalFile: addOpportunityFile(goalUuid: $goalUuid, files: $files) {
    failReasons
  }
}
    `;
export type AddGoalFileMutationFn = Apollo.MutationFunction<AddGoalFileMutation, AddGoalFileMutationVariables>;

/**
 * __useAddGoalFileMutation__
 *
 * To run a mutation, you first call `useAddGoalFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGoalFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGoalFileMutation, { data, loading, error }] = useAddGoalFileMutation({
 *   variables: {
 *      goalUuid: // value for 'goalUuid'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useAddGoalFileMutation(baseOptions?: Apollo.MutationHookOptions<AddGoalFileMutation, AddGoalFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGoalFileMutation, AddGoalFileMutationVariables>(AddGoalFileDocument, options);
      }
export type AddGoalFileMutationHookResult = ReturnType<typeof useAddGoalFileMutation>;
export type AddGoalFileMutationResult = Apollo.MutationResult<AddGoalFileMutation>;
export type AddGoalFileMutationOptions = Apollo.BaseMutationOptions<AddGoalFileMutation, AddGoalFileMutationVariables>;
export const AddMyContactDocument = gql`
    mutation AddMyContact($contactUid: String!) {
  addMyContact(contactUid: $contactUid) {
    failReasons
    id
    contactId
  }
}
    `;
export type AddMyContactMutationFn = Apollo.MutationFunction<AddMyContactMutation, AddMyContactMutationVariables>;

/**
 * __useAddMyContactMutation__
 *
 * To run a mutation, you first call `useAddMyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMyContactMutation, { data, loading, error }] = useAddMyContactMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useAddMyContactMutation(baseOptions?: Apollo.MutationHookOptions<AddMyContactMutation, AddMyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMyContactMutation, AddMyContactMutationVariables>(AddMyContactDocument, options);
      }
export type AddMyContactMutationHookResult = ReturnType<typeof useAddMyContactMutation>;
export type AddMyContactMutationResult = Apollo.MutationResult<AddMyContactMutation>;
export type AddMyContactMutationOptions = Apollo.BaseMutationOptions<AddMyContactMutation, AddMyContactMutationVariables>;
export const AllActivityFeedDocument = gql`
    query AllActivityFeed($contactUid: ID!, $page: Int, $perPage: Int, $filter: InteractionsFilter) {
  allActivityFeed(
    contactUid: $contactUid
    page: $page
    perPage: $perPage
    filter: $filter
  ) {
    entries {
      ...TimelineEventEntry
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${TimelineEventEntryFragmentDoc}`;

/**
 * __useAllActivityFeedQuery__
 *
 * To run a query within a React component, call `useAllActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActivityFeedQuery({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllActivityFeedQuery(baseOptions: Apollo.QueryHookOptions<AllActivityFeedQuery, AllActivityFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActivityFeedQuery, AllActivityFeedQueryVariables>(AllActivityFeedDocument, options);
      }
export function useAllActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActivityFeedQuery, AllActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActivityFeedQuery, AllActivityFeedQueryVariables>(AllActivityFeedDocument, options);
        }
export type AllActivityFeedQueryHookResult = ReturnType<typeof useAllActivityFeedQuery>;
export type AllActivityFeedLazyQueryHookResult = ReturnType<typeof useAllActivityFeedLazyQuery>;
export type AllActivityFeedQueryResult = Apollo.QueryResult<AllActivityFeedQuery, AllActivityFeedQueryVariables>;
export const ApiConnectionsDocument = gql`
    query ApiConnections($listUid: ID!) {
  apiConnections(listUid: $listUid) {
    ...ApiConnection
  }
}
    ${ApiConnectionFragmentDoc}`;

/**
 * __useApiConnectionsQuery__
 *
 * To run a query within a React component, call `useApiConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiConnectionsQuery({
 *   variables: {
 *      listUid: // value for 'listUid'
 *   },
 * });
 */
export function useApiConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ApiConnectionsQuery, ApiConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiConnectionsQuery, ApiConnectionsQueryVariables>(ApiConnectionsDocument, options);
      }
export function useApiConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiConnectionsQuery, ApiConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiConnectionsQuery, ApiConnectionsQueryVariables>(ApiConnectionsDocument, options);
        }
export type ApiConnectionsQueryHookResult = ReturnType<typeof useApiConnectionsQuery>;
export type ApiConnectionsLazyQueryHookResult = ReturnType<typeof useApiConnectionsLazyQuery>;
export type ApiConnectionsQueryResult = Apollo.QueryResult<ApiConnectionsQuery, ApiConnectionsQueryVariables>;
export const ArchiveCompanyDocument = gql`
    mutation ArchiveCompany($uuid: ID!) {
  archiveCompany(uuid: $uuid) {
    failReasons
  }
}
    `;
export type ArchiveCompanyMutationFn = Apollo.MutationFunction<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>;

/**
 * __useArchiveCompanyMutation__
 *
 * To run a mutation, you first call `useArchiveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCompanyMutation, { data, loading, error }] = useArchiveCompanyMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useArchiveCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>(ArchiveCompanyDocument, options);
      }
export type ArchiveCompanyMutationHookResult = ReturnType<typeof useArchiveCompanyMutation>;
export type ArchiveCompanyMutationResult = Apollo.MutationResult<ArchiveCompanyMutation>;
export type ArchiveCompanyMutationOptions = Apollo.BaseMutationOptions<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>;
export const ArchiveContactDocument = gql`
    mutation ArchiveContact($uuid: ID!, $unarchiveOnInteraction: Boolean = false) {
  archiveContact(uuid: $uuid, unarchiveOnInteraction: $unarchiveOnInteraction) {
    failReasons
    contact {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveContactMutationFn = Apollo.MutationFunction<ArchiveContactMutation, ArchiveContactMutationVariables>;

/**
 * __useArchiveContactMutation__
 *
 * To run a mutation, you first call `useArchiveContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveContactMutation, { data, loading, error }] = useArchiveContactMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      unarchiveOnInteraction: // value for 'unarchiveOnInteraction'
 *   },
 * });
 */
export function useArchiveContactMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveContactMutation, ArchiveContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveContactMutation, ArchiveContactMutationVariables>(ArchiveContactDocument, options);
      }
export type ArchiveContactMutationHookResult = ReturnType<typeof useArchiveContactMutation>;
export type ArchiveContactMutationResult = Apollo.MutationResult<ArchiveContactMutation>;
export type ArchiveContactMutationOptions = Apollo.BaseMutationOptions<ArchiveContactMutation, ArchiveContactMutationVariables>;
export const ArchiveGoalDocument = gql`
    mutation ArchiveGoal($uuid: ID!) {
  archiveGoal: archiveOpportunity(uuid: $uuid) {
    failReasons
  }
}
    `;
export type ArchiveGoalMutationFn = Apollo.MutationFunction<ArchiveGoalMutation, ArchiveGoalMutationVariables>;

/**
 * __useArchiveGoalMutation__
 *
 * To run a mutation, you first call `useArchiveGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveGoalMutation, { data, loading, error }] = useArchiveGoalMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useArchiveGoalMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveGoalMutation, ArchiveGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveGoalMutation, ArchiveGoalMutationVariables>(ArchiveGoalDocument, options);
      }
export type ArchiveGoalMutationHookResult = ReturnType<typeof useArchiveGoalMutation>;
export type ArchiveGoalMutationResult = Apollo.MutationResult<ArchiveGoalMutation>;
export type ArchiveGoalMutationOptions = Apollo.BaseMutationOptions<ArchiveGoalMutation, ArchiveGoalMutationVariables>;
export const BulkAddListMemberDocument = gql`
    mutation BulkAddListMember($uid: ID!, $contactEmails: [String!]!) {
  bulkAddListMember(uid: $uid, contactEmails: $contactEmails) {
    failReasons
    members {
      ...ContactProjectListMemberRow
    }
    blockedContacts {
      id
      ...BlockedContactList
    }
    gridMemberRecords {
      ...ContactListGridMemberRow
    }
  }
}
    ${ContactProjectListMemberRowFragmentDoc}
${BlockedContactListFragmentDoc}
${ContactListGridMemberRowFragmentDoc}`;
export type BulkAddListMemberMutationFn = Apollo.MutationFunction<BulkAddListMemberMutation, BulkAddListMemberMutationVariables>;

/**
 * __useBulkAddListMemberMutation__
 *
 * To run a mutation, you first call `useBulkAddListMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddListMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddListMemberMutation, { data, loading, error }] = useBulkAddListMemberMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      contactEmails: // value for 'contactEmails'
 *   },
 * });
 */
export function useBulkAddListMemberMutation(baseOptions?: Apollo.MutationHookOptions<BulkAddListMemberMutation, BulkAddListMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAddListMemberMutation, BulkAddListMemberMutationVariables>(BulkAddListMemberDocument, options);
      }
export type BulkAddListMemberMutationHookResult = ReturnType<typeof useBulkAddListMemberMutation>;
export type BulkAddListMemberMutationResult = Apollo.MutationResult<BulkAddListMemberMutation>;
export type BulkAddListMemberMutationOptions = Apollo.BaseMutationOptions<BulkAddListMemberMutation, BulkAddListMemberMutationVariables>;
export const BulkStayInTouchDocument = gql`
    mutation BulkStayInTouch($myContactEmails: [String!]!, $frequency: StayInTouchFrequency!) {
  bulkStayInTouch(myContactEmails: $myContactEmails, frequency: $frequency) {
    failReasons
  }
}
    `;
export type BulkStayInTouchMutationFn = Apollo.MutationFunction<BulkStayInTouchMutation, BulkStayInTouchMutationVariables>;

/**
 * __useBulkStayInTouchMutation__
 *
 * To run a mutation, you first call `useBulkStayInTouchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStayInTouchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStayInTouchMutation, { data, loading, error }] = useBulkStayInTouchMutation({
 *   variables: {
 *      myContactEmails: // value for 'myContactEmails'
 *      frequency: // value for 'frequency'
 *   },
 * });
 */
export function useBulkStayInTouchMutation(baseOptions?: Apollo.MutationHookOptions<BulkStayInTouchMutation, BulkStayInTouchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkStayInTouchMutation, BulkStayInTouchMutationVariables>(BulkStayInTouchDocument, options);
      }
export type BulkStayInTouchMutationHookResult = ReturnType<typeof useBulkStayInTouchMutation>;
export type BulkStayInTouchMutationResult = Apollo.MutationResult<BulkStayInTouchMutation>;
export type BulkStayInTouchMutationOptions = Apollo.BaseMutationOptions<BulkStayInTouchMutation, BulkStayInTouchMutationVariables>;
export const CheckNewVersionDocument = gql`
    query CheckNewVersion {
  deploymentInfo {
    commit
  }
}
    `;

/**
 * __useCheckNewVersionQuery__
 *
 * To run a query within a React component, call `useCheckNewVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckNewVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckNewVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckNewVersionQuery(baseOptions?: Apollo.QueryHookOptions<CheckNewVersionQuery, CheckNewVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckNewVersionQuery, CheckNewVersionQueryVariables>(CheckNewVersionDocument, options);
      }
export function useCheckNewVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckNewVersionQuery, CheckNewVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckNewVersionQuery, CheckNewVersionQueryVariables>(CheckNewVersionDocument, options);
        }
export type CheckNewVersionQueryHookResult = ReturnType<typeof useCheckNewVersionQuery>;
export type CheckNewVersionLazyQueryHookResult = ReturnType<typeof useCheckNewVersionLazyQuery>;
export type CheckNewVersionQueryResult = Apollo.QueryResult<CheckNewVersionQuery, CheckNewVersionQueryVariables>;
export const CompanyDocumentsDocument = gql`
    query CompanyDocuments($uid: String!) {
  company(uid: $uid) {
    documents {
      ...CompanyDocumentOverview
    }
  }
}
    ${CompanyDocumentOverviewFragmentDoc}`;

/**
 * __useCompanyDocumentsQuery__
 *
 * To run a query within a React component, call `useCompanyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDocumentsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCompanyDocumentsQuery(baseOptions: Apollo.QueryHookOptions<CompanyDocumentsQuery, CompanyDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDocumentsQuery, CompanyDocumentsQueryVariables>(CompanyDocumentsDocument, options);
      }
export function useCompanyDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDocumentsQuery, CompanyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDocumentsQuery, CompanyDocumentsQueryVariables>(CompanyDocumentsDocument, options);
        }
export type CompanyDocumentsQueryHookResult = ReturnType<typeof useCompanyDocumentsQuery>;
export type CompanyDocumentsLazyQueryHookResult = ReturnType<typeof useCompanyDocumentsLazyQuery>;
export type CompanyDocumentsQueryResult = Apollo.QueryResult<CompanyDocumentsQuery, CompanyDocumentsQueryVariables>;
export const CompanyListMembershipsDocument = gql`
    query CompanyListMemberships($companyUid: String!, $excludeHidden: Boolean) {
  companyListMemberships(companyUid: $companyUid, excludeHidden: $excludeHidden) {
    entries {
      id
      companyList {
        ...MembershipCompanyList
      }
    }
  }
}
    ${MembershipCompanyListFragmentDoc}`;

/**
 * __useCompanyListMembershipsQuery__
 *
 * To run a query within a React component, call `useCompanyListMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListMembershipsQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      excludeHidden: // value for 'excludeHidden'
 *   },
 * });
 */
export function useCompanyListMembershipsQuery(baseOptions: Apollo.QueryHookOptions<CompanyListMembershipsQuery, CompanyListMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListMembershipsQuery, CompanyListMembershipsQueryVariables>(CompanyListMembershipsDocument, options);
      }
export function useCompanyListMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListMembershipsQuery, CompanyListMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListMembershipsQuery, CompanyListMembershipsQueryVariables>(CompanyListMembershipsDocument, options);
        }
export type CompanyListMembershipsQueryHookResult = ReturnType<typeof useCompanyListMembershipsQuery>;
export type CompanyListMembershipsLazyQueryHookResult = ReturnType<typeof useCompanyListMembershipsLazyQuery>;
export type CompanyListMembershipsQueryResult = Apollo.QueryResult<CompanyListMembershipsQuery, CompanyListMembershipsQueryVariables>;
export const CompanyOfficeLocationsDocument = gql`
    query CompanyOfficeLocations($companyId: ID!) {
  companyOfficeLocations(companyId: $companyId, page: 1, perPage: 100) {
    entries {
      ...CompanyOfficeLocationRow
    }
  }
}
    ${CompanyOfficeLocationRowFragmentDoc}`;

/**
 * __useCompanyOfficeLocationsQuery__
 *
 * To run a query within a React component, call `useCompanyOfficeLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyOfficeLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyOfficeLocationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyOfficeLocationsQuery(baseOptions: Apollo.QueryHookOptions<CompanyOfficeLocationsQuery, CompanyOfficeLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyOfficeLocationsQuery, CompanyOfficeLocationsQueryVariables>(CompanyOfficeLocationsDocument, options);
      }
export function useCompanyOfficeLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyOfficeLocationsQuery, CompanyOfficeLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyOfficeLocationsQuery, CompanyOfficeLocationsQueryVariables>(CompanyOfficeLocationsDocument, options);
        }
export type CompanyOfficeLocationsQueryHookResult = ReturnType<typeof useCompanyOfficeLocationsQuery>;
export type CompanyOfficeLocationsLazyQueryHookResult = ReturnType<typeof useCompanyOfficeLocationsLazyQuery>;
export type CompanyOfficeLocationsQueryResult = Apollo.QueryResult<CompanyOfficeLocationsQuery, CompanyOfficeLocationsQueryVariables>;
export const ContactLocationsDocument = gql`
    query ContactLocations($companyId: String!, $perPage: Int) {
  contactLocations(companyDomain: $companyId, perPage: $perPage) {
    entries {
      city
      country {
        name
      }
    }
  }
}
    `;

/**
 * __useContactLocationsQuery__
 *
 * To run a query within a React component, call `useContactLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactLocationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useContactLocationsQuery(baseOptions: Apollo.QueryHookOptions<ContactLocationsQuery, ContactLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactLocationsQuery, ContactLocationsQueryVariables>(ContactLocationsDocument, options);
      }
export function useContactLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactLocationsQuery, ContactLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactLocationsQuery, ContactLocationsQueryVariables>(ContactLocationsDocument, options);
        }
export type ContactLocationsQueryHookResult = ReturnType<typeof useContactLocationsQuery>;
export type ContactLocationsLazyQueryHookResult = ReturnType<typeof useContactLocationsLazyQuery>;
export type ContactLocationsQueryResult = Apollo.QueryResult<ContactLocationsQuery, ContactLocationsQueryVariables>;
export const ContactOptionsDocument = gql`
    query ContactOptions($filters: [ContactFilter!], $filter: ContactsFiltering) {
  contacts(filter: $filter, filters: $filters, page: 1, perPage: 5) {
    entries {
      ...ContactPreview
    }
  }
}
    ${ContactPreviewFragmentDoc}`;

/**
 * __useContactOptionsQuery__
 *
 * To run a query within a React component, call `useContactOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useContactOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ContactOptionsQuery, ContactOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactOptionsQuery, ContactOptionsQueryVariables>(ContactOptionsDocument, options);
      }
export function useContactOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactOptionsQuery, ContactOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactOptionsQuery, ContactOptionsQueryVariables>(ContactOptionsDocument, options);
        }
export type ContactOptionsQueryHookResult = ReturnType<typeof useContactOptionsQuery>;
export type ContactOptionsLazyQueryHookResult = ReturnType<typeof useContactOptionsLazyQuery>;
export type ContactOptionsQueryResult = Apollo.QueryResult<ContactOptionsQuery, ContactOptionsQueryVariables>;
export const CreateApiDefinitionDocument = gql`
    mutation CreateApiDefinition($name: String!, $url: String!, $method: HttpMethodEnum!, $body: String, $listId: ID!, $tableKey: RowTypeEnum!, $jsonMappings: [JsonMappingInput!]!, $definitionHeaders: [ApiHeaderInput!]!, $definitionSecrets: [ApiSecretInput!]!, $sourceTableHeaders: [ApiHeaderInput!]!, $sourceTableSecrets: [ApiSecretInput!]!) {
  createApiDefinition(
    apiDefinitionAttributes: {apiUrl: $url, httpMethod: $method, httpBody: $body, apiHeaders: $definitionHeaders, apiSecrets: $definitionSecrets}
    apiSourceTableAttributes: {name: $name, sourceUid: $listId, tableKey: $tableKey, jsonMappings: $jsonMappings, apiHeaders: $sourceTableHeaders, apiSecrets: $sourceTableSecrets}
  ) {
    failReasons
    apiConnection {
      ...ApiConnection
    }
  }
}
    ${ApiConnectionFragmentDoc}`;
export type CreateApiDefinitionMutationFn = Apollo.MutationFunction<CreateApiDefinitionMutation, CreateApiDefinitionMutationVariables>;

/**
 * __useCreateApiDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateApiDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiDefinitionMutation, { data, loading, error }] = useCreateApiDefinitionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      method: // value for 'method'
 *      body: // value for 'body'
 *      listId: // value for 'listId'
 *      tableKey: // value for 'tableKey'
 *      jsonMappings: // value for 'jsonMappings'
 *      definitionHeaders: // value for 'definitionHeaders'
 *      definitionSecrets: // value for 'definitionSecrets'
 *      sourceTableHeaders: // value for 'sourceTableHeaders'
 *      sourceTableSecrets: // value for 'sourceTableSecrets'
 *   },
 * });
 */
export function useCreateApiDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiDefinitionMutation, CreateApiDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiDefinitionMutation, CreateApiDefinitionMutationVariables>(CreateApiDefinitionDocument, options);
      }
export type CreateApiDefinitionMutationHookResult = ReturnType<typeof useCreateApiDefinitionMutation>;
export type CreateApiDefinitionMutationResult = Apollo.MutationResult<CreateApiDefinitionMutation>;
export type CreateApiDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateApiDefinitionMutation, CreateApiDefinitionMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($domain: String!, $attributes: CompanyAttributes!, $companyDefaultType: CompanyTypeDefault, $assignedTo: String, $companyTypeUid: ID, $externalIdentifier: ExternalIdentifierInput) {
  createCompany(
    domain: $domain
    attributes: $attributes
    companyDefaultType: $companyDefaultType
    assignedTo: $assignedTo
    companyTypeUid: $companyTypeUid
    externalIdentifier: $externalIdentifier
  ) {
    uid
    failReasons
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      domain: // value for 'domain'
 *      attributes: // value for 'attributes'
 *      companyDefaultType: // value for 'companyDefaultType'
 *      assignedTo: // value for 'assignedTo'
 *      companyTypeUid: // value for 'companyTypeUid'
 *      externalIdentifier: // value for 'externalIdentifier'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const CreateCompanyContactDocument = gql`
    mutation CreateCompanyContact($email: String, $companyUid: ID!, $linkedinUrl: String) {
  createCompanyContact(
    email: $email
    companyId: $companyUid
    linkedinUrl: $linkedinUrl
  ) {
    uid
    failReasons
  }
}
    `;
export type CreateCompanyContactMutationFn = Apollo.MutationFunction<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>;

/**
 * __useCreateCompanyContactMutation__
 *
 * To run a mutation, you first call `useCreateCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyContactMutation, { data, loading, error }] = useCreateCompanyContactMutation({
 *   variables: {
 *      email: // value for 'email'
 *      companyUid: // value for 'companyUid'
 *      linkedinUrl: // value for 'linkedinUrl'
 *   },
 * });
 */
export function useCreateCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>(CreateCompanyContactDocument, options);
      }
export type CreateCompanyContactMutationHookResult = ReturnType<typeof useCreateCompanyContactMutation>;
export type CreateCompanyContactMutationResult = Apollo.MutationResult<CreateCompanyContactMutation>;
export type CreateCompanyContactMutationOptions = Apollo.BaseMutationOptions<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>;
export const CreateCompanyOfficeLocationDocument = gql`
    mutation CreateCompanyOfficeLocation($companyId: ID!, $primaryLocation: Boolean = false, $headquarterLocation: Boolean = false, $locationAttributes: LocationAttributes!, $labels: [String!]) {
  createCompanyOfficeLocation(
    companyId: $companyId
    primaryLocation: $primaryLocation
    headquarterLocation: $headquarterLocation
    locationAttributes: $locationAttributes
    labels: $labels
  ) {
    failReasons
  }
}
    `;
export type CreateCompanyOfficeLocationMutationFn = Apollo.MutationFunction<CreateCompanyOfficeLocationMutation, CreateCompanyOfficeLocationMutationVariables>;

/**
 * __useCreateCompanyOfficeLocationMutation__
 *
 * To run a mutation, you first call `useCreateCompanyOfficeLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyOfficeLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyOfficeLocationMutation, { data, loading, error }] = useCreateCompanyOfficeLocationMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      primaryLocation: // value for 'primaryLocation'
 *      headquarterLocation: // value for 'headquarterLocation'
 *      locationAttributes: // value for 'locationAttributes'
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useCreateCompanyOfficeLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyOfficeLocationMutation, CreateCompanyOfficeLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyOfficeLocationMutation, CreateCompanyOfficeLocationMutationVariables>(CreateCompanyOfficeLocationDocument, options);
      }
export type CreateCompanyOfficeLocationMutationHookResult = ReturnType<typeof useCreateCompanyOfficeLocationMutation>;
export type CreateCompanyOfficeLocationMutationResult = Apollo.MutationResult<CreateCompanyOfficeLocationMutation>;
export type CreateCompanyOfficeLocationMutationOptions = Apollo.BaseMutationOptions<CreateCompanyOfficeLocationMutation, CreateCompanyOfficeLocationMutationVariables>;
export const CreateCompanyOpportunityDocument = gql`
    mutation CreateCompanyOpportunity($companyUid: ID!, $attributes: CompanyGoalAttributes!) {
  createCompanyOpportunity(companyUid: $companyUid, attributes: $attributes) {
    failReasons
    uid
    record {
      ...AdminCompanyGoalRow
    }
    basicOppRecord: record {
      ...BasicOpportunity
    }
    gridRecord {
      ...OpportunityGrid
    }
  }
}
    ${AdminCompanyGoalRowFragmentDoc}
${BasicOpportunityFragmentDoc}
${OpportunityGridFragmentDoc}`;
export type CreateCompanyOpportunityMutationFn = Apollo.MutationFunction<CreateCompanyOpportunityMutation, CreateCompanyOpportunityMutationVariables>;

/**
 * __useCreateCompanyOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateCompanyOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyOpportunityMutation, { data, loading, error }] = useCreateCompanyOpportunityMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateCompanyOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyOpportunityMutation, CreateCompanyOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyOpportunityMutation, CreateCompanyOpportunityMutationVariables>(CreateCompanyOpportunityDocument, options);
      }
export type CreateCompanyOpportunityMutationHookResult = ReturnType<typeof useCreateCompanyOpportunityMutation>;
export type CreateCompanyOpportunityMutationResult = Apollo.MutationResult<CreateCompanyOpportunityMutation>;
export type CreateCompanyOpportunityMutationOptions = Apollo.BaseMutationOptions<CreateCompanyOpportunityMutation, CreateCompanyOpportunityMutationVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($email: String!) {
  createContact(email: $email) {
    failReasons
    record {
      id
    }
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const CreateExportAuditDocument = gql`
    mutation CreateExportAudit($dataType: ExportDataEnum!, $primaryName: String!, $secondaryName: String!, $rowCount: Int!) {
  createExportAudit(
    dataType: $dataType
    primaryName: $primaryName
    secondaryName: $secondaryName
    rowCount: $rowCount
  ) {
    failReasons
  }
}
    `;
export type CreateExportAuditMutationFn = Apollo.MutationFunction<CreateExportAuditMutation, CreateExportAuditMutationVariables>;

/**
 * __useCreateExportAuditMutation__
 *
 * To run a mutation, you first call `useCreateExportAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportAuditMutation, { data, loading, error }] = useCreateExportAuditMutation({
 *   variables: {
 *      dataType: // value for 'dataType'
 *      primaryName: // value for 'primaryName'
 *      secondaryName: // value for 'secondaryName'
 *      rowCount: // value for 'rowCount'
 *   },
 * });
 */
export function useCreateExportAuditMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportAuditMutation, CreateExportAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportAuditMutation, CreateExportAuditMutationVariables>(CreateExportAuditDocument, options);
      }
export type CreateExportAuditMutationHookResult = ReturnType<typeof useCreateExportAuditMutation>;
export type CreateExportAuditMutationResult = Apollo.MutationResult<CreateExportAuditMutation>;
export type CreateExportAuditMutationOptions = Apollo.BaseMutationOptions<CreateExportAuditMutation, CreateExportAuditMutationVariables>;
export const CurrentUserContactIdDocument = gql`
    query CurrentUserContactId {
  currentUser {
    id
    employee {
      id
      contact {
        id
      }
    }
  }
}
    `;

/**
 * __useCurrentUserContactIdQuery__
 *
 * To run a query within a React component, call `useCurrentUserContactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserContactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserContactIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserContactIdQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserContactIdQuery, CurrentUserContactIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserContactIdQuery, CurrentUserContactIdQueryVariables>(CurrentUserContactIdDocument, options);
      }
export function useCurrentUserContactIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserContactIdQuery, CurrentUserContactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserContactIdQuery, CurrentUserContactIdQueryVariables>(CurrentUserContactIdDocument, options);
        }
export type CurrentUserContactIdQueryHookResult = ReturnType<typeof useCurrentUserContactIdQuery>;
export type CurrentUserContactIdLazyQueryHookResult = ReturnType<typeof useCurrentUserContactIdLazyQuery>;
export type CurrentUserContactIdQueryResult = Apollo.QueryResult<CurrentUserContactIdQuery, CurrentUserContactIdQueryVariables>;
export const CurrentUserEmployeeIdDocument = gql`
    query CurrentUserEmployeeId {
  currentUser {
    id
    employee {
      id
    }
  }
}
    `;

/**
 * __useCurrentUserEmployeeIdQuery__
 *
 * To run a query within a React component, call `useCurrentUserEmployeeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserEmployeeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserEmployeeIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserEmployeeIdQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserEmployeeIdQuery, CurrentUserEmployeeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserEmployeeIdQuery, CurrentUserEmployeeIdQueryVariables>(CurrentUserEmployeeIdDocument, options);
      }
export function useCurrentUserEmployeeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserEmployeeIdQuery, CurrentUserEmployeeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserEmployeeIdQuery, CurrentUserEmployeeIdQueryVariables>(CurrentUserEmployeeIdDocument, options);
        }
export type CurrentUserEmployeeIdQueryHookResult = ReturnType<typeof useCurrentUserEmployeeIdQuery>;
export type CurrentUserEmployeeIdLazyQueryHookResult = ReturnType<typeof useCurrentUserEmployeeIdLazyQuery>;
export type CurrentUserEmployeeIdQueryResult = Apollo.QueryResult<CurrentUserEmployeeIdQuery, CurrentUserEmployeeIdQueryVariables>;
export const DeleteApiConnectionDocument = gql`
    mutation DeleteApiConnection($sourceUid: ID!) {
  deleteApiConnection: deleteApiSource(sourceUid: $sourceUid) {
    failReasons
  }
}
    `;
export type DeleteApiConnectionMutationFn = Apollo.MutationFunction<DeleteApiConnectionMutation, DeleteApiConnectionMutationVariables>;

/**
 * __useDeleteApiConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteApiConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiConnectionMutation, { data, loading, error }] = useDeleteApiConnectionMutation({
 *   variables: {
 *      sourceUid: // value for 'sourceUid'
 *   },
 * });
 */
export function useDeleteApiConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiConnectionMutation, DeleteApiConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiConnectionMutation, DeleteApiConnectionMutationVariables>(DeleteApiConnectionDocument, options);
      }
export type DeleteApiConnectionMutationHookResult = ReturnType<typeof useDeleteApiConnectionMutation>;
export type DeleteApiConnectionMutationResult = Apollo.MutationResult<DeleteApiConnectionMutation>;
export type DeleteApiConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteApiConnectionMutation, DeleteApiConnectionMutationVariables>;
export const ExportCompaniesDocument = gql`
    mutation ExportCompanies($filter: CompanyFiltering) {
  exportCompanies(filter: $filter) {
    failReasons
    export {
      id
    }
  }
}
    `;
export type ExportCompaniesMutationFn = Apollo.MutationFunction<ExportCompaniesMutation, ExportCompaniesMutationVariables>;

/**
 * __useExportCompaniesMutation__
 *
 * To run a mutation, you first call `useExportCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCompaniesMutation, { data, loading, error }] = useExportCompaniesMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<ExportCompaniesMutation, ExportCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCompaniesMutation, ExportCompaniesMutationVariables>(ExportCompaniesDocument, options);
      }
export type ExportCompaniesMutationHookResult = ReturnType<typeof useExportCompaniesMutation>;
export type ExportCompaniesMutationResult = Apollo.MutationResult<ExportCompaniesMutation>;
export type ExportCompaniesMutationOptions = Apollo.BaseMutationOptions<ExportCompaniesMutation, ExportCompaniesMutationVariables>;
export const ExportContactsDocument = gql`
    mutation ExportContacts($filter: ContactsFiltering, $filters: [ContactFilter!]) {
  exportContacts(filter: $filter, filters: $filters) {
    failReasons
    export {
      id
    }
  }
}
    `;
export type ExportContactsMutationFn = Apollo.MutationFunction<ExportContactsMutation, ExportContactsMutationVariables>;

/**
 * __useExportContactsMutation__
 *
 * To run a mutation, you first call `useExportContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportContactsMutation, { data, loading, error }] = useExportContactsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportContactsMutation(baseOptions?: Apollo.MutationHookOptions<ExportContactsMutation, ExportContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportContactsMutation, ExportContactsMutationVariables>(ExportContactsDocument, options);
      }
export type ExportContactsMutationHookResult = ReturnType<typeof useExportContactsMutation>;
export type ExportContactsMutationResult = Apollo.MutationResult<ExportContactsMutation>;
export type ExportContactsMutationOptions = Apollo.BaseMutationOptions<ExportContactsMutation, ExportContactsMutationVariables>;
export const ExportListDocument = gql`
    mutation ExportList($listId: ID!, $filter: ExportListFilter) {
  exportList(uid: $listId, filter: $filter) {
    failReasons
    export {
      id
    }
  }
}
    `;
export type ExportListMutationFn = Apollo.MutationFunction<ExportListMutation, ExportListMutationVariables>;

/**
 * __useExportListMutation__
 *
 * To run a mutation, you first call `useExportListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportListMutation, { data, loading, error }] = useExportListMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportListMutation(baseOptions?: Apollo.MutationHookOptions<ExportListMutation, ExportListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportListMutation, ExportListMutationVariables>(ExportListDocument, options);
      }
export type ExportListMutationHookResult = ReturnType<typeof useExportListMutation>;
export type ExportListMutationResult = Apollo.MutationResult<ExportListMutation>;
export type ExportListMutationOptions = Apollo.BaseMutationOptions<ExportListMutation, ExportListMutationVariables>;
export const ExportMyContactsDocument = gql`
    mutation ExportMyContacts($filter: MyContactsFiltering) {
  exportMyContacts(filter: $filter) {
    failReasons
    export {
      id
    }
  }
}
    `;
export type ExportMyContactsMutationFn = Apollo.MutationFunction<ExportMyContactsMutation, ExportMyContactsMutationVariables>;

/**
 * __useExportMyContactsMutation__
 *
 * To run a mutation, you first call `useExportMyContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMyContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMyContactsMutation, { data, loading, error }] = useExportMyContactsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportMyContactsMutation(baseOptions?: Apollo.MutationHookOptions<ExportMyContactsMutation, ExportMyContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportMyContactsMutation, ExportMyContactsMutationVariables>(ExportMyContactsDocument, options);
      }
export type ExportMyContactsMutationHookResult = ReturnType<typeof useExportMyContactsMutation>;
export type ExportMyContactsMutationResult = Apollo.MutationResult<ExportMyContactsMutation>;
export type ExportMyContactsMutationOptions = Apollo.BaseMutationOptions<ExportMyContactsMutation, ExportMyContactsMutationVariables>;
export const OnExportsUpdateDocument = gql`
    subscription onExportsUpdate {
  exportsUpdated {
    entries {
      id
      displayName
      file {
        name
        url
      }
      status
      percentageComplete
      createdAt
      expectedCount
    }
  }
}
    `;

/**
 * __useOnExportsUpdateSubscription__
 *
 * To run a query within a React component, call `useOnExportsUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnExportsUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnExportsUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnExportsUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnExportsUpdateSubscription, OnExportsUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnExportsUpdateSubscription, OnExportsUpdateSubscriptionVariables>(OnExportsUpdateDocument, options);
      }
export type OnExportsUpdateSubscriptionHookResult = ReturnType<typeof useOnExportsUpdateSubscription>;
export type OnExportsUpdateSubscriptionResult = Apollo.SubscriptionResult<OnExportsUpdateSubscription>;
export const FindProspectEmailDocument = gql`
    mutation FindProspectEmail($name: String!, $domain: String!, $linkedinUrl: String, $prospectId: String!) {
  findProspectEmail(
    name: $name
    domain: $domain
    linkedinUrl: $linkedinUrl
    prospectId: $prospectId
  ) {
    failReasons
    request {
      status
      id
    }
  }
}
    `;
export type FindProspectEmailMutationFn = Apollo.MutationFunction<FindProspectEmailMutation, FindProspectEmailMutationVariables>;

/**
 * __useFindProspectEmailMutation__
 *
 * To run a mutation, you first call `useFindProspectEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindProspectEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findProspectEmailMutation, { data, loading, error }] = useFindProspectEmailMutation({
 *   variables: {
 *      name: // value for 'name'
 *      domain: // value for 'domain'
 *      linkedinUrl: // value for 'linkedinUrl'
 *      prospectId: // value for 'prospectId'
 *   },
 * });
 */
export function useFindProspectEmailMutation(baseOptions?: Apollo.MutationHookOptions<FindProspectEmailMutation, FindProspectEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindProspectEmailMutation, FindProspectEmailMutationVariables>(FindProspectEmailDocument, options);
      }
export type FindProspectEmailMutationHookResult = ReturnType<typeof useFindProspectEmailMutation>;
export type FindProspectEmailMutationResult = Apollo.MutationResult<FindProspectEmailMutation>;
export type FindProspectEmailMutationOptions = Apollo.BaseMutationOptions<FindProspectEmailMutation, FindProspectEmailMutationVariables>;
export const GetAllowIndividualUserExportConfigDocument = gql`
    query GetAllowIndividualUserExportConfig {
  config {
    id
    allowIndividualUserExport
  }
}
    `;

/**
 * __useGetAllowIndividualUserExportConfigQuery__
 *
 * To run a query within a React component, call `useGetAllowIndividualUserExportConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowIndividualUserExportConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowIndividualUserExportConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllowIndividualUserExportConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetAllowIndividualUserExportConfigQuery, GetAllowIndividualUserExportConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllowIndividualUserExportConfigQuery, GetAllowIndividualUserExportConfigQueryVariables>(GetAllowIndividualUserExportConfigDocument, options);
      }
export function useGetAllowIndividualUserExportConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllowIndividualUserExportConfigQuery, GetAllowIndividualUserExportConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllowIndividualUserExportConfigQuery, GetAllowIndividualUserExportConfigQueryVariables>(GetAllowIndividualUserExportConfigDocument, options);
        }
export type GetAllowIndividualUserExportConfigQueryHookResult = ReturnType<typeof useGetAllowIndividualUserExportConfigQuery>;
export type GetAllowIndividualUserExportConfigLazyQueryHookResult = ReturnType<typeof useGetAllowIndividualUserExportConfigLazyQuery>;
export type GetAllowIndividualUserExportConfigQueryResult = Apollo.QueryResult<GetAllowIndividualUserExportConfigQuery, GetAllowIndividualUserExportConfigQueryVariables>;
export const GetArchivedContactsDocument = gql`
    query GetArchivedContacts($companyUuid: ID, $page: Int, $perPage: Int) {
  archivedContacts(companyUuid: $companyUuid, page: $page, perPage: $perPage) {
    entries {
      ...ArchivedContactRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ArchivedContactRowFragmentDoc}`;

/**
 * __useGetArchivedContactsQuery__
 *
 * To run a query within a React component, call `useGetArchivedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedContactsQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetArchivedContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetArchivedContactsQuery, GetArchivedContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedContactsQuery, GetArchivedContactsQueryVariables>(GetArchivedContactsDocument, options);
      }
export function useGetArchivedContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedContactsQuery, GetArchivedContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedContactsQuery, GetArchivedContactsQueryVariables>(GetArchivedContactsDocument, options);
        }
export type GetArchivedContactsQueryHookResult = ReturnType<typeof useGetArchivedContactsQuery>;
export type GetArchivedContactsLazyQueryHookResult = ReturnType<typeof useGetArchivedContactsLazyQuery>;
export type GetArchivedContactsQueryResult = Apollo.QueryResult<GetArchivedContactsQuery, GetArchivedContactsQueryVariables>;
export const GetAudienceListOptionsDocument = gql`
    query GetAudienceListOptions {
  audienceList {
    entries {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAudienceListOptionsQuery__
 *
 * To run a query within a React component, call `useGetAudienceListOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceListOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceListOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAudienceListOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAudienceListOptionsQuery, GetAudienceListOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudienceListOptionsQuery, GetAudienceListOptionsQueryVariables>(GetAudienceListOptionsDocument, options);
      }
export function useGetAudienceListOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceListOptionsQuery, GetAudienceListOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudienceListOptionsQuery, GetAudienceListOptionsQueryVariables>(GetAudienceListOptionsDocument, options);
        }
export type GetAudienceListOptionsQueryHookResult = ReturnType<typeof useGetAudienceListOptionsQuery>;
export type GetAudienceListOptionsLazyQueryHookResult = ReturnType<typeof useGetAudienceListOptionsLazyQuery>;
export type GetAudienceListOptionsQueryResult = Apollo.QueryResult<GetAudienceListOptionsQuery, GetAudienceListOptionsQueryVariables>;
export const GetCompanyInteractionDistributionDocument = gql`
    query GetCompanyInteractionDistribution($companyUuid: ID!) {
  companyInteractionDistribution(companyUuid: $companyUuid, days: 366) {
    day
    interactionCount
  }
}
    `;

/**
 * __useGetCompanyInteractionDistributionQuery__
 *
 * To run a query within a React component, call `useGetCompanyInteractionDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInteractionDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInteractionDistributionQuery({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useGetCompanyInteractionDistributionQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyInteractionDistributionQuery, GetCompanyInteractionDistributionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInteractionDistributionQuery, GetCompanyInteractionDistributionQueryVariables>(GetCompanyInteractionDistributionDocument, options);
      }
export function useGetCompanyInteractionDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInteractionDistributionQuery, GetCompanyInteractionDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInteractionDistributionQuery, GetCompanyInteractionDistributionQueryVariables>(GetCompanyInteractionDistributionDocument, options);
        }
export type GetCompanyInteractionDistributionQueryHookResult = ReturnType<typeof useGetCompanyInteractionDistributionQuery>;
export type GetCompanyInteractionDistributionLazyQueryHookResult = ReturnType<typeof useGetCompanyInteractionDistributionLazyQuery>;
export type GetCompanyInteractionDistributionQueryResult = Apollo.QueryResult<GetCompanyInteractionDistributionQuery, GetCompanyInteractionDistributionQueryVariables>;
export const GetCompanyLastYearDepartmentStatsDocument = gql`
    query GetCompanyLastYearDepartmentStats($uid: String!) {
  company(uid: $uid) {
    id
    lastYearDepartmentsStats {
      id
      department {
        id
        name
      }
      interactionCount
    }
  }
}
    `;

/**
 * __useGetCompanyLastYearDepartmentStatsQuery__
 *
 * To run a query within a React component, call `useGetCompanyLastYearDepartmentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLastYearDepartmentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLastYearDepartmentStatsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetCompanyLastYearDepartmentStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyLastYearDepartmentStatsQuery, GetCompanyLastYearDepartmentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLastYearDepartmentStatsQuery, GetCompanyLastYearDepartmentStatsQueryVariables>(GetCompanyLastYearDepartmentStatsDocument, options);
      }
export function useGetCompanyLastYearDepartmentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLastYearDepartmentStatsQuery, GetCompanyLastYearDepartmentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLastYearDepartmentStatsQuery, GetCompanyLastYearDepartmentStatsQueryVariables>(GetCompanyLastYearDepartmentStatsDocument, options);
        }
export type GetCompanyLastYearDepartmentStatsQueryHookResult = ReturnType<typeof useGetCompanyLastYearDepartmentStatsQuery>;
export type GetCompanyLastYearDepartmentStatsLazyQueryHookResult = ReturnType<typeof useGetCompanyLastYearDepartmentStatsLazyQuery>;
export type GetCompanyLastYearDepartmentStatsQueryResult = Apollo.QueryResult<GetCompanyLastYearDepartmentStatsQuery, GetCompanyLastYearDepartmentStatsQueryVariables>;
export const GetCompanyOpportunityStatsDocument = gql`
    query GetCompanyOpportunityStats($uid: String!) {
  company(uid: $uid) {
    ...CompanyOpportunityStats
  }
}
    ${CompanyOpportunityStatsFragmentDoc}`;

/**
 * __useGetCompanyOpportunityStatsQuery__
 *
 * To run a query within a React component, call `useGetCompanyOpportunityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyOpportunityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyOpportunityStatsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetCompanyOpportunityStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyOpportunityStatsQuery, GetCompanyOpportunityStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyOpportunityStatsQuery, GetCompanyOpportunityStatsQueryVariables>(GetCompanyOpportunityStatsDocument, options);
      }
export function useGetCompanyOpportunityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyOpportunityStatsQuery, GetCompanyOpportunityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyOpportunityStatsQuery, GetCompanyOpportunityStatsQueryVariables>(GetCompanyOpportunityStatsDocument, options);
        }
export type GetCompanyOpportunityStatsQueryHookResult = ReturnType<typeof useGetCompanyOpportunityStatsQuery>;
export type GetCompanyOpportunityStatsLazyQueryHookResult = ReturnType<typeof useGetCompanyOpportunityStatsLazyQuery>;
export type GetCompanyOpportunityStatsQueryResult = Apollo.QueryResult<GetCompanyOpportunityStatsQuery, GetCompanyOpportunityStatsQueryVariables>;
export const GetCompanyPreviewDocument = gql`
    query GetCompanyPreview($uid: String!) {
  company(uid: $uid) {
    ...CompanyPreview
  }
}
    ${CompanyPreviewFragmentDoc}`;

/**
 * __useGetCompanyPreviewQuery__
 *
 * To run a query within a React component, call `useGetCompanyPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyPreviewQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetCompanyPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyPreviewQuery, GetCompanyPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyPreviewQuery, GetCompanyPreviewQueryVariables>(GetCompanyPreviewDocument, options);
      }
export function useGetCompanyPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyPreviewQuery, GetCompanyPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyPreviewQuery, GetCompanyPreviewQueryVariables>(GetCompanyPreviewDocument, options);
        }
export type GetCompanyPreviewQueryHookResult = ReturnType<typeof useGetCompanyPreviewQuery>;
export type GetCompanyPreviewLazyQueryHookResult = ReturnType<typeof useGetCompanyPreviewLazyQuery>;
export type GetCompanyPreviewQueryResult = Apollo.QueryResult<GetCompanyPreviewQuery, GetCompanyPreviewQueryVariables>;
export const GetCompanyProfilesDocument = gql`
    query GetCompanyProfiles($domain: String!, $filter: CompanyProfileFiltering, $page: Int, $perPage: Int) {
  companyProfiles(
    domain: $domain
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...CompanyProfileRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CompanyProfileRowFragmentDoc}`;

/**
 * __useGetCompanyProfilesQuery__
 *
 * To run a query within a React component, call `useGetCompanyProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyProfilesQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetCompanyProfilesQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyProfilesQuery, GetCompanyProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyProfilesQuery, GetCompanyProfilesQueryVariables>(GetCompanyProfilesDocument, options);
      }
export function useGetCompanyProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyProfilesQuery, GetCompanyProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyProfilesQuery, GetCompanyProfilesQueryVariables>(GetCompanyProfilesDocument, options);
        }
export type GetCompanyProfilesQueryHookResult = ReturnType<typeof useGetCompanyProfilesQuery>;
export type GetCompanyProfilesLazyQueryHookResult = ReturnType<typeof useGetCompanyProfilesLazyQuery>;
export type GetCompanyProfilesQueryResult = Apollo.QueryResult<GetCompanyProfilesQuery, GetCompanyProfilesQueryVariables>;
export const GetContactMoreActionsConfigDocument = gql`
    query GetContactMoreActionsConfig {
  config {
    id
    allowPrivateContacts
  }
}
    `;

/**
 * __useGetContactMoreActionsConfigQuery__
 *
 * To run a query within a React component, call `useGetContactMoreActionsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactMoreActionsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactMoreActionsConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactMoreActionsConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetContactMoreActionsConfigQuery, GetContactMoreActionsConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactMoreActionsConfigQuery, GetContactMoreActionsConfigQueryVariables>(GetContactMoreActionsConfigDocument, options);
      }
export function useGetContactMoreActionsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactMoreActionsConfigQuery, GetContactMoreActionsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactMoreActionsConfigQuery, GetContactMoreActionsConfigQueryVariables>(GetContactMoreActionsConfigDocument, options);
        }
export type GetContactMoreActionsConfigQueryHookResult = ReturnType<typeof useGetContactMoreActionsConfigQuery>;
export type GetContactMoreActionsConfigLazyQueryHookResult = ReturnType<typeof useGetContactMoreActionsConfigLazyQuery>;
export type GetContactMoreActionsConfigQueryResult = Apollo.QueryResult<GetContactMoreActionsConfigQuery, GetContactMoreActionsConfigQueryVariables>;
export const GetContactOptionDocument = gql`
    query GetContactOption($uid: String!) {
  contact(uid: $uid) {
    ...ContactPreview
  }
}
    ${ContactPreviewFragmentDoc}`;

/**
 * __useGetContactOptionQuery__
 *
 * To run a query within a React component, call `useGetContactOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactOptionQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetContactOptionQuery(baseOptions: Apollo.QueryHookOptions<GetContactOptionQuery, GetContactOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactOptionQuery, GetContactOptionQueryVariables>(GetContactOptionDocument, options);
      }
export function useGetContactOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactOptionQuery, GetContactOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactOptionQuery, GetContactOptionQueryVariables>(GetContactOptionDocument, options);
        }
export type GetContactOptionQueryHookResult = ReturnType<typeof useGetContactOptionQuery>;
export type GetContactOptionLazyQueryHookResult = ReturnType<typeof useGetContactOptionLazyQuery>;
export type GetContactOptionQueryResult = Apollo.QueryResult<GetContactOptionQuery, GetContactOptionQueryVariables>;
export const GetCurrentUserCurrencyDocument = gql`
    query GetCurrentUserCurrency {
  currentUser: currentTenant {
    id
    currency {
      ...Currency
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useGetCurrentUserCurrencyQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserCurrencyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserCurrencyQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserCurrencyQuery, GetCurrentUserCurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserCurrencyQuery, GetCurrentUserCurrencyQueryVariables>(GetCurrentUserCurrencyDocument, options);
      }
export function useGetCurrentUserCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserCurrencyQuery, GetCurrentUserCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserCurrencyQuery, GetCurrentUserCurrencyQueryVariables>(GetCurrentUserCurrencyDocument, options);
        }
export type GetCurrentUserCurrencyQueryHookResult = ReturnType<typeof useGetCurrentUserCurrencyQuery>;
export type GetCurrentUserCurrencyLazyQueryHookResult = ReturnType<typeof useGetCurrentUserCurrencyLazyQuery>;
export type GetCurrentUserCurrencyQueryResult = Apollo.QueryResult<GetCurrentUserCurrencyQuery, GetCurrentUserCurrencyQueryVariables>;
export const GetCurrentUserEmailDocument = gql`
    query GetCurrentUserEmail {
  currentUser {
    id
    userId
    email
    employee {
      id
    }
  }
}
    `;

/**
 * __useGetCurrentUserEmailQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserEmailQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserEmailQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserEmailQuery, GetCurrentUserEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserEmailQuery, GetCurrentUserEmailQueryVariables>(GetCurrentUserEmailDocument, options);
      }
export function useGetCurrentUserEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserEmailQuery, GetCurrentUserEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserEmailQuery, GetCurrentUserEmailQueryVariables>(GetCurrentUserEmailDocument, options);
        }
export type GetCurrentUserEmailQueryHookResult = ReturnType<typeof useGetCurrentUserEmailQuery>;
export type GetCurrentUserEmailLazyQueryHookResult = ReturnType<typeof useGetCurrentUserEmailLazyQuery>;
export type GetCurrentUserEmailQueryResult = Apollo.QueryResult<GetCurrentUserEmailQuery, GetCurrentUserEmailQueryVariables>;
export const GetIndustryListDocument = gql`
    query GetIndustryList($withCommon: Boolean) {
  industryList(includeCommonIndustries: $withCommon)
}
    `;

/**
 * __useGetIndustryListQuery__
 *
 * To run a query within a React component, call `useGetIndustryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustryListQuery({
 *   variables: {
 *      withCommon: // value for 'withCommon'
 *   },
 * });
 */
export function useGetIndustryListQuery(baseOptions?: Apollo.QueryHookOptions<GetIndustryListQuery, GetIndustryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustryListQuery, GetIndustryListQueryVariables>(GetIndustryListDocument, options);
      }
export function useGetIndustryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustryListQuery, GetIndustryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustryListQuery, GetIndustryListQueryVariables>(GetIndustryListDocument, options);
        }
export type GetIndustryListQueryHookResult = ReturnType<typeof useGetIndustryListQuery>;
export type GetIndustryListLazyQueryHookResult = ReturnType<typeof useGetIndustryListLazyQuery>;
export type GetIndustryListQueryResult = Apollo.QueryResult<GetIndustryListQuery, GetIndustryListQueryVariables>;
export const GetListOptionsDocument = gql`
    query GetListOptions($page: Int, $perPage: Int, $filter: ListFiltering) {
  lists(page: $page, perPage: $perPage, filter: $filter) {
    entries {
      ...ListOption
    }
  }
}
    ${ListOptionFragmentDoc}`;

/**
 * __useGetListOptionsQuery__
 *
 * To run a query within a React component, call `useGetListOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetListOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetListOptionsQuery, GetListOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListOptionsQuery, GetListOptionsQueryVariables>(GetListOptionsDocument, options);
      }
export function useGetListOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListOptionsQuery, GetListOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListOptionsQuery, GetListOptionsQueryVariables>(GetListOptionsDocument, options);
        }
export type GetListOptionsQueryHookResult = ReturnType<typeof useGetListOptionsQuery>;
export type GetListOptionsLazyQueryHookResult = ReturnType<typeof useGetListOptionsLazyQuery>;
export type GetListOptionsQueryResult = Apollo.QueryResult<GetListOptionsQuery, GetListOptionsQueryVariables>;
export const GetMyCompaniesDocument = gql`
    query GetMyCompanies($filter: MyCompaniesFiltering, $orderBy: MyCompaniesOrderBy = LAST_INTERACTION_DESC, $page: Int = 1, $perPage: Int = 10) {
  myCompanies(filter: $filter, orderBy: $orderBy, page: $page, perPage: $perPage) {
    entries {
      id
      interactionMaximum {
        id
        lastAt
        total
      }
      company {
        ...CompanyTableRow
      }
      openOpportunityCount
      pendingTaskCount
      upcomingMeetingCount
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CompanyTableRowFragmentDoc}`;

/**
 * __useGetMyCompaniesQuery__
 *
 * To run a query within a React component, call `useGetMyCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCompaniesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetMyCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCompaniesQuery, GetMyCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCompaniesQuery, GetMyCompaniesQueryVariables>(GetMyCompaniesDocument, options);
      }
export function useGetMyCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCompaniesQuery, GetMyCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCompaniesQuery, GetMyCompaniesQueryVariables>(GetMyCompaniesDocument, options);
        }
export type GetMyCompaniesQueryHookResult = ReturnType<typeof useGetMyCompaniesQuery>;
export type GetMyCompaniesLazyQueryHookResult = ReturnType<typeof useGetMyCompaniesLazyQuery>;
export type GetMyCompaniesQueryResult = Apollo.QueryResult<GetMyCompaniesQuery, GetMyCompaniesQueryVariables>;
export const GetMyContactLastInteractionDocument = gql`
    query GetMyContactLastInteraction($uid: String!) {
  myContact(uid: $uid) {
    id
    interactionMaximum {
      lastAt
    }
  }
}
    `;

/**
 * __useGetMyContactLastInteractionQuery__
 *
 * To run a query within a React component, call `useGetMyContactLastInteractionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContactLastInteractionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContactLastInteractionQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetMyContactLastInteractionQuery(baseOptions: Apollo.QueryHookOptions<GetMyContactLastInteractionQuery, GetMyContactLastInteractionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyContactLastInteractionQuery, GetMyContactLastInteractionQueryVariables>(GetMyContactLastInteractionDocument, options);
      }
export function useGetMyContactLastInteractionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyContactLastInteractionQuery, GetMyContactLastInteractionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyContactLastInteractionQuery, GetMyContactLastInteractionQueryVariables>(GetMyContactLastInteractionDocument, options);
        }
export type GetMyContactLastInteractionQueryHookResult = ReturnType<typeof useGetMyContactLastInteractionQuery>;
export type GetMyContactLastInteractionLazyQueryHookResult = ReturnType<typeof useGetMyContactLastInteractionLazyQuery>;
export type GetMyContactLastInteractionQueryResult = Apollo.QueryResult<GetMyContactLastInteractionQuery, GetMyContactLastInteractionQueryVariables>;
export const MyContactStayInTouchFrequencyDocument = gql`
    query MyContactStayInTouchFrequency($uid: String!) {
  myContact(uid: $uid) {
    id
    stayInTouch {
      frequency
    }
  }
}
    `;

/**
 * __useMyContactStayInTouchFrequencyQuery__
 *
 * To run a query within a React component, call `useMyContactStayInTouchFrequencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyContactStayInTouchFrequencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyContactStayInTouchFrequencyQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useMyContactStayInTouchFrequencyQuery(baseOptions: Apollo.QueryHookOptions<MyContactStayInTouchFrequencyQuery, MyContactStayInTouchFrequencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyContactStayInTouchFrequencyQuery, MyContactStayInTouchFrequencyQueryVariables>(MyContactStayInTouchFrequencyDocument, options);
      }
export function useMyContactStayInTouchFrequencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyContactStayInTouchFrequencyQuery, MyContactStayInTouchFrequencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyContactStayInTouchFrequencyQuery, MyContactStayInTouchFrequencyQueryVariables>(MyContactStayInTouchFrequencyDocument, options);
        }
export type MyContactStayInTouchFrequencyQueryHookResult = ReturnType<typeof useMyContactStayInTouchFrequencyQuery>;
export type MyContactStayInTouchFrequencyLazyQueryHookResult = ReturnType<typeof useMyContactStayInTouchFrequencyLazyQuery>;
export type MyContactStayInTouchFrequencyQueryResult = Apollo.QueryResult<MyContactStayInTouchFrequencyQuery, MyContactStayInTouchFrequencyQueryVariables>;
export const GetMyContactsNavKeyNumbersDocument = gql`
    query GetMyContactsNavKeyNumbers {
  myStayInTouch(overDueOnly: true) {
    pageInfo {
      totalEntries
    }
  }
  upcomingMeetings: meetings(timeScope: FUTURE, ownership: USER) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useGetMyContactsNavKeyNumbersQuery__
 *
 * To run a query within a React component, call `useGetMyContactsNavKeyNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContactsNavKeyNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContactsNavKeyNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyContactsNavKeyNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyContactsNavKeyNumbersQuery, GetMyContactsNavKeyNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyContactsNavKeyNumbersQuery, GetMyContactsNavKeyNumbersQueryVariables>(GetMyContactsNavKeyNumbersDocument, options);
      }
export function useGetMyContactsNavKeyNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyContactsNavKeyNumbersQuery, GetMyContactsNavKeyNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyContactsNavKeyNumbersQuery, GetMyContactsNavKeyNumbersQueryVariables>(GetMyContactsNavKeyNumbersDocument, options);
        }
export type GetMyContactsNavKeyNumbersQueryHookResult = ReturnType<typeof useGetMyContactsNavKeyNumbersQuery>;
export type GetMyContactsNavKeyNumbersLazyQueryHookResult = ReturnType<typeof useGetMyContactsNavKeyNumbersLazyQuery>;
export type GetMyContactsNavKeyNumbersQueryResult = Apollo.QueryResult<GetMyContactsNavKeyNumbersQuery, GetMyContactsNavKeyNumbersQueryVariables>;
export const GetMyOpportunitiesCustomBoardDocument = gql`
    query GetMyOpportunitiesCustomBoard($term: String, $referralSource: String, $fromDate: ISO8601Date, $toDate: ISO8601Date) {
  myOpportunitiesCustomBoard(
    filter: {term: $term, referralSource: $referralSource, fromDate: $fromDate, toDate: $toDate}
  ) {
    ...MyCustomBoardColumn
  }
}
    ${MyCustomBoardColumnFragmentDoc}`;

/**
 * __useGetMyOpportunitiesCustomBoardQuery__
 *
 * To run a query within a React component, call `useGetMyOpportunitiesCustomBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOpportunitiesCustomBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOpportunitiesCustomBoardQuery({
 *   variables: {
 *      term: // value for 'term'
 *      referralSource: // value for 'referralSource'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetMyOpportunitiesCustomBoardQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOpportunitiesCustomBoardQuery, GetMyOpportunitiesCustomBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOpportunitiesCustomBoardQuery, GetMyOpportunitiesCustomBoardQueryVariables>(GetMyOpportunitiesCustomBoardDocument, options);
      }
export function useGetMyOpportunitiesCustomBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOpportunitiesCustomBoardQuery, GetMyOpportunitiesCustomBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOpportunitiesCustomBoardQuery, GetMyOpportunitiesCustomBoardQueryVariables>(GetMyOpportunitiesCustomBoardDocument, options);
        }
export type GetMyOpportunitiesCustomBoardQueryHookResult = ReturnType<typeof useGetMyOpportunitiesCustomBoardQuery>;
export type GetMyOpportunitiesCustomBoardLazyQueryHookResult = ReturnType<typeof useGetMyOpportunitiesCustomBoardLazyQuery>;
export type GetMyOpportunitiesCustomBoardQueryResult = Apollo.QueryResult<GetMyOpportunitiesCustomBoardQuery, GetMyOpportunitiesCustomBoardQueryVariables>;
export const GetMyStayInTouchDocument = gql`
    query GetMyStayInTouch($overDueOnly: Boolean = true, $page: Int, $perPage: Int) {
  myStayInTouch(overDueOnly: $overDueOnly, page: $page, perPage: $perPage) {
    entries {
      ...MyStayInTouchRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${MyStayInTouchRowFragmentDoc}`;

/**
 * __useGetMyStayInTouchQuery__
 *
 * To run a query within a React component, call `useGetMyStayInTouchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyStayInTouchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyStayInTouchQuery({
 *   variables: {
 *      overDueOnly: // value for 'overDueOnly'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetMyStayInTouchQuery(baseOptions?: Apollo.QueryHookOptions<GetMyStayInTouchQuery, GetMyStayInTouchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyStayInTouchQuery, GetMyStayInTouchQueryVariables>(GetMyStayInTouchDocument, options);
      }
export function useGetMyStayInTouchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyStayInTouchQuery, GetMyStayInTouchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyStayInTouchQuery, GetMyStayInTouchQueryVariables>(GetMyStayInTouchDocument, options);
        }
export type GetMyStayInTouchQueryHookResult = ReturnType<typeof useGetMyStayInTouchQuery>;
export type GetMyStayInTouchLazyQueryHookResult = ReturnType<typeof useGetMyStayInTouchLazyQuery>;
export type GetMyStayInTouchQueryResult = Apollo.QueryResult<GetMyStayInTouchQuery, GetMyStayInTouchQueryVariables>;
export const GetOpportunityCustomFieldsDocument = gql`
    query GetOpportunityCustomFields {
  currentTenant {
    id
    opportunityCustomFields {
      ...CustomFieldSchema
    }
  }
}
    ${CustomFieldSchemaFragmentDoc}`;

/**
 * __useGetOpportunityCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetOpportunityCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpportunityCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetOpportunityCustomFieldsQuery, GetOpportunityCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunityCustomFieldsQuery, GetOpportunityCustomFieldsQueryVariables>(GetOpportunityCustomFieldsDocument, options);
      }
export function useGetOpportunityCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunityCustomFieldsQuery, GetOpportunityCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunityCustomFieldsQuery, GetOpportunityCustomFieldsQueryVariables>(GetOpportunityCustomFieldsDocument, options);
        }
export type GetOpportunityCustomFieldsQueryHookResult = ReturnType<typeof useGetOpportunityCustomFieldsQuery>;
export type GetOpportunityCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetOpportunityCustomFieldsLazyQuery>;
export type GetOpportunityCustomFieldsQueryResult = Apollo.QueryResult<GetOpportunityCustomFieldsQuery, GetOpportunityCustomFieldsQueryVariables>;
export const GetPersonCompaniesDocument = gql`
    query GetPersonCompanies($uid: String!) {
  person(uid: $uid) {
    id
    companyContacts: careerCompanies {
      ...CareerCompany
    }
  }
}
    ${CareerCompanyFragmentDoc}`;

/**
 * __useGetPersonCompaniesQuery__
 *
 * To run a query within a React component, call `useGetPersonCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonCompaniesQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetPersonCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetPersonCompaniesQuery, GetPersonCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonCompaniesQuery, GetPersonCompaniesQueryVariables>(GetPersonCompaniesDocument, options);
      }
export function useGetPersonCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonCompaniesQuery, GetPersonCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonCompaniesQuery, GetPersonCompaniesQueryVariables>(GetPersonCompaniesDocument, options);
        }
export type GetPersonCompaniesQueryHookResult = ReturnType<typeof useGetPersonCompaniesQuery>;
export type GetPersonCompaniesLazyQueryHookResult = ReturnType<typeof useGetPersonCompaniesLazyQuery>;
export type GetPersonCompaniesQueryResult = Apollo.QueryResult<GetPersonCompaniesQuery, GetPersonCompaniesQueryVariables>;
export const GetProspectEmailRequestDocument = gql`
    query GetProspectEmailRequest($requestUid: String!) {
  prospectEmailRequest(requestUid: $requestUid) {
    contactEmail
    status
  }
}
    `;

/**
 * __useGetProspectEmailRequestQuery__
 *
 * To run a query within a React component, call `useGetProspectEmailRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectEmailRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectEmailRequestQuery({
 *   variables: {
 *      requestUid: // value for 'requestUid'
 *   },
 * });
 */
export function useGetProspectEmailRequestQuery(baseOptions: Apollo.QueryHookOptions<GetProspectEmailRequestQuery, GetProspectEmailRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProspectEmailRequestQuery, GetProspectEmailRequestQueryVariables>(GetProspectEmailRequestDocument, options);
      }
export function useGetProspectEmailRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProspectEmailRequestQuery, GetProspectEmailRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProspectEmailRequestQuery, GetProspectEmailRequestQueryVariables>(GetProspectEmailRequestDocument, options);
        }
export type GetProspectEmailRequestQueryHookResult = ReturnType<typeof useGetProspectEmailRequestQuery>;
export type GetProspectEmailRequestLazyQueryHookResult = ReturnType<typeof useGetProspectEmailRequestLazyQuery>;
export type GetProspectEmailRequestQueryResult = Apollo.QueryResult<GetProspectEmailRequestQuery, GetProspectEmailRequestQueryVariables>;
export const GetProspectIndustryListDocument = gql`
    query GetProspectIndustryList {
  prospectIndustryList
}
    `;

/**
 * __useGetProspectIndustryListQuery__
 *
 * To run a query within a React component, call `useGetProspectIndustryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectIndustryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectIndustryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProspectIndustryListQuery(baseOptions?: Apollo.QueryHookOptions<GetProspectIndustryListQuery, GetProspectIndustryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProspectIndustryListQuery, GetProspectIndustryListQueryVariables>(GetProspectIndustryListDocument, options);
      }
export function useGetProspectIndustryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProspectIndustryListQuery, GetProspectIndustryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProspectIndustryListQuery, GetProspectIndustryListQueryVariables>(GetProspectIndustryListDocument, options);
        }
export type GetProspectIndustryListQueryHookResult = ReturnType<typeof useGetProspectIndustryListQuery>;
export type GetProspectIndustryListLazyQueryHookResult = ReturnType<typeof useGetProspectIndustryListLazyQuery>;
export type GetProspectIndustryListQueryResult = Apollo.QueryResult<GetProspectIndustryListQuery, GetProspectIndustryListQueryVariables>;
export const GetProspectSearchListDocument = gql`
    query GetProspectSearchList($term: String!, $country: String, $headCount: HeadCountRange, $page: Int, $perPage: Int) {
  prospectSearch(
    term: $term
    country: $country
    headCount: $headCount
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...SearchProspectRow
    }
  }
}
    ${SearchProspectRowFragmentDoc}`;

/**
 * __useGetProspectSearchListQuery__
 *
 * To run a query within a React component, call `useGetProspectSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectSearchListQuery({
 *   variables: {
 *      term: // value for 'term'
 *      country: // value for 'country'
 *      headCount: // value for 'headCount'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetProspectSearchListQuery(baseOptions: Apollo.QueryHookOptions<GetProspectSearchListQuery, GetProspectSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProspectSearchListQuery, GetProspectSearchListQueryVariables>(GetProspectSearchListDocument, options);
      }
export function useGetProspectSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProspectSearchListQuery, GetProspectSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProspectSearchListQuery, GetProspectSearchListQueryVariables>(GetProspectSearchListDocument, options);
        }
export type GetProspectSearchListQueryHookResult = ReturnType<typeof useGetProspectSearchListQuery>;
export type GetProspectSearchListLazyQueryHookResult = ReturnType<typeof useGetProspectSearchListLazyQuery>;
export type GetProspectSearchListQueryResult = Apollo.QueryResult<GetProspectSearchListQuery, GetProspectSearchListQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags {
  tags(perPage: 1000) {
    entries {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetEmployeeDocument = gql`
    query GetEmployee($id: String!) {
  employee(id: $id) {
    ...EmployeePreview
  }
}
    ${EmployeePreviewFragmentDoc}`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const IsDuplicateContactListDocument = gql`
    query IsDuplicateContactList($uid: ID!) {
  list(uid: $uid) {
    id
    allowDuplicates
  }
}
    `;

/**
 * __useIsDuplicateContactListQuery__
 *
 * To run a query within a React component, call `useIsDuplicateContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDuplicateContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDuplicateContactListQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useIsDuplicateContactListQuery(baseOptions: Apollo.QueryHookOptions<IsDuplicateContactListQuery, IsDuplicateContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDuplicateContactListQuery, IsDuplicateContactListQueryVariables>(IsDuplicateContactListDocument, options);
      }
export function useIsDuplicateContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDuplicateContactListQuery, IsDuplicateContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDuplicateContactListQuery, IsDuplicateContactListQueryVariables>(IsDuplicateContactListDocument, options);
        }
export type IsDuplicateContactListQueryHookResult = ReturnType<typeof useIsDuplicateContactListQuery>;
export type IsDuplicateContactListLazyQueryHookResult = ReturnType<typeof useIsDuplicateContactListLazyQuery>;
export type IsDuplicateContactListQueryResult = Apollo.QueryResult<IsDuplicateContactListQuery, IsDuplicateContactListQueryVariables>;
export const IsLoggedOutDocument = gql`
    query IsLoggedOut {
  currentUser {
    id
    userId
    email
  }
}
    `;

/**
 * __useIsLoggedOutQuery__
 *
 * To run a query within a React component, call `useIsLoggedOutQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsLoggedOutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLoggedOutQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsLoggedOutQuery(baseOptions?: Apollo.QueryHookOptions<IsLoggedOutQuery, IsLoggedOutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsLoggedOutQuery, IsLoggedOutQueryVariables>(IsLoggedOutDocument, options);
      }
export function useIsLoggedOutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsLoggedOutQuery, IsLoggedOutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsLoggedOutQuery, IsLoggedOutQueryVariables>(IsLoggedOutDocument, options);
        }
export type IsLoggedOutQueryHookResult = ReturnType<typeof useIsLoggedOutQuery>;
export type IsLoggedOutLazyQueryHookResult = ReturnType<typeof useIsLoggedOutLazyQuery>;
export type IsLoggedOutQueryResult = Apollo.QueryResult<IsLoggedOutQuery, IsLoggedOutQueryVariables>;
export const MagicbellDocument = gql`
    query Magicbell {
  magicbell {
    apiKey
    userExternalId
    userKey
  }
}
    `;

/**
 * __useMagicbellQuery__
 *
 * To run a query within a React component, call `useMagicbellQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagicbellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagicbellQuery({
 *   variables: {
 *   },
 * });
 */
export function useMagicbellQuery(baseOptions?: Apollo.QueryHookOptions<MagicbellQuery, MagicbellQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MagicbellQuery, MagicbellQueryVariables>(MagicbellDocument, options);
      }
export function useMagicbellLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MagicbellQuery, MagicbellQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MagicbellQuery, MagicbellQueryVariables>(MagicbellDocument, options);
        }
export type MagicbellQueryHookResult = ReturnType<typeof useMagicbellQuery>;
export type MagicbellLazyQueryHookResult = ReturnType<typeof useMagicbellLazyQuery>;
export type MagicbellQueryResult = Apollo.QueryResult<MagicbellQuery, MagicbellQueryVariables>;
export const MergeContactDocument = gql`
    mutation MergeContact($previousUuid: ID!, $currentUuid: ID!, $keepBoth: Boolean = true) {
  mergeContact(
    previousUuid: $previousUuid
    currentUuid: $currentUuid
    keepBoth: $keepBoth
  ) {
    failReasons
    currentRecord {
      ...ContactProfile
    }
  }
}
    ${ContactProfileFragmentDoc}`;
export type MergeContactMutationFn = Apollo.MutationFunction<MergeContactMutation, MergeContactMutationVariables>;

/**
 * __useMergeContactMutation__
 *
 * To run a mutation, you first call `useMergeContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeContactMutation, { data, loading, error }] = useMergeContactMutation({
 *   variables: {
 *      previousUuid: // value for 'previousUuid'
 *      currentUuid: // value for 'currentUuid'
 *      keepBoth: // value for 'keepBoth'
 *   },
 * });
 */
export function useMergeContactMutation(baseOptions?: Apollo.MutationHookOptions<MergeContactMutation, MergeContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeContactMutation, MergeContactMutationVariables>(MergeContactDocument, options);
      }
export type MergeContactMutationHookResult = ReturnType<typeof useMergeContactMutation>;
export type MergeContactMutationResult = Apollo.MutationResult<MergeContactMutation>;
export type MergeContactMutationOptions = Apollo.BaseMutationOptions<MergeContactMutation, MergeContactMutationVariables>;
export const MicrosoftAdminConsentDetailDocument = gql`
    query MicrosoftAdminConsentDetail {
  microsoftAdminConsentDetail {
    consents {
      name
      consentUrl
    }
  }
}
    `;

/**
 * __useMicrosoftAdminConsentDetailQuery__
 *
 * To run a query within a React component, call `useMicrosoftAdminConsentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftAdminConsentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrosoftAdminConsentDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useMicrosoftAdminConsentDetailQuery(baseOptions?: Apollo.QueryHookOptions<MicrosoftAdminConsentDetailQuery, MicrosoftAdminConsentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MicrosoftAdminConsentDetailQuery, MicrosoftAdminConsentDetailQueryVariables>(MicrosoftAdminConsentDetailDocument, options);
      }
export function useMicrosoftAdminConsentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MicrosoftAdminConsentDetailQuery, MicrosoftAdminConsentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MicrosoftAdminConsentDetailQuery, MicrosoftAdminConsentDetailQueryVariables>(MicrosoftAdminConsentDetailDocument, options);
        }
export type MicrosoftAdminConsentDetailQueryHookResult = ReturnType<typeof useMicrosoftAdminConsentDetailQuery>;
export type MicrosoftAdminConsentDetailLazyQueryHookResult = ReturnType<typeof useMicrosoftAdminConsentDetailLazyQuery>;
export type MicrosoftAdminConsentDetailQueryResult = Apollo.QueryResult<MicrosoftAdminConsentDetailQuery, MicrosoftAdminConsentDetailQueryVariables>;
export const MyContactsDocument = gql`
    query MyContacts($filter: MyContactsFiltering, $orderBy: MyContactsOrderBy = LAST_INTERACTION_DESC, $page: Int = 1, $perPage: Int = 10) {
  myContacts(filter: $filter, orderBy: $orderBy, page: $page, perPage: $perPage) {
    entries {
      contact {
        ...ContactListRow
      }
      interactionMaximum {
        id
        lastAt
      }
      classified
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactListRowFragmentDoc}`;

/**
 * __useMyContactsQuery__
 *
 * To run a query within a React component, call `useMyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyContactsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMyContactsQuery(baseOptions?: Apollo.QueryHookOptions<MyContactsQuery, MyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyContactsQuery, MyContactsQueryVariables>(MyContactsDocument, options);
      }
export function useMyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyContactsQuery, MyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyContactsQuery, MyContactsQueryVariables>(MyContactsDocument, options);
        }
export type MyContactsQueryHookResult = ReturnType<typeof useMyContactsQuery>;
export type MyContactsLazyQueryHookResult = ReturnType<typeof useMyContactsLazyQuery>;
export type MyContactsQueryResult = Apollo.QueryResult<MyContactsQuery, MyContactsQueryVariables>;
export const ProspectsDocument = gql`
    query Prospects($page: Int, $perPage: Int, $term: String, $filters: [CompanyFilter!], $ownerUid: String) {
  companies(
    page: $page
    perPage: $perPage
    filter: {term: $term, companyDefaultType: PROSPECT, ownerUid: $ownerUid, properties: $filters}
  ) {
    entries {
      ...ProspectRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ProspectRowFragmentDoc}`;

/**
 * __useProspectsQuery__
 *
 * To run a query within a React component, call `useProspectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *      filters: // value for 'filters'
 *      ownerUid: // value for 'ownerUid'
 *   },
 * });
 */
export function useProspectsQuery(baseOptions?: Apollo.QueryHookOptions<ProspectsQuery, ProspectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectsQuery, ProspectsQueryVariables>(ProspectsDocument, options);
      }
export function useProspectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectsQuery, ProspectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectsQuery, ProspectsQueryVariables>(ProspectsDocument, options);
        }
export type ProspectsQueryHookResult = ReturnType<typeof useProspectsQuery>;
export type ProspectsLazyQueryHookResult = ReturnType<typeof useProspectsLazyQuery>;
export type ProspectsQueryResult = Apollo.QueryResult<ProspectsQuery, ProspectsQueryVariables>;
export const ReAssignOpportunityCompanyDocument = gql`
    mutation ReAssignOpportunityCompany($uid: ID!, $companyUid: ID!, $keyContactIds: [ID!]!) {
  reAssignOpportunityCompany(
    uuid: $uid
    companyUid: $companyUid
    keyContactIds: $keyContactIds
  ) {
    failReasons
    record {
      ...AdminCompanyGoalRow
    }
  }
}
    ${AdminCompanyGoalRowFragmentDoc}`;
export type ReAssignOpportunityCompanyMutationFn = Apollo.MutationFunction<ReAssignOpportunityCompanyMutation, ReAssignOpportunityCompanyMutationVariables>;

/**
 * __useReAssignOpportunityCompanyMutation__
 *
 * To run a mutation, you first call `useReAssignOpportunityCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReAssignOpportunityCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reAssignOpportunityCompanyMutation, { data, loading, error }] = useReAssignOpportunityCompanyMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      companyUid: // value for 'companyUid'
 *      keyContactIds: // value for 'keyContactIds'
 *   },
 * });
 */
export function useReAssignOpportunityCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ReAssignOpportunityCompanyMutation, ReAssignOpportunityCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReAssignOpportunityCompanyMutation, ReAssignOpportunityCompanyMutationVariables>(ReAssignOpportunityCompanyDocument, options);
      }
export type ReAssignOpportunityCompanyMutationHookResult = ReturnType<typeof useReAssignOpportunityCompanyMutation>;
export type ReAssignOpportunityCompanyMutationResult = Apollo.MutationResult<ReAssignOpportunityCompanyMutation>;
export type ReAssignOpportunityCompanyMutationOptions = Apollo.BaseMutationOptions<ReAssignOpportunityCompanyMutation, ReAssignOpportunityCompanyMutationVariables>;
export const RemoveCompanyDocumentDocument = gql`
    mutation RemoveCompanyDocument($uid: ID!) {
  removeCompanyDocument(uid: $uid) {
    failReasons
  }
}
    `;
export type RemoveCompanyDocumentMutationFn = Apollo.MutationFunction<RemoveCompanyDocumentMutation, RemoveCompanyDocumentMutationVariables>;

/**
 * __useRemoveCompanyDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyDocumentMutation, { data, loading, error }] = useRemoveCompanyDocumentMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useRemoveCompanyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyDocumentMutation, RemoveCompanyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyDocumentMutation, RemoveCompanyDocumentMutationVariables>(RemoveCompanyDocumentDocument, options);
      }
export type RemoveCompanyDocumentMutationHookResult = ReturnType<typeof useRemoveCompanyDocumentMutation>;
export type RemoveCompanyDocumentMutationResult = Apollo.MutationResult<RemoveCompanyDocumentMutation>;
export type RemoveCompanyDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyDocumentMutation, RemoveCompanyDocumentMutationVariables>;
export const RemoveCompanyListDocument = gql`
    mutation RemoveCompanyList($uid: ID!) {
  removeCompanyList(uid: $uid) {
    failReasons
  }
}
    `;
export type RemoveCompanyListMutationFn = Apollo.MutationFunction<RemoveCompanyListMutation, RemoveCompanyListMutationVariables>;

/**
 * __useRemoveCompanyListMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyListMutation, { data, loading, error }] = useRemoveCompanyListMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useRemoveCompanyListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyListMutation, RemoveCompanyListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyListMutation, RemoveCompanyListMutationVariables>(RemoveCompanyListDocument, options);
      }
export type RemoveCompanyListMutationHookResult = ReturnType<typeof useRemoveCompanyListMutation>;
export type RemoveCompanyListMutationResult = Apollo.MutationResult<RemoveCompanyListMutation>;
export type RemoveCompanyListMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyListMutation, RemoveCompanyListMutationVariables>;
export const RemoveCompanyOfficeLocationDocument = gql`
    mutation RemoveCompanyOfficeLocation($companyOfficeLocationId: ID!) {
  removeCompanyOfficeLocation(companyOfficeLocationId: $companyOfficeLocationId) {
    failReasons
  }
}
    `;
export type RemoveCompanyOfficeLocationMutationFn = Apollo.MutationFunction<RemoveCompanyOfficeLocationMutation, RemoveCompanyOfficeLocationMutationVariables>;

/**
 * __useRemoveCompanyOfficeLocationMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyOfficeLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyOfficeLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyOfficeLocationMutation, { data, loading, error }] = useRemoveCompanyOfficeLocationMutation({
 *   variables: {
 *      companyOfficeLocationId: // value for 'companyOfficeLocationId'
 *   },
 * });
 */
export function useRemoveCompanyOfficeLocationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyOfficeLocationMutation, RemoveCompanyOfficeLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyOfficeLocationMutation, RemoveCompanyOfficeLocationMutationVariables>(RemoveCompanyOfficeLocationDocument, options);
      }
export type RemoveCompanyOfficeLocationMutationHookResult = ReturnType<typeof useRemoveCompanyOfficeLocationMutation>;
export type RemoveCompanyOfficeLocationMutationResult = Apollo.MutationResult<RemoveCompanyOfficeLocationMutation>;
export type RemoveCompanyOfficeLocationMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyOfficeLocationMutation, RemoveCompanyOfficeLocationMutationVariables>;
export const RemoveCustomFieldSchemaDocument = gql`
    mutation RemoveCustomFieldSchema($schemaUuid: ID!) {
  removeCustomFieldSchema(schemaUuid: $schemaUuid) {
    failReasons
  }
}
    `;
export type RemoveCustomFieldSchemaMutationFn = Apollo.MutationFunction<RemoveCustomFieldSchemaMutation, RemoveCustomFieldSchemaMutationVariables>;

/**
 * __useRemoveCustomFieldSchemaMutation__
 *
 * To run a mutation, you first call `useRemoveCustomFieldSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomFieldSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomFieldSchemaMutation, { data, loading, error }] = useRemoveCustomFieldSchemaMutation({
 *   variables: {
 *      schemaUuid: // value for 'schemaUuid'
 *   },
 * });
 */
export function useRemoveCustomFieldSchemaMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomFieldSchemaMutation, RemoveCustomFieldSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomFieldSchemaMutation, RemoveCustomFieldSchemaMutationVariables>(RemoveCustomFieldSchemaDocument, options);
      }
export type RemoveCustomFieldSchemaMutationHookResult = ReturnType<typeof useRemoveCustomFieldSchemaMutation>;
export type RemoveCustomFieldSchemaMutationResult = Apollo.MutationResult<RemoveCustomFieldSchemaMutation>;
export type RemoveCustomFieldSchemaMutationOptions = Apollo.BaseMutationOptions<RemoveCustomFieldSchemaMutation, RemoveCustomFieldSchemaMutationVariables>;
export const RemoveCustomOptionDocument = gql`
    mutation RemoveCustomOption($optionChoiceUuid: ID!) {
  removeCustomOption(optionChoiceUuid: $optionChoiceUuid) {
    failReasons
  }
}
    `;
export type RemoveCustomOptionMutationFn = Apollo.MutationFunction<RemoveCustomOptionMutation, RemoveCustomOptionMutationVariables>;

/**
 * __useRemoveCustomOptionMutation__
 *
 * To run a mutation, you first call `useRemoveCustomOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomOptionMutation, { data, loading, error }] = useRemoveCustomOptionMutation({
 *   variables: {
 *      optionChoiceUuid: // value for 'optionChoiceUuid'
 *   },
 * });
 */
export function useRemoveCustomOptionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomOptionMutation, RemoveCustomOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomOptionMutation, RemoveCustomOptionMutationVariables>(RemoveCustomOptionDocument, options);
      }
export type RemoveCustomOptionMutationHookResult = ReturnType<typeof useRemoveCustomOptionMutation>;
export type RemoveCustomOptionMutationResult = Apollo.MutationResult<RemoveCustomOptionMutation>;
export type RemoveCustomOptionMutationOptions = Apollo.BaseMutationOptions<RemoveCustomOptionMutation, RemoveCustomOptionMutationVariables>;
export const RemoveListDocument = gql`
    mutation RemoveList($uid: ID!) {
  removeList(uid: $uid) {
    failReasons
  }
}
    `;
export type RemoveListMutationFn = Apollo.MutationFunction<RemoveListMutation, RemoveListMutationVariables>;

/**
 * __useRemoveListMutation__
 *
 * To run a mutation, you first call `useRemoveListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeListMutation, { data, loading, error }] = useRemoveListMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useRemoveListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveListMutation, RemoveListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveListMutation, RemoveListMutationVariables>(RemoveListDocument, options);
      }
export type RemoveListMutationHookResult = ReturnType<typeof useRemoveListMutation>;
export type RemoveListMutationResult = Apollo.MutationResult<RemoveListMutation>;
export type RemoveListMutationOptions = Apollo.BaseMutationOptions<RemoveListMutation, RemoveListMutationVariables>;
export const RemoveMyCompanyDocument = gql`
    mutation RemoveMyCompany($myCompanyUid: String!) {
  removeMyCompany(myCompanyUid: $myCompanyUid) {
    failReasons
  }
}
    `;
export type RemoveMyCompanyMutationFn = Apollo.MutationFunction<RemoveMyCompanyMutation, RemoveMyCompanyMutationVariables>;

/**
 * __useRemoveMyCompanyMutation__
 *
 * To run a mutation, you first call `useRemoveMyCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyCompanyMutation, { data, loading, error }] = useRemoveMyCompanyMutation({
 *   variables: {
 *      myCompanyUid: // value for 'myCompanyUid'
 *   },
 * });
 */
export function useRemoveMyCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyCompanyMutation, RemoveMyCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyCompanyMutation, RemoveMyCompanyMutationVariables>(RemoveMyCompanyDocument, options);
      }
export type RemoveMyCompanyMutationHookResult = ReturnType<typeof useRemoveMyCompanyMutation>;
export type RemoveMyCompanyMutationResult = Apollo.MutationResult<RemoveMyCompanyMutation>;
export type RemoveMyCompanyMutationOptions = Apollo.BaseMutationOptions<RemoveMyCompanyMutation, RemoveMyCompanyMutationVariables>;
export const RemoveMyContactDocument = gql`
    mutation RemoveMyContact($myContactUid: String!) {
  removeMyContact(myContactUid: $myContactUid) {
    failReasons
  }
}
    `;
export type RemoveMyContactMutationFn = Apollo.MutationFunction<RemoveMyContactMutation, RemoveMyContactMutationVariables>;

/**
 * __useRemoveMyContactMutation__
 *
 * To run a mutation, you first call `useRemoveMyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyContactMutation, { data, loading, error }] = useRemoveMyContactMutation({
 *   variables: {
 *      myContactUid: // value for 'myContactUid'
 *   },
 * });
 */
export function useRemoveMyContactMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyContactMutation, RemoveMyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyContactMutation, RemoveMyContactMutationVariables>(RemoveMyContactDocument, options);
      }
export type RemoveMyContactMutationHookResult = ReturnType<typeof useRemoveMyContactMutation>;
export type RemoveMyContactMutationResult = Apollo.MutationResult<RemoveMyContactMutation>;
export type RemoveMyContactMutationOptions = Apollo.BaseMutationOptions<RemoveMyContactMutation, RemoveMyContactMutationVariables>;
export const SearchOpportunityKeyContactsDocument = gql`
    query SearchOpportunityKeyContacts($term: String, $companyDomain: String!) {
  contacts: availableOpportunityKeyContacts(
    term: $term
    companyUid: $companyDomain
    page: 1
    perPage: 5
  ) {
    entries {
      ...ContactPreview
    }
  }
}
    ${ContactPreviewFragmentDoc}`;

/**
 * __useSearchOpportunityKeyContactsQuery__
 *
 * To run a query within a React component, call `useSearchOpportunityKeyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOpportunityKeyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOpportunityKeyContactsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      companyDomain: // value for 'companyDomain'
 *   },
 * });
 */
export function useSearchOpportunityKeyContactsQuery(baseOptions: Apollo.QueryHookOptions<SearchOpportunityKeyContactsQuery, SearchOpportunityKeyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOpportunityKeyContactsQuery, SearchOpportunityKeyContactsQueryVariables>(SearchOpportunityKeyContactsDocument, options);
      }
export function useSearchOpportunityKeyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOpportunityKeyContactsQuery, SearchOpportunityKeyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOpportunityKeyContactsQuery, SearchOpportunityKeyContactsQueryVariables>(SearchOpportunityKeyContactsDocument, options);
        }
export type SearchOpportunityKeyContactsQueryHookResult = ReturnType<typeof useSearchOpportunityKeyContactsQuery>;
export type SearchOpportunityKeyContactsLazyQueryHookResult = ReturnType<typeof useSearchOpportunityKeyContactsLazyQuery>;
export type SearchOpportunityKeyContactsQueryResult = Apollo.QueryResult<SearchOpportunityKeyContactsQuery, SearchOpportunityKeyContactsQueryVariables>;
export const SetStayInTouchDocument = gql`
    mutation SetStayInTouch($myContactUid: String!, $frequency: StayInTouchFrequency!) {
  setStayInTouch(myContactUid: $myContactUid, frequency: $frequency) {
    failReasons
  }
}
    `;
export type SetStayInTouchMutationFn = Apollo.MutationFunction<SetStayInTouchMutation, SetStayInTouchMutationVariables>;

/**
 * __useSetStayInTouchMutation__
 *
 * To run a mutation, you first call `useSetStayInTouchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStayInTouchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStayInTouchMutation, { data, loading, error }] = useSetStayInTouchMutation({
 *   variables: {
 *      myContactUid: // value for 'myContactUid'
 *      frequency: // value for 'frequency'
 *   },
 * });
 */
export function useSetStayInTouchMutation(baseOptions?: Apollo.MutationHookOptions<SetStayInTouchMutation, SetStayInTouchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStayInTouchMutation, SetStayInTouchMutationVariables>(SetStayInTouchDocument, options);
      }
export type SetStayInTouchMutationHookResult = ReturnType<typeof useSetStayInTouchMutation>;
export type SetStayInTouchMutationResult = Apollo.MutationResult<SetStayInTouchMutation>;
export type SetStayInTouchMutationOptions = Apollo.BaseMutationOptions<SetStayInTouchMutation, SetStayInTouchMutationVariables>;
export const SyncListActivitiesDocument = gql`
    mutation SyncListActivities($listUuid: String!) {
  syncListActivities(listUuid: $listUuid) {
    failReasons
  }
}
    `;
export type SyncListActivitiesMutationFn = Apollo.MutationFunction<SyncListActivitiesMutation, SyncListActivitiesMutationVariables>;

/**
 * __useSyncListActivitiesMutation__
 *
 * To run a mutation, you first call `useSyncListActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncListActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncListActivitiesMutation, { data, loading, error }] = useSyncListActivitiesMutation({
 *   variables: {
 *      listUuid: // value for 'listUuid'
 *   },
 * });
 */
export function useSyncListActivitiesMutation(baseOptions?: Apollo.MutationHookOptions<SyncListActivitiesMutation, SyncListActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncListActivitiesMutation, SyncListActivitiesMutationVariables>(SyncListActivitiesDocument, options);
      }
export type SyncListActivitiesMutationHookResult = ReturnType<typeof useSyncListActivitiesMutation>;
export type SyncListActivitiesMutationResult = Apollo.MutationResult<SyncListActivitiesMutation>;
export type SyncListActivitiesMutationOptions = Apollo.BaseMutationOptions<SyncListActivitiesMutation, SyncListActivitiesMutationVariables>;
export const TriggerApiSourceDocument = gql`
    mutation TriggerApiSource($sourceUid: ID!) {
  triggerApiSource(sourceUid: $sourceUid) {
    failReasons
  }
}
    `;
export type TriggerApiSourceMutationFn = Apollo.MutationFunction<TriggerApiSourceMutation, TriggerApiSourceMutationVariables>;

/**
 * __useTriggerApiSourceMutation__
 *
 * To run a mutation, you first call `useTriggerApiSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerApiSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerApiSourceMutation, { data, loading, error }] = useTriggerApiSourceMutation({
 *   variables: {
 *      sourceUid: // value for 'sourceUid'
 *   },
 * });
 */
export function useTriggerApiSourceMutation(baseOptions?: Apollo.MutationHookOptions<TriggerApiSourceMutation, TriggerApiSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerApiSourceMutation, TriggerApiSourceMutationVariables>(TriggerApiSourceDocument, options);
      }
export type TriggerApiSourceMutationHookResult = ReturnType<typeof useTriggerApiSourceMutation>;
export type TriggerApiSourceMutationResult = Apollo.MutationResult<TriggerApiSourceMutation>;
export type TriggerApiSourceMutationOptions = Apollo.BaseMutationOptions<TriggerApiSourceMutation, TriggerApiSourceMutationVariables>;
export const UpcomingKeyActivitiesDocument = gql`
    query UpcomingKeyActivities($page: Int, $perPage: Int, $filter: InteractionDetailsFilter, $orderBy: InteractionDetailsOrderBy) {
  keyActivities(
    page: $page
    perPage: $perPage
    filter: $filter
    orderBy: $orderBy
  ) {
    entries {
      ...UpcomingKeyActivity
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${UpcomingKeyActivityFragmentDoc}`;

/**
 * __useUpcomingKeyActivitiesQuery__
 *
 * To run a query within a React component, call `useUpcomingKeyActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingKeyActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingKeyActivitiesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUpcomingKeyActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<UpcomingKeyActivitiesQuery, UpcomingKeyActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingKeyActivitiesQuery, UpcomingKeyActivitiesQueryVariables>(UpcomingKeyActivitiesDocument, options);
      }
export function useUpcomingKeyActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingKeyActivitiesQuery, UpcomingKeyActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingKeyActivitiesQuery, UpcomingKeyActivitiesQueryVariables>(UpcomingKeyActivitiesDocument, options);
        }
export type UpcomingKeyActivitiesQueryHookResult = ReturnType<typeof useUpcomingKeyActivitiesQuery>;
export type UpcomingKeyActivitiesLazyQueryHookResult = ReturnType<typeof useUpcomingKeyActivitiesLazyQuery>;
export type UpcomingKeyActivitiesQueryResult = Apollo.QueryResult<UpcomingKeyActivitiesQuery, UpcomingKeyActivitiesQueryVariables>;
export const UpdateCompanyDocumentDocument = gql`
    mutation UpdateCompanyDocument($uid: String!, $attributes: CompanyDocumentAttributes!) {
  updateCompanyDocument(uid: $uid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type UpdateCompanyDocumentMutationFn = Apollo.MutationFunction<UpdateCompanyDocumentMutation, UpdateCompanyDocumentMutationVariables>;

/**
 * __useUpdateCompanyDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyDocumentMutation, { data, loading, error }] = useUpdateCompanyDocumentMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateCompanyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyDocumentMutation, UpdateCompanyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyDocumentMutation, UpdateCompanyDocumentMutationVariables>(UpdateCompanyDocumentDocument, options);
      }
export type UpdateCompanyDocumentMutationHookResult = ReturnType<typeof useUpdateCompanyDocumentMutation>;
export type UpdateCompanyDocumentMutationResult = Apollo.MutationResult<UpdateCompanyDocumentMutation>;
export type UpdateCompanyDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyDocumentMutation, UpdateCompanyDocumentMutationVariables>;
export const UpdateCompanyOfficeLocationDocument = gql`
    mutation UpdateCompanyOfficeLocation($companyOfficeLocationId: ID!, $primaryLocation: Boolean, $headquarterLocation: Boolean, $labels: [String!], $locationAttributes: LocationAttributes) {
  updateCompanyOfficeLocation(
    companyOfficeLocationId: $companyOfficeLocationId
    primaryLocation: $primaryLocation
    headquarterLocation: $headquarterLocation
    locationAttributes: $locationAttributes
    labels: $labels
  ) {
    failReasons
  }
}
    `;
export type UpdateCompanyOfficeLocationMutationFn = Apollo.MutationFunction<UpdateCompanyOfficeLocationMutation, UpdateCompanyOfficeLocationMutationVariables>;

/**
 * __useUpdateCompanyOfficeLocationMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyOfficeLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyOfficeLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyOfficeLocationMutation, { data, loading, error }] = useUpdateCompanyOfficeLocationMutation({
 *   variables: {
 *      companyOfficeLocationId: // value for 'companyOfficeLocationId'
 *      primaryLocation: // value for 'primaryLocation'
 *      headquarterLocation: // value for 'headquarterLocation'
 *      labels: // value for 'labels'
 *      locationAttributes: // value for 'locationAttributes'
 *   },
 * });
 */
export function useUpdateCompanyOfficeLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyOfficeLocationMutation, UpdateCompanyOfficeLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyOfficeLocationMutation, UpdateCompanyOfficeLocationMutationVariables>(UpdateCompanyOfficeLocationDocument, options);
      }
export type UpdateCompanyOfficeLocationMutationHookResult = ReturnType<typeof useUpdateCompanyOfficeLocationMutation>;
export type UpdateCompanyOfficeLocationMutationResult = Apollo.MutationResult<UpdateCompanyOfficeLocationMutation>;
export type UpdateCompanyOfficeLocationMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyOfficeLocationMutation, UpdateCompanyOfficeLocationMutationVariables>;
export const UpdateCustomFieldSchemaDocument = gql`
    mutation UpdateCustomFieldSchema($schemaId: ID!, $name: String!) {
  updateCustomFieldSchema(schemaId: $schemaId, name: $name) {
    failReasons
    record {
      ...CustomFieldSchema
    }
  }
}
    ${CustomFieldSchemaFragmentDoc}`;
export type UpdateCustomFieldSchemaMutationFn = Apollo.MutationFunction<UpdateCustomFieldSchemaMutation, UpdateCustomFieldSchemaMutationVariables>;

/**
 * __useUpdateCustomFieldSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFieldSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFieldSchemaMutation, { data, loading, error }] = useUpdateCustomFieldSchemaMutation({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCustomFieldSchemaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomFieldSchemaMutation, UpdateCustomFieldSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomFieldSchemaMutation, UpdateCustomFieldSchemaMutationVariables>(UpdateCustomFieldSchemaDocument, options);
      }
export type UpdateCustomFieldSchemaMutationHookResult = ReturnType<typeof useUpdateCustomFieldSchemaMutation>;
export type UpdateCustomFieldSchemaMutationResult = Apollo.MutationResult<UpdateCustomFieldSchemaMutation>;
export type UpdateCustomFieldSchemaMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFieldSchemaMutation, UpdateCustomFieldSchemaMutationVariables>;
export const UpdateCustomFieldSchemaValuesDocument = gql`
    mutation UpdateCustomFieldSchemaValues($schemaUid: ID!, $name: String!, $options: [OptionChoiceAttributes!]) {
  result: updateCustomFieldSchemaValues(
    schemaAttributes: {schemaUid: $schemaUid, name: $name, options: $options}
  ) {
    failReasons
  }
}
    `;
export type UpdateCustomFieldSchemaValuesMutationFn = Apollo.MutationFunction<UpdateCustomFieldSchemaValuesMutation, UpdateCustomFieldSchemaValuesMutationVariables>;

/**
 * __useUpdateCustomFieldSchemaValuesMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFieldSchemaValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldSchemaValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFieldSchemaValuesMutation, { data, loading, error }] = useUpdateCustomFieldSchemaValuesMutation({
 *   variables: {
 *      schemaUid: // value for 'schemaUid'
 *      name: // value for 'name'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateCustomFieldSchemaValuesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomFieldSchemaValuesMutation, UpdateCustomFieldSchemaValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomFieldSchemaValuesMutation, UpdateCustomFieldSchemaValuesMutationVariables>(UpdateCustomFieldSchemaValuesDocument, options);
      }
export type UpdateCustomFieldSchemaValuesMutationHookResult = ReturnType<typeof useUpdateCustomFieldSchemaValuesMutation>;
export type UpdateCustomFieldSchemaValuesMutationResult = Apollo.MutationResult<UpdateCustomFieldSchemaValuesMutation>;
export type UpdateCustomFieldSchemaValuesMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFieldSchemaValuesMutation, UpdateCustomFieldSchemaValuesMutationVariables>;
export const UpdateCustomOptionDocument = gql`
    mutation UpdateCustomOption($optionChoiceUuid: ID!, $optionValue: String!, $optionColour: AccountColour!) {
  updateCustomOption(
    optionChoiceUuid: $optionChoiceUuid
    optionValue: $optionValue
    optionColour: $optionColour
  ) {
    failReasons
  }
}
    `;
export type UpdateCustomOptionMutationFn = Apollo.MutationFunction<UpdateCustomOptionMutation, UpdateCustomOptionMutationVariables>;

/**
 * __useUpdateCustomOptionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomOptionMutation, { data, loading, error }] = useUpdateCustomOptionMutation({
 *   variables: {
 *      optionChoiceUuid: // value for 'optionChoiceUuid'
 *      optionValue: // value for 'optionValue'
 *      optionColour: // value for 'optionColour'
 *   },
 * });
 */
export function useUpdateCustomOptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomOptionMutation, UpdateCustomOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomOptionMutation, UpdateCustomOptionMutationVariables>(UpdateCustomOptionDocument, options);
      }
export type UpdateCustomOptionMutationHookResult = ReturnType<typeof useUpdateCustomOptionMutation>;
export type UpdateCustomOptionMutationResult = Apollo.MutationResult<UpdateCustomOptionMutation>;
export type UpdateCustomOptionMutationOptions = Apollo.BaseMutationOptions<UpdateCustomOptionMutation, UpdateCustomOptionMutationVariables>;
export const UpdateTagsDocument = gql`
    mutation UpdateTags($tags: [String!]!, $uid: ID!) {
  addTagCompany: updateCompany(uid: $uid, attributes: {tags: $tags}) {
    failReasons
  }
}
    `;
export type UpdateTagsMutationFn = Apollo.MutationFunction<UpdateTagsMutation, UpdateTagsMutationVariables>;

/**
 * __useUpdateTagsMutation__
 *
 * To run a mutation, you first call `useUpdateTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagsMutation, { data, loading, error }] = useUpdateTagsMutation({
 *   variables: {
 *      tags: // value for 'tags'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useUpdateTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagsMutation, UpdateTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagsMutation, UpdateTagsMutationVariables>(UpdateTagsDocument, options);
      }
export type UpdateTagsMutationHookResult = ReturnType<typeof useUpdateTagsMutation>;
export type UpdateTagsMutationResult = Apollo.MutationResult<UpdateTagsMutation>;
export type UpdateTagsMutationOptions = Apollo.BaseMutationOptions<UpdateTagsMutation, UpdateTagsMutationVariables>;
export const CreateEventPackRequestDocument = gql`
    mutation CreateEventPackRequest($attributes: EventPackRequestAttribute!) {
  createEventPackRequest(attributes: $attributes) {
    failReasons
    record {
      id
    }
  }
}
    `;
export type CreateEventPackRequestMutationFn = Apollo.MutationFunction<CreateEventPackRequestMutation, CreateEventPackRequestMutationVariables>;

/**
 * __useCreateEventPackRequestMutation__
 *
 * To run a mutation, you first call `useCreateEventPackRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventPackRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventPackRequestMutation, { data, loading, error }] = useCreateEventPackRequestMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateEventPackRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventPackRequestMutation, CreateEventPackRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventPackRequestMutation, CreateEventPackRequestMutationVariables>(CreateEventPackRequestDocument, options);
      }
export type CreateEventPackRequestMutationHookResult = ReturnType<typeof useCreateEventPackRequestMutation>;
export type CreateEventPackRequestMutationResult = Apollo.MutationResult<CreateEventPackRequestMutation>;
export type CreateEventPackRequestMutationOptions = Apollo.BaseMutationOptions<CreateEventPackRequestMutation, CreateEventPackRequestMutationVariables>;
export const EventPackRequestFinishedDocument = gql`
    subscription EventPackRequestFinished($eventPackRequestUid: ID!) {
  eventPackRequestFinished(eventPackRequestUid: $eventPackRequestUid) {
    id
    requestStatus
    eventPackResponse {
      ...EventPackResponse
    }
  }
}
    ${EventPackResponseFragmentDoc}`;

/**
 * __useEventPackRequestFinishedSubscription__
 *
 * To run a query within a React component, call `useEventPackRequestFinishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventPackRequestFinishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPackRequestFinishedSubscription({
 *   variables: {
 *      eventPackRequestUid: // value for 'eventPackRequestUid'
 *   },
 * });
 */
export function useEventPackRequestFinishedSubscription(baseOptions: Apollo.SubscriptionHookOptions<EventPackRequestFinishedSubscription, EventPackRequestFinishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EventPackRequestFinishedSubscription, EventPackRequestFinishedSubscriptionVariables>(EventPackRequestFinishedDocument, options);
      }
export type EventPackRequestFinishedSubscriptionHookResult = ReturnType<typeof useEventPackRequestFinishedSubscription>;
export type EventPackRequestFinishedSubscriptionResult = Apollo.SubscriptionResult<EventPackRequestFinishedSubscription>;
export const CreateLinkedinPostRequestDocument = gql`
    mutation CreateLinkedinPostRequest($attributes: LinkedinPostRequestAttribute!) {
  createLinkedinPostRequest(attributes: $attributes) {
    failReasons
    record {
      id
    }
  }
}
    `;
export type CreateLinkedinPostRequestMutationFn = Apollo.MutationFunction<CreateLinkedinPostRequestMutation, CreateLinkedinPostRequestMutationVariables>;

/**
 * __useCreateLinkedinPostRequestMutation__
 *
 * To run a mutation, you first call `useCreateLinkedinPostRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkedinPostRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkedinPostRequestMutation, { data, loading, error }] = useCreateLinkedinPostRequestMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateLinkedinPostRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkedinPostRequestMutation, CreateLinkedinPostRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkedinPostRequestMutation, CreateLinkedinPostRequestMutationVariables>(CreateLinkedinPostRequestDocument, options);
      }
export type CreateLinkedinPostRequestMutationHookResult = ReturnType<typeof useCreateLinkedinPostRequestMutation>;
export type CreateLinkedinPostRequestMutationResult = Apollo.MutationResult<CreateLinkedinPostRequestMutation>;
export type CreateLinkedinPostRequestMutationOptions = Apollo.BaseMutationOptions<CreateLinkedinPostRequestMutation, CreateLinkedinPostRequestMutationVariables>;
export const LinkedinPostRequestFinishedDocument = gql`
    subscription LinkedinPostRequestFinished($linkedinPostRequestUid: ID!) {
  linkedinPostRequestFinished(linkedinPostRequestUid: $linkedinPostRequestUid) {
    id
    requestStatus
    linkedinPostResponse {
      ...LinkedinPostResponse
    }
  }
}
    ${LinkedinPostResponseFragmentDoc}`;

/**
 * __useLinkedinPostRequestFinishedSubscription__
 *
 * To run a query within a React component, call `useLinkedinPostRequestFinishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLinkedinPostRequestFinishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedinPostRequestFinishedSubscription({
 *   variables: {
 *      linkedinPostRequestUid: // value for 'linkedinPostRequestUid'
 *   },
 * });
 */
export function useLinkedinPostRequestFinishedSubscription(baseOptions: Apollo.SubscriptionHookOptions<LinkedinPostRequestFinishedSubscription, LinkedinPostRequestFinishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LinkedinPostRequestFinishedSubscription, LinkedinPostRequestFinishedSubscriptionVariables>(LinkedinPostRequestFinishedDocument, options);
      }
export type LinkedinPostRequestFinishedSubscriptionHookResult = ReturnType<typeof useLinkedinPostRequestFinishedSubscription>;
export type LinkedinPostRequestFinishedSubscriptionResult = Apollo.SubscriptionResult<LinkedinPostRequestFinishedSubscription>;
export const CreateMarketingEmailRequestDocument = gql`
    mutation CreateMarketingEmailRequest($attributes: MarketingEmailRequestAttribute!) {
  createMarketingEmailRequest(attributes: $attributes) {
    failReasons
    record {
      id
    }
  }
}
    `;
export type CreateMarketingEmailRequestMutationFn = Apollo.MutationFunction<CreateMarketingEmailRequestMutation, CreateMarketingEmailRequestMutationVariables>;

/**
 * __useCreateMarketingEmailRequestMutation__
 *
 * To run a mutation, you first call `useCreateMarketingEmailRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketingEmailRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketingEmailRequestMutation, { data, loading, error }] = useCreateMarketingEmailRequestMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateMarketingEmailRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketingEmailRequestMutation, CreateMarketingEmailRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketingEmailRequestMutation, CreateMarketingEmailRequestMutationVariables>(CreateMarketingEmailRequestDocument, options);
      }
export type CreateMarketingEmailRequestMutationHookResult = ReturnType<typeof useCreateMarketingEmailRequestMutation>;
export type CreateMarketingEmailRequestMutationResult = Apollo.MutationResult<CreateMarketingEmailRequestMutation>;
export type CreateMarketingEmailRequestMutationOptions = Apollo.BaseMutationOptions<CreateMarketingEmailRequestMutation, CreateMarketingEmailRequestMutationVariables>;
export const MarketingEmailRequestFinishedDocument = gql`
    subscription MarketingEmailRequestFinished($marketingEmailRequestUid: ID!) {
  marketingEmailRequestFinished(
    marketingEmailRequestUid: $marketingEmailRequestUid
  ) {
    id
    requestStatus
    marketingEmailResponse {
      ...MarketingEmailResponse
    }
  }
}
    ${MarketingEmailResponseFragmentDoc}`;

/**
 * __useMarketingEmailRequestFinishedSubscription__
 *
 * To run a query within a React component, call `useMarketingEmailRequestFinishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEmailRequestFinishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEmailRequestFinishedSubscription({
 *   variables: {
 *      marketingEmailRequestUid: // value for 'marketingEmailRequestUid'
 *   },
 * });
 */
export function useMarketingEmailRequestFinishedSubscription(baseOptions: Apollo.SubscriptionHookOptions<MarketingEmailRequestFinishedSubscription, MarketingEmailRequestFinishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MarketingEmailRequestFinishedSubscription, MarketingEmailRequestFinishedSubscriptionVariables>(MarketingEmailRequestFinishedDocument, options);
      }
export type MarketingEmailRequestFinishedSubscriptionHookResult = ReturnType<typeof useMarketingEmailRequestFinishedSubscription>;
export type MarketingEmailRequestFinishedSubscriptionResult = Apollo.SubscriptionResult<MarketingEmailRequestFinishedSubscription>;
export const AddBlockPageToBlockPageListDocument = gql`
    mutation AddBlockPageToBlockPageList($blockPageListUid: ID!, $attributes: BlockPageAttributes!) {
  addBlockPageToBlockPageList(
    blockPageListUid: $blockPageListUid
    attributes: $attributes
  ) {
    failReasons
    blockPage {
      id
    }
  }
}
    `;
export type AddBlockPageToBlockPageListMutationFn = Apollo.MutationFunction<AddBlockPageToBlockPageListMutation, AddBlockPageToBlockPageListMutationVariables>;

/**
 * __useAddBlockPageToBlockPageListMutation__
 *
 * To run a mutation, you first call `useAddBlockPageToBlockPageListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBlockPageToBlockPageListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBlockPageToBlockPageListMutation, { data, loading, error }] = useAddBlockPageToBlockPageListMutation({
 *   variables: {
 *      blockPageListUid: // value for 'blockPageListUid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddBlockPageToBlockPageListMutation(baseOptions?: Apollo.MutationHookOptions<AddBlockPageToBlockPageListMutation, AddBlockPageToBlockPageListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBlockPageToBlockPageListMutation, AddBlockPageToBlockPageListMutationVariables>(AddBlockPageToBlockPageListDocument, options);
      }
export type AddBlockPageToBlockPageListMutationHookResult = ReturnType<typeof useAddBlockPageToBlockPageListMutation>;
export type AddBlockPageToBlockPageListMutationResult = Apollo.MutationResult<AddBlockPageToBlockPageListMutation>;
export type AddBlockPageToBlockPageListMutationOptions = Apollo.BaseMutationOptions<AddBlockPageToBlockPageListMutation, AddBlockPageToBlockPageListMutationVariables>;
export const BlockPageDocument = gql`
    query BlockPage($uid: ID!) {
  blockPage(uid: $uid) {
    ...BlockPage
  }
}
    ${BlockPageFragmentDoc}`;

/**
 * __useBlockPageQuery__
 *
 * To run a query within a React component, call `useBlockPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockPageQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useBlockPageQuery(baseOptions: Apollo.QueryHookOptions<BlockPageQuery, BlockPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockPageQuery, BlockPageQueryVariables>(BlockPageDocument, options);
      }
export function useBlockPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockPageQuery, BlockPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockPageQuery, BlockPageQueryVariables>(BlockPageDocument, options);
        }
export type BlockPageQueryHookResult = ReturnType<typeof useBlockPageQuery>;
export type BlockPageLazyQueryHookResult = ReturnType<typeof useBlockPageLazyQuery>;
export type BlockPageQueryResult = Apollo.QueryResult<BlockPageQuery, BlockPageQueryVariables>;
export const CreateBlockPageListTabDocument = gql`
    mutation CreateBlockPageListTab($name: String!, $position: Int!, $group: String!) {
  createBlockPageListTab(name: $name, position: $position, group: $group) {
    failReasons
    id
  }
}
    `;
export type CreateBlockPageListTabMutationFn = Apollo.MutationFunction<CreateBlockPageListTabMutation, CreateBlockPageListTabMutationVariables>;

/**
 * __useCreateBlockPageListTabMutation__
 *
 * To run a mutation, you first call `useCreateBlockPageListTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlockPageListTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlockPageListTabMutation, { data, loading, error }] = useCreateBlockPageListTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      position: // value for 'position'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useCreateBlockPageListTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlockPageListTabMutation, CreateBlockPageListTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlockPageListTabMutation, CreateBlockPageListTabMutationVariables>(CreateBlockPageListTabDocument, options);
      }
export type CreateBlockPageListTabMutationHookResult = ReturnType<typeof useCreateBlockPageListTabMutation>;
export type CreateBlockPageListTabMutationResult = Apollo.MutationResult<CreateBlockPageListTabMutation>;
export type CreateBlockPageListTabMutationOptions = Apollo.BaseMutationOptions<CreateBlockPageListTabMutation, CreateBlockPageListTabMutationVariables>;
export const CurrentUserProfileNameDocument = gql`
    query CurrentUserProfileName {
  info: currentUser {
    id
    profileName
  }
  provider: blockPageProvider {
    id
    url
    token
  }
}
    `;

/**
 * __useCurrentUserProfileNameQuery__
 *
 * To run a query within a React component, call `useCurrentUserProfileNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserProfileNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserProfileNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserProfileNameQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserProfileNameQuery, CurrentUserProfileNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserProfileNameQuery, CurrentUserProfileNameQueryVariables>(CurrentUserProfileNameDocument, options);
      }
export function useCurrentUserProfileNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserProfileNameQuery, CurrentUserProfileNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserProfileNameQuery, CurrentUserProfileNameQueryVariables>(CurrentUserProfileNameDocument, options);
        }
export type CurrentUserProfileNameQueryHookResult = ReturnType<typeof useCurrentUserProfileNameQuery>;
export type CurrentUserProfileNameLazyQueryHookResult = ReturnType<typeof useCurrentUserProfileNameLazyQuery>;
export type CurrentUserProfileNameQueryResult = Apollo.QueryResult<CurrentUserProfileNameQuery, CurrentUserProfileNameQueryVariables>;
export const RemoveBlockPageDocument = gql`
    mutation RemoveBlockPage($blockPageUid: ID!) {
  removeBlockPage(blockPageUid: $blockPageUid) {
    failReasons
    blockPage {
      ...BlockPagePages
    }
  }
}
    ${BlockPagePagesFragmentDoc}`;
export type RemoveBlockPageMutationFn = Apollo.MutationFunction<RemoveBlockPageMutation, RemoveBlockPageMutationVariables>;

/**
 * __useRemoveBlockPageMutation__
 *
 * To run a mutation, you first call `useRemoveBlockPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBlockPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBlockPageMutation, { data, loading, error }] = useRemoveBlockPageMutation({
 *   variables: {
 *      blockPageUid: // value for 'blockPageUid'
 *   },
 * });
 */
export function useRemoveBlockPageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBlockPageMutation, RemoveBlockPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBlockPageMutation, RemoveBlockPageMutationVariables>(RemoveBlockPageDocument, options);
      }
export type RemoveBlockPageMutationHookResult = ReturnType<typeof useRemoveBlockPageMutation>;
export type RemoveBlockPageMutationResult = Apollo.MutationResult<RemoveBlockPageMutation>;
export type RemoveBlockPageMutationOptions = Apollo.BaseMutationOptions<RemoveBlockPageMutation, RemoveBlockPageMutationVariables>;
export const UpdateBlockPageDocument = gql`
    mutation UpdateBlockPage($pageId: ID!, $pageName: String, $iconCode: String) {
  updateBlockPage(uid: $pageId, name: $pageName, iconCode: $iconCode) {
    failReasons
    blockPage {
      ...BlockPagePages
    }
  }
}
    ${BlockPagePagesFragmentDoc}`;
export type UpdateBlockPageMutationFn = Apollo.MutationFunction<UpdateBlockPageMutation, UpdateBlockPageMutationVariables>;

/**
 * __useUpdateBlockPageMutation__
 *
 * To run a mutation, you first call `useUpdateBlockPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockPageMutation, { data, loading, error }] = useUpdateBlockPageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      pageName: // value for 'pageName'
 *      iconCode: // value for 'iconCode'
 *   },
 * });
 */
export function useUpdateBlockPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockPageMutation, UpdateBlockPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockPageMutation, UpdateBlockPageMutationVariables>(UpdateBlockPageDocument, options);
      }
export type UpdateBlockPageMutationHookResult = ReturnType<typeof useUpdateBlockPageMutation>;
export type UpdateBlockPageMutationResult = Apollo.MutationResult<UpdateBlockPageMutation>;
export type UpdateBlockPageMutationOptions = Apollo.BaseMutationOptions<UpdateBlockPageMutation, UpdateBlockPageMutationVariables>;
export const UpdateBlockPageListPositionsDocument = gql`
    mutation UpdateBlockPageListPositions($pageUpdates: [BlockPagePositionAttributes!]!, $blockPageListUid: ID!) {
  updateBlockPageListPositions(
    pageUpdates: $pageUpdates
    blockPageListUid: $blockPageListUid
  ) {
    failReasons
    pages {
      ...BlockPagePages
    }
  }
}
    ${BlockPagePagesFragmentDoc}`;
export type UpdateBlockPageListPositionsMutationFn = Apollo.MutationFunction<UpdateBlockPageListPositionsMutation, UpdateBlockPageListPositionsMutationVariables>;

/**
 * __useUpdateBlockPageListPositionsMutation__
 *
 * To run a mutation, you first call `useUpdateBlockPageListPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockPageListPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockPageListPositionsMutation, { data, loading, error }] = useUpdateBlockPageListPositionsMutation({
 *   variables: {
 *      pageUpdates: // value for 'pageUpdates'
 *      blockPageListUid: // value for 'blockPageListUid'
 *   },
 * });
 */
export function useUpdateBlockPageListPositionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockPageListPositionsMutation, UpdateBlockPageListPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockPageListPositionsMutation, UpdateBlockPageListPositionsMutationVariables>(UpdateBlockPageListPositionsDocument, options);
      }
export type UpdateBlockPageListPositionsMutationHookResult = ReturnType<typeof useUpdateBlockPageListPositionsMutation>;
export type UpdateBlockPageListPositionsMutationResult = Apollo.MutationResult<UpdateBlockPageListPositionsMutation>;
export type UpdateBlockPageListPositionsMutationOptions = Apollo.BaseMutationOptions<UpdateBlockPageListPositionsMutation, UpdateBlockPageListPositionsMutationVariables>;
export const AddEmailMarketingCampaignRecipientDocument = gql`
    mutation AddEmailMarketingCampaignRecipient($campaignUid: ID!, $recipientEmails: [String!]) {
  result: addEmailMarketingCampaignRecipient(
    campaignUid: $campaignUid
    recipientEmails: $recipientEmails
  ) {
    failReasons
  }
}
    `;
export type AddEmailMarketingCampaignRecipientMutationFn = Apollo.MutationFunction<AddEmailMarketingCampaignRecipientMutation, AddEmailMarketingCampaignRecipientMutationVariables>;

/**
 * __useAddEmailMarketingCampaignRecipientMutation__
 *
 * To run a mutation, you first call `useAddEmailMarketingCampaignRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailMarketingCampaignRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailMarketingCampaignRecipientMutation, { data, loading, error }] = useAddEmailMarketingCampaignRecipientMutation({
 *   variables: {
 *      campaignUid: // value for 'campaignUid'
 *      recipientEmails: // value for 'recipientEmails'
 *   },
 * });
 */
export function useAddEmailMarketingCampaignRecipientMutation(baseOptions?: Apollo.MutationHookOptions<AddEmailMarketingCampaignRecipientMutation, AddEmailMarketingCampaignRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmailMarketingCampaignRecipientMutation, AddEmailMarketingCampaignRecipientMutationVariables>(AddEmailMarketingCampaignRecipientDocument, options);
      }
export type AddEmailMarketingCampaignRecipientMutationHookResult = ReturnType<typeof useAddEmailMarketingCampaignRecipientMutation>;
export type AddEmailMarketingCampaignRecipientMutationResult = Apollo.MutationResult<AddEmailMarketingCampaignRecipientMutation>;
export type AddEmailMarketingCampaignRecipientMutationOptions = Apollo.BaseMutationOptions<AddEmailMarketingCampaignRecipientMutation, AddEmailMarketingCampaignRecipientMutationVariables>;
export const ArchiveEmailMarketingCampaignDocument = gql`
    mutation ArchiveEmailMarketingCampaign($campaignUid: ID!) {
  result: archiveEmailMarketingCampaign(campaignUid: $campaignUid) {
    archivedCampaign {
      id
      status
    }
    failReasons
  }
}
    `;
export type ArchiveEmailMarketingCampaignMutationFn = Apollo.MutationFunction<ArchiveEmailMarketingCampaignMutation, ArchiveEmailMarketingCampaignMutationVariables>;

/**
 * __useArchiveEmailMarketingCampaignMutation__
 *
 * To run a mutation, you first call `useArchiveEmailMarketingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEmailMarketingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEmailMarketingCampaignMutation, { data, loading, error }] = useArchiveEmailMarketingCampaignMutation({
 *   variables: {
 *      campaignUid: // value for 'campaignUid'
 *   },
 * });
 */
export function useArchiveEmailMarketingCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEmailMarketingCampaignMutation, ArchiveEmailMarketingCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEmailMarketingCampaignMutation, ArchiveEmailMarketingCampaignMutationVariables>(ArchiveEmailMarketingCampaignDocument, options);
      }
export type ArchiveEmailMarketingCampaignMutationHookResult = ReturnType<typeof useArchiveEmailMarketingCampaignMutation>;
export type ArchiveEmailMarketingCampaignMutationResult = Apollo.MutationResult<ArchiveEmailMarketingCampaignMutation>;
export type ArchiveEmailMarketingCampaignMutationOptions = Apollo.BaseMutationOptions<ArchiveEmailMarketingCampaignMutation, ArchiveEmailMarketingCampaignMutationVariables>;
export const CampaignDocument = gql`
    query Campaign($campaignId: ID!) {
  campaign(uid: $campaignId) {
    ...CampaignDetails
  }
}
    ${CampaignDetailsFragmentDoc}`;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const CampaignEditContentDocument = gql`
    query CampaignEditContent($campaignId: ID!) {
  campaign(uid: $campaignId) {
    id
    title
    templateJson
    status
    recipientList {
      id
    }
  }
}
    `;

/**
 * __useCampaignEditContentQuery__
 *
 * To run a query within a React component, call `useCampaignEditContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignEditContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignEditContentQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignEditContentQuery(baseOptions: Apollo.QueryHookOptions<CampaignEditContentQuery, CampaignEditContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignEditContentQuery, CampaignEditContentQueryVariables>(CampaignEditContentDocument, options);
      }
export function useCampaignEditContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignEditContentQuery, CampaignEditContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignEditContentQuery, CampaignEditContentQueryVariables>(CampaignEditContentDocument, options);
        }
export type CampaignEditContentQueryHookResult = ReturnType<typeof useCampaignEditContentQuery>;
export type CampaignEditContentLazyQueryHookResult = ReturnType<typeof useCampaignEditContentLazyQuery>;
export type CampaignEditContentQueryResult = Apollo.QueryResult<CampaignEditContentQuery, CampaignEditContentQueryVariables>;
export const CampaignLinksDocument = gql`
    query CampaignLinks($campaignId: ID!) {
  campaignLinks(campaignId: $campaignId)
}
    `;

/**
 * __useCampaignLinksQuery__
 *
 * To run a query within a React component, call `useCampaignLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignLinksQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignLinksQuery(baseOptions: Apollo.QueryHookOptions<CampaignLinksQuery, CampaignLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignLinksQuery, CampaignLinksQueryVariables>(CampaignLinksDocument, options);
      }
export function useCampaignLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignLinksQuery, CampaignLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignLinksQuery, CampaignLinksQueryVariables>(CampaignLinksDocument, options);
        }
export type CampaignLinksQueryHookResult = ReturnType<typeof useCampaignLinksQuery>;
export type CampaignLinksLazyQueryHookResult = ReturnType<typeof useCampaignLinksLazyQuery>;
export type CampaignLinksQueryResult = Apollo.QueryResult<CampaignLinksQuery, CampaignLinksQueryVariables>;
export const CampaignsDocument = gql`
    query Campaigns($filter: ProjectCampaignsFilter!) {
  campaigns(filter: $filter) {
    entries {
      ...CampaignInfo
    }
  }
}
    ${CampaignInfoFragmentDoc}`;

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const CloneEmailMarketingCampaignDocument = gql`
    mutation CloneEmailMarketingCampaign($campaignId: ID!, $includeProject: Boolean) {
  result: cloneEmailMarketingCampaign(
    uid: $campaignId
    includeProject: $includeProject
  ) {
    failReasons
    clonedCampaign {
      ...CampaignDetails
    }
  }
}
    ${CampaignDetailsFragmentDoc}`;
export type CloneEmailMarketingCampaignMutationFn = Apollo.MutationFunction<CloneEmailMarketingCampaignMutation, CloneEmailMarketingCampaignMutationVariables>;

/**
 * __useCloneEmailMarketingCampaignMutation__
 *
 * To run a mutation, you first call `useCloneEmailMarketingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneEmailMarketingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneEmailMarketingCampaignMutation, { data, loading, error }] = useCloneEmailMarketingCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      includeProject: // value for 'includeProject'
 *   },
 * });
 */
export function useCloneEmailMarketingCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CloneEmailMarketingCampaignMutation, CloneEmailMarketingCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneEmailMarketingCampaignMutation, CloneEmailMarketingCampaignMutationVariables>(CloneEmailMarketingCampaignDocument, options);
      }
export type CloneEmailMarketingCampaignMutationHookResult = ReturnType<typeof useCloneEmailMarketingCampaignMutation>;
export type CloneEmailMarketingCampaignMutationResult = Apollo.MutationResult<CloneEmailMarketingCampaignMutation>;
export type CloneEmailMarketingCampaignMutationOptions = Apollo.BaseMutationOptions<CloneEmailMarketingCampaignMutation, CloneEmailMarketingCampaignMutationVariables>;
export const EmailMarketingCampaignRecipientsDocument = gql`
    query EmailMarketingCampaignRecipients($campaignUid: ID!, $page: Int, $perPage: Int, $filter: CampaignRecipientsFilterInput) {
  emailMarketingCampaignRecipients(
    campaignUid: $campaignUid
    page: $page
    perPage: $perPage
    filter: $filter
  ) {
    entries {
      ...CampaignRecipient
    }
    pageInfo {
      totalPages
      totalEntries
    }
  }
}
    ${CampaignRecipientFragmentDoc}`;

/**
 * __useEmailMarketingCampaignRecipientsQuery__
 *
 * To run a query within a React component, call `useEmailMarketingCampaignRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingCampaignRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingCampaignRecipientsQuery({
 *   variables: {
 *      campaignUid: // value for 'campaignUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmailMarketingCampaignRecipientsQuery(baseOptions: Apollo.QueryHookOptions<EmailMarketingCampaignRecipientsQuery, EmailMarketingCampaignRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingCampaignRecipientsQuery, EmailMarketingCampaignRecipientsQueryVariables>(EmailMarketingCampaignRecipientsDocument, options);
      }
export function useEmailMarketingCampaignRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingCampaignRecipientsQuery, EmailMarketingCampaignRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingCampaignRecipientsQuery, EmailMarketingCampaignRecipientsQueryVariables>(EmailMarketingCampaignRecipientsDocument, options);
        }
export type EmailMarketingCampaignRecipientsQueryHookResult = ReturnType<typeof useEmailMarketingCampaignRecipientsQuery>;
export type EmailMarketingCampaignRecipientsLazyQueryHookResult = ReturnType<typeof useEmailMarketingCampaignRecipientsLazyQuery>;
export type EmailMarketingCampaignRecipientsQueryResult = Apollo.QueryResult<EmailMarketingCampaignRecipientsQuery, EmailMarketingCampaignRecipientsQueryVariables>;
export const EmailMarketingConfigurationDocument = gql`
    query EmailMarketingConfiguration {
  emailMarketingConfiguration {
    enabled
    id
  }
}
    `;

/**
 * __useEmailMarketingConfigurationQuery__
 *
 * To run a query within a React component, call `useEmailMarketingConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailMarketingConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<EmailMarketingConfigurationQuery, EmailMarketingConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingConfigurationQuery, EmailMarketingConfigurationQueryVariables>(EmailMarketingConfigurationDocument, options);
      }
export function useEmailMarketingConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingConfigurationQuery, EmailMarketingConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingConfigurationQuery, EmailMarketingConfigurationQueryVariables>(EmailMarketingConfigurationDocument, options);
        }
export type EmailMarketingConfigurationQueryHookResult = ReturnType<typeof useEmailMarketingConfigurationQuery>;
export type EmailMarketingConfigurationLazyQueryHookResult = ReturnType<typeof useEmailMarketingConfigurationLazyQuery>;
export type EmailMarketingConfigurationQueryResult = Apollo.QueryResult<EmailMarketingConfigurationQuery, EmailMarketingConfigurationQueryVariables>;
export const EmailMarketingRecipientWarningsDocument = gql`
    query EmailMarketingRecipientWarnings($contactListUid: ID!) {
  result: emailMarketingRecipientWarnings(contactListUid: $contactListUid) {
    ...RecipientWarnings
  }
}
    ${RecipientWarningsFragmentDoc}`;

/**
 * __useEmailMarketingRecipientWarningsQuery__
 *
 * To run a query within a React component, call `useEmailMarketingRecipientWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingRecipientWarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingRecipientWarningsQuery({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *   },
 * });
 */
export function useEmailMarketingRecipientWarningsQuery(baseOptions: Apollo.QueryHookOptions<EmailMarketingRecipientWarningsQuery, EmailMarketingRecipientWarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingRecipientWarningsQuery, EmailMarketingRecipientWarningsQueryVariables>(EmailMarketingRecipientWarningsDocument, options);
      }
export function useEmailMarketingRecipientWarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingRecipientWarningsQuery, EmailMarketingRecipientWarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingRecipientWarningsQuery, EmailMarketingRecipientWarningsQueryVariables>(EmailMarketingRecipientWarningsDocument, options);
        }
export type EmailMarketingRecipientWarningsQueryHookResult = ReturnType<typeof useEmailMarketingRecipientWarningsQuery>;
export type EmailMarketingRecipientWarningsLazyQueryHookResult = ReturnType<typeof useEmailMarketingRecipientWarningsLazyQuery>;
export type EmailMarketingRecipientWarningsQueryResult = Apollo.QueryResult<EmailMarketingRecipientWarningsQuery, EmailMarketingRecipientWarningsQueryVariables>;
export const EmailMarketingTemplatesDocument = gql`
    query EmailMarketingTemplates {
  emailMarketingTemplatesV2(filter: {status: ACTIVE}) {
    entries {
      ...EmailTemplate
    }
  }
}
    ${EmailTemplateFragmentDoc}`;

/**
 * __useEmailMarketingTemplatesQuery__
 *
 * To run a query within a React component, call `useEmailMarketingTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailMarketingTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<EmailMarketingTemplatesQuery, EmailMarketingTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingTemplatesQuery, EmailMarketingTemplatesQueryVariables>(EmailMarketingTemplatesDocument, options);
      }
export function useEmailMarketingTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingTemplatesQuery, EmailMarketingTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingTemplatesQuery, EmailMarketingTemplatesQueryVariables>(EmailMarketingTemplatesDocument, options);
        }
export type EmailMarketingTemplatesQueryHookResult = ReturnType<typeof useEmailMarketingTemplatesQuery>;
export type EmailMarketingTemplatesLazyQueryHookResult = ReturnType<typeof useEmailMarketingTemplatesLazyQuery>;
export type EmailMarketingTemplatesQueryResult = Apollo.QueryResult<EmailMarketingTemplatesQuery, EmailMarketingTemplatesQueryVariables>;
export const EmsCampaignUpdateDocument = gql`
    query EmsCampaignUpdate {
  emailMarketingConfiguration {
    id
    senders {
      ...SendersAutocompleteField
    }
  }
}
    ${SendersAutocompleteFieldFragmentDoc}`;

/**
 * __useEmsCampaignUpdateQuery__
 *
 * To run a query within a React component, call `useEmsCampaignUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmsCampaignUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmsCampaignUpdateQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmsCampaignUpdateQuery(baseOptions?: Apollo.QueryHookOptions<EmsCampaignUpdateQuery, EmsCampaignUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmsCampaignUpdateQuery, EmsCampaignUpdateQueryVariables>(EmsCampaignUpdateDocument, options);
      }
export function useEmsCampaignUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmsCampaignUpdateQuery, EmsCampaignUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmsCampaignUpdateQuery, EmsCampaignUpdateQueryVariables>(EmsCampaignUpdateDocument, options);
        }
export type EmsCampaignUpdateQueryHookResult = ReturnType<typeof useEmsCampaignUpdateQuery>;
export type EmsCampaignUpdateLazyQueryHookResult = ReturnType<typeof useEmsCampaignUpdateLazyQuery>;
export type EmsCampaignUpdateQueryResult = Apollo.QueryResult<EmsCampaignUpdateQuery, EmsCampaignUpdateQueryVariables>;
export const ExportEmailMarketingCampaignRecipientsDocument = gql`
    mutation ExportEmailMarketingCampaignRecipients($campaignUid: String) {
  exportEmailMarketingCampaignRecipients(campaignUid: $campaignUid) {
    export {
      id
    }
    failReasons
  }
}
    `;
export type ExportEmailMarketingCampaignRecipientsMutationFn = Apollo.MutationFunction<ExportEmailMarketingCampaignRecipientsMutation, ExportEmailMarketingCampaignRecipientsMutationVariables>;

/**
 * __useExportEmailMarketingCampaignRecipientsMutation__
 *
 * To run a mutation, you first call `useExportEmailMarketingCampaignRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEmailMarketingCampaignRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEmailMarketingCampaignRecipientsMutation, { data, loading, error }] = useExportEmailMarketingCampaignRecipientsMutation({
 *   variables: {
 *      campaignUid: // value for 'campaignUid'
 *   },
 * });
 */
export function useExportEmailMarketingCampaignRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<ExportEmailMarketingCampaignRecipientsMutation, ExportEmailMarketingCampaignRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEmailMarketingCampaignRecipientsMutation, ExportEmailMarketingCampaignRecipientsMutationVariables>(ExportEmailMarketingCampaignRecipientsDocument, options);
      }
export type ExportEmailMarketingCampaignRecipientsMutationHookResult = ReturnType<typeof useExportEmailMarketingCampaignRecipientsMutation>;
export type ExportEmailMarketingCampaignRecipientsMutationResult = Apollo.MutationResult<ExportEmailMarketingCampaignRecipientsMutation>;
export type ExportEmailMarketingCampaignRecipientsMutationOptions = Apollo.BaseMutationOptions<ExportEmailMarketingCampaignRecipientsMutation, ExportEmailMarketingCampaignRecipientsMutationVariables>;
export const SaveCampaignAsTemplateDocument = gql`
    mutation SaveCampaignAsTemplate($uid: ID!, $templateTitle: String!) {
  saveCampaignAsTemplate(uid: $uid, templateTitle: $templateTitle) {
    createdTemplate {
      id
      title
      templateHtml
    }
    failReasons
  }
}
    `;
export type SaveCampaignAsTemplateMutationFn = Apollo.MutationFunction<SaveCampaignAsTemplateMutation, SaveCampaignAsTemplateMutationVariables>;

/**
 * __useSaveCampaignAsTemplateMutation__
 *
 * To run a mutation, you first call `useSaveCampaignAsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCampaignAsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCampaignAsTemplateMutation, { data, loading, error }] = useSaveCampaignAsTemplateMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      templateTitle: // value for 'templateTitle'
 *   },
 * });
 */
export function useSaveCampaignAsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveCampaignAsTemplateMutation, SaveCampaignAsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCampaignAsTemplateMutation, SaveCampaignAsTemplateMutationVariables>(SaveCampaignAsTemplateDocument, options);
      }
export type SaveCampaignAsTemplateMutationHookResult = ReturnType<typeof useSaveCampaignAsTemplateMutation>;
export type SaveCampaignAsTemplateMutationResult = Apollo.MutationResult<SaveCampaignAsTemplateMutation>;
export type SaveCampaignAsTemplateMutationOptions = Apollo.BaseMutationOptions<SaveCampaignAsTemplateMutation, SaveCampaignAsTemplateMutationVariables>;
export const SaveCampaignRecipientListFilterDocument = gql`
    mutation SaveCampaignRecipientListFilter($input: CampaignRecipientListFilterInput!) {
  saveCampaignRecipientListFilter(input: $input) {
    campaignRecipientListFilter {
      ...RecipientListFilter
    }
    failReasons
  }
}
    ${RecipientListFilterFragmentDoc}`;
export type SaveCampaignRecipientListFilterMutationFn = Apollo.MutationFunction<SaveCampaignRecipientListFilterMutation, SaveCampaignRecipientListFilterMutationVariables>;

/**
 * __useSaveCampaignRecipientListFilterMutation__
 *
 * To run a mutation, you first call `useSaveCampaignRecipientListFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCampaignRecipientListFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCampaignRecipientListFilterMutation, { data, loading, error }] = useSaveCampaignRecipientListFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCampaignRecipientListFilterMutation(baseOptions?: Apollo.MutationHookOptions<SaveCampaignRecipientListFilterMutation, SaveCampaignRecipientListFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCampaignRecipientListFilterMutation, SaveCampaignRecipientListFilterMutationVariables>(SaveCampaignRecipientListFilterDocument, options);
      }
export type SaveCampaignRecipientListFilterMutationHookResult = ReturnType<typeof useSaveCampaignRecipientListFilterMutation>;
export type SaveCampaignRecipientListFilterMutationResult = Apollo.MutationResult<SaveCampaignRecipientListFilterMutation>;
export type SaveCampaignRecipientListFilterMutationOptions = Apollo.BaseMutationOptions<SaveCampaignRecipientListFilterMutation, SaveCampaignRecipientListFilterMutationVariables>;
export const ScheduleEmailMarketingCampaignDocument = gql`
    mutation ScheduleEmailMarketingCampaign($uid: ID!, $scheduledAt: ISO8601DateTime!) {
  result: scheduleEmailMarketingCampaign(uid: $uid, scheduledAt: $scheduledAt) {
    failReasons
    scheduledCampaign {
      id
      status
      scheduledAt
    }
  }
}
    `;
export type ScheduleEmailMarketingCampaignMutationFn = Apollo.MutationFunction<ScheduleEmailMarketingCampaignMutation, ScheduleEmailMarketingCampaignMutationVariables>;

/**
 * __useScheduleEmailMarketingCampaignMutation__
 *
 * To run a mutation, you first call `useScheduleEmailMarketingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleEmailMarketingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleEmailMarketingCampaignMutation, { data, loading, error }] = useScheduleEmailMarketingCampaignMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      scheduledAt: // value for 'scheduledAt'
 *   },
 * });
 */
export function useScheduleEmailMarketingCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleEmailMarketingCampaignMutation, ScheduleEmailMarketingCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleEmailMarketingCampaignMutation, ScheduleEmailMarketingCampaignMutationVariables>(ScheduleEmailMarketingCampaignDocument, options);
      }
export type ScheduleEmailMarketingCampaignMutationHookResult = ReturnType<typeof useScheduleEmailMarketingCampaignMutation>;
export type ScheduleEmailMarketingCampaignMutationResult = Apollo.MutationResult<ScheduleEmailMarketingCampaignMutation>;
export type ScheduleEmailMarketingCampaignMutationOptions = Apollo.BaseMutationOptions<ScheduleEmailMarketingCampaignMutation, ScheduleEmailMarketingCampaignMutationVariables>;
export const SendEmailMarketingTestEmailDocument = gql`
    mutation SendEmailMarketingTestEmail($campaignUid: ID!, $recipientEmail: String!) {
  result: sendEmailMarketingTestEmail(
    campaignUid: $campaignUid
    recipientEmail: $recipientEmail
  ) {
    failReasons
  }
}
    `;
export type SendEmailMarketingTestEmailMutationFn = Apollo.MutationFunction<SendEmailMarketingTestEmailMutation, SendEmailMarketingTestEmailMutationVariables>;

/**
 * __useSendEmailMarketingTestEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailMarketingTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMarketingTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMarketingTestEmailMutation, { data, loading, error }] = useSendEmailMarketingTestEmailMutation({
 *   variables: {
 *      campaignUid: // value for 'campaignUid'
 *      recipientEmail: // value for 'recipientEmail'
 *   },
 * });
 */
export function useSendEmailMarketingTestEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailMarketingTestEmailMutation, SendEmailMarketingTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailMarketingTestEmailMutation, SendEmailMarketingTestEmailMutationVariables>(SendEmailMarketingTestEmailDocument, options);
      }
export type SendEmailMarketingTestEmailMutationHookResult = ReturnType<typeof useSendEmailMarketingTestEmailMutation>;
export type SendEmailMarketingTestEmailMutationResult = Apollo.MutationResult<SendEmailMarketingTestEmailMutation>;
export type SendEmailMarketingTestEmailMutationOptions = Apollo.BaseMutationOptions<SendEmailMarketingTestEmailMutation, SendEmailMarketingTestEmailMutationVariables>;
export const UpdateEmailMarketingCampaignDocument = gql`
    mutation UpdateEmailMarketingCampaign($uid: ID!, $title: String, $subject: String, $continuous: Boolean, $recipientListId: ID, $templateJson: String, $senderID: ID) {
  result: updateEmailMarketingCampaign(
    uid: $uid
    title: $title
    subject: $subject
    continuous: $continuous
    recipientListId: $recipientListId
    templateJson: $templateJson
    senderId: $senderID
  ) {
    updatedCampaign {
      ...CampaignDetails
    }
    failReasons
  }
}
    ${CampaignDetailsFragmentDoc}`;
export type UpdateEmailMarketingCampaignMutationFn = Apollo.MutationFunction<UpdateEmailMarketingCampaignMutation, UpdateEmailMarketingCampaignMutationVariables>;

/**
 * __useUpdateEmailMarketingCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMarketingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMarketingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMarketingCampaignMutation, { data, loading, error }] = useUpdateEmailMarketingCampaignMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      title: // value for 'title'
 *      subject: // value for 'subject'
 *      continuous: // value for 'continuous'
 *      recipientListId: // value for 'recipientListId'
 *      templateJson: // value for 'templateJson'
 *      senderID: // value for 'senderID'
 *   },
 * });
 */
export function useUpdateEmailMarketingCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMarketingCampaignMutation, UpdateEmailMarketingCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMarketingCampaignMutation, UpdateEmailMarketingCampaignMutationVariables>(UpdateEmailMarketingCampaignDocument, options);
      }
export type UpdateEmailMarketingCampaignMutationHookResult = ReturnType<typeof useUpdateEmailMarketingCampaignMutation>;
export type UpdateEmailMarketingCampaignMutationResult = Apollo.MutationResult<UpdateEmailMarketingCampaignMutation>;
export type UpdateEmailMarketingCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMarketingCampaignMutation, UpdateEmailMarketingCampaignMutationVariables>;
export const UpdateEmailMarketingCampaignEmailDocument = gql`
    mutation UpdateEmailMarketingCampaignEmail($uid: ID!, $templateJson: String) {
  result: updateEmailMarketingCampaign(uid: $uid, templateJson: $templateJson) {
    updatedCampaign {
      ...CampaignDetails
    }
    failReasons
  }
}
    ${CampaignDetailsFragmentDoc}`;
export type UpdateEmailMarketingCampaignEmailMutationFn = Apollo.MutationFunction<UpdateEmailMarketingCampaignEmailMutation, UpdateEmailMarketingCampaignEmailMutationVariables>;

/**
 * __useUpdateEmailMarketingCampaignEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMarketingCampaignEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMarketingCampaignEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMarketingCampaignEmailMutation, { data, loading, error }] = useUpdateEmailMarketingCampaignEmailMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      templateJson: // value for 'templateJson'
 *   },
 * });
 */
export function useUpdateEmailMarketingCampaignEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMarketingCampaignEmailMutation, UpdateEmailMarketingCampaignEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMarketingCampaignEmailMutation, UpdateEmailMarketingCampaignEmailMutationVariables>(UpdateEmailMarketingCampaignEmailDocument, options);
      }
export type UpdateEmailMarketingCampaignEmailMutationHookResult = ReturnType<typeof useUpdateEmailMarketingCampaignEmailMutation>;
export type UpdateEmailMarketingCampaignEmailMutationResult = Apollo.MutationResult<UpdateEmailMarketingCampaignEmailMutation>;
export type UpdateEmailMarketingCampaignEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMarketingCampaignEmailMutation, UpdateEmailMarketingCampaignEmailMutationVariables>;
export const AddEmailMarketingCampaignAttachmentDocument = gql`
    mutation AddEmailMarketingCampaignAttachment($uid: ID!, $file: String!) {
  addEmailMarketingCampaignAttachment(uid: $uid, file: $file) {
    failReasons
    campaign {
      ...CampaignDetails
    }
  }
}
    ${CampaignDetailsFragmentDoc}`;
export type AddEmailMarketingCampaignAttachmentMutationFn = Apollo.MutationFunction<AddEmailMarketingCampaignAttachmentMutation, AddEmailMarketingCampaignAttachmentMutationVariables>;

/**
 * __useAddEmailMarketingCampaignAttachmentMutation__
 *
 * To run a mutation, you first call `useAddEmailMarketingCampaignAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailMarketingCampaignAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailMarketingCampaignAttachmentMutation, { data, loading, error }] = useAddEmailMarketingCampaignAttachmentMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useAddEmailMarketingCampaignAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<AddEmailMarketingCampaignAttachmentMutation, AddEmailMarketingCampaignAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmailMarketingCampaignAttachmentMutation, AddEmailMarketingCampaignAttachmentMutationVariables>(AddEmailMarketingCampaignAttachmentDocument, options);
      }
export type AddEmailMarketingCampaignAttachmentMutationHookResult = ReturnType<typeof useAddEmailMarketingCampaignAttachmentMutation>;
export type AddEmailMarketingCampaignAttachmentMutationResult = Apollo.MutationResult<AddEmailMarketingCampaignAttachmentMutation>;
export type AddEmailMarketingCampaignAttachmentMutationOptions = Apollo.BaseMutationOptions<AddEmailMarketingCampaignAttachmentMutation, AddEmailMarketingCampaignAttachmentMutationVariables>;
export const DeleteEmailMarketingCampaignAttachmentDocument = gql`
    mutation DeleteEmailMarketingCampaignAttachment($uid: ID!) {
  deleteEmailMarketingCampaignAttachment(uid: $uid) {
    failReasons
    campaign {
      ...CampaignDetails
    }
  }
}
    ${CampaignDetailsFragmentDoc}`;
export type DeleteEmailMarketingCampaignAttachmentMutationFn = Apollo.MutationFunction<DeleteEmailMarketingCampaignAttachmentMutation, DeleteEmailMarketingCampaignAttachmentMutationVariables>;

/**
 * __useDeleteEmailMarketingCampaignAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteEmailMarketingCampaignAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailMarketingCampaignAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailMarketingCampaignAttachmentMutation, { data, loading, error }] = useDeleteEmailMarketingCampaignAttachmentMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useDeleteEmailMarketingCampaignAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailMarketingCampaignAttachmentMutation, DeleteEmailMarketingCampaignAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailMarketingCampaignAttachmentMutation, DeleteEmailMarketingCampaignAttachmentMutationVariables>(DeleteEmailMarketingCampaignAttachmentDocument, options);
      }
export type DeleteEmailMarketingCampaignAttachmentMutationHookResult = ReturnType<typeof useDeleteEmailMarketingCampaignAttachmentMutation>;
export type DeleteEmailMarketingCampaignAttachmentMutationResult = Apollo.MutationResult<DeleteEmailMarketingCampaignAttachmentMutation>;
export type DeleteEmailMarketingCampaignAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteEmailMarketingCampaignAttachmentMutation, DeleteEmailMarketingCampaignAttachmentMutationVariables>;
export const EmailMarketingFormUrlDocument = gql`
    query EmailMarketingFormUrl($uid: ID!, $formSettings: FormSettings!) {
  emailMarketingFormUrl(uid: $uid, formSettings: $formSettings)
}
    `;

/**
 * __useEmailMarketingFormUrlQuery__
 *
 * To run a query within a React component, call `useEmailMarketingFormUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingFormUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingFormUrlQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      formSettings: // value for 'formSettings'
 *   },
 * });
 */
export function useEmailMarketingFormUrlQuery(baseOptions: Apollo.QueryHookOptions<EmailMarketingFormUrlQuery, EmailMarketingFormUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingFormUrlQuery, EmailMarketingFormUrlQueryVariables>(EmailMarketingFormUrlDocument, options);
      }
export function useEmailMarketingFormUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingFormUrlQuery, EmailMarketingFormUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingFormUrlQuery, EmailMarketingFormUrlQueryVariables>(EmailMarketingFormUrlDocument, options);
        }
export type EmailMarketingFormUrlQueryHookResult = ReturnType<typeof useEmailMarketingFormUrlQuery>;
export type EmailMarketingFormUrlLazyQueryHookResult = ReturnType<typeof useEmailMarketingFormUrlLazyQuery>;
export type EmailMarketingFormUrlQueryResult = Apollo.QueryResult<EmailMarketingFormUrlQuery, EmailMarketingFormUrlQueryVariables>;
export const EmailMarketingProjectFormsDocument = gql`
    query EmailMarketingProjectForms($uid: ID!, $term: String) {
  emailMarketingProjectForms(uid: $uid, term: $term, page: 1, perPage: 10) {
    entries {
      ...ProjectFormOption
    }
  }
}
    ${ProjectFormOptionFragmentDoc}`;

/**
 * __useEmailMarketingProjectFormsQuery__
 *
 * To run a query within a React component, call `useEmailMarketingProjectFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingProjectFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingProjectFormsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useEmailMarketingProjectFormsQuery(baseOptions: Apollo.QueryHookOptions<EmailMarketingProjectFormsQuery, EmailMarketingProjectFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingProjectFormsQuery, EmailMarketingProjectFormsQueryVariables>(EmailMarketingProjectFormsDocument, options);
      }
export function useEmailMarketingProjectFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingProjectFormsQuery, EmailMarketingProjectFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingProjectFormsQuery, EmailMarketingProjectFormsQueryVariables>(EmailMarketingProjectFormsDocument, options);
        }
export type EmailMarketingProjectFormsQueryHookResult = ReturnType<typeof useEmailMarketingProjectFormsQuery>;
export type EmailMarketingProjectFormsLazyQueryHookResult = ReturnType<typeof useEmailMarketingProjectFormsLazyQuery>;
export type EmailMarketingProjectFormsQueryResult = Apollo.QueryResult<EmailMarketingProjectFormsQuery, EmailMarketingProjectFormsQueryVariables>;
export const EmailMarketingListMergeTagsDocument = gql`
    query EmailMarketingListMergeTags($uid: String) {
  emailMarketingListMergeTags(uid: $uid) {
    name
    value
  }
}
    `;

/**
 * __useEmailMarketingListMergeTagsQuery__
 *
 * To run a query within a React component, call `useEmailMarketingListMergeTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingListMergeTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingListMergeTagsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useEmailMarketingListMergeTagsQuery(baseOptions?: Apollo.QueryHookOptions<EmailMarketingListMergeTagsQuery, EmailMarketingListMergeTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingListMergeTagsQuery, EmailMarketingListMergeTagsQueryVariables>(EmailMarketingListMergeTagsDocument, options);
      }
export function useEmailMarketingListMergeTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingListMergeTagsQuery, EmailMarketingListMergeTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingListMergeTagsQuery, EmailMarketingListMergeTagsQueryVariables>(EmailMarketingListMergeTagsDocument, options);
        }
export type EmailMarketingListMergeTagsQueryHookResult = ReturnType<typeof useEmailMarketingListMergeTagsQuery>;
export type EmailMarketingListMergeTagsLazyQueryHookResult = ReturnType<typeof useEmailMarketingListMergeTagsLazyQuery>;
export type EmailMarketingListMergeTagsQueryResult = Apollo.QueryResult<EmailMarketingListMergeTagsQuery, EmailMarketingListMergeTagsQueryVariables>;
export const EmailMarketingListsDocument = gql`
    query EmailMarketingLists($term: String, $projectUuid: ID, $orderBy: ListsOrderBy, $page: Int, $perPage: Int) {
  result: emailMarketingLists(
    filter: {term: $term}
    orderBy: $orderBy
    projectUuid: $projectUuid
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...RecipientListOption
    }
    pageInfo {
      totalEntries
      totalPages
    }
  }
}
    ${RecipientListOptionFragmentDoc}`;

/**
 * __useEmailMarketingListsQuery__
 *
 * To run a query within a React component, call `useEmailMarketingListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingListsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      projectUuid: // value for 'projectUuid'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useEmailMarketingListsQuery(baseOptions?: Apollo.QueryHookOptions<EmailMarketingListsQuery, EmailMarketingListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingListsQuery, EmailMarketingListsQueryVariables>(EmailMarketingListsDocument, options);
      }
export function useEmailMarketingListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingListsQuery, EmailMarketingListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingListsQuery, EmailMarketingListsQueryVariables>(EmailMarketingListsDocument, options);
        }
export type EmailMarketingListsQueryHookResult = ReturnType<typeof useEmailMarketingListsQuery>;
export type EmailMarketingListsLazyQueryHookResult = ReturnType<typeof useEmailMarketingListsLazyQuery>;
export type EmailMarketingListsQueryResult = Apollo.QueryResult<EmailMarketingListsQuery, EmailMarketingListsQueryVariables>;
export const CreateEmailMarketingCampaignDocument = gql`
    mutation CreateEmailMarketingCampaign($title: String!) {
  createEmailMarketingCampaign(title: $title) {
    failReasons
    campaign {
      id
      title
    }
  }
}
    `;
export type CreateEmailMarketingCampaignMutationFn = Apollo.MutationFunction<CreateEmailMarketingCampaignMutation, CreateEmailMarketingCampaignMutationVariables>;

/**
 * __useCreateEmailMarketingCampaignMutation__
 *
 * To run a mutation, you first call `useCreateEmailMarketingCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailMarketingCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailMarketingCampaignMutation, { data, loading, error }] = useCreateEmailMarketingCampaignMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateEmailMarketingCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailMarketingCampaignMutation, CreateEmailMarketingCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailMarketingCampaignMutation, CreateEmailMarketingCampaignMutationVariables>(CreateEmailMarketingCampaignDocument, options);
      }
export type CreateEmailMarketingCampaignMutationHookResult = ReturnType<typeof useCreateEmailMarketingCampaignMutation>;
export type CreateEmailMarketingCampaignMutationResult = Apollo.MutationResult<CreateEmailMarketingCampaignMutation>;
export type CreateEmailMarketingCampaignMutationOptions = Apollo.BaseMutationOptions<CreateEmailMarketingCampaignMutation, CreateEmailMarketingCampaignMutationVariables>;
export const EmailMarketingCampaignsDocument = gql`
    query EmailMarketingCampaigns($page: Int, $perPage: Int, $filter: CampaignsFilterInput) {
  emailMarketingCampaigns(page: $page, perPage: $perPage, filter: $filter) {
    entries {
      ...CampaignRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CampaignRowFragmentDoc}`;

/**
 * __useEmailMarketingCampaignsQuery__
 *
 * To run a query within a React component, call `useEmailMarketingCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingCampaignsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmailMarketingCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<EmailMarketingCampaignsQuery, EmailMarketingCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingCampaignsQuery, EmailMarketingCampaignsQueryVariables>(EmailMarketingCampaignsDocument, options);
      }
export function useEmailMarketingCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingCampaignsQuery, EmailMarketingCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingCampaignsQuery, EmailMarketingCampaignsQueryVariables>(EmailMarketingCampaignsDocument, options);
        }
export type EmailMarketingCampaignsQueryHookResult = ReturnType<typeof useEmailMarketingCampaignsQuery>;
export type EmailMarketingCampaignsLazyQueryHookResult = ReturnType<typeof useEmailMarketingCampaignsLazyQuery>;
export type EmailMarketingCampaignsQueryResult = Apollo.QueryResult<EmailMarketingCampaignsQuery, EmailMarketingCampaignsQueryVariables>;
export const RenameCampaignDocument = gql`
    mutation RenameCampaign($uid: ID!, $title: String) {
  updateEmailMarketingCampaign(uid: $uid, title: $title) {
    failReasons
    updatedCampaign {
      id
      title
    }
  }
}
    `;
export type RenameCampaignMutationFn = Apollo.MutationFunction<RenameCampaignMutation, RenameCampaignMutationVariables>;

/**
 * __useRenameCampaignMutation__
 *
 * To run a mutation, you first call `useRenameCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameCampaignMutation, { data, loading, error }] = useRenameCampaignMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRenameCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RenameCampaignMutation, RenameCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameCampaignMutation, RenameCampaignMutationVariables>(RenameCampaignDocument, options);
      }
export type RenameCampaignMutationHookResult = ReturnType<typeof useRenameCampaignMutation>;
export type RenameCampaignMutationResult = Apollo.MutationResult<RenameCampaignMutation>;
export type RenameCampaignMutationOptions = Apollo.BaseMutationOptions<RenameCampaignMutation, RenameCampaignMutationVariables>;
export const CancelScheduledCampaignDocument = gql`
    mutation CancelScheduledCampaign($uid: ID!) {
  cancelScheduledEmailMarketingCampaign(uid: $uid) {
    failReasons
    campaign {
      id
    }
  }
}
    `;
export type CancelScheduledCampaignMutationFn = Apollo.MutationFunction<CancelScheduledCampaignMutation, CancelScheduledCampaignMutationVariables>;

/**
 * __useCancelScheduledCampaignMutation__
 *
 * To run a mutation, you first call `useCancelScheduledCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledCampaignMutation, { data, loading, error }] = useCancelScheduledCampaignMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCancelScheduledCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CancelScheduledCampaignMutation, CancelScheduledCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScheduledCampaignMutation, CancelScheduledCampaignMutationVariables>(CancelScheduledCampaignDocument, options);
      }
export type CancelScheduledCampaignMutationHookResult = ReturnType<typeof useCancelScheduledCampaignMutation>;
export type CancelScheduledCampaignMutationResult = Apollo.MutationResult<CancelScheduledCampaignMutation>;
export type CancelScheduledCampaignMutationOptions = Apollo.BaseMutationOptions<CancelScheduledCampaignMutation, CancelScheduledCampaignMutationVariables>;
export const SendNowDocument = gql`
    mutation SendNow($uid: ID!, $scheduledAt: ISO8601DateTime!) {
  scheduleEmailMarketingCampaign(uid: $uid, scheduledAt: $scheduledAt) {
    failReasons
    scheduledCampaign {
      id
      status
      scheduledAt
    }
  }
}
    `;
export type SendNowMutationFn = Apollo.MutationFunction<SendNowMutation, SendNowMutationVariables>;

/**
 * __useSendNowMutation__
 *
 * To run a mutation, you first call `useSendNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNowMutation, { data, loading, error }] = useSendNowMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      scheduledAt: // value for 'scheduledAt'
 *   },
 * });
 */
export function useSendNowMutation(baseOptions?: Apollo.MutationHookOptions<SendNowMutation, SendNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNowMutation, SendNowMutationVariables>(SendNowDocument, options);
      }
export type SendNowMutationHookResult = ReturnType<typeof useSendNowMutation>;
export type SendNowMutationResult = Apollo.MutationResult<SendNowMutation>;
export type SendNowMutationOptions = Apollo.BaseMutationOptions<SendNowMutation, SendNowMutationVariables>;
export const CreatedByIdFieldDocument = gql`
    query CreatedByIdField {
  users(page: 1, perPage: 1000) {
    entries {
      ...CreatedByIdFieldOption
    }
  }
}
    ${CreatedByIdFieldOptionFragmentDoc}`;

/**
 * __useCreatedByIdFieldQuery__
 *
 * To run a query within a React component, call `useCreatedByIdFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatedByIdFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedByIdFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreatedByIdFieldQuery(baseOptions?: Apollo.QueryHookOptions<CreatedByIdFieldQuery, CreatedByIdFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatedByIdFieldQuery, CreatedByIdFieldQueryVariables>(CreatedByIdFieldDocument, options);
      }
export function useCreatedByIdFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatedByIdFieldQuery, CreatedByIdFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatedByIdFieldQuery, CreatedByIdFieldQueryVariables>(CreatedByIdFieldDocument, options);
        }
export type CreatedByIdFieldQueryHookResult = ReturnType<typeof useCreatedByIdFieldQuery>;
export type CreatedByIdFieldLazyQueryHookResult = ReturnType<typeof useCreatedByIdFieldLazyQuery>;
export type CreatedByIdFieldQueryResult = Apollo.QueryResult<CreatedByIdFieldQuery, CreatedByIdFieldQueryVariables>;
export const CreatedByIdFieldUserDocument = gql`
    query CreatedByIdFieldUser($uid: ID!) {
  user(uid: $uid) {
    info {
      ...CreatedByIdFieldOption
    }
  }
}
    ${CreatedByIdFieldOptionFragmentDoc}`;

/**
 * __useCreatedByIdFieldUserQuery__
 *
 * To run a query within a React component, call `useCreatedByIdFieldUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatedByIdFieldUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedByIdFieldUserQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCreatedByIdFieldUserQuery(baseOptions: Apollo.QueryHookOptions<CreatedByIdFieldUserQuery, CreatedByIdFieldUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatedByIdFieldUserQuery, CreatedByIdFieldUserQueryVariables>(CreatedByIdFieldUserDocument, options);
      }
export function useCreatedByIdFieldUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatedByIdFieldUserQuery, CreatedByIdFieldUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatedByIdFieldUserQuery, CreatedByIdFieldUserQueryVariables>(CreatedByIdFieldUserDocument, options);
        }
export type CreatedByIdFieldUserQueryHookResult = ReturnType<typeof useCreatedByIdFieldUserQuery>;
export type CreatedByIdFieldUserLazyQueryHookResult = ReturnType<typeof useCreatedByIdFieldUserLazyQuery>;
export type CreatedByIdFieldUserQueryResult = Apollo.QueryResult<CreatedByIdFieldUserQuery, CreatedByIdFieldUserQueryVariables>;
export const WorkspaceIdFieldDocument = gql`
    query WorkspaceIdField {
  apps: projects(nexlApps: true, page: 1, perPage: 1000) {
    entries {
      ...WorkspaceIdFieldOption
    }
  }
  projects(page: 1, perPage: 1000) {
    entries {
      ...WorkspaceIdFieldOption
    }
  }
}
    ${WorkspaceIdFieldOptionFragmentDoc}`;

/**
 * __useWorkspaceIdFieldQuery__
 *
 * To run a query within a React component, call `useWorkspaceIdFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceIdFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceIdFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceIdFieldQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceIdFieldQuery, WorkspaceIdFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceIdFieldQuery, WorkspaceIdFieldQueryVariables>(WorkspaceIdFieldDocument, options);
      }
export function useWorkspaceIdFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceIdFieldQuery, WorkspaceIdFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceIdFieldQuery, WorkspaceIdFieldQueryVariables>(WorkspaceIdFieldDocument, options);
        }
export type WorkspaceIdFieldQueryHookResult = ReturnType<typeof useWorkspaceIdFieldQuery>;
export type WorkspaceIdFieldLazyQueryHookResult = ReturnType<typeof useWorkspaceIdFieldLazyQuery>;
export type WorkspaceIdFieldQueryResult = Apollo.QueryResult<WorkspaceIdFieldQuery, WorkspaceIdFieldQueryVariables>;
export const WorkspaceIdFieldWorkspaceDocument = gql`
    query WorkspaceIdFieldWorkspace($uuid: ID!) {
  project(uuid: $uuid) {
    ...WorkspaceIdFieldOption
  }
}
    ${WorkspaceIdFieldOptionFragmentDoc}`;

/**
 * __useWorkspaceIdFieldWorkspaceQuery__
 *
 * To run a query within a React component, call `useWorkspaceIdFieldWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceIdFieldWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceIdFieldWorkspaceQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useWorkspaceIdFieldWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceIdFieldWorkspaceQuery, WorkspaceIdFieldWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceIdFieldWorkspaceQuery, WorkspaceIdFieldWorkspaceQueryVariables>(WorkspaceIdFieldWorkspaceDocument, options);
      }
export function useWorkspaceIdFieldWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceIdFieldWorkspaceQuery, WorkspaceIdFieldWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceIdFieldWorkspaceQuery, WorkspaceIdFieldWorkspaceQueryVariables>(WorkspaceIdFieldWorkspaceDocument, options);
        }
export type WorkspaceIdFieldWorkspaceQueryHookResult = ReturnType<typeof useWorkspaceIdFieldWorkspaceQuery>;
export type WorkspaceIdFieldWorkspaceLazyQueryHookResult = ReturnType<typeof useWorkspaceIdFieldWorkspaceLazyQuery>;
export type WorkspaceIdFieldWorkspaceQueryResult = Apollo.QueryResult<WorkspaceIdFieldWorkspaceQuery, WorkspaceIdFieldWorkspaceQueryVariables>;
export const ArchiveTemplateDocument = gql`
    mutation ArchiveTemplate($uid: ID!) {
  archiveEmailMarketingTemplate(uid: $uid) {
    failReasons
    template {
      id
    }
  }
}
    `;
export type ArchiveTemplateMutationFn = Apollo.MutationFunction<ArchiveTemplateMutation, ArchiveTemplateMutationVariables>;

/**
 * __useArchiveTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTemplateMutation, { data, loading, error }] = useArchiveTemplateMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useArchiveTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTemplateMutation, ArchiveTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTemplateMutation, ArchiveTemplateMutationVariables>(ArchiveTemplateDocument, options);
      }
export type ArchiveTemplateMutationHookResult = ReturnType<typeof useArchiveTemplateMutation>;
export type ArchiveTemplateMutationResult = Apollo.MutationResult<ArchiveTemplateMutation>;
export type ArchiveTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveTemplateMutation, ArchiveTemplateMutationVariables>;
export const CreateTemplateDocument = gql`
    mutation CreateTemplate($title: String!) {
  createEmailMarketingTemplate(title: $title) {
    failReasons
    template {
      id
      title
      templateJson
    }
  }
}
    `;
export type CreateTemplateMutationFn = Apollo.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = Apollo.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const TemplatesDocument = gql`
    query Templates($page: Int, $perPage: Int, $filter: TemplatesFilterInput) {
  emailMarketingTemplatesV2(page: $page, perPage: $perPage, filter: $filter) {
    entries {
      ...Template
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${TemplateFragmentDoc}`;

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
      }
export function useTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesQueryResult = Apollo.QueryResult<TemplatesQuery, TemplatesQueryVariables>;
export const CloneTemplateDocument = gql`
    mutation CloneTemplate($templateUid: ID!) {
  cloneEmailMarketingTemplate(templateUid: $templateUid) {
    failReasons
    clonedTemplate {
      id
      title
    }
  }
}
    `;
export type CloneTemplateMutationFn = Apollo.MutationFunction<CloneTemplateMutation, CloneTemplateMutationVariables>;

/**
 * __useCloneTemplateMutation__
 *
 * To run a mutation, you first call `useCloneTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneTemplateMutation, { data, loading, error }] = useCloneTemplateMutation({
 *   variables: {
 *      templateUid: // value for 'templateUid'
 *   },
 * });
 */
export function useCloneTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CloneTemplateMutation, CloneTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneTemplateMutation, CloneTemplateMutationVariables>(CloneTemplateDocument, options);
      }
export type CloneTemplateMutationHookResult = ReturnType<typeof useCloneTemplateMutation>;
export type CloneTemplateMutationResult = Apollo.MutationResult<CloneTemplateMutation>;
export type CloneTemplateMutationOptions = Apollo.BaseMutationOptions<CloneTemplateMutation, CloneTemplateMutationVariables>;
export const RenameTemplateDocument = gql`
    mutation RenameTemplate($uid: ID!, $title: String) {
  updateEmailMarketingTemplate(uid: $uid, title: $title) {
    failReasons
    template {
      id
      title
    }
  }
}
    `;
export type RenameTemplateMutationFn = Apollo.MutationFunction<RenameTemplateMutation, RenameTemplateMutationVariables>;

/**
 * __useRenameTemplateMutation__
 *
 * To run a mutation, you first call `useRenameTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameTemplateMutation, { data, loading, error }] = useRenameTemplateMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRenameTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RenameTemplateMutation, RenameTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameTemplateMutation, RenameTemplateMutationVariables>(RenameTemplateDocument, options);
      }
export type RenameTemplateMutationHookResult = ReturnType<typeof useRenameTemplateMutation>;
export type RenameTemplateMutationResult = Apollo.MutationResult<RenameTemplateMutation>;
export type RenameTemplateMutationOptions = Apollo.BaseMutationOptions<RenameTemplateMutation, RenameTemplateMutationVariables>;
export const RestoreTemplateDocument = gql`
    mutation RestoreTemplate($uid: ID!) {
  restoreEmailMarketingTemplate(uid: $uid) {
    failReasons
    template {
      id
    }
  }
}
    `;
export type RestoreTemplateMutationFn = Apollo.MutationFunction<RestoreTemplateMutation, RestoreTemplateMutationVariables>;

/**
 * __useRestoreTemplateMutation__
 *
 * To run a mutation, you first call `useRestoreTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTemplateMutation, { data, loading, error }] = useRestoreTemplateMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useRestoreTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RestoreTemplateMutation, RestoreTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreTemplateMutation, RestoreTemplateMutationVariables>(RestoreTemplateDocument, options);
      }
export type RestoreTemplateMutationHookResult = ReturnType<typeof useRestoreTemplateMutation>;
export type RestoreTemplateMutationResult = Apollo.MutationResult<RestoreTemplateMutation>;
export type RestoreTemplateMutationOptions = Apollo.BaseMutationOptions<RestoreTemplateMutation, RestoreTemplateMutationVariables>;
export const TemplateEditContentDocument = gql`
    query TemplateEditContent($uid: ID!) {
  emailMarketingTemplate(uid: $uid) {
    id
    templateJson
    title
  }
  beePlugin {
    id
    clientId
    clientSecret
    beeUserUid
  }
  beeAuth {
    accessToken
    v2
  }
  emailMarketingConfiguration {
    id
    fonts {
      name
      url
      family
    }
  }
}
    `;

/**
 * __useTemplateEditContentQuery__
 *
 * To run a query within a React component, call `useTemplateEditContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateEditContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateEditContentQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useTemplateEditContentQuery(baseOptions: Apollo.QueryHookOptions<TemplateEditContentQuery, TemplateEditContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateEditContentQuery, TemplateEditContentQueryVariables>(TemplateEditContentDocument, options);
      }
export function useTemplateEditContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateEditContentQuery, TemplateEditContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateEditContentQuery, TemplateEditContentQueryVariables>(TemplateEditContentDocument, options);
        }
export type TemplateEditContentQueryHookResult = ReturnType<typeof useTemplateEditContentQuery>;
export type TemplateEditContentLazyQueryHookResult = ReturnType<typeof useTemplateEditContentLazyQuery>;
export type TemplateEditContentQueryResult = Apollo.QueryResult<TemplateEditContentQuery, TemplateEditContentQueryVariables>;
export const UpdateTemplateContentDocument = gql`
    mutation UpdateTemplateContent($uid: ID!, $templateJson: String) {
  updateEmailMarketingTemplate(uid: $uid, templateJson: $templateJson) {
    failReasons
    template {
      id
      templateJson
    }
  }
}
    `;
export type UpdateTemplateContentMutationFn = Apollo.MutationFunction<UpdateTemplateContentMutation, UpdateTemplateContentMutationVariables>;

/**
 * __useUpdateTemplateContentMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateContentMutation, { data, loading, error }] = useUpdateTemplateContentMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      templateJson: // value for 'templateJson'
 *   },
 * });
 */
export function useUpdateTemplateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateContentMutation, UpdateTemplateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateContentMutation, UpdateTemplateContentMutationVariables>(UpdateTemplateContentDocument, options);
      }
export type UpdateTemplateContentMutationHookResult = ReturnType<typeof useUpdateTemplateContentMutation>;
export type UpdateTemplateContentMutationResult = Apollo.MutationResult<UpdateTemplateContentMutation>;
export type UpdateTemplateContentMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateContentMutation, UpdateTemplateContentMutationVariables>;
export const ArchivedCompaniesDocument = gql`
    query ArchivedCompanies($page: Int, $perPage: Int, $filter: CompanyFiltering, $orderBy: ArchivedCompaniesOrderBy) {
  archivedCompanies(
    page: $page
    perPage: $perPage
    filter: $filter
    orderBy: $orderBy
  ) {
    entries {
      ...CleanerCompanyRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CleanerCompanyRowFragmentDoc}`;

/**
 * __useArchivedCompaniesQuery__
 *
 * To run a query within a React component, call `useArchivedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedCompaniesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useArchivedCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ArchivedCompaniesQuery, ArchivedCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchivedCompaniesQuery, ArchivedCompaniesQueryVariables>(ArchivedCompaniesDocument, options);
      }
export function useArchivedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchivedCompaniesQuery, ArchivedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchivedCompaniesQuery, ArchivedCompaniesQueryVariables>(ArchivedCompaniesDocument, options);
        }
export type ArchivedCompaniesQueryHookResult = ReturnType<typeof useArchivedCompaniesQuery>;
export type ArchivedCompaniesLazyQueryHookResult = ReturnType<typeof useArchivedCompaniesLazyQuery>;
export type ArchivedCompaniesQueryResult = Apollo.QueryResult<ArchivedCompaniesQuery, ArchivedCompaniesQueryVariables>;
export const BulkArchiveCompaniesDocument = gql`
    mutation BulkArchiveCompanies($ids: [ID!]!) {
  bulkArchiveCompanies(uids: $ids) {
    failReasons
  }
}
    `;
export type BulkArchiveCompaniesMutationFn = Apollo.MutationFunction<BulkArchiveCompaniesMutation, BulkArchiveCompaniesMutationVariables>;

/**
 * __useBulkArchiveCompaniesMutation__
 *
 * To run a mutation, you first call `useBulkArchiveCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkArchiveCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkArchiveCompaniesMutation, { data, loading, error }] = useBulkArchiveCompaniesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkArchiveCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<BulkArchiveCompaniesMutation, BulkArchiveCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkArchiveCompaniesMutation, BulkArchiveCompaniesMutationVariables>(BulkArchiveCompaniesDocument, options);
      }
export type BulkArchiveCompaniesMutationHookResult = ReturnType<typeof useBulkArchiveCompaniesMutation>;
export type BulkArchiveCompaniesMutationResult = Apollo.MutationResult<BulkArchiveCompaniesMutation>;
export type BulkArchiveCompaniesMutationOptions = Apollo.BaseMutationOptions<BulkArchiveCompaniesMutation, BulkArchiveCompaniesMutationVariables>;
export const BulkRestoreArchiveContactsDocument = gql`
    mutation BulkRestoreArchiveContacts($contact_uids: [ID!]!) {
  bulkRestoreArchiveContacts(contactUids: $contact_uids) {
    failReasons
  }
}
    `;
export type BulkRestoreArchiveContactsMutationFn = Apollo.MutationFunction<BulkRestoreArchiveContactsMutation, BulkRestoreArchiveContactsMutationVariables>;

/**
 * __useBulkRestoreArchiveContactsMutation__
 *
 * To run a mutation, you first call `useBulkRestoreArchiveContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRestoreArchiveContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRestoreArchiveContactsMutation, { data, loading, error }] = useBulkRestoreArchiveContactsMutation({
 *   variables: {
 *      contact_uids: // value for 'contact_uids'
 *   },
 * });
 */
export function useBulkRestoreArchiveContactsMutation(baseOptions?: Apollo.MutationHookOptions<BulkRestoreArchiveContactsMutation, BulkRestoreArchiveContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRestoreArchiveContactsMutation, BulkRestoreArchiveContactsMutationVariables>(BulkRestoreArchiveContactsDocument, options);
      }
export type BulkRestoreArchiveContactsMutationHookResult = ReturnType<typeof useBulkRestoreArchiveContactsMutation>;
export type BulkRestoreArchiveContactsMutationResult = Apollo.MutationResult<BulkRestoreArchiveContactsMutation>;
export type BulkRestoreArchiveContactsMutationOptions = Apollo.BaseMutationOptions<BulkRestoreArchiveContactsMutation, BulkRestoreArchiveContactsMutationVariables>;
export const BulkRestoreArchivedCompaniesDocument = gql`
    mutation BulkRestoreArchivedCompanies($ids: [ID!]!) {
  bulkRestoreArchivedCompanies(uids: $ids) {
    failReasons
  }
}
    `;
export type BulkRestoreArchivedCompaniesMutationFn = Apollo.MutationFunction<BulkRestoreArchivedCompaniesMutation, BulkRestoreArchivedCompaniesMutationVariables>;

/**
 * __useBulkRestoreArchivedCompaniesMutation__
 *
 * To run a mutation, you first call `useBulkRestoreArchivedCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRestoreArchivedCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRestoreArchivedCompaniesMutation, { data, loading, error }] = useBulkRestoreArchivedCompaniesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkRestoreArchivedCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<BulkRestoreArchivedCompaniesMutation, BulkRestoreArchivedCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRestoreArchivedCompaniesMutation, BulkRestoreArchivedCompaniesMutationVariables>(BulkRestoreArchivedCompaniesDocument, options);
      }
export type BulkRestoreArchivedCompaniesMutationHookResult = ReturnType<typeof useBulkRestoreArchivedCompaniesMutation>;
export type BulkRestoreArchivedCompaniesMutationResult = Apollo.MutationResult<BulkRestoreArchivedCompaniesMutation>;
export type BulkRestoreArchivedCompaniesMutationOptions = Apollo.BaseMutationOptions<BulkRestoreArchivedCompaniesMutation, BulkRestoreArchivedCompaniesMutationVariables>;
export const PurgeContactDocument = gql`
    mutation PurgeContact($contactUid: ID!, $reason: String!) {
  purgeContact(contactUid: $contactUid, reason: $reason) {
    failReasons
  }
}
    `;
export type PurgeContactMutationFn = Apollo.MutationFunction<PurgeContactMutation, PurgeContactMutationVariables>;

/**
 * __usePurgeContactMutation__
 *
 * To run a mutation, you first call `usePurgeContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurgeContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purgeContactMutation, { data, loading, error }] = usePurgeContactMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function usePurgeContactMutation(baseOptions?: Apollo.MutationHookOptions<PurgeContactMutation, PurgeContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurgeContactMutation, PurgeContactMutationVariables>(PurgeContactDocument, options);
      }
export type PurgeContactMutationHookResult = ReturnType<typeof usePurgeContactMutation>;
export type PurgeContactMutationResult = Apollo.MutationResult<PurgeContactMutation>;
export type PurgeContactMutationOptions = Apollo.BaseMutationOptions<PurgeContactMutation, PurgeContactMutationVariables>;
export const RestoreArchivedCompanyDocument = gql`
    mutation RestoreArchivedCompany($id: ID!) {
  restoreArchivedCompany(uid: $id) {
    failReasons
  }
}
    `;
export type RestoreArchivedCompanyMutationFn = Apollo.MutationFunction<RestoreArchivedCompanyMutation, RestoreArchivedCompanyMutationVariables>;

/**
 * __useRestoreArchivedCompanyMutation__
 *
 * To run a mutation, you first call `useRestoreArchivedCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreArchivedCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreArchivedCompanyMutation, { data, loading, error }] = useRestoreArchivedCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreArchivedCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RestoreArchivedCompanyMutation, RestoreArchivedCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreArchivedCompanyMutation, RestoreArchivedCompanyMutationVariables>(RestoreArchivedCompanyDocument, options);
      }
export type RestoreArchivedCompanyMutationHookResult = ReturnType<typeof useRestoreArchivedCompanyMutation>;
export type RestoreArchivedCompanyMutationResult = Apollo.MutationResult<RestoreArchivedCompanyMutation>;
export type RestoreArchivedCompanyMutationOptions = Apollo.BaseMutationOptions<RestoreArchivedCompanyMutation, RestoreArchivedCompanyMutationVariables>;
export const ArchivedContactsCleanerDocument = gql`
    query ArchivedContactsCleaner($page: Int, $perPage: Int, $orderBy: ArchivedContactsOrderBy, $filter: ArchivedContactsFiltering) {
  archivedContacts(
    page: $page
    perPage: $perPage
    orderBy: $orderBy
    filter: $filter
  ) {
    entries {
      ...ArchivedContactCleanerRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ArchivedContactCleanerRowFragmentDoc}`;

/**
 * __useArchivedContactsCleanerQuery__
 *
 * To run a query within a React component, call `useArchivedContactsCleanerQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedContactsCleanerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedContactsCleanerQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArchivedContactsCleanerQuery(baseOptions?: Apollo.QueryHookOptions<ArchivedContactsCleanerQuery, ArchivedContactsCleanerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchivedContactsCleanerQuery, ArchivedContactsCleanerQueryVariables>(ArchivedContactsCleanerDocument, options);
      }
export function useArchivedContactsCleanerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchivedContactsCleanerQuery, ArchivedContactsCleanerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchivedContactsCleanerQuery, ArchivedContactsCleanerQueryVariables>(ArchivedContactsCleanerDocument, options);
        }
export type ArchivedContactsCleanerQueryHookResult = ReturnType<typeof useArchivedContactsCleanerQuery>;
export type ArchivedContactsCleanerLazyQueryHookResult = ReturnType<typeof useArchivedContactsCleanerLazyQuery>;
export type ArchivedContactsCleanerQueryResult = Apollo.QueryResult<ArchivedContactsCleanerQuery, ArchivedContactsCleanerQueryVariables>;
export const AddDuplicateCompaniesToHierarchyDocument = gql`
    mutation AddDuplicateCompaniesToHierarchy($duplicateCompanyUid: ID!) {
  addDuplicateCompaniesToHierarchy(duplicateCompanyUid: $duplicateCompanyUid) {
    failReasons
  }
}
    `;
export type AddDuplicateCompaniesToHierarchyMutationFn = Apollo.MutationFunction<AddDuplicateCompaniesToHierarchyMutation, AddDuplicateCompaniesToHierarchyMutationVariables>;

/**
 * __useAddDuplicateCompaniesToHierarchyMutation__
 *
 * To run a mutation, you first call `useAddDuplicateCompaniesToHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDuplicateCompaniesToHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDuplicateCompaniesToHierarchyMutation, { data, loading, error }] = useAddDuplicateCompaniesToHierarchyMutation({
 *   variables: {
 *      duplicateCompanyUid: // value for 'duplicateCompanyUid'
 *   },
 * });
 */
export function useAddDuplicateCompaniesToHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<AddDuplicateCompaniesToHierarchyMutation, AddDuplicateCompaniesToHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDuplicateCompaniesToHierarchyMutation, AddDuplicateCompaniesToHierarchyMutationVariables>(AddDuplicateCompaniesToHierarchyDocument, options);
      }
export type AddDuplicateCompaniesToHierarchyMutationHookResult = ReturnType<typeof useAddDuplicateCompaniesToHierarchyMutation>;
export type AddDuplicateCompaniesToHierarchyMutationResult = Apollo.MutationResult<AddDuplicateCompaniesToHierarchyMutation>;
export type AddDuplicateCompaniesToHierarchyMutationOptions = Apollo.BaseMutationOptions<AddDuplicateCompaniesToHierarchyMutation, AddDuplicateCompaniesToHierarchyMutationVariables>;
export const DuplicateCompaniesDocument = gql`
    query DuplicateCompanies($page: Int = 1, $perPage: Int = 25, $orderBy: DupilcateCompaniesOrderBy, $filter: DuplicateCompaniesFiltering) {
  duplicateCompanies(
    page: $page
    perPage: $perPage
    orderBy: $orderBy
    filter: $filter
  ) {
    entries {
      ...DuplicateCompaniesRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${DuplicateCompaniesRowFragmentDoc}`;

/**
 * __useDuplicateCompaniesQuery__
 *
 * To run a query within a React component, call `useDuplicateCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateCompaniesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDuplicateCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<DuplicateCompaniesQuery, DuplicateCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicateCompaniesQuery, DuplicateCompaniesQueryVariables>(DuplicateCompaniesDocument, options);
      }
export function useDuplicateCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicateCompaniesQuery, DuplicateCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicateCompaniesQuery, DuplicateCompaniesQueryVariables>(DuplicateCompaniesDocument, options);
        }
export type DuplicateCompaniesQueryHookResult = ReturnType<typeof useDuplicateCompaniesQuery>;
export type DuplicateCompaniesLazyQueryHookResult = ReturnType<typeof useDuplicateCompaniesLazyQuery>;
export type DuplicateCompaniesQueryResult = Apollo.QueryResult<DuplicateCompaniesQuery, DuplicateCompaniesQueryVariables>;
export const DuplicateContactsDocument = gql`
    query DuplicateContacts($filter: DuplicateContactFiltering, $page: Int = 1, $perPage: Int = 25, $orderBy: DupilcateContactsOrderBy) {
  duplicateContacts(
    page: $page
    perPage: $perPage
    orderBy: $orderBy
    filter: $filter
  ) {
    entries {
      ...DuplicateContactRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${DuplicateContactRowFragmentDoc}`;

/**
 * __useDuplicateContactsQuery__
 *
 * To run a query within a React component, call `useDuplicateContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateContactsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDuplicateContactsQuery(baseOptions?: Apollo.QueryHookOptions<DuplicateContactsQuery, DuplicateContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicateContactsQuery, DuplicateContactsQueryVariables>(DuplicateContactsDocument, options);
      }
export function useDuplicateContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicateContactsQuery, DuplicateContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicateContactsQuery, DuplicateContactsQueryVariables>(DuplicateContactsDocument, options);
        }
export type DuplicateContactsQueryHookResult = ReturnType<typeof useDuplicateContactsQuery>;
export type DuplicateContactsLazyQueryHookResult = ReturnType<typeof useDuplicateContactsLazyQuery>;
export type DuplicateContactsQueryResult = Apollo.QueryResult<DuplicateContactsQuery, DuplicateContactsQueryVariables>;
export const MergeCompanyDocument = gql`
    mutation MergeCompany($previousUid: ID!, $currentUid: ID!) {
  mergeCompany(currentUid: $currentUid, previousUid: $previousUid) {
    failReasons
  }
}
    `;
export type MergeCompanyMutationFn = Apollo.MutationFunction<MergeCompanyMutation, MergeCompanyMutationVariables>;

/**
 * __useMergeCompanyMutation__
 *
 * To run a mutation, you first call `useMergeCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCompanyMutation, { data, loading, error }] = useMergeCompanyMutation({
 *   variables: {
 *      previousUid: // value for 'previousUid'
 *      currentUid: // value for 'currentUid'
 *   },
 * });
 */
export function useMergeCompanyMutation(baseOptions?: Apollo.MutationHookOptions<MergeCompanyMutation, MergeCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeCompanyMutation, MergeCompanyMutationVariables>(MergeCompanyDocument, options);
      }
export type MergeCompanyMutationHookResult = ReturnType<typeof useMergeCompanyMutation>;
export type MergeCompanyMutationResult = Apollo.MutationResult<MergeCompanyMutation>;
export type MergeCompanyMutationOptions = Apollo.BaseMutationOptions<MergeCompanyMutation, MergeCompanyMutationVariables>;
export const RemoveDuplicateCompanyDocument = gql`
    mutation RemoveDuplicateCompany($duplicateUid: ID!) {
  removeDuplicateCompany(duplicateUid: $duplicateUid) {
    failReasons
  }
}
    `;
export type RemoveDuplicateCompanyMutationFn = Apollo.MutationFunction<RemoveDuplicateCompanyMutation, RemoveDuplicateCompanyMutationVariables>;

/**
 * __useRemoveDuplicateCompanyMutation__
 *
 * To run a mutation, you first call `useRemoveDuplicateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDuplicateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDuplicateCompanyMutation, { data, loading, error }] = useRemoveDuplicateCompanyMutation({
 *   variables: {
 *      duplicateUid: // value for 'duplicateUid'
 *   },
 * });
 */
export function useRemoveDuplicateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDuplicateCompanyMutation, RemoveDuplicateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDuplicateCompanyMutation, RemoveDuplicateCompanyMutationVariables>(RemoveDuplicateCompanyDocument, options);
      }
export type RemoveDuplicateCompanyMutationHookResult = ReturnType<typeof useRemoveDuplicateCompanyMutation>;
export type RemoveDuplicateCompanyMutationResult = Apollo.MutationResult<RemoveDuplicateCompanyMutation>;
export type RemoveDuplicateCompanyMutationOptions = Apollo.BaseMutationOptions<RemoveDuplicateCompanyMutation, RemoveDuplicateCompanyMutationVariables>;
export const RemoveDuplicateContactDocument = gql`
    mutation RemoveDuplicateContact($duplicateUid: String!) {
  removeDuplicateContact(duplicateUid: $duplicateUid) {
    failReasons
  }
}
    `;
export type RemoveDuplicateContactMutationFn = Apollo.MutationFunction<RemoveDuplicateContactMutation, RemoveDuplicateContactMutationVariables>;

/**
 * __useRemoveDuplicateContactMutation__
 *
 * To run a mutation, you first call `useRemoveDuplicateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDuplicateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDuplicateContactMutation, { data, loading, error }] = useRemoveDuplicateContactMutation({
 *   variables: {
 *      duplicateUid: // value for 'duplicateUid'
 *   },
 * });
 */
export function useRemoveDuplicateContactMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDuplicateContactMutation, RemoveDuplicateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDuplicateContactMutation, RemoveDuplicateContactMutationVariables>(RemoveDuplicateContactDocument, options);
      }
export type RemoveDuplicateContactMutationHookResult = ReturnType<typeof useRemoveDuplicateContactMutation>;
export type RemoveDuplicateContactMutationResult = Apollo.MutationResult<RemoveDuplicateContactMutation>;
export type RemoveDuplicateContactMutationOptions = Apollo.BaseMutationOptions<RemoveDuplicateContactMutation, RemoveDuplicateContactMutationVariables>;
export const BulkIgnoreIncompleteCompaniesDocument = gql`
    mutation BulkIgnoreIncompleteCompanies($company_ids: [ID!]!) {
  bulkIgnoreIncompleteCompanies(companyIds: $company_ids) {
    failReasons
  }
}
    `;
export type BulkIgnoreIncompleteCompaniesMutationFn = Apollo.MutationFunction<BulkIgnoreIncompleteCompaniesMutation, BulkIgnoreIncompleteCompaniesMutationVariables>;

/**
 * __useBulkIgnoreIncompleteCompaniesMutation__
 *
 * To run a mutation, you first call `useBulkIgnoreIncompleteCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkIgnoreIncompleteCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkIgnoreIncompleteCompaniesMutation, { data, loading, error }] = useBulkIgnoreIncompleteCompaniesMutation({
 *   variables: {
 *      company_ids: // value for 'company_ids'
 *   },
 * });
 */
export function useBulkIgnoreIncompleteCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<BulkIgnoreIncompleteCompaniesMutation, BulkIgnoreIncompleteCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkIgnoreIncompleteCompaniesMutation, BulkIgnoreIncompleteCompaniesMutationVariables>(BulkIgnoreIncompleteCompaniesDocument, options);
      }
export type BulkIgnoreIncompleteCompaniesMutationHookResult = ReturnType<typeof useBulkIgnoreIncompleteCompaniesMutation>;
export type BulkIgnoreIncompleteCompaniesMutationResult = Apollo.MutationResult<BulkIgnoreIncompleteCompaniesMutation>;
export type BulkIgnoreIncompleteCompaniesMutationOptions = Apollo.BaseMutationOptions<BulkIgnoreIncompleteCompaniesMutation, BulkIgnoreIncompleteCompaniesMutationVariables>;
export const BulkIgnoreIncompleteContactsDocument = gql`
    mutation BulkIgnoreIncompleteContacts($uids: [ID!]!) {
  bulkIgnoreIncompleteContacts(uids: $uids) {
    failReasons
  }
}
    `;
export type BulkIgnoreIncompleteContactsMutationFn = Apollo.MutationFunction<BulkIgnoreIncompleteContactsMutation, BulkIgnoreIncompleteContactsMutationVariables>;

/**
 * __useBulkIgnoreIncompleteContactsMutation__
 *
 * To run a mutation, you first call `useBulkIgnoreIncompleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkIgnoreIncompleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkIgnoreIncompleteContactsMutation, { data, loading, error }] = useBulkIgnoreIncompleteContactsMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useBulkIgnoreIncompleteContactsMutation(baseOptions?: Apollo.MutationHookOptions<BulkIgnoreIncompleteContactsMutation, BulkIgnoreIncompleteContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkIgnoreIncompleteContactsMutation, BulkIgnoreIncompleteContactsMutationVariables>(BulkIgnoreIncompleteContactsDocument, options);
      }
export type BulkIgnoreIncompleteContactsMutationHookResult = ReturnType<typeof useBulkIgnoreIncompleteContactsMutation>;
export type BulkIgnoreIncompleteContactsMutationResult = Apollo.MutationResult<BulkIgnoreIncompleteContactsMutation>;
export type BulkIgnoreIncompleteContactsMutationOptions = Apollo.BaseMutationOptions<BulkIgnoreIncompleteContactsMutation, BulkIgnoreIncompleteContactsMutationVariables>;
export const ExportIncompleteCompaniesDocument = gql`
    mutation ExportIncompleteCompanies($term: String) {
  exportIncompleteCompanies(filter: {term: $term}) {
    export {
      id
    }
    failReasons
  }
}
    `;
export type ExportIncompleteCompaniesMutationFn = Apollo.MutationFunction<ExportIncompleteCompaniesMutation, ExportIncompleteCompaniesMutationVariables>;

/**
 * __useExportIncompleteCompaniesMutation__
 *
 * To run a mutation, you first call `useExportIncompleteCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportIncompleteCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportIncompleteCompaniesMutation, { data, loading, error }] = useExportIncompleteCompaniesMutation({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useExportIncompleteCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<ExportIncompleteCompaniesMutation, ExportIncompleteCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportIncompleteCompaniesMutation, ExportIncompleteCompaniesMutationVariables>(ExportIncompleteCompaniesDocument, options);
      }
export type ExportIncompleteCompaniesMutationHookResult = ReturnType<typeof useExportIncompleteCompaniesMutation>;
export type ExportIncompleteCompaniesMutationResult = Apollo.MutationResult<ExportIncompleteCompaniesMutation>;
export type ExportIncompleteCompaniesMutationOptions = Apollo.BaseMutationOptions<ExportIncompleteCompaniesMutation, ExportIncompleteCompaniesMutationVariables>;
export const ExportIncompleteContactsDocument = gql`
    mutation ExportIncompleteContacts($filter: IncompleteContactFiltering, $term: String) {
  exportIncompleteContacts(filter: $filter, term: $term) {
    export {
      id
    }
    failReasons
  }
}
    `;
export type ExportIncompleteContactsMutationFn = Apollo.MutationFunction<ExportIncompleteContactsMutation, ExportIncompleteContactsMutationVariables>;

/**
 * __useExportIncompleteContactsMutation__
 *
 * To run a mutation, you first call `useExportIncompleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportIncompleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportIncompleteContactsMutation, { data, loading, error }] = useExportIncompleteContactsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useExportIncompleteContactsMutation(baseOptions?: Apollo.MutationHookOptions<ExportIncompleteContactsMutation, ExportIncompleteContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportIncompleteContactsMutation, ExportIncompleteContactsMutationVariables>(ExportIncompleteContactsDocument, options);
      }
export type ExportIncompleteContactsMutationHookResult = ReturnType<typeof useExportIncompleteContactsMutation>;
export type ExportIncompleteContactsMutationResult = Apollo.MutationResult<ExportIncompleteContactsMutation>;
export type ExportIncompleteContactsMutationOptions = Apollo.BaseMutationOptions<ExportIncompleteContactsMutation, ExportIncompleteContactsMutationVariables>;
export const IgnoreIncompleteCompanyDocument = gql`
    mutation IgnoreIncompleteCompany($uid: ID!) {
  ignoreIncompleteCompany(uid: $uid) {
    failReasons
  }
}
    `;
export type IgnoreIncompleteCompanyMutationFn = Apollo.MutationFunction<IgnoreIncompleteCompanyMutation, IgnoreIncompleteCompanyMutationVariables>;

/**
 * __useIgnoreIncompleteCompanyMutation__
 *
 * To run a mutation, you first call `useIgnoreIncompleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreIncompleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreIncompleteCompanyMutation, { data, loading, error }] = useIgnoreIncompleteCompanyMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useIgnoreIncompleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<IgnoreIncompleteCompanyMutation, IgnoreIncompleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnoreIncompleteCompanyMutation, IgnoreIncompleteCompanyMutationVariables>(IgnoreIncompleteCompanyDocument, options);
      }
export type IgnoreIncompleteCompanyMutationHookResult = ReturnType<typeof useIgnoreIncompleteCompanyMutation>;
export type IgnoreIncompleteCompanyMutationResult = Apollo.MutationResult<IgnoreIncompleteCompanyMutation>;
export type IgnoreIncompleteCompanyMutationOptions = Apollo.BaseMutationOptions<IgnoreIncompleteCompanyMutation, IgnoreIncompleteCompanyMutationVariables>;
export const IgnoreIncompleteContactDocument = gql`
    mutation IgnoreIncompleteContact($id: ID!) {
  ignoreIncompleteContact(uid: $id) {
    failReasons
  }
}
    `;
export type IgnoreIncompleteContactMutationFn = Apollo.MutationFunction<IgnoreIncompleteContactMutation, IgnoreIncompleteContactMutationVariables>;

/**
 * __useIgnoreIncompleteContactMutation__
 *
 * To run a mutation, you first call `useIgnoreIncompleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreIncompleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreIncompleteContactMutation, { data, loading, error }] = useIgnoreIncompleteContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIgnoreIncompleteContactMutation(baseOptions?: Apollo.MutationHookOptions<IgnoreIncompleteContactMutation, IgnoreIncompleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnoreIncompleteContactMutation, IgnoreIncompleteContactMutationVariables>(IgnoreIncompleteContactDocument, options);
      }
export type IgnoreIncompleteContactMutationHookResult = ReturnType<typeof useIgnoreIncompleteContactMutation>;
export type IgnoreIncompleteContactMutationResult = Apollo.MutationResult<IgnoreIncompleteContactMutation>;
export type IgnoreIncompleteContactMutationOptions = Apollo.BaseMutationOptions<IgnoreIncompleteContactMutation, IgnoreIncompleteContactMutationVariables>;
export const IncompleteCompaniesDocument = gql`
    query IncompleteCompanies($page: Int, $perPage: Int, $orderBy: CompaniesOrderBy, $term: String) {
  incompleteCompanies(
    page: $page
    perPage: $perPage
    filter: {term: $term}
    orderBy: $orderBy
  ) {
    entries {
      ...IncompleteCompanyRow
    }
    pageInfo {
      totalPages
      totalEntries
    }
  }
}
    ${IncompleteCompanyRowFragmentDoc}`;

/**
 * __useIncompleteCompaniesQuery__
 *
 * To run a query within a React component, call `useIncompleteCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncompleteCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncompleteCompaniesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useIncompleteCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<IncompleteCompaniesQuery, IncompleteCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncompleteCompaniesQuery, IncompleteCompaniesQueryVariables>(IncompleteCompaniesDocument, options);
      }
export function useIncompleteCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncompleteCompaniesQuery, IncompleteCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncompleteCompaniesQuery, IncompleteCompaniesQueryVariables>(IncompleteCompaniesDocument, options);
        }
export type IncompleteCompaniesQueryHookResult = ReturnType<typeof useIncompleteCompaniesQuery>;
export type IncompleteCompaniesLazyQueryHookResult = ReturnType<typeof useIncompleteCompaniesLazyQuery>;
export type IncompleteCompaniesQueryResult = Apollo.QueryResult<IncompleteCompaniesQuery, IncompleteCompaniesQueryVariables>;
export const IncompleteContactsDocument = gql`
    query IncompleteContacts($page: Int, $perPage: Int, $filter: IncompleteContactFiltering, $orderBy: ContactsOrderBy) {
  incompleteContacts(
    page: $page
    perPage: $perPage
    filter: $filter
    orderBy: $orderBy
  ) {
    entries {
      ...IncompleteContactRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${IncompleteContactRowFragmentDoc}`;

/**
 * __useIncompleteContactsQuery__
 *
 * To run a query within a React component, call `useIncompleteContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncompleteContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncompleteContactsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useIncompleteContactsQuery(baseOptions?: Apollo.QueryHookOptions<IncompleteContactsQuery, IncompleteContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncompleteContactsQuery, IncompleteContactsQueryVariables>(IncompleteContactsDocument, options);
      }
export function useIncompleteContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncompleteContactsQuery, IncompleteContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncompleteContactsQuery, IncompleteContactsQueryVariables>(IncompleteContactsDocument, options);
        }
export type IncompleteContactsQueryHookResult = ReturnType<typeof useIncompleteContactsQuery>;
export type IncompleteContactsLazyQueryHookResult = ReturnType<typeof useIncompleteContactsLazyQuery>;
export type IncompleteContactsQueryResult = Apollo.QueryResult<IncompleteContactsQuery, IncompleteContactsQueryVariables>;
export const BulkUpdateIncompleteContactsDocument = gql`
    mutation BulkUpdateIncompleteContacts($contactUids: [ID!]!, $updatableAttributes: BulkUpdateContactAttributes!) {
  bulkUpdateContact(
    contactUids: $contactUids
    updatableAttributes: $updatableAttributes
  ) {
    failReasons
  }
}
    `;
export type BulkUpdateIncompleteContactsMutationFn = Apollo.MutationFunction<BulkUpdateIncompleteContactsMutation, BulkUpdateIncompleteContactsMutationVariables>;

/**
 * __useBulkUpdateIncompleteContactsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateIncompleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateIncompleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateIncompleteContactsMutation, { data, loading, error }] = useBulkUpdateIncompleteContactsMutation({
 *   variables: {
 *      contactUids: // value for 'contactUids'
 *      updatableAttributes: // value for 'updatableAttributes'
 *   },
 * });
 */
export function useBulkUpdateIncompleteContactsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateIncompleteContactsMutation, BulkUpdateIncompleteContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateIncompleteContactsMutation, BulkUpdateIncompleteContactsMutationVariables>(BulkUpdateIncompleteContactsDocument, options);
      }
export type BulkUpdateIncompleteContactsMutationHookResult = ReturnType<typeof useBulkUpdateIncompleteContactsMutation>;
export type BulkUpdateIncompleteContactsMutationResult = Apollo.MutationResult<BulkUpdateIncompleteContactsMutation>;
export type BulkUpdateIncompleteContactsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateIncompleteContactsMutation, BulkUpdateIncompleteContactsMutationVariables>;
export const IncompleteContactsGridDocument = gql`
    query IncompleteContactsGrid($page: Int, $perPage: Int, $filter: IncompleteContactFiltering, $orderBy: ContactsOrderBy, $datasourceVersion: Int) {
  incompleteContacts(
    page: $page
    perPage: $perPage
    filter: $filter
    orderBy: $orderBy
    datasourceVersion: $datasourceVersion
  ) {
    entries {
      ...IncompleteContactGridRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${IncompleteContactGridRowFragmentDoc}`;

/**
 * __useIncompleteContactsGridQuery__
 *
 * To run a query within a React component, call `useIncompleteContactsGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncompleteContactsGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncompleteContactsGridQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      datasourceVersion: // value for 'datasourceVersion'
 *   },
 * });
 */
export function useIncompleteContactsGridQuery(baseOptions?: Apollo.QueryHookOptions<IncompleteContactsGridQuery, IncompleteContactsGridQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncompleteContactsGridQuery, IncompleteContactsGridQueryVariables>(IncompleteContactsGridDocument, options);
      }
export function useIncompleteContactsGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncompleteContactsGridQuery, IncompleteContactsGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncompleteContactsGridQuery, IncompleteContactsGridQueryVariables>(IncompleteContactsGridDocument, options);
        }
export type IncompleteContactsGridQueryHookResult = ReturnType<typeof useIncompleteContactsGridQuery>;
export type IncompleteContactsGridLazyQueryHookResult = ReturnType<typeof useIncompleteContactsGridLazyQuery>;
export type IncompleteContactsGridQueryResult = Apollo.QueryResult<IncompleteContactsGridQuery, IncompleteContactsGridQueryVariables>;
export const ContactRequireHierarchyPlacementsDocument = gql`
    query ContactRequireHierarchyPlacements($page: Int, $perPage: Int) {
  contactRequireHierarchyPlacements(page: $page, perPage: $perPage) {
    entries {
      id
      contact {
        ...ContactRequireHierarchyPlacement
      }
    }
    pageInfo {
      totalEntries
      totalPages
    }
  }
}
    ${ContactRequireHierarchyPlacementFragmentDoc}`;

/**
 * __useContactRequireHierarchyPlacementsQuery__
 *
 * To run a query within a React component, call `useContactRequireHierarchyPlacementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactRequireHierarchyPlacementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactRequireHierarchyPlacementsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useContactRequireHierarchyPlacementsQuery(baseOptions?: Apollo.QueryHookOptions<ContactRequireHierarchyPlacementsQuery, ContactRequireHierarchyPlacementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactRequireHierarchyPlacementsQuery, ContactRequireHierarchyPlacementsQueryVariables>(ContactRequireHierarchyPlacementsDocument, options);
      }
export function useContactRequireHierarchyPlacementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactRequireHierarchyPlacementsQuery, ContactRequireHierarchyPlacementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactRequireHierarchyPlacementsQuery, ContactRequireHierarchyPlacementsQueryVariables>(ContactRequireHierarchyPlacementsDocument, options);
        }
export type ContactRequireHierarchyPlacementsQueryHookResult = ReturnType<typeof useContactRequireHierarchyPlacementsQuery>;
export type ContactRequireHierarchyPlacementsLazyQueryHookResult = ReturnType<typeof useContactRequireHierarchyPlacementsLazyQuery>;
export type ContactRequireHierarchyPlacementsQueryResult = Apollo.QueryResult<ContactRequireHierarchyPlacementsQuery, ContactRequireHierarchyPlacementsQueryVariables>;
export const ExportUnengagedContactsDocument = gql`
    mutation ExportUnengagedContacts($term: String) {
  exportUnengagedContacts(filter: {term: $term}) {
    export {
      id
    }
    failReasons
  }
}
    `;
export type ExportUnengagedContactsMutationFn = Apollo.MutationFunction<ExportUnengagedContactsMutation, ExportUnengagedContactsMutationVariables>;

/**
 * __useExportUnengagedContactsMutation__
 *
 * To run a mutation, you first call `useExportUnengagedContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUnengagedContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUnengagedContactsMutation, { data, loading, error }] = useExportUnengagedContactsMutation({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useExportUnengagedContactsMutation(baseOptions?: Apollo.MutationHookOptions<ExportUnengagedContactsMutation, ExportUnengagedContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportUnengagedContactsMutation, ExportUnengagedContactsMutationVariables>(ExportUnengagedContactsDocument, options);
      }
export type ExportUnengagedContactsMutationHookResult = ReturnType<typeof useExportUnengagedContactsMutation>;
export type ExportUnengagedContactsMutationResult = Apollo.MutationResult<ExportUnengagedContactsMutation>;
export type ExportUnengagedContactsMutationOptions = Apollo.BaseMutationOptions<ExportUnengagedContactsMutation, ExportUnengagedContactsMutationVariables>;
export const UnengagedContactsDocument = gql`
    query UnengagedContacts($orderBy: UnengagedContactsOrderBy, $page: Int, $perPage: Int, $filter: UnengagedContactsFiltering) {
  unengagedContacts(
    orderBy: $orderBy
    page: $page
    perPage: $perPage
    filter: $filter
  ) {
    entries {
      ...UnengagedContactRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${UnengagedContactRowFragmentDoc}`;

/**
 * __useUnengagedContactsQuery__
 *
 * To run a query within a React component, call `useUnengagedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnengagedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnengagedContactsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUnengagedContactsQuery(baseOptions?: Apollo.QueryHookOptions<UnengagedContactsQuery, UnengagedContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnengagedContactsQuery, UnengagedContactsQueryVariables>(UnengagedContactsDocument, options);
      }
export function useUnengagedContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnengagedContactsQuery, UnengagedContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnengagedContactsQuery, UnengagedContactsQueryVariables>(UnengagedContactsDocument, options);
        }
export type UnengagedContactsQueryHookResult = ReturnType<typeof useUnengagedContactsQuery>;
export type UnengagedContactsLazyQueryHookResult = ReturnType<typeof useUnengagedContactsLazyQuery>;
export type UnengagedContactsQueryResult = Apollo.QueryResult<UnengagedContactsQuery, UnengagedContactsQueryVariables>;
export const CommentThreadCountDocument = gql`
    query CommentThreadCount($attachedToUid: ID!, $attachedToType: CommentThreadAttachable!) {
  commentThreadInfo(
    attachedToUid: $attachedToUid
    attachedToType: $attachedToType
  ) {
    id
    commentsCount
  }
}
    `;

/**
 * __useCommentThreadCountQuery__
 *
 * To run a query within a React component, call `useCommentThreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentThreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentThreadCountQuery({
 *   variables: {
 *      attachedToUid: // value for 'attachedToUid'
 *      attachedToType: // value for 'attachedToType'
 *   },
 * });
 */
export function useCommentThreadCountQuery(baseOptions: Apollo.QueryHookOptions<CommentThreadCountQuery, CommentThreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentThreadCountQuery, CommentThreadCountQueryVariables>(CommentThreadCountDocument, options);
      }
export function useCommentThreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentThreadCountQuery, CommentThreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentThreadCountQuery, CommentThreadCountQueryVariables>(CommentThreadCountDocument, options);
        }
export type CommentThreadCountQueryHookResult = ReturnType<typeof useCommentThreadCountQuery>;
export type CommentThreadCountLazyQueryHookResult = ReturnType<typeof useCommentThreadCountLazyQuery>;
export type CommentThreadCountQueryResult = Apollo.QueryResult<CommentThreadCountQuery, CommentThreadCountQueryVariables>;
export const CommentThreadInfoDocument = gql`
    query CommentThreadInfo($attachedToUid: ID!, $attachedToType: CommentThreadAttachable!, $ff_release_12_faster_comment_threads: Boolean!) {
  commentThreadInfo(
    attachedToUid: $attachedToUid
    attachedToType: $attachedToType
  ) {
    id
    mentionables @include(if: $ff_release_12_faster_comment_threads) {
      ...Mentionable
    }
    mentionableUsers @skip(if: $ff_release_12_faster_comment_threads) {
      ...MentionableUser
    }
  }
}
    ${MentionableFragmentDoc}
${MentionableUserFragmentDoc}`;

/**
 * __useCommentThreadInfoQuery__
 *
 * To run a query within a React component, call `useCommentThreadInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentThreadInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentThreadInfoQuery({
 *   variables: {
 *      attachedToUid: // value for 'attachedToUid'
 *      attachedToType: // value for 'attachedToType'
 *      ff_release_12_faster_comment_threads: // value for 'ff_release_12_faster_comment_threads'
 *   },
 * });
 */
export function useCommentThreadInfoQuery(baseOptions: Apollo.QueryHookOptions<CommentThreadInfoQuery, CommentThreadInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentThreadInfoQuery, CommentThreadInfoQueryVariables>(CommentThreadInfoDocument, options);
      }
export function useCommentThreadInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentThreadInfoQuery, CommentThreadInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentThreadInfoQuery, CommentThreadInfoQueryVariables>(CommentThreadInfoDocument, options);
        }
export type CommentThreadInfoQueryHookResult = ReturnType<typeof useCommentThreadInfoQuery>;
export type CommentThreadInfoLazyQueryHookResult = ReturnType<typeof useCommentThreadInfoLazyQuery>;
export type CommentThreadInfoQueryResult = Apollo.QueryResult<CommentThreadInfoQuery, CommentThreadInfoQueryVariables>;
export const CreateCommentThreadDocument = gql`
    mutation CreateCommentThread($attachedToUid: ID!, $attachedToType: CommentThreadAttachable!, $htmlContent: String!) {
  createCommentThread(
    attachedToUid: $attachedToUid
    attachedToType: $attachedToType
    htmlContent: $htmlContent
  ) {
    failReasons
    commentThread {
      id
    }
  }
}
    `;
export type CreateCommentThreadMutationFn = Apollo.MutationFunction<CreateCommentThreadMutation, CreateCommentThreadMutationVariables>;

/**
 * __useCreateCommentThreadMutation__
 *
 * To run a mutation, you first call `useCreateCommentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentThreadMutation, { data, loading, error }] = useCreateCommentThreadMutation({
 *   variables: {
 *      attachedToUid: // value for 'attachedToUid'
 *      attachedToType: // value for 'attachedToType'
 *      htmlContent: // value for 'htmlContent'
 *   },
 * });
 */
export function useCreateCommentThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentThreadMutation, CreateCommentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentThreadMutation, CreateCommentThreadMutationVariables>(CreateCommentThreadDocument, options);
      }
export type CreateCommentThreadMutationHookResult = ReturnType<typeof useCreateCommentThreadMutation>;
export type CreateCommentThreadMutationResult = Apollo.MutationResult<CreateCommentThreadMutation>;
export type CreateCommentThreadMutationOptions = Apollo.BaseMutationOptions<CreateCommentThreadMutation, CreateCommentThreadMutationVariables>;
export const BulkUpdateCompanyTypeDocument = gql`
    mutation BulkUpdateCompanyType($uids: [ID!]!, $companyTypeUid: ID!) {
  bulkUpdateCompanyType(uids: $uids, companyTypeUid: $companyTypeUid) {
    failReasons
  }
}
    `;
export type BulkUpdateCompanyTypeMutationFn = Apollo.MutationFunction<BulkUpdateCompanyTypeMutation, BulkUpdateCompanyTypeMutationVariables>;

/**
 * __useBulkUpdateCompanyTypeMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCompanyTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCompanyTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateCompanyTypeMutation, { data, loading, error }] = useBulkUpdateCompanyTypeMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *      companyTypeUid: // value for 'companyTypeUid'
 *   },
 * });
 */
export function useBulkUpdateCompanyTypeMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateCompanyTypeMutation, BulkUpdateCompanyTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateCompanyTypeMutation, BulkUpdateCompanyTypeMutationVariables>(BulkUpdateCompanyTypeDocument, options);
      }
export type BulkUpdateCompanyTypeMutationHookResult = ReturnType<typeof useBulkUpdateCompanyTypeMutation>;
export type BulkUpdateCompanyTypeMutationResult = Apollo.MutationResult<BulkUpdateCompanyTypeMutation>;
export type BulkUpdateCompanyTypeMutationOptions = Apollo.BaseMutationOptions<BulkUpdateCompanyTypeMutation, BulkUpdateCompanyTypeMutationVariables>;
export const CompanyDocument = gql`
    query Company($uid: String!) {
  company(uid: $uid) {
    ...CompanyProfile
  }
  myCompany(uid: $uid) {
    ...MyCompanyExists
  }
}
    ${CompanyProfileFragmentDoc}
${MyCompanyExistsFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const CompanyCustomTypesDocument = gql`
    query CompanyCustomTypes {
  tenantConfiguration {
    id
    companyTypes {
      ...CompanyCustomType
    }
  }
}
    ${CompanyCustomTypeFragmentDoc}`;

/**
 * __useCompanyCustomTypesQuery__
 *
 * To run a query within a React component, call `useCompanyCustomTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyCustomTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyCustomTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyCustomTypesQuery(baseOptions?: Apollo.QueryHookOptions<CompanyCustomTypesQuery, CompanyCustomTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyCustomTypesQuery, CompanyCustomTypesQueryVariables>(CompanyCustomTypesDocument, options);
      }
export function useCompanyCustomTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyCustomTypesQuery, CompanyCustomTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyCustomTypesQuery, CompanyCustomTypesQueryVariables>(CompanyCustomTypesDocument, options);
        }
export type CompanyCustomTypesQueryHookResult = ReturnType<typeof useCompanyCustomTypesQuery>;
export type CompanyCustomTypesLazyQueryHookResult = ReturnType<typeof useCompanyCustomTypesLazyQuery>;
export type CompanyCustomTypesQueryResult = Apollo.QueryResult<CompanyCustomTypesQuery, CompanyCustomTypesQueryVariables>;
export const CompanyFormikFieldWithOptionsDocument = gql`
    query CompanyFormikFieldWithOptions($term: String, $page: Int, $perPage: Int) {
  companies(filter: {term: $term}, page: $page, perPage: $perPage) {
    entries {
      ...CompanyFormikFieldWithOptions
    }
  }
}
    ${CompanyFormikFieldWithOptionsFragmentDoc}`;

/**
 * __useCompanyFormikFieldWithOptionsQuery__
 *
 * To run a query within a React component, call `useCompanyFormikFieldWithOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFormikFieldWithOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFormikFieldWithOptionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCompanyFormikFieldWithOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyFormikFieldWithOptionsQuery, CompanyFormikFieldWithOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyFormikFieldWithOptionsQuery, CompanyFormikFieldWithOptionsQueryVariables>(CompanyFormikFieldWithOptionsDocument, options);
      }
export function useCompanyFormikFieldWithOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyFormikFieldWithOptionsQuery, CompanyFormikFieldWithOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyFormikFieldWithOptionsQuery, CompanyFormikFieldWithOptionsQueryVariables>(CompanyFormikFieldWithOptionsDocument, options);
        }
export type CompanyFormikFieldWithOptionsQueryHookResult = ReturnType<typeof useCompanyFormikFieldWithOptionsQuery>;
export type CompanyFormikFieldWithOptionsLazyQueryHookResult = ReturnType<typeof useCompanyFormikFieldWithOptionsLazyQuery>;
export type CompanyFormikFieldWithOptionsQueryResult = Apollo.QueryResult<CompanyFormikFieldWithOptionsQuery, CompanyFormikFieldWithOptionsQueryVariables>;
export const CompanyNotesDocument = gql`
    query CompanyNotes($companyUid: ID!, $page: Int = 1, $perPage: Int = 10) {
  companyNotes(companyUid: $companyUid, page: $page, perPage: $perPage) {
    entries {
      ...CompanyNote
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CompanyNoteFragmentDoc}`;

/**
 * __useCompanyNotesQuery__
 *
 * To run a query within a React component, call `useCompanyNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyNotesQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCompanyNotesQuery(baseOptions: Apollo.QueryHookOptions<CompanyNotesQuery, CompanyNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyNotesQuery, CompanyNotesQueryVariables>(CompanyNotesDocument, options);
      }
export function useCompanyNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyNotesQuery, CompanyNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyNotesQuery, CompanyNotesQueryVariables>(CompanyNotesDocument, options);
        }
export type CompanyNotesQueryHookResult = ReturnType<typeof useCompanyNotesQuery>;
export type CompanyNotesLazyQueryHookResult = ReturnType<typeof useCompanyNotesLazyQuery>;
export type CompanyNotesQueryResult = Apollo.QueryResult<CompanyNotesQuery, CompanyNotesQueryVariables>;
export const CompanyOpportunitiesDocument = gql`
    query CompanyOpportunities($companyUid: String, $filter: CompanyOpportunityFiltering) {
  companyOpportunities(companyUid: $companyUid, filter: $filter) {
    entries {
      ...CompanyOpportunityPreview
    }
  }
}
    ${CompanyOpportunityPreviewFragmentDoc}`;

/**
 * __useCompanyOpportunitiesQuery__
 *
 * To run a query within a React component, call `useCompanyOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyOpportunitiesQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCompanyOpportunitiesQuery(baseOptions?: Apollo.QueryHookOptions<CompanyOpportunitiesQuery, CompanyOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyOpportunitiesQuery, CompanyOpportunitiesQueryVariables>(CompanyOpportunitiesDocument, options);
      }
export function useCompanyOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyOpportunitiesQuery, CompanyOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyOpportunitiesQuery, CompanyOpportunitiesQueryVariables>(CompanyOpportunitiesDocument, options);
        }
export type CompanyOpportunitiesQueryHookResult = ReturnType<typeof useCompanyOpportunitiesQuery>;
export type CompanyOpportunitiesLazyQueryHookResult = ReturnType<typeof useCompanyOpportunitiesLazyQuery>;
export type CompanyOpportunitiesQueryResult = Apollo.QueryResult<CompanyOpportunitiesQuery, CompanyOpportunitiesQueryVariables>;
export const CompanyOptionsDocument = gql`
    query CompanyOptions($term: String, $page: Int, $perPage: Int) {
  companies(filter: {term: $term}, page: $page, perPage: $perPage) {
    entries {
      ...CompanyPreview
    }
  }
}
    ${CompanyPreviewFragmentDoc}`;

/**
 * __useCompanyOptionsQuery__
 *
 * To run a query within a React component, call `useCompanyOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyOptionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCompanyOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyOptionsQuery, CompanyOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyOptionsQuery, CompanyOptionsQueryVariables>(CompanyOptionsDocument, options);
      }
export function useCompanyOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyOptionsQuery, CompanyOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyOptionsQuery, CompanyOptionsQueryVariables>(CompanyOptionsDocument, options);
        }
export type CompanyOptionsQueryHookResult = ReturnType<typeof useCompanyOptionsQuery>;
export type CompanyOptionsLazyQueryHookResult = ReturnType<typeof useCompanyOptionsLazyQuery>;
export type CompanyOptionsQueryResult = Apollo.QueryResult<CompanyOptionsQuery, CompanyOptionsQueryVariables>;
export const CompanyRelationshipPartnersDocument = gql`
    query CompanyRelationshipPartners($companyUid: String!, $page: Int = 1, $perPage: Int = 10) {
  companyRelationshipPartners(
    companyUid: $companyUid
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...CompanyRelationshipPartner
    }
  }
}
    ${CompanyRelationshipPartnerFragmentDoc}`;

/**
 * __useCompanyRelationshipPartnersQuery__
 *
 * To run a query within a React component, call `useCompanyRelationshipPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyRelationshipPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyRelationshipPartnersQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCompanyRelationshipPartnersQuery(baseOptions: Apollo.QueryHookOptions<CompanyRelationshipPartnersQuery, CompanyRelationshipPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyRelationshipPartnersQuery, CompanyRelationshipPartnersQueryVariables>(CompanyRelationshipPartnersDocument, options);
      }
export function useCompanyRelationshipPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyRelationshipPartnersQuery, CompanyRelationshipPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyRelationshipPartnersQuery, CompanyRelationshipPartnersQueryVariables>(CompanyRelationshipPartnersDocument, options);
        }
export type CompanyRelationshipPartnersQueryHookResult = ReturnType<typeof useCompanyRelationshipPartnersQuery>;
export type CompanyRelationshipPartnersLazyQueryHookResult = ReturnType<typeof useCompanyRelationshipPartnersLazyQuery>;
export type CompanyRelationshipPartnersQueryResult = Apollo.QueryResult<CompanyRelationshipPartnersQuery, CompanyRelationshipPartnersQueryVariables>;
export const CompanySlideDocument = gql`
    query CompanySlide($uid: String!) {
  company(uid: $uid) {
    ...CompanySlideProfile
  }
}
    ${CompanySlideProfileFragmentDoc}`;

/**
 * __useCompanySlideQuery__
 *
 * To run a query within a React component, call `useCompanySlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySlideQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCompanySlideQuery(baseOptions: Apollo.QueryHookOptions<CompanySlideQuery, CompanySlideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySlideQuery, CompanySlideQueryVariables>(CompanySlideDocument, options);
      }
export function useCompanySlideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySlideQuery, CompanySlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySlideQuery, CompanySlideQueryVariables>(CompanySlideDocument, options);
        }
export type CompanySlideQueryHookResult = ReturnType<typeof useCompanySlideQuery>;
export type CompanySlideLazyQueryHookResult = ReturnType<typeof useCompanySlideLazyQuery>;
export type CompanySlideQueryResult = Apollo.QueryResult<CompanySlideQuery, CompanySlideQueryVariables>;
export const CompanyToUpdateDocument = gql`
    query CompanyToUpdate($uid: String!) {
  company(uid: $uid) {
    domain
    id
    companyType {
      id
      typeName
    }
    companyTypes {
      id
      typeName
    }
    info {
      ...CompanyInfoToUpdate
    }
    externalIdentifier {
      id
      client
      group
    }
  }
}
    ${CompanyInfoToUpdateFragmentDoc}`;

/**
 * __useCompanyToUpdateQuery__
 *
 * To run a query within a React component, call `useCompanyToUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyToUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyToUpdateQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCompanyToUpdateQuery(baseOptions: Apollo.QueryHookOptions<CompanyToUpdateQuery, CompanyToUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyToUpdateQuery, CompanyToUpdateQueryVariables>(CompanyToUpdateDocument, options);
      }
export function useCompanyToUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyToUpdateQuery, CompanyToUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyToUpdateQuery, CompanyToUpdateQueryVariables>(CompanyToUpdateDocument, options);
        }
export type CompanyToUpdateQueryHookResult = ReturnType<typeof useCompanyToUpdateQuery>;
export type CompanyToUpdateLazyQueryHookResult = ReturnType<typeof useCompanyToUpdateLazyQuery>;
export type CompanyToUpdateQueryResult = Apollo.QueryResult<CompanyToUpdateQuery, CompanyToUpdateQueryVariables>;
export const CompanyWhoKnowsDocument = gql`
    query CompanyWhoKnows($contactUid: String!, $filter: WhoKnowsFiltering) {
  whoKnows(contactUid: $contactUid, filter: $filter) {
    entries {
      ...WhoKnowsUser
    }
  }
}
    ${WhoKnowsUserFragmentDoc}`;

/**
 * __useCompanyWhoKnowsQuery__
 *
 * To run a query within a React component, call `useCompanyWhoKnowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyWhoKnowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyWhoKnowsQuery({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCompanyWhoKnowsQuery(baseOptions: Apollo.QueryHookOptions<CompanyWhoKnowsQuery, CompanyWhoKnowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyWhoKnowsQuery, CompanyWhoKnowsQueryVariables>(CompanyWhoKnowsDocument, options);
      }
export function useCompanyWhoKnowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyWhoKnowsQuery, CompanyWhoKnowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyWhoKnowsQuery, CompanyWhoKnowsQueryVariables>(CompanyWhoKnowsDocument, options);
        }
export type CompanyWhoKnowsQueryHookResult = ReturnType<typeof useCompanyWhoKnowsQuery>;
export type CompanyWhoKnowsLazyQueryHookResult = ReturnType<typeof useCompanyWhoKnowsLazyQuery>;
export type CompanyWhoKnowsQueryResult = Apollo.QueryResult<CompanyWhoKnowsQuery, CompanyWhoKnowsQueryVariables>;
export const CreateCompany2Document = gql`
    mutation CreateCompany2($domain: String!, $attributes: CompanyAttributes!, $companyDefaultType: CompanyTypeDefault, $assignedTo: String, $companyTypeUid: ID, $companyTypesUids: [ID!], $externalIdentifier: ExternalIdentifierInput) {
  createCompany(
    domain: $domain
    attributes: $attributes
    companyDefaultType: $companyDefaultType
    assignedTo: $assignedTo
    companyTypeUid: $companyTypeUid
    externalIdentifier: $externalIdentifier
    companyTypesUids: $companyTypesUids
  ) {
    uid
    failReasons
  }
}
    `;
export type CreateCompany2MutationFn = Apollo.MutationFunction<CreateCompany2Mutation, CreateCompany2MutationVariables>;

/**
 * __useCreateCompany2Mutation__
 *
 * To run a mutation, you first call `useCreateCompany2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompany2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompany2Mutation, { data, loading, error }] = useCreateCompany2Mutation({
 *   variables: {
 *      domain: // value for 'domain'
 *      attributes: // value for 'attributes'
 *      companyDefaultType: // value for 'companyDefaultType'
 *      assignedTo: // value for 'assignedTo'
 *      companyTypeUid: // value for 'companyTypeUid'
 *      companyTypesUids: // value for 'companyTypesUids'
 *      externalIdentifier: // value for 'externalIdentifier'
 *   },
 * });
 */
export function useCreateCompany2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateCompany2Mutation, CreateCompany2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompany2Mutation, CreateCompany2MutationVariables>(CreateCompany2Document, options);
      }
export type CreateCompany2MutationHookResult = ReturnType<typeof useCreateCompany2Mutation>;
export type CreateCompany2MutationResult = Apollo.MutationResult<CreateCompany2Mutation>;
export type CreateCompany2MutationOptions = Apollo.BaseMutationOptions<CreateCompany2Mutation, CreateCompany2MutationVariables>;
export const EmployeeCompanyStatsDocument = gql`
    query EmployeeCompanyStats($page: Int = 1, $perPage: Int = 10, $filter: EmployeeCompanyStatsFilteringInput = {}) {
  employeeCompanyStats(filter: $filter, page: $page, perPage: $perPage) {
    entries {
      ...EmployeeCompanyStatsEntry
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${EmployeeCompanyStatsEntryFragmentDoc}`;

/**
 * __useEmployeeCompanyStatsQuery__
 *
 * To run a query within a React component, call `useEmployeeCompanyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeCompanyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeCompanyStatsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmployeeCompanyStatsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeCompanyStatsQuery, EmployeeCompanyStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeCompanyStatsQuery, EmployeeCompanyStatsQueryVariables>(EmployeeCompanyStatsDocument, options);
      }
export function useEmployeeCompanyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeCompanyStatsQuery, EmployeeCompanyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeCompanyStatsQuery, EmployeeCompanyStatsQueryVariables>(EmployeeCompanyStatsDocument, options);
        }
export type EmployeeCompanyStatsQueryHookResult = ReturnType<typeof useEmployeeCompanyStatsQuery>;
export type EmployeeCompanyStatsLazyQueryHookResult = ReturnType<typeof useEmployeeCompanyStatsLazyQuery>;
export type EmployeeCompanyStatsQueryResult = Apollo.QueryResult<EmployeeCompanyStatsQuery, EmployeeCompanyStatsQueryVariables>;
export const ExternalIdentifierConfigurationDocument = gql`
    query ExternalIdentifierConfiguration {
  tenantConfiguration {
    id
    clientAndGroupIds
    preferInternalIndustry
  }
}
    `;

/**
 * __useExternalIdentifierConfigurationQuery__
 *
 * To run a query within a React component, call `useExternalIdentifierConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdentifierConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIdentifierConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useExternalIdentifierConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<ExternalIdentifierConfigurationQuery, ExternalIdentifierConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalIdentifierConfigurationQuery, ExternalIdentifierConfigurationQueryVariables>(ExternalIdentifierConfigurationDocument, options);
      }
export function useExternalIdentifierConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalIdentifierConfigurationQuery, ExternalIdentifierConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalIdentifierConfigurationQuery, ExternalIdentifierConfigurationQueryVariables>(ExternalIdentifierConfigurationDocument, options);
        }
export type ExternalIdentifierConfigurationQueryHookResult = ReturnType<typeof useExternalIdentifierConfigurationQuery>;
export type ExternalIdentifierConfigurationLazyQueryHookResult = ReturnType<typeof useExternalIdentifierConfigurationLazyQuery>;
export type ExternalIdentifierConfigurationQueryResult = Apollo.QueryResult<ExternalIdentifierConfigurationQuery, ExternalIdentifierConfigurationQueryVariables>;
export const GetCompanyMostActiveContactsDocument = gql`
    query GetCompanyMostActiveContacts($domain: String!, $top: Int!) {
  companyContacts(domain: $domain, perPage: $top) {
    entries {
      ...MostActiveContactTableRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${MostActiveContactTableRowFragmentDoc}`;

/**
 * __useGetCompanyMostActiveContactsQuery__
 *
 * To run a query within a React component, call `useGetCompanyMostActiveContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyMostActiveContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyMostActiveContactsQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      top: // value for 'top'
 *   },
 * });
 */
export function useGetCompanyMostActiveContactsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyMostActiveContactsQuery, GetCompanyMostActiveContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyMostActiveContactsQuery, GetCompanyMostActiveContactsQueryVariables>(GetCompanyMostActiveContactsDocument, options);
      }
export function useGetCompanyMostActiveContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyMostActiveContactsQuery, GetCompanyMostActiveContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyMostActiveContactsQuery, GetCompanyMostActiveContactsQueryVariables>(GetCompanyMostActiveContactsDocument, options);
        }
export type GetCompanyMostActiveContactsQueryHookResult = ReturnType<typeof useGetCompanyMostActiveContactsQuery>;
export type GetCompanyMostActiveContactsLazyQueryHookResult = ReturnType<typeof useGetCompanyMostActiveContactsLazyQuery>;
export type GetCompanyMostActiveContactsQueryResult = Apollo.QueryResult<GetCompanyMostActiveContactsQuery, GetCompanyMostActiveContactsQueryVariables>;
export const OfficeLabelsAutocompleteDocument = gql`
    query OfficeLabelsAutocomplete($term: String) {
  officeLabels(term: $term) {
    entries
  }
}
    `;

/**
 * __useOfficeLabelsAutocompleteQuery__
 *
 * To run a query within a React component, call `useOfficeLabelsAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeLabelsAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeLabelsAutocompleteQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useOfficeLabelsAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<OfficeLabelsAutocompleteQuery, OfficeLabelsAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeLabelsAutocompleteQuery, OfficeLabelsAutocompleteQueryVariables>(OfficeLabelsAutocompleteDocument, options);
      }
export function useOfficeLabelsAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeLabelsAutocompleteQuery, OfficeLabelsAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeLabelsAutocompleteQuery, OfficeLabelsAutocompleteQueryVariables>(OfficeLabelsAutocompleteDocument, options);
        }
export type OfficeLabelsAutocompleteQueryHookResult = ReturnType<typeof useOfficeLabelsAutocompleteQuery>;
export type OfficeLabelsAutocompleteLazyQueryHookResult = ReturnType<typeof useOfficeLabelsAutocompleteLazyQuery>;
export type OfficeLabelsAutocompleteQueryResult = Apollo.QueryResult<OfficeLabelsAutocompleteQuery, OfficeLabelsAutocompleteQueryVariables>;
export const ReportIncorrectCompanyInfoDocument = gql`
    mutation ReportIncorrectCompanyInfo($companyUid: ID!, $fields: [String!], $comment: String) {
  reportIncorrectCompanyData(
    companyUid: $companyUid
    fields: $fields
    comment: $comment
  ) {
    failReasons
  }
}
    `;
export type ReportIncorrectCompanyInfoMutationFn = Apollo.MutationFunction<ReportIncorrectCompanyInfoMutation, ReportIncorrectCompanyInfoMutationVariables>;

/**
 * __useReportIncorrectCompanyInfoMutation__
 *
 * To run a mutation, you first call `useReportIncorrectCompanyInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportIncorrectCompanyInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportIncorrectCompanyInfoMutation, { data, loading, error }] = useReportIncorrectCompanyInfoMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      fields: // value for 'fields'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useReportIncorrectCompanyInfoMutation(baseOptions?: Apollo.MutationHookOptions<ReportIncorrectCompanyInfoMutation, ReportIncorrectCompanyInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportIncorrectCompanyInfoMutation, ReportIncorrectCompanyInfoMutationVariables>(ReportIncorrectCompanyInfoDocument, options);
      }
export type ReportIncorrectCompanyInfoMutationHookResult = ReturnType<typeof useReportIncorrectCompanyInfoMutation>;
export type ReportIncorrectCompanyInfoMutationResult = Apollo.MutationResult<ReportIncorrectCompanyInfoMutation>;
export type ReportIncorrectCompanyInfoMutationOptions = Apollo.BaseMutationOptions<ReportIncorrectCompanyInfoMutation, ReportIncorrectCompanyInfoMutationVariables>;
export const TabsCompanyOpportunitiesCountDocument = gql`
    query TabsCompanyOpportunitiesCount($companyUid: String!, $filter: CompanyOpportunityFiltering) {
  companyOpportunities(companyUid: $companyUid, filter: $filter) {
    entries {
      id
    }
  }
}
    `;

/**
 * __useTabsCompanyOpportunitiesCountQuery__
 *
 * To run a query within a React component, call `useTabsCompanyOpportunitiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTabsCompanyOpportunitiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTabsCompanyOpportunitiesCountQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTabsCompanyOpportunitiesCountQuery(baseOptions: Apollo.QueryHookOptions<TabsCompanyOpportunitiesCountQuery, TabsCompanyOpportunitiesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TabsCompanyOpportunitiesCountQuery, TabsCompanyOpportunitiesCountQueryVariables>(TabsCompanyOpportunitiesCountDocument, options);
      }
export function useTabsCompanyOpportunitiesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TabsCompanyOpportunitiesCountQuery, TabsCompanyOpportunitiesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TabsCompanyOpportunitiesCountQuery, TabsCompanyOpportunitiesCountQueryVariables>(TabsCompanyOpportunitiesCountDocument, options);
        }
export type TabsCompanyOpportunitiesCountQueryHookResult = ReturnType<typeof useTabsCompanyOpportunitiesCountQuery>;
export type TabsCompanyOpportunitiesCountLazyQueryHookResult = ReturnType<typeof useTabsCompanyOpportunitiesCountLazyQuery>;
export type TabsCompanyOpportunitiesCountQueryResult = Apollo.QueryResult<TabsCompanyOpportunitiesCountQuery, TabsCompanyOpportunitiesCountQueryVariables>;
export const TabsCompanyPendingTasksCountDocument = gql`
    query TabsCompanyPendingTasksCount($filter: TaskFiltering, $page: Int = 1, $perPage: Int = 10) {
  tasks(filter: $filter, page: $page, perPage: $perPage) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useTabsCompanyPendingTasksCountQuery__
 *
 * To run a query within a React component, call `useTabsCompanyPendingTasksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTabsCompanyPendingTasksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTabsCompanyPendingTasksCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useTabsCompanyPendingTasksCountQuery(baseOptions?: Apollo.QueryHookOptions<TabsCompanyPendingTasksCountQuery, TabsCompanyPendingTasksCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TabsCompanyPendingTasksCountQuery, TabsCompanyPendingTasksCountQueryVariables>(TabsCompanyPendingTasksCountDocument, options);
      }
export function useTabsCompanyPendingTasksCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TabsCompanyPendingTasksCountQuery, TabsCompanyPendingTasksCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TabsCompanyPendingTasksCountQuery, TabsCompanyPendingTasksCountQueryVariables>(TabsCompanyPendingTasksCountDocument, options);
        }
export type TabsCompanyPendingTasksCountQueryHookResult = ReturnType<typeof useTabsCompanyPendingTasksCountQuery>;
export type TabsCompanyPendingTasksCountLazyQueryHookResult = ReturnType<typeof useTabsCompanyPendingTasksCountLazyQuery>;
export type TabsCompanyPendingTasksCountQueryResult = Apollo.QueryResult<TabsCompanyPendingTasksCountQuery, TabsCompanyPendingTasksCountQueryVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($uid: ID!, $attributes: CompanyAttributes!, $companyTypeUid: ID, $companyTypesUids: [ID!], $externalIdentifier: ExternalIdentifierInput) {
  updateCompany(
    uid: $uid
    attributes: $attributes
    companyTypeUid: $companyTypeUid
    externalIdentifier: $externalIdentifier
    companyTypesUids: $companyTypesUids
  ) {
    failReasons
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *      companyTypeUid: // value for 'companyTypeUid'
 *      companyTypesUids: // value for 'companyTypesUids'
 *      externalIdentifier: // value for 'externalIdentifier'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateCompanyDetailsDocument = gql`
    mutation UpdateCompanyDetails($uid: ID!, $attributes: CompanyAttributes!, $companyTypeUid: ID, $externalIdentifier: ExternalIdentifierInput) {
  updateCompany(
    uid: $uid
    attributes: $attributes
    companyTypeUid: $companyTypeUid
    externalIdentifier: $externalIdentifier
  ) {
    failReasons
    companyUpdated: record {
      id
      companyType {
        id
      }
    }
  }
}
    `;
export type UpdateCompanyDetailsMutationFn = Apollo.MutationFunction<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables>;

/**
 * __useUpdateCompanyDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyDetailsMutation, { data, loading, error }] = useUpdateCompanyDetailsMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *      companyTypeUid: // value for 'companyTypeUid'
 *      externalIdentifier: // value for 'externalIdentifier'
 *   },
 * });
 */
export function useUpdateCompanyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables>(UpdateCompanyDetailsDocument, options);
      }
export type UpdateCompanyDetailsMutationHookResult = ReturnType<typeof useUpdateCompanyDetailsMutation>;
export type UpdateCompanyDetailsMutationResult = Apollo.MutationResult<UpdateCompanyDetailsMutation>;
export type UpdateCompanyDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables>;
export const UpdateCompanyIndustryDocument = gql`
    mutation UpdateCompanyIndustry($uid: ID!, $attributes: CompanyAttributes!) {
  updateCompany(uid: $uid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type UpdateCompanyIndustryMutationFn = Apollo.MutationFunction<UpdateCompanyIndustryMutation, UpdateCompanyIndustryMutationVariables>;

/**
 * __useUpdateCompanyIndustryMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyIndustryMutation, { data, loading, error }] = useUpdateCompanyIndustryMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateCompanyIndustryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyIndustryMutation, UpdateCompanyIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyIndustryMutation, UpdateCompanyIndustryMutationVariables>(UpdateCompanyIndustryDocument, options);
      }
export type UpdateCompanyIndustryMutationHookResult = ReturnType<typeof useUpdateCompanyIndustryMutation>;
export type UpdateCompanyIndustryMutationResult = Apollo.MutationResult<UpdateCompanyIndustryMutation>;
export type UpdateCompanyIndustryMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyIndustryMutation, UpdateCompanyIndustryMutationVariables>;
export const UpdateCompanyTypesDocument = gql`
    mutation UpdateCompanyTypes($uid: ID!, $companyTypeUids: [ID!]!) {
  updateCompany(uid: $uid, companyTypesUids: $companyTypeUids) {
    failReasons
  }
}
    `;
export type UpdateCompanyTypesMutationFn = Apollo.MutationFunction<UpdateCompanyTypesMutation, UpdateCompanyTypesMutationVariables>;

/**
 * __useUpdateCompanyTypesMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyTypesMutation, { data, loading, error }] = useUpdateCompanyTypesMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      companyTypeUids: // value for 'companyTypeUids'
 *   },
 * });
 */
export function useUpdateCompanyTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyTypesMutation, UpdateCompanyTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyTypesMutation, UpdateCompanyTypesMutationVariables>(UpdateCompanyTypesDocument, options);
      }
export type UpdateCompanyTypesMutationHookResult = ReturnType<typeof useUpdateCompanyTypesMutation>;
export type UpdateCompanyTypesMutationResult = Apollo.MutationResult<UpdateCompanyTypesMutation>;
export type UpdateCompanyTypesMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyTypesMutation, UpdateCompanyTypesMutationVariables>;
export const UpdateCompanyTypesDataDocument = gql`
    query UpdateCompanyTypesData($companyUid: String!) {
  company(uid: $companyUid) {
    id
    companyTypes {
      id
      typeName
    }
  }
}
    `;

/**
 * __useUpdateCompanyTypesDataQuery__
 *
 * To run a query within a React component, call `useUpdateCompanyTypesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyTypesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateCompanyTypesDataQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *   },
 * });
 */
export function useUpdateCompanyTypesDataQuery(baseOptions: Apollo.QueryHookOptions<UpdateCompanyTypesDataQuery, UpdateCompanyTypesDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateCompanyTypesDataQuery, UpdateCompanyTypesDataQueryVariables>(UpdateCompanyTypesDataDocument, options);
      }
export function useUpdateCompanyTypesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateCompanyTypesDataQuery, UpdateCompanyTypesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateCompanyTypesDataQuery, UpdateCompanyTypesDataQueryVariables>(UpdateCompanyTypesDataDocument, options);
        }
export type UpdateCompanyTypesDataQueryHookResult = ReturnType<typeof useUpdateCompanyTypesDataQuery>;
export type UpdateCompanyTypesDataLazyQueryHookResult = ReturnType<typeof useUpdateCompanyTypesDataLazyQuery>;
export type UpdateCompanyTypesDataQueryResult = Apollo.QueryResult<UpdateCompanyTypesDataQuery, UpdateCompanyTypesDataQueryVariables>;
export const CompanyAuditTrailDocument = gql`
    query CompanyAuditTrail($company_uid: ID!) {
  companyAuditTrail(companyUid: $company_uid) {
    entries {
      ...Audit
    }
  }
}
    ${AuditFragmentDoc}`;

/**
 * __useCompanyAuditTrailQuery__
 *
 * To run a query within a React component, call `useCompanyAuditTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAuditTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAuditTrailQuery({
 *   variables: {
 *      company_uid: // value for 'company_uid'
 *   },
 * });
 */
export function useCompanyAuditTrailQuery(baseOptions: Apollo.QueryHookOptions<CompanyAuditTrailQuery, CompanyAuditTrailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAuditTrailQuery, CompanyAuditTrailQueryVariables>(CompanyAuditTrailDocument, options);
      }
export function useCompanyAuditTrailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAuditTrailQuery, CompanyAuditTrailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAuditTrailQuery, CompanyAuditTrailQueryVariables>(CompanyAuditTrailDocument, options);
        }
export type CompanyAuditTrailQueryHookResult = ReturnType<typeof useCompanyAuditTrailQuery>;
export type CompanyAuditTrailLazyQueryHookResult = ReturnType<typeof useCompanyAuditTrailLazyQuery>;
export type CompanyAuditTrailQueryResult = Apollo.QueryResult<CompanyAuditTrailQuery, CompanyAuditTrailQueryVariables>;
export const BlockCompanyDocument = gql`
    mutation BlockCompany($id: ID!) {
  blockCompany(uid: $id) {
    failReasons
  }
}
    `;
export type BlockCompanyMutationFn = Apollo.MutationFunction<BlockCompanyMutation, BlockCompanyMutationVariables>;

/**
 * __useBlockCompanyMutation__
 *
 * To run a mutation, you first call `useBlockCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCompanyMutation, { data, loading, error }] = useBlockCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockCompanyMutation(baseOptions?: Apollo.MutationHookOptions<BlockCompanyMutation, BlockCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCompanyMutation, BlockCompanyMutationVariables>(BlockCompanyDocument, options);
      }
export type BlockCompanyMutationHookResult = ReturnType<typeof useBlockCompanyMutation>;
export type BlockCompanyMutationResult = Apollo.MutationResult<BlockCompanyMutation>;
export type BlockCompanyMutationOptions = Apollo.BaseMutationOptions<BlockCompanyMutation, BlockCompanyMutationVariables>;
export const UnBlockCompanyDocument = gql`
    mutation UnBlockCompany($id: ID!) {
  unblockCompany(uid: $id) {
    failReasons
  }
}
    `;
export type UnBlockCompanyMutationFn = Apollo.MutationFunction<UnBlockCompanyMutation, UnBlockCompanyMutationVariables>;

/**
 * __useUnBlockCompanyMutation__
 *
 * To run a mutation, you first call `useUnBlockCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnBlockCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unBlockCompanyMutation, { data, loading, error }] = useUnBlockCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnBlockCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UnBlockCompanyMutation, UnBlockCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnBlockCompanyMutation, UnBlockCompanyMutationVariables>(UnBlockCompanyDocument, options);
      }
export type UnBlockCompanyMutationHookResult = ReturnType<typeof useUnBlockCompanyMutation>;
export type UnBlockCompanyMutationResult = Apollo.MutationResult<UnBlockCompanyMutation>;
export type UnBlockCompanyMutationOptions = Apollo.BaseMutationOptions<UnBlockCompanyMutation, UnBlockCompanyMutationVariables>;
export const CompanyConnectionsDocument = gql`
    query CompanyConnections($companyUid: String!, $page: Int, $perPage: Int) {
  companyConnections(companyUid: $companyUid, page: $page, perPage: $perPage) {
    entries {
      ...CompanyConnectionRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CompanyConnectionRowFragmentDoc}`;

/**
 * __useCompanyConnectionsQuery__
 *
 * To run a query within a React component, call `useCompanyConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyConnectionsQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCompanyConnectionsQuery(baseOptions: Apollo.QueryHookOptions<CompanyConnectionsQuery, CompanyConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyConnectionsQuery, CompanyConnectionsQueryVariables>(CompanyConnectionsDocument, options);
      }
export function useCompanyConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyConnectionsQuery, CompanyConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyConnectionsQuery, CompanyConnectionsQueryVariables>(CompanyConnectionsDocument, options);
        }
export type CompanyConnectionsQueryHookResult = ReturnType<typeof useCompanyConnectionsQuery>;
export type CompanyConnectionsLazyQueryHookResult = ReturnType<typeof useCompanyConnectionsLazyQuery>;
export type CompanyConnectionsQueryResult = Apollo.QueryResult<CompanyConnectionsQuery, CompanyConnectionsQueryVariables>;
export const CompanyFilterWithOptionsDocument = gql`
    query CompanyFilterWithOptions($term: String, $page: Int, $perPage: Int) {
  companies(filter: {term: $term}, page: $page, perPage: $perPage) {
    entries {
      ...CompanyFilterWithOptions
    }
  }
}
    ${CompanyFilterWithOptionsFragmentDoc}`;

/**
 * __useCompanyFilterWithOptionsQuery__
 *
 * To run a query within a React component, call `useCompanyFilterWithOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFilterWithOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFilterWithOptionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCompanyFilterWithOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyFilterWithOptionsQuery, CompanyFilterWithOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyFilterWithOptionsQuery, CompanyFilterWithOptionsQueryVariables>(CompanyFilterWithOptionsDocument, options);
      }
export function useCompanyFilterWithOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyFilterWithOptionsQuery, CompanyFilterWithOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyFilterWithOptionsQuery, CompanyFilterWithOptionsQueryVariables>(CompanyFilterWithOptionsDocument, options);
        }
export type CompanyFilterWithOptionsQueryHookResult = ReturnType<typeof useCompanyFilterWithOptionsQuery>;
export type CompanyFilterWithOptionsLazyQueryHookResult = ReturnType<typeof useCompanyFilterWithOptionsLazyQuery>;
export type CompanyFilterWithOptionsQueryResult = Apollo.QueryResult<CompanyFilterWithOptionsQuery, CompanyFilterWithOptionsQueryVariables>;
export const CompanyHierarchyByUidsDocument = gql`
    query CompanyHierarchyByUids($companyUids: [ID!]) {
  companies(filter: {companyUids: $companyUids}) {
    entries {
      ...CompanyHierarchyByUids
    }
  }
}
    ${CompanyHierarchyByUidsFragmentDoc}`;

/**
 * __useCompanyHierarchyByUidsQuery__
 *
 * To run a query within a React component, call `useCompanyHierarchyByUidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHierarchyByUidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHierarchyByUidsQuery({
 *   variables: {
 *      companyUids: // value for 'companyUids'
 *   },
 * });
 */
export function useCompanyHierarchyByUidsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyHierarchyByUidsQuery, CompanyHierarchyByUidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyHierarchyByUidsQuery, CompanyHierarchyByUidsQueryVariables>(CompanyHierarchyByUidsDocument, options);
      }
export function useCompanyHierarchyByUidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyHierarchyByUidsQuery, CompanyHierarchyByUidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyHierarchyByUidsQuery, CompanyHierarchyByUidsQueryVariables>(CompanyHierarchyByUidsDocument, options);
        }
export type CompanyHierarchyByUidsQueryHookResult = ReturnType<typeof useCompanyHierarchyByUidsQuery>;
export type CompanyHierarchyByUidsLazyQueryHookResult = ReturnType<typeof useCompanyHierarchyByUidsLazyQuery>;
export type CompanyHierarchyByUidsQueryResult = Apollo.QueryResult<CompanyHierarchyByUidsQuery, CompanyHierarchyByUidsQueryVariables>;
export const AddCompanyToAssociationDocument = gql`
    mutation AddCompanyToAssociation($associationUuid: ID!, $companyName: String!, $companyDomain: String, $position: Int) {
  addCompanyToAssociation(
    associationUuid: $associationUuid
    companyName: $companyName
    companyDomain: $companyDomain
    position: $position
  ) {
    failReasons
  }
}
    `;
export type AddCompanyToAssociationMutationFn = Apollo.MutationFunction<AddCompanyToAssociationMutation, AddCompanyToAssociationMutationVariables>;

/**
 * __useAddCompanyToAssociationMutation__
 *
 * To run a mutation, you first call `useAddCompanyToAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyToAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyToAssociationMutation, { data, loading, error }] = useAddCompanyToAssociationMutation({
 *   variables: {
 *      associationUuid: // value for 'associationUuid'
 *      companyName: // value for 'companyName'
 *      companyDomain: // value for 'companyDomain'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useAddCompanyToAssociationMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyToAssociationMutation, AddCompanyToAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyToAssociationMutation, AddCompanyToAssociationMutationVariables>(AddCompanyToAssociationDocument, options);
      }
export type AddCompanyToAssociationMutationHookResult = ReturnType<typeof useAddCompanyToAssociationMutation>;
export type AddCompanyToAssociationMutationResult = Apollo.MutationResult<AddCompanyToAssociationMutation>;
export type AddCompanyToAssociationMutationOptions = Apollo.BaseMutationOptions<AddCompanyToAssociationMutation, AddCompanyToAssociationMutationVariables>;
export const AddCompanyToHierarchyDocument = gql`
    mutation AddCompanyToHierarchy($parentUuid: ID!, $companyName: String!, $companyDomain: String, $position: Int) {
  addCompanyToHierarchy(
    parentUuid: $parentUuid
    companyName: $companyName
    companyDomain: $companyDomain
    position: $position
  ) {
    failReasons
  }
}
    `;
export type AddCompanyToHierarchyMutationFn = Apollo.MutationFunction<AddCompanyToHierarchyMutation, AddCompanyToHierarchyMutationVariables>;

/**
 * __useAddCompanyToHierarchyMutation__
 *
 * To run a mutation, you first call `useAddCompanyToHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyToHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyToHierarchyMutation, { data, loading, error }] = useAddCompanyToHierarchyMutation({
 *   variables: {
 *      parentUuid: // value for 'parentUuid'
 *      companyName: // value for 'companyName'
 *      companyDomain: // value for 'companyDomain'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useAddCompanyToHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyToHierarchyMutation, AddCompanyToHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyToHierarchyMutation, AddCompanyToHierarchyMutationVariables>(AddCompanyToHierarchyDocument, options);
      }
export type AddCompanyToHierarchyMutationHookResult = ReturnType<typeof useAddCompanyToHierarchyMutation>;
export type AddCompanyToHierarchyMutationResult = Apollo.MutationResult<AddCompanyToHierarchyMutation>;
export type AddCompanyToHierarchyMutationOptions = Apollo.BaseMutationOptions<AddCompanyToHierarchyMutation, AddCompanyToHierarchyMutationVariables>;
export const AddContactsToHierarchyDocument = gql`
    mutation AddContactsToHierarchy($contactEmails: [String!]!, $companyUuid: String) {
  addContactsToHierarchy(contactEmails: $contactEmails, companyUuid: $companyUuid) {
    failReasons
  }
}
    `;
export type AddContactsToHierarchyMutationFn = Apollo.MutationFunction<AddContactsToHierarchyMutation, AddContactsToHierarchyMutationVariables>;

/**
 * __useAddContactsToHierarchyMutation__
 *
 * To run a mutation, you first call `useAddContactsToHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactsToHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactsToHierarchyMutation, { data, loading, error }] = useAddContactsToHierarchyMutation({
 *   variables: {
 *      contactEmails: // value for 'contactEmails'
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useAddContactsToHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<AddContactsToHierarchyMutation, AddContactsToHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactsToHierarchyMutation, AddContactsToHierarchyMutationVariables>(AddContactsToHierarchyDocument, options);
      }
export type AddContactsToHierarchyMutationHookResult = ReturnType<typeof useAddContactsToHierarchyMutation>;
export type AddContactsToHierarchyMutationResult = Apollo.MutationResult<AddContactsToHierarchyMutation>;
export type AddContactsToHierarchyMutationOptions = Apollo.BaseMutationOptions<AddContactsToHierarchyMutation, AddContactsToHierarchyMutationVariables>;
export const AddContactsWithCompanyToHierarchyDocument = gql`
    mutation AddContactsWithCompanyToHierarchy($contactEmails: [String!]!, $parentUuid: String, $companyDomain: String, $companyName: String!) {
  addContactsWithCompanyToHierarchy(
    contactEmails: $contactEmails
    parentUuid: $parentUuid
    companyDomain: $companyDomain
    companyName: $companyName
  ) {
    failReasons
  }
}
    `;
export type AddContactsWithCompanyToHierarchyMutationFn = Apollo.MutationFunction<AddContactsWithCompanyToHierarchyMutation, AddContactsWithCompanyToHierarchyMutationVariables>;

/**
 * __useAddContactsWithCompanyToHierarchyMutation__
 *
 * To run a mutation, you first call `useAddContactsWithCompanyToHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactsWithCompanyToHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactsWithCompanyToHierarchyMutation, { data, loading, error }] = useAddContactsWithCompanyToHierarchyMutation({
 *   variables: {
 *      contactEmails: // value for 'contactEmails'
 *      parentUuid: // value for 'parentUuid'
 *      companyDomain: // value for 'companyDomain'
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function useAddContactsWithCompanyToHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<AddContactsWithCompanyToHierarchyMutation, AddContactsWithCompanyToHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactsWithCompanyToHierarchyMutation, AddContactsWithCompanyToHierarchyMutationVariables>(AddContactsWithCompanyToHierarchyDocument, options);
      }
export type AddContactsWithCompanyToHierarchyMutationHookResult = ReturnType<typeof useAddContactsWithCompanyToHierarchyMutation>;
export type AddContactsWithCompanyToHierarchyMutationResult = Apollo.MutationResult<AddContactsWithCompanyToHierarchyMutation>;
export type AddContactsWithCompanyToHierarchyMutationOptions = Apollo.BaseMutationOptions<AddContactsWithCompanyToHierarchyMutation, AddContactsWithCompanyToHierarchyMutationVariables>;
export const BulkAssociateCompaniesDocument = gql`
    mutation BulkAssociateCompanies($companyUuids: [ID!]!) {
  bulkAssociateCompanies(companyUuids: $companyUuids) {
    failReasons
  }
}
    `;
export type BulkAssociateCompaniesMutationFn = Apollo.MutationFunction<BulkAssociateCompaniesMutation, BulkAssociateCompaniesMutationVariables>;

/**
 * __useBulkAssociateCompaniesMutation__
 *
 * To run a mutation, you first call `useBulkAssociateCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssociateCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssociateCompaniesMutation, { data, loading, error }] = useBulkAssociateCompaniesMutation({
 *   variables: {
 *      companyUuids: // value for 'companyUuids'
 *   },
 * });
 */
export function useBulkAssociateCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssociateCompaniesMutation, BulkAssociateCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssociateCompaniesMutation, BulkAssociateCompaniesMutationVariables>(BulkAssociateCompaniesDocument, options);
      }
export type BulkAssociateCompaniesMutationHookResult = ReturnType<typeof useBulkAssociateCompaniesMutation>;
export type BulkAssociateCompaniesMutationResult = Apollo.MutationResult<BulkAssociateCompaniesMutation>;
export type BulkAssociateCompaniesMutationOptions = Apollo.BaseMutationOptions<BulkAssociateCompaniesMutation, BulkAssociateCompaniesMutationVariables>;
export const CompanyHierarchyDocument = gql`
    query CompanyHierarchy($companyUid: ID!) {
  companyHierarchy(companyUid: $companyUid) {
    entries {
      ...CompanyHierarchyEntry
    }
  }
  currentTenant {
    id
    companyHierarchyCustomFields {
      ...CustomFieldSchema
    }
  }
}
    ${CompanyHierarchyEntryFragmentDoc}
${CustomFieldSchemaFragmentDoc}`;

/**
 * __useCompanyHierarchyQuery__
 *
 * To run a query within a React component, call `useCompanyHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHierarchyQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *   },
 * });
 */
export function useCompanyHierarchyQuery(baseOptions: Apollo.QueryHookOptions<CompanyHierarchyQuery, CompanyHierarchyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyHierarchyQuery, CompanyHierarchyQueryVariables>(CompanyHierarchyDocument, options);
      }
export function useCompanyHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyHierarchyQuery, CompanyHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyHierarchyQuery, CompanyHierarchyQueryVariables>(CompanyHierarchyDocument, options);
        }
export type CompanyHierarchyQueryHookResult = ReturnType<typeof useCompanyHierarchyQuery>;
export type CompanyHierarchyLazyQueryHookResult = ReturnType<typeof useCompanyHierarchyLazyQuery>;
export type CompanyHierarchyQueryResult = Apollo.QueryResult<CompanyHierarchyQuery, CompanyHierarchyQueryVariables>;
export const CompanyHierarchyCountDocument = gql`
    query CompanyHierarchyCount($companyUid: ID!) {
  companyHierarchy(companyUid: $companyUid) {
    count
  }
}
    `;

/**
 * __useCompanyHierarchyCountQuery__
 *
 * To run a query within a React component, call `useCompanyHierarchyCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHierarchyCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHierarchyCountQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *   },
 * });
 */
export function useCompanyHierarchyCountQuery(baseOptions: Apollo.QueryHookOptions<CompanyHierarchyCountQuery, CompanyHierarchyCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyHierarchyCountQuery, CompanyHierarchyCountQueryVariables>(CompanyHierarchyCountDocument, options);
      }
export function useCompanyHierarchyCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyHierarchyCountQuery, CompanyHierarchyCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyHierarchyCountQuery, CompanyHierarchyCountQueryVariables>(CompanyHierarchyCountDocument, options);
        }
export type CompanyHierarchyCountQueryHookResult = ReturnType<typeof useCompanyHierarchyCountQuery>;
export type CompanyHierarchyCountLazyQueryHookResult = ReturnType<typeof useCompanyHierarchyCountLazyQuery>;
export type CompanyHierarchyCountQueryResult = Apollo.QueryResult<CompanyHierarchyCountQuery, CompanyHierarchyCountQueryVariables>;
export const CompanyHierarchyOptionsDocument = gql`
    query CompanyHierarchyOptions($companyUid: ID!) {
  companyHierarchy(companyUid: $companyUid) {
    entries {
      ...CompanyHierarchyOption
    }
  }
}
    ${CompanyHierarchyOptionFragmentDoc}`;

/**
 * __useCompanyHierarchyOptionsQuery__
 *
 * To run a query within a React component, call `useCompanyHierarchyOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHierarchyOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHierarchyOptionsQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *   },
 * });
 */
export function useCompanyHierarchyOptionsQuery(baseOptions: Apollo.QueryHookOptions<CompanyHierarchyOptionsQuery, CompanyHierarchyOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyHierarchyOptionsQuery, CompanyHierarchyOptionsQueryVariables>(CompanyHierarchyOptionsDocument, options);
      }
export function useCompanyHierarchyOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyHierarchyOptionsQuery, CompanyHierarchyOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyHierarchyOptionsQuery, CompanyHierarchyOptionsQueryVariables>(CompanyHierarchyOptionsDocument, options);
        }
export type CompanyHierarchyOptionsQueryHookResult = ReturnType<typeof useCompanyHierarchyOptionsQuery>;
export type CompanyHierarchyOptionsLazyQueryHookResult = ReturnType<typeof useCompanyHierarchyOptionsLazyQuery>;
export type CompanyHierarchyOptionsQueryResult = Apollo.QueryResult<CompanyHierarchyOptionsQuery, CompanyHierarchyOptionsQueryVariables>;
export const MoveCompaniesToHierarchyDocument = gql`
    mutation MoveCompaniesToHierarchy($companyUuids: [ID!]!, $parentUuid: ID!) {
  moveCompaniesToHierarchy(parentUuid: $parentUuid, companyUuids: $companyUuids) {
    failReasons
  }
}
    `;
export type MoveCompaniesToHierarchyMutationFn = Apollo.MutationFunction<MoveCompaniesToHierarchyMutation, MoveCompaniesToHierarchyMutationVariables>;

/**
 * __useMoveCompaniesToHierarchyMutation__
 *
 * To run a mutation, you first call `useMoveCompaniesToHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCompaniesToHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCompaniesToHierarchyMutation, { data, loading, error }] = useMoveCompaniesToHierarchyMutation({
 *   variables: {
 *      companyUuids: // value for 'companyUuids'
 *      parentUuid: // value for 'parentUuid'
 *   },
 * });
 */
export function useMoveCompaniesToHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<MoveCompaniesToHierarchyMutation, MoveCompaniesToHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveCompaniesToHierarchyMutation, MoveCompaniesToHierarchyMutationVariables>(MoveCompaniesToHierarchyDocument, options);
      }
export type MoveCompaniesToHierarchyMutationHookResult = ReturnType<typeof useMoveCompaniesToHierarchyMutation>;
export type MoveCompaniesToHierarchyMutationResult = Apollo.MutationResult<MoveCompaniesToHierarchyMutation>;
export type MoveCompaniesToHierarchyMutationOptions = Apollo.BaseMutationOptions<MoveCompaniesToHierarchyMutation, MoveCompaniesToHierarchyMutationVariables>;
export const RemoveCompanyFromHierarchyDocument = gql`
    mutation RemoveCompanyFromHierarchy($companyUuid: String!) {
  removeCompanyFromHierarchy(companyUuid: $companyUuid) {
    failReasons
  }
}
    `;
export type RemoveCompanyFromHierarchyMutationFn = Apollo.MutationFunction<RemoveCompanyFromHierarchyMutation, RemoveCompanyFromHierarchyMutationVariables>;

/**
 * __useRemoveCompanyFromHierarchyMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyFromHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyFromHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyFromHierarchyMutation, { data, loading, error }] = useRemoveCompanyFromHierarchyMutation({
 *   variables: {
 *      companyUuid: // value for 'companyUuid'
 *   },
 * });
 */
export function useRemoveCompanyFromHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyFromHierarchyMutation, RemoveCompanyFromHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyFromHierarchyMutation, RemoveCompanyFromHierarchyMutationVariables>(RemoveCompanyFromHierarchyDocument, options);
      }
export type RemoveCompanyFromHierarchyMutationHookResult = ReturnType<typeof useRemoveCompanyFromHierarchyMutation>;
export type RemoveCompanyFromHierarchyMutationResult = Apollo.MutationResult<RemoveCompanyFromHierarchyMutation>;
export type RemoveCompanyFromHierarchyMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyFromHierarchyMutation, RemoveCompanyFromHierarchyMutationVariables>;
export const RemoveContactFromRequireHierarchyPlacementDocument = gql`
    mutation RemoveContactFromRequireHierarchyPlacement($contactUid: ID!) {
  removeContactFromRequireHierarchyPlacement(contactUid: $contactUid) {
    failReasons
  }
}
    `;
export type RemoveContactFromRequireHierarchyPlacementMutationFn = Apollo.MutationFunction<RemoveContactFromRequireHierarchyPlacementMutation, RemoveContactFromRequireHierarchyPlacementMutationVariables>;

/**
 * __useRemoveContactFromRequireHierarchyPlacementMutation__
 *
 * To run a mutation, you first call `useRemoveContactFromRequireHierarchyPlacementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactFromRequireHierarchyPlacementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactFromRequireHierarchyPlacementMutation, { data, loading, error }] = useRemoveContactFromRequireHierarchyPlacementMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useRemoveContactFromRequireHierarchyPlacementMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContactFromRequireHierarchyPlacementMutation, RemoveContactFromRequireHierarchyPlacementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContactFromRequireHierarchyPlacementMutation, RemoveContactFromRequireHierarchyPlacementMutationVariables>(RemoveContactFromRequireHierarchyPlacementDocument, options);
      }
export type RemoveContactFromRequireHierarchyPlacementMutationHookResult = ReturnType<typeof useRemoveContactFromRequireHierarchyPlacementMutation>;
export type RemoveContactFromRequireHierarchyPlacementMutationResult = Apollo.MutationResult<RemoveContactFromRequireHierarchyPlacementMutation>;
export type RemoveContactFromRequireHierarchyPlacementMutationOptions = Apollo.BaseMutationOptions<RemoveContactFromRequireHierarchyPlacementMutation, RemoveContactFromRequireHierarchyPlacementMutationVariables>;
export const SyncCompanyHierarchyDocument = gql`
    mutation SyncCompanyHierarchy($companyHierarchy: [HierarchyInput!]!) {
  syncCompanyHierarchy(companyHierarchy: $companyHierarchy) {
    failReasons
  }
}
    `;
export type SyncCompanyHierarchyMutationFn = Apollo.MutationFunction<SyncCompanyHierarchyMutation, SyncCompanyHierarchyMutationVariables>;

/**
 * __useSyncCompanyHierarchyMutation__
 *
 * To run a mutation, you first call `useSyncCompanyHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCompanyHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCompanyHierarchyMutation, { data, loading, error }] = useSyncCompanyHierarchyMutation({
 *   variables: {
 *      companyHierarchy: // value for 'companyHierarchy'
 *   },
 * });
 */
export function useSyncCompanyHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<SyncCompanyHierarchyMutation, SyncCompanyHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncCompanyHierarchyMutation, SyncCompanyHierarchyMutationVariables>(SyncCompanyHierarchyDocument, options);
      }
export type SyncCompanyHierarchyMutationHookResult = ReturnType<typeof useSyncCompanyHierarchyMutation>;
export type SyncCompanyHierarchyMutationResult = Apollo.MutationResult<SyncCompanyHierarchyMutation>;
export type SyncCompanyHierarchyMutationOptions = Apollo.BaseMutationOptions<SyncCompanyHierarchyMutation, SyncCompanyHierarchyMutationVariables>;
export const UpdateCompanyHierarchyCustomFieldsDocument = gql`
    mutation UpdateCompanyHierarchyCustomFields($companyUid: ID!, $customFieldAttributes: [CustomFieldAttribute!]!) {
  updateCompanyHierarchy(
    companyUid: $companyUid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
  }
}
    `;
export type UpdateCompanyHierarchyCustomFieldsMutationFn = Apollo.MutationFunction<UpdateCompanyHierarchyCustomFieldsMutation, UpdateCompanyHierarchyCustomFieldsMutationVariables>;

/**
 * __useUpdateCompanyHierarchyCustomFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyHierarchyCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyHierarchyCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyHierarchyCustomFieldsMutation, { data, loading, error }] = useUpdateCompanyHierarchyCustomFieldsMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useUpdateCompanyHierarchyCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyHierarchyCustomFieldsMutation, UpdateCompanyHierarchyCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyHierarchyCustomFieldsMutation, UpdateCompanyHierarchyCustomFieldsMutationVariables>(UpdateCompanyHierarchyCustomFieldsDocument, options);
      }
export type UpdateCompanyHierarchyCustomFieldsMutationHookResult = ReturnType<typeof useUpdateCompanyHierarchyCustomFieldsMutation>;
export type UpdateCompanyHierarchyCustomFieldsMutationResult = Apollo.MutationResult<UpdateCompanyHierarchyCustomFieldsMutation>;
export type UpdateCompanyHierarchyCustomFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyHierarchyCustomFieldsMutation, UpdateCompanyHierarchyCustomFieldsMutationVariables>;
export const InternalIndustriesDocument = gql`
    query InternalIndustries {
  internalIndustries {
    entries {
      ...InternalIndustry
    }
  }
}
    ${InternalIndustryFragmentDoc}`;

/**
 * __useInternalIndustriesQuery__
 *
 * To run a query within a React component, call `useInternalIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalIndustriesQuery(baseOptions?: Apollo.QueryHookOptions<InternalIndustriesQuery, InternalIndustriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalIndustriesQuery, InternalIndustriesQueryVariables>(InternalIndustriesDocument, options);
      }
export function useInternalIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalIndustriesQuery, InternalIndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalIndustriesQuery, InternalIndustriesQueryVariables>(InternalIndustriesDocument, options);
        }
export type InternalIndustriesQueryHookResult = ReturnType<typeof useInternalIndustriesQuery>;
export type InternalIndustriesLazyQueryHookResult = ReturnType<typeof useInternalIndustriesLazyQuery>;
export type InternalIndustriesQueryResult = Apollo.QueryResult<InternalIndustriesQuery, InternalIndustriesQueryVariables>;
export const InternalIndustriesConfigurationDocument = gql`
    query InternalIndustriesConfiguration {
  tenantConfiguration {
    id
    showInternalIndustries
  }
}
    `;

/**
 * __useInternalIndustriesConfigurationQuery__
 *
 * To run a query within a React component, call `useInternalIndustriesConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalIndustriesConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalIndustriesConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalIndustriesConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<InternalIndustriesConfigurationQuery, InternalIndustriesConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalIndustriesConfigurationQuery, InternalIndustriesConfigurationQueryVariables>(InternalIndustriesConfigurationDocument, options);
      }
export function useInternalIndustriesConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalIndustriesConfigurationQuery, InternalIndustriesConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalIndustriesConfigurationQuery, InternalIndustriesConfigurationQueryVariables>(InternalIndustriesConfigurationDocument, options);
        }
export type InternalIndustriesConfigurationQueryHookResult = ReturnType<typeof useInternalIndustriesConfigurationQuery>;
export type InternalIndustriesConfigurationLazyQueryHookResult = ReturnType<typeof useInternalIndustriesConfigurationLazyQuery>;
export type InternalIndustriesConfigurationQueryResult = Apollo.QueryResult<InternalIndustriesConfigurationQuery, InternalIndustriesConfigurationQueryVariables>;
export const AddInteractionKeyActivityDocument = gql`
    mutation AddInteractionKeyActivity($interactionUid: ID!, $activityTitle: String!, $notes: String, $category: KeyActivityCategory!, $description: String) {
  addInteractionKeyActivity(
    interactionUid: $interactionUid
    activityTitle: $activityTitle
    notes: $notes
    category: $category
    description: $description
  ) {
    failReasons
    keyActivity: detail {
      ...KeyActivityPreview
    }
  }
}
    ${KeyActivityPreviewFragmentDoc}`;
export type AddInteractionKeyActivityMutationFn = Apollo.MutationFunction<AddInteractionKeyActivityMutation, AddInteractionKeyActivityMutationVariables>;

/**
 * __useAddInteractionKeyActivityMutation__
 *
 * To run a mutation, you first call `useAddInteractionKeyActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInteractionKeyActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInteractionKeyActivityMutation, { data, loading, error }] = useAddInteractionKeyActivityMutation({
 *   variables: {
 *      interactionUid: // value for 'interactionUid'
 *      activityTitle: // value for 'activityTitle'
 *      notes: // value for 'notes'
 *      category: // value for 'category'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAddInteractionKeyActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddInteractionKeyActivityMutation, AddInteractionKeyActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInteractionKeyActivityMutation, AddInteractionKeyActivityMutationVariables>(AddInteractionKeyActivityDocument, options);
      }
export type AddInteractionKeyActivityMutationHookResult = ReturnType<typeof useAddInteractionKeyActivityMutation>;
export type AddInteractionKeyActivityMutationResult = Apollo.MutationResult<AddInteractionKeyActivityMutation>;
export type AddInteractionKeyActivityMutationOptions = Apollo.BaseMutationOptions<AddInteractionKeyActivityMutation, AddInteractionKeyActivityMutationVariables>;
export const AllInteractionDocument = gql`
    query AllInteraction($interactionType: PartitionedInteractionType, $page: Int = 1, $perPage: Int = 10, $companyUid: String, $keyActivityCategories: [KeyActivityCategory!]) {
  allInteraction(
    interactionType: $interactionType
    page: $page
    perPage: $perPage
    companyUid: $companyUid
    keyActivityCategories: $keyActivityCategories
  ) {
    entries {
      ...InteractionPreview
    }
    pageInfo {
      totalEntries
    }
  }
  currentUser {
    id
    employee {
      id
      contact {
        id
      }
    }
  }
}
    ${InteractionPreviewFragmentDoc}`;

/**
 * __useAllInteractionQuery__
 *
 * To run a query within a React component, call `useAllInteractionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInteractionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInteractionQuery({
 *   variables: {
 *      interactionType: // value for 'interactionType'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      companyUid: // value for 'companyUid'
 *      keyActivityCategories: // value for 'keyActivityCategories'
 *   },
 * });
 */
export function useAllInteractionQuery(baseOptions?: Apollo.QueryHookOptions<AllInteractionQuery, AllInteractionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllInteractionQuery, AllInteractionQueryVariables>(AllInteractionDocument, options);
      }
export function useAllInteractionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllInteractionQuery, AllInteractionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllInteractionQuery, AllInteractionQueryVariables>(AllInteractionDocument, options);
        }
export type AllInteractionQueryHookResult = ReturnType<typeof useAllInteractionQuery>;
export type AllInteractionLazyQueryHookResult = ReturnType<typeof useAllInteractionLazyQuery>;
export type AllInteractionQueryResult = Apollo.QueryResult<AllInteractionQuery, AllInteractionQueryVariables>;
export const BulkMarkAllKeyActivityContactsDocument = gql`
    mutation BulkMarkAllKeyActivityContacts($interactionOn: ISO8601DateTime!, $interactionEndAt: ISO8601DateTime, $category: KeyActivityCategory!, $listId: ID!, $activityTitle: String!, $term: String!, $notes: String, $description: String, $internalContacts: [String!]) {
  bulkMarkAllKeyActivityContacts(
    interactionOn: $interactionOn
    interactionEndAt: $interactionEndAt
    category: $category
    listId: $listId
    activityTitle: $activityTitle
    term: $term
    notes: $notes
    description: $description
    internalContacts: $internalContacts
  ) {
    failReasons
  }
}
    `;
export type BulkMarkAllKeyActivityContactsMutationFn = Apollo.MutationFunction<BulkMarkAllKeyActivityContactsMutation, BulkMarkAllKeyActivityContactsMutationVariables>;

/**
 * __useBulkMarkAllKeyActivityContactsMutation__
 *
 * To run a mutation, you first call `useBulkMarkAllKeyActivityContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkAllKeyActivityContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkAllKeyActivityContactsMutation, { data, loading, error }] = useBulkMarkAllKeyActivityContactsMutation({
 *   variables: {
 *      interactionOn: // value for 'interactionOn'
 *      interactionEndAt: // value for 'interactionEndAt'
 *      category: // value for 'category'
 *      listId: // value for 'listId'
 *      activityTitle: // value for 'activityTitle'
 *      term: // value for 'term'
 *      notes: // value for 'notes'
 *      description: // value for 'description'
 *      internalContacts: // value for 'internalContacts'
 *   },
 * });
 */
export function useBulkMarkAllKeyActivityContactsMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkAllKeyActivityContactsMutation, BulkMarkAllKeyActivityContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkMarkAllKeyActivityContactsMutation, BulkMarkAllKeyActivityContactsMutationVariables>(BulkMarkAllKeyActivityContactsDocument, options);
      }
export type BulkMarkAllKeyActivityContactsMutationHookResult = ReturnType<typeof useBulkMarkAllKeyActivityContactsMutation>;
export type BulkMarkAllKeyActivityContactsMutationResult = Apollo.MutationResult<BulkMarkAllKeyActivityContactsMutation>;
export type BulkMarkAllKeyActivityContactsMutationOptions = Apollo.BaseMutationOptions<BulkMarkAllKeyActivityContactsMutation, BulkMarkAllKeyActivityContactsMutationVariables>;
export const BulkMarkKeyActivityDocument = gql`
    mutation BulkMarkKeyActivity($activityTitle: String!, $interactionOn: ISO8601DateTime!, $interactionEndAt: ISO8601DateTime, $category: KeyActivityCategory!, $externalContacts: [String!]!, $notes: String, $description: String, $internalContacts: [String!]) {
  bulkMarkKeyActivity(
    activityTitle: $activityTitle
    interactionOn: $interactionOn
    interactionEndAt: $interactionEndAt
    category: $category
    externalContacts: $externalContacts
    notes: $notes
    description: $description
    internalContacts: $internalContacts
  ) {
    failReasons
  }
}
    `;
export type BulkMarkKeyActivityMutationFn = Apollo.MutationFunction<BulkMarkKeyActivityMutation, BulkMarkKeyActivityMutationVariables>;

/**
 * __useBulkMarkKeyActivityMutation__
 *
 * To run a mutation, you first call `useBulkMarkKeyActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkKeyActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkKeyActivityMutation, { data, loading, error }] = useBulkMarkKeyActivityMutation({
 *   variables: {
 *      activityTitle: // value for 'activityTitle'
 *      interactionOn: // value for 'interactionOn'
 *      interactionEndAt: // value for 'interactionEndAt'
 *      category: // value for 'category'
 *      externalContacts: // value for 'externalContacts'
 *      notes: // value for 'notes'
 *      description: // value for 'description'
 *      internalContacts: // value for 'internalContacts'
 *   },
 * });
 */
export function useBulkMarkKeyActivityMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkKeyActivityMutation, BulkMarkKeyActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkMarkKeyActivityMutation, BulkMarkKeyActivityMutationVariables>(BulkMarkKeyActivityDocument, options);
      }
export type BulkMarkKeyActivityMutationHookResult = ReturnType<typeof useBulkMarkKeyActivityMutation>;
export type BulkMarkKeyActivityMutationResult = Apollo.MutationResult<BulkMarkKeyActivityMutation>;
export type BulkMarkKeyActivityMutationOptions = Apollo.BaseMutationOptions<BulkMarkKeyActivityMutation, BulkMarkKeyActivityMutationVariables>;
export const BulkMarkKeyActivityWithTrackerDocument = gql`
    mutation BulkMarkKeyActivityWithTracker($activityTitle: String!, $interactionOn: ISO8601DateTime!, $interactionEndAt: ISO8601DateTime, $category: KeyActivityCategory!, $externalContacts: [ID!]!, $notes: String, $description: String, $internalContacts: [ID!], $progressTracker: ProgressTrackerAttributes!) {
  bulkMarkKeyActivityWithTracker(
    progressTracker: $progressTracker
    keyActivity: {activityTitle: $activityTitle, interactionOn: $interactionOn, interactionEndAt: $interactionEndAt, category: $category, notes: $notes, description: $description}
    externalContactsUids: $externalContacts
    internalContactUids: $internalContacts
  ) {
    failReasons
  }
}
    `;
export type BulkMarkKeyActivityWithTrackerMutationFn = Apollo.MutationFunction<BulkMarkKeyActivityWithTrackerMutation, BulkMarkKeyActivityWithTrackerMutationVariables>;

/**
 * __useBulkMarkKeyActivityWithTrackerMutation__
 *
 * To run a mutation, you first call `useBulkMarkKeyActivityWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkKeyActivityWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkKeyActivityWithTrackerMutation, { data, loading, error }] = useBulkMarkKeyActivityWithTrackerMutation({
 *   variables: {
 *      activityTitle: // value for 'activityTitle'
 *      interactionOn: // value for 'interactionOn'
 *      interactionEndAt: // value for 'interactionEndAt'
 *      category: // value for 'category'
 *      externalContacts: // value for 'externalContacts'
 *      notes: // value for 'notes'
 *      description: // value for 'description'
 *      internalContacts: // value for 'internalContacts'
 *      progressTracker: // value for 'progressTracker'
 *   },
 * });
 */
export function useBulkMarkKeyActivityWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkKeyActivityWithTrackerMutation, BulkMarkKeyActivityWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkMarkKeyActivityWithTrackerMutation, BulkMarkKeyActivityWithTrackerMutationVariables>(BulkMarkKeyActivityWithTrackerDocument, options);
      }
export type BulkMarkKeyActivityWithTrackerMutationHookResult = ReturnType<typeof useBulkMarkKeyActivityWithTrackerMutation>;
export type BulkMarkKeyActivityWithTrackerMutationResult = Apollo.MutationResult<BulkMarkKeyActivityWithTrackerMutation>;
export type BulkMarkKeyActivityWithTrackerMutationOptions = Apollo.BaseMutationOptions<BulkMarkKeyActivityWithTrackerMutation, BulkMarkKeyActivityWithTrackerMutationVariables>;
export const ContactsBulkLogNewActivityWithTrackerDocument = gql`
    mutation ContactsBulkLogNewActivityWithTracker($activityTitle: String!, $interactionOn: ISO8601DateTime!, $interactionEndAt: ISO8601DateTime, $category: KeyActivityCategory!, $notes: String, $description: String, $internalContacts: [ID!], $progressTracker: ProgressTrackerAttributes!, $filter: ContactsFiltering, $filters: [ContactFilter!]) {
  contactsBulkMarkKeyActivityWithTracker(
    progressTracker: $progressTracker
    keyActivity: {activityTitle: $activityTitle, interactionOn: $interactionOn, interactionEndAt: $interactionEndAt, category: $category, notes: $notes, description: $description}
    filter: $filter
    filters: $filters
    internalContactUids: $internalContacts
  ) {
    failReasons
  }
}
    `;
export type ContactsBulkLogNewActivityWithTrackerMutationFn = Apollo.MutationFunction<ContactsBulkLogNewActivityWithTrackerMutation, ContactsBulkLogNewActivityWithTrackerMutationVariables>;

/**
 * __useContactsBulkLogNewActivityWithTrackerMutation__
 *
 * To run a mutation, you first call `useContactsBulkLogNewActivityWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactsBulkLogNewActivityWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactsBulkLogNewActivityWithTrackerMutation, { data, loading, error }] = useContactsBulkLogNewActivityWithTrackerMutation({
 *   variables: {
 *      activityTitle: // value for 'activityTitle'
 *      interactionOn: // value for 'interactionOn'
 *      interactionEndAt: // value for 'interactionEndAt'
 *      category: // value for 'category'
 *      notes: // value for 'notes'
 *      description: // value for 'description'
 *      internalContacts: // value for 'internalContacts'
 *      progressTracker: // value for 'progressTracker'
 *      filter: // value for 'filter'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useContactsBulkLogNewActivityWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<ContactsBulkLogNewActivityWithTrackerMutation, ContactsBulkLogNewActivityWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactsBulkLogNewActivityWithTrackerMutation, ContactsBulkLogNewActivityWithTrackerMutationVariables>(ContactsBulkLogNewActivityWithTrackerDocument, options);
      }
export type ContactsBulkLogNewActivityWithTrackerMutationHookResult = ReturnType<typeof useContactsBulkLogNewActivityWithTrackerMutation>;
export type ContactsBulkLogNewActivityWithTrackerMutationResult = Apollo.MutationResult<ContactsBulkLogNewActivityWithTrackerMutation>;
export type ContactsBulkLogNewActivityWithTrackerMutationOptions = Apollo.BaseMutationOptions<ContactsBulkLogNewActivityWithTrackerMutation, ContactsBulkLogNewActivityWithTrackerMutationVariables>;
export const EmployeeKeyActivitiesDocument = gql`
    query EmployeeKeyActivities($occurredAfter: ISO8601DateTime, $occurredBefore: ISO8601DateTime, $contactUid: ID!, $category: KeyActivityCategory!, $page: Int, $perPage: Int) {
  keyActivities(
    filter: {occurredAfter: $occurredAfter, occurredBefore: $occurredBefore, contactUid: $contactUid, category: $category}
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...EmployeeKeyActivity
    }
  }
}
    ${EmployeeKeyActivityFragmentDoc}`;

/**
 * __useEmployeeKeyActivitiesQuery__
 *
 * To run a query within a React component, call `useEmployeeKeyActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeKeyActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeKeyActivitiesQuery({
 *   variables: {
 *      occurredAfter: // value for 'occurredAfter'
 *      occurredBefore: // value for 'occurredBefore'
 *      contactUid: // value for 'contactUid'
 *      category: // value for 'category'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useEmployeeKeyActivitiesQuery(baseOptions: Apollo.QueryHookOptions<EmployeeKeyActivitiesQuery, EmployeeKeyActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeKeyActivitiesQuery, EmployeeKeyActivitiesQueryVariables>(EmployeeKeyActivitiesDocument, options);
      }
export function useEmployeeKeyActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeKeyActivitiesQuery, EmployeeKeyActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeKeyActivitiesQuery, EmployeeKeyActivitiesQueryVariables>(EmployeeKeyActivitiesDocument, options);
        }
export type EmployeeKeyActivitiesQueryHookResult = ReturnType<typeof useEmployeeKeyActivitiesQuery>;
export type EmployeeKeyActivitiesLazyQueryHookResult = ReturnType<typeof useEmployeeKeyActivitiesLazyQuery>;
export type EmployeeKeyActivitiesQueryResult = Apollo.QueryResult<EmployeeKeyActivitiesQuery, EmployeeKeyActivitiesQueryVariables>;
export const EmployeeKeyActivitiesTotalDocument = gql`
    query EmployeeKeyActivitiesTotal($occurredAfter: ISO8601DateTime, $occurredBefore: ISO8601DateTime, $contactUid: ID!, $category: KeyActivityCategory!) {
  keyActivities(
    filter: {occurredAfter: $occurredAfter, occurredBefore: $occurredBefore, contactUid: $contactUid, category: $category}
  ) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useEmployeeKeyActivitiesTotalQuery__
 *
 * To run a query within a React component, call `useEmployeeKeyActivitiesTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeKeyActivitiesTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeKeyActivitiesTotalQuery({
 *   variables: {
 *      occurredAfter: // value for 'occurredAfter'
 *      occurredBefore: // value for 'occurredBefore'
 *      contactUid: // value for 'contactUid'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useEmployeeKeyActivitiesTotalQuery(baseOptions: Apollo.QueryHookOptions<EmployeeKeyActivitiesTotalQuery, EmployeeKeyActivitiesTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeKeyActivitiesTotalQuery, EmployeeKeyActivitiesTotalQueryVariables>(EmployeeKeyActivitiesTotalDocument, options);
      }
export function useEmployeeKeyActivitiesTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeKeyActivitiesTotalQuery, EmployeeKeyActivitiesTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeKeyActivitiesTotalQuery, EmployeeKeyActivitiesTotalQueryVariables>(EmployeeKeyActivitiesTotalDocument, options);
        }
export type EmployeeKeyActivitiesTotalQueryHookResult = ReturnType<typeof useEmployeeKeyActivitiesTotalQuery>;
export type EmployeeKeyActivitiesTotalLazyQueryHookResult = ReturnType<typeof useEmployeeKeyActivitiesTotalLazyQuery>;
export type EmployeeKeyActivitiesTotalQueryResult = Apollo.QueryResult<EmployeeKeyActivitiesTotalQuery, EmployeeKeyActivitiesTotalQueryVariables>;
export const KeyActivityTitlesDocument = gql`
    query KeyActivityTitles($term: String, $categories: [KeyActivityCategory!]) {
  keyActivityTitles(term: $term, categories: $categories) {
    entries
  }
}
    `;

/**
 * __useKeyActivityTitlesQuery__
 *
 * To run a query within a React component, call `useKeyActivityTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityTitlesQuery({
 *   variables: {
 *      term: // value for 'term'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useKeyActivityTitlesQuery(baseOptions?: Apollo.QueryHookOptions<KeyActivityTitlesQuery, KeyActivityTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityTitlesQuery, KeyActivityTitlesQueryVariables>(KeyActivityTitlesDocument, options);
      }
export function useKeyActivityTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityTitlesQuery, KeyActivityTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityTitlesQuery, KeyActivityTitlesQueryVariables>(KeyActivityTitlesDocument, options);
        }
export type KeyActivityTitlesQueryHookResult = ReturnType<typeof useKeyActivityTitlesQuery>;
export type KeyActivityTitlesLazyQueryHookResult = ReturnType<typeof useKeyActivityTitlesLazyQuery>;
export type KeyActivityTitlesQueryResult = Apollo.QueryResult<KeyActivityTitlesQuery, KeyActivityTitlesQueryVariables>;
export const LastActivitiesAtDocument = gql`
    query LastActivitiesAt($companyUid: String!) {
  company(uid: $companyUid) {
    id
    insightStat {
      lastBdInteractionAt
      lastMarketingInteractionAt
    }
  }
}
    `;

/**
 * __useLastActivitiesAtQuery__
 *
 * To run a query within a React component, call `useLastActivitiesAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastActivitiesAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastActivitiesAtQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *   },
 * });
 */
export function useLastActivitiesAtQuery(baseOptions: Apollo.QueryHookOptions<LastActivitiesAtQuery, LastActivitiesAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastActivitiesAtQuery, LastActivitiesAtQueryVariables>(LastActivitiesAtDocument, options);
      }
export function useLastActivitiesAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastActivitiesAtQuery, LastActivitiesAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastActivitiesAtQuery, LastActivitiesAtQueryVariables>(LastActivitiesAtDocument, options);
        }
export type LastActivitiesAtQueryHookResult = ReturnType<typeof useLastActivitiesAtQuery>;
export type LastActivitiesAtLazyQueryHookResult = ReturnType<typeof useLastActivitiesAtLazyQuery>;
export type LastActivitiesAtQueryResult = Apollo.QueryResult<LastActivitiesAtQuery, LastActivitiesAtQueryVariables>;
export const MarkKeyActivityDocument = gql`
    mutation MarkKeyActivity($activityTitle: String!, $interactionOn: ISO8601DateTime!, $interactionEndAt: ISO8601DateTime, $keyActivityCategory: KeyActivityCategory!, $externalContacts: [String!], $internalContacts: [String!], $notes: String, $description: String, $keyActivityListUid: ID) {
  markKeyActivity(
    activityTitle: $activityTitle
    interactionOn: $interactionOn
    interactionEndAt: $interactionEndAt
    keyActivityCategory: $keyActivityCategory
    externalContacts: $externalContacts
    internalContacts: $internalContacts
    notes: $notes
    description: $description
    keyActivityListUid: $keyActivityListUid
  ) {
    failReasons
    keyActivity {
      ...KeyActivityPreview
    }
    keyActitivityListMember {
      ...KeyActivityListMember
    }
  }
}
    ${KeyActivityPreviewFragmentDoc}
${KeyActivityListMemberFragmentDoc}`;
export type MarkKeyActivityMutationFn = Apollo.MutationFunction<MarkKeyActivityMutation, MarkKeyActivityMutationVariables>;

/**
 * __useMarkKeyActivityMutation__
 *
 * To run a mutation, you first call `useMarkKeyActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkKeyActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markKeyActivityMutation, { data, loading, error }] = useMarkKeyActivityMutation({
 *   variables: {
 *      activityTitle: // value for 'activityTitle'
 *      interactionOn: // value for 'interactionOn'
 *      interactionEndAt: // value for 'interactionEndAt'
 *      keyActivityCategory: // value for 'keyActivityCategory'
 *      externalContacts: // value for 'externalContacts'
 *      internalContacts: // value for 'internalContacts'
 *      notes: // value for 'notes'
 *      description: // value for 'description'
 *      keyActivityListUid: // value for 'keyActivityListUid'
 *   },
 * });
 */
export function useMarkKeyActivityMutation(baseOptions?: Apollo.MutationHookOptions<MarkKeyActivityMutation, MarkKeyActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkKeyActivityMutation, MarkKeyActivityMutationVariables>(MarkKeyActivityDocument, options);
      }
export type MarkKeyActivityMutationHookResult = ReturnType<typeof useMarkKeyActivityMutation>;
export type MarkKeyActivityMutationResult = Apollo.MutationResult<MarkKeyActivityMutation>;
export type MarkKeyActivityMutationOptions = Apollo.BaseMutationOptions<MarkKeyActivityMutation, MarkKeyActivityMutationVariables>;
export const MarkMeetingAsKeyActivityDocument = gql`
    mutation MarkMeetingAsKeyActivity($upcomingMeetingUid: ID!, $activityTitle: String!, $notes: String, $category: KeyActivityCategory!, $description: String) {
  markUpcomingMeetingAsKeyActivity(
    upcomingMeetingUid: $upcomingMeetingUid
    activityTitle: $activityTitle
    notes: $notes
    category: $category
    description: $description
  ) {
    failReasons
    keyActivity {
      id
    }
  }
}
    `;
export type MarkMeetingAsKeyActivityMutationFn = Apollo.MutationFunction<MarkMeetingAsKeyActivityMutation, MarkMeetingAsKeyActivityMutationVariables>;

/**
 * __useMarkMeetingAsKeyActivityMutation__
 *
 * To run a mutation, you first call `useMarkMeetingAsKeyActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMeetingAsKeyActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMeetingAsKeyActivityMutation, { data, loading, error }] = useMarkMeetingAsKeyActivityMutation({
 *   variables: {
 *      upcomingMeetingUid: // value for 'upcomingMeetingUid'
 *      activityTitle: // value for 'activityTitle'
 *      notes: // value for 'notes'
 *      category: // value for 'category'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useMarkMeetingAsKeyActivityMutation(baseOptions?: Apollo.MutationHookOptions<MarkMeetingAsKeyActivityMutation, MarkMeetingAsKeyActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkMeetingAsKeyActivityMutation, MarkMeetingAsKeyActivityMutationVariables>(MarkMeetingAsKeyActivityDocument, options);
      }
export type MarkMeetingAsKeyActivityMutationHookResult = ReturnType<typeof useMarkMeetingAsKeyActivityMutation>;
export type MarkMeetingAsKeyActivityMutationResult = Apollo.MutationResult<MarkMeetingAsKeyActivityMutation>;
export type MarkMeetingAsKeyActivityMutationOptions = Apollo.BaseMutationOptions<MarkMeetingAsKeyActivityMutation, MarkMeetingAsKeyActivityMutationVariables>;
export const MarkUpcomingMeetingAsKeyActivityDocument = gql`
    mutation MarkUpcomingMeetingAsKeyActivity($upcomingMeetingUid: ID!, $activityTitle: String!, $notes: String, $category: KeyActivityCategory!, $description: String) {
  markUpcomingMeetingAsKeyActivity(
    upcomingMeetingUid: $upcomingMeetingUid
    activityTitle: $activityTitle
    notes: $notes
    category: $category
    description: $description
  ) {
    failReasons
    keyActivity {
      ...KeyActivityPreview
    }
  }
}
    ${KeyActivityPreviewFragmentDoc}`;
export type MarkUpcomingMeetingAsKeyActivityMutationFn = Apollo.MutationFunction<MarkUpcomingMeetingAsKeyActivityMutation, MarkUpcomingMeetingAsKeyActivityMutationVariables>;

/**
 * __useMarkUpcomingMeetingAsKeyActivityMutation__
 *
 * To run a mutation, you first call `useMarkUpcomingMeetingAsKeyActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUpcomingMeetingAsKeyActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUpcomingMeetingAsKeyActivityMutation, { data, loading, error }] = useMarkUpcomingMeetingAsKeyActivityMutation({
 *   variables: {
 *      upcomingMeetingUid: // value for 'upcomingMeetingUid'
 *      activityTitle: // value for 'activityTitle'
 *      notes: // value for 'notes'
 *      category: // value for 'category'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useMarkUpcomingMeetingAsKeyActivityMutation(baseOptions?: Apollo.MutationHookOptions<MarkUpcomingMeetingAsKeyActivityMutation, MarkUpcomingMeetingAsKeyActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUpcomingMeetingAsKeyActivityMutation, MarkUpcomingMeetingAsKeyActivityMutationVariables>(MarkUpcomingMeetingAsKeyActivityDocument, options);
      }
export type MarkUpcomingMeetingAsKeyActivityMutationHookResult = ReturnType<typeof useMarkUpcomingMeetingAsKeyActivityMutation>;
export type MarkUpcomingMeetingAsKeyActivityMutationResult = Apollo.MutationResult<MarkUpcomingMeetingAsKeyActivityMutation>;
export type MarkUpcomingMeetingAsKeyActivityMutationOptions = Apollo.BaseMutationOptions<MarkUpcomingMeetingAsKeyActivityMutation, MarkUpcomingMeetingAsKeyActivityMutationVariables>;
export const RemoveKeyActivityDocument = gql`
    mutation RemoveKeyActivity($keyActivityUid: ID!) {
  removeKeyActivity(keyActivityUid: $keyActivityUid) {
    failReasons
  }
}
    `;
export type RemoveKeyActivityMutationFn = Apollo.MutationFunction<RemoveKeyActivityMutation, RemoveKeyActivityMutationVariables>;

/**
 * __useRemoveKeyActivityMutation__
 *
 * To run a mutation, you first call `useRemoveKeyActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveKeyActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeKeyActivityMutation, { data, loading, error }] = useRemoveKeyActivityMutation({
 *   variables: {
 *      keyActivityUid: // value for 'keyActivityUid'
 *   },
 * });
 */
export function useRemoveKeyActivityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveKeyActivityMutation, RemoveKeyActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveKeyActivityMutation, RemoveKeyActivityMutationVariables>(RemoveKeyActivityDocument, options);
      }
export type RemoveKeyActivityMutationHookResult = ReturnType<typeof useRemoveKeyActivityMutation>;
export type RemoveKeyActivityMutationResult = Apollo.MutationResult<RemoveKeyActivityMutation>;
export type RemoveKeyActivityMutationOptions = Apollo.BaseMutationOptions<RemoveKeyActivityMutation, RemoveKeyActivityMutationVariables>;
export const UpdateKeyActivityDocument = gql`
    mutation UpdateKeyActivity($keyActivityUid: ID!, $activityTitle: String, $notes: String, $description: String) {
  updateKeyActivity(
    keyActivityUid: $keyActivityUid
    activityTitle: $activityTitle
    notes: $notes
    description: $description
  ) {
    failReasons
    record {
      ...EmployeeKeyActivity
    }
  }
}
    ${EmployeeKeyActivityFragmentDoc}`;
export type UpdateKeyActivityMutationFn = Apollo.MutationFunction<UpdateKeyActivityMutation, UpdateKeyActivityMutationVariables>;

/**
 * __useUpdateKeyActivityMutation__
 *
 * To run a mutation, you first call `useUpdateKeyActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeyActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeyActivityMutation, { data, loading, error }] = useUpdateKeyActivityMutation({
 *   variables: {
 *      keyActivityUid: // value for 'keyActivityUid'
 *      activityTitle: // value for 'activityTitle'
 *      notes: // value for 'notes'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateKeyActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeyActivityMutation, UpdateKeyActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeyActivityMutation, UpdateKeyActivityMutationVariables>(UpdateKeyActivityDocument, options);
      }
export type UpdateKeyActivityMutationHookResult = ReturnType<typeof useUpdateKeyActivityMutation>;
export type UpdateKeyActivityMutationResult = Apollo.MutationResult<UpdateKeyActivityMutation>;
export type UpdateKeyActivityMutationOptions = Apollo.BaseMutationOptions<UpdateKeyActivityMutation, UpdateKeyActivityMutationVariables>;
export const CompanyKeyContactsDocument = gql`
    query CompanyKeyContacts($companyUid: String!, $page: Int, $perPage: Int) {
  companyKeyContacts(companyUid: $companyUid, page: $page, perPage: $perPage) {
    entries {
      ...ContactPreview
      interactionsLast {
        meetingAt
        interactionAt
      }
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactPreviewFragmentDoc}`;

/**
 * __useCompanyKeyContactsQuery__
 *
 * To run a query within a React component, call `useCompanyKeyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyKeyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyKeyContactsQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCompanyKeyContactsQuery(baseOptions: Apollo.QueryHookOptions<CompanyKeyContactsQuery, CompanyKeyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyKeyContactsQuery, CompanyKeyContactsQueryVariables>(CompanyKeyContactsDocument, options);
      }
export function useCompanyKeyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyKeyContactsQuery, CompanyKeyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyKeyContactsQuery, CompanyKeyContactsQueryVariables>(CompanyKeyContactsDocument, options);
        }
export type CompanyKeyContactsQueryHookResult = ReturnType<typeof useCompanyKeyContactsQuery>;
export type CompanyKeyContactsLazyQueryHookResult = ReturnType<typeof useCompanyKeyContactsLazyQuery>;
export type CompanyKeyContactsQueryResult = Apollo.QueryResult<CompanyKeyContactsQuery, CompanyKeyContactsQueryVariables>;
export const CreateCompanyKeyContactDocument = gql`
    mutation CreateCompanyKeyContact($companyUid: String!, $contactUid: String!) {
  createCompanyKeyContact(companyUid: $companyUid, contactUid: $contactUid) {
    failReasons
  }
}
    `;
export type CreateCompanyKeyContactMutationFn = Apollo.MutationFunction<CreateCompanyKeyContactMutation, CreateCompanyKeyContactMutationVariables>;

/**
 * __useCreateCompanyKeyContactMutation__
 *
 * To run a mutation, you first call `useCreateCompanyKeyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyKeyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyKeyContactMutation, { data, loading, error }] = useCreateCompanyKeyContactMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useCreateCompanyKeyContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyKeyContactMutation, CreateCompanyKeyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyKeyContactMutation, CreateCompanyKeyContactMutationVariables>(CreateCompanyKeyContactDocument, options);
      }
export type CreateCompanyKeyContactMutationHookResult = ReturnType<typeof useCreateCompanyKeyContactMutation>;
export type CreateCompanyKeyContactMutationResult = Apollo.MutationResult<CreateCompanyKeyContactMutation>;
export type CreateCompanyKeyContactMutationOptions = Apollo.BaseMutationOptions<CreateCompanyKeyContactMutation, CreateCompanyKeyContactMutationVariables>;
export const RemoveCompanyKeyContactDocument = gql`
    mutation RemoveCompanyKeyContact($companyUid: String!, $contactUid: String!) {
  removeCompanyKeyContact(companyUid: $companyUid, contactUid: $contactUid) {
    failReasons
  }
}
    `;
export type RemoveCompanyKeyContactMutationFn = Apollo.MutationFunction<RemoveCompanyKeyContactMutation, RemoveCompanyKeyContactMutationVariables>;

/**
 * __useRemoveCompanyKeyContactMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyKeyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyKeyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyKeyContactMutation, { data, loading, error }] = useRemoveCompanyKeyContactMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useRemoveCompanyKeyContactMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyKeyContactMutation, RemoveCompanyKeyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyKeyContactMutation, RemoveCompanyKeyContactMutationVariables>(RemoveCompanyKeyContactDocument, options);
      }
export type RemoveCompanyKeyContactMutationHookResult = ReturnType<typeof useRemoveCompanyKeyContactMutation>;
export type RemoveCompanyKeyContactMutationResult = Apollo.MutationResult<RemoveCompanyKeyContactMutation>;
export type RemoveCompanyKeyContactMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyKeyContactMutation, RemoveCompanyKeyContactMutationVariables>;
export const DataCleanerConfigurationDocument = gql`
    query DataCleanerConfiguration {
  dataCleanerConfiguration {
    showContactsRequiringPlacement
  }
}
    `;

/**
 * __useDataCleanerConfigurationQuery__
 *
 * To run a query within a React component, call `useDataCleanerConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataCleanerConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataCleanerConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataCleanerConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<DataCleanerConfigurationQuery, DataCleanerConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataCleanerConfigurationQuery, DataCleanerConfigurationQueryVariables>(DataCleanerConfigurationDocument, options);
      }
export function useDataCleanerConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataCleanerConfigurationQuery, DataCleanerConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataCleanerConfigurationQuery, DataCleanerConfigurationQueryVariables>(DataCleanerConfigurationDocument, options);
        }
export type DataCleanerConfigurationQueryHookResult = ReturnType<typeof useDataCleanerConfigurationQuery>;
export type DataCleanerConfigurationLazyQueryHookResult = ReturnType<typeof useDataCleanerConfigurationLazyQuery>;
export type DataCleanerConfigurationQueryResult = Apollo.QueryResult<DataCleanerConfigurationQuery, DataCleanerConfigurationQueryVariables>;
export const KeyActivityHistoryDocument = gql`
    query KeyActivityHistory($page: Int = 1, $perPage: Int = 10, $companyUid: ID!) {
  keyActivities(
    page: $page
    perPage: $perPage
    filter: {companyUid: $companyUid}
    orderBy: {field: INTERACTION_ON, direction: DESC}
  ) {
    entries {
      ...KeyActivityBox
    }
    pageInfo {
      totalEntries
    }
  }
  currentUser {
    id
    employee {
      id
      contact {
        id
      }
    }
    canViewActivityViewDetail
  }
}
    ${KeyActivityBoxFragmentDoc}`;

/**
 * __useKeyActivityHistoryQuery__
 *
 * To run a query within a React component, call `useKeyActivityHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityHistoryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      companyUid: // value for 'companyUid'
 *   },
 * });
 */
export function useKeyActivityHistoryQuery(baseOptions: Apollo.QueryHookOptions<KeyActivityHistoryQuery, KeyActivityHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityHistoryQuery, KeyActivityHistoryQueryVariables>(KeyActivityHistoryDocument, options);
      }
export function useKeyActivityHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityHistoryQuery, KeyActivityHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityHistoryQuery, KeyActivityHistoryQueryVariables>(KeyActivityHistoryDocument, options);
        }
export type KeyActivityHistoryQueryHookResult = ReturnType<typeof useKeyActivityHistoryQuery>;
export type KeyActivityHistoryLazyQueryHookResult = ReturnType<typeof useKeyActivityHistoryLazyQuery>;
export type KeyActivityHistoryQueryResult = Apollo.QueryResult<KeyActivityHistoryQuery, KeyActivityHistoryQueryVariables>;
export const KeyActivityLatestThreeDocument = gql`
    query KeyActivityLatestThree($companyUid: ID!) {
  keyActivities(
    page: 1
    perPage: 3
    filter: {companyUid: $companyUid, categories: [BUSINESS_DEVELOPMENT, MARKETING]}
    orderBy: {field: INTERACTION_ON, direction: DESC}
  ) {
    entries {
      ...KeyActivityBox
    }
    pageInfo {
      totalEntries
    }
  }
  currentUser {
    id
    employee {
      id
      contact {
        id
      }
    }
    canViewActivityViewDetail
  }
}
    ${KeyActivityBoxFragmentDoc}`;

/**
 * __useKeyActivityLatestThreeQuery__
 *
 * To run a query within a React component, call `useKeyActivityLatestThreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityLatestThreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityLatestThreeQuery({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *   },
 * });
 */
export function useKeyActivityLatestThreeQuery(baseOptions: Apollo.QueryHookOptions<KeyActivityLatestThreeQuery, KeyActivityLatestThreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityLatestThreeQuery, KeyActivityLatestThreeQueryVariables>(KeyActivityLatestThreeDocument, options);
      }
export function useKeyActivityLatestThreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityLatestThreeQuery, KeyActivityLatestThreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityLatestThreeQuery, KeyActivityLatestThreeQueryVariables>(KeyActivityLatestThreeDocument, options);
        }
export type KeyActivityLatestThreeQueryHookResult = ReturnType<typeof useKeyActivityLatestThreeQuery>;
export type KeyActivityLatestThreeLazyQueryHookResult = ReturnType<typeof useKeyActivityLatestThreeLazyQuery>;
export type KeyActivityLatestThreeQueryResult = Apollo.QueryResult<KeyActivityLatestThreeQuery, KeyActivityLatestThreeQueryVariables>;
export const CreateCompanyRelationshipPartnerDocument = gql`
    mutation CreateCompanyRelationshipPartner($companyUid: String!, $ownerUid: String!) {
  createCompanyRelationshipPartner(companyUid: $companyUid, ownerUid: $ownerUid) {
    failReasons
    relationshipPartnerCreated {
      ...CompanyRelationshipPartner
    }
  }
}
    ${CompanyRelationshipPartnerFragmentDoc}`;
export type CreateCompanyRelationshipPartnerMutationFn = Apollo.MutationFunction<CreateCompanyRelationshipPartnerMutation, CreateCompanyRelationshipPartnerMutationVariables>;

/**
 * __useCreateCompanyRelationshipPartnerMutation__
 *
 * To run a mutation, you first call `useCreateCompanyRelationshipPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyRelationshipPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyRelationshipPartnerMutation, { data, loading, error }] = useCreateCompanyRelationshipPartnerMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      ownerUid: // value for 'ownerUid'
 *   },
 * });
 */
export function useCreateCompanyRelationshipPartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyRelationshipPartnerMutation, CreateCompanyRelationshipPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyRelationshipPartnerMutation, CreateCompanyRelationshipPartnerMutationVariables>(CreateCompanyRelationshipPartnerDocument, options);
      }
export type CreateCompanyRelationshipPartnerMutationHookResult = ReturnType<typeof useCreateCompanyRelationshipPartnerMutation>;
export type CreateCompanyRelationshipPartnerMutationResult = Apollo.MutationResult<CreateCompanyRelationshipPartnerMutation>;
export type CreateCompanyRelationshipPartnerMutationOptions = Apollo.BaseMutationOptions<CreateCompanyRelationshipPartnerMutation, CreateCompanyRelationshipPartnerMutationVariables>;
export const RemoveCompanyRelationshipPartnerDocument = gql`
    mutation RemoveCompanyRelationshipPartner($companyUid: String!, $ownerUid: String!) {
  removeCompanyRelationshipPartner(companyUid: $companyUid, ownerUid: $ownerUid) {
    failReasons
    discarded {
      id
      discardedAt
    }
  }
}
    `;
export type RemoveCompanyRelationshipPartnerMutationFn = Apollo.MutationFunction<RemoveCompanyRelationshipPartnerMutation, RemoveCompanyRelationshipPartnerMutationVariables>;

/**
 * __useRemoveCompanyRelationshipPartnerMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyRelationshipPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyRelationshipPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyRelationshipPartnerMutation, { data, loading, error }] = useRemoveCompanyRelationshipPartnerMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      ownerUid: // value for 'ownerUid'
 *   },
 * });
 */
export function useRemoveCompanyRelationshipPartnerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyRelationshipPartnerMutation, RemoveCompanyRelationshipPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyRelationshipPartnerMutation, RemoveCompanyRelationshipPartnerMutationVariables>(RemoveCompanyRelationshipPartnerDocument, options);
      }
export type RemoveCompanyRelationshipPartnerMutationHookResult = ReturnType<typeof useRemoveCompanyRelationshipPartnerMutation>;
export type RemoveCompanyRelationshipPartnerMutationResult = Apollo.MutationResult<RemoveCompanyRelationshipPartnerMutation>;
export type RemoveCompanyRelationshipPartnerMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyRelationshipPartnerMutation, RemoveCompanyRelationshipPartnerMutationVariables>;
export const CompanyHasCustomLogoDocument = gql`
    query CompanyHasCustomLogo($uid: String!) {
  company(uid: $uid) {
    id
    hasCustomLogo
    logoUrl
    info {
      id
      name
    }
  }
}
    `;

/**
 * __useCompanyHasCustomLogoQuery__
 *
 * To run a query within a React component, call `useCompanyHasCustomLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHasCustomLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHasCustomLogoQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCompanyHasCustomLogoQuery(baseOptions: Apollo.QueryHookOptions<CompanyHasCustomLogoQuery, CompanyHasCustomLogoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyHasCustomLogoQuery, CompanyHasCustomLogoQueryVariables>(CompanyHasCustomLogoDocument, options);
      }
export function useCompanyHasCustomLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyHasCustomLogoQuery, CompanyHasCustomLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyHasCustomLogoQuery, CompanyHasCustomLogoQueryVariables>(CompanyHasCustomLogoDocument, options);
        }
export type CompanyHasCustomLogoQueryHookResult = ReturnType<typeof useCompanyHasCustomLogoQuery>;
export type CompanyHasCustomLogoLazyQueryHookResult = ReturnType<typeof useCompanyHasCustomLogoLazyQuery>;
export type CompanyHasCustomLogoQueryResult = Apollo.QueryResult<CompanyHasCustomLogoQuery, CompanyHasCustomLogoQueryVariables>;
export const RemoveCompanyLogoDocument = gql`
    mutation RemoveCompanyLogo($companyUid: String!) {
  removeCompanyLogo(companyUid: $companyUid) {
    failReasons
    company {
      id
      hasCustomLogo
      logoUrl
    }
  }
}
    `;
export type RemoveCompanyLogoMutationFn = Apollo.MutationFunction<RemoveCompanyLogoMutation, RemoveCompanyLogoMutationVariables>;

/**
 * __useRemoveCompanyLogoMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyLogoMutation, { data, loading, error }] = useRemoveCompanyLogoMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *   },
 * });
 */
export function useRemoveCompanyLogoMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyLogoMutation, RemoveCompanyLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyLogoMutation, RemoveCompanyLogoMutationVariables>(RemoveCompanyLogoDocument, options);
      }
export type RemoveCompanyLogoMutationHookResult = ReturnType<typeof useRemoveCompanyLogoMutation>;
export type RemoveCompanyLogoMutationResult = Apollo.MutationResult<RemoveCompanyLogoMutation>;
export type RemoveCompanyLogoMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyLogoMutation, RemoveCompanyLogoMutationVariables>;
export const SetCompanyLogoDocument = gql`
    mutation SetCompanyLogo($companyUid: ID!, $fileSignedId: ID!) {
  setCompanyLogo(companyUid: $companyUid, fileSignedId: $fileSignedId) {
    failReasons
    company {
      id
      hasCustomLogo
      logoUrl
    }
  }
}
    `;
export type SetCompanyLogoMutationFn = Apollo.MutationFunction<SetCompanyLogoMutation, SetCompanyLogoMutationVariables>;

/**
 * __useSetCompanyLogoMutation__
 *
 * To run a mutation, you first call `useSetCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCompanyLogoMutation, { data, loading, error }] = useSetCompanyLogoMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      fileSignedId: // value for 'fileSignedId'
 *   },
 * });
 */
export function useSetCompanyLogoMutation(baseOptions?: Apollo.MutationHookOptions<SetCompanyLogoMutation, SetCompanyLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCompanyLogoMutation, SetCompanyLogoMutationVariables>(SetCompanyLogoDocument, options);
      }
export type SetCompanyLogoMutationHookResult = ReturnType<typeof useSetCompanyLogoMutation>;
export type SetCompanyLogoMutationResult = Apollo.MutationResult<SetCompanyLogoMutation>;
export type SetCompanyLogoMutationOptions = Apollo.BaseMutationOptions<SetCompanyLogoMutation, SetCompanyLogoMutationVariables>;
export const AddCompanyListMemberWithCustomFieldsDocument = gql`
    mutation AddCompanyListMemberWithCustomFields($uid: ID!, $companyId: ID!, $customFieldAttributes: [CustomFieldAttribute!]!) {
  addCompanyListMember(
    listUid: $uid
    companyUid: $companyId
    customFields: $customFieldAttributes
  ) {
    failReasons
    record {
      ...CompanyListMemberRow
    }
  }
}
    ${CompanyListMemberRowFragmentDoc}`;
export type AddCompanyListMemberWithCustomFieldsMutationFn = Apollo.MutationFunction<AddCompanyListMemberWithCustomFieldsMutation, AddCompanyListMemberWithCustomFieldsMutationVariables>;

/**
 * __useAddCompanyListMemberWithCustomFieldsMutation__
 *
 * To run a mutation, you first call `useAddCompanyListMemberWithCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyListMemberWithCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyListMemberWithCustomFieldsMutation, { data, loading, error }] = useAddCompanyListMemberWithCustomFieldsMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      companyId: // value for 'companyId'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useAddCompanyListMemberWithCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyListMemberWithCustomFieldsMutation, AddCompanyListMemberWithCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyListMemberWithCustomFieldsMutation, AddCompanyListMemberWithCustomFieldsMutationVariables>(AddCompanyListMemberWithCustomFieldsDocument, options);
      }
export type AddCompanyListMemberWithCustomFieldsMutationHookResult = ReturnType<typeof useAddCompanyListMemberWithCustomFieldsMutation>;
export type AddCompanyListMemberWithCustomFieldsMutationResult = Apollo.MutationResult<AddCompanyListMemberWithCustomFieldsMutation>;
export type AddCompanyListMemberWithCustomFieldsMutationOptions = Apollo.BaseMutationOptions<AddCompanyListMemberWithCustomFieldsMutation, AddCompanyListMemberWithCustomFieldsMutationVariables>;
export const BulkAddCompanyListMemberDocument = gql`
    mutation BulkAddCompanyListMember($uid: ID!, $companyIds: [ID!]!) {
  bulkAddCompanyListMember(uid: $uid, companyIds: $companyIds) {
    failReasons
    records {
      ...CompanyListMemberRow
    }
  }
}
    ${CompanyListMemberRowFragmentDoc}`;
export type BulkAddCompanyListMemberMutationFn = Apollo.MutationFunction<BulkAddCompanyListMemberMutation, BulkAddCompanyListMemberMutationVariables>;

/**
 * __useBulkAddCompanyListMemberMutation__
 *
 * To run a mutation, you first call `useBulkAddCompanyListMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddCompanyListMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddCompanyListMemberMutation, { data, loading, error }] = useBulkAddCompanyListMemberMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useBulkAddCompanyListMemberMutation(baseOptions?: Apollo.MutationHookOptions<BulkAddCompanyListMemberMutation, BulkAddCompanyListMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAddCompanyListMemberMutation, BulkAddCompanyListMemberMutationVariables>(BulkAddCompanyListMemberDocument, options);
      }
export type BulkAddCompanyListMemberMutationHookResult = ReturnType<typeof useBulkAddCompanyListMemberMutation>;
export type BulkAddCompanyListMemberMutationResult = Apollo.MutationResult<BulkAddCompanyListMemberMutation>;
export type BulkAddCompanyListMemberMutationOptions = Apollo.BaseMutationOptions<BulkAddCompanyListMemberMutation, BulkAddCompanyListMemberMutationVariables>;
export const BulkRemoveCompanyListMemberDocument = gql`
    mutation BulkRemoveCompanyListMember($uid: ID!, $companyIds: [ID!]!) {
  bulkRemoveCompanyListMember(uid: $uid, companyIds: $companyIds) {
    failReasons
  }
}
    `;
export type BulkRemoveCompanyListMemberMutationFn = Apollo.MutationFunction<BulkRemoveCompanyListMemberMutation, BulkRemoveCompanyListMemberMutationVariables>;

/**
 * __useBulkRemoveCompanyListMemberMutation__
 *
 * To run a mutation, you first call `useBulkRemoveCompanyListMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveCompanyListMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveCompanyListMemberMutation, { data, loading, error }] = useBulkRemoveCompanyListMemberMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useBulkRemoveCompanyListMemberMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveCompanyListMemberMutation, BulkRemoveCompanyListMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveCompanyListMemberMutation, BulkRemoveCompanyListMemberMutationVariables>(BulkRemoveCompanyListMemberDocument, options);
      }
export type BulkRemoveCompanyListMemberMutationHookResult = ReturnType<typeof useBulkRemoveCompanyListMemberMutation>;
export type BulkRemoveCompanyListMemberMutationResult = Apollo.MutationResult<BulkRemoveCompanyListMemberMutation>;
export type BulkRemoveCompanyListMemberMutationOptions = Apollo.BaseMutationOptions<BulkRemoveCompanyListMemberMutation, BulkRemoveCompanyListMemberMutationVariables>;
export const BulkUpdateCompanyListMemberDocument = gql`
    mutation BulkUpdateCompanyListMember($listUid: ID, $companyMemberIds: [ID!]!, $customFieldAttributes: [CustomFieldAttribute!]!) {
  bulkUpdateCompanyListMember(
    listUid: $listUid
    companyMemberIds: $companyMemberIds
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
    records {
      ...CompanyListMemberRow
    }
  }
}
    ${CompanyListMemberRowFragmentDoc}`;
export type BulkUpdateCompanyListMemberMutationFn = Apollo.MutationFunction<BulkUpdateCompanyListMemberMutation, BulkUpdateCompanyListMemberMutationVariables>;

/**
 * __useBulkUpdateCompanyListMemberMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCompanyListMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCompanyListMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateCompanyListMemberMutation, { data, loading, error }] = useBulkUpdateCompanyListMemberMutation({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      companyMemberIds: // value for 'companyMemberIds'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useBulkUpdateCompanyListMemberMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateCompanyListMemberMutation, BulkUpdateCompanyListMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateCompanyListMemberMutation, BulkUpdateCompanyListMemberMutationVariables>(BulkUpdateCompanyListMemberDocument, options);
      }
export type BulkUpdateCompanyListMemberMutationHookResult = ReturnType<typeof useBulkUpdateCompanyListMemberMutation>;
export type BulkUpdateCompanyListMemberMutationResult = Apollo.MutationResult<BulkUpdateCompanyListMemberMutation>;
export type BulkUpdateCompanyListMemberMutationOptions = Apollo.BaseMutationOptions<BulkUpdateCompanyListMemberMutation, BulkUpdateCompanyListMemberMutationVariables>;
export const CompaniesDocument = gql`
    query Companies($page: Int, $perPage: Int, $filter: CompanyFiltering, $orderBy: CompaniesOrderBy) {
  companies(page: $page, perPage: $perPage, filter: $filter, orderBy: $orderBy) {
    entries {
      ...CompanyTableRow
    }
    pageInfo {
      totalPages
      totalEntries
    }
  }
}
    ${CompanyTableRowFragmentDoc}`;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const CompanyListCustomFieldSchemasDocument = gql`
    query CompanyListCustomFieldSchemas($uid: ID!) {
  companyList(uuid: $uid) {
    id
    memberCustomFields {
      ...CustomFieldSchema
    }
  }
}
    ${CustomFieldSchemaFragmentDoc}`;

/**
 * __useCompanyListCustomFieldSchemasQuery__
 *
 * To run a query within a React component, call `useCompanyListCustomFieldSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListCustomFieldSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListCustomFieldSchemasQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCompanyListCustomFieldSchemasQuery(baseOptions: Apollo.QueryHookOptions<CompanyListCustomFieldSchemasQuery, CompanyListCustomFieldSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListCustomFieldSchemasQuery, CompanyListCustomFieldSchemasQueryVariables>(CompanyListCustomFieldSchemasDocument, options);
      }
export function useCompanyListCustomFieldSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListCustomFieldSchemasQuery, CompanyListCustomFieldSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListCustomFieldSchemasQuery, CompanyListCustomFieldSchemasQueryVariables>(CompanyListCustomFieldSchemasDocument, options);
        }
export type CompanyListCustomFieldSchemasQueryHookResult = ReturnType<typeof useCompanyListCustomFieldSchemasQuery>;
export type CompanyListCustomFieldSchemasLazyQueryHookResult = ReturnType<typeof useCompanyListCustomFieldSchemasLazyQuery>;
export type CompanyListCustomFieldSchemasQueryResult = Apollo.QueryResult<CompanyListCustomFieldSchemasQuery, CompanyListCustomFieldSchemasQueryVariables>;
export const CompanyListMemberCustomFieldsDocument = gql`
    query CompanyListMemberCustomFields($listMemberUid: ID!) {
  companyListMember(listMemberUid: $listMemberUid) {
    id
    companyList {
      id
    }
    customFields {
      ...CustomField
    }
  }
}
    ${CustomFieldFragmentDoc}`;

/**
 * __useCompanyListMemberCustomFieldsQuery__
 *
 * To run a query within a React component, call `useCompanyListMemberCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListMemberCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListMemberCustomFieldsQuery({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *   },
 * });
 */
export function useCompanyListMemberCustomFieldsQuery(baseOptions: Apollo.QueryHookOptions<CompanyListMemberCustomFieldsQuery, CompanyListMemberCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListMemberCustomFieldsQuery, CompanyListMemberCustomFieldsQueryVariables>(CompanyListMemberCustomFieldsDocument, options);
      }
export function useCompanyListMemberCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListMemberCustomFieldsQuery, CompanyListMemberCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListMemberCustomFieldsQuery, CompanyListMemberCustomFieldsQueryVariables>(CompanyListMemberCustomFieldsDocument, options);
        }
export type CompanyListMemberCustomFieldsQueryHookResult = ReturnType<typeof useCompanyListMemberCustomFieldsQuery>;
export type CompanyListMemberCustomFieldsLazyQueryHookResult = ReturnType<typeof useCompanyListMemberCustomFieldsLazyQuery>;
export type CompanyListMemberCustomFieldsQueryResult = Apollo.QueryResult<CompanyListMemberCustomFieldsQuery, CompanyListMemberCustomFieldsQueryVariables>;
export const CompanyListMemberRemindersDocument = gql`
    query CompanyListMemberReminders($listMemberUid: ID!) {
  companyListMember(listMemberUid: $listMemberUid) {
    id
    listReminders {
      ...ListMemberReminderPreview
    }
  }
}
    ${ListMemberReminderPreviewFragmentDoc}`;

/**
 * __useCompanyListMemberRemindersQuery__
 *
 * To run a query within a React component, call `useCompanyListMemberRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListMemberRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListMemberRemindersQuery({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *   },
 * });
 */
export function useCompanyListMemberRemindersQuery(baseOptions: Apollo.QueryHookOptions<CompanyListMemberRemindersQuery, CompanyListMemberRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListMemberRemindersQuery, CompanyListMemberRemindersQueryVariables>(CompanyListMemberRemindersDocument, options);
      }
export function useCompanyListMemberRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListMemberRemindersQuery, CompanyListMemberRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListMemberRemindersQuery, CompanyListMemberRemindersQueryVariables>(CompanyListMemberRemindersDocument, options);
        }
export type CompanyListMemberRemindersQueryHookResult = ReturnType<typeof useCompanyListMemberRemindersQuery>;
export type CompanyListMemberRemindersLazyQueryHookResult = ReturnType<typeof useCompanyListMemberRemindersLazyQuery>;
export type CompanyListMemberRemindersQueryResult = Apollo.QueryResult<CompanyListMemberRemindersQuery, CompanyListMemberRemindersQueryVariables>;
export const CreateCompanyListDocument = gql`
    mutation CreateCompanyList($name: String!, $projectUid: ID) {
  createCompanyList(name: $name, projectUuid: $projectUid) {
    id
    failReasons
  }
}
    `;
export type CreateCompanyListMutationFn = Apollo.MutationFunction<CreateCompanyListMutation, CreateCompanyListMutationVariables>;

/**
 * __useCreateCompanyListMutation__
 *
 * To run a mutation, you first call `useCreateCompanyListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyListMutation, { data, loading, error }] = useCreateCompanyListMutation({
 *   variables: {
 *      name: // value for 'name'
 *      projectUid: // value for 'projectUid'
 *   },
 * });
 */
export function useCreateCompanyListMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyListMutation, CreateCompanyListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyListMutation, CreateCompanyListMutationVariables>(CreateCompanyListDocument, options);
      }
export type CreateCompanyListMutationHookResult = ReturnType<typeof useCreateCompanyListMutation>;
export type CreateCompanyListMutationResult = Apollo.MutationResult<CreateCompanyListMutation>;
export type CreateCompanyListMutationOptions = Apollo.BaseMutationOptions<CreateCompanyListMutation, CreateCompanyListMutationVariables>;
export const CreateCompanyListReminderSettingDocument = gql`
    mutation CreateCompanyListReminderSetting($listUid: ID!, $timePreposition: ReminderSettingTimePreposition!, $emailSubject: String!, $reminderDays: Int!, $employeeEmails: [String!]!, $dateProperty: String!) {
  result: createCompanyListReminderSetting(
    companyListUid: $listUid
    timePreposition: $timePreposition
    emailSubject: $emailSubject
    reminderDays: $reminderDays
    employeeEmails: $employeeEmails
    dateProperty: $dateProperty
  ) {
    failReasons
  }
}
    `;
export type CreateCompanyListReminderSettingMutationFn = Apollo.MutationFunction<CreateCompanyListReminderSettingMutation, CreateCompanyListReminderSettingMutationVariables>;

/**
 * __useCreateCompanyListReminderSettingMutation__
 *
 * To run a mutation, you first call `useCreateCompanyListReminderSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyListReminderSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyListReminderSettingMutation, { data, loading, error }] = useCreateCompanyListReminderSettingMutation({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      timePreposition: // value for 'timePreposition'
 *      emailSubject: // value for 'emailSubject'
 *      reminderDays: // value for 'reminderDays'
 *      employeeEmails: // value for 'employeeEmails'
 *      dateProperty: // value for 'dateProperty'
 *   },
 * });
 */
export function useCreateCompanyListReminderSettingMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyListReminderSettingMutation, CreateCompanyListReminderSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyListReminderSettingMutation, CreateCompanyListReminderSettingMutationVariables>(CreateCompanyListReminderSettingDocument, options);
      }
export type CreateCompanyListReminderSettingMutationHookResult = ReturnType<typeof useCreateCompanyListReminderSettingMutation>;
export type CreateCompanyListReminderSettingMutationResult = Apollo.MutationResult<CreateCompanyListReminderSettingMutation>;
export type CreateCompanyListReminderSettingMutationOptions = Apollo.BaseMutationOptions<CreateCompanyListReminderSettingMutation, CreateCompanyListReminderSettingMutationVariables>;
export const DatePropertiesForCompanyListReminderDocument = gql`
    query DatePropertiesForCompanyListReminder($listUid: ID!) {
  datePropertiesForCompanyListReminder(companyListUid: $listUid) {
    ...DatePropertyOption
  }
}
    ${DatePropertyOptionFragmentDoc}`;

/**
 * __useDatePropertiesForCompanyListReminderQuery__
 *
 * To run a query within a React component, call `useDatePropertiesForCompanyListReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatePropertiesForCompanyListReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatePropertiesForCompanyListReminderQuery({
 *   variables: {
 *      listUid: // value for 'listUid'
 *   },
 * });
 */
export function useDatePropertiesForCompanyListReminderQuery(baseOptions: Apollo.QueryHookOptions<DatePropertiesForCompanyListReminderQuery, DatePropertiesForCompanyListReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatePropertiesForCompanyListReminderQuery, DatePropertiesForCompanyListReminderQueryVariables>(DatePropertiesForCompanyListReminderDocument, options);
      }
export function useDatePropertiesForCompanyListReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatePropertiesForCompanyListReminderQuery, DatePropertiesForCompanyListReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatePropertiesForCompanyListReminderQuery, DatePropertiesForCompanyListReminderQueryVariables>(DatePropertiesForCompanyListReminderDocument, options);
        }
export type DatePropertiesForCompanyListReminderQueryHookResult = ReturnType<typeof useDatePropertiesForCompanyListReminderQuery>;
export type DatePropertiesForCompanyListReminderLazyQueryHookResult = ReturnType<typeof useDatePropertiesForCompanyListReminderLazyQuery>;
export type DatePropertiesForCompanyListReminderQueryResult = Apollo.QueryResult<DatePropertiesForCompanyListReminderQuery, DatePropertiesForCompanyListReminderQueryVariables>;
export const GetCompanyListOptionsDocument = gql`
    query GetCompanyListOptions($projectUid: ID, $personalOnly: Boolean) {
  companyLists(
    page: 1
    perPage: 1000
    projectUuid: $projectUid
    personalOnly: $personalOnly
  ) {
    entries {
      ...CompanyListOption
    }
  }
}
    ${CompanyListOptionFragmentDoc}`;

/**
 * __useGetCompanyListOptionsQuery__
 *
 * To run a query within a React component, call `useGetCompanyListOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyListOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyListOptionsQuery({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *      personalOnly: // value for 'personalOnly'
 *   },
 * });
 */
export function useGetCompanyListOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyListOptionsQuery, GetCompanyListOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyListOptionsQuery, GetCompanyListOptionsQueryVariables>(GetCompanyListOptionsDocument, options);
      }
export function useGetCompanyListOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyListOptionsQuery, GetCompanyListOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyListOptionsQuery, GetCompanyListOptionsQueryVariables>(GetCompanyListOptionsDocument, options);
        }
export type GetCompanyListOptionsQueryHookResult = ReturnType<typeof useGetCompanyListOptionsQuery>;
export type GetCompanyListOptionsLazyQueryHookResult = ReturnType<typeof useGetCompanyListOptionsLazyQuery>;
export type GetCompanyListOptionsQueryResult = Apollo.QueryResult<GetCompanyListOptionsQuery, GetCompanyListOptionsQueryVariables>;
export const SetCompanyListMemberCustomFieldDocument = gql`
    mutation SetCompanyListMemberCustomField($listMemberUid: ID!, $customFieldAttributes: [CustomFieldAttribute!]!) {
  setCompanyListMemberCustomField(
    listMemberUid: $listMemberUid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
    record {
      ...CompanyListMemberRow
    }
  }
}
    ${CompanyListMemberRowFragmentDoc}`;
export type SetCompanyListMemberCustomFieldMutationFn = Apollo.MutationFunction<SetCompanyListMemberCustomFieldMutation, SetCompanyListMemberCustomFieldMutationVariables>;

/**
 * __useSetCompanyListMemberCustomFieldMutation__
 *
 * To run a mutation, you first call `useSetCompanyListMemberCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCompanyListMemberCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCompanyListMemberCustomFieldMutation, { data, loading, error }] = useSetCompanyListMemberCustomFieldMutation({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useSetCompanyListMemberCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<SetCompanyListMemberCustomFieldMutation, SetCompanyListMemberCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCompanyListMemberCustomFieldMutation, SetCompanyListMemberCustomFieldMutationVariables>(SetCompanyListMemberCustomFieldDocument, options);
      }
export type SetCompanyListMemberCustomFieldMutationHookResult = ReturnType<typeof useSetCompanyListMemberCustomFieldMutation>;
export type SetCompanyListMemberCustomFieldMutationResult = Apollo.MutationResult<SetCompanyListMemberCustomFieldMutation>;
export type SetCompanyListMemberCustomFieldMutationOptions = Apollo.BaseMutationOptions<SetCompanyListMemberCustomFieldMutation, SetCompanyListMemberCustomFieldMutationVariables>;
export const UpdateCompanyListDocument = gql`
    mutation UpdateCompanyList($uid: ID!, $name: String) {
  updateCompanyList(uid: $uid, name: $name) {
    failReasons
  }
}
    `;
export type UpdateCompanyListMutationFn = Apollo.MutationFunction<UpdateCompanyListMutation, UpdateCompanyListMutationVariables>;

/**
 * __useUpdateCompanyListMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyListMutation, { data, loading, error }] = useUpdateCompanyListMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCompanyListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyListMutation, UpdateCompanyListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyListMutation, UpdateCompanyListMutationVariables>(UpdateCompanyListDocument, options);
      }
export type UpdateCompanyListMutationHookResult = ReturnType<typeof useUpdateCompanyListMutation>;
export type UpdateCompanyListMutationResult = Apollo.MutationResult<UpdateCompanyListMutation>;
export type UpdateCompanyListMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyListMutation, UpdateCompanyListMutationVariables>;
export const CompanyListMembersDocument = gql`
    query CompanyListMembers($page: Int, $perPage: Int, $uid: ID!, $term: String) {
  companyListMembers(uid: $uid, page: $page, perPage: $perPage, term: $term) {
    entries {
      ...CompanyListMemberRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CompanyListMemberRowFragmentDoc}`;

/**
 * __useCompanyListMembersQuery__
 *
 * To run a query within a React component, call `useCompanyListMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListMembersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      uid: // value for 'uid'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useCompanyListMembersQuery(baseOptions: Apollo.QueryHookOptions<CompanyListMembersQuery, CompanyListMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListMembersQuery, CompanyListMembersQueryVariables>(CompanyListMembersDocument, options);
      }
export function useCompanyListMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListMembersQuery, CompanyListMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListMembersQuery, CompanyListMembersQueryVariables>(CompanyListMembersDocument, options);
        }
export type CompanyListMembersQueryHookResult = ReturnType<typeof useCompanyListMembersQuery>;
export type CompanyListMembersLazyQueryHookResult = ReturnType<typeof useCompanyListMembersLazyQuery>;
export type CompanyListMembersQueryResult = Apollo.QueryResult<CompanyListMembersQuery, CompanyListMembersQueryVariables>;
export const CompanyListMembersTotalDocument = gql`
    query CompanyListMembersTotal($uid: ID!) {
  companyListMembers(uid: $uid, page: 1, perPage: 1) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useCompanyListMembersTotalQuery__
 *
 * To run a query within a React component, call `useCompanyListMembersTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListMembersTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListMembersTotalQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCompanyListMembersTotalQuery(baseOptions: Apollo.QueryHookOptions<CompanyListMembersTotalQuery, CompanyListMembersTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListMembersTotalQuery, CompanyListMembersTotalQueryVariables>(CompanyListMembersTotalDocument, options);
      }
export function useCompanyListMembersTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListMembersTotalQuery, CompanyListMembersTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListMembersTotalQuery, CompanyListMembersTotalQueryVariables>(CompanyListMembersTotalDocument, options);
        }
export type CompanyListMembersTotalQueryHookResult = ReturnType<typeof useCompanyListMembersTotalQuery>;
export type CompanyListMembersTotalLazyQueryHookResult = ReturnType<typeof useCompanyListMembersTotalLazyQuery>;
export type CompanyListMembersTotalQueryResult = Apollo.QueryResult<CompanyListMembersTotalQuery, CompanyListMembersTotalQueryVariables>;
export const BulkArchiveContactDocument = gql`
    mutation BulkArchiveContact($contactUuids: [ID!]!, $unarchiveOnInteraction: Boolean!) {
  bulkArchiveContact(
    contactUuids: $contactUuids
    unarchiveOnInteraction: $unarchiveOnInteraction
  ) {
    failReasons
  }
}
    `;
export type BulkArchiveContactMutationFn = Apollo.MutationFunction<BulkArchiveContactMutation, BulkArchiveContactMutationVariables>;

/**
 * __useBulkArchiveContactMutation__
 *
 * To run a mutation, you first call `useBulkArchiveContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkArchiveContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkArchiveContactMutation, { data, loading, error }] = useBulkArchiveContactMutation({
 *   variables: {
 *      contactUuids: // value for 'contactUuids'
 *      unarchiveOnInteraction: // value for 'unarchiveOnInteraction'
 *   },
 * });
 */
export function useBulkArchiveContactMutation(baseOptions?: Apollo.MutationHookOptions<BulkArchiveContactMutation, BulkArchiveContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkArchiveContactMutation, BulkArchiveContactMutationVariables>(BulkArchiveContactDocument, options);
      }
export type BulkArchiveContactMutationHookResult = ReturnType<typeof useBulkArchiveContactMutation>;
export type BulkArchiveContactMutationResult = Apollo.MutationResult<BulkArchiveContactMutation>;
export type BulkArchiveContactMutationOptions = Apollo.BaseMutationOptions<BulkArchiveContactMutation, BulkArchiveContactMutationVariables>;
export const CompanyContactsDocument = gql`
    query CompanyContacts($page: Int, $perPage: Int, $term: String, $companyId: ID, $orderBy: ContactsOrderBy, $country: String, $city: String) {
  contacts(
    page: $page
    perPage: $perPage
    filter: {term: $term, companyUid: $companyId, includeInternalContact: true}
    filters: [{operator: IS, property: COUNTRY, value: $country}, {operator: IS, property: CITY, value: $city}]
    orderBy: $orderBy
  ) {
    entries {
      ...CompanyContactRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CompanyContactRowFragmentDoc}`;

/**
 * __useCompanyContactsQuery__
 *
 * To run a query within a React component, call `useCompanyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyContactsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *      companyId: // value for 'companyId'
 *      orderBy: // value for 'orderBy'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useCompanyContactsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
      }
export function useCompanyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
        }
export type CompanyContactsQueryHookResult = ReturnType<typeof useCompanyContactsQuery>;
export type CompanyContactsLazyQueryHookResult = ReturnType<typeof useCompanyContactsLazyQuery>;
export type CompanyContactsQueryResult = Apollo.QueryResult<CompanyContactsQuery, CompanyContactsQueryVariables>;
export const ContactDocument = gql`
    query Contact($uid: String!) {
  contact(uid: $uid) {
    ...ContactProfile
  }
  myContact(uid: $uid) {
    ...MyContactExists
  }
}
    ${ContactProfileFragmentDoc}
${MyContactExistsFragmentDoc}`;

/**
 * __useContactQuery__
 *
 * To run a query within a React component, call `useContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useContactQuery(baseOptions: Apollo.QueryHookOptions<ContactQuery, ContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
      }
export function useContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export type ContactQueryHookResult = ReturnType<typeof useContactQuery>;
export type ContactLazyQueryHookResult = ReturnType<typeof useContactLazyQuery>;
export type ContactQueryResult = Apollo.QueryResult<ContactQuery, ContactQueryVariables>;
export const ContactsDocument = gql`
    query Contacts($page: Int, $perPage: Int, $filters: [ContactFilter!], $filter: ContactsFiltering, $orderBy: ContactsOrderBy) {
  contacts(
    page: $page
    perPage: $perPage
    filters: $filters
    filter: $filter
    orderBy: $orderBy
  ) {
    entries {
      ...ContactListRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactListRowFragmentDoc}`;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useContactsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const ContactsWithGroupsDocument = gql`
    query ContactsWithGroups($page: Int, $perPage: Int, $orderBy: ContactsOrderBy, $filter: ContactsFiltering) {
  contacts(page: $page, perPage: $perPage, filter: $filter, orderBy: $orderBy) {
    entries {
      ...ContactListRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactListRowFragmentDoc}`;

/**
 * __useContactsWithGroupsQuery__
 *
 * To run a query within a React component, call `useContactsWithGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsWithGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsWithGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useContactsWithGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsWithGroupsQuery, ContactsWithGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsWithGroupsQuery, ContactsWithGroupsQueryVariables>(ContactsWithGroupsDocument, options);
      }
export function useContactsWithGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsWithGroupsQuery, ContactsWithGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsWithGroupsQuery, ContactsWithGroupsQueryVariables>(ContactsWithGroupsDocument, options);
        }
export type ContactsWithGroupsQueryHookResult = ReturnType<typeof useContactsWithGroupsQuery>;
export type ContactsWithGroupsLazyQueryHookResult = ReturnType<typeof useContactsWithGroupsLazyQuery>;
export type ContactsWithGroupsQueryResult = Apollo.QueryResult<ContactsWithGroupsQuery, ContactsWithGroupsQueryVariables>;
export const EnterEmailDocument = gql`
    query EnterEmail($uid: String!) {
  person(uid: $uid) {
    id
  }
}
    `;

/**
 * __useEnterEmailQuery__
 *
 * To run a query within a React component, call `useEnterEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterEmailQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useEnterEmailQuery(baseOptions: Apollo.QueryHookOptions<EnterEmailQuery, EnterEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnterEmailQuery, EnterEmailQueryVariables>(EnterEmailDocument, options);
      }
export function useEnterEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnterEmailQuery, EnterEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnterEmailQuery, EnterEmailQueryVariables>(EnterEmailDocument, options);
        }
export type EnterEmailQueryHookResult = ReturnType<typeof useEnterEmailQuery>;
export type EnterEmailLazyQueryHookResult = ReturnType<typeof useEnterEmailLazyQuery>;
export type EnterEmailQueryResult = Apollo.QueryResult<EnterEmailQuery, EnterEmailQueryVariables>;
export const FlagDuplicatePeopleDocument = gql`
    mutation FlagDuplicatePeople($originalPersonUid: ID!, $duplicatePersonUid: ID!) {
  flagDuplicatePeople(
    originalPersonUid: $originalPersonUid
    duplicatePersonUid: $duplicatePersonUid
  ) {
    failReasons
  }
}
    `;
export type FlagDuplicatePeopleMutationFn = Apollo.MutationFunction<FlagDuplicatePeopleMutation, FlagDuplicatePeopleMutationVariables>;

/**
 * __useFlagDuplicatePeopleMutation__
 *
 * To run a mutation, you first call `useFlagDuplicatePeopleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagDuplicatePeopleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagDuplicatePeopleMutation, { data, loading, error }] = useFlagDuplicatePeopleMutation({
 *   variables: {
 *      originalPersonUid: // value for 'originalPersonUid'
 *      duplicatePersonUid: // value for 'duplicatePersonUid'
 *   },
 * });
 */
export function useFlagDuplicatePeopleMutation(baseOptions?: Apollo.MutationHookOptions<FlagDuplicatePeopleMutation, FlagDuplicatePeopleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlagDuplicatePeopleMutation, FlagDuplicatePeopleMutationVariables>(FlagDuplicatePeopleDocument, options);
      }
export type FlagDuplicatePeopleMutationHookResult = ReturnType<typeof useFlagDuplicatePeopleMutation>;
export type FlagDuplicatePeopleMutationResult = Apollo.MutationResult<FlagDuplicatePeopleMutation>;
export type FlagDuplicatePeopleMutationOptions = Apollo.BaseMutationOptions<FlagDuplicatePeopleMutation, FlagDuplicatePeopleMutationVariables>;
export const GetContactForEditDocument = gql`
    query GetContactForEdit($uid: String!) {
  contact(uid: $uid) {
    ...ContactForEdit
  }
}
    ${ContactForEditFragmentDoc}`;

/**
 * __useGetContactForEditQuery__
 *
 * To run a query within a React component, call `useGetContactForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactForEditQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetContactForEditQuery(baseOptions: Apollo.QueryHookOptions<GetContactForEditQuery, GetContactForEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactForEditQuery, GetContactForEditQueryVariables>(GetContactForEditDocument, options);
      }
export function useGetContactForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactForEditQuery, GetContactForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactForEditQuery, GetContactForEditQueryVariables>(GetContactForEditDocument, options);
        }
export type GetContactForEditQueryHookResult = ReturnType<typeof useGetContactForEditQuery>;
export type GetContactForEditLazyQueryHookResult = ReturnType<typeof useGetContactForEditLazyQuery>;
export type GetContactForEditQueryResult = Apollo.QueryResult<GetContactForEditQuery, GetContactForEditQueryVariables>;
export const GetContactIdDocument = gql`
    query GetContactId($uid: String!) {
  contact(uid: $uid) {
    id
  }
}
    `;

/**
 * __useGetContactIdQuery__
 *
 * To run a query within a React component, call `useGetContactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetContactIdQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdQuery, GetContactIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdQuery, GetContactIdQueryVariables>(GetContactIdDocument, options);
      }
export function useGetContactIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdQuery, GetContactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdQuery, GetContactIdQueryVariables>(GetContactIdDocument, options);
        }
export type GetContactIdQueryHookResult = ReturnType<typeof useGetContactIdQuery>;
export type GetContactIdLazyQueryHookResult = ReturnType<typeof useGetContactIdLazyQuery>;
export type GetContactIdQueryResult = Apollo.QueryResult<GetContactIdQuery, GetContactIdQueryVariables>;
export const KeyActivityDescriptionsDocument = gql`
    query KeyActivityDescriptions($term: String, $activityTitle: String) {
  keyActivityDescriptions(term: $term, activityTitle: $activityTitle) {
    entries
  }
}
    `;

/**
 * __useKeyActivityDescriptionsQuery__
 *
 * To run a query within a React component, call `useKeyActivityDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityDescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityDescriptionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      activityTitle: // value for 'activityTitle'
 *   },
 * });
 */
export function useKeyActivityDescriptionsQuery(baseOptions?: Apollo.QueryHookOptions<KeyActivityDescriptionsQuery, KeyActivityDescriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityDescriptionsQuery, KeyActivityDescriptionsQueryVariables>(KeyActivityDescriptionsDocument, options);
      }
export function useKeyActivityDescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityDescriptionsQuery, KeyActivityDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityDescriptionsQuery, KeyActivityDescriptionsQueryVariables>(KeyActivityDescriptionsDocument, options);
        }
export type KeyActivityDescriptionsQueryHookResult = ReturnType<typeof useKeyActivityDescriptionsQuery>;
export type KeyActivityDescriptionsLazyQueryHookResult = ReturnType<typeof useKeyActivityDescriptionsLazyQuery>;
export type KeyActivityDescriptionsQueryResult = Apollo.QueryResult<KeyActivityDescriptionsQuery, KeyActivityDescriptionsQueryVariables>;
export const KeyActivityTitleDocument = gql`
    query KeyActivityTitle($term: String, $searchMode: Boolean) {
  keyActivityTitles(term: $term, searchMode: $searchMode) {
    entries
  }
}
    `;

/**
 * __useKeyActivityTitleQuery__
 *
 * To run a query within a React component, call `useKeyActivityTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityTitleQuery({
 *   variables: {
 *      term: // value for 'term'
 *      searchMode: // value for 'searchMode'
 *   },
 * });
 */
export function useKeyActivityTitleQuery(baseOptions?: Apollo.QueryHookOptions<KeyActivityTitleQuery, KeyActivityTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityTitleQuery, KeyActivityTitleQueryVariables>(KeyActivityTitleDocument, options);
      }
export function useKeyActivityTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityTitleQuery, KeyActivityTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityTitleQuery, KeyActivityTitleQueryVariables>(KeyActivityTitleDocument, options);
        }
export type KeyActivityTitleQueryHookResult = ReturnType<typeof useKeyActivityTitleQuery>;
export type KeyActivityTitleLazyQueryHookResult = ReturnType<typeof useKeyActivityTitleLazyQuery>;
export type KeyActivityTitleQueryResult = Apollo.QueryResult<KeyActivityTitleQuery, KeyActivityTitleQueryVariables>;
export const MarkContactAsJobNotChangeDocument = gql`
    mutation MarkContactAsJobNotChange($uid: ID!) {
  markContactAsJobNotChange(uid: $uid) {
    failReasons
  }
}
    `;
export type MarkContactAsJobNotChangeMutationFn = Apollo.MutationFunction<MarkContactAsJobNotChangeMutation, MarkContactAsJobNotChangeMutationVariables>;

/**
 * __useMarkContactAsJobNotChangeMutation__
 *
 * To run a mutation, you first call `useMarkContactAsJobNotChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkContactAsJobNotChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markContactAsJobNotChangeMutation, { data, loading, error }] = useMarkContactAsJobNotChangeMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useMarkContactAsJobNotChangeMutation(baseOptions?: Apollo.MutationHookOptions<MarkContactAsJobNotChangeMutation, MarkContactAsJobNotChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkContactAsJobNotChangeMutation, MarkContactAsJobNotChangeMutationVariables>(MarkContactAsJobNotChangeDocument, options);
      }
export type MarkContactAsJobNotChangeMutationHookResult = ReturnType<typeof useMarkContactAsJobNotChangeMutation>;
export type MarkContactAsJobNotChangeMutationResult = Apollo.MutationResult<MarkContactAsJobNotChangeMutation>;
export type MarkContactAsJobNotChangeMutationOptions = Apollo.BaseMutationOptions<MarkContactAsJobNotChangeMutation, MarkContactAsJobNotChangeMutationVariables>;
export const OutlookSyncAllowedDocument = gql`
    query OutlookSyncAllowed {
  outlookSyncAllowed
}
    `;

/**
 * __useOutlookSyncAllowedQuery__
 *
 * To run a query within a React component, call `useOutlookSyncAllowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutlookSyncAllowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutlookSyncAllowedQuery({
 *   variables: {
 *   },
 * });
 */
export function useOutlookSyncAllowedQuery(baseOptions?: Apollo.QueryHookOptions<OutlookSyncAllowedQuery, OutlookSyncAllowedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutlookSyncAllowedQuery, OutlookSyncAllowedQueryVariables>(OutlookSyncAllowedDocument, options);
      }
export function useOutlookSyncAllowedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutlookSyncAllowedQuery, OutlookSyncAllowedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutlookSyncAllowedQuery, OutlookSyncAllowedQueryVariables>(OutlookSyncAllowedDocument, options);
        }
export type OutlookSyncAllowedQueryHookResult = ReturnType<typeof useOutlookSyncAllowedQuery>;
export type OutlookSyncAllowedLazyQueryHookResult = ReturnType<typeof useOutlookSyncAllowedLazyQuery>;
export type OutlookSyncAllowedQueryResult = Apollo.QueryResult<OutlookSyncAllowedQuery, OutlookSyncAllowedQueryVariables>;
export const PersonContactsDocument = gql`
    query PersonContacts($uid: String!) {
  person(uid: $uid) {
    id
    contacts {
      ...PersonContact
    }
  }
}
    ${PersonContactFragmentDoc}`;

/**
 * __usePersonContactsQuery__
 *
 * To run a query within a React component, call `usePersonContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonContactsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function usePersonContactsQuery(baseOptions: Apollo.QueryHookOptions<PersonContactsQuery, PersonContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonContactsQuery, PersonContactsQueryVariables>(PersonContactsDocument, options);
      }
export function usePersonContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonContactsQuery, PersonContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonContactsQuery, PersonContactsQueryVariables>(PersonContactsDocument, options);
        }
export type PersonContactsQueryHookResult = ReturnType<typeof usePersonContactsQuery>;
export type PersonContactsLazyQueryHookResult = ReturnType<typeof usePersonContactsLazyQuery>;
export type PersonContactsQueryResult = Apollo.QueryResult<PersonContactsQuery, PersonContactsQueryVariables>;
export const RemoveEmailAddressDocument = gql`
    mutation RemoveEmailAddress($value: String!) {
  removeEmailAddress(value: $value) {
    failReasons
  }
}
    `;
export type RemoveEmailAddressMutationFn = Apollo.MutationFunction<RemoveEmailAddressMutation, RemoveEmailAddressMutationVariables>;

/**
 * __useRemoveEmailAddressMutation__
 *
 * To run a mutation, you first call `useRemoveEmailAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmailAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmailAddressMutation, { data, loading, error }] = useRemoveEmailAddressMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useRemoveEmailAddressMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmailAddressMutation, RemoveEmailAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmailAddressMutation, RemoveEmailAddressMutationVariables>(RemoveEmailAddressDocument, options);
      }
export type RemoveEmailAddressMutationHookResult = ReturnType<typeof useRemoveEmailAddressMutation>;
export type RemoveEmailAddressMutationResult = Apollo.MutationResult<RemoveEmailAddressMutation>;
export type RemoveEmailAddressMutationOptions = Apollo.BaseMutationOptions<RemoveEmailAddressMutation, RemoveEmailAddressMutationVariables>;
export const ReportIncorrectContactDataDocument = gql`
    mutation ReportIncorrectContactData($contactUid: ID!, $reporterUid: ID!, $fields: [String!], $comment: String) {
  reportIncorrectContactData(
    contactUid: $contactUid
    reporterUid: $reporterUid
    fields: $fields
    comment: $comment
  ) {
    failReasons
  }
}
    `;
export type ReportIncorrectContactDataMutationFn = Apollo.MutationFunction<ReportIncorrectContactDataMutation, ReportIncorrectContactDataMutationVariables>;

/**
 * __useReportIncorrectContactDataMutation__
 *
 * To run a mutation, you first call `useReportIncorrectContactDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportIncorrectContactDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportIncorrectContactDataMutation, { data, loading, error }] = useReportIncorrectContactDataMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      reporterUid: // value for 'reporterUid'
 *      fields: // value for 'fields'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useReportIncorrectContactDataMutation(baseOptions?: Apollo.MutationHookOptions<ReportIncorrectContactDataMutation, ReportIncorrectContactDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportIncorrectContactDataMutation, ReportIncorrectContactDataMutationVariables>(ReportIncorrectContactDataDocument, options);
      }
export type ReportIncorrectContactDataMutationHookResult = ReturnType<typeof useReportIncorrectContactDataMutation>;
export type ReportIncorrectContactDataMutationResult = Apollo.MutationResult<ReportIncorrectContactDataMutation>;
export type ReportIncorrectContactDataMutationOptions = Apollo.BaseMutationOptions<ReportIncorrectContactDataMutation, ReportIncorrectContactDataMutationVariables>;
export const RestoreBouncedEmailDocument = gql`
    mutation RestoreBouncedEmail($email: String!) {
  restoreBouncedEmail(email: $email) {
    failReasons
    contact {
      id
      bounce: interactionsBounce {
        id
        count
      }
    }
  }
}
    `;
export type RestoreBouncedEmailMutationFn = Apollo.MutationFunction<RestoreBouncedEmailMutation, RestoreBouncedEmailMutationVariables>;

/**
 * __useRestoreBouncedEmailMutation__
 *
 * To run a mutation, you first call `useRestoreBouncedEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreBouncedEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreBouncedEmailMutation, { data, loading, error }] = useRestoreBouncedEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRestoreBouncedEmailMutation(baseOptions?: Apollo.MutationHookOptions<RestoreBouncedEmailMutation, RestoreBouncedEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreBouncedEmailMutation, RestoreBouncedEmailMutationVariables>(RestoreBouncedEmailDocument, options);
      }
export type RestoreBouncedEmailMutationHookResult = ReturnType<typeof useRestoreBouncedEmailMutation>;
export type RestoreBouncedEmailMutationResult = Apollo.MutationResult<RestoreBouncedEmailMutation>;
export type RestoreBouncedEmailMutationOptions = Apollo.BaseMutationOptions<RestoreBouncedEmailMutation, RestoreBouncedEmailMutationVariables>;
export const SyncOutlookContactDocument = gql`
    mutation SyncOutlookContact($contactUid: ID!) {
  syncOutlookContact(contactUid: $contactUid) {
    failReasons
  }
}
    `;
export type SyncOutlookContactMutationFn = Apollo.MutationFunction<SyncOutlookContactMutation, SyncOutlookContactMutationVariables>;

/**
 * __useSyncOutlookContactMutation__
 *
 * To run a mutation, you first call `useSyncOutlookContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncOutlookContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncOutlookContactMutation, { data, loading, error }] = useSyncOutlookContactMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useSyncOutlookContactMutation(baseOptions?: Apollo.MutationHookOptions<SyncOutlookContactMutation, SyncOutlookContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncOutlookContactMutation, SyncOutlookContactMutationVariables>(SyncOutlookContactDocument, options);
      }
export type SyncOutlookContactMutationHookResult = ReturnType<typeof useSyncOutlookContactMutation>;
export type SyncOutlookContactMutationResult = Apollo.MutationResult<SyncOutlookContactMutation>;
export type SyncOutlookContactMutationOptions = Apollo.BaseMutationOptions<SyncOutlookContactMutation, SyncOutlookContactMutationVariables>;
export const UnarchiveContactDocument = gql`
    mutation UnarchiveContact($uid: ID!) {
  unarchiveContact(uid: $uid) {
    failReasons
  }
}
    `;
export type UnarchiveContactMutationFn = Apollo.MutationFunction<UnarchiveContactMutation, UnarchiveContactMutationVariables>;

/**
 * __useUnarchiveContactMutation__
 *
 * To run a mutation, you first call `useUnarchiveContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveContactMutation, { data, loading, error }] = useUnarchiveContactMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useUnarchiveContactMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveContactMutation, UnarchiveContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveContactMutation, UnarchiveContactMutationVariables>(UnarchiveContactDocument, options);
      }
export type UnarchiveContactMutationHookResult = ReturnType<typeof useUnarchiveContactMutation>;
export type UnarchiveContactMutationResult = Apollo.MutationResult<UnarchiveContactMutation>;
export type UnarchiveContactMutationOptions = Apollo.BaseMutationOptions<UnarchiveContactMutation, UnarchiveContactMutationVariables>;
export const UpdateContactDetailsDocument = gql`
    mutation UpdateContactDetails($uid: ID!, $attributes: ContactAttributes!, $emailAddresses: [EmailEntryInput!]) {
  updateTenantContact: updateContact(
    uid: $uid
    emailAddresses: $emailAddresses
    attributes: $attributes
  ) {
    failReasons
  }
}
    `;
export type UpdateContactDetailsMutationFn = Apollo.MutationFunction<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>;

/**
 * __useUpdateContactDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateContactDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactDetailsMutation, { data, loading, error }] = useUpdateContactDetailsMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *      emailAddresses: // value for 'emailAddresses'
 *   },
 * });
 */
export function useUpdateContactDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>(UpdateContactDetailsDocument, options);
      }
export type UpdateContactDetailsMutationHookResult = ReturnType<typeof useUpdateContactDetailsMutation>;
export type UpdateContactDetailsMutationResult = Apollo.MutationResult<UpdateContactDetailsMutation>;
export type UpdateContactDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>;
export const UpdateContactEmailDocument = gql`
    mutation UpdateContactEmail($uid: ID!, $attributes: ContactAttributes!, $emailAddress: String!) {
  updateContact(uid: $uid, attributes: $attributes, emailAddress: $emailAddress) {
    failReasons
  }
}
    `;
export type UpdateContactEmailMutationFn = Apollo.MutationFunction<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>;

/**
 * __useUpdateContactEmailMutation__
 *
 * To run a mutation, you first call `useUpdateContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactEmailMutation, { data, loading, error }] = useUpdateContactEmailMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useUpdateContactEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>(UpdateContactEmailDocument, options);
      }
export type UpdateContactEmailMutationHookResult = ReturnType<typeof useUpdateContactEmailMutation>;
export type UpdateContactEmailMutationResult = Apollo.MutationResult<UpdateContactEmailMutation>;
export type UpdateContactEmailMutationOptions = Apollo.BaseMutationOptions<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>;
export const UpdateContactEmailsDocument = gql`
    mutation UpdateContactEmails($contactUid: ID!, $emailAddresses: [EmailEntryInput!]!) {
  updateContactEmails(contactUid: $contactUid, emailAddresses: $emailAddresses) {
    failReasons
    record {
      id
      emailAddresses
    }
  }
}
    `;
export type UpdateContactEmailsMutationFn = Apollo.MutationFunction<UpdateContactEmailsMutation, UpdateContactEmailsMutationVariables>;

/**
 * __useUpdateContactEmailsMutation__
 *
 * To run a mutation, you first call `useUpdateContactEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactEmailsMutation, { data, loading, error }] = useUpdateContactEmailsMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      emailAddresses: // value for 'emailAddresses'
 *   },
 * });
 */
export function useUpdateContactEmailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactEmailsMutation, UpdateContactEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactEmailsMutation, UpdateContactEmailsMutationVariables>(UpdateContactEmailsDocument, options);
      }
export type UpdateContactEmailsMutationHookResult = ReturnType<typeof useUpdateContactEmailsMutation>;
export type UpdateContactEmailsMutationResult = Apollo.MutationResult<UpdateContactEmailsMutation>;
export type UpdateContactEmailsMutationOptions = Apollo.BaseMutationOptions<UpdateContactEmailsMutation, UpdateContactEmailsMutationVariables>;
export const UpdateContactPrivacyDocument = gql`
    mutation UpdateContactPrivacy($myContactUid: ID!, $privacyStatus: ContactPrivacy!) {
  updateContactPrivacy(myContactUid: $myContactUid, privacyStatus: $privacyStatus) {
    failReasons
  }
}
    `;
export type UpdateContactPrivacyMutationFn = Apollo.MutationFunction<UpdateContactPrivacyMutation, UpdateContactPrivacyMutationVariables>;

/**
 * __useUpdateContactPrivacyMutation__
 *
 * To run a mutation, you first call `useUpdateContactPrivacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactPrivacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactPrivacyMutation, { data, loading, error }] = useUpdateContactPrivacyMutation({
 *   variables: {
 *      myContactUid: // value for 'myContactUid'
 *      privacyStatus: // value for 'privacyStatus'
 *   },
 * });
 */
export function useUpdateContactPrivacyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactPrivacyMutation, UpdateContactPrivacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactPrivacyMutation, UpdateContactPrivacyMutationVariables>(UpdateContactPrivacyDocument, options);
      }
export type UpdateContactPrivacyMutationHookResult = ReturnType<typeof useUpdateContactPrivacyMutation>;
export type UpdateContactPrivacyMutationResult = Apollo.MutationResult<UpdateContactPrivacyMutation>;
export type UpdateContactPrivacyMutationOptions = Apollo.BaseMutationOptions<UpdateContactPrivacyMutation, UpdateContactPrivacyMutationVariables>;
export const UpdatePersonDetailsDocument = gql`
    mutation UpdatePersonDetails($uid: ID!, $attributes: ContactAttributes!) {
  updateTenantContact: updateContact(uid: $uid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type UpdatePersonDetailsMutationFn = Apollo.MutationFunction<UpdatePersonDetailsMutation, UpdatePersonDetailsMutationVariables>;

/**
 * __useUpdatePersonDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePersonDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonDetailsMutation, { data, loading, error }] = useUpdatePersonDetailsMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePersonDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonDetailsMutation, UpdatePersonDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonDetailsMutation, UpdatePersonDetailsMutationVariables>(UpdatePersonDetailsDocument, options);
      }
export type UpdatePersonDetailsMutationHookResult = ReturnType<typeof useUpdatePersonDetailsMutation>;
export type UpdatePersonDetailsMutationResult = Apollo.MutationResult<UpdatePersonDetailsMutation>;
export type UpdatePersonDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePersonDetailsMutation, UpdatePersonDetailsMutationVariables>;
export const WhoKnowsDocument = gql`
    query WhoKnows($contactUid: String!, $filter: WhoKnowsFiltering, $page: Int, $perPage: Int) {
  whoKnows(
    contactUid: $contactUid
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...ContactWhoKnowsUser
    }
  }
}
    ${ContactWhoKnowsUserFragmentDoc}`;

/**
 * __useWhoKnowsQuery__
 *
 * To run a query within a React component, call `useWhoKnowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoKnowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoKnowsQuery({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useWhoKnowsQuery(baseOptions: Apollo.QueryHookOptions<WhoKnowsQuery, WhoKnowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoKnowsQuery, WhoKnowsQueryVariables>(WhoKnowsDocument, options);
      }
export function useWhoKnowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoKnowsQuery, WhoKnowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoKnowsQuery, WhoKnowsQueryVariables>(WhoKnowsDocument, options);
        }
export type WhoKnowsQueryHookResult = ReturnType<typeof useWhoKnowsQuery>;
export type WhoKnowsLazyQueryHookResult = ReturnType<typeof useWhoKnowsLazyQuery>;
export type WhoKnowsQueryResult = Apollo.QueryResult<WhoKnowsQuery, WhoKnowsQueryVariables>;
export const WhoPreviouslyKnewDocument = gql`
    query WhoPreviouslyKnew($contactUid: String!, $filter: WhoKnowsFiltering, $page: Int, $perPage: Int) {
  whoPreviouslyKnew(
    contactUid: $contactUid
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...WhoPreviouslyKnewByJob
    }
  }
}
    ${WhoPreviouslyKnewByJobFragmentDoc}`;

/**
 * __useWhoPreviouslyKnewQuery__
 *
 * To run a query within a React component, call `useWhoPreviouslyKnewQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoPreviouslyKnewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoPreviouslyKnewQuery({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useWhoPreviouslyKnewQuery(baseOptions: Apollo.QueryHookOptions<WhoPreviouslyKnewQuery, WhoPreviouslyKnewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoPreviouslyKnewQuery, WhoPreviouslyKnewQueryVariables>(WhoPreviouslyKnewDocument, options);
      }
export function useWhoPreviouslyKnewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoPreviouslyKnewQuery, WhoPreviouslyKnewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoPreviouslyKnewQuery, WhoPreviouslyKnewQueryVariables>(WhoPreviouslyKnewDocument, options);
        }
export type WhoPreviouslyKnewQueryHookResult = ReturnType<typeof useWhoPreviouslyKnewQuery>;
export type WhoPreviouslyKnewLazyQueryHookResult = ReturnType<typeof useWhoPreviouslyKnewLazyQuery>;
export type WhoPreviouslyKnewQueryResult = Apollo.QueryResult<WhoPreviouslyKnewQuery, WhoPreviouslyKnewQueryVariables>;
export const EmailLookupDocument = gql`
    query EmailLookup($email: String!) {
  emailLookup(email: $email) {
    isPersonal
    isExceptional
  }
}
    `;

/**
 * __useEmailLookupQuery__
 *
 * To run a query within a React component, call `useEmailLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailLookupQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailLookupQuery(baseOptions: Apollo.QueryHookOptions<EmailLookupQuery, EmailLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailLookupQuery, EmailLookupQueryVariables>(EmailLookupDocument, options);
      }
export function useEmailLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailLookupQuery, EmailLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailLookupQuery, EmailLookupQueryVariables>(EmailLookupDocument, options);
        }
export type EmailLookupQueryHookResult = ReturnType<typeof useEmailLookupQuery>;
export type EmailLookupLazyQueryHookResult = ReturnType<typeof useEmailLookupLazyQuery>;
export type EmailLookupQueryResult = Apollo.QueryResult<EmailLookupQuery, EmailLookupQueryVariables>;
export const ContactAuditTrailDocument = gql`
    query ContactAuditTrail($contactUid: ID!) {
  contactAuditTrail(contactUid: $contactUid) {
    entries {
      ...Audit
    }
  }
}
    ${AuditFragmentDoc}`;

/**
 * __useContactAuditTrailQuery__
 *
 * To run a query within a React component, call `useContactAuditTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAuditTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAuditTrailQuery({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useContactAuditTrailQuery(baseOptions: Apollo.QueryHookOptions<ContactAuditTrailQuery, ContactAuditTrailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAuditTrailQuery, ContactAuditTrailQueryVariables>(ContactAuditTrailDocument, options);
      }
export function useContactAuditTrailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAuditTrailQuery, ContactAuditTrailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAuditTrailQuery, ContactAuditTrailQueryVariables>(ContactAuditTrailDocument, options);
        }
export type ContactAuditTrailQueryHookResult = ReturnType<typeof useContactAuditTrailQuery>;
export type ContactAuditTrailLazyQueryHookResult = ReturnType<typeof useContactAuditTrailLazyQuery>;
export type ContactAuditTrailQueryResult = Apollo.QueryResult<ContactAuditTrailQuery, ContactAuditTrailQueryVariables>;
export const ContactConsentDocument = gql`
    query ContactConsent($contactUid: ID!) {
  contactConsent(contactUid: $contactUid) {
    ...ContactConsent
  }
  config: marketingListConfiguration {
    ...MarketingListConfiguration
  }
}
    ${ContactConsentFragmentDoc}
${MarketingListConfigurationFragmentDoc}`;

/**
 * __useContactConsentQuery__
 *
 * To run a query within a React component, call `useContactConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactConsentQuery({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useContactConsentQuery(baseOptions: Apollo.QueryHookOptions<ContactConsentQuery, ContactConsentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactConsentQuery, ContactConsentQueryVariables>(ContactConsentDocument, options);
      }
export function useContactConsentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactConsentQuery, ContactConsentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactConsentQuery, ContactConsentQueryVariables>(ContactConsentDocument, options);
        }
export type ContactConsentQueryHookResult = ReturnType<typeof useContactConsentQuery>;
export type ContactConsentLazyQueryHookResult = ReturnType<typeof useContactConsentLazyQuery>;
export type ContactConsentQueryResult = Apollo.QueryResult<ContactConsentQuery, ContactConsentQueryVariables>;
export const UpdateContactConsentDocument = gql`
    mutation UpdateContactConsent($attributes: ContactConsentAttribute!, $contactUid: ID!) {
  updateContactConsent(contactUid: $contactUid, attributes: $attributes) {
    failReasons
    record {
      status
    }
  }
}
    `;
export type UpdateContactConsentMutationFn = Apollo.MutationFunction<UpdateContactConsentMutation, UpdateContactConsentMutationVariables>;

/**
 * __useUpdateContactConsentMutation__
 *
 * To run a mutation, you first call `useUpdateContactConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactConsentMutation, { data, loading, error }] = useUpdateContactConsentMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useUpdateContactConsentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactConsentMutation, UpdateContactConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactConsentMutation, UpdateContactConsentMutationVariables>(UpdateContactConsentDocument, options);
      }
export type UpdateContactConsentMutationHookResult = ReturnType<typeof useUpdateContactConsentMutation>;
export type UpdateContactConsentMutationResult = Apollo.MutationResult<UpdateContactConsentMutation>;
export type UpdateContactConsentMutationOptions = Apollo.BaseMutationOptions<UpdateContactConsentMutation, UpdateContactConsentMutationVariables>;
export const ContactCustomFieldSchemaDocument = gql`
    query ContactCustomFieldSchema {
  currentTenant {
    id
    contactInfoCustomFields {
      ...CustomFieldSchema
    }
  }
}
    ${CustomFieldSchemaFragmentDoc}`;

/**
 * __useContactCustomFieldSchemaQuery__
 *
 * To run a query within a React component, call `useContactCustomFieldSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCustomFieldSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCustomFieldSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactCustomFieldSchemaQuery(baseOptions?: Apollo.QueryHookOptions<ContactCustomFieldSchemaQuery, ContactCustomFieldSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCustomFieldSchemaQuery, ContactCustomFieldSchemaQueryVariables>(ContactCustomFieldSchemaDocument, options);
      }
export function useContactCustomFieldSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCustomFieldSchemaQuery, ContactCustomFieldSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCustomFieldSchemaQuery, ContactCustomFieldSchemaQueryVariables>(ContactCustomFieldSchemaDocument, options);
        }
export type ContactCustomFieldSchemaQueryHookResult = ReturnType<typeof useContactCustomFieldSchemaQuery>;
export type ContactCustomFieldSchemaLazyQueryHookResult = ReturnType<typeof useContactCustomFieldSchemaLazyQuery>;
export type ContactCustomFieldSchemaQueryResult = Apollo.QueryResult<ContactCustomFieldSchemaQuery, ContactCustomFieldSchemaQueryVariables>;
export const MarketingContactAllowanceDocument = gql`
    query MarketingContactAllowance($page: Int, $perPage: Int) {
  emailMarketingContactAllowances(page: $page, perPage: $perPage) {
    entries {
      ...MarketingContactAllowanceRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${MarketingContactAllowanceRowFragmentDoc}`;

/**
 * __useMarketingContactAllowanceQuery__
 *
 * To run a query within a React component, call `useMarketingContactAllowanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingContactAllowanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingContactAllowanceQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMarketingContactAllowanceQuery(baseOptions?: Apollo.QueryHookOptions<MarketingContactAllowanceQuery, MarketingContactAllowanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingContactAllowanceQuery, MarketingContactAllowanceQueryVariables>(MarketingContactAllowanceDocument, options);
      }
export function useMarketingContactAllowanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingContactAllowanceQuery, MarketingContactAllowanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingContactAllowanceQuery, MarketingContactAllowanceQueryVariables>(MarketingContactAllowanceDocument, options);
        }
export type MarketingContactAllowanceQueryHookResult = ReturnType<typeof useMarketingContactAllowanceQuery>;
export type MarketingContactAllowanceLazyQueryHookResult = ReturnType<typeof useMarketingContactAllowanceLazyQuery>;
export type MarketingContactAllowanceQueryResult = Apollo.QueryResult<MarketingContactAllowanceQuery, MarketingContactAllowanceQueryVariables>;
export const ContactFormikFieldWithOptionsDocument = gql`
    query ContactFormikFieldWithOptions($term: String!, $companyDomain: ID, $includeInternalContact: Boolean) {
  contacts: contactsQuickSearch(
    term: $term
    companyUid: $companyDomain
    includeEmployees: $includeInternalContact
    limit: 5
  ) {
    entries {
      ...ContactPreview
    }
  }
}
    ${ContactPreviewFragmentDoc}`;

/**
 * __useContactFormikFieldWithOptionsQuery__
 *
 * To run a query within a React component, call `useContactFormikFieldWithOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactFormikFieldWithOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactFormikFieldWithOptionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      companyDomain: // value for 'companyDomain'
 *      includeInternalContact: // value for 'includeInternalContact'
 *   },
 * });
 */
export function useContactFormikFieldWithOptionsQuery(baseOptions: Apollo.QueryHookOptions<ContactFormikFieldWithOptionsQuery, ContactFormikFieldWithOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactFormikFieldWithOptionsQuery, ContactFormikFieldWithOptionsQueryVariables>(ContactFormikFieldWithOptionsDocument, options);
      }
export function useContactFormikFieldWithOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactFormikFieldWithOptionsQuery, ContactFormikFieldWithOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactFormikFieldWithOptionsQuery, ContactFormikFieldWithOptionsQueryVariables>(ContactFormikFieldWithOptionsDocument, options);
        }
export type ContactFormikFieldWithOptionsQueryHookResult = ReturnType<typeof useContactFormikFieldWithOptionsQuery>;
export type ContactFormikFieldWithOptionsLazyQueryHookResult = ReturnType<typeof useContactFormikFieldWithOptionsLazyQuery>;
export type ContactFormikFieldWithOptionsQueryResult = Apollo.QueryResult<ContactFormikFieldWithOptionsQuery, ContactFormikFieldWithOptionsQueryVariables>;
export const BouncedContactsDocument = gql`
    query BouncedContacts($page: Int, $perPage: Int, $term: String, $orderBy: ContactsOrderBy) {
  contacts(
    page: $page
    perPage: $perPage
    filter: {withBouncedEmails: true, term: $term}
    orderBy: $orderBy
  ) {
    entries {
      ...BouncedContactsRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${BouncedContactsRowFragmentDoc}`;

/**
 * __useBouncedContactsQuery__
 *
 * To run a query within a React component, call `useBouncedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBouncedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBouncedContactsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useBouncedContactsQuery(baseOptions?: Apollo.QueryHookOptions<BouncedContactsQuery, BouncedContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BouncedContactsQuery, BouncedContactsQueryVariables>(BouncedContactsDocument, options);
      }
export function useBouncedContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BouncedContactsQuery, BouncedContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BouncedContactsQuery, BouncedContactsQueryVariables>(BouncedContactsDocument, options);
        }
export type BouncedContactsQueryHookResult = ReturnType<typeof useBouncedContactsQuery>;
export type BouncedContactsLazyQueryHookResult = ReturnType<typeof useBouncedContactsLazyQuery>;
export type BouncedContactsQueryResult = Apollo.QueryResult<BouncedContactsQuery, BouncedContactsQueryVariables>;
export const ContactPreferencesDocument = gql`
    query ContactPreferences($contactUid: ID!) {
  contactPreferences(contactUid: $contactUid) {
    schemaCount
    entries {
      ...ContactPreference
    }
  }
}
    ${ContactPreferenceFragmentDoc}`;

/**
 * __useContactPreferencesQuery__
 *
 * To run a query within a React component, call `useContactPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPreferencesQuery({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *   },
 * });
 */
export function useContactPreferencesQuery(baseOptions: Apollo.QueryHookOptions<ContactPreferencesQuery, ContactPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactPreferencesQuery, ContactPreferencesQueryVariables>(ContactPreferencesDocument, options);
      }
export function useContactPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactPreferencesQuery, ContactPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactPreferencesQuery, ContactPreferencesQueryVariables>(ContactPreferencesDocument, options);
        }
export type ContactPreferencesQueryHookResult = ReturnType<typeof useContactPreferencesQuery>;
export type ContactPreferencesLazyQueryHookResult = ReturnType<typeof useContactPreferencesLazyQuery>;
export type ContactPreferencesQueryResult = Apollo.QueryResult<ContactPreferencesQuery, ContactPreferencesQueryVariables>;
export const ContactSlideDocument = gql`
    query ContactSlide($uid: String!, $bouncedUid: ID!) {
  userRoleCorePermissions {
    id
    viewEmployeeEngagementTab
  }
  userRoleOpportunityTrackingPermissions {
    id
    viewEmployeeOpportunitiesTab
  }
  bouncedEmails(uid: $bouncedUid) {
    entries {
      ...BouncedEmail
    }
  }
  contact(uid: $uid) {
    ...ContactProfile
  }
  myContact(uid: $uid) {
    ...MyContactExists
  }
}
    ${BouncedEmailFragmentDoc}
${ContactProfileFragmentDoc}
${MyContactExistsFragmentDoc}`;

/**
 * __useContactSlideQuery__
 *
 * To run a query within a React component, call `useContactSlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactSlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactSlideQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      bouncedUid: // value for 'bouncedUid'
 *   },
 * });
 */
export function useContactSlideQuery(baseOptions: Apollo.QueryHookOptions<ContactSlideQuery, ContactSlideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactSlideQuery, ContactSlideQueryVariables>(ContactSlideDocument, options);
      }
export function useContactSlideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactSlideQuery, ContactSlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactSlideQuery, ContactSlideQueryVariables>(ContactSlideDocument, options);
        }
export type ContactSlideQueryHookResult = ReturnType<typeof useContactSlideQuery>;
export type ContactSlideLazyQueryHookResult = ReturnType<typeof useContactSlideLazyQuery>;
export type ContactSlideQueryResult = Apollo.QueryResult<ContactSlideQuery, ContactSlideQueryVariables>;
export const CreateCareerCompanyDocument = gql`
    mutation CreateCareerCompany($companyUid: ID, $companyName: String, $contactUid: ID!, $jobTitle: String!, $startDate: ISO8601Date, $endDate: ISO8601Date) {
  createCareerCompany(
    companyUid: $companyUid
    companyName: $companyName
    contactUid: $contactUid
    jobTitle: $jobTitle
    startDate: $startDate
    endDate: $endDate
  ) {
    failReasons
    record {
      id
      jobTitle
      jobTitles {
        id
        name
        startDate
        endDate
      }
    }
  }
}
    `;
export type CreateCareerCompanyMutationFn = Apollo.MutationFunction<CreateCareerCompanyMutation, CreateCareerCompanyMutationVariables>;

/**
 * __useCreateCareerCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCareerCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCareerCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCareerCompanyMutation, { data, loading, error }] = useCreateCareerCompanyMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      companyName: // value for 'companyName'
 *      contactUid: // value for 'contactUid'
 *      jobTitle: // value for 'jobTitle'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreateCareerCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCareerCompanyMutation, CreateCareerCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCareerCompanyMutation, CreateCareerCompanyMutationVariables>(CreateCareerCompanyDocument, options);
      }
export type CreateCareerCompanyMutationHookResult = ReturnType<typeof useCreateCareerCompanyMutation>;
export type CreateCareerCompanyMutationResult = Apollo.MutationResult<CreateCareerCompanyMutation>;
export type CreateCareerCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCareerCompanyMutation, CreateCareerCompanyMutationVariables>;
export const DeleteCareerCompanyDocument = gql`
    mutation DeleteCareerCompany($careerCompanyUid: ID!) {
  deleteCareerCompany(careerCompanyUid: $careerCompanyUid) {
    failReasons
  }
}
    `;
export type DeleteCareerCompanyMutationFn = Apollo.MutationFunction<DeleteCareerCompanyMutation, DeleteCareerCompanyMutationVariables>;

/**
 * __useDeleteCareerCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCareerCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCareerCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCareerCompanyMutation, { data, loading, error }] = useDeleteCareerCompanyMutation({
 *   variables: {
 *      careerCompanyUid: // value for 'careerCompanyUid'
 *   },
 * });
 */
export function useDeleteCareerCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCareerCompanyMutation, DeleteCareerCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCareerCompanyMutation, DeleteCareerCompanyMutationVariables>(DeleteCareerCompanyDocument, options);
      }
export type DeleteCareerCompanyMutationHookResult = ReturnType<typeof useDeleteCareerCompanyMutation>;
export type DeleteCareerCompanyMutationResult = Apollo.MutationResult<DeleteCareerCompanyMutation>;
export type DeleteCareerCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCareerCompanyMutation, DeleteCareerCompanyMutationVariables>;
export const UpdateContactDetailsAndLocationDocument = gql`
    mutation UpdateContactDetailsAndLocation($uid: ID!, $officeLocationId: ID, $attributes: ContactAttributes!) {
  updateTenantContact: updateContact(
    uid: $uid
    attributes: $attributes
    officeLocationId: $officeLocationId
  ) {
    failReasons
    record {
      ...ContactForIncompleteContactRow
    }
  }
}
    ${ContactForIncompleteContactRowFragmentDoc}`;
export type UpdateContactDetailsAndLocationMutationFn = Apollo.MutationFunction<UpdateContactDetailsAndLocationMutation, UpdateContactDetailsAndLocationMutationVariables>;

/**
 * __useUpdateContactDetailsAndLocationMutation__
 *
 * To run a mutation, you first call `useUpdateContactDetailsAndLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactDetailsAndLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactDetailsAndLocationMutation, { data, loading, error }] = useUpdateContactDetailsAndLocationMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      officeLocationId: // value for 'officeLocationId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateContactDetailsAndLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactDetailsAndLocationMutation, UpdateContactDetailsAndLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactDetailsAndLocationMutation, UpdateContactDetailsAndLocationMutationVariables>(UpdateContactDetailsAndLocationDocument, options);
      }
export type UpdateContactDetailsAndLocationMutationHookResult = ReturnType<typeof useUpdateContactDetailsAndLocationMutation>;
export type UpdateContactDetailsAndLocationMutationResult = Apollo.MutationResult<UpdateContactDetailsAndLocationMutation>;
export type UpdateContactDetailsAndLocationMutationOptions = Apollo.BaseMutationOptions<UpdateContactDetailsAndLocationMutation, UpdateContactDetailsAndLocationMutationVariables>;
export const CanArchiveContactsAndCompaniesDocument = gql`
    query CanArchiveContactsAndCompanies {
  currentUser {
    id
    canArchiveContactsAndCompanies
  }
}
    `;

/**
 * __useCanArchiveContactsAndCompaniesQuery__
 *
 * To run a query within a React component, call `useCanArchiveContactsAndCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanArchiveContactsAndCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanArchiveContactsAndCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanArchiveContactsAndCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CanArchiveContactsAndCompaniesQuery, CanArchiveContactsAndCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanArchiveContactsAndCompaniesQuery, CanArchiveContactsAndCompaniesQueryVariables>(CanArchiveContactsAndCompaniesDocument, options);
      }
export function useCanArchiveContactsAndCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanArchiveContactsAndCompaniesQuery, CanArchiveContactsAndCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanArchiveContactsAndCompaniesQuery, CanArchiveContactsAndCompaniesQueryVariables>(CanArchiveContactsAndCompaniesDocument, options);
        }
export type CanArchiveContactsAndCompaniesQueryHookResult = ReturnType<typeof useCanArchiveContactsAndCompaniesQuery>;
export type CanArchiveContactsAndCompaniesLazyQueryHookResult = ReturnType<typeof useCanArchiveContactsAndCompaniesLazyQuery>;
export type CanArchiveContactsAndCompaniesQueryResult = Apollo.QueryResult<CanArchiveContactsAndCompaniesQuery, CanArchiveContactsAndCompaniesQueryVariables>;
export const CanUpdateCompanyNameDocument = gql`
    query CanUpdateCompanyName {
  currentUser {
    id
    canUpdateCompanyName
  }
}
    `;

/**
 * __useCanUpdateCompanyNameQuery__
 *
 * To run a query within a React component, call `useCanUpdateCompanyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanUpdateCompanyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanUpdateCompanyNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanUpdateCompanyNameQuery(baseOptions?: Apollo.QueryHookOptions<CanUpdateCompanyNameQuery, CanUpdateCompanyNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanUpdateCompanyNameQuery, CanUpdateCompanyNameQueryVariables>(CanUpdateCompanyNameDocument, options);
      }
export function useCanUpdateCompanyNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanUpdateCompanyNameQuery, CanUpdateCompanyNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanUpdateCompanyNameQuery, CanUpdateCompanyNameQueryVariables>(CanUpdateCompanyNameDocument, options);
        }
export type CanUpdateCompanyNameQueryHookResult = ReturnType<typeof useCanUpdateCompanyNameQuery>;
export type CanUpdateCompanyNameLazyQueryHookResult = ReturnType<typeof useCanUpdateCompanyNameLazyQuery>;
export type CanUpdateCompanyNameQueryResult = Apollo.QueryResult<CanUpdateCompanyNameQuery, CanUpdateCompanyNameQueryVariables>;
export const CanViewActivityDetailsDocument = gql`
    query CanViewActivityDetails {
  currentUser {
    id
    canViewActivityViewDetail
  }
}
    `;

/**
 * __useCanViewActivityDetailsQuery__
 *
 * To run a query within a React component, call `useCanViewActivityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanViewActivityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanViewActivityDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanViewActivityDetailsQuery(baseOptions?: Apollo.QueryHookOptions<CanViewActivityDetailsQuery, CanViewActivityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanViewActivityDetailsQuery, CanViewActivityDetailsQueryVariables>(CanViewActivityDetailsDocument, options);
      }
export function useCanViewActivityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanViewActivityDetailsQuery, CanViewActivityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanViewActivityDetailsQuery, CanViewActivityDetailsQueryVariables>(CanViewActivityDetailsDocument, options);
        }
export type CanViewActivityDetailsQueryHookResult = ReturnType<typeof useCanViewActivityDetailsQuery>;
export type CanViewActivityDetailsLazyQueryHookResult = ReturnType<typeof useCanViewActivityDetailsLazyQuery>;
export type CanViewActivityDetailsQueryResult = Apollo.QueryResult<CanViewActivityDetailsQuery, CanViewActivityDetailsQueryVariables>;
export const UpdateCustomFieldSchemaPositionsDocument = gql`
    mutation UpdateCustomFieldSchemaPositions($customSchemasPositions: [CustomFieldSchemaPosition!]!) {
  updateCustomFieldSchemaPositions(
    customSchemasPositions: $customSchemasPositions
  ) {
    failReasons
  }
}
    `;
export type UpdateCustomFieldSchemaPositionsMutationFn = Apollo.MutationFunction<UpdateCustomFieldSchemaPositionsMutation, UpdateCustomFieldSchemaPositionsMutationVariables>;

/**
 * __useUpdateCustomFieldSchemaPositionsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFieldSchemaPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldSchemaPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFieldSchemaPositionsMutation, { data, loading, error }] = useUpdateCustomFieldSchemaPositionsMutation({
 *   variables: {
 *      customSchemasPositions: // value for 'customSchemasPositions'
 *   },
 * });
 */
export function useUpdateCustomFieldSchemaPositionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomFieldSchemaPositionsMutation, UpdateCustomFieldSchemaPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomFieldSchemaPositionsMutation, UpdateCustomFieldSchemaPositionsMutationVariables>(UpdateCustomFieldSchemaPositionsDocument, options);
      }
export type UpdateCustomFieldSchemaPositionsMutationHookResult = ReturnType<typeof useUpdateCustomFieldSchemaPositionsMutation>;
export type UpdateCustomFieldSchemaPositionsMutationResult = Apollo.MutationResult<UpdateCustomFieldSchemaPositionsMutation>;
export type UpdateCustomFieldSchemaPositionsMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFieldSchemaPositionsMutation, UpdateCustomFieldSchemaPositionsMutationVariables>;
export const DataTemplatesDataRecordsPageDocument = gql`
    query DataTemplatesDataRecordsPage($dataTemplateUid: ID!) {
  dataTemplates(filter: {templateUid: [$dataTemplateUid]}) {
    entries {
      id
      name
      title
      ...DataRecordsGridTemplate
      ...CustomObjectsImporterTemplate
    }
  }
}
    ${DataRecordsGridTemplateFragmentDoc}
${CustomObjectsImporterTemplateFragmentDoc}`;

/**
 * __useDataTemplatesDataRecordsPageQuery__
 *
 * To run a query within a React component, call `useDataTemplatesDataRecordsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTemplatesDataRecordsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTemplatesDataRecordsPageQuery({
 *   variables: {
 *      dataTemplateUid: // value for 'dataTemplateUid'
 *   },
 * });
 */
export function useDataTemplatesDataRecordsPageQuery(baseOptions: Apollo.QueryHookOptions<DataTemplatesDataRecordsPageQuery, DataTemplatesDataRecordsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTemplatesDataRecordsPageQuery, DataTemplatesDataRecordsPageQueryVariables>(DataTemplatesDataRecordsPageDocument, options);
      }
export function useDataTemplatesDataRecordsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTemplatesDataRecordsPageQuery, DataTemplatesDataRecordsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTemplatesDataRecordsPageQuery, DataTemplatesDataRecordsPageQueryVariables>(DataTemplatesDataRecordsPageDocument, options);
        }
export type DataTemplatesDataRecordsPageQueryHookResult = ReturnType<typeof useDataTemplatesDataRecordsPageQuery>;
export type DataTemplatesDataRecordsPageLazyQueryHookResult = ReturnType<typeof useDataTemplatesDataRecordsPageLazyQuery>;
export type DataTemplatesDataRecordsPageQueryResult = Apollo.QueryResult<DataTemplatesDataRecordsPageQuery, DataTemplatesDataRecordsPageQueryVariables>;
export const DashboardEngagementReportDocument = gql`
    query DashboardEngagementReport($beginOn: String!, $endOn: String!) {
  myEngagementReport(beginOn: $beginOn, endOn: $endOn) {
    activityTotals {
      existingContacts
      meetings
      newContacts
      newOpportunities
    }
  }
}
    `;

/**
 * __useDashboardEngagementReportQuery__
 *
 * To run a query within a React component, call `useDashboardEngagementReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardEngagementReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardEngagementReportQuery({
 *   variables: {
 *      beginOn: // value for 'beginOn'
 *      endOn: // value for 'endOn'
 *   },
 * });
 */
export function useDashboardEngagementReportQuery(baseOptions: Apollo.QueryHookOptions<DashboardEngagementReportQuery, DashboardEngagementReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardEngagementReportQuery, DashboardEngagementReportQueryVariables>(DashboardEngagementReportDocument, options);
      }
export function useDashboardEngagementReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardEngagementReportQuery, DashboardEngagementReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardEngagementReportQuery, DashboardEngagementReportQueryVariables>(DashboardEngagementReportDocument, options);
        }
export type DashboardEngagementReportQueryHookResult = ReturnType<typeof useDashboardEngagementReportQuery>;
export type DashboardEngagementReportLazyQueryHookResult = ReturnType<typeof useDashboardEngagementReportLazyQuery>;
export type DashboardEngagementReportQueryResult = Apollo.QueryResult<DashboardEngagementReportQuery, DashboardEngagementReportQueryVariables>;
export const DashboardUserInfoDocument = gql`
    query DashboardUserInfo {
  currentUser {
    id
    employee {
      ...EmployeePreview
      info {
        location {
          id
          city
          country {
            name
          }
        }
      }
      department {
        id
        name
      }
    }
  }
}
    ${EmployeePreviewFragmentDoc}`;

/**
 * __useDashboardUserInfoQuery__
 *
 * To run a query within a React component, call `useDashboardUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<DashboardUserInfoQuery, DashboardUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardUserInfoQuery, DashboardUserInfoQueryVariables>(DashboardUserInfoDocument, options);
      }
export function useDashboardUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardUserInfoQuery, DashboardUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardUserInfoQuery, DashboardUserInfoQueryVariables>(DashboardUserInfoDocument, options);
        }
export type DashboardUserInfoQueryHookResult = ReturnType<typeof useDashboardUserInfoQuery>;
export type DashboardUserInfoLazyQueryHookResult = ReturnType<typeof useDashboardUserInfoLazyQuery>;
export type DashboardUserInfoQueryResult = Apollo.QueryResult<DashboardUserInfoQuery, DashboardUserInfoQueryVariables>;
export const MyOpenTasksDocument = gql`
    query MyOpenTasks($primaryFilter: TaskPrimaryFilterInput) {
  tasks(
    primaryFilter: $primaryFilter
    filter: {status: PENDING}
    page: 1
    perPage: 3
  ) {
    entries {
      ...TaskPreview
    }
  }
}
    ${TaskPreviewFragmentDoc}`;

/**
 * __useMyOpenTasksQuery__
 *
 * To run a query within a React component, call `useMyOpenTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOpenTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOpenTasksQuery({
 *   variables: {
 *      primaryFilter: // value for 'primaryFilter'
 *   },
 * });
 */
export function useMyOpenTasksQuery(baseOptions?: Apollo.QueryHookOptions<MyOpenTasksQuery, MyOpenTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyOpenTasksQuery, MyOpenTasksQueryVariables>(MyOpenTasksDocument, options);
      }
export function useMyOpenTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOpenTasksQuery, MyOpenTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyOpenTasksQuery, MyOpenTasksQueryVariables>(MyOpenTasksDocument, options);
        }
export type MyOpenTasksQueryHookResult = ReturnType<typeof useMyOpenTasksQuery>;
export type MyOpenTasksLazyQueryHookResult = ReturnType<typeof useMyOpenTasksLazyQuery>;
export type MyOpenTasksQueryResult = Apollo.QueryResult<MyOpenTasksQuery, MyOpenTasksQueryVariables>;
export const QuickSearchCompaniesDocument = gql`
    query QuickSearchCompanies($term: String!) {
  companies(page: 1, perPage: 5, filter: {term: $term}) {
    entries {
      ...SearchResultCompany
    }
  }
}
    ${SearchResultCompanyFragmentDoc}`;

/**
 * __useQuickSearchCompaniesQuery__
 *
 * To run a query within a React component, call `useQuickSearchCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickSearchCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickSearchCompaniesQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useQuickSearchCompaniesQuery(baseOptions: Apollo.QueryHookOptions<QuickSearchCompaniesQuery, QuickSearchCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickSearchCompaniesQuery, QuickSearchCompaniesQueryVariables>(QuickSearchCompaniesDocument, options);
      }
export function useQuickSearchCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickSearchCompaniesQuery, QuickSearchCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickSearchCompaniesQuery, QuickSearchCompaniesQueryVariables>(QuickSearchCompaniesDocument, options);
        }
export type QuickSearchCompaniesQueryHookResult = ReturnType<typeof useQuickSearchCompaniesQuery>;
export type QuickSearchCompaniesLazyQueryHookResult = ReturnType<typeof useQuickSearchCompaniesLazyQuery>;
export type QuickSearchCompaniesQueryResult = Apollo.QueryResult<QuickSearchCompaniesQuery, QuickSearchCompaniesQueryVariables>;
export const QuickSearchContactsDocument = gql`
    query QuickSearchContacts($term: String!) {
  contacts: contactsQuickSearch(limit: 5, term: $term) {
    entries {
      ...SearchResultContact
    }
  }
}
    ${SearchResultContactFragmentDoc}`;

/**
 * __useQuickSearchContactsQuery__
 *
 * To run a query within a React component, call `useQuickSearchContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickSearchContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickSearchContactsQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useQuickSearchContactsQuery(baseOptions: Apollo.QueryHookOptions<QuickSearchContactsQuery, QuickSearchContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickSearchContactsQuery, QuickSearchContactsQueryVariables>(QuickSearchContactsDocument, options);
      }
export function useQuickSearchContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickSearchContactsQuery, QuickSearchContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickSearchContactsQuery, QuickSearchContactsQueryVariables>(QuickSearchContactsDocument, options);
        }
export type QuickSearchContactsQueryHookResult = ReturnType<typeof useQuickSearchContactsQuery>;
export type QuickSearchContactsLazyQueryHookResult = ReturnType<typeof useQuickSearchContactsLazyQuery>;
export type QuickSearchContactsQueryResult = Apollo.QueryResult<QuickSearchContactsQuery, QuickSearchContactsQueryVariables>;
export const QuickSearchEmployeesDocument = gql`
    query QuickSearchEmployees($term: String!) {
  employees(term: $term, page: 1, perPage: 5) {
    entries {
      ...QuickSearchEmployee
    }
  }
}
    ${QuickSearchEmployeeFragmentDoc}`;

/**
 * __useQuickSearchEmployeesQuery__
 *
 * To run a query within a React component, call `useQuickSearchEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickSearchEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickSearchEmployeesQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useQuickSearchEmployeesQuery(baseOptions: Apollo.QueryHookOptions<QuickSearchEmployeesQuery, QuickSearchEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickSearchEmployeesQuery, QuickSearchEmployeesQueryVariables>(QuickSearchEmployeesDocument, options);
      }
export function useQuickSearchEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickSearchEmployeesQuery, QuickSearchEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickSearchEmployeesQuery, QuickSearchEmployeesQueryVariables>(QuickSearchEmployeesDocument, options);
        }
export type QuickSearchEmployeesQueryHookResult = ReturnType<typeof useQuickSearchEmployeesQuery>;
export type QuickSearchEmployeesLazyQueryHookResult = ReturnType<typeof useQuickSearchEmployeesLazyQuery>;
export type QuickSearchEmployeesQueryResult = Apollo.QueryResult<QuickSearchEmployeesQuery, QuickSearchEmployeesQueryVariables>;
export const QuickSearchGroupLabelAccessDocument = gql`
    query QuickSearchGroupLabelAccess {
  userRoleCorePermissions {
    id
    allCompanies
    allContacts
  }
  tenantConfiguration {
    id
    showAllEmployeesTab
  }
}
    `;

/**
 * __useQuickSearchGroupLabelAccessQuery__
 *
 * To run a query within a React component, call `useQuickSearchGroupLabelAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickSearchGroupLabelAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickSearchGroupLabelAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuickSearchGroupLabelAccessQuery(baseOptions?: Apollo.QueryHookOptions<QuickSearchGroupLabelAccessQuery, QuickSearchGroupLabelAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickSearchGroupLabelAccessQuery, QuickSearchGroupLabelAccessQueryVariables>(QuickSearchGroupLabelAccessDocument, options);
      }
export function useQuickSearchGroupLabelAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickSearchGroupLabelAccessQuery, QuickSearchGroupLabelAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickSearchGroupLabelAccessQuery, QuickSearchGroupLabelAccessQueryVariables>(QuickSearchGroupLabelAccessDocument, options);
        }
export type QuickSearchGroupLabelAccessQueryHookResult = ReturnType<typeof useQuickSearchGroupLabelAccessQuery>;
export type QuickSearchGroupLabelAccessLazyQueryHookResult = ReturnType<typeof useQuickSearchGroupLabelAccessLazyQuery>;
export type QuickSearchGroupLabelAccessQueryResult = Apollo.QueryResult<QuickSearchGroupLabelAccessQuery, QuickSearchGroupLabelAccessQueryVariables>;
export const ConnectListWithFieldMappingsDocument = gql`
    mutation ConnectListWithFieldMappings($fieldMappings: [ConnectedListMappingInput!], $nameOnEms: String, $listUuid: String!, $audienceId: String!, $campaignManagerId: String) {
  connectList(
    fieldMappings: $fieldMappings
    nameOnEms: $nameOnEms
    listUuid: $listUuid
    audienceId: $audienceId
    campaignManagerId: $campaignManagerId
  ) {
    failReasons
  }
}
    `;
export type ConnectListWithFieldMappingsMutationFn = Apollo.MutationFunction<ConnectListWithFieldMappingsMutation, ConnectListWithFieldMappingsMutationVariables>;

/**
 * __useConnectListWithFieldMappingsMutation__
 *
 * To run a mutation, you first call `useConnectListWithFieldMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectListWithFieldMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectListWithFieldMappingsMutation, { data, loading, error }] = useConnectListWithFieldMappingsMutation({
 *   variables: {
 *      fieldMappings: // value for 'fieldMappings'
 *      nameOnEms: // value for 'nameOnEms'
 *      listUuid: // value for 'listUuid'
 *      audienceId: // value for 'audienceId'
 *      campaignManagerId: // value for 'campaignManagerId'
 *   },
 * });
 */
export function useConnectListWithFieldMappingsMutation(baseOptions?: Apollo.MutationHookOptions<ConnectListWithFieldMappingsMutation, ConnectListWithFieldMappingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectListWithFieldMappingsMutation, ConnectListWithFieldMappingsMutationVariables>(ConnectListWithFieldMappingsDocument, options);
      }
export type ConnectListWithFieldMappingsMutationHookResult = ReturnType<typeof useConnectListWithFieldMappingsMutation>;
export type ConnectListWithFieldMappingsMutationResult = Apollo.MutationResult<ConnectListWithFieldMappingsMutation>;
export type ConnectListWithFieldMappingsMutationOptions = Apollo.BaseMutationOptions<ConnectListWithFieldMappingsMutation, ConnectListWithFieldMappingsMutationVariables>;
export const ConnectListWithFieldMappingsModalDocument = gql`
    query ConnectListWithFieldMappingsModal($uid: ID!) {
  list(uid: $uid) {
    id
    allowDuplicates
    name
  }
  eMarketingConnectors(limit: 100) {
    entries {
      ...EMarketingConnector
    }
  }
}
    ${EMarketingConnectorFragmentDoc}`;

/**
 * __useConnectListWithFieldMappingsModalQuery__
 *
 * To run a query within a React component, call `useConnectListWithFieldMappingsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectListWithFieldMappingsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectListWithFieldMappingsModalQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useConnectListWithFieldMappingsModalQuery(baseOptions: Apollo.QueryHookOptions<ConnectListWithFieldMappingsModalQuery, ConnectListWithFieldMappingsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectListWithFieldMappingsModalQuery, ConnectListWithFieldMappingsModalQueryVariables>(ConnectListWithFieldMappingsModalDocument, options);
      }
export function useConnectListWithFieldMappingsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectListWithFieldMappingsModalQuery, ConnectListWithFieldMappingsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectListWithFieldMappingsModalQuery, ConnectListWithFieldMappingsModalQueryVariables>(ConnectListWithFieldMappingsModalDocument, options);
        }
export type ConnectListWithFieldMappingsModalQueryHookResult = ReturnType<typeof useConnectListWithFieldMappingsModalQuery>;
export type ConnectListWithFieldMappingsModalLazyQueryHookResult = ReturnType<typeof useConnectListWithFieldMappingsModalLazyQuery>;
export type ConnectListWithFieldMappingsModalQueryResult = Apollo.QueryResult<ConnectListWithFieldMappingsModalQuery, ConnectListWithFieldMappingsModalQueryVariables>;
export const EMarketingConnectedListDocument = gql`
    query EMarketingConnectedList($listUid: ID!) {
  connectedLists(listUid: $listUid, limit: 1) {
    ...EMarketingConnectedList
  }
}
    ${EMarketingConnectedListFragmentDoc}`;

/**
 * __useEMarketingConnectedListQuery__
 *
 * To run a query within a React component, call `useEMarketingConnectedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEMarketingConnectedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEMarketingConnectedListQuery({
 *   variables: {
 *      listUid: // value for 'listUid'
 *   },
 * });
 */
export function useEMarketingConnectedListQuery(baseOptions: Apollo.QueryHookOptions<EMarketingConnectedListQuery, EMarketingConnectedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EMarketingConnectedListQuery, EMarketingConnectedListQueryVariables>(EMarketingConnectedListDocument, options);
      }
export function useEMarketingConnectedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EMarketingConnectedListQuery, EMarketingConnectedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EMarketingConnectedListQuery, EMarketingConnectedListQueryVariables>(EMarketingConnectedListDocument, options);
        }
export type EMarketingConnectedListQueryHookResult = ReturnType<typeof useEMarketingConnectedListQuery>;
export type EMarketingConnectedListLazyQueryHookResult = ReturnType<typeof useEMarketingConnectedListLazyQuery>;
export type EMarketingConnectedListQueryResult = Apollo.QueryResult<EMarketingConnectedListQuery, EMarketingConnectedListQueryVariables>;
export const EMarketingCustomFieldSchemasDocument = gql`
    query EMarketingCustomFieldSchemas($campaignManagerUid: ID!, $uid: ID!) {
  remoteCustomFieldSchema(campaignManagerUid: $campaignManagerUid) {
    entries {
      ...RemoteCustomFieldSchema
    }
  }
  contactCustomFieldSchemas: customFieldSchemas(ownerType: CONTACT) {
    entries {
      ...EMarketingCustomFieldSchema
    }
  }
  listCustomFieldSchemas: list(uid: $uid) {
    id
    memberCustomFields {
      ...EMarketingCustomFieldSchema
    }
  }
}
    ${RemoteCustomFieldSchemaFragmentDoc}
${EMarketingCustomFieldSchemaFragmentDoc}`;

/**
 * __useEMarketingCustomFieldSchemasQuery__
 *
 * To run a query within a React component, call `useEMarketingCustomFieldSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useEMarketingCustomFieldSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEMarketingCustomFieldSchemasQuery({
 *   variables: {
 *      campaignManagerUid: // value for 'campaignManagerUid'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useEMarketingCustomFieldSchemasQuery(baseOptions: Apollo.QueryHookOptions<EMarketingCustomFieldSchemasQuery, EMarketingCustomFieldSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EMarketingCustomFieldSchemasQuery, EMarketingCustomFieldSchemasQueryVariables>(EMarketingCustomFieldSchemasDocument, options);
      }
export function useEMarketingCustomFieldSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EMarketingCustomFieldSchemasQuery, EMarketingCustomFieldSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EMarketingCustomFieldSchemasQuery, EMarketingCustomFieldSchemasQueryVariables>(EMarketingCustomFieldSchemasDocument, options);
        }
export type EMarketingCustomFieldSchemasQueryHookResult = ReturnType<typeof useEMarketingCustomFieldSchemasQuery>;
export type EMarketingCustomFieldSchemasLazyQueryHookResult = ReturnType<typeof useEMarketingCustomFieldSchemasLazyQuery>;
export type EMarketingCustomFieldSchemasQueryResult = Apollo.QueryResult<EMarketingCustomFieldSchemasQuery, EMarketingCustomFieldSchemasQueryVariables>;
export const SyncEMarketingListMembersDocument = gql`
    mutation SyncEMarketingListMembers($connectedListId: String!, $fieldMappings: [ConnectedListMappingInput!]!) {
  syncConnectedListMembers(
    connectedListId: $connectedListId
    newMappings: $fieldMappings
  ) {
    failReasons
  }
}
    `;
export type SyncEMarketingListMembersMutationFn = Apollo.MutationFunction<SyncEMarketingListMembersMutation, SyncEMarketingListMembersMutationVariables>;

/**
 * __useSyncEMarketingListMembersMutation__
 *
 * To run a mutation, you first call `useSyncEMarketingListMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEMarketingListMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEMarketingListMembersMutation, { data, loading, error }] = useSyncEMarketingListMembersMutation({
 *   variables: {
 *      connectedListId: // value for 'connectedListId'
 *      fieldMappings: // value for 'fieldMappings'
 *   },
 * });
 */
export function useSyncEMarketingListMembersMutation(baseOptions?: Apollo.MutationHookOptions<SyncEMarketingListMembersMutation, SyncEMarketingListMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEMarketingListMembersMutation, SyncEMarketingListMembersMutationVariables>(SyncEMarketingListMembersDocument, options);
      }
export type SyncEMarketingListMembersMutationHookResult = ReturnType<typeof useSyncEMarketingListMembersMutation>;
export type SyncEMarketingListMembersMutationResult = Apollo.MutationResult<SyncEMarketingListMembersMutation>;
export type SyncEMarketingListMembersMutationOptions = Apollo.BaseMutationOptions<SyncEMarketingListMembersMutation, SyncEMarketingListMembersMutationVariables>;
export const SyncEMarketingListMembersModalDocument = gql`
    query SyncEMarketingListMembersModal($listUid: ID!, $campaignManagerUid: ID!) {
  connectedLists(listUid: $listUid) {
    id
    mappings {
      ...EMarketingConnectedListMapping
    }
  }
  remoteCustomFieldSchema(campaignManagerUid: $campaignManagerUid) {
    entries {
      ...RemoteCustomFieldSchema
    }
  }
  contactCustomFieldSchemas: customFieldSchemas(ownerType: CONTACT) {
    entries {
      ...EMarketingCustomFieldSchema
    }
  }
  listCustomFieldSchemas: list(uid: $listUid) {
    id
    memberCustomFields {
      ...EMarketingCustomFieldSchema
    }
  }
}
    ${EMarketingConnectedListMappingFragmentDoc}
${RemoteCustomFieldSchemaFragmentDoc}
${EMarketingCustomFieldSchemaFragmentDoc}`;

/**
 * __useSyncEMarketingListMembersModalQuery__
 *
 * To run a query within a React component, call `useSyncEMarketingListMembersModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEMarketingListMembersModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEMarketingListMembersModalQuery({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      campaignManagerUid: // value for 'campaignManagerUid'
 *   },
 * });
 */
export function useSyncEMarketingListMembersModalQuery(baseOptions: Apollo.QueryHookOptions<SyncEMarketingListMembersModalQuery, SyncEMarketingListMembersModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEMarketingListMembersModalQuery, SyncEMarketingListMembersModalQueryVariables>(SyncEMarketingListMembersModalDocument, options);
      }
export function useSyncEMarketingListMembersModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEMarketingListMembersModalQuery, SyncEMarketingListMembersModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEMarketingListMembersModalQuery, SyncEMarketingListMembersModalQueryVariables>(SyncEMarketingListMembersModalDocument, options);
        }
export type SyncEMarketingListMembersModalQueryHookResult = ReturnType<typeof useSyncEMarketingListMembersModalQuery>;
export type SyncEMarketingListMembersModalLazyQueryHookResult = ReturnType<typeof useSyncEMarketingListMembersModalLazyQuery>;
export type SyncEMarketingListMembersModalQueryResult = Apollo.QueryResult<SyncEMarketingListMembersModalQuery, SyncEMarketingListMembersModalQueryVariables>;
export const AllEmployeesDocument = gql`
    query AllEmployees {
  employees(page: 1, perPage: 1000) {
    entries {
      ...EmployeePreview
    }
  }
}
    ${EmployeePreviewFragmentDoc}`;

/**
 * __useAllEmployeesQuery__
 *
 * To run a query within a React component, call `useAllEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<AllEmployeesQuery, AllEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEmployeesQuery, AllEmployeesQueryVariables>(AllEmployeesDocument, options);
      }
export function useAllEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEmployeesQuery, AllEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEmployeesQuery, AllEmployeesQueryVariables>(AllEmployeesDocument, options);
        }
export type AllEmployeesQueryHookResult = ReturnType<typeof useAllEmployeesQuery>;
export type AllEmployeesLazyQueryHookResult = ReturnType<typeof useAllEmployeesLazyQuery>;
export type AllEmployeesQueryResult = Apollo.QueryResult<AllEmployeesQuery, AllEmployeesQueryVariables>;
export const EmployeesDocument = gql`
    query Employees($term: String = null, $page: Int = 1, $perPage: Int = 10, $emails: [String!] = null) {
  employees(term: $term, page: $page, perPage: $perPage, emails: $emails) {
    entries {
      ...EmployeePreview
    }
  }
}
    ${EmployeePreviewFragmentDoc}`;

/**
 * __useEmployeesQuery__
 *
 * To run a query within a React component, call `useEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesQuery({
 *   variables: {
 *      term: // value for 'term'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
      }
export function useEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
export type EmployeesQueryHookResult = ReturnType<typeof useEmployeesQuery>;
export type EmployeesLazyQueryHookResult = ReturnType<typeof useEmployeesLazyQuery>;
export type EmployeesQueryResult = Apollo.QueryResult<EmployeesQuery, EmployeesQueryVariables>;
export const EmployeesFieldWithOptionsDocument = gql`
    query EmployeesFieldWithOptions($term: String = null, $page: Int = 1, $perPage: Int = 10, $emails: [String!] = null) {
  employees(term: $term, page: $page, perPage: $perPage, emails: $emails) {
    entries {
      ...EmployeeFieldWithOptions
    }
  }
}
    ${EmployeeFieldWithOptionsFragmentDoc}`;

/**
 * __useEmployeesFieldWithOptionsQuery__
 *
 * To run a query within a React component, call `useEmployeesFieldWithOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesFieldWithOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesFieldWithOptionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useEmployeesFieldWithOptionsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeesFieldWithOptionsQuery, EmployeesFieldWithOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesFieldWithOptionsQuery, EmployeesFieldWithOptionsQueryVariables>(EmployeesFieldWithOptionsDocument, options);
      }
export function useEmployeesFieldWithOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesFieldWithOptionsQuery, EmployeesFieldWithOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesFieldWithOptionsQuery, EmployeesFieldWithOptionsQueryVariables>(EmployeesFieldWithOptionsDocument, options);
        }
export type EmployeesFieldWithOptionsQueryHookResult = ReturnType<typeof useEmployeesFieldWithOptionsQuery>;
export type EmployeesFieldWithOptionsLazyQueryHookResult = ReturnType<typeof useEmployeesFieldWithOptionsLazyQuery>;
export type EmployeesFieldWithOptionsQueryResult = Apollo.QueryResult<EmployeesFieldWithOptionsQuery, EmployeesFieldWithOptionsQueryVariables>;
export const RelationshipPartnerCompanyListDocument = gql`
    query RelationshipPartnerCompanyList($employeeEmail: String!) {
  companies(
    filter: {ownerUid: $employeeEmail}
    page: 1
    perPage: 100
    orderBy: COMPANY_NAME_ASC
  ) {
    entries {
      ...RelationshipPartnerCompany
    }
  }
}
    ${RelationshipPartnerCompanyFragmentDoc}`;

/**
 * __useRelationshipPartnerCompanyListQuery__
 *
 * To run a query within a React component, call `useRelationshipPartnerCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipPartnerCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipPartnerCompanyListQuery({
 *   variables: {
 *      employeeEmail: // value for 'employeeEmail'
 *   },
 * });
 */
export function useRelationshipPartnerCompanyListQuery(baseOptions: Apollo.QueryHookOptions<RelationshipPartnerCompanyListQuery, RelationshipPartnerCompanyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelationshipPartnerCompanyListQuery, RelationshipPartnerCompanyListQueryVariables>(RelationshipPartnerCompanyListDocument, options);
      }
export function useRelationshipPartnerCompanyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelationshipPartnerCompanyListQuery, RelationshipPartnerCompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelationshipPartnerCompanyListQuery, RelationshipPartnerCompanyListQueryVariables>(RelationshipPartnerCompanyListDocument, options);
        }
export type RelationshipPartnerCompanyListQueryHookResult = ReturnType<typeof useRelationshipPartnerCompanyListQuery>;
export type RelationshipPartnerCompanyListLazyQueryHookResult = ReturnType<typeof useRelationshipPartnerCompanyListLazyQuery>;
export type RelationshipPartnerCompanyListQueryResult = Apollo.QueryResult<RelationshipPartnerCompanyListQuery, RelationshipPartnerCompanyListQueryVariables>;
export const TopClientCompanyListDocument = gql`
    query TopClientCompanyList($employeeUid: String!) {
  topClientCompanyList(employeeUid: $employeeUid, page: 1, perPage: 10) {
    entries {
      ...TopClientCompany
    }
  }
  tenantConfiguration {
    id
    preferInternalIndustry
  }
}
    ${TopClientCompanyFragmentDoc}`;

/**
 * __useTopClientCompanyListQuery__
 *
 * To run a query within a React component, call `useTopClientCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopClientCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopClientCompanyListQuery({
 *   variables: {
 *      employeeUid: // value for 'employeeUid'
 *   },
 * });
 */
export function useTopClientCompanyListQuery(baseOptions: Apollo.QueryHookOptions<TopClientCompanyListQuery, TopClientCompanyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopClientCompanyListQuery, TopClientCompanyListQueryVariables>(TopClientCompanyListDocument, options);
      }
export function useTopClientCompanyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopClientCompanyListQuery, TopClientCompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopClientCompanyListQuery, TopClientCompanyListQueryVariables>(TopClientCompanyListDocument, options);
        }
export type TopClientCompanyListQueryHookResult = ReturnType<typeof useTopClientCompanyListQuery>;
export type TopClientCompanyListLazyQueryHookResult = ReturnType<typeof useTopClientCompanyListLazyQuery>;
export type TopClientCompanyListQueryResult = Apollo.QueryResult<TopClientCompanyListQuery, TopClientCompanyListQueryVariables>;
export const TopContactListDocument = gql`
    query TopContactList($employeeUid: String!) {
  topContactList(employeeUid: $employeeUid, page: 1, perPage: 10) {
    entries {
      ...TopContact
    }
  }
}
    ${TopContactFragmentDoc}`;

/**
 * __useTopContactListQuery__
 *
 * To run a query within a React component, call `useTopContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopContactListQuery({
 *   variables: {
 *      employeeUid: // value for 'employeeUid'
 *   },
 * });
 */
export function useTopContactListQuery(baseOptions: Apollo.QueryHookOptions<TopContactListQuery, TopContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopContactListQuery, TopContactListQueryVariables>(TopContactListDocument, options);
      }
export function useTopContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopContactListQuery, TopContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopContactListQuery, TopContactListQueryVariables>(TopContactListDocument, options);
        }
export type TopContactListQueryHookResult = ReturnType<typeof useTopContactListQuery>;
export type TopContactListLazyQueryHookResult = ReturnType<typeof useTopContactListLazyQuery>;
export type TopContactListQueryResult = Apollo.QueryResult<TopContactListQuery, TopContactListQueryVariables>;
export const FeaturesContextDocument = gql`
    query FeaturesContext {
  enabledModules {
    marketingLists
    projects
    objectives
    opportunities
    prospecting
    referrals
    apps
  }
  features {
    key
    enabled
    id
  }
}
    `;

/**
 * __useFeaturesContextQuery__
 *
 * To run a query within a React component, call `useFeaturesContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturesContextQuery(baseOptions?: Apollo.QueryHookOptions<FeaturesContextQuery, FeaturesContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturesContextQuery, FeaturesContextQueryVariables>(FeaturesContextDocument, options);
      }
export function useFeaturesContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturesContextQuery, FeaturesContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturesContextQuery, FeaturesContextQueryVariables>(FeaturesContextDocument, options);
        }
export type FeaturesContextQueryHookResult = ReturnType<typeof useFeaturesContextQuery>;
export type FeaturesContextLazyQueryHookResult = ReturnType<typeof useFeaturesContextLazyQuery>;
export type FeaturesContextQueryResult = Apollo.QueryResult<FeaturesContextQuery, FeaturesContextQueryVariables>;
export const CreateGenericListItemDocument = gql`
    mutation CreateGenericListItem($genericListUid: ID!, $customFieldAttributes: [CustomFieldAttribute!]) {
  createGenericListItem(
    genericListUid: $genericListUid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
    record {
      ...GenericListItemRow
    }
  }
}
    ${GenericListItemRowFragmentDoc}`;
export type CreateGenericListItemMutationFn = Apollo.MutationFunction<CreateGenericListItemMutation, CreateGenericListItemMutationVariables>;

/**
 * __useCreateGenericListItemMutation__
 *
 * To run a mutation, you first call `useCreateGenericListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericListItemMutation, { data, loading, error }] = useCreateGenericListItemMutation({
 *   variables: {
 *      genericListUid: // value for 'genericListUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useCreateGenericListItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericListItemMutation, CreateGenericListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericListItemMutation, CreateGenericListItemMutationVariables>(CreateGenericListItemDocument, options);
      }
export type CreateGenericListItemMutationHookResult = ReturnType<typeof useCreateGenericListItemMutation>;
export type CreateGenericListItemMutationResult = Apollo.MutationResult<CreateGenericListItemMutation>;
export type CreateGenericListItemMutationOptions = Apollo.BaseMutationOptions<CreateGenericListItemMutation, CreateGenericListItemMutationVariables>;
export const CreateGenericListReminderSetttingDocument = gql`
    mutation CreateGenericListReminderSettting($genericListUid: ID!, $timePreposition: ReminderSettingTimePreposition!, $emailSubject: String!, $reminderDays: Int!, $employeeEmails: [String!]!, $dateProperty: String!) {
  result: createGenericListReminderSetting(
    genericListUid: $genericListUid
    timePreposition: $timePreposition
    emailSubject: $emailSubject
    reminderDays: $reminderDays
    employeeEmails: $employeeEmails
    dateProperty: $dateProperty
  ) {
    failReasons
  }
}
    `;
export type CreateGenericListReminderSetttingMutationFn = Apollo.MutationFunction<CreateGenericListReminderSetttingMutation, CreateGenericListReminderSetttingMutationVariables>;

/**
 * __useCreateGenericListReminderSetttingMutation__
 *
 * To run a mutation, you first call `useCreateGenericListReminderSetttingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericListReminderSetttingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericListReminderSetttingMutation, { data, loading, error }] = useCreateGenericListReminderSetttingMutation({
 *   variables: {
 *      genericListUid: // value for 'genericListUid'
 *      timePreposition: // value for 'timePreposition'
 *      emailSubject: // value for 'emailSubject'
 *      reminderDays: // value for 'reminderDays'
 *      employeeEmails: // value for 'employeeEmails'
 *      dateProperty: // value for 'dateProperty'
 *   },
 * });
 */
export function useCreateGenericListReminderSetttingMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericListReminderSetttingMutation, CreateGenericListReminderSetttingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericListReminderSetttingMutation, CreateGenericListReminderSetttingMutationVariables>(CreateGenericListReminderSetttingDocument, options);
      }
export type CreateGenericListReminderSetttingMutationHookResult = ReturnType<typeof useCreateGenericListReminderSetttingMutation>;
export type CreateGenericListReminderSetttingMutationResult = Apollo.MutationResult<CreateGenericListReminderSetttingMutation>;
export type CreateGenericListReminderSetttingMutationOptions = Apollo.BaseMutationOptions<CreateGenericListReminderSetttingMutation, CreateGenericListReminderSetttingMutationVariables>;
export const DatePropertiesForGenericListReminderDocument = gql`
    query DatePropertiesForGenericListReminder($genericListUid: ID!) {
  datePropertiesForGenericListReminder(genericListUid: $genericListUid) {
    ...DatePropertyOption
  }
}
    ${DatePropertyOptionFragmentDoc}`;

/**
 * __useDatePropertiesForGenericListReminderQuery__
 *
 * To run a query within a React component, call `useDatePropertiesForGenericListReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatePropertiesForGenericListReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatePropertiesForGenericListReminderQuery({
 *   variables: {
 *      genericListUid: // value for 'genericListUid'
 *   },
 * });
 */
export function useDatePropertiesForGenericListReminderQuery(baseOptions: Apollo.QueryHookOptions<DatePropertiesForGenericListReminderQuery, DatePropertiesForGenericListReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatePropertiesForGenericListReminderQuery, DatePropertiesForGenericListReminderQueryVariables>(DatePropertiesForGenericListReminderDocument, options);
      }
export function useDatePropertiesForGenericListReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatePropertiesForGenericListReminderQuery, DatePropertiesForGenericListReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatePropertiesForGenericListReminderQuery, DatePropertiesForGenericListReminderQueryVariables>(DatePropertiesForGenericListReminderDocument, options);
        }
export type DatePropertiesForGenericListReminderQueryHookResult = ReturnType<typeof useDatePropertiesForGenericListReminderQuery>;
export type DatePropertiesForGenericListReminderLazyQueryHookResult = ReturnType<typeof useDatePropertiesForGenericListReminderLazyQuery>;
export type DatePropertiesForGenericListReminderQueryResult = Apollo.QueryResult<DatePropertiesForGenericListReminderQuery, DatePropertiesForGenericListReminderQueryVariables>;
export const GenericListDocument = gql`
    query GenericList($uid: ID!) {
  genericList(uid: $uid) {
    id
    items {
      ...GenericListItemRow
    }
  }
}
    ${GenericListItemRowFragmentDoc}`;

/**
 * __useGenericListQuery__
 *
 * To run a query within a React component, call `useGenericListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericListQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGenericListQuery(baseOptions: Apollo.QueryHookOptions<GenericListQuery, GenericListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericListQuery, GenericListQueryVariables>(GenericListDocument, options);
      }
export function useGenericListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericListQuery, GenericListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericListQuery, GenericListQueryVariables>(GenericListDocument, options);
        }
export type GenericListQueryHookResult = ReturnType<typeof useGenericListQuery>;
export type GenericListLazyQueryHookResult = ReturnType<typeof useGenericListLazyQuery>;
export type GenericListQueryResult = Apollo.QueryResult<GenericListQuery, GenericListQueryVariables>;
export const GenericListCustomFieldSchemasDocument = gql`
    query GenericListCustomFieldSchemas($uid: ID!) {
  genericList(uid: $uid) {
    id
    customFieldSchemas {
      ...CustomFieldSchema
    }
  }
}
    ${CustomFieldSchemaFragmentDoc}`;

/**
 * __useGenericListCustomFieldSchemasQuery__
 *
 * To run a query within a React component, call `useGenericListCustomFieldSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericListCustomFieldSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericListCustomFieldSchemasQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGenericListCustomFieldSchemasQuery(baseOptions: Apollo.QueryHookOptions<GenericListCustomFieldSchemasQuery, GenericListCustomFieldSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericListCustomFieldSchemasQuery, GenericListCustomFieldSchemasQueryVariables>(GenericListCustomFieldSchemasDocument, options);
      }
export function useGenericListCustomFieldSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericListCustomFieldSchemasQuery, GenericListCustomFieldSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericListCustomFieldSchemasQuery, GenericListCustomFieldSchemasQueryVariables>(GenericListCustomFieldSchemasDocument, options);
        }
export type GenericListCustomFieldSchemasQueryHookResult = ReturnType<typeof useGenericListCustomFieldSchemasQuery>;
export type GenericListCustomFieldSchemasLazyQueryHookResult = ReturnType<typeof useGenericListCustomFieldSchemasLazyQuery>;
export type GenericListCustomFieldSchemasQueryResult = Apollo.QueryResult<GenericListCustomFieldSchemasQuery, GenericListCustomFieldSchemasQueryVariables>;
export const GenericListItemDocument = gql`
    query GenericListItem($itemUid: ID!) {
  genericListItem(itemUid: $itemUid) {
    ...GenericListItem
  }
  tasks(primaryFilter: {sourceType: GENERIC_LIST_MEMBER, sourceUid: $itemUid}) {
    entries {
      ...TaskPreview
    }
  }
}
    ${GenericListItemFragmentDoc}
${TaskPreviewFragmentDoc}`;

/**
 * __useGenericListItemQuery__
 *
 * To run a query within a React component, call `useGenericListItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericListItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericListItemQuery({
 *   variables: {
 *      itemUid: // value for 'itemUid'
 *   },
 * });
 */
export function useGenericListItemQuery(baseOptions: Apollo.QueryHookOptions<GenericListItemQuery, GenericListItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericListItemQuery, GenericListItemQueryVariables>(GenericListItemDocument, options);
      }
export function useGenericListItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericListItemQuery, GenericListItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericListItemQuery, GenericListItemQueryVariables>(GenericListItemDocument, options);
        }
export type GenericListItemQueryHookResult = ReturnType<typeof useGenericListItemQuery>;
export type GenericListItemLazyQueryHookResult = ReturnType<typeof useGenericListItemLazyQuery>;
export type GenericListItemQueryResult = Apollo.QueryResult<GenericListItemQuery, GenericListItemQueryVariables>;
export const GenericListItemCustomFieldsDocument = gql`
    query GenericListItemCustomFields($itemUid: ID!) {
  genericListItem(itemUid: $itemUid) {
    id
    customFields {
      ...CustomField
    }
  }
}
    ${CustomFieldFragmentDoc}`;

/**
 * __useGenericListItemCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGenericListItemCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericListItemCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericListItemCustomFieldsQuery({
 *   variables: {
 *      itemUid: // value for 'itemUid'
 *   },
 * });
 */
export function useGenericListItemCustomFieldsQuery(baseOptions: Apollo.QueryHookOptions<GenericListItemCustomFieldsQuery, GenericListItemCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericListItemCustomFieldsQuery, GenericListItemCustomFieldsQueryVariables>(GenericListItemCustomFieldsDocument, options);
      }
export function useGenericListItemCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericListItemCustomFieldsQuery, GenericListItemCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericListItemCustomFieldsQuery, GenericListItemCustomFieldsQueryVariables>(GenericListItemCustomFieldsDocument, options);
        }
export type GenericListItemCustomFieldsQueryHookResult = ReturnType<typeof useGenericListItemCustomFieldsQuery>;
export type GenericListItemCustomFieldsLazyQueryHookResult = ReturnType<typeof useGenericListItemCustomFieldsLazyQuery>;
export type GenericListItemCustomFieldsQueryResult = Apollo.QueryResult<GenericListItemCustomFieldsQuery, GenericListItemCustomFieldsQueryVariables>;
export const GenericListItemSlideDocument = gql`
    query GenericListItemSlide($itemUid: ID!) {
  genericListItem(itemUid: $itemUid) {
    ...GenericListItem
  }
}
    ${GenericListItemFragmentDoc}`;

/**
 * __useGenericListItemSlideQuery__
 *
 * To run a query within a React component, call `useGenericListItemSlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericListItemSlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericListItemSlideQuery({
 *   variables: {
 *      itemUid: // value for 'itemUid'
 *   },
 * });
 */
export function useGenericListItemSlideQuery(baseOptions: Apollo.QueryHookOptions<GenericListItemSlideQuery, GenericListItemSlideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericListItemSlideQuery, GenericListItemSlideQueryVariables>(GenericListItemSlideDocument, options);
      }
export function useGenericListItemSlideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericListItemSlideQuery, GenericListItemSlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericListItemSlideQuery, GenericListItemSlideQueryVariables>(GenericListItemSlideDocument, options);
        }
export type GenericListItemSlideQueryHookResult = ReturnType<typeof useGenericListItemSlideQuery>;
export type GenericListItemSlideLazyQueryHookResult = ReturnType<typeof useGenericListItemSlideLazyQuery>;
export type GenericListItemSlideQueryResult = Apollo.QueryResult<GenericListItemSlideQuery, GenericListItemSlideQueryVariables>;
export const GenericListItemsDocument = gql`
    query GenericListItems($genericListUid: ID!, $page: Int, $perPage: Int) {
  genericListItems(
    genericListUid: $genericListUid
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...GenericListItemRow
    }
  }
}
    ${GenericListItemRowFragmentDoc}`;

/**
 * __useGenericListItemsQuery__
 *
 * To run a query within a React component, call `useGenericListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericListItemsQuery({
 *   variables: {
 *      genericListUid: // value for 'genericListUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGenericListItemsQuery(baseOptions: Apollo.QueryHookOptions<GenericListItemsQuery, GenericListItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericListItemsQuery, GenericListItemsQueryVariables>(GenericListItemsDocument, options);
      }
export function useGenericListItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericListItemsQuery, GenericListItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericListItemsQuery, GenericListItemsQueryVariables>(GenericListItemsDocument, options);
        }
export type GenericListItemsQueryHookResult = ReturnType<typeof useGenericListItemsQuery>;
export type GenericListItemsLazyQueryHookResult = ReturnType<typeof useGenericListItemsLazyQuery>;
export type GenericListItemsQueryResult = Apollo.QueryResult<GenericListItemsQuery, GenericListItemsQueryVariables>;
export const GenericListItemsTotalDocument = gql`
    query GenericListItemsTotal($genericListUid: ID!) {
  genericListItems(genericListUid: $genericListUid) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useGenericListItemsTotalQuery__
 *
 * To run a query within a React component, call `useGenericListItemsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericListItemsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericListItemsTotalQuery({
 *   variables: {
 *      genericListUid: // value for 'genericListUid'
 *   },
 * });
 */
export function useGenericListItemsTotalQuery(baseOptions: Apollo.QueryHookOptions<GenericListItemsTotalQuery, GenericListItemsTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericListItemsTotalQuery, GenericListItemsTotalQueryVariables>(GenericListItemsTotalDocument, options);
      }
export function useGenericListItemsTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericListItemsTotalQuery, GenericListItemsTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericListItemsTotalQuery, GenericListItemsTotalQueryVariables>(GenericListItemsTotalDocument, options);
        }
export type GenericListItemsTotalQueryHookResult = ReturnType<typeof useGenericListItemsTotalQuery>;
export type GenericListItemsTotalLazyQueryHookResult = ReturnType<typeof useGenericListItemsTotalLazyQuery>;
export type GenericListItemsTotalQueryResult = Apollo.QueryResult<GenericListItemsTotalQuery, GenericListItemsTotalQueryVariables>;
export const GenericListReminderSettingsDocument = gql`
    query GenericListReminderSettings($genericListUid: ID!) {
  genericListReminderSettings(genericListUid: $genericListUid) {
    ...ReminderSettingPreview
  }
}
    ${ReminderSettingPreviewFragmentDoc}`;

/**
 * __useGenericListReminderSettingsQuery__
 *
 * To run a query within a React component, call `useGenericListReminderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericListReminderSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericListReminderSettingsQuery({
 *   variables: {
 *      genericListUid: // value for 'genericListUid'
 *   },
 * });
 */
export function useGenericListReminderSettingsQuery(baseOptions: Apollo.QueryHookOptions<GenericListReminderSettingsQuery, GenericListReminderSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericListReminderSettingsQuery, GenericListReminderSettingsQueryVariables>(GenericListReminderSettingsDocument, options);
      }
export function useGenericListReminderSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericListReminderSettingsQuery, GenericListReminderSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericListReminderSettingsQuery, GenericListReminderSettingsQueryVariables>(GenericListReminderSettingsDocument, options);
        }
export type GenericListReminderSettingsQueryHookResult = ReturnType<typeof useGenericListReminderSettingsQuery>;
export type GenericListReminderSettingsLazyQueryHookResult = ReturnType<typeof useGenericListReminderSettingsLazyQuery>;
export type GenericListReminderSettingsQueryResult = Apollo.QueryResult<GenericListReminderSettingsQuery, GenericListReminderSettingsQueryVariables>;
export const RemoveGenericListItemsDocument = gql`
    mutation RemoveGenericListItems($uids: [ID!]!) {
  removeGenericListItems(uids: $uids) {
    failReasons
  }
}
    `;
export type RemoveGenericListItemsMutationFn = Apollo.MutationFunction<RemoveGenericListItemsMutation, RemoveGenericListItemsMutationVariables>;

/**
 * __useRemoveGenericListItemsMutation__
 *
 * To run a mutation, you first call `useRemoveGenericListItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGenericListItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGenericListItemsMutation, { data, loading, error }] = useRemoveGenericListItemsMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useRemoveGenericListItemsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGenericListItemsMutation, RemoveGenericListItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGenericListItemsMutation, RemoveGenericListItemsMutationVariables>(RemoveGenericListItemsDocument, options);
      }
export type RemoveGenericListItemsMutationHookResult = ReturnType<typeof useRemoveGenericListItemsMutation>;
export type RemoveGenericListItemsMutationResult = Apollo.MutationResult<RemoveGenericListItemsMutation>;
export type RemoveGenericListItemsMutationOptions = Apollo.BaseMutationOptions<RemoveGenericListItemsMutation, RemoveGenericListItemsMutationVariables>;
export const ReorderGenericListItemsDocument = gql`
    mutation ReorderGenericListItems($uids: [ID!]!) {
  reorderGenericListItems(itemUids: $uids) {
    failReasons
  }
}
    `;
export type ReorderGenericListItemsMutationFn = Apollo.MutationFunction<ReorderGenericListItemsMutation, ReorderGenericListItemsMutationVariables>;

/**
 * __useReorderGenericListItemsMutation__
 *
 * To run a mutation, you first call `useReorderGenericListItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderGenericListItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderGenericListItemsMutation, { data, loading, error }] = useReorderGenericListItemsMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useReorderGenericListItemsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderGenericListItemsMutation, ReorderGenericListItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderGenericListItemsMutation, ReorderGenericListItemsMutationVariables>(ReorderGenericListItemsDocument, options);
      }
export type ReorderGenericListItemsMutationHookResult = ReturnType<typeof useReorderGenericListItemsMutation>;
export type ReorderGenericListItemsMutationResult = Apollo.MutationResult<ReorderGenericListItemsMutation>;
export type ReorderGenericListItemsMutationOptions = Apollo.BaseMutationOptions<ReorderGenericListItemsMutation, ReorderGenericListItemsMutationVariables>;
export const UpdateGenericListItemsDocument = gql`
    mutation UpdateGenericListItems($uids: [ID!]!, $customFieldAttributes: [CustomFieldAttribute!]) {
  updateGenericListItems(
    uids: $uids
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
    records {
      ...GenericListItemRow
    }
  }
}
    ${GenericListItemRowFragmentDoc}`;
export type UpdateGenericListItemsMutationFn = Apollo.MutationFunction<UpdateGenericListItemsMutation, UpdateGenericListItemsMutationVariables>;

/**
 * __useUpdateGenericListItemsMutation__
 *
 * To run a mutation, you first call `useUpdateGenericListItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericListItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGenericListItemsMutation, { data, loading, error }] = useUpdateGenericListItemsMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useUpdateGenericListItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGenericListItemsMutation, UpdateGenericListItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGenericListItemsMutation, UpdateGenericListItemsMutationVariables>(UpdateGenericListItemsDocument, options);
      }
export type UpdateGenericListItemsMutationHookResult = ReturnType<typeof useUpdateGenericListItemsMutation>;
export type UpdateGenericListItemsMutationResult = Apollo.MutationResult<UpdateGenericListItemsMutation>;
export type UpdateGenericListItemsMutationOptions = Apollo.BaseMutationOptions<UpdateGenericListItemsMutation, UpdateGenericListItemsMutationVariables>;
export const CreateFlatfileWorkbookForListDocument = gql`
    mutation CreateFlatfileWorkbookForList($importType: FlatFileImportType!, $listUid: ID!) {
  result: createFlatfileWorkbookForListImport(
    importType: $importType
    listUid: $listUid
  ) {
    failReasons
    workbook {
      ...CreatedWorkbook
    }
  }
}
    ${CreatedWorkbookFragmentDoc}`;
export type CreateFlatfileWorkbookForListMutationFn = Apollo.MutationFunction<CreateFlatfileWorkbookForListMutation, CreateFlatfileWorkbookForListMutationVariables>;

/**
 * __useCreateFlatfileWorkbookForListMutation__
 *
 * To run a mutation, you first call `useCreateFlatfileWorkbookForListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlatfileWorkbookForListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlatfileWorkbookForListMutation, { data, loading, error }] = useCreateFlatfileWorkbookForListMutation({
 *   variables: {
 *      importType: // value for 'importType'
 *      listUid: // value for 'listUid'
 *   },
 * });
 */
export function useCreateFlatfileWorkbookForListMutation(baseOptions?: Apollo.MutationHookOptions<CreateFlatfileWorkbookForListMutation, CreateFlatfileWorkbookForListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFlatfileWorkbookForListMutation, CreateFlatfileWorkbookForListMutationVariables>(CreateFlatfileWorkbookForListDocument, options);
      }
export type CreateFlatfileWorkbookForListMutationHookResult = ReturnType<typeof useCreateFlatfileWorkbookForListMutation>;
export type CreateFlatfileWorkbookForListMutationResult = Apollo.MutationResult<CreateFlatfileWorkbookForListMutation>;
export type CreateFlatfileWorkbookForListMutationOptions = Apollo.BaseMutationOptions<CreateFlatfileWorkbookForListMutation, CreateFlatfileWorkbookForListMutationVariables>;
export const FlatfileAdminImporterDocument = gql`
    mutation FlatfileAdminImporter($importType: FlatFileImportType!) {
  result: createFlatfileWorkbookForAdminImport(importType: $importType) {
    failReasons
    workbook {
      ...CreatedWorkbook
    }
  }
}
    ${CreatedWorkbookFragmentDoc}`;
export type FlatfileAdminImporterMutationFn = Apollo.MutationFunction<FlatfileAdminImporterMutation, FlatfileAdminImporterMutationVariables>;

/**
 * __useFlatfileAdminImporterMutation__
 *
 * To run a mutation, you first call `useFlatfileAdminImporterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlatfileAdminImporterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flatfileAdminImporterMutation, { data, loading, error }] = useFlatfileAdminImporterMutation({
 *   variables: {
 *      importType: // value for 'importType'
 *   },
 * });
 */
export function useFlatfileAdminImporterMutation(baseOptions?: Apollo.MutationHookOptions<FlatfileAdminImporterMutation, FlatfileAdminImporterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlatfileAdminImporterMutation, FlatfileAdminImporterMutationVariables>(FlatfileAdminImporterDocument, options);
      }
export type FlatfileAdminImporterMutationHookResult = ReturnType<typeof useFlatfileAdminImporterMutation>;
export type FlatfileAdminImporterMutationResult = Apollo.MutationResult<FlatfileAdminImporterMutation>;
export type FlatfileAdminImporterMutationOptions = Apollo.BaseMutationOptions<FlatfileAdminImporterMutation, FlatfileAdminImporterMutationVariables>;
export const FlatfileSpaceDocument = gql`
    mutation FlatfileSpace($workbookId: ID!) {
  result: importFlatfileWorkbook(workbookId: $workbookId) {
    failReasons
  }
}
    `;
export type FlatfileSpaceMutationFn = Apollo.MutationFunction<FlatfileSpaceMutation, FlatfileSpaceMutationVariables>;

/**
 * __useFlatfileSpaceMutation__
 *
 * To run a mutation, you first call `useFlatfileSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlatfileSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flatfileSpaceMutation, { data, loading, error }] = useFlatfileSpaceMutation({
 *   variables: {
 *      workbookId: // value for 'workbookId'
 *   },
 * });
 */
export function useFlatfileSpaceMutation(baseOptions?: Apollo.MutationHookOptions<FlatfileSpaceMutation, FlatfileSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlatfileSpaceMutation, FlatfileSpaceMutationVariables>(FlatfileSpaceDocument, options);
      }
export type FlatfileSpaceMutationHookResult = ReturnType<typeof useFlatfileSpaceMutation>;
export type FlatfileSpaceMutationResult = Apollo.MutationResult<FlatfileSpaceMutation>;
export type FlatfileSpaceMutationOptions = Apollo.BaseMutationOptions<FlatfileSpaceMutation, FlatfileSpaceMutationVariables>;
export const ImportListDocument = gql`
    query ImportList($page: Int, $perPage: Int) {
  importList(page: $page, perPage: $perPage) {
    entries {
      ...ImportListRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ImportListRowFragmentDoc}`;

/**
 * __useImportListQuery__
 *
 * To run a query within a React component, call `useImportListQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useImportListQuery(baseOptions?: Apollo.QueryHookOptions<ImportListQuery, ImportListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportListQuery, ImportListQueryVariables>(ImportListDocument, options);
      }
export function useImportListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportListQuery, ImportListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportListQuery, ImportListQueryVariables>(ImportListDocument, options);
        }
export type ImportListQueryHookResult = ReturnType<typeof useImportListQuery>;
export type ImportListLazyQueryHookResult = ReturnType<typeof useImportListLazyQuery>;
export type ImportListQueryResult = Apollo.QueryResult<ImportListQuery, ImportListQueryVariables>;
export const BulkAddIndustryMappingDocument = gql`
    mutation BulkAddIndustryMapping($companyIndustryNameUuids: [String!]!, $internalIndustryUuids: [String!]!) {
  updateIndustryMapping(
    companyIndustryNameUuids: $companyIndustryNameUuids
    internalIndustryUuids: $internalIndustryUuids
  ) {
    failReasons
  }
}
    `;
export type BulkAddIndustryMappingMutationFn = Apollo.MutationFunction<BulkAddIndustryMappingMutation, BulkAddIndustryMappingMutationVariables>;

/**
 * __useBulkAddIndustryMappingMutation__
 *
 * To run a mutation, you first call `useBulkAddIndustryMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddIndustryMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddIndustryMappingMutation, { data, loading, error }] = useBulkAddIndustryMappingMutation({
 *   variables: {
 *      companyIndustryNameUuids: // value for 'companyIndustryNameUuids'
 *      internalIndustryUuids: // value for 'internalIndustryUuids'
 *   },
 * });
 */
export function useBulkAddIndustryMappingMutation(baseOptions?: Apollo.MutationHookOptions<BulkAddIndustryMappingMutation, BulkAddIndustryMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAddIndustryMappingMutation, BulkAddIndustryMappingMutationVariables>(BulkAddIndustryMappingDocument, options);
      }
export type BulkAddIndustryMappingMutationHookResult = ReturnType<typeof useBulkAddIndustryMappingMutation>;
export type BulkAddIndustryMappingMutationResult = Apollo.MutationResult<BulkAddIndustryMappingMutation>;
export type BulkAddIndustryMappingMutationOptions = Apollo.BaseMutationOptions<BulkAddIndustryMappingMutation, BulkAddIndustryMappingMutationVariables>;
export const CompanyIndustryNamesDocument = gql`
    query CompanyIndustryNames($filter: CompanyIndustryNameFiltering, $page: Int, $perPage: Int) {
  companyIndustryNames(filter: $filter, page: $page, perPage: $perPage) {
    entries {
      ...CompanyIndustryName
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CompanyIndustryNameFragmentDoc}`;

/**
 * __useCompanyIndustryNamesQuery__
 *
 * To run a query within a React component, call `useCompanyIndustryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyIndustryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyIndustryNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCompanyIndustryNamesQuery(baseOptions?: Apollo.QueryHookOptions<CompanyIndustryNamesQuery, CompanyIndustryNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyIndustryNamesQuery, CompanyIndustryNamesQueryVariables>(CompanyIndustryNamesDocument, options);
      }
export function useCompanyIndustryNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyIndustryNamesQuery, CompanyIndustryNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyIndustryNamesQuery, CompanyIndustryNamesQueryVariables>(CompanyIndustryNamesDocument, options);
        }
export type CompanyIndustryNamesQueryHookResult = ReturnType<typeof useCompanyIndustryNamesQuery>;
export type CompanyIndustryNamesLazyQueryHookResult = ReturnType<typeof useCompanyIndustryNamesLazyQuery>;
export type CompanyIndustryNamesQueryResult = Apollo.QueryResult<CompanyIndustryNamesQuery, CompanyIndustryNamesQueryVariables>;
export const AddContactNewCompanySwitchDocument = gql`
    mutation AddContactNewCompanySwitch($contactUid: ID!, $companyUid: ID!, $linkedinUrl: String!, $keepBoth: Boolean) {
  addContactNewCompanySwitch(
    contactUid: $contactUid
    companyUid: $companyUid
    linkedinUrl: $linkedinUrl
    keepBoth: $keepBoth
  ) {
    record {
      ...ContactProfile
    }
    failReasons
  }
}
    ${ContactProfileFragmentDoc}`;
export type AddContactNewCompanySwitchMutationFn = Apollo.MutationFunction<AddContactNewCompanySwitchMutation, AddContactNewCompanySwitchMutationVariables>;

/**
 * __useAddContactNewCompanySwitchMutation__
 *
 * To run a mutation, you first call `useAddContactNewCompanySwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactNewCompanySwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactNewCompanySwitchMutation, { data, loading, error }] = useAddContactNewCompanySwitchMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      companyUid: // value for 'companyUid'
 *      linkedinUrl: // value for 'linkedinUrl'
 *      keepBoth: // value for 'keepBoth'
 *   },
 * });
 */
export function useAddContactNewCompanySwitchMutation(baseOptions?: Apollo.MutationHookOptions<AddContactNewCompanySwitchMutation, AddContactNewCompanySwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactNewCompanySwitchMutation, AddContactNewCompanySwitchMutationVariables>(AddContactNewCompanySwitchDocument, options);
      }
export type AddContactNewCompanySwitchMutationHookResult = ReturnType<typeof useAddContactNewCompanySwitchMutation>;
export type AddContactNewCompanySwitchMutationResult = Apollo.MutationResult<AddContactNewCompanySwitchMutation>;
export type AddContactNewCompanySwitchMutationOptions = Apollo.BaseMutationOptions<AddContactNewCompanySwitchMutation, AddContactNewCompanySwitchMutationVariables>;
export const AddContactPersonalEmailCompanySwitchDocument = gql`
    mutation AddContactPersonalEmailCompanySwitch($contactUid: ID!, $personalEmail: String!) {
  addContactPersonalEmailCompanySwitch(
    contactUid: $contactUid
    personalEmail: $personalEmail
  ) {
    failReasons
    record {
      ...ContactProfile
    }
  }
}
    ${ContactProfileFragmentDoc}`;
export type AddContactPersonalEmailCompanySwitchMutationFn = Apollo.MutationFunction<AddContactPersonalEmailCompanySwitchMutation, AddContactPersonalEmailCompanySwitchMutationVariables>;

/**
 * __useAddContactPersonalEmailCompanySwitchMutation__
 *
 * To run a mutation, you first call `useAddContactPersonalEmailCompanySwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactPersonalEmailCompanySwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactPersonalEmailCompanySwitchMutation, { data, loading, error }] = useAddContactPersonalEmailCompanySwitchMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      personalEmail: // value for 'personalEmail'
 *   },
 * });
 */
export function useAddContactPersonalEmailCompanySwitchMutation(baseOptions?: Apollo.MutationHookOptions<AddContactPersonalEmailCompanySwitchMutation, AddContactPersonalEmailCompanySwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactPersonalEmailCompanySwitchMutation, AddContactPersonalEmailCompanySwitchMutationVariables>(AddContactPersonalEmailCompanySwitchDocument, options);
      }
export type AddContactPersonalEmailCompanySwitchMutationHookResult = ReturnType<typeof useAddContactPersonalEmailCompanySwitchMutation>;
export type AddContactPersonalEmailCompanySwitchMutationResult = Apollo.MutationResult<AddContactPersonalEmailCompanySwitchMutation>;
export type AddContactPersonalEmailCompanySwitchMutationOptions = Apollo.BaseMutationOptions<AddContactPersonalEmailCompanySwitchMutation, AddContactPersonalEmailCompanySwitchMutationVariables>;
export const AddContactUnknownCompanySwitchDocument = gql`
    mutation AddContactUnknownCompanySwitch($contactUid: ID!, $removeFromMarketingList: Boolean) {
  addContactUnknownCompanySwitch(
    contactUid: $contactUid
    removeFromMarketingList: $removeFromMarketingList
  ) {
    failReasons
  }
}
    `;
export type AddContactUnknownCompanySwitchMutationFn = Apollo.MutationFunction<AddContactUnknownCompanySwitchMutation, AddContactUnknownCompanySwitchMutationVariables>;

/**
 * __useAddContactUnknownCompanySwitchMutation__
 *
 * To run a mutation, you first call `useAddContactUnknownCompanySwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactUnknownCompanySwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactUnknownCompanySwitchMutation, { data, loading, error }] = useAddContactUnknownCompanySwitchMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      removeFromMarketingList: // value for 'removeFromMarketingList'
 *   },
 * });
 */
export function useAddContactUnknownCompanySwitchMutation(baseOptions?: Apollo.MutationHookOptions<AddContactUnknownCompanySwitchMutation, AddContactUnknownCompanySwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactUnknownCompanySwitchMutation, AddContactUnknownCompanySwitchMutationVariables>(AddContactUnknownCompanySwitchDocument, options);
      }
export type AddContactUnknownCompanySwitchMutationHookResult = ReturnType<typeof useAddContactUnknownCompanySwitchMutation>;
export type AddContactUnknownCompanySwitchMutationResult = Apollo.MutationResult<AddContactUnknownCompanySwitchMutation>;
export type AddContactUnknownCompanySwitchMutationOptions = Apollo.BaseMutationOptions<AddContactUnknownCompanySwitchMutation, AddContactUnknownCompanySwitchMutationVariables>;
export const AddContactWorkEmailCompanySwitchDocument = gql`
    mutation AddContactWorkEmailCompanySwitch($contactUid: ID!, $workEmail: String!, $keepBoth: Boolean) {
  addContactWorkEmailCompanySwitch(
    contactUid: $contactUid
    workEmail: $workEmail
    keepBoth: $keepBoth
  ) {
    failReasons
    record {
      ...ContactProfile
    }
  }
}
    ${ContactProfileFragmentDoc}`;
export type AddContactWorkEmailCompanySwitchMutationFn = Apollo.MutationFunction<AddContactWorkEmailCompanySwitchMutation, AddContactWorkEmailCompanySwitchMutationVariables>;

/**
 * __useAddContactWorkEmailCompanySwitchMutation__
 *
 * To run a mutation, you first call `useAddContactWorkEmailCompanySwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactWorkEmailCompanySwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactWorkEmailCompanySwitchMutation, { data, loading, error }] = useAddContactWorkEmailCompanySwitchMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      workEmail: // value for 'workEmail'
 *      keepBoth: // value for 'keepBoth'
 *   },
 * });
 */
export function useAddContactWorkEmailCompanySwitchMutation(baseOptions?: Apollo.MutationHookOptions<AddContactWorkEmailCompanySwitchMutation, AddContactWorkEmailCompanySwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactWorkEmailCompanySwitchMutation, AddContactWorkEmailCompanySwitchMutationVariables>(AddContactWorkEmailCompanySwitchDocument, options);
      }
export type AddContactWorkEmailCompanySwitchMutationHookResult = ReturnType<typeof useAddContactWorkEmailCompanySwitchMutation>;
export type AddContactWorkEmailCompanySwitchMutationResult = Apollo.MutationResult<AddContactWorkEmailCompanySwitchMutation>;
export type AddContactWorkEmailCompanySwitchMutationOptions = Apollo.BaseMutationOptions<AddContactWorkEmailCompanySwitchMutation, AddContactWorkEmailCompanySwitchMutationVariables>;
export const KeyActivityMonthStatsDocument = gql`
    query KeyActivityMonthStats($employeeUid: ID) {
  keyActivityMonthStats(employeeUid: $employeeUid) {
    id
    month
    totals {
      ...KeyActivityCategoryTotal
    }
  }
}
    ${KeyActivityCategoryTotalFragmentDoc}`;

/**
 * __useKeyActivityMonthStatsQuery__
 *
 * To run a query within a React component, call `useKeyActivityMonthStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityMonthStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityMonthStatsQuery({
 *   variables: {
 *      employeeUid: // value for 'employeeUid'
 *   },
 * });
 */
export function useKeyActivityMonthStatsQuery(baseOptions?: Apollo.QueryHookOptions<KeyActivityMonthStatsQuery, KeyActivityMonthStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityMonthStatsQuery, KeyActivityMonthStatsQueryVariables>(KeyActivityMonthStatsDocument, options);
      }
export function useKeyActivityMonthStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityMonthStatsQuery, KeyActivityMonthStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityMonthStatsQuery, KeyActivityMonthStatsQueryVariables>(KeyActivityMonthStatsDocument, options);
        }
export type KeyActivityMonthStatsQueryHookResult = ReturnType<typeof useKeyActivityMonthStatsQuery>;
export type KeyActivityMonthStatsLazyQueryHookResult = ReturnType<typeof useKeyActivityMonthStatsLazyQuery>;
export type KeyActivityMonthStatsQueryResult = Apollo.QueryResult<KeyActivityMonthStatsQuery, KeyActivityMonthStatsQueryVariables>;
export const KeyActivityToUpdateDocument = gql`
    query KeyActivityToUpdate($sourceReferenceId: String!) {
  keyActivity(sourceReferenceId: $sourceReferenceId) {
    ...KeyActivityToUpdate
  }
}
    ${KeyActivityToUpdateFragmentDoc}`;

/**
 * __useKeyActivityToUpdateQuery__
 *
 * To run a query within a React component, call `useKeyActivityToUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityToUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityToUpdateQuery({
 *   variables: {
 *      sourceReferenceId: // value for 'sourceReferenceId'
 *   },
 * });
 */
export function useKeyActivityToUpdateQuery(baseOptions: Apollo.QueryHookOptions<KeyActivityToUpdateQuery, KeyActivityToUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityToUpdateQuery, KeyActivityToUpdateQueryVariables>(KeyActivityToUpdateDocument, options);
      }
export function useKeyActivityToUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityToUpdateQuery, KeyActivityToUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityToUpdateQuery, KeyActivityToUpdateQueryVariables>(KeyActivityToUpdateDocument, options);
        }
export type KeyActivityToUpdateQueryHookResult = ReturnType<typeof useKeyActivityToUpdateQuery>;
export type KeyActivityToUpdateLazyQueryHookResult = ReturnType<typeof useKeyActivityToUpdateLazyQuery>;
export type KeyActivityToUpdateQueryResult = Apollo.QueryResult<KeyActivityToUpdateQuery, KeyActivityToUpdateQueryVariables>;
export const MyKeyActivityPerformanceDocument = gql`
    query MyKeyActivityPerformance {
  myKeyActivityPerformance {
    monthCurrentTotal
    monthBestTotal
    currentConsecutiveWeeks
    longestConsecutiveWeeksStreak
  }
}
    `;

/**
 * __useMyKeyActivityPerformanceQuery__
 *
 * To run a query within a React component, call `useMyKeyActivityPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyKeyActivityPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyKeyActivityPerformanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyKeyActivityPerformanceQuery(baseOptions?: Apollo.QueryHookOptions<MyKeyActivityPerformanceQuery, MyKeyActivityPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyKeyActivityPerformanceQuery, MyKeyActivityPerformanceQueryVariables>(MyKeyActivityPerformanceDocument, options);
      }
export function useMyKeyActivityPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyKeyActivityPerformanceQuery, MyKeyActivityPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyKeyActivityPerformanceQuery, MyKeyActivityPerformanceQueryVariables>(MyKeyActivityPerformanceDocument, options);
        }
export type MyKeyActivityPerformanceQueryHookResult = ReturnType<typeof useMyKeyActivityPerformanceQuery>;
export type MyKeyActivityPerformanceLazyQueryHookResult = ReturnType<typeof useMyKeyActivityPerformanceLazyQuery>;
export type MyKeyActivityPerformanceQueryResult = Apollo.QueryResult<MyKeyActivityPerformanceQuery, MyKeyActivityPerformanceQueryVariables>;
export const AddContactsToListDocument = gql`
    mutation AddContactsToList($filter: ContactsFiltering, $filters: [ContactFilter!], $listUuid: ID!) {
  addContactsToList(listUuid: $listUuid, filter: $filter, filters: $filters) {
    failReasons
  }
}
    `;
export type AddContactsToListMutationFn = Apollo.MutationFunction<AddContactsToListMutation, AddContactsToListMutationVariables>;

/**
 * __useAddContactsToListMutation__
 *
 * To run a mutation, you first call `useAddContactsToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactsToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactsToListMutation, { data, loading, error }] = useAddContactsToListMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      filters: // value for 'filters'
 *      listUuid: // value for 'listUuid'
 *   },
 * });
 */
export function useAddContactsToListMutation(baseOptions?: Apollo.MutationHookOptions<AddContactsToListMutation, AddContactsToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactsToListMutation, AddContactsToListMutationVariables>(AddContactsToListDocument, options);
      }
export type AddContactsToListMutationHookResult = ReturnType<typeof useAddContactsToListMutation>;
export type AddContactsToListMutationResult = Apollo.MutationResult<AddContactsToListMutation>;
export type AddContactsToListMutationOptions = Apollo.BaseMutationOptions<AddContactsToListMutation, AddContactsToListMutationVariables>;
export const AddContactsToListWithTrackerDocument = gql`
    mutation AddContactsToListWithTracker($title: String!, $description: String, $filter: ContactsFiltering, $filters: [ContactFilter!], $returnPath: String, $destinationListUid: ID!, $customFieldAttributes: [CustomFieldAttribute!]) {
  addContactsToListWithTracker(
    progressTracker: {title: $title, description: $description, returnPath: $returnPath}
    filter: $filter
    filters: $filters
    destinationListUid: $destinationListUid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
  }
}
    `;
export type AddContactsToListWithTrackerMutationFn = Apollo.MutationFunction<AddContactsToListWithTrackerMutation, AddContactsToListWithTrackerMutationVariables>;

/**
 * __useAddContactsToListWithTrackerMutation__
 *
 * To run a mutation, you first call `useAddContactsToListWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactsToListWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactsToListWithTrackerMutation, { data, loading, error }] = useAddContactsToListWithTrackerMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      filter: // value for 'filter'
 *      filters: // value for 'filters'
 *      returnPath: // value for 'returnPath'
 *      destinationListUid: // value for 'destinationListUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useAddContactsToListWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<AddContactsToListWithTrackerMutation, AddContactsToListWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactsToListWithTrackerMutation, AddContactsToListWithTrackerMutationVariables>(AddContactsToListWithTrackerDocument, options);
      }
export type AddContactsToListWithTrackerMutationHookResult = ReturnType<typeof useAddContactsToListWithTrackerMutation>;
export type AddContactsToListWithTrackerMutationResult = Apollo.MutationResult<AddContactsToListWithTrackerMutation>;
export type AddContactsToListWithTrackerMutationOptions = Apollo.BaseMutationOptions<AddContactsToListWithTrackerMutation, AddContactsToListWithTrackerMutationVariables>;
export const AddListContactsToListDocument = gql`
    mutation AddListContactsToList($sourceListUuid: ID!, $destinationListUuid: ID!, $term: String, $filter: ListMembersFilter) {
  addListContactsToList(
    sourceListUuid: $sourceListUuid
    destinationListUuid: $destinationListUuid
    term: $term
    filter: $filter
  ) {
    failReasons
  }
}
    `;
export type AddListContactsToListMutationFn = Apollo.MutationFunction<AddListContactsToListMutation, AddListContactsToListMutationVariables>;

/**
 * __useAddListContactsToListMutation__
 *
 * To run a mutation, you first call `useAddListContactsToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddListContactsToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addListContactsToListMutation, { data, loading, error }] = useAddListContactsToListMutation({
 *   variables: {
 *      sourceListUuid: // value for 'sourceListUuid'
 *      destinationListUuid: // value for 'destinationListUuid'
 *      term: // value for 'term'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAddListContactsToListMutation(baseOptions?: Apollo.MutationHookOptions<AddListContactsToListMutation, AddListContactsToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddListContactsToListMutation, AddListContactsToListMutationVariables>(AddListContactsToListDocument, options);
      }
export type AddListContactsToListMutationHookResult = ReturnType<typeof useAddListContactsToListMutation>;
export type AddListContactsToListMutationResult = Apollo.MutationResult<AddListContactsToListMutation>;
export type AddListContactsToListMutationOptions = Apollo.BaseMutationOptions<AddListContactsToListMutation, AddListContactsToListMutationVariables>;
export const AddListContactsToListWithCustomFieldsDocument = gql`
    mutation AddListContactsToListWithCustomFields($sourceListUuid: ID!, $destinationListUuid: ID!, $term: String, $customFieldAttributes: [CustomFieldAttribute!]!) {
  addListContactsToList(
    sourceListUuid: $sourceListUuid
    destinationListUuid: $destinationListUuid
    term: $term
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
  }
}
    `;
export type AddListContactsToListWithCustomFieldsMutationFn = Apollo.MutationFunction<AddListContactsToListWithCustomFieldsMutation, AddListContactsToListWithCustomFieldsMutationVariables>;

/**
 * __useAddListContactsToListWithCustomFieldsMutation__
 *
 * To run a mutation, you first call `useAddListContactsToListWithCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddListContactsToListWithCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addListContactsToListWithCustomFieldsMutation, { data, loading, error }] = useAddListContactsToListWithCustomFieldsMutation({
 *   variables: {
 *      sourceListUuid: // value for 'sourceListUuid'
 *      destinationListUuid: // value for 'destinationListUuid'
 *      term: // value for 'term'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useAddListContactsToListWithCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<AddListContactsToListWithCustomFieldsMutation, AddListContactsToListWithCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddListContactsToListWithCustomFieldsMutation, AddListContactsToListWithCustomFieldsMutationVariables>(AddListContactsToListWithCustomFieldsDocument, options);
      }
export type AddListContactsToListWithCustomFieldsMutationHookResult = ReturnType<typeof useAddListContactsToListWithCustomFieldsMutation>;
export type AddListContactsToListWithCustomFieldsMutationResult = Apollo.MutationResult<AddListContactsToListWithCustomFieldsMutation>;
export type AddListContactsToListWithCustomFieldsMutationOptions = Apollo.BaseMutationOptions<AddListContactsToListWithCustomFieldsMutation, AddListContactsToListWithCustomFieldsMutationVariables>;
export const AddListContactsToListWithTrackerDocument = gql`
    mutation AddListContactsToListWithTracker($title: String!, $returnPath: String!, $description: String, $sourceListUuid: ID!, $destinationListUuid: ID!, $customFieldAttributes: [CustomFieldAttribute!], $term: String) {
  addListContactsToListWithTracker(
    progressTracker: {title: $title, returnPath: $returnPath, description: $description}
    sourceListUid: $sourceListUuid
    destinationListUid: $destinationListUuid
    customFieldAttributes: $customFieldAttributes
    term: $term
  ) {
    failReasons
  }
}
    `;
export type AddListContactsToListWithTrackerMutationFn = Apollo.MutationFunction<AddListContactsToListWithTrackerMutation, AddListContactsToListWithTrackerMutationVariables>;

/**
 * __useAddListContactsToListWithTrackerMutation__
 *
 * To run a mutation, you first call `useAddListContactsToListWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddListContactsToListWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addListContactsToListWithTrackerMutation, { data, loading, error }] = useAddListContactsToListWithTrackerMutation({
 *   variables: {
 *      title: // value for 'title'
 *      returnPath: // value for 'returnPath'
 *      description: // value for 'description'
 *      sourceListUuid: // value for 'sourceListUuid'
 *      destinationListUuid: // value for 'destinationListUuid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useAddListContactsToListWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<AddListContactsToListWithTrackerMutation, AddListContactsToListWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddListContactsToListWithTrackerMutation, AddListContactsToListWithTrackerMutationVariables>(AddListContactsToListWithTrackerDocument, options);
      }
export type AddListContactsToListWithTrackerMutationHookResult = ReturnType<typeof useAddListContactsToListWithTrackerMutation>;
export type AddListContactsToListWithTrackerMutationResult = Apollo.MutationResult<AddListContactsToListWithTrackerMutation>;
export type AddListContactsToListWithTrackerMutationOptions = Apollo.BaseMutationOptions<AddListContactsToListWithTrackerMutation, AddListContactsToListWithTrackerMutationVariables>;
export const AddMyContactsToListDocument = gql`
    mutation AddMyContactsToList($filter: MyContactsFiltering, $listUuid: ID!) {
  addMyContactsToList(filter: $filter, listUuid: $listUuid) {
    failReasons
  }
}
    `;
export type AddMyContactsToListMutationFn = Apollo.MutationFunction<AddMyContactsToListMutation, AddMyContactsToListMutationVariables>;

/**
 * __useAddMyContactsToListMutation__
 *
 * To run a mutation, you first call `useAddMyContactsToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMyContactsToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMyContactsToListMutation, { data, loading, error }] = useAddMyContactsToListMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      listUuid: // value for 'listUuid'
 *   },
 * });
 */
export function useAddMyContactsToListMutation(baseOptions?: Apollo.MutationHookOptions<AddMyContactsToListMutation, AddMyContactsToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMyContactsToListMutation, AddMyContactsToListMutationVariables>(AddMyContactsToListDocument, options);
      }
export type AddMyContactsToListMutationHookResult = ReturnType<typeof useAddMyContactsToListMutation>;
export type AddMyContactsToListMutationResult = Apollo.MutationResult<AddMyContactsToListMutation>;
export type AddMyContactsToListMutationOptions = Apollo.BaseMutationOptions<AddMyContactsToListMutation, AddMyContactsToListMutationVariables>;
export const AddMyContactsToListWithTrackerDocument = gql`
    mutation AddMyContactsToListWithTracker($filter: MyContactsFiltering, $listUuid: ID!, $title: String!, $returnPath: String!, $description: String) {
  addMyContactsToListWithTracker(
    filter: $filter
    destinationListUid: $listUuid
    progressTracker: {title: $title, returnPath: $returnPath, description: $description}
  ) {
    failReasons
  }
}
    `;
export type AddMyContactsToListWithTrackerMutationFn = Apollo.MutationFunction<AddMyContactsToListWithTrackerMutation, AddMyContactsToListWithTrackerMutationVariables>;

/**
 * __useAddMyContactsToListWithTrackerMutation__
 *
 * To run a mutation, you first call `useAddMyContactsToListWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMyContactsToListWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMyContactsToListWithTrackerMutation, { data, loading, error }] = useAddMyContactsToListWithTrackerMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      listUuid: // value for 'listUuid'
 *      title: // value for 'title'
 *      returnPath: // value for 'returnPath'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAddMyContactsToListWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<AddMyContactsToListWithTrackerMutation, AddMyContactsToListWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMyContactsToListWithTrackerMutation, AddMyContactsToListWithTrackerMutationVariables>(AddMyContactsToListWithTrackerDocument, options);
      }
export type AddMyContactsToListWithTrackerMutationHookResult = ReturnType<typeof useAddMyContactsToListWithTrackerMutation>;
export type AddMyContactsToListWithTrackerMutationResult = Apollo.MutationResult<AddMyContactsToListWithTrackerMutation>;
export type AddMyContactsToListWithTrackerMutationOptions = Apollo.BaseMutationOptions<AddMyContactsToListWithTrackerMutation, AddMyContactsToListWithTrackerMutationVariables>;
export const BulkAddListMembersWithTrackerDocument = gql`
    mutation BulkAddListMembersWithTracker($progressTracker: ProgressTrackerAttributes!, $destinationListUid: ID!, $contactUids: [ID!]!, $customFieldAttributes: [CustomFieldAttribute!]!) {
  bulkAddListMemberWithTracker(
    progressTracker: $progressTracker
    destinationListUid: $destinationListUid
    contactUids: $contactUids
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
  }
}
    `;
export type BulkAddListMembersWithTrackerMutationFn = Apollo.MutationFunction<BulkAddListMembersWithTrackerMutation, BulkAddListMembersWithTrackerMutationVariables>;

/**
 * __useBulkAddListMembersWithTrackerMutation__
 *
 * To run a mutation, you first call `useBulkAddListMembersWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddListMembersWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddListMembersWithTrackerMutation, { data, loading, error }] = useBulkAddListMembersWithTrackerMutation({
 *   variables: {
 *      progressTracker: // value for 'progressTracker'
 *      destinationListUid: // value for 'destinationListUid'
 *      contactUids: // value for 'contactUids'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useBulkAddListMembersWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<BulkAddListMembersWithTrackerMutation, BulkAddListMembersWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAddListMembersWithTrackerMutation, BulkAddListMembersWithTrackerMutationVariables>(BulkAddListMembersWithTrackerDocument, options);
      }
export type BulkAddListMembersWithTrackerMutationHookResult = ReturnType<typeof useBulkAddListMembersWithTrackerMutation>;
export type BulkAddListMembersWithTrackerMutationResult = Apollo.MutationResult<BulkAddListMembersWithTrackerMutation>;
export type BulkAddListMembersWithTrackerMutationOptions = Apollo.BaseMutationOptions<BulkAddListMembersWithTrackerMutation, BulkAddListMembersWithTrackerMutationVariables>;
export const BulkEditListMemberWithTrackerDocument = gql`
    mutation BulkEditListMemberWithTracker($progressTracker: ProgressTrackerAttributes!, $memberUids: [ID!]!, $customFieldAttributes: [CustomFieldAttribute!]!, $listUid: ID) {
  bulkEditListMemberWithTracker(
    progressTracker: $progressTracker
    memberUids: $memberUids
    customFieldAttributes: $customFieldAttributes
    listUid: $listUid
  ) {
    failReasons
  }
}
    `;
export type BulkEditListMemberWithTrackerMutationFn = Apollo.MutationFunction<BulkEditListMemberWithTrackerMutation, BulkEditListMemberWithTrackerMutationVariables>;

/**
 * __useBulkEditListMemberWithTrackerMutation__
 *
 * To run a mutation, you first call `useBulkEditListMemberWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEditListMemberWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEditListMemberWithTrackerMutation, { data, loading, error }] = useBulkEditListMemberWithTrackerMutation({
 *   variables: {
 *      progressTracker: // value for 'progressTracker'
 *      memberUids: // value for 'memberUids'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *      listUid: // value for 'listUid'
 *   },
 * });
 */
export function useBulkEditListMemberWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<BulkEditListMemberWithTrackerMutation, BulkEditListMemberWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkEditListMemberWithTrackerMutation, BulkEditListMemberWithTrackerMutationVariables>(BulkEditListMemberWithTrackerDocument, options);
      }
export type BulkEditListMemberWithTrackerMutationHookResult = ReturnType<typeof useBulkEditListMemberWithTrackerMutation>;
export type BulkEditListMemberWithTrackerMutationResult = Apollo.MutationResult<BulkEditListMemberWithTrackerMutation>;
export type BulkEditListMemberWithTrackerMutationOptions = Apollo.BaseMutationOptions<BulkEditListMemberWithTrackerMutation, BulkEditListMemberWithTrackerMutationVariables>;
export const BulkRemoveContactsFromListWithTrackerDocument = gql`
    mutation BulkRemoveContactsFromListWithTracker($progressTracker: ProgressTrackerAttributes!, $listUid: ID!, $contactUids: [ID!]!) {
  bulkRemoveContactsFromListWithTracker(
    progressTracker: $progressTracker
    listUid: $listUid
    contactUids: $contactUids
  ) {
    failReasons
  }
}
    `;
export type BulkRemoveContactsFromListWithTrackerMutationFn = Apollo.MutationFunction<BulkRemoveContactsFromListWithTrackerMutation, BulkRemoveContactsFromListWithTrackerMutationVariables>;

/**
 * __useBulkRemoveContactsFromListWithTrackerMutation__
 *
 * To run a mutation, you first call `useBulkRemoveContactsFromListWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveContactsFromListWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveContactsFromListWithTrackerMutation, { data, loading, error }] = useBulkRemoveContactsFromListWithTrackerMutation({
 *   variables: {
 *      progressTracker: // value for 'progressTracker'
 *      listUid: // value for 'listUid'
 *      contactUids: // value for 'contactUids'
 *   },
 * });
 */
export function useBulkRemoveContactsFromListWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveContactsFromListWithTrackerMutation, BulkRemoveContactsFromListWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveContactsFromListWithTrackerMutation, BulkRemoveContactsFromListWithTrackerMutationVariables>(BulkRemoveContactsFromListWithTrackerDocument, options);
      }
export type BulkRemoveContactsFromListWithTrackerMutationHookResult = ReturnType<typeof useBulkRemoveContactsFromListWithTrackerMutation>;
export type BulkRemoveContactsFromListWithTrackerMutationResult = Apollo.MutationResult<BulkRemoveContactsFromListWithTrackerMutation>;
export type BulkRemoveContactsFromListWithTrackerMutationOptions = Apollo.BaseMutationOptions<BulkRemoveContactsFromListWithTrackerMutation, BulkRemoveContactsFromListWithTrackerMutationVariables>;
export const BulkRemoveListMemberDocument = gql`
    mutation BulkRemoveListMember($uid: ID!, $listMemberEmails: [String!]!) {
  bulkRemoveListMember(uid: $uid, listMemberEmails: $listMemberEmails) {
    failReasons
  }
}
    `;
export type BulkRemoveListMemberMutationFn = Apollo.MutationFunction<BulkRemoveListMemberMutation, BulkRemoveListMemberMutationVariables>;

/**
 * __useBulkRemoveListMemberMutation__
 *
 * To run a mutation, you first call `useBulkRemoveListMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveListMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveListMemberMutation, { data, loading, error }] = useBulkRemoveListMemberMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      listMemberEmails: // value for 'listMemberEmails'
 *   },
 * });
 */
export function useBulkRemoveListMemberMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveListMemberMutation, BulkRemoveListMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveListMemberMutation, BulkRemoveListMemberMutationVariables>(BulkRemoveListMemberDocument, options);
      }
export type BulkRemoveListMemberMutationHookResult = ReturnType<typeof useBulkRemoveListMemberMutation>;
export type BulkRemoveListMemberMutationResult = Apollo.MutationResult<BulkRemoveListMemberMutation>;
export type BulkRemoveListMemberMutationOptions = Apollo.BaseMutationOptions<BulkRemoveListMemberMutation, BulkRemoveListMemberMutationVariables>;
export const BulkUpdateListMemberDocument = gql`
    mutation BulkUpdateListMember($listUid: ID, $memberIds: [ID!]!, $customFieldAttributes: [CustomFieldAttribute!]!) {
  bulkUpdateListMember(
    listUid: $listUid
    memberIds: $memberIds
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
    records {
      ...ContactProjectListMemberRow
    }
    gridMemberRecords {
      ...ContactListGridMemberRow
    }
  }
}
    ${ContactProjectListMemberRowFragmentDoc}
${ContactListGridMemberRowFragmentDoc}`;
export type BulkUpdateListMemberMutationFn = Apollo.MutationFunction<BulkUpdateListMemberMutation, BulkUpdateListMemberMutationVariables>;

/**
 * __useBulkUpdateListMemberMutation__
 *
 * To run a mutation, you first call `useBulkUpdateListMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateListMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateListMemberMutation, { data, loading, error }] = useBulkUpdateListMemberMutation({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      memberIds: // value for 'memberIds'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useBulkUpdateListMemberMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateListMemberMutation, BulkUpdateListMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateListMemberMutation, BulkUpdateListMemberMutationVariables>(BulkUpdateListMemberDocument, options);
      }
export type BulkUpdateListMemberMutationHookResult = ReturnType<typeof useBulkUpdateListMemberMutation>;
export type BulkUpdateListMemberMutationResult = Apollo.MutationResult<BulkUpdateListMemberMutation>;
export type BulkUpdateListMemberMutationOptions = Apollo.BaseMutationOptions<BulkUpdateListMemberMutation, BulkUpdateListMemberMutationVariables>;
export const CreateListDocument = gql`
    mutation CreateList($name: String!, $category: ListCategory) {
  createList(name: $name, category: $category) {
    id
    failReasons
  }
}
    `;
export type CreateListMutationFn = Apollo.MutationFunction<CreateListMutation, CreateListMutationVariables>;

/**
 * __useCreateListMutation__
 *
 * To run a mutation, you first call `useCreateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListMutation, { data, loading, error }] = useCreateListMutation({
 *   variables: {
 *      name: // value for 'name'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCreateListMutation(baseOptions?: Apollo.MutationHookOptions<CreateListMutation, CreateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListMutation, CreateListMutationVariables>(CreateListDocument, options);
      }
export type CreateListMutationHookResult = ReturnType<typeof useCreateListMutation>;
export type CreateListMutationResult = Apollo.MutationResult<CreateListMutation>;
export type CreateListMutationOptions = Apollo.BaseMutationOptions<CreateListMutation, CreateListMutationVariables>;
export const ListCustomFieldSchemasDocument = gql`
    query ListCustomFieldSchemas($uid: ID!) {
  list(uid: $uid) {
    id
    name
    memberCustomFields {
      ...CustomFieldSchema
    }
    tabUid
    project {
      id
      title
    }
    usageMode
  }
}
    ${CustomFieldSchemaFragmentDoc}`;

/**
 * __useListCustomFieldSchemasQuery__
 *
 * To run a query within a React component, call `useListCustomFieldSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomFieldSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomFieldSchemasQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useListCustomFieldSchemasQuery(baseOptions: Apollo.QueryHookOptions<ListCustomFieldSchemasQuery, ListCustomFieldSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCustomFieldSchemasQuery, ListCustomFieldSchemasQueryVariables>(ListCustomFieldSchemasDocument, options);
      }
export function useListCustomFieldSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomFieldSchemasQuery, ListCustomFieldSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCustomFieldSchemasQuery, ListCustomFieldSchemasQueryVariables>(ListCustomFieldSchemasDocument, options);
        }
export type ListCustomFieldSchemasQueryHookResult = ReturnType<typeof useListCustomFieldSchemasQuery>;
export type ListCustomFieldSchemasLazyQueryHookResult = ReturnType<typeof useListCustomFieldSchemasLazyQuery>;
export type ListCustomFieldSchemasQueryResult = Apollo.QueryResult<ListCustomFieldSchemasQuery, ListCustomFieldSchemasQueryVariables>;
export const ListMemberCustomFieldsDocument = gql`
    query ListMemberCustomFields($listMemberUid: ID!) {
  listMember(listMemberUid: $listMemberUid) {
    id
    list {
      id
    }
    customFields {
      ...CustomField
    }
    creator {
      ...CreatorDetails
    }
  }
}
    ${CustomFieldFragmentDoc}
${CreatorDetailsFragmentDoc}`;

/**
 * __useListMemberCustomFieldsQuery__
 *
 * To run a query within a React component, call `useListMemberCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMemberCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMemberCustomFieldsQuery({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *   },
 * });
 */
export function useListMemberCustomFieldsQuery(baseOptions: Apollo.QueryHookOptions<ListMemberCustomFieldsQuery, ListMemberCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMemberCustomFieldsQuery, ListMemberCustomFieldsQueryVariables>(ListMemberCustomFieldsDocument, options);
      }
export function useListMemberCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMemberCustomFieldsQuery, ListMemberCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMemberCustomFieldsQuery, ListMemberCustomFieldsQueryVariables>(ListMemberCustomFieldsDocument, options);
        }
export type ListMemberCustomFieldsQueryHookResult = ReturnType<typeof useListMemberCustomFieldsQuery>;
export type ListMemberCustomFieldsLazyQueryHookResult = ReturnType<typeof useListMemberCustomFieldsLazyQuery>;
export type ListMemberCustomFieldsQueryResult = Apollo.QueryResult<ListMemberCustomFieldsQuery, ListMemberCustomFieldsQueryVariables>;
export const ListNameDocument = gql`
    query ListName($uid: ID!) {
  list(uid: $uid) {
    id
    name
  }
}
    `;

/**
 * __useListNameQuery__
 *
 * To run a query within a React component, call `useListNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNameQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useListNameQuery(baseOptions: Apollo.QueryHookOptions<ListNameQuery, ListNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListNameQuery, ListNameQueryVariables>(ListNameDocument, options);
      }
export function useListNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListNameQuery, ListNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListNameQuery, ListNameQueryVariables>(ListNameDocument, options);
        }
export type ListNameQueryHookResult = ReturnType<typeof useListNameQuery>;
export type ListNameLazyQueryHookResult = ReturnType<typeof useListNameLazyQuery>;
export type ListNameQueryResult = Apollo.QueryResult<ListNameQuery, ListNameQueryVariables>;
export const ListUsageInfoDocument = gql`
    query ListUsageInfo($uid: ID!) {
  list(uid: $uid) {
    id
    tabUid
    project {
      id
      title
      nexlApps
    }
    name
    usageMode
  }
}
    `;

/**
 * __useListUsageInfoQuery__
 *
 * To run a query within a React component, call `useListUsageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsageInfoQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useListUsageInfoQuery(baseOptions: Apollo.QueryHookOptions<ListUsageInfoQuery, ListUsageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsageInfoQuery, ListUsageInfoQueryVariables>(ListUsageInfoDocument, options);
      }
export function useListUsageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsageInfoQuery, ListUsageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsageInfoQuery, ListUsageInfoQueryVariables>(ListUsageInfoDocument, options);
        }
export type ListUsageInfoQueryHookResult = ReturnType<typeof useListUsageInfoQuery>;
export type ListUsageInfoLazyQueryHookResult = ReturnType<typeof useListUsageInfoLazyQuery>;
export type ListUsageInfoQueryResult = Apollo.QueryResult<ListUsageInfoQuery, ListUsageInfoQueryVariables>;
export const SetListMemberCustomFieldDocument = gql`
    mutation SetListMemberCustomField($listMemberUid: ID!, $customFieldAttributes: [CustomFieldAttribute!]!) {
  setListMemberCustomField(
    listMemberUid: $listMemberUid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
    record {
      ...ContactProjectListMemberRow
    }
    gridMemberRecord {
      ...ContactListGridMemberRow
    }
  }
}
    ${ContactProjectListMemberRowFragmentDoc}
${ContactListGridMemberRowFragmentDoc}`;
export type SetListMemberCustomFieldMutationFn = Apollo.MutationFunction<SetListMemberCustomFieldMutation, SetListMemberCustomFieldMutationVariables>;

/**
 * __useSetListMemberCustomFieldMutation__
 *
 * To run a mutation, you first call `useSetListMemberCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetListMemberCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setListMemberCustomFieldMutation, { data, loading, error }] = useSetListMemberCustomFieldMutation({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useSetListMemberCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<SetListMemberCustomFieldMutation, SetListMemberCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetListMemberCustomFieldMutation, SetListMemberCustomFieldMutationVariables>(SetListMemberCustomFieldDocument, options);
      }
export type SetListMemberCustomFieldMutationHookResult = ReturnType<typeof useSetListMemberCustomFieldMutation>;
export type SetListMemberCustomFieldMutationResult = Apollo.MutationResult<SetListMemberCustomFieldMutation>;
export type SetListMemberCustomFieldMutationOptions = Apollo.BaseMutationOptions<SetListMemberCustomFieldMutation, SetListMemberCustomFieldMutationVariables>;
export const UpdateListDocument = gql`
    mutation UpdateList($uid: ID!, $name: String = null, $category: ListCategory = null) {
  updateList(uid: $uid, name: $name, category: $category) {
    failReasons
    list {
      id
      name
      category
    }
  }
}
    `;
export type UpdateListMutationFn = Apollo.MutationFunction<UpdateListMutation, UpdateListMutationVariables>;

/**
 * __useUpdateListMutation__
 *
 * To run a mutation, you first call `useUpdateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListMutation, { data, loading, error }] = useUpdateListMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      name: // value for 'name'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useUpdateListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListMutation, UpdateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListMutation, UpdateListMutationVariables>(UpdateListDocument, options);
      }
export type UpdateListMutationHookResult = ReturnType<typeof useUpdateListMutation>;
export type UpdateListMutationResult = Apollo.MutationResult<UpdateListMutation>;
export type UpdateListMutationOptions = Apollo.BaseMutationOptions<UpdateListMutation, UpdateListMutationVariables>;
export const ContactListGridMembersDocument = gql`
    query ContactListGridMembers($listId: ID!, $page: Int, $perPage: Int) {
  contactListGridMembers(contactListUid: $listId, page: $page, per: $perPage) {
    id
    entries {
      ...ContactListGridMemberRow
    }
  }
}
    ${ContactListGridMemberRowFragmentDoc}`;

/**
 * __useContactListGridMembersQuery__
 *
 * To run a query within a React component, call `useContactListGridMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListGridMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListGridMembersQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useContactListGridMembersQuery(baseOptions: Apollo.QueryHookOptions<ContactListGridMembersQuery, ContactListGridMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListGridMembersQuery, ContactListGridMembersQueryVariables>(ContactListGridMembersDocument, options);
      }
export function useContactListGridMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListGridMembersQuery, ContactListGridMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListGridMembersQuery, ContactListGridMembersQueryVariables>(ContactListGridMembersDocument, options);
        }
export type ContactListGridMembersQueryHookResult = ReturnType<typeof useContactListGridMembersQuery>;
export type ContactListGridMembersLazyQueryHookResult = ReturnType<typeof useContactListGridMembersLazyQuery>;
export type ContactListGridMembersQueryResult = Apollo.QueryResult<ContactListGridMembersQuery, ContactListGridMembersQueryVariables>;
export const ContactListGridMembersDeltaDocument = gql`
    query ContactListGridMembersDelta($contactListUid: ID!, $deltaAfter: ISO8601DateTime!, $deltaSize: Int!) {
  contactListGridMembersDelta(
    deltaAfter: $deltaAfter
    contactListUid: $contactListUid
    deltaSize: $deltaSize
  ) {
    exceeded
    added {
      ...ContactListGridMemberRow
    }
    removed {
      id
    }
    updated {
      ...ContactListGridMemberRow
    }
  }
}
    ${ContactListGridMemberRowFragmentDoc}`;

/**
 * __useContactListGridMembersDeltaQuery__
 *
 * To run a query within a React component, call `useContactListGridMembersDeltaQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListGridMembersDeltaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListGridMembersDeltaQuery({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *      deltaAfter: // value for 'deltaAfter'
 *      deltaSize: // value for 'deltaSize'
 *   },
 * });
 */
export function useContactListGridMembersDeltaQuery(baseOptions: Apollo.QueryHookOptions<ContactListGridMembersDeltaQuery, ContactListGridMembersDeltaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListGridMembersDeltaQuery, ContactListGridMembersDeltaQueryVariables>(ContactListGridMembersDeltaDocument, options);
      }
export function useContactListGridMembersDeltaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListGridMembersDeltaQuery, ContactListGridMembersDeltaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListGridMembersDeltaQuery, ContactListGridMembersDeltaQueryVariables>(ContactListGridMembersDeltaDocument, options);
        }
export type ContactListGridMembersDeltaQueryHookResult = ReturnType<typeof useContactListGridMembersDeltaQuery>;
export type ContactListGridMembersDeltaLazyQueryHookResult = ReturnType<typeof useContactListGridMembersDeltaLazyQuery>;
export type ContactListGridMembersDeltaQueryResult = Apollo.QueryResult<ContactListGridMembersDeltaQuery, ContactListGridMembersDeltaQueryVariables>;
export const ContactListGridMembersTotalDocument = gql`
    query ContactListGridMembersTotal($listId: ID!) {
  contactListGridMembers(contactListUid: $listId, page: 1, per: 1) {
    pageInfo {
      totalEntries
    }
    deltaAfter
  }
  currentUser {
    userId
  }
}
    `;

/**
 * __useContactListGridMembersTotalQuery__
 *
 * To run a query within a React component, call `useContactListGridMembersTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListGridMembersTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListGridMembersTotalQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useContactListGridMembersTotalQuery(baseOptions: Apollo.QueryHookOptions<ContactListGridMembersTotalQuery, ContactListGridMembersTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListGridMembersTotalQuery, ContactListGridMembersTotalQueryVariables>(ContactListGridMembersTotalDocument, options);
      }
export function useContactListGridMembersTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListGridMembersTotalQuery, ContactListGridMembersTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListGridMembersTotalQuery, ContactListGridMembersTotalQueryVariables>(ContactListGridMembersTotalDocument, options);
        }
export type ContactListGridMembersTotalQueryHookResult = ReturnType<typeof useContactListGridMembersTotalQuery>;
export type ContactListGridMembersTotalLazyQueryHookResult = ReturnType<typeof useContactListGridMembersTotalLazyQuery>;
export type ContactListGridMembersTotalQueryResult = Apollo.QueryResult<ContactListGridMembersTotalQuery, ContactListGridMembersTotalQueryVariables>;
export const ContactListGridMembersWithFiltersDocument = gql`
    query ContactListGridMembersWithFilters($listId: ID!, $page: Int, $perPage: Int, $contactFilter: ContactListGridMembersFiltering, $listMemberFilter: ListMemberFilter) {
  contactListGridMembers(
    contactListUid: $listId
    page: $page
    per: $perPage
    contactFilter: $contactFilter
    listMemberFilter: $listMemberFilter
  ) {
    id
    entries {
      ...ContactListGridMemberRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactListGridMemberRowFragmentDoc}`;

/**
 * __useContactListGridMembersWithFiltersQuery__
 *
 * To run a query within a React component, call `useContactListGridMembersWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListGridMembersWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListGridMembersWithFiltersQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      contactFilter: // value for 'contactFilter'
 *      listMemberFilter: // value for 'listMemberFilter'
 *   },
 * });
 */
export function useContactListGridMembersWithFiltersQuery(baseOptions: Apollo.QueryHookOptions<ContactListGridMembersWithFiltersQuery, ContactListGridMembersWithFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListGridMembersWithFiltersQuery, ContactListGridMembersWithFiltersQueryVariables>(ContactListGridMembersWithFiltersDocument, options);
      }
export function useContactListGridMembersWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListGridMembersWithFiltersQuery, ContactListGridMembersWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListGridMembersWithFiltersQuery, ContactListGridMembersWithFiltersQueryVariables>(ContactListGridMembersWithFiltersDocument, options);
        }
export type ContactListGridMembersWithFiltersQueryHookResult = ReturnType<typeof useContactListGridMembersWithFiltersQuery>;
export type ContactListGridMembersWithFiltersLazyQueryHookResult = ReturnType<typeof useContactListGridMembersWithFiltersLazyQuery>;
export type ContactListGridMembersWithFiltersQueryResult = Apollo.QueryResult<ContactListGridMembersWithFiltersQuery, ContactListGridMembersWithFiltersQueryVariables>;
export const ContactListFormDocument = gql`
    query ContactListForm($uid: ID!) {
  contactListForm(uid: $uid) {
    ...ContactListFormDetails
  }
}
    ${ContactListFormDetailsFragmentDoc}`;

/**
 * __useContactListFormQuery__
 *
 * To run a query within a React component, call `useContactListFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListFormQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useContactListFormQuery(baseOptions: Apollo.QueryHookOptions<ContactListFormQuery, ContactListFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListFormQuery, ContactListFormQueryVariables>(ContactListFormDocument, options);
      }
export function useContactListFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListFormQuery, ContactListFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListFormQuery, ContactListFormQueryVariables>(ContactListFormDocument, options);
        }
export type ContactListFormQueryHookResult = ReturnType<typeof useContactListFormQuery>;
export type ContactListFormLazyQueryHookResult = ReturnType<typeof useContactListFormLazyQuery>;
export type ContactListFormQueryResult = Apollo.QueryResult<ContactListFormQuery, ContactListFormQueryVariables>;
export const ContactListFormsDocument = gql`
    query ContactListForms($uid: ID!, $page: Int, $perPage: Int) {
  contactListForms(uid: $uid, page: $page, perPage: $perPage) {
    entries {
      ...ContactListFormInfo
    }
  }
}
    ${ContactListFormInfoFragmentDoc}`;

/**
 * __useContactListFormsQuery__
 *
 * To run a query within a React component, call `useContactListFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListFormsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useContactListFormsQuery(baseOptions: Apollo.QueryHookOptions<ContactListFormsQuery, ContactListFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListFormsQuery, ContactListFormsQueryVariables>(ContactListFormsDocument, options);
      }
export function useContactListFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListFormsQuery, ContactListFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListFormsQuery, ContactListFormsQueryVariables>(ContactListFormsDocument, options);
        }
export type ContactListFormsQueryHookResult = ReturnType<typeof useContactListFormsQuery>;
export type ContactListFormsLazyQueryHookResult = ReturnType<typeof useContactListFormsLazyQuery>;
export type ContactListFormsQueryResult = Apollo.QueryResult<ContactListFormsQuery, ContactListFormsQueryVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($contact_list_id: ID!, $title: String!, $description: String) {
  result: createForm(
    contactListId: $contact_list_id
    title: $title
    description: $description
  ) {
    record {
      id
    }
    failReasons
  }
}
    `;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      contact_list_id: // value for 'contact_list_id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, options);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const DeleteFormDocument = gql`
    mutation DeleteForm($id: ID!) {
  result: deleteForm(id: $id) {
    failReasons
  }
}
    `;
export type DeleteFormMutationFn = Apollo.MutationFunction<DeleteFormMutation, DeleteFormMutationVariables>;

/**
 * __useDeleteFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormMutation, { data, loading, error }] = useDeleteFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormMutation, DeleteFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormMutation, DeleteFormMutationVariables>(DeleteFormDocument, options);
      }
export type DeleteFormMutationHookResult = ReturnType<typeof useDeleteFormMutation>;
export type DeleteFormMutationResult = Apollo.MutationResult<DeleteFormMutation>;
export type DeleteFormMutationOptions = Apollo.BaseMutationOptions<DeleteFormMutation, DeleteFormMutationVariables>;
export const PublishFormDocument = gql`
    mutation PublishForm($id: ID!) {
  publishForm(id: $id) {
    record {
      title
      description
    }
    failReasons
  }
}
    `;
export type PublishFormMutationFn = Apollo.MutationFunction<PublishFormMutation, PublishFormMutationVariables>;

/**
 * __usePublishFormMutation__
 *
 * To run a mutation, you first call `usePublishFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishFormMutation, { data, loading, error }] = usePublishFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishFormMutation(baseOptions?: Apollo.MutationHookOptions<PublishFormMutation, PublishFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishFormMutation, PublishFormMutationVariables>(PublishFormDocument, options);
      }
export type PublishFormMutationHookResult = ReturnType<typeof usePublishFormMutation>;
export type PublishFormMutationResult = Apollo.MutationResult<PublishFormMutation>;
export type PublishFormMutationOptions = Apollo.BaseMutationOptions<PublishFormMutation, PublishFormMutationVariables>;
export const UpdateFormDocument = gql`
    mutation UpdateForm($id: ID!, $title: String!, $description: String) {
  result: updateForm(id: $id, title: $title, description: $description) {
    record {
      id
    }
    failReasons
  }
}
    `;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(UpdateFormDocument, options);
      }
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const UpdateFormConfirmationSettingsDocument = gql`
    mutation UpdateFormConfirmationSettings($id: ID!, $confirmationPageSettings: ConfirmationPageSettingsInput!) {
  result: updateFormConfirmationSettings(
    id: $id
    confirmationPageSettings: $confirmationPageSettings
  ) {
    failReasons
  }
}
    `;
export type UpdateFormConfirmationSettingsMutationFn = Apollo.MutationFunction<UpdateFormConfirmationSettingsMutation, UpdateFormConfirmationSettingsMutationVariables>;

/**
 * __useUpdateFormConfirmationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFormConfirmationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormConfirmationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormConfirmationSettingsMutation, { data, loading, error }] = useUpdateFormConfirmationSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      confirmationPageSettings: // value for 'confirmationPageSettings'
 *   },
 * });
 */
export function useUpdateFormConfirmationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormConfirmationSettingsMutation, UpdateFormConfirmationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormConfirmationSettingsMutation, UpdateFormConfirmationSettingsMutationVariables>(UpdateFormConfirmationSettingsDocument, options);
      }
export type UpdateFormConfirmationSettingsMutationHookResult = ReturnType<typeof useUpdateFormConfirmationSettingsMutation>;
export type UpdateFormConfirmationSettingsMutationResult = Apollo.MutationResult<UpdateFormConfirmationSettingsMutation>;
export type UpdateFormConfirmationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateFormConfirmationSettingsMutation, UpdateFormConfirmationSettingsMutationVariables>;
export const UpdateFormInfoDocument = gql`
    mutation UpdateFormInfo($id: ID!, $title: String!, $description: String, $elements: [FormElementInput!], $confirmationPageSettings: ConfirmationPageSettingsInput) {
  result: updateFormInfo(
    id: $id
    title: $title
    description: $description
    elements: $elements
    confirmationPageSettings: $confirmationPageSettings
  ) {
    record {
      id
    }
    failReasons
  }
}
    `;
export type UpdateFormInfoMutationFn = Apollo.MutationFunction<UpdateFormInfoMutation, UpdateFormInfoMutationVariables>;

/**
 * __useUpdateFormInfoMutation__
 *
 * To run a mutation, you first call `useUpdateFormInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormInfoMutation, { data, loading, error }] = useUpdateFormInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      elements: // value for 'elements'
 *      confirmationPageSettings: // value for 'confirmationPageSettings'
 *   },
 * });
 */
export function useUpdateFormInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormInfoMutation, UpdateFormInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormInfoMutation, UpdateFormInfoMutationVariables>(UpdateFormInfoDocument, options);
      }
export type UpdateFormInfoMutationHookResult = ReturnType<typeof useUpdateFormInfoMutation>;
export type UpdateFormInfoMutationResult = Apollo.MutationResult<UpdateFormInfoMutation>;
export type UpdateFormInfoMutationOptions = Apollo.BaseMutationOptions<UpdateFormInfoMutation, UpdateFormInfoMutationVariables>;
export const UpdateFormKeyActivitySettingsDocument = gql`
    mutation UpdateFormKeyActivitySettings($id: ID!, $keyActivitySettings: KeyActivitySettingsInput!) {
  result: updateFormKeyActivitySettings(
    id: $id
    keyActivitySettings: $keyActivitySettings
  ) {
    failReasons
  }
}
    `;
export type UpdateFormKeyActivitySettingsMutationFn = Apollo.MutationFunction<UpdateFormKeyActivitySettingsMutation, UpdateFormKeyActivitySettingsMutationVariables>;

/**
 * __useUpdateFormKeyActivitySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFormKeyActivitySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormKeyActivitySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormKeyActivitySettingsMutation, { data, loading, error }] = useUpdateFormKeyActivitySettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      keyActivitySettings: // value for 'keyActivitySettings'
 *   },
 * });
 */
export function useUpdateFormKeyActivitySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormKeyActivitySettingsMutation, UpdateFormKeyActivitySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormKeyActivitySettingsMutation, UpdateFormKeyActivitySettingsMutationVariables>(UpdateFormKeyActivitySettingsDocument, options);
      }
export type UpdateFormKeyActivitySettingsMutationHookResult = ReturnType<typeof useUpdateFormKeyActivitySettingsMutation>;
export type UpdateFormKeyActivitySettingsMutationResult = Apollo.MutationResult<UpdateFormKeyActivitySettingsMutation>;
export type UpdateFormKeyActivitySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateFormKeyActivitySettingsMutation, UpdateFormKeyActivitySettingsMutationVariables>;
export const UpdateFormSettingsDocument = gql`
    mutation UpdateFormSettings($id: ID!, $includeDefaultFooter: Boolean, $setConsentToGiven: Boolean!) {
  result: updateFormSettings(
    id: $id
    setConsentToGiven: $setConsentToGiven
    includeDefaultFooter: $includeDefaultFooter
  ) {
    failReasons
  }
}
    `;
export type UpdateFormSettingsMutationFn = Apollo.MutationFunction<UpdateFormSettingsMutation, UpdateFormSettingsMutationVariables>;

/**
 * __useUpdateFormSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFormSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormSettingsMutation, { data, loading, error }] = useUpdateFormSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      includeDefaultFooter: // value for 'includeDefaultFooter'
 *      setConsentToGiven: // value for 'setConsentToGiven'
 *   },
 * });
 */
export function useUpdateFormSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormSettingsMutation, UpdateFormSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormSettingsMutation, UpdateFormSettingsMutationVariables>(UpdateFormSettingsDocument, options);
      }
export type UpdateFormSettingsMutationHookResult = ReturnType<typeof useUpdateFormSettingsMutation>;
export type UpdateFormSettingsMutationResult = Apollo.MutationResult<UpdateFormSettingsMutation>;
export type UpdateFormSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateFormSettingsMutation, UpdateFormSettingsMutationVariables>;
export const UpdateFormThemeSettingsDocument = gql`
    mutation UpdateFormThemeSettings($id: ID!, $includeDefaultFooter: Boolean, $setConsentToGiven: Boolean!, $disableRecaptcha: Boolean) {
  result: updateFormSettings(
    id: $id
    setConsentToGiven: $setConsentToGiven
    includeDefaultFooter: $includeDefaultFooter
    disableRecaptcha: $disableRecaptcha
  ) {
    failReasons
    updatedForm {
      id
      setConsentToGiven
      includeDefaultFooter
      disableRecaptcha
      status
    }
  }
}
    `;
export type UpdateFormThemeSettingsMutationFn = Apollo.MutationFunction<UpdateFormThemeSettingsMutation, UpdateFormThemeSettingsMutationVariables>;

/**
 * __useUpdateFormThemeSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFormThemeSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormThemeSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormThemeSettingsMutation, { data, loading, error }] = useUpdateFormThemeSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      includeDefaultFooter: // value for 'includeDefaultFooter'
 *      setConsentToGiven: // value for 'setConsentToGiven'
 *      disableRecaptcha: // value for 'disableRecaptcha'
 *   },
 * });
 */
export function useUpdateFormThemeSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormThemeSettingsMutation, UpdateFormThemeSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormThemeSettingsMutation, UpdateFormThemeSettingsMutationVariables>(UpdateFormThemeSettingsDocument, options);
      }
export type UpdateFormThemeSettingsMutationHookResult = ReturnType<typeof useUpdateFormThemeSettingsMutation>;
export type UpdateFormThemeSettingsMutationResult = Apollo.MutationResult<UpdateFormThemeSettingsMutation>;
export type UpdateFormThemeSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateFormThemeSettingsMutation, UpdateFormThemeSettingsMutationVariables>;
export const DeleteThemeCoverImageForFormDocument = gql`
    mutation DeleteThemeCoverImageForForm($formUid: ID!) {
  deleteThemeCoverImageForForm(formUid: $formUid) {
    failReasons
    form {
      id
      status
      theme {
        id
        coverImage {
          url
        }
      }
    }
  }
}
    `;
export type DeleteThemeCoverImageForFormMutationFn = Apollo.MutationFunction<DeleteThemeCoverImageForFormMutation, DeleteThemeCoverImageForFormMutationVariables>;

/**
 * __useDeleteThemeCoverImageForFormMutation__
 *
 * To run a mutation, you first call `useDeleteThemeCoverImageForFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThemeCoverImageForFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThemeCoverImageForFormMutation, { data, loading, error }] = useDeleteThemeCoverImageForFormMutation({
 *   variables: {
 *      formUid: // value for 'formUid'
 *   },
 * });
 */
export function useDeleteThemeCoverImageForFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThemeCoverImageForFormMutation, DeleteThemeCoverImageForFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThemeCoverImageForFormMutation, DeleteThemeCoverImageForFormMutationVariables>(DeleteThemeCoverImageForFormDocument, options);
      }
export type DeleteThemeCoverImageForFormMutationHookResult = ReturnType<typeof useDeleteThemeCoverImageForFormMutation>;
export type DeleteThemeCoverImageForFormMutationResult = Apollo.MutationResult<DeleteThemeCoverImageForFormMutation>;
export type DeleteThemeCoverImageForFormMutationOptions = Apollo.BaseMutationOptions<DeleteThemeCoverImageForFormMutation, DeleteThemeCoverImageForFormMutationVariables>;
export const UpdateThemeForFormDocument = gql`
    mutation UpdateThemeForForm($formUid: ID!, $settings: FormThemeSettingsInput!) {
  updateThemeForForm(formUid: $formUid, settings: $settings) {
    failReasons
    form {
      id
      status
      theme {
        id
        coverImage {
          url
        }
      }
    }
  }
}
    `;
export type UpdateThemeForFormMutationFn = Apollo.MutationFunction<UpdateThemeForFormMutation, UpdateThemeForFormMutationVariables>;

/**
 * __useUpdateThemeForFormMutation__
 *
 * To run a mutation, you first call `useUpdateThemeForFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemeForFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemeForFormMutation, { data, loading, error }] = useUpdateThemeForFormMutation({
 *   variables: {
 *      formUid: // value for 'formUid'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateThemeForFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThemeForFormMutation, UpdateThemeForFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThemeForFormMutation, UpdateThemeForFormMutationVariables>(UpdateThemeForFormDocument, options);
      }
export type UpdateThemeForFormMutationHookResult = ReturnType<typeof useUpdateThemeForFormMutation>;
export type UpdateThemeForFormMutationResult = Apollo.MutationResult<UpdateThemeForFormMutation>;
export type UpdateThemeForFormMutationOptions = Apollo.BaseMutationOptions<UpdateThemeForFormMutation, UpdateThemeForFormMutationVariables>;
export const CreateFormWorkflowDocument = gql`
    mutation CreateFormWorkflow($formUid: ID!, $taskType: WorkflowTask!, $listUid: ID, $campaignUid: ID, $conditions: [WorkflowConditionInput!], $userUids: [String!]) {
  createFormWorkflow(
    taskType: $taskType
    formUid: $formUid
    listUid: $listUid
    campaignUid: $campaignUid
    conditions: $conditions
    userUids: $userUids
  ) {
    failReasons
  }
}
    `;
export type CreateFormWorkflowMutationFn = Apollo.MutationFunction<CreateFormWorkflowMutation, CreateFormWorkflowMutationVariables>;

/**
 * __useCreateFormWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateFormWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormWorkflowMutation, { data, loading, error }] = useCreateFormWorkflowMutation({
 *   variables: {
 *      formUid: // value for 'formUid'
 *      taskType: // value for 'taskType'
 *      listUid: // value for 'listUid'
 *      campaignUid: // value for 'campaignUid'
 *      conditions: // value for 'conditions'
 *      userUids: // value for 'userUids'
 *   },
 * });
 */
export function useCreateFormWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormWorkflowMutation, CreateFormWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormWorkflowMutation, CreateFormWorkflowMutationVariables>(CreateFormWorkflowDocument, options);
      }
export type CreateFormWorkflowMutationHookResult = ReturnType<typeof useCreateFormWorkflowMutation>;
export type CreateFormWorkflowMutationResult = Apollo.MutationResult<CreateFormWorkflowMutation>;
export type CreateFormWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateFormWorkflowMutation, CreateFormWorkflowMutationVariables>;
export const DeleteFormWorkflowDocument = gql`
    mutation DeleteFormWorkflow($id: ID!) {
  deleteFormWorkflow(id: $id) {
    failReasons
  }
}
    `;
export type DeleteFormWorkflowMutationFn = Apollo.MutationFunction<DeleteFormWorkflowMutation, DeleteFormWorkflowMutationVariables>;

/**
 * __useDeleteFormWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteFormWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormWorkflowMutation, { data, loading, error }] = useDeleteFormWorkflowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormWorkflowMutation, DeleteFormWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormWorkflowMutation, DeleteFormWorkflowMutationVariables>(DeleteFormWorkflowDocument, options);
      }
export type DeleteFormWorkflowMutationHookResult = ReturnType<typeof useDeleteFormWorkflowMutation>;
export type DeleteFormWorkflowMutationResult = Apollo.MutationResult<DeleteFormWorkflowMutation>;
export type DeleteFormWorkflowMutationOptions = Apollo.BaseMutationOptions<DeleteFormWorkflowMutation, DeleteFormWorkflowMutationVariables>;
export const UpdateFormWorkflowDocument = gql`
    mutation UpdateFormWorkflow($id: ID!, $listUid: ID, $campaignUid: ID, $conditions: [WorkflowConditionInput!], $userUids: [String!]) {
  updateFormWorkflow(
    id: $id
    listUid: $listUid
    campaignUid: $campaignUid
    conditions: $conditions
    userUids: $userUids
  ) {
    failReasons
    workflow {
      ...WorkflowDetails
    }
  }
}
    ${WorkflowDetailsFragmentDoc}`;
export type UpdateFormWorkflowMutationFn = Apollo.MutationFunction<UpdateFormWorkflowMutation, UpdateFormWorkflowMutationVariables>;

/**
 * __useUpdateFormWorkflowMutation__
 *
 * To run a mutation, you first call `useUpdateFormWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormWorkflowMutation, { data, loading, error }] = useUpdateFormWorkflowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      listUid: // value for 'listUid'
 *      campaignUid: // value for 'campaignUid'
 *      conditions: // value for 'conditions'
 *      userUids: // value for 'userUids'
 *   },
 * });
 */
export function useUpdateFormWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormWorkflowMutation, UpdateFormWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormWorkflowMutation, UpdateFormWorkflowMutationVariables>(UpdateFormWorkflowDocument, options);
      }
export type UpdateFormWorkflowMutationHookResult = ReturnType<typeof useUpdateFormWorkflowMutation>;
export type UpdateFormWorkflowMutationResult = Apollo.MutationResult<UpdateFormWorkflowMutation>;
export type UpdateFormWorkflowMutationOptions = Apollo.BaseMutationOptions<UpdateFormWorkflowMutation, UpdateFormWorkflowMutationVariables>;
export const AddKeyActivityToListDocument = gql`
    mutation AddKeyActivityToList($keyActivityUid: ID, $keyActivityListUid: ID) {
  addKeyActivityToList(
    keyActivityUid: $keyActivityUid
    keyActivityListUid: $keyActivityListUid
  ) {
    failReasons
    record {
      ...KeyActivityListMember
    }
  }
}
    ${KeyActivityListMemberFragmentDoc}`;
export type AddKeyActivityToListMutationFn = Apollo.MutationFunction<AddKeyActivityToListMutation, AddKeyActivityToListMutationVariables>;

/**
 * __useAddKeyActivityToListMutation__
 *
 * To run a mutation, you first call `useAddKeyActivityToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddKeyActivityToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addKeyActivityToListMutation, { data, loading, error }] = useAddKeyActivityToListMutation({
 *   variables: {
 *      keyActivityUid: // value for 'keyActivityUid'
 *      keyActivityListUid: // value for 'keyActivityListUid'
 *   },
 * });
 */
export function useAddKeyActivityToListMutation(baseOptions?: Apollo.MutationHookOptions<AddKeyActivityToListMutation, AddKeyActivityToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddKeyActivityToListMutation, AddKeyActivityToListMutationVariables>(AddKeyActivityToListDocument, options);
      }
export type AddKeyActivityToListMutationHookResult = ReturnType<typeof useAddKeyActivityToListMutation>;
export type AddKeyActivityToListMutationResult = Apollo.MutationResult<AddKeyActivityToListMutation>;
export type AddKeyActivityToListMutationOptions = Apollo.BaseMutationOptions<AddKeyActivityToListMutation, AddKeyActivityToListMutationVariables>;
export const KeyActivityListMembersDocument = gql`
    query KeyActivityListMembers($keyActivityListUid: ID, $page: Int, $perPage: Int) {
  keyActivityListMembers(
    keyActivityListUid: $keyActivityListUid
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...KeyActivityListMember
    }
  }
}
    ${KeyActivityListMemberFragmentDoc}`;

/**
 * __useKeyActivityListMembersQuery__
 *
 * To run a query within a React component, call `useKeyActivityListMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityListMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityListMembersQuery({
 *   variables: {
 *      keyActivityListUid: // value for 'keyActivityListUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useKeyActivityListMembersQuery(baseOptions?: Apollo.QueryHookOptions<KeyActivityListMembersQuery, KeyActivityListMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityListMembersQuery, KeyActivityListMembersQueryVariables>(KeyActivityListMembersDocument, options);
      }
export function useKeyActivityListMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityListMembersQuery, KeyActivityListMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityListMembersQuery, KeyActivityListMembersQueryVariables>(KeyActivityListMembersDocument, options);
        }
export type KeyActivityListMembersQueryHookResult = ReturnType<typeof useKeyActivityListMembersQuery>;
export type KeyActivityListMembersLazyQueryHookResult = ReturnType<typeof useKeyActivityListMembersLazyQuery>;
export type KeyActivityListMembersQueryResult = Apollo.QueryResult<KeyActivityListMembersQuery, KeyActivityListMembersQueryVariables>;
export const KeyActivityListMembersTotalDocument = gql`
    query KeyActivityListMembersTotal($keyActivityListUid: ID) {
  keyActivityListMembers(keyActivityListUid: $keyActivityListUid) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useKeyActivityListMembersTotalQuery__
 *
 * To run a query within a React component, call `useKeyActivityListMembersTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityListMembersTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityListMembersTotalQuery({
 *   variables: {
 *      keyActivityListUid: // value for 'keyActivityListUid'
 *   },
 * });
 */
export function useKeyActivityListMembersTotalQuery(baseOptions?: Apollo.QueryHookOptions<KeyActivityListMembersTotalQuery, KeyActivityListMembersTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityListMembersTotalQuery, KeyActivityListMembersTotalQueryVariables>(KeyActivityListMembersTotalDocument, options);
      }
export function useKeyActivityListMembersTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityListMembersTotalQuery, KeyActivityListMembersTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityListMembersTotalQuery, KeyActivityListMembersTotalQueryVariables>(KeyActivityListMembersTotalDocument, options);
        }
export type KeyActivityListMembersTotalQueryHookResult = ReturnType<typeof useKeyActivityListMembersTotalQuery>;
export type KeyActivityListMembersTotalLazyQueryHookResult = ReturnType<typeof useKeyActivityListMembersTotalLazyQuery>;
export type KeyActivityListMembersTotalQueryResult = Apollo.QueryResult<KeyActivityListMembersTotalQuery, KeyActivityListMembersTotalQueryVariables>;
export const KeyActivityMeetingOrEmailActionsCellRendererDocument = gql`
    query KeyActivityMeetingOrEmailActionsCellRenderer($sourceReferenceId: String!) {
  keyActivity(sourceReferenceId: $sourceReferenceId) {
    id
    calendarMeeting {
      id
    }
    interaction {
      id
      interactionType
    }
  }
}
    `;

/**
 * __useKeyActivityMeetingOrEmailActionsCellRendererQuery__
 *
 * To run a query within a React component, call `useKeyActivityMeetingOrEmailActionsCellRendererQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityMeetingOrEmailActionsCellRendererQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityMeetingOrEmailActionsCellRendererQuery({
 *   variables: {
 *      sourceReferenceId: // value for 'sourceReferenceId'
 *   },
 * });
 */
export function useKeyActivityMeetingOrEmailActionsCellRendererQuery(baseOptions: Apollo.QueryHookOptions<KeyActivityMeetingOrEmailActionsCellRendererQuery, KeyActivityMeetingOrEmailActionsCellRendererQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityMeetingOrEmailActionsCellRendererQuery, KeyActivityMeetingOrEmailActionsCellRendererQueryVariables>(KeyActivityMeetingOrEmailActionsCellRendererDocument, options);
      }
export function useKeyActivityMeetingOrEmailActionsCellRendererLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityMeetingOrEmailActionsCellRendererQuery, KeyActivityMeetingOrEmailActionsCellRendererQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityMeetingOrEmailActionsCellRendererQuery, KeyActivityMeetingOrEmailActionsCellRendererQueryVariables>(KeyActivityMeetingOrEmailActionsCellRendererDocument, options);
        }
export type KeyActivityMeetingOrEmailActionsCellRendererQueryHookResult = ReturnType<typeof useKeyActivityMeetingOrEmailActionsCellRendererQuery>;
export type KeyActivityMeetingOrEmailActionsCellRendererLazyQueryHookResult = ReturnType<typeof useKeyActivityMeetingOrEmailActionsCellRendererLazyQuery>;
export type KeyActivityMeetingOrEmailActionsCellRendererQueryResult = Apollo.QueryResult<KeyActivityMeetingOrEmailActionsCellRendererQuery, KeyActivityMeetingOrEmailActionsCellRendererQueryVariables>;
export const RemoveKeyActivityFromListDocument = gql`
    mutation RemoveKeyActivityFromList($keyActivityMemberUid: ID!) {
  removeKeyActivityMember(memberUid: $keyActivityMemberUid) {
    failReasons
    member {
      id
      isPersisted
    }
  }
}
    `;
export type RemoveKeyActivityFromListMutationFn = Apollo.MutationFunction<RemoveKeyActivityFromListMutation, RemoveKeyActivityFromListMutationVariables>;

/**
 * __useRemoveKeyActivityFromListMutation__
 *
 * To run a mutation, you first call `useRemoveKeyActivityFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveKeyActivityFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeKeyActivityFromListMutation, { data, loading, error }] = useRemoveKeyActivityFromListMutation({
 *   variables: {
 *      keyActivityMemberUid: // value for 'keyActivityMemberUid'
 *   },
 * });
 */
export function useRemoveKeyActivityFromListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveKeyActivityFromListMutation, RemoveKeyActivityFromListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveKeyActivityFromListMutation, RemoveKeyActivityFromListMutationVariables>(RemoveKeyActivityFromListDocument, options);
      }
export type RemoveKeyActivityFromListMutationHookResult = ReturnType<typeof useRemoveKeyActivityFromListMutation>;
export type RemoveKeyActivityFromListMutationResult = Apollo.MutationResult<RemoveKeyActivityFromListMutation>;
export type RemoveKeyActivityFromListMutationOptions = Apollo.BaseMutationOptions<RemoveKeyActivityFromListMutation, RemoveKeyActivityFromListMutationVariables>;
export const ListAutocompleteOptionsDocument = gql`
    query ListAutocompleteOptions($term: String) {
  myLists(term: $term, listType: CONTACT_LIST) {
    entries {
      ...ListAutocompleteOption
    }
  }
}
    ${ListAutocompleteOptionFragmentDoc}`;

/**
 * __useListAutocompleteOptionsQuery__
 *
 * To run a query within a React component, call `useListAutocompleteOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAutocompleteOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAutocompleteOptionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useListAutocompleteOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ListAutocompleteOptionsQuery, ListAutocompleteOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAutocompleteOptionsQuery, ListAutocompleteOptionsQueryVariables>(ListAutocompleteOptionsDocument, options);
      }
export function useListAutocompleteOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAutocompleteOptionsQuery, ListAutocompleteOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAutocompleteOptionsQuery, ListAutocompleteOptionsQueryVariables>(ListAutocompleteOptionsDocument, options);
        }
export type ListAutocompleteOptionsQueryHookResult = ReturnType<typeof useListAutocompleteOptionsQuery>;
export type ListAutocompleteOptionsLazyQueryHookResult = ReturnType<typeof useListAutocompleteOptionsLazyQuery>;
export type ListAutocompleteOptionsQueryResult = Apollo.QueryResult<ListAutocompleteOptionsQuery, ListAutocompleteOptionsQueryVariables>;
export const ListAutocompleteValueByIdsDocument = gql`
    query ListAutocompleteValueByIds($myListUids: [String!]!) {
  multiMyContactList(myListUids: $myListUids) {
    entries {
      ...ListAutocompleteOption
    }
  }
}
    ${ListAutocompleteOptionFragmentDoc}`;

/**
 * __useListAutocompleteValueByIdsQuery__
 *
 * To run a query within a React component, call `useListAutocompleteValueByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAutocompleteValueByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAutocompleteValueByIdsQuery({
 *   variables: {
 *      myListUids: // value for 'myListUids'
 *   },
 * });
 */
export function useListAutocompleteValueByIdsQuery(baseOptions: Apollo.QueryHookOptions<ListAutocompleteValueByIdsQuery, ListAutocompleteValueByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAutocompleteValueByIdsQuery, ListAutocompleteValueByIdsQueryVariables>(ListAutocompleteValueByIdsDocument, options);
      }
export function useListAutocompleteValueByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAutocompleteValueByIdsQuery, ListAutocompleteValueByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAutocompleteValueByIdsQuery, ListAutocompleteValueByIdsQueryVariables>(ListAutocompleteValueByIdsDocument, options);
        }
export type ListAutocompleteValueByIdsQueryHookResult = ReturnType<typeof useListAutocompleteValueByIdsQuery>;
export type ListAutocompleteValueByIdsLazyQueryHookResult = ReturnType<typeof useListAutocompleteValueByIdsLazyQuery>;
export type ListAutocompleteValueByIdsQueryResult = Apollo.QueryResult<ListAutocompleteValueByIdsQuery, ListAutocompleteValueByIdsQueryVariables>;
export const BulkRemoveCleanedMembersDocument = gql`
    mutation BulkRemoveCleanedMembers($contactListUid: ID!, $filter: VerificationFilterInput!) {
  bulkRemoveContactListCleanedMembers(
    contactListUid: $contactListUid
    filter: $filter
  ) {
    failReasons
  }
}
    `;
export type BulkRemoveCleanedMembersMutationFn = Apollo.MutationFunction<BulkRemoveCleanedMembersMutation, BulkRemoveCleanedMembersMutationVariables>;

/**
 * __useBulkRemoveCleanedMembersMutation__
 *
 * To run a mutation, you first call `useBulkRemoveCleanedMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveCleanedMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveCleanedMembersMutation, { data, loading, error }] = useBulkRemoveCleanedMembersMutation({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBulkRemoveCleanedMembersMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveCleanedMembersMutation, BulkRemoveCleanedMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveCleanedMembersMutation, BulkRemoveCleanedMembersMutationVariables>(BulkRemoveCleanedMembersDocument, options);
      }
export type BulkRemoveCleanedMembersMutationHookResult = ReturnType<typeof useBulkRemoveCleanedMembersMutation>;
export type BulkRemoveCleanedMembersMutationResult = Apollo.MutationResult<BulkRemoveCleanedMembersMutation>;
export type BulkRemoveCleanedMembersMutationOptions = Apollo.BaseMutationOptions<BulkRemoveCleanedMembersMutation, BulkRemoveCleanedMembersMutationVariables>;
export const BulkRemoveFromListDocument = gql`
    mutation BulkRemoveFromList($uid: ID!, $listMemberUids: [ID!]!) {
  bulkRemoveListMember(uid: $uid, listMemberUids: $listMemberUids) {
    failReasons
  }
}
    `;
export type BulkRemoveFromListMutationFn = Apollo.MutationFunction<BulkRemoveFromListMutation, BulkRemoveFromListMutationVariables>;

/**
 * __useBulkRemoveFromListMutation__
 *
 * To run a mutation, you first call `useBulkRemoveFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveFromListMutation, { data, loading, error }] = useBulkRemoveFromListMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      listMemberUids: // value for 'listMemberUids'
 *   },
 * });
 */
export function useBulkRemoveFromListMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveFromListMutation, BulkRemoveFromListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveFromListMutation, BulkRemoveFromListMutationVariables>(BulkRemoveFromListDocument, options);
      }
export type BulkRemoveFromListMutationHookResult = ReturnType<typeof useBulkRemoveFromListMutation>;
export type BulkRemoveFromListMutationResult = Apollo.MutationResult<BulkRemoveFromListMutation>;
export type BulkRemoveFromListMutationOptions = Apollo.BaseMutationOptions<BulkRemoveFromListMutation, BulkRemoveFromListMutationVariables>;
export const ListCleanStatusDocument = gql`
    query ListCleanStatus($uid: ID!) {
  list(uid: $uid) {
    id
    clean {
      id
      status
    }
  }
}
    `;

/**
 * __useListCleanStatusQuery__
 *
 * To run a query within a React component, call `useListCleanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCleanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCleanStatusQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useListCleanStatusQuery(baseOptions: Apollo.QueryHookOptions<ListCleanStatusQuery, ListCleanStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCleanStatusQuery, ListCleanStatusQueryVariables>(ListCleanStatusDocument, options);
      }
export function useListCleanStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCleanStatusQuery, ListCleanStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCleanStatusQuery, ListCleanStatusQueryVariables>(ListCleanStatusDocument, options);
        }
export type ListCleanStatusQueryHookResult = ReturnType<typeof useListCleanStatusQuery>;
export type ListCleanStatusLazyQueryHookResult = ReturnType<typeof useListCleanStatusLazyQuery>;
export type ListCleanStatusQueryResult = Apollo.QueryResult<ListCleanStatusQuery, ListCleanStatusQueryVariables>;
export const ListCleanerDocument = gql`
    query ListCleaner($contactListUid: ID!, $page: Int, $perPage: Int, $filter: VerificationFilterInput) {
  listCleaner(
    contactListUid: $contactListUid
    page: $page
    perPage: $perPage
    filter: $filter
  ) {
    entries {
      ...ListCleaner
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ListCleanerFragmentDoc}`;

/**
 * __useListCleanerQuery__
 *
 * To run a query within a React component, call `useListCleanerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCleanerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCleanerQuery({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListCleanerQuery(baseOptions: Apollo.QueryHookOptions<ListCleanerQuery, ListCleanerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCleanerQuery, ListCleanerQueryVariables>(ListCleanerDocument, options);
      }
export function useListCleanerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCleanerQuery, ListCleanerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCleanerQuery, ListCleanerQueryVariables>(ListCleanerDocument, options);
        }
export type ListCleanerQueryHookResult = ReturnType<typeof useListCleanerQuery>;
export type ListCleanerLazyQueryHookResult = ReturnType<typeof useListCleanerLazyQuery>;
export type ListCleanerQueryResult = Apollo.QueryResult<ListCleanerQuery, ListCleanerQueryVariables>;
export const ListCleanerHeaderDocument = gql`
    query ListCleanerHeader($uid: ID!) {
  list(uid: $uid) {
    ...ListCleanerHeader
  }
}
    ${ListCleanerHeaderFragmentDoc}`;

/**
 * __useListCleanerHeaderQuery__
 *
 * To run a query within a React component, call `useListCleanerHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCleanerHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCleanerHeaderQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useListCleanerHeaderQuery(baseOptions: Apollo.QueryHookOptions<ListCleanerHeaderQuery, ListCleanerHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCleanerHeaderQuery, ListCleanerHeaderQueryVariables>(ListCleanerHeaderDocument, options);
      }
export function useListCleanerHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCleanerHeaderQuery, ListCleanerHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCleanerHeaderQuery, ListCleanerHeaderQueryVariables>(ListCleanerHeaderDocument, options);
        }
export type ListCleanerHeaderQueryHookResult = ReturnType<typeof useListCleanerHeaderQuery>;
export type ListCleanerHeaderLazyQueryHookResult = ReturnType<typeof useListCleanerHeaderLazyQuery>;
export type ListCleanerHeaderQueryResult = Apollo.QueryResult<ListCleanerHeaderQuery, ListCleanerHeaderQueryVariables>;
export const ListCleanerInfoDocument = gql`
    query ListCleanerInfo($contactListUid: ID!) {
  listCleaner(contactListUid: $contactListUid) {
    clean {
      ...ListCleanerInfo
    }
  }
}
    ${ListCleanerInfoFragmentDoc}`;

/**
 * __useListCleanerInfoQuery__
 *
 * To run a query within a React component, call `useListCleanerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCleanerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCleanerInfoQuery({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *   },
 * });
 */
export function useListCleanerInfoQuery(baseOptions: Apollo.QueryHookOptions<ListCleanerInfoQuery, ListCleanerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCleanerInfoQuery, ListCleanerInfoQueryVariables>(ListCleanerInfoDocument, options);
      }
export function useListCleanerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCleanerInfoQuery, ListCleanerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCleanerInfoQuery, ListCleanerInfoQueryVariables>(ListCleanerInfoDocument, options);
        }
export type ListCleanerInfoQueryHookResult = ReturnType<typeof useListCleanerInfoQuery>;
export type ListCleanerInfoLazyQueryHookResult = ReturnType<typeof useListCleanerInfoLazyQuery>;
export type ListCleanerInfoQueryResult = Apollo.QueryResult<ListCleanerInfoQuery, ListCleanerInfoQueryVariables>;
export const OverrideContactVerificationDocument = gql`
    mutation OverrideContactVerification($contactUid: ID!, $risk: VerificationRisk!) {
  listCleanerOverrideContactVerification(contactUid: $contactUid, risk: $risk) {
    failReasons
    verification {
      ...ListCleaner
    }
  }
}
    ${ListCleanerFragmentDoc}`;
export type OverrideContactVerificationMutationFn = Apollo.MutationFunction<OverrideContactVerificationMutation, OverrideContactVerificationMutationVariables>;

/**
 * __useOverrideContactVerificationMutation__
 *
 * To run a mutation, you first call `useOverrideContactVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideContactVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideContactVerificationMutation, { data, loading, error }] = useOverrideContactVerificationMutation({
 *   variables: {
 *      contactUid: // value for 'contactUid'
 *      risk: // value for 'risk'
 *   },
 * });
 */
export function useOverrideContactVerificationMutation(baseOptions?: Apollo.MutationHookOptions<OverrideContactVerificationMutation, OverrideContactVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideContactVerificationMutation, OverrideContactVerificationMutationVariables>(OverrideContactVerificationDocument, options);
      }
export type OverrideContactVerificationMutationHookResult = ReturnType<typeof useOverrideContactVerificationMutation>;
export type OverrideContactVerificationMutationResult = Apollo.MutationResult<OverrideContactVerificationMutation>;
export type OverrideContactVerificationMutationOptions = Apollo.BaseMutationOptions<OverrideContactVerificationMutation, OverrideContactVerificationMutationVariables>;
export const VerifyListDocument = gql`
    mutation VerifyList($contactListUid: ID!) {
  verifyList(contactListUid: $contactListUid) {
    failReasons
    clean {
      id
      status
    }
  }
}
    `;
export type VerifyListMutationFn = Apollo.MutationFunction<VerifyListMutation, VerifyListMutationVariables>;

/**
 * __useVerifyListMutation__
 *
 * To run a mutation, you first call `useVerifyListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyListMutation, { data, loading, error }] = useVerifyListMutation({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *   },
 * });
 */
export function useVerifyListMutation(baseOptions?: Apollo.MutationHookOptions<VerifyListMutation, VerifyListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyListMutation, VerifyListMutationVariables>(VerifyListDocument, options);
      }
export type VerifyListMutationHookResult = ReturnType<typeof useVerifyListMutation>;
export type VerifyListMutationResult = Apollo.MutationResult<VerifyListMutation>;
export type VerifyListMutationOptions = Apollo.BaseMutationOptions<VerifyListMutation, VerifyListMutationVariables>;
export const ListCleanerRiskFiltersDocument = gql`
    query ListCleanerRiskFilters($contactListUid: ID!, $contactStatus: VerificationContactStatus) {
  listCleaner(
    contactListUid: $contactListUid
    filter: {contactStatus: $contactStatus}
  ) {
    clean {
      ...ListCleanerRiskFilters
    }
  }
}
    ${ListCleanerRiskFiltersFragmentDoc}`;

/**
 * __useListCleanerRiskFiltersQuery__
 *
 * To run a query within a React component, call `useListCleanerRiskFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCleanerRiskFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCleanerRiskFiltersQuery({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *      contactStatus: // value for 'contactStatus'
 *   },
 * });
 */
export function useListCleanerRiskFiltersQuery(baseOptions: Apollo.QueryHookOptions<ListCleanerRiskFiltersQuery, ListCleanerRiskFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCleanerRiskFiltersQuery, ListCleanerRiskFiltersQueryVariables>(ListCleanerRiskFiltersDocument, options);
      }
export function useListCleanerRiskFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCleanerRiskFiltersQuery, ListCleanerRiskFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCleanerRiskFiltersQuery, ListCleanerRiskFiltersQueryVariables>(ListCleanerRiskFiltersDocument, options);
        }
export type ListCleanerRiskFiltersQueryHookResult = ReturnType<typeof useListCleanerRiskFiltersQuery>;
export type ListCleanerRiskFiltersLazyQueryHookResult = ReturnType<typeof useListCleanerRiskFiltersLazyQuery>;
export type ListCleanerRiskFiltersQueryResult = Apollo.QueryResult<ListCleanerRiskFiltersQuery, ListCleanerRiskFiltersQueryVariables>;
export const ContactsExistInListDocument = gql`
    query ContactsExistInList($contactUids: [String!]!, $listId: ID!) {
  contactsExistInList(listId: $listId, contactUids: $contactUids) {
    entries
  }
}
    `;

/**
 * __useContactsExistInListQuery__
 *
 * To run a query within a React component, call `useContactsExistInListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsExistInListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsExistInListQuery({
 *   variables: {
 *      contactUids: // value for 'contactUids'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useContactsExistInListQuery(baseOptions: Apollo.QueryHookOptions<ContactsExistInListQuery, ContactsExistInListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsExistInListQuery, ContactsExistInListQueryVariables>(ContactsExistInListDocument, options);
      }
export function useContactsExistInListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsExistInListQuery, ContactsExistInListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsExistInListQuery, ContactsExistInListQueryVariables>(ContactsExistInListDocument, options);
        }
export type ContactsExistInListQueryHookResult = ReturnType<typeof useContactsExistInListQuery>;
export type ContactsExistInListLazyQueryHookResult = ReturnType<typeof useContactsExistInListLazyQuery>;
export type ContactsExistInListQueryResult = Apollo.QueryResult<ContactsExistInListQuery, ContactsExistInListQueryVariables>;
export const ListMembersDocument = gql`
    query ListMembers($page: Int, $perPage: Int, $uid: ID!, $term: String, $orderBy: ListMembersOrderBy, $filter: ListMembersFilter) {
  listMembers: listMembers(
    uid: $uid
    page: $page
    perPage: $perPage
    term: $term
    orderBy: $orderBy
    filter: $filter
  ) {
    entries {
      ...ContactProjectListMemberRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactProjectListMemberRowFragmentDoc}`;

/**
 * __useListMembersQuery__
 *
 * To run a query within a React component, call `useListMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMembersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      uid: // value for 'uid'
 *      term: // value for 'term'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListMembersQuery(baseOptions: Apollo.QueryHookOptions<ListMembersQuery, ListMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMembersQuery, ListMembersQueryVariables>(ListMembersDocument, options);
      }
export function useListMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMembersQuery, ListMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMembersQuery, ListMembersQueryVariables>(ListMembersDocument, options);
        }
export type ListMembersQueryHookResult = ReturnType<typeof useListMembersQuery>;
export type ListMembersLazyQueryHookResult = ReturnType<typeof useListMembersLazyQuery>;
export type ListMembersQueryResult = Apollo.QueryResult<ListMembersQuery, ListMembersQueryVariables>;
export const ListMembersInContactsDocument = gql`
    query ListMembersInContacts($contactUids: [ID!]!, $uid: ID!, $perPage: Int) {
  listMembers(
    uid: $uid
    page: 1
    perPage: $perPage
    filter: {contactUidsNoDuplicates: $contactUids}
  ) {
    entries {
      contact {
        id
      }
    }
  }
}
    `;

/**
 * __useListMembersInContactsQuery__
 *
 * To run a query within a React component, call `useListMembersInContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMembersInContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMembersInContactsQuery({
 *   variables: {
 *      contactUids: // value for 'contactUids'
 *      uid: // value for 'uid'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useListMembersInContactsQuery(baseOptions: Apollo.QueryHookOptions<ListMembersInContactsQuery, ListMembersInContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMembersInContactsQuery, ListMembersInContactsQueryVariables>(ListMembersInContactsDocument, options);
      }
export function useListMembersInContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMembersInContactsQuery, ListMembersInContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMembersInContactsQuery, ListMembersInContactsQueryVariables>(ListMembersInContactsDocument, options);
        }
export type ListMembersInContactsQueryHookResult = ReturnType<typeof useListMembersInContactsQuery>;
export type ListMembersInContactsLazyQueryHookResult = ReturnType<typeof useListMembersInContactsLazyQuery>;
export type ListMembersInContactsQueryResult = Apollo.QueryResult<ListMembersInContactsQuery, ListMembersInContactsQueryVariables>;
export const ListMembersTotalDocument = gql`
    query ListMembersTotal($uid: ID!) {
  listMembers(uid: $uid, page: 1, perPage: 1) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useListMembersTotalQuery__
 *
 * To run a query within a React component, call `useListMembersTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMembersTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMembersTotalQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useListMembersTotalQuery(baseOptions: Apollo.QueryHookOptions<ListMembersTotalQuery, ListMembersTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMembersTotalQuery, ListMembersTotalQueryVariables>(ListMembersTotalDocument, options);
      }
export function useListMembersTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMembersTotalQuery, ListMembersTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMembersTotalQuery, ListMembersTotalQueryVariables>(ListMembersTotalDocument, options);
        }
export type ListMembersTotalQueryHookResult = ReturnType<typeof useListMembersTotalQuery>;
export type ListMembersTotalLazyQueryHookResult = ReturnType<typeof useListMembersTotalLazyQuery>;
export type ListMembersTotalQueryResult = Apollo.QueryResult<ListMembersTotalQuery, ListMembersTotalQueryVariables>;
export const ListMembershipDocument = gql`
    query ListMembership($contactEmail: ID!, $perPage: Int, $marketingListOnly: Boolean = false, $excludeHidden: Boolean) {
  listMembers(
    perPage: $perPage
    filter: {marketingListOnly: $marketingListOnly, contactUids: [$contactEmail], excludeHidden: $excludeHidden}
  ) {
    entries {
      memberId: id
      list {
        ...ListMembershipPreview
      }
    }
  }
}
    ${ListMembershipPreviewFragmentDoc}`;

/**
 * __useListMembershipQuery__
 *
 * To run a query within a React component, call `useListMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMembershipQuery({
 *   variables: {
 *      contactEmail: // value for 'contactEmail'
 *      perPage: // value for 'perPage'
 *      marketingListOnly: // value for 'marketingListOnly'
 *      excludeHidden: // value for 'excludeHidden'
 *   },
 * });
 */
export function useListMembershipQuery(baseOptions: Apollo.QueryHookOptions<ListMembershipQuery, ListMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMembershipQuery, ListMembershipQueryVariables>(ListMembershipDocument, options);
      }
export function useListMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMembershipQuery, ListMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMembershipQuery, ListMembershipQueryVariables>(ListMembershipDocument, options);
        }
export type ListMembershipQueryHookResult = ReturnType<typeof useListMembershipQuery>;
export type ListMembershipLazyQueryHookResult = ReturnType<typeof useListMembershipLazyQuery>;
export type ListMembershipQueryResult = Apollo.QueryResult<ListMembershipQuery, ListMembershipQueryVariables>;
export const CreateListViewDocument = gql`
    mutation CreateListView($listUid: ID!, $name: String!, $viewType: ListViewType!, $renderMode: ListViewRenderMode, $schemaUid: ID) {
  createListView(
    attributes: {listUid: $listUid, name: $name, viewType: $viewType, schemaUid: $schemaUid, renderMode: $renderMode, columnStateConfiguration: {scope: COLUMN_STATE, configuration: ""}, filterModelConfiguration: {scope: FILTER_MODEL, configuration: ""}, searchStateConfiguration: {scope: SEARCH_STATE, configuration: ""}}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type CreateListViewMutationFn = Apollo.MutationFunction<CreateListViewMutation, CreateListViewMutationVariables>;

/**
 * __useCreateListViewMutation__
 *
 * To run a mutation, you first call `useCreateListViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListViewMutation, { data, loading, error }] = useCreateListViewMutation({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      name: // value for 'name'
 *      viewType: // value for 'viewType'
 *      renderMode: // value for 'renderMode'
 *      schemaUid: // value for 'schemaUid'
 *   },
 * });
 */
export function useCreateListViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateListViewMutation, CreateListViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListViewMutation, CreateListViewMutationVariables>(CreateListViewDocument, options);
      }
export type CreateListViewMutationHookResult = ReturnType<typeof useCreateListViewMutation>;
export type CreateListViewMutationResult = Apollo.MutationResult<CreateListViewMutation>;
export type CreateListViewMutationOptions = Apollo.BaseMutationOptions<CreateListViewMutation, CreateListViewMutationVariables>;
export const DeleteListViewDocument = gql`
    mutation DeleteListView($listViewUid: ID!) {
  deleteListView(listViewUid: $listViewUid) {
    failReasons
  }
}
    `;
export type DeleteListViewMutationFn = Apollo.MutationFunction<DeleteListViewMutation, DeleteListViewMutationVariables>;

/**
 * __useDeleteListViewMutation__
 *
 * To run a mutation, you first call `useDeleteListViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListViewMutation, { data, loading, error }] = useDeleteListViewMutation({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *   },
 * });
 */
export function useDeleteListViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListViewMutation, DeleteListViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListViewMutation, DeleteListViewMutationVariables>(DeleteListViewDocument, options);
      }
export type DeleteListViewMutationHookResult = ReturnType<typeof useDeleteListViewMutation>;
export type DeleteListViewMutationResult = Apollo.MutationResult<DeleteListViewMutation>;
export type DeleteListViewMutationOptions = Apollo.BaseMutationOptions<DeleteListViewMutation, DeleteListViewMutationVariables>;
export const ListViewDocument = gql`
    query ListView($listViewUid: ID!) {
  listView(listViewUid: $listViewUid) {
    ...ListView
  }
}
    ${ListViewFragmentDoc}`;

/**
 * __useListViewQuery__
 *
 * To run a query within a React component, call `useListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListViewQuery({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *   },
 * });
 */
export function useListViewQuery(baseOptions: Apollo.QueryHookOptions<ListViewQuery, ListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListViewQuery, ListViewQueryVariables>(ListViewDocument, options);
      }
export function useListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListViewQuery, ListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListViewQuery, ListViewQueryVariables>(ListViewDocument, options);
        }
export type ListViewQueryHookResult = ReturnType<typeof useListViewQuery>;
export type ListViewLazyQueryHookResult = ReturnType<typeof useListViewLazyQuery>;
export type ListViewQueryResult = Apollo.QueryResult<ListViewQuery, ListViewQueryVariables>;
export const ListViewsDocument = gql`
    query ListViews($listUid: String!) {
  listViews(listUid: $listUid) {
    ...ListView
  }
}
    ${ListViewFragmentDoc}`;

/**
 * __useListViewsQuery__
 *
 * To run a query within a React component, call `useListViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListViewsQuery({
 *   variables: {
 *      listUid: // value for 'listUid'
 *   },
 * });
 */
export function useListViewsQuery(baseOptions: Apollo.QueryHookOptions<ListViewsQuery, ListViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListViewsQuery, ListViewsQueryVariables>(ListViewsDocument, options);
      }
export function useListViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListViewsQuery, ListViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListViewsQuery, ListViewsQueryVariables>(ListViewsDocument, options);
        }
export type ListViewsQueryHookResult = ReturnType<typeof useListViewsQuery>;
export type ListViewsLazyQueryHookResult = ReturnType<typeof useListViewsLazyQuery>;
export type ListViewsQueryResult = Apollo.QueryResult<ListViewsQuery, ListViewsQueryVariables>;
export const UpdateListViewColumnStateDocument = gql`
    mutation UpdateListViewColumnState($listViewUid: String!, $columnState: String!, $name: String!) {
  updateListView(
    listViewUid: $listViewUid
    attributes: {name: $name, columnStateConfiguration: {scope: COLUMN_STATE, configuration: $columnState}}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type UpdateListViewColumnStateMutationFn = Apollo.MutationFunction<UpdateListViewColumnStateMutation, UpdateListViewColumnStateMutationVariables>;

/**
 * __useUpdateListViewColumnStateMutation__
 *
 * To run a mutation, you first call `useUpdateListViewColumnStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListViewColumnStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListViewColumnStateMutation, { data, loading, error }] = useUpdateListViewColumnStateMutation({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *      columnState: // value for 'columnState'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateListViewColumnStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListViewColumnStateMutation, UpdateListViewColumnStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListViewColumnStateMutation, UpdateListViewColumnStateMutationVariables>(UpdateListViewColumnStateDocument, options);
      }
export type UpdateListViewColumnStateMutationHookResult = ReturnType<typeof useUpdateListViewColumnStateMutation>;
export type UpdateListViewColumnStateMutationResult = Apollo.MutationResult<UpdateListViewColumnStateMutation>;
export type UpdateListViewColumnStateMutationOptions = Apollo.BaseMutationOptions<UpdateListViewColumnStateMutation, UpdateListViewColumnStateMutationVariables>;
export const UpdateListViewFilterModelDocument = gql`
    mutation UpdateListViewFilterModel($listViewUid: String!, $filterModel: String!, $name: String!) {
  updateListView(
    listViewUid: $listViewUid
    attributes: {name: $name, filterModelConfiguration: {scope: FILTER_MODEL, configuration: $filterModel}}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type UpdateListViewFilterModelMutationFn = Apollo.MutationFunction<UpdateListViewFilterModelMutation, UpdateListViewFilterModelMutationVariables>;

/**
 * __useUpdateListViewFilterModelMutation__
 *
 * To run a mutation, you first call `useUpdateListViewFilterModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListViewFilterModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListViewFilterModelMutation, { data, loading, error }] = useUpdateListViewFilterModelMutation({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *      filterModel: // value for 'filterModel'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateListViewFilterModelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListViewFilterModelMutation, UpdateListViewFilterModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListViewFilterModelMutation, UpdateListViewFilterModelMutationVariables>(UpdateListViewFilterModelDocument, options);
      }
export type UpdateListViewFilterModelMutationHookResult = ReturnType<typeof useUpdateListViewFilterModelMutation>;
export type UpdateListViewFilterModelMutationResult = Apollo.MutationResult<UpdateListViewFilterModelMutation>;
export type UpdateListViewFilterModelMutationOptions = Apollo.BaseMutationOptions<UpdateListViewFilterModelMutation, UpdateListViewFilterModelMutationVariables>;
export const UpdateListViewInfoDocument = gql`
    mutation UpdateListViewInfo($listViewUid: String!, $name: String!, $schemaUid: ID) {
  updateListView(
    listViewUid: $listViewUid
    attributes: {name: $name, schemaUid: $schemaUid}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type UpdateListViewInfoMutationFn = Apollo.MutationFunction<UpdateListViewInfoMutation, UpdateListViewInfoMutationVariables>;

/**
 * __useUpdateListViewInfoMutation__
 *
 * To run a mutation, you first call `useUpdateListViewInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListViewInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListViewInfoMutation, { data, loading, error }] = useUpdateListViewInfoMutation({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *      name: // value for 'name'
 *      schemaUid: // value for 'schemaUid'
 *   },
 * });
 */
export function useUpdateListViewInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListViewInfoMutation, UpdateListViewInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListViewInfoMutation, UpdateListViewInfoMutationVariables>(UpdateListViewInfoDocument, options);
      }
export type UpdateListViewInfoMutationHookResult = ReturnType<typeof useUpdateListViewInfoMutation>;
export type UpdateListViewInfoMutationResult = Apollo.MutationResult<UpdateListViewInfoMutation>;
export type UpdateListViewInfoMutationOptions = Apollo.BaseMutationOptions<UpdateListViewInfoMutation, UpdateListViewInfoMutationVariables>;
export const UpdateListViewSearchStateDocument = gql`
    mutation UpdateListViewSearchState($listViewUid: String!, $searchState: String!, $name: String!) {
  updateListView(
    listViewUid: $listViewUid
    attributes: {name: $name, searchStateConfiguration: {scope: SEARCH_STATE, configuration: $searchState}}
  ) {
    failReasons
    listView {
      ...ListView
    }
  }
}
    ${ListViewFragmentDoc}`;
export type UpdateListViewSearchStateMutationFn = Apollo.MutationFunction<UpdateListViewSearchStateMutation, UpdateListViewSearchStateMutationVariables>;

/**
 * __useUpdateListViewSearchStateMutation__
 *
 * To run a mutation, you first call `useUpdateListViewSearchStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListViewSearchStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListViewSearchStateMutation, { data, loading, error }] = useUpdateListViewSearchStateMutation({
 *   variables: {
 *      listViewUid: // value for 'listViewUid'
 *      searchState: // value for 'searchState'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateListViewSearchStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListViewSearchStateMutation, UpdateListViewSearchStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListViewSearchStateMutation, UpdateListViewSearchStateMutationVariables>(UpdateListViewSearchStateDocument, options);
      }
export type UpdateListViewSearchStateMutationHookResult = ReturnType<typeof useUpdateListViewSearchStateMutation>;
export type UpdateListViewSearchStateMutationResult = Apollo.MutationResult<UpdateListViewSearchStateMutation>;
export type UpdateListViewSearchStateMutationOptions = Apollo.BaseMutationOptions<UpdateListViewSearchStateMutation, UpdateListViewSearchStateMutationVariables>;
export const RemovedHistoryPageDocument = gql`
    query RemovedHistoryPage($page: Int, $perPage: Int, $uid: ID!) {
  list(uid: $uid) {
    id
    name
  }
  listMembers(
    uid: $uid
    page: $page
    perPage: $perPage
    filter: {scope: REMOVED}
    orderBy: DISCARDED_AT_DESC
  ) {
    entries {
      ...RemovedHistoryRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${RemovedHistoryRowFragmentDoc}`;

/**
 * __useRemovedHistoryPageQuery__
 *
 * To run a query within a React component, call `useRemovedHistoryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemovedHistoryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemovedHistoryPageQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useRemovedHistoryPageQuery(baseOptions: Apollo.QueryHookOptions<RemovedHistoryPageQuery, RemovedHistoryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemovedHistoryPageQuery, RemovedHistoryPageQueryVariables>(RemovedHistoryPageDocument, options);
      }
export function useRemovedHistoryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemovedHistoryPageQuery, RemovedHistoryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemovedHistoryPageQuery, RemovedHistoryPageQueryVariables>(RemovedHistoryPageDocument, options);
        }
export type RemovedHistoryPageQueryHookResult = ReturnType<typeof useRemovedHistoryPageQuery>;
export type RemovedHistoryPageLazyQueryHookResult = ReturnType<typeof useRemovedHistoryPageLazyQuery>;
export type RemovedHistoryPageQueryResult = Apollo.QueryResult<RemovedHistoryPageQuery, RemovedHistoryPageQueryVariables>;
export const RestoreDiscardedListMembersDocument = gql`
    mutation RestoreDiscardedListMembers($listMemberUids: [ID!]!, $listUid: ID!) {
  restoreDiscardedListMembers(listMemberUids: $listMemberUids, listUid: $listUid) {
    failReasons
  }
}
    `;
export type RestoreDiscardedListMembersMutationFn = Apollo.MutationFunction<RestoreDiscardedListMembersMutation, RestoreDiscardedListMembersMutationVariables>;

/**
 * __useRestoreDiscardedListMembersMutation__
 *
 * To run a mutation, you first call `useRestoreDiscardedListMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDiscardedListMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDiscardedListMembersMutation, { data, loading, error }] = useRestoreDiscardedListMembersMutation({
 *   variables: {
 *      listMemberUids: // value for 'listMemberUids'
 *      listUid: // value for 'listUid'
 *   },
 * });
 */
export function useRestoreDiscardedListMembersMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDiscardedListMembersMutation, RestoreDiscardedListMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDiscardedListMembersMutation, RestoreDiscardedListMembersMutationVariables>(RestoreDiscardedListMembersDocument, options);
      }
export type RestoreDiscardedListMembersMutationHookResult = ReturnType<typeof useRestoreDiscardedListMembersMutation>;
export type RestoreDiscardedListMembersMutationResult = Apollo.MutationResult<RestoreDiscardedListMembersMutation>;
export type RestoreDiscardedListMembersMutationOptions = Apollo.BaseMutationOptions<RestoreDiscardedListMembersMutation, RestoreDiscardedListMembersMutationVariables>;
export const ShareListViewDocument = gql`
    mutation ShareListView($listUid: ID!, $sharedWithUids: [ID!]!, $listViewUid: ID, $permission: SharedListViewPermission!) {
  shareListView(
    listUid: $listUid
    sharedWithUids: $sharedWithUids
    listViewUid: $listViewUid
    permission: $permission
  ) {
    failReasons
  }
}
    `;
export type ShareListViewMutationFn = Apollo.MutationFunction<ShareListViewMutation, ShareListViewMutationVariables>;

/**
 * __useShareListViewMutation__
 *
 * To run a mutation, you first call `useShareListViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareListViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareListViewMutation, { data, loading, error }] = useShareListViewMutation({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      sharedWithUids: // value for 'sharedWithUids'
 *      listViewUid: // value for 'listViewUid'
 *      permission: // value for 'permission'
 *   },
 * });
 */
export function useShareListViewMutation(baseOptions?: Apollo.MutationHookOptions<ShareListViewMutation, ShareListViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareListViewMutation, ShareListViewMutationVariables>(ShareListViewDocument, options);
      }
export type ShareListViewMutationHookResult = ReturnType<typeof useShareListViewMutation>;
export type ShareListViewMutationResult = Apollo.MutationResult<ShareListViewMutation>;
export type ShareListViewMutationOptions = Apollo.BaseMutationOptions<ShareListViewMutation, ShareListViewMutationVariables>;
export const ShareListViewByInviteTabDocument = gql`
    query ShareListViewByInviteTab($uid: ID!) {
  tab(uid: $uid) {
    id
    isAppTab
    isWorkspaceTab
  }
}
    `;

/**
 * __useShareListViewByInviteTabQuery__
 *
 * To run a query within a React component, call `useShareListViewByInviteTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareListViewByInviteTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareListViewByInviteTabQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useShareListViewByInviteTabQuery(baseOptions: Apollo.QueryHookOptions<ShareListViewByInviteTabQuery, ShareListViewByInviteTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShareListViewByInviteTabQuery, ShareListViewByInviteTabQueryVariables>(ShareListViewByInviteTabDocument, options);
      }
export function useShareListViewByInviteTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShareListViewByInviteTabQuery, ShareListViewByInviteTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShareListViewByInviteTabQuery, ShareListViewByInviteTabQueryVariables>(ShareListViewByInviteTabDocument, options);
        }
export type ShareListViewByInviteTabQueryHookResult = ReturnType<typeof useShareListViewByInviteTabQuery>;
export type ShareListViewByInviteTabLazyQueryHookResult = ReturnType<typeof useShareListViewByInviteTabLazyQuery>;
export type ShareListViewByInviteTabQueryResult = Apollo.QueryResult<ShareListViewByInviteTabQuery, ShareListViewByInviteTabQueryVariables>;
export const UsersForSelectionDocument = gql`
    query UsersForSelection($term: String) {
  usersForSelection(page: 1, perPage: 1000, term: $term) {
    entries {
      ...UserForSelection
    }
  }
}
    ${UserForSelectionFragmentDoc}`;

/**
 * __useUsersForSelectionQuery__
 *
 * To run a query within a React component, call `useUsersForSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersForSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersForSelectionQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useUsersForSelectionQuery(baseOptions?: Apollo.QueryHookOptions<UsersForSelectionQuery, UsersForSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersForSelectionQuery, UsersForSelectionQueryVariables>(UsersForSelectionDocument, options);
      }
export function useUsersForSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersForSelectionQuery, UsersForSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersForSelectionQuery, UsersForSelectionQueryVariables>(UsersForSelectionDocument, options);
        }
export type UsersForSelectionQueryHookResult = ReturnType<typeof useUsersForSelectionQuery>;
export type UsersForSelectionLazyQueryHookResult = ReturnType<typeof useUsersForSelectionLazyQuery>;
export type UsersForSelectionQueryResult = Apollo.QueryResult<UsersForSelectionQuery, UsersForSelectionQueryVariables>;
export const UsersForSelectionByEmailDocument = gql`
    query UsersForSelectionByEmail($term: String, $emails: [String!]) {
  usersForSelection(page: 1, perPage: 1000, term: $term, emails: $emails) {
    entries {
      ...UserForSelection
    }
  }
}
    ${UserForSelectionFragmentDoc}`;

/**
 * __useUsersForSelectionByEmailQuery__
 *
 * To run a query within a React component, call `useUsersForSelectionByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersForSelectionByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersForSelectionByEmailQuery({
 *   variables: {
 *      term: // value for 'term'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useUsersForSelectionByEmailQuery(baseOptions?: Apollo.QueryHookOptions<UsersForSelectionByEmailQuery, UsersForSelectionByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersForSelectionByEmailQuery, UsersForSelectionByEmailQueryVariables>(UsersForSelectionByEmailDocument, options);
      }
export function useUsersForSelectionByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersForSelectionByEmailQuery, UsersForSelectionByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersForSelectionByEmailQuery, UsersForSelectionByEmailQueryVariables>(UsersForSelectionByEmailDocument, options);
        }
export type UsersForSelectionByEmailQueryHookResult = ReturnType<typeof useUsersForSelectionByEmailQuery>;
export type UsersForSelectionByEmailLazyQueryHookResult = ReturnType<typeof useUsersForSelectionByEmailLazyQuery>;
export type UsersForSelectionByEmailQueryResult = Apollo.QueryResult<UsersForSelectionByEmailQuery, UsersForSelectionByEmailQueryVariables>;
export const AddFilteredContactsToListTableDocument = gql`
    query AddFilteredContactsToListTable($page: Int, $perPage: Int, $filters: [ContactFilter!], $filter: ContactsFiltering, $orderBy: ContactsOrderBy) {
  contacts(
    page: $page
    perPage: $perPage
    filters: $filters
    filter: $filter
    orderBy: $orderBy
  ) {
    entries {
      ...ContactListRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactListRowFragmentDoc}`;

/**
 * __useAddFilteredContactsToListTableQuery__
 *
 * To run a query within a React component, call `useAddFilteredContactsToListTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddFilteredContactsToListTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddFilteredContactsToListTableQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAddFilteredContactsToListTableQuery(baseOptions?: Apollo.QueryHookOptions<AddFilteredContactsToListTableQuery, AddFilteredContactsToListTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddFilteredContactsToListTableQuery, AddFilteredContactsToListTableQueryVariables>(AddFilteredContactsToListTableDocument, options);
      }
export function useAddFilteredContactsToListTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddFilteredContactsToListTableQuery, AddFilteredContactsToListTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddFilteredContactsToListTableQuery, AddFilteredContactsToListTableQueryVariables>(AddFilteredContactsToListTableDocument, options);
        }
export type AddFilteredContactsToListTableQueryHookResult = ReturnType<typeof useAddFilteredContactsToListTableQuery>;
export type AddFilteredContactsToListTableLazyQueryHookResult = ReturnType<typeof useAddFilteredContactsToListTableLazyQuery>;
export type AddFilteredContactsToListTableQueryResult = Apollo.QueryResult<AddFilteredContactsToListTableQuery, AddFilteredContactsToListTableQueryVariables>;
export const AddCompanyToExclusionListDocument = gql`
    mutation AddCompanyToExclusionList($companyUid: ID!, $reason: String, $exclusionListCategories: [ListCategory!]!, $excludeEveryCategory: Boolean!, $exclusionType: ExclusionType) {
  addCompanyToExclusionList(
    companyUid: $companyUid
    reason: $reason
    exclusionListCategories: $exclusionListCategories
    excludeEveryCategory: $excludeEveryCategory
    exclusionType: $exclusionType
  ) {
    failReasons
    record {
      ...CompanyExclusionRow
    }
  }
}
    ${CompanyExclusionRowFragmentDoc}`;
export type AddCompanyToExclusionListMutationFn = Apollo.MutationFunction<AddCompanyToExclusionListMutation, AddCompanyToExclusionListMutationVariables>;

/**
 * __useAddCompanyToExclusionListMutation__
 *
 * To run a mutation, you first call `useAddCompanyToExclusionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyToExclusionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyToExclusionListMutation, { data, loading, error }] = useAddCompanyToExclusionListMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      reason: // value for 'reason'
 *      exclusionListCategories: // value for 'exclusionListCategories'
 *      excludeEveryCategory: // value for 'excludeEveryCategory'
 *      exclusionType: // value for 'exclusionType'
 *   },
 * });
 */
export function useAddCompanyToExclusionListMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyToExclusionListMutation, AddCompanyToExclusionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyToExclusionListMutation, AddCompanyToExclusionListMutationVariables>(AddCompanyToExclusionListDocument, options);
      }
export type AddCompanyToExclusionListMutationHookResult = ReturnType<typeof useAddCompanyToExclusionListMutation>;
export type AddCompanyToExclusionListMutationResult = Apollo.MutationResult<AddCompanyToExclusionListMutation>;
export type AddCompanyToExclusionListMutationOptions = Apollo.BaseMutationOptions<AddCompanyToExclusionListMutation, AddCompanyToExclusionListMutationVariables>;
export const CompanyExclusionListDocument = gql`
    query CompanyExclusionList($page: Int, $perPage: Int, $term: String) {
  companyExclusionList(page: $page, perPage: $perPage, term: $term) {
    entries {
      ...CompanyExclusionRow
    }
    pageInfo {
      totalEntries
      totalPages
    }
  }
}
    ${CompanyExclusionRowFragmentDoc}`;

/**
 * __useCompanyExclusionListQuery__
 *
 * To run a query within a React component, call `useCompanyExclusionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyExclusionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyExclusionListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useCompanyExclusionListQuery(baseOptions?: Apollo.QueryHookOptions<CompanyExclusionListQuery, CompanyExclusionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyExclusionListQuery, CompanyExclusionListQueryVariables>(CompanyExclusionListDocument, options);
      }
export function useCompanyExclusionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyExclusionListQuery, CompanyExclusionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyExclusionListQuery, CompanyExclusionListQueryVariables>(CompanyExclusionListDocument, options);
        }
export type CompanyExclusionListQueryHookResult = ReturnType<typeof useCompanyExclusionListQuery>;
export type CompanyExclusionListLazyQueryHookResult = ReturnType<typeof useCompanyExclusionListLazyQuery>;
export type CompanyExclusionListQueryResult = Apollo.QueryResult<CompanyExclusionListQuery, CompanyExclusionListQueryVariables>;
export const RemoveCompanyFromExclusionListDocument = gql`
    mutation RemoveCompanyFromExclusionList($companyExclusionUid: ID!) {
  removeCompanyFromExclusionList(companyExclusionUid: $companyExclusionUid) {
    failReasons
  }
}
    `;
export type RemoveCompanyFromExclusionListMutationFn = Apollo.MutationFunction<RemoveCompanyFromExclusionListMutation, RemoveCompanyFromExclusionListMutationVariables>;

/**
 * __useRemoveCompanyFromExclusionListMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyFromExclusionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyFromExclusionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyFromExclusionListMutation, { data, loading, error }] = useRemoveCompanyFromExclusionListMutation({
 *   variables: {
 *      companyExclusionUid: // value for 'companyExclusionUid'
 *   },
 * });
 */
export function useRemoveCompanyFromExclusionListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyFromExclusionListMutation, RemoveCompanyFromExclusionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyFromExclusionListMutation, RemoveCompanyFromExclusionListMutationVariables>(RemoveCompanyFromExclusionListDocument, options);
      }
export type RemoveCompanyFromExclusionListMutationHookResult = ReturnType<typeof useRemoveCompanyFromExclusionListMutation>;
export type RemoveCompanyFromExclusionListMutationResult = Apollo.MutationResult<RemoveCompanyFromExclusionListMutation>;
export type RemoveCompanyFromExclusionListMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyFromExclusionListMutation, RemoveCompanyFromExclusionListMutationVariables>;
export const UpdateCompanyExclusionDocument = gql`
    mutation UpdateCompanyExclusion($companyExclusionUuid: ID!, $reason: String, $exclusionListCategories: [ListCategory!]!, $excludeEveryCategory: Boolean!) {
  updateCompanyExclusion(
    companyExclusionUuid: $companyExclusionUuid
    reason: $reason
    exclusionListCategories: $exclusionListCategories
    excludeEveryCategory: $excludeEveryCategory
  ) {
    failReasons
    record {
      id
      excludeFromEveryListCategory
      exclusionListCategories
      reason
    }
  }
}
    `;
export type UpdateCompanyExclusionMutationFn = Apollo.MutationFunction<UpdateCompanyExclusionMutation, UpdateCompanyExclusionMutationVariables>;

/**
 * __useUpdateCompanyExclusionMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyExclusionMutation, { data, loading, error }] = useUpdateCompanyExclusionMutation({
 *   variables: {
 *      companyExclusionUuid: // value for 'companyExclusionUuid'
 *      reason: // value for 'reason'
 *      exclusionListCategories: // value for 'exclusionListCategories'
 *      excludeEveryCategory: // value for 'excludeEveryCategory'
 *   },
 * });
 */
export function useUpdateCompanyExclusionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyExclusionMutation, UpdateCompanyExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyExclusionMutation, UpdateCompanyExclusionMutationVariables>(UpdateCompanyExclusionDocument, options);
      }
export type UpdateCompanyExclusionMutationHookResult = ReturnType<typeof useUpdateCompanyExclusionMutation>;
export type UpdateCompanyExclusionMutationResult = Apollo.MutationResult<UpdateCompanyExclusionMutation>;
export type UpdateCompanyExclusionMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyExclusionMutation, UpdateCompanyExclusionMutationVariables>;
export const ContactExclusionsDocument = gql`
    query ContactExclusions($page: Int = 1, $perPage: Int = 10, $term: String = "") {
  contactExclusions(page: $page, perPage: $perPage, term: $term) {
    entries {
      ...ContactExclusionRow
    }
    pageInfo {
      totalEntries
      totalPages
    }
  }
}
    ${ContactExclusionRowFragmentDoc}`;

/**
 * __useContactExclusionsQuery__
 *
 * To run a query within a React component, call `useContactExclusionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactExclusionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactExclusionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useContactExclusionsQuery(baseOptions?: Apollo.QueryHookOptions<ContactExclusionsQuery, ContactExclusionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactExclusionsQuery, ContactExclusionsQueryVariables>(ContactExclusionsDocument, options);
      }
export function useContactExclusionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactExclusionsQuery, ContactExclusionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactExclusionsQuery, ContactExclusionsQueryVariables>(ContactExclusionsDocument, options);
        }
export type ContactExclusionsQueryHookResult = ReturnType<typeof useContactExclusionsQuery>;
export type ContactExclusionsLazyQueryHookResult = ReturnType<typeof useContactExclusionsLazyQuery>;
export type ContactExclusionsQueryResult = Apollo.QueryResult<ContactExclusionsQuery, ContactExclusionsQueryVariables>;
export const CreateContactExclusionRuleDocument = gql`
    mutation CreateContactExclusionRule($schemaUid: ID!, $optionChoiceUids: [ID!]!, $reason: String!, $exclusionListCategories: [ListCategory!]!, $excludeFromEveryCategory: Boolean!, $exclusionType: ExclusionType) {
  createContactExclusionRule(
    attributes: {schemaUid: $schemaUid, optionChoiceUids: $optionChoiceUids, reason: $reason, exclusionListCategories: $exclusionListCategories, excludeFromEveryListCategory: $excludeFromEveryCategory}
    exclusionType: $exclusionType
  ) {
    failReasons
    record {
      ...ContactExclusionRow
    }
  }
}
    ${ContactExclusionRowFragmentDoc}`;
export type CreateContactExclusionRuleMutationFn = Apollo.MutationFunction<CreateContactExclusionRuleMutation, CreateContactExclusionRuleMutationVariables>;

/**
 * __useCreateContactExclusionRuleMutation__
 *
 * To run a mutation, you first call `useCreateContactExclusionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactExclusionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactExclusionRuleMutation, { data, loading, error }] = useCreateContactExclusionRuleMutation({
 *   variables: {
 *      schemaUid: // value for 'schemaUid'
 *      optionChoiceUids: // value for 'optionChoiceUids'
 *      reason: // value for 'reason'
 *      exclusionListCategories: // value for 'exclusionListCategories'
 *      excludeFromEveryCategory: // value for 'excludeFromEveryCategory'
 *      exclusionType: // value for 'exclusionType'
 *   },
 * });
 */
export function useCreateContactExclusionRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactExclusionRuleMutation, CreateContactExclusionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactExclusionRuleMutation, CreateContactExclusionRuleMutationVariables>(CreateContactExclusionRuleDocument, options);
      }
export type CreateContactExclusionRuleMutationHookResult = ReturnType<typeof useCreateContactExclusionRuleMutation>;
export type CreateContactExclusionRuleMutationResult = Apollo.MutationResult<CreateContactExclusionRuleMutation>;
export type CreateContactExclusionRuleMutationOptions = Apollo.BaseMutationOptions<CreateContactExclusionRuleMutation, CreateContactExclusionRuleMutationVariables>;
export const ExcludedContactsModalDocument = gql`
    query ExcludedContactsModal($contactUids: [ID!]!, $listId: String!, $exclusionTypes: [ExclusionType!]!) {
  matchingMarketingExclusions(
    listUid: $listId
    contactUids: $contactUids
    exclusionTypes: $exclusionTypes
  ) {
    ...MatchingExclusion
  }
  marketingListConfiguration {
    id
    allowUnsubscribed
    consentLegitimateInterestText
  }
}
    ${MatchingExclusionFragmentDoc}`;

/**
 * __useExcludedContactsModalQuery__
 *
 * To run a query within a React component, call `useExcludedContactsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useExcludedContactsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExcludedContactsModalQuery({
 *   variables: {
 *      contactUids: // value for 'contactUids'
 *      listId: // value for 'listId'
 *      exclusionTypes: // value for 'exclusionTypes'
 *   },
 * });
 */
export function useExcludedContactsModalQuery(baseOptions: Apollo.QueryHookOptions<ExcludedContactsModalQuery, ExcludedContactsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExcludedContactsModalQuery, ExcludedContactsModalQueryVariables>(ExcludedContactsModalDocument, options);
      }
export function useExcludedContactsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExcludedContactsModalQuery, ExcludedContactsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExcludedContactsModalQuery, ExcludedContactsModalQueryVariables>(ExcludedContactsModalDocument, options);
        }
export type ExcludedContactsModalQueryHookResult = ReturnType<typeof useExcludedContactsModalQuery>;
export type ExcludedContactsModalLazyQueryHookResult = ReturnType<typeof useExcludedContactsModalLazyQuery>;
export type ExcludedContactsModalQueryResult = Apollo.QueryResult<ExcludedContactsModalQuery, ExcludedContactsModalQueryVariables>;
export const RemoveContactExclusionRuleDocument = gql`
    mutation RemoveContactExclusionRule($contactExclusionRuleUid: ID!) {
  removeContactExclusionRule(contactExclusionRuleUid: $contactExclusionRuleUid) {
    failReasons
  }
}
    `;
export type RemoveContactExclusionRuleMutationFn = Apollo.MutationFunction<RemoveContactExclusionRuleMutation, RemoveContactExclusionRuleMutationVariables>;

/**
 * __useRemoveContactExclusionRuleMutation__
 *
 * To run a mutation, you first call `useRemoveContactExclusionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactExclusionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactExclusionRuleMutation, { data, loading, error }] = useRemoveContactExclusionRuleMutation({
 *   variables: {
 *      contactExclusionRuleUid: // value for 'contactExclusionRuleUid'
 *   },
 * });
 */
export function useRemoveContactExclusionRuleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContactExclusionRuleMutation, RemoveContactExclusionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContactExclusionRuleMutation, RemoveContactExclusionRuleMutationVariables>(RemoveContactExclusionRuleDocument, options);
      }
export type RemoveContactExclusionRuleMutationHookResult = ReturnType<typeof useRemoveContactExclusionRuleMutation>;
export type RemoveContactExclusionRuleMutationResult = Apollo.MutationResult<RemoveContactExclusionRuleMutation>;
export type RemoveContactExclusionRuleMutationOptions = Apollo.BaseMutationOptions<RemoveContactExclusionRuleMutation, RemoveContactExclusionRuleMutationVariables>;
export const UpdateContactExclusionRuleDocument = gql`
    mutation UpdateContactExclusionRule($contactExclusionRuleUid: ID!, $schemaUid: ID!, $optionChoiceUids: [ID!]!, $reason: String!, $exclusionListCategories: [ListCategory!]!, $excludeFromEveryListCategory: Boolean!) {
  updateContactExclusionRule(
    contactExclusionRuleUid: $contactExclusionRuleUid
    attributes: {schemaUid: $schemaUid, optionChoiceUids: $optionChoiceUids, reason: $reason, exclusionListCategories: $exclusionListCategories, excludeFromEveryListCategory: $excludeFromEveryListCategory}
  ) {
    failReasons
  }
}
    `;
export type UpdateContactExclusionRuleMutationFn = Apollo.MutationFunction<UpdateContactExclusionRuleMutation, UpdateContactExclusionRuleMutationVariables>;

/**
 * __useUpdateContactExclusionRuleMutation__
 *
 * To run a mutation, you first call `useUpdateContactExclusionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactExclusionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactExclusionRuleMutation, { data, loading, error }] = useUpdateContactExclusionRuleMutation({
 *   variables: {
 *      contactExclusionRuleUid: // value for 'contactExclusionRuleUid'
 *      schemaUid: // value for 'schemaUid'
 *      optionChoiceUids: // value for 'optionChoiceUids'
 *      reason: // value for 'reason'
 *      exclusionListCategories: // value for 'exclusionListCategories'
 *      excludeFromEveryListCategory: // value for 'excludeFromEveryListCategory'
 *   },
 * });
 */
export function useUpdateContactExclusionRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactExclusionRuleMutation, UpdateContactExclusionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactExclusionRuleMutation, UpdateContactExclusionRuleMutationVariables>(UpdateContactExclusionRuleDocument, options);
      }
export type UpdateContactExclusionRuleMutationHookResult = ReturnType<typeof useUpdateContactExclusionRuleMutation>;
export type UpdateContactExclusionRuleMutationResult = Apollo.MutationResult<UpdateContactExclusionRuleMutation>;
export type UpdateContactExclusionRuleMutationOptions = Apollo.BaseMutationOptions<UpdateContactExclusionRuleMutation, UpdateContactExclusionRuleMutationVariables>;
export const BeeAuthDocument = gql`
    query BeeAuth {
  beeAuth {
    ...BeeAuth
  }
  emailMarketingConfiguration {
    ...EmailMarketingConfiguration
  }
}
    ${BeeAuthFragmentDoc}
${EmailMarketingConfigurationFragmentDoc}`;

/**
 * __useBeeAuthQuery__
 *
 * To run a query within a React component, call `useBeeAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeeAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeeAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useBeeAuthQuery(baseOptions?: Apollo.QueryHookOptions<BeeAuthQuery, BeeAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeeAuthQuery, BeeAuthQueryVariables>(BeeAuthDocument, options);
      }
export function useBeeAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeeAuthQuery, BeeAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeeAuthQuery, BeeAuthQueryVariables>(BeeAuthDocument, options);
        }
export type BeeAuthQueryHookResult = ReturnType<typeof useBeeAuthQuery>;
export type BeeAuthLazyQueryHookResult = ReturnType<typeof useBeeAuthLazyQuery>;
export type BeeAuthQueryResult = Apollo.QueryResult<BeeAuthQuery, BeeAuthQueryVariables>;
export const ConnectListDocument = gql`
    mutation ConnectList($listUuid: String!, $audienceId: String!) {
  connectList(listUuid: $listUuid, audienceId: $audienceId) {
    failReasons
  }
}
    `;
export type ConnectListMutationFn = Apollo.MutationFunction<ConnectListMutation, ConnectListMutationVariables>;

/**
 * __useConnectListMutation__
 *
 * To run a mutation, you first call `useConnectListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectListMutation, { data, loading, error }] = useConnectListMutation({
 *   variables: {
 *      listUuid: // value for 'listUuid'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useConnectListMutation(baseOptions?: Apollo.MutationHookOptions<ConnectListMutation, ConnectListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectListMutation, ConnectListMutationVariables>(ConnectListDocument, options);
      }
export type ConnectListMutationHookResult = ReturnType<typeof useConnectListMutation>;
export type ConnectListMutationResult = Apollo.MutationResult<ConnectListMutation>;
export type ConnectListMutationOptions = Apollo.BaseMutationOptions<ConnectListMutation, ConnectListMutationVariables>;
export const ConnectedListUpdatedDocument = gql`
    subscription ConnectedListUpdated($listUid: ID!) {
  connectedListUpdated(listUid: $listUid) {
    ...ConnectedListInfo
  }
}
    ${ConnectedListInfoFragmentDoc}`;

/**
 * __useConnectedListUpdatedSubscription__
 *
 * To run a query within a React component, call `useConnectedListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConnectedListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedListUpdatedSubscription({
 *   variables: {
 *      listUid: // value for 'listUid'
 *   },
 * });
 */
export function useConnectedListUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ConnectedListUpdatedSubscription, ConnectedListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConnectedListUpdatedSubscription, ConnectedListUpdatedSubscriptionVariables>(ConnectedListUpdatedDocument, options);
      }
export type ConnectedListUpdatedSubscriptionHookResult = ReturnType<typeof useConnectedListUpdatedSubscription>;
export type ConnectedListUpdatedSubscriptionResult = Apollo.SubscriptionResult<ConnectedListUpdatedSubscription>;
export const ConsentLegitimateInterestTextDocument = gql`
    query ConsentLegitimateInterestText {
  marketingListConfiguration {
    ...MarketingListConfiguration
  }
}
    ${MarketingListConfigurationFragmentDoc}`;

/**
 * __useConsentLegitimateInterestTextQuery__
 *
 * To run a query within a React component, call `useConsentLegitimateInterestTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsentLegitimateInterestTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsentLegitimateInterestTextQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsentLegitimateInterestTextQuery(baseOptions?: Apollo.QueryHookOptions<ConsentLegitimateInterestTextQuery, ConsentLegitimateInterestTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsentLegitimateInterestTextQuery, ConsentLegitimateInterestTextQueryVariables>(ConsentLegitimateInterestTextDocument, options);
      }
export function useConsentLegitimateInterestTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsentLegitimateInterestTextQuery, ConsentLegitimateInterestTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsentLegitimateInterestTextQuery, ConsentLegitimateInterestTextQueryVariables>(ConsentLegitimateInterestTextDocument, options);
        }
export type ConsentLegitimateInterestTextQueryHookResult = ReturnType<typeof useConsentLegitimateInterestTextQuery>;
export type ConsentLegitimateInterestTextLazyQueryHookResult = ReturnType<typeof useConsentLegitimateInterestTextLazyQuery>;
export type ConsentLegitimateInterestTextQueryResult = Apollo.QueryResult<ConsentLegitimateInterestTextQuery, ConsentLegitimateInterestTextQueryVariables>;
export const DisconnectConnectedListDocument = gql`
    mutation DisconnectConnectedList($connectedListId: String!) {
  disconnectConnectedList(connectedListId: $connectedListId) {
    failReasons
  }
}
    `;
export type DisconnectConnectedListMutationFn = Apollo.MutationFunction<DisconnectConnectedListMutation, DisconnectConnectedListMutationVariables>;

/**
 * __useDisconnectConnectedListMutation__
 *
 * To run a mutation, you first call `useDisconnectConnectedListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectConnectedListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectConnectedListMutation, { data, loading, error }] = useDisconnectConnectedListMutation({
 *   variables: {
 *      connectedListId: // value for 'connectedListId'
 *   },
 * });
 */
export function useDisconnectConnectedListMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectConnectedListMutation, DisconnectConnectedListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectConnectedListMutation, DisconnectConnectedListMutationVariables>(DisconnectConnectedListDocument, options);
      }
export type DisconnectConnectedListMutationHookResult = ReturnType<typeof useDisconnectConnectedListMutation>;
export type DisconnectConnectedListMutationResult = Apollo.MutationResult<DisconnectConnectedListMutation>;
export type DisconnectConnectedListMutationOptions = Apollo.BaseMutationOptions<DisconnectConnectedListMutation, DisconnectConnectedListMutationVariables>;
export const DisconnectListDocument = gql`
    mutation DisconnectList($listUuid: String!) {
  disconnectList(listUuid: $listUuid) {
    failReasons
  }
}
    `;
export type DisconnectListMutationFn = Apollo.MutationFunction<DisconnectListMutation, DisconnectListMutationVariables>;

/**
 * __useDisconnectListMutation__
 *
 * To run a mutation, you first call `useDisconnectListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectListMutation, { data, loading, error }] = useDisconnectListMutation({
 *   variables: {
 *      listUuid: // value for 'listUuid'
 *   },
 * });
 */
export function useDisconnectListMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectListMutation, DisconnectListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectListMutation, DisconnectListMutationVariables>(DisconnectListDocument, options);
      }
export type DisconnectListMutationHookResult = ReturnType<typeof useDisconnectListMutation>;
export type DisconnectListMutationResult = Apollo.MutationResult<DisconnectListMutation>;
export type DisconnectListMutationOptions = Apollo.BaseMutationOptions<DisconnectListMutation, DisconnectListMutationVariables>;
export const EnableMarketingExclusionDocument = gql`
    query EnableMarketingExclusion {
  marketingListConfiguration {
    id
    enableMarketingExclusion
  }
}
    `;

/**
 * __useEnableMarketingExclusionQuery__
 *
 * To run a query within a React component, call `useEnableMarketingExclusionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnableMarketingExclusionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnableMarketingExclusionQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnableMarketingExclusionQuery(baseOptions?: Apollo.QueryHookOptions<EnableMarketingExclusionQuery, EnableMarketingExclusionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnableMarketingExclusionQuery, EnableMarketingExclusionQueryVariables>(EnableMarketingExclusionDocument, options);
      }
export function useEnableMarketingExclusionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnableMarketingExclusionQuery, EnableMarketingExclusionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnableMarketingExclusionQuery, EnableMarketingExclusionQueryVariables>(EnableMarketingExclusionDocument, options);
        }
export type EnableMarketingExclusionQueryHookResult = ReturnType<typeof useEnableMarketingExclusionQuery>;
export type EnableMarketingExclusionLazyQueryHookResult = ReturnType<typeof useEnableMarketingExclusionLazyQuery>;
export type EnableMarketingExclusionQueryResult = Apollo.QueryResult<EnableMarketingExclusionQuery, EnableMarketingExclusionQueryVariables>;
export const GetCurrentUserCampaignManagerDocument = gql`
    query GetCurrentUserCampaignManager {
  campaignManager {
    id
    name
  }
}
    `;

/**
 * __useGetCurrentUserCampaignManagerQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserCampaignManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserCampaignManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserCampaignManagerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserCampaignManagerQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserCampaignManagerQuery, GetCurrentUserCampaignManagerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserCampaignManagerQuery, GetCurrentUserCampaignManagerQueryVariables>(GetCurrentUserCampaignManagerDocument, options);
      }
export function useGetCurrentUserCampaignManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserCampaignManagerQuery, GetCurrentUserCampaignManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserCampaignManagerQuery, GetCurrentUserCampaignManagerQueryVariables>(GetCurrentUserCampaignManagerDocument, options);
        }
export type GetCurrentUserCampaignManagerQueryHookResult = ReturnType<typeof useGetCurrentUserCampaignManagerQuery>;
export type GetCurrentUserCampaignManagerLazyQueryHookResult = ReturnType<typeof useGetCurrentUserCampaignManagerLazyQuery>;
export type GetCurrentUserCampaignManagerQueryResult = Apollo.QueryResult<GetCurrentUserCampaignManagerQuery, GetCurrentUserCampaignManagerQueryVariables>;
export const GetListInfoDocument = gql`
    query GetListInfo($uid: ID!) {
  list(uid: $uid) {
    ...ListInfo
  }
}
    ${ListInfoFragmentDoc}`;

/**
 * __useGetListInfoQuery__
 *
 * To run a query within a React component, call `useGetListInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListInfoQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetListInfoQuery(baseOptions: Apollo.QueryHookOptions<GetListInfoQuery, GetListInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListInfoQuery, GetListInfoQueryVariables>(GetListInfoDocument, options);
      }
export function useGetListInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListInfoQuery, GetListInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListInfoQuery, GetListInfoQueryVariables>(GetListInfoDocument, options);
        }
export type GetListInfoQueryHookResult = ReturnType<typeof useGetListInfoQuery>;
export type GetListInfoLazyQueryHookResult = ReturnType<typeof useGetListInfoLazyQuery>;
export type GetListInfoQueryResult = Apollo.QueryResult<GetListInfoQuery, GetListInfoQueryVariables>;
export const GetListsDocument = gql`
    query GetLists($page: Int, $perPage: Int, $filter: ListFiltering, $orderBy: ListsOrderBy) {
  lists(page: $page, perPage: $perPage, filter: $filter, orderBy: $orderBy) {
    entries {
      ...ListRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ListRowFragmentDoc}`;

/**
 * __useGetListsQuery__
 *
 * To run a query within a React component, call `useGetListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetListsQuery(baseOptions?: Apollo.QueryHookOptions<GetListsQuery, GetListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListsQuery, GetListsQueryVariables>(GetListsDocument, options);
      }
export function useGetListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListsQuery, GetListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListsQuery, GetListsQueryVariables>(GetListsDocument, options);
        }
export type GetListsQueryHookResult = ReturnType<typeof useGetListsQuery>;
export type GetListsLazyQueryHookResult = ReturnType<typeof useGetListsLazyQuery>;
export type GetListsQueryResult = Apollo.QueryResult<GetListsQuery, GetListsQueryVariables>;
export const MarketingListExcludedContactsDocument = gql`
    query MarketingListExcludedContacts($page: Int, $perPage: Int, $uid: ID!, $term: String, $withMissingFields: Boolean = false, $orderBy: ListMembersOrderBy = CREATED_AT_ASC, $filter: ListMembersFilter) {
  listMembers(
    uid: $uid
    page: $page
    perPage: $perPage
    term: $term
    withMissingFields: $withMissingFields
    orderBy: $orderBy
    filter: $filter
  ) {
    entries {
      contact {
        ...BlockedContactListRow
      }
    }
  }
}
    ${BlockedContactListRowFragmentDoc}`;

/**
 * __useMarketingListExcludedContactsQuery__
 *
 * To run a query within a React component, call `useMarketingListExcludedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingListExcludedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingListExcludedContactsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      uid: // value for 'uid'
 *      term: // value for 'term'
 *      withMissingFields: // value for 'withMissingFields'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingListExcludedContactsQuery(baseOptions: Apollo.QueryHookOptions<MarketingListExcludedContactsQuery, MarketingListExcludedContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingListExcludedContactsQuery, MarketingListExcludedContactsQueryVariables>(MarketingListExcludedContactsDocument, options);
      }
export function useMarketingListExcludedContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingListExcludedContactsQuery, MarketingListExcludedContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingListExcludedContactsQuery, MarketingListExcludedContactsQueryVariables>(MarketingListExcludedContactsDocument, options);
        }
export type MarketingListExcludedContactsQueryHookResult = ReturnType<typeof useMarketingListExcludedContactsQuery>;
export type MarketingListExcludedContactsLazyQueryHookResult = ReturnType<typeof useMarketingListExcludedContactsLazyQuery>;
export type MarketingListExcludedContactsQueryResult = Apollo.QueryResult<MarketingListExcludedContactsQuery, MarketingListExcludedContactsQueryVariables>;
export const MarketingListInfoDocument = gql`
    query MarketingListInfo($uid: ID!) {
  list(uid: $uid) {
    ...ListInfo
  }
  marketingListCounts(listUid: $uid) {
    excludedContactsCount
    excludedCompaniesCount
    totalExcludedContactsCount
  }
  marketingListConfiguration {
    id
    enableMarketingExclusion
  }
}
    ${ListInfoFragmentDoc}`;

/**
 * __useMarketingListInfoQuery__
 *
 * To run a query within a React component, call `useMarketingListInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingListInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingListInfoQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useMarketingListInfoQuery(baseOptions: Apollo.QueryHookOptions<MarketingListInfoQuery, MarketingListInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingListInfoQuery, MarketingListInfoQueryVariables>(MarketingListInfoDocument, options);
      }
export function useMarketingListInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingListInfoQuery, MarketingListInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingListInfoQuery, MarketingListInfoQueryVariables>(MarketingListInfoDocument, options);
        }
export type MarketingListInfoQueryHookResult = ReturnType<typeof useMarketingListInfoQuery>;
export type MarketingListInfoLazyQueryHookResult = ReturnType<typeof useMarketingListInfoLazyQuery>;
export type MarketingListInfoQueryResult = Apollo.QueryResult<MarketingListInfoQuery, MarketingListInfoQueryVariables>;
export const MarketingListMembersDocument = gql`
    query MarketingListMembers($page: Int, $perPage: Int, $uid: ID!, $term: String, $withMissingFields: Boolean = false, $orderBy: ListMembersOrderBy = CREATED_AT_ASC, $filter: ListMembersFilter) {
  listMembers(
    uid: $uid
    page: $page
    perPage: $perPage
    term: $term
    withMissingFields: $withMissingFields
    orderBy: $orderBy
    filter: $filter
  ) {
    entries {
      ...MarketingListMemberRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${MarketingListMemberRowFragmentDoc}`;

/**
 * __useMarketingListMembersQuery__
 *
 * To run a query within a React component, call `useMarketingListMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingListMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingListMembersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      uid: // value for 'uid'
 *      term: // value for 'term'
 *      withMissingFields: // value for 'withMissingFields'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingListMembersQuery(baseOptions: Apollo.QueryHookOptions<MarketingListMembersQuery, MarketingListMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingListMembersQuery, MarketingListMembersQueryVariables>(MarketingListMembersDocument, options);
      }
export function useMarketingListMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingListMembersQuery, MarketingListMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingListMembersQuery, MarketingListMembersQueryVariables>(MarketingListMembersDocument, options);
        }
export type MarketingListMembersQueryHookResult = ReturnType<typeof useMarketingListMembersQuery>;
export type MarketingListMembersLazyQueryHookResult = ReturnType<typeof useMarketingListMembersLazyQuery>;
export type MarketingListMembersQueryResult = Apollo.QueryResult<MarketingListMembersQuery, MarketingListMembersQueryVariables>;
export const OutOfSyncMemberCountDocument = gql`
    query OutOfSyncMemberCount($uid: ID!) {
  listMembers(uid: $uid, withMissingFields: true, page: 1, perPage: 1) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useOutOfSyncMemberCountQuery__
 *
 * To run a query within a React component, call `useOutOfSyncMemberCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutOfSyncMemberCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutOfSyncMemberCountQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useOutOfSyncMemberCountQuery(baseOptions: Apollo.QueryHookOptions<OutOfSyncMemberCountQuery, OutOfSyncMemberCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutOfSyncMemberCountQuery, OutOfSyncMemberCountQueryVariables>(OutOfSyncMemberCountDocument, options);
      }
export function useOutOfSyncMemberCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutOfSyncMemberCountQuery, OutOfSyncMemberCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutOfSyncMemberCountQuery, OutOfSyncMemberCountQueryVariables>(OutOfSyncMemberCountDocument, options);
        }
export type OutOfSyncMemberCountQueryHookResult = ReturnType<typeof useOutOfSyncMemberCountQuery>;
export type OutOfSyncMemberCountLazyQueryHookResult = ReturnType<typeof useOutOfSyncMemberCountLazyQuery>;
export type OutOfSyncMemberCountQueryResult = Apollo.QueryResult<OutOfSyncMemberCountQuery, OutOfSyncMemberCountQueryVariables>;
export const SharedMarketingListInfoDocument = gql`
    query SharedMarketingListInfo($uid: ID!) {
  marketingListCounts(listUid: $uid) {
    excludedContactsCount
    excludedCompaniesCount
    totalExcludedContactsCount
  }
  marketingListConfiguration {
    id
    enableMarketingExclusion
  }
}
    `;

/**
 * __useSharedMarketingListInfoQuery__
 *
 * To run a query within a React component, call `useSharedMarketingListInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedMarketingListInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedMarketingListInfoQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useSharedMarketingListInfoQuery(baseOptions: Apollo.QueryHookOptions<SharedMarketingListInfoQuery, SharedMarketingListInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedMarketingListInfoQuery, SharedMarketingListInfoQueryVariables>(SharedMarketingListInfoDocument, options);
      }
export function useSharedMarketingListInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedMarketingListInfoQuery, SharedMarketingListInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedMarketingListInfoQuery, SharedMarketingListInfoQueryVariables>(SharedMarketingListInfoDocument, options);
        }
export type SharedMarketingListInfoQueryHookResult = ReturnType<typeof useSharedMarketingListInfoQuery>;
export type SharedMarketingListInfoLazyQueryHookResult = ReturnType<typeof useSharedMarketingListInfoLazyQuery>;
export type SharedMarketingListInfoQueryResult = Apollo.QueryResult<SharedMarketingListInfoQuery, SharedMarketingListInfoQueryVariables>;
export const SharedMarketingListNameDocument = gql`
    query SharedMarketingListName($uid: ID!) {
  list(uid: $uid) {
    id
    name
  }
}
    `;

/**
 * __useSharedMarketingListNameQuery__
 *
 * To run a query within a React component, call `useSharedMarketingListNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedMarketingListNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedMarketingListNameQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useSharedMarketingListNameQuery(baseOptions: Apollo.QueryHookOptions<SharedMarketingListNameQuery, SharedMarketingListNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedMarketingListNameQuery, SharedMarketingListNameQueryVariables>(SharedMarketingListNameDocument, options);
      }
export function useSharedMarketingListNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedMarketingListNameQuery, SharedMarketingListNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedMarketingListNameQuery, SharedMarketingListNameQueryVariables>(SharedMarketingListNameDocument, options);
        }
export type SharedMarketingListNameQueryHookResult = ReturnType<typeof useSharedMarketingListNameQuery>;
export type SharedMarketingListNameLazyQueryHookResult = ReturnType<typeof useSharedMarketingListNameLazyQuery>;
export type SharedMarketingListNameQueryResult = Apollo.QueryResult<SharedMarketingListNameQuery, SharedMarketingListNameQueryVariables>;
export const SyncListMembersDocument = gql`
    mutation SyncListMembers($listUuid: String!) {
  syncListMembers(listUuid: $listUuid) {
    failReasons
  }
}
    `;
export type SyncListMembersMutationFn = Apollo.MutationFunction<SyncListMembersMutation, SyncListMembersMutationVariables>;

/**
 * __useSyncListMembersMutation__
 *
 * To run a mutation, you first call `useSyncListMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncListMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncListMembersMutation, { data, loading, error }] = useSyncListMembersMutation({
 *   variables: {
 *      listUuid: // value for 'listUuid'
 *   },
 * });
 */
export function useSyncListMembersMutation(baseOptions?: Apollo.MutationHookOptions<SyncListMembersMutation, SyncListMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncListMembersMutation, SyncListMembersMutationVariables>(SyncListMembersDocument, options);
      }
export type SyncListMembersMutationHookResult = ReturnType<typeof useSyncListMembersMutation>;
export type SyncListMembersMutationResult = Apollo.MutationResult<SyncListMembersMutation>;
export type SyncListMembersMutationOptions = Apollo.BaseMutationOptions<SyncListMembersMutation, SyncListMembersMutationVariables>;
export const EmployeeMeetingsDocument = gql`
    query EmployeeMeetings($startTimeAfter: ISO8601DateTime!, $startTimeBefore: ISO8601DateTime!, $limit: Int) {
  employeeMeetings: meetings(
    filter: {startTimeAfter: $startTimeAfter, startTimeBefore: $startTimeBefore}
    ownership: USER
    perPage: $limit
  ) {
    entries {
      ...EmployeeMeetingListItem
    }
  }
}
    ${EmployeeMeetingListItemFragmentDoc}`;

/**
 * __useEmployeeMeetingsQuery__
 *
 * To run a query within a React component, call `useEmployeeMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeMeetingsQuery({
 *   variables: {
 *      startTimeAfter: // value for 'startTimeAfter'
 *      startTimeBefore: // value for 'startTimeBefore'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEmployeeMeetingsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeMeetingsQuery, EmployeeMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeMeetingsQuery, EmployeeMeetingsQueryVariables>(EmployeeMeetingsDocument, options);
      }
export function useEmployeeMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeMeetingsQuery, EmployeeMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeMeetingsQuery, EmployeeMeetingsQueryVariables>(EmployeeMeetingsDocument, options);
        }
export type EmployeeMeetingsQueryHookResult = ReturnType<typeof useEmployeeMeetingsQuery>;
export type EmployeeMeetingsLazyQueryHookResult = ReturnType<typeof useEmployeeMeetingsLazyQuery>;
export type EmployeeMeetingsQueryResult = Apollo.QueryResult<EmployeeMeetingsQuery, EmployeeMeetingsQueryVariables>;
export const InteractionPreviewDocument = gql`
    query InteractionPreview($sourceReferenceId: String!) {
  keyActivity(sourceReferenceId: $sourceReferenceId) {
    interaction {
      ...InteractionPreview
    }
  }
}
    ${InteractionPreviewFragmentDoc}`;

/**
 * __useInteractionPreviewQuery__
 *
 * To run a query within a React component, call `useInteractionPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionPreviewQuery({
 *   variables: {
 *      sourceReferenceId: // value for 'sourceReferenceId'
 *   },
 * });
 */
export function useInteractionPreviewQuery(baseOptions: Apollo.QueryHookOptions<InteractionPreviewQuery, InteractionPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InteractionPreviewQuery, InteractionPreviewQueryVariables>(InteractionPreviewDocument, options);
      }
export function useInteractionPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InteractionPreviewQuery, InteractionPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InteractionPreviewQuery, InteractionPreviewQueryVariables>(InteractionPreviewDocument, options);
        }
export type InteractionPreviewQueryHookResult = ReturnType<typeof useInteractionPreviewQuery>;
export type InteractionPreviewLazyQueryHookResult = ReturnType<typeof useInteractionPreviewLazyQuery>;
export type InteractionPreviewQueryResult = Apollo.QueryResult<InteractionPreviewQuery, InteractionPreviewQueryVariables>;
export const KeyActivityPreviewDocument = gql`
    query KeyActivityPreview($sourceReferenceId: String!) {
  keyActivity(sourceReferenceId: $sourceReferenceId) {
    ...KeyActivityPreview
  }
}
    ${KeyActivityPreviewFragmentDoc}`;

/**
 * __useKeyActivityPreviewQuery__
 *
 * To run a query within a React component, call `useKeyActivityPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityPreviewQuery({
 *   variables: {
 *      sourceReferenceId: // value for 'sourceReferenceId'
 *   },
 * });
 */
export function useKeyActivityPreviewQuery(baseOptions: Apollo.QueryHookOptions<KeyActivityPreviewQuery, KeyActivityPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityPreviewQuery, KeyActivityPreviewQueryVariables>(KeyActivityPreviewDocument, options);
      }
export function useKeyActivityPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityPreviewQuery, KeyActivityPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityPreviewQuery, KeyActivityPreviewQueryVariables>(KeyActivityPreviewDocument, options);
        }
export type KeyActivityPreviewQueryHookResult = ReturnType<typeof useKeyActivityPreviewQuery>;
export type KeyActivityPreviewLazyQueryHookResult = ReturnType<typeof useKeyActivityPreviewLazyQuery>;
export type KeyActivityPreviewQueryResult = Apollo.QueryResult<KeyActivityPreviewQuery, KeyActivityPreviewQueryVariables>;
export const MeetingSlideDocument = gql`
    query MeetingSlide($meetingUid: ID!) {
  employeeMeeting(meetingId: $meetingUid) {
    ...MeetingSlide
  }
}
    ${MeetingSlideFragmentDoc}`;

/**
 * __useMeetingSlideQuery__
 *
 * To run a query within a React component, call `useMeetingSlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingSlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingSlideQuery({
 *   variables: {
 *      meetingUid: // value for 'meetingUid'
 *   },
 * });
 */
export function useMeetingSlideQuery(baseOptions: Apollo.QueryHookOptions<MeetingSlideQuery, MeetingSlideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingSlideQuery, MeetingSlideQueryVariables>(MeetingSlideDocument, options);
      }
export function useMeetingSlideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingSlideQuery, MeetingSlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingSlideQuery, MeetingSlideQueryVariables>(MeetingSlideDocument, options);
        }
export type MeetingSlideQueryHookResult = ReturnType<typeof useMeetingSlideQuery>;
export type MeetingSlideLazyQueryHookResult = ReturnType<typeof useMeetingSlideLazyQuery>;
export type MeetingSlideQueryResult = Apollo.QueryResult<MeetingSlideQuery, MeetingSlideQueryVariables>;
export const MyRecentMeetingsDocument = gql`
    query MyRecentMeetings($startTimeAfter: ISO8601DateTime!, $startTimeBefore: ISO8601DateTime!, $page: Int = 1, $perPage: Int = 10) {
  myRecentMeetings: meetings(
    filter: {startTimeAfter: $startTimeAfter, startTimeBefore: $startTimeBefore}
    ownership: USER
    page: $page
    perPage: $perPage
    order: START_TIME_DESC
  ) {
    entries {
      ...RecentMeetingListItem
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${RecentMeetingListItemFragmentDoc}`;

/**
 * __useMyRecentMeetingsQuery__
 *
 * To run a query within a React component, call `useMyRecentMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRecentMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRecentMeetingsQuery({
 *   variables: {
 *      startTimeAfter: // value for 'startTimeAfter'
 *      startTimeBefore: // value for 'startTimeBefore'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMyRecentMeetingsQuery(baseOptions: Apollo.QueryHookOptions<MyRecentMeetingsQuery, MyRecentMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRecentMeetingsQuery, MyRecentMeetingsQueryVariables>(MyRecentMeetingsDocument, options);
      }
export function useMyRecentMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRecentMeetingsQuery, MyRecentMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRecentMeetingsQuery, MyRecentMeetingsQueryVariables>(MyRecentMeetingsDocument, options);
        }
export type MyRecentMeetingsQueryHookResult = ReturnType<typeof useMyRecentMeetingsQuery>;
export type MyRecentMeetingsLazyQueryHookResult = ReturnType<typeof useMyRecentMeetingsLazyQuery>;
export type MyRecentMeetingsQueryResult = Apollo.QueryResult<MyRecentMeetingsQuery, MyRecentMeetingsQueryVariables>;
export const MyContactsListMembersDocument = gql`
    query MyContactsListMembers($page: Int, $perPage: Int, $uid: ID!, $term: String, $withMissingFields: Boolean = false, $orderBy: ListMembersOrderBy = CREATED_AT_ASC, $filter: ListMembersFilter) {
  listMembers(
    uid: $uid
    page: $page
    perPage: $perPage
    term: $term
    withMissingFields: $withMissingFields
    orderBy: $orderBy
    filter: $filter
  ) {
    entries {
      id
      contact {
        id
        ...ContactRequestContactRow
      }
      myContact {
        id
        interactionMaximum {
          id
          lastAt
        }
        classified
      }
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactRequestContactRowFragmentDoc}`;

/**
 * __useMyContactsListMembersQuery__
 *
 * To run a query within a React component, call `useMyContactsListMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyContactsListMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyContactsListMembersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      uid: // value for 'uid'
 *      term: // value for 'term'
 *      withMissingFields: // value for 'withMissingFields'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyContactsListMembersQuery(baseOptions: Apollo.QueryHookOptions<MyContactsListMembersQuery, MyContactsListMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyContactsListMembersQuery, MyContactsListMembersQueryVariables>(MyContactsListMembersDocument, options);
      }
export function useMyContactsListMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyContactsListMembersQuery, MyContactsListMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyContactsListMembersQuery, MyContactsListMembersQueryVariables>(MyContactsListMembersDocument, options);
        }
export type MyContactsListMembersQueryHookResult = ReturnType<typeof useMyContactsListMembersQuery>;
export type MyContactsListMembersLazyQueryHookResult = ReturnType<typeof useMyContactsListMembersLazyQuery>;
export type MyContactsListMembersQueryResult = Apollo.QueryResult<MyContactsListMembersQuery, MyContactsListMembersQueryVariables>;
export const MyContactsViewDocument = gql`
    query MyContactsView($filter: MyContactsFiltering, $orderBy: MyContactsOrderBy = LAST_INTERACTION_DESC, $page: Int = 1, $perPage: Int = 10) {
  myContacts(filter: $filter, orderBy: $orderBy, page: $page, perPage: $perPage) {
    entries {
      id
      contact {
        id
        ...ContactRequestContactRow
      }
      interactionMaximum {
        id
        lastAt
      }
      classified
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactRequestContactRowFragmentDoc}`;

/**
 * __useMyContactsViewQuery__
 *
 * To run a query within a React component, call `useMyContactsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyContactsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyContactsViewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMyContactsViewQuery(baseOptions?: Apollo.QueryHookOptions<MyContactsViewQuery, MyContactsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyContactsViewQuery, MyContactsViewQueryVariables>(MyContactsViewDocument, options);
      }
export function useMyContactsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyContactsViewQuery, MyContactsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyContactsViewQuery, MyContactsViewQueryVariables>(MyContactsViewDocument, options);
        }
export type MyContactsViewQueryHookResult = ReturnType<typeof useMyContactsViewQuery>;
export type MyContactsViewLazyQueryHookResult = ReturnType<typeof useMyContactsViewLazyQuery>;
export type MyContactsViewQueryResult = Apollo.QueryResult<MyContactsViewQuery, MyContactsViewQueryVariables>;
export const MyCalendarDocument = gql`
    query MyCalendar($filter: CalendarFieldFilter!, $order: CalendarFieldOrderBy = ASC) {
  myCalendar(filter: $filter, order: $order) {
    entries {
      ...MyCalendarItem
    }
  }
}
    ${MyCalendarItemFragmentDoc}`;

/**
 * __useMyCalendarQuery__
 *
 * To run a query within a React component, call `useMyCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCalendarQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMyCalendarQuery(baseOptions: Apollo.QueryHookOptions<MyCalendarQuery, MyCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCalendarQuery, MyCalendarQueryVariables>(MyCalendarDocument, options);
      }
export function useMyCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCalendarQuery, MyCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCalendarQuery, MyCalendarQueryVariables>(MyCalendarDocument, options);
        }
export type MyCalendarQueryHookResult = ReturnType<typeof useMyCalendarQuery>;
export type MyCalendarLazyQueryHookResult = ReturnType<typeof useMyCalendarLazyQuery>;
export type MyCalendarQueryResult = Apollo.QueryResult<MyCalendarQuery, MyCalendarQueryVariables>;
export const BulkRemoveMyContactDocument = gql`
    mutation BulkRemoveMyContact($myContactUids: [ID!]!) {
  bulkRemoveMyContact(myContactUids: $myContactUids) {
    failReasons
  }
}
    `;
export type BulkRemoveMyContactMutationFn = Apollo.MutationFunction<BulkRemoveMyContactMutation, BulkRemoveMyContactMutationVariables>;

/**
 * __useBulkRemoveMyContactMutation__
 *
 * To run a mutation, you first call `useBulkRemoveMyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveMyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveMyContactMutation, { data, loading, error }] = useBulkRemoveMyContactMutation({
 *   variables: {
 *      myContactUids: // value for 'myContactUids'
 *   },
 * });
 */
export function useBulkRemoveMyContactMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveMyContactMutation, BulkRemoveMyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveMyContactMutation, BulkRemoveMyContactMutationVariables>(BulkRemoveMyContactDocument, options);
      }
export type BulkRemoveMyContactMutationHookResult = ReturnType<typeof useBulkRemoveMyContactMutation>;
export type BulkRemoveMyContactMutationResult = Apollo.MutationResult<BulkRemoveMyContactMutation>;
export type BulkRemoveMyContactMutationOptions = Apollo.BaseMutationOptions<BulkRemoveMyContactMutation, BulkRemoveMyContactMutationVariables>;
export const ContactUnderReviewDocument = gql`
    query ContactUnderReview($uid: String!) {
  contact(uid: $uid) {
    ...ContactCustomFieldOnlyProfile
  }
  myContact(uid: $uid) {
    ...MyContactExists
  }
}
    ${ContactCustomFieldOnlyProfileFragmentDoc}
${MyContactExistsFragmentDoc}`;

/**
 * __useContactUnderReviewQuery__
 *
 * To run a query within a React component, call `useContactUnderReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactUnderReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactUnderReviewQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useContactUnderReviewQuery(baseOptions: Apollo.QueryHookOptions<ContactUnderReviewQuery, ContactUnderReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactUnderReviewQuery, ContactUnderReviewQueryVariables>(ContactUnderReviewDocument, options);
      }
export function useContactUnderReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactUnderReviewQuery, ContactUnderReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactUnderReviewQuery, ContactUnderReviewQueryVariables>(ContactUnderReviewDocument, options);
        }
export type ContactUnderReviewQueryHookResult = ReturnType<typeof useContactUnderReviewQuery>;
export type ContactUnderReviewLazyQueryHookResult = ReturnType<typeof useContactUnderReviewLazyQuery>;
export type ContactUnderReviewQueryResult = Apollo.QueryResult<ContactUnderReviewQuery, ContactUnderReviewQueryVariables>;
export const CompleteMyTaskDocument = gql`
    mutation CompleteMyTask($uid: ID!) {
  completeMyTask(uid: $uid) {
    failReasons
  }
}
    `;
export type CompleteMyTaskMutationFn = Apollo.MutationFunction<CompleteMyTaskMutation, CompleteMyTaskMutationVariables>;

/**
 * __useCompleteMyTaskMutation__
 *
 * To run a mutation, you first call `useCompleteMyTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMyTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMyTaskMutation, { data, loading, error }] = useCompleteMyTaskMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCompleteMyTaskMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMyTaskMutation, CompleteMyTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteMyTaskMutation, CompleteMyTaskMutationVariables>(CompleteMyTaskDocument, options);
      }
export type CompleteMyTaskMutationHookResult = ReturnType<typeof useCompleteMyTaskMutation>;
export type CompleteMyTaskMutationResult = Apollo.MutationResult<CompleteMyTaskMutation>;
export type CompleteMyTaskMutationOptions = Apollo.BaseMutationOptions<CompleteMyTaskMutation, CompleteMyTaskMutationVariables>;
export const MyTaskDocument = gql`
    query MyTask($uid: ID!) {
  myTask(uid: $uid) {
    ...MyTaskListRow
  }
}
    ${MyTaskListRowFragmentDoc}`;

/**
 * __useMyTaskQuery__
 *
 * To run a query within a React component, call `useMyTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTaskQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useMyTaskQuery(baseOptions: Apollo.QueryHookOptions<MyTaskQuery, MyTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTaskQuery, MyTaskQueryVariables>(MyTaskDocument, options);
      }
export function useMyTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTaskQuery, MyTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTaskQuery, MyTaskQueryVariables>(MyTaskDocument, options);
        }
export type MyTaskQueryHookResult = ReturnType<typeof useMyTaskQuery>;
export type MyTaskLazyQueryHookResult = ReturnType<typeof useMyTaskLazyQuery>;
export type MyTaskQueryResult = Apollo.QueryResult<MyTaskQuery, MyTaskQueryVariables>;
export const ReopenMyTaskDocument = gql`
    mutation ReopenMyTask($taskUid: ID!) {
  reopenMyTask(taskUid: $taskUid) {
    failReasons
  }
}
    `;
export type ReopenMyTaskMutationFn = Apollo.MutationFunction<ReopenMyTaskMutation, ReopenMyTaskMutationVariables>;

/**
 * __useReopenMyTaskMutation__
 *
 * To run a mutation, you first call `useReopenMyTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenMyTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenMyTaskMutation, { data, loading, error }] = useReopenMyTaskMutation({
 *   variables: {
 *      taskUid: // value for 'taskUid'
 *   },
 * });
 */
export function useReopenMyTaskMutation(baseOptions?: Apollo.MutationHookOptions<ReopenMyTaskMutation, ReopenMyTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenMyTaskMutation, ReopenMyTaskMutationVariables>(ReopenMyTaskDocument, options);
      }
export type ReopenMyTaskMutationHookResult = ReturnType<typeof useReopenMyTaskMutation>;
export type ReopenMyTaskMutationResult = Apollo.MutationResult<ReopenMyTaskMutation>;
export type ReopenMyTaskMutationOptions = Apollo.BaseMutationOptions<ReopenMyTaskMutation, ReopenMyTaskMutationVariables>;
export const UpdateMyTaskDocument = gql`
    mutation UpdateMyTask($taskUid: ID!, $assigneeUid: ID, $title: String, $description: String, $dueOn: String) {
  updateMyTask(
    taskUid: $taskUid
    assigneeUid: $assigneeUid
    title: $title
    description: $description
    dueOn: $dueOn
  ) {
    task {
      ...MyTaskListRow
    }
    failReasons
  }
}
    ${MyTaskListRowFragmentDoc}`;
export type UpdateMyTaskMutationFn = Apollo.MutationFunction<UpdateMyTaskMutation, UpdateMyTaskMutationVariables>;

/**
 * __useUpdateMyTaskMutation__
 *
 * To run a mutation, you first call `useUpdateMyTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyTaskMutation, { data, loading, error }] = useUpdateMyTaskMutation({
 *   variables: {
 *      taskUid: // value for 'taskUid'
 *      assigneeUid: // value for 'assigneeUid'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      dueOn: // value for 'dueOn'
 *   },
 * });
 */
export function useUpdateMyTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyTaskMutation, UpdateMyTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyTaskMutation, UpdateMyTaskMutationVariables>(UpdateMyTaskDocument, options);
      }
export type UpdateMyTaskMutationHookResult = ReturnType<typeof useUpdateMyTaskMutation>;
export type UpdateMyTaskMutationResult = Apollo.MutationResult<UpdateMyTaskMutation>;
export type UpdateMyTaskMutationOptions = Apollo.BaseMutationOptions<UpdateMyTaskMutation, UpdateMyTaskMutationVariables>;
export const CreateMyTaskByDateDocument = gql`
    mutation CreateMyTaskByDate($assignedToUid: ID, $requestedByUid: ID, $attributes: CreateTaskAttributes!) {
  createTask(
    assignedToUid: $assignedToUid
    requestedByUid: $requestedByUid
    attributes: $attributes
  ) {
    failReasons
  }
}
    `;
export type CreateMyTaskByDateMutationFn = Apollo.MutationFunction<CreateMyTaskByDateMutation, CreateMyTaskByDateMutationVariables>;

/**
 * __useCreateMyTaskByDateMutation__
 *
 * To run a mutation, you first call `useCreateMyTaskByDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyTaskByDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyTaskByDateMutation, { data, loading, error }] = useCreateMyTaskByDateMutation({
 *   variables: {
 *      assignedToUid: // value for 'assignedToUid'
 *      requestedByUid: // value for 'requestedByUid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateMyTaskByDateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyTaskByDateMutation, CreateMyTaskByDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyTaskByDateMutation, CreateMyTaskByDateMutationVariables>(CreateMyTaskByDateDocument, options);
      }
export type CreateMyTaskByDateMutationHookResult = ReturnType<typeof useCreateMyTaskByDateMutation>;
export type CreateMyTaskByDateMutationResult = Apollo.MutationResult<CreateMyTaskByDateMutation>;
export type CreateMyTaskByDateMutationOptions = Apollo.BaseMutationOptions<CreateMyTaskByDateMutation, CreateMyTaskByDateMutationVariables>;
export const MyCompletedTasksDocument = gql`
    query MyCompletedTasks($primaryFilter: TaskPrimaryFilterInput) {
  tasks(
    primaryFilter: $primaryFilter
    filter: {status: COMPLETED}
    page: 1
    perPage: 1000
  ) {
    entries {
      ...MyTaskListRowByDate
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${MyTaskListRowByDateFragmentDoc}`;

/**
 * __useMyCompletedTasksQuery__
 *
 * To run a query within a React component, call `useMyCompletedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCompletedTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCompletedTasksQuery({
 *   variables: {
 *      primaryFilter: // value for 'primaryFilter'
 *   },
 * });
 */
export function useMyCompletedTasksQuery(baseOptions?: Apollo.QueryHookOptions<MyCompletedTasksQuery, MyCompletedTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCompletedTasksQuery, MyCompletedTasksQueryVariables>(MyCompletedTasksDocument, options);
      }
export function useMyCompletedTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCompletedTasksQuery, MyCompletedTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCompletedTasksQuery, MyCompletedTasksQueryVariables>(MyCompletedTasksDocument, options);
        }
export type MyCompletedTasksQueryHookResult = ReturnType<typeof useMyCompletedTasksQuery>;
export type MyCompletedTasksLazyQueryHookResult = ReturnType<typeof useMyCompletedTasksLazyQuery>;
export type MyCompletedTasksQueryResult = Apollo.QueryResult<MyCompletedTasksQuery, MyCompletedTasksQueryVariables>;
export const MyOpenTasksByDateDocument = gql`
    query MyOpenTasksByDate($primaryFilter: TaskPrimaryFilterInput, $todayStartTime: ISO8601DateTime!) {
  tasksOverdue: tasks(
    primaryFilter: $primaryFilter
    filter: {status: PENDING, timeFrame: {timeFrame: OVERDUE, todayStartTime: $todayStartTime}}
    page: 1
    perPage: 1000
  ) {
    entries {
      ...MyTaskListRowByDate
    }
    pageInfo {
      totalEntries
    }
  }
  tasksToday: tasks(
    primaryFilter: $primaryFilter
    filter: {status: PENDING, timeFrame: {timeFrame: TODAY, todayStartTime: $todayStartTime}}
    page: 1
    perPage: 1000
  ) {
    entries {
      ...MyTaskListRowByDate
    }
    pageInfo {
      totalEntries
    }
  }
  tasksUpcoming: tasks(
    primaryFilter: $primaryFilter
    filter: {status: PENDING, timeFrame: {timeFrame: UPCOMING, todayStartTime: $todayStartTime}}
    page: 1
    perPage: 1000
  ) {
    entries {
      ...MyTaskListRowByDate
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${MyTaskListRowByDateFragmentDoc}`;

/**
 * __useMyOpenTasksByDateQuery__
 *
 * To run a query within a React component, call `useMyOpenTasksByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOpenTasksByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOpenTasksByDateQuery({
 *   variables: {
 *      primaryFilter: // value for 'primaryFilter'
 *      todayStartTime: // value for 'todayStartTime'
 *   },
 * });
 */
export function useMyOpenTasksByDateQuery(baseOptions: Apollo.QueryHookOptions<MyOpenTasksByDateQuery, MyOpenTasksByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyOpenTasksByDateQuery, MyOpenTasksByDateQueryVariables>(MyOpenTasksByDateDocument, options);
      }
export function useMyOpenTasksByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOpenTasksByDateQuery, MyOpenTasksByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyOpenTasksByDateQuery, MyOpenTasksByDateQueryVariables>(MyOpenTasksByDateDocument, options);
        }
export type MyOpenTasksByDateQueryHookResult = ReturnType<typeof useMyOpenTasksByDateQuery>;
export type MyOpenTasksByDateLazyQueryHookResult = ReturnType<typeof useMyOpenTasksByDateLazyQuery>;
export type MyOpenTasksByDateQueryResult = Apollo.QueryResult<MyOpenTasksByDateQuery, MyOpenTasksByDateQueryVariables>;
export const CreateContactListDocument = gql`
    mutation CreateContactList($name: String!, $usageMode: UsageModeInput, $allowDuplicates: Boolean) {
  createList(
    name: $name
    usageMode: $usageMode
    allowDuplicates: $allowDuplicates
  ) {
    id
    failReasons
  }
}
    `;
export type CreateContactListMutationFn = Apollo.MutationFunction<CreateContactListMutation, CreateContactListMutationVariables>;

/**
 * __useCreateContactListMutation__
 *
 * To run a mutation, you first call `useCreateContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactListMutation, { data, loading, error }] = useCreateContactListMutation({
 *   variables: {
 *      name: // value for 'name'
 *      usageMode: // value for 'usageMode'
 *      allowDuplicates: // value for 'allowDuplicates'
 *   },
 * });
 */
export function useCreateContactListMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactListMutation, CreateContactListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactListMutation, CreateContactListMutationVariables>(CreateContactListDocument, options);
      }
export type CreateContactListMutationHookResult = ReturnType<typeof useCreateContactListMutation>;
export type CreateContactListMutationResult = Apollo.MutationResult<CreateContactListMutation>;
export type CreateContactListMutationOptions = Apollo.BaseMutationOptions<CreateContactListMutation, CreateContactListMutationVariables>;
export const CreateMyListCompanyListDocument = gql`
    mutation CreateMyListCompanyList($name: String!) {
  createCompanyList(name: $name) {
    id
    failReasons
  }
}
    `;
export type CreateMyListCompanyListMutationFn = Apollo.MutationFunction<CreateMyListCompanyListMutation, CreateMyListCompanyListMutationVariables>;

/**
 * __useCreateMyListCompanyListMutation__
 *
 * To run a mutation, you first call `useCreateMyListCompanyListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyListCompanyListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyListCompanyListMutation, { data, loading, error }] = useCreateMyListCompanyListMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateMyListCompanyListMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyListCompanyListMutation, CreateMyListCompanyListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyListCompanyListMutation, CreateMyListCompanyListMutationVariables>(CreateMyListCompanyListDocument, options);
      }
export type CreateMyListCompanyListMutationHookResult = ReturnType<typeof useCreateMyListCompanyListMutation>;
export type CreateMyListCompanyListMutationResult = Apollo.MutationResult<CreateMyListCompanyListMutation>;
export type CreateMyListCompanyListMutationOptions = Apollo.BaseMutationOptions<CreateMyListCompanyListMutation, CreateMyListCompanyListMutationVariables>;
export const CreateMyListGenericListDocument = gql`
    mutation CreateMyListGenericList($title: String!) {
  createGenericList(title: $title) {
    failReasons
    record {
      id
      title
    }
  }
}
    `;
export type CreateMyListGenericListMutationFn = Apollo.MutationFunction<CreateMyListGenericListMutation, CreateMyListGenericListMutationVariables>;

/**
 * __useCreateMyListGenericListMutation__
 *
 * To run a mutation, you first call `useCreateMyListGenericListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyListGenericListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyListGenericListMutation, { data, loading, error }] = useCreateMyListGenericListMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateMyListGenericListMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyListGenericListMutation, CreateMyListGenericListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyListGenericListMutation, CreateMyListGenericListMutationVariables>(CreateMyListGenericListDocument, options);
      }
export type CreateMyListGenericListMutationHookResult = ReturnType<typeof useCreateMyListGenericListMutation>;
export type CreateMyListGenericListMutationResult = Apollo.MutationResult<CreateMyListGenericListMutation>;
export type CreateMyListGenericListMutationOptions = Apollo.BaseMutationOptions<CreateMyListGenericListMutation, CreateMyListGenericListMutationVariables>;
export const MyListCompanyListDocument = gql`
    query MyListCompanyList($uuid: ID!) {
  companyList(uuid: $uuid) {
    id
    name
  }
}
    `;

/**
 * __useMyListCompanyListQuery__
 *
 * To run a query within a React component, call `useMyListCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyListCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyListCompanyListQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useMyListCompanyListQuery(baseOptions: Apollo.QueryHookOptions<MyListCompanyListQuery, MyListCompanyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyListCompanyListQuery, MyListCompanyListQueryVariables>(MyListCompanyListDocument, options);
      }
export function useMyListCompanyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyListCompanyListQuery, MyListCompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyListCompanyListQuery, MyListCompanyListQueryVariables>(MyListCompanyListDocument, options);
        }
export type MyListCompanyListQueryHookResult = ReturnType<typeof useMyListCompanyListQuery>;
export type MyListCompanyListLazyQueryHookResult = ReturnType<typeof useMyListCompanyListLazyQuery>;
export type MyListCompanyListQueryResult = Apollo.QueryResult<MyListCompanyListQuery, MyListCompanyListQueryVariables>;
export const MyListGenericListDocument = gql`
    query MyListGenericList($uid: ID!) {
  genericList(uid: $uid) {
    id
    title
  }
}
    `;

/**
 * __useMyListGenericListQuery__
 *
 * To run a query within a React component, call `useMyListGenericListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyListGenericListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyListGenericListQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useMyListGenericListQuery(baseOptions: Apollo.QueryHookOptions<MyListGenericListQuery, MyListGenericListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyListGenericListQuery, MyListGenericListQueryVariables>(MyListGenericListDocument, options);
      }
export function useMyListGenericListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyListGenericListQuery, MyListGenericListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyListGenericListQuery, MyListGenericListQueryVariables>(MyListGenericListDocument, options);
        }
export type MyListGenericListQueryHookResult = ReturnType<typeof useMyListGenericListQuery>;
export type MyListGenericListLazyQueryHookResult = ReturnType<typeof useMyListGenericListLazyQuery>;
export type MyListGenericListQueryResult = Apollo.QueryResult<MyListGenericListQuery, MyListGenericListQueryVariables>;
export const MyListsDocument = gql`
    query MyLists($scope: MyListScope, $listType: MyListList, $term: String) {
  myLists(scope: $scope, listType: $listType, term: $term) {
    entries {
      ...MyListsRow
    }
  }
}
    ${MyListsRowFragmentDoc}`;

/**
 * __useMyListsQuery__
 *
 * To run a query within a React component, call `useMyListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyListsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      listType: // value for 'listType'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useMyListsQuery(baseOptions?: Apollo.QueryHookOptions<MyListsQuery, MyListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyListsQuery, MyListsQueryVariables>(MyListsDocument, options);
      }
export function useMyListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyListsQuery, MyListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyListsQuery, MyListsQueryVariables>(MyListsDocument, options);
        }
export type MyListsQueryHookResult = ReturnType<typeof useMyListsQuery>;
export type MyListsLazyQueryHookResult = ReturnType<typeof useMyListsLazyQuery>;
export type MyListsQueryResult = Apollo.QueryResult<MyListsQuery, MyListsQueryVariables>;
export const ArchiveGenericListDocument = gql`
    mutation ArchiveGenericList($uid: ID!) {
  archiveGenericList(genericListUid: $uid) {
    failReasons
  }
}
    `;
export type ArchiveGenericListMutationFn = Apollo.MutationFunction<ArchiveGenericListMutation, ArchiveGenericListMutationVariables>;

/**
 * __useArchiveGenericListMutation__
 *
 * To run a mutation, you first call `useArchiveGenericListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveGenericListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveGenericListMutation, { data, loading, error }] = useArchiveGenericListMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useArchiveGenericListMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveGenericListMutation, ArchiveGenericListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveGenericListMutation, ArchiveGenericListMutationVariables>(ArchiveGenericListDocument, options);
      }
export type ArchiveGenericListMutationHookResult = ReturnType<typeof useArchiveGenericListMutation>;
export type ArchiveGenericListMutationResult = Apollo.MutationResult<ArchiveGenericListMutation>;
export type ArchiveGenericListMutationOptions = Apollo.BaseMutationOptions<ArchiveGenericListMutation, ArchiveGenericListMutationVariables>;
export const RenameCompanyListDocument = gql`
    mutation RenameCompanyList($uid: ID!, $name: String) {
  updateCompanyList(uid: $uid, name: $name) {
    failReasons
  }
}
    `;
export type RenameCompanyListMutationFn = Apollo.MutationFunction<RenameCompanyListMutation, RenameCompanyListMutationVariables>;

/**
 * __useRenameCompanyListMutation__
 *
 * To run a mutation, you first call `useRenameCompanyListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameCompanyListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameCompanyListMutation, { data, loading, error }] = useRenameCompanyListMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameCompanyListMutation(baseOptions?: Apollo.MutationHookOptions<RenameCompanyListMutation, RenameCompanyListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameCompanyListMutation, RenameCompanyListMutationVariables>(RenameCompanyListDocument, options);
      }
export type RenameCompanyListMutationHookResult = ReturnType<typeof useRenameCompanyListMutation>;
export type RenameCompanyListMutationResult = Apollo.MutationResult<RenameCompanyListMutation>;
export type RenameCompanyListMutationOptions = Apollo.BaseMutationOptions<RenameCompanyListMutation, RenameCompanyListMutationVariables>;
export const RenameContactListDocument = gql`
    mutation RenameContactList($uid: ID!, $name: String) {
  updateList(uid: $uid, name: $name) {
    failReasons
  }
}
    `;
export type RenameContactListMutationFn = Apollo.MutationFunction<RenameContactListMutation, RenameContactListMutationVariables>;

/**
 * __useRenameContactListMutation__
 *
 * To run a mutation, you first call `useRenameContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameContactListMutation, { data, loading, error }] = useRenameContactListMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameContactListMutation(baseOptions?: Apollo.MutationHookOptions<RenameContactListMutation, RenameContactListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameContactListMutation, RenameContactListMutationVariables>(RenameContactListDocument, options);
      }
export type RenameContactListMutationHookResult = ReturnType<typeof useRenameContactListMutation>;
export type RenameContactListMutationResult = Apollo.MutationResult<RenameContactListMutation>;
export type RenameContactListMutationOptions = Apollo.BaseMutationOptions<RenameContactListMutation, RenameContactListMutationVariables>;
export const RenameGenericListDocument = gql`
    mutation RenameGenericList($genericListUid: ID!, $name: String!) {
  updateGenericList(genericListUid: $genericListUid, name: $name) {
    failReasons
  }
}
    `;
export type RenameGenericListMutationFn = Apollo.MutationFunction<RenameGenericListMutation, RenameGenericListMutationVariables>;

/**
 * __useRenameGenericListMutation__
 *
 * To run a mutation, you first call `useRenameGenericListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameGenericListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameGenericListMutation, { data, loading, error }] = useRenameGenericListMutation({
 *   variables: {
 *      genericListUid: // value for 'genericListUid'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameGenericListMutation(baseOptions?: Apollo.MutationHookOptions<RenameGenericListMutation, RenameGenericListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameGenericListMutation, RenameGenericListMutationVariables>(RenameGenericListDocument, options);
      }
export type RenameGenericListMutationHookResult = ReturnType<typeof useRenameGenericListMutation>;
export type RenameGenericListMutationResult = Apollo.MutationResult<RenameGenericListMutation>;
export type RenameGenericListMutationOptions = Apollo.BaseMutationOptions<RenameGenericListMutation, RenameGenericListMutationVariables>;
export const RemoveUserAccessDocument = gql`
    mutation RemoveUserAccess($userUid: String!, $listUid: String!, $listType: MyListList!) {
  removeMyListShareAccess(
    userUid: $userUid
    listUid: $listUid
    listType: $listType
  ) {
    failReasons
  }
}
    `;
export type RemoveUserAccessMutationFn = Apollo.MutationFunction<RemoveUserAccessMutation, RemoveUserAccessMutationVariables>;

/**
 * __useRemoveUserAccessMutation__
 *
 * To run a mutation, you first call `useRemoveUserAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserAccessMutation, { data, loading, error }] = useRemoveUserAccessMutation({
 *   variables: {
 *      userUid: // value for 'userUid'
 *      listUid: // value for 'listUid'
 *      listType: // value for 'listType'
 *   },
 * });
 */
export function useRemoveUserAccessMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserAccessMutation, RemoveUserAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserAccessMutation, RemoveUserAccessMutationVariables>(RemoveUserAccessDocument, options);
      }
export type RemoveUserAccessMutationHookResult = ReturnType<typeof useRemoveUserAccessMutation>;
export type RemoveUserAccessMutationResult = Apollo.MutationResult<RemoveUserAccessMutation>;
export type RemoveUserAccessMutationOptions = Apollo.BaseMutationOptions<RemoveUserAccessMutation, RemoveUserAccessMutationVariables>;
export const ShareAccessUsersDocument = gql`
    query ShareAccessUsers($listUid: ID!, $listType: MyListList!) {
  sharedMyListUsers(listUid: $listUid, listType: $listType) {
    entries {
      ...ShareAccessUsersRow
    }
  }
}
    ${ShareAccessUsersRowFragmentDoc}`;

/**
 * __useShareAccessUsersQuery__
 *
 * To run a query within a React component, call `useShareAccessUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareAccessUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareAccessUsersQuery({
 *   variables: {
 *      listUid: // value for 'listUid'
 *      listType: // value for 'listType'
 *   },
 * });
 */
export function useShareAccessUsersQuery(baseOptions: Apollo.QueryHookOptions<ShareAccessUsersQuery, ShareAccessUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShareAccessUsersQuery, ShareAccessUsersQueryVariables>(ShareAccessUsersDocument, options);
      }
export function useShareAccessUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShareAccessUsersQuery, ShareAccessUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShareAccessUsersQuery, ShareAccessUsersQueryVariables>(ShareAccessUsersDocument, options);
        }
export type ShareAccessUsersQueryHookResult = ReturnType<typeof useShareAccessUsersQuery>;
export type ShareAccessUsersLazyQueryHookResult = ReturnType<typeof useShareAccessUsersLazyQuery>;
export type ShareAccessUsersQueryResult = Apollo.QueryResult<ShareAccessUsersQuery, ShareAccessUsersQueryVariables>;
export const ShareListCompanyDocument = gql`
    mutation ShareListCompany($companyListUid: ID!, $permission: MyListPermission!, $sharedWithUids: [String!]!) {
  shareCompanyList(
    companyListUid: $companyListUid
    permission: $permission
    sharedWithUids: $sharedWithUids
  ) {
    failReasons
  }
}
    `;
export type ShareListCompanyMutationFn = Apollo.MutationFunction<ShareListCompanyMutation, ShareListCompanyMutationVariables>;

/**
 * __useShareListCompanyMutation__
 *
 * To run a mutation, you first call `useShareListCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareListCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareListCompanyMutation, { data, loading, error }] = useShareListCompanyMutation({
 *   variables: {
 *      companyListUid: // value for 'companyListUid'
 *      permission: // value for 'permission'
 *      sharedWithUids: // value for 'sharedWithUids'
 *   },
 * });
 */
export function useShareListCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ShareListCompanyMutation, ShareListCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareListCompanyMutation, ShareListCompanyMutationVariables>(ShareListCompanyDocument, options);
      }
export type ShareListCompanyMutationHookResult = ReturnType<typeof useShareListCompanyMutation>;
export type ShareListCompanyMutationResult = Apollo.MutationResult<ShareListCompanyMutation>;
export type ShareListCompanyMutationOptions = Apollo.BaseMutationOptions<ShareListCompanyMutation, ShareListCompanyMutationVariables>;
export const ShareListContactDocument = gql`
    mutation ShareListContact($contactListUid: ID!, $permission: MyListPermission!, $sharedWithUids: [String!]!) {
  shareContactList(
    contactListUid: $contactListUid
    permission: $permission
    sharedWithUids: $sharedWithUids
  ) {
    failReasons
  }
}
    `;
export type ShareListContactMutationFn = Apollo.MutationFunction<ShareListContactMutation, ShareListContactMutationVariables>;

/**
 * __useShareListContactMutation__
 *
 * To run a mutation, you first call `useShareListContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareListContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareListContactMutation, { data, loading, error }] = useShareListContactMutation({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *      permission: // value for 'permission'
 *      sharedWithUids: // value for 'sharedWithUids'
 *   },
 * });
 */
export function useShareListContactMutation(baseOptions?: Apollo.MutationHookOptions<ShareListContactMutation, ShareListContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareListContactMutation, ShareListContactMutationVariables>(ShareListContactDocument, options);
      }
export type ShareListContactMutationHookResult = ReturnType<typeof useShareListContactMutation>;
export type ShareListContactMutationResult = Apollo.MutationResult<ShareListContactMutation>;
export type ShareListContactMutationOptions = Apollo.BaseMutationOptions<ShareListContactMutation, ShareListContactMutationVariables>;
export const ShareListGenericDocument = gql`
    mutation ShareListGeneric($genericListUid: ID!, $permission: MyListPermission!, $sharedWithUids: [String!]!) {
  shareGenericList(
    genericListUid: $genericListUid
    permission: $permission
    sharedWithUids: $sharedWithUids
  ) {
    failReasons
  }
}
    `;
export type ShareListGenericMutationFn = Apollo.MutationFunction<ShareListGenericMutation, ShareListGenericMutationVariables>;

/**
 * __useShareListGenericMutation__
 *
 * To run a mutation, you first call `useShareListGenericMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareListGenericMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareListGenericMutation, { data, loading, error }] = useShareListGenericMutation({
 *   variables: {
 *      genericListUid: // value for 'genericListUid'
 *      permission: // value for 'permission'
 *      sharedWithUids: // value for 'sharedWithUids'
 *   },
 * });
 */
export function useShareListGenericMutation(baseOptions?: Apollo.MutationHookOptions<ShareListGenericMutation, ShareListGenericMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareListGenericMutation, ShareListGenericMutationVariables>(ShareListGenericDocument, options);
      }
export type ShareListGenericMutationHookResult = ReturnType<typeof useShareListGenericMutation>;
export type ShareListGenericMutationResult = Apollo.MutationResult<ShareListGenericMutation>;
export type ShareListGenericMutationOptions = Apollo.BaseMutationOptions<ShareListGenericMutation, ShareListGenericMutationVariables>;
export const AdminMenuDocument = gql`
    query AdminMenu {
  config {
    id
    adminReportingEnabled
  }
  interactionsConfig: interactionsConfiguration {
    id
    keyActivityTitlesRecommendedGroup
  }
  tenantConfiguration {
    id
    showInternalIndustries
  }
  marketingListConfiguration {
    id
    enableEms
  }
}
    `;

/**
 * __useAdminMenuQuery__
 *
 * To run a query within a React component, call `useAdminMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminMenuQuery(baseOptions?: Apollo.QueryHookOptions<AdminMenuQuery, AdminMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMenuQuery, AdminMenuQueryVariables>(AdminMenuDocument, options);
      }
export function useAdminMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMenuQuery, AdminMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMenuQuery, AdminMenuQueryVariables>(AdminMenuDocument, options);
        }
export type AdminMenuQueryHookResult = ReturnType<typeof useAdminMenuQuery>;
export type AdminMenuLazyQueryHookResult = ReturnType<typeof useAdminMenuLazyQuery>;
export type AdminMenuQueryResult = Apollo.QueryResult<AdminMenuQuery, AdminMenuQueryVariables>;
export const NavUserInfoDocument = gql`
    query NavUserInfo {
  currentUser {
    id
    firstName
    lastName
    profileImageUrl
    email
  }
}
    `;

/**
 * __useNavUserInfoQuery__
 *
 * To run a query within a React component, call `useNavUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<NavUserInfoQuery, NavUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavUserInfoQuery, NavUserInfoQueryVariables>(NavUserInfoDocument, options);
      }
export function useNavUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavUserInfoQuery, NavUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavUserInfoQuery, NavUserInfoQueryVariables>(NavUserInfoDocument, options);
        }
export type NavUserInfoQueryHookResult = ReturnType<typeof useNavUserInfoQuery>;
export type NavUserInfoLazyQueryHookResult = ReturnType<typeof useNavUserInfoLazyQuery>;
export type NavUserInfoQueryResult = Apollo.QueryResult<NavUserInfoQuery, NavUserInfoQueryVariables>;
export const SideNavDocument = gql`
    query SideNav($currentUserEmployeeId: ID!) {
  individualConsented {
    isRequired
    url
  }
  myTasks(scope: MY_TASKS, status: PENDING) {
    id
    total
  }
  tasks(
    primaryFilter: {sourceType: MY_TASKS, sourceUid: $currentUserEmployeeId}
    filter: {status: PENDING}
  ) {
    pageInfo {
      totalEntries
    }
  }
  myStayInTouch(overDueOnly: true) {
    pageInfo {
      totalEntries
    }
  }
  upcomingMeetings: meetings(timeScope: FUTURE, ownership: USER) {
    pageInfo {
      totalEntries
    }
  }
  opportunityTrackingConfiguration {
    id
    visibleFirmWide
  }
  microsoftAdminConsentDetail {
    consents {
      name
      consentUrl
    }
  }
  emailMarketingConfiguration {
    id
    enabled
  }
  userRoleCorePermissions {
    id
    allContacts
    allCompanies
  }
  userRoleObjectiveManagementPermissions {
    id
    allObjectives
  }
  userRoleOpportunityTrackingPermissions {
    id
    allOpportunities
  }
  userRoleEnrichmentPermissions {
    id
    allProspects
  }
  everAfterStatus {
    id
    enabled
    hasPersona
  }
}
    `;

/**
 * __useSideNavQuery__
 *
 * To run a query within a React component, call `useSideNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useSideNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSideNavQuery({
 *   variables: {
 *      currentUserEmployeeId: // value for 'currentUserEmployeeId'
 *   },
 * });
 */
export function useSideNavQuery(baseOptions: Apollo.QueryHookOptions<SideNavQuery, SideNavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SideNavQuery, SideNavQueryVariables>(SideNavDocument, options);
      }
export function useSideNavLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SideNavQuery, SideNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SideNavQuery, SideNavQueryVariables>(SideNavDocument, options);
        }
export type SideNavQueryHookResult = ReturnType<typeof useSideNavQuery>;
export type SideNavLazyQueryHookResult = ReturnType<typeof useSideNavLazyQuery>;
export type SideNavQueryResult = Apollo.QueryResult<SideNavQuery, SideNavQueryVariables>;
export const ArchiveCompanyNoteDocument = gql`
    mutation ArchiveCompanyNote($uuid: ID!) {
  archiveCompanyNote(uuid: $uuid) {
    failReasons
  }
}
    `;
export type ArchiveCompanyNoteMutationFn = Apollo.MutationFunction<ArchiveCompanyNoteMutation, ArchiveCompanyNoteMutationVariables>;

/**
 * __useArchiveCompanyNoteMutation__
 *
 * To run a mutation, you first call `useArchiveCompanyNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCompanyNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCompanyNoteMutation, { data, loading, error }] = useArchiveCompanyNoteMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useArchiveCompanyNoteMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCompanyNoteMutation, ArchiveCompanyNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCompanyNoteMutation, ArchiveCompanyNoteMutationVariables>(ArchiveCompanyNoteDocument, options);
      }
export type ArchiveCompanyNoteMutationHookResult = ReturnType<typeof useArchiveCompanyNoteMutation>;
export type ArchiveCompanyNoteMutationResult = Apollo.MutationResult<ArchiveCompanyNoteMutation>;
export type ArchiveCompanyNoteMutationOptions = Apollo.BaseMutationOptions<ArchiveCompanyNoteMutation, ArchiveCompanyNoteMutationVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($companyUid: ID!, $contactUid: ID, $content: String!, $access: CompanyNoteAccess) {
  createCompanyNote(
    companyUid: $companyUid
    contactUid: $contactUid
    content: $content
    access: $access
  ) {
    failReasons
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      contactUid: // value for 'contactUid'
 *      content: // value for 'content'
 *      access: // value for 'access'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const GetPersonNotesDocument = gql`
    query GetPersonNotes($personUid: String!, $page: Int, $perPage: Int) {
  notes: personNotes(personUid: $personUid, page: $page, perPage: $perPage) {
    entries {
      ...CompanyNote
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${CompanyNoteFragmentDoc}`;

/**
 * __useGetPersonNotesQuery__
 *
 * To run a query within a React component, call `useGetPersonNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonNotesQuery({
 *   variables: {
 *      personUid: // value for 'personUid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetPersonNotesQuery(baseOptions: Apollo.QueryHookOptions<GetPersonNotesQuery, GetPersonNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonNotesQuery, GetPersonNotesQueryVariables>(GetPersonNotesDocument, options);
      }
export function useGetPersonNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonNotesQuery, GetPersonNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonNotesQuery, GetPersonNotesQueryVariables>(GetPersonNotesDocument, options);
        }
export type GetPersonNotesQueryHookResult = ReturnType<typeof useGetPersonNotesQuery>;
export type GetPersonNotesLazyQueryHookResult = ReturnType<typeof useGetPersonNotesLazyQuery>;
export type GetPersonNotesQueryResult = Apollo.QueryResult<GetPersonNotesQuery, GetPersonNotesQueryVariables>;
export const UpdateCompanyNoteDocument = gql`
    mutation UpdateCompanyNote($uid: ID!, $content: String!, $access: CompanyNoteAccess) {
  updateCompanyNote(uid: $uid, content: $content, access: $access) {
    failReasons
  }
}
    `;
export type UpdateCompanyNoteMutationFn = Apollo.MutationFunction<UpdateCompanyNoteMutation, UpdateCompanyNoteMutationVariables>;

/**
 * __useUpdateCompanyNoteMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyNoteMutation, { data, loading, error }] = useUpdateCompanyNoteMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      content: // value for 'content'
 *      access: // value for 'access'
 *   },
 * });
 */
export function useUpdateCompanyNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyNoteMutation, UpdateCompanyNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyNoteMutation, UpdateCompanyNoteMutationVariables>(UpdateCompanyNoteDocument, options);
      }
export type UpdateCompanyNoteMutationHookResult = ReturnType<typeof useUpdateCompanyNoteMutation>;
export type UpdateCompanyNoteMutationResult = Apollo.MutationResult<UpdateCompanyNoteMutation>;
export type UpdateCompanyNoteMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyNoteMutation, UpdateCompanyNoteMutationVariables>;
export const AllObjectivesDocument = gql`
    query AllObjectives($groupBy: ObjectiveGroupBy, $status: ObjectiveStatus, $term: String) {
  allObjectives(groupBy: $groupBy, status: $status, term: $term) {
    group
    objectives {
      ...ObjectiveListItem
    }
  }
}
    ${ObjectiveListItemFragmentDoc}`;

/**
 * __useAllObjectivesQuery__
 *
 * To run a query within a React component, call `useAllObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllObjectivesQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      status: // value for 'status'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useAllObjectivesQuery(baseOptions?: Apollo.QueryHookOptions<AllObjectivesQuery, AllObjectivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllObjectivesQuery, AllObjectivesQueryVariables>(AllObjectivesDocument, options);
      }
export function useAllObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllObjectivesQuery, AllObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllObjectivesQuery, AllObjectivesQueryVariables>(AllObjectivesDocument, options);
        }
export type AllObjectivesQueryHookResult = ReturnType<typeof useAllObjectivesQuery>;
export type AllObjectivesLazyQueryHookResult = ReturnType<typeof useAllObjectivesLazyQuery>;
export type AllObjectivesQueryResult = Apollo.QueryResult<AllObjectivesQuery, AllObjectivesQueryVariables>;
export const CreateObjectiveDocument = gql`
    mutation CreateObjective($attributes: ObjectiveAttribute!) {
  createObjective(attributes: $attributes) {
    failReasons
    objectiveUuid
  }
}
    `;
export type CreateObjectiveMutationFn = Apollo.MutationFunction<CreateObjectiveMutation, CreateObjectiveMutationVariables>;

/**
 * __useCreateObjectiveMutation__
 *
 * To run a mutation, you first call `useCreateObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObjectiveMutation, { data, loading, error }] = useCreateObjectiveMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateObjectiveMutation, CreateObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateObjectiveMutation, CreateObjectiveMutationVariables>(CreateObjectiveDocument, options);
      }
export type CreateObjectiveMutationHookResult = ReturnType<typeof useCreateObjectiveMutation>;
export type CreateObjectiveMutationResult = Apollo.MutationResult<CreateObjectiveMutation>;
export type CreateObjectiveMutationOptions = Apollo.BaseMutationOptions<CreateObjectiveMutation, CreateObjectiveMutationVariables>;
export const MyObjectivesDocument = gql`
    query MyObjectives($page: Int = 1, $perPage: Int = 10, $status: ObjectiveStatus = ACTIVE, $term: String = "") {
  myObjectives(page: $page, perPage: $perPage, status: $status, term: $term) {
    entries {
      ...ObjectiveListItem
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ObjectiveListItemFragmentDoc}`;

/**
 * __useMyObjectivesQuery__
 *
 * To run a query within a React component, call `useMyObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyObjectivesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      status: // value for 'status'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useMyObjectivesQuery(baseOptions?: Apollo.QueryHookOptions<MyObjectivesQuery, MyObjectivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyObjectivesQuery, MyObjectivesQueryVariables>(MyObjectivesDocument, options);
      }
export function useMyObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyObjectivesQuery, MyObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyObjectivesQuery, MyObjectivesQueryVariables>(MyObjectivesDocument, options);
        }
export type MyObjectivesQueryHookResult = ReturnType<typeof useMyObjectivesQuery>;
export type MyObjectivesLazyQueryHookResult = ReturnType<typeof useMyObjectivesLazyQuery>;
export type MyObjectivesQueryResult = Apollo.QueryResult<MyObjectivesQuery, MyObjectivesQueryVariables>;
export const ObjectiveDocument = gql`
    query Objective($objectiveUuid: ID!) {
  objective(objectiveUuid: $objectiveUuid) {
    ...ObjectiveDetails
  }
}
    ${ObjectiveDetailsFragmentDoc}`;

/**
 * __useObjectiveQuery__
 *
 * To run a query within a React component, call `useObjectiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectiveQuery({
 *   variables: {
 *      objectiveUuid: // value for 'objectiveUuid'
 *   },
 * });
 */
export function useObjectiveQuery(baseOptions: Apollo.QueryHookOptions<ObjectiveQuery, ObjectiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjectiveQuery, ObjectiveQueryVariables>(ObjectiveDocument, options);
      }
export function useObjectiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjectiveQuery, ObjectiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjectiveQuery, ObjectiveQueryVariables>(ObjectiveDocument, options);
        }
export type ObjectiveQueryHookResult = ReturnType<typeof useObjectiveQuery>;
export type ObjectiveLazyQueryHookResult = ReturnType<typeof useObjectiveLazyQuery>;
export type ObjectiveQueryResult = Apollo.QueryResult<ObjectiveQuery, ObjectiveQueryVariables>;
export const UpdateObjectiveDocument = gql`
    mutation UpdateObjective($objectiveUuid: ID!, $attributes: ObjectiveAttribute!) {
  updateObjective(objectiveUuid: $objectiveUuid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type UpdateObjectiveMutationFn = Apollo.MutationFunction<UpdateObjectiveMutation, UpdateObjectiveMutationVariables>;

/**
 * __useUpdateObjectiveMutation__
 *
 * To run a mutation, you first call `useUpdateObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjectiveMutation, { data, loading, error }] = useUpdateObjectiveMutation({
 *   variables: {
 *      objectiveUuid: // value for 'objectiveUuid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateObjectiveMutation, UpdateObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateObjectiveMutation, UpdateObjectiveMutationVariables>(UpdateObjectiveDocument, options);
      }
export type UpdateObjectiveMutationHookResult = ReturnType<typeof useUpdateObjectiveMutation>;
export type UpdateObjectiveMutationResult = Apollo.MutationResult<UpdateObjectiveMutation>;
export type UpdateObjectiveMutationOptions = Apollo.BaseMutationOptions<UpdateObjectiveMutation, UpdateObjectiveMutationVariables>;
export const CreateObjectiveProgressDocument = gql`
    mutation CreateObjectiveProgress($objectiveUuid: ID!, $progressAttributes: ProgressAttribute!) {
  createObjectiveProgress(
    objectiveUuid: $objectiveUuid
    progressAttributes: $progressAttributes
  ) {
    failReasons
  }
}
    `;
export type CreateObjectiveProgressMutationFn = Apollo.MutationFunction<CreateObjectiveProgressMutation, CreateObjectiveProgressMutationVariables>;

/**
 * __useCreateObjectiveProgressMutation__
 *
 * To run a mutation, you first call `useCreateObjectiveProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObjectiveProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObjectiveProgressMutation, { data, loading, error }] = useCreateObjectiveProgressMutation({
 *   variables: {
 *      objectiveUuid: // value for 'objectiveUuid'
 *      progressAttributes: // value for 'progressAttributes'
 *   },
 * });
 */
export function useCreateObjectiveProgressMutation(baseOptions?: Apollo.MutationHookOptions<CreateObjectiveProgressMutation, CreateObjectiveProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateObjectiveProgressMutation, CreateObjectiveProgressMutationVariables>(CreateObjectiveProgressDocument, options);
      }
export type CreateObjectiveProgressMutationHookResult = ReturnType<typeof useCreateObjectiveProgressMutation>;
export type CreateObjectiveProgressMutationResult = Apollo.MutationResult<CreateObjectiveProgressMutation>;
export type CreateObjectiveProgressMutationOptions = Apollo.BaseMutationOptions<CreateObjectiveProgressMutation, CreateObjectiveProgressMutationVariables>;
export const RemoveObjectiveProgressDocument = gql`
    mutation RemoveObjectiveProgress($progressUuid: ID!) {
  removeObjectiveProgress(progressUuid: $progressUuid) {
    failReasons
  }
}
    `;
export type RemoveObjectiveProgressMutationFn = Apollo.MutationFunction<RemoveObjectiveProgressMutation, RemoveObjectiveProgressMutationVariables>;

/**
 * __useRemoveObjectiveProgressMutation__
 *
 * To run a mutation, you first call `useRemoveObjectiveProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveObjectiveProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeObjectiveProgressMutation, { data, loading, error }] = useRemoveObjectiveProgressMutation({
 *   variables: {
 *      progressUuid: // value for 'progressUuid'
 *   },
 * });
 */
export function useRemoveObjectiveProgressMutation(baseOptions?: Apollo.MutationHookOptions<RemoveObjectiveProgressMutation, RemoveObjectiveProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveObjectiveProgressMutation, RemoveObjectiveProgressMutationVariables>(RemoveObjectiveProgressDocument, options);
      }
export type RemoveObjectiveProgressMutationHookResult = ReturnType<typeof useRemoveObjectiveProgressMutation>;
export type RemoveObjectiveProgressMutationResult = Apollo.MutationResult<RemoveObjectiveProgressMutation>;
export type RemoveObjectiveProgressMutationOptions = Apollo.BaseMutationOptions<RemoveObjectiveProgressMutation, RemoveObjectiveProgressMutationVariables>;
export const UpdateObjectiveProgressDocument = gql`
    mutation UpdateObjectiveProgress($progressUuid: ID!, $progressAttributes: ProgressAttribute!) {
  updateObjectiveProgress(
    progressUuid: $progressUuid
    progressAttributes: $progressAttributes
  ) {
    failReasons
  }
}
    `;
export type UpdateObjectiveProgressMutationFn = Apollo.MutationFunction<UpdateObjectiveProgressMutation, UpdateObjectiveProgressMutationVariables>;

/**
 * __useUpdateObjectiveProgressMutation__
 *
 * To run a mutation, you first call `useUpdateObjectiveProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjectiveProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjectiveProgressMutation, { data, loading, error }] = useUpdateObjectiveProgressMutation({
 *   variables: {
 *      progressUuid: // value for 'progressUuid'
 *      progressAttributes: // value for 'progressAttributes'
 *   },
 * });
 */
export function useUpdateObjectiveProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateObjectiveProgressMutation, UpdateObjectiveProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateObjectiveProgressMutation, UpdateObjectiveProgressMutationVariables>(UpdateObjectiveProgressDocument, options);
      }
export type UpdateObjectiveProgressMutationHookResult = ReturnType<typeof useUpdateObjectiveProgressMutation>;
export type UpdateObjectiveProgressMutationResult = Apollo.MutationResult<UpdateObjectiveProgressMutation>;
export type UpdateObjectiveProgressMutationOptions = Apollo.BaseMutationOptions<UpdateObjectiveProgressMutation, UpdateObjectiveProgressMutationVariables>;
export const OnExportUpdateDocument = gql`
    subscription onExportUpdate($exportId: ID!) {
  exportUpdated(exportUid: $exportId) {
    id
    displayName
    file {
      name
      url
    }
    status
    percentageComplete
    createdAt
  }
}
    `;

/**
 * __useOnExportUpdateSubscription__
 *
 * To run a query within a React component, call `useOnExportUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnExportUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnExportUpdateSubscription({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useOnExportUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnExportUpdateSubscription, OnExportUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnExportUpdateSubscription, OnExportUpdateSubscriptionVariables>(OnExportUpdateDocument, options);
      }
export type OnExportUpdateSubscriptionHookResult = ReturnType<typeof useOnExportUpdateSubscription>;
export type OnExportUpdateSubscriptionResult = Apollo.SubscriptionResult<OnExportUpdateSubscription>;
export const CompanyGoalsCustomStatusDistributionDocument = gql`
    query CompanyGoalsCustomStatusDistribution($term: String, $internalContactEmail: String, $employeeEmail: ID, $referralSource: String, $fromDate: ISO8601Date, $toDate: ISO8601Date, $projectUid: ID) {
  companyGoals(
    filter: {term: $term, ownerUid: $internalContactEmail, withEmployeeUid: $employeeEmail, referralSource: $referralSource, fromDate: $fromDate, toDate: $toDate, projectUid: $projectUid}
  ) {
    customStatusDistribution {
      count
      customStatus {
        ...OpportunityTrackingCustomStatus
      }
      totalProposedFeeAmount {
        format
      }
    }
    totalProposedFeeAmount {
      format
    }
  }
}
    ${OpportunityTrackingCustomStatusFragmentDoc}`;

/**
 * __useCompanyGoalsCustomStatusDistributionQuery__
 *
 * To run a query within a React component, call `useCompanyGoalsCustomStatusDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyGoalsCustomStatusDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyGoalsCustomStatusDistributionQuery({
 *   variables: {
 *      term: // value for 'term'
 *      internalContactEmail: // value for 'internalContactEmail'
 *      employeeEmail: // value for 'employeeEmail'
 *      referralSource: // value for 'referralSource'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      projectUid: // value for 'projectUid'
 *   },
 * });
 */
export function useCompanyGoalsCustomStatusDistributionQuery(baseOptions?: Apollo.QueryHookOptions<CompanyGoalsCustomStatusDistributionQuery, CompanyGoalsCustomStatusDistributionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyGoalsCustomStatusDistributionQuery, CompanyGoalsCustomStatusDistributionQueryVariables>(CompanyGoalsCustomStatusDistributionDocument, options);
      }
export function useCompanyGoalsCustomStatusDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyGoalsCustomStatusDistributionQuery, CompanyGoalsCustomStatusDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyGoalsCustomStatusDistributionQuery, CompanyGoalsCustomStatusDistributionQueryVariables>(CompanyGoalsCustomStatusDistributionDocument, options);
        }
export type CompanyGoalsCustomStatusDistributionQueryHookResult = ReturnType<typeof useCompanyGoalsCustomStatusDistributionQuery>;
export type CompanyGoalsCustomStatusDistributionLazyQueryHookResult = ReturnType<typeof useCompanyGoalsCustomStatusDistributionLazyQuery>;
export type CompanyGoalsCustomStatusDistributionQueryResult = Apollo.QueryResult<CompanyGoalsCustomStatusDistributionQuery, CompanyGoalsCustomStatusDistributionQueryVariables>;
export const GetCompanyGoalDocument = gql`
    query GetCompanyGoal($uid: ID!) {
  companyGoal: opportunity(uid: $uid) {
    ...CompanyGoalPreview
  }
}
    ${CompanyGoalPreviewFragmentDoc}`;

/**
 * __useGetCompanyGoalQuery__
 *
 * To run a query within a React component, call `useGetCompanyGoalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyGoalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyGoalQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetCompanyGoalQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyGoalQuery, GetCompanyGoalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyGoalQuery, GetCompanyGoalQueryVariables>(GetCompanyGoalDocument, options);
      }
export function useGetCompanyGoalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyGoalQuery, GetCompanyGoalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyGoalQuery, GetCompanyGoalQueryVariables>(GetCompanyGoalDocument, options);
        }
export type GetCompanyGoalQueryHookResult = ReturnType<typeof useGetCompanyGoalQuery>;
export type GetCompanyGoalLazyQueryHookResult = ReturnType<typeof useGetCompanyGoalLazyQuery>;
export type GetCompanyGoalQueryResult = Apollo.QueryResult<GetCompanyGoalQuery, GetCompanyGoalQueryVariables>;
export const LinkProjectsToOpportunityDocument = gql`
    mutation LinkProjectsToOpportunity($projectUuids: [ID!]!, $opportunityUuid: ID!) {
  linkProjectsToOpportunity(
    projectUuids: $projectUuids
    opportunityUuid: $opportunityUuid
  ) {
    failReasons
  }
}
    `;
export type LinkProjectsToOpportunityMutationFn = Apollo.MutationFunction<LinkProjectsToOpportunityMutation, LinkProjectsToOpportunityMutationVariables>;

/**
 * __useLinkProjectsToOpportunityMutation__
 *
 * To run a mutation, you first call `useLinkProjectsToOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkProjectsToOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkProjectsToOpportunityMutation, { data, loading, error }] = useLinkProjectsToOpportunityMutation({
 *   variables: {
 *      projectUuids: // value for 'projectUuids'
 *      opportunityUuid: // value for 'opportunityUuid'
 *   },
 * });
 */
export function useLinkProjectsToOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<LinkProjectsToOpportunityMutation, LinkProjectsToOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkProjectsToOpportunityMutation, LinkProjectsToOpportunityMutationVariables>(LinkProjectsToOpportunityDocument, options);
      }
export type LinkProjectsToOpportunityMutationHookResult = ReturnType<typeof useLinkProjectsToOpportunityMutation>;
export type LinkProjectsToOpportunityMutationResult = Apollo.MutationResult<LinkProjectsToOpportunityMutation>;
export type LinkProjectsToOpportunityMutationOptions = Apollo.BaseMutationOptions<LinkProjectsToOpportunityMutation, LinkProjectsToOpportunityMutationVariables>;
export const MoveOpportunitiesOnMyCustomBoardDocument = gql`
    mutation MoveOpportunitiesOnMyCustomBoard($opportunities: [MoveOpportunityInputCustom!]!) {
  moveOpportunitiesOnMyCustomBoard(opportunities: $opportunities) {
    failReasons
  }
}
    `;
export type MoveOpportunitiesOnMyCustomBoardMutationFn = Apollo.MutationFunction<MoveOpportunitiesOnMyCustomBoardMutation, MoveOpportunitiesOnMyCustomBoardMutationVariables>;

/**
 * __useMoveOpportunitiesOnMyCustomBoardMutation__
 *
 * To run a mutation, you first call `useMoveOpportunitiesOnMyCustomBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveOpportunitiesOnMyCustomBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveOpportunitiesOnMyCustomBoardMutation, { data, loading, error }] = useMoveOpportunitiesOnMyCustomBoardMutation({
 *   variables: {
 *      opportunities: // value for 'opportunities'
 *   },
 * });
 */
export function useMoveOpportunitiesOnMyCustomBoardMutation(baseOptions?: Apollo.MutationHookOptions<MoveOpportunitiesOnMyCustomBoardMutation, MoveOpportunitiesOnMyCustomBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveOpportunitiesOnMyCustomBoardMutation, MoveOpportunitiesOnMyCustomBoardMutationVariables>(MoveOpportunitiesOnMyCustomBoardDocument, options);
      }
export type MoveOpportunitiesOnMyCustomBoardMutationHookResult = ReturnType<typeof useMoveOpportunitiesOnMyCustomBoardMutation>;
export type MoveOpportunitiesOnMyCustomBoardMutationResult = Apollo.MutationResult<MoveOpportunitiesOnMyCustomBoardMutation>;
export type MoveOpportunitiesOnMyCustomBoardMutationOptions = Apollo.BaseMutationOptions<MoveOpportunitiesOnMyCustomBoardMutation, MoveOpportunitiesOnMyCustomBoardMutationVariables>;
export const OpportunityAuditTrailDocument = gql`
    query OpportunityAuditTrail($opportunityUid: ID!) {
  opportunityAuditTrail(id: $opportunityUid) {
    entries {
      ...OpportunityAudit
    }
  }
}
    ${OpportunityAuditFragmentDoc}`;

/**
 * __useOpportunityAuditTrailQuery__
 *
 * To run a query within a React component, call `useOpportunityAuditTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityAuditTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityAuditTrailQuery({
 *   variables: {
 *      opportunityUid: // value for 'opportunityUid'
 *   },
 * });
 */
export function useOpportunityAuditTrailQuery(baseOptions: Apollo.QueryHookOptions<OpportunityAuditTrailQuery, OpportunityAuditTrailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityAuditTrailQuery, OpportunityAuditTrailQueryVariables>(OpportunityAuditTrailDocument, options);
      }
export function useOpportunityAuditTrailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityAuditTrailQuery, OpportunityAuditTrailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityAuditTrailQuery, OpportunityAuditTrailQueryVariables>(OpportunityAuditTrailDocument, options);
        }
export type OpportunityAuditTrailQueryHookResult = ReturnType<typeof useOpportunityAuditTrailQuery>;
export type OpportunityAuditTrailLazyQueryHookResult = ReturnType<typeof useOpportunityAuditTrailLazyQuery>;
export type OpportunityAuditTrailQueryResult = Apollo.QueryResult<OpportunityAuditTrailQuery, OpportunityAuditTrailQueryVariables>;
export const OpportunityProjectsDocument = gql`
    query OpportunityProjects($uuid: String!) {
  opportunityProjects(uuid: $uuid) {
    entries {
      id
      title
      overviewTab {
        id
      }
    }
  }
}
    `;

/**
 * __useOpportunityProjectsQuery__
 *
 * To run a query within a React component, call `useOpportunityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityProjectsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useOpportunityProjectsQuery(baseOptions: Apollo.QueryHookOptions<OpportunityProjectsQuery, OpportunityProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityProjectsQuery, OpportunityProjectsQueryVariables>(OpportunityProjectsDocument, options);
      }
export function useOpportunityProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityProjectsQuery, OpportunityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityProjectsQuery, OpportunityProjectsQueryVariables>(OpportunityProjectsDocument, options);
        }
export type OpportunityProjectsQueryHookResult = ReturnType<typeof useOpportunityProjectsQuery>;
export type OpportunityProjectsLazyQueryHookResult = ReturnType<typeof useOpportunityProjectsLazyQuery>;
export type OpportunityProjectsQueryResult = Apollo.QueryResult<OpportunityProjectsQuery, OpportunityProjectsQueryVariables>;
export const OpportunityProjectsForUidDocument = gql`
    query OpportunityProjectsForUid($opportunityUid: ID!) {
  opportunityProjectsForUid(opportunityUid: $opportunityUid) {
    entries {
      id
      title
      overviewTab {
        id
      }
    }
  }
}
    `;

/**
 * __useOpportunityProjectsForUidQuery__
 *
 * To run a query within a React component, call `useOpportunityProjectsForUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityProjectsForUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityProjectsForUidQuery({
 *   variables: {
 *      opportunityUid: // value for 'opportunityUid'
 *   },
 * });
 */
export function useOpportunityProjectsForUidQuery(baseOptions: Apollo.QueryHookOptions<OpportunityProjectsForUidQuery, OpportunityProjectsForUidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityProjectsForUidQuery, OpportunityProjectsForUidQueryVariables>(OpportunityProjectsForUidDocument, options);
      }
export function useOpportunityProjectsForUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityProjectsForUidQuery, OpportunityProjectsForUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityProjectsForUidQuery, OpportunityProjectsForUidQueryVariables>(OpportunityProjectsForUidDocument, options);
        }
export type OpportunityProjectsForUidQueryHookResult = ReturnType<typeof useOpportunityProjectsForUidQuery>;
export type OpportunityProjectsForUidLazyQueryHookResult = ReturnType<typeof useOpportunityProjectsForUidLazyQuery>;
export type OpportunityProjectsForUidQueryResult = Apollo.QueryResult<OpportunityProjectsForUidQuery, OpportunityProjectsForUidQueryVariables>;
export const OpportunityTrackingCustomStatusesDocument = gql`
    query OpportunityTrackingCustomStatuses {
  opportunityTrackingConfiguration {
    id
    customStatuses {
      ...OpportunityTrackingCustomStatus
    }
  }
}
    ${OpportunityTrackingCustomStatusFragmentDoc}`;

/**
 * __useOpportunityTrackingCustomStatusesQuery__
 *
 * To run a query within a React component, call `useOpportunityTrackingCustomStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityTrackingCustomStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityTrackingCustomStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpportunityTrackingCustomStatusesQuery(baseOptions?: Apollo.QueryHookOptions<OpportunityTrackingCustomStatusesQuery, OpportunityTrackingCustomStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityTrackingCustomStatusesQuery, OpportunityTrackingCustomStatusesQueryVariables>(OpportunityTrackingCustomStatusesDocument, options);
      }
export function useOpportunityTrackingCustomStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityTrackingCustomStatusesQuery, OpportunityTrackingCustomStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityTrackingCustomStatusesQuery, OpportunityTrackingCustomStatusesQueryVariables>(OpportunityTrackingCustomStatusesDocument, options);
        }
export type OpportunityTrackingCustomStatusesQueryHookResult = ReturnType<typeof useOpportunityTrackingCustomStatusesQuery>;
export type OpportunityTrackingCustomStatusesLazyQueryHookResult = ReturnType<typeof useOpportunityTrackingCustomStatusesLazyQuery>;
export type OpportunityTrackingCustomStatusesQueryResult = Apollo.QueryResult<OpportunityTrackingCustomStatusesQuery, OpportunityTrackingCustomStatusesQueryVariables>;
export const UpdateOpportunityDocument = gql`
    mutation UpdateOpportunity($uid: ID!, $attributes: CompanyGoalAttributes!) {
  updateOpportunity(uuid: $uid, attributes: $attributes) {
    failReasons
    record {
      ...AdminCompanyGoalRow
    }
    basicOppRecord: record {
      ...BasicOpportunity
    }
    gridRecord {
      ...OpportunityGrid
    }
  }
}
    ${AdminCompanyGoalRowFragmentDoc}
${BasicOpportunityFragmentDoc}
${OpportunityGridFragmentDoc}`;
export type UpdateOpportunityMutationFn = Apollo.MutationFunction<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;

/**
 * __useUpdateOpportunityMutation__
 *
 * To run a mutation, you first call `useUpdateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpportunityMutation, { data, loading, error }] = useUpdateOpportunityMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>(UpdateOpportunityDocument, options);
      }
export type UpdateOpportunityMutationHookResult = ReturnType<typeof useUpdateOpportunityMutation>;
export type UpdateOpportunityMutationResult = Apollo.MutationResult<UpdateOpportunityMutation>;
export type UpdateOpportunityMutationOptions = Apollo.BaseMutationOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;
export const BasicOpportunitiesDocument = gql`
    query BasicOpportunities($page: Int, $perPage: Int, $filter: CompanyGoalFiltering) {
  companyGoals(page: $page, perPage: $perPage, filter: $filter) {
    entries {
      ...BasicOpportunity
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${BasicOpportunityFragmentDoc}`;

/**
 * __useBasicOpportunitiesQuery__
 *
 * To run a query within a React component, call `useBasicOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicOpportunitiesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBasicOpportunitiesQuery(baseOptions?: Apollo.QueryHookOptions<BasicOpportunitiesQuery, BasicOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasicOpportunitiesQuery, BasicOpportunitiesQueryVariables>(BasicOpportunitiesDocument, options);
      }
export function useBasicOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasicOpportunitiesQuery, BasicOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasicOpportunitiesQuery, BasicOpportunitiesQueryVariables>(BasicOpportunitiesDocument, options);
        }
export type BasicOpportunitiesQueryHookResult = ReturnType<typeof useBasicOpportunitiesQuery>;
export type BasicOpportunitiesLazyQueryHookResult = ReturnType<typeof useBasicOpportunitiesLazyQuery>;
export type BasicOpportunitiesQueryResult = Apollo.QueryResult<BasicOpportunitiesQuery, BasicOpportunitiesQueryVariables>;
export const AddOpportunityNoteDocument = gql`
    mutation AddOpportunityNote($opportunityId: ID!, $content: String!) {
  addOpportunityNote(opportunityId: $opportunityId, content: $content) {
    failReasons
  }
}
    `;
export type AddOpportunityNoteMutationFn = Apollo.MutationFunction<AddOpportunityNoteMutation, AddOpportunityNoteMutationVariables>;

/**
 * __useAddOpportunityNoteMutation__
 *
 * To run a mutation, you first call `useAddOpportunityNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOpportunityNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOpportunityNoteMutation, { data, loading, error }] = useAddOpportunityNoteMutation({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useAddOpportunityNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddOpportunityNoteMutation, AddOpportunityNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOpportunityNoteMutation, AddOpportunityNoteMutationVariables>(AddOpportunityNoteDocument, options);
      }
export type AddOpportunityNoteMutationHookResult = ReturnType<typeof useAddOpportunityNoteMutation>;
export type AddOpportunityNoteMutationResult = Apollo.MutationResult<AddOpportunityNoteMutation>;
export type AddOpportunityNoteMutationOptions = Apollo.BaseMutationOptions<AddOpportunityNoteMutation, AddOpportunityNoteMutationVariables>;
export const OpportunityNotesDocument = gql`
    query OpportunityNotes($opportunityId: ID!, $page: Int, $perPage: Int) {
  opportunityNotes(opportunityId: $opportunityId, page: $page, perPage: $perPage) {
    entries {
      ...OpportunityNotePreview
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${OpportunityNotePreviewFragmentDoc}`;

/**
 * __useOpportunityNotesQuery__
 *
 * To run a query within a React component, call `useOpportunityNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityNotesQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useOpportunityNotesQuery(baseOptions: Apollo.QueryHookOptions<OpportunityNotesQuery, OpportunityNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityNotesQuery, OpportunityNotesQueryVariables>(OpportunityNotesDocument, options);
      }
export function useOpportunityNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityNotesQuery, OpportunityNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityNotesQuery, OpportunityNotesQueryVariables>(OpportunityNotesDocument, options);
        }
export type OpportunityNotesQueryHookResult = ReturnType<typeof useOpportunityNotesQuery>;
export type OpportunityNotesLazyQueryHookResult = ReturnType<typeof useOpportunityNotesLazyQuery>;
export type OpportunityNotesQueryResult = Apollo.QueryResult<OpportunityNotesQuery, OpportunityNotesQueryVariables>;
export const ArchiveOpportunityNoteDocument = gql`
    mutation ArchiveOpportunityNote($noteId: ID!) {
  archiveOpportunityNote(noteId: $noteId) {
    failReasons
  }
}
    `;
export type ArchiveOpportunityNoteMutationFn = Apollo.MutationFunction<ArchiveOpportunityNoteMutation, ArchiveOpportunityNoteMutationVariables>;

/**
 * __useArchiveOpportunityNoteMutation__
 *
 * To run a mutation, you first call `useArchiveOpportunityNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOpportunityNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOpportunityNoteMutation, { data, loading, error }] = useArchiveOpportunityNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useArchiveOpportunityNoteMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOpportunityNoteMutation, ArchiveOpportunityNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOpportunityNoteMutation, ArchiveOpportunityNoteMutationVariables>(ArchiveOpportunityNoteDocument, options);
      }
export type ArchiveOpportunityNoteMutationHookResult = ReturnType<typeof useArchiveOpportunityNoteMutation>;
export type ArchiveOpportunityNoteMutationResult = Apollo.MutationResult<ArchiveOpportunityNoteMutation>;
export type ArchiveOpportunityNoteMutationOptions = Apollo.BaseMutationOptions<ArchiveOpportunityNoteMutation, ArchiveOpportunityNoteMutationVariables>;
export const UpdateOpportunityNoteDocument = gql`
    mutation UpdateOpportunityNote($noteId: ID!, $content: String!) {
  updateOpportunityNote(noteId: $noteId, content: $content) {
    failReasons
    note {
      ...OpportunityNotePreview
    }
  }
}
    ${OpportunityNotePreviewFragmentDoc}`;
export type UpdateOpportunityNoteMutationFn = Apollo.MutationFunction<UpdateOpportunityNoteMutation, UpdateOpportunityNoteMutationVariables>;

/**
 * __useUpdateOpportunityNoteMutation__
 *
 * To run a mutation, you first call `useUpdateOpportunityNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpportunityNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpportunityNoteMutation, { data, loading, error }] = useUpdateOpportunityNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateOpportunityNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpportunityNoteMutation, UpdateOpportunityNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpportunityNoteMutation, UpdateOpportunityNoteMutationVariables>(UpdateOpportunityNoteDocument, options);
      }
export type UpdateOpportunityNoteMutationHookResult = ReturnType<typeof useUpdateOpportunityNoteMutation>;
export type UpdateOpportunityNoteMutationResult = Apollo.MutationResult<UpdateOpportunityNoteMutation>;
export type UpdateOpportunityNoteMutationOptions = Apollo.BaseMutationOptions<UpdateOpportunityNoteMutation, UpdateOpportunityNoteMutationVariables>;
export const OpportunitiesForGridDocument = gql`
    query OpportunitiesForGrid($page: Int, $perPage: Int, $term: String, $internalContactEmail: String, $employeeEmail: ID, $referralSource: String, $fromDate: ISO8601Date, $toDate: ISO8601Date, $customStatusId: ID, $projectUid: ID) {
  opportunitiesForGrid(
    page: $page
    perPage: $perPage
    filter: {term: $term, ownerUid: $internalContactEmail, withEmployeeUid: $employeeEmail, referralSource: $referralSource, fromDate: $fromDate, toDate: $toDate, customStatusId: $customStatusId, projectUid: $projectUid}
  ) {
    entries {
      ...OpportunityGrid
    }
  }
}
    ${OpportunityGridFragmentDoc}`;

/**
 * __useOpportunitiesForGridQuery__
 *
 * To run a query within a React component, call `useOpportunitiesForGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunitiesForGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunitiesForGridQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *      internalContactEmail: // value for 'internalContactEmail'
 *      employeeEmail: // value for 'employeeEmail'
 *      referralSource: // value for 'referralSource'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      customStatusId: // value for 'customStatusId'
 *      projectUid: // value for 'projectUid'
 *   },
 * });
 */
export function useOpportunitiesForGridQuery(baseOptions?: Apollo.QueryHookOptions<OpportunitiesForGridQuery, OpportunitiesForGridQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunitiesForGridQuery, OpportunitiesForGridQueryVariables>(OpportunitiesForGridDocument, options);
      }
export function useOpportunitiesForGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunitiesForGridQuery, OpportunitiesForGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunitiesForGridQuery, OpportunitiesForGridQueryVariables>(OpportunitiesForGridDocument, options);
        }
export type OpportunitiesForGridQueryHookResult = ReturnType<typeof useOpportunitiesForGridQuery>;
export type OpportunitiesForGridLazyQueryHookResult = ReturnType<typeof useOpportunitiesForGridLazyQuery>;
export type OpportunitiesForGridQueryResult = Apollo.QueryResult<OpportunitiesForGridQuery, OpportunitiesForGridQueryVariables>;
export const OpportunitiesForGridTotalDocument = gql`
    query OpportunitiesForGridTotal($term: String, $internalContactEmail: String, $employeeEmail: ID, $referralSource: String, $fromDate: ISO8601Date, $toDate: ISO8601Date, $customStatusId: ID) {
  opportunitiesForGrid(
    filter: {term: $term, ownerUid: $internalContactEmail, withEmployeeUid: $employeeEmail, referralSource: $referralSource, fromDate: $fromDate, toDate: $toDate, customStatusId: $customStatusId}
  ) {
    pageInfo {
      totalEntries
    }
  }
  opportunityTrackingConfiguration {
    id
    customStatuses {
      ...OpportunityTrackingCustomStatus
    }
  }
}
    ${OpportunityTrackingCustomStatusFragmentDoc}`;

/**
 * __useOpportunitiesForGridTotalQuery__
 *
 * To run a query within a React component, call `useOpportunitiesForGridTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunitiesForGridTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunitiesForGridTotalQuery({
 *   variables: {
 *      term: // value for 'term'
 *      internalContactEmail: // value for 'internalContactEmail'
 *      employeeEmail: // value for 'employeeEmail'
 *      referralSource: // value for 'referralSource'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      customStatusId: // value for 'customStatusId'
 *   },
 * });
 */
export function useOpportunitiesForGridTotalQuery(baseOptions?: Apollo.QueryHookOptions<OpportunitiesForGridTotalQuery, OpportunitiesForGridTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunitiesForGridTotalQuery, OpportunitiesForGridTotalQueryVariables>(OpportunitiesForGridTotalDocument, options);
      }
export function useOpportunitiesForGridTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunitiesForGridTotalQuery, OpportunitiesForGridTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunitiesForGridTotalQuery, OpportunitiesForGridTotalQueryVariables>(OpportunitiesForGridTotalDocument, options);
        }
export type OpportunitiesForGridTotalQueryHookResult = ReturnType<typeof useOpportunitiesForGridTotalQuery>;
export type OpportunitiesForGridTotalLazyQueryHookResult = ReturnType<typeof useOpportunitiesForGridTotalLazyQuery>;
export type OpportunitiesForGridTotalQueryResult = Apollo.QueryResult<OpportunitiesForGridTotalQuery, OpportunitiesForGridTotalQueryVariables>;
export const ProgressTrackerUpdatedDocument = gql`
    subscription progressTrackerUpdated {
  progressTrackersUpdated {
    entries {
      id
      title
      description
      status
      percentageComplete
      expectedCount
      returnPath
      createdAt
    }
  }
}
    `;

/**
 * __useProgressTrackerUpdatedSubscription__
 *
 * To run a query within a React component, call `useProgressTrackerUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProgressTrackerUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressTrackerUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProgressTrackerUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ProgressTrackerUpdatedSubscription, ProgressTrackerUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProgressTrackerUpdatedSubscription, ProgressTrackerUpdatedSubscriptionVariables>(ProgressTrackerUpdatedDocument, options);
      }
export type ProgressTrackerUpdatedSubscriptionHookResult = ReturnType<typeof useProgressTrackerUpdatedSubscription>;
export type ProgressTrackerUpdatedSubscriptionResult = Apollo.SubscriptionResult<ProgressTrackerUpdatedSubscription>;
export const AddProjectDocumentDocument = gql`
    mutation AddProjectDocument($projectUid: String!, $attributes: ProjectDocumentAttributes!) {
  addProjectDocument(projectUid: $projectUid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type AddProjectDocumentMutationFn = Apollo.MutationFunction<AddProjectDocumentMutation, AddProjectDocumentMutationVariables>;

/**
 * __useAddProjectDocumentMutation__
 *
 * To run a mutation, you first call `useAddProjectDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectDocumentMutation, { data, loading, error }] = useAddProjectDocumentMutation({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddProjectDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectDocumentMutation, AddProjectDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectDocumentMutation, AddProjectDocumentMutationVariables>(AddProjectDocumentDocument, options);
      }
export type AddProjectDocumentMutationHookResult = ReturnType<typeof useAddProjectDocumentMutation>;
export type AddProjectDocumentMutationResult = Apollo.MutationResult<AddProjectDocumentMutation>;
export type AddProjectDocumentMutationOptions = Apollo.BaseMutationOptions<AddProjectDocumentMutation, AddProjectDocumentMutationVariables>;
export const AddProjectMembersDocument = gql`
    mutation AddProjectMembers($uid: ID!, $memberEmails: [String!]!) {
  addProjectMembers(uuid: $uid, memberEmails: $memberEmails) {
    failReasons
  }
}
    `;
export type AddProjectMembersMutationFn = Apollo.MutationFunction<AddProjectMembersMutation, AddProjectMembersMutationVariables>;

/**
 * __useAddProjectMembersMutation__
 *
 * To run a mutation, you first call `useAddProjectMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMembersMutation, { data, loading, error }] = useAddProjectMembersMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      memberEmails: // value for 'memberEmails'
 *   },
 * });
 */
export function useAddProjectMembersMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectMembersMutation, AddProjectMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectMembersMutation, AddProjectMembersMutationVariables>(AddProjectMembersDocument, options);
      }
export type AddProjectMembersMutationHookResult = ReturnType<typeof useAddProjectMembersMutation>;
export type AddProjectMembersMutationResult = Apollo.MutationResult<AddProjectMembersMutation>;
export type AddProjectMembersMutationOptions = Apollo.BaseMutationOptions<AddProjectMembersMutation, AddProjectMembersMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($attributes: ProjectAttribute!) {
  createProject(attributes: $attributes) {
    failReasons
    record {
      id
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateProjectFromTemplateDocument = gql`
    mutation CreateProjectFromTemplate($templateProjectId: ID!) {
  createProjectFromTemplate(templateProjectId: $templateProjectId) {
    record {
      id
      nexlApps
    }
    failReasons
  }
}
    `;
export type CreateProjectFromTemplateMutationFn = Apollo.MutationFunction<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>;

/**
 * __useCreateProjectFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateProjectFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFromTemplateMutation, { data, loading, error }] = useCreateProjectFromTemplateMutation({
 *   variables: {
 *      templateProjectId: // value for 'templateProjectId'
 *   },
 * });
 */
export function useCreateProjectFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>(CreateProjectFromTemplateDocument, options);
      }
export type CreateProjectFromTemplateMutationHookResult = ReturnType<typeof useCreateProjectFromTemplateMutation>;
export type CreateProjectFromTemplateMutationResult = Apollo.MutationResult<CreateProjectFromTemplateMutation>;
export type CreateProjectFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>;
export const GetProjectOptionsDocument = gql`
    query GetProjectOptions($term: String) {
  projects(page: 1, perPage: 1000, term: $term) {
    entries {
      ...ProjectOption
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ProjectOptionFragmentDoc}`;

/**
 * __useGetProjectOptionsQuery__
 *
 * To run a query within a React component, call `useGetProjectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectOptionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useGetProjectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>(GetProjectOptionsDocument, options);
      }
export function useGetProjectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>(GetProjectOptionsDocument, options);
        }
export type GetProjectOptionsQueryHookResult = ReturnType<typeof useGetProjectOptionsQuery>;
export type GetProjectOptionsLazyQueryHookResult = ReturnType<typeof useGetProjectOptionsLazyQuery>;
export type GetProjectOptionsQueryResult = Apollo.QueryResult<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>;
export const MoveProjectDocument = gql`
    mutation MoveProject($uuid: ID!, $folderId: ID) {
  updateProject(uuid: $uuid, attributes: {folderId: $folderId}) {
    failReasons
  }
}
    `;
export type MoveProjectMutationFn = Apollo.MutationFunction<MoveProjectMutation, MoveProjectMutationVariables>;

/**
 * __useMoveProjectMutation__
 *
 * To run a mutation, you first call `useMoveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveProjectMutation, { data, loading, error }] = useMoveProjectMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useMoveProjectMutation(baseOptions?: Apollo.MutationHookOptions<MoveProjectMutation, MoveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveProjectMutation, MoveProjectMutationVariables>(MoveProjectDocument, options);
      }
export type MoveProjectMutationHookResult = ReturnType<typeof useMoveProjectMutation>;
export type MoveProjectMutationResult = Apollo.MutationResult<MoveProjectMutation>;
export type MoveProjectMutationOptions = Apollo.BaseMutationOptions<MoveProjectMutation, MoveProjectMutationVariables>;
export const ProjectDocument = gql`
    query Project($uid: ID!) {
  project(uuid: $uid) {
    ...ProjectOverview
  }
}
    ${ProjectOverviewFragmentDoc}`;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
      }
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const ProjectDocumentsDocument = gql`
    query ProjectDocuments($uuid: ID!) {
  project(uuid: $uuid) {
    documents {
      ...ProjectDocumentOverview
    }
  }
}
    ${ProjectDocumentOverviewFragmentDoc}`;

/**
 * __useProjectDocumentsQuery__
 *
 * To run a query within a React component, call `useProjectDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDocumentsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useProjectDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>(ProjectDocumentsDocument, options);
      }
export function useProjectDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>(ProjectDocumentsDocument, options);
        }
export type ProjectDocumentsQueryHookResult = ReturnType<typeof useProjectDocumentsQuery>;
export type ProjectDocumentsLazyQueryHookResult = ReturnType<typeof useProjectDocumentsLazyQuery>;
export type ProjectDocumentsQueryResult = Apollo.QueryResult<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>;
export const ProjectMembershipsDocument = gql`
    query ProjectMemberships($uid: ID!) {
  projectMemberships(uuid: $uid, page: 1, perPage: 100) {
    entries {
      ...ProjectMembership
    }
  }
}
    ${ProjectMembershipFragmentDoc}`;

/**
 * __useProjectMembershipsQuery__
 *
 * To run a query within a React component, call `useProjectMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMembershipsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useProjectMembershipsQuery(baseOptions: Apollo.QueryHookOptions<ProjectMembershipsQuery, ProjectMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectMembershipsQuery, ProjectMembershipsQueryVariables>(ProjectMembershipsDocument, options);
      }
export function useProjectMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectMembershipsQuery, ProjectMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectMembershipsQuery, ProjectMembershipsQueryVariables>(ProjectMembershipsDocument, options);
        }
export type ProjectMembershipsQueryHookResult = ReturnType<typeof useProjectMembershipsQuery>;
export type ProjectMembershipsLazyQueryHookResult = ReturnType<typeof useProjectMembershipsLazyQuery>;
export type ProjectMembershipsQueryResult = Apollo.QueryResult<ProjectMembershipsQuery, ProjectMembershipsQueryVariables>;
export const ProjectsDocument = gql`
    query Projects($term: String, $page: Int, $perPage: Int, $nexlApps: Boolean) {
  projects(term: $term, page: $page, perPage: $perPage, nexlApps: $nexlApps) {
    entries {
      ...ProjectListRow
    }
    pageInfo {
      totalEntries
    }
    subFolders {
      ...ProjectFolder
    }
  }
}
    ${ProjectListRowFragmentDoc}
${ProjectFolderFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      nexlApps: // value for 'nexlApps'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const ProjectsInFolderDocument = gql`
    query ProjectsInFolder($term: String, $page: Int, $perPage: Int, $nexlApps: Boolean, $folderUid: ID) {
  projects(
    term: $term
    page: $page
    perPage: $perPage
    nexlApps: $nexlApps
    folderUid: $folderUid
  ) {
    entries {
      ...ProjectListRow
    }
    pageInfo {
      totalEntries
    }
    subFolders {
      ...ProjectFolder
    }
    rootFolderId
  }
}
    ${ProjectListRowFragmentDoc}
${ProjectFolderFragmentDoc}`;

/**
 * __useProjectsInFolderQuery__
 *
 * To run a query within a React component, call `useProjectsInFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsInFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsInFolderQuery({
 *   variables: {
 *      term: // value for 'term'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      nexlApps: // value for 'nexlApps'
 *      folderUid: // value for 'folderUid'
 *   },
 * });
 */
export function useProjectsInFolderQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsInFolderQuery, ProjectsInFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsInFolderQuery, ProjectsInFolderQueryVariables>(ProjectsInFolderDocument, options);
      }
export function useProjectsInFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsInFolderQuery, ProjectsInFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsInFolderQuery, ProjectsInFolderQueryVariables>(ProjectsInFolderDocument, options);
        }
export type ProjectsInFolderQueryHookResult = ReturnType<typeof useProjectsInFolderQuery>;
export type ProjectsInFolderLazyQueryHookResult = ReturnType<typeof useProjectsInFolderLazyQuery>;
export type ProjectsInFolderQueryResult = Apollo.QueryResult<ProjectsInFolderQuery, ProjectsInFolderQueryVariables>;
export const RemoveProjectDocument = gql`
    mutation RemoveProject($projectUuid: ID!) {
  removeProject(projectUuid: $projectUuid) {
    failReasons
  }
}
    `;
export type RemoveProjectMutationFn = Apollo.MutationFunction<RemoveProjectMutation, RemoveProjectMutationVariables>;

/**
 * __useRemoveProjectMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMutation, { data, loading, error }] = useRemoveProjectMutation({
 *   variables: {
 *      projectUuid: // value for 'projectUuid'
 *   },
 * });
 */
export function useRemoveProjectMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectMutation, RemoveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectMutation, RemoveProjectMutationVariables>(RemoveProjectDocument, options);
      }
export type RemoveProjectMutationHookResult = ReturnType<typeof useRemoveProjectMutation>;
export type RemoveProjectMutationResult = Apollo.MutationResult<RemoveProjectMutation>;
export type RemoveProjectMutationOptions = Apollo.BaseMutationOptions<RemoveProjectMutation, RemoveProjectMutationVariables>;
export const RemoveProjectDocumentDocument = gql`
    mutation RemoveProjectDocument($uid: ID!) {
  removeProjectDocument(uid: $uid) {
    failReasons
  }
}
    `;
export type RemoveProjectDocumentMutationFn = Apollo.MutationFunction<RemoveProjectDocumentMutation, RemoveProjectDocumentMutationVariables>;

/**
 * __useRemoveProjectDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveProjectDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectDocumentMutation, { data, loading, error }] = useRemoveProjectDocumentMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useRemoveProjectDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectDocumentMutation, RemoveProjectDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectDocumentMutation, RemoveProjectDocumentMutationVariables>(RemoveProjectDocumentDocument, options);
      }
export type RemoveProjectDocumentMutationHookResult = ReturnType<typeof useRemoveProjectDocumentMutation>;
export type RemoveProjectDocumentMutationResult = Apollo.MutationResult<RemoveProjectDocumentMutation>;
export type RemoveProjectDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveProjectDocumentMutation, RemoveProjectDocumentMutationVariables>;
export const RemoveProjectMembersDocument = gql`
    mutation RemoveProjectMembers($uid: ID!, $memberEmails: [String!]!) {
  removeProjectMembers(uuid: $uid, memberEmails: $memberEmails) {
    failReasons
  }
}
    `;
export type RemoveProjectMembersMutationFn = Apollo.MutationFunction<RemoveProjectMembersMutation, RemoveProjectMembersMutationVariables>;

/**
 * __useRemoveProjectMembersMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMembersMutation, { data, loading, error }] = useRemoveProjectMembersMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      memberEmails: // value for 'memberEmails'
 *   },
 * });
 */
export function useRemoveProjectMembersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectMembersMutation, RemoveProjectMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectMembersMutation, RemoveProjectMembersMutationVariables>(RemoveProjectMembersDocument, options);
      }
export type RemoveProjectMembersMutationHookResult = ReturnType<typeof useRemoveProjectMembersMutation>;
export type RemoveProjectMembersMutationResult = Apollo.MutationResult<RemoveProjectMembersMutation>;
export type RemoveProjectMembersMutationOptions = Apollo.BaseMutationOptions<RemoveProjectMembersMutation, RemoveProjectMembersMutationVariables>;
export const RemoveProjectOpportunityDocument = gql`
    mutation RemoveProjectOpportunity($projectUid: ID!, $opportunityUid: ID!) {
  removeProjectOpportunity(uuid: $projectUid, goalUuid: $opportunityUid) {
    failReasons
  }
}
    `;
export type RemoveProjectOpportunityMutationFn = Apollo.MutationFunction<RemoveProjectOpportunityMutation, RemoveProjectOpportunityMutationVariables>;

/**
 * __useRemoveProjectOpportunityMutation__
 *
 * To run a mutation, you first call `useRemoveProjectOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectOpportunityMutation, { data, loading, error }] = useRemoveProjectOpportunityMutation({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *      opportunityUid: // value for 'opportunityUid'
 *   },
 * });
 */
export function useRemoveProjectOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectOpportunityMutation, RemoveProjectOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectOpportunityMutation, RemoveProjectOpportunityMutationVariables>(RemoveProjectOpportunityDocument, options);
      }
export type RemoveProjectOpportunityMutationHookResult = ReturnType<typeof useRemoveProjectOpportunityMutation>;
export type RemoveProjectOpportunityMutationResult = Apollo.MutationResult<RemoveProjectOpportunityMutation>;
export type RemoveProjectOpportunityMutationOptions = Apollo.BaseMutationOptions<RemoveProjectOpportunityMutation, RemoveProjectOpportunityMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($uid: ID!, $attributes: ProjectAttribute!) {
  updateProject(uuid: $uid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateProjectDocumentDocument = gql`
    mutation UpdateProjectDocument($uid: String!, $attributes: ProjectDocumentAttributes!) {
  updateProjectDocument(uid: $uid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type UpdateProjectDocumentMutationFn = Apollo.MutationFunction<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>;

/**
 * __useUpdateProjectDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDocumentMutation, { data, loading, error }] = useUpdateProjectDocumentMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateProjectDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>(UpdateProjectDocumentDocument, options);
      }
export type UpdateProjectDocumentMutationHookResult = ReturnType<typeof useUpdateProjectDocumentMutation>;
export type UpdateProjectDocumentMutationResult = Apollo.MutationResult<UpdateProjectDocumentMutation>;
export type UpdateProjectDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>;
export const CreateProjectFolderDocument = gql`
    mutation CreateProjectFolder($name: String!, $parentId: ID!) {
  createProjectFolder(name: $name, parentId: $parentId) {
    failReasons
  }
}
    `;
export type CreateProjectFolderMutationFn = Apollo.MutationFunction<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>;

/**
 * __useCreateProjectFolderMutation__
 *
 * To run a mutation, you first call `useCreateProjectFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFolderMutation, { data, loading, error }] = useCreateProjectFolderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCreateProjectFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>(CreateProjectFolderDocument, options);
      }
export type CreateProjectFolderMutationHookResult = ReturnType<typeof useCreateProjectFolderMutation>;
export type CreateProjectFolderMutationResult = Apollo.MutationResult<CreateProjectFolderMutation>;
export type CreateProjectFolderMutationOptions = Apollo.BaseMutationOptions<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>;
export const RemoveProjectFolderDocument = gql`
    mutation RemoveProjectFolder($folderUuid: ID!) {
  removeProjectFolder(folderUuid: $folderUuid) {
    failReasons
  }
}
    `;
export type RemoveProjectFolderMutationFn = Apollo.MutationFunction<RemoveProjectFolderMutation, RemoveProjectFolderMutationVariables>;

/**
 * __useRemoveProjectFolderMutation__
 *
 * To run a mutation, you first call `useRemoveProjectFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectFolderMutation, { data, loading, error }] = useRemoveProjectFolderMutation({
 *   variables: {
 *      folderUuid: // value for 'folderUuid'
 *   },
 * });
 */
export function useRemoveProjectFolderMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectFolderMutation, RemoveProjectFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectFolderMutation, RemoveProjectFolderMutationVariables>(RemoveProjectFolderDocument, options);
      }
export type RemoveProjectFolderMutationHookResult = ReturnType<typeof useRemoveProjectFolderMutation>;
export type RemoveProjectFolderMutationResult = Apollo.MutationResult<RemoveProjectFolderMutation>;
export type RemoveProjectFolderMutationOptions = Apollo.BaseMutationOptions<RemoveProjectFolderMutation, RemoveProjectFolderMutationVariables>;
export const UpdateFolderDocument = gql`
    mutation UpdateFolder($folderUuid: ID!, $name: String, $parentId: ID) {
  updateProjectFolder(folderUuid: $folderUuid, name: $name, parentId: $parentId) {
    failReasons
  }
}
    `;
export type UpdateFolderMutationFn = Apollo.MutationFunction<UpdateFolderMutation, UpdateFolderMutationVariables>;

/**
 * __useUpdateFolderMutation__
 *
 * To run a mutation, you first call `useUpdateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderMutation, { data, loading, error }] = useUpdateFolderMutation({
 *   variables: {
 *      folderUuid: // value for 'folderUuid'
 *      name: // value for 'name'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useUpdateFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFolderMutation, UpdateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFolderMutation, UpdateFolderMutationVariables>(UpdateFolderDocument, options);
      }
export type UpdateFolderMutationHookResult = ReturnType<typeof useUpdateFolderMutation>;
export type UpdateFolderMutationResult = Apollo.MutationResult<UpdateFolderMutation>;
export type UpdateFolderMutationOptions = Apollo.BaseMutationOptions<UpdateFolderMutation, UpdateFolderMutationVariables>;
export const AddProjectNoteDocument = gql`
    mutation AddProjectNote($uid: ID!, $attributes: ProjectNoteAttribute!) {
  addProjectNote(uuid: $uid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type AddProjectNoteMutationFn = Apollo.MutationFunction<AddProjectNoteMutation, AddProjectNoteMutationVariables>;

/**
 * __useAddProjectNoteMutation__
 *
 * To run a mutation, you first call `useAddProjectNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectNoteMutation, { data, loading, error }] = useAddProjectNoteMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddProjectNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectNoteMutation, AddProjectNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectNoteMutation, AddProjectNoteMutationVariables>(AddProjectNoteDocument, options);
      }
export type AddProjectNoteMutationHookResult = ReturnType<typeof useAddProjectNoteMutation>;
export type AddProjectNoteMutationResult = Apollo.MutationResult<AddProjectNoteMutation>;
export type AddProjectNoteMutationOptions = Apollo.BaseMutationOptions<AddProjectNoteMutation, AddProjectNoteMutationVariables>;
export const GetProjectNotesDocument = gql`
    query GetProjectNotes($uid: ID!, $page: Int, $perPage: Int) {
  projectNotes(uuid: $uid, page: $page, perPage: $perPage) {
    entries {
      ...ProjectNotePreview
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ProjectNotePreviewFragmentDoc}`;

/**
 * __useGetProjectNotesQuery__
 *
 * To run a query within a React component, call `useGetProjectNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectNotesQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetProjectNotesQuery(baseOptions: Apollo.QueryHookOptions<GetProjectNotesQuery, GetProjectNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectNotesQuery, GetProjectNotesQueryVariables>(GetProjectNotesDocument, options);
      }
export function useGetProjectNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectNotesQuery, GetProjectNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectNotesQuery, GetProjectNotesQueryVariables>(GetProjectNotesDocument, options);
        }
export type GetProjectNotesQueryHookResult = ReturnType<typeof useGetProjectNotesQuery>;
export type GetProjectNotesLazyQueryHookResult = ReturnType<typeof useGetProjectNotesLazyQuery>;
export type GetProjectNotesQueryResult = Apollo.QueryResult<GetProjectNotesQuery, GetProjectNotesQueryVariables>;
export const RemoveProjectNoteDocument = gql`
    mutation RemoveProjectNote($noteUid: ID!) {
  removeProjectNote(noteUuid: $noteUid) {
    failReasons
  }
}
    `;
export type RemoveProjectNoteMutationFn = Apollo.MutationFunction<RemoveProjectNoteMutation, RemoveProjectNoteMutationVariables>;

/**
 * __useRemoveProjectNoteMutation__
 *
 * To run a mutation, you first call `useRemoveProjectNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectNoteMutation, { data, loading, error }] = useRemoveProjectNoteMutation({
 *   variables: {
 *      noteUid: // value for 'noteUid'
 *   },
 * });
 */
export function useRemoveProjectNoteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectNoteMutation, RemoveProjectNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectNoteMutation, RemoveProjectNoteMutationVariables>(RemoveProjectNoteDocument, options);
      }
export type RemoveProjectNoteMutationHookResult = ReturnType<typeof useRemoveProjectNoteMutation>;
export type RemoveProjectNoteMutationResult = Apollo.MutationResult<RemoveProjectNoteMutation>;
export type RemoveProjectNoteMutationOptions = Apollo.BaseMutationOptions<RemoveProjectNoteMutation, RemoveProjectNoteMutationVariables>;
export const UpdateProjectNoteDocument = gql`
    mutation UpdateProjectNote($noteUuid: ID!, $attributes: ProjectNoteAttribute!) {
  updateProjectNote(noteUuid: $noteUuid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type UpdateProjectNoteMutationFn = Apollo.MutationFunction<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>;

/**
 * __useUpdateProjectNoteMutation__
 *
 * To run a mutation, you first call `useUpdateProjectNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectNoteMutation, { data, loading, error }] = useUpdateProjectNoteMutation({
 *   variables: {
 *      noteUuid: // value for 'noteUuid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateProjectNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>(UpdateProjectNoteDocument, options);
      }
export type UpdateProjectNoteMutationHookResult = ReturnType<typeof useUpdateProjectNoteMutation>;
export type UpdateProjectNoteMutationResult = Apollo.MutationResult<UpdateProjectNoteMutation>;
export type UpdateProjectNoteMutationOptions = Apollo.BaseMutationOptions<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>;
export const CreateProjectOpportunityDocument = gql`
    mutation CreateProjectOpportunity($projectUid: ID!, $companyUid: ID!, $customFieldAttributes: [CustomFieldAttribute!], $opportunityAttributes: CompanyGoalAttributes!, $customStatusUid: ID) {
  createProjectOpportunity(
    projectUid: $projectUid
    companyUid: $companyUid
    customFieldAttributes: $customFieldAttributes
    opportunityAttributes: $opportunityAttributes
    customStatusUid: $customStatusUid
  ) {
    failReasons
    record {
      ...ProjectOpportunityGridRow
    }
  }
}
    ${ProjectOpportunityGridRowFragmentDoc}`;
export type CreateProjectOpportunityMutationFn = Apollo.MutationFunction<CreateProjectOpportunityMutation, CreateProjectOpportunityMutationVariables>;

/**
 * __useCreateProjectOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateProjectOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectOpportunityMutation, { data, loading, error }] = useCreateProjectOpportunityMutation({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *      companyUid: // value for 'companyUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *      opportunityAttributes: // value for 'opportunityAttributes'
 *      customStatusUid: // value for 'customStatusUid'
 *   },
 * });
 */
export function useCreateProjectOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectOpportunityMutation, CreateProjectOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectOpportunityMutation, CreateProjectOpportunityMutationVariables>(CreateProjectOpportunityDocument, options);
      }
export type CreateProjectOpportunityMutationHookResult = ReturnType<typeof useCreateProjectOpportunityMutation>;
export type CreateProjectOpportunityMutationResult = Apollo.MutationResult<CreateProjectOpportunityMutation>;
export type CreateProjectOpportunityMutationOptions = Apollo.BaseMutationOptions<CreateProjectOpportunityMutation, CreateProjectOpportunityMutationVariables>;
export const ProjectOpportunitiesDocument = gql`
    query ProjectOpportunities($page: Int, $perPage: Int, $term: String, $internalContactEmail: String, $employeeEmail: ID, $referralSource: String, $fromDate: ISO8601Date, $toDate: ISO8601Date, $customStatusId: ID, $projectUid: ID!) {
  projectOpportunities(
    page: $page
    perPage: $perPage
    projectUid: $projectUid
    filter: {term: $term, ownerUid: $internalContactEmail, withEmployeeUid: $employeeEmail, referralSource: $referralSource, fromDate: $fromDate, toDate: $toDate, customStatusId: $customStatusId}
  ) {
    entries {
      ...ProjectOpportunityGridRow
    }
  }
  opportunityTrackingConfiguration {
    id
    customStatuses {
      ...OpportunityTrackingCustomStatus
    }
  }
}
    ${ProjectOpportunityGridRowFragmentDoc}
${OpportunityTrackingCustomStatusFragmentDoc}`;

/**
 * __useProjectOpportunitiesQuery__
 *
 * To run a query within a React component, call `useProjectOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOpportunitiesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *      internalContactEmail: // value for 'internalContactEmail'
 *      employeeEmail: // value for 'employeeEmail'
 *      referralSource: // value for 'referralSource'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      customStatusId: // value for 'customStatusId'
 *      projectUid: // value for 'projectUid'
 *   },
 * });
 */
export function useProjectOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<ProjectOpportunitiesQuery, ProjectOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectOpportunitiesQuery, ProjectOpportunitiesQueryVariables>(ProjectOpportunitiesDocument, options);
      }
export function useProjectOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectOpportunitiesQuery, ProjectOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectOpportunitiesQuery, ProjectOpportunitiesQueryVariables>(ProjectOpportunitiesDocument, options);
        }
export type ProjectOpportunitiesQueryHookResult = ReturnType<typeof useProjectOpportunitiesQuery>;
export type ProjectOpportunitiesLazyQueryHookResult = ReturnType<typeof useProjectOpportunitiesLazyQuery>;
export type ProjectOpportunitiesQueryResult = Apollo.QueryResult<ProjectOpportunitiesQuery, ProjectOpportunitiesQueryVariables>;
export const ProjectOpportunityDocument = gql`
    query ProjectOpportunity($uid: ID!) {
  projectOpportunity(uid: $uid) {
    ...ProjectOpportunityGridRow
  }
}
    ${ProjectOpportunityGridRowFragmentDoc}`;

/**
 * __useProjectOpportunityQuery__
 *
 * To run a query within a React component, call `useProjectOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOpportunityQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useProjectOpportunityQuery(baseOptions: Apollo.QueryHookOptions<ProjectOpportunityQuery, ProjectOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectOpportunityQuery, ProjectOpportunityQueryVariables>(ProjectOpportunityDocument, options);
      }
export function useProjectOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectOpportunityQuery, ProjectOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectOpportunityQuery, ProjectOpportunityQueryVariables>(ProjectOpportunityDocument, options);
        }
export type ProjectOpportunityQueryHookResult = ReturnType<typeof useProjectOpportunityQuery>;
export type ProjectOpportunityLazyQueryHookResult = ReturnType<typeof useProjectOpportunityLazyQuery>;
export type ProjectOpportunityQueryResult = Apollo.QueryResult<ProjectOpportunityQuery, ProjectOpportunityQueryVariables>;
export const ProjectOpportunityCustomFieldSchemasDocument = gql`
    query ProjectOpportunityCustomFieldSchemas($uuid: ID!) {
  project(uuid: $uuid) {
    id
    opportunityCustomFieldSchemas {
      ...CustomFieldSchema
    }
  }
}
    ${CustomFieldSchemaFragmentDoc}`;

/**
 * __useProjectOpportunityCustomFieldSchemasQuery__
 *
 * To run a query within a React component, call `useProjectOpportunityCustomFieldSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOpportunityCustomFieldSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOpportunityCustomFieldSchemasQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useProjectOpportunityCustomFieldSchemasQuery(baseOptions: Apollo.QueryHookOptions<ProjectOpportunityCustomFieldSchemasQuery, ProjectOpportunityCustomFieldSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectOpportunityCustomFieldSchemasQuery, ProjectOpportunityCustomFieldSchemasQueryVariables>(ProjectOpportunityCustomFieldSchemasDocument, options);
      }
export function useProjectOpportunityCustomFieldSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectOpportunityCustomFieldSchemasQuery, ProjectOpportunityCustomFieldSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectOpportunityCustomFieldSchemasQuery, ProjectOpportunityCustomFieldSchemasQueryVariables>(ProjectOpportunityCustomFieldSchemasDocument, options);
        }
export type ProjectOpportunityCustomFieldSchemasQueryHookResult = ReturnType<typeof useProjectOpportunityCustomFieldSchemasQuery>;
export type ProjectOpportunityCustomFieldSchemasLazyQueryHookResult = ReturnType<typeof useProjectOpportunityCustomFieldSchemasLazyQuery>;
export type ProjectOpportunityCustomFieldSchemasQueryResult = Apollo.QueryResult<ProjectOpportunityCustomFieldSchemasQuery, ProjectOpportunityCustomFieldSchemasQueryVariables>;
export const ProjectOpportunityCustomFieldsForEditDocument = gql`
    query ProjectOpportunityCustomFieldsForEdit($uid: ID!) {
  projectOpportunity(uid: $uid) {
    id
    customFields {
      ...CustomFieldGrid
    }
    opportunity {
      customFields {
        ...CustomFieldGrid
      }
    }
  }
}
    ${CustomFieldGridFragmentDoc}`;

/**
 * __useProjectOpportunityCustomFieldsForEditQuery__
 *
 * To run a query within a React component, call `useProjectOpportunityCustomFieldsForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOpportunityCustomFieldsForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOpportunityCustomFieldsForEditQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useProjectOpportunityCustomFieldsForEditQuery(baseOptions: Apollo.QueryHookOptions<ProjectOpportunityCustomFieldsForEditQuery, ProjectOpportunityCustomFieldsForEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectOpportunityCustomFieldsForEditQuery, ProjectOpportunityCustomFieldsForEditQueryVariables>(ProjectOpportunityCustomFieldsForEditDocument, options);
      }
export function useProjectOpportunityCustomFieldsForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectOpportunityCustomFieldsForEditQuery, ProjectOpportunityCustomFieldsForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectOpportunityCustomFieldsForEditQuery, ProjectOpportunityCustomFieldsForEditQueryVariables>(ProjectOpportunityCustomFieldsForEditDocument, options);
        }
export type ProjectOpportunityCustomFieldsForEditQueryHookResult = ReturnType<typeof useProjectOpportunityCustomFieldsForEditQuery>;
export type ProjectOpportunityCustomFieldsForEditLazyQueryHookResult = ReturnType<typeof useProjectOpportunityCustomFieldsForEditLazyQuery>;
export type ProjectOpportunityCustomFieldsForEditQueryResult = Apollo.QueryResult<ProjectOpportunityCustomFieldsForEditQuery, ProjectOpportunityCustomFieldsForEditQueryVariables>;
export const UpdateProjectOpportunityDocument = gql`
    mutation UpdateProjectOpportunity($projectOpportunityUid: ID!, $customFieldAttributes: [CustomFieldAttribute!], $opportunityAttributes: CompanyGoalAttributes, $customStatusUid: ID) {
  updateProjectOpportunity(
    projectOpportunityUid: $projectOpportunityUid
    customFieldAttributes: $customFieldAttributes
    opportunityAttributes: $opportunityAttributes
    customStatusUid: $customStatusUid
  ) {
    failReasons
    record {
      ...ProjectOpportunityGridRow
    }
  }
}
    ${ProjectOpportunityGridRowFragmentDoc}`;
export type UpdateProjectOpportunityMutationFn = Apollo.MutationFunction<UpdateProjectOpportunityMutation, UpdateProjectOpportunityMutationVariables>;

/**
 * __useUpdateProjectOpportunityMutation__
 *
 * To run a mutation, you first call `useUpdateProjectOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectOpportunityMutation, { data, loading, error }] = useUpdateProjectOpportunityMutation({
 *   variables: {
 *      projectOpportunityUid: // value for 'projectOpportunityUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *      opportunityAttributes: // value for 'opportunityAttributes'
 *      customStatusUid: // value for 'customStatusUid'
 *   },
 * });
 */
export function useUpdateProjectOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectOpportunityMutation, UpdateProjectOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectOpportunityMutation, UpdateProjectOpportunityMutationVariables>(UpdateProjectOpportunityDocument, options);
      }
export type UpdateProjectOpportunityMutationHookResult = ReturnType<typeof useUpdateProjectOpportunityMutation>;
export type UpdateProjectOpportunityMutationResult = Apollo.MutationResult<UpdateProjectOpportunityMutation>;
export type UpdateProjectOpportunityMutationOptions = Apollo.BaseMutationOptions<UpdateProjectOpportunityMutation, UpdateProjectOpportunityMutationVariables>;
export const AddProjectTaskSectionDocument = gql`
    mutation AddProjectTaskSection($projectUid: ID!, $title: String!) {
  addProjectTaskSection(projectUid: $projectUid, title: $title) {
    failReasons
    record {
      id
      blockPageIdentifier
    }
  }
}
    `;
export type AddProjectTaskSectionMutationFn = Apollo.MutationFunction<AddProjectTaskSectionMutation, AddProjectTaskSectionMutationVariables>;

/**
 * __useAddProjectTaskSectionMutation__
 *
 * To run a mutation, you first call `useAddProjectTaskSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectTaskSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectTaskSectionMutation, { data, loading, error }] = useAddProjectTaskSectionMutation({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useAddProjectTaskSectionMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectTaskSectionMutation, AddProjectTaskSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectTaskSectionMutation, AddProjectTaskSectionMutationVariables>(AddProjectTaskSectionDocument, options);
      }
export type AddProjectTaskSectionMutationHookResult = ReturnType<typeof useAddProjectTaskSectionMutation>;
export type AddProjectTaskSectionMutationResult = Apollo.MutationResult<AddProjectTaskSectionMutation>;
export type AddProjectTaskSectionMutationOptions = Apollo.BaseMutationOptions<AddProjectTaskSectionMutation, AddProjectTaskSectionMutationVariables>;
export const BlockPageProjectTaskSectionsDocument = gql`
    query BlockPageProjectTaskSections($projectUid: String!) {
  projectTaskSections(projectUid: $projectUid) {
    entries {
      ...BlockPageProjectSection
    }
  }
}
    ${BlockPageProjectSectionFragmentDoc}`;

/**
 * __useBlockPageProjectTaskSectionsQuery__
 *
 * To run a query within a React component, call `useBlockPageProjectTaskSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockPageProjectTaskSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockPageProjectTaskSectionsQuery({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *   },
 * });
 */
export function useBlockPageProjectTaskSectionsQuery(baseOptions: Apollo.QueryHookOptions<BlockPageProjectTaskSectionsQuery, BlockPageProjectTaskSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockPageProjectTaskSectionsQuery, BlockPageProjectTaskSectionsQueryVariables>(BlockPageProjectTaskSectionsDocument, options);
      }
export function useBlockPageProjectTaskSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockPageProjectTaskSectionsQuery, BlockPageProjectTaskSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockPageProjectTaskSectionsQuery, BlockPageProjectTaskSectionsQueryVariables>(BlockPageProjectTaskSectionsDocument, options);
        }
export type BlockPageProjectTaskSectionsQueryHookResult = ReturnType<typeof useBlockPageProjectTaskSectionsQuery>;
export type BlockPageProjectTaskSectionsLazyQueryHookResult = ReturnType<typeof useBlockPageProjectTaskSectionsLazyQuery>;
export type BlockPageProjectTaskSectionsQueryResult = Apollo.QueryResult<BlockPageProjectTaskSectionsQuery, BlockPageProjectTaskSectionsQueryVariables>;
export const BlockPageTasksBySourceTypeAndIdDocument = gql`
    query BlockPageTasksBySourceTypeAndId($primaryFilter: TaskPrimaryFilterInput, $filter: TaskFiltering, $page: Int = 1, $perPage: Int = 10) {
  tasks(
    primaryFilter: $primaryFilter
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...TaskWithProjectTaskSection
    }
  }
}
    ${TaskWithProjectTaskSectionFragmentDoc}`;

/**
 * __useBlockPageTasksBySourceTypeAndIdQuery__
 *
 * To run a query within a React component, call `useBlockPageTasksBySourceTypeAndIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockPageTasksBySourceTypeAndIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockPageTasksBySourceTypeAndIdQuery({
 *   variables: {
 *      primaryFilter: // value for 'primaryFilter'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useBlockPageTasksBySourceTypeAndIdQuery(baseOptions?: Apollo.QueryHookOptions<BlockPageTasksBySourceTypeAndIdQuery, BlockPageTasksBySourceTypeAndIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockPageTasksBySourceTypeAndIdQuery, BlockPageTasksBySourceTypeAndIdQueryVariables>(BlockPageTasksBySourceTypeAndIdDocument, options);
      }
export function useBlockPageTasksBySourceTypeAndIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockPageTasksBySourceTypeAndIdQuery, BlockPageTasksBySourceTypeAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockPageTasksBySourceTypeAndIdQuery, BlockPageTasksBySourceTypeAndIdQueryVariables>(BlockPageTasksBySourceTypeAndIdDocument, options);
        }
export type BlockPageTasksBySourceTypeAndIdQueryHookResult = ReturnType<typeof useBlockPageTasksBySourceTypeAndIdQuery>;
export type BlockPageTasksBySourceTypeAndIdLazyQueryHookResult = ReturnType<typeof useBlockPageTasksBySourceTypeAndIdLazyQuery>;
export type BlockPageTasksBySourceTypeAndIdQueryResult = Apollo.QueryResult<BlockPageTasksBySourceTypeAndIdQuery, BlockPageTasksBySourceTypeAndIdQueryVariables>;
export const CreateTaskWithSectionDocument = gql`
    mutation CreateTaskWithSection($assignedToUid: ID!, $projectUid: ID, $projectTaskSectionUid: ID, $requestedByUid: ID!, $attributes: CreateTaskAttributes!) {
  createTask(
    assignedToUid: $assignedToUid
    projectUid: $projectUid
    projectTaskSectionUid: $projectTaskSectionUid
    requestedByUid: $requestedByUid
    attributes: $attributes
  ) {
    failReasons
  }
}
    `;
export type CreateTaskWithSectionMutationFn = Apollo.MutationFunction<CreateTaskWithSectionMutation, CreateTaskWithSectionMutationVariables>;

/**
 * __useCreateTaskWithSectionMutation__
 *
 * To run a mutation, you first call `useCreateTaskWithSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskWithSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskWithSectionMutation, { data, loading, error }] = useCreateTaskWithSectionMutation({
 *   variables: {
 *      assignedToUid: // value for 'assignedToUid'
 *      projectUid: // value for 'projectUid'
 *      projectTaskSectionUid: // value for 'projectTaskSectionUid'
 *      requestedByUid: // value for 'requestedByUid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateTaskWithSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskWithSectionMutation, CreateTaskWithSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskWithSectionMutation, CreateTaskWithSectionMutationVariables>(CreateTaskWithSectionDocument, options);
      }
export type CreateTaskWithSectionMutationHookResult = ReturnType<typeof useCreateTaskWithSectionMutation>;
export type CreateTaskWithSectionMutationResult = Apollo.MutationResult<CreateTaskWithSectionMutation>;
export type CreateTaskWithSectionMutationOptions = Apollo.BaseMutationOptions<CreateTaskWithSectionMutation, CreateTaskWithSectionMutationVariables>;
export const GetTasksBySourceTypeAndIdDocument = gql`
    query GetTasksBySourceTypeAndId($primaryFilter: TaskPrimaryFilterInput, $page: Int = 1, $perPage: Int = 10) {
  tasks(primaryFilter: $primaryFilter, page: $page, perPage: $perPage) {
    entries {
      ...TaskWithProjectTaskSection
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${TaskWithProjectTaskSectionFragmentDoc}`;

/**
 * __useGetTasksBySourceTypeAndIdQuery__
 *
 * To run a query within a React component, call `useGetTasksBySourceTypeAndIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksBySourceTypeAndIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksBySourceTypeAndIdQuery({
 *   variables: {
 *      primaryFilter: // value for 'primaryFilter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetTasksBySourceTypeAndIdQuery(baseOptions?: Apollo.QueryHookOptions<GetTasksBySourceTypeAndIdQuery, GetTasksBySourceTypeAndIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksBySourceTypeAndIdQuery, GetTasksBySourceTypeAndIdQueryVariables>(GetTasksBySourceTypeAndIdDocument, options);
      }
export function useGetTasksBySourceTypeAndIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksBySourceTypeAndIdQuery, GetTasksBySourceTypeAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksBySourceTypeAndIdQuery, GetTasksBySourceTypeAndIdQueryVariables>(GetTasksBySourceTypeAndIdDocument, options);
        }
export type GetTasksBySourceTypeAndIdQueryHookResult = ReturnType<typeof useGetTasksBySourceTypeAndIdQuery>;
export type GetTasksBySourceTypeAndIdLazyQueryHookResult = ReturnType<typeof useGetTasksBySourceTypeAndIdLazyQuery>;
export type GetTasksBySourceTypeAndIdQueryResult = Apollo.QueryResult<GetTasksBySourceTypeAndIdQuery, GetTasksBySourceTypeAndIdQueryVariables>;
export const ProjectTaskSectionsDocument = gql`
    query ProjectTaskSections($projectUid: String!) {
  projectTaskSections(projectUid: $projectUid) {
    entries {
      ...ProjectSection
    }
  }
}
    ${ProjectSectionFragmentDoc}`;

/**
 * __useProjectTaskSectionsQuery__
 *
 * To run a query within a React component, call `useProjectTaskSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTaskSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTaskSectionsQuery({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *   },
 * });
 */
export function useProjectTaskSectionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectTaskSectionsQuery, ProjectTaskSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectTaskSectionsQuery, ProjectTaskSectionsQueryVariables>(ProjectTaskSectionsDocument, options);
      }
export function useProjectTaskSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTaskSectionsQuery, ProjectTaskSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectTaskSectionsQuery, ProjectTaskSectionsQueryVariables>(ProjectTaskSectionsDocument, options);
        }
export type ProjectTaskSectionsQueryHookResult = ReturnType<typeof useProjectTaskSectionsQuery>;
export type ProjectTaskSectionsLazyQueryHookResult = ReturnType<typeof useProjectTaskSectionsLazyQuery>;
export type ProjectTaskSectionsQueryResult = Apollo.QueryResult<ProjectTaskSectionsQuery, ProjectTaskSectionsQueryVariables>;
export const RemoveProjectTaskSectionDocument = gql`
    mutation RemoveProjectTaskSection($projectTaskSectionUid: ID!) {
  removeProjectTaskSection(projectTaskSectionUid: $projectTaskSectionUid) {
    failReasons
  }
}
    `;
export type RemoveProjectTaskSectionMutationFn = Apollo.MutationFunction<RemoveProjectTaskSectionMutation, RemoveProjectTaskSectionMutationVariables>;

/**
 * __useRemoveProjectTaskSectionMutation__
 *
 * To run a mutation, you first call `useRemoveProjectTaskSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectTaskSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectTaskSectionMutation, { data, loading, error }] = useRemoveProjectTaskSectionMutation({
 *   variables: {
 *      projectTaskSectionUid: // value for 'projectTaskSectionUid'
 *   },
 * });
 */
export function useRemoveProjectTaskSectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectTaskSectionMutation, RemoveProjectTaskSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectTaskSectionMutation, RemoveProjectTaskSectionMutationVariables>(RemoveProjectTaskSectionDocument, options);
      }
export type RemoveProjectTaskSectionMutationHookResult = ReturnType<typeof useRemoveProjectTaskSectionMutation>;
export type RemoveProjectTaskSectionMutationResult = Apollo.MutationResult<RemoveProjectTaskSectionMutation>;
export type RemoveProjectTaskSectionMutationOptions = Apollo.BaseMutationOptions<RemoveProjectTaskSectionMutation, RemoveProjectTaskSectionMutationVariables>;
export const RenameProjectTaskSectionDocument = gql`
    mutation RenameProjectTaskSection($projectTaskSectionUid: ID!, $title: String!) {
  updateProjectTaskSection(
    projectTaskSectionUid: $projectTaskSectionUid
    title: $title
  ) {
    failReasons
    record {
      id
      title
    }
  }
}
    `;
export type RenameProjectTaskSectionMutationFn = Apollo.MutationFunction<RenameProjectTaskSectionMutation, RenameProjectTaskSectionMutationVariables>;

/**
 * __useRenameProjectTaskSectionMutation__
 *
 * To run a mutation, you first call `useRenameProjectTaskSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameProjectTaskSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameProjectTaskSectionMutation, { data, loading, error }] = useRenameProjectTaskSectionMutation({
 *   variables: {
 *      projectTaskSectionUid: // value for 'projectTaskSectionUid'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRenameProjectTaskSectionMutation(baseOptions?: Apollo.MutationHookOptions<RenameProjectTaskSectionMutation, RenameProjectTaskSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameProjectTaskSectionMutation, RenameProjectTaskSectionMutationVariables>(RenameProjectTaskSectionDocument, options);
      }
export type RenameProjectTaskSectionMutationHookResult = ReturnType<typeof useRenameProjectTaskSectionMutation>;
export type RenameProjectTaskSectionMutationResult = Apollo.MutationResult<RenameProjectTaskSectionMutation>;
export type RenameProjectTaskSectionMutationOptions = Apollo.BaseMutationOptions<RenameProjectTaskSectionMutation, RenameProjectTaskSectionMutationVariables>;
export const UpdateProjectTaskSectionPositionsDocument = gql`
    mutation UpdateProjectTaskSectionPositions($projectUid: ID!, $projectTaskSectionUids: [ID!]!) {
  updateProjectTaskSectionPositions(
    projectUid: $projectUid
    projectTaskSectionUids: $projectTaskSectionUids
  ) {
    failReasons
    updatedProjectTaskSections {
      ...ProjectSection
    }
  }
}
    ${ProjectSectionFragmentDoc}`;
export type UpdateProjectTaskSectionPositionsMutationFn = Apollo.MutationFunction<UpdateProjectTaskSectionPositionsMutation, UpdateProjectTaskSectionPositionsMutationVariables>;

/**
 * __useUpdateProjectTaskSectionPositionsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectTaskSectionPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectTaskSectionPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectTaskSectionPositionsMutation, { data, loading, error }] = useUpdateProjectTaskSectionPositionsMutation({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *      projectTaskSectionUids: // value for 'projectTaskSectionUids'
 *   },
 * });
 */
export function useUpdateProjectTaskSectionPositionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectTaskSectionPositionsMutation, UpdateProjectTaskSectionPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectTaskSectionPositionsMutation, UpdateProjectTaskSectionPositionsMutationVariables>(UpdateProjectTaskSectionPositionsDocument, options);
      }
export type UpdateProjectTaskSectionPositionsMutationHookResult = ReturnType<typeof useUpdateProjectTaskSectionPositionsMutation>;
export type UpdateProjectTaskSectionPositionsMutationResult = Apollo.MutationResult<UpdateProjectTaskSectionPositionsMutation>;
export type UpdateProjectTaskSectionPositionsMutationOptions = Apollo.BaseMutationOptions<UpdateProjectTaskSectionPositionsMutation, UpdateProjectTaskSectionPositionsMutationVariables>;
export const UpdateTaskPositionsDocument = gql`
    mutation UpdateTaskPositions($projectTaskSectionUid: ID!, $projectUid: ID!, $taskUids: [ID!]!) {
  updateTaskPositions(
    projectTaskSectionUid: $projectTaskSectionUid
    projectUid: $projectUid
    taskUids: $taskUids
  ) {
    failReasons
  }
}
    `;
export type UpdateTaskPositionsMutationFn = Apollo.MutationFunction<UpdateTaskPositionsMutation, UpdateTaskPositionsMutationVariables>;

/**
 * __useUpdateTaskPositionsMutation__
 *
 * To run a mutation, you first call `useUpdateTaskPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskPositionsMutation, { data, loading, error }] = useUpdateTaskPositionsMutation({
 *   variables: {
 *      projectTaskSectionUid: // value for 'projectTaskSectionUid'
 *      projectUid: // value for 'projectUid'
 *      taskUids: // value for 'taskUids'
 *   },
 * });
 */
export function useUpdateTaskPositionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskPositionsMutation, UpdateTaskPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskPositionsMutation, UpdateTaskPositionsMutationVariables>(UpdateTaskPositionsDocument, options);
      }
export type UpdateTaskPositionsMutationHookResult = ReturnType<typeof useUpdateTaskPositionsMutation>;
export type UpdateTaskPositionsMutationResult = Apollo.MutationResult<UpdateTaskPositionsMutation>;
export type UpdateTaskPositionsMutationOptions = Apollo.BaseMutationOptions<UpdateTaskPositionsMutation, UpdateTaskPositionsMutationVariables>;
export const AddProjectTaskDocument = gql`
    mutation AddProjectTask($uid: ID!, $attributes: ProjectTaskAttribute!) {
  addProjectTask(uuid: $uid, attributes: $attributes) {
    failReasons
  }
}
    `;
export type AddProjectTaskMutationFn = Apollo.MutationFunction<AddProjectTaskMutation, AddProjectTaskMutationVariables>;

/**
 * __useAddProjectTaskMutation__
 *
 * To run a mutation, you first call `useAddProjectTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectTaskMutation, { data, loading, error }] = useAddProjectTaskMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddProjectTaskMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectTaskMutation, AddProjectTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectTaskMutation, AddProjectTaskMutationVariables>(AddProjectTaskDocument, options);
      }
export type AddProjectTaskMutationHookResult = ReturnType<typeof useAddProjectTaskMutation>;
export type AddProjectTaskMutationResult = Apollo.MutationResult<AddProjectTaskMutation>;
export type AddProjectTaskMutationOptions = Apollo.BaseMutationOptions<AddProjectTaskMutation, AddProjectTaskMutationVariables>;
export const GetProjectTasksDocument = gql`
    query GetProjectTasks($uid: ID!, $page: Int, $perPage: Int, $filter: ProjectTaskFiltering) {
  projectTasks(uuid: $uid, page: $page, perPage: $perPage, filter: $filter) {
    entries {
      ...ProjectTaskPreview
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ProjectTaskPreviewFragmentDoc}`;

/**
 * __useGetProjectTasksQuery__
 *
 * To run a query within a React component, call `useGetProjectTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTasksQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProjectTasksQuery(baseOptions: Apollo.QueryHookOptions<GetProjectTasksQuery, GetProjectTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectTasksQuery, GetProjectTasksQueryVariables>(GetProjectTasksDocument, options);
      }
export function useGetProjectTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectTasksQuery, GetProjectTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectTasksQuery, GetProjectTasksQueryVariables>(GetProjectTasksDocument, options);
        }
export type GetProjectTasksQueryHookResult = ReturnType<typeof useGetProjectTasksQuery>;
export type GetProjectTasksLazyQueryHookResult = ReturnType<typeof useGetProjectTasksLazyQuery>;
export type GetProjectTasksQueryResult = Apollo.QueryResult<GetProjectTasksQuery, GetProjectTasksQueryVariables>;
export const ProjectOverviewTasksDocument = gql`
    query ProjectOverviewTasks($primaryFilter: TaskPrimaryFilterInput) {
  tasks(
    primaryFilter: $primaryFilter
    page: 1
    perPage: 3
    filter: {status: PENDING}
  ) {
    entries {
      ...TaskPreview
    }
  }
}
    ${TaskPreviewFragmentDoc}`;

/**
 * __useProjectOverviewTasksQuery__
 *
 * To run a query within a React component, call `useProjectOverviewTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOverviewTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOverviewTasksQuery({
 *   variables: {
 *      primaryFilter: // value for 'primaryFilter'
 *   },
 * });
 */
export function useProjectOverviewTasksQuery(baseOptions?: Apollo.QueryHookOptions<ProjectOverviewTasksQuery, ProjectOverviewTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectOverviewTasksQuery, ProjectOverviewTasksQueryVariables>(ProjectOverviewTasksDocument, options);
      }
export function useProjectOverviewTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectOverviewTasksQuery, ProjectOverviewTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectOverviewTasksQuery, ProjectOverviewTasksQueryVariables>(ProjectOverviewTasksDocument, options);
        }
export type ProjectOverviewTasksQueryHookResult = ReturnType<typeof useProjectOverviewTasksQuery>;
export type ProjectOverviewTasksLazyQueryHookResult = ReturnType<typeof useProjectOverviewTasksLazyQuery>;
export type ProjectOverviewTasksQueryResult = Apollo.QueryResult<ProjectOverviewTasksQuery, ProjectOverviewTasksQueryVariables>;
export const CreateSentReferralDocument = gql`
    mutation CreateSentReferral($sentToContactUid: ID!, $clientContactUid: ID, $clientCompanyUid: ID!, $referredByEmployeeUid: ID!, $sentAt: ISO8601DateTime!, $typeOfLegalMatter: String, $resultStatus: SentReferralResultStatus, $customFieldAttributes: [CustomFieldAttribute!]) {
  createSentReferral(
    sentToContactUid: $sentToContactUid
    clientContactUid: $clientContactUid
    clientCompanyUid: $clientCompanyUid
    referredByEmployeeUid: $referredByEmployeeUid
    sentAt: $sentAt
    typeOfLegalMatter: $typeOfLegalMatter
    resultStatus: $resultStatus
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
  }
}
    `;
export type CreateSentReferralMutationFn = Apollo.MutationFunction<CreateSentReferralMutation, CreateSentReferralMutationVariables>;

/**
 * __useCreateSentReferralMutation__
 *
 * To run a mutation, you first call `useCreateSentReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSentReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSentReferralMutation, { data, loading, error }] = useCreateSentReferralMutation({
 *   variables: {
 *      sentToContactUid: // value for 'sentToContactUid'
 *      clientContactUid: // value for 'clientContactUid'
 *      clientCompanyUid: // value for 'clientCompanyUid'
 *      referredByEmployeeUid: // value for 'referredByEmployeeUid'
 *      sentAt: // value for 'sentAt'
 *      typeOfLegalMatter: // value for 'typeOfLegalMatter'
 *      resultStatus: // value for 'resultStatus'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useCreateSentReferralMutation(baseOptions?: Apollo.MutationHookOptions<CreateSentReferralMutation, CreateSentReferralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSentReferralMutation, CreateSentReferralMutationVariables>(CreateSentReferralDocument, options);
      }
export type CreateSentReferralMutationHookResult = ReturnType<typeof useCreateSentReferralMutation>;
export type CreateSentReferralMutationResult = Apollo.MutationResult<CreateSentReferralMutation>;
export type CreateSentReferralMutationOptions = Apollo.BaseMutationOptions<CreateSentReferralMutation, CreateSentReferralMutationVariables>;
export const DeleteSentReferralDocument = gql`
    mutation DeleteSentReferral($id: ID!) {
  deleteSentReferral(sentReferralUid: $id) {
    failReasons
  }
}
    `;
export type DeleteSentReferralMutationFn = Apollo.MutationFunction<DeleteSentReferralMutation, DeleteSentReferralMutationVariables>;

/**
 * __useDeleteSentReferralMutation__
 *
 * To run a mutation, you first call `useDeleteSentReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSentReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSentReferralMutation, { data, loading, error }] = useDeleteSentReferralMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSentReferralMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSentReferralMutation, DeleteSentReferralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSentReferralMutation, DeleteSentReferralMutationVariables>(DeleteSentReferralDocument, options);
      }
export type DeleteSentReferralMutationHookResult = ReturnType<typeof useDeleteSentReferralMutation>;
export type DeleteSentReferralMutationResult = Apollo.MutationResult<DeleteSentReferralMutation>;
export type DeleteSentReferralMutationOptions = Apollo.BaseMutationOptions<DeleteSentReferralMutation, DeleteSentReferralMutationVariables>;
export const ReceivedReferralsTotalDocument = gql`
    query ReceivedReferralsTotal($page: Int = 1, $perPage: Int = 1, $term: String) {
  companyGoals(
    filter: {receivedReferral: true, term: $term}
    page: $page
    perPage: $perPage
  ) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useReceivedReferralsTotalQuery__
 *
 * To run a query within a React component, call `useReceivedReferralsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceivedReferralsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceivedReferralsTotalQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useReceivedReferralsTotalQuery(baseOptions?: Apollo.QueryHookOptions<ReceivedReferralsTotalQuery, ReceivedReferralsTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReceivedReferralsTotalQuery, ReceivedReferralsTotalQueryVariables>(ReceivedReferralsTotalDocument, options);
      }
export function useReceivedReferralsTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceivedReferralsTotalQuery, ReceivedReferralsTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReceivedReferralsTotalQuery, ReceivedReferralsTotalQueryVariables>(ReceivedReferralsTotalDocument, options);
        }
export type ReceivedReferralsTotalQueryHookResult = ReturnType<typeof useReceivedReferralsTotalQuery>;
export type ReceivedReferralsTotalLazyQueryHookResult = ReturnType<typeof useReceivedReferralsTotalLazyQuery>;
export type ReceivedReferralsTotalQueryResult = Apollo.QueryResult<ReceivedReferralsTotalQuery, ReceivedReferralsTotalQueryVariables>;
export const SentReferralDocument = gql`
    query SentReferral($sentReferralUid: ID!) {
  sentReferral(sentReferralUid: $sentReferralUid) {
    ...SentReferralForForm
  }
}
    ${SentReferralForFormFragmentDoc}`;

/**
 * __useSentReferralQuery__
 *
 * To run a query within a React component, call `useSentReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentReferralQuery({
 *   variables: {
 *      sentReferralUid: // value for 'sentReferralUid'
 *   },
 * });
 */
export function useSentReferralQuery(baseOptions: Apollo.QueryHookOptions<SentReferralQuery, SentReferralQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentReferralQuery, SentReferralQueryVariables>(SentReferralDocument, options);
      }
export function useSentReferralLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentReferralQuery, SentReferralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentReferralQuery, SentReferralQueryVariables>(SentReferralDocument, options);
        }
export type SentReferralQueryHookResult = ReturnType<typeof useSentReferralQuery>;
export type SentReferralLazyQueryHookResult = ReturnType<typeof useSentReferralLazyQuery>;
export type SentReferralQueryResult = Apollo.QueryResult<SentReferralQuery, SentReferralQueryVariables>;
export const SentReferralCustomFieldsDocument = gql`
    query SentReferralCustomFields {
  currentTenant {
    id
    sentReferralCustomFields {
      ...CustomFieldSchema
    }
  }
}
    ${CustomFieldSchemaFragmentDoc}`;

/**
 * __useSentReferralCustomFieldsQuery__
 *
 * To run a query within a React component, call `useSentReferralCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentReferralCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentReferralCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSentReferralCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<SentReferralCustomFieldsQuery, SentReferralCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentReferralCustomFieldsQuery, SentReferralCustomFieldsQueryVariables>(SentReferralCustomFieldsDocument, options);
      }
export function useSentReferralCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentReferralCustomFieldsQuery, SentReferralCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentReferralCustomFieldsQuery, SentReferralCustomFieldsQueryVariables>(SentReferralCustomFieldsDocument, options);
        }
export type SentReferralCustomFieldsQueryHookResult = ReturnType<typeof useSentReferralCustomFieldsQuery>;
export type SentReferralCustomFieldsLazyQueryHookResult = ReturnType<typeof useSentReferralCustomFieldsLazyQuery>;
export type SentReferralCustomFieldsQueryResult = Apollo.QueryResult<SentReferralCustomFieldsQuery, SentReferralCustomFieldsQueryVariables>;
export const SentReferralsDocument = gql`
    query SentReferrals($filter: SentReferralsFilterInput = null, $page: Int = 1, $perPage: Int = 10) {
  sentReferrals(filter: $filter, page: $page, perPage: $perPage) {
    entries {
      ...SentReferralRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${SentReferralRowFragmentDoc}`;

/**
 * __useSentReferralsQuery__
 *
 * To run a query within a React component, call `useSentReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentReferralsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useSentReferralsQuery(baseOptions?: Apollo.QueryHookOptions<SentReferralsQuery, SentReferralsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentReferralsQuery, SentReferralsQueryVariables>(SentReferralsDocument, options);
      }
export function useSentReferralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentReferralsQuery, SentReferralsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentReferralsQuery, SentReferralsQueryVariables>(SentReferralsDocument, options);
        }
export type SentReferralsQueryHookResult = ReturnType<typeof useSentReferralsQuery>;
export type SentReferralsLazyQueryHookResult = ReturnType<typeof useSentReferralsLazyQuery>;
export type SentReferralsQueryResult = Apollo.QueryResult<SentReferralsQuery, SentReferralsQueryVariables>;
export const SentReferralsTotalDocument = gql`
    query SentReferralsTotal($filter: SentReferralsFilterInput = null, $page: Int = 1, $perPage: Int = 1) {
  sentReferrals(filter: $filter, page: $page, perPage: $perPage) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useSentReferralsTotalQuery__
 *
 * To run a query within a React component, call `useSentReferralsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentReferralsTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentReferralsTotalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useSentReferralsTotalQuery(baseOptions?: Apollo.QueryHookOptions<SentReferralsTotalQuery, SentReferralsTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentReferralsTotalQuery, SentReferralsTotalQueryVariables>(SentReferralsTotalDocument, options);
      }
export function useSentReferralsTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentReferralsTotalQuery, SentReferralsTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentReferralsTotalQuery, SentReferralsTotalQueryVariables>(SentReferralsTotalDocument, options);
        }
export type SentReferralsTotalQueryHookResult = ReturnType<typeof useSentReferralsTotalQuery>;
export type SentReferralsTotalLazyQueryHookResult = ReturnType<typeof useSentReferralsTotalLazyQuery>;
export type SentReferralsTotalQueryResult = Apollo.QueryResult<SentReferralsTotalQuery, SentReferralsTotalQueryVariables>;
export const UpdateSentReferralDocument = gql`
    mutation UpdateSentReferral($sentReferralUid: ID!, $clientContactUid: ID, $referredByEmployeeUid: ID, $sentAt: ISO8601DateTime, $typeOfLegalMatter: String, $resultStatus: SentReferralResultStatus, $customFieldAttributes: [CustomFieldAttribute!]) {
  updateSentReferral(
    sentReferralUid: $sentReferralUid
    clientContactUid: $clientContactUid
    referredByEmployeeUid: $referredByEmployeeUid
    sentAt: $sentAt
    typeOfLegalMatter: $typeOfLegalMatter
    resultStatus: $resultStatus
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
    record {
      ...SentReferralRow
    }
  }
}
    ${SentReferralRowFragmentDoc}`;
export type UpdateSentReferralMutationFn = Apollo.MutationFunction<UpdateSentReferralMutation, UpdateSentReferralMutationVariables>;

/**
 * __useUpdateSentReferralMutation__
 *
 * To run a mutation, you first call `useUpdateSentReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSentReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSentReferralMutation, { data, loading, error }] = useUpdateSentReferralMutation({
 *   variables: {
 *      sentReferralUid: // value for 'sentReferralUid'
 *      clientContactUid: // value for 'clientContactUid'
 *      referredByEmployeeUid: // value for 'referredByEmployeeUid'
 *      sentAt: // value for 'sentAt'
 *      typeOfLegalMatter: // value for 'typeOfLegalMatter'
 *      resultStatus: // value for 'resultStatus'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useUpdateSentReferralMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSentReferralMutation, UpdateSentReferralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSentReferralMutation, UpdateSentReferralMutationVariables>(UpdateSentReferralDocument, options);
      }
export type UpdateSentReferralMutationHookResult = ReturnType<typeof useUpdateSentReferralMutation>;
export type UpdateSentReferralMutationResult = Apollo.MutationResult<UpdateSentReferralMutation>;
export type UpdateSentReferralMutationOptions = Apollo.BaseMutationOptions<UpdateSentReferralMutation, UpdateSentReferralMutationVariables>;
export const CompanyListReminderSettingsDocument = gql`
    query CompanyListReminderSettings($companyListUid: ID!) {
  companyListReminderSettings(companyListUid: $companyListUid) {
    ...ReminderSettingPreview
  }
}
    ${ReminderSettingPreviewFragmentDoc}`;

/**
 * __useCompanyListReminderSettingsQuery__
 *
 * To run a query within a React component, call `useCompanyListReminderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListReminderSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListReminderSettingsQuery({
 *   variables: {
 *      companyListUid: // value for 'companyListUid'
 *   },
 * });
 */
export function useCompanyListReminderSettingsQuery(baseOptions: Apollo.QueryHookOptions<CompanyListReminderSettingsQuery, CompanyListReminderSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListReminderSettingsQuery, CompanyListReminderSettingsQueryVariables>(CompanyListReminderSettingsDocument, options);
      }
export function useCompanyListReminderSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListReminderSettingsQuery, CompanyListReminderSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListReminderSettingsQuery, CompanyListReminderSettingsQueryVariables>(CompanyListReminderSettingsDocument, options);
        }
export type CompanyListReminderSettingsQueryHookResult = ReturnType<typeof useCompanyListReminderSettingsQuery>;
export type CompanyListReminderSettingsLazyQueryHookResult = ReturnType<typeof useCompanyListReminderSettingsLazyQuery>;
export type CompanyListReminderSettingsQueryResult = Apollo.QueryResult<CompanyListReminderSettingsQuery, CompanyListReminderSettingsQueryVariables>;
export const ContactListReminderSettingsDocument = gql`
    query ContactListReminderSettings($contactListUid: ID!) {
  contactListReminderSettings(contactListUid: $contactListUid) {
    ...ReminderSettingPreview
  }
}
    ${ReminderSettingPreviewFragmentDoc}`;

/**
 * __useContactListReminderSettingsQuery__
 *
 * To run a query within a React component, call `useContactListReminderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListReminderSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListReminderSettingsQuery({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *   },
 * });
 */
export function useContactListReminderSettingsQuery(baseOptions: Apollo.QueryHookOptions<ContactListReminderSettingsQuery, ContactListReminderSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListReminderSettingsQuery, ContactListReminderSettingsQueryVariables>(ContactListReminderSettingsDocument, options);
      }
export function useContactListReminderSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListReminderSettingsQuery, ContactListReminderSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListReminderSettingsQuery, ContactListReminderSettingsQueryVariables>(ContactListReminderSettingsDocument, options);
        }
export type ContactListReminderSettingsQueryHookResult = ReturnType<typeof useContactListReminderSettingsQuery>;
export type ContactListReminderSettingsLazyQueryHookResult = ReturnType<typeof useContactListReminderSettingsLazyQuery>;
export type ContactListReminderSettingsQueryResult = Apollo.QueryResult<ContactListReminderSettingsQuery, ContactListReminderSettingsQueryVariables>;
export const CreateContactListReminderSettingDocument = gql`
    mutation CreateContactListReminderSetting($contactListUid: ID!, $timePreposition: ReminderSettingTimePreposition!, $emailSubject: String!, $reminderDays: Int!, $employeeEmails: [String!]!, $dateProperty: String!) {
  result: createContactListReminderSetting(
    contactListUid: $contactListUid
    timePreposition: $timePreposition
    emailSubject: $emailSubject
    reminderDays: $reminderDays
    employeeEmails: $employeeEmails
    dateProperty: $dateProperty
  ) {
    failReasons
  }
}
    `;
export type CreateContactListReminderSettingMutationFn = Apollo.MutationFunction<CreateContactListReminderSettingMutation, CreateContactListReminderSettingMutationVariables>;

/**
 * __useCreateContactListReminderSettingMutation__
 *
 * To run a mutation, you first call `useCreateContactListReminderSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactListReminderSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactListReminderSettingMutation, { data, loading, error }] = useCreateContactListReminderSettingMutation({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *      timePreposition: // value for 'timePreposition'
 *      emailSubject: // value for 'emailSubject'
 *      reminderDays: // value for 'reminderDays'
 *      employeeEmails: // value for 'employeeEmails'
 *      dateProperty: // value for 'dateProperty'
 *   },
 * });
 */
export function useCreateContactListReminderSettingMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactListReminderSettingMutation, CreateContactListReminderSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactListReminderSettingMutation, CreateContactListReminderSettingMutationVariables>(CreateContactListReminderSettingDocument, options);
      }
export type CreateContactListReminderSettingMutationHookResult = ReturnType<typeof useCreateContactListReminderSettingMutation>;
export type CreateContactListReminderSettingMutationResult = Apollo.MutationResult<CreateContactListReminderSettingMutation>;
export type CreateContactListReminderSettingMutationOptions = Apollo.BaseMutationOptions<CreateContactListReminderSettingMutation, CreateContactListReminderSettingMutationVariables>;
export const DatePropertiesForContactListReminderDocument = gql`
    query DatePropertiesForContactListReminder($contactListUid: ID!) {
  datePropertiesForContactListReminder(contactListUid: $contactListUid) {
    ...DatePropertyOption
  }
}
    ${DatePropertyOptionFragmentDoc}`;

/**
 * __useDatePropertiesForContactListReminderQuery__
 *
 * To run a query within a React component, call `useDatePropertiesForContactListReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatePropertiesForContactListReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatePropertiesForContactListReminderQuery({
 *   variables: {
 *      contactListUid: // value for 'contactListUid'
 *   },
 * });
 */
export function useDatePropertiesForContactListReminderQuery(baseOptions: Apollo.QueryHookOptions<DatePropertiesForContactListReminderQuery, DatePropertiesForContactListReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatePropertiesForContactListReminderQuery, DatePropertiesForContactListReminderQueryVariables>(DatePropertiesForContactListReminderDocument, options);
      }
export function useDatePropertiesForContactListReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatePropertiesForContactListReminderQuery, DatePropertiesForContactListReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatePropertiesForContactListReminderQuery, DatePropertiesForContactListReminderQueryVariables>(DatePropertiesForContactListReminderDocument, options);
        }
export type DatePropertiesForContactListReminderQueryHookResult = ReturnType<typeof useDatePropertiesForContactListReminderQuery>;
export type DatePropertiesForContactListReminderLazyQueryHookResult = ReturnType<typeof useDatePropertiesForContactListReminderLazyQuery>;
export type DatePropertiesForContactListReminderQueryResult = Apollo.QueryResult<DatePropertiesForContactListReminderQuery, DatePropertiesForContactListReminderQueryVariables>;
export const DismissReminderDocument = gql`
    mutation DismissReminder($reminderUid: ID!) {
  dismissReminder(reminderUid: $reminderUid) {
    failReasons
  }
}
    `;
export type DismissReminderMutationFn = Apollo.MutationFunction<DismissReminderMutation, DismissReminderMutationVariables>;

/**
 * __useDismissReminderMutation__
 *
 * To run a mutation, you first call `useDismissReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissReminderMutation, { data, loading, error }] = useDismissReminderMutation({
 *   variables: {
 *      reminderUid: // value for 'reminderUid'
 *   },
 * });
 */
export function useDismissReminderMutation(baseOptions?: Apollo.MutationHookOptions<DismissReminderMutation, DismissReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissReminderMutation, DismissReminderMutationVariables>(DismissReminderDocument, options);
      }
export type DismissReminderMutationHookResult = ReturnType<typeof useDismissReminderMutation>;
export type DismissReminderMutationResult = Apollo.MutationResult<DismissReminderMutation>;
export type DismissReminderMutationOptions = Apollo.BaseMutationOptions<DismissReminderMutation, DismissReminderMutationVariables>;
export const ContactListMemberRemindersDocument = gql`
    query ContactListMemberReminders($listMemberUid: ID!) {
  listMember(listMemberUid: $listMemberUid) {
    id
    listReminders {
      id
      active
      reminderSetting {
        emailSubject
        id
        dateProperty
      }
    }
  }
}
    `;

/**
 * __useContactListMemberRemindersQuery__
 *
 * To run a query within a React component, call `useContactListMemberRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListMemberRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListMemberRemindersQuery({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *   },
 * });
 */
export function useContactListMemberRemindersQuery(baseOptions: Apollo.QueryHookOptions<ContactListMemberRemindersQuery, ContactListMemberRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListMemberRemindersQuery, ContactListMemberRemindersQueryVariables>(ContactListMemberRemindersDocument, options);
      }
export function useContactListMemberRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListMemberRemindersQuery, ContactListMemberRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListMemberRemindersQuery, ContactListMemberRemindersQueryVariables>(ContactListMemberRemindersDocument, options);
        }
export type ContactListMemberRemindersQueryHookResult = ReturnType<typeof useContactListMemberRemindersQuery>;
export type ContactListMemberRemindersLazyQueryHookResult = ReturnType<typeof useContactListMemberRemindersLazyQuery>;
export type ContactListMemberRemindersQueryResult = Apollo.QueryResult<ContactListMemberRemindersQuery, ContactListMemberRemindersQueryVariables>;
export const RemoveCompanyReminderSettingDocument = gql`
    mutation RemoveCompanyReminderSetting($reminderSettingUid: ID!) {
  removeReminderSetting(reminderSettingUid: $reminderSettingUid) {
    failReasons
  }
}
    `;
export type RemoveCompanyReminderSettingMutationFn = Apollo.MutationFunction<RemoveCompanyReminderSettingMutation, RemoveCompanyReminderSettingMutationVariables>;

/**
 * __useRemoveCompanyReminderSettingMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyReminderSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyReminderSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyReminderSettingMutation, { data, loading, error }] = useRemoveCompanyReminderSettingMutation({
 *   variables: {
 *      reminderSettingUid: // value for 'reminderSettingUid'
 *   },
 * });
 */
export function useRemoveCompanyReminderSettingMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyReminderSettingMutation, RemoveCompanyReminderSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyReminderSettingMutation, RemoveCompanyReminderSettingMutationVariables>(RemoveCompanyReminderSettingDocument, options);
      }
export type RemoveCompanyReminderSettingMutationHookResult = ReturnType<typeof useRemoveCompanyReminderSettingMutation>;
export type RemoveCompanyReminderSettingMutationResult = Apollo.MutationResult<RemoveCompanyReminderSettingMutation>;
export type RemoveCompanyReminderSettingMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyReminderSettingMutation, RemoveCompanyReminderSettingMutationVariables>;
export const UpdateCompanyReminderSettingDocument = gql`
    mutation UpdateCompanyReminderSetting($reminderSettingUid: ID!, $timePreposition: ReminderSettingTimePreposition, $emailSubject: String, $reminderDays: Int, $employeeEmails: [String!]) {
  updateReminderSetting(
    reminderSettingUid: $reminderSettingUid
    timePreposition: $timePreposition
    emailSubject: $emailSubject
    reminderDays: $reminderDays
    employeeEmails: $employeeEmails
  ) {
    failReasons
  }
}
    `;
export type UpdateCompanyReminderSettingMutationFn = Apollo.MutationFunction<UpdateCompanyReminderSettingMutation, UpdateCompanyReminderSettingMutationVariables>;

/**
 * __useUpdateCompanyReminderSettingMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyReminderSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyReminderSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyReminderSettingMutation, { data, loading, error }] = useUpdateCompanyReminderSettingMutation({
 *   variables: {
 *      reminderSettingUid: // value for 'reminderSettingUid'
 *      timePreposition: // value for 'timePreposition'
 *      emailSubject: // value for 'emailSubject'
 *      reminderDays: // value for 'reminderDays'
 *      employeeEmails: // value for 'employeeEmails'
 *   },
 * });
 */
export function useUpdateCompanyReminderSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyReminderSettingMutation, UpdateCompanyReminderSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyReminderSettingMutation, UpdateCompanyReminderSettingMutationVariables>(UpdateCompanyReminderSettingDocument, options);
      }
export type UpdateCompanyReminderSettingMutationHookResult = ReturnType<typeof useUpdateCompanyReminderSettingMutation>;
export type UpdateCompanyReminderSettingMutationResult = Apollo.MutationResult<UpdateCompanyReminderSettingMutation>;
export type UpdateCompanyReminderSettingMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyReminderSettingMutation, UpdateCompanyReminderSettingMutationVariables>;
export const CanViewEmbeddedReportDocument = gql`
    query CanViewEmbeddedReport {
  currentUser {
    id
    canViewEmbeddedReport
  }
}
    `;

/**
 * __useCanViewEmbeddedReportQuery__
 *
 * To run a query within a React component, call `useCanViewEmbeddedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanViewEmbeddedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanViewEmbeddedReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanViewEmbeddedReportQuery(baseOptions?: Apollo.QueryHookOptions<CanViewEmbeddedReportQuery, CanViewEmbeddedReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanViewEmbeddedReportQuery, CanViewEmbeddedReportQueryVariables>(CanViewEmbeddedReportDocument, options);
      }
export function useCanViewEmbeddedReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanViewEmbeddedReportQuery, CanViewEmbeddedReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanViewEmbeddedReportQuery, CanViewEmbeddedReportQueryVariables>(CanViewEmbeddedReportDocument, options);
        }
export type CanViewEmbeddedReportQueryHookResult = ReturnType<typeof useCanViewEmbeddedReportQuery>;
export type CanViewEmbeddedReportLazyQueryHookResult = ReturnType<typeof useCanViewEmbeddedReportLazyQuery>;
export type CanViewEmbeddedReportQueryResult = Apollo.QueryResult<CanViewEmbeddedReportQuery, CanViewEmbeddedReportQueryVariables>;
export const DashboardListDocument = gql`
    query DashboardList {
  dashboardList {
    entries {
      ...Report
    }
  }
}
    ${ReportFragmentDoc}`;

/**
 * __useDashboardListQuery__
 *
 * To run a query within a React component, call `useDashboardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardListQuery(baseOptions?: Apollo.QueryHookOptions<DashboardListQuery, DashboardListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardListQuery, DashboardListQueryVariables>(DashboardListDocument, options);
      }
export function useDashboardListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardListQuery, DashboardListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardListQuery, DashboardListQueryVariables>(DashboardListDocument, options);
        }
export type DashboardListQueryHookResult = ReturnType<typeof useDashboardListQuery>;
export type DashboardListLazyQueryHookResult = ReturnType<typeof useDashboardListLazyQuery>;
export type DashboardListQueryResult = Apollo.QueryResult<DashboardListQuery, DashboardListQueryVariables>;
export const EmbeddedReportingDashboardDocument = gql`
    query EmbeddedReportingDashboard($dashboardUid: String!) {
  embeddedReportingDashboard(dashboardUid: $dashboardUid) {
    id
    title
    description {
      html
    }
    embeddedPath
  }
}
    `;

/**
 * __useEmbeddedReportingDashboardQuery__
 *
 * To run a query within a React component, call `useEmbeddedReportingDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbeddedReportingDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbeddedReportingDashboardQuery({
 *   variables: {
 *      dashboardUid: // value for 'dashboardUid'
 *   },
 * });
 */
export function useEmbeddedReportingDashboardQuery(baseOptions: Apollo.QueryHookOptions<EmbeddedReportingDashboardQuery, EmbeddedReportingDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmbeddedReportingDashboardQuery, EmbeddedReportingDashboardQueryVariables>(EmbeddedReportingDashboardDocument, options);
      }
export function useEmbeddedReportingDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmbeddedReportingDashboardQuery, EmbeddedReportingDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmbeddedReportingDashboardQuery, EmbeddedReportingDashboardQueryVariables>(EmbeddedReportingDashboardDocument, options);
        }
export type EmbeddedReportingDashboardQueryHookResult = ReturnType<typeof useEmbeddedReportingDashboardQuery>;
export type EmbeddedReportingDashboardLazyQueryHookResult = ReturnType<typeof useEmbeddedReportingDashboardLazyQuery>;
export type EmbeddedReportingDashboardQueryResult = Apollo.QueryResult<EmbeddedReportingDashboardQuery, EmbeddedReportingDashboardQueryVariables>;
export const BulkAllowReviewContactsDocument = gql`
    mutation BulkAllowReviewContacts($contactUids: [ID!]!) {
  bulkUpdateContactsReviewRuleValueForContacts(contactUids: $contactUids) {
    failReasons
  }
}
    `;
export type BulkAllowReviewContactsMutationFn = Apollo.MutationFunction<BulkAllowReviewContactsMutation, BulkAllowReviewContactsMutationVariables>;

/**
 * __useBulkAllowReviewContactsMutation__
 *
 * To run a mutation, you first call `useBulkAllowReviewContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAllowReviewContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAllowReviewContactsMutation, { data, loading, error }] = useBulkAllowReviewContactsMutation({
 *   variables: {
 *      contactUids: // value for 'contactUids'
 *   },
 * });
 */
export function useBulkAllowReviewContactsMutation(baseOptions?: Apollo.MutationHookOptions<BulkAllowReviewContactsMutation, BulkAllowReviewContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAllowReviewContactsMutation, BulkAllowReviewContactsMutationVariables>(BulkAllowReviewContactsDocument, options);
      }
export type BulkAllowReviewContactsMutationHookResult = ReturnType<typeof useBulkAllowReviewContactsMutation>;
export type BulkAllowReviewContactsMutationResult = Apollo.MutationResult<BulkAllowReviewContactsMutation>;
export type BulkAllowReviewContactsMutationOptions = Apollo.BaseMutationOptions<BulkAllowReviewContactsMutation, BulkAllowReviewContactsMutationVariables>;
export const BulkSetContactsPrivacyDocument = gql`
    mutation BulkSetContactsPrivacy($contactUids: [ID!]!, $privacyStatus: ContactPrivacy!, $removeFromMyContacts: Boolean) {
  bulkUpdateContactsPrivacy(
    contactUids: $contactUids
    privacyStatus: $privacyStatus
    removeFromMyContacts: $removeFromMyContacts
  ) {
    failReasons
  }
}
    `;
export type BulkSetContactsPrivacyMutationFn = Apollo.MutationFunction<BulkSetContactsPrivacyMutation, BulkSetContactsPrivacyMutationVariables>;

/**
 * __useBulkSetContactsPrivacyMutation__
 *
 * To run a mutation, you first call `useBulkSetContactsPrivacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSetContactsPrivacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSetContactsPrivacyMutation, { data, loading, error }] = useBulkSetContactsPrivacyMutation({
 *   variables: {
 *      contactUids: // value for 'contactUids'
 *      privacyStatus: // value for 'privacyStatus'
 *      removeFromMyContacts: // value for 'removeFromMyContacts'
 *   },
 * });
 */
export function useBulkSetContactsPrivacyMutation(baseOptions?: Apollo.MutationHookOptions<BulkSetContactsPrivacyMutation, BulkSetContactsPrivacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSetContactsPrivacyMutation, BulkSetContactsPrivacyMutationVariables>(BulkSetContactsPrivacyDocument, options);
      }
export type BulkSetContactsPrivacyMutationHookResult = ReturnType<typeof useBulkSetContactsPrivacyMutation>;
export type BulkSetContactsPrivacyMutationResult = Apollo.MutationResult<BulkSetContactsPrivacyMutation>;
export type BulkSetContactsPrivacyMutationOptions = Apollo.BaseMutationOptions<BulkSetContactsPrivacyMutation, BulkSetContactsPrivacyMutationVariables>;
export const ReviewContactsContextDocument = gql`
    query ReviewContactsContext {
  contactsReviewConfiguration {
    allowContactsReview
    id
  }
  contactsReviewRule {
    id
    title
    subTitle
    optionChoice {
      id
      value
    }
    schema {
      id
      name
    }
  }
}
    `;

/**
 * __useReviewContactsContextQuery__
 *
 * To run a query within a React component, call `useReviewContactsContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewContactsContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewContactsContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useReviewContactsContextQuery(baseOptions?: Apollo.QueryHookOptions<ReviewContactsContextQuery, ReviewContactsContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewContactsContextQuery, ReviewContactsContextQueryVariables>(ReviewContactsContextDocument, options);
      }
export function useReviewContactsContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewContactsContextQuery, ReviewContactsContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewContactsContextQuery, ReviewContactsContextQueryVariables>(ReviewContactsContextDocument, options);
        }
export type ReviewContactsContextQueryHookResult = ReturnType<typeof useReviewContactsContextQuery>;
export type ReviewContactsContextLazyQueryHookResult = ReturnType<typeof useReviewContactsContextLazyQuery>;
export type ReviewContactsContextQueryResult = Apollo.QueryResult<ReviewContactsContextQuery, ReviewContactsContextQueryVariables>;
export const ReviewContactsContextReviewableMyContactsDocument = gql`
    query ReviewContactsContextReviewableMyContacts($withCustomField: CustomFieldTerm!) {
  myContacts(
    filter: {withCustomField: [$withCustomField], excludeClassified: true}
  ) {
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useReviewContactsContextReviewableMyContactsQuery__
 *
 * To run a query within a React component, call `useReviewContactsContextReviewableMyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewContactsContextReviewableMyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewContactsContextReviewableMyContactsQuery({
 *   variables: {
 *      withCustomField: // value for 'withCustomField'
 *   },
 * });
 */
export function useReviewContactsContextReviewableMyContactsQuery(baseOptions: Apollo.QueryHookOptions<ReviewContactsContextReviewableMyContactsQuery, ReviewContactsContextReviewableMyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewContactsContextReviewableMyContactsQuery, ReviewContactsContextReviewableMyContactsQueryVariables>(ReviewContactsContextReviewableMyContactsDocument, options);
      }
export function useReviewContactsContextReviewableMyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewContactsContextReviewableMyContactsQuery, ReviewContactsContextReviewableMyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewContactsContextReviewableMyContactsQuery, ReviewContactsContextReviewableMyContactsQueryVariables>(ReviewContactsContextReviewableMyContactsDocument, options);
        }
export type ReviewContactsContextReviewableMyContactsQueryHookResult = ReturnType<typeof useReviewContactsContextReviewableMyContactsQuery>;
export type ReviewContactsContextReviewableMyContactsLazyQueryHookResult = ReturnType<typeof useReviewContactsContextReviewableMyContactsLazyQuery>;
export type ReviewContactsContextReviewableMyContactsQueryResult = Apollo.QueryResult<ReviewContactsContextReviewableMyContactsQuery, ReviewContactsContextReviewableMyContactsQueryVariables>;
export const CurrentAccountDocument = gql`
    query CurrentAccount {
  currentUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useCurrentAccountQuery__
 *
 * To run a query within a React component, call `useCurrentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAccountQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAccountQuery, CurrentAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAccountQuery, CurrentAccountQueryVariables>(CurrentAccountDocument, options);
      }
export function useCurrentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAccountQuery, CurrentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAccountQuery, CurrentAccountQueryVariables>(CurrentAccountDocument, options);
        }
export type CurrentAccountQueryHookResult = ReturnType<typeof useCurrentAccountQuery>;
export type CurrentAccountLazyQueryHookResult = ReturnType<typeof useCurrentAccountLazyQuery>;
export type CurrentAccountQueryResult = Apollo.QueryResult<CurrentAccountQuery, CurrentAccountQueryVariables>;
export const CurrentAccountBannerDocument = gql`
    query CurrentAccountBanner {
  currentUser {
    ...User
  }
  delegateAccesses {
    ...DelegateAccess
  }
}
    ${UserFragmentDoc}
${DelegateAccessFragmentDoc}`;

/**
 * __useCurrentAccountBannerQuery__
 *
 * To run a query within a React component, call `useCurrentAccountBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAccountBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAccountBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAccountBannerQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAccountBannerQuery, CurrentAccountBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAccountBannerQuery, CurrentAccountBannerQueryVariables>(CurrentAccountBannerDocument, options);
      }
export function useCurrentAccountBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAccountBannerQuery, CurrentAccountBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAccountBannerQuery, CurrentAccountBannerQueryVariables>(CurrentAccountBannerDocument, options);
        }
export type CurrentAccountBannerQueryHookResult = ReturnType<typeof useCurrentAccountBannerQuery>;
export type CurrentAccountBannerLazyQueryHookResult = ReturnType<typeof useCurrentAccountBannerLazyQuery>;
export type CurrentAccountBannerQueryResult = Apollo.QueryResult<CurrentAccountBannerQuery, CurrentAccountBannerQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    employee {
      ...EmployeePreview
    }
  }
}
    ${EmployeePreviewFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const DelegatedAccessesDocument = gql`
    query DelegatedAccesses {
  delegateAccesses {
    ...DelegateAccess
  }
}
    ${DelegateAccessFragmentDoc}`;

/**
 * __useDelegatedAccessesQuery__
 *
 * To run a query within a React component, call `useDelegatedAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDelegatedAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDelegatedAccessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDelegatedAccessesQuery(baseOptions?: Apollo.QueryHookOptions<DelegatedAccessesQuery, DelegatedAccessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DelegatedAccessesQuery, DelegatedAccessesQueryVariables>(DelegatedAccessesDocument, options);
      }
export function useDelegatedAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DelegatedAccessesQuery, DelegatedAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DelegatedAccessesQuery, DelegatedAccessesQueryVariables>(DelegatedAccessesDocument, options);
        }
export type DelegatedAccessesQueryHookResult = ReturnType<typeof useDelegatedAccessesQuery>;
export type DelegatedAccessesLazyQueryHookResult = ReturnType<typeof useDelegatedAccessesLazyQuery>;
export type DelegatedAccessesQueryResult = Apollo.QueryResult<DelegatedAccessesQuery, DelegatedAccessesQueryVariables>;
export const SetAccountColourDocument = gql`
    mutation SetAccountColour($uid: String!, $colour: AccountColour!) {
  setAccountColour(uid: $uid, colour: $colour) {
    failReasons
  }
}
    `;
export type SetAccountColourMutationFn = Apollo.MutationFunction<SetAccountColourMutation, SetAccountColourMutationVariables>;

/**
 * __useSetAccountColourMutation__
 *
 * To run a mutation, you first call `useSetAccountColourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountColourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccountColourMutation, { data, loading, error }] = useSetAccountColourMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      colour: // value for 'colour'
 *   },
 * });
 */
export function useSetAccountColourMutation(baseOptions?: Apollo.MutationHookOptions<SetAccountColourMutation, SetAccountColourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAccountColourMutation, SetAccountColourMutationVariables>(SetAccountColourDocument, options);
      }
export type SetAccountColourMutationHookResult = ReturnType<typeof useSetAccountColourMutation>;
export type SetAccountColourMutationResult = Apollo.MutationResult<SetAccountColourMutation>;
export type SetAccountColourMutationOptions = Apollo.BaseMutationOptions<SetAccountColourMutation, SetAccountColourMutationVariables>;
export const SetMyTimezoneDocument = gql`
    mutation SetMyTimezone($timezone: String!) {
  setMyTimezone(timezone: $timezone) {
    failReasons
  }
}
    `;
export type SetMyTimezoneMutationFn = Apollo.MutationFunction<SetMyTimezoneMutation, SetMyTimezoneMutationVariables>;

/**
 * __useSetMyTimezoneMutation__
 *
 * To run a mutation, you first call `useSetMyTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyTimezoneMutation, { data, loading, error }] = useSetMyTimezoneMutation({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useSetMyTimezoneMutation(baseOptions?: Apollo.MutationHookOptions<SetMyTimezoneMutation, SetMyTimezoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyTimezoneMutation, SetMyTimezoneMutationVariables>(SetMyTimezoneDocument, options);
      }
export type SetMyTimezoneMutationHookResult = ReturnType<typeof useSetMyTimezoneMutation>;
export type SetMyTimezoneMutationResult = Apollo.MutationResult<SetMyTimezoneMutation>;
export type SetMyTimezoneMutationOptions = Apollo.BaseMutationOptions<SetMyTimezoneMutation, SetMyTimezoneMutationVariables>;
export const SwitchAccountDocument = gql`
    mutation SwitchAccount($to: String!) {
  switchAccount(to: $to) {
    currentUser {
      email
      firstName
      lastName
    }
    failReasons
  }
}
    `;
export type SwitchAccountMutationFn = Apollo.MutationFunction<SwitchAccountMutation, SwitchAccountMutationVariables>;

/**
 * __useSwitchAccountMutation__
 *
 * To run a mutation, you first call `useSwitchAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchAccountMutation, { data, loading, error }] = useSwitchAccountMutation({
 *   variables: {
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSwitchAccountMutation(baseOptions?: Apollo.MutationHookOptions<SwitchAccountMutation, SwitchAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchAccountMutation, SwitchAccountMutationVariables>(SwitchAccountDocument, options);
      }
export type SwitchAccountMutationHookResult = ReturnType<typeof useSwitchAccountMutation>;
export type SwitchAccountMutationResult = Apollo.MutationResult<SwitchAccountMutation>;
export type SwitchAccountMutationOptions = Apollo.BaseMutationOptions<SwitchAccountMutation, SwitchAccountMutationVariables>;
export const CreateCampaignTabDocument = gql`
    mutation CreateCampaignTab($name: String!, $group: String!, $position: Int!, $ownedBy: OwnedByInput, $continuous: Boolean) {
  createCampaignTab(
    name: $name
    group: $group
    position: $position
    ownedBy: $ownedBy
    continuous: $continuous
  ) {
    id
    failReasons
  }
}
    `;
export type CreateCampaignTabMutationFn = Apollo.MutationFunction<CreateCampaignTabMutation, CreateCampaignTabMutationVariables>;

/**
 * __useCreateCampaignTabMutation__
 *
 * To run a mutation, you first call `useCreateCampaignTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignTabMutation, { data, loading, error }] = useCreateCampaignTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      ownedBy: // value for 'ownedBy'
 *      continuous: // value for 'continuous'
 *   },
 * });
 */
export function useCreateCampaignTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignTabMutation, CreateCampaignTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignTabMutation, CreateCampaignTabMutationVariables>(CreateCampaignTabDocument, options);
      }
export type CreateCampaignTabMutationHookResult = ReturnType<typeof useCreateCampaignTabMutation>;
export type CreateCampaignTabMutationResult = Apollo.MutationResult<CreateCampaignTabMutation>;
export type CreateCampaignTabMutationOptions = Apollo.BaseMutationOptions<CreateCampaignTabMutation, CreateCampaignTabMutationVariables>;
export const CreateCompanyListTabDocument = gql`
    mutation CreateCompanyListTab($name: String!, $usageMode: CompanyUsageModeInput!, $group: String!, $position: Int!, $ownedBy: OwnedByInput!, $renderMode: RenderMode!) {
  createStaticCompanyListTab(
    name: $name
    usageMode: $usageMode
    group: $group
    position: $position
    ownedBy: $ownedBy
    companyListAttributes: {renderMode: $renderMode}
  ) {
    id
    failReasons
    record {
      pageResult {
        ... on CompanyListItem {
          id
        }
      }
    }
  }
}
    `;
export type CreateCompanyListTabMutationFn = Apollo.MutationFunction<CreateCompanyListTabMutation, CreateCompanyListTabMutationVariables>;

/**
 * __useCreateCompanyListTabMutation__
 *
 * To run a mutation, you first call `useCreateCompanyListTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyListTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyListTabMutation, { data, loading, error }] = useCreateCompanyListTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      usageMode: // value for 'usageMode'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      ownedBy: // value for 'ownedBy'
 *      renderMode: // value for 'renderMode'
 *   },
 * });
 */
export function useCreateCompanyListTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyListTabMutation, CreateCompanyListTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyListTabMutation, CreateCompanyListTabMutationVariables>(CreateCompanyListTabDocument, options);
      }
export type CreateCompanyListTabMutationHookResult = ReturnType<typeof useCreateCompanyListTabMutation>;
export type CreateCompanyListTabMutationResult = Apollo.MutationResult<CreateCompanyListTabMutation>;
export type CreateCompanyListTabMutationOptions = Apollo.BaseMutationOptions<CreateCompanyListTabMutation, CreateCompanyListTabMutationVariables>;
export const CreateContactListTabDocument = gql`
    mutation CreateContactListTab($name: String!, $usageMode: UsageMode!, $group: String!, $position: Int!, $ownedBy: OwnedByInput!, $allowDuplicates: Boolean) {
  createStaticContactListTab(
    name: $name
    usageMode: $usageMode
    group: $group
    position: $position
    ownedBy: $ownedBy
    allowDuplicates: $allowDuplicates
  ) {
    id
    failReasons
    record {
      pageResult {
        ... on List {
          id
        }
      }
    }
  }
}
    `;
export type CreateContactListTabMutationFn = Apollo.MutationFunction<CreateContactListTabMutation, CreateContactListTabMutationVariables>;

/**
 * __useCreateContactListTabMutation__
 *
 * To run a mutation, you first call `useCreateContactListTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactListTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactListTabMutation, { data, loading, error }] = useCreateContactListTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      usageMode: // value for 'usageMode'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      ownedBy: // value for 'ownedBy'
 *      allowDuplicates: // value for 'allowDuplicates'
 *   },
 * });
 */
export function useCreateContactListTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactListTabMutation, CreateContactListTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactListTabMutation, CreateContactListTabMutationVariables>(CreateContactListTabDocument, options);
      }
export type CreateContactListTabMutationHookResult = ReturnType<typeof useCreateContactListTabMutation>;
export type CreateContactListTabMutationResult = Apollo.MutationResult<CreateContactListTabMutation>;
export type CreateContactListTabMutationOptions = Apollo.BaseMutationOptions<CreateContactListTabMutation, CreateContactListTabMutationVariables>;
export const CreateContactListTabWithRenderModesDocument = gql`
    mutation CreateContactListTabWithRenderModes($name: String!, $usageMode: UsageMode!, $group: String!, $position: Int!, $projectUid: ID, $ownedBy: OwnedByInput, $allowDuplicates: Boolean, $contactListAttributes: ContactListAttributes) {
  createStaticContactListTab(
    name: $name
    usageMode: $usageMode
    group: $group
    position: $position
    allowDuplicates: $allowDuplicates
    ownedBy: $ownedBy
    projectUid: $projectUid
    contactListAttributes: $contactListAttributes
  ) {
    id
    failReasons
    record {
      pageResult {
        ... on List {
          id
        }
      }
    }
  }
}
    `;
export type CreateContactListTabWithRenderModesMutationFn = Apollo.MutationFunction<CreateContactListTabWithRenderModesMutation, CreateContactListTabWithRenderModesMutationVariables>;

/**
 * __useCreateContactListTabWithRenderModesMutation__
 *
 * To run a mutation, you first call `useCreateContactListTabWithRenderModesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactListTabWithRenderModesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactListTabWithRenderModesMutation, { data, loading, error }] = useCreateContactListTabWithRenderModesMutation({
 *   variables: {
 *      name: // value for 'name'
 *      usageMode: // value for 'usageMode'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      projectUid: // value for 'projectUid'
 *      ownedBy: // value for 'ownedBy'
 *      allowDuplicates: // value for 'allowDuplicates'
 *      contactListAttributes: // value for 'contactListAttributes'
 *   },
 * });
 */
export function useCreateContactListTabWithRenderModesMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactListTabWithRenderModesMutation, CreateContactListTabWithRenderModesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactListTabWithRenderModesMutation, CreateContactListTabWithRenderModesMutationVariables>(CreateContactListTabWithRenderModesDocument, options);
      }
export type CreateContactListTabWithRenderModesMutationHookResult = ReturnType<typeof useCreateContactListTabWithRenderModesMutation>;
export type CreateContactListTabWithRenderModesMutationResult = Apollo.MutationResult<CreateContactListTabWithRenderModesMutation>;
export type CreateContactListTabWithRenderModesMutationOptions = Apollo.BaseMutationOptions<CreateContactListTabWithRenderModesMutation, CreateContactListTabWithRenderModesMutationVariables>;
export const CreateEmbedUrlTabDocument = gql`
    mutation CreateEmbedUrlTab($name: String!, $group: String!, $position: Int!, $url: String!) {
  createEmbedUrlTab(name: $name, group: $group, position: $position, url: $url) {
    id
    failReasons
  }
}
    `;
export type CreateEmbedUrlTabMutationFn = Apollo.MutationFunction<CreateEmbedUrlTabMutation, CreateEmbedUrlTabMutationVariables>;

/**
 * __useCreateEmbedUrlTabMutation__
 *
 * To run a mutation, you first call `useCreateEmbedUrlTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmbedUrlTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmbedUrlTabMutation, { data, loading, error }] = useCreateEmbedUrlTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCreateEmbedUrlTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmbedUrlTabMutation, CreateEmbedUrlTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmbedUrlTabMutation, CreateEmbedUrlTabMutationVariables>(CreateEmbedUrlTabDocument, options);
      }
export type CreateEmbedUrlTabMutationHookResult = ReturnType<typeof useCreateEmbedUrlTabMutation>;
export type CreateEmbedUrlTabMutationResult = Apollo.MutationResult<CreateEmbedUrlTabMutation>;
export type CreateEmbedUrlTabMutationOptions = Apollo.BaseMutationOptions<CreateEmbedUrlTabMutation, CreateEmbedUrlTabMutationVariables>;
export const CreateGenericListTabDocument = gql`
    mutation CreateGenericListTab($name: String!, $group: String!, $position: Int!, $ownedBy: OwnedByInput!, $renderMode: RenderMode!) {
  createStaticGenericListTab(
    name: $name
    group: $group
    position: $position
    ownedBy: $ownedBy
    genericListAttributes: {renderMode: $renderMode}
  ) {
    id
    failReasons
    record {
      pageResult {
        ... on GenericList {
          id
        }
      }
    }
  }
}
    `;
export type CreateGenericListTabMutationFn = Apollo.MutationFunction<CreateGenericListTabMutation, CreateGenericListTabMutationVariables>;

/**
 * __useCreateGenericListTabMutation__
 *
 * To run a mutation, you first call `useCreateGenericListTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericListTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericListTabMutation, { data, loading, error }] = useCreateGenericListTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      ownedBy: // value for 'ownedBy'
 *      renderMode: // value for 'renderMode'
 *   },
 * });
 */
export function useCreateGenericListTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericListTabMutation, CreateGenericListTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericListTabMutation, CreateGenericListTabMutationVariables>(CreateGenericListTabDocument, options);
      }
export type CreateGenericListTabMutationHookResult = ReturnType<typeof useCreateGenericListTabMutation>;
export type CreateGenericListTabMutationResult = Apollo.MutationResult<CreateGenericListTabMutation>;
export type CreateGenericListTabMutationOptions = Apollo.BaseMutationOptions<CreateGenericListTabMutation, CreateGenericListTabMutationVariables>;
export const CreateKeyActivityListTabDocument = gql`
    mutation CreateKeyActivityListTab($name: String!, $group: String!, $position: Int!, $projectUid: ID, $ownedBy: OwnedByInput, $renderMode: RenderMode!) {
  createKeyActivityListTab(
    name: $name
    group: $group
    position: $position
    ownedBy: $ownedBy
    projectUid: $projectUid
    keyActivityListAttributes: {renderMode: $renderMode}
  ) {
    failReasons
    record {
      ...TabResultItem
    }
  }
}
    ${TabResultItemFragmentDoc}`;
export type CreateKeyActivityListTabMutationFn = Apollo.MutationFunction<CreateKeyActivityListTabMutation, CreateKeyActivityListTabMutationVariables>;

/**
 * __useCreateKeyActivityListTabMutation__
 *
 * To run a mutation, you first call `useCreateKeyActivityListTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeyActivityListTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeyActivityListTabMutation, { data, loading, error }] = useCreateKeyActivityListTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      projectUid: // value for 'projectUid'
 *      ownedBy: // value for 'ownedBy'
 *      renderMode: // value for 'renderMode'
 *   },
 * });
 */
export function useCreateKeyActivityListTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateKeyActivityListTabMutation, CreateKeyActivityListTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeyActivityListTabMutation, CreateKeyActivityListTabMutationVariables>(CreateKeyActivityListTabDocument, options);
      }
export type CreateKeyActivityListTabMutationHookResult = ReturnType<typeof useCreateKeyActivityListTabMutation>;
export type CreateKeyActivityListTabMutationResult = Apollo.MutationResult<CreateKeyActivityListTabMutation>;
export type CreateKeyActivityListTabMutationOptions = Apollo.BaseMutationOptions<CreateKeyActivityListTabMutation, CreateKeyActivityListTabMutationVariables>;
export const CreateMarketingListTabWithRenderModesDocument = gql`
    mutation CreateMarketingListTabWithRenderModes($name: String!, $usageMode: UsageMode!, $group: String!, $position: Int!, $marketingListAttributes: MarketingListAttributes, $ownedBy: OwnedByInput) {
  createStaticMarketingListTab(
    name: $name
    position: $position
    usageMode: $usageMode
    group: $group
    ownedBy: $ownedBy
    marketingListAttributes: $marketingListAttributes
  ) {
    id
    failReasons
    record {
      pageResult {
        ... on List {
          id
        }
      }
    }
  }
}
    `;
export type CreateMarketingListTabWithRenderModesMutationFn = Apollo.MutationFunction<CreateMarketingListTabWithRenderModesMutation, CreateMarketingListTabWithRenderModesMutationVariables>;

/**
 * __useCreateMarketingListTabWithRenderModesMutation__
 *
 * To run a mutation, you first call `useCreateMarketingListTabWithRenderModesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketingListTabWithRenderModesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketingListTabWithRenderModesMutation, { data, loading, error }] = useCreateMarketingListTabWithRenderModesMutation({
 *   variables: {
 *      name: // value for 'name'
 *      usageMode: // value for 'usageMode'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      marketingListAttributes: // value for 'marketingListAttributes'
 *      ownedBy: // value for 'ownedBy'
 *   },
 * });
 */
export function useCreateMarketingListTabWithRenderModesMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketingListTabWithRenderModesMutation, CreateMarketingListTabWithRenderModesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketingListTabWithRenderModesMutation, CreateMarketingListTabWithRenderModesMutationVariables>(CreateMarketingListTabWithRenderModesDocument, options);
      }
export type CreateMarketingListTabWithRenderModesMutationHookResult = ReturnType<typeof useCreateMarketingListTabWithRenderModesMutation>;
export type CreateMarketingListTabWithRenderModesMutationResult = Apollo.MutationResult<CreateMarketingListTabWithRenderModesMutation>;
export type CreateMarketingListTabWithRenderModesMutationOptions = Apollo.BaseMutationOptions<CreateMarketingListTabWithRenderModesMutation, CreateMarketingListTabWithRenderModesMutationVariables>;
export const CreatePageViewTabDocument = gql`
    mutation CreatePageViewTab($name: String!, $position: Int!, $group: String!, $filter: JSON!, $tabRenderMode: TabRenderMode) {
  createPageViewTab(
    name: $name
    filter: $filter
    position: $position
    group: $group
    renderMode: $tabRenderMode
  ) {
    failReasons
    id
  }
}
    `;
export type CreatePageViewTabMutationFn = Apollo.MutationFunction<CreatePageViewTabMutation, CreatePageViewTabMutationVariables>;

/**
 * __useCreatePageViewTabMutation__
 *
 * To run a mutation, you first call `useCreatePageViewTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageViewTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageViewTabMutation, { data, loading, error }] = useCreatePageViewTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      position: // value for 'position'
 *      group: // value for 'group'
 *      filter: // value for 'filter'
 *      tabRenderMode: // value for 'tabRenderMode'
 *   },
 * });
 */
export function useCreatePageViewTabMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageViewTabMutation, CreatePageViewTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageViewTabMutation, CreatePageViewTabMutationVariables>(CreatePageViewTabDocument, options);
      }
export type CreatePageViewTabMutationHookResult = ReturnType<typeof useCreatePageViewTabMutation>;
export type CreatePageViewTabMutationResult = Apollo.MutationResult<CreatePageViewTabMutation>;
export type CreatePageViewTabMutationOptions = Apollo.BaseMutationOptions<CreatePageViewTabMutation, CreatePageViewTabMutationVariables>;
export const CreateStaticCompanyListTabDocument = gql`
    mutation CreateStaticCompanyListTab($name: String!, $usageMode: CompanyUsageModeInput!, $group: String!, $position: Int!, $projectUid: ID, $renderMode: RenderMode!) {
  createStaticCompanyListTab(
    name: $name
    usageMode: $usageMode
    group: $group
    position: $position
    projectUid: $projectUid
    companyListAttributes: {renderMode: $renderMode}
  ) {
    id
    failReasons
    record {
      pageResult {
        ... on CompanyListItem {
          id
        }
      }
    }
  }
}
    `;
export type CreateStaticCompanyListTabMutationFn = Apollo.MutationFunction<CreateStaticCompanyListTabMutation, CreateStaticCompanyListTabMutationVariables>;

/**
 * __useCreateStaticCompanyListTabMutation__
 *
 * To run a mutation, you first call `useCreateStaticCompanyListTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaticCompanyListTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaticCompanyListTabMutation, { data, loading, error }] = useCreateStaticCompanyListTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      usageMode: // value for 'usageMode'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      projectUid: // value for 'projectUid'
 *      renderMode: // value for 'renderMode'
 *   },
 * });
 */
export function useCreateStaticCompanyListTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateStaticCompanyListTabMutation, CreateStaticCompanyListTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStaticCompanyListTabMutation, CreateStaticCompanyListTabMutationVariables>(CreateStaticCompanyListTabDocument, options);
      }
export type CreateStaticCompanyListTabMutationHookResult = ReturnType<typeof useCreateStaticCompanyListTabMutation>;
export type CreateStaticCompanyListTabMutationResult = Apollo.MutationResult<CreateStaticCompanyListTabMutation>;
export type CreateStaticCompanyListTabMutationOptions = Apollo.BaseMutationOptions<CreateStaticCompanyListTabMutation, CreateStaticCompanyListTabMutationVariables>;
export const CreateStaticContactListTabDocument = gql`
    mutation CreateStaticContactListTab($name: String!, $usageMode: UsageMode!, $group: String!, $position: Int!, $projectUid: ID, $allowDuplicates: Boolean) {
  createStaticContactListTab(
    name: $name
    usageMode: $usageMode
    group: $group
    position: $position
    projectUid: $projectUid
    allowDuplicates: $allowDuplicates
  ) {
    id
    failReasons
    record {
      pageResult {
        ... on List {
          id
        }
      }
    }
  }
}
    `;
export type CreateStaticContactListTabMutationFn = Apollo.MutationFunction<CreateStaticContactListTabMutation, CreateStaticContactListTabMutationVariables>;

/**
 * __useCreateStaticContactListTabMutation__
 *
 * To run a mutation, you first call `useCreateStaticContactListTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaticContactListTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaticContactListTabMutation, { data, loading, error }] = useCreateStaticContactListTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      usageMode: // value for 'usageMode'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      projectUid: // value for 'projectUid'
 *      allowDuplicates: // value for 'allowDuplicates'
 *   },
 * });
 */
export function useCreateStaticContactListTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateStaticContactListTabMutation, CreateStaticContactListTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStaticContactListTabMutation, CreateStaticContactListTabMutationVariables>(CreateStaticContactListTabDocument, options);
      }
export type CreateStaticContactListTabMutationHookResult = ReturnType<typeof useCreateStaticContactListTabMutation>;
export type CreateStaticContactListTabMutationResult = Apollo.MutationResult<CreateStaticContactListTabMutation>;
export type CreateStaticContactListTabMutationOptions = Apollo.BaseMutationOptions<CreateStaticContactListTabMutation, CreateStaticContactListTabMutationVariables>;
export const CreateStaticGenericListTabDocument = gql`
    mutation CreateStaticGenericListTab($name: String!, $group: String!, $position: Int!, $renderMode: RenderMode!) {
  createStaticGenericListTab(
    name: $name
    group: $group
    position: $position
    genericListAttributes: {renderMode: $renderMode}
  ) {
    id
    failReasons
    record {
      pageResult {
        ... on GenericList {
          id
        }
      }
    }
  }
}
    `;
export type CreateStaticGenericListTabMutationFn = Apollo.MutationFunction<CreateStaticGenericListTabMutation, CreateStaticGenericListTabMutationVariables>;

/**
 * __useCreateStaticGenericListTabMutation__
 *
 * To run a mutation, you first call `useCreateStaticGenericListTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaticGenericListTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaticGenericListTabMutation, { data, loading, error }] = useCreateStaticGenericListTabMutation({
 *   variables: {
 *      name: // value for 'name'
 *      group: // value for 'group'
 *      position: // value for 'position'
 *      renderMode: // value for 'renderMode'
 *   },
 * });
 */
export function useCreateStaticGenericListTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateStaticGenericListTabMutation, CreateStaticGenericListTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStaticGenericListTabMutation, CreateStaticGenericListTabMutationVariables>(CreateStaticGenericListTabDocument, options);
      }
export type CreateStaticGenericListTabMutationHookResult = ReturnType<typeof useCreateStaticGenericListTabMutation>;
export type CreateStaticGenericListTabMutationResult = Apollo.MutationResult<CreateStaticGenericListTabMutation>;
export type CreateStaticGenericListTabMutationOptions = Apollo.BaseMutationOptions<CreateStaticGenericListTabMutation, CreateStaticGenericListTabMutationVariables>;
export const RemovePageTabDocument = gql`
    mutation RemovePageTab($uid: String!) {
  removePageTab(uid: $uid) {
    failReasons
  }
}
    `;
export type RemovePageTabMutationFn = Apollo.MutationFunction<RemovePageTabMutation, RemovePageTabMutationVariables>;

/**
 * __useRemovePageTabMutation__
 *
 * To run a mutation, you first call `useRemovePageTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePageTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePageTabMutation, { data, loading, error }] = useRemovePageTabMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useRemovePageTabMutation(baseOptions?: Apollo.MutationHookOptions<RemovePageTabMutation, RemovePageTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePageTabMutation, RemovePageTabMutationVariables>(RemovePageTabDocument, options);
      }
export type RemovePageTabMutationHookResult = ReturnType<typeof useRemovePageTabMutation>;
export type RemovePageTabMutationResult = Apollo.MutationResult<RemovePageTabMutation>;
export type RemovePageTabMutationOptions = Apollo.BaseMutationOptions<RemovePageTabMutation, RemovePageTabMutationVariables>;
export const ShowAllEmployeesTabConfigurationDocument = gql`
    query ShowAllEmployeesTabConfiguration {
  tenantConfiguration {
    id
    showAllEmployeesTab
  }
}
    `;

/**
 * __useShowAllEmployeesTabConfigurationQuery__
 *
 * To run a query within a React component, call `useShowAllEmployeesTabConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowAllEmployeesTabConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowAllEmployeesTabConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowAllEmployeesTabConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<ShowAllEmployeesTabConfigurationQuery, ShowAllEmployeesTabConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowAllEmployeesTabConfigurationQuery, ShowAllEmployeesTabConfigurationQueryVariables>(ShowAllEmployeesTabConfigurationDocument, options);
      }
export function useShowAllEmployeesTabConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowAllEmployeesTabConfigurationQuery, ShowAllEmployeesTabConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowAllEmployeesTabConfigurationQuery, ShowAllEmployeesTabConfigurationQueryVariables>(ShowAllEmployeesTabConfigurationDocument, options);
        }
export type ShowAllEmployeesTabConfigurationQueryHookResult = ReturnType<typeof useShowAllEmployeesTabConfigurationQuery>;
export type ShowAllEmployeesTabConfigurationLazyQueryHookResult = ReturnType<typeof useShowAllEmployeesTabConfigurationLazyQuery>;
export type ShowAllEmployeesTabConfigurationQueryResult = Apollo.QueryResult<ShowAllEmployeesTabConfigurationQuery, ShowAllEmployeesTabConfigurationQueryVariables>;
export const TabDocument = gql`
    query Tab($uid: ID!) {
  tab(uid: $uid) {
    ...TabResultItem
  }
}
    ${TabResultItemFragmentDoc}`;

/**
 * __useTabQuery__
 *
 * To run a query within a React component, call `useTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTabQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useTabQuery(baseOptions: Apollo.QueryHookOptions<TabQuery, TabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TabQuery, TabQueryVariables>(TabDocument, options);
      }
export function useTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TabQuery, TabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TabQuery, TabQueryVariables>(TabDocument, options);
        }
export type TabQueryHookResult = ReturnType<typeof useTabQuery>;
export type TabLazyQueryHookResult = ReturnType<typeof useTabLazyQuery>;
export type TabQueryResult = Apollo.QueryResult<TabQuery, TabQueryVariables>;
export const TabsDocument = gql`
    query Tabs($group: String, $renderMode: TabRenderMode) {
  tabs(group: $group, page: 1, perPage: 1000, renderMode: $renderMode) {
    entries {
      ...TabResultItem
    }
  }
}
    ${TabResultItemFragmentDoc}`;

/**
 * __useTabsQuery__
 *
 * To run a query within a React component, call `useTabsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTabsQuery({
 *   variables: {
 *      group: // value for 'group'
 *      renderMode: // value for 'renderMode'
 *   },
 * });
 */
export function useTabsQuery(baseOptions?: Apollo.QueryHookOptions<TabsQuery, TabsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TabsQuery, TabsQueryVariables>(TabsDocument, options);
      }
export function useTabsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TabsQuery, TabsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TabsQuery, TabsQueryVariables>(TabsDocument, options);
        }
export type TabsQueryHookResult = ReturnType<typeof useTabsQuery>;
export type TabsLazyQueryHookResult = ReturnType<typeof useTabsLazyQuery>;
export type TabsQueryResult = Apollo.QueryResult<TabsQuery, TabsQueryVariables>;
export const UpdatePageTabsDocument = gql`
    mutation UpdatePageTabs($pageTabs: [TabInput!]!) {
  updatePageTabs(pageTabs: $pageTabs) {
    failReasons
    tabs {
      ... on TabResult {
        id
        name
        position
        renderMode
      }
    }
  }
}
    `;
export type UpdatePageTabsMutationFn = Apollo.MutationFunction<UpdatePageTabsMutation, UpdatePageTabsMutationVariables>;

/**
 * __useUpdatePageTabsMutation__
 *
 * To run a mutation, you first call `useUpdatePageTabsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageTabsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageTabsMutation, { data, loading, error }] = useUpdatePageTabsMutation({
 *   variables: {
 *      pageTabs: // value for 'pageTabs'
 *   },
 * });
 */
export function useUpdatePageTabsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageTabsMutation, UpdatePageTabsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageTabsMutation, UpdatePageTabsMutationVariables>(UpdatePageTabsDocument, options);
      }
export type UpdatePageTabsMutationHookResult = ReturnType<typeof useUpdatePageTabsMutation>;
export type UpdatePageTabsMutationResult = Apollo.MutationResult<UpdatePageTabsMutation>;
export type UpdatePageTabsMutationOptions = Apollo.BaseMutationOptions<UpdatePageTabsMutation, UpdatePageTabsMutationVariables>;
export const UpdatePageViewTabDocument = gql`
    mutation UpdatePageViewTab($uid: ID!, $filter: JSON!) {
  updatePageViewTab(uid: $uid, filter: $filter) {
    failReasons
  }
}
    `;
export type UpdatePageViewTabMutationFn = Apollo.MutationFunction<UpdatePageViewTabMutation, UpdatePageViewTabMutationVariables>;

/**
 * __useUpdatePageViewTabMutation__
 *
 * To run a mutation, you first call `useUpdatePageViewTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageViewTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageViewTabMutation, { data, loading, error }] = useUpdatePageViewTabMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatePageViewTabMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageViewTabMutation, UpdatePageViewTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageViewTabMutation, UpdatePageViewTabMutationVariables>(UpdatePageViewTabDocument, options);
      }
export type UpdatePageViewTabMutationHookResult = ReturnType<typeof useUpdatePageViewTabMutation>;
export type UpdatePageViewTabMutationResult = Apollo.MutationResult<UpdatePageViewTabMutation>;
export type UpdatePageViewTabMutationOptions = Apollo.BaseMutationOptions<UpdatePageViewTabMutation, UpdatePageViewTabMutationVariables>;
export const AddTagsToAllContactsWithTrackerDocument = gql`
    mutation AddTagsToAllContactsWithTracker($progressTracker: ProgressTrackerAttributes!, $filter: ContactsFiltering, $filters: [ContactFilter!], $tags: [String!]) {
  addTagsToAllContactsWithTracker(
    progressTracker: $progressTracker
    filter: $filter
    filters: $filters
    tags: $tags
  ) {
    failReasons
  }
}
    `;
export type AddTagsToAllContactsWithTrackerMutationFn = Apollo.MutationFunction<AddTagsToAllContactsWithTrackerMutation, AddTagsToAllContactsWithTrackerMutationVariables>;

/**
 * __useAddTagsToAllContactsWithTrackerMutation__
 *
 * To run a mutation, you first call `useAddTagsToAllContactsWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagsToAllContactsWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagsToAllContactsWithTrackerMutation, { data, loading, error }] = useAddTagsToAllContactsWithTrackerMutation({
 *   variables: {
 *      progressTracker: // value for 'progressTracker'
 *      filter: // value for 'filter'
 *      filters: // value for 'filters'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useAddTagsToAllContactsWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<AddTagsToAllContactsWithTrackerMutation, AddTagsToAllContactsWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagsToAllContactsWithTrackerMutation, AddTagsToAllContactsWithTrackerMutationVariables>(AddTagsToAllContactsWithTrackerDocument, options);
      }
export type AddTagsToAllContactsWithTrackerMutationHookResult = ReturnType<typeof useAddTagsToAllContactsWithTrackerMutation>;
export type AddTagsToAllContactsWithTrackerMutationResult = Apollo.MutationResult<AddTagsToAllContactsWithTrackerMutation>;
export type AddTagsToAllContactsWithTrackerMutationOptions = Apollo.BaseMutationOptions<AddTagsToAllContactsWithTrackerMutation, AddTagsToAllContactsWithTrackerMutationVariables>;
export const AddTagsToContactsDocument = gql`
    mutation AddTagsToContacts($contactEmails: [String!]!, $tags: [String!]!) {
  addTagsToContacts(contactEmails: $contactEmails, tags: $tags) {
    failReasons
    contactCards {
      ...ContactCard
    }
  }
}
    ${ContactCardFragmentDoc}`;
export type AddTagsToContactsMutationFn = Apollo.MutationFunction<AddTagsToContactsMutation, AddTagsToContactsMutationVariables>;

/**
 * __useAddTagsToContactsMutation__
 *
 * To run a mutation, you first call `useAddTagsToContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagsToContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagsToContactsMutation, { data, loading, error }] = useAddTagsToContactsMutation({
 *   variables: {
 *      contactEmails: // value for 'contactEmails'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useAddTagsToContactsMutation(baseOptions?: Apollo.MutationHookOptions<AddTagsToContactsMutation, AddTagsToContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagsToContactsMutation, AddTagsToContactsMutationVariables>(AddTagsToContactsDocument, options);
      }
export type AddTagsToContactsMutationHookResult = ReturnType<typeof useAddTagsToContactsMutation>;
export type AddTagsToContactsMutationResult = Apollo.MutationResult<AddTagsToContactsMutation>;
export type AddTagsToContactsMutationOptions = Apollo.BaseMutationOptions<AddTagsToContactsMutation, AddTagsToContactsMutationVariables>;
export const BullkAddTagsToContactsWithTrackerDocument = gql`
    mutation BullkAddTagsToContactsWithTracker($progressTracker: ProgressTrackerAttributes!, $contactUids: [ID!]!, $tags: [String!]) {
  bulkAddTagsToContactsWithTracker(
    progressTracker: $progressTracker
    contactUids: $contactUids
    tags: $tags
  ) {
    failReasons
  }
}
    `;
export type BullkAddTagsToContactsWithTrackerMutationFn = Apollo.MutationFunction<BullkAddTagsToContactsWithTrackerMutation, BullkAddTagsToContactsWithTrackerMutationVariables>;

/**
 * __useBullkAddTagsToContactsWithTrackerMutation__
 *
 * To run a mutation, you first call `useBullkAddTagsToContactsWithTrackerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBullkAddTagsToContactsWithTrackerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bullkAddTagsToContactsWithTrackerMutation, { data, loading, error }] = useBullkAddTagsToContactsWithTrackerMutation({
 *   variables: {
 *      progressTracker: // value for 'progressTracker'
 *      contactUids: // value for 'contactUids'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useBullkAddTagsToContactsWithTrackerMutation(baseOptions?: Apollo.MutationHookOptions<BullkAddTagsToContactsWithTrackerMutation, BullkAddTagsToContactsWithTrackerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BullkAddTagsToContactsWithTrackerMutation, BullkAddTagsToContactsWithTrackerMutationVariables>(BullkAddTagsToContactsWithTrackerDocument, options);
      }
export type BullkAddTagsToContactsWithTrackerMutationHookResult = ReturnType<typeof useBullkAddTagsToContactsWithTrackerMutation>;
export type BullkAddTagsToContactsWithTrackerMutationResult = Apollo.MutationResult<BullkAddTagsToContactsWithTrackerMutation>;
export type BullkAddTagsToContactsWithTrackerMutationOptions = Apollo.BaseMutationOptions<BullkAddTagsToContactsWithTrackerMutation, BullkAddTagsToContactsWithTrackerMutationVariables>;
export const BulkRemoveTagDocument = gql`
    mutation BulkRemoveTag($tagUids: [ID!]!) {
  bulkRemoveTag(tagUids: $tagUids) {
    failReasons
  }
}
    `;
export type BulkRemoveTagMutationFn = Apollo.MutationFunction<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>;

/**
 * __useBulkRemoveTagMutation__
 *
 * To run a mutation, you first call `useBulkRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveTagMutation, { data, loading, error }] = useBulkRemoveTagMutation({
 *   variables: {
 *      tagUids: // value for 'tagUids'
 *   },
 * });
 */
export function useBulkRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>(BulkRemoveTagDocument, options);
      }
export type BulkRemoveTagMutationHookResult = ReturnType<typeof useBulkRemoveTagMutation>;
export type BulkRemoveTagMutationResult = Apollo.MutationResult<BulkRemoveTagMutation>;
export type BulkRemoveTagMutationOptions = Apollo.BaseMutationOptions<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($name: String!) {
  createTag(name: $name) {
    failReasons
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const RemoveTagDocument = gql`
    mutation RemoveTag($tagUid: ID!) {
  removeTag(tagUid: $tagUid) {
    failReasons
  }
}
    `;
export type RemoveTagMutationFn = Apollo.MutationFunction<RemoveTagMutation, RemoveTagMutationVariables>;

/**
 * __useRemoveTagMutation__
 *
 * To run a mutation, you first call `useRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagMutation, { data, loading, error }] = useRemoveTagMutation({
 *   variables: {
 *      tagUid: // value for 'tagUid'
 *   },
 * });
 */
export function useRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagMutation, RemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagMutation, RemoveTagMutationVariables>(RemoveTagDocument, options);
      }
export type RemoveTagMutationHookResult = ReturnType<typeof useRemoveTagMutation>;
export type RemoveTagMutationResult = Apollo.MutationResult<RemoveTagMutation>;
export type RemoveTagMutationOptions = Apollo.BaseMutationOptions<RemoveTagMutation, RemoveTagMutationVariables>;
export const RenameTagDocument = gql`
    mutation RenameTag($tagUid: ID!, $name: String!) {
  renameTag(tagUid: $tagUid, name: $name) {
    failReasons
  }
}
    `;
export type RenameTagMutationFn = Apollo.MutationFunction<RenameTagMutation, RenameTagMutationVariables>;

/**
 * __useRenameTagMutation__
 *
 * To run a mutation, you first call `useRenameTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameTagMutation, { data, loading, error }] = useRenameTagMutation({
 *   variables: {
 *      tagUid: // value for 'tagUid'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameTagMutation(baseOptions?: Apollo.MutationHookOptions<RenameTagMutation, RenameTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameTagMutation, RenameTagMutationVariables>(RenameTagDocument, options);
      }
export type RenameTagMutationHookResult = ReturnType<typeof useRenameTagMutation>;
export type RenameTagMutationResult = Apollo.MutationResult<RenameTagMutation>;
export type RenameTagMutationOptions = Apollo.BaseMutationOptions<RenameTagMutation, RenameTagMutationVariables>;
export const RestrictTagCreationConfigurationDocument = gql`
    query RestrictTagCreationConfiguration {
  tenantConfiguration {
    id
    restrictTagCreation
  }
}
    `;

/**
 * __useRestrictTagCreationConfigurationQuery__
 *
 * To run a query within a React component, call `useRestrictTagCreationConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictTagCreationConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictTagCreationConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useRestrictTagCreationConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<RestrictTagCreationConfigurationQuery, RestrictTagCreationConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RestrictTagCreationConfigurationQuery, RestrictTagCreationConfigurationQueryVariables>(RestrictTagCreationConfigurationDocument, options);
      }
export function useRestrictTagCreationConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RestrictTagCreationConfigurationQuery, RestrictTagCreationConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RestrictTagCreationConfigurationQuery, RestrictTagCreationConfigurationQueryVariables>(RestrictTagCreationConfigurationDocument, options);
        }
export type RestrictTagCreationConfigurationQueryHookResult = ReturnType<typeof useRestrictTagCreationConfigurationQuery>;
export type RestrictTagCreationConfigurationLazyQueryHookResult = ReturnType<typeof useRestrictTagCreationConfigurationLazyQuery>;
export type RestrictTagCreationConfigurationQueryResult = Apollo.QueryResult<RestrictTagCreationConfigurationQuery, RestrictTagCreationConfigurationQueryVariables>;
export const TagsDocument = gql`
    query Tags($page: Int, $perPage: Int, $term: String, $orderBy: TagOrderBy) {
  tags(page: $page, perPage: $perPage, term: $term, orderBy: $orderBy) {
    entries {
      id
      name
      usedCount
      createdAt
    }
    pageInfo {
      totalEntries
    }
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const TagsAutocompleteDocument = gql`
    query TagsAutocomplete($term: String) {
  tags(page: 1, perPage: 50, term: $term, orderBy: COUNT_DESC) {
    entries {
      ...TagOption
    }
  }
}
    ${TagOptionFragmentDoc}`;

/**
 * __useTagsAutocompleteQuery__
 *
 * To run a query within a React component, call `useTagsAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsAutocompleteQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useTagsAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<TagsAutocompleteQuery, TagsAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsAutocompleteQuery, TagsAutocompleteQueryVariables>(TagsAutocompleteDocument, options);
      }
export function useTagsAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsAutocompleteQuery, TagsAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsAutocompleteQuery, TagsAutocompleteQueryVariables>(TagsAutocompleteDocument, options);
        }
export type TagsAutocompleteQueryHookResult = ReturnType<typeof useTagsAutocompleteQuery>;
export type TagsAutocompleteLazyQueryHookResult = ReturnType<typeof useTagsAutocompleteLazyQuery>;
export type TagsAutocompleteQueryResult = Apollo.QueryResult<TagsAutocompleteQuery, TagsAutocompleteQueryVariables>;
export const CompleteTaskDocument = gql`
    mutation CompleteTask($taskUid: ID!) {
  completeTask(taskUid: $taskUid) {
    failReasons
  }
}
    `;
export type CompleteTaskMutationFn = Apollo.MutationFunction<CompleteTaskMutation, CompleteTaskMutationVariables>;

/**
 * __useCompleteTaskMutation__
 *
 * To run a mutation, you first call `useCompleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTaskMutation, { data, loading, error }] = useCompleteTaskMutation({
 *   variables: {
 *      taskUid: // value for 'taskUid'
 *   },
 * });
 */
export function useCompleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<CompleteTaskMutation, CompleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteTaskMutation, CompleteTaskMutationVariables>(CompleteTaskDocument, options);
      }
export type CompleteTaskMutationHookResult = ReturnType<typeof useCompleteTaskMutation>;
export type CompleteTaskMutationResult = Apollo.MutationResult<CompleteTaskMutation>;
export type CompleteTaskMutationOptions = Apollo.BaseMutationOptions<CompleteTaskMutation, CompleteTaskMutationVariables>;
export const ContactListNameChipDocument = gql`
    query ContactListNameChip($uid: ID!) {
  list(uid: $uid) {
    id
    name
  }
}
    `;

/**
 * __useContactListNameChipQuery__
 *
 * To run a query within a React component, call `useContactListNameChipQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListNameChipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListNameChipQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useContactListNameChipQuery(baseOptions: Apollo.QueryHookOptions<ContactListNameChipQuery, ContactListNameChipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListNameChipQuery, ContactListNameChipQueryVariables>(ContactListNameChipDocument, options);
      }
export function useContactListNameChipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListNameChipQuery, ContactListNameChipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListNameChipQuery, ContactListNameChipQueryVariables>(ContactListNameChipDocument, options);
        }
export type ContactListNameChipQueryHookResult = ReturnType<typeof useContactListNameChipQuery>;
export type ContactListNameChipLazyQueryHookResult = ReturnType<typeof useContactListNameChipLazyQuery>;
export type ContactListNameChipQueryResult = Apollo.QueryResult<ContactListNameChipQuery, ContactListNameChipQueryVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($companyUid: ID, $assignedToUid: ID, $requestedByUid: ID, $contactUid: ID, $projectUid: ID, $attributes: CreateTaskAttributes!, $contactListMemberUid: ID, $companyListMemberUid: ID, $genericListMemberUid: ID) {
  createTask(
    companyUid: $companyUid
    assignedToUid: $assignedToUid
    requestedByUid: $requestedByUid
    contactUid: $contactUid
    projectUid: $projectUid
    contactListMemberUid: $contactListMemberUid
    companyListMemberUid: $companyListMemberUid
    genericListMemberUid: $genericListMemberUid
    attributes: $attributes
  ) {
    failReasons
    record {
      id
    }
  }
}
    `;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      companyUid: // value for 'companyUid'
 *      assignedToUid: // value for 'assignedToUid'
 *      requestedByUid: // value for 'requestedByUid'
 *      contactUid: // value for 'contactUid'
 *      projectUid: // value for 'projectUid'
 *      attributes: // value for 'attributes'
 *      contactListMemberUid: // value for 'contactListMemberUid'
 *      companyListMemberUid: // value for 'companyListMemberUid'
 *      genericListMemberUid: // value for 'genericListMemberUid'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const CreateTaskCreatorDisplayNameDocument = gql`
    query CreateTaskCreatorDisplayName {
  currentUser {
    id
    employee {
      id
      email
      info {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useCreateTaskCreatorDisplayNameQuery__
 *
 * To run a query within a React component, call `useCreateTaskCreatorDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskCreatorDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateTaskCreatorDisplayNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateTaskCreatorDisplayNameQuery(baseOptions?: Apollo.QueryHookOptions<CreateTaskCreatorDisplayNameQuery, CreateTaskCreatorDisplayNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateTaskCreatorDisplayNameQuery, CreateTaskCreatorDisplayNameQueryVariables>(CreateTaskCreatorDisplayNameDocument, options);
      }
export function useCreateTaskCreatorDisplayNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateTaskCreatorDisplayNameQuery, CreateTaskCreatorDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateTaskCreatorDisplayNameQuery, CreateTaskCreatorDisplayNameQueryVariables>(CreateTaskCreatorDisplayNameDocument, options);
        }
export type CreateTaskCreatorDisplayNameQueryHookResult = ReturnType<typeof useCreateTaskCreatorDisplayNameQuery>;
export type CreateTaskCreatorDisplayNameLazyQueryHookResult = ReturnType<typeof useCreateTaskCreatorDisplayNameLazyQuery>;
export type CreateTaskCreatorDisplayNameQueryResult = Apollo.QueryResult<CreateTaskCreatorDisplayNameQuery, CreateTaskCreatorDisplayNameQueryVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($taskUid: ID!) {
  deleteTask(taskUid: $taskUid) {
    failReasons
  }
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      taskUid: // value for 'taskUid'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const ReopenTaskDocument = gql`
    mutation ReopenTask($taskUid: ID!) {
  reopenTask(taskUid: $taskUid) {
    failReasons
  }
}
    `;
export type ReopenTaskMutationFn = Apollo.MutationFunction<ReopenTaskMutation, ReopenTaskMutationVariables>;

/**
 * __useReopenTaskMutation__
 *
 * To run a mutation, you first call `useReopenTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenTaskMutation, { data, loading, error }] = useReopenTaskMutation({
 *   variables: {
 *      taskUid: // value for 'taskUid'
 *   },
 * });
 */
export function useReopenTaskMutation(baseOptions?: Apollo.MutationHookOptions<ReopenTaskMutation, ReopenTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenTaskMutation, ReopenTaskMutationVariables>(ReopenTaskDocument, options);
      }
export type ReopenTaskMutationHookResult = ReturnType<typeof useReopenTaskMutation>;
export type ReopenTaskMutationResult = Apollo.MutationResult<ReopenTaskMutation>;
export type ReopenTaskMutationOptions = Apollo.BaseMutationOptions<ReopenTaskMutation, ReopenTaskMutationVariables>;
export const TaskDocument = gql`
    query Task($taskUid: ID!) {
  task(taskUid: $taskUid) {
    ...TaskSlide
  }
}
    ${TaskSlideFragmentDoc}`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      taskUid: // value for 'taskUid'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>;
export const TasksDocument = gql`
    query Tasks($filter: TaskFiltering, $primaryFilter: TaskPrimaryFilterInput, $page: Int = 1, $perPage: Int = 10) {
  tasks(
    primaryFilter: $primaryFilter
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...TaskListRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${TaskListRowFragmentDoc}`;

/**
 * __useTasksQuery__
 *
 * To run a query within a React component, call `useTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      primaryFilter: // value for 'primaryFilter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useTasksQuery(baseOptions?: Apollo.QueryHookOptions<TasksQuery, TasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
      }
export function useTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksQuery, TasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
        }
export type TasksQueryHookResult = ReturnType<typeof useTasksQuery>;
export type TasksLazyQueryHookResult = ReturnType<typeof useTasksLazyQuery>;
export type TasksQueryResult = Apollo.QueryResult<TasksQuery, TasksQueryVariables>;
export const TasksByDateDocument = gql`
    query TasksByDate($primaryFilter: TaskPrimaryFilterInput, $contactUid: ID, $companyUid: ID, $todayStartTime: ISO8601DateTime!) {
  tasksOverdue: tasks(
    primaryFilter: $primaryFilter
    filter: {contactUid: $contactUid, companyUid: $companyUid, status: PENDING, timeFrame: {timeFrame: OVERDUE, todayStartTime: $todayStartTime}}
    page: 1
    perPage: 1000
  ) {
    entries {
      ...TaskPreview
    }
  }
  tasksToday: tasks(
    primaryFilter: $primaryFilter
    filter: {contactUid: $contactUid, companyUid: $companyUid, status: PENDING, timeFrame: {timeFrame: TODAY, todayStartTime: $todayStartTime}}
    page: 1
    perPage: 1000
  ) {
    entries {
      ...TaskPreview
    }
  }
  tasksUpcoming: tasks(
    primaryFilter: $primaryFilter
    filter: {contactUid: $contactUid, companyUid: $companyUid, status: PENDING, timeFrame: {timeFrame: UPCOMING, todayStartTime: $todayStartTime}}
    page: 1
    perPage: 1000
  ) {
    entries {
      ...TaskPreview
    }
  }
  tasksCompleted: tasks(
    primaryFilter: $primaryFilter
    filter: {contactUid: $contactUid, companyUid: $companyUid, status: COMPLETED}
    page: 1
    perPage: 1000
  ) {
    entries {
      ...TaskPreview
    }
  }
}
    ${TaskPreviewFragmentDoc}`;

/**
 * __useTasksByDateQuery__
 *
 * To run a query within a React component, call `useTasksByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksByDateQuery({
 *   variables: {
 *      primaryFilter: // value for 'primaryFilter'
 *      contactUid: // value for 'contactUid'
 *      companyUid: // value for 'companyUid'
 *      todayStartTime: // value for 'todayStartTime'
 *   },
 * });
 */
export function useTasksByDateQuery(baseOptions: Apollo.QueryHookOptions<TasksByDateQuery, TasksByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksByDateQuery, TasksByDateQueryVariables>(TasksByDateDocument, options);
      }
export function useTasksByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksByDateQuery, TasksByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksByDateQuery, TasksByDateQueryVariables>(TasksByDateDocument, options);
        }
export type TasksByDateQueryHookResult = ReturnType<typeof useTasksByDateQuery>;
export type TasksByDateLazyQueryHookResult = ReturnType<typeof useTasksByDateLazyQuery>;
export type TasksByDateQueryResult = Apollo.QueryResult<TasksByDateQuery, TasksByDateQueryVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($taskUid: ID!, $assignedToUid: ID, $title: String, $description: String, $dueOn: String, $priority: PriorityEnum, $requestedByUid: ID) {
  updateTask(
    taskUid: $taskUid
    assignedToUid: $assignedToUid
    title: $title
    description: $description
    dueOn: $dueOn
    priority: $priority
    requestedByUid: $requestedByUid
  ) {
    record {
      ...TaskSlide
    }
    failReasons
  }
}
    ${TaskSlideFragmentDoc}`;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      taskUid: // value for 'taskUid'
 *      assignedToUid: // value for 'assignedToUid'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      dueOn: // value for 'dueOn'
 *      priority: // value for 'priority'
 *      requestedByUid: // value for 'requestedByUid'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const TemplateProjectDocument = gql`
    query TemplateProject($uuid: ID!) {
  templateProject(uuid: $uuid) {
    iconCode
    colorCode
    title
    description {
      trixHtml
      plainText
      html
    }
    documents {
      ...ProjectDocumentOverview
    }
    id
    objectives {
      ...ObjectiveListItem
    }
    nexlApps
    firmWide
  }
}
    ${ProjectDocumentOverviewFragmentDoc}
${ObjectiveListItemFragmentDoc}`;

/**
 * __useTemplateProjectQuery__
 *
 * To run a query within a React component, call `useTemplateProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateProjectQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useTemplateProjectQuery(baseOptions: Apollo.QueryHookOptions<TemplateProjectQuery, TemplateProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateProjectQuery, TemplateProjectQueryVariables>(TemplateProjectDocument, options);
      }
export function useTemplateProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateProjectQuery, TemplateProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateProjectQuery, TemplateProjectQueryVariables>(TemplateProjectDocument, options);
        }
export type TemplateProjectQueryHookResult = ReturnType<typeof useTemplateProjectQuery>;
export type TemplateProjectLazyQueryHookResult = ReturnType<typeof useTemplateProjectLazyQuery>;
export type TemplateProjectQueryResult = Apollo.QueryResult<TemplateProjectQuery, TemplateProjectQueryVariables>;
export const InteractionsConfigurationDocument = gql`
    query InteractionsConfiguration {
  interactionsConfiguration {
    id
    keyActivityTitlesOnlyUseRecommended
  }
}
    `;

/**
 * __useInteractionsConfigurationQuery__
 *
 * To run a query within a React component, call `useInteractionsConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionsConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionsConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useInteractionsConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<InteractionsConfigurationQuery, InteractionsConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InteractionsConfigurationQuery, InteractionsConfigurationQueryVariables>(InteractionsConfigurationDocument, options);
      }
export function useInteractionsConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InteractionsConfigurationQuery, InteractionsConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InteractionsConfigurationQuery, InteractionsConfigurationQueryVariables>(InteractionsConfigurationDocument, options);
        }
export type InteractionsConfigurationQueryHookResult = ReturnType<typeof useInteractionsConfigurationQuery>;
export type InteractionsConfigurationLazyQueryHookResult = ReturnType<typeof useInteractionsConfigurationLazyQuery>;
export type InteractionsConfigurationQueryResult = Apollo.QueryResult<InteractionsConfigurationQuery, InteractionsConfigurationQueryVariables>;
export const PagesDocument = gql`
    query Pages {
  opportunityTrackingConfiguration {
    id
    visibleFirmWide
  }
  userRoleCorePermissions {
    id
    allContacts
    allCompanies
  }
  userRoleObjectiveManagementPermissions {
    id
    allObjectives
  }
  userRoleOpportunityTrackingPermissions {
    id
    allOpportunities
  }
  userRoleEnrichmentPermissions {
    id
    allProspects
  }
  accessConfiguration {
    id
    showRoleAdmin
  }
  currentUser {
    id
    canViewEmbeddedReport
  }
}
    `;

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagesQuery(baseOptions?: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
      }
export function usePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>;
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>;
export type PagesQueryResult = Apollo.QueryResult<PagesQuery, PagesQueryVariables>;
export const SetUiConfigurationDocument = gql`
    mutation SetUiConfiguration($name: String!, $configuration: String!, $scope: String!) {
  setUiConfiguration(name: $name, configuration: $configuration, scope: $scope) {
    failReasons
    record {
      ...UiConfig
    }
  }
}
    ${UiConfigFragmentDoc}`;
export type SetUiConfigurationMutationFn = Apollo.MutationFunction<SetUiConfigurationMutation, SetUiConfigurationMutationVariables>;

/**
 * __useSetUiConfigurationMutation__
 *
 * To run a mutation, you first call `useSetUiConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUiConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUiConfigurationMutation, { data, loading, error }] = useSetUiConfigurationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      configuration: // value for 'configuration'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useSetUiConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SetUiConfigurationMutation, SetUiConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUiConfigurationMutation, SetUiConfigurationMutationVariables>(SetUiConfigurationDocument, options);
      }
export type SetUiConfigurationMutationHookResult = ReturnType<typeof useSetUiConfigurationMutation>;
export type SetUiConfigurationMutationResult = Apollo.MutationResult<SetUiConfigurationMutation>;
export type SetUiConfigurationMutationOptions = Apollo.BaseMutationOptions<SetUiConfigurationMutation, SetUiConfigurationMutationVariables>;
export const UiConfigurationDocument = gql`
    query UiConfiguration($name: String!) {
  columnState: uiConfiguration(name: $name, scope: "column_state") {
    ...UiConfig
  }
  filterModel: uiConfiguration(name: $name, scope: "filter_model") {
    ...UiConfig
  }
  searchState: uiConfiguration(name: $name, scope: "search_state") {
    ...UiConfig
  }
  calendarView: uiConfiguration(name: $name, scope: "calendar_view") {
    ...UiConfig
  }
}
    ${UiConfigFragmentDoc}`;

/**
 * __useUiConfigurationQuery__
 *
 * To run a query within a React component, call `useUiConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUiConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUiConfigurationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUiConfigurationQuery(baseOptions: Apollo.QueryHookOptions<UiConfigurationQuery, UiConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UiConfigurationQuery, UiConfigurationQueryVariables>(UiConfigurationDocument, options);
      }
export function useUiConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UiConfigurationQuery, UiConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UiConfigurationQuery, UiConfigurationQueryVariables>(UiConfigurationDocument, options);
        }
export type UiConfigurationQueryHookResult = ReturnType<typeof useUiConfigurationQuery>;
export type UiConfigurationLazyQueryHookResult = ReturnType<typeof useUiConfigurationLazyQuery>;
export type UiConfigurationQueryResult = Apollo.QueryResult<UiConfigurationQuery, UiConfigurationQueryVariables>;
export const MyAllContactUpdateEventsDocument = gql`
    query MyAllContactUpdateEvents($filter: ContactUpdateEventFilter, $page: Int = 1, $perPage: Int = 10) {
  myAllContactUpdateEvents(page: $page, perPage: $perPage, filter: $filter) {
    entries {
      ...ContactUpdateEventRow
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ContactUpdateEventRowFragmentDoc}`;

/**
 * __useMyAllContactUpdateEventsQuery__
 *
 * To run a query within a React component, call `useMyAllContactUpdateEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAllContactUpdateEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAllContactUpdateEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMyAllContactUpdateEventsQuery(baseOptions?: Apollo.QueryHookOptions<MyAllContactUpdateEventsQuery, MyAllContactUpdateEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAllContactUpdateEventsQuery, MyAllContactUpdateEventsQueryVariables>(MyAllContactUpdateEventsDocument, options);
      }
export function useMyAllContactUpdateEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAllContactUpdateEventsQuery, MyAllContactUpdateEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAllContactUpdateEventsQuery, MyAllContactUpdateEventsQueryVariables>(MyAllContactUpdateEventsDocument, options);
        }
export type MyAllContactUpdateEventsQueryHookResult = ReturnType<typeof useMyAllContactUpdateEventsQuery>;
export type MyAllContactUpdateEventsLazyQueryHookResult = ReturnType<typeof useMyAllContactUpdateEventsLazyQuery>;
export type MyAllContactUpdateEventsQueryResult = Apollo.QueryResult<MyAllContactUpdateEventsQuery, MyAllContactUpdateEventsQueryVariables>;
export const AccessConfigurationDocument = gql`
    query AccessConfiguration {
  accessConfiguration {
    id
    showRoleAdmin
  }
}
    `;

/**
 * __useAccessConfigurationQuery__
 *
 * To run a query within a React component, call `useAccessConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<AccessConfigurationQuery, AccessConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessConfigurationQuery, AccessConfigurationQueryVariables>(AccessConfigurationDocument, options);
      }
export function useAccessConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessConfigurationQuery, AccessConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessConfigurationQuery, AccessConfigurationQueryVariables>(AccessConfigurationDocument, options);
        }
export type AccessConfigurationQueryHookResult = ReturnType<typeof useAccessConfigurationQuery>;
export type AccessConfigurationLazyQueryHookResult = ReturnType<typeof useAccessConfigurationLazyQuery>;
export type AccessConfigurationQueryResult = Apollo.QueryResult<AccessConfigurationQuery, AccessConfigurationQueryVariables>;
export const AccessRoleFieldOptionsDocument = gql`
    query AccessRoleFieldOptions {
  accessRoles {
    entries {
      ...AccessRoleFieldOption
    }
  }
}
    ${AccessRoleFieldOptionFragmentDoc}`;

/**
 * __useAccessRoleFieldOptionsQuery__
 *
 * To run a query within a React component, call `useAccessRoleFieldOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessRoleFieldOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessRoleFieldOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessRoleFieldOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AccessRoleFieldOptionsQuery, AccessRoleFieldOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessRoleFieldOptionsQuery, AccessRoleFieldOptionsQueryVariables>(AccessRoleFieldOptionsDocument, options);
      }
export function useAccessRoleFieldOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessRoleFieldOptionsQuery, AccessRoleFieldOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessRoleFieldOptionsQuery, AccessRoleFieldOptionsQueryVariables>(AccessRoleFieldOptionsDocument, options);
        }
export type AccessRoleFieldOptionsQueryHookResult = ReturnType<typeof useAccessRoleFieldOptionsQuery>;
export type AccessRoleFieldOptionsLazyQueryHookResult = ReturnType<typeof useAccessRoleFieldOptionsLazyQuery>;
export type AccessRoleFieldOptionsQueryResult = Apollo.QueryResult<AccessRoleFieldOptionsQuery, AccessRoleFieldOptionsQueryVariables>;
export const AccessRolesDocument = gql`
    query AccessRoles {
  accessRoles {
    entries {
      ...AccessRole
    }
  }
}
    ${AccessRoleFragmentDoc}`;

/**
 * __useAccessRolesQuery__
 *
 * To run a query within a React component, call `useAccessRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessRolesQuery(baseOptions?: Apollo.QueryHookOptions<AccessRolesQuery, AccessRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessRolesQuery, AccessRolesQueryVariables>(AccessRolesDocument, options);
      }
export function useAccessRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessRolesQuery, AccessRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessRolesQuery, AccessRolesQueryVariables>(AccessRolesDocument, options);
        }
export type AccessRolesQueryHookResult = ReturnType<typeof useAccessRolesQuery>;
export type AccessRolesLazyQueryHookResult = ReturnType<typeof useAccessRolesLazyQuery>;
export type AccessRolesQueryResult = Apollo.QueryResult<AccessRolesQuery, AccessRolesQueryVariables>;
export const AddUserDocument = gql`
    mutation AddUser($email: String!, $roleUid: ID!, $firstName: String, $lastName: String) {
  addUser(
    email: $email
    roleUid: $roleUid
    firstName: $firstName
    lastName: $lastName
  ) {
    failReasons
    user {
      ...UserGridRow
    }
  }
}
    ${UserGridRowFragmentDoc}`;
export type AddUserMutationFn = Apollo.MutationFunction<AddUserMutation, AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      roleUid: // value for 'roleUid'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export const ArchiveUserDocument = gql`
    mutation ArchiveUser($userUid: ID!) {
  archiveUser(userUid: $userUid) {
    failReasons
    user {
      ...UserGridRow
    }
  }
}
    ${UserGridRowFragmentDoc}`;
export type ArchiveUserMutationFn = Apollo.MutationFunction<ArchiveUserMutation, ArchiveUserMutationVariables>;

/**
 * __useArchiveUserMutation__
 *
 * To run a mutation, you first call `useArchiveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveUserMutation, { data, loading, error }] = useArchiveUserMutation({
 *   variables: {
 *      userUid: // value for 'userUid'
 *   },
 * });
 */
export function useArchiveUserMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveUserMutation, ArchiveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveUserMutation, ArchiveUserMutationVariables>(ArchiveUserDocument, options);
      }
export type ArchiveUserMutationHookResult = ReturnType<typeof useArchiveUserMutation>;
export type ArchiveUserMutationResult = Apollo.MutationResult<ArchiveUserMutation>;
export type ArchiveUserMutationOptions = Apollo.BaseMutationOptions<ArchiveUserMutation, ArchiveUserMutationVariables>;
export const CreateCustomUserRoleDocument = gql`
    mutation CreateCustomUserRole($name: String!, $description: String, $baseLegacyRole: BaseLegacyRole!) {
  createCustomUserRole(
    name: $name
    description: $description
    baseLegacyRole: $baseLegacyRole
  ) {
    failReasons
    role {
      id
    }
  }
}
    `;
export type CreateCustomUserRoleMutationFn = Apollo.MutationFunction<CreateCustomUserRoleMutation, CreateCustomUserRoleMutationVariables>;

/**
 * __useCreateCustomUserRoleMutation__
 *
 * To run a mutation, you first call `useCreateCustomUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomUserRoleMutation, { data, loading, error }] = useCreateCustomUserRoleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      baseLegacyRole: // value for 'baseLegacyRole'
 *   },
 * });
 */
export function useCreateCustomUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomUserRoleMutation, CreateCustomUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomUserRoleMutation, CreateCustomUserRoleMutationVariables>(CreateCustomUserRoleDocument, options);
      }
export type CreateCustomUserRoleMutationHookResult = ReturnType<typeof useCreateCustomUserRoleMutation>;
export type CreateCustomUserRoleMutationResult = Apollo.MutationResult<CreateCustomUserRoleMutation>;
export type CreateCustomUserRoleMutationOptions = Apollo.BaseMutationOptions<CreateCustomUserRoleMutation, CreateCustomUserRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($roleUid: ID!) {
  deleteRole(roleUid: $roleUid) {
    failReasons
  }
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleUid: // value for 'roleUid'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($roleUid: ID!, $name: String, $description: String) {
  updateRole(roleUid: $roleUid, name: $name, description: $description) {
    failReasons
    accessRole {
      id
      name
      description
    }
  }
}
    `;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      roleUid: // value for 'roleUid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const UpdateRolePermissionsDocument = gql`
    mutation UpdateRolePermissions($accessRoleUid: ID!, $allContacts: Boolean, $allCompanies: Boolean, $allProspects: Boolean, $allOpportunities: Boolean, $allObjectives: Boolean, $viewEmployeeEngagementTab: Boolean, $viewEmployeeOpportunitiesTab: Boolean, $exportCompanyLists: Boolean, $exportContactLists: Boolean, $exportGenericLists: Boolean, $exportKeyActivityLists: Boolean, $exportOpportunities: Boolean, $exportAllActivities: Boolean, $exportMarketingLists: Boolean, $exportReferrals: Boolean, $exportAllOpportunities: Boolean, $readCompanyReport: Boolean, $editCompanyReport: Boolean) {
  core: updateCoreRolePermission(
    accessRoleUid: $accessRoleUid
    allContacts: $allContacts
    allCompanies: $allCompanies
    viewEmployeeEngagementTab: $viewEmployeeEngagementTab
  ) {
    failReasons
  }
  enrichment: updateEnrichmentRolePermission(
    accessRoleUid: $accessRoleUid
    allProspects: $allProspects
  ) {
    failReasons
  }
  opportunityTracking: updateOpportunityTrackingRolePermission(
    accessRoleUid: $accessRoleUid
    allOpportunities: $allOpportunities
    viewEmployeeOpportunitiesTab: $viewEmployeeOpportunitiesTab
    exportAllOpportunities: $exportAllOpportunities
  ) {
    failReasons
  }
  objectiveManagement: updateObjectiveManagementRolePermission(
    accessRoleUid: $accessRoleUid
    allObjectives: $allObjectives
  ) {
    failReasons
  }
  projectManagement: updateProjectManagementRolePermission(
    accessRoleUid: $accessRoleUid
    exportCompanyLists: $exportCompanyLists
    exportContactLists: $exportContactLists
    exportGenericLists: $exportGenericLists
    exportKeyActivityLists: $exportKeyActivityLists
    exportOpportunities: $exportOpportunities
  ) {
    failReasons
  }
  interactions: updateInteractionsRolePermission(
    accessRoleUid: $accessRoleUid
    exportAllActivities: $exportAllActivities
  ) {
    failReasons
  }
  marketingLists: updateMarketingListsRolePermission(
    accessRoleUid: $accessRoleUid
    exportMarketingLists: $exportMarketingLists
  ) {
    failReasons
  }
  referralTracking: updateReferralTrackingRolePermission(
    accessRoleUid: $accessRoleUid
    exportReferrals: $exportReferrals
  ) {
    failReasons
  }
  researchReports: updateResearchReportsRolePermission(
    accessRoleUid: $accessRoleUid
    readCompanyReport: $readCompanyReport
    editCompanyReport: $editCompanyReport
  ) {
    failReasons
  }
}
    `;
export type UpdateRolePermissionsMutationFn = Apollo.MutationFunction<UpdateRolePermissionsMutation, UpdateRolePermissionsMutationVariables>;

/**
 * __useUpdateRolePermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRolePermissionsMutation, { data, loading, error }] = useUpdateRolePermissionsMutation({
 *   variables: {
 *      accessRoleUid: // value for 'accessRoleUid'
 *      allContacts: // value for 'allContacts'
 *      allCompanies: // value for 'allCompanies'
 *      allProspects: // value for 'allProspects'
 *      allOpportunities: // value for 'allOpportunities'
 *      allObjectives: // value for 'allObjectives'
 *      viewEmployeeEngagementTab: // value for 'viewEmployeeEngagementTab'
 *      viewEmployeeOpportunitiesTab: // value for 'viewEmployeeOpportunitiesTab'
 *      exportCompanyLists: // value for 'exportCompanyLists'
 *      exportContactLists: // value for 'exportContactLists'
 *      exportGenericLists: // value for 'exportGenericLists'
 *      exportKeyActivityLists: // value for 'exportKeyActivityLists'
 *      exportOpportunities: // value for 'exportOpportunities'
 *      exportAllActivities: // value for 'exportAllActivities'
 *      exportMarketingLists: // value for 'exportMarketingLists'
 *      exportReferrals: // value for 'exportReferrals'
 *      exportAllOpportunities: // value for 'exportAllOpportunities'
 *      readCompanyReport: // value for 'readCompanyReport'
 *      editCompanyReport: // value for 'editCompanyReport'
 *   },
 * });
 */
export function useUpdateRolePermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRolePermissionsMutation, UpdateRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRolePermissionsMutation, UpdateRolePermissionsMutationVariables>(UpdateRolePermissionsDocument, options);
      }
export type UpdateRolePermissionsMutationHookResult = ReturnType<typeof useUpdateRolePermissionsMutation>;
export type UpdateRolePermissionsMutationResult = Apollo.MutationResult<UpdateRolePermissionsMutation>;
export type UpdateRolePermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateRolePermissionsMutation, UpdateRolePermissionsMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($roleUid: ID!, $userUid: ID!) {
  updateUser(roleUid: $roleUid, userUid: $userUid) {
    failReasons
    user {
      ...UserGridRow
    }
  }
}
    ${UserGridRowFragmentDoc}`;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      roleUid: // value for 'roleUid'
 *      userUid: // value for 'userUid'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const UsersGridDocument = gql`
    query UsersGrid($page: Int!, $perPage: Int!, $term: String) {
  users(page: $page, perPage: $perPage, scope: ACTIVE, term: $term) {
    pageInfo {
      totalEntries
    }
    entries: adminEntries {
      ...UserGridRow
    }
  }
}
    ${UserGridRowFragmentDoc}`;

/**
 * __useUsersGridQuery__
 *
 * To run a query within a React component, call `useUsersGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersGridQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useUsersGridQuery(baseOptions: Apollo.QueryHookOptions<UsersGridQuery, UsersGridQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersGridQuery, UsersGridQueryVariables>(UsersGridDocument, options);
      }
export function useUsersGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersGridQuery, UsersGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersGridQuery, UsersGridQueryVariables>(UsersGridDocument, options);
        }
export type UsersGridQueryHookResult = ReturnType<typeof useUsersGridQuery>;
export type UsersGridLazyQueryHookResult = ReturnType<typeof useUsersGridLazyQuery>;
export type UsersGridQueryResult = Apollo.QueryResult<UsersGridQuery, UsersGridQueryVariables>;
export const AccessRolePageDocument = gql`
    query AccessRolePage($accessRoleUid: ID!) {
  tenantConfiguration {
    id
    showAllEmployeesTab
  }
  accessRole(uid: $accessRoleUid) {
    ...AccessRoleDetails
  }
  coreRolePermissions(accessRoleUid: $accessRoleUid) {
    id
    ...AccessRoleContactPermissions
    ...AccessRoleCompanyPermissions
  }
  opportunityTrackingRolePermissions(accessRoleUid: $accessRoleUid) {
    id
    ...AccessRoleOpportunityTrackingPermissions
  }
  objectiveManagementRolePermissions(accessRoleUid: $accessRoleUid) {
    id
    ...AccessRoleObjectiveManagementPermissions
  }
  enrichmentRolePermissions(accessRoleUid: $accessRoleUid) {
    id
    ...AccessRoleEnrichmentPermissions
  }
  projectManagementRolePermissions(accessRoleUid: $accessRoleUid) {
    id
    ...AccessRoleProjectManagementPermissions
  }
  interactionsRolePermissions(accessRoleUid: $accessRoleUid) {
    id
    ...AccessRoleInteractionsPermissions
  }
  marketingListsRolePermissions(accessRoleUid: $accessRoleUid) {
    id
    ...AccessRoleMarketingListsPermissions
  }
  referralTrackingRolePermissions(accessRoleUid: $accessRoleUid) {
    id
    ...AccessRoleReferralTrackingPermissions
  }
  researchReportsRolePermissions(accessRoleUid: $accessRoleUid) {
    id
    ...AccessRoleResearchReportsPermissions
  }
}
    ${AccessRoleDetailsFragmentDoc}
${AccessRoleContactPermissionsFragmentDoc}
${AccessRoleCompanyPermissionsFragmentDoc}
${AccessRoleOpportunityTrackingPermissionsFragmentDoc}
${AccessRoleObjectiveManagementPermissionsFragmentDoc}
${AccessRoleEnrichmentPermissionsFragmentDoc}
${AccessRoleProjectManagementPermissionsFragmentDoc}
${AccessRoleInteractionsPermissionsFragmentDoc}
${AccessRoleMarketingListsPermissionsFragmentDoc}
${AccessRoleReferralTrackingPermissionsFragmentDoc}
${AccessRoleResearchReportsPermissionsFragmentDoc}`;

/**
 * __useAccessRolePageQuery__
 *
 * To run a query within a React component, call `useAccessRolePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessRolePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessRolePageQuery({
 *   variables: {
 *      accessRoleUid: // value for 'accessRoleUid'
 *   },
 * });
 */
export function useAccessRolePageQuery(baseOptions: Apollo.QueryHookOptions<AccessRolePageQuery, AccessRolePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessRolePageQuery, AccessRolePageQueryVariables>(AccessRolePageDocument, options);
      }
export function useAccessRolePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessRolePageQuery, AccessRolePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessRolePageQuery, AccessRolePageQueryVariables>(AccessRolePageDocument, options);
        }
export type AccessRolePageQueryHookResult = ReturnType<typeof useAccessRolePageQuery>;
export type AccessRolePageLazyQueryHookResult = ReturnType<typeof useAccessRolePageLazyQuery>;
export type AccessRolePageQueryResult = Apollo.QueryResult<AccessRolePageQuery, AccessRolePageQueryVariables>;
export const CreateUserDelegateAccessDocument = gql`
    mutation CreateUserDelegateAccess($delegateUserUid: ID!, $userUid: ID!) {
  createUserDelegateAccess(delegateUserUid: $delegateUserUid, userUid: $userUid) {
    failReasons
  }
}
    `;
export type CreateUserDelegateAccessMutationFn = Apollo.MutationFunction<CreateUserDelegateAccessMutation, CreateUserDelegateAccessMutationVariables>;

/**
 * __useCreateUserDelegateAccessMutation__
 *
 * To run a mutation, you first call `useCreateUserDelegateAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDelegateAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDelegateAccessMutation, { data, loading, error }] = useCreateUserDelegateAccessMutation({
 *   variables: {
 *      delegateUserUid: // value for 'delegateUserUid'
 *      userUid: // value for 'userUid'
 *   },
 * });
 */
export function useCreateUserDelegateAccessMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserDelegateAccessMutation, CreateUserDelegateAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDelegateAccessMutation, CreateUserDelegateAccessMutationVariables>(CreateUserDelegateAccessDocument, options);
      }
export type CreateUserDelegateAccessMutationHookResult = ReturnType<typeof useCreateUserDelegateAccessMutation>;
export type CreateUserDelegateAccessMutationResult = Apollo.MutationResult<CreateUserDelegateAccessMutation>;
export type CreateUserDelegateAccessMutationOptions = Apollo.BaseMutationOptions<CreateUserDelegateAccessMutation, CreateUserDelegateAccessMutationVariables>;
export const DelegateAccessesDocument = gql`
    query DelegateAccesses($userId: ID!) {
  allDelegateAccesses(userUid: $userId) {
    entries {
      id
      delegateUserInfo {
        ...DelegateAccessInfo
      }
    }
  }
}
    ${DelegateAccessInfoFragmentDoc}`;

/**
 * __useDelegateAccessesQuery__
 *
 * To run a query within a React component, call `useDelegateAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDelegateAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDelegateAccessesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDelegateAccessesQuery(baseOptions: Apollo.QueryHookOptions<DelegateAccessesQuery, DelegateAccessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DelegateAccessesQuery, DelegateAccessesQueryVariables>(DelegateAccessesDocument, options);
      }
export function useDelegateAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DelegateAccessesQuery, DelegateAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DelegateAccessesQuery, DelegateAccessesQueryVariables>(DelegateAccessesDocument, options);
        }
export type DelegateAccessesQueryHookResult = ReturnType<typeof useDelegateAccessesQuery>;
export type DelegateAccessesLazyQueryHookResult = ReturnType<typeof useDelegateAccessesLazyQuery>;
export type DelegateAccessesQueryResult = Apollo.QueryResult<DelegateAccessesQuery, DelegateAccessesQueryVariables>;
export const DeleteUserDelegateAccessDocument = gql`
    mutation DeleteUserDelegateAccess($delegateUserUid: ID!, $userUid: ID!) {
  deleteUserDelegateAccess(delegateUserUid: $delegateUserUid, userUid: $userUid) {
    failReasons
  }
}
    `;
export type DeleteUserDelegateAccessMutationFn = Apollo.MutationFunction<DeleteUserDelegateAccessMutation, DeleteUserDelegateAccessMutationVariables>;

/**
 * __useDeleteUserDelegateAccessMutation__
 *
 * To run a mutation, you first call `useDeleteUserDelegateAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDelegateAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDelegateAccessMutation, { data, loading, error }] = useDeleteUserDelegateAccessMutation({
 *   variables: {
 *      delegateUserUid: // value for 'delegateUserUid'
 *      userUid: // value for 'userUid'
 *   },
 * });
 */
export function useDeleteUserDelegateAccessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserDelegateAccessMutation, DeleteUserDelegateAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserDelegateAccessMutation, DeleteUserDelegateAccessMutationVariables>(DeleteUserDelegateAccessDocument, options);
      }
export type DeleteUserDelegateAccessMutationHookResult = ReturnType<typeof useDeleteUserDelegateAccessMutation>;
export type DeleteUserDelegateAccessMutationResult = Apollo.MutationResult<DeleteUserDelegateAccessMutation>;
export type DeleteUserDelegateAccessMutationOptions = Apollo.BaseMutationOptions<DeleteUserDelegateAccessMutation, DeleteUserDelegateAccessMutationVariables>;
export const GetCurrentUserRolesDocument = gql`
    query GetCurrentUserRoles {
  currentUser {
    id
    role
  }
}
    `;

/**
 * __useGetCurrentUserRolesQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>(GetCurrentUserRolesDocument, options);
      }
export function useGetCurrentUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>(GetCurrentUserRolesDocument, options);
        }
export type GetCurrentUserRolesQueryHookResult = ReturnType<typeof useGetCurrentUserRolesQuery>;
export type GetCurrentUserRolesLazyQueryHookResult = ReturnType<typeof useGetCurrentUserRolesLazyQuery>;
export type GetCurrentUserRolesQueryResult = Apollo.QueryResult<GetCurrentUserRolesQuery, GetCurrentUserRolesQueryVariables>;
export const UserRoleContextRolePermissionsDocument = gql`
    query UserRoleContextRolePermissions {
  userRoleCorePermissions {
    id
    allContacts
    allCompanies
    exportAllContacts
    exportMyCompanies
    exportAllCompanies
    exportMyContacts
  }
  userRoleObjectiveManagementPermissions {
    id
    allObjectives
  }
  userRoleOpportunityTrackingPermissions {
    id
    allOpportunities
    exportAllOpportunities
  }
  userRoleEnrichmentPermissions {
    id
    allProspects
  }
  userRoleProjectManagementPermissions {
    id
    ...AccessRoleProjectManagementPermissions
  }
  userRoleInteractionsPermissions {
    id
    ...AccessRoleInteractionsPermissions
  }
  userRoleMarketingListsPermissions {
    id
    ...AccessRoleMarketingListsPermissions
  }
  userRoleReferralTrackingPermissions {
    id
    ...AccessRoleReferralTrackingPermissions
  }
  userRoleResearchReportsPermissions {
    id
    ...AccessRoleResearchReportsPermissions
  }
}
    ${AccessRoleProjectManagementPermissionsFragmentDoc}
${AccessRoleInteractionsPermissionsFragmentDoc}
${AccessRoleMarketingListsPermissionsFragmentDoc}
${AccessRoleReferralTrackingPermissionsFragmentDoc}
${AccessRoleResearchReportsPermissionsFragmentDoc}`;

/**
 * __useUserRoleContextRolePermissionsQuery__
 *
 * To run a query within a React component, call `useUserRoleContextRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleContextRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleContextRolePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRoleContextRolePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<UserRoleContextRolePermissionsQuery, UserRoleContextRolePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRoleContextRolePermissionsQuery, UserRoleContextRolePermissionsQueryVariables>(UserRoleContextRolePermissionsDocument, options);
      }
export function useUserRoleContextRolePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRoleContextRolePermissionsQuery, UserRoleContextRolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRoleContextRolePermissionsQuery, UserRoleContextRolePermissionsQueryVariables>(UserRoleContextRolePermissionsDocument, options);
        }
export type UserRoleContextRolePermissionsQueryHookResult = ReturnType<typeof useUserRoleContextRolePermissionsQuery>;
export type UserRoleContextRolePermissionsLazyQueryHookResult = ReturnType<typeof useUserRoleContextRolePermissionsLazyQuery>;
export type UserRoleContextRolePermissionsQueryResult = Apollo.QueryResult<UserRoleContextRolePermissionsQuery, UserRoleContextRolePermissionsQueryVariables>;
export const KeyActivityListMemberSlideDocument = gql`
    query KeyActivityListMemberSlide($listMemberUid: ID!) {
  keyActivityListMember(listMemberUid: $listMemberUid) {
    id
    keyActivity {
      ...KeyActivityDetails
    }
    customFields {
      ...CustomField
    }
    list {
      id
    }
  }
}
    ${KeyActivityDetailsFragmentDoc}
${CustomFieldFragmentDoc}`;

/**
 * __useKeyActivityListMemberSlideQuery__
 *
 * To run a query within a React component, call `useKeyActivityListMemberSlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityListMemberSlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityListMemberSlideQuery({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *   },
 * });
 */
export function useKeyActivityListMemberSlideQuery(baseOptions: Apollo.QueryHookOptions<KeyActivityListMemberSlideQuery, KeyActivityListMemberSlideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityListMemberSlideQuery, KeyActivityListMemberSlideQueryVariables>(KeyActivityListMemberSlideDocument, options);
      }
export function useKeyActivityListMemberSlideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityListMemberSlideQuery, KeyActivityListMemberSlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityListMemberSlideQuery, KeyActivityListMemberSlideQueryVariables>(KeyActivityListMemberSlideDocument, options);
        }
export type KeyActivityListMemberSlideQueryHookResult = ReturnType<typeof useKeyActivityListMemberSlideQuery>;
export type KeyActivityListMemberSlideLazyQueryHookResult = ReturnType<typeof useKeyActivityListMemberSlideLazyQuery>;
export type KeyActivityListMemberSlideQueryResult = Apollo.QueryResult<KeyActivityListMemberSlideQuery, KeyActivityListMemberSlideQueryVariables>;
export const KeyActivitySlideDocument = gql`
    query KeyActivitySlide($sourceReferenceId: String!) {
  keyActivity(sourceReferenceId: $sourceReferenceId) {
    ...KeyActivityDetails
  }
}
    ${KeyActivityDetailsFragmentDoc}`;

/**
 * __useKeyActivitySlideQuery__
 *
 * To run a query within a React component, call `useKeyActivitySlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivitySlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivitySlideQuery({
 *   variables: {
 *      sourceReferenceId: // value for 'sourceReferenceId'
 *   },
 * });
 */
export function useKeyActivitySlideQuery(baseOptions: Apollo.QueryHookOptions<KeyActivitySlideQuery, KeyActivitySlideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivitySlideQuery, KeyActivitySlideQueryVariables>(KeyActivitySlideDocument, options);
      }
export function useKeyActivitySlideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivitySlideQuery, KeyActivitySlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivitySlideQuery, KeyActivitySlideQueryVariables>(KeyActivitySlideDocument, options);
        }
export type KeyActivitySlideQueryHookResult = ReturnType<typeof useKeyActivitySlideQuery>;
export type KeyActivitySlideLazyQueryHookResult = ReturnType<typeof useKeyActivitySlideLazyQuery>;
export type KeyActivitySlideQueryResult = Apollo.QueryResult<KeyActivitySlideQuery, KeyActivitySlideQueryVariables>;
export const KeyActivityListCustomFieldSchemasDocument = gql`
    query KeyActivityListCustomFieldSchemas($uid: ID!) {
  keyActivityList(uid: $uid) {
    id
    memberCustomFields {
      ...CustomFieldSchema
    }
  }
}
    ${CustomFieldSchemaFragmentDoc}`;

/**
 * __useKeyActivityListCustomFieldSchemasQuery__
 *
 * To run a query within a React component, call `useKeyActivityListCustomFieldSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityListCustomFieldSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityListCustomFieldSchemasQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useKeyActivityListCustomFieldSchemasQuery(baseOptions: Apollo.QueryHookOptions<KeyActivityListCustomFieldSchemasQuery, KeyActivityListCustomFieldSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityListCustomFieldSchemasQuery, KeyActivityListCustomFieldSchemasQueryVariables>(KeyActivityListCustomFieldSchemasDocument, options);
      }
export function useKeyActivityListCustomFieldSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityListCustomFieldSchemasQuery, KeyActivityListCustomFieldSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityListCustomFieldSchemasQuery, KeyActivityListCustomFieldSchemasQueryVariables>(KeyActivityListCustomFieldSchemasDocument, options);
        }
export type KeyActivityListCustomFieldSchemasQueryHookResult = ReturnType<typeof useKeyActivityListCustomFieldSchemasQuery>;
export type KeyActivityListCustomFieldSchemasLazyQueryHookResult = ReturnType<typeof useKeyActivityListCustomFieldSchemasLazyQuery>;
export type KeyActivityListCustomFieldSchemasQueryResult = Apollo.QueryResult<KeyActivityListCustomFieldSchemasQuery, KeyActivityListCustomFieldSchemasQueryVariables>;
export const SetKeyActivityListMemberCustomFieldDocument = gql`
    mutation SetKeyActivityListMemberCustomField($listMemberUid: ID!, $customFieldAttributes: [CustomFieldAttribute!]!) {
  setKeyActivityListMemberCustomField(
    listMemberUid: $listMemberUid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
    record {
      id
      customFields {
        ...CustomField
      }
    }
  }
}
    ${CustomFieldFragmentDoc}`;
export type SetKeyActivityListMemberCustomFieldMutationFn = Apollo.MutationFunction<SetKeyActivityListMemberCustomFieldMutation, SetKeyActivityListMemberCustomFieldMutationVariables>;

/**
 * __useSetKeyActivityListMemberCustomFieldMutation__
 *
 * To run a mutation, you first call `useSetKeyActivityListMemberCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetKeyActivityListMemberCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setKeyActivityListMemberCustomFieldMutation, { data, loading, error }] = useSetKeyActivityListMemberCustomFieldMutation({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useSetKeyActivityListMemberCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<SetKeyActivityListMemberCustomFieldMutation, SetKeyActivityListMemberCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetKeyActivityListMemberCustomFieldMutation, SetKeyActivityListMemberCustomFieldMutationVariables>(SetKeyActivityListMemberCustomFieldDocument, options);
      }
export type SetKeyActivityListMemberCustomFieldMutationHookResult = ReturnType<typeof useSetKeyActivityListMemberCustomFieldMutation>;
export type SetKeyActivityListMemberCustomFieldMutationResult = Apollo.MutationResult<SetKeyActivityListMemberCustomFieldMutation>;
export type SetKeyActivityListMemberCustomFieldMutationOptions = Apollo.BaseMutationOptions<SetKeyActivityListMemberCustomFieldMutation, SetKeyActivityListMemberCustomFieldMutationVariables>;
export const CreateListCustomFieldSchemaDocument = gql`
    mutation CreateListCustomFieldSchema($listUuid: ID!, $customFieldAttributes: CustomFieldSchemaAttributes!) {
  createListCustomFieldSchema(
    listUuid: $listUuid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
  }
}
    `;
export type CreateListCustomFieldSchemaMutationFn = Apollo.MutationFunction<CreateListCustomFieldSchemaMutation, CreateListCustomFieldSchemaMutationVariables>;

/**
 * __useCreateListCustomFieldSchemaMutation__
 *
 * To run a mutation, you first call `useCreateListCustomFieldSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListCustomFieldSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListCustomFieldSchemaMutation, { data, loading, error }] = useCreateListCustomFieldSchemaMutation({
 *   variables: {
 *      listUuid: // value for 'listUuid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useCreateListCustomFieldSchemaMutation(baseOptions?: Apollo.MutationHookOptions<CreateListCustomFieldSchemaMutation, CreateListCustomFieldSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListCustomFieldSchemaMutation, CreateListCustomFieldSchemaMutationVariables>(CreateListCustomFieldSchemaDocument, options);
      }
export type CreateListCustomFieldSchemaMutationHookResult = ReturnType<typeof useCreateListCustomFieldSchemaMutation>;
export type CreateListCustomFieldSchemaMutationResult = Apollo.MutationResult<CreateListCustomFieldSchemaMutation>;
export type CreateListCustomFieldSchemaMutationOptions = Apollo.BaseMutationOptions<CreateListCustomFieldSchemaMutation, CreateListCustomFieldSchemaMutationVariables>;
export const UpdateFormExpiryDocument = gql`
    mutation UpdateFormExpiry($formUid: ID!, $enabled: Boolean!, $date: ISO8601DateTime, $pageHeader: String, $pageDescription: String) {
  updateFormExpiry(
    enabled: $enabled
    formUid: $formUid
    date: $date
    pageHeader: $pageHeader
    pageDescription: $pageDescription
  ) {
    failReasons
  }
}
    `;
export type UpdateFormExpiryMutationFn = Apollo.MutationFunction<UpdateFormExpiryMutation, UpdateFormExpiryMutationVariables>;

/**
 * __useUpdateFormExpiryMutation__
 *
 * To run a mutation, you first call `useUpdateFormExpiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormExpiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormExpiryMutation, { data, loading, error }] = useUpdateFormExpiryMutation({
 *   variables: {
 *      formUid: // value for 'formUid'
 *      enabled: // value for 'enabled'
 *      date: // value for 'date'
 *      pageHeader: // value for 'pageHeader'
 *      pageDescription: // value for 'pageDescription'
 *   },
 * });
 */
export function useUpdateFormExpiryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormExpiryMutation, UpdateFormExpiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormExpiryMutation, UpdateFormExpiryMutationVariables>(UpdateFormExpiryDocument, options);
      }
export type UpdateFormExpiryMutationHookResult = ReturnType<typeof useUpdateFormExpiryMutation>;
export type UpdateFormExpiryMutationResult = Apollo.MutationResult<UpdateFormExpiryMutation>;
export type UpdateFormExpiryMutationOptions = Apollo.BaseMutationOptions<UpdateFormExpiryMutation, UpdateFormExpiryMutationVariables>;
export const UpdateFormWaitlistDocument = gql`
    mutation UpdateFormWaitlist($formId: ID!, $enabled: Boolean!, $redirectUrl: String, $condition: WaitlistConditionInput) {
  updateFormWaitlist(
    formId: $formId
    enabled: $enabled
    condition: $condition
    redirectUrl: $redirectUrl
  ) {
    failReasons
  }
}
    `;
export type UpdateFormWaitlistMutationFn = Apollo.MutationFunction<UpdateFormWaitlistMutation, UpdateFormWaitlistMutationVariables>;

/**
 * __useUpdateFormWaitlistMutation__
 *
 * To run a mutation, you first call `useUpdateFormWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormWaitlistMutation, { data, loading, error }] = useUpdateFormWaitlistMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      enabled: // value for 'enabled'
 *      redirectUrl: // value for 'redirectUrl'
 *      condition: // value for 'condition'
 *   },
 * });
 */
export function useUpdateFormWaitlistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormWaitlistMutation, UpdateFormWaitlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormWaitlistMutation, UpdateFormWaitlistMutationVariables>(UpdateFormWaitlistDocument, options);
      }
export type UpdateFormWaitlistMutationHookResult = ReturnType<typeof useUpdateFormWaitlistMutation>;
export type UpdateFormWaitlistMutationResult = Apollo.MutationResult<UpdateFormWaitlistMutation>;
export type UpdateFormWaitlistMutationOptions = Apollo.BaseMutationOptions<UpdateFormWaitlistMutation, UpdateFormWaitlistMutationVariables>;
export const WaitlistConditionFormRollupFieldOptionsDocument = gql`
    query WaitlistConditionFormRollupFieldOptions($filters: RollupFieldFiltersInput) {
  tableLikeRollupFields(filters: $filters) {
    entries {
      ...WaitlistConditionFormRollupFieldOption
    }
  }
}
    ${WaitlistConditionFormRollupFieldOptionFragmentDoc}`;

/**
 * __useWaitlistConditionFormRollupFieldOptionsQuery__
 *
 * To run a query within a React component, call `useWaitlistConditionFormRollupFieldOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitlistConditionFormRollupFieldOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitlistConditionFormRollupFieldOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useWaitlistConditionFormRollupFieldOptionsQuery(baseOptions?: Apollo.QueryHookOptions<WaitlistConditionFormRollupFieldOptionsQuery, WaitlistConditionFormRollupFieldOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitlistConditionFormRollupFieldOptionsQuery, WaitlistConditionFormRollupFieldOptionsQueryVariables>(WaitlistConditionFormRollupFieldOptionsDocument, options);
      }
export function useWaitlistConditionFormRollupFieldOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitlistConditionFormRollupFieldOptionsQuery, WaitlistConditionFormRollupFieldOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitlistConditionFormRollupFieldOptionsQuery, WaitlistConditionFormRollupFieldOptionsQueryVariables>(WaitlistConditionFormRollupFieldOptionsDocument, options);
        }
export type WaitlistConditionFormRollupFieldOptionsQueryHookResult = ReturnType<typeof useWaitlistConditionFormRollupFieldOptionsQuery>;
export type WaitlistConditionFormRollupFieldOptionsLazyQueryHookResult = ReturnType<typeof useWaitlistConditionFormRollupFieldOptionsLazyQuery>;
export type WaitlistConditionFormRollupFieldOptionsQueryResult = Apollo.QueryResult<WaitlistConditionFormRollupFieldOptionsQuery, WaitlistConditionFormRollupFieldOptionsQueryVariables>;
export const KeyActivityListAutocompleteDocument = gql`
    query KeyActivityListAutocomplete($page: Int, $perPage: Int, $keyActivityUid: ID, $term: String) {
  keyActivityLists(page: $page, perPage: $perPage, filter: {term: $term}) {
    entries {
      ...KeyActivityListAutocompleteOption
    }
  }
}
    ${KeyActivityListAutocompleteOptionFragmentDoc}`;

/**
 * __useKeyActivityListAutocompleteQuery__
 *
 * To run a query within a React component, call `useKeyActivityListAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyActivityListAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyActivityListAutocompleteQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      keyActivityUid: // value for 'keyActivityUid'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useKeyActivityListAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<KeyActivityListAutocompleteQuery, KeyActivityListAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyActivityListAutocompleteQuery, KeyActivityListAutocompleteQueryVariables>(KeyActivityListAutocompleteDocument, options);
      }
export function useKeyActivityListAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyActivityListAutocompleteQuery, KeyActivityListAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyActivityListAutocompleteQuery, KeyActivityListAutocompleteQueryVariables>(KeyActivityListAutocompleteDocument, options);
        }
export type KeyActivityListAutocompleteQueryHookResult = ReturnType<typeof useKeyActivityListAutocompleteQuery>;
export type KeyActivityListAutocompleteLazyQueryHookResult = ReturnType<typeof useKeyActivityListAutocompleteLazyQuery>;
export type KeyActivityListAutocompleteQueryResult = Apollo.QueryResult<KeyActivityListAutocompleteQuery, KeyActivityListAutocompleteQueryVariables>;
export const GetCompanyIdFromListMemberIdDocument = gql`
    query GetCompanyIdFromListMemberId($listMemberUid: ID!) {
  companyListMember(listMemberUid: $listMemberUid) {
    company {
      id
    }
  }
}
    `;

/**
 * __useGetCompanyIdFromListMemberIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyIdFromListMemberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIdFromListMemberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIdFromListMemberIdQuery({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *   },
 * });
 */
export function useGetCompanyIdFromListMemberIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyIdFromListMemberIdQuery, GetCompanyIdFromListMemberIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyIdFromListMemberIdQuery, GetCompanyIdFromListMemberIdQueryVariables>(GetCompanyIdFromListMemberIdDocument, options);
      }
export function useGetCompanyIdFromListMemberIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyIdFromListMemberIdQuery, GetCompanyIdFromListMemberIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyIdFromListMemberIdQuery, GetCompanyIdFromListMemberIdQueryVariables>(GetCompanyIdFromListMemberIdDocument, options);
        }
export type GetCompanyIdFromListMemberIdQueryHookResult = ReturnType<typeof useGetCompanyIdFromListMemberIdQuery>;
export type GetCompanyIdFromListMemberIdLazyQueryHookResult = ReturnType<typeof useGetCompanyIdFromListMemberIdLazyQuery>;
export type GetCompanyIdFromListMemberIdQueryResult = Apollo.QueryResult<GetCompanyIdFromListMemberIdQuery, GetCompanyIdFromListMemberIdQueryVariables>;
export const GetContactIdFromListMemberIdDocument = gql`
    query GetContactIdFromListMemberId($listMemberUid: ID!) {
  listMember(listMemberUid: $listMemberUid) {
    contact {
      id
    }
  }
}
    `;

/**
 * __useGetContactIdFromListMemberIdQuery__
 *
 * To run a query within a React component, call `useGetContactIdFromListMemberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdFromListMemberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdFromListMemberIdQuery({
 *   variables: {
 *      listMemberUid: // value for 'listMemberUid'
 *   },
 * });
 */
export function useGetContactIdFromListMemberIdQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdFromListMemberIdQuery, GetContactIdFromListMemberIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdFromListMemberIdQuery, GetContactIdFromListMemberIdQueryVariables>(GetContactIdFromListMemberIdDocument, options);
      }
export function useGetContactIdFromListMemberIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdFromListMemberIdQuery, GetContactIdFromListMemberIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdFromListMemberIdQuery, GetContactIdFromListMemberIdQueryVariables>(GetContactIdFromListMemberIdDocument, options);
        }
export type GetContactIdFromListMemberIdQueryHookResult = ReturnType<typeof useGetContactIdFromListMemberIdQuery>;
export type GetContactIdFromListMemberIdLazyQueryHookResult = ReturnType<typeof useGetContactIdFromListMemberIdLazyQuery>;
export type GetContactIdFromListMemberIdQueryResult = Apollo.QueryResult<GetContactIdFromListMemberIdQuery, GetContactIdFromListMemberIdQueryVariables>;
export const OpportunityFormDocument = gql`
    query OpportunityForm($uid: ID!, $includeCompanyGoal: Boolean!) {
  companyGoal: opportunity(uid: $uid) @include(if: $includeCompanyGoal) {
    ...CompanyGoalPreview
  }
  opportunityTrackingConfiguration {
    id
    customStatuses {
      ...OpportunityTrackingCustomStatus
    }
  }
}
    ${CompanyGoalPreviewFragmentDoc}
${OpportunityTrackingCustomStatusFragmentDoc}`;

/**
 * __useOpportunityFormQuery__
 *
 * To run a query within a React component, call `useOpportunityFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityFormQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      includeCompanyGoal: // value for 'includeCompanyGoal'
 *   },
 * });
 */
export function useOpportunityFormQuery(baseOptions: Apollo.QueryHookOptions<OpportunityFormQuery, OpportunityFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityFormQuery, OpportunityFormQueryVariables>(OpportunityFormDocument, options);
      }
export function useOpportunityFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityFormQuery, OpportunityFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityFormQuery, OpportunityFormQueryVariables>(OpportunityFormDocument, options);
        }
export type OpportunityFormQueryHookResult = ReturnType<typeof useOpportunityFormQuery>;
export type OpportunityFormLazyQueryHookResult = ReturnType<typeof useOpportunityFormLazyQuery>;
export type OpportunityFormQueryResult = Apollo.QueryResult<OpportunityFormQuery, OpportunityFormQueryVariables>;
export const OpportunitySlideDocument = gql`
    query OpportunitySlide($opportunityUid: ID!, $workspaceOpportunityUid: ID!, $shouldFetchOpportunity: Boolean!, $shouldFetchProjects: Boolean!, $shouldFetchCustomFields: Boolean!) {
  opportunity(uid: $opportunityUid) @include(if: $shouldFetchOpportunity) {
    ...OpportunityPreview
  }
  opportunityProjectsForUid(opportunityUid: $opportunityUid) @include(if: $shouldFetchProjects) {
    entries {
      ...ProjectOption
    }
  }
  workspaceOpportunity: projectOpportunity(uid: $workspaceOpportunityUid) @include(if: $shouldFetchCustomFields) {
    id
    projectId
    customFields {
      ...CustomFieldGrid
    }
    opportunity {
      id
    }
  }
}
    ${OpportunityPreviewFragmentDoc}
${ProjectOptionFragmentDoc}
${CustomFieldGridFragmentDoc}`;

/**
 * __useOpportunitySlideQuery__
 *
 * To run a query within a React component, call `useOpportunitySlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunitySlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunitySlideQuery({
 *   variables: {
 *      opportunityUid: // value for 'opportunityUid'
 *      workspaceOpportunityUid: // value for 'workspaceOpportunityUid'
 *      shouldFetchOpportunity: // value for 'shouldFetchOpportunity'
 *      shouldFetchProjects: // value for 'shouldFetchProjects'
 *      shouldFetchCustomFields: // value for 'shouldFetchCustomFields'
 *   },
 * });
 */
export function useOpportunitySlideQuery(baseOptions: Apollo.QueryHookOptions<OpportunitySlideQuery, OpportunitySlideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunitySlideQuery, OpportunitySlideQueryVariables>(OpportunitySlideDocument, options);
      }
export function useOpportunitySlideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunitySlideQuery, OpportunitySlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunitySlideQuery, OpportunitySlideQueryVariables>(OpportunitySlideDocument, options);
        }
export type OpportunitySlideQueryHookResult = ReturnType<typeof useOpportunitySlideQuery>;
export type OpportunitySlideLazyQueryHookResult = ReturnType<typeof useOpportunitySlideLazyQuery>;
export type OpportunitySlideQueryResult = Apollo.QueryResult<OpportunitySlideQuery, OpportunitySlideQueryVariables>;
export const CustomOpportunityStatsDocument = gql`
    query CustomOpportunityStats($withEmployeeUid: ID) {
  companyGoals(filter: {withEmployeeUid: $withEmployeeUid}) {
    customStatusDistribution {
      ...CustomOpportunityStatsUI
    }
  }
}
    ${CustomOpportunityStatsUiFragmentDoc}`;

/**
 * __useCustomOpportunityStatsQuery__
 *
 * To run a query within a React component, call `useCustomOpportunityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomOpportunityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomOpportunityStatsQuery({
 *   variables: {
 *      withEmployeeUid: // value for 'withEmployeeUid'
 *   },
 * });
 */
export function useCustomOpportunityStatsQuery(baseOptions?: Apollo.QueryHookOptions<CustomOpportunityStatsQuery, CustomOpportunityStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomOpportunityStatsQuery, CustomOpportunityStatsQueryVariables>(CustomOpportunityStatsDocument, options);
      }
export function useCustomOpportunityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomOpportunityStatsQuery, CustomOpportunityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomOpportunityStatsQuery, CustomOpportunityStatsQueryVariables>(CustomOpportunityStatsDocument, options);
        }
export type CustomOpportunityStatsQueryHookResult = ReturnType<typeof useCustomOpportunityStatsQuery>;
export type CustomOpportunityStatsLazyQueryHookResult = ReturnType<typeof useCustomOpportunityStatsLazyQuery>;
export type CustomOpportunityStatsQueryResult = Apollo.QueryResult<CustomOpportunityStatsQuery, CustomOpportunityStatsQueryVariables>;
export const DownloadEmailMarketingCampaignTemplateDocument = gql`
    mutation DownloadEmailMarketingCampaignTemplate($uid: ID!) {
  downloadEmailMarketingCampaignTemplate(uid: $uid) {
    failReasons
    templateHtml
  }
}
    `;
export type DownloadEmailMarketingCampaignTemplateMutationFn = Apollo.MutationFunction<DownloadEmailMarketingCampaignTemplateMutation, DownloadEmailMarketingCampaignTemplateMutationVariables>;

/**
 * __useDownloadEmailMarketingCampaignTemplateMutation__
 *
 * To run a mutation, you first call `useDownloadEmailMarketingCampaignTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadEmailMarketingCampaignTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadEmailMarketingCampaignTemplateMutation, { data, loading, error }] = useDownloadEmailMarketingCampaignTemplateMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useDownloadEmailMarketingCampaignTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DownloadEmailMarketingCampaignTemplateMutation, DownloadEmailMarketingCampaignTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadEmailMarketingCampaignTemplateMutation, DownloadEmailMarketingCampaignTemplateMutationVariables>(DownloadEmailMarketingCampaignTemplateDocument, options);
      }
export type DownloadEmailMarketingCampaignTemplateMutationHookResult = ReturnType<typeof useDownloadEmailMarketingCampaignTemplateMutation>;
export type DownloadEmailMarketingCampaignTemplateMutationResult = Apollo.MutationResult<DownloadEmailMarketingCampaignTemplateMutation>;
export type DownloadEmailMarketingCampaignTemplateMutationOptions = Apollo.BaseMutationOptions<DownloadEmailMarketingCampaignTemplateMutation, DownloadEmailMarketingCampaignTemplateMutationVariables>;
export const MyJourneyPageDocument = gql`
    query MyJourneyPage {
  currentUser {
    firstName
    lastName
    email
  }
  mobileConfigs {
    entries {
      name
      value
    }
  }
  everAfterStatus {
    enabled
    hasPersona
    persona
    personaLabel
    productAccountId
  }
}
    `;

/**
 * __useMyJourneyPageQuery__
 *
 * To run a query within a React component, call `useMyJourneyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyJourneyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyJourneyPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyJourneyPageQuery(baseOptions?: Apollo.QueryHookOptions<MyJourneyPageQuery, MyJourneyPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyJourneyPageQuery, MyJourneyPageQueryVariables>(MyJourneyPageDocument, options);
      }
export function useMyJourneyPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyJourneyPageQuery, MyJourneyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyJourneyPageQuery, MyJourneyPageQueryVariables>(MyJourneyPageDocument, options);
        }
export type MyJourneyPageQueryHookResult = ReturnType<typeof useMyJourneyPageQuery>;
export type MyJourneyPageLazyQueryHookResult = ReturnType<typeof useMyJourneyPageLazyQuery>;
export type MyJourneyPageQueryResult = Apollo.QueryResult<MyJourneyPageQuery, MyJourneyPageQueryVariables>;
export const OpportunityIdFromWorkspaceOpportunityDocument = gql`
    query OpportunityIdFromWorkspaceOpportunity($uid: ID!) {
  projectOpportunity(uid: $uid) {
    opportunity {
      id
    }
  }
}
    `;

/**
 * __useOpportunityIdFromWorkspaceOpportunityQuery__
 *
 * To run a query within a React component, call `useOpportunityIdFromWorkspaceOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityIdFromWorkspaceOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityIdFromWorkspaceOpportunityQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useOpportunityIdFromWorkspaceOpportunityQuery(baseOptions: Apollo.QueryHookOptions<OpportunityIdFromWorkspaceOpportunityQuery, OpportunityIdFromWorkspaceOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityIdFromWorkspaceOpportunityQuery, OpportunityIdFromWorkspaceOpportunityQueryVariables>(OpportunityIdFromWorkspaceOpportunityDocument, options);
      }
export function useOpportunityIdFromWorkspaceOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityIdFromWorkspaceOpportunityQuery, OpportunityIdFromWorkspaceOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityIdFromWorkspaceOpportunityQuery, OpportunityIdFromWorkspaceOpportunityQueryVariables>(OpportunityIdFromWorkspaceOpportunityDocument, options);
        }
export type OpportunityIdFromWorkspaceOpportunityQueryHookResult = ReturnType<typeof useOpportunityIdFromWorkspaceOpportunityQuery>;
export type OpportunityIdFromWorkspaceOpportunityLazyQueryHookResult = ReturnType<typeof useOpportunityIdFromWorkspaceOpportunityLazyQuery>;
export type OpportunityIdFromWorkspaceOpportunityQueryResult = Apollo.QueryResult<OpportunityIdFromWorkspaceOpportunityQuery, OpportunityIdFromWorkspaceOpportunityQueryVariables>;
export const SharedViewPageDocument = gql`
    query SharedViewPage($tabUid: ID!, $listViewUid: ID!) {
  tab(uid: $tabUid) {
    ...TabResultItem
  }
  listView(listViewUid: $listViewUid) {
    ...ListView
  }
}
    ${TabResultItemFragmentDoc}
${ListViewFragmentDoc}`;

/**
 * __useSharedViewPageQuery__
 *
 * To run a query within a React component, call `useSharedViewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedViewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedViewPageQuery({
 *   variables: {
 *      tabUid: // value for 'tabUid'
 *      listViewUid: // value for 'listViewUid'
 *   },
 * });
 */
export function useSharedViewPageQuery(baseOptions: Apollo.QueryHookOptions<SharedViewPageQuery, SharedViewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedViewPageQuery, SharedViewPageQueryVariables>(SharedViewPageDocument, options);
      }
export function useSharedViewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedViewPageQuery, SharedViewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedViewPageQuery, SharedViewPageQueryVariables>(SharedViewPageDocument, options);
        }
export type SharedViewPageQueryHookResult = ReturnType<typeof useSharedViewPageQuery>;
export type SharedViewPageLazyQueryHookResult = ReturnType<typeof useSharedViewPageLazyQuery>;
export type SharedViewPageQueryResult = Apollo.QueryResult<SharedViewPageQuery, SharedViewPageQueryVariables>;
export const UpdateProjectFoldersDocument = gql`
    query UpdateProjectFolders($perPage: Int, $folderUid: ID) {
  projects(perPage: $perPage, folderUid: $folderUid) {
    subFolders {
      ...ProjectFolder
    }
  }
}
    ${ProjectFolderFragmentDoc}`;

/**
 * __useUpdateProjectFoldersQuery__
 *
 * To run a query within a React component, call `useUpdateProjectFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateProjectFoldersQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      folderUid: // value for 'folderUid'
 *   },
 * });
 */
export function useUpdateProjectFoldersQuery(baseOptions?: Apollo.QueryHookOptions<UpdateProjectFoldersQuery, UpdateProjectFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateProjectFoldersQuery, UpdateProjectFoldersQueryVariables>(UpdateProjectFoldersDocument, options);
      }
export function useUpdateProjectFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateProjectFoldersQuery, UpdateProjectFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateProjectFoldersQuery, UpdateProjectFoldersQueryVariables>(UpdateProjectFoldersDocument, options);
        }
export type UpdateProjectFoldersQueryHookResult = ReturnType<typeof useUpdateProjectFoldersQuery>;
export type UpdateProjectFoldersLazyQueryHookResult = ReturnType<typeof useUpdateProjectFoldersLazyQuery>;
export type UpdateProjectFoldersQueryResult = Apollo.QueryResult<UpdateProjectFoldersQuery, UpdateProjectFoldersQueryVariables>;
export const CreateProjectOpportunityCustomFieldSchemaDocument = gql`
    mutation CreateProjectOpportunityCustomFieldSchema($projectUid: ID!, $customFieldAttributes: CustomFieldSchemaAttributes!) {
  createProjectOpportunityCustomFieldSchema(
    projectUid: $projectUid
    customFieldAttributes: $customFieldAttributes
  ) {
    failReasons
  }
}
    `;
export type CreateProjectOpportunityCustomFieldSchemaMutationFn = Apollo.MutationFunction<CreateProjectOpportunityCustomFieldSchemaMutation, CreateProjectOpportunityCustomFieldSchemaMutationVariables>;

/**
 * __useCreateProjectOpportunityCustomFieldSchemaMutation__
 *
 * To run a mutation, you first call `useCreateProjectOpportunityCustomFieldSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectOpportunityCustomFieldSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectOpportunityCustomFieldSchemaMutation, { data, loading, error }] = useCreateProjectOpportunityCustomFieldSchemaMutation({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *      customFieldAttributes: // value for 'customFieldAttributes'
 *   },
 * });
 */
export function useCreateProjectOpportunityCustomFieldSchemaMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectOpportunityCustomFieldSchemaMutation, CreateProjectOpportunityCustomFieldSchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectOpportunityCustomFieldSchemaMutation, CreateProjectOpportunityCustomFieldSchemaMutationVariables>(CreateProjectOpportunityCustomFieldSchemaDocument, options);
      }
export type CreateProjectOpportunityCustomFieldSchemaMutationHookResult = ReturnType<typeof useCreateProjectOpportunityCustomFieldSchemaMutation>;
export type CreateProjectOpportunityCustomFieldSchemaMutationResult = Apollo.MutationResult<CreateProjectOpportunityCustomFieldSchemaMutation>;
export type CreateProjectOpportunityCustomFieldSchemaMutationOptions = Apollo.BaseMutationOptions<CreateProjectOpportunityCustomFieldSchemaMutation, CreateProjectOpportunityCustomFieldSchemaMutationVariables>;
export const TableLikeRollupFieldsDocument = gql`
    query TableLikeRollupFields($filter: RollupFieldFiltersInput) {
  tableLikeRollupFields(filters: $filter) {
    entries {
      ...TableLikeRollupField
    }
  }
}
    ${TableLikeRollupFieldFragmentDoc}`;

/**
 * __useTableLikeRollupFieldsQuery__
 *
 * To run a query within a React component, call `useTableLikeRollupFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableLikeRollupFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableLikeRollupFieldsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTableLikeRollupFieldsQuery(baseOptions?: Apollo.QueryHookOptions<TableLikeRollupFieldsQuery, TableLikeRollupFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableLikeRollupFieldsQuery, TableLikeRollupFieldsQueryVariables>(TableLikeRollupFieldsDocument, options);
      }
export function useTableLikeRollupFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableLikeRollupFieldsQuery, TableLikeRollupFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableLikeRollupFieldsQuery, TableLikeRollupFieldsQueryVariables>(TableLikeRollupFieldsDocument, options);
        }
export type TableLikeRollupFieldsQueryHookResult = ReturnType<typeof useTableLikeRollupFieldsQuery>;
export type TableLikeRollupFieldsLazyQueryHookResult = ReturnType<typeof useTableLikeRollupFieldsLazyQuery>;
export type TableLikeRollupFieldsQueryResult = Apollo.QueryResult<TableLikeRollupFieldsQuery, TableLikeRollupFieldsQueryVariables>;
export const DeleteTableLikeRollupFieldDocument = gql`
    mutation DeleteTableLikeRollupField($id: ID!) {
  deleteTableLikeRollupField(id: $id) {
    failReasons
    rollupField {
      id
      discardedAt
    }
  }
}
    `;
export type DeleteTableLikeRollupFieldMutationFn = Apollo.MutationFunction<DeleteTableLikeRollupFieldMutation, DeleteTableLikeRollupFieldMutationVariables>;

/**
 * __useDeleteTableLikeRollupFieldMutation__
 *
 * To run a mutation, you first call `useDeleteTableLikeRollupFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableLikeRollupFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableLikeRollupFieldMutation, { data, loading, error }] = useDeleteTableLikeRollupFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTableLikeRollupFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableLikeRollupFieldMutation, DeleteTableLikeRollupFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableLikeRollupFieldMutation, DeleteTableLikeRollupFieldMutationVariables>(DeleteTableLikeRollupFieldDocument, options);
      }
export type DeleteTableLikeRollupFieldMutationHookResult = ReturnType<typeof useDeleteTableLikeRollupFieldMutation>;
export type DeleteTableLikeRollupFieldMutationResult = Apollo.MutationResult<DeleteTableLikeRollupFieldMutation>;
export type DeleteTableLikeRollupFieldMutationOptions = Apollo.BaseMutationOptions<DeleteTableLikeRollupFieldMutation, DeleteTableLikeRollupFieldMutationVariables>;
export const UpdateTableLikeRollupFieldDocument = gql`
    mutation UpdateTableLikeRollupField($id: ID!, $name: String!) {
  updateTableLikeRollupField(id: $id, name: $name) {
    failReasons
    rollupField {
      id
      name
    }
  }
}
    `;
export type UpdateTableLikeRollupFieldMutationFn = Apollo.MutationFunction<UpdateTableLikeRollupFieldMutation, UpdateTableLikeRollupFieldMutationVariables>;

/**
 * __useUpdateTableLikeRollupFieldMutation__
 *
 * To run a mutation, you first call `useUpdateTableLikeRollupFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableLikeRollupFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableLikeRollupFieldMutation, { data, loading, error }] = useUpdateTableLikeRollupFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateTableLikeRollupFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTableLikeRollupFieldMutation, UpdateTableLikeRollupFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTableLikeRollupFieldMutation, UpdateTableLikeRollupFieldMutationVariables>(UpdateTableLikeRollupFieldDocument, options);
      }
export type UpdateTableLikeRollupFieldMutationHookResult = ReturnType<typeof useUpdateTableLikeRollupFieldMutation>;
export type UpdateTableLikeRollupFieldMutationResult = Apollo.MutationResult<UpdateTableLikeRollupFieldMutation>;
export type UpdateTableLikeRollupFieldMutationOptions = Apollo.BaseMutationOptions<UpdateTableLikeRollupFieldMutation, UpdateTableLikeRollupFieldMutationVariables>;
export const CreateTableLikeRollupFieldDocument = gql`
    mutation CreateTableLikeRollupField($input: CreateTableLikeRollupFieldInput!) {
  createTableLikeRollupField(input: $input) {
    failReasons
    rollupField {
      ...TableLikeRollupField
    }
  }
}
    ${TableLikeRollupFieldFragmentDoc}`;
export type CreateTableLikeRollupFieldMutationFn = Apollo.MutationFunction<CreateTableLikeRollupFieldMutation, CreateTableLikeRollupFieldMutationVariables>;

/**
 * __useCreateTableLikeRollupFieldMutation__
 *
 * To run a mutation, you first call `useCreateTableLikeRollupFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableLikeRollupFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableLikeRollupFieldMutation, { data, loading, error }] = useCreateTableLikeRollupFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableLikeRollupFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableLikeRollupFieldMutation, CreateTableLikeRollupFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableLikeRollupFieldMutation, CreateTableLikeRollupFieldMutationVariables>(CreateTableLikeRollupFieldDocument, options);
      }
export type CreateTableLikeRollupFieldMutationHookResult = ReturnType<typeof useCreateTableLikeRollupFieldMutation>;
export type CreateTableLikeRollupFieldMutationResult = Apollo.MutationResult<CreateTableLikeRollupFieldMutation>;
export type CreateTableLikeRollupFieldMutationOptions = Apollo.BaseMutationOptions<CreateTableLikeRollupFieldMutation, CreateTableLikeRollupFieldMutationVariables>;
export const CreateTableLikeRollupFieldSourceListOptionsDocument = gql`
    query CreateTableLikeRollupFieldSourceListOptions($projectUid: ID!) {
  project(uuid: $projectUid) {
    id
    tabs {
      ...CreateTableLikeRollupFieldSourceListTab
    }
  }
}
    ${CreateTableLikeRollupFieldSourceListTabFragmentDoc}`;

/**
 * __useCreateTableLikeRollupFieldSourceListOptionsQuery__
 *
 * To run a query within a React component, call `useCreateTableLikeRollupFieldSourceListOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateTableLikeRollupFieldSourceListOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateTableLikeRollupFieldSourceListOptionsQuery({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *   },
 * });
 */
export function useCreateTableLikeRollupFieldSourceListOptionsQuery(baseOptions: Apollo.QueryHookOptions<CreateTableLikeRollupFieldSourceListOptionsQuery, CreateTableLikeRollupFieldSourceListOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateTableLikeRollupFieldSourceListOptionsQuery, CreateTableLikeRollupFieldSourceListOptionsQueryVariables>(CreateTableLikeRollupFieldSourceListOptionsDocument, options);
      }
export function useCreateTableLikeRollupFieldSourceListOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateTableLikeRollupFieldSourceListOptionsQuery, CreateTableLikeRollupFieldSourceListOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateTableLikeRollupFieldSourceListOptionsQuery, CreateTableLikeRollupFieldSourceListOptionsQueryVariables>(CreateTableLikeRollupFieldSourceListOptionsDocument, options);
        }
export type CreateTableLikeRollupFieldSourceListOptionsQueryHookResult = ReturnType<typeof useCreateTableLikeRollupFieldSourceListOptionsQuery>;
export type CreateTableLikeRollupFieldSourceListOptionsLazyQueryHookResult = ReturnType<typeof useCreateTableLikeRollupFieldSourceListOptionsLazyQuery>;
export type CreateTableLikeRollupFieldSourceListOptionsQueryResult = Apollo.QueryResult<CreateTableLikeRollupFieldSourceListOptionsQuery, CreateTableLikeRollupFieldSourceListOptionsQueryVariables>;
export const RollupColumnsSelectFieldDocument = gql`
    query RollupColumnsSelectField($projectUid: ID!, $sourceType: SourceTypeEnum, $sourceListType: TableLikeRollupSourceListTypeEnum, $sourceListId: ID) {
  tableLikeRollupColumns(
    projectUid: $projectUid
    sourceType: $sourceType
    sourceListType: $sourceListType
    sourceListId: $sourceListId
  ) {
    columns {
      ...RollupColumnsSelectFieldOption
    }
  }
}
    ${RollupColumnsSelectFieldOptionFragmentDoc}`;

/**
 * __useRollupColumnsSelectFieldQuery__
 *
 * To run a query within a React component, call `useRollupColumnsSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useRollupColumnsSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRollupColumnsSelectFieldQuery({
 *   variables: {
 *      projectUid: // value for 'projectUid'
 *      sourceType: // value for 'sourceType'
 *      sourceListType: // value for 'sourceListType'
 *      sourceListId: // value for 'sourceListId'
 *   },
 * });
 */
export function useRollupColumnsSelectFieldQuery(baseOptions: Apollo.QueryHookOptions<RollupColumnsSelectFieldQuery, RollupColumnsSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RollupColumnsSelectFieldQuery, RollupColumnsSelectFieldQueryVariables>(RollupColumnsSelectFieldDocument, options);
      }
export function useRollupColumnsSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RollupColumnsSelectFieldQuery, RollupColumnsSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RollupColumnsSelectFieldQuery, RollupColumnsSelectFieldQueryVariables>(RollupColumnsSelectFieldDocument, options);
        }
export type RollupColumnsSelectFieldQueryHookResult = ReturnType<typeof useRollupColumnsSelectFieldQuery>;
export type RollupColumnsSelectFieldLazyQueryHookResult = ReturnType<typeof useRollupColumnsSelectFieldLazyQuery>;
export type RollupColumnsSelectFieldQueryResult = Apollo.QueryResult<RollupColumnsSelectFieldQuery, RollupColumnsSelectFieldQueryVariables>;
export const ReceivedReferralsDocument = gql`
    query ReceivedReferrals($page: Int = 1, $perPage: Int = 10, $term: String) {
  companyGoals(
    filter: {receivedReferral: true, term: $term}
    page: $page
    perPage: $perPage
  ) {
    entries {
      ...ReceivedReferralGrid
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ReceivedReferralGridFragmentDoc}`;

/**
 * __useReceivedReferralsQuery__
 *
 * To run a query within a React component, call `useReceivedReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceivedReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceivedReferralsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useReceivedReferralsQuery(baseOptions?: Apollo.QueryHookOptions<ReceivedReferralsQuery, ReceivedReferralsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReceivedReferralsQuery, ReceivedReferralsQueryVariables>(ReceivedReferralsDocument, options);
      }
export function useReceivedReferralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceivedReferralsQuery, ReceivedReferralsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReceivedReferralsQuery, ReceivedReferralsQueryVariables>(ReceivedReferralsDocument, options);
        }
export type ReceivedReferralsQueryHookResult = ReturnType<typeof useReceivedReferralsQuery>;
export type ReceivedReferralsLazyQueryHookResult = ReturnType<typeof useReceivedReferralsLazyQuery>;
export type ReceivedReferralsQueryResult = Apollo.QueryResult<ReceivedReferralsQuery, ReceivedReferralsQueryVariables>;
export const GenerateJwtDocument = gql`
    mutation GenerateJwt {
  generateJwt {
    expiresAt
    token
    failReasons
  }
}
    `;
export type GenerateJwtMutationFn = Apollo.MutationFunction<GenerateJwtMutation, GenerateJwtMutationVariables>;

/**
 * __useGenerateJwtMutation__
 *
 * To run a mutation, you first call `useGenerateJwtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateJwtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateJwtMutation, { data, loading, error }] = useGenerateJwtMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateJwtMutation(baseOptions?: Apollo.MutationHookOptions<GenerateJwtMutation, GenerateJwtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateJwtMutation, GenerateJwtMutationVariables>(GenerateJwtDocument, options);
      }
export type GenerateJwtMutationHookResult = ReturnType<typeof useGenerateJwtMutation>;
export type GenerateJwtMutationResult = Apollo.MutationResult<GenerateJwtMutation>;
export type GenerateJwtMutationOptions = Apollo.BaseMutationOptions<GenerateJwtMutation, GenerateJwtMutationVariables>;
export const JwtAudienceDocument = gql`
    query JwtAudience {
  jwtAudience {
    nexlAi
    nexl360
  }
}
    `;

/**
 * __useJwtAudienceQuery__
 *
 * To run a query within a React component, call `useJwtAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useJwtAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJwtAudienceQuery({
 *   variables: {
 *   },
 * });
 */
export function useJwtAudienceQuery(baseOptions?: Apollo.QueryHookOptions<JwtAudienceQuery, JwtAudienceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JwtAudienceQuery, JwtAudienceQueryVariables>(JwtAudienceDocument, options);
      }
export function useJwtAudienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JwtAudienceQuery, JwtAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JwtAudienceQuery, JwtAudienceQueryVariables>(JwtAudienceDocument, options);
        }
export type JwtAudienceQueryHookResult = ReturnType<typeof useJwtAudienceQuery>;
export type JwtAudienceLazyQueryHookResult = ReturnType<typeof useJwtAudienceLazyQuery>;
export type JwtAudienceQueryResult = Apollo.QueryResult<JwtAudienceQuery, JwtAudienceQueryVariables>;
export const CreateResearchReportDocument = gql`
    mutation CreateResearchReport($title: String!, $researchReportableId: ID!, $researchReportableType: ResearchReportableTypeEnum!) {
  createResearchReport(
    title: $title
    researchReportableId: $researchReportableId
    researchReportableType: $researchReportableType
  ) {
    report {
      id
    }
    failReasons
  }
}
    `;
export type CreateResearchReportMutationFn = Apollo.MutationFunction<CreateResearchReportMutation, CreateResearchReportMutationVariables>;

/**
 * __useCreateResearchReportMutation__
 *
 * To run a mutation, you first call `useCreateResearchReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResearchReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResearchReportMutation, { data, loading, error }] = useCreateResearchReportMutation({
 *   variables: {
 *      title: // value for 'title'
 *      researchReportableId: // value for 'researchReportableId'
 *      researchReportableType: // value for 'researchReportableType'
 *   },
 * });
 */
export function useCreateResearchReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateResearchReportMutation, CreateResearchReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResearchReportMutation, CreateResearchReportMutationVariables>(CreateResearchReportDocument, options);
      }
export type CreateResearchReportMutationHookResult = ReturnType<typeof useCreateResearchReportMutation>;
export type CreateResearchReportMutationResult = Apollo.MutationResult<CreateResearchReportMutation>;
export type CreateResearchReportMutationOptions = Apollo.BaseMutationOptions<CreateResearchReportMutation, CreateResearchReportMutationVariables>;
export const CreateResearchReportSectionDocument = gql`
    mutation CreateResearchReportSection($reportId: ID!, $attributes: ResearchReportSectionAttributes!) {
  createResearchReportSection(reportId: $reportId, attributes: $attributes) {
    reportSection {
      ...ResearchReportSection
    }
    failReasons
  }
}
    ${ResearchReportSectionFragmentDoc}`;
export type CreateResearchReportSectionMutationFn = Apollo.MutationFunction<CreateResearchReportSectionMutation, CreateResearchReportSectionMutationVariables>;

/**
 * __useCreateResearchReportSectionMutation__
 *
 * To run a mutation, you first call `useCreateResearchReportSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResearchReportSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResearchReportSectionMutation, { data, loading, error }] = useCreateResearchReportSectionMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateResearchReportSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateResearchReportSectionMutation, CreateResearchReportSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResearchReportSectionMutation, CreateResearchReportSectionMutationVariables>(CreateResearchReportSectionDocument, options);
      }
export type CreateResearchReportSectionMutationHookResult = ReturnType<typeof useCreateResearchReportSectionMutation>;
export type CreateResearchReportSectionMutationResult = Apollo.MutationResult<CreateResearchReportSectionMutation>;
export type CreateResearchReportSectionMutationOptions = Apollo.BaseMutationOptions<CreateResearchReportSectionMutation, CreateResearchReportSectionMutationVariables>;
export const DeleteResearchReportDocument = gql`
    mutation DeleteResearchReport($reportId: ID!) {
  deleteResearchReport(reportId: $reportId) {
    failReasons
    report {
      id
      isDiscarded
    }
  }
}
    `;
export type DeleteResearchReportMutationFn = Apollo.MutationFunction<DeleteResearchReportMutation, DeleteResearchReportMutationVariables>;

/**
 * __useDeleteResearchReportMutation__
 *
 * To run a mutation, you first call `useDeleteResearchReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResearchReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResearchReportMutation, { data, loading, error }] = useDeleteResearchReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useDeleteResearchReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResearchReportMutation, DeleteResearchReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResearchReportMutation, DeleteResearchReportMutationVariables>(DeleteResearchReportDocument, options);
      }
export type DeleteResearchReportMutationHookResult = ReturnType<typeof useDeleteResearchReportMutation>;
export type DeleteResearchReportMutationResult = Apollo.MutationResult<DeleteResearchReportMutation>;
export type DeleteResearchReportMutationOptions = Apollo.BaseMutationOptions<DeleteResearchReportMutation, DeleteResearchReportMutationVariables>;
export const DeleteResearchReportSectionDocument = gql`
    mutation DeleteResearchReportSection($reportSectionId: ID!) {
  deleteResearchReportSection(reportSectionId: $reportSectionId) {
    failReasons
    reportSection {
      id
      isDiscarded
    }
  }
}
    `;
export type DeleteResearchReportSectionMutationFn = Apollo.MutationFunction<DeleteResearchReportSectionMutation, DeleteResearchReportSectionMutationVariables>;

/**
 * __useDeleteResearchReportSectionMutation__
 *
 * To run a mutation, you first call `useDeleteResearchReportSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResearchReportSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResearchReportSectionMutation, { data, loading, error }] = useDeleteResearchReportSectionMutation({
 *   variables: {
 *      reportSectionId: // value for 'reportSectionId'
 *   },
 * });
 */
export function useDeleteResearchReportSectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResearchReportSectionMutation, DeleteResearchReportSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResearchReportSectionMutation, DeleteResearchReportSectionMutationVariables>(DeleteResearchReportSectionDocument, options);
      }
export type DeleteResearchReportSectionMutationHookResult = ReturnType<typeof useDeleteResearchReportSectionMutation>;
export type DeleteResearchReportSectionMutationResult = Apollo.MutationResult<DeleteResearchReportSectionMutation>;
export type DeleteResearchReportSectionMutationOptions = Apollo.BaseMutationOptions<DeleteResearchReportSectionMutation, DeleteResearchReportSectionMutationVariables>;
export const ResearchReportsDocument = gql`
    query ResearchReports($page: Int, $perPage: Int, $researchReportableId: ID, $researchReportableType: ResearchReportableTypeEnum) {
  researchReports(
    page: $page
    perPage: $perPage
    researchReportableId: $researchReportableId
    researchReportableType: $researchReportableType
  ) {
    entries {
      ...ResearchReportGrid
    }
    pageInfo {
      totalEntries
    }
  }
}
    ${ResearchReportGridFragmentDoc}`;

/**
 * __useResearchReportsQuery__
 *
 * To run a query within a React component, call `useResearchReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResearchReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResearchReportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      researchReportableId: // value for 'researchReportableId'
 *      researchReportableType: // value for 'researchReportableType'
 *   },
 * });
 */
export function useResearchReportsQuery(baseOptions?: Apollo.QueryHookOptions<ResearchReportsQuery, ResearchReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResearchReportsQuery, ResearchReportsQueryVariables>(ResearchReportsDocument, options);
      }
export function useResearchReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResearchReportsQuery, ResearchReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResearchReportsQuery, ResearchReportsQueryVariables>(ResearchReportsDocument, options);
        }
export type ResearchReportsQueryHookResult = ReturnType<typeof useResearchReportsQuery>;
export type ResearchReportsLazyQueryHookResult = ReturnType<typeof useResearchReportsLazyQuery>;
export type ResearchReportsQueryResult = Apollo.QueryResult<ResearchReportsQuery, ResearchReportsQueryVariables>;
export const GetContactForCreatorDocument = gql`
    query GetContactForCreator($uid: ID!) {
  user(uid: $uid) {
    info {
      employee {
        contact {
          ...ContactPreview
        }
      }
    }
  }
}
    ${ContactPreviewFragmentDoc}`;

/**
 * __useGetContactForCreatorQuery__
 *
 * To run a query within a React component, call `useGetContactForCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactForCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactForCreatorQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetContactForCreatorQuery(baseOptions: Apollo.QueryHookOptions<GetContactForCreatorQuery, GetContactForCreatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactForCreatorQuery, GetContactForCreatorQueryVariables>(GetContactForCreatorDocument, options);
      }
export function useGetContactForCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactForCreatorQuery, GetContactForCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactForCreatorQuery, GetContactForCreatorQueryVariables>(GetContactForCreatorDocument, options);
        }
export type GetContactForCreatorQueryHookResult = ReturnType<typeof useGetContactForCreatorQuery>;
export type GetContactForCreatorLazyQueryHookResult = ReturnType<typeof useGetContactForCreatorLazyQuery>;
export type GetContactForCreatorQueryResult = Apollo.QueryResult<GetContactForCreatorQuery, GetContactForCreatorQueryVariables>;
export const ResearchReportDocument = gql`
    query ResearchReport($id: ID!) {
  researchReport(id: $id) {
    ...ResearchReport
  }
}
    ${ResearchReportFragmentDoc}`;

/**
 * __useResearchReportQuery__
 *
 * To run a query within a React component, call `useResearchReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useResearchReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResearchReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResearchReportQuery(baseOptions: Apollo.QueryHookOptions<ResearchReportQuery, ResearchReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResearchReportQuery, ResearchReportQueryVariables>(ResearchReportDocument, options);
      }
export function useResearchReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResearchReportQuery, ResearchReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResearchReportQuery, ResearchReportQueryVariables>(ResearchReportDocument, options);
        }
export type ResearchReportQueryHookResult = ReturnType<typeof useResearchReportQuery>;
export type ResearchReportLazyQueryHookResult = ReturnType<typeof useResearchReportLazyQuery>;
export type ResearchReportQueryResult = Apollo.QueryResult<ResearchReportQuery, ResearchReportQueryVariables>;
export const UpdateResearchReportSectionPositionsDocument = gql`
    mutation UpdateResearchReportSectionPositions($reportUid: ID!, $reportSectionUids: [ID!]!) {
  updateResearchReportSectionPositions(
    reportUid: $reportUid
    reportSectionUids: $reportSectionUids
  ) {
    failReasons
    reportSections {
      id
      title
      position
    }
  }
}
    `;
export type UpdateResearchReportSectionPositionsMutationFn = Apollo.MutationFunction<UpdateResearchReportSectionPositionsMutation, UpdateResearchReportSectionPositionsMutationVariables>;

/**
 * __useUpdateResearchReportSectionPositionsMutation__
 *
 * To run a mutation, you first call `useUpdateResearchReportSectionPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResearchReportSectionPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResearchReportSectionPositionsMutation, { data, loading, error }] = useUpdateResearchReportSectionPositionsMutation({
 *   variables: {
 *      reportUid: // value for 'reportUid'
 *      reportSectionUids: // value for 'reportSectionUids'
 *   },
 * });
 */
export function useUpdateResearchReportSectionPositionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResearchReportSectionPositionsMutation, UpdateResearchReportSectionPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResearchReportSectionPositionsMutation, UpdateResearchReportSectionPositionsMutationVariables>(UpdateResearchReportSectionPositionsDocument, options);
      }
export type UpdateResearchReportSectionPositionsMutationHookResult = ReturnType<typeof useUpdateResearchReportSectionPositionsMutation>;
export type UpdateResearchReportSectionPositionsMutationResult = Apollo.MutationResult<UpdateResearchReportSectionPositionsMutation>;
export type UpdateResearchReportSectionPositionsMutationOptions = Apollo.BaseMutationOptions<UpdateResearchReportSectionPositionsMutation, UpdateResearchReportSectionPositionsMutationVariables>;
export const UpdateResearchReportDocument = gql`
    mutation UpdateResearchReport($reportId: ID!, $title: String, $status: ResearchReportStatusEnum) {
  updateResearchReport(reportId: $reportId, title: $title, status: $status) {
    report {
      id
      title
      status
    }
    failReasons
  }
}
    `;
export type UpdateResearchReportMutationFn = Apollo.MutationFunction<UpdateResearchReportMutation, UpdateResearchReportMutationVariables>;

/**
 * __useUpdateResearchReportMutation__
 *
 * To run a mutation, you first call `useUpdateResearchReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResearchReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResearchReportMutation, { data, loading, error }] = useUpdateResearchReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      title: // value for 'title'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateResearchReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResearchReportMutation, UpdateResearchReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResearchReportMutation, UpdateResearchReportMutationVariables>(UpdateResearchReportDocument, options);
      }
export type UpdateResearchReportMutationHookResult = ReturnType<typeof useUpdateResearchReportMutation>;
export type UpdateResearchReportMutationResult = Apollo.MutationResult<UpdateResearchReportMutation>;
export type UpdateResearchReportMutationOptions = Apollo.BaseMutationOptions<UpdateResearchReportMutation, UpdateResearchReportMutationVariables>;
export const UpdateResearchReportSectionDocument = gql`
    mutation UpdateResearchReportSection($reportSectionId: ID!, $attributes: ResearchReportSectionAttributes!) {
  updateResearchReportSection(
    reportSectionId: $reportSectionId
    attributes: $attributes
  ) {
    reportSection {
      ...ResearchReportSection
    }
    failReasons
  }
}
    ${ResearchReportSectionFragmentDoc}`;
export type UpdateResearchReportSectionMutationFn = Apollo.MutationFunction<UpdateResearchReportSectionMutation, UpdateResearchReportSectionMutationVariables>;

/**
 * __useUpdateResearchReportSectionMutation__
 *
 * To run a mutation, you first call `useUpdateResearchReportSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResearchReportSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResearchReportSectionMutation, { data, loading, error }] = useUpdateResearchReportSectionMutation({
 *   variables: {
 *      reportSectionId: // value for 'reportSectionId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateResearchReportSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResearchReportSectionMutation, UpdateResearchReportSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResearchReportSectionMutation, UpdateResearchReportSectionMutationVariables>(UpdateResearchReportSectionDocument, options);
      }
export type UpdateResearchReportSectionMutationHookResult = ReturnType<typeof useUpdateResearchReportSectionMutation>;
export type UpdateResearchReportSectionMutationResult = Apollo.MutationResult<UpdateResearchReportSectionMutation>;
export type UpdateResearchReportSectionMutationOptions = Apollo.BaseMutationOptions<UpdateResearchReportSectionMutation, UpdateResearchReportSectionMutationVariables>;